var W0 = Object.defineProperty, j0 = Object.defineProperties;
var z0 = Object.getOwnPropertyDescriptors;
var ii = Object.getOwnPropertySymbols;
var xo = Object.prototype.hasOwnProperty, Do = Object.prototype.propertyIsEnumerable;
var No = (e, T, F) => T in e ? W0(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, Fe = (e, T) => {
  for (var F in T || (T = {}))
    xo.call(T, F) && No(e, F, T[F]);
  if (ii)
    for (var F of ii(T))
      Do.call(T, F) && No(e, F, T[F]);
  return e;
}, Ke = (e, T) => j0(e, z0(T));
var Uo = (e, T) => {
  var F = {};
  for (var $ in e)
    xo.call(e, $) && T.indexOf($) < 0 && (F[$] = e[$]);
  if (e != null && ii)
    for (var $ of ii(e))
      T.indexOf($) < 0 && Do.call(e, $) && (F[$] = e[$]);
  return F;
};
var Me = (e, T, F) => new Promise(($, J) => {
  var ee = (se) => {
    try {
      oe(F.next(se));
    } catch (le) {
      J(le);
    }
  }, ne = (se) => {
    try {
      oe(F.throw(se));
    } catch (le) {
      J(le);
    }
  }, oe = (se) => se.done ? $(se.value) : Promise.resolve(se.value).then(ee, ne);
  oe((F = F.apply(e, T)).next());
});
function n(e) {
  for (var T = arguments.length, F = Array(T > 1 ? T - 1 : 0), $ = 1; $ < T; $++)
    F[$ - 1] = arguments[$];
  if (process.env.NODE_ENV !== "production") {
    var J = Y[e], ee = J ? typeof J == "function" ? J.apply(null, F) : J : "unknown error nr: " + e;
    throw Error("[Immer] " + ee);
  }
  throw Error("[Immer] minified error nr: " + e + (F.length ? " " + F.map(function(ne) {
    return "'" + ne + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(e) {
  return !!e && !!e[Q];
}
function t(e) {
  var T;
  return !!e && (function(F) {
    if (!F || typeof F != "object")
      return !1;
    var $ = Object.getPrototypeOf(F);
    if ($ === null)
      return !0;
    var J = Object.hasOwnProperty.call($, "constructor") && $.constructor;
    return J === Object || typeof J == "function" && Function.toString.call(J) === Z;
  }(e) || Array.isArray(e) || !!e[L] || !!(!((T = e.constructor) === null || T === void 0) && T[L]) || s(e) || v(e));
}
function i(e, T, F) {
  F === void 0 && (F = !1), o(e) === 0 ? (F ? Object.keys : nn)(e).forEach(function($) {
    F && typeof $ == "symbol" || T($, e[$], e);
  }) : e.forEach(function($, J) {
    return T(J, $, e);
  });
}
function o(e) {
  var T = e[Q];
  return T ? T.i > 3 ? T.i - 4 : T.i : Array.isArray(e) ? 1 : s(e) ? 2 : v(e) ? 3 : 0;
}
function u(e, T) {
  return o(e) === 2 ? e.has(T) : Object.prototype.hasOwnProperty.call(e, T);
}
function a(e, T) {
  return o(e) === 2 ? e.get(T) : e[T];
}
function f(e, T, F) {
  var $ = o(e);
  $ === 2 ? e.set(T, F) : $ === 3 ? e.add(F) : e[T] = F;
}
function c(e, T) {
  return e === T ? e !== 0 || 1 / e == 1 / T : e != e && T != T;
}
function s(e) {
  return X && e instanceof Map;
}
function v(e) {
  return q && e instanceof Set;
}
function p(e) {
  return e.o || e.t;
}
function l(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var T = rn(e);
  delete T[Q];
  for (var F = nn(T), $ = 0; $ < F.length; $++) {
    var J = F[$], ee = T[J];
    ee.writable === !1 && (ee.writable = !0, ee.configurable = !0), (ee.get || ee.set) && (T[J] = { configurable: !0, writable: !0, enumerable: ee.enumerable, value: e[J] });
  }
  return Object.create(Object.getPrototypeOf(e), T);
}
function d(e, T) {
  return T === void 0 && (T = !1), y(e) || r(e) || !t(e) || (o(e) > 1 && (e.set = e.add = e.clear = e.delete = h), Object.freeze(e), T && i(e, function(F, $) {
    return d($, !0);
  }, !0)), e;
}
function h() {
  n(2);
}
function y(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function b(e) {
  var T = tn[e];
  return T || n(18, e), T;
}
function m(e, T) {
  tn[e] || (tn[e] = T);
}
function _() {
  return process.env.NODE_ENV === "production" || U || n(0), U;
}
function j(e, T) {
  T && (b("Patches"), e.u = [], e.s = [], e.v = T);
}
function g(e) {
  O(e), e.p.forEach(S), e.p = null;
}
function O(e) {
  e === U && (U = e.l);
}
function w(e) {
  return U = { p: [], l: U, h: e, m: !0, _: 0 };
}
function S(e) {
  var T = e[Q];
  T.i === 0 || T.i === 1 ? T.j() : T.g = !0;
}
function P(e, T) {
  T._ = T.p.length;
  var F = T.p[0], $ = e !== void 0 && e !== F;
  return T.h.O || b("ES5").S(T, e, $), $ ? (F[Q].P && (g(T), n(4)), t(e) && (e = M$1(T, e), T.l || x(T, e)), T.u && b("Patches").M(F[Q].t, e, T.u, T.s)) : e = M$1(T, F, []), g(T), T.u && T.v(T.u, T.s), e !== H ? e : void 0;
}
function M$1(e, T, F) {
  if (y(T))
    return T;
  var $ = T[Q];
  if (!$)
    return i(T, function(oe, se) {
      return A(e, $, T, oe, se, F);
    }, !0), T;
  if ($.A !== e)
    return T;
  if (!$.P)
    return x(e, $.t, !0), $.t;
  if (!$.I) {
    $.I = !0, $.A._--;
    var J = $.i === 4 || $.i === 5 ? $.o = l($.k) : $.o, ee = J, ne = !1;
    $.i === 3 && (ee = new Set(J), J.clear(), ne = !0), i(ee, function(oe, se) {
      return A(e, $, J, oe, se, F, ne);
    }), x(e, J, !1), F && e.u && b("Patches").N($, F, e.u, e.s);
  }
  return $.o;
}
function A(e, T, F, $, J, ee, ne) {
  if (process.env.NODE_ENV !== "production" && J === F && n(5), r(J)) {
    var oe = M$1(e, J, ee && T && T.i !== 3 && !u(T.R, $) ? ee.concat($) : void 0);
    if (f(F, $, oe), !r(oe))
      return;
    e.m = !1;
  } else
    ne && F.add(J);
  if (t(J) && !y(J)) {
    if (!e.h.D && e._ < 1)
      return;
    M$1(e, J), T && T.A.l || x(e, J);
  }
}
function x(e, T, F) {
  F === void 0 && (F = !1), !e.l && e.h.D && e.m && d(T, F);
}
function z(e, T) {
  var F = e[Q];
  return (F ? p(F) : e)[T];
}
function I(e, T) {
  if (T in e)
    for (var F = Object.getPrototypeOf(e); F; ) {
      var $ = Object.getOwnPropertyDescriptor(F, T);
      if ($)
        return $;
      F = Object.getPrototypeOf(F);
    }
}
function k(e) {
  e.P || (e.P = !0, e.l && k(e.l));
}
function E(e) {
  e.o || (e.o = l(e.t));
}
function N(e, T, F) {
  var $ = s(T) ? b("MapSet").F(T, F) : v(T) ? b("MapSet").T(T, F) : e.O ? function(J, ee) {
    var ne = Array.isArray(J), oe = { i: ne ? 1 : 0, A: ee ? ee.A : _(), P: !1, I: !1, R: {}, l: ee, t: J, k: null, o: null, j: null, C: !1 }, se = oe, le = en$1;
    ne && (se = [oe], le = on);
    var de = Proxy.revocable(se, le), ce = de.revoke, he = de.proxy;
    return oe.k = he, oe.j = ce, he;
  }(T, F) : b("ES5").J(T, F);
  return (F ? F.A : _()).p.push($), $;
}
function R$1(e) {
  return r(e) || n(22, e), function T(F) {
    if (!t(F))
      return F;
    var $, J = F[Q], ee = o(F);
    if (J) {
      if (!J.P && (J.i < 4 || !b("ES5").K(J)))
        return J.t;
      J.I = !0, $ = D(F, ee), J.I = !1;
    } else
      $ = D(F, ee);
    return i($, function(ne, oe) {
      J && a(J.t, ne) === oe || f($, ne, T(oe));
    }), ee === 3 ? new Set($) : $;
  }(e);
}
function D(e, T) {
  switch (T) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return l(e);
}
function C() {
  function e(oe, se) {
    function le() {
      this.constructor = oe;
    }
    J(oe, se), oe.prototype = (le.prototype = se.prototype, new le());
  }
  function T(oe) {
    oe.o || (oe.R = /* @__PURE__ */ new Map(), oe.o = new Map(oe.t));
  }
  function F(oe) {
    oe.o || (oe.o = /* @__PURE__ */ new Set(), oe.t.forEach(function(se) {
      if (t(se)) {
        var le = N(oe.A.h, se, oe);
        oe.p.set(se, le), oe.o.add(le);
      } else
        oe.o.add(se);
    }));
  }
  function $(oe) {
    oe.g && n(3, JSON.stringify(p(oe)));
  }
  var J = function(oe, se) {
    return (J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(le, de) {
      le.__proto__ = de;
    } || function(le, de) {
      for (var ce in de)
        de.hasOwnProperty(ce) && (le[ce] = de[ce]);
    })(oe, se);
  }, ee = function() {
    function oe(le, de) {
      return this[Q] = { i: 2, l: de, A: de ? de.A : _(), P: !1, I: !1, o: void 0, R: void 0, t: le, k: this, C: !1, g: !1 }, this;
    }
    e(oe, Map);
    var se = oe.prototype;
    return Object.defineProperty(se, "size", { get: function() {
      return p(this[Q]).size;
    } }), se.has = function(le) {
      return p(this[Q]).has(le);
    }, se.set = function(le, de) {
      var ce = this[Q];
      return $(ce), p(ce).has(le) && p(ce).get(le) === de || (T(ce), k(ce), ce.R.set(le, !0), ce.o.set(le, de), ce.R.set(le, !0)), this;
    }, se.delete = function(le) {
      if (!this.has(le))
        return !1;
      var de = this[Q];
      return $(de), T(de), k(de), de.t.has(le) ? de.R.set(le, !1) : de.R.delete(le), de.o.delete(le), !0;
    }, se.clear = function() {
      var le = this[Q];
      $(le), p(le).size && (T(le), k(le), le.R = /* @__PURE__ */ new Map(), i(le.t, function(de) {
        le.R.set(de, !1);
      }), le.o.clear());
    }, se.forEach = function(le, de) {
      var ce = this;
      p(this[Q]).forEach(function(he, ve) {
        le.call(de, ce.get(ve), ve, ce);
      });
    }, se.get = function(le) {
      var de = this[Q];
      $(de);
      var ce = p(de).get(le);
      if (de.I || !t(ce) || ce !== de.t.get(le))
        return ce;
      var he = N(de.A.h, ce, de);
      return T(de), de.o.set(le, he), he;
    }, se.keys = function() {
      return p(this[Q]).keys();
    }, se.values = function() {
      var le, de = this, ce = this.keys();
      return (le = {})[V] = function() {
        return de.values();
      }, le.next = function() {
        var he = ce.next();
        return he.done ? he : { done: !1, value: de.get(he.value) };
      }, le;
    }, se.entries = function() {
      var le, de = this, ce = this.keys();
      return (le = {})[V] = function() {
        return de.entries();
      }, le.next = function() {
        var he = ce.next();
        if (he.done)
          return he;
        var ve = de.get(he.value);
        return { done: !1, value: [he.value, ve] };
      }, le;
    }, se[V] = function() {
      return this.entries();
    }, oe;
  }(), ne = function() {
    function oe(le, de) {
      return this[Q] = { i: 3, l: de, A: de ? de.A : _(), P: !1, I: !1, o: void 0, t: le, k: this, p: /* @__PURE__ */ new Map(), g: !1, C: !1 }, this;
    }
    e(oe, Set);
    var se = oe.prototype;
    return Object.defineProperty(se, "size", { get: function() {
      return p(this[Q]).size;
    } }), se.has = function(le) {
      var de = this[Q];
      return $(de), de.o ? !!de.o.has(le) || !(!de.p.has(le) || !de.o.has(de.p.get(le))) : de.t.has(le);
    }, se.add = function(le) {
      var de = this[Q];
      return $(de), this.has(le) || (F(de), k(de), de.o.add(le)), this;
    }, se.delete = function(le) {
      if (!this.has(le))
        return !1;
      var de = this[Q];
      return $(de), F(de), k(de), de.o.delete(le) || !!de.p.has(le) && de.o.delete(de.p.get(le));
    }, se.clear = function() {
      var le = this[Q];
      $(le), p(le).size && (F(le), k(le), le.o.clear());
    }, se.values = function() {
      var le = this[Q];
      return $(le), F(le), le.o.values();
    }, se.entries = function() {
      var le = this[Q];
      return $(le), F(le), le.o.entries();
    }, se.keys = function() {
      return this.values();
    }, se[V] = function() {
      return this.values();
    }, se.forEach = function(le, de) {
      for (var ce = this.values(), he = ce.next(); !he.done; )
        le.call(de, he.value, he.value, this), he = ce.next();
    }, oe;
  }();
  m("MapSet", { F: function(oe, se) {
    return new ee(oe, se);
  }, T: function(oe, se) {
    return new ne(oe, se);
  } });
}
var G, U, W = typeof Symbol != "undefined" && typeof Symbol("x") == "symbol", X = typeof Map != "undefined", q = typeof Set != "undefined", B = typeof Proxy != "undefined" && Proxy.revocable !== void 0 && typeof Reflect != "undefined", H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = typeof Symbol != "undefined" && Symbol.iterator || "@@iterator", Y = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, Z = "" + Object.prototype.constructor, nn = typeof Reflect != "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(e) {
  var T = {};
  return nn(e).forEach(function(F) {
    T[F] = Object.getOwnPropertyDescriptor(e, F);
  }), T;
}, tn = {}, en$1 = { get: function(e, T) {
  if (T === Q)
    return e;
  var F = p(e);
  if (!u(F, T))
    return function(J, ee, ne) {
      var oe, se = I(ee, ne);
      return se ? "value" in se ? se.value : (oe = se.get) === null || oe === void 0 ? void 0 : oe.call(J.k) : void 0;
    }(e, F, T);
  var $ = F[T];
  return e.I || !t($) ? $ : $ === z(e.t, T) ? (E(e), e.o[T] = N(e.A.h, $, e)) : $;
}, has: function(e, T) {
  return T in p(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(p(e));
}, set: function(e, T, F) {
  var $ = I(p(e), T);
  if ($ != null && $.set)
    return $.set.call(e.k, F), !0;
  if (!e.P) {
    var J = z(p(e), T), ee = J == null ? void 0 : J[Q];
    if (ee && ee.t === F)
      return e.o[T] = F, e.R[T] = !1, !0;
    if (c(F, J) && (F !== void 0 || u(e.t, T)))
      return !0;
    E(e), k(e);
  }
  return e.o[T] === F && (F !== void 0 || T in e.o) || Number.isNaN(F) && Number.isNaN(e.o[T]) || (e.o[T] = F, e.R[T] = !0), !0;
}, deleteProperty: function(e, T) {
  return z(e.t, T) !== void 0 || T in e.t ? (e.R[T] = !1, E(e), k(e)) : delete e.R[T], e.o && delete e.o[T], !0;
}, getOwnPropertyDescriptor: function(e, T) {
  var F = p(e), $ = Reflect.getOwnPropertyDescriptor(F, T);
  return $ && { writable: !0, configurable: e.i !== 1 || T !== "length", enumerable: $.enumerable, value: F[T] };
}, defineProperty: function() {
  n(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  n(12);
} }, on = {};
i(en$1, function(e, T) {
  on[e] = function() {
    return arguments[0] = arguments[0][0], T.apply(this, arguments);
  };
}), on.deleteProperty = function(e, T) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(T)) && n(13), on.set.call(this, e, T, void 0);
}, on.set = function(e, T, F) {
  return process.env.NODE_ENV !== "production" && T !== "length" && isNaN(parseInt(T)) && n(14), en$1.set.call(this, e[0], T, F, e[0]);
};
var un = function() {
  function e(F) {
    var $ = this;
    this.O = B, this.D = !0, this.produce = function(J, ee, ne) {
      if (typeof J == "function" && typeof ee != "function") {
        var oe = ee;
        ee = J;
        var se = $;
        return function(be) {
          var Te = this;
          be === void 0 && (be = oe);
          for (var Se = arguments.length, Ie = Array(Se > 1 ? Se - 1 : 0), Oe = 1; Oe < Se; Oe++)
            Ie[Oe - 1] = arguments[Oe];
          return se.produce(be, function(Le) {
            var Ne;
            return (Ne = ee).call.apply(Ne, [Te, Le].concat(Ie));
          });
        };
      }
      var le;
      if (typeof ee != "function" && n(6), ne !== void 0 && typeof ne != "function" && n(7), t(J)) {
        var de = w($), ce = N($, J, void 0), he = !0;
        try {
          le = ee(ce), he = !1;
        } finally {
          he ? g(de) : O(de);
        }
        return typeof Promise != "undefined" && le instanceof Promise ? le.then(function(be) {
          return j(de, ne), P(be, de);
        }, function(be) {
          throw g(de), be;
        }) : (j(de, ne), P(le, de));
      }
      if (!J || typeof J != "object") {
        if ((le = ee(J)) === void 0 && (le = J), le === H && (le = void 0), $.D && d(le, !0), ne) {
          var ve = [], ge = [];
          b("Patches").M(J, le, ve, ge), ne(ve, ge);
        }
        return le;
      }
      n(21, J);
    }, this.produceWithPatches = function(J, ee) {
      if (typeof J == "function")
        return function(le) {
          for (var de = arguments.length, ce = Array(de > 1 ? de - 1 : 0), he = 1; he < de; he++)
            ce[he - 1] = arguments[he];
          return $.produceWithPatches(le, function(ve) {
            return J.apply(void 0, [ve].concat(ce));
          });
        };
      var ne, oe, se = $.produce(J, ee, function(le, de) {
        ne = le, oe = de;
      });
      return typeof Promise != "undefined" && se instanceof Promise ? se.then(function(le) {
        return [le, ne, oe];
      }) : [se, ne, oe];
    }, typeof (F == null ? void 0 : F.useProxies) == "boolean" && this.setUseProxies(F.useProxies), typeof (F == null ? void 0 : F.autoFreeze) == "boolean" && this.setAutoFreeze(F.autoFreeze);
  }
  var T = e.prototype;
  return T.createDraft = function(F) {
    t(F) || n(8), r(F) && (F = R$1(F));
    var $ = w(this), J = N(this, F, void 0);
    return J[Q].C = !0, O($), J;
  }, T.finishDraft = function(F, $) {
    var J = F && F[Q];
    process.env.NODE_ENV !== "production" && (J && J.C || n(9), J.I && n(10));
    var ee = J.A;
    return j(ee, $), P(void 0, ee);
  }, T.setAutoFreeze = function(F) {
    this.D = F;
  }, T.setUseProxies = function(F) {
    F && !B && n(20), this.O = F;
  }, T.applyPatches = function(F, $) {
    var J;
    for (J = $.length - 1; J >= 0; J--) {
      var ee = $[J];
      if (ee.path.length === 0 && ee.op === "replace") {
        F = ee.value;
        break;
      }
    }
    J > -1 && ($ = $.slice(J + 1));
    var ne = b("Patches").$;
    return r(F) ? ne(F, $) : this.produce(F, function(oe) {
      return ne(oe, $);
    });
  }, e;
}(), an = new un(), fn = an.produce;
an.produceWithPatches.bind(an);
an.setAutoFreeze.bind(an);
an.setUseProxies.bind(an);
an.applyPatches.bind(an);
an.createDraft.bind(an);
an.finishDraft.bind(an);
const produce = fn;
var extendStatics = function(e, T) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(F, $) {
    F.__proto__ = $;
  } || function(F, $) {
    for (var J in $)
      Object.prototype.hasOwnProperty.call($, J) && (F[J] = $[J]);
  }, extendStatics(e, T);
};
function __extends(e, T) {
  if (typeof T != "function" && T !== null)
    throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
  extendStatics(e, T);
  function F() {
    this.constructor = e;
  }
  e.prototype = T === null ? Object.create(T) : (F.prototype = T.prototype, new F());
}
var __assign = function() {
  return __assign = Object.assign || function(T) {
    for (var F, $ = 1, J = arguments.length; $ < J; $++) {
      F = arguments[$];
      for (var ee in F)
        Object.prototype.hasOwnProperty.call(F, ee) && (T[ee] = F[ee]);
    }
    return T;
  }, __assign.apply(this, arguments);
};
function __awaiter(e, T, F, $) {
  function J(ee) {
    return ee instanceof F ? ee : new F(function(ne) {
      ne(ee);
    });
  }
  return new (F || (F = Promise))(function(ee, ne) {
    function oe(de) {
      try {
        le($.next(de));
      } catch (ce) {
        ne(ce);
      }
    }
    function se(de) {
      try {
        le($.throw(de));
      } catch (ce) {
        ne(ce);
      }
    }
    function le(de) {
      de.done ? ee(de.value) : J(de.value).then(oe, se);
    }
    le(($ = $.apply(e, T || [])).next());
  });
}
function __generator(e, T) {
  var F = { label: 0, sent: function() {
    if (ee[0] & 1)
      throw ee[1];
    return ee[1];
  }, trys: [], ops: [] }, $, J, ee, ne;
  return ne = { next: oe(0), throw: oe(1), return: oe(2) }, typeof Symbol == "function" && (ne[Symbol.iterator] = function() {
    return this;
  }), ne;
  function oe(le) {
    return function(de) {
      return se([le, de]);
    };
  }
  function se(le) {
    if ($)
      throw new TypeError("Generator is already executing.");
    for (; ne && (ne = 0, le[0] && (F = 0)), F; )
      try {
        if ($ = 1, J && (ee = le[0] & 2 ? J.return : le[0] ? J.throw || ((ee = J.return) && ee.call(J), 0) : J.next) && !(ee = ee.call(J, le[1])).done)
          return ee;
        switch (J = 0, ee && (le = [le[0] & 2, ee.value]), le[0]) {
          case 0:
          case 1:
            ee = le;
            break;
          case 4:
            return F.label++, { value: le[1], done: !1 };
          case 5:
            F.label++, J = le[1], le = [0];
            continue;
          case 7:
            le = F.ops.pop(), F.trys.pop();
            continue;
          default:
            if (ee = F.trys, !(ee = ee.length > 0 && ee[ee.length - 1]) && (le[0] === 6 || le[0] === 2)) {
              F = 0;
              continue;
            }
            if (le[0] === 3 && (!ee || le[1] > ee[0] && le[1] < ee[3])) {
              F.label = le[1];
              break;
            }
            if (le[0] === 6 && F.label < ee[1]) {
              F.label = ee[1], ee = le;
              break;
            }
            if (ee && F.label < ee[2]) {
              F.label = ee[2], F.ops.push(le);
              break;
            }
            ee[2] && F.ops.pop(), F.trys.pop();
            continue;
        }
        le = T.call(e, F);
      } catch (de) {
        le = [6, de], J = 0;
      } finally {
        $ = ee = 0;
      }
    if (le[0] & 5)
      throw le[1];
    return { value: le[0] ? le[1] : void 0, done: !0 };
  }
}
function __values(e) {
  var T = typeof Symbol == "function" && Symbol.iterator, F = T && e[T], $ = 0;
  if (F)
    return F.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && $ >= e.length && (e = void 0), { value: e && e[$++], done: !e };
      }
    };
  throw new TypeError(T ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(e, T) {
  var F = typeof Symbol == "function" && e[Symbol.iterator];
  if (!F)
    return e;
  var $ = F.call(e), J, ee = [], ne;
  try {
    for (; (T === void 0 || T-- > 0) && !(J = $.next()).done; )
      ee.push(J.value);
  } catch (oe) {
    ne = { error: oe };
  } finally {
    try {
      J && !J.done && (F = $.return) && F.call($);
    } finally {
      if (ne)
        throw ne.error;
    }
  }
  return ee;
}
function __spreadArray(e, T, F) {
  if (F || arguments.length === 2)
    for (var $ = 0, J = T.length, ee; $ < J; $++)
      (ee || !($ in T)) && (ee || (ee = Array.prototype.slice.call(T, 0, $)), ee[$] = T[$]);
  return e.concat(ee || Array.prototype.slice.call(T));
}
function __await(e) {
  return this instanceof __await ? (this.v = e, this) : new __await(e);
}
function __asyncGenerator(e, T, F) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var $ = F.apply(e, T || []), J, ee = [];
  return J = {}, oe("next"), oe("throw"), oe("return", ne), J[Symbol.asyncIterator] = function() {
    return this;
  }, J;
  function ne(ve) {
    return function(ge) {
      return Promise.resolve(ge).then(ve, ce);
    };
  }
  function oe(ve, ge) {
    $[ve] && (J[ve] = function(be) {
      return new Promise(function(Te, Se) {
        ee.push([ve, be, Te, Se]) > 1 || se(ve, be);
      });
    }, ge && (J[ve] = ge(J[ve])));
  }
  function se(ve, ge) {
    try {
      le($[ve](ge));
    } catch (be) {
      he(ee[0][3], be);
    }
  }
  function le(ve) {
    ve.value instanceof __await ? Promise.resolve(ve.value.v).then(de, ce) : he(ee[0][2], ve);
  }
  function de(ve) {
    se("next", ve);
  }
  function ce(ve) {
    se("throw", ve);
  }
  function he(ve, ge) {
    ve(ge), ee.shift(), ee.length && se(ee[0][0], ee[0][1]);
  }
}
function __asyncValues(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var T = e[Symbol.asyncIterator], F;
  return T ? T.call(e) : (e = typeof __values == "function" ? __values(e) : e[Symbol.iterator](), F = {}, $("next"), $("throw"), $("return"), F[Symbol.asyncIterator] = function() {
    return this;
  }, F);
  function $(ee) {
    F[ee] = e[ee] && function(ne) {
      return new Promise(function(oe, se) {
        ne = e[ee](ne), J(oe, se, ne.done, ne.value);
      });
    };
  }
  function J(ee, ne, oe, se) {
    Promise.resolve(se).then(function(le) {
      ee({ value: le, done: oe });
    }, ne);
  }
}
typeof SuppressedError == "function" && SuppressedError;
function isFunction$6(e) {
  return typeof e == "function";
}
function createErrorClass(e) {
  var T = function($) {
    Error.call($), $.stack = new Error().stack;
  }, F = e(T);
  return F.prototype = Object.create(Error.prototype), F.prototype.constructor = F, F;
}
var UnsubscriptionError = createErrorClass(function(e) {
  return function(F) {
    e(this), this.message = F ? F.length + ` errors occurred during unsubscription:
` + F.map(function($, J) {
      return J + 1 + ") " + $.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = F;
  };
});
function arrRemove(e, T) {
  if (e) {
    var F = e.indexOf(T);
    0 <= F && e.splice(F, 1);
  }
}
var Subscription = function() {
  function e(T) {
    this.initialTeardown = T, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var T, F, $, J, ee;
    if (!this.closed) {
      this.closed = !0;
      var ne = this._parentage;
      if (ne)
        if (this._parentage = null, Array.isArray(ne))
          try {
            for (var oe = __values(ne), se = oe.next(); !se.done; se = oe.next()) {
              var le = se.value;
              le.remove(this);
            }
          } catch (be) {
            T = { error: be };
          } finally {
            try {
              se && !se.done && (F = oe.return) && F.call(oe);
            } finally {
              if (T)
                throw T.error;
            }
          }
        else
          ne.remove(this);
      var de = this.initialTeardown;
      if (isFunction$6(de))
        try {
          de();
        } catch (be) {
          ee = be instanceof UnsubscriptionError ? be.errors : [be];
        }
      var ce = this._finalizers;
      if (ce) {
        this._finalizers = null;
        try {
          for (var he = __values(ce), ve = he.next(); !ve.done; ve = he.next()) {
            var ge = ve.value;
            try {
              execFinalizer(ge);
            } catch (be) {
              ee = ee != null ? ee : [], be instanceof UnsubscriptionError ? ee = __spreadArray(__spreadArray([], __read(ee)), __read(be.errors)) : ee.push(be);
            }
          }
        } catch (be) {
          $ = { error: be };
        } finally {
          try {
            ve && !ve.done && (J = he.return) && J.call(he);
          } finally {
            if ($)
              throw $.error;
          }
        }
      }
      if (ee)
        throw new UnsubscriptionError(ee);
    }
  }, e.prototype.add = function(T) {
    var F;
    if (T && T !== this)
      if (this.closed)
        execFinalizer(T);
      else {
        if (T instanceof e) {
          if (T.closed || T._hasParent(this))
            return;
          T._addParent(this);
        }
        (this._finalizers = (F = this._finalizers) !== null && F !== void 0 ? F : []).push(T);
      }
  }, e.prototype._hasParent = function(T) {
    var F = this._parentage;
    return F === T || Array.isArray(F) && F.includes(T);
  }, e.prototype._addParent = function(T) {
    var F = this._parentage;
    this._parentage = Array.isArray(F) ? (F.push(T), F) : F ? [F, T] : T;
  }, e.prototype._removeParent = function(T) {
    var F = this._parentage;
    F === T ? this._parentage = null : Array.isArray(F) && arrRemove(F, T);
  }, e.prototype.remove = function(T) {
    var F = this._finalizers;
    F && arrRemove(F, T), T instanceof e && T._removeParent(this);
  }, e.EMPTY = function() {
    var T = new e();
    return T.closed = !0, T;
  }(), e;
}(), EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(e) {
  return e instanceof Subscription || e && "closed" in e && isFunction$6(e.remove) && isFunction$6(e.add) && isFunction$6(e.unsubscribe);
}
function execFinalizer(e) {
  isFunction$6(e) ? e() : e.unsubscribe();
}
var config = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, timeoutProvider = {
  setTimeout: function(e, T) {
    for (var F = [], $ = 2; $ < arguments.length; $++)
      F[$ - 2] = arguments[$];
    var J = timeoutProvider.delegate;
    return J != null && J.setTimeout ? J.setTimeout.apply(J, __spreadArray([e, T], __read(F))) : setTimeout.apply(void 0, __spreadArray([e, T], __read(F)));
  },
  clearTimeout: function(e) {
    var T = timeoutProvider.delegate;
    return ((T == null ? void 0 : T.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function reportUnhandledError(e) {
  timeoutProvider.setTimeout(function() {
    throw e;
  });
}
function noop$2() {
}
function errorContext(e) {
  e();
}
var Subscriber = function(e) {
  __extends(T, e);
  function T(F) {
    var $ = e.call(this) || this;
    return $.isStopped = !1, F ? ($.destination = F, isSubscription(F) && F.add($)) : $.destination = EMPTY_OBSERVER, $;
  }
  return T.create = function(F, $, J) {
    return new SafeSubscriber(F, $, J);
  }, T.prototype.next = function(F) {
    this.isStopped || this._next(F);
  }, T.prototype.error = function(F) {
    this.isStopped || (this.isStopped = !0, this._error(F));
  }, T.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, T.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, T.prototype._next = function(F) {
    this.destination.next(F);
  }, T.prototype._error = function(F) {
    try {
      this.destination.error(F);
    } finally {
      this.unsubscribe();
    }
  }, T.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, T;
}(Subscription), _bind = Function.prototype.bind;
function bind$3(e, T) {
  return _bind.call(e, T);
}
var ConsumerObserver = function() {
  function e(T) {
    this.partialObserver = T;
  }
  return e.prototype.next = function(T) {
    var F = this.partialObserver;
    if (F.next)
      try {
        F.next(T);
      } catch ($) {
        handleUnhandledError($);
      }
  }, e.prototype.error = function(T) {
    var F = this.partialObserver;
    if (F.error)
      try {
        F.error(T);
      } catch ($) {
        handleUnhandledError($);
      }
    else
      handleUnhandledError(T);
  }, e.prototype.complete = function() {
    var T = this.partialObserver;
    if (T.complete)
      try {
        T.complete();
      } catch (F) {
        handleUnhandledError(F);
      }
  }, e;
}(), SafeSubscriber = function(e) {
  __extends(T, e);
  function T(F, $, J) {
    var ee = e.call(this) || this, ne;
    if (isFunction$6(F) || !F)
      ne = {
        next: F != null ? F : void 0,
        error: $ != null ? $ : void 0,
        complete: J != null ? J : void 0
      };
    else {
      var oe;
      ee && config.useDeprecatedNextContext ? (oe = Object.create(F), oe.unsubscribe = function() {
        return ee.unsubscribe();
      }, ne = {
        next: F.next && bind$3(F.next, oe),
        error: F.error && bind$3(F.error, oe),
        complete: F.complete && bind$3(F.complete, oe)
      }) : ne = F;
    }
    return ee.destination = new ConsumerObserver(ne), ee;
  }
  return T;
}(Subscriber);
function handleUnhandledError(e) {
  reportUnhandledError(e);
}
function defaultErrorHandler(e) {
  throw e;
}
var EMPTY_OBSERVER = {
  closed: !0,
  next: noop$2,
  error: defaultErrorHandler,
  complete: noop$2
}, observable = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function identity$2(e) {
  return e;
}
function pipeFromArray(e) {
  return e.length === 0 ? identity$2 : e.length === 1 ? e[0] : function(F) {
    return e.reduce(function($, J) {
      return J($);
    }, F);
  };
}
var Observable = function() {
  function e(T) {
    T && (this._subscribe = T);
  }
  return e.prototype.lift = function(T) {
    var F = new e();
    return F.source = this, F.operator = T, F;
  }, e.prototype.subscribe = function(T, F, $) {
    var J = this, ee = isSubscriber(T) ? T : new SafeSubscriber(T, F, $);
    return errorContext(function() {
      var ne = J, oe = ne.operator, se = ne.source;
      ee.add(oe ? oe.call(ee, se) : se ? J._subscribe(ee) : J._trySubscribe(ee));
    }), ee;
  }, e.prototype._trySubscribe = function(T) {
    try {
      return this._subscribe(T);
    } catch (F) {
      T.error(F);
    }
  }, e.prototype.forEach = function(T, F) {
    var $ = this;
    return F = getPromiseCtor(F), new F(function(J, ee) {
      var ne = new SafeSubscriber({
        next: function(oe) {
          try {
            T(oe);
          } catch (se) {
            ee(se), ne.unsubscribe();
          }
        },
        error: ee,
        complete: J
      });
      $.subscribe(ne);
    });
  }, e.prototype._subscribe = function(T) {
    var F;
    return (F = this.source) === null || F === void 0 ? void 0 : F.subscribe(T);
  }, e.prototype[observable] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var T = [], F = 0; F < arguments.length; F++)
      T[F] = arguments[F];
    return pipeFromArray(T)(this);
  }, e.prototype.toPromise = function(T) {
    var F = this;
    return T = getPromiseCtor(T), new T(function($, J) {
      var ee;
      F.subscribe(function(ne) {
        return ee = ne;
      }, function(ne) {
        return J(ne);
      }, function() {
        return $(ee);
      });
    });
  }, e.create = function(T) {
    return new e(T);
  }, e;
}();
function getPromiseCtor(e) {
  var T;
  return (T = e != null ? e : config.Promise) !== null && T !== void 0 ? T : Promise;
}
function isObserver(e) {
  return e && isFunction$6(e.next) && isFunction$6(e.error) && isFunction$6(e.complete);
}
function isSubscriber(e) {
  return e && e instanceof Subscriber || isObserver(e) && isSubscription(e);
}
function hasLift(e) {
  return isFunction$6(e == null ? void 0 : e.lift);
}
function operate(e) {
  return function(T) {
    if (hasLift(T))
      return T.lift(function(F) {
        try {
          return e(F, this);
        } catch ($) {
          this.error($);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function createOperatorSubscriber(e, T, F, $, J) {
  return new OperatorSubscriber(e, T, F, $, J);
}
var OperatorSubscriber = function(e) {
  __extends(T, e);
  function T(F, $, J, ee, ne, oe) {
    var se = e.call(this, F) || this;
    return se.onFinalize = ne, se.shouldUnsubscribe = oe, se._next = $ ? function(le) {
      try {
        $(le);
      } catch (de) {
        F.error(de);
      }
    } : e.prototype._next, se._error = ee ? function(le) {
      try {
        ee(le);
      } catch (de) {
        F.error(de);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, se._complete = J ? function() {
      try {
        J();
      } catch (le) {
        F.error(le);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, se;
  }
  return T.prototype.unsubscribe = function() {
    var F;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var $ = this.closed;
      e.prototype.unsubscribe.call(this), !$ && ((F = this.onFinalize) === null || F === void 0 || F.call(this));
    }
  }, T;
}(Subscriber), ObjectUnsubscribedError = createErrorClass(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Subject = function(e) {
  __extends(T, e);
  function T() {
    var F = e.call(this) || this;
    return F.closed = !1, F.currentObservers = null, F.observers = [], F.isStopped = !1, F.hasError = !1, F.thrownError = null, F;
  }
  return T.prototype.lift = function(F) {
    var $ = new AnonymousSubject(this, this);
    return $.operator = F, $;
  }, T.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new ObjectUnsubscribedError();
  }, T.prototype.next = function(F) {
    var $ = this;
    errorContext(function() {
      var J, ee;
      if ($._throwIfClosed(), !$.isStopped) {
        $.currentObservers || ($.currentObservers = Array.from($.observers));
        try {
          for (var ne = __values($.currentObservers), oe = ne.next(); !oe.done; oe = ne.next()) {
            var se = oe.value;
            se.next(F);
          }
        } catch (le) {
          J = { error: le };
        } finally {
          try {
            oe && !oe.done && (ee = ne.return) && ee.call(ne);
          } finally {
            if (J)
              throw J.error;
          }
        }
      }
    });
  }, T.prototype.error = function(F) {
    var $ = this;
    errorContext(function() {
      if ($._throwIfClosed(), !$.isStopped) {
        $.hasError = $.isStopped = !0, $.thrownError = F;
        for (var J = $.observers; J.length; )
          J.shift().error(F);
      }
    });
  }, T.prototype.complete = function() {
    var F = this;
    errorContext(function() {
      if (F._throwIfClosed(), !F.isStopped) {
        F.isStopped = !0;
        for (var $ = F.observers; $.length; )
          $.shift().complete();
      }
    });
  }, T.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(T.prototype, "observed", {
    get: function() {
      var F;
      return ((F = this.observers) === null || F === void 0 ? void 0 : F.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), T.prototype._trySubscribe = function(F) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, F);
  }, T.prototype._subscribe = function(F) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(F), this._innerSubscribe(F);
  }, T.prototype._innerSubscribe = function(F) {
    var $ = this, J = this, ee = J.hasError, ne = J.isStopped, oe = J.observers;
    return ee || ne ? EMPTY_SUBSCRIPTION : (this.currentObservers = null, oe.push(F), new Subscription(function() {
      $.currentObservers = null, arrRemove(oe, F);
    }));
  }, T.prototype._checkFinalizedStatuses = function(F) {
    var $ = this, J = $.hasError, ee = $.thrownError, ne = $.isStopped;
    J ? F.error(ee) : ne && F.complete();
  }, T.prototype.asObservable = function() {
    var F = new Observable();
    return F.source = this, F;
  }, T.create = function(F, $) {
    return new AnonymousSubject(F, $);
  }, T;
}(Observable), AnonymousSubject = function(e) {
  __extends(T, e);
  function T(F, $) {
    var J = e.call(this) || this;
    return J.destination = F, J.source = $, J;
  }
  return T.prototype.next = function(F) {
    var $, J;
    (J = ($ = this.destination) === null || $ === void 0 ? void 0 : $.next) === null || J === void 0 || J.call($, F);
  }, T.prototype.error = function(F) {
    var $, J;
    (J = ($ = this.destination) === null || $ === void 0 ? void 0 : $.error) === null || J === void 0 || J.call($, F);
  }, T.prototype.complete = function() {
    var F, $;
    ($ = (F = this.destination) === null || F === void 0 ? void 0 : F.complete) === null || $ === void 0 || $.call(F);
  }, T.prototype._subscribe = function(F) {
    var $, J;
    return (J = ($ = this.source) === null || $ === void 0 ? void 0 : $.subscribe(F)) !== null && J !== void 0 ? J : EMPTY_SUBSCRIPTION;
  }, T;
}(Subject), BehaviorSubject = function(e) {
  __extends(T, e);
  function T(F) {
    var $ = e.call(this) || this;
    return $._value = F, $;
  }
  return Object.defineProperty(T.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), T.prototype._subscribe = function(F) {
    var $ = e.prototype._subscribe.call(this, F);
    return !$.closed && F.next(this._value), $;
  }, T.prototype.getValue = function() {
    var F = this, $ = F.hasError, J = F.thrownError, ee = F._value;
    if ($)
      throw J;
    return this._throwIfClosed(), ee;
  }, T.prototype.next = function(F) {
    e.prototype.next.call(this, this._value = F);
  }, T;
}(Subject), dateTimestampProvider = {
  now: function() {
    return (dateTimestampProvider.delegate || Date).now();
  },
  delegate: void 0
}, Action = function(e) {
  __extends(T, e);
  function T(F, $) {
    return e.call(this) || this;
  }
  return T.prototype.schedule = function(F, $) {
    return this;
  }, T;
}(Subscription), intervalProvider = {
  setInterval: function(e, T) {
    for (var F = [], $ = 2; $ < arguments.length; $++)
      F[$ - 2] = arguments[$];
    var J = intervalProvider.delegate;
    return J != null && J.setInterval ? J.setInterval.apply(J, __spreadArray([e, T], __read(F))) : setInterval.apply(void 0, __spreadArray([e, T], __read(F)));
  },
  clearInterval: function(e) {
    var T = intervalProvider.delegate;
    return ((T == null ? void 0 : T.clearInterval) || clearInterval)(e);
  },
  delegate: void 0
}, AsyncAction = function(e) {
  __extends(T, e);
  function T(F, $) {
    var J = e.call(this, F, $) || this;
    return J.scheduler = F, J.work = $, J.pending = !1, J;
  }
  return T.prototype.schedule = function(F, $) {
    var J;
    if ($ === void 0 && ($ = 0), this.closed)
      return this;
    this.state = F;
    var ee = this.id, ne = this.scheduler;
    return ee != null && (this.id = this.recycleAsyncId(ne, ee, $)), this.pending = !0, this.delay = $, this.id = (J = this.id) !== null && J !== void 0 ? J : this.requestAsyncId(ne, this.id, $), this;
  }, T.prototype.requestAsyncId = function(F, $, J) {
    return J === void 0 && (J = 0), intervalProvider.setInterval(F.flush.bind(F, this), J);
  }, T.prototype.recycleAsyncId = function(F, $, J) {
    if (J === void 0 && (J = 0), J != null && this.delay === J && this.pending === !1)
      return $;
    $ != null && intervalProvider.clearInterval($);
  }, T.prototype.execute = function(F, $) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var J = this._execute(F, $);
    if (J)
      return J;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, T.prototype._execute = function(F, $) {
    var J = !1, ee;
    try {
      this.work(F);
    } catch (ne) {
      J = !0, ee = ne || new Error("Scheduled action threw falsy error");
    }
    if (J)
      return this.unsubscribe(), ee;
  }, T.prototype.unsubscribe = function() {
    if (!this.closed) {
      var F = this, $ = F.id, J = F.scheduler, ee = J.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, arrRemove(ee, this), $ != null && (this.id = this.recycleAsyncId(J, $, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, T;
}(Action), Scheduler = function() {
  function e(T, F) {
    F === void 0 && (F = e.now), this.schedulerActionCtor = T, this.now = F;
  }
  return e.prototype.schedule = function(T, F, $) {
    return F === void 0 && (F = 0), new this.schedulerActionCtor(this, T).schedule($, F);
  }, e.now = dateTimestampProvider.now, e;
}(), AsyncScheduler = function(e) {
  __extends(T, e);
  function T(F, $) {
    $ === void 0 && ($ = Scheduler.now);
    var J = e.call(this, F, $) || this;
    return J.actions = [], J._active = !1, J;
  }
  return T.prototype.flush = function(F) {
    var $ = this.actions;
    if (this._active) {
      $.push(F);
      return;
    }
    var J;
    this._active = !0;
    do
      if (J = F.execute(F.state, F.delay))
        break;
    while (F = $.shift());
    if (this._active = !1, J) {
      for (; F = $.shift(); )
        F.unsubscribe();
      throw J;
    }
  }, T;
}(Scheduler), asyncScheduler = new AsyncScheduler(AsyncAction), EMPTY = new Observable(function(e) {
  return e.complete();
});
function isScheduler(e) {
  return e && isFunction$6(e.schedule);
}
function last(e) {
  return e[e.length - 1];
}
function popScheduler(e) {
  return isScheduler(last(e)) ? e.pop() : void 0;
}
function popNumber(e, T) {
  return typeof last(e) == "number" ? e.pop() : T;
}
var isArrayLike$2 = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function isPromise$1(e) {
  return isFunction$6(e == null ? void 0 : e.then);
}
function isInteropObservable(e) {
  return isFunction$6(e[observable]);
}
function isAsyncIterable(e) {
  return Symbol.asyncIterator && isFunction$6(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function createInvalidObservableTypeError(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function getSymbolIterator() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var iterator = getSymbolIterator();
function isIterable(e) {
  return isFunction$6(e == null ? void 0 : e[iterator]);
}
function readableStreamLikeToAsyncGenerator(e) {
  return __asyncGenerator(this, arguments, function() {
    var F, $, J, ee;
    return __generator(this, function(ne) {
      switch (ne.label) {
        case 0:
          F = e.getReader(), ne.label = 1;
        case 1:
          ne.trys.push([1, , 9, 10]), ne.label = 2;
        case 2:
          return [4, __await(F.read())];
        case 3:
          return $ = ne.sent(), J = $.value, ee = $.done, ee ? [4, __await(void 0)] : [3, 5];
        case 4:
          return [2, ne.sent()];
        case 5:
          return [4, __await(J)];
        case 6:
          return [4, ne.sent()];
        case 7:
          return ne.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return F.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function isReadableStreamLike(e) {
  return isFunction$6(e == null ? void 0 : e.getReader);
}
function innerFrom(e) {
  if (e instanceof Observable)
    return e;
  if (e != null) {
    if (isInteropObservable(e))
      return fromInteropObservable(e);
    if (isArrayLike$2(e))
      return fromArrayLike(e);
    if (isPromise$1(e))
      return fromPromise(e);
    if (isAsyncIterable(e))
      return fromAsyncIterable(e);
    if (isIterable(e))
      return fromIterable(e);
    if (isReadableStreamLike(e))
      return fromReadableStreamLike(e);
  }
  throw createInvalidObservableTypeError(e);
}
function fromInteropObservable(e) {
  return new Observable(function(T) {
    var F = e[observable]();
    if (isFunction$6(F.subscribe))
      return F.subscribe(T);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function fromArrayLike(e) {
  return new Observable(function(T) {
    for (var F = 0; F < e.length && !T.closed; F++)
      T.next(e[F]);
    T.complete();
  });
}
function fromPromise(e) {
  return new Observable(function(T) {
    e.then(function(F) {
      T.closed || (T.next(F), T.complete());
    }, function(F) {
      return T.error(F);
    }).then(null, reportUnhandledError);
  });
}
function fromIterable(e) {
  return new Observable(function(T) {
    var F, $;
    try {
      for (var J = __values(e), ee = J.next(); !ee.done; ee = J.next()) {
        var ne = ee.value;
        if (T.next(ne), T.closed)
          return;
      }
    } catch (oe) {
      F = { error: oe };
    } finally {
      try {
        ee && !ee.done && ($ = J.return) && $.call(J);
      } finally {
        if (F)
          throw F.error;
      }
    }
    T.complete();
  });
}
function fromAsyncIterable(e) {
  return new Observable(function(T) {
    process$1(e, T).catch(function(F) {
      return T.error(F);
    });
  });
}
function fromReadableStreamLike(e) {
  return fromAsyncIterable(readableStreamLikeToAsyncGenerator(e));
}
function process$1(e, T) {
  var F, $, J, ee;
  return __awaiter(this, void 0, void 0, function() {
    var ne, oe;
    return __generator(this, function(se) {
      switch (se.label) {
        case 0:
          se.trys.push([0, 5, 6, 11]), F = __asyncValues(e), se.label = 1;
        case 1:
          return [4, F.next()];
        case 2:
          if ($ = se.sent(), !!$.done)
            return [3, 4];
          if (ne = $.value, T.next(ne), T.closed)
            return [2];
          se.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return oe = se.sent(), J = { error: oe }, [3, 11];
        case 6:
          return se.trys.push([6, , 9, 10]), $ && !$.done && (ee = F.return) ? [4, ee.call(F)] : [3, 8];
        case 7:
          se.sent(), se.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (J)
            throw J.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return T.complete(), [2];
      }
    });
  });
}
function executeSchedule(e, T, F, $, J) {
  $ === void 0 && ($ = 0), J === void 0 && (J = !1);
  var ee = T.schedule(function() {
    F(), J ? e.add(this.schedule(null, $)) : this.unsubscribe();
  }, $);
  if (e.add(ee), !J)
    return ee;
}
function observeOn(e, T) {
  return T === void 0 && (T = 0), operate(function(F, $) {
    F.subscribe(createOperatorSubscriber($, function(J) {
      return executeSchedule($, e, function() {
        return $.next(J);
      }, T);
    }, function() {
      return executeSchedule($, e, function() {
        return $.complete();
      }, T);
    }, function(J) {
      return executeSchedule($, e, function() {
        return $.error(J);
      }, T);
    }));
  });
}
function subscribeOn(e, T) {
  return T === void 0 && (T = 0), operate(function(F, $) {
    $.add(e.schedule(function() {
      return F.subscribe($);
    }, T));
  });
}
function scheduleObservable(e, T) {
  return innerFrom(e).pipe(subscribeOn(T), observeOn(T));
}
function schedulePromise(e, T) {
  return innerFrom(e).pipe(subscribeOn(T), observeOn(T));
}
function scheduleArray(e, T) {
  return new Observable(function(F) {
    var $ = 0;
    return T.schedule(function() {
      $ === e.length ? F.complete() : (F.next(e[$++]), F.closed || this.schedule());
    });
  });
}
function scheduleIterable(e, T) {
  return new Observable(function(F) {
    var $;
    return executeSchedule(F, T, function() {
      $ = e[iterator](), executeSchedule(F, T, function() {
        var J, ee, ne;
        try {
          J = $.next(), ee = J.value, ne = J.done;
        } catch (oe) {
          F.error(oe);
          return;
        }
        ne ? F.complete() : F.next(ee);
      }, 0, !0);
    }), function() {
      return isFunction$6($ == null ? void 0 : $.return) && $.return();
    };
  });
}
function scheduleAsyncIterable(e, T) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new Observable(function(F) {
    executeSchedule(F, T, function() {
      var $ = e[Symbol.asyncIterator]();
      executeSchedule(F, T, function() {
        $.next().then(function(J) {
          J.done ? F.complete() : F.next(J.value);
        });
      }, 0, !0);
    });
  });
}
function scheduleReadableStreamLike(e, T) {
  return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(e), T);
}
function scheduled(e, T) {
  if (e != null) {
    if (isInteropObservable(e))
      return scheduleObservable(e, T);
    if (isArrayLike$2(e))
      return scheduleArray(e, T);
    if (isPromise$1(e))
      return schedulePromise(e, T);
    if (isAsyncIterable(e))
      return scheduleAsyncIterable(e, T);
    if (isIterable(e))
      return scheduleIterable(e, T);
    if (isReadableStreamLike(e))
      return scheduleReadableStreamLike(e, T);
  }
  throw createInvalidObservableTypeError(e);
}
function from(e, T) {
  return T ? scheduled(e, T) : innerFrom(e);
}
function map$1(e, T) {
  return operate(function(F, $) {
    var J = 0;
    F.subscribe(createOperatorSubscriber($, function(ee) {
      $.next(e.call(T, ee, J++));
    }));
  });
}
function mergeInternals(e, T, F, $, J, ee, ne, oe) {
  var se = [], le = 0, de = 0, ce = !1, he = function() {
    ce && !se.length && !le && T.complete();
  }, ve = function(be) {
    return le < $ ? ge(be) : se.push(be);
  }, ge = function(be) {
    ee && T.next(be), le++;
    var Te = !1;
    innerFrom(F(be, de++)).subscribe(createOperatorSubscriber(T, function(Se) {
      J == null || J(Se), ee ? ve(Se) : T.next(Se);
    }, function() {
      Te = !0;
    }, void 0, function() {
      if (Te)
        try {
          le--;
          for (var Se = function() {
            var Ie = se.shift();
            ne ? executeSchedule(T, ne, function() {
              return ge(Ie);
            }) : ge(Ie);
          }; se.length && le < $; )
            Se();
          he();
        } catch (Ie) {
          T.error(Ie);
        }
    }));
  };
  return e.subscribe(createOperatorSubscriber(T, ve, function() {
    ce = !0, he();
  })), function() {
    oe == null || oe();
  };
}
function mergeMap(e, T, F) {
  return F === void 0 && (F = 1 / 0), isFunction$6(T) ? mergeMap(function($, J) {
    return map$1(function(ee, ne) {
      return T($, ee, J, ne);
    })(innerFrom(e($, J)));
  }, F) : (typeof T == "number" && (F = T), operate(function($, J) {
    return mergeInternals($, J, e, F);
  }));
}
function mergeAll(e) {
  return e === void 0 && (e = 1 / 0), mergeMap(identity$2, e);
}
function merge$1() {
  for (var e = [], T = 0; T < arguments.length; T++)
    e[T] = arguments[T];
  var F = popScheduler(e), $ = popNumber(e, 1 / 0), J = e;
  return J.length ? J.length === 1 ? innerFrom(J[0]) : mergeAll($)(from(J, F)) : EMPTY;
}
function filter(e, T) {
  return operate(function(F, $) {
    var J = 0;
    F.subscribe(createOperatorSubscriber($, function(ee) {
      return e.call(T, ee, J++) && $.next(ee);
    }));
  });
}
function bufferTime(e) {
  for (var T, F, $ = [], J = 1; J < arguments.length; J++)
    $[J - 1] = arguments[J];
  var ee = (T = popScheduler($)) !== null && T !== void 0 ? T : asyncScheduler, ne = (F = $[0]) !== null && F !== void 0 ? F : null, oe = $[1] || 1 / 0;
  return operate(function(se, le) {
    var de = [], ce = !1, he = function(be) {
      var Te = be.buffer, Se = be.subs;
      Se.unsubscribe(), arrRemove(de, be), le.next(Te), ce && ve();
    }, ve = function() {
      if (de) {
        var be = new Subscription();
        le.add(be);
        var Te = [], Se = {
          buffer: Te,
          subs: be
        };
        de.push(Se), executeSchedule(be, ee, function() {
          return he(Se);
        }, e);
      }
    };
    ne !== null && ne >= 0 ? executeSchedule(le, ee, ve, ne, !0) : ce = !0, ve();
    var ge = createOperatorSubscriber(le, function(be) {
      var Te, Se, Ie = de.slice();
      try {
        for (var Oe = __values(Ie), Le = Oe.next(); !Le.done; Le = Oe.next()) {
          var Ne = Le.value, Ue = Ne.buffer;
          Ue.push(be), oe <= Ue.length && he(Ne);
        }
      } catch (je) {
        Te = { error: je };
      } finally {
        try {
          Le && !Le.done && (Se = Oe.return) && Se.call(Oe);
        } finally {
          if (Te)
            throw Te.error;
        }
      }
    }, function() {
      for (; de != null && de.length; )
        le.next(de.shift().buffer);
      ge == null || ge.unsubscribe(), le.complete(), le.unsubscribe();
    }, void 0, function() {
      return de = null;
    });
    se.subscribe(ge);
  });
}
function distinctUntilChanged(e, T) {
  return T === void 0 && (T = identity$2), e = e != null ? e : defaultCompare, operate(function(F, $) {
    var J, ee = !0;
    F.subscribe(createOperatorSubscriber($, function(ne) {
      var oe = T(ne);
      (ee || !e(J, oe)) && (ee = !1, J = oe, $.next(ne));
    }));
  });
}
function defaultCompare(e, T) {
  return e === T;
}
function finalize(e) {
  return operate(function(T, F) {
    try {
      T.subscribe(F);
    } finally {
      F.add(e);
    }
  });
}
function share(e) {
  e === void 0 && (e = {});
  var T = e.connector, F = T === void 0 ? function() {
    return new Subject();
  } : T, $ = e.resetOnError, J = $ === void 0 ? !0 : $, ee = e.resetOnComplete, ne = ee === void 0 ? !0 : ee, oe = e.resetOnRefCountZero, se = oe === void 0 ? !0 : oe;
  return function(le) {
    var de, ce, he, ve = 0, ge = !1, be = !1, Te = function() {
      ce == null || ce.unsubscribe(), ce = void 0;
    }, Se = function() {
      Te(), de = he = void 0, ge = be = !1;
    }, Ie = function() {
      var Oe = de;
      Se(), Oe == null || Oe.unsubscribe();
    };
    return operate(function(Oe, Le) {
      ve++, !be && !ge && Te();
      var Ne = he = he != null ? he : F();
      Le.add(function() {
        ve--, ve === 0 && !be && !ge && (ce = handleReset(Ie, se));
      }), Ne.subscribe(Le), !de && ve > 0 && (de = new SafeSubscriber({
        next: function(Ue) {
          return Ne.next(Ue);
        },
        error: function(Ue) {
          be = !0, Te(), ce = handleReset(Se, J, Ue), Ne.error(Ue);
        },
        complete: function() {
          ge = !0, Te(), ce = handleReset(Se, ne), Ne.complete();
        }
      }), innerFrom(Oe).subscribe(de));
    })(le);
  };
}
function handleReset(e, T) {
  for (var F = [], $ = 2; $ < arguments.length; $++)
    F[$ - 2] = arguments[$];
  if (T === !0) {
    e();
    return;
  }
  if (T !== !1) {
    var J = new SafeSubscriber({
      next: function() {
        J.unsubscribe(), e();
      }
    });
    return innerFrom(T.apply(void 0, __spreadArray([], __read(F)))).subscribe(J);
  }
}
function tap(e, T, F) {
  var $ = isFunction$6(e) || T || F ? { next: e, error: T, complete: F } : e;
  return $ ? operate(function(J, ee) {
    var ne;
    (ne = $.subscribe) === null || ne === void 0 || ne.call($);
    var oe = !0;
    J.subscribe(createOperatorSubscriber(ee, function(se) {
      var le;
      (le = $.next) === null || le === void 0 || le.call($, se), ee.next(se);
    }, function() {
      var se;
      oe = !1, (se = $.complete) === null || se === void 0 || se.call($), ee.complete();
    }, function(se) {
      var le;
      oe = !1, (le = $.error) === null || le === void 0 || le.call($, se), ee.error(se);
    }, function() {
      var se, le;
      oe && ((se = $.unsubscribe) === null || se === void 0 || se.call($)), (le = $.finalize) === null || le === void 0 || le.call($);
    }));
  }) : identity$2;
}
var __defProp$N = Object.defineProperty, __defNormalProp$N = (e, T, F) => T in e ? __defProp$N(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$N = (e, T, F) => (__defNormalProp$N(e, typeof T != "symbol" ? T + "" : T, F), F);
class Events {
  constructor() {
    __publicField$N(this, "_events", {}), __publicField$N(this, "_emitFirstEvents", {});
  }
  _unsubscribe(T, F) {
    T.forEach(($) => {
      $.unsubscribe();
    }), this._events[F] = [];
  }
  on(T, F) {
    const $ = this._events[T], J = new Subject();
    return $ ? $.push(J) : this._events[T] = [J], J.subscribe(F), T in this._emitFirstEvents && (this._emitFirstEvents[T].forEach((ee) => F(ee)), delete this._emitFirstEvents[T]), J;
  }
  emit(T, F) {
    const $ = this._events[T];
    $ && $.length > 0 ? $.forEach((J) => J.next(F)) : this._emitFirstEvents[T] = [F];
  }
  remove(T, F) {
    const { _events: $ } = this, J = $[T];
    if (F) {
      F.unsubscribe(), $[T] = J.filter((ee) => ee !== F);
      return;
    }
    this._unsubscribe(J, T);
  }
  removeAll() {
    const { _events: T } = this;
    Object.keys(T).forEach((F) => {
      const $ = T[F];
      this._unsubscribe($, F);
    }), this._events = {};
  }
}
var __defProp$M = Object.defineProperty, __defNormalProp$M = (e, T, F) => T in e ? __defProp$M(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$M = (e, T, F) => (__defNormalProp$M(e, typeof T != "symbol" ? T + "" : T, F), F);
const assignImmerly = produce((e, T) => Fe(Fe({}, e), T));
class State extends Events {
  constructor(T) {
    super(), __publicField$M(this, "_state$"), this._state$ = new BehaviorSubject(T);
  }
  get state() {
    return this._getState();
  }
  _getState() {
    return this._state$.value;
  }
  _selectState(T) {
    return this._state$.pipe(map$1(T), distinctUntilChanged());
  }
  _getModelState(T, F, $) {
    if ($) {
      const J = $(T._getState()[F]), ee = T._selectState((ne) => $(ne[F]));
      return {
        state: J,
        state$: ee
      };
    } else
      return {
        state: T._getState()[F],
        state$: T._selectState((J) => J[F])
      };
  }
  setState(T) {
    const F = this._getState(), $ = typeof T == "function" ? produce(F, T) : assignImmerly(F, T);
    this._state$.next($);
  }
}
class Model extends State {
}
function modelStateGetter(e, T, F) {
  return () => e._getModelState(e, T, F);
}
var __defProp$L = Object.defineProperty, __defNormalProp$L = (e, T, F) => T in e ? __defProp$L(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$L = (e, T, F) => (__defNormalProp$L(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$L = {};
class MessageModel extends Model {
  constructor() {
    super(INITIAL_STATE$L), __publicField$L(this, "UI_TOAST_ERROR", "http.error"), __publicField$L(this, "UNAUTHORIZED", "401401"), __publicField$L(this, "MULTI_ACCOUNT_LOGINED", "400001"), __publicField$L(this, "MULTI_TABS", "400003"), __publicField$L(this, "MULTI_DEVICES", "MULTI_DEVICES"), __publicField$L(this, "NO_ACCESS", "403"), __publicField$L(this, "NOT_FOUND", "404");
  }
  init() {
    return Me(this, null, function* () {
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$L);
  }
}
const messageModel = new MessageModel();
var commonjsGlobal = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, querystringify$1 = {}, has = Object.prototype.hasOwnProperty, undef;
function decode(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch (T) {
    return null;
  }
}
function encode$2(e) {
  try {
    return encodeURIComponent(e);
  } catch (T) {
    return null;
  }
}
function querystring(e) {
  for (var T = /([^=?#&]+)=?([^&]*)/g, F = {}, $; $ = T.exec(e); ) {
    var J = decode($[1]), ee = decode($[2]);
    J === null || ee === null || J in F || (F[J] = ee);
  }
  return F;
}
function querystringify(e, T) {
  T = T || "";
  var F = [], $, J;
  typeof T != "string" && (T = "?");
  for (J in e)
    if (has.call(e, J)) {
      if ($ = e[J], !$ && ($ === null || $ === undef || isNaN($)) && ($ = ""), J = encode$2(J), $ = encode$2($), J === null || $ === null)
        continue;
      F.push(J + "=" + $);
    }
  return F.length ? T + F.join("&") : "";
}
querystringify$1.stringify = querystringify;
querystringify$1.parse = querystring;
function isTrue(e) {
  return !!e;
}
function getRandomString(e) {
  return `${e || "random"}_${new Date().getTime()}_${Math.random().toString(36).substring(2)}`;
}
function bind$2(e, T) {
  return function() {
    return e.apply(T, arguments);
  };
}
const { toString: toString$2 } = Object.prototype, { getPrototypeOf } = Object, kindOf = ((e) => (T) => {
  const F = toString$2.call(T);
  return e[F] || (e[F] = F.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (e) => (e = e.toLowerCase(), (T) => kindOf(T) === e), typeOfTest = (e) => (T) => typeof T === e, { isArray: isArray$9 } = Array, isUndefined = typeOfTest("undefined");
function isBuffer$3(e) {
  return e !== null && !isUndefined(e) && e.constructor !== null && !isUndefined(e.constructor) && isFunction$5(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(e) {
  let T;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? T = ArrayBuffer.isView(e) : T = e && e.buffer && isArrayBuffer(e.buffer), T;
}
const isString = typeOfTest("string"), isFunction$5 = typeOfTest("function"), isNumber = typeOfTest("number"), isObject$9 = (e) => e !== null && typeof e == "object", isBoolean = (e) => e === !0 || e === !1, isPlainObject = (e) => {
  if (kindOf(e) !== "object")
    return !1;
  const T = getPrototypeOf(e);
  return (T === null || T === Object.prototype || Object.getPrototypeOf(T) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, isDate = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (e) => isObject$9(e) && isFunction$5(e.pipe), isFormData = (e) => {
  let T;
  return e && (typeof FormData == "function" && e instanceof FormData || isFunction$5(e.append) && ((T = kindOf(e)) === "formdata" || T === "object" && isFunction$5(e.toString) && e.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), trim$2 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(e, T, { allOwnKeys: F = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let $, J;
  if (typeof e != "object" && (e = [e]), isArray$9(e))
    for ($ = 0, J = e.length; $ < J; $++)
      T.call(null, e[$], $, e);
  else {
    const ee = F ? Object.getOwnPropertyNames(e) : Object.keys(e), ne = ee.length;
    let oe;
    for ($ = 0; $ < ne; $++)
      oe = ee[$], T.call(null, e[oe], oe, e);
  }
}
function findKey(e, T) {
  T = T.toLowerCase();
  const F = Object.keys(e);
  let $ = F.length, J;
  for (; $-- > 0; )
    if (J = F[$], T === J.toLowerCase())
      return J;
  return null;
}
const _global = (() => typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global)(), isContextDefined = (e) => !isUndefined(e) && e !== _global;
function merge() {
  const { caseless: e } = isContextDefined(this) && this || {}, T = {}, F = ($, J) => {
    const ee = e && findKey(T, J) || J;
    isPlainObject(T[ee]) && isPlainObject($) ? T[ee] = merge(T[ee], $) : isPlainObject($) ? T[ee] = merge({}, $) : isArray$9($) ? T[ee] = $.slice() : T[ee] = $;
  };
  for (let $ = 0, J = arguments.length; $ < J; $++)
    arguments[$] && forEach(arguments[$], F);
  return T;
}
const extend = (e, T, F, { allOwnKeys: $ } = {}) => (forEach(T, (J, ee) => {
  F && isFunction$5(J) ? e[ee] = bind$2(J, F) : e[ee] = J;
}, { allOwnKeys: $ }), e), stripBOM = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits = (e, T, F, $) => {
  e.prototype = Object.create(T.prototype, $), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: T.prototype
  }), F && Object.assign(e.prototype, F);
}, toFlatObject = (e, T, F, $) => {
  let J, ee, ne;
  const oe = {};
  if (T = T || {}, e == null)
    return T;
  do {
    for (J = Object.getOwnPropertyNames(e), ee = J.length; ee-- > 0; )
      ne = J[ee], (!$ || $(ne, e, T)) && !oe[ne] && (T[ne] = e[ne], oe[ne] = !0);
    e = F !== !1 && getPrototypeOf(e);
  } while (e && (!F || F(e, T)) && e !== Object.prototype);
  return T;
}, endsWith = (e, T, F) => {
  e = String(e), (F === void 0 || F > e.length) && (F = e.length), F -= T.length;
  const $ = e.indexOf(T, F);
  return $ !== -1 && $ === F;
}, toArray = (e) => {
  if (!e)
    return null;
  if (isArray$9(e))
    return e;
  let T = e.length;
  if (!isNumber(T))
    return null;
  const F = new Array(T);
  for (; T-- > 0; )
    F[T] = e[T];
  return F;
}, isTypedArray$3 = ((e) => (T) => e && T instanceof e)(typeof Uint8Array != "undefined" && getPrototypeOf(Uint8Array)), forEachEntry = (e, T) => {
  const $ = (e && e[Symbol.iterator]).call(e);
  let J;
  for (; (J = $.next()) && !J.done; ) {
    const ee = J.value;
    T.call(e, ee[0], ee[1]);
  }
}, matchAll = (e, T) => {
  let F;
  const $ = [];
  for (; (F = e.exec(T)) !== null; )
    $.push(F);
  return $;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(F, $, J) {
    return $.toUpperCase() + J;
  }
), hasOwnProperty$9 = (({ hasOwnProperty: e }) => (T, F) => e.call(T, F))(Object.prototype), isRegExp = kindOfTest("RegExp"), reduceDescriptors = (e, T) => {
  const F = Object.getOwnPropertyDescriptors(e), $ = {};
  forEach(F, (J, ee) => {
    let ne;
    (ne = T(J, ee, e)) !== !1 && ($[ee] = ne || J);
  }), Object.defineProperties(e, $);
}, freezeMethods = (e) => {
  reduceDescriptors(e, (T, F) => {
    if (isFunction$5(e) && ["arguments", "caller", "callee"].indexOf(F) !== -1)
      return !1;
    const $ = e[F];
    if (!!isFunction$5($)) {
      if (T.enumerable = !1, "writable" in T) {
        T.writable = !1;
        return;
      }
      T.set || (T.set = () => {
        throw Error("Can not rewrite read-only method '" + F + "'");
      });
    }
  });
}, toObjectSet = (e, T) => {
  const F = {}, $ = (J) => {
    J.forEach((ee) => {
      F[ee] = !0;
    });
  };
  return isArray$9(e) ? $(e) : $(String(e).split(T)), F;
}, noop$1 = () => {
}, toFiniteNumber = (e, T) => (e = +e, Number.isFinite(e) ? e : T), ALPHA = "abcdefghijklmnopqrstuvwxyz", DIGIT = "0123456789", ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}, generateString = (e = 16, T = ALPHABET.ALPHA_DIGIT) => {
  let F = "";
  const { length: $ } = T;
  for (; e--; )
    F += T[Math.random() * $ | 0];
  return F;
};
function isSpecCompliantForm(e) {
  return !!(e && isFunction$5(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const toJSONObject = (e) => {
  const T = new Array(10), F = ($, J) => {
    if (isObject$9($)) {
      if (T.indexOf($) >= 0)
        return;
      if (!("toJSON" in $)) {
        T[J] = $;
        const ee = isArray$9($) ? [] : {};
        return forEach($, (ne, oe) => {
          const se = F(ne, J + 1);
          !isUndefined(se) && (ee[oe] = se);
        }), T[J] = void 0, ee;
      }
    }
    return $;
  };
  return F(e, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (e) => e && (isObject$9(e) || isFunction$5(e)) && isFunction$5(e.then) && isFunction$5(e.catch), utils$1 = {
  isArray: isArray$9,
  isArrayBuffer,
  isBuffer: isBuffer$3,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: isObject$9,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$5,
  isStream,
  isURLSearchParams,
  isTypedArray: isTypedArray$3,
  isFileList,
  forEach,
  merge,
  extend,
  trim: trim$2,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: hasOwnProperty$9,
  hasOwnProp: hasOwnProperty$9,
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$1,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError(e, T, F, $, J) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", T && (this.code = T), F && (this.config = F), $ && (this.request = $), J && (this.response = J);
}
utils$1.inherits(AxiosError, Error, {
  toJSON: function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
].forEach((e) => {
  descriptors[e] = { value: e };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError.from = (e, T, F, $, J, ee) => {
  const ne = Object.create(prototype$1);
  return utils$1.toFlatObject(e, ne, function(se) {
    return se !== Error.prototype;
  }, (oe) => oe !== "isAxiosError"), AxiosError.call(ne, e.message, T, F, $, J), ne.cause = e, ne.name = e.name, ee && Object.assign(ne, ee), ne;
};
const httpAdapter = null;
function isVisitable(e) {
  return utils$1.isPlainObject(e) || utils$1.isArray(e);
}
function removeBrackets(e) {
  return utils$1.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function renderKey(e, T, F) {
  return e ? e.concat(T).map(function(J, ee) {
    return J = removeBrackets(J), !F && ee ? "[" + J + "]" : J;
  }).join(F ? "." : "") : T;
}
function isFlatArray(e) {
  return utils$1.isArray(e) && !e.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function(T) {
  return /^is[A-Z]/.test(T);
});
function toFormData(e, T, F) {
  if (!utils$1.isObject(e))
    throw new TypeError("target must be an object");
  T = T || new FormData(), F = utils$1.toFlatObject(F, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(be, Te) {
    return !utils$1.isUndefined(Te[be]);
  });
  const $ = F.metaTokens, J = F.visitor || de, ee = F.dots, ne = F.indexes, se = (F.Blob || typeof Blob != "undefined" && Blob) && utils$1.isSpecCompliantForm(T);
  if (!utils$1.isFunction(J))
    throw new TypeError("visitor must be a function");
  function le(ge) {
    if (ge === null)
      return "";
    if (utils$1.isDate(ge))
      return ge.toISOString();
    if (!se && utils$1.isBlob(ge))
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    return utils$1.isArrayBuffer(ge) || utils$1.isTypedArray(ge) ? se && typeof Blob == "function" ? new Blob([ge]) : Buffer.from(ge) : ge;
  }
  function de(ge, be, Te) {
    let Se = ge;
    if (ge && !Te && typeof ge == "object") {
      if (utils$1.endsWith(be, "{}"))
        be = $ ? be : be.slice(0, -2), ge = JSON.stringify(ge);
      else if (utils$1.isArray(ge) && isFlatArray(ge) || (utils$1.isFileList(ge) || utils$1.endsWith(be, "[]")) && (Se = utils$1.toArray(ge)))
        return be = removeBrackets(be), Se.forEach(function(Oe, Le) {
          !(utils$1.isUndefined(Oe) || Oe === null) && T.append(
            ne === !0 ? renderKey([be], Le, ee) : ne === null ? be : be + "[]",
            le(Oe)
          );
        }), !1;
    }
    return isVisitable(ge) ? !0 : (T.append(renderKey(Te, be, ee), le(ge)), !1);
  }
  const ce = [], he = Object.assign(predicates, {
    defaultVisitor: de,
    convertValue: le,
    isVisitable
  });
  function ve(ge, be) {
    if (!utils$1.isUndefined(ge)) {
      if (ce.indexOf(ge) !== -1)
        throw Error("Circular reference detected in " + be.join("."));
      ce.push(ge), utils$1.forEach(ge, function(Se, Ie) {
        (!(utils$1.isUndefined(Se) || Se === null) && J.call(
          T,
          Se,
          utils$1.isString(Ie) ? Ie.trim() : Ie,
          be,
          he
        )) === !0 && ve(Se, be ? be.concat(Ie) : [Ie]);
      }), ce.pop();
    }
  }
  if (!utils$1.isObject(e))
    throw new TypeError("data must be an object");
  return ve(e), T;
}
function encode$1(e) {
  const T = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function($) {
    return T[$];
  });
}
function AxiosURLSearchParams(e, T) {
  this._pairs = [], e && toFormData(e, this, T);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function(T, F) {
  this._pairs.push([T, F]);
};
prototype.toString = function(T) {
  const F = T ? function($) {
    return T.call(this, $, encode$1);
  } : encode$1;
  return this._pairs.map(function(J) {
    return F(J[0]) + "=" + F(J[1]);
  }, "").join("&");
};
function encode(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(e, T, F) {
  if (!T)
    return e;
  const $ = F && F.encode || encode, J = F && F.serialize;
  let ee;
  if (J ? ee = J(T, F) : ee = utils$1.isURLSearchParams(T) ? T.toString() : new AxiosURLSearchParams(T, F).toString($), ee) {
    const ne = e.indexOf("#");
    ne !== -1 && (e = e.slice(0, ne)), e += (e.indexOf("?") === -1 ? "?" : "&") + ee;
  }
  return e;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  use(T, F, $) {
    return this.handlers.push({
      fulfilled: T,
      rejected: F,
      synchronous: $ ? $.synchronous : !1,
      runWhen: $ ? $.runWhen : null
    }), this.handlers.length - 1;
  }
  eject(T) {
    this.handlers[T] && (this.handlers[T] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(T) {
    utils$1.forEach(this.handlers, function($) {
      $ !== null && T($);
    });
  }
}
const InterceptorManager$1 = InterceptorManager, transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams != "undefined" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData != "undefined" ? FormData : null, Blob$1 = typeof Blob != "undefined" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hasBrowserEnv = typeof window != "undefined" && typeof document != "undefined", hasStandardBrowserEnv = ((e) => hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator != "undefined" && navigator.product), hasStandardBrowserWebWorkerEnv = (() => typeof WorkerGlobalScope != "undefined" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  hasStandardBrowserEnv
}, Symbol.toStringTag, { value: "Module" })), platform = Fe(Fe({}, utils), platform$1);
function toURLEncodedForm(e, T) {
  return toFormData(e, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(F, $, J, ee) {
      return platform.isNode && utils$1.isBuffer(F) ? (this.append($, F.toString("base64")), !1) : ee.defaultVisitor.apply(this, arguments);
    }
  }, T));
}
function parsePropPath(e) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, e).map((T) => T[0] === "[]" ? "" : T[1] || T[0]);
}
function arrayToObject(e) {
  const T = {}, F = Object.keys(e);
  let $;
  const J = F.length;
  let ee;
  for ($ = 0; $ < J; $++)
    ee = F[$], T[ee] = e[ee];
  return T;
}
function formDataToJSON(e) {
  function T(F, $, J, ee) {
    let ne = F[ee++];
    if (ne === "__proto__")
      return !0;
    const oe = Number.isFinite(+ne), se = ee >= F.length;
    return ne = !ne && utils$1.isArray(J) ? J.length : ne, se ? (utils$1.hasOwnProp(J, ne) ? J[ne] = [J[ne], $] : J[ne] = $, !oe) : ((!J[ne] || !utils$1.isObject(J[ne])) && (J[ne] = []), T(F, $, J[ne], ee) && utils$1.isArray(J[ne]) && (J[ne] = arrayToObject(J[ne])), !oe);
  }
  if (utils$1.isFormData(e) && utils$1.isFunction(e.entries)) {
    const F = {};
    return utils$1.forEachEntry(e, ($, J) => {
      T(parsePropPath($), J, F, 0);
    }), F;
  }
  return null;
}
function stringifySafely(e, T, F) {
  if (utils$1.isString(e))
    try {
      return (T || JSON.parse)(e), utils$1.trim(e);
    } catch ($) {
      if ($.name !== "SyntaxError")
        throw $;
    }
  return (F || JSON.stringify)(e);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http"],
  transformRequest: [function(T, F) {
    const $ = F.getContentType() || "", J = $.indexOf("application/json") > -1, ee = utils$1.isObject(T);
    if (ee && utils$1.isHTMLForm(T) && (T = new FormData(T)), utils$1.isFormData(T))
      return J ? JSON.stringify(formDataToJSON(T)) : T;
    if (utils$1.isArrayBuffer(T) || utils$1.isBuffer(T) || utils$1.isStream(T) || utils$1.isFile(T) || utils$1.isBlob(T))
      return T;
    if (utils$1.isArrayBufferView(T))
      return T.buffer;
    if (utils$1.isURLSearchParams(T))
      return F.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), T.toString();
    let oe;
    if (ee) {
      if ($.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(T, this.formSerializer).toString();
      if ((oe = utils$1.isFileList(T)) || $.indexOf("multipart/form-data") > -1) {
        const se = this.env && this.env.FormData;
        return toFormData(
          oe ? { "files[]": T } : T,
          se && new se(),
          this.formSerializer
        );
      }
    }
    return ee || J ? (F.setContentType("application/json", !1), stringifySafely(T)) : T;
  }],
  transformResponse: [function(T) {
    const F = this.transitional || defaults.transitional, $ = F && F.forcedJSONParsing, J = this.responseType === "json";
    if (T && utils$1.isString(T) && ($ && !this.responseType || J)) {
      const ne = !(F && F.silentJSONParsing) && J;
      try {
        return JSON.parse(T);
      } catch (oe) {
        if (ne)
          throw oe.name === "SyntaxError" ? AxiosError.from(oe, AxiosError.ERR_BAD_RESPONSE, this, null, this.response) : oe;
      }
    }
    return T;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function(T) {
    return T >= 200 && T < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  defaults.headers[e] = {};
});
const defaults$1 = defaults, ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (e) => {
  const T = {};
  let F, $, J;
  return e && e.split(`
`).forEach(function(ne) {
    J = ne.indexOf(":"), F = ne.substring(0, J).trim().toLowerCase(), $ = ne.substring(J + 1).trim(), !(!F || T[F] && ignoreDuplicateOf[F]) && (F === "set-cookie" ? T[F] ? T[F].push($) : T[F] = [$] : T[F] = T[F] ? T[F] + ", " + $ : $);
  }), T;
}, $internals = Symbol("internals");
function normalizeHeader(e) {
  return e && String(e).trim().toLowerCase();
}
function normalizeValue(e) {
  return e === !1 || e == null ? e : utils$1.isArray(e) ? e.map(normalizeValue) : String(e);
}
function parseTokens(e) {
  const T = /* @__PURE__ */ Object.create(null), F = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let $;
  for (; $ = F.exec(e); )
    T[$[1]] = $[2];
  return T;
}
const isValidHeaderName = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function matchHeaderValue(e, T, F, $, J) {
  if (utils$1.isFunction($))
    return $.call(this, T, F);
  if (J && (T = F), !!utils$1.isString(T)) {
    if (utils$1.isString($))
      return T.indexOf($) !== -1;
    if (utils$1.isRegExp($))
      return $.test(T);
  }
}
function formatHeader(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (T, F, $) => F.toUpperCase() + $);
}
function buildAccessors(e, T) {
  const F = utils$1.toCamelCase(" " + T);
  ["get", "set", "has"].forEach(($) => {
    Object.defineProperty(e, $ + F, {
      value: function(J, ee, ne) {
        return this[$].call(this, T, J, ee, ne);
      },
      configurable: !0
    });
  });
}
class AxiosHeaders {
  constructor(T) {
    T && this.set(T);
  }
  set(T, F, $) {
    const J = this;
    function ee(oe, se, le) {
      const de = normalizeHeader(se);
      if (!de)
        throw new Error("header name must be a non-empty string");
      const ce = utils$1.findKey(J, de);
      (!ce || J[ce] === void 0 || le === !0 || le === void 0 && J[ce] !== !1) && (J[ce || se] = normalizeValue(oe));
    }
    const ne = (oe, se) => utils$1.forEach(oe, (le, de) => ee(le, de, se));
    return utils$1.isPlainObject(T) || T instanceof this.constructor ? ne(T, F) : utils$1.isString(T) && (T = T.trim()) && !isValidHeaderName(T) ? ne(parseHeaders(T), F) : T != null && ee(F, T, $), this;
  }
  get(T, F) {
    if (T = normalizeHeader(T), T) {
      const $ = utils$1.findKey(this, T);
      if ($) {
        const J = this[$];
        if (!F)
          return J;
        if (F === !0)
          return parseTokens(J);
        if (utils$1.isFunction(F))
          return F.call(this, J, $);
        if (utils$1.isRegExp(F))
          return F.exec(J);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(T, F) {
    if (T = normalizeHeader(T), T) {
      const $ = utils$1.findKey(this, T);
      return !!($ && this[$] !== void 0 && (!F || matchHeaderValue(this, this[$], $, F)));
    }
    return !1;
  }
  delete(T, F) {
    const $ = this;
    let J = !1;
    function ee(ne) {
      if (ne = normalizeHeader(ne), ne) {
        const oe = utils$1.findKey($, ne);
        oe && (!F || matchHeaderValue($, $[oe], oe, F)) && (delete $[oe], J = !0);
      }
    }
    return utils$1.isArray(T) ? T.forEach(ee) : ee(T), J;
  }
  clear(T) {
    const F = Object.keys(this);
    let $ = F.length, J = !1;
    for (; $--; ) {
      const ee = F[$];
      (!T || matchHeaderValue(this, this[ee], ee, T, !0)) && (delete this[ee], J = !0);
    }
    return J;
  }
  normalize(T) {
    const F = this, $ = {};
    return utils$1.forEach(this, (J, ee) => {
      const ne = utils$1.findKey($, ee);
      if (ne) {
        F[ne] = normalizeValue(J), delete F[ee];
        return;
      }
      const oe = T ? formatHeader(ee) : String(ee).trim();
      oe !== ee && delete F[ee], F[oe] = normalizeValue(J), $[oe] = !0;
    }), this;
  }
  concat(...T) {
    return this.constructor.concat(this, ...T);
  }
  toJSON(T) {
    const F = /* @__PURE__ */ Object.create(null);
    return utils$1.forEach(this, ($, J) => {
      $ != null && $ !== !1 && (F[J] = T && utils$1.isArray($) ? $.join(", ") : $);
    }), F;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([T, F]) => T + ": " + F).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(T) {
    return T instanceof this ? T : new this(T);
  }
  static concat(T, ...F) {
    const $ = new this(T);
    return F.forEach((J) => $.set(J)), $;
  }
  static accessor(T) {
    const $ = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, J = this.prototype;
    function ee(ne) {
      const oe = normalizeHeader(ne);
      $[oe] || (buildAccessors(J, ne), $[oe] = !0);
    }
    return utils$1.isArray(T) ? T.forEach(ee) : ee(T), this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value: e }, T) => {
  let F = T[0].toUpperCase() + T.slice(1);
  return {
    get: () => e,
    set($) {
      this[F] = $;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders);
const AxiosHeaders$1 = AxiosHeaders;
function transformData(e, T) {
  const F = this || defaults$1, $ = T || F, J = AxiosHeaders$1.from($.headers);
  let ee = $.data;
  return utils$1.forEach(e, function(oe) {
    ee = oe.call(F, ee, J.normalize(), T ? T.status : void 0);
  }), J.normalize(), ee;
}
function isCancel(e) {
  return !!(e && e.__CANCEL__);
}
function CanceledError(e, T, F) {
  AxiosError.call(this, e == null ? "canceled" : e, AxiosError.ERR_CANCELED, T, F), this.name = "CanceledError";
}
utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: !0
});
function settle(e, T, F) {
  const $ = F.config.validateStatus;
  !F.status || !$ || $(F.status) ? e(F) : T(new AxiosError(
    "Request failed with status code " + F.status,
    [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(F.status / 100) - 4],
    F.config,
    F.request,
    F
  ));
}
const cookies = platform.hasStandardBrowserEnv ? {
  write(e, T, F, $, J, ee) {
    const ne = [e + "=" + encodeURIComponent(T)];
    utils$1.isNumber(F) && ne.push("expires=" + new Date(F).toGMTString()), utils$1.isString($) && ne.push("path=" + $), utils$1.isString(J) && ne.push("domain=" + J), ee === !0 && ne.push("secure"), document.cookie = ne.join("; ");
  },
  read(e) {
    const T = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
    return T ? decodeURIComponent(T[3]) : null;
  },
  remove(e) {
    this.write(e, "", Date.now() - 864e5);
  }
} : {
  write() {
  },
  read() {
    return null;
  },
  remove() {
  }
};
function isAbsoluteURL(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function combineURLs(e, T) {
  return T ? e.replace(/\/?\/$/, "") + "/" + T.replace(/^\/+/, "") : e;
}
function buildFullPath(e, T) {
  return e && !isAbsoluteURL(T) ? combineURLs(e, T) : T;
}
const isURLSameOrigin = platform.hasStandardBrowserEnv ? function() {
  const T = /(msie|trident)/i.test(navigator.userAgent), F = document.createElement("a");
  let $;
  function J(ee) {
    let ne = ee;
    return T && (F.setAttribute("href", ne), ne = F.href), F.setAttribute("href", ne), {
      href: F.href,
      protocol: F.protocol ? F.protocol.replace(/:$/, "") : "",
      host: F.host,
      search: F.search ? F.search.replace(/^\?/, "") : "",
      hash: F.hash ? F.hash.replace(/^#/, "") : "",
      hostname: F.hostname,
      port: F.port,
      pathname: F.pathname.charAt(0) === "/" ? F.pathname : "/" + F.pathname
    };
  }
  return $ = J(window.location.href), function(ne) {
    const oe = utils$1.isString(ne) ? J(ne) : ne;
    return oe.protocol === $.protocol && oe.host === $.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function parseProtocol(e) {
  const T = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return T && T[1] || "";
}
function speedometer(e, T) {
  e = e || 10;
  const F = new Array(e), $ = new Array(e);
  let J = 0, ee = 0, ne;
  return T = T !== void 0 ? T : 1e3, function(se) {
    const le = Date.now(), de = $[ee];
    ne || (ne = le), F[J] = se, $[J] = le;
    let ce = ee, he = 0;
    for (; ce !== J; )
      he += F[ce++], ce = ce % e;
    if (J = (J + 1) % e, J === ee && (ee = (ee + 1) % e), le - ne < T)
      return;
    const ve = de && le - de;
    return ve ? Math.round(he * 1e3 / ve) : void 0;
  };
}
function progressEventReducer(e, T) {
  let F = 0;
  const $ = speedometer(50, 250);
  return (J) => {
    const ee = J.loaded, ne = J.lengthComputable ? J.total : void 0, oe = ee - F, se = $(oe), le = ee <= ne;
    F = ee;
    const de = {
      loaded: ee,
      total: ne,
      progress: ne ? ee / ne : void 0,
      bytes: oe,
      rate: se || void 0,
      estimated: se && ne && le ? (ne - ee) / se : void 0,
      event: J
    };
    de[T ? "download" : "upload"] = !0, e(de);
  };
}
const isXHRAdapterSupported = typeof XMLHttpRequest != "undefined", xhrAdapter = isXHRAdapterSupported && function(e) {
  return new Promise(function(F, $) {
    let J = e.data;
    const ee = AxiosHeaders$1.from(e.headers).normalize();
    let { responseType: ne, withXSRFToken: oe } = e, se;
    function le() {
      e.cancelToken && e.cancelToken.unsubscribe(se), e.signal && e.signal.removeEventListener("abort", se);
    }
    let de;
    if (utils$1.isFormData(J)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
        ee.setContentType(!1);
      else if ((de = ee.getContentType()) !== !1) {
        const [be, ...Te] = de ? de.split(";").map((Se) => Se.trim()).filter(Boolean) : [];
        ee.setContentType([be || "multipart/form-data", ...Te].join("; "));
      }
    }
    let ce = new XMLHttpRequest();
    if (e.auth) {
      const be = e.auth.username || "", Te = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      ee.set("Authorization", "Basic " + btoa(be + ":" + Te));
    }
    const he = buildFullPath(e.baseURL, e.url);
    ce.open(e.method.toUpperCase(), buildURL(he, e.params, e.paramsSerializer), !0), ce.timeout = e.timeout;
    function ve() {
      if (!ce)
        return;
      const be = AxiosHeaders$1.from(
        "getAllResponseHeaders" in ce && ce.getAllResponseHeaders()
      ), Se = {
        data: !ne || ne === "text" || ne === "json" ? ce.responseText : ce.response,
        status: ce.status,
        statusText: ce.statusText,
        headers: be,
        config: e,
        request: ce
      };
      settle(function(Oe) {
        F(Oe), le();
      }, function(Oe) {
        $(Oe), le();
      }, Se), ce = null;
    }
    if ("onloadend" in ce ? ce.onloadend = ve : ce.onreadystatechange = function() {
      !ce || ce.readyState !== 4 || ce.status === 0 && !(ce.responseURL && ce.responseURL.indexOf("file:") === 0) || setTimeout(ve);
    }, ce.onabort = function() {
      !ce || ($(new AxiosError("Request aborted", AxiosError.ECONNABORTED, e, ce)), ce = null);
    }, ce.onerror = function() {
      $(new AxiosError("Network Error", AxiosError.ERR_NETWORK, e, ce)), ce = null;
    }, ce.ontimeout = function() {
      let Te = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const Se = e.transitional || transitionalDefaults;
      e.timeoutErrorMessage && (Te = e.timeoutErrorMessage), $(new AxiosError(
        Te,
        Se.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        e,
        ce
      )), ce = null;
    }, platform.hasStandardBrowserEnv && (oe && utils$1.isFunction(oe) && (oe = oe(e)), oe || oe !== !1 && isURLSameOrigin(he))) {
      const be = e.xsrfHeaderName && e.xsrfCookieName && cookies.read(e.xsrfCookieName);
      be && ee.set(e.xsrfHeaderName, be);
    }
    J === void 0 && ee.setContentType(null), "setRequestHeader" in ce && utils$1.forEach(ee.toJSON(), function(Te, Se) {
      ce.setRequestHeader(Se, Te);
    }), utils$1.isUndefined(e.withCredentials) || (ce.withCredentials = !!e.withCredentials), ne && ne !== "json" && (ce.responseType = e.responseType), typeof e.onDownloadProgress == "function" && ce.addEventListener("progress", progressEventReducer(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && ce.upload && ce.upload.addEventListener("progress", progressEventReducer(e.onUploadProgress)), (e.cancelToken || e.signal) && (se = (be) => {
      !ce || ($(!be || be.type ? new CanceledError(null, e, ce) : be), ce.abort(), ce = null);
    }, e.cancelToken && e.cancelToken.subscribe(se), e.signal && (e.signal.aborted ? se() : e.signal.addEventListener("abort", se)));
    const ge = parseProtocol(he);
    if (ge && platform.protocols.indexOf(ge) === -1) {
      $(new AxiosError("Unsupported protocol " + ge + ":", AxiosError.ERR_BAD_REQUEST, e));
      return;
    }
    ce.send(J || null);
  });
}, knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};
utils$1.forEach(knownAdapters, (e, T) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: T });
    } catch (F) {
    }
    Object.defineProperty(e, "adapterName", { value: T });
  }
});
const renderReason = (e) => `- ${e}`, isResolvedHandle = (e) => utils$1.isFunction(e) || e === null || e === !1, adapters = {
  getAdapter: (e) => {
    e = utils$1.isArray(e) ? e : [e];
    const { length: T } = e;
    let F, $;
    const J = {};
    for (let ee = 0; ee < T; ee++) {
      F = e[ee];
      let ne;
      if ($ = F, !isResolvedHandle(F) && ($ = knownAdapters[(ne = String(F)).toLowerCase()], $ === void 0))
        throw new AxiosError(`Unknown adapter '${ne}'`);
      if ($)
        break;
      J[ne || "#" + ee] = $;
    }
    if (!$) {
      const ee = Object.entries(J).map(
        ([oe, se]) => `adapter ${oe} ` + (se === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let ne = T ? ee.length > 1 ? `since :
` + ee.map(renderReason).join(`
`) : " " + renderReason(ee[0]) : "as no adapter specified";
      throw new AxiosError(
        "There is no suitable adapter to dispatch the request " + ne,
        "ERR_NOT_SUPPORT"
      );
    }
    return $;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError(null, e);
}
function dispatchRequest(e) {
  return throwIfCancellationRequested(e), e.headers = AxiosHeaders$1.from(e.headers), e.data = transformData.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(e.adapter || defaults$1.adapter)(e).then(function($) {
    return throwIfCancellationRequested(e), $.data = transformData.call(
      e,
      e.transformResponse,
      $
    ), $.headers = AxiosHeaders$1.from($.headers), $;
  }, function($) {
    return isCancel($) || (throwIfCancellationRequested(e), $ && $.response && ($.response.data = transformData.call(
      e,
      e.transformResponse,
      $.response
    ), $.response.headers = AxiosHeaders$1.from($.response.headers))), Promise.reject($);
  });
}
const headersToObject = (e) => e instanceof AxiosHeaders$1 ? e.toJSON() : e;
function mergeConfig(e, T) {
  T = T || {};
  const F = {};
  function $(le, de, ce) {
    return utils$1.isPlainObject(le) && utils$1.isPlainObject(de) ? utils$1.merge.call({ caseless: ce }, le, de) : utils$1.isPlainObject(de) ? utils$1.merge({}, de) : utils$1.isArray(de) ? de.slice() : de;
  }
  function J(le, de, ce) {
    if (utils$1.isUndefined(de)) {
      if (!utils$1.isUndefined(le))
        return $(void 0, le, ce);
    } else
      return $(le, de, ce);
  }
  function ee(le, de) {
    if (!utils$1.isUndefined(de))
      return $(void 0, de);
  }
  function ne(le, de) {
    if (utils$1.isUndefined(de)) {
      if (!utils$1.isUndefined(le))
        return $(void 0, le);
    } else
      return $(void 0, de);
  }
  function oe(le, de, ce) {
    if (ce in T)
      return $(le, de);
    if (ce in e)
      return $(void 0, le);
  }
  const se = {
    url: ee,
    method: ee,
    data: ee,
    baseURL: ne,
    transformRequest: ne,
    transformResponse: ne,
    paramsSerializer: ne,
    timeout: ne,
    timeoutMessage: ne,
    withCredentials: ne,
    withXSRFToken: ne,
    adapter: ne,
    responseType: ne,
    xsrfCookieName: ne,
    xsrfHeaderName: ne,
    onUploadProgress: ne,
    onDownloadProgress: ne,
    decompress: ne,
    maxContentLength: ne,
    maxBodyLength: ne,
    beforeRedirect: ne,
    transport: ne,
    httpAgent: ne,
    httpsAgent: ne,
    cancelToken: ne,
    socketPath: ne,
    responseEncoding: ne,
    validateStatus: oe,
    headers: (le, de) => J(headersToObject(le), headersToObject(de), !0)
  };
  return utils$1.forEach(Object.keys(Object.assign({}, e, T)), function(de) {
    const ce = se[de] || J, he = ce(e[de], T[de], de);
    utils$1.isUndefined(he) && ce !== oe || (F[de] = he);
  }), F;
}
const VERSION = "1.6.7", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, T) => {
  validators$1[e] = function($) {
    return typeof $ === e || "a" + (T < 1 ? "n " : " ") + e;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function(T, F, $) {
  function J(ee, ne) {
    return "[Axios v" + VERSION + "] Transitional option '" + ee + "'" + ne + ($ ? ". " + $ : "");
  }
  return (ee, ne, oe) => {
    if (T === !1)
      throw new AxiosError(
        J(ne, " has been removed" + (F ? " in " + F : "")),
        AxiosError.ERR_DEPRECATED
      );
    return F && !deprecatedWarnings[ne] && (deprecatedWarnings[ne] = !0, console.warn(
      J(
        ne,
        " has been deprecated since v" + F + " and will be removed in the near future"
      )
    )), T ? T(ee, ne, oe) : !0;
  };
};
function assertOptions(e, T, F) {
  if (typeof e != "object")
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  const $ = Object.keys(e);
  let J = $.length;
  for (; J-- > 0; ) {
    const ee = $[J], ne = T[ee];
    if (ne) {
      const oe = e[ee], se = oe === void 0 || ne(oe, ee, e);
      if (se !== !0)
        throw new AxiosError("option " + ee + " must be " + se, AxiosError.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (F !== !0)
      throw new AxiosError("Unknown option " + ee, AxiosError.ERR_BAD_OPTION);
  }
}
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
class Axios {
  constructor(T) {
    this.defaults = T, this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }
  request(T, F) {
    return Me(this, null, function* () {
      try {
        return yield this._request(T, F);
      } catch ($) {
        if ($ instanceof Error) {
          let J;
          Error.captureStackTrace ? Error.captureStackTrace(J = {}) : J = new Error();
          const ee = J.stack ? J.stack.replace(/^.+\n/, "") : "";
          $.stack ? ee && !String($.stack).endsWith(ee.replace(/^.+\n.+\n/, "")) && ($.stack += `
` + ee) : $.stack = ee;
        }
        throw $;
      }
    });
  }
  _request(T, F) {
    typeof T == "string" ? (F = F || {}, F.url = T) : F = T || {}, F = mergeConfig(this.defaults, F);
    const { transitional: $, paramsSerializer: J, headers: ee } = F;
    $ !== void 0 && validator.assertOptions($, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), J != null && (utils$1.isFunction(J) ? F.paramsSerializer = {
      serialize: J
    } : validator.assertOptions(J, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), F.method = (F.method || this.defaults.method || "get").toLowerCase();
    let ne = ee && utils$1.merge(
      ee.common,
      ee[F.method]
    );
    ee && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (ge) => {
        delete ee[ge];
      }
    ), F.headers = AxiosHeaders$1.concat(ne, ee);
    const oe = [];
    let se = !0;
    this.interceptors.request.forEach(function(be) {
      typeof be.runWhen == "function" && be.runWhen(F) === !1 || (se = se && be.synchronous, oe.unshift(be.fulfilled, be.rejected));
    });
    const le = [];
    this.interceptors.response.forEach(function(be) {
      le.push(be.fulfilled, be.rejected);
    });
    let de, ce = 0, he;
    if (!se) {
      const ge = [dispatchRequest.bind(this), void 0];
      for (ge.unshift.apply(ge, oe), ge.push.apply(ge, le), he = ge.length, de = Promise.resolve(F); ce < he; )
        de = de.then(ge[ce++], ge[ce++]);
      return de;
    }
    he = oe.length;
    let ve = F;
    for (ce = 0; ce < he; ) {
      const ge = oe[ce++], be = oe[ce++];
      try {
        ve = ge(ve);
      } catch (Te) {
        be.call(this, Te);
        break;
      }
    }
    try {
      de = dispatchRequest.call(this, ve);
    } catch (ge) {
      return Promise.reject(ge);
    }
    for (ce = 0, he = le.length; ce < he; )
      de = de.then(le[ce++], le[ce++]);
    return de;
  }
  getUri(T) {
    T = mergeConfig(this.defaults, T);
    const F = buildFullPath(T.baseURL, T.url);
    return buildURL(F, T.params, T.paramsSerializer);
  }
}
utils$1.forEach(["delete", "get", "head", "options"], function(T) {
  Axios.prototype[T] = function(F, $) {
    return this.request(mergeConfig($ || {}, {
      method: T,
      url: F,
      data: ($ || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function(T) {
  function F($) {
    return function(ee, ne, oe) {
      return this.request(mergeConfig(oe || {}, {
        method: T,
        headers: $ ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: ee,
        data: ne
      }));
    };
  }
  Axios.prototype[T] = F(), Axios.prototype[T + "Form"] = F(!0);
});
const Axios$1 = Axios;
class CancelToken {
  constructor(T) {
    if (typeof T != "function")
      throw new TypeError("executor must be a function.");
    let F;
    this.promise = new Promise(function(ee) {
      F = ee;
    });
    const $ = this;
    this.promise.then((J) => {
      if (!$._listeners)
        return;
      let ee = $._listeners.length;
      for (; ee-- > 0; )
        $._listeners[ee](J);
      $._listeners = null;
    }), this.promise.then = (J) => {
      let ee;
      const ne = new Promise((oe) => {
        $.subscribe(oe), ee = oe;
      }).then(J);
      return ne.cancel = function() {
        $.unsubscribe(ee);
      }, ne;
    }, T(function(ee, ne, oe) {
      $.reason || ($.reason = new CanceledError(ee, ne, oe), F($.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(T) {
    if (this.reason) {
      T(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(T) : this._listeners = [T];
  }
  unsubscribe(T) {
    if (!this._listeners)
      return;
    const F = this._listeners.indexOf(T);
    F !== -1 && this._listeners.splice(F, 1);
  }
  static source() {
    let T;
    return {
      token: new CancelToken(function(J) {
        T = J;
      }),
      cancel: T
    };
  }
}
const CancelToken$1 = CancelToken;
function spread(e) {
  return function(F) {
    return e.apply(null, F);
  };
}
function isAxiosError(e) {
  return utils$1.isObject(e) && e.isAxiosError === !0;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([e, T]) => {
  HttpStatusCode[T] = e;
});
const HttpStatusCode$1 = HttpStatusCode;
function createInstance(e) {
  const T = new Axios$1(e), F = bind$2(Axios$1.prototype.request, T);
  return utils$1.extend(F, Axios$1.prototype, T, { allOwnKeys: !0 }), utils$1.extend(F, T, null, { allOwnKeys: !0 }), F.create = function(J) {
    return createInstance(mergeConfig(e, J));
  }, F;
}
const axios = createInstance(defaults$1);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function(T) {
  return Promise.all(T);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (e) => formDataToJSON(utils$1.isHTMLForm(e) ? new FormData(e) : e);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
const axios$1 = axios;
function httpPostRefreshToken(e) {
  return Me(this, null, function* () {
    return request$1.post("/sso/events/audience/refresh-token", {
      refreshToken: e
    });
  });
}
var __defProp$K = Object.defineProperty, __defNormalProp$K = (e, T, F) => T in e ? __defProp$K(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$K = (e, T, F) => (__defNormalProp$K(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$K = {
  _timer: void 0
};
class RefreshTokenModel extends Model {
  constructor() {
    super(INITIAL_STATE$K), __publicField$K(this, "_REFRESHTOKEN_AHEAD_OF_TIME", 5 * 60 * 1e3);
  }
  get running() {
    return !!this.state._timer;
  }
  init() {
    return Me(this, null, function* () {
      var T;
      if (this.running)
        return;
      const {
        accessToken: F = "",
        refreshToken: $ = "",
        expiration: J
      } = (T = lsGetEventToken()) != null ? T : {};
      if (F) {
        if (!$ || !J)
          return;
      } else
        return Promise.reject(new Error("Local accessToken is not found"));
      const ee = J - Date.now();
      if ($)
        if (ee > this._REFRESHTOKEN_AHEAD_OF_TIME)
          this._startTimer($, ee);
        else
          return this._refresh($);
    });
  }
  destroy() {
    this._stopTimer();
  }
  _startTimer(T, F) {
    const { _timer: $ } = this.state, J = F - this._REFRESHTOKEN_AHEAD_OF_TIME;
    if (J <= 0)
      return;
    $ && this._stopTimer();
    const ee = window.setTimeout(() => Me(this, null, function* () {
      this._refresh(T);
    }), J);
    this.setState({
      _timer: ee
    });
  }
  _stopTimer() {
    const { _timer: T } = this.state;
    clearTimeout(T), this.setState({
      _timer: void 0
    });
  }
  _refresh(T) {
    return Me(this, null, function* () {
      return httpPostRefreshToken(T).then((F) => {
        var $, J;
        const {
          accessToken: ee = "",
          refreshToken: ne = "",
          expiration: oe = 0
        } = (J = ($ = F == null ? void 0 : F.data) == null ? void 0 : $.data) != null ? J : {};
        lsSetEventToken(ee, ne, oe);
      }).catch((F) => Promise.reject(F));
    });
  }
}
const refreshTokenModel = new RefreshTokenModel();
var OnlineUserType = /* @__PURE__ */ ((e) => (e[e.HOST = 0] = "HOST", e[e.GUEST = 1] = "GUEST", e[e.ASSISTANT = 2] = "ASSISTANT", e[e.ID_AUDIENCE = 3] = "ID_AUDIENCE", e[e.ANONYMOUS_AUDIENCE = 4] = "ANONYMOUS_AUDIENCE", e[e.ADMINISTRATORS = 6] = "ADMINISTRATORS", e))(OnlineUserType || {}), LiveStatus = /* @__PURE__ */ ((e) => (e[e.NOBEGIN = 1] = "NOBEGIN", e[e.LIVING = 2] = "LIVING", e))(LiveStatus || {}), RoomMode = /* @__PURE__ */ ((e) => (e[e.LIVE = 1] = "LIVE", e[e.MEETING = 2] = "MEETING", e[e.SEMINAR = 3] = "SEMINAR", e))(RoomMode || {}), LiveDelayEnum = /* @__PURE__ */ ((e) => (e[e.COMMON = 1] = "COMMON", e[e.NO_DELAY = 2] = "NO_DELAY", e))(LiveDelayEnum || {}), LanguageTypeEnum = /* @__PURE__ */ ((e) => (e[e.DEFAULT = 0] = "DEFAULT", e[e["zh-Hans"] = 1] = "zh-Hans", e[e.en = 2] = "en", e[e["zh-Hant"] = 3] = "zh-Hant", e[e.ar = 4] = "ar", e))(LanguageTypeEnum || {}), LanguageEnum = /* @__PURE__ */ ((e) => (e["zh-Hans"] = "zh-Hans", e.en = "en", e["zh-Hant"] = "zh-Hant", e.ar = "ar", e))(LanguageEnum || {});
const LanguageConfig = {
  ["zh-Hans"]: {
    language: "zh-Hans",
    systemLangs: ["zh", "zh-cn", "zh-sg"]
  },
  en: {
    language: "en",
    systemLangs: ["en", "en-"]
  },
  ["zh-Hant"]: {
    language: "zh-Hant",
    systemLangs: ["zh-mo", "zh-tw", "zh-hk"]
  },
  ar: {
    language: "ar",
    systemLangs: ["ar", "ar-"]
  }
};
var LiveScene = /* @__PURE__ */ ((e) => (e[e.LINK = 1] = "LINK", e[e.STREAM_PUSH = 2] = "STREAM_PUSH", e[e.STREAM_PULL = 3] = "STREAM_PULL", e[e.MEETING = 4] = "MEETING", e))(LiveScene || {}), InteractionType = /* @__PURE__ */ ((e) => (e.CHAT = "CHAT", e.LIKE = "LIKE", e.VOTE = "VOTE", e))(InteractionType || {}), AnonymousForbiddenType = /* @__PURE__ */ ((e) => (e[e.LOGIN = 0] = "LOGIN", e[e.NICKNAME = 1] = "NICKNAME", e))(AnonymousForbiddenType || {}), InteractionTypeEnum = /* @__PURE__ */ ((e) => (e[e.SYSTEM = 1] = "SYSTEM", e[e.CUSTOM = 2] = "CUSTOM", e))(InteractionTypeEnum || {}), ScreenOrientationEnum = /* @__PURE__ */ ((e) => (e[e.LANDSCAPE = 0] = "LANDSCAPE", e[e.PORTRAIT = 1] = "PORTRAIT", e))(ScreenOrientationEnum || {});
function httpPutAudiencesName(e, T) {
  return Me(this, null, function* () {
    return request$1.put(`/events/${e}/audiences`, { name: T });
  });
}
function httpPutAudiencesAvatar(e, T) {
  return Me(this, null, function* () {
    return request$1.put(`/events/${e}/audiences`, { avatar: T });
  });
}
function httpGutUserInfo() {
  return Me(this, null, function* () {
    return request$1.get("/audiences/mine");
  });
}
function httpGetConfigUrl(e) {
  return e.appKey === "app" && delete e.appKey, request$1.get(
    "/web/config-url",
    { method: "GET", params: e }
  );
}
function httpGetMine(e, T) {
  return Me(this, null, function* () {
    const { ignoreResponseIC: F = !1 } = T || {};
    return request$1.get("/personnel/mine", {
      params: e,
      ignoreResponseIC: F
    });
  });
}
function wrapBlurUrl(e) {
  return e;
}
var VirtualEventStatusEnum = /* @__PURE__ */ ((e) => (e[e.EVENTPRE = 0] = "EVENTPRE", e[e.EVENTING = 1] = "EVENTING", e[e.EVENTEND = 2] = "EVENTEND", e[e.INIT = 3] = "INIT", e))(VirtualEventStatusEnum || {});
const INITIAL_STATE$J = {
  loading: !0,
  eventNumber: "",
  eventInvalid: !1,
  watchUrl: "https://watch.event.mudu.com",
  loginTargetUrl: "https://console.event.mudu.com",
  assistantUrl: "https://assistant.event.mudu.com",
  liveUrl: "https://live.event.mudu.com",
  goImUrl: "wss://im.event.mudu.com/sub",
  loginUrl: "https://account.event.mudu.com/login",
  eventUrl: "https://mdn-event.mudu.tv",
  hasConfigUrl: !1,
  systemTime: 0,
  systemTimeGap: 0,
  mainRoomNumber: "",
  mainSeminarNumber: "",
  eventId: 0,
  eventName: "",
  eventStatus: 3,
  eventLogo: "",
  eventLogoEnable: !1,
  audienceNicknameChangeFlag: !0,
  interactAccessFlag: !0
};
class EventModel extends Model {
  constructor() {
    super(INITIAL_STATE$J);
  }
  init(T, F) {
    return Me(this, null, function* () {
      const {
        virtualEventId: $,
        virtualEventName: J,
        virtualEventStatus: ee,
        virtualEventLogo: ne,
        virtualEventLogoState: oe,
        mainVenueNumber: se,
        mainSeminarNumber: le,
        removeFlag: de,
        audienceNicknameChangeFlag: ce = 1,
        interactAccessFlag: he = 1
      } = T || {};
      this._setEventInvalidState(isTrue(de)), this.setState({
        systemTime: F,
        systemTimeGap: F - new Date().getTime(),
        eventId: $,
        eventName: J,
        eventStatus: ee,
        eventLogo: ne,
        eventLogoEnable: isTrue(oe),
        mainRoomNumber: se,
        mainSeminarNumber: le,
        audienceNicknameChangeFlag: isTrue(ce),
        interactAccessFlag: isTrue(he)
      });
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$J);
  }
  _setEventNumberState(T) {
    this.setState({ eventNumber: T });
  }
  _setEventInvalidState(T) {
    this.setState({ eventInvalid: T });
  }
  _setInteractAccessFlagState(T) {
    this.setState({ interactAccessFlag: T });
  }
  _requestConfigUrlLazily() {
    return Me(this, null, function* () {
      if (this.state.hasConfigUrl)
        return Promise.resolve();
      const T = this.state.eventNumber;
      try {
        const { data: { data: F } } = yield httpGetConfigUrl({ virtualEventNumber: T });
        return this._setConfigUrlState(Fe({}, F)), this.setState({ hasConfigUrl: !0 }), Promise.resolve(F);
      } catch (F) {
        return Promise.reject(F);
      }
    });
  }
  _setConfigUrlState(T) {
    const {
      loginTargetUrl: F,
      liveUrl: $,
      watchUrl: J,
      eventUrl: ee,
      goImUrl: ne,
      loginUrl: oe,
      assistantUrl: se
    } = T;
    this.setState({
      loginTargetUrl: F,
      liveUrl: $,
      watchUrl: J,
      eventUrl: ee,
      goImUrl: ne,
      loginUrl: oe,
      assistantUrl: se
    });
  }
}
const eventModel = new EventModel();
var __defProp$J = Object.defineProperty, __defNormalProp$J = (e, T, F) => T in e ? __defProp$J(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$J = (e, T, F) => (__defNormalProp$J(e, typeof T != "symbol" ? T + "" : T, F), F);
const ignoreInterceptType = [
  InteractionType.CHAT,
  InteractionType.LIKE,
  InteractionType.VOTE
], needNicknameType = [
  InteractionType.CHAT
], INITIAL_STATE$I = {
  loading: !0,
  tenantId: 0,
  userType: OnlineUserType.ANONYMOUS_AUDIENCE,
  userId: 0,
  nickName: "",
  avatar: "",
  avatarModifyFlag: !0,
  anonymousNickname: "\u533F\u540D\u89C2\u4F17",
  thirdOpenId: "",
  email: "",
  mobile: "",
  promotionChannelId: "",
  nickNameFlag: !1
};
class UserModel extends Model {
  constructor() {
    super(INITIAL_STATE$I), __publicField$J(this, "ANONYMOUS_FORBIDDEN", "ANONYMOUS_FORBIDDEN");
  }
  init(T) {
    return Me(this, null, function* () {
      const {
        tenantId: F,
        userType: $,
        liveUserId: J,
        nickName: ee,
        anonymousNickname: ne,
        thirdOpenId: oe = "",
        email: se,
        mobile: le,
        promotionChannelId: de,
        nickNameFlag: ce
      } = T || {};
      this.setState({
        loading: !1,
        email: se,
        mobile: le,
        userType: $ != null ? $ : OnlineUserType.ANONYMOUS_AUDIENCE,
        userId: J,
        nickName: ee,
        anonymousNickname: ne,
        thirdOpenId: oe,
        tenantId: F,
        promotionChannelId: de,
        nickNameFlag: isTrue(ce)
      }), this._queryUserInfo();
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$I);
  }
  _interceptAnonymous(T) {
    const { nickNameFlag: F } = this.state, { interactAccessFlag: $, audienceNicknameChangeFlag: J } = eventModel.state;
    return this.state.userType === OnlineUserType.ANONYMOUS_AUDIENCE ? !$ && T && ignoreInterceptType.includes(T) ? needNicknameType.includes(T) && J && !F ? (this.emit(this.ANONYMOUS_FORBIDDEN, { type: AnonymousForbiddenType.NICKNAME }), Promise.reject()) : Promise.resolve() : (this.emit(this.ANONYMOUS_FORBIDDEN, { type: AnonymousForbiddenType.LOGIN }), Promise.reject()) : Promise.resolve();
  }
  _setRamTokenState(T) {
    this.setState({ ramToken: T });
  }
  setUserName(T) {
    return httpPutAudiencesName(eventModel.state.eventId, T).then(() => {
      this.setState({
        nickName: T,
        nickNameFlag: !0
      });
    });
  }
  setUserAvatar(T) {
    return Me(this, null, function* () {
      yield this._interceptAnonymous();
      const { avatarModifyFlag: F } = this.state;
      return F ? httpPutAudiencesAvatar(eventModel.state.eventId, T).then(() => {
        this.setState({
          avatar: T,
          avatarModifyFlag: !1
        }), setTimeout(() => {
          this.setState({ avatarModifyFlag: !0 });
        }, 3e3);
      }) : Promise.reject({
        code: "30001"
      });
    });
  }
  _queryUserInfo() {
    httpGutUserInfo().then((T) => {
      var F, $;
      const J = ($ = (F = T == null ? void 0 : T.data) == null ? void 0 : F.data) != null ? $ : {};
      this.setState({
        nickName: (J == null ? void 0 : J.nickName) || "",
        avatar: (J == null ? void 0 : J.avatar) || ""
      });
    }).catch(() => {
    });
  }
}
const userModel = new UserModel();
var assign = make_assign(), create$1 = make_create(), trim$1 = make_trim(), Global$5 = typeof window != "undefined" ? window : commonjsGlobal, util$6 = {
  assign,
  create: create$1,
  trim: trim$1,
  bind: bind$1,
  slice: slice$1,
  each: each$7,
  map,
  pluck: pluck$1,
  isList: isList$1,
  isFunction: isFunction$4,
  isObject: isObject$8,
  Global: Global$5
};
function make_assign() {
  return Object.assign ? Object.assign : function(T, F, $, J) {
    for (var ee = 1; ee < arguments.length; ee++)
      each$7(Object(arguments[ee]), function(ne, oe) {
        T[oe] = ne;
      });
    return T;
  };
}
function make_create() {
  if (Object.create)
    return function(T, F, $, J) {
      var ee = slice$1(arguments, 1);
      return assign.apply(this, [Object.create(T)].concat(ee));
    };
  {
    let e = function() {
    };
    return function(F, $, J, ee) {
      var ne = slice$1(arguments, 1);
      return e.prototype = F, assign.apply(this, [new e()].concat(ne));
    };
  }
}
function make_trim() {
  return String.prototype.trim ? function(T) {
    return String.prototype.trim.call(T);
  } : function(T) {
    return T.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  };
}
function bind$1(e, T) {
  return function() {
    return T.apply(e, Array.prototype.slice.call(arguments, 0));
  };
}
function slice$1(e, T) {
  return Array.prototype.slice.call(e, T || 0);
}
function each$7(e, T) {
  pluck$1(e, function(F, $) {
    return T(F, $), !1;
  });
}
function map(e, T) {
  var F = isList$1(e) ? [] : {};
  return pluck$1(e, function($, J) {
    return F[J] = T($, J), !1;
  }), F;
}
function pluck$1(e, T) {
  if (isList$1(e)) {
    for (var F = 0; F < e.length; F++)
      if (T(e[F], F))
        return e[F];
  } else
    for (var $ in e)
      if (e.hasOwnProperty($) && T(e[$], $))
        return e[$];
}
function isList$1(e) {
  return e != null && typeof e != "function" && typeof e.length == "number";
}
function isFunction$4(e) {
  return e && {}.toString.call(e) === "[object Function]";
}
function isObject$8(e) {
  return e && {}.toString.call(e) === "[object Object]";
}
var util$5 = util$6, slice = util$5.slice, pluck = util$5.pluck, each$6 = util$5.each, bind = util$5.bind, create = util$5.create, isList = util$5.isList, isFunction$3 = util$5.isFunction, isObject$7 = util$5.isObject, storeEngine = {
  createStore
}, storeAPI = {
  version: "2.0.12",
  enabled: !1,
  get: function(e, T) {
    var F = this.storage.read(this._namespacePrefix + e);
    return this._deserialize(F, T);
  },
  set: function(e, T) {
    return T === void 0 ? this.remove(e) : (this.storage.write(this._namespacePrefix + e, this._serialize(T)), T);
  },
  remove: function(e) {
    this.storage.remove(this._namespacePrefix + e);
  },
  each: function(e) {
    var T = this;
    this.storage.each(function(F, $) {
      e.call(T, T._deserialize(F), ($ || "").replace(T._namespaceRegexp, ""));
    });
  },
  clearAll: function() {
    this.storage.clearAll();
  },
  hasNamespace: function(e) {
    return this._namespacePrefix == "__storejs_" + e + "_";
  },
  createStore: function() {
    return createStore.apply(this, arguments);
  },
  addPlugin: function(e) {
    this._addPlugin(e);
  },
  namespace: function(e) {
    return createStore(this.storage, this.plugins, e);
  }
};
function _warn() {
  var e = typeof console == "undefined" ? null : console;
  if (!!e) {
    var T = e.warn ? e.warn : e.log;
    T.apply(e, arguments);
  }
}
function createStore(e, T, F) {
  F || (F = ""), e && !isList(e) && (e = [e]), T && !isList(T) && (T = [T]);
  var $ = F ? "__storejs_" + F + "_" : "", J = F ? new RegExp("^" + $) : null, ee = /^[a-zA-Z0-9_\-]*$/;
  if (!ee.test(F))
    throw new Error("store.js namespaces can only have alphanumerics + underscores and dashes");
  var ne = {
    _namespacePrefix: $,
    _namespaceRegexp: J,
    _testStorage: function(se) {
      try {
        var le = "__storejs__test__";
        se.write(le, le);
        var de = se.read(le) === le;
        return se.remove(le), de;
      } catch (ce) {
        return !1;
      }
    },
    _assignPluginFnProp: function(se, le) {
      var de = this[le];
      this[le] = function() {
        var he = slice(arguments, 0), ve = this;
        function ge() {
          if (!!de)
            return each$6(arguments, function(Te, Se) {
              he[Se] = Te;
            }), de.apply(ve, he);
        }
        var be = [ge].concat(he);
        return se.apply(ve, be);
      };
    },
    _serialize: function(se) {
      return JSON.stringify(se);
    },
    _deserialize: function(se, le) {
      if (!se)
        return le;
      var de = "";
      try {
        de = JSON.parse(se);
      } catch (ce) {
        de = se;
      }
      return de !== void 0 ? de : le;
    },
    _addStorage: function(se) {
      this.enabled || this._testStorage(se) && (this.storage = se, this.enabled = !0);
    },
    _addPlugin: function(se) {
      var le = this;
      if (isList(se)) {
        each$6(se, function(he) {
          le._addPlugin(he);
        });
        return;
      }
      var de = pluck(this.plugins, function(he) {
        return se === he;
      });
      if (!de) {
        if (this.plugins.push(se), !isFunction$3(se))
          throw new Error("Plugins must be function values that return objects");
        var ce = se.call(this);
        if (!isObject$7(ce))
          throw new Error("Plugins must return an object of function properties");
        each$6(ce, function(he, ve) {
          if (!isFunction$3(he))
            throw new Error("Bad plugin property: " + ve + " from plugin " + se.name + ". Plugins should only return functions.");
          le._assignPluginFnProp(he, ve);
        });
      }
    },
    addStorage: function(se) {
      _warn("store.addStorage(storage) is deprecated. Use createStore([storages])"), this._addStorage(se);
    }
  }, oe = create(ne, storeAPI, {
    plugins: []
  });
  return oe.raw = {}, each$6(oe, function(se, le) {
    isFunction$3(se) && (oe.raw[le] = bind(oe, se));
  }), each$6(e, function(se) {
    oe._addStorage(se);
  }), each$6(T, function(se) {
    oe._addPlugin(se);
  }), oe;
}
var util$4 = util$6, Global$4 = util$4.Global, localStorage_1 = {
  name: "localStorage",
  read: read$5,
  write: write$5,
  each: each$5,
  remove: remove$5,
  clearAll: clearAll$5
};
function localStorage$1() {
  return Global$4.localStorage;
}
function read$5(e) {
  return localStorage$1().getItem(e);
}
function write$5(e, T) {
  return localStorage$1().setItem(e, T);
}
function each$5(e) {
  for (var T = localStorage$1().length - 1; T >= 0; T--) {
    var F = localStorage$1().key(T);
    e(read$5(F), F);
  }
}
function remove$5(e) {
  return localStorage$1().removeItem(e);
}
function clearAll$5() {
  return localStorage$1().clear();
}
var util$3 = util$6, Global$3 = util$3.Global, oldFFGlobalStorage = {
  name: "oldFF-globalStorage",
  read: read$4,
  write: write$4,
  each: each$4,
  remove: remove$4,
  clearAll: clearAll$4
}, globalStorage = Global$3.globalStorage;
function read$4(e) {
  return globalStorage[e];
}
function write$4(e, T) {
  globalStorage[e] = T;
}
function each$4(e) {
  for (var T = globalStorage.length - 1; T >= 0; T--) {
    var F = globalStorage.key(T);
    e(globalStorage[F], F);
  }
}
function remove$4(e) {
  return globalStorage.removeItem(e);
}
function clearAll$4() {
  each$4(function(e, T) {
    delete globalStorage[e];
  });
}
var util$2 = util$6, Global$2 = util$2.Global, oldIEUserDataStorage = {
  name: "oldIE-userDataStorage",
  write: write$3,
  read: read$3,
  each: each$3,
  remove: remove$3,
  clearAll: clearAll$3
}, storageName = "storejs", doc$1 = Global$2.document, _withStorageEl = _makeIEStorageElFunction(), disable = (Global$2.navigator ? Global$2.navigator.userAgent : "").match(/ (MSIE 8|MSIE 9|MSIE 10)\./);
function write$3(e, T) {
  if (!disable) {
    var F = fixKey(e);
    _withStorageEl(function($) {
      $.setAttribute(F, T), $.save(storageName);
    });
  }
}
function read$3(e) {
  if (!disable) {
    var T = fixKey(e), F = null;
    return _withStorageEl(function($) {
      F = $.getAttribute(T);
    }), F;
  }
}
function each$3(e) {
  _withStorageEl(function(T) {
    for (var F = T.XMLDocument.documentElement.attributes, $ = F.length - 1; $ >= 0; $--) {
      var J = F[$];
      e(T.getAttribute(J.name), J.name);
    }
  });
}
function remove$3(e) {
  var T = fixKey(e);
  _withStorageEl(function(F) {
    F.removeAttribute(T), F.save(storageName);
  });
}
function clearAll$3() {
  _withStorageEl(function(e) {
    var T = e.XMLDocument.documentElement.attributes;
    e.load(storageName);
    for (var F = T.length - 1; F >= 0; F--)
      e.removeAttribute(T[F].name);
    e.save(storageName);
  });
}
var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
function fixKey(e) {
  return e.replace(/^\d/, "___$&").replace(forbiddenCharsRegex, "___");
}
function _makeIEStorageElFunction() {
  if (!doc$1 || !doc$1.documentElement || !doc$1.documentElement.addBehavior)
    return null;
  var e = "script", T, F, $;
  try {
    F = new ActiveXObject("htmlfile"), F.open(), F.write("<" + e + ">document.w=window</" + e + '><iframe src="/favicon.ico"></iframe>'), F.close(), T = F.w.frames[0].document, $ = T.createElement("div");
  } catch (J) {
    $ = doc$1.createElement("div"), T = doc$1.body;
  }
  return function(J) {
    var ee = [].slice.call(arguments, 0);
    ee.unshift($), T.appendChild($), $.addBehavior("#default#userData"), $.load(storageName), J.apply(this, ee), T.removeChild($);
  };
}
var util$1 = util$6, Global$1 = util$1.Global, trim = util$1.trim, cookieStorage = {
  name: "cookieStorage",
  read: read$2,
  write: write$2,
  each: each$2,
  remove: remove$2,
  clearAll: clearAll$2
}, doc = Global$1.document;
function read$2(e) {
  if (!e || !_has(e))
    return null;
  var T = "(?:^|.*;\\s*)" + escape(e).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
  return unescape(doc.cookie.replace(new RegExp(T), "$1"));
}
function each$2(e) {
  for (var T = doc.cookie.split(/; ?/g), F = T.length - 1; F >= 0; F--)
    if (!!trim(T[F])) {
      var $ = T[F].split("="), J = unescape($[0]), ee = unescape($[1]);
      e(ee, J);
    }
}
function write$2(e, T) {
  !e || (doc.cookie = escape(e) + "=" + escape(T) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/");
}
function remove$2(e) {
  !e || !_has(e) || (doc.cookie = escape(e) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/");
}
function clearAll$2() {
  each$2(function(e, T) {
    remove$2(T);
  });
}
function _has(e) {
  return new RegExp("(?:^|;\\s*)" + escape(e).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(doc.cookie);
}
var util = util$6, Global = util.Global, sessionStorage_1 = {
  name: "sessionStorage",
  read: read$1,
  write: write$1,
  each: each$1,
  remove: remove$1,
  clearAll: clearAll$1
};
function sessionStorage() {
  return Global.sessionStorage;
}
function read$1(e) {
  return sessionStorage().getItem(e);
}
function write$1(e, T) {
  return sessionStorage().setItem(e, T);
}
function each$1(e) {
  for (var T = sessionStorage().length - 1; T >= 0; T--) {
    var F = sessionStorage().key(T);
    e(read$1(F), F);
  }
}
function remove$1(e) {
  return sessionStorage().removeItem(e);
}
function clearAll$1() {
  return sessionStorage().clear();
}
var memoryStorage_1 = {
  name: "memoryStorage",
  read,
  write,
  each,
  remove,
  clearAll
}, memoryStorage = {};
function read(e) {
  return memoryStorage[e];
}
function write(e, T) {
  memoryStorage[e] = T;
}
function each(e) {
  for (var T in memoryStorage)
    memoryStorage.hasOwnProperty(T) && e(memoryStorage[T], T);
}
function remove(e) {
  delete memoryStorage[e];
}
function clearAll(e) {
  memoryStorage = {};
}
var all = [
  localStorage_1,
  oldFFGlobalStorage,
  oldIEUserDataStorage,
  cookieStorage,
  sessionStorage_1,
  memoryStorage_1
], json2$1 = {}, hasRequiredJson2;
function requireJson2() {
  return hasRequiredJson2 || (hasRequiredJson2 = 1, typeof JSON != "object" && (JSON = {}), function() {
    var rx_one = /^[\],:{}\s]*$/, rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, rx_four = /(?:^|:|,)(?:\s*\[)+/g, rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    function f(e) {
      return e < 10 ? "0" + e : e;
    }
    function this_value() {
      return this.valueOf();
    }
    typeof Date.prototype.toJSON != "function" && (Date.prototype.toJSON = function() {
      return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
    }, Boolean.prototype.toJSON = this_value, Number.prototype.toJSON = this_value, String.prototype.toJSON = this_value);
    var gap, indent, meta, rep;
    function quote(e) {
      return rx_escapable.lastIndex = 0, rx_escapable.test(e) ? '"' + e.replace(rx_escapable, function(T) {
        var F = meta[T];
        return typeof F == "string" ? F : "\\u" + ("0000" + T.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + e + '"';
    }
    function str(e, T) {
      var F, $, J, ee, ne = gap, oe, se = T[e];
      switch (se && typeof se == "object" && typeof se.toJSON == "function" && (se = se.toJSON(e)), typeof rep == "function" && (se = rep.call(T, e, se)), typeof se) {
        case "string":
          return quote(se);
        case "number":
          return isFinite(se) ? String(se) : "null";
        case "boolean":
        case "null":
          return String(se);
        case "object":
          if (!se)
            return "null";
          if (gap += indent, oe = [], Object.prototype.toString.apply(se) === "[object Array]") {
            for (ee = se.length, F = 0; F < ee; F += 1)
              oe[F] = str(F, se) || "null";
            return J = oe.length === 0 ? "[]" : gap ? `[
` + gap + oe.join(`,
` + gap) + `
` + ne + "]" : "[" + oe.join(",") + "]", gap = ne, J;
          }
          if (rep && typeof rep == "object")
            for (ee = rep.length, F = 0; F < ee; F += 1)
              typeof rep[F] == "string" && ($ = rep[F], J = str($, se), J && oe.push(quote($) + (gap ? ": " : ":") + J));
          else
            for ($ in se)
              Object.prototype.hasOwnProperty.call(se, $) && (J = str($, se), J && oe.push(quote($) + (gap ? ": " : ":") + J));
          return J = oe.length === 0 ? "{}" : gap ? `{
` + gap + oe.join(`,
` + gap) + `
` + ne + "}" : "{" + oe.join(",") + "}", gap = ne, J;
      }
    }
    typeof JSON.stringify != "function" && (meta = {
      "\b": "\\b",
      "	": "\\t",
      "\n": "\\n",
      "\f": "\\f",
      "\r": "\\r",
      '"': '\\"',
      "\\": "\\\\"
    }, JSON.stringify = function(e, T, F) {
      var $;
      if (gap = "", indent = "", typeof F == "number")
        for ($ = 0; $ < F; $ += 1)
          indent += " ";
      else
        typeof F == "string" && (indent = F);
      if (rep = T, T && typeof T != "function" && (typeof T != "object" || typeof T.length != "number"))
        throw new Error("JSON.stringify");
      return str("", { "": e });
    }), typeof JSON.parse != "function" && (JSON.parse = function(text, reviver) {
      var j;
      function walk(e, T) {
        var F, $, J = e[T];
        if (J && typeof J == "object")
          for (F in J)
            Object.prototype.hasOwnProperty.call(J, F) && ($ = walk(J, F), $ !== void 0 ? J[F] = $ : delete J[F]);
        return reviver.call(e, T, J);
      }
      if (text = String(text), rx_dangerous.lastIndex = 0, rx_dangerous.test(text) && (text = text.replace(rx_dangerous, function(e) {
        return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
      })), rx_one.test(
        text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, "")
      ))
        return j = eval("(" + text + ")"), typeof reviver == "function" ? walk({ "": j }, "") : j;
      throw new SyntaxError("JSON.parse");
    });
  }()), json2$1;
}
var json2 = json2Plugin;
function json2Plugin() {
  return requireJson2(), {};
}
var engine = storeEngine, storages = all, plugins = [json2], store_legacy = engine.createStore(storages, plugins), __defProp$I = Object.defineProperty, __defNormalProp$I = (e, T, F) => T in e ? __defProp$I(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$I = (e, T, F) => (__defNormalProp$I(e, typeof T != "symbol" ? T + "" : T, F), F);
class LRUCache {
  constructor(T, F) {
    __publicField$I(this, "length"), __publicField$I(this, "data"), this.length = T, this.data = F || [];
  }
  set(T, F) {
    const { data: $, length: J } = this, ee = new Map($);
    if (ee.has(T) && ee.delete(T), ee.set(T, F), ee.size > J) {
      const ne = ee.keys().next().value;
      ee.delete(ne);
    }
    this.data = Array.from(ee);
  }
  get(T) {
    const { data: F } = this, $ = new Map(F);
    if (!$.has(T))
      return null;
    const J = $.get(T);
    return $.delete(T), $.set(T, J), this.data = Array.from($), J;
  }
  remove(T) {
    const { data: F } = this, $ = new Map(F);
    $.has(T) && $.delete(T), this.data = Array.from($);
  }
}
class LRULocalStorage {
  constructor(T, F) {
    __publicField$I(this, "storeKey"), __publicField$I(this, "maxLength"), this.storeKey = T, this.maxLength = F != null ? F : 20;
  }
  get(T) {
    var F;
    const { bellwether: $ = !1 } = T != null ? T : {}, J = this.getDataKey(), { length: ee = this.maxLength, data: ne } = (F = store_legacy.get(this.storeKey)) != null ? F : {}, oe = new LRUCache(ee, ne), se = oe.get(J);
    return $ && store_legacy.set(this.storeKey, oe), J ? se : null;
  }
  set(T) {
    var F;
    const $ = this.getDataKey();
    if ($) {
      const { length: J = this.maxLength, data: ee } = (F = store_legacy.get(this.storeKey)) != null ? F : {}, ne = new LRUCache(J, ee);
      ne.set($, T), store_legacy.set(this.storeKey, ne);
    }
  }
  remove() {
    var T;
    const F = this.getDataKey();
    if (F) {
      const { length: $ = this.maxLength, data: J } = (T = store_legacy.get(this.storeKey)) != null ? T : {}, ee = new LRUCache($, J);
      ee.remove(F), store_legacy.set(this.storeKey, ee);
    }
  }
  removeAll() {
    store_legacy.remove(this.storeKey);
  }
}
class EventLocalStorage extends LRULocalStorage {
  getDataKey() {
    return eventModel.state.eventNumber;
  }
}
const STORE_KEY$1 = "landing:accessTokens", MAX_LENGTH = 20, eventLs = new EventLocalStorage(STORE_KEY$1, MAX_LENGTH);
function lsGetEventToken(e) {
  return eventLs.get(e);
}
function lsSetEventToken(e, T, F) {
  if (eventLs.set({
    accessToken: e,
    refreshToken: T,
    expiration: F
  }), T && F) {
    const $ = F - Date.now();
    refreshTokenModel._startTimer(T, $);
  }
  userModel._setRamTokenState(e);
}
function lsRemoveEventToken() {
  eventLs.remove();
}
const consoleLogger = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, T) {
    console && console[e] && console[e].apply(console, T);
  }
};
class Logger {
  constructor(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(T, F);
  }
  init(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = F.prefix || "i18next:", this.logger = T || consoleLogger, this.options = F, this.debug = F.debug;
  }
  log() {
    for (var T = arguments.length, F = new Array(T), $ = 0; $ < T; $++)
      F[$] = arguments[$];
    return this.forward(F, "log", "", !0);
  }
  warn() {
    for (var T = arguments.length, F = new Array(T), $ = 0; $ < T; $++)
      F[$] = arguments[$];
    return this.forward(F, "warn", "", !0);
  }
  error() {
    for (var T = arguments.length, F = new Array(T), $ = 0; $ < T; $++)
      F[$] = arguments[$];
    return this.forward(F, "error", "");
  }
  deprecate() {
    for (var T = arguments.length, F = new Array(T), $ = 0; $ < T; $++)
      F[$] = arguments[$];
    return this.forward(F, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(T, F, $, J) {
    return J && !this.debug ? null : (typeof T[0] == "string" && (T[0] = `${$}${this.prefix} ${T[0]}`), this.logger[F](T));
  }
  create(T) {
    return new Logger(this.logger, Fe({
      prefix: `${this.prefix}:${T}:`
    }, this.options));
  }
  clone(T) {
    return T = T || this.options, T.prefix = T.prefix || this.prefix, new Logger(this.logger, T);
  }
}
var baseLogger = new Logger();
class EventEmitter$1 {
  constructor() {
    this.observers = {};
  }
  on(T, F) {
    return T.split(" ").forEach(($) => {
      this.observers[$] || (this.observers[$] = /* @__PURE__ */ new Map());
      const J = this.observers[$].get(F) || 0;
      this.observers[$].set(F, J + 1);
    }), this;
  }
  off(T, F) {
    if (!!this.observers[T]) {
      if (!F) {
        delete this.observers[T];
        return;
      }
      this.observers[T].delete(F);
    }
  }
  emit(T) {
    for (var F = arguments.length, $ = new Array(F > 1 ? F - 1 : 0), J = 1; J < F; J++)
      $[J - 1] = arguments[J];
    this.observers[T] && Array.from(this.observers[T].entries()).forEach((ne) => {
      let [oe, se] = ne;
      for (let le = 0; le < se; le++)
        oe(...$);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((ne) => {
      let [oe, se] = ne;
      for (let le = 0; le < se; le++)
        oe.apply(oe, [T, ...$]);
    });
  }
}
function defer() {
  let e, T;
  const F = new Promise(($, J) => {
    e = $, T = J;
  });
  return F.resolve = e, F.reject = T, F;
}
function makeString(e) {
  return e == null ? "" : "" + e;
}
function copy(e, T, F) {
  e.forEach(($) => {
    T[$] && (F[$] = T[$]);
  });
}
const lastOfPathSeparatorRegExp = /###/g;
function getLastOfPath(e, T, F) {
  function $(oe) {
    return oe && oe.indexOf("###") > -1 ? oe.replace(lastOfPathSeparatorRegExp, ".") : oe;
  }
  function J() {
    return !e || typeof e == "string";
  }
  const ee = typeof T != "string" ? T : T.split(".");
  let ne = 0;
  for (; ne < ee.length - 1; ) {
    if (J())
      return {};
    const oe = $(ee[ne]);
    !e[oe] && F && (e[oe] = new F()), Object.prototype.hasOwnProperty.call(e, oe) ? e = e[oe] : e = {}, ++ne;
  }
  return J() ? {} : {
    obj: e,
    k: $(ee[ne])
  };
}
function setPath(e, T, F) {
  const {
    obj: $,
    k: J
  } = getLastOfPath(e, T, Object);
  if ($ !== void 0 || T.length === 1) {
    $[J] = F;
    return;
  }
  let ee = T[T.length - 1], ne = T.slice(0, T.length - 1), oe = getLastOfPath(e, ne, Object);
  for (; oe.obj === void 0 && ne.length; )
    ee = `${ne[ne.length - 1]}.${ee}`, ne = ne.slice(0, ne.length - 1), oe = getLastOfPath(e, ne, Object), oe && oe.obj && typeof oe.obj[`${oe.k}.${ee}`] != "undefined" && (oe.obj = void 0);
  oe.obj[`${oe.k}.${ee}`] = F;
}
function pushPath(e, T, F, $) {
  const {
    obj: J,
    k: ee
  } = getLastOfPath(e, T, Object);
  J[ee] = J[ee] || [], J[ee].push(F);
}
function getPath(e, T) {
  const {
    obj: F,
    k: $
  } = getLastOfPath(e, T);
  if (!!F)
    return F[$];
}
function getPathWithDefaults(e, T, F) {
  const $ = getPath(e, F);
  return $ !== void 0 ? $ : getPath(T, F);
}
function deepExtend(e, T, F) {
  for (const $ in T)
    $ !== "__proto__" && $ !== "constructor" && ($ in e ? typeof e[$] == "string" || e[$] instanceof String || typeof T[$] == "string" || T[$] instanceof String ? F && (e[$] = T[$]) : deepExtend(e[$], T[$], F) : e[$] = T[$]);
  return e;
}
function regexEscape(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function escape$1(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, (T) => _entityMap[T]) : e;
}
class RegExpCache {
  constructor(T) {
    this.capacity = T, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(T) {
    const F = this.regExpMap.get(T);
    if (F !== void 0)
      return F;
    const $ = new RegExp(T);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(T, $), this.regExpQueue.push(T), $;
  }
}
const chars = [" ", ",", "?", "!", ";"], looksLikeObjectPathRegExpCache = new RegExpCache(20);
function looksLikeObjectPath(e, T, F) {
  T = T || "", F = F || "";
  const $ = chars.filter((ne) => T.indexOf(ne) < 0 && F.indexOf(ne) < 0);
  if ($.length === 0)
    return !0;
  const J = looksLikeObjectPathRegExpCache.getRegExp(`(${$.map((ne) => ne === "?" ? "\\?" : ne).join("|")})`);
  let ee = !J.test(e);
  if (!ee) {
    const ne = e.indexOf(F);
    ne > 0 && !J.test(e.substring(0, ne)) && (ee = !0);
  }
  return ee;
}
function deepFind(e, T) {
  let F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[T])
    return e[T];
  const $ = T.split(F);
  let J = e;
  for (let ee = 0; ee < $.length; ) {
    if (!J || typeof J != "object")
      return;
    let ne, oe = "";
    for (let se = ee; se < $.length; ++se)
      if (se !== ee && (oe += F), oe += $[se], ne = J[oe], ne !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof ne) > -1 && se < $.length - 1)
          continue;
        ee += se - ee + 1;
        break;
      }
    J = ne;
  }
  return J;
}
function getCleanedCode(e) {
  return e && e.indexOf("_") > 0 ? e.replace("_", "-") : e;
}
class ResourceStore extends EventEmitter$1 {
  constructor(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = T || {}, this.options = F, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(T) {
    this.options.ns.indexOf(T) < 0 && this.options.ns.push(T);
  }
  removeNamespaces(T) {
    const F = this.options.ns.indexOf(T);
    F > -1 && this.options.ns.splice(F, 1);
  }
  getResource(T, F, $) {
    let J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const ee = J.keySeparator !== void 0 ? J.keySeparator : this.options.keySeparator, ne = J.ignoreJSONStructure !== void 0 ? J.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let oe;
    T.indexOf(".") > -1 ? oe = T.split(".") : (oe = [T, F], $ && (Array.isArray($) ? oe.push(...$) : typeof $ == "string" && ee ? oe.push(...$.split(ee)) : oe.push($)));
    const se = getPath(this.data, oe);
    return !se && !F && !$ && T.indexOf(".") > -1 && (T = oe[0], F = oe[1], $ = oe.slice(2).join(".")), se || !ne || typeof $ != "string" ? se : deepFind(this.data && this.data[T] && this.data[T][F], $, ee);
  }
  addResource(T, F, $, J) {
    let ee = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const ne = ee.keySeparator !== void 0 ? ee.keySeparator : this.options.keySeparator;
    let oe = [T, F];
    $ && (oe = oe.concat(ne ? $.split(ne) : $)), T.indexOf(".") > -1 && (oe = T.split("."), J = F, F = oe[1]), this.addNamespaces(F), setPath(this.data, oe, J), ee.silent || this.emit("added", T, F, $, J);
  }
  addResources(T, F, $) {
    let J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const ee in $)
      (typeof $[ee] == "string" || Array.isArray($[ee])) && this.addResource(T, F, ee, $[ee], {
        silent: !0
      });
    J.silent || this.emit("added", T, F, $);
  }
  addResourceBundle(T, F, $, J, ee) {
    let ne = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, oe = [T, F];
    T.indexOf(".") > -1 && (oe = T.split("."), J = $, $ = F, F = oe[1]), this.addNamespaces(F);
    let se = getPath(this.data, oe) || {};
    ne.skipCopy || ($ = JSON.parse(JSON.stringify($))), J ? deepExtend(se, $, ee) : se = Fe(Fe({}, se), $), setPath(this.data, oe, se), ne.silent || this.emit("added", T, F, $);
  }
  removeResourceBundle(T, F) {
    this.hasResourceBundle(T, F) && delete this.data[T][F], this.removeNamespaces(F), this.emit("removed", T, F);
  }
  hasResourceBundle(T, F) {
    return this.getResource(T, F) !== void 0;
  }
  getResourceBundle(T, F) {
    return F || (F = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? Fe({}, this.getResource(T, F)) : this.getResource(T, F);
  }
  getDataByLanguage(T) {
    return this.data[T];
  }
  hasLanguageSomeTranslations(T) {
    const F = this.getDataByLanguage(T);
    return !!(F && Object.keys(F) || []).find((J) => F[J] && Object.keys(F[J]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var postProcessor = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, T, F, $, J) {
    return e.forEach((ee) => {
      this.processors[ee] && (T = this.processors[ee].process(T, F, $, J));
    }), T;
  }
};
const checkedLoadedFor = {};
class Translator extends EventEmitter$1 {
  constructor(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), copy(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], T, this), this.options = F, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = baseLogger.create("translator");
  }
  changeLanguage(T) {
    T && (this.language = T);
  }
  exists(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (T == null)
      return !1;
    const $ = this.resolve(T, F);
    return $ && $.res !== void 0;
  }
  extractFromKey(T, F) {
    let $ = F.nsSeparator !== void 0 ? F.nsSeparator : this.options.nsSeparator;
    $ === void 0 && ($ = ":");
    const J = F.keySeparator !== void 0 ? F.keySeparator : this.options.keySeparator;
    let ee = F.ns || this.options.defaultNS || [];
    const ne = $ && T.indexOf($) > -1, oe = !this.options.userDefinedKeySeparator && !F.keySeparator && !this.options.userDefinedNsSeparator && !F.nsSeparator && !looksLikeObjectPath(T, $, J);
    if (ne && !oe) {
      const se = T.match(this.interpolator.nestingRegexp);
      if (se && se.length > 0)
        return {
          key: T,
          namespaces: ee
        };
      const le = T.split($);
      ($ !== J || $ === J && this.options.ns.indexOf(le[0]) > -1) && (ee = le.shift()), T = le.join(J);
    }
    return typeof ee == "string" && (ee = [ee]), {
      key: T,
      namespaces: ee
    };
  }
  translate(T, F, $) {
    if (typeof F != "object" && this.options.overloadTranslationOptionHandler && (F = this.options.overloadTranslationOptionHandler(arguments)), typeof F == "object" && (F = Fe({}, F)), F || (F = {}), T == null)
      return "";
    Array.isArray(T) || (T = [String(T)]);
    const J = F.returnDetails !== void 0 ? F.returnDetails : this.options.returnDetails, ee = F.keySeparator !== void 0 ? F.keySeparator : this.options.keySeparator, {
      key: ne,
      namespaces: oe
    } = this.extractFromKey(T[T.length - 1], F), se = oe[oe.length - 1], le = F.lng || this.language, de = F.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (le && le.toLowerCase() === "cimode") {
      if (de) {
        const Le = F.nsSeparator || this.options.nsSeparator;
        return J ? {
          res: `${se}${Le}${ne}`,
          usedKey: ne,
          exactUsedKey: ne,
          usedLng: le,
          usedNS: se,
          usedParams: this.getUsedParamsDetails(F)
        } : `${se}${Le}${ne}`;
      }
      return J ? {
        res: ne,
        usedKey: ne,
        exactUsedKey: ne,
        usedLng: le,
        usedNS: se,
        usedParams: this.getUsedParamsDetails(F)
      } : ne;
    }
    const ce = this.resolve(T, F);
    let he = ce && ce.res;
    const ve = ce && ce.usedKey || ne, ge = ce && ce.exactUsedKey || ne, be = Object.prototype.toString.apply(he), Te = ["[object Number]", "[object Function]", "[object RegExp]"], Se = F.joinArrays !== void 0 ? F.joinArrays : this.options.joinArrays, Ie = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (Ie && he && (typeof he != "string" && typeof he != "boolean" && typeof he != "number") && Te.indexOf(be) < 0 && !(typeof Se == "string" && Array.isArray(he))) {
      if (!F.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const Le = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(ve, he, Ke(Fe({}, F), {
          ns: oe
        })) : `key '${ne} (${this.language})' returned an object instead of string.`;
        return J ? (ce.res = Le, ce.usedParams = this.getUsedParamsDetails(F), ce) : Le;
      }
      if (ee) {
        const Le = Array.isArray(he), Ne = Le ? [] : {}, Ue = Le ? ge : ve;
        for (const je in he)
          if (Object.prototype.hasOwnProperty.call(he, je)) {
            const we = `${Ue}${ee}${je}`;
            Ne[je] = this.translate(we, Ke(Fe({}, F), {
              joinArrays: !1,
              ns: oe
            })), Ne[je] === we && (Ne[je] = he[je]);
          }
        he = Ne;
      }
    } else if (Ie && typeof Se == "string" && Array.isArray(he))
      he = he.join(Se), he && (he = this.extendTranslation(he, T, F, $));
    else {
      let Le = !1, Ne = !1;
      const Ue = F.count !== void 0 && typeof F.count != "string", je = Translator.hasDefaultValue(F), we = Ue ? this.pluralResolver.getSuffix(le, F.count, F) : "", He = F.ordinal && Ue ? this.pluralResolver.getSuffix(le, F.count, {
        ordinal: !1
      }) : "", De = Ue && !F.ordinal && F.count === 0 && this.pluralResolver.shouldUseIntlApi(), $e = De && F[`defaultValue${this.options.pluralSeparator}zero`] || F[`defaultValue${we}`] || F[`defaultValue${He}`] || F.defaultValue;
      !this.isValidLookup(he) && je && (Le = !0, he = $e), this.isValidLookup(he) || (Ne = !0, he = ne);
      const lt = (F.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && Ne ? void 0 : he, tt = je && $e !== he && this.options.updateMissing;
      if (Ne || Le || tt) {
        if (this.logger.log(tt ? "updateKey" : "missingKey", le, se, ne, tt ? $e : he), ee) {
          const it = this.resolve(ne, Ke(Fe({}, F), {
            keySeparator: !1
          }));
          it && it.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let nt = [];
        const Et = this.languageUtils.getFallbackCodes(this.options.fallbackLng, F.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Et && Et[0])
          for (let it = 0; it < Et.length; it++)
            nt.push(Et[it]);
        else
          this.options.saveMissingTo === "all" ? nt = this.languageUtils.toResolveHierarchy(F.lng || this.language) : nt.push(F.lng || this.language);
        const It = (it, ft, At) => {
          const ur = je && At !== he ? At : lt;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(it, se, ft, ur, tt, F) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(it, se, ft, ur, tt, F), this.emit("missingKey", it, se, ft, he);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && Ue ? nt.forEach((it) => {
          const ft = this.pluralResolver.getSuffixes(it, F);
          De && F[`defaultValue${this.options.pluralSeparator}zero`] && ft.indexOf(`${this.options.pluralSeparator}zero`) < 0 && ft.push(`${this.options.pluralSeparator}zero`), ft.forEach((At) => {
            It([it], ne + At, F[`defaultValue${At}`] || $e);
          });
        }) : It(nt, ne, $e));
      }
      he = this.extendTranslation(he, T, F, ce, $), Ne && he === ne && this.options.appendNamespaceToMissingKey && (he = `${se}:${ne}`), (Ne || Le) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? he = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${se}:${ne}` : ne, Le ? he : void 0) : he = this.options.parseMissingKeyHandler(he));
    }
    return J ? (ce.res = he, ce.usedParams = this.getUsedParamsDetails(F), ce) : he;
  }
  extendTranslation(T, F, $, J, ee) {
    var ne = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      T = this.i18nFormat.parse(T, Fe(Fe({}, this.options.interpolation.defaultVariables), $), $.lng || this.language || J.usedLng, J.usedNS, J.usedKey, {
        resolved: J
      });
    else if (!$.skipInterpolation) {
      $.interpolation && this.interpolator.init(Ke(Fe({}, $), {
        interpolation: Fe(Fe({}, this.options.interpolation), $.interpolation)
      }));
      const le = typeof T == "string" && ($ && $.interpolation && $.interpolation.skipOnVariables !== void 0 ? $.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let de;
      if (le) {
        const he = T.match(this.interpolator.nestingRegexp);
        de = he && he.length;
      }
      let ce = $.replace && typeof $.replace != "string" ? $.replace : $;
      if (this.options.interpolation.defaultVariables && (ce = Fe(Fe({}, this.options.interpolation.defaultVariables), ce)), T = this.interpolator.interpolate(T, ce, $.lng || this.language, $), le) {
        const he = T.match(this.interpolator.nestingRegexp), ve = he && he.length;
        de < ve && ($.nest = !1);
      }
      !$.lng && this.options.compatibilityAPI !== "v1" && J && J.res && ($.lng = J.usedLng), $.nest !== !1 && (T = this.interpolator.nest(T, function() {
        for (var he = arguments.length, ve = new Array(he), ge = 0; ge < he; ge++)
          ve[ge] = arguments[ge];
        return ee && ee[0] === ve[0] && !$.context ? (ne.logger.warn(`It seems you are nesting recursively key: ${ve[0]} in key: ${F[0]}`), null) : ne.translate(...ve, F);
      }, $)), $.interpolation && this.interpolator.reset();
    }
    const oe = $.postProcess || this.options.postProcess, se = typeof oe == "string" ? [oe] : oe;
    return T != null && se && se.length && $.applyPostProcessor !== !1 && (T = postProcessor.handle(se, T, F, this.options && this.options.postProcessPassResolved ? Fe({
      i18nResolved: Ke(Fe({}, J), {
        usedParams: this.getUsedParamsDetails($)
      })
    }, $) : $, this)), T;
  }
  resolve(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $, J, ee, ne, oe;
    return typeof T == "string" && (T = [T]), T.forEach((se) => {
      if (this.isValidLookup($))
        return;
      const le = this.extractFromKey(se, F), de = le.key;
      J = de;
      let ce = le.namespaces;
      this.options.fallbackNS && (ce = ce.concat(this.options.fallbackNS));
      const he = F.count !== void 0 && typeof F.count != "string", ve = he && !F.ordinal && F.count === 0 && this.pluralResolver.shouldUseIntlApi(), ge = F.context !== void 0 && (typeof F.context == "string" || typeof F.context == "number") && F.context !== "", be = F.lngs ? F.lngs : this.languageUtils.toResolveHierarchy(F.lng || this.language, F.fallbackLng);
      ce.forEach((Te) => {
        this.isValidLookup($) || (oe = Te, !checkedLoadedFor[`${be[0]}-${Te}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(oe) && (checkedLoadedFor[`${be[0]}-${Te}`] = !0, this.logger.warn(`key "${J}" for languages "${be.join(", ")}" won't get resolved as namespace "${oe}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), be.forEach((Se) => {
          if (this.isValidLookup($))
            return;
          ne = Se;
          const Ie = [de];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(Ie, de, Se, Te, F);
          else {
            let Le;
            he && (Le = this.pluralResolver.getSuffix(Se, F.count, F));
            const Ne = `${this.options.pluralSeparator}zero`, Ue = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (he && (Ie.push(de + Le), F.ordinal && Le.indexOf(Ue) === 0 && Ie.push(de + Le.replace(Ue, this.options.pluralSeparator)), ve && Ie.push(de + Ne)), ge) {
              const je = `${de}${this.options.contextSeparator}${F.context}`;
              Ie.push(je), he && (Ie.push(je + Le), F.ordinal && Le.indexOf(Ue) === 0 && Ie.push(je + Le.replace(Ue, this.options.pluralSeparator)), ve && Ie.push(je + Ne));
            }
          }
          let Oe;
          for (; Oe = Ie.pop(); )
            this.isValidLookup($) || (ee = Oe, $ = this.getResource(Se, Te, Oe, F));
        }));
      });
    }), {
      res: $,
      usedKey: J,
      exactUsedKey: ee,
      usedLng: ne,
      usedNS: oe
    };
  }
  isValidLookup(T) {
    return T !== void 0 && !(!this.options.returnNull && T === null) && !(!this.options.returnEmptyString && T === "");
  }
  getResource(T, F, $) {
    let J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(T, F, $, J) : this.resourceStore.getResource(T, F, $, J);
  }
  getUsedParamsDetails() {
    let T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const F = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], $ = T.replace && typeof T.replace != "string";
    let J = $ ? T.replace : T;
    if ($ && typeof T.count != "undefined" && (J.count = T.count), this.options.interpolation.defaultVariables && (J = Fe(Fe({}, this.options.interpolation.defaultVariables), J)), !$) {
      J = Fe({}, J);
      for (const ee of F)
        delete J[ee];
    }
    return J;
  }
  static hasDefaultValue(T) {
    const F = "defaultValue";
    for (const $ in T)
      if (Object.prototype.hasOwnProperty.call(T, $) && F === $.substring(0, F.length) && T[$] !== void 0)
        return !0;
    return !1;
  }
}
function capitalize(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
class LanguageUtil {
  constructor(T) {
    this.options = T, this.supportedLngs = this.options.supportedLngs || !1, this.logger = baseLogger.create("languageUtils");
  }
  getScriptPartFromCode(T) {
    if (T = getCleanedCode(T), !T || T.indexOf("-") < 0)
      return null;
    const F = T.split("-");
    return F.length === 2 || (F.pop(), F[F.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(F.join("-"));
  }
  getLanguagePartFromCode(T) {
    if (T = getCleanedCode(T), !T || T.indexOf("-") < 0)
      return T;
    const F = T.split("-");
    return this.formatLanguageCode(F[0]);
  }
  formatLanguageCode(T) {
    if (typeof T == "string" && T.indexOf("-") > -1) {
      const F = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let $ = T.split("-");
      return this.options.lowerCaseLng ? $ = $.map((J) => J.toLowerCase()) : $.length === 2 ? ($[0] = $[0].toLowerCase(), $[1] = $[1].toUpperCase(), F.indexOf($[1].toLowerCase()) > -1 && ($[1] = capitalize($[1].toLowerCase()))) : $.length === 3 && ($[0] = $[0].toLowerCase(), $[1].length === 2 && ($[1] = $[1].toUpperCase()), $[0] !== "sgn" && $[2].length === 2 && ($[2] = $[2].toUpperCase()), F.indexOf($[1].toLowerCase()) > -1 && ($[1] = capitalize($[1].toLowerCase())), F.indexOf($[2].toLowerCase()) > -1 && ($[2] = capitalize($[2].toLowerCase()))), $.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? T.toLowerCase() : T;
  }
  isSupportedCode(T) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (T = this.getLanguagePartFromCode(T)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(T) > -1;
  }
  getBestMatchFromCodes(T) {
    if (!T)
      return null;
    let F;
    return T.forEach(($) => {
      if (F)
        return;
      const J = this.formatLanguageCode($);
      (!this.options.supportedLngs || this.isSupportedCode(J)) && (F = J);
    }), !F && this.options.supportedLngs && T.forEach(($) => {
      if (F)
        return;
      const J = this.getLanguagePartFromCode($);
      if (this.isSupportedCode(J))
        return F = J;
      F = this.options.supportedLngs.find((ee) => {
        if (ee === J)
          return ee;
        if (!(ee.indexOf("-") < 0 && J.indexOf("-") < 0) && (ee.indexOf("-") > 0 && J.indexOf("-") < 0 && ee.substring(0, ee.indexOf("-")) === J || ee.indexOf(J) === 0 && J.length > 1))
          return ee;
      });
    }), F || (F = this.getFallbackCodes(this.options.fallbackLng)[0]), F;
  }
  getFallbackCodes(T, F) {
    if (!T)
      return [];
    if (typeof T == "function" && (T = T(F)), typeof T == "string" && (T = [T]), Array.isArray(T))
      return T;
    if (!F)
      return T.default || [];
    let $ = T[F];
    return $ || ($ = T[this.getScriptPartFromCode(F)]), $ || ($ = T[this.formatLanguageCode(F)]), $ || ($ = T[this.getLanguagePartFromCode(F)]), $ || ($ = T.default), $ || [];
  }
  toResolveHierarchy(T, F) {
    const $ = this.getFallbackCodes(F || this.options.fallbackLng || [], T), J = [], ee = (ne) => {
      !ne || (this.isSupportedCode(ne) ? J.push(ne) : this.logger.warn(`rejecting language code not found in supportedLngs: ${ne}`));
    };
    return typeof T == "string" && (T.indexOf("-") > -1 || T.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && ee(this.formatLanguageCode(T)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && ee(this.getScriptPartFromCode(T)), this.options.load !== "currentOnly" && ee(this.getLanguagePartFromCode(T))) : typeof T == "string" && ee(this.formatLanguageCode(T)), $.forEach((ne) => {
      J.indexOf(ne) < 0 && ee(this.formatLanguageCode(ne));
    }), J;
  }
}
let sets = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], _rulesPluralsTypes = {
  1: function(e) {
    return Number(e > 1);
  },
  2: function(e) {
    return Number(e != 1);
  },
  3: function(e) {
    return 0;
  },
  4: function(e) {
    return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
  },
  5: function(e) {
    return Number(e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5);
  },
  6: function(e) {
    return Number(e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2);
  },
  7: function(e) {
    return Number(e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
  },
  8: function(e) {
    return Number(e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3);
  },
  9: function(e) {
    return Number(e >= 2);
  },
  10: function(e) {
    return Number(e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
  },
  11: function(e) {
    return Number(e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3);
  },
  12: function(e) {
    return Number(e % 10 != 1 || e % 100 == 11);
  },
  13: function(e) {
    return Number(e !== 0);
  },
  14: function(e) {
    return Number(e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3);
  },
  15: function(e) {
    return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
  },
  16: function(e) {
    return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2);
  },
  17: function(e) {
    return Number(e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1);
  },
  18: function(e) {
    return Number(e == 0 ? 0 : e == 1 ? 1 : 2);
  },
  19: function(e) {
    return Number(e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3);
  },
  20: function(e) {
    return Number(e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2);
  },
  21: function(e) {
    return Number(e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0);
  },
  22: function(e) {
    return Number(e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3);
  }
};
const nonIntlVersions = ["v1", "v2", "v3"], intlVersions = ["v4"], suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  const e = {};
  return sets.forEach((T) => {
    T.lngs.forEach((F) => {
      e[F] = {
        numbers: T.nr,
        plurals: _rulesPluralsTypes[T.fc]
      };
    });
  }), e;
}
class PluralResolver {
  constructor(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = T, this.options = F, this.logger = baseLogger.create("pluralResolver"), (!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl == "undefined" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = createRules();
  }
  addRule(T, F) {
    this.rules[T] = F;
  }
  getRule(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(getCleanedCode(T === "dev" ? "en" : T), {
          type: F.ordinal ? "ordinal" : "cardinal"
        });
      } catch ($) {
        return;
      }
    return this.rules[T] || this.rules[this.languageUtils.getLanguagePartFromCode(T)];
  }
  needsPlural(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const $ = this.getRule(T, F);
    return this.shouldUseIntlApi() ? $ && $.resolvedOptions().pluralCategories.length > 1 : $ && $.numbers.length > 1;
  }
  getPluralFormsOfKey(T, F) {
    let $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(T, $).map((J) => `${F}${J}`);
  }
  getSuffixes(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const $ = this.getRule(T, F);
    return $ ? this.shouldUseIntlApi() ? $.resolvedOptions().pluralCategories.sort((J, ee) => suffixesOrder[J] - suffixesOrder[ee]).map((J) => `${this.options.prepend}${F.ordinal ? `ordinal${this.options.prepend}` : ""}${J}`) : $.numbers.map((J) => this.getSuffix(T, J, F)) : [];
  }
  getSuffix(T, F) {
    let $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const J = this.getRule(T, $);
    return J ? this.shouldUseIntlApi() ? `${this.options.prepend}${$.ordinal ? `ordinal${this.options.prepend}` : ""}${J.select(F)}` : this.getSuffixRetroCompatible(J, F) : (this.logger.warn(`no plural rule found for: ${T}`), "");
  }
  getSuffixRetroCompatible(T, F) {
    const $ = T.noAbs ? T.plurals(F) : T.plurals(Math.abs(F));
    let J = T.numbers[$];
    this.options.simplifyPluralSuffix && T.numbers.length === 2 && T.numbers[0] === 1 && (J === 2 ? J = "plural" : J === 1 && (J = ""));
    const ee = () => this.options.prepend && J.toString() ? this.options.prepend + J.toString() : J.toString();
    return this.options.compatibilityJSON === "v1" ? J === 1 ? "" : typeof J == "number" ? `_plural_${J.toString()}` : ee() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && T.numbers.length === 2 && T.numbers[0] === 1 ? ee() : this.options.prepend && $.toString() ? this.options.prepend + $.toString() : $.toString();
  }
  shouldUseIntlApi() {
    return !nonIntlVersions.includes(this.options.compatibilityJSON);
  }
}
function deepFindWithDefaults(e, T, F) {
  let $ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", J = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, ee = getPathWithDefaults(e, T, F);
  return !ee && J && typeof F == "string" && (ee = deepFind(e, F, $), ee === void 0 && (ee = deepFind(T, F, $))), ee;
}
class Interpolator {
  constructor() {
    let T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = baseLogger.create("interpolator"), this.options = T, this.format = T.interpolation && T.interpolation.format || ((F) => F), this.init(T);
  }
  init() {
    let T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    T.interpolation || (T.interpolation = {
      escapeValue: !0
    });
    const {
      escape: F,
      escapeValue: $,
      useRawValueToEscape: J,
      prefix: ee,
      prefixEscaped: ne,
      suffix: oe,
      suffixEscaped: se,
      formatSeparator: le,
      unescapeSuffix: de,
      unescapePrefix: ce,
      nestingPrefix: he,
      nestingPrefixEscaped: ve,
      nestingSuffix: ge,
      nestingSuffixEscaped: be,
      nestingOptionsSeparator: Te,
      maxReplaces: Se,
      alwaysFormat: Ie
    } = T.interpolation;
    this.escape = F !== void 0 ? F : escape$1, this.escapeValue = $ !== void 0 ? $ : !0, this.useRawValueToEscape = J !== void 0 ? J : !1, this.prefix = ee ? regexEscape(ee) : ne || "{{", this.suffix = oe ? regexEscape(oe) : se || "}}", this.formatSeparator = le || ",", this.unescapePrefix = de ? "" : ce || "-", this.unescapeSuffix = this.unescapePrefix ? "" : de || "", this.nestingPrefix = he ? regexEscape(he) : ve || regexEscape("$t("), this.nestingSuffix = ge ? regexEscape(ge) : be || regexEscape(")"), this.nestingOptionsSeparator = Te || ",", this.maxReplaces = Se || 1e3, this.alwaysFormat = Ie !== void 0 ? Ie : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const T = (F, $) => F && F.source === $ ? (F.lastIndex = 0, F) : new RegExp($, "g");
    this.regexp = T(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = T(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = T(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(T, F, $, J) {
    let ee, ne, oe;
    const se = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function le(ge) {
      return ge.replace(/\$/g, "$$$$");
    }
    const de = (ge) => {
      if (ge.indexOf(this.formatSeparator) < 0) {
        const Ie = deepFindWithDefaults(F, se, ge, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(Ie, void 0, $, Ke(Fe(Fe({}, J), F), {
          interpolationkey: ge
        })) : Ie;
      }
      const be = ge.split(this.formatSeparator), Te = be.shift().trim(), Se = be.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(F, se, Te, this.options.keySeparator, this.options.ignoreJSONStructure), Se, $, Ke(Fe(Fe({}, J), F), {
        interpolationkey: Te
      }));
    };
    this.resetRegExp();
    const ce = J && J.missingInterpolationHandler || this.options.missingInterpolationHandler, he = J && J.interpolation && J.interpolation.skipOnVariables !== void 0 ? J.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (ge) => le(ge)
    }, {
      regex: this.regexp,
      safeValue: (ge) => this.escapeValue ? le(this.escape(ge)) : le(ge)
    }].forEach((ge) => {
      for (oe = 0; ee = ge.regex.exec(T); ) {
        const be = ee[1].trim();
        if (ne = de(be), ne === void 0)
          if (typeof ce == "function") {
            const Se = ce(T, ee, J);
            ne = typeof Se == "string" ? Se : "";
          } else if (J && Object.prototype.hasOwnProperty.call(J, be))
            ne = "";
          else if (he) {
            ne = ee[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${be} for interpolating ${T}`), ne = "";
        else
          typeof ne != "string" && !this.useRawValueToEscape && (ne = makeString(ne));
        const Te = ge.safeValue(ne);
        if (T = T.replace(ee[0], Te), he ? (ge.regex.lastIndex += ne.length, ge.regex.lastIndex -= ee[0].length) : ge.regex.lastIndex = 0, oe++, oe >= this.maxReplaces)
          break;
      }
    }), T;
  }
  nest(T, F) {
    let $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, J, ee, ne;
    function oe(se, le) {
      const de = this.nestingOptionsSeparator;
      if (se.indexOf(de) < 0)
        return se;
      const ce = se.split(new RegExp(`${de}[ ]*{`));
      let he = `{${ce[1]}`;
      se = ce[0], he = this.interpolate(he, ne);
      const ve = he.match(/'/g), ge = he.match(/"/g);
      (ve && ve.length % 2 === 0 && !ge || ge.length % 2 !== 0) && (he = he.replace(/'/g, '"'));
      try {
        ne = JSON.parse(he), le && (ne = Fe(Fe({}, le), ne));
      } catch (be) {
        return this.logger.warn(`failed parsing options string in nesting for key ${se}`, be), `${se}${de}${he}`;
      }
      return ne.defaultValue && ne.defaultValue.indexOf(this.prefix) > -1 && delete ne.defaultValue, se;
    }
    for (; J = this.nestingRegexp.exec(T); ) {
      let se = [];
      ne = Fe({}, $), ne = ne.replace && typeof ne.replace != "string" ? ne.replace : ne, ne.applyPostProcessor = !1, delete ne.defaultValue;
      let le = !1;
      if (J[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(J[1])) {
        const de = J[1].split(this.formatSeparator).map((ce) => ce.trim());
        J[1] = de.shift(), se = de, le = !0;
      }
      if (ee = F(oe.call(this, J[1].trim(), ne), ne), ee && J[0] === T && typeof ee != "string")
        return ee;
      typeof ee != "string" && (ee = makeString(ee)), ee || (this.logger.warn(`missed to resolve ${J[1]} for nesting ${T}`), ee = ""), le && (ee = se.reduce((de, ce) => this.format(de, ce, $.lng, Ke(Fe({}, $), {
        interpolationkey: J[1].trim()
      })), ee.trim())), T = T.replace(J[0], ee), this.regexp.lastIndex = 0;
    }
    return T;
  }
}
function parseFormatStr(e) {
  let T = e.toLowerCase().trim();
  const F = {};
  if (e.indexOf("(") > -1) {
    const $ = e.split("(");
    T = $[0].toLowerCase().trim();
    const J = $[1].substring(0, $[1].length - 1);
    T === "currency" && J.indexOf(":") < 0 ? F.currency || (F.currency = J.trim()) : T === "relativetime" && J.indexOf(":") < 0 ? F.range || (F.range = J.trim()) : J.split(";").forEach((ne) => {
      if (ne) {
        const [oe, ...se] = ne.split(":"), le = se.join(":").trim().replace(/^'+|'+$/g, ""), de = oe.trim();
        F[de] || (F[de] = le), le === "false" && (F[de] = !1), le === "true" && (F[de] = !0), isNaN(le) || (F[de] = parseInt(le, 10));
      }
    });
  }
  return {
    formatName: T,
    formatOptions: F
  };
}
function createCachedFormatter(e) {
  const T = {};
  return function($, J, ee) {
    const ne = J + JSON.stringify(ee);
    let oe = T[ne];
    return oe || (oe = e(getCleanedCode(J), ee), T[ne] = oe), oe($);
  };
}
class Formatter {
  constructor() {
    let T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = baseLogger.create("formatter"), this.options = T, this.formats = {
      number: createCachedFormatter((F, $) => {
        const J = new Intl.NumberFormat(F, Fe({}, $));
        return (ee) => J.format(ee);
      }),
      currency: createCachedFormatter((F, $) => {
        const J = new Intl.NumberFormat(F, Ke(Fe({}, $), {
          style: "currency"
        }));
        return (ee) => J.format(ee);
      }),
      datetime: createCachedFormatter((F, $) => {
        const J = new Intl.DateTimeFormat(F, Fe({}, $));
        return (ee) => J.format(ee);
      }),
      relativetime: createCachedFormatter((F, $) => {
        const J = new Intl.RelativeTimeFormat(F, Fe({}, $));
        return (ee) => J.format(ee, $.range || "day");
      }),
      list: createCachedFormatter((F, $) => {
        const J = new Intl.ListFormat(F, Fe({}, $));
        return (ee) => J.format(ee);
      })
    }, this.init(T);
  }
  init(T) {
    const $ = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = $.formatSeparator ? $.formatSeparator : $.formatSeparator || ",";
  }
  add(T, F) {
    this.formats[T.toLowerCase().trim()] = F;
  }
  addCached(T, F) {
    this.formats[T.toLowerCase().trim()] = createCachedFormatter(F);
  }
  format(T, F, $) {
    let J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return F.split(this.formatSeparator).reduce((oe, se) => {
      const {
        formatName: le,
        formatOptions: de
      } = parseFormatStr(se);
      if (this.formats[le]) {
        let ce = oe;
        try {
          const he = J && J.formatParams && J.formatParams[J.interpolationkey] || {}, ve = he.locale || he.lng || J.locale || J.lng || $;
          ce = this.formats[le](oe, ve, Fe(Fe(Fe({}, de), J), he));
        } catch (he) {
          this.logger.warn(he);
        }
        return ce;
      } else
        this.logger.warn(`there was no format function for ${le}`);
      return oe;
    }, T);
  }
}
function removePending(e, T) {
  e.pending[T] !== void 0 && (delete e.pending[T], e.pendingCount--);
}
class Connector extends EventEmitter$1 {
  constructor(T, F, $) {
    let J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = T, this.store = F, this.services = $, this.languageUtils = $.languageUtils, this.options = J, this.logger = baseLogger.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = J.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = J.maxRetries >= 0 ? J.maxRetries : 5, this.retryTimeout = J.retryTimeout >= 1 ? J.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init($, J.backend, J);
  }
  queueLoad(T, F, $, J) {
    const ee = {}, ne = {}, oe = {}, se = {};
    return T.forEach((le) => {
      let de = !0;
      F.forEach((ce) => {
        const he = `${le}|${ce}`;
        !$.reload && this.store.hasResourceBundle(le, ce) ? this.state[he] = 2 : this.state[he] < 0 || (this.state[he] === 1 ? ne[he] === void 0 && (ne[he] = !0) : (this.state[he] = 1, de = !1, ne[he] === void 0 && (ne[he] = !0), ee[he] === void 0 && (ee[he] = !0), se[ce] === void 0 && (se[ce] = !0)));
      }), de || (oe[le] = !0);
    }), (Object.keys(ee).length || Object.keys(ne).length) && this.queue.push({
      pending: ne,
      pendingCount: Object.keys(ne).length,
      loaded: {},
      errors: [],
      callback: J
    }), {
      toLoad: Object.keys(ee),
      pending: Object.keys(ne),
      toLoadLanguages: Object.keys(oe),
      toLoadNamespaces: Object.keys(se)
    };
  }
  loaded(T, F, $) {
    const J = T.split("|"), ee = J[0], ne = J[1];
    F && this.emit("failedLoading", ee, ne, F), $ && this.store.addResourceBundle(ee, ne, $, void 0, void 0, {
      skipCopy: !0
    }), this.state[T] = F ? -1 : 2;
    const oe = {};
    this.queue.forEach((se) => {
      pushPath(se.loaded, [ee], ne), removePending(se, T), F && se.errors.push(F), se.pendingCount === 0 && !se.done && (Object.keys(se.loaded).forEach((le) => {
        oe[le] || (oe[le] = {});
        const de = se.loaded[le];
        de.length && de.forEach((ce) => {
          oe[le][ce] === void 0 && (oe[le][ce] = !0);
        });
      }), se.done = !0, se.errors.length ? se.callback(se.errors) : se.callback());
    }), this.emit("loaded", oe), this.queue = this.queue.filter((se) => !se.done);
  }
  read(T, F, $) {
    let J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, ee = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, ne = arguments.length > 5 ? arguments[5] : void 0;
    if (!T.length)
      return ne(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: T,
        ns: F,
        fcName: $,
        tried: J,
        wait: ee,
        callback: ne
      });
      return;
    }
    this.readingCalls++;
    const oe = (le, de) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const ce = this.waitingReads.shift();
        this.read(ce.lng, ce.ns, ce.fcName, ce.tried, ce.wait, ce.callback);
      }
      if (le && de && J < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, T, F, $, J + 1, ee * 2, ne);
        }, ee);
        return;
      }
      ne(le, de);
    }, se = this.backend[$].bind(this.backend);
    if (se.length === 2) {
      try {
        const le = se(T, F);
        le && typeof le.then == "function" ? le.then((de) => oe(null, de)).catch(oe) : oe(null, le);
      } catch (le) {
        oe(le);
      }
      return;
    }
    return se(T, F, oe);
  }
  prepareLoading(T, F) {
    let $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, J = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), J && J();
    typeof T == "string" && (T = this.languageUtils.toResolveHierarchy(T)), typeof F == "string" && (F = [F]);
    const ee = this.queueLoad(T, F, $, J);
    if (!ee.toLoad.length)
      return ee.pending.length || J(), null;
    ee.toLoad.forEach((ne) => {
      this.loadOne(ne);
    });
  }
  load(T, F, $) {
    this.prepareLoading(T, F, {}, $);
  }
  reload(T, F, $) {
    this.prepareLoading(T, F, {
      reload: !0
    }, $);
  }
  loadOne(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const $ = T.split("|"), J = $[0], ee = $[1];
    this.read(J, ee, "read", void 0, void 0, (ne, oe) => {
      ne && this.logger.warn(`${F}loading namespace ${ee} for language ${J} failed`, ne), !ne && oe && this.logger.log(`${F}loaded namespace ${ee} for language ${J}`, oe), this.loaded(T, ne, oe);
    });
  }
  saveMissing(T, F, $, J, ee) {
    let ne = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, oe = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(F)) {
      this.logger.warn(`did not save key "${$}" as the namespace "${F}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!($ == null || $ === "")) {
      if (this.backend && this.backend.create) {
        const se = Ke(Fe({}, ne), {
          isUpdate: ee
        }), le = this.backend.create.bind(this.backend);
        if (le.length < 6)
          try {
            let de;
            le.length === 5 ? de = le(T, F, $, J, se) : de = le(T, F, $, J), de && typeof de.then == "function" ? de.then((ce) => oe(null, ce)).catch(oe) : oe(null, de);
          } catch (de) {
            oe(de);
          }
        else
          le(T, F, $, J, oe, se);
      }
      !T || !T[0] || this.store.addResource(T[0], F, $, J);
    }
  }
}
function get$2() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(T) {
      let F = {};
      if (typeof T[1] == "object" && (F = T[1]), typeof T[1] == "string" && (F.defaultValue = T[1]), typeof T[2] == "string" && (F.tDescription = T[2]), typeof T[2] == "object" || typeof T[3] == "object") {
        const $ = T[3] || T[2];
        Object.keys($).forEach((J) => {
          F[J] = $[J];
        });
      }
      return F;
    },
    interpolation: {
      escapeValue: !0,
      format: (e) => e,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function transformOptions(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function noop() {
}
function bindMemberFunctions(e) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((F) => {
    typeof e[F] == "function" && (e[F] = e[F].bind(e));
  });
}
class I18n extends EventEmitter$1 {
  constructor() {
    let T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, F = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = transformOptions(T), this.services = {}, this.logger = baseLogger, this.modules = {
      external: []
    }, bindMemberFunctions(this), F && !this.isInitialized && !T.isClone) {
      if (!this.options.initImmediate)
        return this.init(T, F), this;
      setTimeout(() => {
        this.init(T, F);
      }, 0);
    }
  }
  init() {
    var T = this;
    let F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, $ = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof F == "function" && ($ = F, F = {}), !F.defaultNS && F.defaultNS !== !1 && F.ns && (typeof F.ns == "string" ? F.defaultNS = F.ns : F.ns.indexOf("translation") < 0 && (F.defaultNS = F.ns[0]));
    const J = get$2();
    this.options = Fe(Fe(Fe({}, J), this.options), transformOptions(F)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = Fe(Fe({}, J.interpolation), this.options.interpolation)), F.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = F.keySeparator), F.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = F.nsSeparator);
    function ee(de) {
      return de ? typeof de == "function" ? new de() : de : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? baseLogger.init(ee(this.modules.logger), this.options) : baseLogger.init(null, this.options);
      let de;
      this.modules.formatter ? de = this.modules.formatter : typeof Intl != "undefined" && (de = Formatter);
      const ce = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const he = this.services;
      he.logger = baseLogger, he.resourceStore = this.store, he.languageUtils = ce, he.pluralResolver = new PluralResolver(ce, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), de && (!this.options.interpolation.format || this.options.interpolation.format === J.interpolation.format) && (he.formatter = ee(de), he.formatter.init(he, this.options), this.options.interpolation.format = he.formatter.format.bind(he.formatter)), he.interpolator = new Interpolator(this.options), he.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, he.backendConnector = new Connector(ee(this.modules.backend), he.resourceStore, he, this.options), he.backendConnector.on("*", function(ve) {
        for (var ge = arguments.length, be = new Array(ge > 1 ? ge - 1 : 0), Te = 1; Te < ge; Te++)
          be[Te - 1] = arguments[Te];
        T.emit(ve, ...be);
      }), this.modules.languageDetector && (he.languageDetector = ee(this.modules.languageDetector), he.languageDetector.init && he.languageDetector.init(he, this.options.detection, this.options)), this.modules.i18nFormat && (he.i18nFormat = ee(this.modules.i18nFormat), he.i18nFormat.init && he.i18nFormat.init(this)), this.translator = new Translator(this.services, this.options), this.translator.on("*", function(ve) {
        for (var ge = arguments.length, be = new Array(ge > 1 ? ge - 1 : 0), Te = 1; Te < ge; Te++)
          be[Te - 1] = arguments[Te];
        T.emit(ve, ...be);
      }), this.modules.external.forEach((ve) => {
        ve.init && ve.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, $ || ($ = noop), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const de = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      de.length > 0 && de[0] !== "dev" && (this.options.lng = de[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((de) => {
      this[de] = function() {
        return T.store[de](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((de) => {
      this[de] = function() {
        return T.store[de](...arguments), T;
      };
    });
    const se = defer(), le = () => {
      const de = (ce, he) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), se.resolve(he), $(ce, he);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return de(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, de);
    };
    return this.options.resources || !this.options.initImmediate ? le() : setTimeout(le, 0), se;
  }
  loadResources(T) {
    let $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
    const J = typeof T == "string" ? T : this.language;
    if (typeof T == "function" && ($ = T), !this.options.resources || this.options.partialBundledLanguages) {
      if (J && J.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return $();
      const ee = [], ne = (oe) => {
        if (!oe || oe === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(oe).forEach((le) => {
          le !== "cimode" && ee.indexOf(le) < 0 && ee.push(le);
        });
      };
      J ? ne(J) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((se) => ne(se)), this.options.preload && this.options.preload.forEach((oe) => ne(oe)), this.services.backendConnector.load(ee, this.options.ns, (oe) => {
        !oe && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), $(oe);
      });
    } else
      $(null);
  }
  reloadResources(T, F, $) {
    const J = defer();
    return T || (T = this.languages), F || (F = this.options.ns), $ || ($ = noop), this.services.backendConnector.reload(T, F, (ee) => {
      J.resolve(), $(ee);
    }), J;
  }
  use(T) {
    if (!T)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!T.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return T.type === "backend" && (this.modules.backend = T), (T.type === "logger" || T.log && T.warn && T.error) && (this.modules.logger = T), T.type === "languageDetector" && (this.modules.languageDetector = T), T.type === "i18nFormat" && (this.modules.i18nFormat = T), T.type === "postProcessor" && postProcessor.addPostProcessor(T), T.type === "formatter" && (this.modules.formatter = T), T.type === "3rdParty" && this.modules.external.push(T), this;
  }
  setResolvedLanguage(T) {
    if (!(!T || !this.languages) && !(["cimode", "dev"].indexOf(T) > -1))
      for (let F = 0; F < this.languages.length; F++) {
        const $ = this.languages[F];
        if (!(["cimode", "dev"].indexOf($) > -1) && this.store.hasLanguageSomeTranslations($)) {
          this.resolvedLanguage = $;
          break;
        }
      }
  }
  changeLanguage(T, F) {
    var $ = this;
    this.isLanguageChangingTo = T;
    const J = defer();
    this.emit("languageChanging", T);
    const ee = (se) => {
      this.language = se, this.languages = this.services.languageUtils.toResolveHierarchy(se), this.resolvedLanguage = void 0, this.setResolvedLanguage(se);
    }, ne = (se, le) => {
      le ? (ee(le), this.translator.changeLanguage(le), this.isLanguageChangingTo = void 0, this.emit("languageChanged", le), this.logger.log("languageChanged", le)) : this.isLanguageChangingTo = void 0, J.resolve(function() {
        return $.t(...arguments);
      }), F && F(se, function() {
        return $.t(...arguments);
      });
    }, oe = (se) => {
      !T && !se && this.services.languageDetector && (se = []);
      const le = typeof se == "string" ? se : this.services.languageUtils.getBestMatchFromCodes(se);
      le && (this.language || ee(le), this.translator.language || this.translator.changeLanguage(le), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(le)), this.loadResources(le, (de) => {
        ne(de, le);
      });
    };
    return !T && this.services.languageDetector && !this.services.languageDetector.async ? oe(this.services.languageDetector.detect()) : !T && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(oe) : this.services.languageDetector.detect(oe) : oe(T), J;
  }
  getFixedT(T, F, $) {
    var J = this;
    const ee = function(ne, oe) {
      let se;
      if (typeof oe != "object") {
        for (var le = arguments.length, de = new Array(le > 2 ? le - 2 : 0), ce = 2; ce < le; ce++)
          de[ce - 2] = arguments[ce];
        se = J.options.overloadTranslationOptionHandler([ne, oe].concat(de));
      } else
        se = Fe({}, oe);
      se.lng = se.lng || ee.lng, se.lngs = se.lngs || ee.lngs, se.ns = se.ns || ee.ns, se.keyPrefix !== "" && (se.keyPrefix = se.keyPrefix || $ || ee.keyPrefix);
      const he = J.options.keySeparator || ".";
      let ve;
      return se.keyPrefix && Array.isArray(ne) ? ve = ne.map((ge) => `${se.keyPrefix}${he}${ge}`) : ve = se.keyPrefix ? `${se.keyPrefix}${he}${ne}` : ne, J.t(ve, se);
    };
    return typeof T == "string" ? ee.lng = T : ee.lngs = T, ee.ns = F, ee.keyPrefix = $, ee;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(T) {
    this.options.defaultNS = T;
  }
  hasLoadedNamespace(T) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const $ = F.lng || this.resolvedLanguage || this.languages[0], J = this.options ? this.options.fallbackLng : !1, ee = this.languages[this.languages.length - 1];
    if ($.toLowerCase() === "cimode")
      return !0;
    const ne = (oe, se) => {
      const le = this.services.backendConnector.state[`${oe}|${se}`];
      return le === -1 || le === 2;
    };
    if (F.precheck) {
      const oe = F.precheck(this, ne);
      if (oe !== void 0)
        return oe;
    }
    return !!(this.hasResourceBundle($, T) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || ne($, T) && (!J || ne(ee, T)));
  }
  loadNamespaces(T, F) {
    const $ = defer();
    return this.options.ns ? (typeof T == "string" && (T = [T]), T.forEach((J) => {
      this.options.ns.indexOf(J) < 0 && this.options.ns.push(J);
    }), this.loadResources((J) => {
      $.resolve(), F && F(J);
    }), $) : (F && F(), Promise.resolve());
  }
  loadLanguages(T, F) {
    const $ = defer();
    typeof T == "string" && (T = [T]);
    const J = this.options.preload || [], ee = T.filter((ne) => J.indexOf(ne) < 0 && this.services.languageUtils.isSupportedCode(ne));
    return ee.length ? (this.options.preload = J.concat(ee), this.loadResources((ne) => {
      $.resolve(), F && F(ne);
    }), $) : (F && F(), Promise.resolve());
  }
  dir(T) {
    if (T || (T = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !T)
      return "rtl";
    const F = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], $ = this.services && this.services.languageUtils || new LanguageUtil(get$2());
    return F.indexOf($.getLanguagePartFromCode(T)) > -1 || T.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, F = arguments.length > 1 ? arguments[1] : void 0;
    return new I18n(T, F);
  }
  cloneInstance() {
    let T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
    const $ = T.forkResourceStore;
    $ && delete T.forkResourceStore;
    const J = Ke(Fe(Fe({}, this.options), T), {
      isClone: !0
    }), ee = new I18n(J);
    return (T.debug !== void 0 || T.prefix !== void 0) && (ee.logger = ee.logger.clone(T)), ["store", "services", "language"].forEach((oe) => {
      ee[oe] = this[oe];
    }), ee.services = Fe({}, this.services), ee.services.utils = {
      hasLoadedNamespace: ee.hasLoadedNamespace.bind(ee)
    }, $ && (ee.store = new ResourceStore(this.store.data, J), ee.services.resourceStore = ee.store), ee.translator = new Translator(ee.services, J), ee.translator.on("*", function(oe) {
      for (var se = arguments.length, le = new Array(se > 1 ? se - 1 : 0), de = 1; de < se; de++)
        le[de - 1] = arguments[de];
      ee.emit(oe, ...le);
    }), ee.init(J, F), ee.translator.options = J, ee.translator.backendConnector.services.utils = {
      hasLoadedNamespace: ee.hasLoadedNamespace.bind(ee)
    }, ee;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;
const httpErrorCode$3 = {
  200: "SUCCESS",
  201: "The resource has been created",
  202: "The request has been received",
  300: "FAIL",
  401: "The login status is invalid, please log in again",
  403: "Unauthorized",
  500: "System exception",
  5002: "Parameter error",
  5003: "Internal call failed",
  5004: "Failed to create file",
  5005: "Failed to save file",
  5006: "Requests are frequent",
  5008: "Data error",
  5009: "Authentication failed, user type is incorrect",
  5010: "Duplicate request",
  5011: "Internal call failed",
  5012: "Request too frequent, please try again later",
  5013: "Failed to acquire lock",
  1e5: "Database exception",
  100001: "Existent",
  100005: "No data found",
  100006: "Service initialization",
  100007: "Service is blocked",
  100008: "Blocking exception",
  100009: "Dubbo communication exception",
  100010: "Illegal parameter exception",
  100011: "Illegal state exception",
  100012: "The request parameters are abnormal, please modify them and submit them again",
  100013: "The request parameters are abnormal, please modify them and submit them again",
  100014: "The request parameters are abnormal, please modify them and submit them again",
  100015: "Unable to generate distributed ID with invalid worker ID",
  100016: "Network error, please try again later",
  100017: "Network error, please try again later",
  100018: "One Server of the %s is initializing",
  100019: "Invalid request",
  100020: "The server is busy, please try again later",
  100021: "Access timeout",
  100022: "Database index conflict : %s",
  100023: "Requested parameter conversion error",
  100024: "Requested JSON parameter conversion error",
  100025: "Request Param: %s, Value: %s, Parameter type: %s, Value Type not match Parameter type",
  100026: "The Content type in the request header is not supported. Please check the Content type value in the header carefully",
  100027: "Return parameter serialization exception",
  100028: "The requested method is not supported",
  100029: "Request parameter conversion exception",
  100030: "The requested message body JSON deserialization exception",
  100031: "Input error of [ %s ] in request parameter",
  100040: "AccessToken does not exist",
  100041: "The login status is invalid, please log in again",
  100042: "Invalid Basic Authentication Token",
  100043: "Session timed out, please log in again",
  100044: "Illegal token, please compare the signature of the token carefully",
  100045: "Missing token parameter",
  100046: "Error parsing user identity, please log in again!",
  100047: "Tenant id is empty!",
  100048: "You do not have permission to enter",
  100049: "Logging in",
  100050: "Your account is already logged in on another device",
  100051: "This function cannot be used in the current version, please upgrade the product version first",
  100052: "MQ failed to send message",
  100053: "Failed to send email, please check email configuration",
  100054: "The message body of the request does not meet the requirements of the API",
  100055: "The request message body BODY is empty",
  100056: "[%s] input error in request parameter",
  100057: "Bad luck",
  100058: "MDF token expire",
  100059: "The internal encryption operation is abnormal",
  100060: "The internal decryption operation is abnormal",
  100061: "The internal processing key calculation is abnormal",
  100062: "%s is required",
  100063: "This language has not been configured. Please enable after configuration.",
  100064: "The current language type is not yet configured!",
  100065: "Only the Ultimate Edition can use this open capability!",
  100066: "Failed to modify data",
  100067: "Failed to delete data",
  100068: "Login configuration has expired, the status has been updated",
  100069: "Do not operate frequently",
  100070: "Please configure the WeChat official account information first",
  100071: "Not logged in yet, please log in first",
  100072: "Failed to add data",
  100073: "The validity period cannot exceed %s days",
  100074: "Do not repeat operations",
  100076: "Setting failed, incomplete enterprise WeCom authorization",
  100077: "WeCom interface request failed",
  100078: "WeCom error",
  100100: "Mobile number format is incorrect",
  100700: "Distributed ID initialization exception",
  100701: "Distributed ID generation failed",
  100702: "Invalid key, causing distributed ID generation to fail",
  100703: "Time rollback, causing distributed ID generation failure",
  100704: "Error distributed ID initialization",
  100800: "Document download exception",
  100900: "The SMS phone number parameter is abnormal",
  100901: "SMS template parameters are abnormal",
  100902: "Get SMS template code exception by class name",
  100903: "SMS Aliyun Service Response is Null Exception",
  100904: "System error, please try again later.",
  100905: "Please try again later",
  100906: "Thread pool execution task exception",
  100907: "Service is busy, please try again later",
  100908: "The number of text messages sent exceeds the limit, please try again later.",
  100909: "You have not registered yet, please register first",
  100910: "You are unable to participate in this event, please contact the organizer",
  100911: "Please get the permission first",
  100912: "You are unable to participate in this event, please contact the organizer",
  100913: "The parameter cannot be empty",
  100914: "You cannot participate in this event. If you have any questions, please contact the organizer",
  100971: "It contains illegal characters. Please check and try again",
  100972: "Seat already exists",
  100973: "Removal of seat failed, please try again later",
  100974: "Failed to add seat, please try again later",
  100975: "Registration failed",
  100976: "Login failed",
  100977: "Invoke the multi-cloud convergence exception",
  100978: "Exit failed to register",
  100979: "The interface has been limited",
  100980: "Please enter the request ID",
  100981: "Invalid password encryption request",
  100982: "Private key parsing exception",
  100983: "Please enter a password of length %s~%s bits",
  100984: "Please enter the correct format password",
  100985: "The maximum password length is %s",
  100986: "The RSA private key signature has failed",
  100987: "RSA public key verification failed",
  100988: "RSA public key encryption failed",
  100989: "The RSA private key decryption failed",
  100990: "RSA initialization key has error and algorithm exception",
  100991: "The RSA encryption is abnormal",
  100992: "Illegal invocation",
  100993: "The uploaded image format only supports %s. Please try again",
  100994: "The upload has failed, please try again",
  100995: "The uploaded image exceeds the limit, the maximum %s MB",
  100996: "Request Param is Empty",
  100997: "Data does not exist",
  100998: "The reported behavior type is not supported",
  100999: "Unknown error",
  101001: "Please enter username or password",
  101002: "Account does not exist",
  101003: "Wrong password",
  101004: "RefreshToken is invalid, unable to load user information",
  101005: "RefreshToken is empty",
  101006: "GrantType is not supported, please pass the correct grantType parameter",
  101007: "Account format error",
  101008: "The account has already been activated, please do not repeat the operation.",
  101009: "The link has expired, please contact the administrator for a new invitation link.",
  101010: "Invalid user",
  101011: "Failed to create user",
  101012: "Failed to modify user",
  101013: "Failed to delete user",
  101014: "Parameter error, modify user status failed",
  101015: "Cannot perform this operation on myself",
  101020: "User and enterprise binding failed",
  101021: "Old and new passwords cannot be the same",
  101022: "Please complete the man-machine verification first",
  101023: "CAPTCHA failed",
  101024: "Verification code error",
  101025: "Please enter the mobile number",
  101026: "The account does not exist, please enter the mobile number",
  101027: "Please enter the email",
  101028: "The account does not exist, please enter the\xA0 email",
  101029: "Mobile number format is incorrect",
  101030: "Failed to send email",
  101031: "User has no permission to log in",
  101032: "Enterprise is locked, no permission to log in",
  101033: "Mobile number already exists",
  101034: "Email already exists",
  101035: "The account/password is incorrect, please re-enter",
  101036: "Account has been locked, please try again in %s minutes",
  101037: "The account is locked, please contact the administrator to unlock it",
  101038: "The verification code has expired, please get the verification code again",
  101039: "Version is too low, please upgrade the version",
  101050: "Get data permission parameter exception",
  101051: "The code cannot exceed 6 times per hour",
  101052: "The code cannot exceed 20 times in 24 hours",
  101053: "Failed to get the organization tree, please confirm whether the parameters are correct",
  101054: "Failed to add administrator",
  101055: "Failed to remove admin",
  101056: "Failed to modify administrator role",
  101057: "User to add administrator cannot be empty",
  101058: "Failed to add collaboration account",
  101059: "Failed to remove collaboration account",
  101060: "Failed to modify collaboration account role",
  101061: "The collaboration account already exists, please confirm whether it is a duplicate",
  101062: "The number of admin users cannot exceed",
  101063: "Failed to replace enterprise administrator",
  101064: "Do not get the code repeatedly within one minute!",
  101065: "Failed to change password",
  101066: "Incorrect token parameter",
  101067: "Incorrect account format",
  101068: "Username does not match mobile phone/email, please check and try again",
  101069: "Only one operation is supported within 5 minutes, please do not operate frequently",
  101070: "Username does not support duplicates",
  101071: "Third-party IDs do not support duplicates",
  101072: "The account is not activated, please use it after activation",
  101073: "Username error, please check and try again",
  101074: "This user is not allowed to log in to the management platform",
  101075: "When you are independently activated by email, you need to set the mailbox",
  101076: "Please enter the effective date",
  101077: "Please enter the expiration date",
  101078: "Please enter a correctly formatting effective date",
  101079: "Please enter a correctly formatting expiration date",
  101080: "The effective date cannot be earlier than today",
  101081: "The expiration date cannot be earlier than the effective date",
  101082: "Please select the account type",
  101083: "You have not the permission to log in",
  101084: "You have not the permission to log in",
  101085: "Date parsing exception",
  101086: "Effective date cannot be modified",
  101087: "Expiration date cannot be earlier than today",
  101088: "Cannot distinguish whether it is a time-limited account",
  101089: "Time-limited account is not allowed to modify the account status",
  101090: "You have not the permission to log in",
  101091: "Failed to add seats",
  101092: "The effective date must not be later than today",
  101094: `User names do not support special characters such as ' " \\ / & > <`,
  103e3: "Invalid organization",
  103001: "Invalid parent organization",
  103002: "Root org already exists",
  103003: "Unable to delete root org",
  103004: "Unable to modify root org status",
  103005: "The same level department name cannot be repeated",
  103006: "The parent organization is not allowed to modify",
  103007: "The parent organization is disabled, please enable the parent organization first",
  103010: "Failed to create organization",
  103011: "Failed to modify organization",
  103012: "Failed to delete organization",
  103013: "The number of organization layers cannot exceed 7 layers",
  103014: "Organization child nodes cannot exceed 100",
  103015: "There are personnel or business data under this department and cannot be deleted",
  108e3: "Invalid retention information",
  108001: "Failed to update retention information",
  108002: "Invalid follow up information",
  108003: "Failed to create retention record",
  108004: "Failed to create follow up record",
  108005: "Email sending failed",
  108006: "Server is busy",
  108007: "Repeated sending verification code",
  108008: "Verification code error",
  108009: "Verification code has expired",
  109e3: "Invalid role",
  109001: "Failed to create role",
  109002: "Failed to modify role",
  109003: "Failed to delete role",
  109004: "There are employees associated with this role",
  109005: "Failed to create role permission association information",
  109006: "Failed to delete role permission association information",
  109007: "Role permissions cannot be empty",
  109008: "Role name cannot be repeated",
  110001: "Invalid permission",
  111e3: "Please enter username or password",
  111001: "Account does not exist",
  111002: "Account has been disabled",
  111003: "RefreshToken is invalid, unable to load user information",
  111004: "RefreshToken is empty",
  111005: "GrantType is not supported, please pass the correct grantType parameter",
  111006: "Invalid employee",
  111007: "Failed to create employee",
  111008: "Failed to modify employee",
  111009: "Failed to change employee password",
  111010: "Failed to delete employee role",
  111011: "Username/email/phone number already exists, duplication is not allowed",
  111012: "Failed to create employee role",
  111013: "Account/password error",
  111014: "Failed to update login ip and time",
  111015: "Failed to send email",
  111016: "If the password is wrong more than 3 times, it needs to be sent for man-machine verification",
  111017: "Invalid CAB parameter",
  111018: "CAPTCHA failed",
  111019: "Old and new passwords cannot be the same",
  111020: "Incorrect token",
  111021: "Wrong old password",
  111022: "Email has been sent, please try again in a minute",
  112e3: "Failed to modify tenant information",
  112001: "Invalid tenant",
  112002: "Incorrect parameter passed in",
  112003: "Invalid email configuration",
  112004: "Failed to send email",
  112005: "Invalid resource",
  112006: "Failed to create resource control",
  112007: "Invalid resource type",
  112008: "Disable reason cannot be empty",
  112009: "Client principal name cannot be empty",
  112010: "Customer star rating needs to be in 1-5",
  112011: "Client principal name already exists",
  112012: "The number of sub-tenants has reached the resource package capacity and cannot be created",
  112013: "Failed to create tenant information",
  112014: "Contact information cannot be empty",
  112015: "Do not repeat send emails within a minute",
  112016: "Failed to create portal",
  112017: "Invalid portal",
  112018: "Failed to modify portal",
  112019: "Failed to delete portal",
  112020: "Failed to create section",
  112021: "Failed to edit section",
  112022: "Failed to delete section",
  112023: "Invalid section",
  112024: "Top bar or bottom bar does not allow sorting",
  112025: "Top bar cannot be duplicated",
  112026: "Bottom bar cannot be duplicated",
  112027: "Failed to create image type data",
  112028: "Failed to modify carousel",
  112029: "Failed to delete carousel",
  112030: "Invalid carousel",
  112031: "Failed to create video list",
  112032: "Failed to modify video list",
  112033: "Failed to delete video list",
  112034: "Invalid video list",
  112035: "Failed to create video",
  112036: "Failed to edit video",
  112037: "Failed to delete video",
  112038: "Invalid video",
  112039: "Abnormal change of company name",
  112040: "Modify logo icon abnormality",
  112041: "Modify website icon exception",
  112042: "Modify the menu logo exception",
  112043: "Modify login settings exception",
  112044: "Modify the abnormal settings of the WeChat open platform",
  112045: "Modify the abnormal settings of WeChat public account",
  112046: "Modify the abnormal settings of WeChat payment",
  112047: "Modify third-party authorization exception",
  112048: "Modify email configuration exception",
  112049: "Invalid live scene",
  112050: "Get WeChat payment settings exception",
  112051: "Invalid user",
  112052: "Data does not exist",
  112053: "Data duplication",
  112054: "Invalid parameter",
  112055: "Customer ID already exists",
  112056: "Resource management and control live broadcast type parameter is abnormal",
  112057: "Invalid section type",
  112058: "The number cannot be less than 0 and the number cannot exceed the maximum limit of %s",
  112059: "Failed to create event list",
  112060: "Failed to modify activity list",
  112061: "Failed to delete active list",
  112062: "Invalid activity list",
  112063: "Failed to create partner group",
  112064: "Failed to modify partner grouping",
  112065: "Failed to delete partner group",
  112066: "Invalid partner grouping",
  112067: "Failed to create partner",
  112068: "Failed to modify partner",
  112069: "Failed to delete partner",
  112070: "Invalid partner",
  112071: "Section sort field exception",
  112072: "Duplicate portal name, please change and try again",
  112073: "Portal creation failed",
  112074: "Failed to modify partner",
  112075: "Portal deletion failed",
  112076: "Failed to create portal extension",
  112077: "Failed to create portal stats extension",
  112078: "Each portal must contain at least one section",
  112079: "There can only be one top bar section",
  112080: "There can only be five image ad sections",
  112081: "There can only be five category navigation panels",
  112082: "There can only be five graphic introduction sections",
  112083: "There can only be three video collection sections",
  112084: "There can only be three activity list sections",
  112085: "There can only be one partner section",
  112086: "There can only be one contact us section",
  112087: "There can only be one bottom bar section",
  112088: "The portal is already on the shelf, please take it off the shelf before deleting it",
  112090: "Failed to insert tenant configuration",
  112091: "Create up to 5 portals, please upgrade the version first",
  112092: "Create up to 20 portals",
  112093: "Media library resolution exceeds maximum limit",
  112094: "Customer ID cannot be empty",
  112095: "Modify password expiration setting exception",
  112096: "Failed to update tenant configuration",
  112097: "Basic version has insufficient permissions",
  112098: "Initializing the tenant configuration failed, please try again later",
  112201: "Failed to initialize tenant custom login page configuration, please try again later",
  112202: "Failed to update tenant custom login page configuration, please try again later112203",
  112203: "Tenant custom login page configuration does not exist",
  112204: "The service of Suihuan Space has not been opened yet, please contact customer service",
  112205: "The random space code does not exist",
  112206: "Please turn on/off the multi-login authentication switch",
  112207: "Enable at least one authentication method",
  112208: "The value range of the multi-login authentication switch is 0~1",
  112209: "The value range of multi-login authentication method is 0~1",
  112210: "Non-existent tenant configuration",
  113e3: "Failed to create collaborator",
  113001: "Failed to modify collaborator",
  113002: "Failed to delete collaborator",
  113003: "Invalid collaborator",
  113004: "The number of creations exceeds the upper limit",
  113005: "The event collaborator name already exists",
  114e3: "Invalid query",
  114001: "Failed to create notification sending record",
  114002: "Failed to modify notification sending record",
  114003: "Invalid SMS template",
  115e3: "Invalid product version",
  115001: "Failed to update product version",
  115002: "Failed to create product version",
  115003: "Invalid product version feature",
  115004: "Version status does not allow changes",
  115005: "Invalid resource pack",
  115006: "Failed to create plan",
  115007: "The resource package and version trial type in the package package are inconsistent with the package package!",
  115008: "The validity period of the resource package and version in the package package is inconsistent with the package package!",
  115009: "Update plan failed",
  115010: "Invalid plan",
  115011: "Package status cannot be changed",
  115012: "Invalid product version action record",
  115013: "Product version modification is not allowed",
  115014: "Trial version price needs to be 0",
  115015: "Resource pack ID already exists",
  115016: "Invalid resource",
  116001: "Invalid client version",
  116002: "Creating client version failed",
  116003: "Modifying client version failed",
  116004: "Deleting client version failed",
  116005: "Build number does not allow duplicates",
  117050: "Create room exception",
  117051: "Modify room exception",
  117052: "Delete room exception",
  117053: "Invalid room",
  117054: "The current live broadcast is live and does not support switching",
  117055: "The room is not live",
  117056: "The current live room is live, and deletion is not supported",
  117057: "Failed to modify live broadcast status",
  117058: "Does not match the current live broadcast method",
  117059: "Exception when calling Tencent Cloud to end recording",
  117060: "Mixed flow layout exception",
  117061: "Cloud live streaming mix layout is abnormal",
  117062: "The room is configured to not use the mic",
  117063: "The last live broadcast is counting the results, please start the broadcast later",
  117064: "Failed to modify live broadcast status",
  117065: "Does not match the current live broadcast method",
  117066: "Calling Tencent Cloud to end the recording exception",
  117067: "Mixed flow layout exception",
  117068: "Cloud live streaming mix layout is abnormal",
  117069: "The room is configured to not use the mic",
  117070: "The last live broadcast is counting the results, please start the broadcast later",
  117080: "Invalid stream",
  117081: "There is no live stream at the moment, please push the stream and then start the live broadcast",
  117120: "Invalid room configuration",
  117121: "Failed to create room configuration",
  117122: "Failed to modify room configuration",
  117160: "Invalid classification",
  117161: "Category name cannot be repeated",
  117162: "The number of classification layers exceeds the maximum limit",
  117163: "The number of primary categories exceeds the maximum limit",
  117164: "The number of sub-categories exceeds the maximum limit",
  117165: "Failed to modify whether the category has child nodes",
  117166: "Failed to modify classification",
  117167: "Failed to delete category",
  117168: "Already the first, can't move up any further",
  117169: "It's the last one, can't move down any further",
  117170: "Failed to move up category",
  117171: "Category down move failed",
  117172: "Failed to modify room label",
  117200: "The live stream is live",
  117201: "Pull stream live is not live",
  117202: "Failed to create live streaming",
  117203: "Failed to modify live streaming",
  117210: "Invalid list",
  117211: "Failed to create list",
  117212: "Failed to modify list",
  117213: "Failed to delete list",
  117214: "The list is live",
  117215: "List not live",
  117216: "No video in list",
  117217: "There is a list to set up scheduled live broadcast, please cancel the scheduled live broadcast first",
  117218: "The list is not set to live broadcast regularly",
  117219: "Failed to modify loop playback status",
  117220: "The scheduled live broadcast time should be greater than the current time",
  117221: "Scheduled live broadcast time has been modified",
  117222: "Scheduled live broadcast time has not been modified",
  117230: "Invalid program",
  117231: "Failed to create show",
  117232: "Video is live",
  117233: "Video is not live",
  117240: "Failed to create live broadcast task",
  117241: "The page has not been initialized, please try again later",
  117242: "Failed to start live",
  117243: "There are no available live streams, Please check them before using",
  117272: "Invalid live stream information",
  117273: "Invalid session",
  117274: "Failed to create session",
  117275: "Failed to modify the session",
  117300: "Invalid session",
  117301: "Failed to create session",
  117302: "Failed to modify the session",
  117303: "Calling Tencent Cloud to close the whiteboard push stream interface is abnormal",
  117304: "Modify whiteboard task exception",
  117305: "No room information",
  117306: "Whiteboard streaming is not enabled in the current room",
  117307: "The current room has enabled whiteboard streaming",
  117308: "Invalid room data",
  117309: "No stream found for current room",
  117310: "Invalid document or path",
  117311: "Document upload failed",
  117312: "The length of the uploaded document exceeds the limit",
  117313: "Incorrect upload format",
  117314: "Document record modification failed",
  117315: "Create documentation exceptions",
  117316: "Invalid documentation",
  117317: "The current state cannot be deleted",
  117318: "Delete Documentation Exception",
  117319: "Only one document can be used at a time",
  117320: "Retranscoding exception",
  117321: "The current document has not been transcoded successfully",
  117322: "Get network resource exception",
  117323: "Create transcoding task exception",
  117324: "The chat check function is enabled depends on the chat function being enabled",
  117325: "The opening of the bullet screen review function depends on the opening of the bullet screen function",
  117326: "Watch page is not allowed to show live footage",
  117327: "The current room is already the main venue",
  117328: "The main site does not support deletion",
  117329: "Room like data is abnormal",
  117330: "There is no main venue, please create the main venue first",
  117331: "The room does not exist, please contact the organizer",
  117332: "Live scenes cannot be modified",
  117333: "Live delay cannot be changed",
  117334: "Room mode error",
  117335: "Error creating callback template",
  117336: "Modify callback template error",
  117340: "Invalid Text Live",
  117341: "Exception in creating live video",
  117342: "Exceptions in editing Text Live",
  117343: "Exception in deleting live video",
  117344: "The live broadcast of images and texts has been started, so it is unnecessary to start it again",
  117345: "The live telecast has been closed, so it is unnecessary to close it repeatedly",
  117346: "The value range of liveDelay is 1-2",
  117347: "Live broadcast start time is earlier than current time",
  117348: "End time cannot be earlier than start time",
  117349: "Wrong start time or end time format",
  117350: "Check-in has been enabled",
  117351: "Check-in has been closed",
  117352: "Failed to enable check-in.",
  117353: "Failed to close check-in.",
  117354: "Topic has been enabled.",
  117355: "Topic has been closed.",
  117356: "Failed to enable topic.",
  117357: "Failed to close topic.",
  117358: "Enable Tencent Cloud bypass push-stream failed",
  117359: "Close Tencent Cloud bypass push-stream failed",
  117360: "Invalid bypass push-stream task",
  117361: "Update Tencent Cloud bypass push-stream failed",
  117362: "The live broadcast is going on. Please try again later",
  117363: "The current live broadcast is in preparation, and switching is not supported",
  117364: "Unable to create a 0 delay live room",
  117996: "Alibaba Cloud document upload: abnormal file size",
  117997: "Generate ID less than 0",
  117998: "No",
  118001: "Create flow monitoring data exception",
  118002: "Modify room exception",
  118003: "Delete room exception",
  120001: "Invalid room",
  120002: "Create multiple list exceptions",
  120003: "Invalid pull stream list",
  120004: "Modify pull list exception",
  120005: "The current room live broadcast method is abnormal",
  120006: "Room status, scene verification failed",
  120007: "The current room state cannot cancel the timer",
  120008: "There is a timed list in the current room",
  120009: "Repeat turn on timer",
  120010: "Create pull task exception",
  120011: "Modify the exception of the pull stream task",
  120012: "Delete pull task exception",
  120013: "Mobile ID is empty",
  120014: "Front ID is empty",
  120015: "List task sorting exception",
  120016: "Streaming live streaming does not support batch addition",
  120017: "Bulk addition exceeds the maximum limit",
  120018: "No streaming tasks available",
  120019: "The current room status cannot start live streaming",
  120020: "The current room live broadcast scene is incorrect",
  120021: "Abnormal start of streaming live",
  120022: "Getting the Tencent Cloud Pull Streaming Task List Is Abnormal",
  120023: "The current room status cannot end the live broadcast",
  120024: "End streaming live exception",
  120025: "Query media library exception",
  120026: "Media library resolution exceeds maximum limit",
  120027: "The pull source is invalid",
  120028: "The pull source is invalid",
  120029: "Handle the exception that the disconnection callback is not received",
  120030: "Invalid pull stream address",
  120031: "Invalid timing",
  120032: "Exceeding the maximum playback time limit is limited to 7 days",
  120033: "Start/end time exception",
  120034: "The start time should be earlier than the end time",
  120035: "The Tencent Cloud callback task id does not match the current task id",
  120036: "Invalid room type",
  120037: "Abnormal playback time",
  120038: "Submit media library file duplicate",
  120039: "There are videos in the video list that are currently being checked.",
  120040: "There are videos in the video list that have failed the check.",
  120041: "The end time must be more than 10 minutes later than the start time",
  120042: "The pull flow task does not exist",
  120043: "Processing the list live callback, failed to modify the data",
  120044: "Add video exception, video duration exception",
  120045: "The current broadcast mode is not correct",
  121e3: "Invalid file type",
  121001: "The default thesaurus data is empty",
  121002: "Failed to modify default thesaurus",
  121003: "Self-built sensitive word repetition",
  121004: "Failed to create sensitive words",
  121005: "Failed to delete sensitive words",
  121006: "Failed to modify sensitive words",
  121007: "Invalid sensitive word",
  121008: "Unable to delete non-self-created sensitive word types",
  121009: "File size exceeds limit",
  121010: "File data exceeds 5000",
  121011: "File parsing failed",
  121012: "The total number of self-created sensitive words exceeds the limit",
  121013: "Invalid tenant",
  121014: "Tenant parameter is missing",
  121015: "The child thread failed to create a tenant enterprise sensitive word",
  121016: "Failed to create default sensitive word in child thread",
  121017: "There is inappropriate content. Please modify it and try again",
  121018: "There is inappropriate content. Please modify it and try again",
  121019: "There is inappropriate content",
  122001: "Invalid person information",
  122002: "Failed to create participant",
  122003: "Failed to modify participant",
  122004: "Failed to remove participant",
  122005: "The mobile number has not been registered, please go to register",
  122006: "You have been banned from this campaign",
  122007: "This phone number has already been registered, please do not register again",
  122008: "Fill in at least one of mobile phone and email",
  122009: "Please select a ticket",
  122010: "The person already exists",
  122011: "Not registered for this event",
  122012: "Failed to delete guest",
  122013: "Please do not register again",
  122014: "If the quantity exceeds 500, please upload in batches",
  122015: "The document does not conform to the import specification, please operate according to the EXCEL document template specification",
  122016: "Abnormal audience review status",
  122017: "Sign up and log in and External authorized viewers do not support deletion",
  123001: "Invalid room authorization configuration",
  123002: "Failed to modify the room authorization configuration",
  123003: "Failed to empty the phone whitelist",
  123004: "Duplicate usernames in the list.",
  123005: "Pull the whitelist excel failed",
  123006: "The user name cannot be empty",
  123007: "TenantId Parameter is missing",
  123008: "RoomId Parameter is missing",
  123009: "0 delay or global acceleration room cannot open multiple lines",
  124001: "Invalid mic configuration",
  124002: "Failed to create connected microphone configuration",
  124003: "Failed to generate live chat configuration ID",
  124004: "Video Call is turned off and operation is not allowed",
  124005: "The guest's microphone connection switch has been turned off, and operation is not allowed",
  124006: "The guest connection mode has been set to the application mode",
  124007: "The audience's application for connecting to the microphone has been turned off, and the operation is not allowed",
  124008: "Assistant can't connect to the microphone",
  124009: "Failed to modify parameter configuration",
  124010: "Only the host or presenter can operate the shared screen",
  124011: "Do not repeat the action to share the screen",
  124012: "User output status is already cancel output or output",
  124013: "Failed to create live chat user",
  124014: "Failed to modify live chat user",
  124015: "User is already the presenter",
  124016: "The operator is not the moderator",
  124017: "The original speaker does not exist",
  124018: "The user is already connected to the microphone",
  124019: "Cannot set audience as presenter",
  124020: "The user is already connected to the microphone",
  124021: "Failed to generate live chat configuration ID",
  124022: "Only the host or presenter can operate the shared screen",
  124023: "Do not repeat the action to share the screen",
  124030: "Failed to create live chat operation record",
  124031: "Failed to create muxed record",
  124032: "Invalid event recording",
  124033: "Failed to create event recording",
  124034: "Failed to modify event recording",
  124035: "The parameter for querying the data of a certain day is empty",
  124040: "The automatic recording switch cannot be modified during live broadcast",
  124041: "Failed to modify automatic recording",
  124050: "Invalid connection request record",
  124051: "Failed to create live chat request record",
  124052: "Failed to modify live chat request record",
  124053: "The host is not connected",
  124054: "Live chat request has been processed",
  124055: "The user is inconsistent with the live chat request user",
  124056: "Live chat room is full",
  124057: "The continuous microphone mode has been set to the application mode",
  124058: "linkRequestId is required",
  124059: "Live chat request denied",
  124060: "There is currently a live chat user, failed to disable",
  124061: "There is currently a live chat application or invitation, failed to disable",
  124062: "User does not exist",
  124065: "The type is inconsistent with the live chat request type",
  124067: "Only guests and named audience members can apply via Mic",
  124068: "The application for connecting the microphone has been initiated or the microphone has been connected",
  124069: "There is a request to connect to the microphone or the microphone has been connected",
  124070: "Guest is not online",
  124071: "Only guests can be invited to live chat",
  124072: "The current number of people is full, please try again later",
  124073: "Live chat application timed out, please apply again",
  124074: "The live chat request failed",
  124075: "Do not apply for live chat frequently",
  124076: "Streaming failed, Tencent cloud room does not exist",
  124077: "Muxing failed",
  124078: "Only the host can mute all",
  124079: "Live chat request message type is not set",
  124080: "The mic status is not set",
  124081: "Failed to create live chat output record",
  124082: "Failed to modify the live chat output record",
  124083: "Only the speaker can set the layout",
  124084: "Invalid live chat operation record",
  124085: "Failed to create live chat operation record",
  124086: "Failed to modify live chating operation record",
  124087: "Do not operate the user frequently",
  124088: "This operation has expired",
  124089: "Users are inconsistent with live chat request users",
  124090: "Sharing screen failure",
  124091: "The current Mai has been hung up",
  124092: "Live chat is in process, failed to switch HD live chat mode",
  124093: "The user is in Lian Mai, please try again later",
  124094: "The operation failed, please first follow the wheat and then operate",
  124095: "In the last operation, please try again later",
  124096: "Do not repeat the operation",
  124097: "Only the people can operate",
  124098: "Documents, whiteboards, shared screens are not opened, and can not be switched by screen",
  124099: "Operator non -team leader",
  124100: "Only the team leader can be mute",
  124101: "Live Chat has been closed",
  125001: "Query order data parameter is empty",
  125002: "Wrong payment type",
  125003: "Invalid payment parameters",
  125004: "Default implementation cannot pay",
  125005: "Invalid refund parameter",
  125006: "Invalid payment record",
  125007: "Callback exception",
  125008: "Calling the WeChat order interface is abnormal",
  125009: "Calling the WeChat refund interface is abnormal",
  125010: "Invalid payment record",
  125011: "Abnormal payment",
  125012: "Wrong payment method",
  125013: "WeChat callback type is unknown",
  125014: "WeChat callback data decryption exception",
  125015: "Repeat payment for an order",
  125016: "Close WeChat order exception",
  125017: "Abnormal order status",
  125018: "WeChat payment record status is abnormal",
  125019: "Cancel payment exception",
  125020: "The current order is in the refund process",
  125021: "Order not paid",
  125022: "Refund amount exceeds payment amount",
  125023: "The specified refund time has not been reached",
  125024: "Failed to request WeChat refund",
  125025: "Invalid business type",
  125100: "Add order record exception",
  125101: "Modify order record exception",
  125102: "Invalid order record",
  125110: "Add abnormal payment record",
  125111: "Modify payment record exception",
  125112: "Invalid payment record",
  125120: "Add an exception to the refund record",
  125121: "Modify the exception of the refund record",
  125122: "Invalid refund record",
  125130: "Added WeChat account reconciliation record exception",
  125131: "Modify WeChat account reconciliation record exception",
  125132: "Invalid WeChat reconciliation record",
  125133: "Invalid refund record",
  125134: "Calling the WeChat interface is abnormal",
  125135: "JsApi get signature exception",
  125136: "Order has already paid",
  126001: "Parameter information is missing",
  126002: "Failed to create session statistics",
  126003: "Failed to modify session name data",
  126004: "Invalid session data",
  126005: "Missing query parameter",
  126006: "Failed to count watch time data",
  126007: "Failed to count viewers",
  126008: "Failed to count viewing area data",
  126020: "Get live stream exception",
  126021: "Get on-demand streaming exception",
  126022: "Add room statistics",
  126023: "Add room area statistics",
  126024: "Getting room stats takes too long",
  126025: "The child thread execution task timed out",
  126026: "Child thread execution exception",
  126027: "Failed to add activity statistics record",
  126028: "Failed to modify activity statistics record",
  126029: "Failed to add active area record",
  126030: "Failed to modify active area record",
  126031: "Do not use two dimension queries at the same time",
  126032: "Invalid likes record",
  126033: "Save room trend data exceptions",
  126034: "Save channel trend data exception",
  126035: "The parameters of the lottery statistics list are abnormal",
  126036: "No data for this user exists",
  126037: "User rank type does not exist",
  126038: "Please select to view channel data or venue data",
  126039: "Added reward statistics exception",
  126040: "Delete tip statistics exception",
  126041: "Failed to create registration area statistics",
  126042: "Failed to modify registration area statistics",
  126043: "Failed to create the number of registrations by day",
  126044: "Failed to modify the number of registrations by day",
  127001: "Questionnaire name does not support repetition",
  127002: "The number of questionnaire options ranges from 2 to 50",
  127003: "Questionnaire exceeds the maximum number of questions of the same type",
  127004: "Nonexistent questionnaire",
  127005: "Failed to delete questionnaire",
  127006: "Failed to update questionnaire status",
  127007: "There is no active questionnaire in the current live room",
  127008: "Required question not answered",
  127009: "The user has filled out the questionnaire",
  127010: "The current questionnaire has ended and cannot be submitted",
  127011: "There is currently a questionnaire in use, please stop using the questionnaire first",
  127012: "The current questionnaire is in use, please stop using it first",
  127013: "Multiple-answer questions are not allowed in multiple-choice questions",
  127014: "Do not create empty questionnaires",
  127015: "The user needs to agree to the data agreement before submitting the answer",
  127016: "Questionnaire question title exceeds the maximum character limit",
  127017: "Questionnaire option content exceeds the maximum word limit",
  127018: "Questionnaire answer content exceeds the maximum word limit",
  127019: "Only 11 digits are allowed for the mobile phone number of the questionnaire",
  127020: "Questionnaire response email number format is incorrect",
  127021: "This phone number has already been registered, please do not register again",
  127022: "Please configure WeChat payment merchants first, otherwise the charging function cannot be enabled",
  127023: "The charging price range is 0.01~999999.99",
  127024: "Questionnaire questions cannot be empty",
  127025: "Support up to 50 questions",
  127026: "The questionnaire is already in this state, please do not repeat the operation",
  127027: "Questionnaire title cannot be empty",
  127028: "Multiple choice option cannot be empty",
  127029: "Failed to update questionnaire",
  127030: "Failed to delete questionnaire",
  127031: "Verification code must be filled",
  127032: "Verification code error",
  127033: "Tenant id cannot be empty",
  127034: "Activity id cannot be empty",
  127035: "Required question not filled",
  127036: "Existing participant registration, the form no longer supports modification",
  127037: "Illegal value for question type",
  127038: "Please select a ticket",
  127039: "You have already participated in the activity, no need to register again",
  127040: "Please keep at least one way of mobile phone number or email",
  127041: "Registration form id cannot be empty",
  127042: "Questionnaire question does not exist",
  127043: "Multiple choice option content cannot be empty",
  127044: "Questionnaire name is required",
  127045: "The value range of questionScore is 1-100",
  127046: "The organizer is confirming your registration, please do not register again",
  127047: "The organizer is confirming your registration, please wait patiently",
  127048: "Your registration has not been confirmed, please wait patiently",
  127049: "Your registration has not been confirmed, please do not register again",
  127050: "The number of questions or options should be the same as the Chinese configuration.",
  128001: "The current state prohibits switching the live room mode",
  128002: "It is forbidden to switch the live room mode repeatedly",
  128003: "Non-existent screen",
  128004: "Failed to update non-home screen settings",
  128005: "Failed to update home screen settings",
  128006: "Invalid room",
  128007: "The original main screen id parameter is missing",
  128008: "No picture selected as main picture",
  128009: "The current screen is already the main screen",
  128010: "Failed to call prohibit push stream",
  128011: "Failed to call resume push stream",
  128012: "Failed to call the streaming list",
  128013: "The current live room is in live broadcast and does not support adding pictures",
  128014: "Insufficient resources for live streaming",
  128015: "The current mode does not support adding pictures",
  128016: "Screen name does not support duplication",
  128017: "The current live broadcast room is live, and it does not support deleting the screen",
  128018: "Prohibit deletion of home screen",
  128019: "There can only be a maximum of 8 screens",
  128020: "Tenants lack live streaming resources",
  128021: "Failed to delete screen",
  128022: "Getting online stream list error",
  128023: "The push live broadcast timing compensation failed to enable the live broadcast state",
  128024: "The push live broadcast timing compensation stopped live broadcast status failed",
  128025: "Failed to add screen",
  128026: "Failed to delete screen",
  128027: "There are no available push domains in the domain group.",
  128028: "There are no available pull domains in the domain group.",
  128029: "Presence of streams in push streams that are prohibited from ending live streams",
  129001: "Invalid event",
  129002: "Failed to create the event, please try again later.",
  129003: "Create event failed",
  129004: "Modification event failed",
  129005: "The event is over",
  129006: "Publication cancelled, please do not repeat the operation.",
  129007: "Published, please do not repeat the operation.",
  129008: "The current event end time has passed, please modify the event time before publishing",
  129009: "Failed to set the publishing status",
  129010: "The room was not created by the event.",
  129011: "Invalid event schedule",
  129012: "Failed to create event schedule",
  129013: "Failed to modify the event schedule",
  129014: "Failed to delete the event schedule",
  129015: "The current room has already been associated with another scheduled event time. Please adjust promptly.",
  129016: "Failed to create the event langding page.",
  129017: "Failed to modify the event langding page.",
  129018: "The name of the guest cannot be empty",
  129019: "Event cannot be published at the moment. Please create a registration form first and publish later.",
  129020: "No registration, the event can not be published",
  129021: "Registration has been stopped",
  129022: "Meeting start time format is abnormal",
  129023: "Meeting end time format is abnormal",
  129024: "Meeting start or end time is empty",
  129025: "Failed to delete the event.",
  129026: "The event has been deleted.",
  129027: "The event mode does not match the room mode.",
  129028: "Non-existent event.",
  129031: "Invalid event tickets.",
  129032: "Create event ticket failed",
  129033: "Ticket number is not allowed",
  129034: "Only unpublish tickets can be edited.",
  129035: "Unpublished tickets can only be modified to published status.",
  129036: "Published tickets can only be modified to unpublished status.",
  129037: "Unpublished tickets can only be modified to published status.",
  129038: "Failed to modify the event ticket shelf status",
  129039: "Ticket quantity cannot be less than the number of tickets already sold.",
  129040: "There are unpublished tickets, please refresh the page and choose tickets again.",
  129041: "Failed to modify the import quantity",
  129042: "Ticket function is not available because the event has not enabled it yet.",
  129043: "Modify the event ticket failed",
  129050: "Ticket function is available for this event, please choose a ticket.",
  129051: "You can only choose up to 10 tickets.",
  129052: "Ticket association for registration form failed.",
  129053: "Tickets are already off the shelves",
  129054: "Tickets are sold out, please re-select the tickets",
  129055: "Tickets are not in the ticket status, please select the ticket again",
  129056: "Creating a user ticket association has failed",
  129057: "Failed to modify the user ticket association to delete the mark",
  129058: "Invalid user ticket association",
  129059: "WeChat payment has not been configured, and the charging ticket function cannot be used",
  129060: "Schedule guests do not exist",
  129061: "The user's ticket payment status is incorrect",
  129062: "Failed to modify the user's ticket payment status",
  129063: "Ticket name is not allowed, please confirm",
  129064: "Tickets that have been on the shelves and off the shelves can only be modified: ticket name, ticket description, ticket quantity, ticket time",
  129065: "No tickets on the shelves, no event can be released",
  129070: "Create schedule evaluation failed",
  129071: "The evaluation function is not turned on",
  129072: "Please review it after the schedule begins",
  129073: "Support the evaluation only once",
  129080: "Failed to modify the sharing settings",
  129081: "Modifying the activity decoration serial number failed",
  129082: "Activity decoration serial number is repeated",
  129083: "A single activity limit creates up to 20 entry forms",
  129084: "The Activity has been set up and the enrollment form cannot be created",
  129085: "Access to promotion channels is empty",
  129086: "New promotion channels have failed",
  129087: "Add up to 20 channels",
  129088: "Same name of the promotion channel",
  129089: "Promotion channel number is the same",
  129090: "Access promotion channel statistics are empty",
  129091: "New promotion channel statistics failed",
  129092: "Someone has already signed up and cannot be edited",
  129093: "Failed to modify the channel enabled status",
  129094: "The place inquiry is not opened, please open it first",
  129095: "Without configured activity decoration, please configure first",
  129096: "Promotion channel editing failed",
  129097: "Date query is not opened, please open it first",
  129100: "Faof create to failed",
  129101: "Modifying activity access failed",
  129102: "Invalid access to activities",
  129103: "Please configure the registration form first",
  129104: "The Open platform is not enabled",
  129105: "Create guest exception",
  129106: "Modify guest abnormalities",
  129107: "Invalid guest",
  129108: "Invalid guest",
  129109: "Modification of nicknames is not allowed",
  129110: "Failed to update the promotion channel statistics",
  129120: "Invalid notification type",
  129121: "WeChat notification template is not configured",
  129122: "The live schedule has at most %s guests",
  129123: "Mobile phone number or email is required",
  129124: "This interface does not currently support registration or whitelist access configuration",
  129125: "Failed to create user ticket order",
  129126: "Failed to update order status",
  129127: "Removal status cannot be empty",
  129128: "The mobile phone number format is incorrect: %s",
  129129: "Start time should be before end time",
  129130: "The minimum activity time is %s hours",
  129131: "The maximum activity time is %s days",
  129132: "Import data cannot be empty",
  129133: "Guests are not allowed to add repeatedly",
  129134: "The notification time cannot be the historical time",
  129135: "WeChat official account has not been configured, and WeChat subscription notification cannot be opened",
  129136: "The resources for creating seminars are insufficient. The event cannot be restored.",
  129137: "The event notification configuration already exists",
  129138: "Please select at least one notification method",
  129139: "You have subscribed",
  129140: "Event subscription time has ended",
  129141: "Message content exceeds the limit length",
  129142: "The email content cannot be empty",
  129143: "The subscribe success notification content cannot be empty",
  129144: "The activity subscription function has been turned off",
  129145: "Enable at least one active language",
  129151: "Enable at least one active language",
  130001: "Customer disabled status does not allow purchases",
  130002: "Product is not available",
  130003: "Failed to create order",
  130004: "Create order approval process failed",
  130005: "Failed to create order payment process",
  130006: "Failed to modify order",
  130007: "Invalid order",
  130008: "The current approval status of the order is incorrect and the status cannot be modified",
  130009: "Reasons are required for refusal",
  130010: "Effective time is required for timing to take effect",
  130011: "Failed to create reversal order",
  130012: "Failed to modify reversal order status",
  130013: "Invalid reverse order",
  130014: "Reversible quantity error",
  130015: "The product has expired and cannot be reversed",
  130016: "Order not paid, no reversal allowed",
  130017: "Failed to create customer information",
  130018: "Order effective time update failed",
  130019: "Product packages and versions can only be purchased 1 piece",
  130020: "The offset amount cannot be greater than the actual payment amount",
  130021: "The reversal quantity cannot be greater than the reversible quantity",
  130022: "The order has been reversed and cannot be reversed again",
  130023: "Only one version can be purchased in the same order",
  130024: "The write-off amount should be less than the actual payment amount",
  131001: 'The red packet password you sent contains sensitive words "%s"',
  131002: "Only named users are allowed to grab red packets",
  131003: "There are a lot of people grabbing red envelopes, please try again later",
  131004: "Illegal request",
  131005: "Invalid red envelope",
  131006: "Pre-issued red envelope error",
  131007: "Password incorrect",
  131008: "The red envelope has expired",
  131009: "Red packets have been disabled",
  131010: "You have already claimed the red envelope, please do not claim it again.",
  131011: "Illegal red envelope parameters",
  131012: "The interval between sending red packets should not be less than 1 minute, please try again later",
  131013: "Please configure WeChat official account and merchant information first",
  131014: "No permission to operate the red envelope record",
  131015: "The audience has not authorized WeChat",
  131016: "Red envelopes that do not exist",
  131017: "This status red envelope does not support modification",
  131018: "The amount of a single red envelope must be between 0.3 and 200 yuan",
  131019: "This status red envelope does not support publishing",
  131020: "Non-existent red envelope claim record",
  131021: "System exception",
  131022: "Red envelopes are sold out",
  131023: "Pre-issued red envelope stuffed with wrong return",
  131024: "Error processing user's claim record",
  131025: "Message sending exception",
  131026: "Please open it in Wechat",
  132001: "Invalid meeting room",
  132002: "Invalid meeting",
  132003: "Invalid host authentication password",
  132004: "The correct host authentication password",
  132005: "Invalid Meeting ID",
  132006: "Reservation failed",
  132007: "Tencent conference creation failure",
  132008: "Tencent meeting modification failed",
  132009: "Tencent meeting cancellation failure",
  132010: "Conference room parameters are abnormal",
  132011: "Conference room cancellation failed",
  132012: "Conference room initialization failed",
  132013: "User flow water acquisition is abnormal",
  132014: "The meeting room reservation date does not match the meeting date",
  132015: "Invalid meeting time",
  132016: "The guest's mobile phone number is empty or misformed",
  132017: "Please cancel 24 hours before the conference room begins",
  132018: "Deleting users from the Tencent Conference SSO platform failed",
  132019: "Deleting users on Tencent's conference platform failed",
  132020: "The resource pack corresponding to the conference room is expired and cannot be deleted",
  132021: "The conference room already has other meetings during this time period",
  132022: "The number of meeting rooms that can be booked during this period is 0, please contact the customer service for processing",
  132023: "The conference room will be created within 30 days",
  132024: "The meeting has been started and no modification is allowed",
  132025: "The meeting has started and deletion is not allowed",
  132026: "Only support the agreed conference rooms within 30 days",
  132027: "Invalid meeting participant flow water",
  133001: "Failed to create anchor permission association information",
  133002: "Failed to delete anchor permission related information",
  133003: "Invalid streamer query",
  133004: "The number of creations exceeds the upper limit",
  133005: "Moderator is logged in",
  133006: "Username can not be blank",
  133007: "Wrong password",
  133008: "Invalid appId",
  133009: "Invalid room information",
  133010: "Invalid host",
  133011: "The name already exists, please reset",
  133012: "Currently in live broadcast, update host password is not supported",
  133113: "Parameter information is missing",
  133114: "Failed to modify host information",
  133115: "Moderator is logged in",
  133116: "Moderators cannot manually create",
  133117: "Only live chat broadcast has a guest role",
  133118: "Guest has logged in",
  133119: "The assistant of this room type does not have this permission, please select again",
  133120: "Assistant monitoring authority is required",
  133121: "Assistant monitoring authority is required",
  133122: "Please use the Web to enter",
  133994: "Invalid logged in user",
  133995: "Password error more than 10 times, please try again in 30 minutes!",
  133996: "Illegal room permission",
  133997: "The account does not exist, please contact the organizer",
  133998: "The host cannot be deleted",
  134001: "Create tenant commodity exception",
  134002: "Modify tenant commodity exception",
  134003: "Delete tenant commodity exception",
  134004: "Invalid Tenant Item",
  134011: "Create room product exception",
  134012: "Modify room product exception",
  134013: "Delete room product exception",
  134014: "Invalid room item",
  134015: "Create room product parameters are invalid",
  134016: "Room sort field exception",
  134017: "Room sorting parameter is abnormal",
  134018: "The first or last one does not support moving up and down",
  134019: "Invalid media library resource",
  134020: "Failed to upload image",
  134021: "Product name cannot be repeated",
  134022: "The price of the product must be less than the underlined price",
  134024: "A maximum of 50 items can be added to the room",
  134995: "Invalid logged in user",
  135001: "Deleting media library assets failed",
  135002: "Move to library failed",
  135003: "Temporary media assets do not exist",
  135004: "Physical deletion of staging repository resource failed",
  135005: "Failed to save and delete records",
  135006: "Failed to perform physical deletion of media library media assets",
  135007: "Failed to perform physical deletion of staging library media assets",
  135011: "The deletion failed, and the call to Tencent Cloud to delete the media asset interface failed.",
  135012: "Failed to create media library upload file record",
  135013: "Failed to create media library file",
  135014: "Invalid media asset information",
  135015: "Failed to update media library upload file record",
  135016: "Failed to update media library file",
  135017: "The maximum number of requests",
  135018: "Invalid media library file",
  135019: "Invalid media library file upload record",
  135020: "Physical deletion of media library resource failed",
  135021: "Media library file name cannot be empty",
  135022: "Failed to create media library transcoding record",
  135023: "Failed to update media library transcoding record",
  135024: "The file is being transcoded or transcoded successfully, but cannot be transcoded",
  135025: "Invalid transcoding task",
  135026: "Invalid video source",
  135027: "The upload queue supports up to 20 items",
  135028: "Failed to delete network upload record",
  135029: "Failed to retransmit network upload file",
  135030: "Failed to create media library transcoded file",
  135031: "Failed to update media library transcode file",
  135032: "Wait for upload and upload failure to delete",
  135033: "Upload failed to retransmit",
  135034: "The file is not transcoded or is being transcoded and cannot be deleted",
  135035: "Failed to modify video file expiration time",
  135036: "Video has been deleted and cannot be played",
  135037: "Failed to modify media library upload record",
  135038: "Failed to create media library upload record",
  135039: "Video has been deleted and cannot be played",
  135040: "Select up to 20 media files",
  135041: "Invalid media library storage resource information",
  135042: "Create media detection task failed",
  135043: "Modified media detection task failed",
  135044: "Modifying the media table detection status failed",
  135045: "MDC detection result callback result is empty",
  135046: "The MDF synchronization detection status failed",
  135047: "Create the MDF detection task failed",
  135048: "The media aspects waiting for transcoding, transcoding, and transcoding failure cannot be transferred",
  135049: "Inferior transcoding resolution",
  135050: "This video already has a transcoding video of %s, please do not repeat the transcoding",
  135051: "The %s of this video is being transferred, please check the results later",
  135052: "The code rate does not exceed 5Mbps",
  135053: "This video is being transcoded and cannot be deleted",
  135054: "Video files can be transferred",
  135055: "The successful detection of media capital can be transferred",
  135056: "The file is referenced and cannot be deleted",
  135057: "Video is abnormal, please try again later",
  136001: "Duplicate Merchant Payment Order Number",
  136002: "Merchant payment WeChat configuration does not exist",
  136003: "Merchant payment order does not exist",
  137001: "Non-existent live",
  137002: "End call failed",
  137003: "call has ended",
  137004: "call has ended",
  137005: "Ability does not exist",
  137006: "Room exists with an ongoing call",
  137007: "The event has ended and the call cannot be initiated",
  137008: "Error in getting specific calling ability information",
  137009: "Create call failed",
  137010: "Update call failed",
  137011: "Delete call failed",
  137012: "Please select an unopened check-in",
  137013: "The duration of the call to action is greater than the sign-in time, please choose the duration again",
  137014: "Please start the check-in function first",
  137015: "There is a check-in ongoing, please try again later",
  137016: "The call to action check-in start failed",
  138001: "Promotion channel does not exist",
  138002: "This channel has been discontinued",
  138003: "The channel has expired",
  139001: "Invalid notification",
  139002: "Failed to create notification",
  139003: "Failed to modify notice",
  139004: "Send Cancel to edit only",
  139005: "Failed to create the notification object",
  139006: "Failed to modify the notification object",
  139007: "Cancel failed, change notification was sent successfully",
  14e4: "Failed to create order report",
  140001: "Failed to modify order report status",
  140002: "The value range of status is 1-2",
  140003: "Invalid Order Report",
  140004: "Failed to delete file",
  140005: "Invalid report download URL",
  140006: "Seminar viewing ad hoc concurrency should be selected Seminar Room",
  141e3: "Failed to create data export task",
  141001: "There is currently an export task, please try again later",
  141002: "Failed to modify data export status",
  141003: "The value range of export status is 0-2",
  141004: "Invalid data export task",
  141005: "Delete data export task failed",
  141006: "Invalid export download URL",
  142001: "Invalid developer app",
  142002: "Invalid appSecret",
  142003: "Create customer exception",
  142004: "Modify the app",
  142005: "Application keys can only be downloaded once",
  142006: "Ability to create exceptions",
  142007: "Abnormal editing ability",
  142008: "Query Ability Details Abnormal",
  142009: "Delete ability details exception",
  142010: "Delete ability-permission association exception",
  142011: "Create Capability-Permission Association Exception",
  142012: "IP is invalid",
  142013: "Please enable the open platform function first",
  143001: "Product that does not exist",
  144001: "Customer does not exist",
  145001: "Ability does not exist",
  145002: "Duplicate association permission exception",
  146001: "The number of apps created by the belonging organization has reached the limit",
  146002: "System is busy, please try again later",
  146003: "App does not exist",
  146004: "Illegal access to app data",
  146005: "The application does not exist or the audit initial state is abnormal",
  146006: "Failed to modify application",
  146007: "Incorrect application key or application credentials",
  146008: "App not enabled",
  146009: "App is disabled",
  146010: "Customer does not exist",
  146011: "Customer is disabled",
  146012: "Application key creation exception, please try again later",
  146013: "Authorized customer has been disabled",
  146014: "The maximum number of applications must be greater than the number used",
  146015: "Incorrect grantType parameter",
  146016: "The scope parameter is incorrect",
  146017: "External user unique ID cannot be empty",
  146018: "The activity number and activity id cannot both be empty",
  146019: "The app does not exist or is not enabled",
  146020: "To enable the administrator login URL, you need to configure the address.",
  147001: "Wrong color number",
  147002: "Theme modification failed",
  147003: "Topic initialization failed",
  148e3: "Create data export task failed",
  148001: "An export task already exists, so please try again later",
  148002: "Failed to modify the data export status",
  148003: "The exported state values range from 0-2",
  148004: "Invalid data export task",
  148005: "The delete data export task failed",
  148006: "Invalid export piece download address",
  149001: "Failed to modify the ads image",
  149002: "Nonexistent advertising item id",
  149003: "Failed to modify the picture",
  149004: "Please confirm if ads are allowed to be closed",
  149005: "The ad picture list cannot be empty",
  149006: "Advertising image item jump address format is incorrect",
  149007: "The display position cannot be empty",
  15e4: "Invalid Enterprise Resource Pack",
  150001: "Failed to modify enterprise resource pack",
  150002: "Enterprise inventory is insufficient",
  150003: "Failed to modify enterprise inventory",
  150004: "Failed to create enterprise resource consumption pipeline",
  150005: "Insufficient media library capacity",
  150006: "Not enough customers",
  150007: "Insufficient SMS resources, please contact the administrator",
  150008: "The list live broadcast time is insufficient to start the list live broadcast",
  150009: "Insufficient streaming service duration resources, unable to conduct live streaming",
  150010: "Insufficient third-party retweet time",
  150011: "Insufficient inventory of virtual meeting rooms",
  150012: "Insufficient third-party retweet time",
  150013: "Failed to obtain verification code, please contact the organizer",
  150014: "Unable to play, please contact the organizer",
  150015: "Insufficient inventory of resources",
  150016: "Insufficient concurrent resources to play",
  150017: "Insufficient resources for Live Chat Duration",
  150018: "Insufficient inventory for UHD audio and video connection time",
  150020: "Unknown control group",
  150021: "General resource management and control exception",
  150022: "Insufficient resources for seminars",
  150023: "Playback error, insufficient resources",
  150024: "Insufficient number of workshops can be created",
  150025: "Invalid version",
  150026: "The current version can create a maximum of 1 live broadcast room, please upgrade the version first",
  150027: "The current version cannot create different types of spaces, please upgrade the version first",
  150028: "Please purchase seminar meeting room resources first",
  150029: "SMS template error",
  150030: "Insufficient inventory for UHD webinar resources",
  150031: "Please buy UHD webinar room resources first",
  151001: "Invalid online audience",
  151002: "Invalid live chat",
  151003: "Invalid online private message",
  151004: "Invalid online user type",
  151005: "Invalid request parameter",
  151006: "You do not have permission to enter this venue",
  151007: "Exceeds room ceiling limit",
  151008: "Admin has turned off chat",
  151009: "Anonymous users are not allowed to chat",
  151010: "Start sign in exception",
  151011: "Close check-in exception",
  151012: "Get check-in data exception",
  151013: "Failed to export sign-in data Sign-in has not ended",
  151014: "The current check-in session is not over",
  151015: "Add check-in user exception",
  151016: "You are on the banned list",
  151017: 'The content you sent contains sensitive words "%s"',
  151018: "Modify the abnormal status of online users connected to the microphone",
  151019: "The message has not been reviewed, the operation is prohibited",
  151020: "Chat list query exceeds 800 limit",
  151021: "No permission to create red envelopes",
  151022: "You are talking too fast, rest for %s seconds",
  151023: "Do not operate frequently",
  151024: "The message service is abnormal, please refresh the page",
  151025: "Anonymous chat for named users is closed",
  151026: "Banned users have reached the upper limit",
  151027: "Kicked users have reached the upper limit",
  151028: "Reply failed, the message has been deleted",
  151029: "Chat content is illegal",
  152001: "Create line configuration exception",
  152002: "Modify the abnormal global line configuration",
  152003: "Modify multi-resolution configuration exception",
  152004: "Room does not exist",
  152005: "Streaming",
  152006: "Streaming not started",
  152007: "Configuration does not exist or multi-resolution configuration is not enabled",
  152008: "Modify the default line exception",
  152009: "Correct the abnormal line status",
  152010: "Modifying the line name is abnormal",
  152011: "Invalid third-party feed",
  152012: "Modify third-party push stream exception",
  152013: "Create a third-party push exception",
  152014: "Remove third-party push exceptions",
  152015: "Create and witness cloud push abnormality",
  152016: "Get distributed lock exception",
  152017: "Get graphic data exception",
  152018: "Release distributed lock exception",
  152019: "Please try again later",
  153001: 'The content of the notice you sent contains sensitive words "%s"',
  153002: "Notices are being sent too frequently, please try again in 5 seconds",
  153003: "The content of the notice is not compliant",
  154001: "Ineffective marketing tools",
  154002: "Marketing tool active",
  154003: "Create Marketing Tool Exceptions",
  154004: "Modify Marketing Tool Exception",
  154005: "Delete Marketing Tool Exception",
  154006: "Only one interaction of the same type can be enabled at a time, and the current number of enabled interactions is %s",
  154007: "Form ID is not modifiable",
  154008: "Form questions cannot be deleted",
  154009: "Problem is not replaceable",
  154010: "Question type cannot be modified",
  154011: "Options are not interchangeable",
  154012: "Options cannot be deleted",
  154013: "Question exceeds maximum limit",
  154014: "Submit questionnaire is empty",
  154015: "Create Marketing Tools Key Audience Exceptions",
  154016: "Do not repeat",
  154017: "Marketing tool name does not support duplicates",
  154018: "Submit customer service ability is empty",
  154019: "Ineffective Marketing Tool Statistics",
  154020: "Marketing tool not enabled",
  154021: "Marketing Tools Unlinked Capabilities",
  154022: "The event has passed the end time and the questionnaire cannot be submitted",
  154023: "Questionnaire does not exist for marketing tool type",
  154024: "Create file download exception",
  154025: "Edit file download exception",
  154026: "Create file download parameter exception",
  154027: "Invalid file download",
  154028: "Create file details exception",
  154029: "Edit file details exception",
  154030: "Delete file details exception",
  154031: "File upload failed",
  154032: "Create file details parameter exception",
  154033: "Invalid marketing tool type",
  154034: "file name duplicate",
  154035: "The number of files failed to verify the current number %s",
  154036: "Delete file details exception",
  154037: "Create file details parameter exception",
  155e3: "Failed to update custom menu bar",
  155001: "Failed to add menu bar video",
  155002: "invalid id",
  155003: "Invalid video item",
  155004: "Deleting menu bar video failed",
  155005: "Failed to update video order",
  155006: "Failed to get media library video information",
  155007: "Parameter error",
  155008: "Failed to create decoration information",
  155009: "Failed to modify decoration information",
  155010: "Please create a channel first",
  155011: "Invalid custom menu",
  155012: "Mobile ID is empty",
  155013: "Front ID is empty",
  155014: "Custom menu sorting exception",
  155015: "URL is empty",
  155016: "Copy decoration page option is empty",
  155017: "Group is empty",
  155018: "Failed to modify decoration information",
  155019: "Failed to delete room in group",
  155020: "Failed to create room in group",
  155021: "Failed to create group",
  155022: "There is no room for the group",
  155023: "The room activities selected by the copy decoration plan are inconsistent",
  155024: "The room selected by the copy decoration plan is consistent",
  155025: "Logo cannot be dragged",
  155026: "Failed to delete menu bar",
  155027: "The custom menu bar video configuration is abnormal",
  155028: "Live synopsis title is null",
  155029: "Start time or end time is empty",
  155030: "Live synopsis is not null",
  155031: "Up to 3 preset texts can be selected",
  155032: "WatermarkWordType The values range from 0-1",
  155033: "Choose at least 1 preset text",
  155034: "Please enter the online user switch ID",
  155035: "The value range of the online user switch identification is 0~1",
  155036: "Please enter the online account picture switch logo",
  155037: "The value range of the online user avatar switch is 0~1",
  155038: "Please enter the range of online users",
  155039: "The scope of online users must include the audience",
  155040: "The value range of the online user range is %s~%s",
  155041: "Failed to edit online user configuration",
  155042: "At least one language is turned on",
  156001: "File size is a maximum of 5M",
  156002: "You currently have an import task, please try again later",
  156003: "The file only supports the xls, xlsx format",
  156004: "At most 5w and 1 bar",
  156005: "Failed to upload file",
  156007: "Create data task import failed",
  156008: "Modify data task import failed",
  156009: "Error record over limit",
  156010: "Failed to read file",
  157001: "Inlerable screen control",
  157002: "Create screen control failed",
  157003: "Modification of screen control failed",
  157004: "Modify the screen control layout failed",
  157005: "Modify the screen control broadcast ID ID failed",
  160001: "The current function is not enabled, please contact the administrator",
  160002: "The format of the domain name is incorrect, please re-fill",
  160003: "The current domain name is duplicated, please re-fill",
  160004: "The certificate format is incorrect, please confirm and resubmit",
  160005: "Certificate and domain name do not match",
  160006: "The certificate is valid for less than one month, please use a new certificate",
  160007: "The key format is incorrect, please confirm and resubmit",
  160008: "Certificate and key parsing failed, please confirm and resubmit",
  160009: "The certificate does not match the key, please confirm and resubmit",
  160010: "The current page is already configured, please modify or disable it and then reconfigure",
  160011: "The current page is not configured, please configure the domain name first",
  160012: "Cloud vendor error",
  160013: "Certificate deployment failed",
  160014: "Certificate modification failed",
  160015: "Invalid page id",
  160016: "Failed to restore default",
  160017: "User name error",
  160018: "Domain name does not match activity information",
  161001: "Create bug-user failed",
  161002: "Create bug-IP failed",
  161003: "Invalid bug-user",
  161004: "Invalid bug-IP",
  161005: "Failed to delete bug-user",
  161006: "Failed to delete bug-IP",
  161007: "IP already exist",
  161008: "The cell phone or mailbox already exists",
  162001: "Create blacklisted users failed",
  162002: "Create blacklist IP failed",
  162003: "Invalid blacklist user",
  162004: "Invalid blacklist IP",
  162005: "Failed to delete the blacklist user",
  162006: "Failed to delete the blacklist IP",
  162007: "IP already exist",
  162008: "The cell phone or mailbox already exists",
  170001: "Registration failed, please contact the administrator",
  170002: "Invalid room",
  170003: "Failed to remove participant, please contact administrator",
  170004: "The draw has ended",
  170005: "Invalid lottery",
  170006: "The name of the lottery in the same live room does not support duplication",
  170007: "The maximum number of prizes in the draw is 20",
  170008: "Invalid award",
  170009: "No ongoing sweepstakes",
  170010: "The prize has been drawn and cannot be edited",
  170011: "The prize has been drawn and cannot be deleted",
  170012: "The prize draw is currently in progress and cannot be closed for the time being",
  170013: "Invalid Prize",
  170014: "Do not repeat the lottery",
  170015: "Modify the lottery status to fail in the lottery",
  170016: "Failed to modify lottery status",
  170017: "There are prizes in operation, please try again later",
  170018: "Failed to create lottery record",
  170019: "Failed to create winning record",
  170020: "Failed to modify the number of winners of the lottery",
  170021: "Please start the raffle first",
  170022: "The lottery has ended and the prize cannot be drawn",
  170023: "You have joined the luckydraw, please do not repeated the operation",
  170024: "There can only be one active sweepstakes",
  170025: "Failed to modify the number of winners of a participant",
  170026: "The lottery status has been changed, please refresh the page to view",
  170027: "Please set at least one award",
  170028: "Sweepstakes has ended",
  170029: "The sweepstakes has ended and participants cannot be deleted",
  170030: "The status of the lottery room is abnormal, please wait",
  170031: "Invalid personnel information",
  170032: "Failed to create award priority winner",
  170033: "Failed to delete prize first prize winner",
  170034: "Entry is not allowed for this sweepstakes",
  170035: "The current lottery does not allow spectators to register, please re-select the scope of the lottery",
  170036: "Invalid Sweepstakes Participant",
  170037: "The number of winners shall not be greater than the number of prizes",
  170038: "The current number of prizes is less than the preset number of winners, please modify and try again",
  170039: "Invalid sweepstakes range",
  170040: "Batch lottery is not supported",
  170041: "Code error",
  170042: "Please input code",
  170043: "If the lottery is not operated within 30 days after the start of the lottery, the lottery cannot be drawn",
  171001: "Create reward template exception",
  171002: "Modify the reward template exception",
  171003: "Delete tip template exception",
  171004: "Invalid tip template",
  171010: "Template name cannot be repeated",
  171101: "Create reward template exception",
  171102: "Modify the reward template exception",
  171103: "Delete tip template exception",
  171104: "Modify the abnormal order of reward items",
  171105: "Add up to 20 tipping props",
  171106: "Failed to update tip template open tag",
  171110: "The name of the tipping item is not allowed to be repeated",
  171111: "Invalid product item",
  171112: "Goods props are disabled",
  171113: "Item payment status error",
  171114: "No reward in the room",
  171115: "The props are in use, and the use of exceptions is not avoided. Please close them before editing.",
  171116: "Do not operate frequently",
  183001: "Invalid live viewer",
  183002: "Account cannot be empty",
  183003: "Mobile number format is incorrect",
  183004: "Incorrect authorization mode",
  183005: "Verification code error",
  183006: "User does not exist",
  183007: "Wrong password",
  183008: "Failed to create audience",
  183009: "The mobile phone number already exists, no repetition is allowed",
  183010: "Get WeChat authorization link exception, scope is empty",
  183011: "Getting WeChat authorization link is abnormal, scope is invalid",
  183012: "Call WeChat network request exception",
  183013: "Invalid Authorized Viewer",
  183014: "Abnormal acquisition of WeChat user data",
  183015: "Create WeChat user exception",
  183016: "Bind user exception",
  183017: "Query user token exception",
  183018: "WeChat user does not match the currently logged in user",
  183019: "WeChat authorization timeout",
  183020: "The current logged-in user has been bound to WeChat",
  183021: "Get WeChat authorized link room number is empty",
  183022: "The tenant does not configure WeChat authorization information",
  183023: "WeChat callback code is invalid",
  183024: "WeChat callback state is invalid",
  183025: "User id is empty",
  183026: "Wechat Get accessToken exception",
  183027: "Wechat Getting jsApiTicket exception",
  183028: "Room number cannot be empty",
  183029: "Authorization timed out",
  183030: "The official account is not bound to the open platform",
  183031: "The authorization method of the open platform is not currently supported",
  183032: 'It contains the sensitive word "%s", Please modify it first',
  183033: `Not support special characters such as ' " \\ / & > < `,
  183034: "Failed to modify audience",
  183035: "Invalid room number",
  183036: "WeChat user does not match the currently logged in user",
  183037: "Incorrect access method",
  183038: "Mobile number/email cannot be empty",
  183039: "Verification code must be filled",
  183040: "Password cannot be empty",
  183041: "Wrong password",
  183042: "At least one email address or third-party number",
  183043: "User status cannot be 1",
  183044: "More than 1 audience",
  183045: "Failed to modify removal status",
  183046: "Failed to delete user",
  183047: "Failed to create a third-party account",
  183048: "Failed to obtain third-party account",
  183050: "Incorrect configuration of WeChat appsecret",
  183051: "WeChat appid configuration is incorrect",
  183052: "WeChat official account is not configured with IP white list",
  183053: "WeChat official account is abnormal, and the IP needs to be confirmed by the administrator",
  183054: "WeChat official account is abnormal, and the IP is waiting for the administrator to confirm",
  183055: "WeChat official account call exception, IP rejected by administrator",
  183056: "WeChat official account call exception, IP rejected by administrator",
  183057: "WeChat official account AppSecret configuration error",
  183058: "WeChat grant_ Type parameter is non client_ credential",
  183059: "Audience review failed",
  183060: "The current account is a virtual account.",
  200001: "Missing data",
  200002: "Illegal parameter",
  200003: "Pilot name up to 255 characters",
  200004: "The cloud guide is not turned on",
  200005: "Cloud Pilot has been deleted",
  200006: "Cloud Anchor is down",
  200007: "Cloud Pilot is turned on",
  200008: "The cloud guide has not been shut down",
  200009: "Delay broadcast is enabled",
  200010: "Timelapse is turned off",
  200011: "The cloud guide has insufficient resources and fails",
  200012: "Timecast has not been enabled",
  200013: "The pilot is on",
  200014: "Illegal IP request",
  200015: "Broadcast station names only support Chinese and English and numbers",
  200016: "Frequent operations",
  200017: "Resource is being released, please try again later",
  200018: "Please turn off the delay broadcast first",
  208e3: "Invalid permission",
  209e3: "Invalid role",
  209001: "Failed to create role",
  209002: "Failed to modify role",
  209003: "Failed to delete role",
  209004: "There is an associated user for this role",
  209005: "Failed to create role permission association information",
  209006: "Failed to delete role permission association information",
  209007: "Add member parameter error",
  209008: "Delete member parameter error",
  209009: "Role name cannot be repeated",
  209010: "The character cannot be edited",
  21e4: "Email and phone cannot be both empty",
  210001: "Failed to add staff",
  210002: "Failed to modify people",
  210003: "Invalid person information",
  210004: "Mobile number already exists",
  210005: "Email already exists",
  210006: "Phone number/email does not exist",
  210007: "Mobile number/email already exists",
  210008: "Wrong password",
  210009: "Old password cannot be empty",
  210010: "WeChat openId already exists",
  210011: "Third-party user id already exists",
  210012: "The current version does not support group management, please upgrade the version first",
  22e4: "The number of groups exceeds the tenant maximum limit -",
  220001: "Failed to add personnel group",
  220002: "Failed to modify personnel group",
  220003: "Invalid people grouping",
  220004: "Failed to delete people group",
  220005: "The group name already exists, please do not enter it repeatedly",
  221001: "Details of non-existent red packets",
  221002: "Failed to persist red packet data details",
  221003: "Persistent red envelope channel summary data failed",
  221004: "Non-existent red envelope summary data",
  221005: "No contest information",
  221006: "Name cannot be empty",
  221007: "Phone cannot be blank",
  221008: "E-mail can not be empty",
  221009: "Address cannot be empty",
  221010: "Emoticon image size exceeds the maximum limit",
  221011: "Emoticon image format error",
  221012: "Emoticons uploaded for more than 1 day",
  221013: "The current version can create at most 1 set of emoticons, please upgrade the version first",
  221014: "Create up to 5 emoticons",
  221015: "The emoticon library name cannot be repeated",
  221016: "Please do not operate while uploading the emoticon",
  221017: "Emoticons that don't exist",
  222001: "Webinar must be live chat broadcast type",
  222002: "Invalid playlist",
  222003: "Failed to create playlist",
  222004: "Failed to modify playlist",
  222005: "Failed to delete playlist",
  222006: "Playlist is in use",
  222007: "The playlist does not have an input source configured",
  222008: "Failed to modify playlist usage status",
  222009: "Please configure the playlist before starting the live broadcast",
  222010: "There are duplicate scenes in the layout. Please delete or rename them",
  222011: "Full screen cannot be selected for this configuration",
  222012: "The layout name cannot be repeated",
  222013: "Playlists are only available for seminars",
  222014: "The first or last one does not support moving up and down",
  222015: "Playlist sort field exception",
  222016: "Create up to 50 playlists",
  222017: "Do not operate frequently",
  222018: "The preset broadcast order cannot be modified",
  222019: "The preset broadcast order cannot be deleted",
  223001: "Invalid contest",
  223002: "Failed to create contest",
  223003: "Failed to modify the contest",
  223004: "Failed to delete contest",
  223005: "Failed to create contest prize",
  223006: "Failed to modify the contest prize",
  223007: "The contest name cannot be repeated",
  223008: "Only open contests can be edited",
  223009: "Only unopened contests can be deleted",
  223010: "There is currently an ongoing contest, which does not support closing",
  223011: "Contest status error",
  223012: "Please enable the quiz feature first",
  223013: "There is currently an ongoing competition, please end it first",
  223014: "Invalid contest prize",
  223015: "Failed to create contest record",
  223016: "Failed to modify the contest record",
  223017: "There is more than 1 contest in progress",
  223018: "There is no award quiz",
  223019: "Duplicate user contest record",
  223020: "Questionnaire has no answers",
  225001: "Invalid exam",
  225002: "Failed to create exam",
  225003: "Failed to modify the exam",
  225004: "Delete exam failed",
  225005: "There are no exams in progress",
  225006: "Unusual number of exams in progress",
  225007: "Exam name cannot be repeated",
  225008: "Only open exams can be edited",
  225009: "Only unopened exams can be deleted",
  225010: "More than 1 exam in progress",
  225011: "Only unopened exams can be opened",
  225012: "Exam information that does not exist",
  225013: "You are too late to enter the exam.",
  225014: "Exam is over",
  225015: "Failed to create exam record",
  225016: "Only exams in progress can end",
  225017: "Exam has not started",
  225018: "The exam is already open, no need to open it again",
  225019: "Exam is closed, no need to close again",
  225020: "Nonexistent exam records",
  225021: "Question time elapsed",
  225022: "The document does not meet the import specification, please follow the EXCEL document template specification",
  225023: "Please upload.xls perhaps.xlsx formatted file",
  226001: "Invalid question",
  226002: "Failed to create question",
  226003: "Failed to modify question",
  226004: "Failed to delete question",
  226005: "There are no ongoing questions",
  226006: "Unusual number of questions in progress",
  226008: "Only open questions can be edited",
  226009: "Only unopened questions can be deleted",
  226010: "More than 1 question in progress",
  226011: "Only unopened questions can be opened",
  226012: "Only ongoing questions can be ended",
  226013: "Question information that does not exist",
  226014: "Question has been posted",
  226015: "question closed",
  226016: "The question is not over yet",
  226017: "Repeated submit",
  226018: "Error submission options",
  226019: "Answers cannot be submitted for non-in-progress questions",
  226020: "Choose at most one answer",
  226021: "Please select at least two answers",
  226022: "Number of options up to 50",
  226023: "Option not submitted",
  226024: "Do not repeat the modification",
  227001: "Nonexistent distribution task",
  227002: "Failed to create distribution task",
  227003: "Failed to create distribution tasks in batches",
  227004: "Failed to modify distribution task",
  227005: "Duplicate target push stream address",
  227006: "Create up to 20 live distribution tasks at a time",
  227007: "The destination push stream address is duplicated",
  227008: "Incorrect batch operation parameters",
  227009: "failed to delete",
  227010: "Batch delete failed",
  227011: "Bulk operation failed",
  227012: "Multi-cloud fusion callback parameter error",
  227013: "The current live broadcast has not started, and the live broadcast distribution task cannot be started",
  227014: "This action is forbidden for this live broadcast type",
  227015: "Frequent operations, please try again later",
  227016: "The distribution task is in progress and cannot be deleted",
  227017: "This task prohibits this operation",
  227018: "Non-existent distribution platform",
  227019: "Non-existent distribution platform",
  227020: "The China live platform does not support the rtmps protocol",
  227021: "Distribution platform type does not match",
  228001: "Voting names cannot be duplicated",
  228002: "Failed to create Voting",
  228003: "Only Votings that are not open can be edited",
  228004: "Invalid vote",
  228005: "There have already been votes",
  228006: "Edit vote failed",
  228007: "Only unopened Votings\xA0 can be deleted",
  228008: "Delete vote failed",
  228009: "The number of votes in progress is greater than 1",
  228010: "Failed to edit voting status",
  228011: "Duplicate submissions",
  228012: "Votes that are not in progress cannot be submitted",
  228013: "Failed to create voting record",
  228014: "The number of options exceeded",
  228015: "The deadline is at least 1 minute later than the current time",
  229001: "Create record failed",
  230001: "Manufacturer type:%s temporarily can not find the interface:%s, please check carefully",
  230002: "Vendor type:%s, this interface is not supported:%s",
  230003: "The%s interface calling cloud%s exception:%s",
  230004: "Cloud vendor requests packet back as NULL",
  231001: "Failed to create bill",
  231002: "Failed to modify bill",
  231003: "Create bill task failed",
  231004: "The activity does not exist",
  231005: "Failed to update the task status after the bill is generated",
  231006: "Bill is empty",
  240001: "The signature status is incorrect. Please check and try again",
  240002: "The AccessKey configuration is incorrect",
  240003: "The signature does not exist. Please check and try again",
  240004: "Communication failed. Please check the configuration item",
  240005: "%s must be either uppercase or lowercase letters or digits",
  240006: "Mandatory items are not configured",
  240007: "Configure your own SMS service first",
  250001: "Failed to edit the template. Please check the configuration items",
  250002: "%s must be uppercase letters / digits / _",
  250003: "Mandatory items are not configured",
  250004: "Use a verification code type SMS template",
  250005: "The SMS template type is incorrect",
  250006: "The SMS template code does not exist. Please check and try again",
  250007: "The SMS template must have a {code} variable",
  250008: "Unsupported variables exist in the SMS template. Procedure",
  250009: "The SMS template has not been approved. Please confirm and try again",
  250010: "The SMS template is used in the same scenario. Please confirm and try again",
  250011: "The SMS service is not configured",
  250012: "Get short chain exception",
  250013: "The {expireDate} variable must exist in the SMS template",
  250014: "The SMS template does not exist",
  260001: "Do not add duplicate email addresses",
  260002: "Do not add duplicate phone numbers",
  260003: "Failed to add contact",
  260004: "Contact does not exist",
  260005: "Failed to modify the contact",
  260006: "Please complete name and email address",
  260007: "Error in the mailbox format!",
  260008: "Please enter your name!",
  260009: "Please enter your email address or mobile phone number!",
  260010: "Email / mobile phone number format error!",
  260011: "Add up to 5 contacts",
  260012: "Cannot delete",
  260013: "Operation failed, please try again",
  270001: "Failed to modify the resource alert configuration",
  280001: "Failed to create a settlement bill",
  280002: "Invalid settlement sheet",
  290001: "Failed to initialize preset menu while creating room",
  290002: "The current room is in the preset menu",
  290003: "Failed to add user-defined menu for warehousing",
  290004: "Failed to add custom menu",
  290005: "Invalid menu",
  290006: "Do not operate across rooms",
  290007: "The current menu is being edited",
  290008: "Failed to modify the menu information and put it into storage",
  290009: "Failed to modify menu information",
  290010: "The current menu is being deleted",
  290011: "Preset menu cannot be deleted",
  290012: "Failed to delete menu warehousing",
  290013: "Failed to delete menu",
  290014: "The current room is performing menu sorting",
  290015: "The moved menu is not a valid menu",
  290016: "The menu being moved is not a valid menu",
  290017: "Please do not operate across rooms for menu sorting. The moved menu does not belong to this room",
  290018: "Please do not operate across rooms for menu sorting. The moved menu does not belong to this room",
  290019: "Do not operate across languages for menu sorting",
  290020: "Menu sorting and warehousing failed",
  290021: "Menu sorting failed",
  290022: "Unsupported menu component",
  290023: "Preset menu cannot add components",
  290024: "Failed to add %s component information with default value into the database",
  290025: "Failed to add default %s component information",
  290026: "Failed to add component information for default value",
  290027: "Add up to %s components under a single custom menu",
  290028: "Preset menu cannot edit components",
  290029: "Disable cross menu editing of components",
  290030: "When editing a component, the input parameter [requestData] object must be a Json string after conversion. Cross menu editing of components is prohibited",
  290031: "Invalid %s component",
  290032: "Failed to edit %s component information",
  290033: "Preset menu cannot delete components",
  290034: "Disable deleting components across menus",
  290035: "Failed to delete %s component information for warehousing",
  290036: "Failed to delete %s component information",
  290037: "When editing a rich text box component, the text content cannot exceed %s words",
  290038: "Preset menu cannot query components",
  290039: "Prohibit querying components across menus",
  290040: "Please enter a start time",
  290041: "Please enter end time",
  290042: "Up to %s pictures can be configured",
  290043: "Failed to edit %s component information for warehousing",
  290044: "%s Duplicate sorting is not allowed",
  290045: "%s sorting must be continuous",
  290046: "You can configure up to %s partner groups",
  290047: "Up to %s partners can be configured",
  290048: "Up to %s activities can be configured",
  290049: "Up to %s locations can be configured",
  290050: "Failed to sort and store components under the menu",
  290051: "Failed to sort the components under the menu",
  290052: "The components under the current menu are being sorted",
  290053: "Preset menu cannot be sorted by components",
  290054: "The moved component is not a valid component",
  290055: "The component being moved is not a valid component",
  290056: "The current room is being copied and decorated",
  290057: "Failed to copy the exciting video from the menu or playback area",
  290058: "Failed to copy the menu or play area wonderful video into the library",
  290059: "Up to %s videos can be configured",
  290060: "Failed to add a exciting video to the mysql",
  290061: "Failed to add exciting video",
  290062: "The menu for the video type does not exist",
  290063: "Wonderful videos that don't exist",
  290064: "Failed to modify the exciting video storage",
  290065: "Failed to modify the exciting video",
  290066: "Failed to delete the exciting video into the mysql",
  290067: "Failed to delete the exciting video",
  290068: "The current room is performing exciting video sorting",
  290069: "Mobile exciting video is invalid",
  290070: "The moved exciting video is invalid",
  290071: "Please do not operate across rooms in order to sort exciting videos. Movable exciting videos do not belong to this room",
  290072: "Please do not operate across rooms in order to sort exciting videos. The exciting videos being moved do not belong to this room",
  290073: "Please do not operate across menus for exciting video sorting. The menu of the moved exciting video and the moving exciting video do not match",
  290074: "Failed to migrate and store menu data",
  290075: "Failed to reorder the component list under the menu due to component deletion",
  290076: "Adding custom menus exceeds the limit. You can add up to %s custom menus",
  290077: "Please input the WeChat QR code image",
  290078: "Please enter a contact telephone number",
  290079: "Please enter the contact email",
  290080: "Please enter the contact Weibo address",
  290081: "Please enter the contact FaceBook address",
  290082: "The selected video has invalid media library videos",
  290083: "The selected video has been deleted, please reselect",
  290084: "The current room is in menu data compensation",
  290085: "Menu data compensation failed",
  290086: "The current room is performing an Arabic menu data compensation operation",
  290998: "Prohibit cross tenant operations",
  291001: "Create a group configuration error",
  291002: "Update the configuration error between the group",
  291003: "Delete the configuration error between the group",
  291004: "Update the configuration error between the group",
  291005: "There is no separate group configuration",
  291006: "Need a group quantity parameter",
  291007: "There are already configuration between the group, please do not re -create",
  291008: "Maximum allowed to add 50 groups",
  291101: "There is no group room",
  291102: "Create a group error",
  291103: "Delete the inter -group error",
  291104: "Update division error",
  291105: "Update the information error of the group leader",
  291106: "Batch delete inter -group error",
  291107: "Batch update the group leader information error",
  291108: "The application of assistance between the group is empty",
  291109: "The application has been in this state",
  291110: "The host is in the group room",
  291111: "Discussion of group discussions",
  291112: "Unprocessed between groups",
  291113: "Incorrect request status in groups",
  291301: "The members are full, please select the group again",
  291302: "Failure to create members in batches",
  291303: "Please click to refresh to get the latest list",
  291304: "Batch initialization members failed",
  291305: "Batch deletion of members of the group error",
  291306: "Failure to allocate members, please refresh the page to retry",
  291307: "Members are full, please select a group again",
  291997: "Discussion is prohibited from this operation",
  291998: "The operating frequency is too fast, please try again later",
  292001: "Create tenants' callback configuration exception",
  292002: "Reset the tenant callback configuration abnormal",
  292003: "Practitioners' callback configuration does not exist",
  292004: "Delete the tenant callback configuration abnormal",
  292005: "Practitioner callback configuration already exists",
  292006: "Practitioner callback configuration already exists",
  292007: "The current staff is already the main speaker",
  292008: "The original staff was not the main speaker",
  292009: "The group is too full to join!",
  292010: "You were not included in the group discussion",
  292011: "You are already in another group",
  292012: "Failed to batch delete the group group",
  292013: "The host is still in the group room and cannot be deleted",
  292014: "The host could not become the group leader",
  292015: "You are already in the group discussion and cannot reenter",
  293001: "The room is not in the discussion",
  293002: "The room is being discussed",
  293003: "There is no group in the current failure, there is currently no group",
  293004: "Failure to start, please start the live broadcast first",
  294001: "Create tenants' callback configuration exception",
  294002: "Reset the tenant callback configuration abnormal",
  294003: "Practitioners' callback configuration does not exist",
  294004: "Delete the tenant callback configuration abnormal",
  294005: "Practitioner callback configuration already exists",
  294006: "Practitioner callback configuration already exists",
  294100: "Practitioners have reached the maximum value",
  295001: "Enable at least one login method",
  300001: "The number of custom interactions cannot exceed 100",
  300002: "Interaction number already exists",
  300101: "Failed to update iframe configuration",
  501e3: "Invalid department",
  501001: "Invalid parent department",
  501002: "Cannot modify default department",
  501010: "Failed to create department",
  501011: "Failed to modify department",
  501012: "Failed to delete department",
  501013: "The department name of the department at the same level cannot be repeated",
  501014: "Failed to modify department level",
  501015: "Failed to modify department status",
  501016: "There are still members under this department, disabling is not allowed",
  501017: "There are still enabled sub-departments under this department, disabling is not allowed",
  501018: "There are still members under this node, and deletion is not supported",
  502001: "Failed to create global concurrent service configuration",
  502002: "Failed to update global concurrency service configuration status",
  502003: "There is already an activation record of [Effective] or [To be effective] within this effective time range. Please cancel the [To be effective] record or change the effective time and try again.",
  601001: "The check-in to the current state does not allow deletion",
  601003: "Data anomaly",
  601004: "The check-in status is incorrect, and it cannot be turned on or off",
  601005: "The check-in is already on",
  601006: "The check-in is closed",
  601007: "Check-ins that are not turned on can be edited",
  601009: "Do not check in repeatedly",
  601011: "Please enable the check-in function first",
  601012: "There is already a check-in in progress, please do not initiate it repeatedly",
  601013: "The current check-in has been deleted, please refresh the list again",
  601201: "Unknown error for the U.S. interface",
  601202: "Sensitive word repetition",
  601203: "Sensitive word length too long",
  601204: "Too much data to import at once",
  601205: "Data import, please try again later",
  601206: "Self-built sensitive words do not exist",
  601207: "No permission to switch the AI solution",
  601300: "The data does not exist or has been deleted",
  601301: "Contains sensitive words",
  601302: "System default data, no operation allowed",
  601303: "Only 1,000 pieces of data can be imported at a time",
  601304: "Extra long length",
  601305: "Please enter a number from 1-10000",
  601306: "Please enter a number from 1-300",
  601307: "Please enter a number from 1-20",
  601308: "Configuration already exists\uFF0Cplease refresh the page",
  601309: "AI Attendee Robot has been activated\uFF0Cplease refresh the page",
  601310: "AI Attendee Robot has been closed\uFF0Cplease refresh the page",
  601311: "AI Atmosphere Master has been paused\uFF0Cplease refresh the page",
  601312: "AI Attendee Robot status error\uFF0Cplease refresh the page",
  601313: "Unable to active AI Attendee Robot without live streaming",
  601314: "The nickname library is currently in use. Please adjust the AI Attendee Robot configuration or end the AI Attendee Robot and try again",
  601315: "The chat library is currently in use. Please adjust the AI Attendee Robot configuration or end the AI Attendee Robot and try again",
  601316: "Please pause AI Attendee Robot first",
  601317: "Up to 10 nickname libraries can be created",
  601318: "Creation failed, the storage capacity has reached the maximum limit",
  601319: "Up to 20 script libraries can be created",
  601320: "At least one record needs to be retained in the nickname library. If all records need to be deleted, it is recommended to use the nickname library deletion function",
  601321: "At least one record needs to be retained in the chat library. If all records need to be deleted, it is recommended to use the script library deletion function",
  601322: "Frequent operations",
  601323: "The number of AI Attendee Robot selected cannot be greater than the total number of nicknames in the nickname library",
  602001: "The number of topic interactions exceeded",
  602002: "Thread replies are closed and cannot be replied to",
  602003: "Likes without opening the topic",
  602004: "Replies to likes are not turned on",
  602005: "No audit required",
  602006: "Topic does not exist",
  602007: "There are sensitive words in the chat box, please edit again",
  602008: "The topic switch is not turned on",
  602009: "In silence, you can't participate in topic interactions",
  602010: "You have liked",
  602011: "Response is still approved",
  602012: "The topic is at the top",
  602013: "Topic unpinned",
  602014: "The reply has been approved, please refresh the list",
  602015: "The reply has been deleted, Please refresh the list",
  603001: "Add up to 10 posters",
  603002: "Data fetch failed",
  603003: "Poster data failed to add",
  603004: "room matching error",
  603005: "Activity matching error",
  603006: "Poster modification failed",
  603007: "Poster deletion failed",
  603008: "Please turn on the poster sharing switch first",
  603009: "Share configuration is created repeatedly",
  604001: "Admin has turned off chat",
  604002: "Chat is pinned",
  604003: "The chat has not been pinned",
  604004: "Chat moderated",
  604005: "Chat does not require moderation",
  604006: "Chat has been declined",
  604007: "Invalid live chat",
  604008: "Sending message error",
  604009: "Sticky up to 10 messages",
  604010: "Message cannot be empty",
  604011: "Chat messages have not been reviewed yet",
  605e3: "Illegal parameter",
  605001: "Query user failed",
  605002: "User already exists",
  605003: "Failed to add user",
  605004: "Cache add user failed",
  605005: "Failed to delete user",
  605006: "User online processing failed",
  605007: "User offline processing failed",
  605008: "Failed to get prize pool data",
  605101: "Order acquisition failed",
  605102: "Order creation failed",
  606e3: "Draw does not exist",
  606001: "Draw name already exists",
  606002: "The maximum number of prizes in the draw is 20",
  606003: "Award does not exist",
  606004: "No ongoing sweepstakes",
  606005: "The prize has been drawn and cannot be edited",
  606006: "The prize has been drawn and cannot be deleted",
  606007: "The prize is in the lottery and cannot be closed for the time being",
  606008: "Prize does not exist",
  606009: "Prize draw, please try again later",
  606010: "Prize drawn",
  606011: "The current prize draw has already been entered, please do not register repeatedly",
  606013: "Priority winning configuration is not enabled",
  606014: "No entries are allowed in this draw",
  606015: "Invalid draw participant",
  606016: "The number of winners cannot be greater than the number of prizes",
  606017: "Password error",
  606018: "The draw has not been performed within 30 days of the start of the sweepstakes, Unable to draw",
  606019: "Sensitive word exists",
  606020: "Character is too long",
  606021: "Only unopened draws are allowed to be deleted",
  606022: "Abnormal flow of lottery status",
  606023: "Draw is open",
  606024: "The draw is closed",
  606025: "At least 1 prize to open the draw",
  606026: "Audience does not exist",
  606027: "Form does not exist",
  606028: "Viewer deleted",
  606030: "Draw not open",
  606031: "Download form is not open",
  607001: "Illegal parameter",
  607002: "The red packet password contains sensitive words",
  607003: "The red packet password is incorrect",
  607004: "The red packet has expired",
  607005: "Please configure WeChat Official Account and Merchant Information first",
  607006: "The red packet does not exist",
  607007: "Red packets cannot be modified",
  607008: "The red envelope has been snatched out",
  607010: "The total amount of red envelopes shall not be less than 0.3 yuan * the number of red packets, and shall not exceed 20W yuan",
  607013: "Red envelope is being distributed",
  607014: "The red packet record does not exist",
  607015: "Viewers do not receive the red envelope within 24 hours",
  608001: "A timer is already running, please do not initiate another one.",
  608002: "Completed",
  608003: "No timer in progress",
  2800003: "Failed to update the clearing bill",
  2800004: "Failed to delete the bill",
  2800005: "Invalid heartbeat",
  2800006: "Failed to update the settlement status"
}, en = {
  httpErrorCode: httpErrorCode$3
}, httpErrorCode$2 = {
  200: "SUCCESS",
  201: "\u6210\u529F\uFF0C\u5DF2\u521B\u5EFA\u8BE5\u8D44\u6E90",
  202: "\u6210\u529F\uFF0C\u5DF2\u63A5\u6536\u8BE5\u8BF7\u6C42",
  300: "\u5931\u8D25",
  401: "\u767B\u5F55\u72B6\u6001\u5931\u6548\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55",
  403: "\u672A\u6388\u6743",
  500: "\u7CFB\u7EDF\u5F02\u5E38",
  5002: "\u53C2\u6570\u9519\u8BEF",
  5003: "\u5185\u90E8\u8C03\u7528\u5931\u8D25",
  5004: "\u521B\u5EFA\u6587\u4EF6\u5931\u8D25",
  5005: "\u4FDD\u5B58\u6587\u4EF6\u5931\u8D25",
  5006: "\u8BF7\u6C42\u9891\u7E41",
  5008: "\u6570\u636E\u9519\u8BEF",
  5009: "\u8EAB\u4EFD\u9274\u6743\u5931\u8D25,\u7528\u6237\u7C7B\u578B\u9519\u8BEF",
  5010: "\u91CD\u590D\u8BF7\u6C42",
  5011: "\u5185\u90E8\u8C03\u7528\u5931\u8D25",
  5012: "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41,\u8BF7\u7A0D\u540E\u518D\u8BD5",
  5013: "\u83B7\u53D6\u9501\u5931\u8D25",
  1e5: "\u6570\u636E\u5E93\u5F02\u5E38",
  100001: "\u5DF2\u5B58\u5728\u7684",
  100005: "\u672A\u67E5\u8BE2\u5230\u6570\u636E",
  100006: "\u670D\u52A1\u521D\u59CB\u5316\u4E2D",
  100007: "\u670D\u52A1\u963B\u585E\u4E2D",
  100008: "\u963B\u585E\u5F02\u5E38",
  100009: "dubbo\u901A\u4FE1\u5F02\u5E38",
  100010: "\u975E\u6CD5\u53C2\u6570\u5F02\u5E38",
  100011: "\u975E\u6CD5\u72B6\u6001\u5F02\u5E38",
  100012: "\u8BF7\u6C42\u53C2\u6570\u5F02\u5E38,\u8BF7\u4FEE\u6539\u540E\u518D\u6B21\u63D0\u4EA4",
  100013: "\u8BF7\u6C42\u53C2\u6570\u5F02\u5E38,\u8BF7\u4FEE\u6539\u540E\u518D\u6B21\u63D0\u4EA4",
  100014: "\u8BF7\u6C42\u53C2\u6570\u5F02\u5E38,\u8BF7\u4FEE\u6539\u540E\u518D\u6B21\u63D0\u4EA4",
  100015: "\u4F7F\u7528\u65E0\u6548\u7684worker ID\uFF0C\u65E0\u6CD5\u751F\u6210\u5206\u5E03\u5F0FID",
  100016: "\u7F51\u7EDC\u5F02\u5E38\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  100017: "\u7F51\u7EDC\u5F02\u5E38\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  100018: "\u670D\u52A1 %s \u521D\u59CB\u5316\u4E2D",
  100019: "\u65E0\u6548\u8BF7\u6C42",
  100020: "\u670D\u52A1\u5668\u7E41\u5FD9\uFF0C\u8BF7\u7A0D\u5019\u91CD\u8BD5",
  100021: "\u8BBF\u95EE\u8D85\u65F6",
  100022: "\u6570\u636E\u5E93\u7D22\u5F15\u51B2\u7A81 : %s",
  100023: "\u8BF7\u6C42\u7684\u53C2\u6570\u8F6C\u6362\u5F02\u5E38",
  100024: "\u8BF7\u6C42\u7684Json\u53C2\u6570\u8F6C\u6362\u5F02\u5E38",
  100025: "\u8BF7\u6C42\u53C2\u6570: %s, \u503C: %s, \u53C2\u6570\u7C7B\u578B: %s, \u503C\u7684\u7C7B\u578B\u548C\u53C2\u6570\u7C7B\u578B\u4E0D\u5339\u914D",
  100026: "\u8BF7\u6C42\u5934\u4E2D\u7684Content type\u4E0D\u652F\u6301,\u8BF7\u4ED4\u7EC6\u68C0\u67E5Header\u4E2D\u7684Content type\u503C",
  100027: "\u8FD4\u56DE\u53C2\u6570\u5E8F\u5217\u5316\u5F02\u5E38",
  100028: "\u8BF7\u6C42\u7684Method\u4E0D\u652F\u6301",
  100029: "\u8BF7\u6C42\u53C2\u6570\u8F6C\u6362\u5F02\u5E38",
  100030: "\u8BF7\u6C42\u7684\u6D88\u606F\u4F53JSON\u53CD\u5E8F\u5217\u5316\u5F02\u5E38",
  100031: "\u8BF7\u6C42\u53C2\u6570\u4E2D\u7684 %s \u8F93\u5165\u9519\u8BEF",
  100040: "accessToken\u4E0D\u5B58\u5728",
  100041: "\u767B\u5F55\u72B6\u6001\u5931\u6548\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55",
  100042: "\u65E0\u6548\u7684\u57FA\u672C\u8EAB\u4EFD\u9A8C\u8BC1\u4EE4\u724C",
  100043: "\u4F1A\u8BDD\u8D85\u65F6\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55",
  100044: "\u4E0D\u5408\u6CD5\u7684token\uFF0C\u8BF7\u8BA4\u771F\u6BD4\u5BF9 token \u7684\u7B7E\u540D",
  100045: "\u7F3A\u5C11token\u53C2\u6570",
  100046: "\u89E3\u6790\u7528\u6237\u8EAB\u4EFD\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55\uFF01",
  100047: "\u79DF\u6237id\u4E3A\u7A7A\uFF01",
  100048: "\u60A8\u65E0\u6743\u9650\u8FDB\u5165",
  100049: "\u5F53\u524D\u6B63\u5728\u767B\u5F55\u4E2D",
  100050: "\u60A8\u7684\u8D26\u53F7\u5DF2\u5728\u5176\u4ED6\u8BBE\u5907\u767B\u5F55",
  100051: "\u5F53\u524D\u7248\u672C\u65E0\u6CD5\u4F7F\u7528\u8BE5\u529F\u80FD\uFF0C\u8BF7\u5148\u5347\u7EA7\u4EA7\u54C1\u7248\u672C",
  100052: "MQ\u53D1\u9001\u6D88\u606F\u5931\u8D25",
  100053: "\u90AE\u4EF6\u53D1\u9001\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u90AE\u7BB1\u914D\u7F6E",
  100054: "\u8BF7\u6C42\u7684\u6D88\u606F\u4F53\u4E0D\u7B26\u5408API\u7684\u8981\u6C42",
  100055: "\u8BF7\u6C42\u7684\u6D88\u606F\u4F53BODY\u4E3A\u7A7A",
  100056: "\u8BF7\u6C42\u53C2\u6570\u4E2D\u7684 %s \u8F93\u5165\u9519\u8BEF",
  100057: "\u8FD0\u6C14\u4E0D\u4F73",
  100058: "MDF\u4EE4\u724C\u5931\u6548",
  100059: "\u5185\u90E8\u52A0\u5BC6\u8FD0\u7B97\u5F02\u5E38",
  100060: "\u5185\u90E8\u89E3\u5BC6\u8FD0\u7B97\u5F02\u5E38",
  100061: "\u5185\u90E8\u52A0\u5DE5\u5BC6\u94A5\u8FD0\u7B97\u5F02\u5E38",
  100062: "%s \u662F\u5FC5\u9700\u9879",
  100063: "\u8BE5\u8BED\u8A00\u5C1A\u672A\u914D\u7F6E\uFF0C\u8BF7\u5B8C\u6210\u914D\u7F6E\u540E\u518D\u5F00\u542F",
  100064: "\u5F53\u524D\u8BED\u8A00\u7C7B\u578B\u6682\u672A\u914D\u7F6E\uFF01",
  100065: "\u4EC5\u65D7\u8230\u7248\u53EF\u4EE5\u4F7F\u7528\u6B64\u5F00\u653E\u80FD\u529B\uFF01",
  100066: "\u4FEE\u6539\u6570\u636E\u5931\u8D25",
  100067: "\u5220\u9664\u6570\u636E\u5931\u8D25",
  100068: "\u767B\u5F55\u914D\u7F6E\u5DF2\u5931\u6548\uFF0C\u5DF2\u66F4\u65B0\u72B6\u6001",
  100069: "\u8BF7\u52FF\u9891\u7E41\u64CD\u4F5C",
  100070: "\u8BF7\u5148\u914D\u7F6E\u5FAE\u4FE1\u516C\u4F17\u53F7\u4FE1\u606F",
  100071: "\u6682\u672A\u767B\u5F55\uFF0C\u8BF7\u5148\u767B\u5F55",
  100072: "\u65B0\u589E\u6570\u636E\u5931\u8D25",
  100073: "\u6709\u6548\u671F\u4E0D\u80FD\u8D85\u8FC7%s\u5929",
  100074: "\u8BF7\u52FF\u91CD\u590D\u64CD\u4F5C",
  100076: "\u8BBE\u7F6E\u5931\u8D25\uFF0C\u672A\u5B8C\u6210\u4F01\u4E1A\u5FAE\u4FE1\u6388\u6743",
  100077: "\u4F01\u5FAE\u63A5\u53E3\u8BF7\u6C42\u5931\u8D25",
  100078: "\u4F01\u4E1A\u5FAE\u4FE1\u914D\u7F6E\u5F02\u5E38",
  100100: "\u624B\u673A\u53F7\u7801\u683C\u5F0F\u4E0D\u6B63\u786E",
  100700: "\u5206\u5E03\u5F0FID\u521D\u59CB\u5316\u5F02\u5E38",
  100701: "\u5206\u5E03\u5F0FID\u751F\u6210\u5931\u8D25",
  100702: "\u65E0\u6548\u7684key\uFF0C\u5BFC\u81F4\u5206\u5E03\u5F0FID\u751F\u6210\u5931\u8D25",
  100703: "\u65F6\u95F4\u56DE\u6EDA\uFF0C\u5BFC\u81F4\u5206\u5E03\u5F0FID\u751F\u6210\u5931\u8D25",
  100704: "\u5206\u5E03\u5F0FID\u751F\u6210\u6A21\u5F0FidCreateModel\u914D\u7F6E\u5F02\u5E38,\u5BFC\u81F4\u5206\u5E03\u5F0FID\u521D\u59CB\u5316\u5F02\u5E38",
  100800: "\u6587\u6863\u4E0B\u8F7D\u5F02\u5E38",
  100900: "\u77ED\u4FE1\u624B\u673A\u53F7\u53C2\u6570\u5F02\u5E38",
  100901: "\u77ED\u4FE1\u6A21\u677F\u53C2\u6570\u5F02\u5E38",
  100902: "\u901A\u8FC7\u7C7B\u540D\u83B7\u53D6\u77ED\u4FE1\u6A21\u677Fcode\u5F02\u5E38",
  100903: "\u77ED\u4FE1\u963F\u91CC\u4E91\u670D\u52A1\u54CD\u5E94\u4E3A\u7A7A\u5F02\u5E38",
  100904: "\u7CFB\u7EDF\u5F02\u5E38\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002",
  100905: "\u8BF7\u7A0D\u540E\u518D\u8BD5",
  100906: "\u7EBF\u7A0B\u6C60\u6267\u884C\u4EFB\u52A1\u5F02\u5E38",
  100907: "\u670D\u52A1\u7E41\u5FD9\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  100908: "\u77ED\u4FE1\u53D1\u9001\u6761\u6570\u8D85\u8FC7\u4E0A\u9650\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002",
  100909: "\u60A8\u5C1A\u672A\u62A5\u540D\uFF0C\u8BF7\u62A5\u540D\u540E\u53C2\u4E0E",
  100910: "\u60A8\u65E0\u6CD5\u53C2\u52A0\u672C\u6D3B\u52A8\uFF0C\u5982\u6709\u7591\u95EE\u8BF7\u8054\u7CFB\u4E3B\u529E\u65B9",
  100911: "\u8BF7\u5148\u8FDB\u884C\u51C6\u5165",
  100912: "\u60A8\u65E0\u6CD5\u53C2\u4E0E\u672C\u6D3B\u52A8\uFF0C\u8BF7\u8054\u7CFB\u4E3B\u529E\u65B9",
  100913: "\u53C2\u6570\u4E0D\u80FD\u4E3A\u7A7A",
  100914: "\u60A8\u65E0\u6CD5\u53C2\u52A0\u672C\u6D3B\u52A8\uFF0C\u5982\u6709\u7591\u95EE\u8BF7\u8054\u7CFB\u4E3B\u529E\u65B9",
  100971: "\u8F93\u5165\u7684\u5185\u5BB9\u5305\u542B\u975E\u6CD5\u5B57\u7B26\uFF0C\u8BF7\u68C0\u67E5\u540E\u518D\u91CD\u8BD5",
  100972: "\u5E2D\u4F4D\u5DF2\u5B58\u5728",
  100973: "\u79FB\u9664\u5E2D\u4F4D\u5931\u8D25,\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  100974: "\u6DFB\u52A0\u5E2D\u4F4D\u5931\u8D25,\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  100975: "\u6CE8\u518C\u5931\u8D25",
  100976: "\u767B\u5F55\u5931\u8D25",
  100977: "\u8C03\u7528\u591A\u4E91\u878D\u5408\u5F02\u5E38",
  100978: "\u9000\u51FA\u767B\u5F55\u5931\u8D25",
  100979: "\u63A5\u53E3\u5DF2\u9650\u6D41",
  100980: "\u8BF7\u8F93\u5165\u8BF7\u6C42ID",
  100981: "\u65E0\u6548\u7684\u5BC6\u7801\u52A0\u5BC6\u8BF7\u6C42",
  100982: "\u79C1\u94A5\u89E3\u6790\u5F02\u5E38",
  100983: "\u8BF7\u8F93\u5165\u957F\u5EA6\u4E3A%s~%s\u4F4D\u7684\u5BC6\u7801",
  100984: "\u8BF7\u8F93\u5165\u6B63\u786E\u683C\u5F0F\u7684\u5BC6\u7801",
  100985: "\u5BC6\u7801\u957F\u5EA6\u6700\u5927\u4E3A%s",
  100986: "RSA\u79C1\u94A5\u7B7E\u540D\u5931\u8D25",
  100987: "RSA\u516C\u94A5\u9A8C\u7B7E\u5931\u8D25",
  100988: "RSA\u516C\u94A5\u52A0\u5BC6\u5931\u8D25",
  100989: "RSA\u79C1\u94A5\u89E3\u5BC6\u5931\u8D25",
  100990: "RSA\u521D\u59CB\u5316\u5BC6\u94A5\u51FA\u73B0\u9519\u8BEF,\u7B97\u6CD5\u5F02\u5E38",
  100991: "RSA\u52A0\u5BC6\u5F02\u5E38",
  100992: "\u975E\u6CD5\u8C03\u7528",
  100993: "\u4E0A\u4F20\u7684\u56FE\u7247\u683C\u5F0F\u4EC5\u652F\u6301 %s, \u8BF7\u91CD\u8BD5",
  100994: "\u4E0A\u4F20\u5931\u8D25,\u8BF7\u91CD\u8BD5",
  100995: "\u4E0A\u4F20\u7684\u56FE\u7247\u8D85\u51FA\u4E86\u9650\u5236,\u6700\u5927 %s MB",
  100996: "\u8BF7\u6C42\u53C2\u6570\u4E3A\u7A7A",
  100997: "\u6570\u636E\u4E0D\u5B58\u5728",
  100998: "\u4E0A\u62A5\u884C\u4E3A\u7C7B\u578B\u4E0D\u652F\u6301",
  100999: "\u672A\u77E5\u9519\u8BEF",
  101001: "\u8BF7\u8F93\u5165\u7528\u6237\u540D\u6216\u5BC6\u7801",
  101002: "\u8D26\u53F7\u4E0D\u5B58\u5728",
  101003: "\u5BC6\u7801\u9519\u8BEF",
  101004: "refreshToken\u65E0\u6548\uFF0C\u65E0\u6CD5\u52A0\u8F7D\u7528\u6237\u4FE1\u606F",
  101005: "refreshToken\u4E3A\u7A7A",
  101006: "grantType \u4E0D\u652F\u6301\uFF0C\u8BF7\u4F20\u9012\u6B63\u786E\u7684 grantType \u53C2\u6570",
  101007: "\u8D26\u53F7\u683C\u5F0F\u9519\u8BEF",
  101008: "\u8BE5\u8D26\u53F7\u5DF2\u6FC0\u6D3B\uFF0C\u8BF7\u52FF\u91CD\u590D\u64CD\u4F5C\u3002",
  101009: "\u94FE\u63A5\u5DF2\u5931\u6548\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u83B7\u53D6\u65B0\u7684\u9080\u8BF7\u94FE\u63A5\u3002",
  101010: "\u65E0\u6548\u7684\u7528\u6237",
  101011: "\u521B\u5EFA\u7528\u6237\u5931\u8D25",
  101012: "\u4FEE\u6539\u7528\u6237\u5931\u8D25",
  101013: "\u5220\u9664\u7528\u6237\u5931\u8D25",
  101014: "\u53C2\u6570\u9519\u8BEF\uFF0C\u4FEE\u6539\u7528\u6237\u72B6\u6001\u5931\u8D25",
  101015: "\u65E0\u6CD5\u5BF9\u81EA\u5DF1\u8FDB\u884C\u8BE5\u64CD\u4F5C",
  101020: "\u7528\u6237\u4E0E\u4F01\u4E1A\u7ED1\u5B9A\u5931\u8D25",
  101021: "\u65B0\u65E7\u5BC6\u7801\u4E0D\u80FD\u76F8\u540C",
  101022: "\u8BF7\u5148\u5B8C\u6210\u4EBA\u673A\u6821\u9A8C",
  101023: "\u4EBA\u673A\u6821\u9A8C\u5931\u8D25",
  101024: "\u9A8C\u8BC1\u7801\u9519\u8BEF",
  101025: "\u8BF7\u8F93\u5165\u7ED1\u5B9A\u624B\u673A\u53F7",
  101026: "\u8D26\u53F7\u4E0D\u5B58\u5728\uFF0C\u8BF7\u8F93\u5165\u7ED1\u5B9A\u624B\u673A\u53F7",
  101027: "\u8BF7\u8F93\u5165\u7ED1\u5B9A\u90AE\u7BB1",
  101028: "\u8D26\u53F7\u4E0D\u5B58\u5728\uFF0C\u8BF7\u8F93\u5165\u7ED1\u5B9A\u90AE\u7BB1",
  101029: "\u624B\u673A\u53F7\u7801\u683C\u5F0F\u4E0D\u6B63\u786E",
  101030: "\u53D1\u9001\u5BC6\u7801\u90AE\u4EF6\u5931\u8D25",
  101031: "\u7528\u6237\u65E0\u6743\u9650\u767B\u5F55",
  101032: "\u4F01\u4E1A\u5DF2\u9501\u5B9A\uFF0C\u65E0\u6743\u9650\u767B\u5F55",
  101033: "\u624B\u673A\u53F7\u7801\u5DF2\u5B58\u5728",
  101034: "\u90AE\u7BB1\u5DF2\u5B58\u5728",
  101035: "\u8D26\u53F7/\u5BC6\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165",
  101036: "\u8D26\u53F7\u5DF2\u88AB\u9501\u5B9A\uFF0C\u8BF7\u5728%s\u5206\u949F\u540E\u91CD\u8BD5",
  101037: "\u8D26\u53F7\u5DF2\u9501\u5B9A\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u89E3\u9664\u9501\u5B9A",
  101038: "\u9A8C\u8BC1\u7801\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u83B7\u53D6\u9A8C\u8BC1\u7801",
  101039: "\u7248\u672C\u8FC7\u4F4E\uFF0C\u8BF7\u5347\u7EA7\u7248\u672C",
  101050: "\u83B7\u53D6\u6570\u636E\u6743\u9650\u53C2\u6570\u5F02\u5E38",
  101051: "\u9A8C\u8BC1\u78011\u5C0F\u65F6\u4E0D\u80FD\u8D85\u8FC76\u6B21",
  101052: "\u9A8C\u8BC1\u780124\u5C0F\u65F6\u4E0D\u80FD\u8D85\u8FC720\u6B21",
  101053: "\u83B7\u53D6\u7EC4\u7EC7\u6811\u5931\u8D25\uFF0C\u8BF7\u786E\u8BA4\u53C2\u6570\u662F\u5426\u6B63\u786E",
  101054: "\u6DFB\u52A0\u7BA1\u7406\u5458\u5931\u8D25",
  101055: "\u79FB\u9664\u7BA1\u7406\u5458\u5931\u8D25",
  101056: "\u4FEE\u6539\u7BA1\u7406\u5458\u89D2\u8272\u5931\u8D25",
  101057: "\u6DFB\u52A0\u7BA1\u7406\u5458\u7684\u7528\u6237\u4E0D\u80FD\u4E3A\u7A7A",
  101058: "\u6DFB\u52A0\u534F\u4F5C\u8D26\u53F7\u5931\u8D25",
  101059: "\u79FB\u9664\u534F\u4F5C\u8D26\u53F7\u5931\u8D25",
  101060: "\u4FEE\u6539\u534F\u4F5C\u8D26\u53F7\u89D2\u8272\u5931\u8D25",
  101061: "\u534F\u4F5C\u8D26\u53F7\u5DF2\u5B58\u5728\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u91CD\u590D",
  101062: "\u7BA1\u7406\u5458\u7528\u6237\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7",
  101063: "\u66F4\u6362\u4F01\u4E1A\u7BA1\u7406\u5458\u5931\u8D25",
  101064: "\u8BF7\u52FF\u4E00\u5206\u949F\u5185\u91CD\u590D\u83B7\u53D6\u9A8C\u8BC1\u7801!",
  101065: "\u4FEE\u6539\u5BC6\u7801\u5931\u8D25",
  101066: "token\u53C2\u6570\u4E0D\u6B63\u786E",
  101067: "\u8D26\u53F7\u683C\u5F0F\u4E0D\u6B63\u786E",
  101068: "\u7528\u6237\u540D\u4E0E\u624B\u673A\u53F7/\u90AE\u7BB1\u4E0D\u5339\u914D\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u8BD5",
  101069: "5\u5206\u949F\u5185\u4EC5\u652F\u6301\u64CD\u4F5C\u4E00\u6B21\uFF0C\u8BF7\u52FF\u9891\u7E41\u64CD\u4F5C",
  101070: "\u7528\u6237\u540D\u4E0D\u652F\u6301\u91CD\u590D",
  101071: "\u7B2C\u4E09\u65B9\u7F16\u53F7\u4E0D\u652F\u6301\u91CD\u590D",
  101072: "\u8D26\u53F7\u672A\u6FC0\u6D3B\uFF0C\u8BF7\u6FC0\u6D3B\u540E\u4F7F\u7528",
  101073: "\u7528\u6237\u540D\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u65B0\u5C1D\u8BD5",
  101074: "\u8BE5\u7528\u6237\u4E0D\u5141\u8BB8\u767B\u5F55\u7BA1\u7406\u5E73\u53F0",
  101075: "\u8D26\u53F7\u751F\u6210\u65B9\u5F0F\u9009\u62E9\u901A\u8FC7\u90AE\u4EF6\u81EA\u4E3B\u6FC0\u6D3B\u65F6\uFF0C\u9700\u8BBE\u7F6E\u90AE\u7BB1",
  101076: "\u8BF7\u8F93\u5165\u751F\u6548\u65E5\u671F",
  101077: "\u8BF7\u8F93\u5165\u5931\u6548\u65E5\u671F",
  101078: "\u8BF7\u8F93\u5165\u683C\u5F0F\u6B63\u786E\u7684\u751F\u6548\u65E5\u671F",
  101079: "\u8BF7\u8F93\u5165\u683C\u5F0F\u6B63\u786E\u7684\u5931\u6548\u65E5\u671F",
  101080: "\u751F\u6548\u65E5\u671F\u4E0D\u80FD\u65E9\u4E8E\u4ECA\u5929",
  101081: "\u5931\u6548\u65E5\u671F\u4E0D\u80FD\u65E9\u4E8E\u751F\u6548\u65E5\u671F",
  101082: "\u8BF7\u9009\u62E9\u8D26\u53F7\u7C7B\u578B",
  101083: "\u7528\u6237\u65E0\u6743\u9650\u767B\u5F55",
  101084: "\u7528\u6237\u65E0\u6743\u9650\u767B\u5F55",
  101085: "\u65E5\u671F\u89E3\u6790\u5F02\u5E38",
  101086: "\u4E0D\u80FD\u4FEE\u6539\u751F\u6548\u65E5\u671F",
  101087: "\u5931\u6548\u65E5\u671F\u4E0D\u5F97\u65E9\u4E8E\u5F53\u5929",
  101088: "\u65E0\u6CD5\u533A\u5206\u8D26\u53F7\u662F\u5426\u9650\u65F6",
  101089: "\u9650\u65F6\u8D26\u53F7\u4E0D\u5141\u8BB8\u4FEE\u6539\u8D26\u53F7\u72B6\u6001",
  101090: "\u7528\u6237\u65E0\u6743\u9650\u767B\u5F55",
  101091: "\u6DFB\u52A0\u5E2D\u4F4D\u5931\u8D25",
  101092: "\u751F\u6548\u65E5\u671F\u4E0D\u5F97\u665A\u4E8E\u5F53\u5929",
  101094: `\u7528\u6237\u540D\u79F0\u4E0D\u652F\u6301 ' " \\ / & > < \u7B49\u7279\u6B8A\u5B57\u7B26`,
  103e3: "\u65E0\u6548\u7684\u7EC4\u7EC7",
  103001: "\u65E0\u6548\u7684\u7236\u7EC4\u7EC7",
  103002: "\u6839\u7EC4\u7EC7\u5DF2\u5B58\u5728",
  103003: "\u65E0\u6CD5\u5220\u9664\u6839\u7EC4\u7EC7",
  103004: "\u65E0\u6CD5\u4FEE\u6539\u6839\u7EC4\u7EC7\u72B6\u6001",
  103005: "\u540C\u7EA7\u90E8\u95E8\u540D\u79F0\u4E0D\u80FD\u91CD\u590D",
  103006: "\u4E0A\u7EA7\u7EC4\u7EC7\u4E0D\u5141\u8BB8\u4FEE\u6539",
  103007: "\u4E0A\u7EA7\u7EC4\u7EC7\u5904\u4E8E\u7981\u7528\u72B6\u6001\uFF0C\u8BF7\u5148\u542F\u7528\u4E0A\u7EA7\u7EC4\u7EC7",
  103010: "\u521B\u5EFA\u7EC4\u7EC7\u5931\u8D25",
  103011: "\u4FEE\u6539\u7EC4\u7EC7\u5931\u8D25",
  103012: "\u5220\u9664\u7EC4\u7EC7\u5931\u8D25",
  103013: "\u7EC4\u7EC7\u5C42\u6570\u4E0D\u80FD\u8D85\u8FC77\u5C42",
  103014: "\u7EC4\u7EC7\u5B50\u8282\u70B9\u4E0D\u80FD\u8D85\u8FC7100\u4E2A",
  103015: "\u8BE5\u90E8\u95E8\u4E0B\u6709\u4EBA\u5458\u6216\u4E1A\u52A1\u6570\u636E\u5B58\u5728\uFF0C\u65E0\u6CD5\u5220\u9664",
  108e3: "\u65E0\u6548\u7684\u7559\u8D44\u4FE1\u606F",
  108001: "\u66F4\u65B0\u7559\u8D44\u4FE1\u606F\u5931\u8D25",
  108002: "\u65E0\u6548\u7684\u8DDF\u8FDB\u4FE1\u606F",
  108003: "\u521B\u5EFA\u7559\u8D44\u8BB0\u5F55\u5931\u8D25",
  108004: "\u521B\u5EFA\u8DDF\u8FDB\u8BB0\u5F55\u5931\u8D25",
  108005: "\u90AE\u4EF6\u53D1\u9001\u5931\u8D25",
  108006: "\u670D\u52A1\u5668\u7E41\u5FD9",
  108007: "\u91CD\u590D\u53D1\u9001\u9A8C\u8BC1\u7801",
  108008: "\u9A8C\u8BC1\u7801\u9519\u8BEF",
  108009: "\u9A8C\u8BC1\u7801\u5DF2\u8FC7\u671F",
  109e3: "\u65E0\u6548\u7684\u89D2\u8272",
  109001: "\u521B\u5EFA\u89D2\u8272\u5931\u8D25",
  109002: "\u4FEE\u6539\u89D2\u8272\u5931\u8D25",
  109003: "\u5220\u9664\u89D2\u8272\u5931\u8D25",
  109004: "\u8BE5\u89D2\u8272\u5B58\u5728\u5173\u8054\u5458\u5DE5",
  109005: "\u521B\u5EFA\u89D2\u8272\u6743\u9650\u5173\u8054\u4FE1\u606F\u5931\u8D25",
  109006: "\u5220\u9664\u89D2\u8272\u6743\u9650\u5173\u8054\u4FE1\u606F\u5931\u8D25",
  109007: "\u89D2\u8272\u7684\u6743\u9650\u4E0D\u80FD\u4E3A\u7A7A",
  109008: "\u89D2\u8272\u540D\u79F0\u4E0D\u53EF\u91CD\u590D",
  110001: "\u65E0\u6548\u7684\u6743\u9650",
  111e3: "\u8BF7\u8F93\u5165\u7528\u6237\u540D\u6216\u5BC6\u7801",
  111001: "\u8D26\u53F7\u4E0D\u5B58\u5728",
  111002: "\u8D26\u53F7\u5DF2\u88AB\u7981\u7528",
  111003: "refreshToken\u65E0\u6548\uFF0C\u65E0\u6CD5\u52A0\u8F7D\u7528\u6237\u4FE1\u606F",
  111004: "refreshToken\u4E3A\u7A7A",
  111005: "grantType \u4E0D\u652F\u6301\uFF0C\u8BF7\u4F20\u9012\u6B63\u786E\u7684 grantType \u53C2\u6570",
  111006: "\u65E0\u6548\u7684\u5458\u5DE5",
  111007: "\u521B\u5EFA\u5458\u5DE5\u5931\u8D25",
  111008: "\u4FEE\u6539\u5458\u5DE5\u5931\u8D25",
  111009: "\u4FEE\u6539\u5458\u5DE5\u5BC6\u7801\u5931\u8D25",
  111010: "\u5220\u9664\u5458\u5DE5\u89D2\u8272\u5931\u8D25",
  111011: "\u7528\u6237\u540D/\u90AE\u7BB1/\u624B\u673A\u53F7\u5DF2\u5B58\u5728\uFF0C\u4E0D\u5141\u8BB8\u91CD\u590D",
  111012: "\u521B\u5EFA\u5458\u5DE5\u89D2\u8272\u5931\u8D25",
  111013: "\u8D26\u53F7/\u5BC6\u7801\u9519\u8BEF",
  111014: "\u66F4\u65B0\u767B\u5F55ip\u53CA\u65F6\u95F4\u5931\u8D25",
  111015: "\u53D1\u9001\u5BC6\u7801\u90AE\u4EF6\u5931\u8D25",
  111016: "\u5BC6\u7801\u9519\u8BEF\u8D85\u8FC73\u6B21\uFF0C\u9700\u53D1\u9001\u4EBA\u673A\u6821\u9A8C",
  111017: "\u65E0\u6548\u7684\u4EBA\u673A\u6821\u9A8C\u53C2\u6570",
  111018: "\u4EBA\u673A\u6821\u9A8C\u5931\u8D25",
  111019: "\u65B0\u65E7\u5BC6\u7801\u4E0D\u80FD\u76F8\u540C",
  111020: "token\u4E0D\u6B63\u786E",
  111021: "\u65E7\u5BC6\u7801\u9519\u8BEF",
  111022: "\u90AE\u4EF6\u5DF2\u53D1\u9001\uFF0C\u8BF7\u4E00\u5206\u949F\u540E\u91CD\u8BD5",
  112e3: "\u4FEE\u6539\u79DF\u6237\u4FE1\u606F\u5931\u8D25",
  112001: "\u65E0\u6548\u7684\u79DF\u6237",
  112002: "\u4F20\u5165\u7684\u53C2\u6570\u4E0D\u6B63\u786E",
  112003: "\u65E0\u6548\u7684\u90AE\u7BB1\u914D\u7F6E",
  112004: "\u53D1\u9001\u90AE\u4EF6\u5931\u8D25",
  112005: "\u65E0\u6548\u7684\u8D44\u6E90",
  112006: "\u521B\u5EFA\u8D44\u6E90\u7BA1\u63A7\u5931\u8D25",
  112007: "\u65E0\u6548\u7684\u8D44\u6E90\u7C7B\u578B",
  112008: "\u7981\u7528\u7406\u7531\u4E0D\u80FD\u4E3A\u7A7A",
  112009: "\u5BA2\u6237\u4E3B\u4F53\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A",
  112010: "\u5BA2\u6237\u661F\u7EA7\u9700\u57281-5\u661F",
  112011: "\u5BA2\u6237\u4E3B\u4F53\u540D\u79F0\u5DF2\u5B58\u5728",
  112012: "\u5B50\u79DF\u6237\u6570\u91CF\u5DF2\u8FBE\u8D44\u6E90\u5305\u5BB9\u91CF\uFF0C\u65E0\u6CD5\u521B\u5EFA",
  112013: "\u521B\u5EFA\u79DF\u6237\u4FE1\u606F\u5931\u8D25",
  112014: "\u8054\u7CFB\u4EBA\u4FE1\u606F\u4E0D\u80FD\u4E3A\u7A7A",
  112015: "\u8BF7\u52FF\u4E00\u5206\u949F\u5185\u91CD\u590D\u53D1\u9001\u90AE\u4EF6",
  112016: "\u521B\u5EFA\u95E8\u6237\u5931\u8D25",
  112017: "\u65E0\u6548\u7684\u95E8\u6237",
  112018: "\u4FEE\u6539\u95E8\u6237\u5931\u8D25",
  112019: "\u5220\u9664\u95E8\u6237\u5931\u8D25",
  112020: "\u521B\u5EFA\u677F\u5757\u5931\u8D25",
  112021: "\u4FEE\u6539\u677F\u5757\u5931\u8D25",
  112022: "\u5220\u9664\u677F\u5757\u5931\u8D25",
  112023: "\u65E0\u6548\u677F\u5757",
  112024: "\u9876\u90E8\u680F\u6216\u8005\u5E95\u90E8\u680F\u4E0D\u5141\u8BB8\u6392\u5E8F",
  112025: "\u9876\u90E8\u680F\u4E0D\u80FD\u91CD\u590D\u521B\u5EFA",
  112026: "\u5E95\u90E8\u680F\u4E0D\u80FD\u91CD\u590D\u521B\u5EFA",
  112027: "\u521B\u5EFA\u56FE\u7247\u7C7B\u578B\u6570\u636E\u5931\u8D25",
  112028: "\u4FEE\u6539\u8F6E\u64AD\u56FE\u5931\u8D25",
  112029: "\u5220\u9664\u8F6E\u64AD\u56FE\u5931\u8D25",
  112030: "\u65E0\u6548\u8F6E\u64AD\u56FE",
  112031: "\u521B\u5EFA\u89C6\u9891\u680F\u5931\u8D25",
  112032: "\u4FEE\u6539\u89C6\u9891\u680F\u5931\u8D25",
  112033: "\u5220\u9664\u89C6\u9891\u680F\u5931\u8D25",
  112034: "\u65E0\u6548\u89C6\u9891\u680F",
  112035: "\u521B\u5EFA\u89C6\u9891\u5931\u8D25",
  112036: "\u4FEE\u6539\u89C6\u9891\u5931\u8D25",
  112037: "\u5220\u9664\u89C6\u9891\u5931\u8D25",
  112038: "\u65E0\u6548\u89C6\u9891",
  112039: "\u4FEE\u6539\u516C\u53F8\u540D\u79F0\u5F02\u5E38",
  112040: "\u4FEE\u6539logo\u56FE\u6807\u5F02\u5E38",
  112041: "\u4FEE\u6539\u7F51\u7AD9\u56FE\u6807\u5F02\u5E38",
  112042: "\u4FEE\u6539\u83DC\u5355logo\u5F02\u5E38",
  112043: "\u4FEE\u6539\u767B\u5F55\u8BBE\u7F6E\u5F02\u5E38",
  112044: "\u4FEE\u6539\u5FAE\u4FE1\u5F00\u653E\u5E73\u53F0\u8BBE\u7F6E\u5F02\u5E38",
  112045: "\u4FEE\u6539\u5FAE\u4FE1\u516C\u4F17\u53F7\u8BBE\u7F6E\u5F02\u5E38",
  112046: "\u4FEE\u6539\u5FAE\u4FE1\u652F\u4ED8\u8BBE\u7F6E\u5F02\u5E38",
  112047: "\u4FEE\u6539\u7B2C\u4E09\u65B9\u6388\u6743\u5F02\u5E38",
  112048: "\u4FEE\u6539\u90AE\u7BB1\u914D\u7F6E\u5F02\u5E38",
  112049: "\u65E0\u6548\u7684\u76F4\u64AD\u573A\u666F",
  112050: "\u83B7\u53D6\u5FAE\u4FE1\u652F\u4ED8\u8BBE\u7F6E\u5F02\u5E38",
  112051: "\u65E0\u6548\u7684\u767B\u5F55\u7528\u6237",
  112052: "\u6570\u636E\u4E0D\u5B58\u5728",
  112053: "\u6570\u636E\u91CD\u590D",
  112054: "\u65E0\u6548\u53C2\u6570",
  112055: "\u5BA2\u6237\u7F16\u53F7\u5DF2\u5B58\u5728",
  112056: "\u8D44\u6E90\u7BA1\u63A7\u76F4\u64AD\u7C7B\u578B\u53C2\u6570\u5F02\u5E38",
  112057: "\u65E0\u6548\u7684\u677F\u5757\u7C7B\u578B",
  112058: "\u6570\u91CF\u4E0D\u80FD\u5C11\u4E8E 0 \u5E76\u4E14\u6570\u91CF\u4E0D\u80FD\u8D85\u51FA\u9650\u5236 \u6700\u5927%s\u4E2A",
  112059: "\u521B\u5EFA\u6D3B\u52A8\u5217\u8868\u5931\u8D25",
  112060: "\u4FEE\u6539\u6D3B\u52A8\u5217\u8868\u5931\u8D25",
  112061: "\u5220\u9664\u6D3B\u52A8\u5217\u8868\u5931\u8D25",
  112062: "\u65E0\u6548\u6D3B\u52A8\u5217\u8868",
  112063: "\u521B\u5EFA\u5408\u4F5C\u4F19\u4F34\u5206\u7EC4\u5931\u8D25",
  112064: "\u4FEE\u6539\u5408\u4F5C\u4F19\u4F34\u5206\u7EC4\u5931\u8D25",
  112065: "\u5220\u9664\u5408\u4F5C\u4F19\u4F34\u5206\u7EC4\u5931\u8D25",
  112066: "\u65E0\u6548\u5408\u4F5C\u4F19\u4F34\u5206\u7EC4",
  112067: "\u521B\u5EFA\u5408\u4F5C\u4F19\u4F34\u5931\u8D25",
  112068: "\u4FEE\u6539\u5408\u4F5C\u4F19\u4F34\u5931\u8D25",
  112069: "\u5220\u9664\u5408\u4F5C\u4F19\u4F34\u5931\u8D25",
  112070: "\u65E0\u6548\u5408\u4F5C\u4F19\u4F34",
  112071: "\u677F\u5757\u6392\u5E8F\u5B57\u6BB5\u5F02\u5E38",
  112072: "\u95E8\u6237\u540D\u79F0\u91CD\u590D\uFF0C\u8BF7\u66F4\u6362\u540E\u91CD\u8BD5",
  112073: "\u95E8\u6237\u521B\u5EFA\u5931\u8D25",
  112074: "\u4FEE\u6539\u5408\u4F5C\u4F19\u4F34\u5931\u8D25",
  112075: "\u95E8\u6237\u5220\u9664\u5931\u8D25",
  112076: "\u521B\u5EFA\u95E8\u6237\u6269\u5C55\u5931\u8D25",
  112077: "\u521B\u5EFA\u95E8\u6237\u7EDF\u8BA1\u6269\u5C55\u5931\u8D25",
  112078: "\u6BCF\u4E2A\u95E8\u6237\u6700\u5C11\u9700\u8981\u5305\u542B\u4E00\u4E2A\u677F\u5757",
  112079: "\u53EA\u80FD\u6709\u4E00\u4E2A\u9876\u90E8\u680F\u677F\u5757",
  112080: "\u53EA\u80FD\u6709\u4E94\u4E2A\u56FE\u7247\u5E7F\u544A\u677F\u5757",
  112081: "\u53EA\u80FD\u6709\u4E94\u4E2A\u5206\u7C7B\u5BFC\u822A\u677F\u5757",
  112082: "\u53EA\u80FD\u6709\u4E94\u4E2A\u56FE\u6587\u4ECB\u7ECD\u677F\u5757",
  112083: "\u53EA\u80FD\u6709\u4E09\u4E2A\u89C6\u9891\u9526\u96C6\u677F\u5757",
  112084: "\u53EA\u80FD\u6709\u4E09\u4E2A\u6D3B\u52A8\u5217\u8868\u677F\u5757",
  112085: "\u53EA\u80FD\u6709\u4E00\u4E2A\u5408\u4F5C\u4F19\u4F34\u677F\u5757",
  112086: "\u53EA\u80FD\u6709\u4E00\u4E2A\u8054\u7CFB\u6211\u4EEC\u677F\u5757",
  112087: "\u53EA\u80FD\u6709\u4E00\u4E2A\u5E95\u90E8\u680F\u677F\u5757",
  112088: "\u95E8\u6237\u5DF2\u4E0A\u67B6\uFF0C\u8BF7\u5148\u4E0B\u67B6\u518D\u5220\u9664",
  112090: "\u63D2\u5165\u79DF\u6237\u914D\u7F6E\u5931\u8D25",
  112091: "\u6700\u591A\u521B\u5EFA5\u4E2A\u95E8\u6237\uFF0C\u8BF7\u5148\u5347\u7EA7\u7248\u672C",
  112092: "\u6700\u591A\u521B\u5EFA20\u4E2A\u95E8\u6237",
  112093: "\u5A92\u4F53\u5E93\u5206\u8FA8\u7387\u8D85\u51FA\u6700\u5927\u9650\u5236",
  112094: "\u5BA2\u6237\u7F16\u53F7\u4E0D\u80FD\u4E3A\u7A7A",
  112095: "\u4FEE\u6539\u5BC6\u7801\u8FC7\u671F\u8BBE\u7F6E\u5F02\u5E38",
  112096: "\u66F4\u65B0\u79DF\u6237\u914D\u7F6E\u5931\u8D25",
  112097: "\u57FA\u7840\u7248\u672C\u79DF\u6237\u6743\u9650\u4E0D\u8DB3",
  112098: "\u521D\u59CB\u5316\u79DF\u6237\u914D\u7F6E\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  112201: "\u521D\u59CB\u5316\u79DF\u6237\u81EA\u5B9A\u4E49\u767B\u5F55\u9875\u914D\u7F6E\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  112202: "\u66F4\u65B0\u79DF\u6237\u81EA\u5B9A\u4E49\u767B\u5F55\u9875\u914D\u7F6E\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  112203: "\u4E0D\u5B58\u5728\u7684\u79DF\u6237\u81EA\u5B9A\u4E49\u767B\u5F55\u9875\u914D\u7F6E\u5931\u8D25",
  112204: "\u968F\u5E7B\u7A7A\u95F4\u670D\u52A1\u5C1A\u672A\u5F00\u901A\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
  112205: "\u968F\u5E7B\u7A7A\u95F4code\u4E0D\u5B58\u5728",
  112206: "\u8BF7\u5F00\u542F/\u5173\u95ED\u591A\u91CD\u767B\u5F55\u8BA4\u8BC1\u5F00\u5173",
  112207: "\u81F3\u5C11\u5F00\u542F\u4E00\u79CD\u8BA4\u8BC1\u65B9\u5F0F",
  112208: "\u591A\u91CD\u767B\u5F55\u8BA4\u8BC1\u5F00\u5173\u7684\u53D6\u503C\u8303\u56F4\u4E3A0~1",
  112209: "\u591A\u91CD\u767B\u5F55\u8BA4\u8BC1\u65B9\u5F0F\u7684\u53D6\u503C\u8303\u56F4\u4E3A0~1",
  112210: "\u4E0D\u5B58\u5728\u7684\u79DF\u6237\u914D\u7F6E",
  113e3: "\u521B\u5EFA\u534F\u4F5C\u8005\u5931\u8D25",
  113001: "\u4FEE\u6539\u534F\u4F5C\u8005\u5931\u8D25",
  113002: "\u5220\u9664\u534F\u4F5C\u8005\u5931\u8D25",
  113003: "\u65E0\u6548\u7684\u534F\u4F5C\u8005",
  113004: "\u521B\u5EFA\u6570\u91CF\u8D85\u8FC7\u4E0A\u9650",
  113005: "\u534F\u4F5C\u8005\u540D\u79F0\u5DF2\u5B58\u5728",
  114e3: "\u65E0\u6548\u7684\u67E5\u8BE2",
  114001: "\u521B\u5EFA\u901A\u77E5\u53D1\u9001\u8BB0\u5F55\u5931\u8D25",
  114002: "\u4FEE\u6539\u901A\u77E5\u53D1\u9001\u8BB0\u5F55\u5931\u8D25",
  114003: "\u65E0\u6548\u7684\u77ED\u4FE1\u6A21\u7248",
  115e3: "\u65E0\u6548\u7684\u4EA7\u54C1\u7248\u672C",
  115001: "\u66F4\u65B0\u4EA7\u54C1\u7248\u672C\u5931\u8D25",
  115002: "\u521B\u5EFA\u4EA7\u54C1\u7248\u672C\u5931\u8D25",
  115003: "\u65E0\u6548\u7684\u4EA7\u54C1\u7248\u672C\u529F\u80FD",
  115004: "\u7248\u672C\u72B6\u6001\u4E0D\u5141\u8BB8\u66F4\u6539",
  115005: "\u65E0\u6548\u7684\u8D44\u6E90\u5305",
  115006: "\u521B\u5EFA\u5957\u9910\u5931\u8D25",
  115007: "\u5957\u9910\u5305\u5185\u7684\u8D44\u6E90\u5305\u548C\u7248\u672C\u8BD5\u7528\u7C7B\u578B\u4E0E\u5957\u9910\u5305\u4E0D\u4E00\u81F4\uFF01",
  115008: "\u5957\u9910\u5305\u5185\u7684\u8D44\u6E90\u5305\u548C\u7248\u672C\u6709\u6548\u671F\u4E0E\u5957\u9910\u5305\u4E0D\u4E00\u81F4\uFF01",
  115009: "\u66F4\u65B0\u5957\u9910\u5931\u8D25",
  115010: "\u65E0\u6548\u7684\u5957\u9910",
  115011: "\u5957\u9910\u72B6\u6001\u4E0D\u5141\u8BB8\u66F4\u6539",
  115012: "\u65E0\u6548\u7684\u4EA7\u54C1\u7248\u672C\u64CD\u4F5C\u8BB0\u5F55",
  115013: "\u4EA7\u54C1\u7248\u672C\u4E0D\u5141\u8BB8\u4FEE\u6539",
  115014: "\u8BD5\u7528\u7248\u4EF7\u683C\u9700\u4E3A0",
  115015: "\u8D44\u6E90\u5305\u7F16\u53F7\u5DF2\u5B58\u5728",
  115016: "\u65E0\u6548\u7684\u8D44\u6E90",
  116001: "\u65E0\u6548\u7684\u5BA2\u6237\u7AEF\u7248\u672C",
  116002: "\u521B\u5EFA\u5BA2\u6237\u7AEF\u7248\u672C\u5931\u8D25",
  116003: "\u4FEE\u6539\u5BA2\u6237\u7AEF\u7248\u672C\u5931\u8D25",
  116004: "\u5220\u9664\u5BA2\u6237\u7AEF\u7248\u672C\u5931\u8D25",
  116005: "\u6784\u5EFA\u53F7\u4E0D\u5141\u8BB8\u91CD\u590D",
  117050: "\u521B\u5EFA\u623F\u95F4\u5F02\u5E38",
  117051: "\u4FEE\u6539\u623F\u95F4\u5F02\u5E38",
  117052: "\u5220\u9664\u623F\u95F4\u5F02\u5E38",
  117053: "\u65E0\u6548\u623F\u95F4",
  117054: "\u5F53\u524D\u76F4\u64AD\u5904\u4E8E\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u5207\u6362",
  117055: "\u623F\u95F4\u4E0D\u5728\u76F4\u64AD",
  117056: "\u5F53\u524D\u76F4\u64AD\u95F4\u5904\u4E8E\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u5220\u9664",
  117057: "\u4FEE\u6539\u76F4\u64AD\u72B6\u6001\u5931\u8D25",
  117058: "\u4E0E\u5F53\u524D\u76F4\u64AD\u65B9\u5F0F\u4E0D\u7B26",
  117059: "\u8C03\u7528\u817E\u8BAF\u4E91\u7ED3\u675F\u5F55\u5236\u5F02\u5E38",
  117060: "\u6DF7\u6D41\u5E03\u5C40\u5F02\u5E38",
  117061: "\u4E91\u76F4\u64AD\u6DF7\u6D41\u5E03\u5C40\u5F02\u5E38",
  117062: "\u623F\u95F4\u914D\u7F6E\u4E3A\u4E0D\u4F7F\u7528\u8FDE\u9EA6",
  117063: "\u4E0A\u573A\u76F4\u64AD\u6B63\u5728\u7EDF\u8BA1\u7ED3\u679C\uFF0C\u8BF7\u7A0D\u540E\u5F00\u64AD",
  117064: "\u5F53\u524D\u76F4\u64AD\u95F4\u5904\u4E8E\u5B9A\u65F6\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u5220\u9664",
  117065: "\u5F53\u524D\u76F4\u64AD\u5904\u4E8E\u5B9A\u65F6\u4E2D\uFF0C\u4E0D\u652F\u6301\u5207\u6362",
  117066: "\u65E0\u6548\u623F\u95F4\u72B6\u6001",
  117067: "\u6D3B\u52A8\u53C2\u6570\u4E0D\u80FD\u4E3A\u7A7A",
  117068: "\u6D3B\u52A8\u521B\u5EFA\u76F4\u64AD\u623F\u95F4\u6700\u592750\u4E2A",
  117069: "\u6D3B\u52A8\u521B\u5EFA\u4F1A\u8BAE\u623F\u95F4\u6700\u592750\u4E2A",
  117070: "\u65E0\u6548\u7684\u623F\u95F4\u6A21\u5F0F",
  117080: "\u65E0\u6548\u6D41",
  117081: "\u6682\u65E0\u76F4\u64AD\u6D41\uFF0C\u8BF7\u63A8\u6D41\u540E\u518D\u5F00\u59CB\u76F4\u64AD",
  117120: "\u65E0\u6548\u623F\u95F4\u914D\u7F6E",
  117121: "\u521B\u5EFA\u623F\u95F4\u914D\u7F6E\u5931\u8D25",
  117122: "\u4FEE\u6539\u623F\u95F4\u914D\u7F6E\u5931\u8D25",
  117160: "\u65E0\u6548\u5206\u7C7B",
  117161: "\u5206\u7C7B\u540D\u79F0\u4E0D\u53EF\u91CD\u590D",
  117162: "\u5206\u7C7B\u5C42\u6570\u8D85\u8FC7\u6700\u5927\u9650\u5236",
  117163: "\u4E00\u7EA7\u5206\u7C7B\u4E2A\u6570\u8D85\u8FC7\u6700\u5927\u9650\u5236",
  117164: "\u5B50\u7EA7\u5206\u7C7B\u4E2A\u6570\u8D85\u8FC7\u6700\u5927\u9650\u5236",
  117165: "\u4FEE\u6539\u5206\u7C7B\u662F\u5426\u6709\u5B50\u8282\u70B9\u5931\u8D25",
  117166: "\u4FEE\u6539\u5206\u7C7B\u5931\u8D25",
  117167: "\u5220\u9664\u5206\u7C7B\u5931\u8D25",
  117168: "\u5DF2\u662F\u7B2C\u4E00\u4F4D\uFF0C\u4E0D\u80FD\u518D\u4E0A\u79FB",
  117169: "\u5DF2\u662F\u6700\u540E\u4E00\u4F4D\uFF0C\u4E0D\u80FD\u518D\u4E0B\u79FB",
  117170: "\u5206\u7C7B\u4E0A\u79FB\u5931\u8D25",
  117171: "\u5206\u7C7B\u4E0B\u79FB\u5931\u8D25",
  117172: "\u4FEE\u6539\u623F\u95F4\u6807\u7B7E\u5931\u8D25",
  117200: "\u62C9\u6D41\u76F4\u64AD\u6B63\u5728\u76F4\u64AD\u4E2D",
  117201: "\u62C9\u6D41\u76F4\u64AD\u672A\u5728\u76F4\u64AD",
  117202: "\u521B\u5EFA\u62C9\u6D41\u76F4\u64AD\u5931\u8D25",
  117203: "\u4FEE\u6539\u62C9\u6D41\u76F4\u64AD\u5931\u8D25",
  117210: "\u65E0\u6548\u5217\u8868",
  117211: "\u521B\u5EFA\u5217\u8868\u5931\u8D25",
  117212: "\u4FEE\u6539\u5217\u8868\u5931\u8D25",
  117213: "\u5220\u9664\u5217\u8868\u5931\u8D25",
  117214: "\u5217\u8868\u6B63\u5728\u76F4\u64AD\u4E2D",
  117215: "\u5217\u8868\u672A\u5728\u76F4\u64AD",
  117216: "\u5217\u8868\u4E2D\u65E0\u89C6\u9891",
  117217: "\u5DF2\u6709\u5217\u8868\u8BBE\u7F6E\u5B9A\u65F6\u76F4\u64AD\uFF0C\u8BF7\u5148\u53D6\u6D88\u5B9A\u65F6\u76F4\u64AD",
  117218: "\u5217\u8868\u672A\u8BBE\u7F6E\u5B9A\u65F6\u76F4\u64AD",
  117219: "\u4FEE\u6539\u5FAA\u73AF\u64AD\u653E\u72B6\u6001\u5931\u8D25",
  117220: "\u5B9A\u65F6\u76F4\u64AD\u65F6\u95F4\u5E94\u5927\u4E8E\u5F53\u524D\u65F6\u95F4",
  117221: "\u5B9A\u65F6\u76F4\u64AD\u65F6\u95F4\u5DF2\u4FEE\u6539",
  117222: "\u5B9A\u65F6\u76F4\u64AD\u65F6\u95F4\u672A\u4FEE\u6539",
  117230: "\u65E0\u6548\u8282\u76EE",
  117231: "\u521B\u5EFA\u8282\u76EE\u5931\u8D25",
  117232: "\u89C6\u9891\u5DF2\u5728\u76F4\u64AD\u4E2D",
  117233: "\u89C6\u9891\u672A\u5728\u76F4\u64AD",
  117240: "\u521B\u5EFA\u76F4\u64AD\u4EFB\u52A1\u5931\u8D25",
  117241: "\u9875\u9762\u672A\u521D\u59CB\u5316\u5B8C\u6BD5,\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  117242: "\u5F00\u59CB\u76F4\u64AD\u5931\u8D25",
  117243: "\u64AD\u5355\u4E2D\u7684\u753B\u9762\u65E0\u89C6\u9891\u6D41\uFF0C\u8BF7\u68C0\u67E5\u540E\u518D\u4F7F\u7528",
  117272: "\u65E0\u6548\u7684\u76F4\u64AD\u4FE1\u606F",
  117273: "\u65E0\u6548\u573A\u6B21",
  117274: "\u521B\u5EFA\u573A\u6B21\u5931\u8D25",
  117275: "\u4FEE\u6539\u573A\u6B21\u5931\u8D25",
  117300: "\u5F00\u542F\u767D\u677F\u63A8\u6D41\u53C2\u6570\u65E0\u6548",
  117301: "\u817E\u8BAF\u4E91\u5F00\u542F\u767D\u677F\u63A8\u6D41\u63A5\u53E3\u5F02\u5E38",
  117302: "\u65E0\u6548\u767D\u677F\u63A8\u6D41\u4EFB\u52A1",
  117303: "\u8C03\u7528\u817E\u8BAF\u4E91\u5173\u95ED\u767D\u677F\u63A8\u6D41\u63A5\u53E3\u5F02\u5E38",
  117304: "\u4FEE\u6539\u767D\u677F\u4EFB\u52A1\u5F02\u5E38",
  117305: "\u65E0\u623F\u95F4\u4FE1\u606F",
  117306: "\u5F53\u524D\u623F\u95F4\u6CA1\u6709\u5F00\u542F\u767D\u677F\u63A8\u6D41",
  117307: "\u5F53\u524D\u623F\u95F4\u5DF2\u7ECF\u5F00\u542F\u767D\u677F\u63A8\u6D41",
  117308: "\u65E0\u6548\u7684\u623F\u95F4\u6570\u636E",
  117309: "\u5F53\u524D\u623F\u95F4\u6CA1\u6709\u627E\u5230\u6D41",
  117310: "\u65E0\u6548\u7684\u6587\u6863\u6216\u8DEF\u5F84",
  117311: "\u6587\u6863\u4E0A\u4F20\u5931\u8D25",
  117312: "\u4E0A\u4F20\u6587\u6863\u957F\u5EA6\u8D85\u51FA\u9650\u5236",
  117313: "\u4E0A\u4F20\u683C\u5F0F\u9519\u8BEF",
  117314: "\u6587\u6863\u8BB0\u5F55\u4FEE\u6539\u5931\u8D25",
  117315: "\u521B\u5EFA\u6587\u6863\u8BB0\u5F55\u5F02\u5E38",
  117316: "\u65E0\u6548\u7684\u6587\u6863\u8BB0\u5F55",
  117317: "\u5F53\u524D\u72B6\u6001\u4E0D\u80FD\u5220\u9664",
  117318: "\u5220\u9664\u6587\u6863\u8BB0\u5F55\u5F02\u5E38",
  117319: "\u540C\u65F6\u53EA\u80FD\u4F7F\u7528\u4E00\u4E2A\u6587\u6863",
  117320: "\u91CD\u65B0\u8F6C\u7801\u5F02\u5E38",
  117321: "\u5F53\u524D\u6587\u6863\u672A\u8F6C\u7801\u6210\u529F",
  117322: "\u83B7\u53D6\u7F51\u7EDC\u8D44\u6E90\u5F02\u5E38",
  117323: "\u521B\u5EFA\u8F6C\u7801\u4EFB\u52A1\u5F02\u5E38",
  117324: "\u804A\u5929\u68C0\u67E5\u529F\u80FD\u5F00\u542F\u4F9D\u8D56\u4E8E\u804A\u5929\u529F\u80FD\u5F00\u542F",
  117325: "\u5F39\u5E55\u5BA1\u6838\u529F\u80FD\u5F00\u542F\u4F9D\u8D56\u4E8E\u5F39\u5E55\u529F\u80FD\u5F00\u542F",
  117326: "\u89C2\u770B\u9875\u672A\u5141\u8BB8\u5C55\u793A\u76F4\u64AD\u753B\u9762",
  117327: "\u5F53\u524D\u623F\u95F4\u5DF2\u7ECF\u662F\u4E3B\u4F1A\u573A",
  117328: "\u4E3B\u4F1A\u573A\u4E0D\u652F\u6301\u5220\u9664",
  117329: "\u623F\u95F4\u70B9\u8D5E\u6570\u636E\u5F02\u5E38",
  117330: "\u6CA1\u6709\u4E3B\u4F1A\u573A\uFF0C\u8BF7\u5148\u521B\u5EFA\u4E3B\u4F1A\u573A",
  117331: "\u623F\u95F4\u4E0D\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u4E3B\u529E\u65B9",
  117332: "\u76F4\u64AD\u573A\u666F\u4E0D\u80FD\u4FEE\u6539",
  117333: "\u4E0D\u53EF\u66F4\u6539\u76F4\u64AD\u5EF6\u65F6",
  117334: "\u623F\u95F4\u6A21\u5F0F\u9519\u8BEF",
  117335: "\u521B\u5EFA\u56DE\u8C03\u6A21\u677F\u9519\u8BEF",
  117336: "\u4FEE\u6539\u56DE\u8C03\u6A21\u677F\u9519\u8BEF",
  117340: "\u65E0\u6548\u7684\u56FE\u6587\u76F4\u64AD",
  117341: "\u521B\u5EFA\u56FE\u6587\u76F4\u64AD\u5F02\u5E38",
  117342: "\u7F16\u8F91\u56FE\u6587\u76F4\u64AD\u5F02\u5E38",
  117343: "\u5220\u9664\u56FE\u6587\u76F4\u64AD\u5F02\u5E38",
  117344: "\u56FE\u6587\u76F4\u64AD\u5DF2\u5F00\u542F\uFF0C\u65E0\u9700\u91CD\u590D\u5F00\u542F",
  117345: "\u56FE\u6587\u76F4\u64AD\u5DF2\u5173\u95ED\uFF0C\u65E0\u9700\u91CD\u590D\u5173\u95ED",
  117346: "liveDelay \u7684\u53D6\u503C\u8303\u56F4\u662F1-2",
  117347: "\u76F4\u64AD\u5F00\u59CB\u65F6\u95F4\u65E9\u4E8E\u5F53\u524D\u65F6\u95F4",
  117348: "\u7ED3\u675F\u65F6\u95F4\u4E0D\u5F97\u65E9\u4E8E\u5F00\u59CB\u65F6\u95F4",
  117349: "\u5F00\u59CB\u65F6\u95F4\u6216\u7ED3\u675F\u65F6\u95F4\u683C\u5F0F\u9519\u8BEF",
  117350: "\u7B7E\u5230\u5DF2\u5F00\u542F\uFF0C\u65E0\u9700\u91CD\u590D\u5F00\u542F",
  117351: "\u7B7E\u5230\u5DF2\u5173\u95ED\uFF0C\u65E0\u9700\u91CD\u590D\u5173\u95ED",
  117352: "\u7B7E\u5230\u5F00\u542F\u5931\u8D25",
  117353: "\u7B7E\u5230\u5173\u95ED\u5931\u8D25",
  117354: "\u8BDD\u9898\u4E92\u52A8\u5DF2\u5F00\u542F\uFF0C\u65E0\u9700\u91CD\u590D\u5F00\u542F",
  117355: "\u8BDD\u9898\u4E92\u52A8\u5DF2\u5173\u95ED\uFF0C\u65E0\u9700\u91CD\u590D\u5173\u95ED",
  117356: "\u8BDD\u9898\u4E92\u52A8\u5F00\u542F\u5931\u8D25",
  117357: "\u8BDD\u9898\u4E92\u52A8\u5173\u95ED\u5931\u8D25",
  117358: "\u8C03\u7528\u817E\u8BAF\u4E91\u5F00\u542F\u65C1\u8DEF\u63A8\u6D41\u63A5\u53E3\u5F02\u5E38",
  117359: "\u8C03\u7528\u817E\u8BAF\u4E91\u5173\u95ED\u65C1\u8DEF\u63A8\u6D41\u63A5\u53E3\u5F02\u5E38",
  117360: "\u65E0\u6548\u65C1\u8DEF\u63A8\u6D41\u4EFB\u52A1",
  117361: "\u8C03\u7528\u817E\u8BAF\u4E91\u66F4\u65B0\u65C1\u8DEF\u63A8\u6D41\u63A5\u53E3\u5F02\u5E38",
  117362: "\u76F4\u64AD\u6B63\u5728\u5F00\u542F\u4E2D, \u8BF7\u7A0D\u540E\u518D\u8BD5",
  117363: "\u5F53\u524D\u76F4\u64AD\u5904\u4E8E\u51C6\u5907\u4E2D\uFF0C\u4E0D\u652F\u6301\u5207\u6362",
  117364: "\u62C9\u6D41\u76F4\u64AD\u65E0\u6CD5\u521B\u5EFA0\u5EF6\u65F6",
  117996: "\u963F\u91CC\u4E91\u6587\u6863\u4E0A\u4F20\uFF1A\u6587\u4EF6\u5927\u5C0F\u5F02\u5E38",
  117997: "\u751F\u6210ID\u5C0F\u4E8E0",
  117998: "\u6682\u65E0",
  118001: "\u521B\u5EFA\u6D41\u76D1\u63A7\u6570\u636E\u5F02\u5E38",
  118002: "\u4FEE\u6539\u623F\u95F4\u5F02\u5E38",
  118003: "\u5220\u9664\u623F\u95F4\u5F02\u5E38",
  120001: "\u65E0\u6548\u623F\u95F4",
  120002: "\u521B\u5EFA\u591A\u5217\u8868\u5F02\u5E38",
  120003: "\u65E0\u6548\u62C9\u6D41\u5217\u8868",
  120004: "\u4FEE\u6539\u62C9\u6D41\u5217\u8868\u5F02\u5E38",
  120005: "\u5F53\u524D\u623F\u95F4\u76F4\u64AD\u65B9\u5F0F\u5F02\u5E38",
  120006: "\u623F\u95F4\u72B6\u6001\uFF0C\u573A\u666F\u9A8C\u8BC1\u672A\u901A\u8FC7",
  120007: "\u5F53\u524D\u623F\u95F4\u72B6\u6001\u4E0D\u80FD\u53D6\u6D88\u5B9A\u65F6",
  120008: "\u5F53\u524D\u623F\u95F4\u5B58\u5728\u5B9A\u65F6\u5217\u8868",
  120009: "\u91CD\u590D\u5F00\u542F\u5B9A\u65F6",
  120010: "\u521B\u5EFA\u62C9\u6D41\u8BE6\u60C5\u5F02\u5E38",
  120011: "\u4FEE\u6539\u62C9\u6D41\u4EFB\u52A1\u5F02\u5E38",
  120012: "\u5220\u9664\u62C9\u6D41\u4EFB\u52A1\u5F02\u5E38",
  120013: "\u79FB\u52A8ID\u4E3A\u7A7A",
  120014: "front ID\u4E3A\u7A7A",
  120015: "\u5217\u8868\u4EFB\u52A1\u6392\u5E8F\u5F02\u5E38",
  120016: "\u62C9\u6D41\u76F4\u64AD\u4E0D\u652F\u6301\u6279\u91CF\u65B0\u589E",
  120017: "\u6279\u91CF\u65B0\u589E\u8D85\u51FA\u6700\u5927\u9650\u5236",
  120018: "\u6682\u65E0\u53EF\u7528\u62C9\u6D41\u6E90",
  120019: "\u5F53\u524D\u623F\u95F4\u72B6\u6001\u4E0D\u80FD\u5F00\u59CB\u76F4\u64AD",
  120020: "\u5F53\u524D\u623F\u95F4\u76F4\u64AD\u573A\u666F\u4E0D\u6B63\u786E",
  120021: "\u5F00\u59CB\u62C9\u6D41\u76F4\u64AD\u5F02\u5E38",
  120022: "\u83B7\u53D6\u62C9\u6D41\u4EFB\u52A1\u5217\u8868\u5F02\u5E38",
  120023: "\u5F53\u524D\u623F\u95F4\u72B6\u6001\u4E0D\u80FD\u7ED3\u675F\u76F4\u64AD",
  120024: "\u7ED3\u675F\u62C9\u6D41\u76F4\u64AD\u5F02\u5E38",
  120025: "\u67E5\u8BE2\u5A92\u4F53\u5E93\u5F02\u5E38",
  120026: "\u5A92\u4F53\u5E93\u5206\u8FA8\u7387\u8D85\u51FA\u6700\u5927\u9650\u5236",
  120027: "\u62C9\u6D41\u6E90\u65E0\u6548",
  120028: "\u62C9\u6D41\u6E90\u65E0\u6548",
  120029: "\u5904\u7406\u6CA1\u6709\u6536\u5230\u65AD\u6D41\u56DE\u8C03\u5F02\u5E38",
  120030: "\u65E0\u6548\u62C9\u6D41\u5730\u5740",
  120031: "\u65E0\u6548\u5B9A\u65F6\u65F6\u95F4",
  120032: "\u8D85\u51FA\u6700\u5927\u64AD\u653E\u65F6\u957F\u9650\u5236 \u9650\u5236\u4E3A5\u5929",
  120033: "\u5F00\u59CB/\u7ED3\u675F\u65F6\u95F4\u5F02\u5E38",
  120034: "\u5F00\u59CB\u65F6\u95F4\u8981\u65E9\u4E0E\u7ED3\u675F\u65F6\u95F4",
  120035: "\u817E\u8BAF\u4E91\u56DE\u8C03\u4EFB\u52A1id\u548C\u5F53\u524D\u4EFB\u52A1id\u4E0D\u5339\u914D",
  120036: "\u65E0\u6548\u7684\u623F\u95F4\u7C7B\u578B",
  120037: "\u64AD\u653E\u65F6\u957F\u5F02\u5E38",
  120038: "\u63D0\u4EA4\u5A92\u4F53\u5E93\u6587\u4EF6\u91CD\u590D",
  120039: "\u89C6\u9891\u5217\u8868\u5B58\u5728\u6B63\u5728\u68C0\u6D4B\u4E2D\u7684\u89C6\u9891",
  120040: "\u89C6\u9891\u5217\u8868\u5B58\u5728\u672A\u68C0\u6D4B\u6210\u529F\u7684\u89C6\u9891",
  120041: "\u7ED3\u675F\u65F6\u95F4\u9700\u6BD4\u5F00\u59CB\u65F6\u95F4\u665A10\u5206\u949F\u4EE5\u4E0A",
  120042: "\u62C9\u6D41\u4EFB\u52A1\u4E0D\u5B58\u5728",
  120043: "\u5904\u7406\u5217\u8868\u76F4\u64AD\u56DE\u8C03\uFF0C\u4FEE\u6539\u6570\u636E\u5931\u8D25",
  120044: "\u6DFB\u52A0\u89C6\u9891\u5F02\u5E38\uFF0C\u89C6\u9891\u65F6\u957F\u5F02\u5E38",
  120045: "\u5F53\u524D\u623F\u95F4\u76F4\u64AD\u65B9\u5F0F\u4E0D\u6B63\u786E",
  121e3: "\u65E0\u6548\u7684\u6587\u4EF6\u7C7B\u578B",
  121001: "\u9ED8\u8BA4\u8BCD\u5E93\u6570\u636E\u4E3A\u7A7A",
  121002: "\u4FEE\u6539\u9ED8\u8BA4\u8BCD\u5E93\u5931\u8D25",
  121003: "\u81EA\u5EFA\u654F\u611F\u8BCD\u91CD\u590D",
  121004: "\u521B\u5EFA\u654F\u611F\u8BCD\u5931\u8D25",
  121005: "\u5220\u9664\u654F\u611F\u8BCD\u5931\u8D25",
  121006: "\u4FEE\u6539\u654F\u611F\u8BCD\u5931\u8D25",
  121007: "\u65E0\u6548\u7684\u654F\u611F\u8BCD",
  121008: "\u65E0\u6CD5\u5220\u9664\u975E\u81EA\u5EFA\u654F\u611F\u8BCD\u7C7B\u578B",
  121009: "\u6587\u4EF6\u5927\u5C0F\u8D85\u51FA\u9650\u5236",
  121010: "\u6587\u4EF6\u6570\u636E\u8D85\u51FA5000\u6761",
  121011: "\u6587\u4EF6\u89E3\u6790\u5931\u8D25",
  121012: "\u81EA\u5EFA\u654F\u611F\u8BCD\u603B\u6570\u8D85\u51FA\u9650\u5236",
  121013: "\u65E0\u6548\u7684\u79DF\u6237",
  121014: "\u79DF\u6237\u53C2\u6570\u7F3A\u5931",
  121015: "\u5B50\u7EBF\u7A0B\u521B\u5EFA\u79DF\u6237\u4F01\u4E1A\u654F\u611F\u8BCD\u5931\u8D25",
  121016: "\u5B50\u7EBF\u7A0B\u521B\u5EFA\u9ED8\u8BA4\u654F\u611F\u8BCD\u5931\u8D25",
  121017: "\u65B0\u6635\u79F0\u5305\u542B\u8FDD\u89C4\u5185\u5BB9,\u8BF7\u4FEE\u6539\u540E\u91CD\u8BD5",
  121018: "\u60A8\u53D1\u9001\u7684\u5185\u5BB9\u5B58\u5728\u8FDD\u89C4\u5185\u5BB9,\u8BF7\u4FEE\u6539\u540E\u91CD\u8BD5",
  121019: '\u60A8\u53D1\u9001\u7684\u6587\u5B57\u5305\u542B"%s"\u8FDD\u89C4\u5185\u5BB9',
  122001: "\u65E0\u6548\u7684\u4EBA\u5458\u4FE1\u606F",
  122002: "\u521B\u5EFA\u53C2\u4E0E\u8005\u5931\u8D25",
  122003: "\u4FEE\u6539\u53C2\u4E0E\u8005\u5931\u8D25",
  122004: "\u79FB\u9664\u53C2\u4E0E\u8005\u5931\u8D25",
  122005: "\u624B\u673A\u53F7\u672A\u62A5\u540D\uFF0C\u8BF7\u524D\u5F80\u62A5\u540D",
  122006: "\u60A8\u5DF2\u88AB\u7981\u6B62\u53C2\u4E0E\u672C\u6D3B\u52A8",
  122007: "\u8BE5\u624B\u673A\u53F7\u5DF2\u62A5\u540D\uFF0C\u8BF7\u52FF\u91CD\u590D\u62A5\u540D",
  122008: "\u624B\u673A\u3001\u90AE\u7BB1\u81F3\u5C11\u586B\u5199\u4E00\u9879",
  122009: "\u8BF7\u9009\u62E9\u4E00\u5F20\u95E8\u7968",
  122010: "\u8BE5\u4EBA\u5458\u5DF2\u5B58\u5728",
  122011: "\u672A\u62A5\u540D\u8BE5\u6D3B\u52A8",
  122012: "\u5220\u9664\u5609\u5BBE\u5931\u8D25",
  122013: "\u8BF7\u52FF\u91CD\u590D\u62A5\u540D",
  122014: "\u6570\u91CF\u8D85\u8FC7500\u6761\uFF0C\u8BF7\u5206\u6279\u6B21\u4E0A\u4F20",
  122015: "\u6587\u6863\u4E0D\u7B26\u5408\u5BFC\u5165\u89C4\u8303\uFF0C\u8BF7\u6309\u7167EXCEL\u6587\u6863\u6A21\u7248\u89C4\u8303\u64CD\u4F5C",
  122016: "\u89C2\u4F17\u5BA1\u6838\u72B6\u6001\u5F02\u5E38",
  122017: "\u62A5\u540D\u767B\u5F55/\u5916\u90E8\u6388\u6743\u89C2\u4F17\u4E0D\u652F\u6301\u5220\u9664",
  123001: "\u65E0\u6548\u7684\u623F\u95F4\u6388\u6743\u89C2\u770B\u914D\u7F6E",
  123002: "\u4FEE\u6539\u623F\u95F4\u6388\u6743\u89C2\u770B\u914D\u7F6E\u5931\u8D25",
  123003: "\u6E05\u7A7A\u624B\u673A\u767D\u540D\u5355\u5931\u8D25",
  123004: "\u89C2\u4F17\u767D\u540D\u5355\u4E2D\u7528\u6237\u540D\u91CD\u590D",
  123005: "\u62C9\u53D6\u767D\u540D\u5355excel\u5931\u8D25",
  123006: "\u7528\u6237\u540D\u4E0D\u80FD\u4E3A\u7A7A",
  123007: "tenantId\u53C2\u6570\u7F3A\u5931",
  123008: "roomId\u53C2\u6570\u7F3A\u5931",
  123009: "\u96F6\u5EF6\u65F6/\u5168\u7403\u52A0\u901F\u623F\u95F4\u65E0\u6CD5\u5F00\u542F\u591A\u7EBF\u8DEF",
  124001: "\u65E0\u6548\u7684\u8FDE\u9EA6\u914D\u7F6E",
  124002: "\u521B\u5EFA\u8FDE\u9EA6\u914D\u7F6E\u5931\u8D25",
  124003: "\u751F\u6210\u8FDE\u9EA6\u914D\u7F6EID\u5931\u8D25",
  124004: "\u8FDE\u9EA6\u603B\u5F00\u5173\u5DF2\u5173\u95ED\uFF0C\u4E0D\u5141\u8BB8\u64CD\u4F5C",
  124005: "\u5609\u5BBE\u8FDE\u9EA6\u5F00\u5173\u5DF2\u5173\u95ED\uFF0C\u4E0D\u5141\u8BB8\u64CD\u4F5C",
  124006: "\u5609\u5BBE\u8FDE\u9EA6\u6A21\u5F0F\u5DF2\u7F6E\u4E3A\u7533\u8BF7\u6A21\u5F0F",
  124007: "\u89C2\u4F17\u7533\u8BF7\u8FDE\u9EA6\u5F00\u5173\u5DF2\u5173\u95ED\uFF0C\u4E0D\u5141\u8BB8\u64CD\u4F5C",
  124008: "\u52A9\u7406\u4E0D\u80FD\u8FDE\u9EA6",
  124009: "\u4FEE\u6539\u53C2\u6570\u914D\u7F6E\u5931\u8D25",
  124010: "\u4EC5\u4E3B\u8BB2\u4EBA\u53EF\u4EE5\u64CD\u4F5C\u5171\u4EAB\u5C4F\u5E55",
  124011: "\u8BF7\u52FF\u91CD\u590D\u64CD\u4F5C\u5171\u4EAB\u5C4F\u5E55",
  124012: "\u7528\u6237\u8F93\u51FA\u72B6\u6001\u5DF2\u662F\u53D6\u6D88\u8F93\u51FA\u6216\u8F93\u51FA",
  124013: "\u521B\u5EFA\u8FDE\u9EA6\u7528\u6237\u5931\u8D25",
  124014: "\u4FEE\u6539\u8FDE\u9EA6\u7528\u6237\u5931\u8D25",
  124015: "\u7528\u6237\u5DF2\u662F\u4E3B\u8BB2\u4EBA",
  124016: "\u64CD\u4F5C\u4EBA\u975E\u4E3B\u6301\u4EBA",
  124017: "\u539F\u4E3B\u8BB2\u4EBA\u4E0D\u5B58\u5728",
  124018: "\u7528\u6237\u5DF2\u5728\u8FDE\u9EA6\u72B6\u6001",
  124019: "\u4E0D\u80FD\u8BBE\u7F6E\u89C2\u4F17\u4E3A\u4E3B\u8BB2\u4EBA",
  124020: "\u7528\u6237\u5DF2\u5728\u8FDE\u9EA6\u72B6\u6001",
  124021: "\u4FEE\u6539\u8FDE\u9EA6\u914D\u7F6E\u5931\u8D25",
  124022: "\u65E0\u6548\u7684\u8FDE\u9EA6\u7528\u6237",
  124023: "\u7528\u6237\u672A\u5728\u8FDE\u9EA6\u72B6\u6001",
  124030: "\u521B\u5EFA\u8FDE\u9EA6\u64CD\u4F5C\u8BB0\u5F55\u5931\u8D25",
  124031: "\u521B\u5EFA\u6DF7\u6D41\u8BB0\u5F55\u5931\u8D25",
  124032: "\u65E0\u6548\u7684\u6D3B\u52A8\u5F55\u5236",
  124033: "\u521B\u5EFA\u6D3B\u52A8\u5F55\u5236\u5931\u8D25",
  124034: "\u4FEE\u6539\u6D3B\u52A8\u5F55\u5236\u5931\u8D25",
  124035: "\u67E5\u8BE2\u67D0\u5929\u573A\u6B21\u6570\u636E\u53C2\u6570\u4E3A\u7A7A",
  124040: "\u76F4\u64AD\u4E2D\u4E0D\u80FD\u4FEE\u6539\u81EA\u52A8\u5F55\u5236\u5F00\u5173",
  124041: "\u4FEE\u6539\u81EA\u52A8\u5F55\u5236\u5931\u8D25",
  124050: "\u65E0\u6548\u7684\u8FDE\u9EA6\u8BF7\u6C42\u8BB0\u5F55",
  124051: "\u521B\u5EFA\u8FDE\u9EA6\u8BF7\u6C42\u8BB0\u5F55\u5931\u8D25",
  124052: "\u4FEE\u6539\u8FDE\u9EA6\u8BF7\u6C42\u8BB0\u5F55\u5931\u8D25",
  124053: "\u4E3B\u6301\u4EBA\u672A\u8FDE\u9EA6",
  124054: "\u8FDE\u9EA6\u8BF7\u6C42\u5DF2\u5904\u7406",
  124055: "\u7528\u6237\u4E0E\u8FDE\u9EA6\u8BF7\u6C42\u7528\u6237\u4E0D\u4E00\u81F4",
  124056: "\u8FDE\u9EA6\u4EBA\u6570\u5DF2\u6EE1",
  124057: "\u8FDE\u9EA6\u6A21\u5F0F\u5DF2\u7F6E\u4E3A\u7533\u8BF7\u6A21\u5F0F",
  124058: "linkRequestId \u662F\u5FC5\u586B\u9879",
  124059: "\u8FDE\u9EA6\u8BF7\u6C42\u672A\u540C\u610F",
  124060: "\u5F53\u524D\u5B58\u5728\u8FDE\u9EA6\u7528\u6237\uFF0C\u4E0D\u5141\u8BB8\u5173\u95ED",
  124061: "\u5F53\u524D\u5B58\u5728\u8FDE\u9EA6\u7533\u8BF7/\u9080\u8BF7\uFF0C\u4E0D\u5141\u8BB8\u5173\u95ED",
  124062: "\u7528\u6237\u4E0D\u5B58\u5728",
  124065: "\u7C7B\u578B\u4E0E\u8FDE\u9EA6\u8BF7\u6C42\u7C7B\u578B\u4E0D\u4E00\u81F4",
  124067: "\u4EC5\u5609\u5BBE\u4E0E\u5177\u540D\u89C2\u4F17\u53EF\u4EE5\u8FDE\u9EA6\u7533\u8BF7",
  124068: "\u5DF2\u53D1\u8D77\u8FDE\u9EA6\u7533\u8BF7\u6216\u5DF2\u8FDE\u9EA6",
  124069: "\u5DF2\u5B58\u5728\u8FDE\u9EA6\u8BF7\u6C42\u6216\u5DF2\u8FDE\u9EA6",
  124070: "\u5609\u5BBE\u672A\u4E0A\u7EBF",
  124071: "\u4EC5\u53EF\u4EE5\u5BF9\u5609\u5BBE\u8FDE\u9EA6\u9080\u8BF7",
  124072: "\u5F53\u524D\u4EBA\u6570\u5DF2\u6EE1\uFF0C\u8BF7\u7A0D\u5019\u518D\u8BD5",
  124073: "\u8FDE\u9EA6\u7533\u8BF7\u8D85\u65F6\uFF0C\u8BF7\u91CD\u65B0\u7533\u8BF7",
  124074: "\u8FDE\u9EA6\u8BF7\u6C42\u7ED3\u679C\u9519\u8BEF\uFF0C\u4E0D\u80FD\u7528\u4E8E\u8FDE\u9EA6",
  124075: "\u8BF7\u52FF\u9891\u7E41\u7533\u8BF7\u8FDE\u9EA6",
  124076: "\u6DF7\u6D41\u5931\u8D25\uFF0C\u817E\u8BAF\u4E91\u623F\u95F4\u4E0D\u5B58\u5728",
  124077: "\u6DF7\u6D41\u5931\u8D25",
  124078: "\u4EC5\u4E3B\u6301\u4EBA\u53EF\u4EE5\u5168\u4F53\u9759\u97F3",
  124079: "\u8FDE\u9EA6\u8BF7\u6C42\u6D88\u606F\u7C7B\u578B\u672A\u8BBE\u7F6E",
  124080: "\u8FDE\u9EA6\u72B6\u6001\u672A\u8BBE\u7F6E",
  124081: "\u521B\u5EFA\u8FDE\u9EA6\u8F93\u51FA\u8BB0\u5F55\u5931\u8D25",
  124082: "\u4FEE\u6539\u8FDE\u9EA6\u8F93\u51FA\u8BB0\u5F55\u5931\u8D25",
  124083: "\u4EC5\u4E3B\u8BB2\u4EBA\u80FD\u8BBE\u7F6E\u5E03\u5C40",
  124084: "\u65E0\u6548\u7684\u8FDE\u9EA6\u64CD\u4F5C\u8BB0\u5F55",
  124085: "\u521B\u5EFA\u8FDE\u9EA6\u64CD\u4F5C\u8BB0\u5F55\u5931\u8D25",
  124086: "\u4FEE\u6539\u8FDE\u9EA6\u64CD\u4F5C\u8BB0\u5F55\u5931\u8D25",
  124087: "\u8BF7\u52FF\u9891\u7E41\u5BF9\u8BE5\u7528\u6237\u64CD\u4F5C",
  124088: "\u8BE5\u64CD\u4F5C\u5DF2\u8FC7\u671F",
  124089: "\u7528\u6237\u4E0E\u8FDE\u9EA6\u8BF7\u6C42\u7528\u6237\u4E0D\u4E00\u81F4",
  124090: "\u5171\u4EAB\u5C4F\u5E55\u5931\u8D25",
  124091: "\u5F53\u524D\u8FDE\u9EA6\u5DF2\u88AB\u6302\u65AD",
  124092: "\u5F53\u524D\u6B63\u5728\u8FDE\u9EA6\u4E2D\uFF0C\u4E0D\u5141\u8BB8\u5207\u6362\u8D85\u6E05\u8FDE\u9EA6\u5F00\u5173",
  124093: "\u7528\u6237\u6B63\u5728\u8FDE\u9EA6\u4E2D, \u8BF7\u7A0D\u540E\u518D\u8BD5",
  124094: "\u64CD\u4F5C\u5931\u8D25\uFF0C\u8BF7\u5148\u8FDE\u9EA6\u540E\u518D\u64CD\u4F5C",
  124095: "\u4E0A\u4E2A\u64CD\u4F5C\u8FDB\u884C\u4E2D\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  124096: "\u8BF7\u52FF\u91CD\u590D\u64CD\u4F5C",
  124097: "\u4EC5\u4E3B\u8BB2\u4EBA\u80FD\u64CD\u4F5C",
  124098: "\u6587\u6863\u3001\u767D\u677F\u3001\u5171\u4EAB\u5C4F\u5E55\u672A\u5F00\u542F\uFF0C\u4E0D\u80FD\u753B\u9762\u5207\u6362",
  124099: "\u64CD\u4F5C\u4EBA\u975E\u7EC4\u957F",
  124100: "\u4EC5\u7EC4\u957F\u53EF\u4EE5\u5168\u4F53\u9759\u97F3",
  124101: "\u8FDE\u9EA6\u5DF2\u5173\u95ED",
  125001: "\u67E5\u8BE2\u8BA2\u5355\u6570\u636E\u53C2\u6570\u4E3A\u7A7A",
  125002: "\u652F\u4ED8\u7C7B\u578B\u9519\u8BEF",
  125003: "\u652F\u4ED8\u53C2\u6570\u65E0\u6548",
  125004: "\u9ED8\u8BA4\u5B9E\u73B0\u4E0D\u80FD\u652F\u4ED8",
  125005: "\u9000\u6B3E\u53C2\u6570\u65E0\u6548",
  125006: "\u65E0\u6548\u7684\u652F\u4ED8\u8BB0\u5F55",
  125007: "\u56DE\u8C03\u5F02\u5E38",
  125008: "\u8C03\u7528\u5FAE\u4FE1\u4E0B\u5355\u63A5\u53E3\u5F02\u5E38",
  125009: "\u8C03\u7528\u5FAE\u4FE1\u9000\u6B3E\u63A5\u53E3\u5F02\u5E38",
  125010: "\u65E0\u6548\u7684\u652F\u4ED8\u8BB0\u5F55",
  125011: "\u652F\u4ED8\u5F02\u5E38",
  125012: "\u652F\u4ED8\u65B9\u5F0F\u9519\u8BEF",
  125013: "\u5FAE\u4FE1\u56DE\u8C03\u7C7B\u578B\u672A\u77E5",
  125014: "\u5FAE\u4FE1\u56DE\u8C03\u6570\u636E\u89E3\u5BC6\u5F02\u5E38",
  125015: "\u8BA2\u5355\u91CD\u590D\u652F\u4ED8",
  125016: "\u5173\u95ED\u5FAE\u4FE1\u8BA2\u5355\u5F02\u5E38",
  125017: "\u8BA2\u5355\u72B6\u6001\u5F02\u5E38",
  125018: "\u5FAE\u4FE1\u652F\u4ED8\u8BB0\u5F55\u72B6\u6001\u5F02\u5E38",
  125019: "\u53D6\u6D88\u652F\u4ED8\u5F02\u5E38",
  125020: "\u5F53\u524D\u8BA2\u5355\u5904\u4E8E\u9000\u6B3E\u6D41\u7A0B\u4E2D",
  125021: "\u8BA2\u5355\u672A\u652F\u4ED8",
  125022: "\u9000\u6B3E\u91D1\u989D\u8D85\u51FA\u652F\u4ED8\u91D1\u989D",
  125023: "\u672A\u5230\u6307\u5B9A\u9000\u6B3E\u65F6\u95F4",
  125024: "\u8BF7\u6C42\u5FAE\u4FE1\u9000\u6B3E\u5931\u8D25",
  125025: "\u65E0\u6548\u7684\u4E1A\u52A1\u7C7B\u578B",
  125100: "\u65B0\u589E\u8BA2\u5355\u8BB0\u5F55\u5F02\u5E38",
  125101: "\u4FEE\u6539\u8BA2\u5355\u8BB0\u5F55\u5F02\u5E38",
  125102: "\u65E0\u6548\u8BA2\u5355\u8BB0\u5F55",
  125110: "\u65B0\u589E\u652F\u4ED8\u8BB0\u5F55\u5F02\u5E38",
  125111: "\u4FEE\u6539\u652F\u4ED8\u8BB0\u5F55\u5F02\u5E38",
  125112: "\u65E0\u6548\u7684\u652F\u4ED8\u8BB0\u5F55",
  125120: "\u65B0\u589E\u9000\u6B3E\u8BB0\u5F55\u5F02\u5E38",
  125121: "\u4FEE\u6539\u9000\u6B3E\u8BB0\u5F55\u5F02\u5E38",
  125122: "\u65E0\u6548\u7684\u9000\u6B3E\u8BB0\u5F55",
  125130: "\u65B0\u589E\u5FAE\u4FE1\u5BF9\u8D26\u8BB0\u5F55\u5F02\u5E38",
  125131: "\u4FEE\u6539\u5FAE\u4FE1\u5BF9\u8D26\u8BB0\u5F55\u5F02\u5E38",
  125132: "\u65E0\u6548\u7684\u5FAE\u4FE1\u5BF9\u8D26\u8BB0\u5F55",
  125133: "\u65E0\u6548\u7684\u9000\u6B3E\u8BB0\u5F55",
  125134: "\u8C03\u7528\u5FAE\u4FE1\u63A5\u53E3\u5F02\u5E38",
  125135: "JsApi\u83B7\u53D6\u7B7E\u540D\u5F02\u5E38",
  125136: "\u8BA2\u5355\u5DF2\u652F\u4ED8",
  126001: "\u53C2\u6570\u4FE1\u606F\u5B58\u5728\u7F3A\u5931",
  126002: "\u521B\u5EFA\u573A\u6B21\u7EDF\u8BA1\u6570\u636E\u5931\u8D25",
  126003: "\u4FEE\u6539\u573A\u6B21\u540D\u79F0\u6570\u636E\u5931\u8D25",
  126004: "\u65E0\u6548\u573A\u6B21\u6570\u636E",
  126005: "\u67E5\u8BE2\u53C2\u6570\u7F3A\u5931",
  126006: "\u7EDF\u8BA1\u89C2\u770B\u65F6\u957F\u6570\u636E\u5931\u8D25",
  126007: "\u7EDF\u8BA1\u89C2\u770B\u4EBA\u6570\u6570\u636E\u5931\u8D25",
  126008: "\u7EDF\u8BA1\u89C2\u770B\u533A\u57DF\u6570\u636E\u5931\u8D25",
  126020: "\u83B7\u53D6\u76F4\u64AD\u6D41\u6C34\u5F02\u5E38",
  126021: "\u83B7\u53D6\u70B9\u64AD\u6D41\u6C34\u5F02\u5E38",
  126022: "\u65B0\u589E\u623F\u95F4\u7EDF\u8BA1",
  126023: "\u65B0\u589E\u623F\u95F4\u533A\u57DF\u7EDF\u8BA1",
  126024: "\u83B7\u53D6\u623F\u95F4\u7EDF\u8BA1\u6570\u636E\u65F6\u95F4\u8D85\u957F",
  126025: "\u5B50\u7EBF\u7A0B\u6267\u884C\u4EFB\u52A1\u8D85\u65F6",
  126026: "\u5B50\u7EBF\u7A0B\u6267\u884C\u5F02\u5E38",
  126027: "\u65B0\u589E\u6D3B\u52A8\u7EDF\u8BA1\u8BB0\u5F55\u5931\u8D25",
  126028: "\u4FEE\u6539\u6D3B\u52A8\u7EDF\u8BA1\u8BB0\u5F55\u5931\u8D25",
  126029: "\u65B0\u589E\u6D3B\u52A8\u533A\u57DF\u8BB0\u5F55\u5931\u8D25",
  126030: "\u4FEE\u6539\u6D3B\u52A8\u533A\u57DF\u8BB0\u5F55\u5931\u8D25",
  126031: "\u7981\u6B62\u540C\u65F6\u4F7F\u7528\u4E24\u4E2A\u7EF4\u5EA6\u67E5\u8BE2",
  126032: "\u65E0\u6548\u7684\u70B9\u8D5E\u6D41\u6C34\u8BB0\u5F55",
  126033: "\u4FDD\u5B58\u623F\u95F4\u8D8B\u52BF\u6570\u636E\u5F02\u5E38",
  126034: "\u4FDD\u5B58\u6E20\u9053\u8D8B\u52BF\u6570\u636E\u5F02\u5E38",
  126035: "\u62BD\u5956\u7EDF\u8BA1\u5217\u8868\u53C2\u6570\u5F02\u5E38",
  126036: "\u4E0D\u5B58\u5728\u8BE5\u7528\u6237\u7684\u6570\u636E",
  126037: "\u7528\u6237\u6392\u540D\u7C7B\u578B\u4E0D\u5B58\u5728",
  126038: "\u8BF7\u9009\u62E9\u67E5\u770B\u9891\u9053\u6570\u636E\u6216\u573A\u6240\u6570\u636E",
  126039: "\u65B0\u589E\u6253\u8D4F\u7EDF\u8BA1\u5F02\u5E38",
  126040: "\u5220\u9664\u6253\u8D4F\u7EDF\u8BA1\u5F02\u5E38",
  126041: "\u521B\u5EFA\u62A5\u540D\u533A\u57DF\u7EDF\u8BA1\u5931\u8D25",
  126042: "\u4FEE\u6539\u62A5\u540D\u533A\u57DF\u7EDF\u8BA1\u5931\u8D25",
  126043: "\u521B\u5EFA\u62A5\u540D\u4EBA\u6570\u6309\u5929\u7EDF\u8BA1\u5931\u8D25",
  126044: "\u4FEE\u6539\u62A5\u540D\u4EBA\u6570\u6309\u5929\u7EDF\u8BA1\u5931\u8D25",
  127001: "\u95EE\u5377\u540D\u79F0\u4E0D\u652F\u6301\u91CD\u590D",
  127002: "\u95EE\u5377\u9009\u9879\u4E2A\u6570\u8303\u56F4\u4E3A2-50\u4E2A",
  127003: "\u95EE\u5377\u95EE\u9898\u8D85\u8FC7\u540C\u7C7B\u578B\u7684\u6700\u5927\u4E2A\u6570\u9650\u5236",
  127004: "\u4E0D\u5B58\u5728\u7684\u95EE\u5377",
  127005: "\u522A\u9664\u95EE\u5377\u5931\u8D25",
  127006: "\u66F4\u65B0\u95EE\u5377\u72B6\u6001\u5931\u8D25",
  127007: "\u5F53\u524D\u76F4\u64AD\u95F4\u65E0\u6B63\u5728\u4F7F\u7528\u7684\u95EE\u5377",
  127008: "\u5FC5\u586B\u95EE\u9898\u672A\u56DE\u7B54",
  127009: "\u8BE5\u7528\u6237\u5DF2\u586B\u5199\u8FC7\u95EE\u5377",
  127010: "\u5F53\u524D\u95EE\u5377\u5DF2\u7ED3\u675F\uFF0C\u65E0\u6CD5\u63D0\u4EA4",
  127011: "\u5F53\u524D\u5DF2\u6709\u95EE\u5377\u5904\u4E8E\u4F7F\u7528\u72B6\u6001\uFF0C\u8BF7\u5148\u505C\u6B62\u4F7F\u7528\u4E2D\u7684\u95EE\u5377",
  127012: "\u5F53\u524D\u95EE\u5377\u5904\u4E8E\u4F7F\u7528\u4E2D\uFF0C\u8BF7\u5148\u505C\u6B62\u4F7F\u7528",
  127013: "\u5355\u9009\u9898\u4E2D\u7981\u6B62\u51FA\u73B0\u591A\u7B54\u6848",
  127014: "\u7981\u6B62\u521B\u5EFA\u7A7A\u7684\u95EE\u5377",
  127015: "\u7528\u6237\u9700\u540C\u610F\u6570\u636E\u534F\u8BAE,\u624D\u80FD\u63D0\u4EA4\u56DE\u7B54",
  127016: "\u95EE\u5377\u95EE\u9898\u6807\u9898\u8D85\u8FC7\u6700\u5927\u5B57\u6570\u9650\u5236",
  127017: "\u95EE\u5377\u9009\u9879\u5185\u5BB9\u8D85\u8FC7\u6700\u5927\u5B57\u6570\u9650\u5236",
  127018: "\u95EE\u5377\u56DE\u7B54\u5185\u5BB9\u8D85\u8FC7\u6700\u5927\u5B57\u6570\u9650\u5236",
  127019: "\u95EE\u5377\u56DE\u7B54\u624B\u673A\u53F7\u53EA\u5141\u8BB811\u4F4D\u6570\u5B57",
  127020: "\u95EE\u5377\u56DE\u7B54\u90AE\u7BB1\u53F7\u683C\u5F0F\u6709\u8BEF",
  127021: "\u8BE5\u624B\u673A\u53F7\u5DF2\u62A5\u540D\uFF0C\u8BF7\u52FF\u91CD\u590D\u62A5\u540D",
  127022: "\u8BF7\u5148\u914D\u7F6E\u5FAE\u4FE1\u652F\u4ED8\u5546\u6237\uFF0C\u5426\u5219\u65E0\u6CD5\u5F00\u542F\u6536\u8D39\u529F\u80FD",
  127023: "\u6536\u8D39\u4EF7\u683C\u8303\u56F4\u57280.01~999999.99",
  127024: "\u95EE\u5377\u95EE\u9898\u4E0D\u80FD\u4E3A\u7A7A",
  127025: "\u6700\u591A\u652F\u630150\u4E2A\u9898\u76EE",
  127026: "\u95EE\u5377\u5DF2\u662F\u6B64\u72B6\u6001\uFF0C\u8BF7\u52FF\u91CD\u590D\u64CD\u4F5C",
  127027: "\u95EE\u5377\u6807\u9898\u4E0D\u80FD\u4E3A\u7A7A",
  127028: "\u9009\u62E9\u9898\u9009\u9879\u4E0D\u80FD\u4E3A\u7A7A",
  127029: "\u66F4\u65B0\u95EE\u5377\u5931\u8D25",
  127030: "\u5220\u9664\u95EE\u5377\u5931\u8D25",
  127031: "\u9A8C\u8BC1\u7801\u4E0D\u80FD\u4E3A\u7A7A",
  127032: "\u9A8C\u8BC1\u7801\u9519\u8BEF",
  127033: "\u79DF\u6237id\u4E0D\u80FD\u4E3A\u7A7A",
  127034: "\u6D3B\u52A8id\u4E0D\u80FD\u4E3A\u7A7A",
  127035: "\u5FC5\u7B54\u95EE\u9898\u672A\u586B\u5199",
  127036: "\u5DF2\u6709\u53C2\u4E0E\u8005\u62A5\u540D\uFF0C\u8868\u5355\u4E0D\u518D\u652F\u6301\u4FEE\u6539",
  127037: "\u95EE\u9898\u7C7B\u578B\u503C\u975E\u6CD5",
  127038: "\u8BF7\u9009\u62E9\u95E8\u7968",
  127039: "\u60A8\u5DF2\u53C2\u4E0E\u6D3B\u52A8\uFF0C\u65E0\u9700\u91CD\u590D\u62A5\u540D",
  127040: "\u8BF7\u81F3\u5C11\u4FDD\u7559\u624B\u673A\u53F7\u6216\u90AE\u7BB1\u4E00\u79CD\u65B9\u5F0F",
  127041: "\u62A5\u540D\u8868\u5355id\u4E0D\u80FD\u4E3A\u7A7A",
  127042: "\u95EE\u5377\u95EE\u9898\u4E0D\u5B58\u5728",
  127043: "\u9009\u62E9\u9898\u9009\u9879\u5185\u5BB9\u4E0D\u80FD\u4E3A\u7A7A",
  127044: "\u95EE\u5377\u540D\u79F0 \u662F\u5FC5\u9700\u9879",
  127045: "questionScore \u53D6\u503C\u8303\u56F4\u4E3A1-100",
  127046: "\u4E3B\u529E\u65B9\u6B63\u5728\u786E\u8BA4\u60A8\u7684\u62A5\u540D\uFF0C\u8BF7\u52FF\u91CD\u590D\u62A5\u540D",
  127047: "\u4E3B\u529E\u65B9\u6B63\u5728\u786E\u8BA4\u60A8\u7684\u62A5\u540D\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85",
  127048: "\u60A8\u7684\u62A5\u540D\u5C1A\u672A\u786E\u8BA4\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85",
  127049: "\u60A8\u7684\u62A5\u540D\u5C1A\u672A\u786E\u8BA4\uFF0C\u8BF7\u52FF\u91CD\u590D\u62A5\u540D",
  127050: "\u9898\u76EE\u6570\u91CF\u6216\u9009\u9879\u6570\u91CF\u5E94\u4E0E\u4E2D\u6587\u914D\u7F6E\u76F8\u540C",
  128001: "\u5F53\u524D\u72B6\u6001\u7981\u6B62\u5207\u6362\u76F4\u64AD\u95F4\u6A21\u5F0F",
  128002: "\u7981\u6B62\u91CD\u590D\u5207\u6362\u76F4\u64AD\u95F4\u6A21\u5F0F",
  128003: "\u4E0D\u5B58\u5728\u7684\u753B\u9762",
  128004: "\u66F4\u65B0\u975E\u4E3B\u753B\u9762\u8BBE\u7F6E\u5931\u8D25",
  128005: "\u66F4\u65B0\u4E3B\u753B\u9762\u8BBE\u7F6E\u5931\u8D25",
  128006: "\u65E0\u6548\u623F\u95F4",
  128007: "\u539F\u4E3B\u753B\u9762id\u53C2\u6570\u7F3A\u5931",
  128008: "\u672A\u9009\u62E9\u753B\u9762\u4F5C\u4E3A\u4E3B\u753B\u9762",
  128009: "\u5F53\u524D\u753B\u9762\u5DF2\u662F\u4E3B\u753B\u9762",
  128010: "\u8C03\u7528\u7981\u6B62\u63A8\u6D41\u5931\u8D25",
  128011: "\u8C03\u7528\u6062\u590D\u63A8\u6D41\u5931\u8D25",
  128012: "\u8C03\u7528\u6B63\u5728\u63A8\u6D41\u5217\u8868\u5931\u8D25",
  128013: "\u5F53\u524D\u76F4\u64AD\u95F4\u5904\u4E8E\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u589E\u52A0\u753B\u9762",
  128014: "\u63A8\u6D41\u76F4\u64AD\u76F8\u5173\u8D44\u6E90\u4E0D\u8DB3",
  128015: "\u5F53\u524D\u6A21\u5F0F\u4E0D\u652F\u6301\u589E\u52A0\u753B\u9762",
  128016: "\u753B\u9762\u540D\u79F0\u4E0D\u652F\u6301\u91CD\u590D",
  128017: "\u5F53\u524D\u76F4\u64AD\u95F4\u5904\u4E8E\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u5220\u9664\u753B\u9762",
  128018: "\u7981\u6B62\u5220\u9664\u4E3B\u753B\u9762",
  128019: "\u6700\u591A\u53EA\u80FD\u67098\u4E2A\u753B\u9762",
  128020: "\u79DF\u6237\u7F3A\u5C11\u63A8\u6D41\u76F4\u64AD\u8D44\u6E90",
  128021: "\u5220\u9664\u753B\u9762\u5931\u8D25",
  128022: "\u83B7\u53D6\u5728\u7EBF\u6D41\u5217\u8868\u9519\u8BEF",
  128023: "\u63A8\u6D41\u76F4\u64AD\u5B9A\u65F6\u8865\u507F\u5F00\u542F\u76F4\u64AD\u72B6\u6001\u5931\u8D25",
  128024: "\u63A8\u6D41\u76F4\u64AD\u5B9A\u65F6\u8865\u507F\u505C\u6B62\u76F4\u64AD\u72B6\u6001\u5931\u8D25",
  128025: "\u65B0\u589E\u753B\u9762\u5931\u8D25",
  128026: "\u5220\u9664\u753B\u9762\u5931\u8D25",
  128027: "\u57DF\u540D\u7EC4\u4E0D\u5B58\u5728\u53EF\u7528\u63A8\u6D41\u57DF\u540D",
  128028: "\u57DF\u540D\u7EC4\u4E0D\u5B58\u5728\u53EF\u7528\u62C9\u6D41\u57DF\u540D",
  128029: "\u5B58\u5728\u63A8\u6D41\u4E2D\u7684\u6D41\uFF0C\u7981\u6B62\u7ED3\u675F\u76F4\u64AD",
  129001: "\u65E0\u6548\u7684\u6D3B\u52A8",
  129002: "\u521B\u5EFA\u6D3B\u52A8\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  129003: "\u521B\u5EFA\u6D3B\u52A8\u5931\u8D25",
  129004: "\u4FEE\u6539\u6D3B\u52A8\u5931\u8D25",
  129005: "\u6D3B\u52A8\u5DF2\u7ED3\u675F",
  129006: "\u5DF2\u8BBE\u7F6E\u53D6\u6D88\u53D1\u5E03\uFF0C\u8BF7\u52FF\u91CD\u590D\u64CD\u4F5C",
  129007: "\u5DF2\u8BBE\u7F6E\u53D1\u5E03\uFF0C\u8BF7\u52FF\u91CD\u590D\u64CD\u4F5C",
  129008: "\u5F53\u524D\u5DF2\u8FC7\u6D3B\u52A8\u7ED3\u675F\u65F6\u95F4\uFF0C\u8BF7\u4FEE\u6539\u6D3B\u52A8\u65F6\u95F4\u540E\u518D\u53D1\u5E03",
  129009: "\u8BBE\u7F6E\u53D1\u5E03\u72B6\u6001\u5931\u8D25",
  129010: "\u623F\u95F4\u975E\u6D3B\u52A8\u521B\u5EFA",
  129011: "\u65E0\u6548\u7684\u6D3B\u52A8\u65E5\u7A0B",
  129012: "\u521B\u5EFA\u6D3B\u52A8\u65E5\u7A0B\u5931\u8D25",
  129013: "\u4FEE\u6539\u6D3B\u52A8\u65E5\u7A0B\u5931\u8D25",
  129014: "\u5220\u9664\u6D3B\u52A8\u65E5\u7A0B\u5931\u8D25",
  129015: "\u5F53\u524D\u76F4\u64AD\u95F4\u5DF2\u5173\u8054\u5176\u4ED6\u65E5\u7A0B\u65F6\u95F4\uFF0C\u8BF7\u8C03\u6574\u65E5\u7A0B\u65F6\u95F4\u6216\u66F4\u6539\u76F4\u64AD\u95F4\u3002\u51B2\u7A81\u65F6\u95F4\uFF1A",
  129016: "\u521B\u5EFA\u6D3B\u52A8\u843D\u5730\u9875\u5931\u8D25",
  129017: "\u4FEE\u6539\u6D3B\u52A8\u843D\u5730\u9875\u5931\u8D25",
  129018: "\u5609\u5BBE\u59D3\u540D\u4E0D\u80FD\u4E3A\u7A7A",
  129019: "\u5F53\u524D\u6682\u4E0D\u53EF\u53D1\u5E03\u6D3B\u52A8\uFF0C\u8BF7\u5148\u521B\u5EFA\u62A5\u540D\u8868\u5355\u540E\u518D\u53D1\u5E03",
  129020: "\u65E0\u62A5\u540D\uFF0C\u6D3B\u52A8\u65E0\u6CD5\u53D1\u5E03",
  129021: "\u5DF2\u505C\u6B62\u62A5\u540D",
  129022: "\u4F1A\u8BAE\u5F00\u59CB\u65F6\u95F4\u683C\u5F0F\u5F02\u5E38",
  129023: "\u4F1A\u8BAE\u7ED3\u675F\u65F6\u95F4\u683C\u5F0F\u5F02\u5E38",
  129024: "\u4F1A\u8BAE\u5F00\u59CB\u6216\u8005\u7ED3\u675F\u65F6\u95F4\u4E3A\u7A7A",
  129025: "\u4FEE\u6539\u6D3B\u52A8\u4F5C\u5E9F\u6807\u8BC6\u5931\u8D25",
  129026: "\u6D3B\u52A8\u5DF2\u4F5C\u5E9F",
  129027: "\u6D3B\u52A8\u6A21\u5F0F\u4E0E\u623F\u95F4\u6A21\u5F0F\u4E0D\u5339\u914D",
  129028: "\u4E0D\u5B58\u5728\u7684\u6D3B\u52A8",
  129031: "\u65E0\u6548\u7684\u6D3B\u52A8\u95E8\u7968",
  129032: "\u521B\u5EFA\u6D3B\u52A8\u95E8\u7968\u5931\u8D25",
  129033: "\u95E8\u7968\u7F16\u53F7\u4E0D\u5141\u8BB8\u91CD\u590D\uFF0C\u8BF7\u786E\u8BA4",
  129034: "\u4EC5\u672A\u4E0A\u67B6\u95E8\u7968\u53EF\u4EE5\u7F16\u8F91",
  129035: "\u672A\u4E0A\u67B6\u4EC5\u80FD\u4FEE\u6539\u4E3A\u5DF2\u4E0A\u67B6",
  129036: "\u5DF2\u4E0A\u67B6\u4EC5\u80FD\u4FEE\u6539\u4E3A\u5DF2\u4E0B\u67B6",
  129037: "\u5DF2\u4E0B\u67B6\u4EC5\u80FD\u4FEE\u6539\u4E3A\u5DF2\u4E0A\u67B6",
  129038: "\u4FEE\u6539\u6D3B\u52A8\u95E8\u7968\u4E0A\u67B6\u72B6\u6001\u5931\u8D25",
  129039: "\u95E8\u7968\u6570\u91CF\u4E0D\u80FD\u5C0F\u4E8E\u5DF2\u552E\u95E8\u7968\u6570\u91CF\u7684\u503C",
  129040: "\u5B58\u5728\u672A\u4E0A\u67B6\u95E8\u7968\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u91CD\u65B0\u9009\u62E9\u95E8\u7968",
  129041: "\u4FEE\u6539\u540E\u53F0\u5BFC\u5165\u6570\u91CF\u5931\u8D25",
  129042: "\u6D3B\u52A8\u5C1A\u672A\u5F00\u542F\u95E8\u7968\u529F\u80FD\uFF0C\u95E8\u7968\u529F\u80FD\u65E0\u6CD5\u4F7F\u7528",
  129043: "\u4FEE\u6539\u6D3B\u52A8\u95E8\u7968\u5931\u8D25",
  129050: "\u6D3B\u52A8\u5DF2\u5F00\u542F\u95E8\u7968\u529F\u80FD\uFF0C\u8BF7\u9009\u62E9\u95E8\u7968",
  129051: "\u95E8\u7968\u6700\u591A\u9009\u62E910\u5F20",
  129052: "\u521B\u5EFA\u62A5\u540D\u8868\u5355\u95E8\u7968\u5173\u8054\u5931\u8D25",
  129053: "\u95E8\u7968\u5DF2\u4E0B\u67B6\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u95E8\u7968",
  129054: "\u95E8\u7968\u5DF2\u552E\u7F44\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u95E8\u7968",
  129055: "\u95E8\u7968\u672A\u5728\u552E\u7968\u4E2D\u72B6\u6001\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u95E8\u7968",
  129056: "\u521B\u5EFA\u7528\u6237\u95E8\u7968\u5173\u8054\u5931\u8D25",
  129057: "\u4FEE\u6539\u7528\u6237\u95E8\u7968\u5173\u8054\u5220\u9664\u6807\u8BB0\u5931\u8D25",
  129058: "\u65E0\u6548\u7684\u7528\u6237\u95E8\u7968\u5173\u8054",
  129059: "\u5C1A\u672A\u914D\u7F6E\u5FAE\u4FE1\u652F\u4ED8\uFF0C\u6536\u8D39\u95E8\u7968\u529F\u80FD\u65E0\u6CD5\u4F7F\u7528",
  129060: "\u65E5\u7A0B\u5609\u5BBE\u4E0D\u5B58\u5728",
  129061: "\u7528\u6237\u95E8\u7968\u652F\u4ED8\u72B6\u6001\u4E0D\u6B63\u786E",
  129062: "\u4FEE\u6539\u7528\u6237\u95E8\u7968\u652F\u4ED8\u72B6\u6001\u5931\u8D25",
  129063: "\u95E8\u7968\u540D\u79F0\u4E0D\u5141\u8BB8\u91CD\u590D\uFF0C\u8BF7\u786E\u8BA4",
  129064: "\u5DF2\u4E0A\u67B6\uFF0C\u5DF2\u4E0B\u67B6\u7684\u95E8\u7968\u4EC5\u652F\u6301\u4FEE\u6539\uFF1A\u95E8\u7968\u540D\u79F0\uFF0C\u95E8\u7968\u63CF\u8FF0\uFF0C\u95E8\u7968\u6570\u91CF\uFF0C\u552E\u7968\u65F6\u95F4",
  129065: "\u65E0\u4E0A\u67B6\u4E2D\u7684\u95E8\u7968\uFF0C\u6D3B\u52A8\u65E0\u6CD5\u53D1\u5E03",
  129070: "\u521B\u5EFA\u65E5\u7A0B\u8BC4\u4EF7\u5931\u8D25",
  129071: "\u8BC4\u4EF7\u529F\u80FD\u672A\u5F00\u542F",
  129072: "\u8BF7\u5728\u65E5\u7A0B\u5F00\u59CB\u540E\u518D\u8FDB\u884C\u8BC4\u4EF7",
  129073: "\u4EC5\u652F\u6301\u8BC4\u4EF7\u4E00\u6B21",
  129080: "\u4FEE\u6539\u5206\u4EAB\u8BBE\u7F6E\u5931\u8D25",
  129081: "\u4FEE\u6539\u6D3B\u52A8\u88C5\u4FEE\u5E8F\u53F7\u5931\u8D25",
  129082: "\u6D3B\u52A8\u88C5\u4FEE\u5E8F\u53F7\u91CD\u590D",
  129083: "\u5355\u4E2A\u6D3B\u52A8\u9650\u5236\u6700\u591A\u521B\u5EFA20\u4E2A\u62A5\u540D\u8868\u5355",
  129084: "\u6D3B\u52A8\u5DF2\u8BBE\u7F6E\u4E0D\u80FD\u521B\u5EFA\u62A5\u540D\u8868\u5355",
  129085: "\u83B7\u53D6\u63A8\u5E7F\u6E20\u9053\u4E3A\u7A7A",
  129086: "\u65B0\u589E\u63A8\u5E7F\u6E20\u9053\u5931\u8D25",
  129087: "\u6700\u591A\u6DFB\u52A020\u4E2A\u6E20\u9053",
  129088: "\u63A8\u5E7F\u6E20\u9053\u540D\u79F0\u76F8\u540C",
  129089: "\u63A8\u5E7F\u6E20\u9053\u7F16\u53F7\u76F8\u540C",
  129090: "\u83B7\u53D6\u63A8\u5E7F\u6E20\u9053\u7EDF\u8BA1\u6570\u636E\u4E3A\u7A7A",
  129091: "\u65B0\u589E\u63A8\u5E7F\u6E20\u9053\u7EDF\u8BA1\u6570\u636E\u5931\u8D25",
  129092: "\u5DF2\u7ECF\u6709\u4EBA\u62A5\u540D,\u65E0\u6CD5\u7F16\u8F91",
  129093: "\u4FEE\u6539\u6E20\u9053\u542F\u7528\u72B6\u6001\u5931\u8D25",
  129094: "\u672A\u5F00\u542F\u573A\u6240\u67E5\u8BE2\uFF0C\u8BF7\u5148\u5F00\u542F",
  129095: "\u672A\u914D\u7F6E\u6D3B\u52A8\u88C5\u4FEE\uFF0C\u8BF7\u5148\u914D\u7F6E",
  129096: "\u63A8\u5E7F\u6E20\u9053\u7F16\u8F91\u5931\u8D25",
  129097: "\u672A\u5F00\u542F\u65E5\u671F\u67E5\u8BE2\uFF0C\u8BF7\u5148\u5F00\u542F",
  129100: "\u521B\u5EFA\u6D3B\u52A8\u51C6\u5165\u5931\u8D25",
  129101: "\u4FEE\u6539\u6D3B\u52A8\u51C6\u5165\u5931\u8D25",
  129102: "\u65E0\u6548\u7684\u6D3B\u52A8\u51C6\u5165",
  129103: "\u8BF7\u5148\u914D\u7F6E\u62A5\u540D\u8868\u5355",
  129104: "\u672A\u542F\u7528\u5F00\u653E\u5E73\u53F0",
  129105: "\u521B\u5EFA\u5609\u5BBE\u5F02\u5E38",
  129106: "\u4FEE\u6539\u5609\u5BBE\u5F02\u5E38",
  129107: "\u65E0\u6548\u7684\u5609\u5BBE",
  129108: "\u65E0\u6548\u7684\u5609\u5BBE",
  129109: "\u4E0D\u5141\u8BB8\u4FEE\u6539\u6635\u79F0",
  129110: "\u66F4\u65B0\u63A8\u5E7F\u6E20\u9053\u7EDF\u8BA1\u6570\u636E\u5931\u8D25",
  129120: "\u65E0\u6548\u7684\u901A\u77E5\u7C7B\u578B",
  129121: "\u672A\u914D\u7F6E\u5FAE\u4FE1\u901A\u77E5\u6A21\u677F",
  129122: "\u76F4\u64AD\u65E5\u7A0B\u6700\u591A%s\u4F4D\u5609\u5BBE",
  129123: "\u624B\u673A\u53F7\u6216\u90AE\u7BB1\u5FC5\u586B\u4E00\u9879",
  129124: "\u8BE5\u63A5\u53E3\u6682\u4E0D\u652F\u6301\u62A5\u540D\u6216\u767D\u540D\u5355\u51C6\u5165\u914D\u7F6E",
  129125: "\u521B\u5EFA\u7528\u6237\u95E8\u7968\u8BA2\u5355\u5931\u8D25",
  129126: "\u66F4\u65B0\u8BA2\u5355\u72B6\u6001\u5931\u8D25",
  129127: "\u79FB\u9664\u72B6\u6001\u4E0D\u80FD\u4E3A\u7A7A",
  129128: "\u624B\u673A\u53F7\u683C\u5F0F\u4E0D\u6B63\u786E:%s",
  129129: "\u5F00\u59CB\u65F6\u95F4\u5E94\u5728\u7ED3\u675F\u65F6\u95F4\u4E4B\u524D",
  129130: "\u6D3B\u52A8\u65F6\u95F4\u6700\u77ED\u4E3A%s\u5C0F\u65F6",
  129131: "\u6D3B\u52A8\u65F6\u95F4\u6700\u957F\u4E3A%s\u5929",
  129132: "\u5BFC\u5165\u6570\u636E\u4E0D\u80FD\u4E3A\u7A7A",
  129133: "\u5609\u5BBE\u4E0D\u5141\u8BB8\u91CD\u590D\u6DFB\u52A0",
  129134: "\u901A\u77E5\u65F6\u95F4\u4E0D\u80FD\u4E3A\u5386\u53F2\u65F6\u95F4",
  129135: "\u5C1A\u672A\u914D\u7F6E\u5FAE\u4FE1\u516C\u4F17\u53F7\uFF0C\u65E0\u6CD5\u5F00\u542F\u5FAE\u4FE1\u8BA2\u9605\u901A\u77E5",
  129136: "\u7814\u8BA8\u4F1A\u53EF\u521B\u5EFA\u6570\u91CF\u8D44\u6E90\u4E0D\u8DB3\uFF0C\u65E0\u6CD5\u6062\u590D\u8BE5\u6D3B\u52A8",
  129137: "\u6D3B\u52A8\u901A\u77E5\u914D\u7F6E\u5DF2\u5B58\u5728",
  129138: "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u79CD\u901A\u77E5\u65B9\u5F0F",
  129139: "\u60A8\u5DF2\u8BA2\u9605\uFF0C\u65E0\u9700\u91CD\u590D\u63D0\u4EA4",
  129140: "\u6D3B\u52A8\u8BA2\u9605\u65F6\u95F4\u5DF2\u7ED3\u675F",
  129141: "\u90AE\u4EF6\u5185\u5BB9\u8D85\u8FC7\u9650\u5236\u957F\u5EA6",
  129142: "\u90AE\u4EF6\u5185\u5BB9\u4E0D\u80FD\u4E3A\u7A7A",
  129143: "\u8BA2\u9605\u6210\u529F\u901A\u77E5\u5185\u5BB9\u4E0D\u80FD\u4E3A\u7A7A",
  129144: "\u6D3B\u52A8\u8BA2\u9605\u529F\u80FD\u5DF2\u5173\u95ED",
  129145: "\u81F3\u5C11\u5F00\u542F\u4E00\u4E2A\u6D3B\u52A8\u8BED\u8A00",
  129151: "\u81F3\u5C11\u5F00\u542F\u4E00\u4E2A\u6D3B\u52A8\u8BED\u8A00",
  130001: "\u5BA2\u6237\u7981\u7528\u72B6\u6001\u4E0D\u5141\u8BB8\u8D2D\u4E70",
  130002: "\u4EA7\u54C1\u672A\u5904\u4E8E\u4E0A\u67B6\u72B6\u6001",
  130003: "\u521B\u5EFA\u8BA2\u5355\u5931\u8D25",
  130004: "\u521B\u5EFA\u8BA2\u5355\u5BA1\u6279\u6D41\u7A0B\u5931\u8D25",
  130005: "\u521B\u5EFA\u8BA2\u5355\u652F\u4ED8\u6D41\u7A0B\u5931\u8D25",
  130006: "\u4FEE\u6539\u8BA2\u5355\u5931\u8D25",
  130007: "\u65E0\u6548\u7684\u8BA2\u5355",
  130008: "\u8BA2\u5355\u5F53\u524D\u5BA1\u6279\u72B6\u6001\u4E0D\u6B63\u786E\uFF0C\u65E0\u6CD5\u4FEE\u6539\u72B6\u6001",
  130009: "\u62D2\u7EDD\u65F6\u9700\u8981\u7406\u7531",
  130010: "\u5B9A\u65F6\u751F\u6548\u65F6\u9700\u8981\u751F\u6548\u65F6\u95F4",
  130011: "\u521B\u5EFA\u51B2\u9500\u8BA2\u5355\u5931\u8D25",
  130012: "\u4FEE\u6539\u51B2\u9500\u8BA2\u5355\u72B6\u6001\u5931\u8D25",
  130013: "\u65E0\u6548\u7684\u51B2\u9500\u8BA2\u5355",
  130014: "\u53EF\u51B2\u9500\u6570\u91CF\u9519\u8BEF",
  130015: "\u4EA7\u54C1\u5DF2\u8FC7\u671F\uFF0C\u65E0\u6CD5\u51B2\u9500",
  130016: "\u8BA2\u5355\u672A\u652F\u4ED8\uFF0C\u4E0D\u5141\u8BB8\u51B2\u9500",
  130017: "\u521B\u5EFA\u5BA2\u6237\u4FE1\u606F\u5931\u8D25",
  130018: "\u8BA2\u5355\u751F\u6548\u65F6\u95F4\u66F4\u65B0\u5931\u8D25",
  130019: "\u4EA7\u54C1\u5957\u9910\u53CA\u7248\u672C\u4EC5\u80FD\u8D2D\u4E701\u4EF6",
  130020: "\u51B2\u9500\u91D1\u989D\u4E0D\u80FD\u5927\u4E8E\u5B9E\u4ED8\u91D1\u989D",
  130021: "\u51B2\u9500\u6570\u91CF\u4E0D\u80FD\u5927\u4E8E\u53EF\u51B2\u9500\u6570\u91CF",
  130022: "\u8BE5\u8BA2\u5355\u5DF2\u88AB\u51B2\u9500\uFF0C\u65E0\u6CD5\u518D\u6B21\u51B2\u9500",
  130023: "\u540C\u4E00\u4E2A\u8BA2\u5355\u4E2D\u53EA\u80FD\u8D2D\u4E70\u4E00\u4E2A\u7248\u672C",
  130024: "\u51B2\u9500\u91D1\u989D\u5E94\u5C0F\u4E8E\u5B9E\u4ED8\u91D1\u989D",
  131001: '\u60A8\u53D1\u9001\u7684\u7EA2\u5305\u53E3\u4EE4\u5305\u542B\u654F\u611F\u8BCD"%s"',
  131002: "\u4EC5\u5141\u8BB8\u5177\u540D\u7528\u6237\u62A2\u7EA2\u5305",
  131003: "\u62A2\u7EA2\u5305\u4EBA\u6570\u8F83\u591A\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  131004: "\u975E\u6CD5\u8BF7\u6C42",
  131005: "\u65E0\u6548\u7684\u7EA2\u5305",
  131006: "\u9884\u53D1\u7EA2\u5305\u9519\u8BEF",
  131007: "\u53E3\u4EE4\u9519\u8BEF",
  131008: "\u7EA2\u5305\u5DF2\u8FC7\u671F",
  131009: "\u7EA2\u5305\u5DF2\u88AB\u7981\u7528",
  131010: "\u60A8\u5DF2\u9886\u53D6\u8FC7\u8BE5\u7EA2\u5305\uFF0C\u8BF7\u52FF\u91CD\u590D\u9886\u53D6\u3002",
  131011: "\u975E\u6CD5\u7684\u7EA2\u5305\u53C2\u6570",
  131012: "\u53D1\u7EA2\u5305\u95F4\u9694\u4E0D\u5F97\u5C0F\u4E8E1\u5206\u949F\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  131013: "\u8BF7\u5148\u914D\u7F6E\u5FAE\u4FE1\u516C\u4F17\u53F7\u548C\u5546\u6237\u4FE1\u606F",
  131014: "\u65E0\u6743\u9650\u64CD\u4F5C\u8BE5\u7EA2\u5305\u8BB0\u5F55",
  131015: "\u89C2\u4F17\u672A\u8FDB\u884C\u5FAE\u4FE1\u6388\u6743",
  131016: "\u4E0D\u5B58\u5728\u7684\u7EA2\u5305",
  131017: "\u6B64\u72B6\u6001\u7EA2\u5305\u4E0D\u652F\u6301\u4FEE\u6539",
  131018: "\u5355\u4E2A\u7EA2\u5305\u91D1\u989D\u9700\u57280.3\u81F3200\u5143\u4E4B\u95F4",
  131019: "\u6B64\u72B6\u6001\u7EA2\u5305\u4E0D\u652F\u6301\u53D1\u5E03",
  131020: "\u4E0D\u5B58\u5728\u7684\u7EA2\u5305\u9886\u53D6\u8BB0\u5F55",
  131021: "\u7CFB\u7EDF\u5F02\u5E38",
  131022: "\u7EA2\u5305\u5DF2\u62A2\u5B8C",
  131023: "\u9884\u53D1\u7EA2\u5305\u585E\u56DE\u62A5\u9519",
  131024: "\u5904\u7406\u7528\u6237\u9886\u53D6\u8BB0\u5F55\u51FA\u9519",
  131025: "\u6D88\u606F\u53D1\u9001\u5F02\u5E38",
  131026: "\u8BF7\u5728\u5FAE\u4FE1\u73AF\u5883\u5185\u53C2\u4E0E\u9886\u7EA2\u5305",
  132001: "\u65E0\u6548\u7684\u4F1A\u8BAE\u5BA4",
  132002: "\u65E0\u6548\u7684\u4F1A\u8BAE",
  132003: "\u65E0\u6548\u7684\u4E3B\u6301\u4EBA\u8BA4\u8BC1\u53E3\u4EE4",
  132004: "\u9519\u8BEF\u7684\u4E3B\u6301\u4EBA\u8BA4\u8BC1\u53E3\u4EE4",
  132005: "\u65E0\u6548\u7684\u4F1A\u8BAE\u90E8\u5206ID",
  132006: "\u9884\u5B9A\u5931\u8D25\u8BF7\u91CD\u8BD5",
  132007: "\u817E\u8BAF\u4F1A\u8BAE\u521B\u5EFA\u5931\u8D25",
  132008: "\u817E\u8BAF\u4F1A\u8BAE\u4FEE\u6539\u5931\u8D25",
  132009: "\u817E\u8BAF\u4F1A\u8BAE\u53D6\u6D88\u5931\u8D25",
  132010: "\u4F1A\u8BAE\u5BA4\u53C2\u6570\u5F02\u5E38",
  132011: "\u4F1A\u8BAE\u5BA4\u53D6\u6D88\u5931\u8D25",
  132012: "\u4F1A\u8BAE\u5BA4\u521D\u59CB\u5316\u5931\u8D25",
  132013: "\u7528\u6237\u6D41\u6C34\u83B7\u53D6\u5F02\u5E38",
  132014: "\u4F1A\u8BAE\u5BA4\u9884\u5B9A\u65E5\u671F\u4E0E\u4F1A\u8BAE\u65E5\u671F\u4E0D\u5339\u914D",
  132015: "\u65E0\u6548\u7684\u4F1A\u8BAE\u65F6\u95F4",
  132016: "\u5609\u5BBE\u624B\u673A\u53F7\u4E3A\u7A7A\u6216\u8005\u683C\u5F0F\u9519\u8BEF",
  132017: "\u8BF7\u5728\u4F1A\u8BAE\u5BA4\u751F\u6548\u65F6\u95F424\u5C0F\u65F6\u4E4B\u524D\u53D6\u6D88",
  132018: "\u5728\u817E\u8BAF\u4F1A\u8BAESSO\u5E73\u53F0\u5220\u9664\u7528\u6237\u5931\u8D25",
  132019: "\u5728\u817E\u8BAF\u4F1A\u8BAE\u5E73\u53F0\u5220\u9664\u7528\u6237\u5931\u8D25",
  132020: "\u4F1A\u8BAE\u5BA4\u5BF9\u5E94\u7684\u8D44\u6E90\u5305\u8FC7\u671F\uFF0C\u65E0\u6CD5\u5220\u9664",
  132021: "\u4F1A\u8BAE\u5BA4\u5728\u8BE5\u65F6\u95F4\u6BB5\u5DF2\u6709\u5176\u4ED6\u4F1A\u8BAE",
  132022: "\u8BE5\u65F6\u6BB5\u53EF\u9884\u5B9A\u4F1A\u8BAE\u5BA4\u6570\u91CF\u4E3A0\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D\u5904\u7406",
  132023: "\u4F1A\u8BAE\u5BA4\u7684\u521B\u5EFA\u8303\u56F4\u572830\u5929\u4EE5\u5185",
  132024: "\u4F1A\u8BAE\u5DF2\u5F00\u59CB\uFF0C\u4E0D\u5141\u8BB8\u4FEE\u6539",
  132025: "\u4F1A\u8BAE\u5DF2\u5F00\u59CB\uFF0C\u4E0D\u5141\u8BB8\u5220\u9664",
  132026: "\u4EC5\u652F\u6301\u7EA6\u5B9A30\u5929\u5185\u7684\u4F1A\u8BAE\u5BA4",
  132027: "\u65E0\u6548\u7684\u4F1A\u8BAE\u53C2\u4E0E\u8005\u6D41\u6C34",
  133001: "\u521B\u5EFA\u4E3B\u64AD\u6743\u9650\u5173\u8054\u4FE1\u606F\u5931\u8D25",
  133002: "\u5220\u9664\u4E3B\u64AD\u6743\u9650\u5173\u8054\u4FE1\u606F\u5931\u8D25",
  133003: "\u65E0\u6548\u7684\u4E3B\u64AD\u67E5\u8BE2",
  133004: "\u521B\u5EFA\u6570\u91CF\u8D85\u8FC7\u4E0A\u9650",
  133005: "\u4E3B\u6301\u4EBA\u5DF2\u767B\u5F55",
  133006: "\u6635\u79F0\u4E0D\u80FD\u4E3A\u7A7A",
  133007: "\u53E3\u4EE4\u9519\u8BEF",
  133008: "\u65E0\u6548\u7684appId",
  133009: "\u65E0\u6548\u7684\u623F\u95F4\u4FE1\u606F",
  133010: "\u65E0\u6548\u7684\u4E3B\u64AD",
  133011: "\u8BE5\u540D\u79F0\u5DF2\u5B58\u5728\uFF0C\u8BF7\u91CD\u65B0\u8BBE\u7F6E",
  133012: "\u5F53\u524D\u6B63\u5728\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u66F4\u65B0\u4E3B\u6301\u4EBA\u53E3\u4EE4",
  133113: "\u53C2\u6570\u4FE1\u606F\u5B58\u5728\u7F3A\u5931",
  133114: "\u4FEE\u6539\u4E3B\u64AD\u4FE1\u606F\u5931\u8D25",
  133115: "\u4E3B\u6301\u4EBA\u5DF2\u767B\u5F55",
  133116: "\u4E3B\u6301\u4EBA\u65E0\u6CD5\u624B\u52A8\u521B\u5EFA",
  133117: "\u975E\u8FDE\u9EA6\u76F4\u64AD\u65E0\u5609\u5BBE",
  133118: "\u5609\u5BBE\u5DF2\u767B\u5F55",
  133119: "\u8BE5\u623F\u95F4\u7C7B\u578B\u7684\u52A9\u7406\u6CA1\u6709\u8BE5\u6743\u9650\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9",
  133120: "\u52A9\u7406\u6743\u9650\u4E0D\u80FD\u4E3A\u7A7A",
  133121: "\u52A9\u7406\u76D1\u63A7\u6743\u9650\u4E3A\u5FC5\u586B\u9879",
  133122: "\u8BF7\u4F7F\u7528\u7F51\u9875\u7AEF\u8FDB\u5165",
  133994: "\u65E0\u6548\u7684\u767B\u5F55\u7528\u6237",
  133995: "\u5BC6\u7801\u9519\u8BEF\u8D85\u8FC710\u6B21\uFF0C\u8BF7\u572830\u5206\u949F\u540E\u91CD\u8BD5\uFF01",
  133996: "\u975E\u6CD5\u7684\u623F\u95F4\u6743\u9650",
  133997: "\u8D26\u53F7\u4E0D\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u4E3B\u529E\u65B9",
  133998: "\u4E3B\u6301\u4EBA\u4E0D\u80FD\u5220\u9664",
  134001: "\u521B\u5EFA\u79DF\u6237\u5546\u54C1\u5F02\u5E38",
  134002: "\u4FEE\u6539\u79DF\u6237\u5546\u54C1\u5F02\u5E38",
  134003: "\u5220\u9664\u79DF\u6237\u5546\u54C1\u5F02\u5E38",
  134004: "\u65E0\u6548\u79DF\u6237\u5546\u54C1",
  134011: "\u521B\u5EFA\u623F\u95F4\u5546\u54C1\u5F02\u5E38",
  134012: "\u4FEE\u6539\u623F\u95F4\u5546\u54C1\u5F02\u5E38",
  134013: "\u5220\u9664\u623F\u95F4\u5546\u54C1\u5F02\u5E38",
  134014: "\u65E0\u6548\u623F\u95F4\u5546\u54C1",
  134015: "\u521B\u5EFA\u623F\u95F4\u5546\u54C1\u53C2\u6570\u65E0\u6548",
  134016: "\u623F\u95F4\u6392\u5E8F\u5B57\u6BB5\u5F02\u5E38",
  134017: "\u623F\u95F4\u6392\u5E8F\u53C2\u6570\u5F02\u5E38",
  134018: "\u7B2C\u4E00\u4E2A\u6216\u8005\u6700\u540E\u4E00\u4E2A\u4E0D\u652F\u6301\u4E0A\u79FB\u4E0B\u79FB",
  134019: "\u65E0\u6548\u7684\u5A92\u4F53\u5E93\u8D44\u6E90",
  134020: "\u4E0A\u4F20\u56FE\u7247\u5931\u8D25",
  134021: "\u5546\u54C1\u540D\u4E0D\u80FD\u91CD\u590D",
  134022: "\u5546\u54C1\u4EF7\u683C\u9700\u5C0F\u4E8E\u5212\u7EBF\u4EF7\u683C",
  134024: "\u623F\u95F4\u5185\u6700\u5927\u6DFB\u52A050\u4E2A\u5546\u54C1",
  134995: "\u65E0\u6548\u7684\u767B\u5F55\u7528\u6237",
  135001: "\u5220\u9664\u5A92\u4F53\u5E93\u8D44\u6E90\u5931\u8D25",
  135002: "\u79FB\u81F3\u5A92\u4F53\u5E93\u5931\u8D25",
  135003: "\u6682\u5B58\u5A92\u8D44\u4E0D\u5B58\u5728",
  135004: "\u7269\u7406\u5220\u9664\u6682\u5B58\u5E93\u8D44\u6E90\u5931\u8D25",
  135005: "\u4FDD\u5B58\u5220\u9664\u8BB0\u5F55\u5931\u8D25",
  135006: "\u6267\u884C\u7269\u7406\u5220\u9664\u5A92\u4F53\u5E93\u5A92\u8D44\u5931\u8D25",
  135007: "\u6267\u884C\u7269\u7406\u5220\u9664\u6682\u5B58\u5E93\u5A92\u8D44\u5931\u8D25",
  135011: "\u5220\u9664\u5931\u8D25\uFF0C\u8C03\u7528\u817E\u8BAF\u4E91\u5220\u9664\u5A92\u8D44\u63A5\u53E3\u5931\u8D25",
  135012: "\u521B\u5EFA\u5A92\u4F53\u5E93\u4E0A\u4F20\u6587\u4EF6\u8BB0\u5F55\u5931\u8D25",
  135013: "\u521B\u5EFA\u5A92\u4F53\u5E93\u6587\u4EF6\u5931\u8D25",
  135014: "\u65E0\u6548\u7684\u5A92\u8D44\u4FE1\u606F",
  135015: "\u66F4\u65B0\u5A92\u4F53\u5E93\u4E0A\u4F20\u6587\u4EF6\u8BB0\u5F55\u5931\u8D25",
  135016: "\u66F4\u65B0\u5A92\u4F53\u5E93\u6587\u4EF6\u5931\u8D25",
  135017: "\u8BF7\u6C42\u6B21\u6570\u8FBE\u5230\u6700\u5927\u503C",
  135018: "\u65E0\u6548\u7684\u5A92\u4F53\u5E93\u6587\u4EF6",
  135019: "\u65E0\u6548\u7684\u5A92\u4F53\u5E93\u6587\u4EF6\u4E0A\u4F20\u8BB0\u5F55",
  135020: "\u7269\u7406\u5220\u9664\u5A92\u4F53\u5E93\u8D44\u6E90\u5931\u8D25",
  135021: "\u5A92\u4F53\u5E93\u6587\u4EF6\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A",
  135022: "\u521B\u5EFA\u5A92\u4F53\u5E93\u8F6C\u7801\u8BB0\u5F55\u5931\u8D25",
  135023: "\u66F4\u65B0\u5A92\u4F53\u5E93\u8F6C\u7801\u8BB0\u5F55\u5931\u8D25",
  135024: "\u6587\u4EF6\u8F6C\u7801\u4E2D\u6216\u8F6C\u7801\u6210\u529F\uFF0C\u65E0\u6CD5\u8F6C\u7801",
  135025: "\u65E0\u6548\u7684\u8F6C\u7801\u4EFB\u52A1",
  135026: "\u65E0\u6548\u7684\u89C6\u9891\u6765\u6E90",
  135027: "\u4E0A\u4F20\u961F\u5217\u6700\u591A\u652F\u630120\u6761",
  135028: "\u5220\u9664\u7F51\u7EDC\u4E0A\u4F20\u8BB0\u5F55\u5931\u8D25",
  135029: "\u91CD\u4F20\u7F51\u7EDC\u4E0A\u4F20\u6587\u4EF6\u5931\u8D25",
  135030: "\u521B\u5EFA\u5A92\u4F53\u5E93\u8F6C\u7801\u6587\u4EF6\u5931\u8D25",
  135031: "\u66F4\u65B0\u5A92\u4F53\u5E93\u8F6C\u7801\u6587\u4EF6\u5931\u8D25",
  135032: "\u7B49\u5F85\u4E0A\u4F20\u53CA\u4E0A\u4F20\u5931\u8D25\u624D\u80FD\u5220\u9664",
  135033: "\u4E0A\u4F20\u5931\u8D25\u624D\u80FD\u91CD\u4F20",
  135034: "\u6587\u4EF6\u672A\u8F6C\u7801\u6216\u8F6C\u7801\u4E2D\uFF0C\u65E0\u6CD5\u5220\u9664",
  135035: "\u4FEE\u6539\u89C6\u9891\u6587\u4EF6\u8FC7\u671F\u65F6\u95F4\u5931\u8D25",
  135036: "\u89C6\u9891\u5DF2\u88AB\u5220\u9664\uFF0C\u65E0\u6CD5\u64AD\u653E",
  135037: "\u4FEE\u6539\u5A92\u4F53\u5E93\u4E0A\u4F20\u8BB0\u5F55\u5931\u8D25",
  135038: "\u521B\u5EFA\u5A92\u4F53\u5E93\u4E0A\u4F20\u8BB0\u5F55\u5931\u8D25",
  135039: "\u65E0\u6548\u7684\u5A92\u4F53\u5E93\u4E0A\u4F20\u8BB0\u5F55",
  135040: "\u6700\u591A\u9009\u62E920\u4E2A\u5A92\u4F53\u6587\u4EF6",
  135041: "\u65E0\u6548\u7684\u5A92\u4F53\u5E93\u5B58\u50A8\u8D44\u6E90\u4FE1\u606F",
  135042: "\u521B\u5EFA\u5A92\u4F53\u68C0\u6D4B\u4EFB\u52A1\u5931\u8D25",
  135043: "\u4FEE\u6539\u5A92\u4F53\u68C0\u6D4B\u4EFB\u52A1\u5931\u8D25",
  135044: "\u4FEE\u6539\u5A92\u4F53\u8868\u68C0\u6D4B\u72B6\u6001\u5931\u8D25",
  135045: "\u76EE\u7779\u4E91\u68C0\u6D4B\u7ED3\u679C\u56DE\u8C03\u7ED3\u679C\u4E3A\u7A7A",
  135046: "mdf\u540C\u6B65\u68C0\u6D4B\u72B6\u6001\u5931\u8D25",
  135047: "\u521B\u5EFAmdf\u68C0\u6D4B\u4EFB\u52A1\u5931\u8D25",
  135048: "\u7B49\u5F85\u8F6C\u7801\u3001\u8F6C\u7801\u4E2D\u3001\u8F6C\u7801\u5931\u8D25\u7684\u5A92\u8D44\u4E0D\u80FD\u8F6C\u7801",
  135049: "\u65E0\u6548\u7684\u8F6C\u7801\u5206\u8FA8\u7387",
  135050: "\u8BE5\u89C6\u9891\u5DF2\u6709%s\u7684\u8F6C\u7801\u89C6\u9891\uFF0C\u8BF7\u52FF\u91CD\u590D\u8F6C\u7801",
  135051: "\u8BE5\u89C6\u9891\u7684%s\u6B63\u5728\u8F6C\u7801\u4E2D\uFF0C\u8BF7\u7A0D\u540E\u67E5\u8BE2\u7ED3\u679C",
  135052: "\u7801\u7387\u672A\u8D85\u8FC75Mbps",
  135053: "\u8BE5\u89C6\u9891\u6B63\u5728\u8F6C\u7801\u4E2D\uFF0C\u65E0\u6CD5\u5220\u9664",
  135054: "\u4EC5\u89C6\u9891\u6587\u4EF6\u53EF\u4EE5\u8F6C\u7801",
  135055: "\u68C0\u6D4B\u6210\u529F\u7684\u5A92\u8D44\u624D\u80FD\u8F6C\u7801",
  135056: "\u6587\u4EF6\u5B58\u5728\u5F15\u7528\uFF0C\u65E0\u6CD5\u5220\u9664",
  135057: "\u89C6\u9891\u5F02\u5E38\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  136001: "\u91CD\u590D\u7684\u5546\u6237\u652F\u4ED8\u8BA2\u5355\u53F7",
  136002: "\u5546\u6237\u4ED8\u6B3E\u5FAE\u4FE1\u914D\u7F6E\u4E0D\u5B58\u5728",
  136003: "\u5546\u6237\u4ED8\u6B3E\u8BA2\u5355\u4E0D\u5B58\u5728",
  137001: "\u4E0D\u5B58\u5728\u7684\u76F4\u64AD\u95F4",
  137002: "\u7ED3\u675F\u53F7\u53EC\u5931\u8D25",
  137003: "\u53F7\u53EC\u5DF2\u7ECF\u7ED3\u675F",
  137004: "\u53F7\u53EC\u5DF2\u7ECF\u7ED3\u675F",
  137005: "\u80FD\u529B\u4E0D\u5B58\u5728",
  137006: "\u623F\u95F4\u5B58\u5728\u6B63\u5728\u8FDB\u884C\u7684\u53F7\u53EC",
  137007: "\u6D3B\u52A8\u5DF2\u7ED3\u675F\uFF0C\u65E0\u6CD5\u53D1\u8D77\u53F7\u53EC",
  137008: "\u83B7\u53D6\u5177\u4F53\u53F7\u53EC\u80FD\u529B\u4FE1\u606F\u9519\u8BEF",
  137009: "\u521B\u5EFA\u53F7\u53EC\u5931\u8D25",
  137010: "\u521B\u5EFA\u53F7\u53EC\u5931\u8D25",
  137011: "\u5220\u9664\u53F7\u53EC\u5931\u8D25",
  137012: "\u8BF7\u9009\u62E9\u672A\u5F00\u542F\u7684\u7B7E\u5230",
  137013: "\u884C\u52A8\u53F7\u53EC\u7684\u6301\u7EED\u65F6\u95F4\u5927\u4E8E\u7B7E\u5230\u65F6\u957F,\u8BF7\u91CD\u65B0\u9009\u62E9\u6301\u7EED\u65F6\u95F4",
  137014: "\u8BF7\u5148\u5F00\u542F\u7B7E\u5230\u529F\u80FD",
  137015: "\u6709\u7B7E\u5230\u6B63\u5728\u8FDB\u884C\u4E2D\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  137016: "\u884C\u52A8\u53F7\u53EC\u7684\u7B7E\u5230\u5F00\u542F\u5931\u8D25",
  138001: "\u63A8\u5E7F\u6E20\u9053\u4E0D\u5B58\u5728",
  138002: "\u8BE5\u6E20\u9053\u5DF2\u4E0B\u67B6",
  138003: "\u8BE5\u6E20\u9053\u5DF2\u5931\u6548",
  139001: "\u65E0\u6548\u7684\u901A\u77E5",
  139002: "\u521B\u5EFA\u901A\u77E5\u5931\u8D25",
  139003: "\u4FEE\u6539\u901A\u77E5\u5931\u8D25",
  139004: "\u4EC5\u5F85\u53D1\u9001\u53D6\u6D88\u53EF\u4EE5\u7F16\u8F91",
  139005: "\u521B\u5EFA\u901A\u77E5\u5BF9\u8C61\u5931\u8D25",
  139006: "\u4FEE\u6539\u901A\u77E5\u5BF9\u8C61\u5931\u8D25",
  139007: "\u53D6\u6D88\u5931\u8D25\uFF0C\u6539\u901A\u77E5\u5DF2\u53D1\u9001\u6210\u529F",
  14e4: "\u521B\u5EFA\u8BA2\u5355\u62A5\u8868\u5931\u8D25",
  140001: "\u4FEE\u6539\u8BA2\u5355\u62A5\u8868\u72B6\u6001\u5931\u8D25",
  140002: "\u72B6\u6001\u53D6\u503C\u8303\u56F4\u4E3A1-2",
  140003: "\u65E0\u6548\u7684\u8BA2\u5355\u62A5\u8868",
  140004: "\u5220\u9664\u6587\u4EF6\u5931\u8D25",
  140005: "\u65E0\u6548\u7684\u62A5\u8868\u4E0B\u8F7D\u5730\u5740",
  140006: "\u7814\u8BA8\u4F1A\u89C2\u770B\u4E34\u65F6\u5E76\u53D1 \u5E94\u9009\u62E9 \u7814\u8BA8\u4F1A\u623F\u95F4",
  141e3: "\u521B\u5EFA\u6570\u636E\u5BFC\u51FA\u4EFB\u52A1\u5931\u8D25",
  141001: "\u5F53\u524D\u5DF2\u6709\u5BFC\u51FA\u4EFB\u52A1\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  141002: "\u4FEE\u6539\u6570\u636E\u5BFC\u51FA\u72B6\u6001\u5931\u8D25",
  141003: "\u5BFC\u51FA\u72B6\u6001\u53D6\u503C\u8303\u56F4\u4E3A0-2",
  141004: "\u65E0\u6548\u7684\u6570\u636E\u5BFC\u51FA\u4EFB\u52A1",
  141005: "\u5220\u9664\u6570\u636E\u5BFC\u51FA\u4EFB\u52A1\u5931\u8D25",
  141006: "\u65E0\u6548\u7684\u5BFC\u51FA\u4EF6\u4E0B\u8F7D\u5730\u5740",
  142001: "\u65E0\u6548\u7684\u5F00\u53D1\u8005\u5E94\u7528",
  142002: "\u65E0\u6548\u7684appSecret",
  142003: "\u521B\u5EFA\u5BA2\u6237\u5F02\u5E38",
  142004: "\u4FEE\u6539\u5E94\u7528",
  142005: "\u5E94\u7528\u79D8\u94A5\u53EA\u80FD\u4E0B\u8F7D\u4E00\u6B21",
  142006: "\u521B\u5EFA\u80FD\u529B\u5F02\u5E38",
  142007: "\u7F16\u8F91\u80FD\u529B\u5F02\u5E38",
  142008: "\u67E5\u8BE2\u80FD\u529B\u8BE6\u60C5\u5F02\u5E38",
  142009: "\u5220\u9664\u80FD\u529B\u8BE6\u60C5\u5F02\u5E38",
  142010: "\u5220\u9664\u80FD\u529B-\u6743\u9650\u5173\u8054\u5F02\u5E38",
  142011: "\u521B\u5EFA\u80FD\u529B-\u6743\u9650\u5173\u8054\u5F02\u5E38",
  142012: "IP \u4E0D\u5408\u6CD5",
  142013: "\u8BF7\u5148\u5F00\u542F\u5F00\u653E\u5E73\u53F0\u529F\u80FD",
  143001: "\u4E0D\u5B58\u5728\u7684\u4EA7\u54C1",
  144001: "\u5BA2\u6237\u4E0D\u5B58\u5728",
  145001: "\u80FD\u529B\u4E0D\u5B58\u5728",
  145002: "\u91CD\u590D\u5173\u8054\u6743\u9650\u5F02\u5E38",
  146001: "\u5F52\u5C5E\u7EC4\u7EC7\u521B\u5EFA\u7684\u5E94\u7528\u6570\u91CF\u8FBE\u5230\u4E0A\u9650",
  146002: "\u7CFB\u7EDF\u7E41\u5FD9\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  146003: "\u5E94\u7528\u4E0D\u5B58\u5728",
  146004: "\u975E\u6CD5\u8BBF\u95EE\u5E94\u7528\u6570\u636E",
  146005: "\u5E94\u7528\u4E0D\u5B58\u5728\u6216\u8005\u5BA1\u6838\u521D\u59CB\u72B6\u6001\u5F02\u5E38",
  146006: "\u4FEE\u6539\u5E94\u7528\u5931\u8D25",
  146007: "\u5E94\u7528key\u6216\u5E94\u7528\u51ED\u8BC1\u4E0D\u6B63\u786E",
  146008: "\u5E94\u7528\u672A\u542F\u7528",
  146009: "\u5E94\u7528\u5DF2\u88AB\u7981\u7528",
  146010: "\u5BA2\u6237\u4E0D\u5B58\u5728",
  146011: "\u5BA2\u6237\u5DF2\u88AB\u7981\u7528",
  146012: "\u5E94\u7528key\u521B\u5EFA\u5F02\u5E38\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  146013: "\u6388\u6743\u5BA2\u6237\u5DF2\u88AB\u7981\u7528",
  146014: "\u5E94\u7528\u4E0A\u9650\u6570\u91CF\u9700\u5927\u4E8E\u5DF2\u4F7F\u7528\u6570\u91CF",
  146015: "grantType \u53C2\u6570\u4E0D\u6B63\u786E",
  146016: "scope \u53C2\u6570\u4E0D\u6B63\u786E",
  146017: "\u5916\u90E8\u7528\u6237\u552F\u4E00\u6807\u8BC6\u4E0D\u80FD\u4E3A\u7A7A",
  146018: "\u6D3B\u52A8\u53F7\u548C\u6D3B\u52A8id\u4E0D\u80FD\u90FD\u4E3A\u7A7A",
  146019: "\u8BE5\u5E94\u7528\u4E0D\u5B58\u5728\u6216\u672A\u542F\u7528",
  146020: "\u5F00\u542F\u7BA1\u7406\u5458\u767B\u9646URL\u9700\u914D\u7F6E\u5730\u5740",
  147001: "\u989C\u8272\u7F16\u53F7\u9519\u8BEF",
  147002: "\u4E3B\u9898\u4FEE\u6539\u5931\u8D25",
  147003: "\u4E3B\u9898\u521D\u59CB\u5316\u5931\u8D25",
  148e3: "\u521B\u5EFA\u6570\u636E\u5BFC\u51FA\u4EFB\u52A1\u5931\u8D25",
  148001: "\u5F53\u524D\u5DF2\u6709\u5BFC\u51FA\u4EFB\u52A1\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  148002: "\u4FEE\u6539\u6570\u636E\u5BFC\u51FA\u72B6\u6001\u5931\u8D25",
  148003: "\u5BFC\u51FA\u72B6\u6001\u53D6\u503C\u8303\u56F4\u4E3A0-2",
  148004: "\u65E0\u6548\u7684\u6570\u636E\u5BFC\u51FA\u4EFB\u52A1",
  148005: "\u5220\u9664\u6570\u636E\u5BFC\u51FA\u4EFB\u52A1\u5931\u8D25",
  148006: "\u65E0\u6548\u7684\u5BFC\u51FA\u4EF6\u4E0B\u8F7D\u5730\u5740",
  149001: "\u4FEE\u6539\u56FE\u7247\u5E7F\u544A\u5931\u8D25",
  149002: "\u4E0D\u5B58\u5728\u7684\u5E7F\u544A\u9879id",
  149003: "\u4FEE\u6539\u56FE\u7247\u5E7F\u544A\u9879\u5931\u8D25",
  149004: "\u5141\u8BB8\u5173\u95ED\u5F00\u5173\u72B6\u6001\u4E0D\u80FD\u4E3A\u7A7A",
  149005: "\u5E7F\u544A\u56FE\u7247\u5217\u8868\u4E0D\u80FD\u4E3A\u7A7A",
  149006: "\u5E7F\u544A\u56FE\u7247\u9879\u8DF3\u8F6C\u5730\u5740\u683C\u5F0F\u4E0D\u6B63\u786E",
  149007: "\u5C55\u793A\u4F4D\u7F6E\u4E0D\u80FD\u4E3A\u7A7A",
  15e4: "\u65E0\u6548\u7684\u4F01\u4E1A\u8D44\u6E90\u5305",
  150001: "\u4FEE\u6539\u4F01\u4E1A\u8D44\u6E90\u5305\u5931\u8D25",
  150002: "\u4F01\u4E1A\u5E93\u5B58\u4E0D\u8DB3",
  150003: "\u4FEE\u6539\u4F01\u4E1A\u5E93\u5B58\u5931\u8D25",
  150004: "\u521B\u5EFA\u4F01\u4E1A\u8D44\u6E90\u6D88\u8017\u6D41\u6C34\u5931\u8D25",
  150005: "\u5A92\u4F53\u5E93\u5BB9\u91CF\u4E0D\u8DB3",
  150006: "\u5BA2\u6237\u6570\u91CF\u4E0D\u8DB3",
  150007: "\u77ED\u4FE1\u8D44\u6E90\u4E0D\u8DB3\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
  150008: "\u5217\u8868\u76F4\u64AD\u65F6\u957F\u8D44\u6E90\u4E0D\u8DB3\uFF0C\u65E0\u6CD5\u5F00\u542F",
  150009: "\u5A92\u4F53\u670D\u52A1\u65F6\u957F\u8D44\u6E90\u4E0D\u8DB3\uFF0C\u65E0\u6CD5\u8FDB\u884C\u76F4\u64AD",
  150010: "\u7B2C\u4E09\u65B9\u8F6C\u63A8\u65F6\u957F\u4E0D\u8DB3",
  150011: "\u865A\u62DF\u4F1A\u8BAE\u5BA4\u5E93\u5B58\u4E0D\u8DB3",
  150012: "\u7B2C\u4E09\u65B9\u8F6C\u63A8\u65F6\u957F\u4E0D\u8DB3",
  150013: "\u9A8C\u8BC1\u7801\u83B7\u53D6\u5931\u8D25\uFF0C\u8BF7\u8054\u7CFB\u4E3B\u529E\u65B9",
  150014: "\u65E0\u6CD5\u64AD\u653E\uFF0C\u8BF7\u8054\u7CFB\u4E3B\u529E\u65B9",
  150015: "\u8D44\u6E90\u5E93\u5B58\u91CF\u4E0D\u8DB3",
  150016: "\u5E76\u53D1\u8D44\u6E90\u4E0D\u8DB3\uFF0C\u65E0\u6CD5\u64AD\u653E",
  150017: "\u8FDE\u9EA6\u65F6\u957F\u8D44\u6E90\u4E0D\u8DB3",
  150018: "\u8D85\u6E05\u97F3\u89C6\u9891\u8FDE\u9EA6\u65F6\u957F\u5E93\u5B58\u4E0D\u8DB3",
  150020: "\u672A\u77E5\u7684\u7BA1\u63A7\u5206\u7EC4",
  150021: "\u901A\u7528\u8D44\u6E90\u7BA1\u63A7\u5F02\u5E38",
  150022: "\u7814\u8BA8\u4F1A\u8D44\u6E90\u4E0D\u8DB3",
  150023: "\u64AD\u653E\u9519\u8BEF\uFF0C\u8D44\u6E90\u4E0D\u8DB3",
  150024: "\u7814\u8BA8\u4F1A\u53EF\u521B\u5EFA\u6570\u91CF\u4E0D\u8DB3",
  150025: "\u65E0\u6548\u7684\u7248\u672C",
  150026: "\u5F53\u524D\u7248\u672C\u6700\u591A\u521B\u5EFA1\u4E2A\u76F4\u64AD\u95F4\uFF0C\u8BF7\u5148\u5347\u7EA7\u7248\u672C",
  150027: "\u5F53\u524D\u7248\u672C\u65E0\u6CD5\u521B\u5EFA\u4E0D\u540C\u7C7B\u578B\u7A7A\u95F4\uFF0C\u8BF7\u5148\u5347\u7EA7\u7248\u672C",
  150028: "\u8BF7\u5148\u8D2D\u4E70\u7814\u8BA8\u4F1A\u4F1A\u8BAE\u5BA4\u8D44\u6E90",
  150029: "\u9A8C\u8BC1\u7801\u77ED\u4FE1\u5C1A\u672A\u914D\u7F6E\uFF0C\u8BF7\u8054\u7CFB\u4E3B\u529E\u65B9",
  150030: "\u8D85\u6E05\u7814\u8BA8\u4F1A\u8D44\u6E90\u4E0D\u8DB3",
  150031: "\u8BF7\u5148\u8D2D\u4E70\u8D85\u6E05\u7814\u8BA8\u4F1A\u4F1A\u8BAE\u5BA4\u8D44\u6E90",
  151001: "\u65E0\u6548\u7684\u7EBF\u4E0A\u89C2\u4F17",
  151002: "\u65E0\u6548\u7684\u5728\u7EBF\u804A\u5929",
  151003: "\u65E0\u6548\u7684\u5728\u7EBF\u79C1\u4FE1",
  151004: "\u65E0\u6548\u7684\u5728\u7EBF\u7528\u6237\u7C7B\u578B",
  151005: "\u65E0\u6548\u7684\u8BF7\u6C42\u53C2\u6570",
  151006: "\u60A8\u65E0\u6743\u9650\u8FDB\u5165\u8BE5\u4F1A\u573A",
  151007: "\u8D85\u8FC7\u623F\u95F4\u7F6E\u9876\u9650\u5236",
  151008: "\u7BA1\u7406\u5458\u5DF2\u5173\u95ED\u804A\u5929\u529F\u80FD",
  151009: "\u533F\u540D\u7528\u6237\u4E0D\u5141\u8BB8\u804A\u5929",
  151010: "\u5F00\u59CB\u7B7E\u5230\u5F02\u5E38",
  151011: "\u5173\u95ED\u7B7E\u5230\u5F02\u5E38",
  151012: "\u83B7\u53D6\u7B7E\u5230\u6570\u636E\u5F02\u5E38",
  151013: "\u5BFC\u51FA\u7B7E\u5230\u6570\u636E\u5931\u8D25\u7B7E\u5230\u5C1A\u672A\u7ED3\u675F",
  151014: "\u5F53\u524D\u7B7E\u5230\u573A\u6B21\u672A\u7ED3\u675F",
  151015: "\u65B0\u589E\u7B7E\u5230\u7528\u6237\u5F02\u5E38",
  151016: "\u4F60\u5728\u7981\u8A00\u5217\u8868\u4E2D",
  151017: '\u60A8\u53D1\u9001\u7684\u5185\u5BB9\u5305\u542B\u654F\u611F\u8BCD"%s"',
  151018: "\u4FEE\u6539\u5728\u7EBF\u7528\u6237\u8FDE\u9EA6\u72B6\u6001\u5F02\u5E38",
  151019: "\u8BE5\u6D88\u606F\u672A\u5BA1\u6838,\u7981\u6B62\u64CD\u4F5C",
  151020: "\u804A\u5929\u5217\u8868\u67E5\u8BE2\u8D85\u51FA\u4E86800\u6761\u9650\u5236",
  151021: "\u6CA1\u6709\u6743\u9650\u6765\u521B\u5EFA\u7EA2\u5305",
  151022: "\u60A8\u8BF4\u7684\u592A\u5FEB\u4E86,\u4F11\u606F%s\u79D2\u5427",
  151023: "\u8BF7\u52FF\u9891\u7E41\u64CD\u4F5C",
  151024: "\u6D88\u606F\u670D\u52A1\u5F02\u5E38\uFF0C\u8BF7\u5237\u65B0\u9875\u9762",
  151025: "\u5177\u540D\u7528\u6237\u533F\u540D\u804A\u5929\u5173\u95ED",
  151026: "\u7981\u8A00\u7528\u6237\u5DF2\u8FBE\u4E0A\u9650",
  151027: "\u8E22\u51FA\u7528\u6237\u5DF2\u8FBE\u4E0A\u9650",
  151028: "\u56DE\u590D\u5931\u8D25,\u6D88\u606F\u5DF2\u88AB\u5220\u9664",
  151029: "\u804A\u5929\u5185\u5BB9\u4E0D\u5408\u89C4",
  152001: "\u521B\u5EFA\u7EBF\u8DEF\u914D\u7F6E\u5F02\u5E38",
  152002: "\u4FEE\u6539\u5168\u7403\u7EBF\u8DEF\u914D\u7F6E\u5F02\u5E38",
  152003: "\u4FEE\u6539\u591A\u5206\u8FA8\u7387\u914D\u7F6E\u5F02\u5E38",
  152004: "\u623F\u95F4\u4E0D\u5B58\u5728",
  152005: "\u6B63\u5728\u63A8\u6D41\u4E2D",
  152006: "\u672A\u5F00\u59CB\u76F4\u64AD",
  152007: "\u914D\u7F6E\u4E0D\u5B58\u5728\u6216\u8005\u672A\u5F00\u542F\u591A\u5206\u8FA8\u7387\u914D\u7F6E",
  152008: "\u4FEE\u6539\u9ED8\u8BA4\u7EBF\u8DEF\u5F02\u5E38",
  152009: "\u4FEE\u6539\u7EBF\u8DEF\u72B6\u6001\u5F02\u5E38",
  152010: "\u4FEE\u6539\u7EBF\u8DEF\u540D\u79F0\u5F02\u5E38",
  152011: "\u65E0\u6548\u7684\u7B2C\u4E09\u65B9\u63A8\u6D41",
  152012: "\u4FEE\u6539\u7B2C\u4E09\u65B9\u63A8\u6D41\u5F02\u5E38",
  152013: "\u521B\u5EFA\u7B2C\u4E09\u65B9\u63A8\u6D41\u5F02\u5E38",
  152014: "\u5220\u9664\u7B2C\u4E09\u65B9\u63A8\u6D41\u5F02\u5E38",
  152015: "\u521B\u5EFA\u76EE\u7779\u4E91\u63A8\u6D41\u5F02\u5E38",
  152016: "\u83B7\u53D6\u5206\u5E03\u5F0F\u9501\u5F02\u5E38",
  152017: "\u83B7\u53D6\u56FE\u6587\u6570\u636E\u5F02\u5E38",
  152018: "\u91CA\u653E\u5206\u5E03\u5F0F\u9501\u5F02\u5E38",
  152019: "\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  153001: '\u60A8\u53D1\u9001\u7684\u516C\u544A\u5185\u5BB9\u5305\u542B\u654F\u611F\u8BCD"%s"',
  153002: "\u516C\u544A\u53D1\u9001\u8FC7\u4E8E\u9891\u7E41,\u8BF75\u79D2\u540E\u91CD\u8BD5",
  153003: "\u516C\u544A\u5185\u5BB9\u4E0D\u5408\u89C4",
  154001: "\u65E0\u6548\u7684\u8425\u9500\u5DE5\u5177",
  154002: "\u8425\u9500\u5DE5\u5177\u542F\u7528\u4E2D",
  154003: "\u521B\u5EFA\u8425\u9500\u5DE5\u5177\u5F02\u5E38",
  154004: "\u4FEE\u6539\u8425\u9500\u5DE5\u5177\u5F02\u5E38",
  154005: "\u5220\u9664\u8425\u9500\u5DE5\u5177\u5F02\u5E38",
  154006: "\u76F8\u540C\u7C7B\u578B\u7684\u4E92\u52A8\u540C\u65F6\u53EA\u80FD\u542F\u7528\u4E00\u4E2A,\u5F53\u524D\u542F\u7528\u6570\u91CF\u4E3A%s",
  154007: "\u8868\u5355ID\u4E0D\u53EF\u4FEE\u6539",
  154008: "\u8868\u5355\u95EE\u9898\u4E0D\u53EF\u5220\u9664",
  154009: "\u95EE\u9898\u4E0D\u53EF\u66F4\u6362",
  154010: "\u95EE\u9898\u7C7B\u578B\u4E0D\u53EF\u4FEE\u6539",
  154011: "\u9009\u9879\u4E0D\u53EF\u66F4\u6362",
  154012: "\u9009\u9879\u4E0D\u53EF\u5220\u9664",
  154013: "\u9898\u76EE\u8D85\u51FA\u6700\u5927\u9650\u5236",
  154014: "\u63D0\u4EA4\u95EE\u5377\u4E3A\u7A7A",
  154015: "\u521B\u5EFA\u8425\u9500\u5DE5\u5177\u5173\u952E\u89C2\u4F17\u5F02\u5E38",
  154016: "\u8BF7\u52FF\u91CD\u590D\u586B\u5199",
  154017: "\u8425\u9500\u5DE5\u5177\u540D\u79F0\u4E0D\u652F\u6301\u91CD\u590D",
  154018: "\u63D0\u4EA4\u5BA2\u670D\u80FD\u529B\u4E3A\u7A7A",
  154019: "\u65E0\u6548\u7684\u8425\u9500\u5DE5\u5177\u7EDF\u8BA1",
  154020: "\u8425\u9500\u5DE5\u5177\u672A\u542F\u7528",
  154021: "\u8425\u9500\u5DE5\u5177\u672A\u5173\u8054\u80FD\u529B",
  154022: "\u6D3B\u52A8\u5DF2\u8FC7\u7ED3\u675F\u65F6\u95F4\u4E0D\u53EF\u63D0\u4EA4\u95EE\u5377",
  154023: "\u8425\u9500\u5DE5\u5177\u7C7B\u578B\u4E0D\u5B58\u5728\u95EE\u5377",
  154024: "\u521B\u5EFA\u6587\u4EF6\u4E0B\u8F7D\u5F02\u5E38",
  154025: "\u7F16\u8F91\u6587\u4EF6\u4E0B\u8F7D\u5F02\u5E38",
  154026: "\u521B\u5EFA\u6587\u4EF6\u4E0B\u8F7D\u53C2\u6570\u5F02\u5E38",
  154027: "\u65E0\u6548\u7684\u6587\u4EF6\u4E0B\u8F7D",
  154028: "\u521B\u5EFA\u6587\u4EF6\u8BE6\u60C5\u5F02\u5E38",
  154029: "\u7F16\u8F91\u6587\u4EF6\u8BE6\u60C5\u5F02\u5E38",
  154030: "\u5220\u9664\u6587\u4EF6\u8BE6\u60C5\u5F02\u5E38",
  154031: "\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25",
  154032: "\u521B\u5EFA\u6587\u4EF6\u8BE6\u60C5\u53C2\u6570\u5F02\u5E38",
  154033: "\u8425\u9500\u5DE5\u5177\u7C7B\u578B\u65E0\u6548",
  154034: "\u6587\u4EF6\u540D\u91CD\u590D",
  154035: "\u6587\u4EF6\u6570\u91CF\u9A8C\u8BC1\u5931\u8D25 \u5F53\u524D\u6570\u91CF%s",
  154036: "\u5220\u9664\u6587\u4EF6\u8BE6\u60C5\u5F02\u5E38",
  154037: "\u521B\u5EFA\u6587\u4EF6\u8BE6\u60C5\u53C2\u6570\u5F02\u5E38",
  155e3: "\u66F4\u65B0\u81EA\u5B9A\u4E49\u83DC\u5355\u680F\u5931\u8D25",
  155001: "\u6DFB\u52A0\u83DC\u5355\u680F\u89C6\u9891\u5931\u8D25",
  155002: "\u65E0\u6548\u7684id",
  155003: "\u65E0\u6548\u7684\u89C6\u9891\u9879\u76EE",
  155004: "\u5220\u9664\u83DC\u5355\u680F\u89C6\u9891\u5931\u8D25",
  155005: "\u66F4\u65B0\u89C6\u9891\u987A\u5E8F\u5931\u8D25",
  155006: "\u83B7\u53D6\u5A92\u4F53\u5E93\u89C6\u9891\u4FE1\u606F\u5931\u8D25",
  155007: "\u53C2\u6570\u9519\u8BEF",
  155008: "\u521B\u5EFA\u88C5\u4FEE\u4FE1\u606F\u5931\u8D25",
  155009: "\u4FEE\u6539\u88C5\u4FEE\u4FE1\u606F\u5931\u8D25",
  155010: "\u8BF7\u5148\u521B\u5EFA\u9891\u9053",
  155011: "\u65E0\u6548\u7684\u81EA\u5B9A\u4E49\u83DC\u5355",
  155012: "\u79FB\u52A8ID\u4E3A\u7A7A",
  155013: "front ID\u4E3A\u7A7A",
  155014: "\u81EA\u5B9A\u4E49\u83DC\u5355\u6392\u5E8F\u5F02\u5E38",
  155015: "URL\u4E3A\u7A7A",
  155016: "\u590D\u5236\u88C5\u4FEE\u9875\u9009\u9879\u4E3A\u7A7A",
  155017: "\u5206\u7EC4\u4E3A\u7A7A",
  155018: "\u4FEE\u6539\u88C5\u4FEE\u4FE1\u606F\u5931\u8D25",
  155019: "\u5220\u9664\u5206\u7EC4\u5185\u623F\u95F4\u5931\u8D25",
  155020: "\u521B\u5EFA\u5206\u7EC4\u5185\u623F\u95F4\u5931\u8D25",
  155021: "\u521B\u5EFA\u5206\u7EC4\u5931\u8D25",
  155022: "\u5206\u7EC4\u5185\u6CA1\u6709\u5BF9\u4E8E\u7684\u623F\u95F4",
  155023: "\u590D\u5236\u88C5\u4FEE\u65B9\u6848\u9009\u62E9\u7684\u623F\u95F4\u6D3B\u52A8\u4E0D\u4E00\u81F4",
  155024: "\u590D\u5236\u88C5\u4FEE\u65B9\u6848\u9009\u62E9\u7684\u623F\u95F4\u4E00\u81F4",
  155025: "LOGO\u4E0D\u80FD\u62D6\u52A8",
  155026: "\u5220\u9664\u83DC\u5355\u680F\u5931\u8D25",
  155027: "\u81EA\u5B9A\u4E49\u83DC\u5355\u680F\u89C6\u9891\u914D\u7F6E\u5F02\u5E38",
  155028: "\u76F4\u64AD\u7B80\u4ECB\u4E3B\u6807\u9898\u4E3A\u7A7A",
  155029: "\u5F00\u59CB\u65F6\u95F4\u6216\u8005\u7ED3\u675F\u65F6\u95F4\u4E3A\u7A7A",
  155030: "\u5DF2\u6709\u76F4\u64AD\u7B80\u4ECB\u7C7B\u578B\u83DC\u5355",
  155031: "\u6700\u591A\u53EF\u9009\u62E93\u79CD\u9884\u8BBE\u6587\u6848",
  155032: "watermarkWordType \u53D6\u503C\u8303\u56F4\u4E3A0-1",
  155033: "\u6700\u5C11\u9009\u62E91\u79CD\u9884\u8BBE\u6587\u6848",
  155034: "\u8BF7\u8F93\u5165\u5728\u7EBF\u7528\u6237\u5F00\u5173\u6807\u8BC6",
  155035: "\u5728\u7EBF\u7528\u6237\u5F00\u5173\u6807\u8BC6\u7684\u53D6\u503C\u8303\u56F4\u4E3A0~1",
  155036: "\u8BF7\u8F93\u5165\u5728\u7EBF\u7528\u6237\u5934\u50CF\u5F00\u5173\u6807\u8BC6",
  155037: "\u5728\u7EBF\u7528\u6237\u5934\u50CF\u5F00\u5173\u6807\u8BC6\u7684\u53D6\u503C\u8303\u56F4\u4E3A0~1",
  155038: "\u8BF7\u8F93\u5165\u5728\u7EBF\u7528\u6237\u8303\u56F4",
  155039: "\u5728\u7EBF\u7528\u6237\u8303\u56F4\u5FC5\u987B\u5305\u542B\u89C2\u4F17",
  155040: "\u5728\u7EBF\u7528\u6237\u8303\u56F4\u7684\u53D6\u503C\u8303\u56F4\u4E3A%s~%s",
  155041: "\u7F16\u8F91\u5728\u7EBF\u7528\u6237\u914D\u7F6E\u5931\u8D25",
  155042: "\u81F3\u5C11\u5F00\u542F\u4E00\u4E2A\u8BED\u8A00",
  156001: "\u6587\u4EF6\u5927\u5C0F\u6700\u59275M",
  156002: "\u5F53\u524D\u5DF2\u6709\u5BFC\u5165\u4EFB\u52A1\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  156003: "\u6587\u4EF6\u4EC5\u652F\u6301xls,xlsx\u683C\u5F0F",
  156004: "\u5355\u6B21\u6700\u591A\u5BFC\u51655w\uFF0C\u6700\u5C11\u5BFC\u51651\u6761",
  156005: "\u4E0A\u4F20\u6587\u4EF6\u5931\u8D25",
  156007: "\u521B\u5EFA\u6570\u636E\u4EFB\u52A1\u5BFC\u5165\u5931\u8D25",
  156008: "\u4FEE\u6539\u6570\u636E\u4EFB\u52A1\u5BFC\u5165\u5931\u8D25",
  156009: "\u9519\u8BEF\u8BB0\u5F55\u8D85\u9650",
  156010: "\u8BFB\u53D6\u6587\u4EF6\u5931\u8D25",
  157001: "\u65E0\u6548\u7684\u5C4F\u5E55\u63A7\u5236",
  157002: "\u521B\u5EFA\u5C4F\u5E55\u63A7\u5236\u5931\u8D25",
  157003: "\u4FEE\u6539\u5C4F\u5E55\u63A7\u5236\u5931\u8D25",
  157004: "\u4FEE\u6539\u5C4F\u5E55\u63A7\u5236\u5E03\u5C40\u5931\u8D25",
  157005: "\u4FEE\u6539\u5C4F\u5E55\u63A7\u5236\u64AD\u5355ID\u5931\u8D25",
  160001: "\u5F53\u524D\u529F\u80FD\u672A\u5F00\u542F\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
  160002: "\u57DF\u540D\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u586B\u5199",
  160003: "\u5F53\u524D\u57DF\u540D\u91CD\u590D\uFF0C\u8BF7\u91CD\u65B0\u586B\u5199",
  160004: "\u8BC1\u4E66\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u63D0\u4EA4",
  160005: "\u8BC1\u4E66\u548C\u57DF\u540D\u4E0D\u5339\u914D",
  160006: "\u8BC1\u4E66\u6709\u6548\u65F6\u95F4\u4E0D\u8DB3\u4E00\u4E2A\u6708\uFF0C\u8BF7\u4F7F\u7528\u65B0\u7684\u8BC1\u4E66",
  160007: "\u5BC6\u94A5\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u63D0\u4EA4",
  160008: "\u8BC1\u4E66\u548C\u5BC6\u94A5\u89E3\u6790\u5931\u8D25\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u63D0\u4EA4",
  160009: "\u8BC1\u4E66\u4E0E\u5BC6\u94A5\u4E0D\u5339\u914D\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u63D0\u4EA4",
  160010: "\u5F53\u524D\u9875\u9762\u5DF2\u914D\u7F6E\uFF0C\u8BF7\u4FEE\u6539\u6216\u505C\u7528\u540E\u91CD\u65B0\u914D\u7F6E",
  160011: "\u5F53\u524D\u9875\u9762\u672A\u914D\u7F6E\uFF0C\u8BF7\u5148\u914D\u7F6E\u57DF\u540D",
  160012: "\u4E91\u5382\u5546\u9519\u8BEF",
  160013: "\u8BC1\u4E66\u90E8\u7F72\u5931\u8D25",
  160014: "\u8BC1\u4E66\u4FEE\u6539\u5931\u8D25",
  160015: "\u65E0\u6548\u9875\u9762id",
  160016: "\u6062\u590D\u9ED8\u8BA4\u5931\u8D25",
  160017: "\u7528\u6237\u540D\u9519\u8BEF",
  160018: "\u57DF\u540D\u4E0E\u6D3B\u52A8\u4FE1\u606F\u4E0D\u5339\u914D",
  161001: "\u65B0\u589E\u4F1A\u866B\u7528\u6237\u5931\u8D25",
  161002: "\u65B0\u589E\u4F1A\u866BIP\u5931\u8D25",
  161003: "\u65E0\u6548\u7684\u4F1A\u866B\u7528\u6237",
  161004: "\u65E0\u6548\u7684\u4F1A\u866BIP",
  161005: "\u5220\u9664\u4F1A\u866B\u7528\u6237\u5931\u8D25",
  161006: "\u5220\u9664\u4F1A\u866BIP\u5931\u8D25",
  161007: "IP\u5DF2\u5B58\u5728",
  161008: "\u624B\u673A\u6216\u90AE\u7BB1\u5DF2\u5B58\u5728",
  162001: "\u65B0\u589E\u9ED1\u540D\u5355\u7528\u6237\u5931\u8D25",
  162002: "\u65B0\u589E\u9ED1\u540D\u5355IP\u5931\u8D25",
  162003: "\u65E0\u6548\u7684\u9ED1\u540D\u5355\u7528\u6237",
  162004: "\u65E0\u6548\u7684\u9ED1\u540D\u5355IP",
  162005: "\u5220\u9664\u9ED1\u540D\u5355\u7528\u6237\u5931\u8D25",
  162006: "\u5220\u9664\u9ED1\u540D\u5355IP\u5931\u8D25",
  162007: "IP\u5DF2\u5B58\u5728",
  162008: "\u624B\u673A\u6216\u90AE\u7BB1\u5DF2\u5B58\u5728",
  170001: "\u62A5\u540D\u53C2\u4E0E\u5931\u8D25\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
  170002: "\u65E0\u6548\u623F\u95F4",
  170003: "\u79FB\u9664\u53C2\u4E0E\u4EBA\u5458\u5931\u8D25\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
  170004: "\u62BD\u5956\u5DF2\u7ED3\u675F",
  170005: "\u65E0\u6548\u62BD\u5956",
  170006: "\u540C\u4E00\u76F4\u64AD\u95F4\u62BD\u5956\u540D\u79F0\u4E0D\u652F\u6301\u91CD\u590D",
  170007: "\u62BD\u5956\u7684\u5956\u9879\u6570\u91CF\u6700\u591A\u4E3A20\u4E2A",
  170008: "\u65E0\u6548\u7684\u5956\u9879",
  170009: "\u6CA1\u6709\u6B63\u5728\u8FDB\u884C\u4E2D\u7684\u62BD\u5956\u6D3B\u52A8",
  170010: "\u5956\u9879\u5DF2\u5F00\u5956\uFF0C\u65E0\u6CD5\u7F16\u8F91",
  170011: "\u5956\u9879\u5DF2\u5F00\u5956\uFF0C\u65E0\u6CD5\u5220\u9664",
  170012: "\u5956\u9879\u5F00\u5956\u4E2D\uFF0C\u6682\u65F6\u65E0\u6CD5\u5173\u95ED",
  170013: "\u65E0\u6548\u7684\u5956\u54C1",
  170014: "\u8BF7\u52FF\u91CD\u590D\u5F00\u5956",
  170015: "\u4FEE\u6539\u5F00\u5956\u72B6\u6001\u4E3A\u5F00\u5956\u4E2D\u5931\u8D25",
  170016: "\u4FEE\u6539\u5F00\u5956\u72B6\u6001\u5931\u8D25",
  170017: "\u6709\u5956\u9879\u5728\u64CD\u4F5C\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  170018: "\u521B\u5EFA\u5F00\u5956\u8BB0\u5F55\u5931\u8D25",
  170019: "\u521B\u5EFA\u4E2D\u5956\u8BB0\u5F55\u5931\u8D25",
  170020: "\u4FEE\u6539\u62BD\u5956\u7684\u4E2D\u5956\u4EBA\u6570\u5931\u8D25",
  170021: "\u8BF7\u5148\u5F00\u542F\u62BD\u5956\u6D3B\u52A8",
  170022: "\u62BD\u5956\u6D3B\u52A8\u5DF2\u7ED3\u675F\uFF0C\u65E0\u6CD5\u5F00\u5956",
  170023: "\u5F53\u524D\u62BD\u5956\u6D3B\u52A8\u5DF2\u7ECF\u53C2\u4E0E\uFF0C\u8BF7\u52FF\u91CD\u590D\u62A5\u540D\u53C2\u4E0E",
  170024: "\u53EA\u80FD\u6709\u4E00\u4E2A\u8FDB\u884C\u4E2D\u7684\u62BD\u5956\u6D3B\u52A8",
  170025: "\u4FEE\u6539\u53C2\u4E0E\u8005\u4E2D\u5956\u6B21\u6570\u5931\u8D25",
  170026: "\u62BD\u5956\u72B6\u6001\u5DF2\u53D8\u66F4\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u67E5\u770B",
  170027: "\u8BF7\u81F3\u5C11\u8BBE\u7F6E\u4E00\u4E2A\u5956\u9879",
  170028: "\u62BD\u5956\u6D3B\u52A8\u5DF2\u7ED3\u675F",
  170029: "\u62BD\u5956\u6D3B\u52A8\u5DF2\u7ED3\u675F\uFF0C\u65E0\u6CD5\u5220\u9664\u53C2\u4E0E\u8005",
  170030: "\u62BD\u5956\u623F\u95F4\u72B6\u6001\u5F02\u5E38\uFF0C\u8BF7\u7A0D\u7B49",
  170031: "\u65E0\u6548\u4EBA\u5458\u4FE1\u606F",
  170032: "\u521B\u5EFA\u5956\u9879\u4F18\u5148\u4E2D\u5956\u8005\u5931\u8D25",
  170033: "\u5220\u9664\u5956\u9879\u4F18\u5148\u4E2D\u5956\u8005\u5931\u8D25",
  170034: "\u8BE5\u62BD\u5956\u4E0D\u5141\u8BB8\u62A5\u540D\u53C2\u4E0E",
  170035: "\u5F53\u524D\u62BD\u5956\u4E0D\u5141\u8BB8\u89C2\u4F17\u62A5\u540D\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u62BD\u5956\u8303\u56F4",
  170036: "\u65E0\u6548\u7684\u62BD\u5956\u53C2\u4E0E\u8005",
  170037: "\u4E2D\u5956\u4EBA\u6570\u4E0D\u5F97\u5927\u4E8E\u5956\u54C1\u6570\u91CF",
  170038: "\u5F53\u524D\u5956\u54C1\u6570\u91CF\u5C0F\u4E8E\u9884\u8BBE\u4E2D\u5956\u89C2\u4F17\u6570\u91CF\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u8BD5",
  170039: "\u65E0\u6548\u7684\u62BD\u5956\u8303\u56F4",
  170040: "\u672A\u652F\u6301\u6279\u91CF\u5F00\u5956",
  170041: "\u53E3\u4EE4\u9519\u8BEF",
  170042: "\u8BF7\u5148\u586B\u5199\u53E3\u4EE4",
  170043: "\u62BD\u5956\u6D3B\u52A8\u5F00\u542F30\u5929\u5185\u672A\u64CD\u4F5C\u5F00\u5956\uFF0C\u65E0\u6CD5\u5F00\u5956",
  171001: "\u521B\u5EFA\u6253\u8D4F\u6A21\u7248\u5F02\u5E38",
  171002: "\u4FEE\u6539\u6253\u8D4F\u6A21\u7248\u5F02\u5E38",
  171003: "\u5220\u9664\u6253\u8D4F\u6A21\u7248\u5F02\u5E38",
  171004: "\u65E0\u6548\u6253\u8D4F\u6A21\u7248",
  171010: "\u6A21\u7248\u540D\u79F0\u4E0D\u80FD\u91CD\u590D",
  171101: "\u521B\u5EFA\u6253\u8D4F\u6A21\u7248\u5F02\u5E38",
  171102: "\u4FEE\u6539\u6253\u8D4F\u6A21\u7248\u5F02\u5E38",
  171103: "\u5220\u9664\u6253\u8D4F\u6A21\u7248\u5F02\u5E38",
  171104: "\u4FEE\u6539\u6253\u8D4F\u9053\u5177\u6392\u5E8F\u5F02\u5E38",
  171105: "\u6700\u591A\u6DFB\u52A020\u4E2A\u6253\u8D4F\u9053\u5177",
  171106: "\u66F4\u65B0\u6253\u8D4F\u6A21\u677F\u5F00\u542F\u6807\u8BB0\u5931\u8D25",
  171110: "\u6253\u8D4F\u9053\u5177\u540D\u79F0\u4E0D\u5141\u8BB8\u91CD\u590D",
  171111: "\u65E0\u6548\u7684\u5546\u54C1\u9053\u5177",
  171112: "\u5546\u54C1\u9053\u5177\u5DF2\u7981\u7528",
  171113: "\u9053\u5177\u4ED8\u8D39\u72B6\u6001\u9519\u8BEF",
  171114: "\u623F\u95F4\u7981\u6B62\u6253\u8D4F",
  171115: "\u9053\u5177\u542F\u7528\u4E2D\uFF0C\u672A\u907F\u514D\u4F7F\u7528\u5F02\u5E38\uFF0C\u8BF7\u5173\u95ED\u540E\u518D\u7F16\u8F91",
  171116: "\u8BF7\u52FF\u9891\u7E41\u64CD\u4F5C",
  183001: "\u65E0\u6548\u7684\u76F4\u64AD\u89C2\u4F17",
  183002: "\u8D26\u53F7\u4E0D\u80FD\u4E3A\u7A7A",
  183003: "\u624B\u673A\u53F7\u7801\u683C\u5F0F\u4E0D\u6B63\u786E",
  183004: "\u6388\u6743\u6A21\u5F0F\u4E0D\u6B63\u786E",
  183005: "\u9A8C\u8BC1\u7801\u9519\u8BEF",
  183006: "\u4E0D\u5B58\u5728\u8BE5\u7528\u6237",
  183007: "\u5BC6\u7801\u9519\u8BEF",
  183008: "\u521B\u5EFA\u89C2\u4F17\u5931\u8D25",
  183009: "\u624B\u673A\u53F7\u5DF2\u5B58\u5728\uFF0C\u4E0D\u5141\u8BB8\u91CD\u590D",
  183010: "\u83B7\u53D6\u5FAE\u4FE1\u6388\u6743\u94FE\u63A5\u5F02\u5E38\uFF0Cscope\u4E3A\u7A7A",
  183011: "\u83B7\u53D6\u5FAE\u4FE1\u6388\u6743\u94FE\u63A5\u5F02\u5E38\uFF0Cscope\u65E0\u6548",
  183012: "\u8C03\u7528\u5FAE\u4FE1\u7F51\u7EDC\u8BF7\u6C42\u5F02\u5E38",
  183013: "\u65E0\u6548\u7684\u6388\u6743\u89C2\u4F17",
  183014: "\u83B7\u53D6\u5FAE\u4FE1\u7528\u6237\u6570\u636E\u5F02\u5E38",
  183015: "\u521B\u5EFA\u5FAE\u4FE1\u7528\u6237\u5F02\u5E38",
  183016: "\u7ED1\u5B9A\u7528\u6237\u5F02\u5E38",
  183017: "\u67E5\u8BE2\u7528\u6237token\u5F02\u5E38",
  183018: "\u5FAE\u4FE1\u7528\u6237\u4E0E\u5F53\u524D\u767B\u5F55\u7528\u6237\u4E0D\u5339\u914D",
  183019: "\u5FAE\u4FE1\u6388\u6743\u8D85\u65F6",
  183020: "\u5F53\u524D\u767B\u5F55\u7528\u6237\u5DF2\u7ECF\u7ED1\u5B9A\u5FAE\u4FE1",
  183021: "\u83B7\u53D6\u5FAE\u4FE1\u6388\u6743\u94FE\u63A5\u623F\u95F4\u53F7\u4E3A\u7A7A",
  183022: "\u79DF\u6237\u672A\u914D\u7F6E\u5FAE\u4FE1\u6388\u6743\u4FE1\u606F",
  183023: "\u5FAE\u4FE1\u56DE\u8C03code\u65E0\u6548",
  183024: "\u5FAE\u4FE1\u56DE\u8C03state\u65E0\u6548",
  183025: "\u7528\u6237id\u4E3A\u7A7A",
  183026: "\u5FAE\u4FE1\u83B7\u53D6accessToken\u5F02\u5E38",
  183027: "\u5FAE\u4FE1\u83B7\u53D6jsApiTicket\u5F02\u5E38",
  183028: "\u623F\u95F4\u53F7\u4E0D\u80FD\u4E3A\u7A7A",
  183029: "\u6388\u6743\u8D85\u65F6",
  183030: "\u516C\u4F17\u53F7\u6CA1\u6709\u7ED1\u5B9A\u5F00\u653E\u5E73\u53F0",
  183031: "\u6682\u4E0D\u652F\u6301\u5F00\u653E\u5E73\u53F0\u7684\u6388\u6743\u65B9\u5F0F",
  183032: '\u60A8\u8F93\u5165\u7684\u5185\u5BB9\u5305\u542B\u654F\u611F\u8BCD"%s"\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u8BD5\u3002',
  183033: `\u4E0D\u652F\u6301 ' " \\ / & > < \u7B49\u7279\u6B8A\u5B57\u7B26\u3002`,
  183034: "\u4FEE\u6539\u89C2\u4F17\u5931\u8D25",
  183035: "\u65E0\u6548\u7684\u623F\u95F4\u53F7",
  183036: "\u5FAE\u4FE1\u56DE\u8C03\u5F02\u5E38",
  183037: "\u51C6\u5165\u65B9\u5F0F\u4E0D\u6B63\u786E",
  183038: "\u624B\u673A\u53F7/\u90AE\u7BB1\u4E0D\u80FD\u4E3A\u7A7A",
  183039: "\u9A8C\u8BC1\u7801\u4E0D\u80FD\u4E3A\u7A7A",
  183040: "\u53E3\u4EE4\u4E0D\u80FD\u4E3A\u7A7A",
  183041: "\u53E3\u4EE4\u9519\u8BEF",
  183042: "\u90AE\u7BB1\u6216\u7B2C\u4E09\u65B9\u7F16\u53F7\u81F3\u5C11\u586B\u4E00\u4E2A",
  183043: "\u7528\u6237\u72B6\u6001\u4E0D\u80FD\u4E3A1",
  183044: "\u89C2\u4F17\u8D85\u8FC71\u4E2A",
  183045: "\u4FEE\u6539\u79FB\u9664\u72B6\u6001\u5931\u8D25",
  183046: "\u5220\u9664\u7528\u6237\u5931\u8D25",
  183047: "\u521B\u5EFA\u7B2C\u4E09\u65B9\u8D26\u53F7\u5931\u8D25",
  183048: "\u83B7\u53D6\u7B2C\u4E09\u65B9\u8D26\u53F7\u5931\u8D25",
  183050: "\u5FAE\u4FE1 appsecret \u914D\u7F6E\u4E0D\u6B63\u786E",
  183051: "\u5FAE\u4FE1 appid \u914D\u7F6E\u4E0D\u6B63\u786E",
  183052: "\u5FAE\u4FE1\u516C\u4F17\u53F7\u672A\u914D\u7F6EIP\u767D\u540D\u5355",
  183053: "\u5FAE\u4FE1\u516C\u4F17\u53F7\u5F02\u5E38\uFF0CIP\u9700\u7BA1\u7406\u5458\u786E\u8BA4",
  183054: "\u5FAE\u4FE1\u516C\u4F17\u53F7\u5F02\u5E38\uFF0CIP\u7B49\u5F85\u7BA1\u7406\u5458\u786E\u8BA4\u4E2D",
  183055: "\u5FAE\u4FE1\u516C\u4F17\u53F7\u8C03\u7528\u5F02\u5E38\uFF0CIP\u88AB\u7BA1\u7406\u5458\u62D2\u7EDD",
  183056: "\u5FAE\u4FE1\u516C\u4F17\u53F7\u8C03\u7528\u5F02\u5E38\uFF0CIP\u88AB\u7BA1\u7406\u5458\u62D2\u7EDD",
  183057: "\u5FAE\u4FE1\u516C\u4F17\u53F7AppSecret\u914D\u7F6E\u9519\u8BEF",
  183058: "\u5FAE\u4FE1\u6388\u6743grant_type\u4F20\u53C2\u4E3A\u975Eclient_credential",
  183059: "\u89C2\u4F17\u5BA1\u6838\u5931\u8D25",
  183060: "\u5F53\u524D\u8D26\u53F7\u4E3A\u865A\u62DF\u8D26\u53F7",
  200001: "\u6570\u636E\u7F3A\u5931",
  200002: "\u975E\u6CD5\u53C2\u6570",
  200003: "\u5BFC\u64AD\u53F0\u540D\u79F0\u6700\u957F255\u5B57\u7B26",
  200004: "\u4E91\u5BFC\u64AD\u53F0\u5C1A\u672A\u5F00\u542F",
  200005: "\u4E91\u5BFC\u64AD\u53F0\u5DF2\u5220\u9664",
  200006: "\u4E91\u5BFC\u64AD\u53F0\u5DF2\u5173\u95ED",
  200007: "\u4E91\u5BFC\u64AD\u53F0\u5DF2\u5F00\u542F",
  200008: "\u4E91\u5BFC\u64AD\u53F0\u5C1A\u672A\u5173\u95ED",
  200009: "\u5EF6\u65F6\u64AD\u5DF2\u5F00\u542F",
  200010: "\u5EF6\u65F6\u64AD\u5DF2\u5173\u95ED",
  200011: "\u4E91\u5BFC\u64AD\u53F0\u4F7F\u7528\u65F6\u957F\u8D44\u6E90\u4E0D\u8DB3\uFF0C\u5F00\u542F\u5931\u8D25",
  200012: "\u5EF6\u65F6\u64AD\u5C1A\u672A\u5F00\u542F",
  200013: "\u5BFC\u64AD\u53F0\u5F00\u542F\u4E2D",
  200014: "\u975E\u6CD5IP\u8BF7\u6C42",
  200015: "\u5BFC\u64AD\u53F0\u540D\u79F0\u4EC5\u652F\u6301\u4E2D\u82F1\u6587\u548C\u6570\u5B57",
  200016: "\u64CD\u4F5C\u9891\u7E41",
  200017: "\u8D44\u6E90\u6B63\u5728\u91CA\u653E\u4E2D\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  200018: "\u8BF7\u5148\u5173\u95ED\u5EF6\u65F6\u64AD",
  208e3: "\u65E0\u6548\u7684\u6743\u9650",
  209e3: "\u65E0\u6548\u7684\u89D2\u8272",
  209001: "\u521B\u5EFA\u89D2\u8272\u5931\u8D25",
  209002: "\u4FEE\u6539\u89D2\u8272\u5931\u8D25",
  209003: "\u5220\u9664\u89D2\u8272\u5931\u8D25",
  209004: "\u8BE5\u89D2\u8272\u5B58\u5728\u5173\u8054\u7528\u6237",
  209005: "\u521B\u5EFA\u89D2\u8272\u6743\u9650\u5173\u8054\u4FE1\u606F\u5931\u8D25",
  209006: "\u5220\u9664\u89D2\u8272\u6743\u9650\u5173\u8054\u4FE1\u606F\u5931\u8D25",
  209007: "\u6DFB\u52A0\u6210\u5458\u53C2\u6570\u9519\u8BEF",
  209008: "\u5220\u9664\u6210\u5458\u53C2\u6570\u9519\u8BEF",
  209009: "\u89D2\u8272\u540D\u79F0\u4E0D\u53EF\u91CD\u590D",
  209010: "\u89D2\u8272\u4E0D\u53EF\u7F16\u8F91",
  21e4: "\u90AE\u7BB1\u548C\u624B\u673A\u4E0D\u80FD\u90FD\u4E3A\u7A7A",
  210001: "\u65B0\u589E\u4EBA\u5458\u5931\u8D25",
  210002: "\u4FEE\u6539\u4EBA\u5458\u5931\u8D25",
  210003: "\u65E0\u6548\u7684\u4EBA\u5458\u4FE1\u606F",
  210004: "\u624B\u673A\u53F7\u7801\u5DF2\u5B58\u5728",
  210005: "\u90AE\u7BB1\u5DF2\u5B58\u5728",
  210006: "\u624B\u673A\u53F7/\u90AE\u7BB1\u4E0D\u5B58\u5728",
  210007: "\u624B\u673A\u53F7/\u90AE\u7BB1\u5DF2\u5B58\u5728",
  210008: "\u5BC6\u7801\u9519\u8BEF",
  210009: "\u65E7\u5BC6\u7801\u4E0D\u80FD\u4E3A\u7A7A",
  210010: "\u5FAE\u4FE1openId\u5DF2\u5B58\u5728",
  210011: "\u7B2C\u4E09\u65B9\u7528\u6237id\u5DF2\u5B58\u5728",
  210012: "\u5F53\u524D\u7248\u672C\u4E0D\u652F\u6301\u5206\u7EC4\u7BA1\u7406\uFF0C\u8BF7\u5148\u5347\u7EA7\u7248\u672C",
  22e4: "\u5206\u7EC4\u6570\u91CF\u8D85\u8FC7\u79DF\u6237\u6700\u5927\u9650\u5236-",
  220001: "\u65B0\u589E\u4EBA\u5458\u5206\u7EC4\u5931\u8D25",
  220002: "\u4FEE\u6539\u4EBA\u5458\u5206\u7EC4\u5931\u8D25",
  220003: "\u65E0\u6548\u7684\u4EBA\u5458\u5206\u7EC4",
  220004: "\u5220\u9664\u4EBA\u5458\u5206\u7EC4\u5931\u8D25",
  220005: "\u5206\u7EC4\u540D\u79F0\u5DF2\u5B58\u5728\uFF0C\u8BF7\u52FF\u91CD\u590D\u8F93\u5165",
  221001: "\u4E0D\u5B58\u5728\u7684\u7EA2\u5305\u660E\u7EC6",
  221002: "\u6301\u4E45\u5316\u7EA2\u5305\u6570\u636E\u660E\u7EC6\u5931\u8D25",
  221003: "\u6301\u4E45\u5316\u7EA2\u5305\u6E20\u9053\u6C47\u603B\u6570\u636E\u5931\u8D25",
  221004: "\u4E0D\u5B58\u5728\u7684\u7EA2\u5305\u6C47\u603B\u6570\u636E",
  221005: "\u65E0\u7ADE\u7B54\u4FE1\u606F",
  221006: "\u59D3\u540D\u4E0D\u80FD\u4E3A\u7A7A",
  221007: "\u624B\u673A\u4E0D\u80FD\u4E3A\u7A7A",
  221008: "\u90AE\u7BB1\u4E0D\u80FD\u4E3A\u7A7A",
  221009: "\u5730\u5740\u4E0D\u80FD\u4E3A\u7A7A",
  221010: "\u8868\u60C5\u56FE\u7247\u5927\u5C0F\u8D85\u8FC7\u6700\u5927\u9650\u5236",
  221011: "\u8868\u60C5\u56FE\u7247\u683C\u5F0F\u9519\u8BEF",
  221012: "\u8868\u60C5\u56FE\u7247\u4E0A\u4F20\u65F6\u95F4\u8D85\u8FC71\u5929",
  221013: "\u5F53\u524D\u7248\u672C\u6700\u591A\u521B\u5EFA1\u5957\u8868\u60C5\u5305\uFF0C\u8BF7\u5148\u5347\u7EA7\u7248\u672C",
  221014: "\u6700\u591A\u521B\u5EFA5\u5957\u8868\u60C5\u5305",
  221015: "\u8868\u60C5\u5305\u540D\u79F0\u4E0D\u652F\u6301\u91CD\u590D",
  221016: "\u8868\u60C5\u4E0A\u4F20\u4E2D\uFF0C\u8BF7\u52FF\u64CD\u4F5C",
  221017: "\u4E0D\u5B58\u5728\u7684\u8868\u60C5\u5E93",
  222001: "\u7814\u8BA8\u4F1A\u76F4\u64AD\u573A\u666F\u5FC5\u987B\u4E3A\u8FDE\u9EA6\u76F4\u64AD",
  222002: "\u65E0\u6548\u7684\u64AD\u5355",
  222003: "\u521B\u5EFA\u64AD\u5355\u5931\u8D25",
  222004: "\u4FEE\u6539\u64AD\u5355\u5931\u8D25",
  222005: "\u5220\u9664\u64AD\u5355\u5931\u8D25",
  222006: "\u64AD\u5355\u6B63\u5728\u4F7F\u7528\u4E2D",
  222007: "\u64AD\u5355\u672A\u914D\u7F6E\u8F93\u5165\u6E90",
  222008: "\u4FEE\u6539\u64AD\u5355\u4F7F\u7528\u72B6\u6001\u5931\u8D25",
  222009: "\u8BF7\u5148\u914D\u7F6E\u64AD\u5355\u518D\u5F00\u59CB\u76F4\u64AD",
  222010: "\u64AD\u5355\u5B58\u5728\u76F8\u540C\u753B\u9762\uFF0C\u8BF7\u5148\u4FEE\u6539\u518D\u4FDD\u5B58",
  222011: "\u6B64\u914D\u7F6E\u4E0D\u80FD\u9009\u62E9\u5168\u5C4F",
  222012: "\u540C\u4E00\u4F1A\u8BAE\u5185\u540D\u79F0\u4E0D\u652F\u6301\u91CD\u590D",
  222013: "\u4EC5\u7814\u8BA8\u4F1A\u53EF\u4F7F\u7528\u64AD\u5355",
  222014: "\u7B2C\u4E00\u4E2A\u6216\u8005\u6700\u540E\u4E00\u4E2A\u4E0D\u652F\u6301\u4E0A\u79FB\u4E0B\u79FB",
  222015: "\u64AD\u5355\u6392\u5E8F\u5B57\u6BB5\u5F02\u5E38",
  222016: "\u6700\u591A\u521B\u5EFA50\u4E2A\u64AD\u5355",
  222017: "\u8BF7\u52FF\u9891\u7E41\u64CD\u4F5C",
  222018: "\u9884\u8BBE\u64AD\u5355\u65E0\u6CD5\u4FEE\u6539",
  222019: "\u9884\u8BBE\u64AD\u5355\u65E0\u6CD5\u5220\u9664",
  223001: "\u65E0\u6548\u7684\u7ADE\u7B54",
  223002: "\u521B\u5EFA\u7ADE\u7B54\u5931\u8D25",
  223003: "\u4FEE\u6539\u7ADE\u7B54\u5931\u8D25",
  223004: "\u5220\u9664\u7ADE\u7B54\u5931\u8D25",
  223005: "\u521B\u5EFA\u7ADE\u7B54\u5956\u54C1\u5931\u8D25",
  223006: "\u4FEE\u6539\u7ADE\u7B54\u5956\u54C1\u5931\u8D25",
  223007: "\u7ADE\u7B54\u540D\u79F0\u4E0D\u80FD\u91CD\u590D",
  223008: "\u4EC5\u672A\u5F00\u542F\u7684\u7ADE\u7B54\u53EF\u4EE5\u7F16\u8F91",
  223009: "\u4EC5\u672A\u5F00\u542F\u7684\u7ADE\u7B54\u53EF\u4EE5\u5220\u9664",
  223010: "\u5F53\u524D\u6709\u8FDB\u884C\u4E2D\u7ADE\u7B54\uFF0C\u4E0D\u652F\u6301\u5173\u95ED",
  223011: "\u7ADE\u7B54\u72B6\u6001\u9519\u8BEF",
  223012: "\u8BF7\u5148\u5F00\u542F\u7ADE\u7B54\u529F\u80FD",
  223013: "\u5F53\u524D\u6709\u6B63\u5728\u8FDB\u884C\u4E2D\u7684\u7ADE\u7B54\uFF0C\u8BF7\u5148\u7ED3\u675F",
  223014: "\u65E0\u6548\u7684\u7ADE\u7B54\u5956\u54C1",
  223015: "\u521B\u5EFA\u7ADE\u7B54\u8BB0\u5F55\u5931\u8D25",
  223016: "\u4FEE\u6539\u7ADE\u7B54\u8BB0\u5F55\u5931\u8D25",
  223017: "\u6B63\u5728\u8FDB\u884C\u4E2D\u7684\u7ADE\u7B54\u5927\u4E8E1\u4E2A",
  223018: "\u6682\u65E0\u7ADE\u7B54\u6D3B\u52A8",
  223019: "\u91CD\u590D\u7684\u7528\u6237\u7ADE\u7B54\u8BB0\u5F55",
  223020: "\u95EE\u5377\u672A\u8BBE\u7F6E\u7B54\u6848",
  225001: "\u65E0\u6548\u7684\u8003\u8BD5",
  225002: "\u521B\u5EFA\u8003\u8BD5\u5931\u8D25",
  225003: "\u4FEE\u6539\u8003\u8BD5\u5931\u8D25",
  225004: "\u5220\u9664\u8003\u8BD5\u5931\u8D25",
  225005: "\u4E0D\u5B58\u5728\u8FDB\u884C\u4E2D\u7684\u8003\u8BD5",
  225006: "\u8FDB\u884C\u4E2D\u7684\u8003\u8BD5\u6570\u91CF\u5F02\u5E38",
  225007: "\u8003\u8BD5\u540D\u79F0\u4E0D\u80FD\u91CD\u590D",
  225008: "\u4EC5\u672A\u5F00\u542F\u7684\u8003\u8BD5\u53EF\u4EE5\u7F16\u8F91",
  225009: "\u4EC5\u672A\u5F00\u542F\u7684\u8003\u8BD5\u53EF\u4EE5\u5220\u9664",
  225010: "\u6B63\u5728\u8FDB\u884C\u4E2D\u7684\u8003\u8BD5\u5927\u4E8E1\u4E2A",
  225011: "\u4EC5\u672A\u5F00\u542F\u7684\u8003\u8BD5\u53EF\u4EE5\u5F00\u542F",
  225012: "\u4E0D\u5B58\u5728\u7684\u8003\u8BD5\u4FE1\u606F",
  225013: "\u60A8\u6765\u665A\u4E86\uFF0C\u5F53\u524D\u8003\u8BD5\u5DF2\u4E0D\u5141\u8BB8\u8FDB\u5165",
  225014: "\u8003\u8BD5\u5DF2\u7ED3\u675F",
  225015: "\u521B\u5EFA\u8003\u8BD5\u8BB0\u5F55\u5931\u8D25",
  225016: "\u4EC5\u8FDB\u884C\u4E2D\u7684\u8003\u8BD5\u53EF\u4EE5\u7ED3\u675F",
  225017: "\u8003\u8BD5\u672A\u5F00\u59CB",
  225018: "\u8003\u8BD5\u5DF2\u5F00\u542F\uFF0C\u65E0\u9700\u91CD\u590D\u5F00\u542F",
  225019: "\u8003\u8BD5\u5DF2\u5173\u95ED\uFF0C\u65E0\u9700\u91CD\u590D\u5173\u95ED",
  225020: "\u4E0D\u5B58\u5728\u7684\u8003\u8BD5\u8BB0\u5F55",
  225021: "\u5DF2\u8FC7\u7B54\u9898\u65F6\u95F4",
  225022: "\u6587\u6863\u4E0D\u7B26\u5408\u5BFC\u5165\u89C4\u8303,\u8BF7\u6309\u7167EXCEL\u6587\u6863\u6A21\u677F\u89C4\u8303\u64CD\u4F5C",
  225023: "\u8BF7\u4E0A\u4F20.xls\u6216.xlsx\u683C\u5F0F\u6587\u4EF6",
  226001: "\u65E0\u6548\u7684\u63D0\u95EE",
  226002: "\u521B\u5EFA\u63D0\u95EE\u5931\u8D25",
  226003: "\u4FEE\u6539\u63D0\u95EE\u5931\u8D25",
  226004: "\u5220\u9664\u63D0\u95EE\u5931\u8D25",
  226005: "\u4E0D\u5B58\u5728\u8FDB\u884C\u4E2D\u7684\u63D0\u95EE",
  226006: "\u8FDB\u884C\u4E2D\u7684\u63D0\u95EE\u6570\u91CF\u5F02\u5E38",
  226008: "\u4EC5\u672A\u5F00\u542F\u7684\u63D0\u95EE\u53EF\u4EE5\u7F16\u8F91",
  226009: "\u4EC5\u672A\u5F00\u542F\u7684\u63D0\u95EE\u53EF\u4EE5\u5220\u9664",
  226010: "\u6B63\u5728\u8FDB\u884C\u4E2D\u7684\u63D0\u95EE\u5927\u4E8E1\u4E2A",
  226011: "\u4EC5\u672A\u5F00\u542F\u7684\u63D0\u95EE\u53EF\u4EE5\u5F00\u542F",
  226012: "\u4EC5\u8FDB\u884C\u4E2D\u7684\u63D0\u95EE\u53EF\u4EE5\u7ED3\u675F",
  226013: "\u4E0D\u5B58\u5728\u7684\u63D0\u95EE\u4FE1\u606F",
  226014: "\u63D0\u95EE\u5DF2\u516C\u5E03",
  226015: "\u63D0\u95EE\u5DF2\u7ED3\u675F",
  226016: "\u63D0\u95EE\u672A\u7ED3\u675F",
  226017: "\u91CD\u590D\u63D0\u4EA4",
  226018: "\u9519\u8BEF\u63D0\u4EA4\u9009\u9879",
  226019: "\u975E\u8FDB\u884C\u4E2D\u7684\u63D0\u95EE\u4E0D\u53EF\u63D0\u4EA4\u7B54\u6848",
  226020: "\u6700\u591A\u9009\u62E9\u4E00\u4E2A\u7B54\u6848",
  226021: "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E24\u4E2A\u7B54\u6848",
  226022: "\u9009\u9879\u6570\u91CF\u6700\u591A50\u4E2A",
  226023: "\u9009\u9879\u672A\u63D0\u4EA4",
  226024: "\u8BF7\u52FF\u91CD\u590D\u4FEE\u6539",
  227001: "\u4E0D\u5B58\u5728\u7684\u5206\u53D1\u4EFB\u52A1",
  227002: "\u521B\u5EFA\u5206\u53D1\u4EFB\u52A1\u5931\u8D25",
  227003: "\u6279\u91CF\u521B\u5EFA\u5206\u53D1\u4EFB\u52A1\u5931\u8D25",
  227004: "\u4FEE\u6539\u5206\u53D1\u4EFB\u52A1\u5931\u8D25",
  227005: "\u76EE\u6807\u63A8\u6D41\u5730\u5740\u91CD\u590D",
  227006: "\u4E00\u6B21\u6700\u591A\u521B\u5EFA20\u4E2A\u76F4\u64AD\u5206\u53D1\u4EFB\u52A1",
  227007: "\u76EE\u6807\u63A8\u6D41\u5730\u5740\u91CD\u590D",
  227008: "\u6279\u91CF\u64CD\u4F5C\u53C2\u6570\u4E0D\u5BF9",
  227009: "\u5220\u9664\u5931\u8D25",
  227010: "\u6279\u91CF\u5220\u9664\u5931\u8D25",
  227011: "\u6279\u91CF\u64CD\u4F5C\u5931\u8D25",
  227012: "\u591A\u4E91\u878D\u5408\u56DE\u8C03\u53C2\u6570\u9519\u8BEF",
  227013: "\u5F53\u524D\u76F4\u64AD\u5C1A\u672A\u5F00\u59CB\uFF0C\u65E0\u6CD5\u542F\u52A8\u76F4\u64AD\u5206\u53D1\u4EFB\u52A1",
  227014: "\u8BE5\u76F4\u64AD\u7C7B\u578B\u7981\u6B62\u6B64\u64CD\u4F5C",
  227015: "\u64CD\u4F5C\u9891\u7E41,\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  227016: "\u5206\u53D1\u4EFB\u52A1\u8FDB\u884C\u4E2D\uFF0C\u65E0\u6CD5\u5220\u9664",
  227017: "\u8BE5\u4EFB\u52A1\u7981\u6B62\u6B64\u64CD\u4F5C",
  227018: "\u4E0D\u5B58\u5728\u7684\u5206\u53D1\u5E73\u53F0",
  227019: "\u5F53\u524D\u5217\u8868\u76F4\u64AD\u89C6\u9891\u5927\u4E8E1\u4E2A\uFF0C\u65E0\u6CD5\u4F7F\u7528\u76F4\u64AD\u5206\u53D1\u529F\u80FD",
  227020: "\u56FD\u5185\u5E73\u53F0\u4E0D\u652F\u6301rtmps\u534F\u8BAE",
  227021: "\u5206\u53D1\u5E73\u53F0\u7C7B\u578B\u4E0D\u5339\u914D",
  228001: "\u6295\u7968\u540D\u79F0\u4E0D\u80FD\u91CD\u590D",
  228002: "\u521B\u5EFA\u6295\u7968\u5931\u8D25",
  228003: "\u4EC5\u672A\u5F00\u542F\u7684\u6295\u7968\u53EF\u4EE5\u7F16\u8F91",
  228004: "\u65E0\u6548\u7684\u6295\u7968",
  228005: "\u5DF2\u7ECF\u6709\u4EBA\u6295\u7968",
  228006: "\u7F16\u8F91\u6295\u7968\u5931\u8D25",
  228007: "\u4EC5\u672A\u5F00\u542F\u7684\u6295\u7968\u53EF\u4EE5\u5220\u9664",
  228008: "\u5220\u9664\u6295\u7968\u5931\u8D25",
  228009: "\u6B63\u5728\u8FDB\u884C\u4E2D\u7684\u6295\u7968\u5927\u4E8E1\u4E2A",
  228010: "\u7F16\u8F91\u6295\u7968\u72B6\u6001\u5931\u8D25",
  228011: "\u91CD\u590D\u63D0\u4EA4",
  228012: "\u975E\u8FDB\u884C\u4E2D\u7684\u6295\u7968\u4E0D\u53EF\u63D0\u4EA4",
  228013: "\u521B\u5EFA\u6295\u7968\u8BB0\u5F55\u5931\u8D25",
  228014: "\u8D85\u8FC7\u9009\u9879\u6570\u91CF",
  228015: "\u622A\u6B62\u65F6\u95F4\u81F3\u5C11\u665A\u4E8E\u5F53\u524D\u65F6\u95F41\u5206\u949F",
  229001: "\u521B\u5EFA\u64CD\u4F5C\u8BB0\u5F55\u5931\u8D25",
  230001: "\u5382\u5546\u7C7B\u578B:%s\u4E0B\u6682\u627E\u4E0D\u5230\u8BE5\u63A5\u53E3: %s,\u8BF7\u4ED4\u7EC6\u6838\u5BF9",
  230002: "\u5382\u5546\u7C7B\u578B:%s, \u6682\u4E0D\u652F\u6301\u8BE5\u63A5\u53E3: %s",
  230003: "\u8C03\u7528\u4E91%s\u7684%s\u63A5\u53E3\u5F02\u5E38: %s",
  230004: "\u4E91\u5382\u5546\u8BF7\u6C42\u56DE\u5305\u4E3ANULL",
  231001: "\u521B\u5EFA\u8D26\u5355\u5931\u8D25",
  231002: "\u4FEE\u6539\u8D26\u5355\u5931\u8D25",
  231003: "\u521B\u5EFA\u8D26\u5355\u4EFB\u52A1\u5931\u8D25",
  231004: "\u573A\u6B21\u4E0D\u5B58\u5728",
  231005: "\u8D26\u5355\u751F\u6210\u5B8C\u6BD5\u66F4\u65B0\u4EFB\u52A1\u72B6\u6001\u5931\u8D25",
  231006: "\u8D26\u5355\u4E3A\u7A7A",
  240001: "\u7B7E\u540D\u72B6\u6001\u4E0D\u6B63\u786E\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u8BD5",
  240002: "AccessKey\u914D\u7F6E\u4E0D\u6B63\u786E",
  240003: "\u7B7E\u540D\u4E0D\u5B58\u5728\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u8BD5",
  240004: "\u901A\u4FE1\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u914D\u7F6E\u9879",
  240005: "%s \u5FC5\u987B\u662F\u5927\u5C0F\u5199\u5B57\u6BCD\u3001\u6570\u5B57",
  240006: "\u5FC5\u586B\u9879\u672A\u914D\u7F6E",
  240007: "\u8BF7\u5148\u914D\u7F6E\u81EA\u6709\u77ED\u4FE1\u670D\u52A1",
  250001: "\u7F16\u8F91\u6A21\u677F\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u914D\u7F6E\u9879",
  250002: "%s \u5FC5\u987B\u662F\u5927\u5C0F\u5199\u5B57\u6BCD+\u6570\u5B57+_",
  250003: "\u5FC5\u586B\u9879\u672A\u914D\u7F6E",
  250004: "\u8BF7\u4F7F\u7528\u9A8C\u8BC1\u7801\u7C7B\u578B\u7684\u77ED\u4FE1\u6A21\u677F",
  250005: "\u77ED\u4FE1\u6A21\u677F\u7C7B\u578B\u4E0D\u6B63\u786E",
  250006: "\u77ED\u4FE1\u6A21\u677Fcode\u4E0D\u5B58\u5728\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u8BD5",
  250007: "\u77ED\u4FE1\u6A21\u677F\u4E2D\u5FC5\u987B\u6709{code}\u53D8\u91CF",
  250008: "\u77ED\u4FE1\u6A21\u677F\u4E2D\u5B58\u5728\u4E0D\u652F\u6301\u7684\u53D8\u91CF",
  250009: "\u77ED\u4FE1\u6A21\u677F\u5C1A\u672A\u901A\u8FC7\u5BA1\u6838\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u8BD5",
  250010: "\u77ED\u4FE1\u6A21\u677F\u4F7F\u7528\u573A\u666F\u91CD\u590D\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u8BD5",
  250011: "\u672A\u914D\u7F6E\u81EA\u6709\u77ED\u4FE1\u670D\u52A1",
  250012: "\u83B7\u53D6\u77ED\u94FE\u5F02\u5E38",
  250013: "\u77ED\u4FE1\u6A21\u677F\u4E2D\u5FC5\u987B\u6709{expireDate}\u53D8\u91CF",
  250014: "\u77ED\u4FE1\u6A21\u677F\u4E0D\u5B58\u5728",
  260001: "\u8BF7\u52FF\u6DFB\u52A0\u91CD\u590D\u90AE\u7BB1",
  260002: "\u8BF7\u52FF\u6DFB\u52A0\u91CD\u590D\u624B\u673A\u53F7",
  260003: "\u6DFB\u52A0\u8054\u7CFB\u4EBA\u5931\u8D25",
  260004: "\u8054\u7CFB\u4EBA\u4E0D\u5B58\u5728",
  260005: "\u4FEE\u6539\u8054\u7CFB\u4EBA\u5931\u8D25",
  260006: "\u8BF7\u5C06\u59D3\u540D\u548C\u90AE\u7BB1\u586B\u5199\u5B8C\u6574",
  260007: "\u90AE\u7BB1\u683C\u5F0F\u9519\u8BEF\uFF01",
  260008: "\u8BF7\u8F93\u5165\u59D3\u540D\uFF01",
  260009: "\u8BF7\u8F93\u5165\u90AE\u7BB1\u6216\u624B\u673A\u53F7\uFF01",
  260010: "\u90AE\u7BB1/\u624B\u673A\u53F7\u683C\u5F0F\u9519\u8BEF\uFF01",
  260011: "\u6DFB\u52A0\u81F3\u591A5\u4E2A\u8054\u7CFB\u4EBA",
  260012: "\u4E0D\u53EF\u5220\u9664",
  260013: "\u64CD\u4F5C\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5",
  270001: "\u4FEE\u6539\u8D44\u6E90\u9884\u8B66\u914D\u7F6E\u5931\u8D25",
  280001: "\u521B\u5EFA\u7ED3\u7B97\u5355\u5931\u8D25",
  280002: "\u65E0\u6548\u7ED3\u7B97\u5355",
  290001: "\u521B\u5EFA\u623F\u95F4\u65F6\u521D\u59CB\u5316\u9884\u8BBE\u83DC\u5355\u5931\u8D25",
  290002: "\u5F53\u524D\u623F\u95F4\u6B63\u5728\u9884\u8BBE\u83DC\u5355\u4E2D",
  290003: "\u65B0\u589E\u81EA\u5B9A\u4E49\u83DC\u5355\u5165\u5E93\u5931\u8D25",
  290004: "\u65B0\u589E\u81EA\u5B9A\u4E49\u83DC\u5355\u5931\u8D25",
  290005: "\u65E0\u6548\u83DC\u5355",
  290006: "\u8BF7\u52FF\u8DE8\u623F\u95F4\u64CD\u4F5C",
  290007: "\u5F53\u524D\u83DC\u5355\u6B63\u5728\u7F16\u8F91\u4E2D",
  290008: "\u4FEE\u6539\u83DC\u5355\u4FE1\u606F\u5165\u5E93\u5931\u8D25",
  290009: "\u4FEE\u6539\u83DC\u5355\u4FE1\u606F\u5931\u8D25",
  290010: "\u5F53\u524D\u83DC\u5355\u6B63\u88AB\u5220\u9664\u4E2D",
  290011: "\u9884\u8BBE\u83DC\u5355\u4E0D\u53EF\u5220\u9664",
  290012: "\u5220\u9664\u83DC\u5355\u5165\u5E93\u5931\u8D25",
  290013: "\u5220\u9664\u83DC\u5355\u5931\u8D25",
  290014: "\u5F53\u524D\u623F\u95F4\u6B63\u5728\u6267\u884C\u83DC\u5355\u6392\u5E8F\u4E2D",
  290015: "\u79FB\u52A8\u7684\u83DC\u5355\u4E3A\u65E0\u6548\u83DC\u5355",
  290016: "\u88AB\u79FB\u52A8\u7684\u83DC\u5355\u4E3A\u65E0\u6548\u83DC\u5355",
  290017: "\u83DC\u5355\u6392\u5E8F\u8BF7\u52FF\u8DE8\u623F\u95F4\u64CD\u4F5C,\u79FB\u52A8\u7684\u83DC\u5355\u4E0D\u5C5E\u4E8E\u8BE5\u623F\u95F4\u4E0B",
  290018: "\u83DC\u5355\u6392\u5E8F\u8BF7\u52FF\u8DE8\u623F\u95F4\u64CD\u4F5C,\u88AB\u79FB\u52A8\u7684\u83DC\u5355\u4E0D\u5C5E\u4E8E\u8BE5\u623F\u95F4\u4E0B",
  290019: "\u83DC\u5355\u6392\u5E8F\u8BF7\u52FF\u8DE8\u8BED\u8A00\u64CD\u4F5C",
  290020: "\u83DC\u5355\u6392\u5E8F\u5165\u5E93\u5931\u8D25",
  290021: "\u83DC\u5355\u6392\u5E8F\u5931\u8D25",
  290022: "\u4E0D\u652F\u6301\u7684\u83DC\u5355\u7EC4\u4EF6",
  290023: "\u9884\u8BBE\u83DC\u5355\u65E0\u6CD5\u6DFB\u52A0\u7EC4\u4EF6",
  290024: "\u65B0\u589E\u9ED8\u8BA4\u503C\u7684%s\u7EC4\u4EF6\u4FE1\u606F\u5165\u5E93\u5931\u8D25",
  290025: "\u65B0\u589E\u9ED8\u8BA4\u503C\u7684%s\u7EC4\u4EF6\u4FE1\u606F\u5931\u8D25",
  290026: "\u65B0\u589E\u9ED8\u8BA4\u503C\u7684\u7EC4\u4EF6\u4FE1\u606F\u5931\u8D25",
  290027: "\u5355\u4E2A\u81EA\u5B9A\u4E49\u83DC\u5355\u4E0B\u6700\u591A\u6DFB\u52A0%s\u4E2A\u7EC4\u4EF6",
  290028: "\u9884\u8BBE\u83DC\u5355\u65E0\u6CD5\u7F16\u8F91\u7EC4\u4EF6",
  290029: "\u7981\u6B62\u8DE8\u83DC\u5355\u7F16\u8F91\u7EC4\u4EF6",
  290030: "\u7F16\u8F91\u7EC4\u4EF6\u65F6\u7684\u5165\u53C2[requestData]\u5BF9\u8C61\u8F6C\u6362\u540E\u5FC5\u987B\u662FJson\u5B57\u7B26\u4E32",
  290031: "\u65E0\u6548\u7684%s\u7EC4\u4EF6",
  290032: "\u7F16\u8F91%s\u7EC4\u4EF6\u4FE1\u606F\u5931\u8D25",
  290033: "\u9884\u8BBE\u83DC\u5355\u65E0\u6CD5\u5220\u9664\u7EC4\u4EF6",
  290034: "\u7981\u6B62\u8DE8\u83DC\u5355\u5220\u9664\u7EC4\u4EF6",
  290035: "\u5220\u9664%s\u7EC4\u4EF6\u4FE1\u606F\u5165\u5E93\u5931\u8D25",
  290036: "\u5220\u9664%s\u7EC4\u4EF6\u4FE1\u606F\u5931\u8D25",
  290037: "\u7F16\u8F91\u5BCC\u6587\u672C\u6846\u7EC4\u4EF6\u65F6\u6587\u672C\u5185\u5BB9\u5B57\u6570\u4E0D\u80FD\u8D85\u51FA%s\u5B57",
  290038: "\u9884\u8BBE\u83DC\u5355\u65E0\u6CD5\u67E5\u8BE2\u7EC4\u4EF6",
  290039: "\u7981\u6B62\u8DE8\u83DC\u5355\u67E5\u8BE2\u7EC4\u4EF6",
  290040: "\u8BF7\u8F93\u5165\u5F00\u59CB\u65F6\u95F4",
  290041: "\u8BF7\u8F93\u5165\u7ED3\u675F\u65F6\u95F4",
  290042: "\u6700\u591A\u53EF\u914D\u7F6E%s\u5F20\u56FE\u7247",
  290043: "\u7F16\u8F91%s\u7EC4\u4EF6\u4FE1\u606F\u5165\u5E93\u5931\u8D25",
  290044: "%s\u6392\u5E8F\u4E0D\u5141\u8BB8\u91CD\u590D",
  290045: "%s\u6392\u5E8F\u5FC5\u987B\u8FDE\u7EED",
  290046: "\u6700\u591A\u53EF\u914D\u7F6E%s\u4E2A\u5408\u4F5C\u4F19\u4F34\u7FA4\u7EC4",
  290047: "\u6700\u591A\u53EF\u914D\u7F6E%s\u4E2A\u5408\u4F5C\u4F19\u4F34",
  290048: "\u6700\u591A\u53EF\u914D\u7F6E%s\u4E2A\u6D3B\u52A8",
  290049: "\u6700\u591A\u53EF\u914D\u7F6E%s\u4E2A\u573A\u6240",
  290050: "\u5BF9\u83DC\u5355\u4E0B\u7684\u7EC4\u4EF6\u6392\u5E8F\u5165\u5E93\u5931\u8D25",
  290051: "\u5BF9\u83DC\u5355\u4E0B\u7684\u7EC4\u4EF6\u6392\u5E8F\u5931\u8D25",
  290052: "\u5F53\u524D\u83DC\u5355\u4E0B\u7684\u7EC4\u4EF6\u6B63\u5728\u6392\u5E8F\u4E2D",
  290053: "\u9884\u8BBE\u83DC\u5355\u65E0\u6CD5\u7EC4\u4EF6\u6392\u5E8F",
  290054: "\u79FB\u52A8\u7684\u7EC4\u4EF6\u4E3A\u65E0\u6548\u7EC4\u4EF6",
  290055: "\u88AB\u79FB\u52A8\u7684\u7EC4\u4EF6\u4E3A\u65E0\u6548\u7EC4\u4EF6",
  290056: "\u5F53\u524D\u623F\u95F4\u6B63\u5728\u590D\u5236\u88C5\u4FEE\u4E2D",
  290057: "\u590D\u5236\u83DC\u5355\u6216\u8005\u64AD\u653E\u533A\u7CBE\u5F69\u89C6\u9891\u5931\u8D25",
  290058: "\u590D\u5236\u83DC\u5355\u6216\u8005\u64AD\u653E\u533A\u7CBE\u5F69\u89C6\u9891\u5165\u5E93\u5931\u8D25",
  290059: "\u6700\u591A\u53EF\u914D\u7F6E%s\u4E2A\u89C6\u9891",
  290060: "\u6DFB\u52A0\u7CBE\u5F69\u89C6\u9891\u5165\u5E93\u5931\u8D25",
  290061: "\u6DFB\u52A0\u7CBE\u5F69\u89C6\u9891\u5931\u8D25",
  290062: "\u89C6\u9891\u7C7B\u578B\u7684\u83DC\u5355\u4E0D\u5B58\u5728",
  290063: "\u4E0D\u5B58\u5728\u7684\u7CBE\u5F69\u89C6\u9891",
  290064: "\u4FEE\u6539\u7CBE\u5F69\u89C6\u9891\u5165\u5E93\u5931\u8D25",
  290065: "\u4FEE\u6539\u7CBE\u5F69\u89C6\u9891\u5931\u8D25",
  290066: "\u5220\u9664\u7CBE\u5F69\u89C6\u9891\u5165\u5E93\u5931\u8D25",
  290067: "\u5220\u9664\u7CBE\u5F69\u89C6\u9891\u5931\u8D25",
  290068: "\u5F53\u524D\u623F\u95F4\u6B63\u5728\u6267\u884C\u7CBE\u5F69\u89C6\u9891\u6392\u5E8F\u4E2D",
  290069: "\u79FB\u52A8\u7684\u7CBE\u5F69\u89C6\u9891\u4E3A\u65E0\u6548\u89C6\u9891",
  290070: "\u88AB\u79FB\u52A8\u7684\u7CBE\u5F69\u89C6\u9891\u4E3A\u65E0\u6548\u89C6\u9891",
  290071: "\u7CBE\u5F69\u89C6\u9891\u6392\u5E8F\u8BF7\u52FF\u8DE8\u623F\u95F4\u64CD\u4F5C,\u79FB\u52A8\u7684\u7CBE\u5F69\u89C6\u9891\u4E0D\u5C5E\u4E8E\u8BE5\u623F\u95F4\u4E0B",
  290072: "\u7CBE\u5F69\u89C6\u9891\u6392\u5E8F\u8BF7\u52FF\u8DE8\u623F\u95F4\u64CD\u4F5C,\u88AB\u79FB\u52A8\u7684\u7CBE\u5F69\u89C6\u9891\u4E0D\u5C5E\u4E8E\u8BE5\u623F\u95F4\u4E0B",
  290073: "\u7CBE\u5F69\u89C6\u9891\u6392\u5E8F\u8BF7\u52FF\u8DE8\u83DC\u5355\u64CD\u4F5C,\u88AB\u79FB\u52A8\u7684\u7CBE\u5F69\u89C6\u9891\u548C\u79FB\u52A8\u7684\u7CBE\u5F69\u89C6\u9891\u7684\u6240\u5C5E\u83DC\u5355\u4E0D\u5339\u914D",
  290074: "\u83DC\u5355\u6570\u636E\u8FC1\u79FB\u5165\u5E93\u5931\u8D25",
  290075: "\u7EC4\u4EF6\u5220\u9664\u5F15\u8D77\u7684\u83DC\u5355\u4E0B\u7684\u7EC4\u4EF6\u5217\u8868\u91CD\u6392\u5E8F\u5165\u5E93\u5931\u8D25",
  290076: "\u65B0\u589E\u81EA\u5B9A\u4E49\u83DC\u5355\u8D85\u51FA\u9650\u5236,\u6700\u591A\u53EF\u65B0\u589E%s\u4E2A\u81EA\u5B9A\u4E49\u83DC\u5355",
  290077: "\u8BF7\u8F93\u5165\u5FAE\u4FE1\u4E8C\u7EF4\u7801\u56FE\u7247",
  290078: "\u8BF7\u8F93\u5165\u8054\u7CFB\u7535\u8BDD",
  290079: "\u8BF7\u8F93\u5165\u8054\u7CFB\u90AE\u7BB1",
  290080: "\u8BF7\u8F93\u5165\u8054\u7CFB\u5FAE\u535A\u5730\u5740",
  290081: "\u8BF7\u8F93\u5165\u8054\u7CFBFaceBook\u5730\u5740",
  290082: "\u6240\u9009\u89C6\u9891\u5B58\u5728\u65E0\u6548\u7684\u5A92\u4F53\u5E93\u89C6\u9891",
  290083: "\u6240\u9009\u89C6\u9891\u88AB\u5220\u9664,\u8BF7\u91CD\u65B0\u9009\u62E9",
  290084: "\u5F53\u524D\u623F\u95F4\u6B63\u5728\u83DC\u5355\u6570\u636E\u8865\u507F\u4E2D",
  290085: "\u83DC\u5355\u6570\u636E\u8865\u507F\u5931\u8D25",
  290086: "\u5F53\u524D\u623F\u95F4\u6B63\u5728\u6267\u884C\u963F\u62C9\u4F2F\u8BED\u83DC\u5355\u6570\u636E\u8865\u507F\u64CD\u4F5C",
  290998: "\u7981\u6B62\u8DE8\u79DF\u6237\u64CD\u4F5C",
  291001: "\u521B\u5EFA\u5206\u7EC4\u95F4\u914D\u7F6E\u9519\u8BEF",
  291002: "\u66F4\u65B0\u5206\u7EC4\u95F4\u914D\u7F6E\u9519\u8BEF",
  291003: "\u5220\u9664\u5206\u7EC4\u95F4\u914D\u7F6E\u9519\u8BEF",
  291004: "\u66F4\u65B0\u5206\u7EC4\u95F4\u914D\u7F6E\u9519\u8BEF",
  291005: "\u4E0D\u5B58\u5728\u7684\u5206\u7EC4\u95F4\u914D\u7F6E",
  291006: "\u9700\u8981\u5206\u7EC4\u6570\u91CF\u53C2\u6570",
  291007: "\u5DF2\u5B58\u5728\u5206\u7EC4\u95F4\u914D\u7F6E,\u8BF7\u52FF\u91CD\u65B0\u521B\u5EFA",
  291008: "\u6700\u591A\u5141\u8BB8\u6DFB\u52A050\u4E2A\u5206\u7EC4",
  291101: "\u4E0D\u5B58\u5728\u7684\u5206\u7EC4\u95F4",
  291102: "\u521B\u5EFA\u5206\u7EC4\u95F4\u9519\u8BEF",
  291103: "\u5220\u9664\u5206\u7EC4\u95F4\u9519\u8BEF",
  291104: "\u66F4\u65B0\u5206\u7EC4\u95F4\u9519\u8BEF",
  291105: "\u66F4\u65B0\u5206\u7EC4\u95F4\u7EC4\u957F\u4FE1\u606F\u9519\u8BEF",
  291106: "\u6279\u91CF\u5220\u9664\u5206\u7EC4\u95F4\u9519\u8BEF",
  291107: "\u6279\u91CF\u66F4\u65B0\u5206\u7EC4\u95F4\u7EC4\u957F\u4FE1\u606F\u9519\u8BEF",
  291108: "\u5206\u7EC4\u95F4\u7533\u8BF7\u534F\u52A9\u72B6\u6001\u4E3A\u7A7A",
  291109: "\u7533\u8BF7\u5DF2\u5728\u8BE5\u72B6\u6001\u4E2D",
  291110: "\u4E3B\u6301\u4EBA\u6B63\u5728\u5206\u7EC4\u623F\u95F4\u4E2D",
  291111: "\u5206\u7EC4\u8BA8\u8BBA\u672A\u5F00\u59CB",
  291112: "\u672A\u8BBE\u7F6E\u5206\u7EC4\u95F4",
  291113: "\u5206\u7EC4\u95F4\u8BF7\u6C42\u72B6\u6001\u4E0D\u6B63\u786E",
  291301: "\u6210\u5458\u5DF2\u6EE1,\u8BF7\u91CD\u65B0\u9009\u62E9\u5206\u7EC4",
  291302: "\u6279\u91CF\u521B\u5EFA\u6210\u5458\u5931\u8D25",
  291303: "\u8BF7\u70B9\u51FB\u5237\u65B0\u83B7\u53D6\u6700\u65B0\u5217\u8868",
  291304: "\u6279\u91CF\u521D\u59CB\u5316\u6210\u5458\u5931\u8D25",
  291305: "\u6279\u91CF\u5220\u9664\u5206\u7EC4\u95F4\u6210\u5458\u9519\u8BEF",
  291306: "\u5206\u914D\u6210\u5458\u5931\u8D25,\u8BF7\u5237\u65B0\u9875\u9762\u91CD\u8BD5",
  291307: "\u6210\u5458\u5DF2\u6EE1\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u5206\u7EC4",
  291997: "\u8BA8\u8BBA\u8FDB\u884C\u4E2D,\u7981\u6B62\u6B64\u64CD\u4F5C",
  291998: "\u64CD\u4F5C\u9891\u7387\u8FC7\u5FEB\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  292001: "\u65E0\u6548\u7684\u5206\u7EC4\u95F4\u4EBA\u5458",
  292002: "\u65B0\u589E\u5206\u7EC4\u95F4\u4EBA\u5458\u5931\u8D25",
  292003: "\u4FEE\u6539\u5206\u7EC4\u95F4\u4EBA\u5458\u5931\u8D25",
  292004: "\u5220\u9664\u5206\u7EC4\u95F4\u4EBA\u5458\u5931\u8D25",
  292005: "\u5F53\u524D\u4EBA\u5458\u5DF2\u7ECF\u662F\u7EC4\u957F",
  292006: "\u5206\u7EC4\u6210\u5458\u89D2\u8272id\u83B7\u53D6\u5931\u8D25",
  292007: "\u5F53\u524D\u4EBA\u5458\u5DF2\u7ECF\u662F\u4E3B\u8BB2",
  292008: "\u539F\u4EBA\u5458\u4E0D\u662F\u4E3B\u8BB2",
  292009: "\u8BE5\u5206\u7EC4\u4EBA\u5458\u5DF2\u6EE1\uFF0C\u65E0\u6CD5\u52A0\u5165!",
  292010: "\u60A8\u672A\u5728\u5206\u7EC4\u8BA8\u8BBA\u4E2D",
  292011: "\u60A8\u5DF2\u5728\u5176\u4ED6\u5206\u7EC4\u4E2D",
  292012: "\u6279\u91CF\u5220\u9664\u5206\u7EC4\u95F4\u4EBA\u5458\u5931\u8D25",
  292013: "\u4E3B\u6301\u4EBA\u4ECD\u5728\u5206\u7EC4\u95F4\uFF0C\u65E0\u6CD5\u5220\u9664",
  292014: "\u4E3B\u6301\u4EBA\u65E0\u6CD5\u6210\u4E3A\u7EC4\u957F",
  292015: "\u60A8\u5DF2\u7ECF\u5728\u5206\u7EC4\u8BA8\u8BBA\u4E2D\uFF0C\u65E0\u6CD5\u518D\u6B21\u8FDB\u5165",
  293001: "\u623F\u95F4\u4E0D\u5728\u8BA8\u8BBA\u4E2D",
  293002: "\u623F\u95F4\u6B63\u5728\u8BA8\u8BBA\u4E2D",
  293003: "\u5F00\u542F\u5931\u8D25\uFF0C\u5F53\u524D\u6682\u65E0\u5206\u7EC4",
  293004: "\u5F00\u542F\u5931\u8D25\uFF0C\u8BF7\u5148\u5F00\u542F\u76F4\u64AD",
  294001: "\u521B\u5EFA\u79DF\u6237\u56DE\u8C03\u914D\u7F6E\u5F02\u5E38",
  294002: "\u91CD\u7F6E\u79DF\u6237\u56DE\u8C03\u914D\u7F6E\u5F02\u5E38",
  294003: "\u79DF\u6237\u56DE\u8C03\u914D\u7F6E\u4E0D\u5B58\u5728",
  294004: "\u5220\u9664\u79DF\u6237\u56DE\u8C03\u914D\u7F6E\u5F02\u5E38",
  294005: "\u79DF\u6237\u56DE\u8C03\u914D\u7F6E\u5DF2\u5B58\u5728",
  294006: "\u79DF\u6237\u56DE\u8C03\u914D\u7F6E\u5DF2\u5B58\u5728",
  294100: "\u79DF\u6237\u56DE\u8C03\u5DF2\u8FBE\u5230\u6700\u5927\u503C",
  295001: "\u81F3\u5C11\u5F00\u542F\u4E00\u79CD\u767B\u5F55\u65B9\u5F0F",
  300001: "\u81EA\u5B9A\u4E49\u4E92\u52A8\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7100",
  300002: "\u4E92\u52A8\u7F16\u53F7\u5DF2\u5B58\u5728",
  300101: "\u66F4\u65B0iframe\u914D\u7F6E\u5931\u8D25",
  501e3: "\u65E0\u6548\u7684\u90E8\u95E8",
  501001: "\u65E0\u6548\u7684\u7236\u90E8\u95E8",
  501002: "\u65E0\u6CD5\u4FEE\u6539\u9ED8\u8BA4\u90E8\u95E8",
  501010: "\u521B\u5EFA\u90E8\u95E8\u5931\u8D25",
  501011: "\u4FEE\u6539\u90E8\u95E8\u5931\u8D25",
  501012: "\u5220\u9664\u90E8\u95E8\u5931\u8D25",
  501013: "\u540C\u7EA7\u90E8\u95E8\u7684\u90E8\u95E8\u540D\u79F0\u4E0D\u80FD\u91CD\u590D",
  501014: "\u4FEE\u6539\u90E8\u95E8\u7B49\u7EA7\u5931\u8D25",
  501015: "\u4FEE\u6539\u90E8\u95E8\u72B6\u6001\u5931\u8D25",
  501016: "\u8BE5\u90E8\u95E8\u4E0B\u4ECD\u6709\u6210\u5458\uFF0C\u4E0D\u5141\u8BB8\u7981\u7528",
  501017: "\u8BE5\u90E8\u95E8\u4E0B\u4ECD\u6709\u542F\u7528\u7684\u5B50\u90E8\u95E8\uFF0C\u4E0D\u5141\u8BB8\u7981\u7528",
  501018: "\u8BE5\u8282\u70B9\u4E0B\u4ECD\u6709\u6210\u5458\uFF0C\u4E0D\u652F\u6301\u5220\u9664",
  502001: "\u521B\u5EFA\u5168\u7403\u5E76\u53D1\u670D\u52A1\u914D\u7F6E\u5931\u8D25",
  502002: "\u66F4\u65B0\u5168\u7403\u5E76\u53D1\u670D\u52A1\u914D\u7F6E\u72B6\u6001\u5931\u8D25",
  502003: "\u5728\u8BE5\u751F\u6548\u65F6\u95F4\u8303\u56F4\u4E0B\u5DF2\u5B58\u5728\u3010\u751F\u6548\u4E2D\u3011\u6216\u3010\u5F85\u751F\u6548\u3011\u7684\u5F00\u901A\u8BB0\u5F55\uFF0C\u8BF7\u4F5C\u5E9F\u3010\u5F85\u751F\u6548\u3011\u8BB0\u5F55\u6216\u66F4\u6539\u751F\u6548\u65F6\u95F4\u540E\u91CD\u8BD5\u3002",
  601001: "\u8BE5\u7B7E\u5230\u5F53\u524D\u72B6\u6001\u4E0D\u5141\u8BB8\u5220\u9664",
  601003: "\u6570\u636E\u5F02\u5E38",
  601004: "\u7B7E\u5230\u72B6\u6001\u6709\u8BEF\uFF0C\u65E0\u6CD5\u64CD\u4F5C\u5F00\u542F\u6216\u5173\u95ED",
  601005: "\u8BE5\u7B7E\u5230\u5DF2\u7ECF\u5F00\u542F",
  601006: "\u8BE5\u7B7E\u5230\u5DF2\u7ECF\u5173\u95ED",
  601007: "\u672A\u5F00\u542F\u7684\u7B7E\u5230\u624D\u80FD\u7F16\u8F91",
  601009: "\u8BF7\u52FF\u91CD\u590D\u7B7E\u5230",
  601011: "\u8BF7\u5148\u5F00\u542F\u7B7E\u5230\u529F\u80FD",
  601012: "\u5DF2\u6709\u7B7E\u5230\u8FDB\u884C\u4E2D\uFF0C\u8BF7\u52FF\u91CD\u590D\u53D1\u8D77",
  601013: "\u5F53\u524D\u7B7E\u5230\u5DF2\u5220\u9664\uFF0C\u8BF7\u91CD\u65B0\u5237\u65B0\u5217\u8868",
  601201: "\u6570\u7F8E\u63A5\u53E3\u672A\u77E5\u9519\u8BEF",
  601202: "\u654F\u611F\u8BCD\u91CD\u590D",
  601203: "\u654F\u611F\u8BCD\u957F\u5EA6\u8FC7\u957F",
  601204: "\u4E00\u6B21\u6027\u5BFC\u5165\u6570\u636E\u8FC7\u591A",
  601205: "\u6570\u636E\u5BFC\u5165\u4E2D\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  601206: "\u81EA\u5EFA\u654F\u611F\u8BCD\u4E0D\u5B58\u5728",
  601207: "\u65E0\u6743\u9650\u5207\u6362\u8BE5ai\u65B9\u6848",
  601300: "\u6570\u636E\u4E0D\u5B58\u5728\u6216\u5DF2\u5220\u9664",
  601301: "\u5305\u542B\u654F\u611F\u8BCD",
  601302: "\u7CFB\u7EDF\u9884\u8BBE\u6570\u636E\uFF0C\u4E0D\u5141\u8BB8\u64CD\u4F5C",
  601303: "\u6BCF\u6B21\u4EC5\u80FD\u5BFC\u51651000\u6761\u6570\u636E",
  601304: "\u957F\u5EA6\u8D85\u957F",
  601305: "\u8BF7\u8F93\u51651-10000\u7684\u6570\u5B57",
  601306: "\u8BF7\u8F93\u51651-300\u7684\u6570\u5B57",
  601307: "\u8BF7\u8F93\u51651-20\u7684\u6570\u5B57",
  601308: "\u914D\u7F6E\u5DF2\u5B58\u5728\uFF0C\u8BF7\u5237\u65B0\u9875\u9762",
  601309: "AI\u6C1B\u56F4\u5E08\u5DF2\u5F00\u542F\uFF0C\u8BF7\u5237\u65B0\u9875\u9762",
  601310: "AI\u6C1B\u56F4\u5E08\u5DF2\u5173\u95ED\uFF0C\u8BF7\u5237\u65B0\u9875\u9762",
  601311: "AI\u6C1B\u56F4\u5E08\u5DF2\u6682\u505C\uFF0C\u8BF7\u5237\u65B0\u9875\u9762",
  601312: "AI\u6C1B\u56F4\u5E08\u72B6\u6001\u975E\u6CD5\uFF0C\u8BF7\u5237\u65B0\u9875\u9762",
  601313: "\u672A\u76F4\u64AD\u65F6\u65E0\u6CD5\u5F00\u542FAI\u6C1B\u56F4\u5E08",
  601314: "\u6635\u79F0\u5E93\u6B63\u5728\u4F7F\u7528\u4E2D\uFF0C\u8BF7\u8C03\u6574AI\u6C1B\u56F4\u5E08\u914D\u7F6E\u6216\u7ED3\u675FAI\u6C1B\u56F4\u5E08\u540E\u91CD\u8BD5",
  601315: "\u8BDD\u672F\u5E93\u6B63\u5728\u4F7F\u7528\u4E2D\uFF0C\u8BF7\u8C03\u6574AI\u6C1B\u56F4\u5E08\u914D\u7F6E\u6216\u7ED3\u675FAI\u6C1B\u56F4\u5E08\u540E\u91CD\u8BD5",
  601316: "\u8BF7\u5148\u6682\u505CAI\u6C1B\u56F4\u5E08",
  601317: "\u4F01\u4E1A\u6700\u591A\u53EF\u521B\u5EFA10\u4E2A\u6635\u79F0\u5E93",
  601318: "\u521B\u5EFA\u5931\u8D25\uFF0C\u5E93\u5BB9\u91CF\u5DF2\u8FBE\u4E0A\u9650",
  601319: "\u4F01\u4E1A\u6700\u591A\u53EF\u521B\u5EFA20\u4E2A\u8BDD\u672F\u5E93",
  601320: "\u6635\u79F0\u5E93\u81F3\u5C11\u9700\u8981\u4FDD\u7559\u4E00\u6761\u8BB0\u5F55\uFF0C\u5982\u9700\u8981\u5220\u9664\u6240\u6709\u8BB0\u5F55\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u6635\u79F0\u5E93\u5220\u9664\u529F\u80FD",
  601321: "\u8BDD\u672F\u5E93\u81F3\u5C11\u9700\u8981\u4FDD\u7559\u4E00\u6761\u8BB0\u5F55\uFF0C\u5982\u9700\u8981\u5220\u9664\u6240\u6709\u8BB0\u5F55\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u8BDD\u672F\u5E93\u5220\u9664\u529F\u80FD",
  601322: "\u64CD\u4F5C\u9891\u7E41",
  601323: "AI\u6C1B\u56F4\u5E08\u7684\u9009\u62E9\u6570\u91CF\u4E0D\u53EF\u5927\u4E8E\u6635\u79F0\u5E93\u4E2D\u6635\u79F0\u7684\u603B\u6570",
  602001: "\u8BDD\u9898\u4E92\u52A8\u6570\u91CF\u8D85\u9650",
  602002: "\u8BDD\u9898\u56DE\u590D\u5DF2\u5173\u95ED\uFF0C\u65E0\u6CD5\u56DE\u590D",
  602003: "\u672A\u5F00\u542F\u8BDD\u9898\u70B9\u8D5E",
  602004: "\u672A\u5F00\u542F\u56DE\u590D\u70B9\u8D5E",
  602005: "\u4E0D\u9700\u8981\u5BA1\u6838",
  602006: "\u8BDD\u9898\u4E0D\u5B58\u5728",
  602007: "\u56DE\u590D\u5185\u5BB9\u4E2D\u6709\u654F\u611F\u8BCD\uFF0C\u8BF7\u91CD\u65B0\u7F16\u8F91",
  602008: "\u8BDD\u9898\u5F00\u5173\u672A\u5F00\u542F",
  602009: "\u7981\u8A00\u4E2D\uFF0C\u60A8\u65E0\u6CD5\u53C2\u4E0E\u8BDD\u9898\u4E92\u52A8",
  602010: "\u60A8\u5DF2\u70B9\u8D5E",
  602011: "\u56DE\u590D\u5C1A\u4E3A\u901A\u8FC7\u5BA1\u6838",
  602012: "\u8BDD\u9898\u5DF2\u7F6E\u9876",
  602013: "\u8BDD\u9898\u5DF2\u53D6\u6D88\u7F6E\u9876",
  602014: "\u8BE5\u56DE\u590D\u5DF2\u5BA1\u6838\u901A\u8FC7\uFF0C\u8BF7\u5237\u65B0\u5217\u8868",
  602015: "\u8BE5\u56DE\u590D\u5DF2\u88AB\u5220\u9664\uFF0C\u8BF7\u5237\u65B0\u5217\u8868",
  603001: "\u6700\u591A\u6DFB\u52A010\u5F20\u6D77\u62A5",
  603002: "\u6570\u636E\u83B7\u53D6\u5931\u8D25",
  603003: "\u6D77\u62A5\u6570\u636E\u6DFB\u52A0\u5931\u8D25",
  603004: "room\u5339\u914D\u9519\u8BEF",
  603005: "\u6D3B\u52A8\u5339\u914D\u9519\u8BEF",
  603006: "\u6D77\u62A5\u4FEE\u6539\u5931\u8D25",
  603007: "\u6D77\u62A5\u5220\u9664\u5931\u8D25",
  603008: "\u8BF7\u5148\u5F00\u542F\u6D77\u62A5\u5206\u4EAB\u5F00\u5173",
  603009: "\u5206\u4EAB\u914D\u7F6E\u91CD\u590D\u521B\u5EFA",
  604001: "\u7BA1\u7406\u5458\u5DF2\u5173\u95ED\u804A\u5929\u529F\u80FD",
  604002: "\u804A\u5929\u5DF2\u7F6E\u9876",
  604003: "\u804A\u5929\u5C1A\u672A\u7F6E\u9876",
  604004: "\u804A\u5929\u5DF2\u5BA1\u6838",
  604005: "\u804A\u5929\u4E0D\u9700\u8981\u5BA1\u6838",
  604006: "\u804A\u5929\u5DF2\u88AB\u62D2\u7EDD",
  604007: "\u65E0\u6548\u7684\u5728\u7EBF\u804A\u5929",
  604008: "\u53D1\u9001\u804A\u5929\u9519\u8BEF",
  604009: "\u6700\u591A\u7F6E\u987610\u6761\u6D88\u606F",
  604010: "\u804A\u5929\u5185\u5BB9\u4E0D\u5408\u89C4",
  604011: "\u804A\u5929\u6D88\u606F\u5C1A\u672A\u5BA1\u6838",
  605e3: "\u975E\u6CD5\u53C2\u6570",
  605001: "\u67E5\u8BE2\u7528\u6237\u5931\u8D25",
  605002: "\u7528\u6237\u5DF2\u5B58\u5728",
  605003: "\u6DFB\u52A0\u7528\u6237\u5931\u8D25",
  605004: "\u7F13\u5B58\u52A0\u7528\u6237\u5931\u8D25",
  605005: "\u5220\u9664\u7528\u6237\u5931\u8D25",
  605006: "\u7528\u6237\u4E0A\u7EBF\u5904\u7406\u5931\u8D25",
  605007: "\u7528\u6237\u4E0B\u7EBF\u5904\u7406\u5931\u8D25",
  605008: "\u83B7\u53D6\u5956\u6C60\u6570\u636E\u5931\u8D25",
  605101: "\u8BA2\u5355\u83B7\u53D6\u5931\u8D25",
  605102: "\u8BA2\u5355\u521B\u5EFA\u5931\u8D25",
  606e3: "\u62BD\u5956\u4E0D\u5B58\u5728",
  606001: "\u62BD\u5956\u540D\u79F0\u5DF2\u5B58\u5728",
  606002: "\u62BD\u5956\u7684\u5956\u9879\u6570\u91CF\u6700\u591A\u4E3A20\u4E2A",
  606003: "\u5956\u9879\u4E0D\u5B58\u5728",
  606004: "\u6CA1\u6709\u6B63\u5728\u8FDB\u884C\u4E2D\u7684\u62BD\u5956\u6D3B\u52A8",
  606005: "\u5956\u9879\u5DF2\u5F00\u5956\uFF0C\u65E0\u6CD5\u7F16\u8F91",
  606006: "\u5956\u9879\u5DF2\u5F00\u5956\uFF0C\u65E0\u6CD5\u5220\u9664",
  606007: "\u5956\u9879\u5F00\u5956\u4E2D\uFF0C\u6682\u65F6\u65E0\u6CD5\u5173\u95ED",
  606008: "\u5956\u54C1\u4E0D\u5B58\u5728",
  606009: "\u5956\u9879\u5F00\u5956\u4E2D\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  606010: "\u5956\u9879\u5DF2\u5F00\u5956",
  606011: "\u5F53\u524D\u62BD\u5956\u6D3B\u52A8\u5DF2\u7ECF\u53C2\u4E0E\uFF0C\u8BF7\u52FF\u91CD\u590D\u62A5\u540D\u53C2\u4E0E",
  606013: "\u4F18\u5148\u4E2D\u5956\u914D\u7F6E\u672A\u5F00\u542F",
  606014: "\u8BE5\u62BD\u5956\u4E0D\u5141\u8BB8\u62A5\u540D\u53C2\u4E0E",
  606015: "\u65E0\u6548\u7684\u62BD\u5956\u53C2\u4E0E\u8005",
  606016: "\u4E2D\u5956\u4EBA\u6570\u4E0D\u5F97\u5927\u4E8E\u5956\u54C1\u6570\u91CF",
  606017: "\u53E3\u4EE4\u9519\u8BEF",
  606018: "\u62BD\u5956\u6D3B\u52A8\u5F00\u542F30\u5929\u5185\u672A\u64CD\u4F5C\u5F00\u5956\uFF0C\u65E0\u6CD5\u5F00\u5956",
  606019: "\u5B58\u5728\u654F\u611F\u8BCD",
  606020: "\u5B57\u7B26\u8D85\u957F",
  606021: "\u53EA\u6709\u672A\u5F00\u542F\u7684\u62BD\u5956\u5141\u8BB8\u5220\u9664",
  606022: "\u62BD\u5956\u72B6\u6001\u6D41\u8F6C\u5F02\u5E38",
  606023: "\u62BD\u5956\u5DF2\u5F00\u542F",
  606024: "\u62BD\u5956\u5DF2\u5173\u95ED",
  606025: "\u81F3\u5C11\u67091\u4E2A\u5956\u9879\u624D\u80FD\u5F00\u542F\u62BD\u5956",
  606026: "\u89C2\u4F17\u4E0D\u5B58\u5728",
  606027: "\u8868\u5355\u4E0D\u5B58\u5728",
  606028: "\u89C2\u4F17\u5DF2\u5220\u9664",
  606030: "\u62BD\u5956\u672A\u5F00\u542F",
  606031: "\u4E0B\u8F7D\u8868\u5355\u672A\u5F00\u542F",
  607001: "\u975E\u6CD5\u53C2\u6570",
  607002: "\u7EA2\u5305\u53E3\u4EE4\u5305\u542B\u654F\u611F\u8BCD",
  607003: "\u7EA2\u5305\u53E3\u4EE4\u9519\u8BEF",
  607004: "\u7EA2\u5305\u5DF2\u8FC7\u671F",
  607005: "\u8BF7\u5148\u914D\u7F6E\u5FAE\u4FE1\u516C\u4F17\u53F7\u548C\u5546\u6237\u4FE1\u606F",
  607006: "\u7EA2\u5305\u4E0D\u5B58\u5728",
  607007: "\u7EA2\u5305\u4E0D\u652F\u6301\u4FEE\u6539",
  607008: "\u7EA2\u5305\u5DF2\u62A2\u5B8C",
  607010: "\u7EA2\u5305\u603B\u91D1\u989D\u4E0D\u5F97\u5C11\u4E8E0.3\u5143*\u7EA2\u5305\u4E2A\u6570\uFF0C\u4E0D\u5F97\u8D85\u8FC720W\u5143",
  607013: "\u7EA2\u5305\u53D1\u653E\u4E2D",
  607014: "\u7EA2\u5305\u8BB0\u5F55\u4E0D\u5B58\u5728",
  607015: "\u89C2\u4F1724\u5C0F\u65F6\u5185\u672A\u9886\u53D6\u7EA2\u5305",
  608001: "\u5DF2\u6709\u8BA1\u65F6\u5668\u5728\u8FD0\u884C\u4E2D\uFF0C\u8BF7\u52FF\u91CD\u590D\u53D1\u8D77",
  608002: "\u5DF2\u7ED3\u675F",
  608003: "\u6CA1\u6709\u8FDB\u884C\u4E2D\u7684\u8BA1\u65F6\u5668",
  2800003: "\u66F4\u65B0\u7ED3\u7B97\u5355\u5931\u8D25",
  2800004: "\u5220\u9664\u7ED3\u7B97\u5355\u5931\u8D25",
  2800005: "\u65E0\u6548\u5FC3\u8DF3",
  2800006: "\u66F4\u65B0\u7ED3\u7B97\u72B6\u6001\u5931\u8D25"
}, zh_Hans = {
  httpErrorCode: httpErrorCode$2
}, httpErrorCode$1 = {
  200: "SUCCESS",
  201: "\u6210\u529F\uFF0C\u5DF2\u5275\u5EFA\u8A72\u8CC7\u6E90",
  202: "\u6210\u529F\uFF0C\u5DF2\u63A5\u6536\u8A72\u8ACB\u6C42",
  300: "\u5931\u6557",
  401: "\u767B\u9304\u72C0\u614B\u5931\u6548\uFF0C\u8ACB\u91CD\u65B0\u767B\u9304",
  403: "\u672A\u6388\u6B0A",
  500: "\u7CFB\u7D71\u7570\u5E38",
  5002: "\u53C3\u6578\u932F\u8AA4",
  5003: "\u5167\u90E8\u8ABF\u7528\u5931\u6557",
  5004: "\u5275\u5EFA\u6A94\u6848\u5931\u6557",
  5005: "\u4FDD\u5B58\u6A94\u6848\u5931\u6557",
  5006: "\u8ACB\u6C42\u983B\u7E41",
  5008: "\u6578\u64DA\u932F\u8AA4",
  5009: "\u8EAB\u4EFD\u9451\u6B0A\u5931\u6557,\u7528\u6236\u985E\u578B\u932F\u8AA4",
  5010: "\u91CD\u8907\u8ACB\u6C42",
  5011: "\u5167\u90E8\u8ABF\u7528\u5931\u6557",
  5012: "\u8ACB\u6C42\u904E\u65BC\u983B\u7E41,\u8ACB\u7A0D\u5F8C\u518D\u8A66",
  5013: "\u7372\u53D6\u9396\u5931\u6557",
  1e5: "\u6578\u64DA\u5EAB\u7570\u5E38",
  100001: "\u5DF2\u5B58\u5728\u7684",
  100005: "\u672A\u67FB\u8A62\u5230\u6578\u64DA",
  100006: "\u670D\u52D9\u521D\u59CB\u5316\u4E2D",
  100007: "\u670D\u52D9\u963B\u585E\u4E2D",
  100008: "\u963B\u585E\u7570\u5E38",
  100009: "dubbo\u901A\u4FE1\u7570\u5E38",
  100010: "\u975E\u6CD5\u53C3\u6578\u7570\u5E38",
  100011: "\u975E\u6CD5\u72C0\u614B\u7570\u5E38",
  100012: "\u8ACB\u6C42\u53C3\u6578\u7570\u5E38,\u8ACB\u4FEE\u6539\u5F8C\u518D\u6B21\u63D0\u4EA4",
  100013: "\u8ACB\u6C42\u53C3\u6578\u7570\u5E38,\u8ACB\u4FEE\u6539\u5F8C\u518D\u6B21\u63D0\u4EA4",
  100014: "\u8ACB\u6C42\u53C3\u6578\u7570\u5E38,\u8ACB\u4FEE\u6539\u5F8C\u518D\u6B21\u63D0\u4EA4",
  100015: "\u4F7F\u7528\u7121\u6548\u7684worker ID\uFF0C\u7121\u6CD5\u751F\u6210\u5206\u4F48\u5F0FID",
  100016: "\u7DB2\u7D61\u7570\u5E38\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  100017: "\u7DB2\u7D61\u7570\u5E38\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  100018: "\u670D\u52D9 %s \u521D\u59CB\u5316\u4E2D",
  100019: "\u7121\u6548\u8ACB\u6C42",
  100020: "\u670D\u52D9\u5668\u7E41\u5FD9\uFF0C\u8ACB\u7A0D\u5019\u91CD\u8A66",
  100021: "\u8A2A\u554F\u8D85\u6642",
  100022: "\u6578\u64DA\u5EAB\u7D22\u5F15\u885D\u7A81 : %s",
  100023: "\u8ACB\u6C42\u7684\u53C3\u6578\u8F49\u63DB\u7570\u5E38",
  100024: "\u8ACB\u6C42\u7684Json\u53C3\u6578\u8F49\u63DB\u7570\u5E38",
  100025: "\u8ACB\u6C42\u53C3\u6578: %s, \u503C: %s, \u53C3\u6578\u985E\u578B: %s, \u503C\u7684\u985E\u578B\u548C\u53C3\u6578\u985E\u578B\u4E0D\u5339\u914D",
  100026: "\u8ACB\u6C42\u982D\u4E2D\u7684Content type\u4E0D\u652F\u6301,\u8ACB\u4ED4\u7D30\u6AA2\u67E5Header\u4E2D\u7684Content type\u503C",
  100027: "\u8FD4\u56DE\u53C3\u6578\u5E8F\u5217\u5316\u7570\u5E38",
  100028: "\u8ACB\u6C42\u7684Method\u4E0D\u652F\u6301",
  100029: "\u8ACB\u6C42\u53C3\u6578\u8F49\u63DB\u7570\u5E38",
  100030: "\u8ACB\u6C42\u7684\u6D88\u606F\u9AD4JSON\u53CD\u5E8F\u5217\u5316\u7570\u5E38",
  100031: "\u8ACB\u6C42\u53C3\u6578\u4E2D\u7684 %s \u8F38\u5165\u932F\u8AA4",
  100040: "accessToken\u4E0D\u5B58\u5728",
  100041: "\u767B\u9304\u72C0\u614B\u5931\u6548\uFF0C\u8ACB\u91CD\u65B0\u767B\u9304",
  100042: "\u7121\u6548\u7684\u57FA\u672C\u8EAB\u4EFD\u9A57\u8B49\u4EE4\u724C",
  100043: "\u6703\u8A71\u8D85\u6642\uFF0C\u8ACB\u91CD\u65B0\u767B\u9304",
  100044: "\u4E0D\u5408\u6CD5\u7684token\uFF0C\u8ACB\u8A8D\u771F\u6BD4\u5C0D token \u7684\u7C3D\u540D",
  100045: "\u7F3A\u5C11token\u53C3\u6578",
  100046: "\u89E3\u6790\u7528\u6236\u8EAB\u4EFD\u932F\u8AA4\uFF0C\u8ACB\u91CD\u65B0\u767B\u9304\uFF01",
  100047: "\u79DF\u6236id\u7232\u7A7A\uFF01",
  100048: "\u60A8\u7121\u6B0A\u9650\u9032\u5165",
  100049: "\u7576\u524D\u6B63\u5728\u767B\u9304\u4E2D",
  100050: "\u60A8\u7684\u8CEC\u865F\u5DF2\u5728\u5176\u4ED6\u8A2D\u5099\u767B\u9304",
  100051: "\u7576\u524D\u7248\u672C\u7121\u6CD5\u4F7F\u7528\u8A72\u529F\u80FD\uFF0C\u8ACB\u5148\u5347\u7D1A\u7522\u54C1\u7248\u672C",
  100052: "MQ\u767C\u9001\u6D88\u606F\u5931\u6557",
  100053: "\u90F5\u4EF6\u767C\u9001\u5931\u6557\uFF0C\u8ACB\u6AA2\u67E5\u90F5\u7BB1\u914D\u7F6E",
  100054: "\u8ACB\u6C42\u7684\u6D88\u606F\u9AD4\u4E0D\u7B26\u5408API\u7684\u8981\u6C42",
  100055: "\u8ACB\u6C42\u7684\u6D88\u606F\u9AD4BODY\u7232\u7A7A",
  100056: "\u8ACB\u6C42\u53C3\u6578\u4E2D\u7684 %s \u8F38\u5165\u932F\u8AA4",
  100057: "\u904B\u6C23\u4E0D\u4F73",
  100058: "MDF\u4EE4\u724C\u5931\u6548",
  100059: "\u5167\u90E8\u52A0\u5BC6\u904B\u7B97\u7570\u5E38",
  100060: "\u5167\u90E8\u89E3\u5BC6\u904B\u7B97\u7570\u5E38",
  100061: "\u5167\u90E8\u52A0\u5DE5\u5BC6\u9470\u904B\u7B97\u7570\u5E38",
  100062: "%s \u662F\u5FC5\u9700\u9805",
  100063: "\u8A72\u8A9E\u8A00\u5C1A\u672A\u914D\u7F6E\uFF0C\u8ACB\u5B8C\u6210\u914D\u7F6E\u5F8C\u518D\u958B\u5553",
  100064: "\u7576\u524D\u8A9E\u8A00\u985E\u578B\u66AB\u672A\u914D\u7F6E\uFF01",
  100065: "\u50C5\u65D7\u8266\u7248\u53EF\u4EE5\u4F7F\u7528\u6B64\u958B\u653E\u80FD\u529B\uFF01",
  100066: "\u4FEE\u6539\u6578\u64DA\u5931\u6557",
  100067: "\u5220\u9664\u6578\u64DA\u5931\u6557",
  100068: "\u767B\u9304\u914D\u7F6E\u5DF2\u5931\u6548\uFF0C\u5DF2\u66F4\u65B0\u72C0\u614B",
  100069: "\u8ACB\u52FF\u983B\u7E41\u64CD\u4F5C",
  100070: "\u8ACB\u5148\u914D\u7F6E\u5FAE\u4FE1\u516C\u8846\u865F\u4FE1\u606F",
  100071: "\u66AB\u672A\u767B\u9304\uFF0C\u8ACB\u5148\u767B\u9304",
  100072: "\u65B0\u589E\u6578\u64DA\u5931\u6557",
  100073: "\u6709\u6548\u671F\u4E0D\u80FD\u8D85\u904E%s\u5929",
  100074: "\u8ACB\u52FF\u91CD\u8907\u64CD\u4F5C",
  100076: "\u8A2D\u7F6E\u5931\u6557\uFF0C\u672A\u5B8C\u6210\u4F01\u696D\u5FAE\u4FE1\u6388\u6B0A",
  100077: "\u4F01\u5FAE\u63A5\u53E3\u8ACB\u6C42\u5931\u6557",
  100078: "\u4F01\u696D\u5FAE\u4FE1\u914D\u7F6E\u7570\u5E38",
  100100: "\u624B\u6A5F\u865F\u78BC\u683C\u5F0F\u4E0D\u6B63\u78BA",
  100700: "\u5206\u4F48\u5F0FID\u521D\u59CB\u5316\u7570\u5E38",
  100701: "s",
  100702: "\u7121\u6548\u7684key\uFF0C\u5C0E\u81F4\u5206\u4F48\u5F0FID\u751F\u6210\u5931\u6557",
  100703: "\u6642\u9593\u56DE\u6EFE\uFF0C\u5C0E\u81F4\u5206\u4F48\u5F0FID\u751F\u6210\u5931\u6557",
  100704: "\u5206\u4F48\u5F0FID\u751F\u6210\u6A21\u5F0FidCreateModel\u914D\u7F6E\u7570\u5E38,\u5C0E\u81F4\u5206\u4F48\u5F0FID\u521D\u59CB\u5316\u7570\u5E38",
  100800: "\u6587\u6A94\u4E0B\u8F09\u7570\u5E38",
  100900: "\u77ED\u4FE1\u624B\u6A5F\u865F\u53C3\u6578\u7570\u5E38",
  100901: "\u77ED\u4FE1\u6A21\u677F\u53C3\u6578\u7570\u5E38",
  100902: "\u901A\u904E\u985E\u540D\u7372\u53D6\u77ED\u4FE1\u6A21\u677Fcode\u7570\u5E38",
  100903: "\u77ED\u4FE1\u963F\u91CC\u96F2\u670D\u52D9\u97FF\u61C9\u7232\u7A7A\u7570\u5E38",
  100904: "\u7CFB\u7D71\u7570\u5E38\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002",
  100905: "\u8ACB\u7A0D\u5F8C\u518D\u8A66",
  100906: "\u7DDA\u7A0B\u6C60\u57F7\u884C\u4EFB\u52D9\u7570\u5E38",
  100907: "\u670D\u52D9\u7E41\u5FD9\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66",
  100908: "\u77ED\u4FE1\u767C\u9001\u689D\u6578\u8D85\u904E\u4E0A\u9650\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002",
  100909: "\u60A8\u5C1A\u672A\u5831\u540D\uFF0C\u8ACB\u5831\u540D\u5F8C\u53C3\u8207",
  100910: "\u60A8\u7121\u6CD5\u53C3\u52A0\u672C\u6D3B\u52D5\uFF0C\u5982\u6709\u7591\u554F\u8ACB\u806F\u7E6B\u4E3B\u8FA6\u65B9",
  100911: "\u8ACB\u5148\u9032\u884C\u51C6\u5165",
  100912: "\u60A8\u7121\u6CD5\u53C3\u8207\u672C\u6D3B\u52D5\uFF0C\u8ACB\u806F\u7E6B\u4E3B\u8FA6\u65B9",
  100913: "\u53C3\u6578\u4E0D\u80FD\u7232\u7A7A",
  100914: "\u60A8\u7121\u6CD5\u53C3\u52A0\u672C\u6D3B\u52D5\uFF0C\u5982\u6709\u7591\u554F\u8ACB\u806F\u7E6B\u4E3B\u8FA6\u65B9",
  100971: "\u8F38\u5165\u7684\u5167\u5BB9\u5305\u542B\u975E\u6CD5\u5B57\u7B26\uFF0C\u8ACB\u6AA2\u67E5\u5F8C\u518D\u91CD\u8A66",
  100972: "\u5E2D\u4F4D\u5DF2\u5B58\u5728",
  100973: "\u79FB\u9664\u5E2D\u4F4D\u5931\u6557,\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  100974: "\u6DFB\u52A0\u5E2D\u4F4D\u5931\u6557,\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  100975: "\u8A3B\u518A\u5931\u6557",
  100976: "\u767B\u9304\u5931\u6557",
  100977: "\u8ABF\u7528\u591A\u96F2\u878D\u5408\u7570\u5E38",
  100978: "\u9000\u51FA\u767B\u9304\u5931\u6557",
  100979: "\u63A5\u53E3\u5DF2\u9650\u6D41",
  100980: "\u8ACB\u8F38\u5165\u8ACB\u6C42ID",
  100981: "\u7121\u6548\u7684\u5BC6\u78BC\u52A0\u5BC6\u8ACB\u6C42",
  100982: "\u79C1\u9470\u89E3\u6790\u7570\u5E38",
  100983: "\u8ACB\u8F38\u5165\u9577\u5EA6\u7232%s~%s\u4F4D\u7684\u5BC6\u78BC",
  100984: "\u8ACB\u8F38\u5165\u6B63\u78BA\u683C\u5F0F\u7684\u5BC6\u78BC",
  100985: "\u5BC6\u78BC\u9577\u5EA6\u6700\u5927\u7232%s",
  100986: "RSA\u79C1\u9470\u7C3D\u540D\u5931\u6557",
  100987: "RSA\u516C\u9470\u9A57\u7C64\u5931\u6557",
  100988: "RSA\u516C\u9470\u52A0\u5BC6\u5931\u6557",
  100989: "RSA\u79C1\u9470\u89E3\u5BC6\u5931\u6557",
  100990: "RSA\u521D\u59CB\u5316\u5BC6\u9470\u51FA\u73FE\u932F\u8AA4,\u7B97\u6CD5\u7570\u5E38",
  100991: "RSA\u52A0\u5BC6\u7570\u5E38",
  100992: "\u975E\u6CD5\u8ABF\u7528",
  100993: "\u4E0A\u50B3\u7684\u5716\u7247\u683C\u5F0F\u50C5\u652F\u6301 %s, \u8ACB\u91CD\u8A66",
  100994: "\u4E0A\u50B3\u5931\u6557,\u8ACB\u91CD\u8A66",
  100995: "\u4E0A\u50B3\u7684\u5716\u7247\u8D85\u51FA\u4E86\u9650\u5236,\u6700\u5927 %s MB",
  100996: "\u8ACB\u6C42\u53C3\u6578\u7232\u7A7A",
  100997: "\u6578\u64DA\u4E0D\u5B58\u5728",
  100998: "\u4E0A\u5831\u884C\u7232\u985E\u578B\u4E0D\u652F\u6301",
  100999: "\u672A\u77E5\u932F\u8AA4",
  101001: "\u8ACB\u8F38\u5165\u7528\u6236\u540D\u6216\u5BC6\u78BC",
  101002: "\u8CEC\u865F\u4E0D\u5B58\u5728",
  101003: "\u5BC6\u78BC\u932F\u8AA4",
  101004: "refreshToken\u7121\u6548\uFF0C\u7121\u6CD5\u52A0\u8F09\u7528\u6236\u4FE1\u606F",
  101005: "refreshToken\u7232\u7A7A",
  101006: "grantType \u4E0D\u652F\u6301\uFF0C\u8ACB\u50B3\u905E\u6B63\u78BA\u7684 grantType \u53C3\u6578",
  101007: "\u8CEC\u865F\u683C\u5F0F\u932F\u8AA4",
  101008: "\u8A72\u8CEC\u865F\u5DF2\u6FC0\u6D3B\uFF0C\u8ACB\u52FF\u91CD\u8907\u64CD\u4F5C\u3002",
  101009: "\u93C8\u63A5\u5DF2\u5931\u6548\uFF0C\u8ACB\u806F\u7E6B\u7BA1\u7406\u54E1\u7372\u53D6\u65B0\u7684\u9080\u8ACB\u93C8\u63A5\u3002",
  101010: "\u7121\u6548\u7684\u7528\u6236",
  101011: "\u5275\u5EFA\u7528\u6236\u5931\u6557",
  101012: "\u4FEE\u6539\u7528\u6236\u5931\u6557",
  101013: "\u522A\u9664\u7528\u6236\u5931\u6557",
  101014: "\u53C3\u6578\u932F\u8AA4\uFF0C\u4FEE\u6539\u7528\u6236\u72C0\u614B\u5931\u6557",
  101015: "\u7121\u6CD5\u5C0D\u81EA\u5DF1\u9032\u884C\u8A72\u64CD\u4F5C",
  101020: "\u7528\u6236\u8207\u4F01\u696D\u7D81\u5B9A\u5931\u6557",
  101021: "\u65B0\u820A\u5BC6\u78BC\u4E0D\u80FD\u76F8\u540C",
  101022: "\u8ACB\u5148\u5B8C\u6210\u4EBA\u6A5F\u6821\u9A57",
  101023: "\u4EBA\u6A5F\u6821\u9A57\u5931\u6557",
  101024: "\u9A57\u8B49\u78BC\u932F\u8AA4",
  101025: "\u8ACB\u8F38\u5165\u7D81\u5B9A\u624B\u6A5F\u865F",
  101026: "\u8CEC\u865F\u4E0D\u5B58\u5728\uFF0C\u8ACB\u8F38\u5165\u7D81\u5B9A\u624B\u6A5F\u865F",
  101027: "\u8ACB\u8F38\u5165\u7D81\u5B9A\u90F5\u7BB1",
  101028: "\u8CEC\u865F\u4E0D\u5B58\u5728\uFF0C\u8ACB\u8F38\u5165\u7D81\u5B9A\u90F5\u7BB1",
  101029: "\u624B\u6A5F\u865F\u78BC\u683C\u5F0F\u4E0D\u6B63\u78BA",
  101030: "\u767C\u9001\u5BC6\u78BC\u90F5\u4EF6\u5931\u6557",
  101031: "\u7528\u6236\u7121\u6B0A\u9650\u767B\u9304",
  101032: "\u4F01\u696D\u5DF2\u9396\u5B9A\uFF0C\u7121\u6B0A\u9650\u767B\u9304",
  101033: "\u624B\u6A5F\u865F\u78BC\u5DF2\u5B58\u5728",
  101034: "\u90F5\u7BB1\u5DF2\u5B58\u5728",
  101035: "\u8CEC\u865F/\u5BC6\u78BC\u932F\u8AA4\uFF0C\u8ACB\u91CD\u65B0\u8F38\u5165",
  101036: "\u8CEC\u865F\u5DF2\u88AB\u9396\u5B9A\uFF0C\u8ACB\u5728%s\u5206\u9418\u5F8C\u91CD\u8A66",
  101037: "\u8CEC\u865F\u5DF2\u9396\u5B9A\uFF0C\u8ACB\u806F\u7E6B\u7BA1\u7406\u54E1\u89E3\u9664\u9396\u5B9A",
  101038: "\u9A57\u8B49\u78BC\u904E\u671F\uFF0C\u8ACB\u91CD\u65B0\u7372\u53D6\u9A57\u8B49\u78BC",
  101039: "\u7248\u672C\u904E\u4F4E\uFF0C\u8ACB\u5347\u7D1A\u7248\u672C",
  101050: "\u7372\u53D6\u6578\u64DA\u6B0A\u9650\u53C3\u6578\u7570\u5E38",
  101051: "\u9A57\u8B49\u78BC1\u5C0F\u6642\u4E0D\u80FD\u8D85\u904E6\u6B21",
  101052: "\u9A57\u8B49\u78BC24\u5C0F\u6642\u4E0D\u80FD\u8D85\u904E20\u6B21",
  101053: "\u7372\u53D6\u7D44\u7E54\u6A39\u5931\u6557\uFF0C\u8ACB\u78BA\u8A8D\u53C3\u6578\u662F\u5426\u6B63\u78BA",
  101054: "\u6DFB\u52A0\u7BA1\u7406\u54E1\u5931\u6557",
  101055: "\u79FB\u9664\u7BA1\u7406\u54E1\u5931\u6557",
  101056: "\u4FEE\u6539\u7BA1\u7406\u54E1\u89D2\u8272\u5931\u6557",
  101057: "\u6DFB\u52A0\u7BA1\u7406\u54E1\u7684\u7528\u6236\u4E0D\u80FD\u7232\u7A7A",
  101058: "\u6DFB\u52A0\u5354\u4F5C\u8CEC\u865F\u5931\u6557",
  101059: "\u79FB\u9664\u5354\u4F5C\u8CEC\u865F\u5931\u6557",
  101060: "\u4FEE\u6539\u5354\u4F5C\u8CEC\u865F\u89D2\u8272\u5931\u6557",
  101061: "\u5354\u4F5C\u8CEC\u865F\u5DF2\u5B58\u5728\uFF0C\u8ACB\u78BA\u8A8D\u662F\u5426\u91CD\u8907",
  101062: "\u7BA1\u7406\u54E1\u7528\u6236\u6578\u91CF\u4E0D\u80FD\u8D85\u904E",
  101063: "\u66F4\u63DB\u4F01\u696D\u7BA1\u7406\u54E1\u5931\u6557",
  101064: "\u8ACB\u52FF\u4E00\u5206\u9418\u5167\u91CD\u8907\u7372\u53D6\u9A57\u8B49\u78BC!",
  101065: "\u4FEE\u6539\u5BC6\u78BC\u5931\u6557",
  101066: "token\u53C3\u6578\u4E0D\u6B63\u78BA",
  101067: "\u8CEC\u865F\u683C\u5F0F\u4E0D\u6B63\u78BA",
  101068: "\u7528\u6236\u540D\u8207\u624B\u6A5F\u865F/\u90F5\u7BB1\u4E0D\u5339\u914D\uFF0C\u8ACB\u6AA2\u67E5\u5F8C\u91CD\u8A66",
  101069: "5\u5206\u9418\u5167\u50C5\u652F\u6301\u64CD\u4F5C\u4E00\u6B21\uFF0C\u8ACB\u52FF\u983B\u7E41\u64CD\u4F5C",
  101070: "\u7528\u6236\u540D\u4E0D\u652F\u6301\u91CD\u8907",
  101071: "\u7B2C\u4E09\u65B9\u7DE8\u865F\u4E0D\u652F\u6301\u91CD\u8907",
  101072: "\u8CEC\u865F\u672A\u6FC0\u6D3B\uFF0C\u8ACB\u6FC0\u6D3B\u5F8C\u4F7F\u7528",
  101073: "\u7528\u6236\u540D\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u5F8C\u91CD\u65B0\u5617\u8A66",
  101074: "\u8A72\u7528\u6236\u4E0D\u5141\u8A31\u767B\u9304\u7BA1\u7406\u5E73\u81FA",
  101075: "\u8CEC\u865F\u751F\u6210\u65B9\u5F0F\u9078\u64C7\u901A\u904E\u90F5\u4EF6\u81EA\u4E3B\u6FC0\u6D3B\u6642\uFF0C\u9700\u8A2D\u7F6E\u90F5\u7BB1",
  101076: "\u8ACB\u8F38\u5165\u751F\u6548\u65E5\u671F",
  101077: "\u8ACB\u8F38\u5165\u5931\u6548\u65E5\u671F",
  101078: "\u8ACB\u8F38\u5165\u683C\u5F0F\u6B63\u78BA\u7684\u751F\u6548\u65E5\u671F",
  101079: "\u8ACB\u8F38\u5165\u683C\u5F0F\u6B63\u78BA\u7684\u5931\u6548\u65E5\u671F",
  101080: "\u751F\u6548\u65E5\u671F\u4E0D\u80FD\u65E9\u65BC\u4ECA\u5929",
  101081: "\u5931\u6548\u65E5\u671F\u4E0D\u80FD\u65E9\u65BC\u751F\u6548\u65E5\u671F",
  101082: "\u8ACB\u9078\u64C7\u8CEC\u865F\u985E\u578B",
  101083: "\u7528\u6236\u7121\u6B0A\u9650\u767B\u9304",
  101084: "\u7528\u6236\u7121\u6B0A\u9650\u767B\u9304",
  101085: "\u65E5\u671F\u89E3\u6790\u7570\u5E38",
  101086: "\u4E0D\u80FD\u4FEE\u6539\u751F\u6548\u65E5\u671F",
  101087: "\u5931\u6548\u65E5\u671F\u4E0D\u5F97\u65E9\u65BC\u7576\u5929",
  101088: "\u7121\u6CD5\u5340\u5206\u8CEC\u865F\u662F\u5426\u9650\u6642",
  101089: "\u9650\u6642\u8CEC\u865F\u4E0D\u5141\u8A31\u4FEE\u6539\u8CEC\u865F\u72C0\u614B",
  101090: "\u7528\u6236\u7121\u6B0A\u9650\u767B\u9304",
  101091: "\u6DFB\u52A0\u5E2D\u4F4D\u5931\u6557",
  101092: "\u751F\u6548\u65E5\u671F\u4E0D\u5F97\u665A\u65BC\u7576\u5929",
  101094: "\u7528\u6236\u540D\u7A31\u4E0D\u652F\u6301'\u201C\\ / & > <\u7B49\u7279\u6B8A\u5B57\u5143",
  103e3: "\u7121\u6548\u7684\u7D44\u7E54",
  103001: "\u7121\u6548\u7684\u7236\u7D44\u7E54",
  103002: "\u6839\u7D44\u7E54\u5DF2\u5B58\u5728",
  103003: "\u7121\u6CD5\u522A\u9664\u6839\u7D44\u7E54",
  103004: "\u7121\u6CD5\u4FEE\u6539\u6839\u7D44\u7E54\u72C0\u614B",
  103005: "\u540C\u7D1A\u90E8\u9580\u540D\u7A31\u4E0D\u80FD\u91CD\u8907",
  103006: "\u4E0A\u7D1A\u7D44\u7E54\u4E0D\u5141\u8A31\u4FEE\u6539",
  103007: "\u4E0A\u7D1A\u7D44\u7E54\u8655\u65BC\u7981\u7528\u72C0\u614B\uFF0C\u8ACB\u5148\u5553\u7528\u4E0A\u7D1A\u7D44\u7E54",
  103010: "\u5275\u5EFA\u7D44\u7E54\u5931\u6557",
  103011: "\u4FEE\u6539\u7D44\u7E54\u5931\u6557",
  103012: "\u522A\u9664\u7D44\u7E54\u5931\u6557",
  103013: "\u7D44\u7E54\u5C64\u6578\u4E0D\u80FD\u8D85\u904E7\u5C64",
  103014: "\u7D44\u7E54\u5B50\u7BC0\u9EDE\u4E0D\u80FD\u8D85\u904E100\u500B",
  103015: "\u8A72\u90E8\u9580\u4E0B\u6709\u4EBA\u54E1\u6216\u696D\u52D9\u6578\u64DA\u5B58\u5728\uFF0C\u7121\u6CD5\u522A\u9664",
  108e3: "\u7121\u6548\u7684\u7559\u8CC7\u4FE1\u606F",
  108001: "\u66F4\u65B0\u7559\u8CC7\u4FE1\u606F\u5931\u6557",
  108002: "\u7121\u6548\u7684\u8DDF\u9032\u4FE1\u606F",
  108003: "\u5275\u5EFA\u7559\u8CC7\u8A18\u9304\u5931\u6557",
  108004: "\u5275\u5EFA\u8DDF\u9032\u8A18\u9304\u5931\u6557",
  108005: "\u90F5\u4EF6\u767C\u9001\u5931\u6557",
  108006: "\u670D\u52D9\u5668\u7E41\u5FD9",
  108007: "\u91CD\u8907\u767C\u9001\u9A57\u8B49\u78BC",
  108008: "\u9A57\u8B49\u78BC\u932F\u8AA4",
  108009: "\u9A57\u8B49\u78BC\u5DF2\u904E\u671F",
  109e3: "\u7121\u6548\u7684\u89D2\u8272",
  109001: "\u5275\u5EFA\u89D2\u8272\u5931\u6557",
  109002: "\u4FEE\u6539\u89D2\u8272\u5931\u6557",
  109003: "\u522A\u9664\u89D2\u8272\u5931\u6557",
  109004: "\u8A72\u89D2\u8272\u5B58\u5728\u95DC\u806F\u54E1\u5DE5",
  109005: "\u5275\u5EFA\u89D2\u8272\u6B0A\u9650\u95DC\u806F\u4FE1\u606F\u5931\u6557",
  109006: "\u522A\u9664\u89D2\u8272\u6B0A\u9650\u95DC\u806F\u4FE1\u606F\u5931\u6557",
  109007: "\u89D2\u8272\u7684\u6B0A\u9650\u4E0D\u80FD\u7232\u7A7A",
  109008: "\u89D2\u8272\u540D\u7A31\u4E0D\u53EF\u91CD\u8907",
  110001: "\u7121\u6548\u7684\u6B0A\u9650",
  111e3: "\u8ACB\u8F38\u5165\u7528\u6236\u540D\u6216\u5BC6\u78BC",
  111001: "\u8CEC\u865F\u4E0D\u5B58\u5728",
  111002: "\u8CEC\u865F\u5DF2\u88AB\u7981\u7528",
  111003: "refreshToken\u7121\u6548\uFF0C\u7121\u6CD5\u52A0\u8F09\u7528\u6236\u4FE1\u606F",
  111004: "refreshToken\u7232\u7A7A",
  111005: "grantType \u4E0D\u652F\u6301\uFF0C\u8ACB\u50B3\u905E\u6B63\u78BA\u7684 grantType \u53C3\u6578",
  111006: "\u7121\u6548\u7684\u54E1\u5DE5",
  111007: "\u5275\u5EFA\u54E1\u5DE5\u5931\u6557",
  111008: "\u4FEE\u6539\u54E1\u5DE5\u5931\u6557",
  111009: "\u4FEE\u6539\u54E1\u5DE5\u5BC6\u78BC\u5931\u6557",
  111010: "\u522A\u9664\u54E1\u5DE5\u89D2\u8272\u5931\u6557",
  111011: "\u7528\u6236\u540D/\u90F5\u7BB1/\u624B\u6A5F\u865F\u5DF2\u5B58\u5728\uFF0C\u4E0D\u5141\u8A31\u91CD\u8907",
  111012: "\u5275\u5EFA\u54E1\u5DE5\u89D2\u8272\u5931\u6557",
  111013: "\u8CEC\u865F/\u5BC6\u78BC\u932F\u8AA4",
  111014: "\u66F4\u65B0\u767B\u9304ip\u53CA\u6642\u9593\u5931\u6557",
  111015: "\u767C\u9001\u5BC6\u78BC\u90F5\u4EF6\u5931\u6557",
  111016: "\u5BC6\u78BC\u932F\u8AA4\u8D85\u904E3\u6B21\uFF0C\u9700\u767C\u9001\u4EBA\u6A5F\u6821\u9A57",
  111017: "\u7121\u6548\u7684\u4EBA\u6A5F\u6821\u9A57\u53C3\u6578",
  111018: "\u4EBA\u6A5F\u6821\u9A57\u5931\u6557",
  111019: "\u65B0\u820A\u5BC6\u78BC\u4E0D\u80FD\u76F8\u540C",
  111020: "token\u4E0D\u6B63\u78BA",
  111021: "\u820A\u5BC6\u78BC\u932F\u8AA4",
  111022: "\u90F5\u4EF6\u5DF2\u767C\u9001\uFF0C\u8ACB\u4E00\u5206\u9418\u5F8C\u91CD\u8A66",
  112e3: "\u4FEE\u6539\u79DF\u6236\u4FE1\u606F\u5931\u6557",
  112001: "\u7121\u6548\u7684\u79DF\u6236",
  112002: "\u50B3\u5165\u7684\u53C3\u6578\u4E0D\u6B63\u78BA",
  112003: "\u7121\u6548\u7684\u90F5\u7BB1\u914D\u7F6E",
  112004: "\u767C\u9001\u90F5\u4EF6\u5931\u6557",
  112005: "\u7121\u6548\u7684\u8CC7\u6E90",
  112006: "\u5275\u5EFA\u8CC7\u6E90\u7BA1\u63A7\u5931\u6557",
  112007: "\u7121\u6548\u7684\u8CC7\u6E90\u985E\u578B",
  112008: "\u7981\u7528\u7406\u7531\u4E0D\u80FD\u7232\u7A7A",
  112009: "\u5BA2\u6236\u4E3B\u9AD4\u540D\u7A31\u4E0D\u80FD\u7232\u7A7A",
  112010: "\u5BA2\u6236\u661F\u7D1A\u9700\u57281-5\u661F",
  112011: "\u5BA2\u6236\u4E3B\u9AD4\u540D\u7A31\u5DF2\u5B58\u5728",
  112012: "\u5B50\u79DF\u6236\u6578\u91CF\u5DF2\u9054\u8CC7\u6E90\u5305\u5BB9\u91CF\uFF0C\u7121\u6CD5\u5275\u5EFA",
  112013: "\u5275\u5EFA\u79DF\u6236\u4FE1\u606F\u5931\u6557",
  112014: "\u806F\u7E6B\u4EBA\u4FE1\u606F\u4E0D\u80FD\u7232\u7A7A",
  112015: "\u8ACB\u52FF\u4E00\u5206\u9418\u5167\u91CD\u8907\u767C\u9001\u90F5\u4EF6",
  112016: "\u5275\u5EFA\u9580\u6236\u5931\u6557",
  112017: "\u7121\u6548\u7684\u9580\u6236",
  112018: "\u4FEE\u6539\u9580\u6236\u5931\u6557",
  112019: "\u522A\u9664\u9580\u6236\u5931\u6557",
  112020: "\u5275\u5EFA\u677F\u584A\u5931\u6557",
  112021: "\u4FEE\u6539\u677F\u584A\u5931\u6557",
  112022: "\u522A\u9664\u677F\u584A\u5931\u6557",
  112023: "\u7121\u6548\u677F\u584A",
  112024: "\u9802\u90E8\u6B04\u6216\u8005\u5E95\u90E8\u6B04\u4E0D\u5141\u8A31\u6392\u5E8F",
  112025: "\u9802\u90E8\u6B04\u4E0D\u80FD\u91CD\u8907\u5275\u5EFA",
  112026: "\u5E95\u90E8\u6B04\u4E0D\u80FD\u91CD\u8907\u5275\u5EFA",
  112027: "\u5275\u5EFA\u5716\u7247\u985E\u578B\u6578\u64DA\u5931\u6557",
  112028: "\u4FEE\u6539\u8F2A\u64AD\u5716\u5931\u6557",
  112029: "\u522A\u9664\u8F2A\u64AD\u5716\u5931\u6557",
  112030: "\u7121\u6548\u8F2A\u64AD\u5716",
  112031: "\u5275\u5EFA\u8996\u983B\u6B04\u5931\u6557",
  112032: "\u4FEE\u6539\u8996\u983B\u6B04\u5931\u6557",
  112033: "\u522A\u9664\u8996\u983B\u6B04\u5931\u6557",
  112034: "\u7121\u6548\u8996\u983B\u6B04",
  112035: "\u5275\u5EFA\u8996\u983B\u5931\u6557",
  112036: "\u4FEE\u6539\u8996\u983B\u5931\u6557",
  112037: "\u522A\u9664\u8996\u983B\u5931\u6557",
  112038: "\u7121\u6548\u8996\u983B",
  112039: "\u4FEE\u6539\u516C\u53F8\u540D\u7A31\u7570\u5E38",
  112040: "\u4FEE\u6539logo\u5716\u6A19\u7570\u5E38",
  112041: "\u4FEE\u6539\u7DB2\u7AD9\u5716\u6A19\u7570\u5E38",
  112042: "\u4FEE\u6539\u83DC\u55AElogo\u7570\u5E38",
  112043: "\u4FEE\u6539\u767B\u9304\u8A2D\u7F6E\u7570\u5E38",
  112044: "\u4FEE\u6539\u5FAE\u4FE1\u958B\u653E\u5E73\u81FA\u8A2D\u7F6E\u7570\u5E38",
  112045: "\u4FEE\u6539\u5FAE\u4FE1\u516C\u8846\u865F\u8A2D\u7F6E\u7570\u5E38",
  112046: "\u4FEE\u6539\u5FAE\u4FE1\u652F\u4ED8\u8A2D\u7F6E\u7570\u5E38",
  112047: "\u4FEE\u6539\u7B2C\u4E09\u65B9\u6388\u6B0A\u7570\u5E38",
  112048: "\u4FEE\u6539\u90F5\u7BB1\u914D\u7F6E\u7570\u5E38",
  112049: "\u7121\u6548\u7684\u76F4\u64AD\u5834\u666F",
  112050: "\u7372\u53D6\u5FAE\u4FE1\u652F\u4ED8\u8A2D\u7F6E\u7570\u5E38",
  112051: "\u7121\u6548\u7684\u767B\u9304\u7528\u6236",
  112052: "\u6578\u64DA\u4E0D\u5B58\u5728",
  112053: "\u6578\u64DA\u91CD\u8907",
  112054: "\u7121\u6548\u53C3\u6578",
  112055: "\u5BA2\u6236\u7DE8\u865F\u5DF2\u5B58\u5728",
  112056: "\u8CC7\u6E90\u7BA1\u63A7\u76F4\u64AD\u985E\u578B\u53C3\u6578\u7570\u5E38",
  112057: "\u7121\u6548\u7684\u677F\u584A\u985E\u578B",
  112058: "\u6578\u91CF\u4E0D\u80FD\u5C11\u65BC 0 \u4E26\u4E14\u6578\u91CF\u4E0D\u80FD\u8D85\u51FA\u9650\u5236 \u6700\u5927%s\u500B",
  112059: "\u5275\u5EFA\u6D3B\u52D5\u5217\u8868\u5931\u6557",
  112060: "\u4FEE\u6539\u6D3B\u52D5\u5217\u8868\u5931\u6557",
  112061: "\u522A\u9664\u6D3B\u52D5\u5217\u8868\u5931\u6557",
  112062: "\u7121\u6548\u6D3B\u52D5\u5217\u8868",
  112063: "\u5275\u5EFA\u5408\u4F5C\u4F19\u4F34\u5206\u7D44\u5931\u6557",
  112064: "\u4FEE\u6539\u5408\u4F5C\u4F19\u4F34\u5206\u7D44\u5931\u6557",
  112065: "\u522A\u9664\u5408\u4F5C\u4F19\u4F34\u5206\u7D44\u5931\u6557",
  112066: "\u7121\u6548\u5408\u4F5C\u4F19\u4F34\u5206\u7D44",
  112067: "\u5275\u5EFA\u5408\u4F5C\u4F19\u4F34\u5931\u6557",
  112068: "\u4FEE\u6539\u5408\u4F5C\u4F19\u4F34\u5931\u6557",
  112069: "\u522A\u9664\u5408\u4F5C\u4F19\u4F34\u5931\u6557",
  112070: "\u7121\u6548\u5408\u4F5C\u4F19\u4F34",
  112071: "\u677F\u584A\u6392\u5E8F\u5B57\u6BB5\u7570\u5E38",
  112072: "\u9580\u6236\u540D\u7A31\u91CD\u8907\uFF0C\u8ACB\u66F4\u63DB\u5F8C\u91CD\u8A66",
  112073: "\u9580\u6236\u5275\u5EFA\u5931\u6557",
  112074: "\u4FEE\u6539\u5408\u4F5C\u4F19\u4F34\u5931\u6557",
  112075: "\u9580\u6236\u522A\u9664\u5931\u6557",
  112076: "\u5275\u5EFA\u9580\u6236\u64F4\u5C55\u5931\u6557",
  112077: "\u5275\u5EFA\u9580\u6236\u7D71\u8A08\u64F4\u5C55\u5931\u6557",
  112078: "\u6BCF\u500B\u9580\u6236\u6700\u5C11\u9700\u8981\u5305\u542B\u4E00\u500B\u677F\u584A",
  112079: "\u53EA\u80FD\u6709\u4E00\u500B\u9802\u90E8\u6B04\u677F\u584A",
  112080: "\u53EA\u80FD\u6709\u4E94\u500B\u5716\u7247\u5EE3\u544A\u677F\u584A",
  112081: "\u53EA\u80FD\u6709\u4E94\u500B\u5206\u985E\u5C0E\u822A\u677F\u584A",
  112082: "\u53EA\u80FD\u6709\u4E94\u500B\u5716\u6587\u4ECB\u7D39\u677F\u584A",
  112083: "\u53EA\u80FD\u6709\u4E09\u500B\u8996\u983B\u9326\u96C6\u677F\u584A",
  112084: "\u53EA\u80FD\u6709\u4E09\u500B\u6D3B\u52D5\u5217\u8868\u677F\u584A",
  112085: "\u53EA\u80FD\u6709\u4E00\u500B\u5408\u4F5C\u4F19\u4F34\u677F\u584A",
  112086: "\u53EA\u80FD\u6709\u4E00\u500B\u806F\u7E6B\u6211\u5011\u677F\u584A",
  112087: "\u53EA\u80FD\u6709\u4E00\u500B\u5E95\u90E8\u6B04\u677F\u584A",
  112088: "\u9580\u6236\u5DF2\u4E0A\u67B6\uFF0C\u8ACB\u5148\u4E0B\u67B6\u518D\u522A\u9664",
  112090: "\u63D2\u5165\u79DF\u6236\u914D\u7F6E\u5931\u6557",
  112091: "\u6700\u591A\u5275\u5EFA5\u500B\u9580\u6236\uFF0C\u8ACB\u5148\u5347\u7D1A\u7248\u672C",
  112092: "\u6700\u591A\u5275\u5EFA20\u500B\u9580\u6236",
  112093: "\u5A92\u9AD4\u5EAB\u5206\u8FA8\u7387\u8D85\u51FA\u6700\u5927\u9650\u5236",
  112094: "\u5BA2\u6236\u7DE8\u865F\u4E0D\u80FD\u7232\u7A7A",
  112095: "\u4FEE\u6539\u5BC6\u78BC\u904E\u671F\u8A2D\u7F6E\u7570\u5E38",
  112096: "\u66F4\u65B0\u79DF\u6236\u914D\u7F6E\u5931\u6557",
  112097: "\u57FA\u790E\u7248\u672C\u79DF\u6236\u6B0A\u9650\u4E0D\u8DB3",
  112098: "\u521D\u59CB\u5316\u79DF\u6236\u914D\u7F6E\u5931\u6557\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  112201: "\u521D\u59CB\u5316\u79DF\u6236\u81EA\u5B9A\u7FA9\u767B\u9304\u9801\u914D\u7F6E\u5931\u6557\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  112202: "\u66F4\u65B0\u79DF\u6236\u81EA\u5B9A\u7FA9\u767B\u9304\u9801\u914D\u7F6E\u5931\u6557\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  112203: "\u4E0D\u5B58\u5728\u7684\u79DF\u6236\u81EA\u5B9A\u7FA9\u767B\u9304\u9801\u914D\u7F6E\u5931\u6557",
  112204: "\u96A8\u5E7B\u7A7A\u9593\u670D\u52D9\u5C1A\u672A\u958B\u901A\uFF0C\u8ACB\u806F\u7E6B\u5BA2\u670D",
  112205: "\u96A8\u5E7B\u7A7A\u9593code\u4E0D\u5B58\u5728",
  112206: "\u8ACB\u958B\u555F/\u95DC\u9589\u591A\u91CD\u767B\u5165\u8A8D\u8B49\u958B\u95DC",
  112207: "\u81F3\u5C11\u958B\u555F\u4E00\u7A2E\u8A8D\u8B49\u7BA1\u9053",
  112208: "\u591A\u91CD\u767B\u5165\u8A8D\u8B49\u958B\u95DC\u7684\u53D6\u503C\u7BC4\u570D\u70BA0~1",
  112209: "\u591A\u91CD\u767B\u5165\u8A8D\u8B49\u7BA1\u9053\u7684\u53D6\u503C\u7BC4\u570D\u70BA0~1",
  112210: "\u4E0D\u5B58\u5728\u7684\u79DF\u6236\u914D\u5BD8",
  113e3: "\u5275\u5EFA\u5354\u4F5C\u8005\u5931\u6557",
  113001: "\u4FEE\u6539\u5354\u4F5C\u8005\u5931\u6557",
  113002: "\u522A\u9664\u5354\u4F5C\u8005\u5931\u6557",
  113003: "\u7121\u6548\u7684\u5354\u4F5C\u8005",
  113004: "\u5275\u5EFA\u6578\u91CF\u8D85\u904E\u4E0A\u9650",
  113005: "\u5354\u4F5C\u8005\u540D\u7A31\u5DF2\u5B58\u5728",
  114e3: "\u7121\u6548\u7684\u67E5\u8A62",
  114001: "\u5275\u5EFA\u901A\u77E5\u767C\u9001\u8A18\u9304\u5931\u6557",
  114002: "\u4FEE\u6539\u901A\u77E5\u767C\u9001\u8A18\u9304\u5931\u6557",
  114003: "\u7121\u6548\u7684\u77ED\u4FE1\u6A21\u7248",
  115e3: "\u7121\u6548\u7684\u7522\u54C1\u7248\u672C",
  115001: "\u66F4\u65B0\u7522\u54C1\u7248\u672C\u5931\u6557",
  115002: "\u5275\u5EFA\u7522\u54C1\u7248\u672C\u5931\u6557",
  115003: "\u7121\u6548\u7684\u7522\u54C1\u7248\u672C\u529F\u80FD",
  115004: "\u7248\u672C\u72C0\u614B\u4E0D\u5141\u8A31\u66F4\u6539",
  115005: "\u7121\u6548\u7684\u8CC7\u6E90\u5305",
  115006: "\u5275\u5EFA\u5957\u9910\u5931\u6557",
  115007: "\u5957\u9910\u5305\u5167\u7684\u8CC7\u6E90\u5305\u548C\u7248\u672C\u8A66\u7528\u985E\u578B\u8207\u5957\u9910\u5305\u4E0D\u4E00\u81F4\uFF01",
  115008: "\u5957\u9910\u5305\u5167\u7684\u8CC7\u6E90\u5305\u548C\u7248\u672C\u6709\u6548\u671F\u8207\u5957\u9910\u5305\u4E0D\u4E00\u81F4\uFF01",
  115009: "\u66F4\u65B0\u5957\u9910\u5931\u6557",
  115010: "\u7121\u6548\u7684\u5957\u9910",
  115011: "\u5957\u9910\u72C0\u614B\u4E0D\u5141\u8A31\u66F4\u6539",
  115012: "\u7121\u6548\u7684\u7522\u54C1\u7248\u672C\u64CD\u4F5C\u8A18\u9304",
  115013: "\u7522\u54C1\u7248\u672C\u4E0D\u5141\u8A31\u4FEE\u6539",
  115014: "\u8A66\u7528\u7248\u50F9\u683C\u9700\u72320",
  115015: "\u8CC7\u6E90\u5305\u7DE8\u865F\u5DF2\u5B58\u5728",
  115016: "\u7121\u6548\u7684\u8CC7\u6E90",
  116001: "\u7121\u6548\u7684\u5BA2\u6236\u7AEF\u7248\u672C",
  116002: "\u5275\u5EFA\u5BA2\u6236\u7AEF\u7248\u672C\u5931\u6557",
  116003: "\u4FEE\u6539\u5BA2\u6236\u7AEF\u7248\u672C\u5931\u6557",
  116004: "\u522A\u9664\u5BA2\u6236\u7AEF\u7248\u672C\u5931\u6557",
  116005: "\u69CB\u5EFA\u865F\u4E0D\u5141\u8A31\u91CD\u8907",
  117050: "\u5275\u5EFA\u623F\u9593\u7570\u5E38",
  117051: "\u4FEE\u6539\u623F\u9593\u7570\u5E38",
  117052: "\u522A\u9664\u623F\u9593\u7570\u5E38",
  117053: "\u7121\u6548\u623F\u9593",
  117054: "\u7576\u524D\u76F4\u64AD\u8655\u65BC\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u5207\u63DB",
  117055: "\u623F\u9593\u4E0D\u5728\u76F4\u64AD",
  117056: "\u7576\u524D\u76F4\u64AD\u9593\u8655\u65BC\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u522A\u9664",
  117057: "\u4FEE\u6539\u76F4\u64AD\u72C0\u614B\u5931\u6557",
  117058: "\u8207\u7576\u524D\u76F4\u64AD\u65B9\u5F0F\u4E0D\u7B26",
  117059: "\u8ABF\u7528\u9A30\u8A0A\u96F2\u7D50\u675F\u9304\u88FD\u7570\u5E38",
  117060: "\u6DF7\u6D41\u4F48\u5C40\u7570\u5E38",
  117061: "\u96F2\u76F4\u64AD\u6DF7\u6D41\u4F48\u5C40\u7570\u5E38",
  117062: "\u623F\u9593\u914D\u7F6E\u7232\u4E0D\u4F7F\u7528\u9023\u9EA5",
  117063: "\u4E0A\u5834\u76F4\u64AD\u6B63\u5728\u7D71\u8A08\u7D50\u679C\uFF0C\u8ACB\u7A0D\u5F8C\u958B\u64AD",
  117064: "\u7576\u524D\u76F4\u64AD\u9593\u8655\u65BC\u5B9A\u6642\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u522A\u9664",
  117065: "\u7576\u524D\u76F4\u64AD\u8655\u65BC\u5B9A\u6642\u4E2D\uFF0C\u4E0D\u652F\u6301\u5207\u63DB",
  117066: "\u7121\u6548\u623F\u9593\u72C0\u614B",
  117067: "\u6D3B\u52D5\u53C3\u6578\u4E0D\u80FD\u7232\u7A7A",
  117068: "\u6D3B\u52D5\u5275\u5EFA\u76F4\u64AD\u623F\u9593\u6700\u592750\u500B",
  117069: "\u6D3B\u52D5\u5275\u5EFA\u6703\u8B70\u623F\u9593\u6700\u592750\u500B",
  117070: "\u7121\u6548\u7684\u623F\u9593\u6A21\u5F0F",
  117080: "\u7121\u6548\u6D41",
  117081: "\u66AB\u7121\u76F4\u64AD\u6D41\uFF0C\u8ACB\u63A8\u6D41\u5F8C\u518D\u958B\u59CB\u76F4\u64AD",
  117120: "\u7121\u6548\u623F\u9593\u914D\u7F6E",
  117121: "\u5275\u5EFA\u623F\u9593\u914D\u7F6E\u5931\u6557",
  117122: "\u4FEE\u6539\u623F\u9593\u914D\u7F6E\u5931\u6557",
  117160: "\u7121\u6548\u5206\u985E",
  117161: "\u5206\u985E\u540D\u7A31\u4E0D\u53EF\u91CD\u8907",
  117162: "\u5206\u985E\u5C64\u6578\u8D85\u904E\u6700\u5927\u9650\u5236",
  117163: "\u4E00\u7D1A\u5206\u985E\u500B\u6578\u8D85\u904E\u6700\u5927\u9650\u5236",
  117164: "\u5B50\u7D1A\u5206\u985E\u500B\u6578\u8D85\u904E\u6700\u5927\u9650\u5236",
  117165: "\u4FEE\u6539\u5206\u985E\u662F\u5426\u6709\u5B50\u7BC0\u9EDE\u5931\u6557",
  117166: "\u4FEE\u6539\u5206\u985E\u5931\u6557",
  117167: "\u522A\u9664\u5206\u985E\u5931\u6557",
  117168: "\u5DF2\u662F\u7B2C\u4E00\u4F4D\uFF0C\u4E0D\u80FD\u518D\u4E0A\u79FB",
  117169: "\u5DF2\u662F\u6700\u5F8C\u4E00\u4F4D\uFF0C\u4E0D\u80FD\u518D\u4E0B\u79FB",
  117170: "\u5206\u985E\u4E0A\u79FB\u5931\u6557",
  117171: "\u5206\u985E\u4E0B\u79FB\u5931\u6557",
  117172: "\u4FEE\u6539\u623F\u9593\u6A19\u7C64\u5931\u6557",
  117200: "\u62C9\u6D41\u76F4\u64AD\u6B63\u5728\u76F4\u64AD\u4E2D",
  117201: "\u62C9\u6D41\u76F4\u64AD\u672A\u5728\u76F4\u64AD",
  117202: "\u5275\u5EFA\u62C9\u6D41\u76F4\u64AD\u5931\u6557",
  117203: "\u4FEE\u6539\u62C9\u6D41\u76F4\u64AD\u5931\u6557",
  117210: "\u7121\u6548\u5217\u8868",
  117211: "\u5275\u5EFA\u5217\u8868\u5931\u6557",
  117212: "\u4FEE\u6539\u5217\u8868\u5931\u6557",
  117213: "\u522A\u9664\u5217\u8868\u5931\u6557",
  117214: "\u5217\u8868\u6B63\u5728\u76F4\u64AD\u4E2D",
  117215: "\u5217\u8868\u672A\u5728\u76F4\u64AD",
  117216: "\u5217\u8868\u4E2D\u7121\u8996\u983B",
  117217: "\u5DF2\u6709\u5217\u8868\u8A2D\u7F6E\u5B9A\u6642\u76F4\u64AD\uFF0C\u8ACB\u5148\u53D6\u6D88\u5B9A\u6642\u76F4\u64AD",
  117218: "\u5217\u8868\u672A\u8A2D\u7F6E\u5B9A\u6642\u76F4\u64AD",
  117219: "\u4FEE\u6539\u5FAA\u74B0\u64AD\u653E\u72C0\u614B\u5931\u6557",
  117220: "\u5B9A\u6642\u76F4\u64AD\u6642\u9593\u61C9\u5927\u65BC\u7576\u524D\u6642\u9593",
  117221: "\u5B9A\u6642\u76F4\u64AD\u6642\u9593\u5DF2\u4FEE\u6539",
  117222: "\u5B9A\u6642\u76F4\u64AD\u6642\u9593\u672A\u4FEE\u6539",
  117230: "\u7121\u6548\u7BC0\u76EE",
  117231: "\u5275\u5EFA\u7BC0\u76EE\u5931\u6557",
  117232: "\u8996\u983B\u5DF2\u5728\u76F4\u64AD\u4E2D",
  117233: "\u8996\u983B\u672A\u5728\u76F4\u64AD",
  117240: "\u5275\u5EFA\u76F4\u64AD\u4EFB\u52D9\u5931\u6557",
  117241: "\u9801\u9762\u672A\u521D\u59CB\u5316\u5B8C\u7562,\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  117242: "\u958B\u59CB\u76F4\u64AD\u5931\u6557",
  117243: "\u64AD\u55AE\u4E2D\u7684\u756B\u9762\u7121\u8996\u983B\u6D41\uFF0C\u8ACB\u6AA2\u67E5\u5F8C\u518D\u4F7F\u7528",
  117272: "\u7121\u6548\u7684\u76F4\u64AD\u4FE1\u606F",
  117273: "\u7121\u6548\u5834\u6B21",
  117274: "\u5275\u5EFA\u5834\u6B21\u5931\u6557",
  117275: "\u4FEE\u6539\u5834\u6B21\u5931\u6557",
  117300: "\u958B\u5553\u767D\u677F\u63A8\u6D41\u53C3\u6578\u7121\u6548",
  117301: "\u9A30\u8A0A\u96F2\u958B\u5553\u767D\u677F\u63A8\u6D41\u63A5\u53E3\u7570\u5E38",
  117302: "\u7121\u6548\u767D\u677F\u63A8\u6D41\u4EFB\u52D9",
  117303: "\u8ABF\u7528\u9A30\u8A0A\u96F2\u95DC\u9589\u767D\u677F\u63A8\u6D41\u63A5\u53E3\u7570\u5E38",
  117304: "\u4FEE\u6539\u767D\u677F\u4EFB\u52D9\u7570\u5E38",
  117305: "\u7121\u623F\u9593\u4FE1\u606F",
  117306: "\u7576\u524D\u623F\u9593\u6C92\u6709\u958B\u5553\u767D\u677F\u63A8\u6D41",
  117307: "\u7576\u524D\u623F\u9593\u5DF2\u7D93\u958B\u5553\u767D\u677F\u63A8\u6D41",
  117308: "\u7121\u6548\u7684\u623F\u9593\u6578\u64DA",
  117309: "\u7576\u524D\u623F\u9593\u6C92\u6709\u627E\u5230\u6D41",
  117310: "\u7121\u6548\u7684\u6587\u6A94\u6216\u8DEF\u5F91",
  117311: "\u6587\u6A94\u4E0A\u50B3\u5931\u6557",
  117312: "\u4E0A\u50B3\u6587\u6A94\u9577\u5EA6\u8D85\u51FA\u9650\u5236",
  117313: "\u4E0A\u50B3\u683C\u5F0F\u932F\u8AA4",
  117314: "\u6587\u6A94\u8A18\u9304\u4FEE\u6539\u5931\u6557",
  117315: "\u5275\u5EFA\u6587\u6A94\u8A18\u9304\u7570\u5E38",
  117316: "\u7121\u6548\u7684\u6587\u6A94\u8A18\u9304",
  117317: "\u7576\u524D\u72C0\u614B\u4E0D\u80FD\u522A\u9664",
  117318: "\u522A\u9664\u6587\u6A94\u8A18\u9304\u7570\u5E38",
  117319: "\u540C\u6642\u53EA\u80FD\u4F7F\u7528\u4E00\u500B\u6587\u6A94",
  117320: "\u91CD\u65B0\u8F49\u78BC\u7570\u5E38",
  117321: "\u7576\u524D\u6587\u6A94\u672A\u8F49\u78BC\u6210\u529F",
  117322: "\u7372\u53D6\u7DB2\u7D61\u8CC7\u6E90\u7570\u5E38",
  117323: "\u5275\u5EFA\u8F49\u78BC\u4EFB\u52D9\u7570\u5E38",
  117324: "\u804A\u5929\u6AA2\u67E5\u529F\u80FD\u958B\u5553\u4F9D\u8CF4\u65BC\u804A\u5929\u529F\u80FD\u958B\u5553",
  117325: "\u5F48\u5E55\u5BE9\u8988\u529F\u80FD\u958B\u5553\u4F9D\u8CF4\u65BC\u5F48\u5E55\u529F\u80FD\u958B\u5553",
  117326: "\u89C0\u770B\u9801\u672A\u5141\u8A31\u5C55\u793A\u76F4\u64AD\u756B\u9762",
  117327: "\u7576\u524D\u623F\u9593\u5DF2\u7D93\u662F\u4E3B\u6703\u5834",
  117328: "\u4E3B\u6703\u5834\u4E0D\u652F\u6301\u522A\u9664",
  117329: "\u623F\u9593\u9EDE\u8D0A\u6578\u64DA\u7570\u5E38",
  117330: "\u6C92\u6709\u4E3B\u6703\u5834\uFF0C\u8ACB\u5148\u5275\u5EFA\u4E3B\u6703\u5834",
  117331: "\u623F\u9593\u4E0D\u5B58\u5728\uFF0C\u8ACB\u806F\u7E6B\u4E3B\u8FA6\u65B9",
  117332: "\u76F4\u64AD\u5834\u666F\u4E0D\u80FD\u4FEE\u6539",
  117333: "\u4E0D\u53EF\u66F4\u6539\u76F4\u64AD\u5EF6\u6642",
  117334: "\u623F\u9593\u6A21\u5F0F\u932F\u8AA4",
  117335: "\u5275\u5EFA\u56DE\u8ABF\u6A21\u677F\u932F\u8AA4",
  117336: "\u4FEE\u6539\u56DE\u8ABF\u6A21\u677F\u932F\u8AA4",
  117340: "\u7121\u6548\u7684\u5716\u6587\u76F4\u64AD",
  117341: "\u5275\u5EFA\u5716\u6587\u76F4\u64AD\u7570\u5E38",
  117342: "\u7DE8\u8F2F\u5716\u6587\u76F4\u64AD\u7570\u5E38",
  117343: "\u522A\u9664\u5716\u6587\u76F4\u64AD\u7570\u5E38",
  117344: "\u5716\u6587\u76F4\u64AD\u5DF2\u958B\u5553\uFF0C\u7121\u9700\u91CD\u8907\u958B\u5553",
  117345: "\u5716\u6587\u76F4\u64AD\u5DF2\u95DC\u9589\uFF0C\u7121\u9700\u91CD\u8907\u95DC\u9589",
  117346: "liveDelay \u7684\u53D6\u503C\u7BC4\u570D\u662F1-2",
  117347: "\u76F4\u64AD\u958B\u59CB\u6642\u9593\u65E9\u65BC\u7576\u524D\u6642\u9593",
  117348: "\u7D50\u675F\u6642\u9593\u4E0D\u5F97\u65E9\u65BC\u958B\u59CB\u6642\u9593",
  117349: "\u958B\u59CB\u6642\u9593\u6216\u7D50\u675F\u6642\u9593\u683C\u5F0F\u932F\u8AA4",
  117350: "\u7C3D\u5230\u5DF2\u958B\u5553\uFF0C\u7121\u9700\u91CD\u8907\u958B\u5553",
  117351: "\u7C3D\u5230\u5DF2\u95DC\u9589\uFF0C\u7121\u9700\u91CD\u8907\u95DC\u9589",
  117352: "\u7C3D\u5230\u958B\u5553\u5931\u6557",
  117353: "\u7C3D\u5230\u95DC\u9589\u5931\u6557",
  117354: "\u8A71\u984C\u4E92\u52D5\u5DF2\u958B\u5553\uFF0C\u7121\u9700\u91CD\u8907\u958B\u5553",
  117355: "\u8A71\u984C\u4E92\u52D5\u5DF2\u95DC\u9589\uFF0C\u7121\u9700\u91CD\u8907\u95DC\u9589",
  117356: "\u8A71\u984C\u4E92\u52D5\u958B\u5553\u5931\u6557",
  117357: "\u8A71\u984C\u4E92\u52D5\u95DC\u9589\u5931\u6557",
  117358: "\u8ABF\u7528\u9A30\u8A0A\u96F2\u958B\u5553\u65C1\u8DEF\u63A8\u6D41\u63A5\u53E3\u7570\u5E38",
  117359: "\u8ABF\u7528\u9A30\u8A0A\u96F2\u95DC\u9589\u65C1\u8DEF\u63A8\u6D41\u63A5\u53E3\u7570\u5E38",
  117360: "\u7121\u6548\u65C1\u8DEF\u63A8\u6D41\u4EFB\u52D9",
  117361: "\u8ABF\u7528\u9A30\u8A0A\u96F2\u66F4\u65B0\u65C1\u8DEF\u63A8\u6D41\u63A5\u53E3\u7570\u5E38",
  117362: "\u76F4\u64AD\u6B63\u5728\u958B\u5553\u4E2D, \u8ACB\u7A0D\u5F8C\u518D\u8A66",
  117363: "\u7576\u524D\u76F4\u64AD\u8655\u65BC\u6E96\u5099\u4E2D\uFF0C\u4E0D\u652F\u6301\u5207\u63DB",
  117364: "\u62C9\u6D41\u76F4\u64AD\u7121\u6CD5\u5275\u5EFA0\u5EF6\u6642",
  117996: "\u963F\u91CC\u96F2\u6587\u6A94\u4E0A\u50B3\uFF1A\u6587\u4EF6\u5927\u5C0F\u7570\u5E38",
  117997: "\u751F\u6210ID\u5C0F\u65BC0",
  117998: "\u66AB\u7121",
  118001: "\u5275\u5EFA\u6D41\u76E3\u63A7\u6578\u64DA\u7570\u5E38",
  118002: "\u4FEE\u6539\u623F\u9593\u7570\u5E38",
  118003: "\u522A\u9664\u623F\u9593\u7570\u5E38",
  120001: "\u7121\u6548\u623F\u9593",
  120002: "\u5275\u5EFA\u591A\u5217\u8868\u7570\u5E38",
  120003: "\u7121\u6548\u62C9\u6D41\u5217\u8868",
  120004: "\u4FEE\u6539\u62C9\u6D41\u5217\u8868\u7570\u5E38",
  120005: "\u7576\u524D\u623F\u9593\u76F4\u64AD\u65B9\u5F0F\u7570\u5E38",
  120006: "\u623F\u9593\u72C0\u614B\uFF0C\u5834\u666F\u9A57\u8B49\u672A\u901A\u904E",
  120007: "\u7576\u524D\u623F\u9593\u72C0\u614B\u4E0D\u80FD\u53D6\u6D88\u5B9A\u6642",
  120008: "\u7576\u524D\u623F\u9593\u5B58\u5728\u5B9A\u6642\u5217\u8868",
  120009: "\u91CD\u8907\u958B\u5553\u5B9A\u6642",
  120010: "\u5275\u5EFA\u62C9\u6D41\u8A73\u60C5\u7570\u5E38",
  120011: "\u4FEE\u6539\u62C9\u6D41\u4EFB\u52D9\u7570\u5E38",
  120012: "\u522A\u9664\u62C9\u6D41\u4EFB\u52D9\u7570\u5E38",
  120013: "\u79FB\u52D5ID\u7232\u7A7A",
  120014: "front ID\u7232\u7A7A",
  120015: "\u5217\u8868\u4EFB\u52D9\u6392\u5E8F\u7570\u5E38",
  120016: "\u62C9\u6D41\u76F4\u64AD\u4E0D\u652F\u6301\u6279\u91CF\u65B0\u589E",
  120017: "\u6279\u91CF\u65B0\u589E\u8D85\u51FA\u6700\u5927\u9650\u5236",
  120018: "\u66AB\u7121\u53EF\u7528\u62C9\u6D41\u6E90",
  120019: "\u7576\u524D\u623F\u9593\u72C0\u614B\u4E0D\u80FD\u958B\u59CB\u76F4\u64AD",
  120020: "\u7576\u524D\u623F\u9593\u76F4\u64AD\u5834\u666F\u4E0D\u6B63\u78BA",
  120021: "\u958B\u59CB\u62C9\u6D41\u76F4\u64AD\u7570\u5E38",
  120022: "\u7372\u53D6\u62C9\u6D41\u4EFB\u52D9\u5217\u8868\u7570\u5E38",
  120023: "\u7576\u524D\u623F\u9593\u72C0\u614B\u4E0D\u80FD\u7D50\u675F\u76F4\u64AD",
  120024: "\u7D50\u675F\u62C9\u6D41\u76F4\u64AD\u7570\u5E38",
  120025: "\u67E5\u8A62\u5A92\u9AD4\u5EAB\u7570\u5E38",
  120026: "\u5A92\u9AD4\u5EAB\u5206\u8FA8\u7387\u8D85\u51FA\u6700\u5927\u9650\u5236",
  120027: "\u62C9\u6D41\u6E90\u7121\u6548",
  120028: "\u62C9\u6D41\u6E90\u7121\u6548",
  120029: "\u8655\u7406\u6C92\u6709\u6536\u5230\u65B7\u6D41\u56DE\u8ABF\u7570\u5E38",
  120030: "\u7121\u6548\u62C9\u6D41\u5730\u5740",
  120031: "\u7121\u6548\u5B9A\u6642\u6642\u9593",
  120032: "\u8D85\u51FA\u6700\u5927\u64AD\u653E\u6642\u9577\u9650\u5236 \u9650\u5236\u72325\u5929",
  120033: "\u958B\u59CB/\u7D50\u675F\u6642\u9593\u7570\u5E38",
  120034: "\u958B\u59CB\u6642\u9593\u8981\u65E9\u8207\u7D50\u675F\u6642\u9593",
  120035: "\u9A30\u8A0A\u96F2\u56DE\u8ABF\u4EFB\u52D9id\u548C\u7576\u524D\u4EFB\u52D9id\u4E0D\u5339\u914D",
  120036: "\u7121\u6548\u7684\u623F\u9593\u985E\u578B",
  120037: "\u64AD\u653E\u6642\u9577\u7570\u5E38",
  120038: "\u63D0\u4EA4\u5A92\u9AD4\u5EAB\u6587\u4EF6\u91CD\u8907",
  120039: "\u8996\u983B\u5217\u8868\u5B58\u5728\u6B63\u5728\u6AA2\u6E2C\u4E2D\u7684\u8996\u983B",
  120040: "\u8996\u983B\u5217\u8868\u5B58\u5728\u672A\u6AA2\u6E2C\u6210\u529F\u7684\u8996\u983B",
  120041: "\u7D50\u675F\u6642\u9593\u9700\u6BD4\u958B\u59CB\u6642\u9593\u665A10\u5206\u9418\u4EE5\u4E0A",
  120042: "\u62C9\u6D41\u4EFB\u52D9\u4E0D\u5B58\u5728",
  120043: "\u8655\u7406\u5217\u8868\u76F4\u64AD\u56DE\u8ABF\uFF0C\u4FEE\u6539\u6578\u64DA\u5931\u6557",
  120044: "\u6DFB\u52A0\u8996\u983B\u7570\u5E38\uFF0C\u8996\u983B\u6642\u9577\u7570\u5E38",
  120045: "\u7576\u524D\u623F\u9593\u76F4\u64AD\u65B9\u5F0F\u4E0D\u6B63\u78BA",
  121e3: "\u7121\u6548\u7684\u6587\u4EF6\u985E\u578B",
  121001: "\u9ED8\u8A8D\u8A5E\u5EAB\u6578\u64DA\u7232\u7A7A",
  121002: "\u4FEE\u6539\u9ED8\u8A8D\u8A5E\u5EAB\u5931\u6557",
  121003: "\u81EA\u5EFA\u654F\u611F\u8A5E\u91CD\u8907",
  121004: "\u5275\u5EFA\u654F\u611F\u8A5E\u5931\u6557",
  121005: "\u522A\u9664\u654F\u611F\u8A5E\u5931\u6557",
  121006: "\u4FEE\u6539\u654F\u611F\u8A5E\u5931\u6557",
  121007: "\u7121\u6548\u7684\u654F\u611F\u8A5E",
  121008: "\u7121\u6CD5\u522A\u9664\u975E\u81EA\u5EFA\u654F\u611F\u8A5E\u985E\u578B",
  121009: "\u6587\u4EF6\u5927\u5C0F\u8D85\u51FA\u9650\u5236",
  121010: "\u6587\u4EF6\u6578\u64DA\u8D85\u51FA5000\u689D",
  121011: "\u6587\u4EF6\u89E3\u6790\u5931\u6557",
  121012: "\u81EA\u5EFA\u654F\u611F\u8A5E\u7E3D\u6578\u8D85\u51FA\u9650\u5236",
  121013: "\u7121\u6548\u7684\u79DF\u6236",
  121014: "\u79DF\u6236\u53C3\u6578\u7F3A\u5931",
  121015: "\u5B50\u7DDA\u7A0B\u5275\u5EFA\u79DF\u6236\u4F01\u696D\u654F\u611F\u8A5E\u5931\u6557",
  121016: "\u5B50\u7DDA\u7A0B\u5275\u5EFA\u9ED8\u8A8D\u654F\u611F\u8A5E\u5931\u6557",
  121017: "\u65B0\u66B1\u7A31\u5305\u542B\u9055\u898F\u5167\u5BB9,\u8ACB\u4FEE\u6539\u5F8C\u91CD\u8A66",
  121018: "\u60A8\u767C\u9001\u7684\u5167\u5BB9\u5B58\u5728\u9055\u898F\u5167\u5BB9,\u8ACB\u4FEE\u6539\u5F8C\u91CD\u8A66",
  121019: '\u60A8\u767C\u9001\u7684\u6587\u5B57\u5305\u542B"%s"\u9055\u898F\u5167\u5BB9',
  122001: "\u7121\u6548\u7684\u4EBA\u54E1\u4FE1\u606F",
  122002: "\u5275\u5EFA\u53C3\u8207\u8005\u5931\u6557",
  122003: "\u4FEE\u6539\u53C3\u8207\u8005\u5931\u6557",
  122004: "\u79FB\u9664\u53C3\u8207\u8005\u5931\u6557",
  122005: "\u624B\u6A5F\u865F\u672A\u5831\u540D\uFF0C\u8ACB\u524D\u5F80\u5831\u540D",
  122006: "\u60A8\u5DF2\u88AB\u7981\u6B62\u53C3\u8207\u672C\u6D3B\u52D5",
  122007: "\u8A72\u624B\u6A5F\u865F\u5DF2\u5831\u540D\uFF0C\u8ACB\u52FF\u91CD\u8907\u5831\u540D",
  122008: "\u624B\u6A5F\u3001\u90F5\u7BB1\u81F3\u5C11\u586B\u5BEB\u4E00\u9805",
  122009: "\u8ACB\u9078\u64C7\u4E00\u5F35\u9580\u7968",
  122010: "\u8A72\u4EBA\u54E1\u5DF2\u5B58\u5728",
  122011: "\u672A\u5831\u540D\u8A72\u6D3B\u52D5",
  122012: "\u522A\u9664\u5609\u8CD3\u5931\u6557",
  122013: "\u8ACB\u52FF\u91CD\u8907\u5831\u540D",
  122014: "\u6578\u91CF\u8D85\u904E500\u689D\uFF0C\u8ACB\u5206\u6279\u6B21\u4E0A\u50B3",
  122015: "\u6587\u6A94\u4E0D\u7B26\u5408\u5C0E\u5165\u898F\u7BC4\uFF0C\u8ACB\u6309\u7167EXCEL\u6587\u6A94\u6A21\u7248\u898F\u7BC4\u64CD\u4F5C",
  122016: "\u89C0\u8846\u5BE9\u8988\u72C0\u614B\u7570\u5E38",
  122017: "\u5831\u540D\u767B\u9304/\u5916\u90E8\u6388\u6B0A\u89C0\u8846\u4E0D\u652F\u6301\u522A\u9664",
  123001: "\u7121\u6548\u7684\u623F\u9593\u6388\u6B0A\u89C0\u770B\u914D\u7F6E",
  123002: "\u4FEE\u6539\u623F\u9593\u6388\u6B0A\u89C0\u770B\u914D\u7F6E\u5931\u6557",
  123003: "\u6E05\u7A7A\u624B\u6A5F\u767D\u540D\u55AE\u5931\u6557",
  123004: "\u89C0\u8846\u767D\u540D\u55AE\u4E2D\u7528\u6236\u540D\u91CD\u8907",
  123005: "\u62C9\u53D6\u767D\u540D\u55AEexcel\u5931\u6557",
  123006: "\u7528\u6236\u540D\u4E0D\u80FD\u7232\u7A7A",
  123007: "tenantId\u53C3\u6578\u7F3A\u5931",
  123008: "roomId\u53C3\u6578\u7F3A\u5931",
  123009: "\u96F6\u5EF6\u6642/\u5168\u7403\u52A0\u901F\u623F\u9593\u7121\u6CD5\u958B\u5553\u591A\u7DDA\u8DEF",
  124001: "\u7121\u6548\u7684\u9023\u9EA5\u914D\u7F6E",
  124002: "\u5275\u5EFA\u9023\u9EA5\u914D\u7F6E\u5931\u6557",
  124003: "\u751F\u6210\u9023\u9EA5\u914D\u7F6EID\u5931\u6557",
  124004: "\u9023\u9EA5\u7E3D\u958B\u95DC\u5DF2\u95DC\u9589\uFF0C\u4E0D\u5141\u8A31\u64CD\u4F5C",
  124005: "\u5609\u8CD3\u9023\u9EA5\u958B\u95DC\u5DF2\u95DC\u9589\uFF0C\u4E0D\u5141\u8A31\u64CD\u4F5C",
  124006: "\u5609\u8CD3\u9023\u9EA5\u6A21\u5F0F\u5DF2\u7F6E\u7232\u7533\u8ACB\u6A21\u5F0F",
  124007: "\u89C0\u8846\u7533\u8ACB\u9023\u9EA5\u958B\u95DC\u5DF2\u95DC\u9589\uFF0C\u4E0D\u5141\u8A31\u64CD\u4F5C",
  124008: "\u52A9\u7406\u4E0D\u80FD\u9023\u9EA5",
  124009: "\u4FEE\u6539\u53C3\u6578\u914D\u7F6E\u5931\u6557",
  124010: "\u50C5\u4E3B\u8B1B\u4EBA\u53EF\u4EE5\u64CD\u4F5C\u5171\u4EAB\u5C4F\u5E55",
  124011: "\u8ACB\u52FF\u91CD\u8907\u64CD\u4F5C\u5171\u4EAB\u5C4F\u5E55",
  124012: "\u7528\u6236\u8F38\u51FA\u72C0\u614B\u5DF2\u662F\u53D6\u6D88\u8F38\u51FA\u6216\u8F38\u51FA",
  124013: "\u5275\u5EFA\u9023\u9EA5\u7528\u6236\u5931\u6557",
  124014: "\u4FEE\u6539\u9023\u9EA5\u7528\u6236\u5931\u6557",
  124015: "\u7528\u6236\u5DF2\u662F\u4E3B\u8B1B\u4EBA",
  124016: "\u64CD\u4F5C\u4EBA\u975E\u4E3B\u6301\u4EBA",
  124017: "\u539F\u4E3B\u8B1B\u4EBA\u4E0D\u5B58\u5728",
  124018: "\u7528\u6236\u5DF2\u5728\u9023\u9EA5\u72C0\u614B",
  124019: "\u4E0D\u80FD\u8A2D\u7F6E\u89C0\u8846\u7232\u4E3B\u8B1B\u4EBA",
  124020: "\u7528\u6236\u5DF2\u5728\u9023\u9EA5\u72C0\u614B",
  124021: "\u4FEE\u6539\u9023\u9EA5\u914D\u7F6E\u5931\u6557",
  124022: "\u7121\u6548\u7684\u9023\u9EA5\u7528\u6236",
  124023: "\u7528\u6236\u672A\u5728\u9023\u9EA5\u72C0\u614B",
  124030: "\u5275\u5EFA\u9023\u9EA5\u64CD\u4F5C\u8A18\u9304\u5931\u6557",
  124031: "\u5275\u5EFA\u6DF7\u6D41\u8A18\u9304\u5931\u6557",
  124032: "\u7121\u6548\u7684\u6D3B\u52D5\u9304\u88FD",
  124033: "\u5275\u5EFA\u6D3B\u52D5\u9304\u88FD\u5931\u6557",
  124034: "\u4FEE\u6539\u6D3B\u52D5\u9304\u88FD\u5931\u6557",
  124035: "\u67E5\u8A62\u67D0\u5929\u5834\u6B21\u6578\u64DA\u53C3\u6578\u7232\u7A7A",
  124040: "\u76F4\u64AD\u4E2D\u4E0D\u80FD\u4FEE\u6539\u81EA\u52D5\u9304\u88FD\u958B\u95DC",
  124041: "\u4FEE\u6539\u81EA\u52D5\u9304\u88FD\u5931\u6557",
  124050: "\u7121\u6548\u7684\u9023\u9EA5\u8ACB\u6C42\u8A18\u9304",
  124051: "\u5275\u5EFA\u9023\u9EA5\u8ACB\u6C42\u8A18\u9304\u5931\u6557",
  124052: "\u4FEE\u6539\u9023\u9EA5\u8ACB\u6C42\u8A18\u9304\u5931\u6557",
  124053: "\u4E3B\u6301\u4EBA\u672A\u9023\u9EA5",
  124054: "\u9023\u9EA5\u8ACB\u6C42\u5DF2\u8655\u7406",
  124055: "\u7528\u6236\u8207\u9023\u9EA5\u8ACB\u6C42\u7528\u6236\u4E0D\u4E00\u81F4",
  124056: "\u9023\u9EA5\u4EBA\u6578\u5DF2\u6EFF",
  124057: "\u9023\u9EA5\u6A21\u5F0F\u5DF2\u7F6E\u7232\u7533\u8ACB\u6A21\u5F0F",
  124058: "linkRequestId \u662F\u5FC5\u586B\u9805",
  124059: "\u9023\u9EA5\u8ACB\u6C42\u672A\u540C\u610F",
  124060: "\u7576\u524D\u5B58\u5728\u9023\u9EA5\u7528\u6236\uFF0C\u4E0D\u5141\u8A31\u95DC\u9589",
  124061: "\u7576\u524D\u5B58\u5728\u9023\u9EA5\u7533\u8ACB/\u9080\u8ACB\uFF0C\u4E0D\u5141\u8A31\u95DC\u9589",
  124062: "\u7528\u6236\u4E0D\u5B58\u5728",
  124065: "\u985E\u578B\u8207\u9023\u9EA5\u8ACB\u6C42\u985E\u578B\u4E0D\u4E00\u81F4",
  124067: "\u50C5\u5609\u8CD3\u8207\u5177\u540D\u89C0\u8846\u53EF\u4EE5\u9023\u9EA5\u7533\u8ACB",
  124068: "\u5DF2\u767C\u8D77\u9023\u9EA5\u7533\u8ACB\u6216\u5DF2\u9023\u9EA5",
  124069: "\u5DF2\u5B58\u5728\u9023\u9EA5\u8ACB\u6C42\u6216\u5DF2\u9023\u9EA5",
  124070: "\u5609\u8CD3\u672A\u4E0A\u7DDA",
  124071: "\u50C5\u53EF\u4EE5\u5C0D\u5609\u8CD3\u9023\u9EA5\u9080\u8ACB",
  124072: "\u7576\u524D\u4EBA\u6578\u5DF2\u6EFF\uFF0C\u8ACB\u7A0D\u5019\u518D\u8A66",
  124073: "\u9023\u9EA5\u7533\u8ACB\u8D85\u6642\uFF0C\u8ACB\u91CD\u65B0\u7533\u8ACB",
  124074: "\u9023\u9EA5\u8ACB\u6C42\u7D50\u679C\u932F\u8AA4\uFF0C\u4E0D\u80FD\u7528\u65BC\u9023\u9EA5",
  124075: "\u8ACB\u52FF\u983B\u7E41\u7533\u8ACB\u9023\u9EA5",
  124076: "\u6DF7\u6D41\u5931\u6557\uFF0C\u9A30\u8A0A\u96F2\u623F\u9593\u4E0D\u5B58\u5728",
  124077: "\u6DF7\u6D41\u5931\u6557",
  124078: "\u50C5\u4E3B\u6301\u4EBA\u53EF\u4EE5\u5168\u9AD4\u975C\u97F3",
  124079: "\u9023\u9EA5\u8ACB\u6C42\u6D88\u606F\u985E\u578B\u672A\u8A2D\u7F6E",
  124080: "\u9023\u9EA5\u72C0\u614B\u672A\u8A2D\u7F6E",
  124081: "\u5275\u5EFA\u9023\u9EA5\u8F38\u51FA\u8A18\u9304\u5931\u6557",
  124082: "\u4FEE\u6539\u9023\u9EA5\u8F38\u51FA\u8A18\u9304\u5931\u6557",
  124083: "\u50C5\u4E3B\u8B1B\u4EBA\u80FD\u8A2D\u7F6E\u4F48\u5C40",
  124084: "\u7121\u6548\u7684\u9023\u9EA5\u64CD\u4F5C\u8A18\u9304",
  124085: "\u5275\u5EFA\u9023\u9EA5\u64CD\u4F5C\u8A18\u9304\u5931\u6557",
  124086: "\u4FEE\u6539\u9023\u9EA5\u64CD\u4F5C\u8A18\u9304\u5931\u6557",
  124087: "\u8ACB\u52FF\u983B\u7E41\u5C0D\u8A72\u7528\u6236\u64CD\u4F5C",
  124088: "\u8A72\u64CD\u4F5C\u5DF2\u904E\u671F",
  124089: "\u7528\u6236\u8207\u9023\u9EA5\u8ACB\u6C42\u7528\u6236\u4E0D\u4E00\u81F4",
  124090: "\u5171\u4EAB\u5C4F\u5E55\u5931\u6557",
  124091: "\u7576\u524D\u9023\u9EA5\u5DF2\u88AB\u639B\u65B7",
  124092: "\u7576\u524D\u6B63\u5728\u9023\u9EA5\u4E2D\uFF0C\u4E0D\u5141\u8A31\u5207\u63DB\u8D85\u6E05\u9023\u9EA5\u958B\u95DC",
  124093: "\u7528\u6236\u6B63\u5728\u9023\u9EA5\u4E2D, \u8ACB\u7A0D\u5F8C\u518D\u8A66",
  124094: "\u64CD\u4F5C\u5931\u6557\uFF0C\u8ACB\u5148\u9023\u9EA5\u5F8C\u518D\u64CD\u4F5C",
  124095: "\u4E0A\u500B\u64CD\u4F5C\u9032\u884C\u4E2D\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  124096: "\u8ACB\u52FF\u91CD\u8907\u64CD\u4F5C",
  124097: "\u50C5\u4E3B\u8B1B\u4EBA\u80FD\u64CD\u4F5C",
  124098: "\u6587\u6A94\u3001\u767D\u677F\u3001\u5171\u4EAB\u5C4F\u5E55\u672A\u958B\u5553\uFF0C\u4E0D\u80FD\u756B\u9762\u5207\u63DB",
  124099: "\u64CD\u4F5C\u4EBA\u975E\u7D44\u9577",
  124100: "\u50C5\u7D44\u9577\u53EF\u4EE5\u5168\u9AD4\u975C\u97F3",
  124101: "\u9023\u9EA5\u5DF2\u95DC\u9589",
  125001: "\u67E5\u8A62\u8A02\u55AE\u6578\u64DA\u53C3\u6578\u7232\u7A7A",
  125002: "\u652F\u4ED8\u985E\u578B\u932F\u8AA4",
  125003: "\u652F\u4ED8\u53C3\u6578\u7121\u6548",
  125004: "\u9ED8\u8A8D\u5BE6\u73FE\u4E0D\u80FD\u652F\u4ED8",
  125005: "\u9000\u6B3E\u53C3\u6578\u7121\u6548",
  125006: "\u7121\u6548\u7684\u652F\u4ED8\u8A18\u9304",
  125007: "\u56DE\u8ABF\u7570\u5E38",
  125008: "\u8ABF\u7528\u5FAE\u4FE1\u4E0B\u55AE\u63A5\u53E3\u7570\u5E38",
  125009: "\u8ABF\u7528\u5FAE\u4FE1\u9000\u6B3E\u63A5\u53E3\u7570\u5E38",
  125010: "\u7121\u6548\u7684\u652F\u4ED8\u8A18\u9304",
  125011: "\u652F\u4ED8\u7570\u5E38",
  125012: "\u652F\u4ED8\u65B9\u5F0F\u932F\u8AA4",
  125013: "\u5FAE\u4FE1\u56DE\u8ABF\u985E\u578B\u672A\u77E5",
  125014: "\u5FAE\u4FE1\u56DE\u8ABF\u6578\u64DA\u89E3\u5BC6\u7570\u5E38",
  125015: "\u8A02\u55AE\u91CD\u8907\u652F\u4ED8",
  125016: "\u95DC\u9589\u5FAE\u4FE1\u8A02\u55AE\u7570\u5E38",
  125017: "\u8A02\u55AE\u72C0\u614B\u7570\u5E38",
  125018: "\u5FAE\u4FE1\u652F\u4ED8\u8A18\u9304\u72C0\u614B\u7570\u5E38",
  125019: "\u53D6\u6D88\u652F\u4ED8\u7570\u5E38",
  125020: "\u7576\u524D\u8A02\u55AE\u8655\u65BC\u9000\u6B3E\u6D41\u7A0B\u4E2D",
  125021: "\u8A02\u55AE\u672A\u652F\u4ED8",
  125022: "\u9000\u6B3E\u91D1\u984D\u8D85\u51FA\u652F\u4ED8\u91D1\u984D",
  125023: "\u672A\u5230\u6307\u5B9A\u9000\u6B3E\u6642\u9593",
  125024: "\u8ACB\u6C42\u5FAE\u4FE1\u9000\u6B3E\u5931\u6557",
  125025: "\u7121\u6548\u7684\u696D\u52D9\u985E\u578B",
  125100: "\u65B0\u589E\u8A02\u55AE\u8A18\u9304\u7570\u5E38",
  125101: "\u4FEE\u6539\u8A02\u55AE\u8A18\u9304\u7570\u5E38",
  125102: "\u7121\u6548\u8A02\u55AE\u8A18\u9304",
  125110: "\u65B0\u589E\u652F\u4ED8\u8A18\u9304\u7570\u5E38",
  125111: "\u4FEE\u6539\u652F\u4ED8\u8A18\u9304\u7570\u5E38",
  125112: "\u7121\u6548\u7684\u652F\u4ED8\u8A18\u9304",
  125120: "\u65B0\u589E\u9000\u6B3E\u8A18\u9304\u7570\u5E38",
  125121: "\u4FEE\u6539\u9000\u6B3E\u8A18\u9304\u7570\u5E38",
  125122: "\u7121\u6548\u7684\u9000\u6B3E\u8A18\u9304",
  125130: "\u65B0\u589E\u5FAE\u4FE1\u5C0D\u8CEC\u8A18\u9304\u7570\u5E38",
  125131: "\u4FEE\u6539\u5FAE\u4FE1\u5C0D\u8CEC\u8A18\u9304\u7570\u5E38",
  125132: "\u7121\u6548\u7684\u5FAE\u4FE1\u5C0D\u8CEC\u8A18\u9304",
  125133: "\u7121\u6548\u7684\u9000\u6B3E\u8A18\u9304",
  125134: "\u8ABF\u7528\u5FAE\u4FE1\u63A5\u53E3\u7570\u5E38",
  125135: "JsApi\u7372\u53D6\u7C3D\u540D\u7570\u5E38",
  125136: "\u8A02\u55AE\u5DF2\u652F\u4ED8",
  126001: "\u53C3\u6578\u4FE1\u606F\u5B58\u5728\u7F3A\u5931",
  126002: "\u5275\u5EFA\u5834\u6B21\u7D71\u8A08\u6578\u64DA\u5931\u6557",
  126003: "\u4FEE\u6539\u5834\u6B21\u540D\u7A31\u6578\u64DA\u5931\u6557",
  126004: "\u7121\u6548\u5834\u6B21\u6578\u64DA",
  126005: "\u67E5\u8A62\u53C3\u6578\u7F3A\u5931",
  126006: "\u7D71\u8A08\u89C0\u770B\u6642\u9577\u6578\u64DA\u5931\u6557",
  126007: "\u7D71\u8A08\u89C0\u770B\u4EBA\u6578\u6578\u64DA\u5931\u6557",
  126008: "\u7D71\u8A08\u89C0\u770B\u5340\u57DF\u6578\u64DA\u5931\u6557",
  126020: "\u7372\u53D6\u76F4\u64AD\u6D41\u6C34\u7570\u5E38",
  126021: "\u7372\u53D6\u9EDE\u64AD\u6D41\u6C34\u7570\u5E38",
  126022: "\u65B0\u589E\u623F\u9593\u7D71\u8A08",
  126023: "\u65B0\u589E\u623F\u9593\u5340\u57DF\u7D71\u8A08",
  126024: "\u7372\u53D6\u623F\u9593\u7D71\u8A08\u6578\u64DA\u6642\u9593\u8D85\u9577",
  126025: "\u5B50\u7DDA\u7A0B\u57F7\u884C\u4EFB\u52D9\u8D85\u6642",
  126026: "\u5B50\u7DDA\u7A0B\u57F7\u884C\u7570\u5E38",
  126027: "\u65B0\u589E\u6D3B\u52D5\u7D71\u8A08\u8A18\u9304\u5931\u6557",
  126028: "\u4FEE\u6539\u6D3B\u52D5\u7D71\u8A08\u8A18\u9304\u5931\u6557",
  126029: "\u65B0\u589E\u6D3B\u52D5\u5340\u57DF\u8A18\u9304\u5931\u6557",
  126030: "\u4FEE\u6539\u6D3B\u52D5\u5340\u57DF\u8A18\u9304\u5931\u6557",
  126031: "\u7981\u6B62\u540C\u6642\u4F7F\u7528\u5169\u500B\u7DAD\u5EA6\u67E5\u8A62",
  126032: "\u7121\u6548\u7684\u9EDE\u8D0A\u6D41\u6C34\u8A18\u9304",
  126033: "\u4FDD\u5B58\u623F\u9593\u8DA8\u52E2\u6578\u64DA\u7570\u5E38",
  126034: "\u4FDD\u5B58\u6E20\u9053\u8DA8\u52E2\u6578\u64DA\u7570\u5E38",
  126035: "\u62BD\u734E\u7D71\u8A08\u5217\u8868\u53C3\u6578\u7570\u5E38",
  126036: "\u4E0D\u5B58\u5728\u8A72\u7528\u6236\u7684\u6578\u64DA",
  126037: "\u7528\u6236\u6392\u540D\u985E\u578B\u4E0D\u5B58\u5728",
  126038: "\u8ACB\u9078\u64C7\u67E5\u770B\u983B\u9053\u6578\u64DA\u6216\u5834\u6240\u6578\u64DA",
  126039: "\u65B0\u589E\u6253\u8CDE\u7D71\u8A08\u7570\u5E38",
  126040: "\u522A\u9664\u6253\u8CDE\u7D71\u8A08\u7570\u5E38",
  126041: "\u5275\u5EFA\u5831\u540D\u5340\u57DF\u7D71\u8A08\u5931\u6557",
  126042: "\u4FEE\u6539\u5831\u540D\u5340\u57DF\u7D71\u8A08\u5931\u6557",
  126043: "\u5275\u5EFA\u5831\u540D\u4EBA\u6578\u6309\u5929\u7D71\u8A08\u5931\u6557",
  126044: "\u4FEE\u6539\u5831\u540D\u4EBA\u6578\u6309\u5929\u7D71\u8A08\u5931\u6557",
  127001: "\u554F\u5377\u540D\u7A31\u4E0D\u652F\u6301\u91CD\u8907",
  127002: "\u554F\u5377\u9078\u9805\u500B\u6578\u7BC4\u570D\u72322-50\u500B",
  127003: "\u554F\u5377\u554F\u984C\u8D85\u904E\u540C\u985E\u578B\u7684\u6700\u5927\u500B\u6578\u9650\u5236",
  127004: "\u4E0D\u5B58\u5728\u7684\u554F\u5377",
  127005: "\u522A\u9664\u554F\u5377\u5931\u6557",
  127006: "\u66F4\u65B0\u554F\u5377\u72C0\u614B\u5931\u6557",
  127007: "\u7576\u524D\u76F4\u64AD\u9593\u7121\u6B63\u5728\u4F7F\u7528\u7684\u554F\u5377",
  127008: "\u5FC5\u586B\u554F\u984C\u672A\u56DE\u7B54",
  127009: "\u8A72\u7528\u6236\u5DF2\u586B\u5BEB\u904E\u554F\u5377",
  127010: "\u7576\u524D\u554F\u5377\u5DF2\u7D50\u675F\uFF0C\u7121\u6CD5\u63D0\u4EA4",
  127011: "\u7576\u524D\u5DF2\u6709\u554F\u5377\u8655\u65BC\u4F7F\u7528\u72C0\u614B\uFF0C\u8ACB\u5148\u505C\u6B62\u4F7F\u7528\u4E2D\u7684\u554F\u5377",
  127012: "\u7576\u524D\u554F\u5377\u8655\u65BC\u4F7F\u7528\u4E2D\uFF0C\u8ACB\u5148\u505C\u6B62\u4F7F\u7528",
  127013: "\u55AE\u9078\u984C\u4E2D\u7981\u6B62\u51FA\u73FE\u591A\u7B54\u6848",
  127014: "\u7981\u6B62\u5275\u5EFA\u7A7A\u7684\u554F\u5377",
  127015: "\u7528\u6236\u9700\u540C\u610F\u6578\u64DA\u5354\u8B70,\u624D\u80FD\u63D0\u4EA4\u56DE\u7B54",
  127016: "\u554F\u5377\u554F\u984C\u6A19\u984C\u8D85\u904E\u6700\u5927\u5B57\u6578\u9650\u5236",
  127017: "\u554F\u5377\u9078\u9805\u5167\u5BB9\u8D85\u904E\u6700\u5927\u5B57\u6578\u9650\u5236",
  127018: "\u554F\u5377\u56DE\u7B54\u5167\u5BB9\u8D85\u904E\u6700\u5927\u5B57\u6578\u9650\u5236",
  127019: "\u554F\u5377\u56DE\u7B54\u624B\u6A5F\u865F\u53EA\u5141\u8A3111\u4F4D\u6578\u5B57",
  127020: "\u554F\u5377\u56DE\u7B54\u90F5\u7BB1\u865F\u683C\u5F0F\u6709\u8AA4",
  127021: "\u8A72\u624B\u6A5F\u865F\u5DF2\u5831\u540D\uFF0C\u8ACB\u52FF\u91CD\u8907\u5831\u540D",
  127022: "\u8ACB\u5148\u914D\u7F6E\u5FAE\u4FE1\u652F\u4ED8\u5546\u6236\uFF0C\u5426\u5247\u7121\u6CD5\u958B\u5553\u6536\u8CBB\u529F\u80FD",
  127023: "\u6536\u8CBB\u50F9\u683C\u7BC4\u570D\u57280.01~999999.99",
  127024: "\u554F\u5377\u554F\u984C\u4E0D\u80FD\u7232\u7A7A",
  127025: "\u6700\u591A\u652F\u630150\u500B\u984C\u76EE",
  127026: "\u554F\u5377\u5DF2\u662F\u6B64\u72C0\u614B\uFF0C\u8ACB\u52FF\u91CD\u8907\u64CD\u4F5C",
  127027: "\u554F\u5377\u6A19\u984C\u4E0D\u80FD\u7232\u7A7A",
  127028: "\u9078\u64C7\u984C\u9078\u9805\u4E0D\u80FD\u7232\u7A7A",
  127029: "\u66F4\u65B0\u554F\u5377\u5931\u6557",
  127030: "\u522A\u9664\u554F\u5377\u5931\u6557",
  127031: "\u9A57\u8B49\u78BC\u4E0D\u80FD\u7232\u7A7A",
  127032: "\u9A57\u8B49\u78BC\u932F\u8AA4",
  127033: "\u79DF\u6236id\u4E0D\u80FD\u7232\u7A7A",
  127034: "\u6D3B\u52D5id\u4E0D\u80FD\u7232\u7A7A",
  127035: "\u5FC5\u7B54\u554F\u984C\u672A\u586B\u5BEB",
  127036: "\u5DF2\u6709\u53C3\u8207\u8005\u5831\u540D\uFF0C\u8868\u55AE\u4E0D\u518D\u652F\u6301\u4FEE\u6539",
  127037: "\u554F\u984C\u985E\u578B\u503C\u975E\u6CD5",
  127038: "\u8ACB\u9078\u64C7\u9580\u7968",
  127039: "\u60A8\u5DF2\u53C3\u8207\u6D3B\u52D5\uFF0C\u7121\u9700\u91CD\u8907\u5831\u540D",
  127040: "\u8ACB\u81F3\u5C11\u4FDD\u7559\u624B\u6A5F\u865F\u6216\u90F5\u7BB1\u4E00\u7A2E\u65B9\u5F0F",
  127041: "\u5831\u540D\u8868\u55AEid\u4E0D\u80FD\u7232\u7A7A",
  127042: "\u554F\u5377\u554F\u984C\u4E0D\u5B58\u5728",
  127043: "\u9078\u64C7\u984C\u9078\u9805\u5167\u5BB9\u4E0D\u80FD\u7232\u7A7A",
  127044: "\u554F\u5377\u540D\u7A31 \u662F\u5FC5\u9700\u9805",
  127045: "questionScore \u53D6\u503C\u7BC4\u570D\u72321-100",
  127046: "\u4E3B\u8FA6\u65B9\u6B63\u5728\u78BA\u8A8D\u60A8\u7684\u5831\u540D\uFF0C\u8ACB\u52FF\u91CD\u8907\u5831\u540D",
  127047: "\u4E3B\u8FA6\u65B9\u6B63\u5728\u78BA\u8A8D\u60A8\u7684\u5831\u540D\uFF0C\u8ACB\u8010\u5FC3\u7B49\u5F85",
  127048: "\u60A8\u7684\u5831\u540D\u5C1A\u672A\u78BA\u8A8D\uFF0C\u8ACB\u8010\u5FC3\u7B49\u5F85",
  127049: "\u60A8\u7684\u5831\u540D\u5C1A\u672A\u78BA\u8A8D\uFF0C\u8ACB\u52FF\u91CD\u8907\u5831\u540D",
  127050: "\u984C\u76EE\u6578\u91CF\u6216\u9078\u9805\u6578\u91CF\u61C9\u8207\u4E2D\u6587\u914D\u7F6E\u76F8\u540C",
  128001: "\u7576\u524D\u72C0\u614B\u7981\u6B62\u5207\u63DB\u76F4\u64AD\u9593\u6A21\u5F0F",
  128002: "\u7981\u6B62\u91CD\u8907\u5207\u63DB\u76F4\u64AD\u9593\u6A21\u5F0F",
  128003: "\u4E0D\u5B58\u5728\u7684\u756B\u9762",
  128004: "\u66F4\u65B0\u975E\u4E3B\u756B\u9762\u8A2D\u7F6E\u5931\u6557",
  128005: "\u66F4\u65B0\u4E3B\u756B\u9762\u8A2D\u7F6E\u5931\u6557",
  128006: "\u7121\u6548\u623F\u9593",
  128007: "\u539F\u4E3B\u756B\u9762id\u53C3\u6578\u7F3A\u5931",
  128008: "\u672A\u9078\u64C7\u756B\u9762\u4F5C\u7232\u4E3B\u756B\u9762",
  128009: "\u7576\u524D\u756B\u9762\u5DF2\u662F\u4E3B\u756B\u9762",
  128010: "\u8ABF\u7528\u7981\u6B62\u63A8\u6D41\u5931\u6557",
  128011: "\u8ABF\u7528\u6062\u5FA9\u63A8\u6D41\u5931\u6557",
  128012: "\u8ABF\u7528\u6B63\u5728\u63A8\u6D41\u5217\u8868\u5931\u6557",
  128013: "\u7576\u524D\u76F4\u64AD\u9593\u8655\u65BC\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u589E\u52A0\u756B\u9762",
  128014: "\u63A8\u6D41\u76F4\u64AD\u76F8\u95DC\u8CC7\u6E90\u4E0D\u8DB3",
  128015: "\u7576\u524D\u6A21\u5F0F\u4E0D\u652F\u6301\u589E\u52A0\u756B\u9762",
  128016: "\u756B\u9762\u540D\u7A31\u4E0D\u652F\u6301\u91CD\u8907",
  128017: "\u7576\u524D\u76F4\u64AD\u9593\u8655\u65BC\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u522A\u9664\u756B\u9762",
  128018: "\u7981\u6B62\u522A\u9664\u4E3B\u756B\u9762",
  128019: "\u6700\u591A\u96BB\u80FD\u67098\u500B\u756B\u9762",
  128020: "\u79DF\u6236\u7F3A\u5C11\u63A8\u6D41\u76F4\u64AD\u8CC7\u6E90",
  128021: "\u522A\u9664\u756B\u9762\u5931\u6557",
  128022: "\u7372\u53D6\u5728\u7DDA\u6D41\u5217\u8868\u932F\u8AA4",
  128023: "\u63A8\u6D41\u76F4\u64AD\u5B9A\u6642\u88DC\u511F\u958B\u5553\u76F4\u64AD\u72C0\u614B\u5931\u6557",
  128024: "\u63A8\u6D41\u76F4\u64AD\u5B9A\u6642\u88DC\u511F\u505C\u6B62\u76F4\u64AD\u72C0\u614B\u5931\u6557",
  128025: "\u65B0\u589E\u756B\u9762\u5931\u6557",
  128026: "\u522A\u9664\u756B\u9762\u5931\u6557",
  128027: "\u57DF\u540D\u7D44\u4E0D\u5B58\u5728\u53EF\u7528\u63A8\u6D41\u57DF\u540D",
  128028: "\u57DF\u540D\u7D44\u4E0D\u5B58\u5728\u53EF\u7528\u62C9\u6D41\u57DF\u540D",
  128029: "\u5B58\u5728\u63A8\u6D41\u4E2D\u7684\u6D41\uFF0C\u7981\u6B62\u7D50\u675F\u76F4\u64AD",
  129001: "\u7121\u6548\u7684\u6D3B\u52D5",
  129002: "\u5275\u5EFA\u6D3B\u52D5\u5931\u6557\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  129003: "\u5275\u5EFA\u6D3B\u52D5\u5931\u6557",
  129004: "\u4FEE\u6539\u6D3B\u52D5\u5931\u6557",
  129005: "\u6D3B\u52D5\u5DF2\u7D50\u675F",
  129006: "\u5DF2\u8A2D\u7F6E\u53D6\u6D88\u767C\u4F48\uFF0C\u8ACB\u52FF\u91CD\u8907\u64CD\u4F5C",
  129007: "\u5DF2\u8A2D\u7F6E\u767C\u4F48\uFF0C\u8ACB\u52FF\u91CD\u8907\u64CD\u4F5C",
  129008: "\u7576\u524D\u5DF2\u904E\u6D3B\u52D5\u7D50\u675F\u6642\u9593\uFF0C\u8ACB\u4FEE\u6539\u6D3B\u52D5\u6642\u9593\u5F8C\u518D\u767C\u5E03",
  129009: "\u8A2D\u7F6E\u767C\u4F48\u72C0\u614B\u5931\u6557",
  129010: "\u623F\u9593\u975E\u6D3B\u52D5\u5275\u5EFA",
  129011: "\u7121\u6548\u7684\u6D3B\u52D5\u65E5\u7A0B",
  129012: "\u5275\u5EFA\u6D3B\u52D5\u65E5\u7A0B\u5931\u6557",
  129013: "\u4FEE\u6539\u6D3B\u52D5\u65E5\u7A0B\u5931\u6557",
  129014: "\u522A\u9664\u6D3B\u52D5\u65E5\u7A0B\u5931\u6557",
  129015: "\u7576\u524D\u76F4\u64AD\u9593\u5DF2\u95DC\u806F\u5176\u4ED6\u65E5\u7A0B\u6642\u9593\uFF0C\u8ACB\u8ABF\u6574\u65E5\u7A0B\u6642\u9593\u6216\u66F4\u6539\u76F4\u64AD\u9593\u3002\u885D\u7A81\u6642\u9593\uFF1A",
  129016: "\u5275\u5EFA\u6D3B\u52D5\u843D\u5730\u9801\u5931\u6557",
  129017: "\u4FEE\u6539\u6D3B\u52D5\u843D\u5730\u9801\u5931\u6557",
  129018: "\u5609\u8CD3\u59D3\u540D\u4E0D\u80FD\u7232\u7A7A",
  129019: "\u7576\u524D\u66AB\u4E0D\u53EF\u767C\u4F48\u6D3B\u52D5\uFF0C\u8ACB\u5148\u5275\u5EFA\u5831\u540D\u8868\u55AE\u5F8C\u518D\u767C\u5E03",
  129020: "\u7121\u5831\u540D\uFF0C\u6D3B\u52D5\u7121\u6CD5\u767C\u4F48",
  129021: "\u5DF2\u505C\u6B62\u5831\u540D",
  129022: "\u6703\u8B70\u958B\u59CB\u6642\u9593\u683C\u5F0F\u7570\u5E38",
  129023: "\u6703\u8B70\u7D50\u675F\u6642\u9593\u683C\u5F0F\u7570\u5E38",
  129024: "\u6703\u8B70\u958B\u59CB\u6216\u8005\u7D50\u675F\u6642\u9593\u70BA\u7A7A",
  129025: "\u4FEE\u6539\u6D3B\u52D5\u4F5C\u5EE2\u6A19\u8B58\u5931\u6557",
  129026: "\u6D3B\u52D5\u5DF2\u4F5C\u5EE2",
  129027: "\u6D3B\u52D5\u6A21\u5F0F\u8207\u623F\u9593\u6A21\u5F0F\u4E0D\u5339\u914D",
  129028: "\u4E0D\u5B58\u5728\u7684\u6D3B\u52D5",
  129031: "\u7121\u6548\u7684\u6D3B\u52D5\u9580\u7968",
  129032: "\u5275\u5EFA\u6D3B\u52D5\u9580\u7968\u5931\u6557",
  129033: "\u9580\u7968\u7DE8\u865F\u4E0D\u5141\u8A31\u91CD\u8907\uFF0C\u8ACB\u78BA\u8A8D",
  129034: "\u50C5\u672A\u4E0A\u67B6\u9580\u7968\u53EF\u4EE5\u7DE8\u8F2F",
  129035: "\u672A\u4E0A\u67B6\u50C5\u80FD\u4FEE\u6539\u7232\u5DF2\u4E0A\u67B6",
  129036: "\u5DF2\u4E0A\u67B6\u50C5\u80FD\u4FEE\u6539\u7232\u5DF2\u4E0B\u67B6",
  129037: "\u5DF2\u4E0B\u67B6\u50C5\u80FD\u4FEE\u6539\u7232\u5DF2\u4E0A\u67B6",
  129038: "\u4FEE\u6539\u6D3B\u52D5\u9580\u7968\u4E0A\u67B6\u72C0\u614B\u5931\u6557",
  129039: "\u9580\u7968\u6578\u91CF\u4E0D\u80FD\u5C0F\u65BC\u5DF2\u552E\u9580\u7968\u6578\u91CF\u7684\u503C",
  129040: "\u5B58\u5728\u672A\u4E0A\u67B6\u9580\u7968\uFF0C\u8ACB\u5237\u65B0\u9801\u9762\u91CD\u65B0\u9078\u64C7\u9580\u7968",
  129041: "\u4FEE\u6539\u5F8C\u81FA\u5C0E\u5165\u6578\u91CF\u5931\u6557",
  129042: "\u6D3B\u52D5\u5C1A\u672A\u958B\u5553\u9580\u7968\u529F\u80FD\uFF0C\u9580\u7968\u529F\u80FD\u7121\u6CD5\u4F7F\u7528",
  129043: "\u4FEE\u6539\u6D3B\u52D5\u9580\u7968\u5931\u6557",
  129050: "\u6D3B\u52D5\u5DF2\u958B\u5553\u9580\u7968\u529F\u80FD\uFF0C\u8ACB\u9078\u64C7\u9580\u7968",
  129051: "\u9580\u7968\u6700\u591A\u9078\u64C710\u5F35",
  129052: "\u5275\u5EFA\u5831\u540D\u8868\u55AE\u9580\u7968\u95DC\u806F\u5931\u6557",
  129053: "\u9580\u7968\u5DF2\u4E0B\u67B6\uFF0C\u8ACB\u91CD\u65B0\u9078\u64C7\u9580\u7968",
  129054: "\u9580\u7968\u5DF2\u552E\u7F44\uFF0C\u8ACB\u91CD\u65B0\u9078\u64C7\u9580\u7968",
  129055: "\u9580\u7968\u672A\u5728\u552E\u7968\u4E2D\u72C0\u614B\uFF0C\u8ACB\u91CD\u65B0\u9078\u64C7\u9580\u7968",
  129056: "\u5275\u5EFA\u7528\u6236\u9580\u7968\u95DC\u806F\u5931\u6557",
  129057: "\u4FEE\u6539\u7528\u6236\u9580\u7968\u95DC\u806F\u522A\u9664\u6A19\u8A18\u5931\u6557",
  129058: "\u7121\u6548\u7684\u7528\u6236\u9580\u7968\u95DC\u806F",
  129059: "\u5C1A\u672A\u914D\u7F6E\u5FAE\u4FE1\u652F\u4ED8\uFF0C\u6536\u8CBB\u9580\u7968\u529F\u80FD\u7121\u6CD5\u4F7F\u7528",
  129060: "\u65E5\u7A0B\u5609\u8CD3\u4E0D\u5B58\u5728",
  129061: "\u7528\u6236\u9580\u7968\u652F\u4ED8\u72C0\u614B\u4E0D\u6B63\u78BA",
  129062: "\u4FEE\u6539\u7528\u6236\u9580\u7968\u652F\u4ED8\u72C0\u614B\u5931\u6557",
  129063: "\u9580\u7968\u540D\u7A31\u4E0D\u5141\u8A31\u91CD\u8907\uFF0C\u8ACB\u78BA\u8A8D",
  129064: "\u5DF2\u4E0A\u67B6\uFF0C\u5DF2\u4E0B\u67B6\u7684\u9580\u7968\u50C5\u652F\u6301\u4FEE\u6539\uFF1A\u9580\u7968\u540D\u7A31\uFF0C\u9580\u7968\u63CF\u8FF0\uFF0C\u9580\u7968\u6578\u91CF\uFF0C\u552E\u7968\u6642\u9593",
  129065: "\u7121\u4E0A\u67B6\u4E2D\u7684\u9580\u7968\uFF0C\u6D3B\u52D5\u7121\u6CD5\u767C\u4F48",
  129070: "\u5275\u5EFA\u65E5\u7A0B\u8A55\u50F9\u5931\u6557",
  129071: "\u8A55\u50F9\u529F\u80FD\u672A\u958B\u5553",
  129072: "\u8ACB\u5728\u65E5\u7A0B\u958B\u59CB\u5F8C\u518D\u9032\u884C\u8A55\u50F9",
  129073: "\u50C5\u652F\u6301\u8A55\u50F9\u4E00\u6B21",
  129080: "\u4FEE\u6539\u5206\u4EAB\u8A2D\u7F6E\u5931\u6557",
  129081: "\u4FEE\u6539\u6D3B\u52D5\u88DD\u4FEE\u5E8F\u865F\u5931\u6557",
  129082: "\u6D3B\u52D5\u88DD\u4FEE\u5E8F\u865F\u91CD\u8907",
  129083: "\u55AE\u500B\u6D3B\u52D5\u9650\u5236\u6700\u591A\u5275\u5EFA20\u500B\u5831\u540D\u8868\u55AE",
  129084: "\u6D3B\u52D5\u5DF2\u8A2D\u7F6E\u4E0D\u80FD\u5275\u5EFA\u5831\u540D\u8868\u55AE",
  129085: "\u7372\u53D6\u63A8\u5EE3\u6E20\u9053\u7232\u7A7A",
  129086: "\u65B0\u589E\u63A8\u5EE3\u6E20\u9053\u5931\u6557",
  129087: "\u6700\u591A\u6DFB\u52A020\u500B\u6E20\u9053",
  129088: "\u63A8\u5EE3\u6E20\u9053\u540D\u7A31\u76F8\u540C",
  129089: "\u63A8\u5EE3\u6E20\u9053\u7DE8\u865F\u76F8\u540C",
  129090: "\u7372\u53D6\u63A8\u5EE3\u6E20\u9053\u7D71\u8A08\u6578\u64DA\u7232\u7A7A",
  129091: "\u65B0\u589E\u63A8\u5EE3\u6E20\u9053\u7D71\u8A08\u6578\u64DA\u5931\u6557",
  129092: "\u5DF2\u7D93\u6709\u4EBA\u5831\u540D,\u7121\u6CD5\u7DE8\u8F2F",
  129093: "\u4FEE\u6539\u6E20\u9053\u5553\u7528\u72C0\u614B\u5931\u6557",
  129094: "\u672A\u958B\u5553\u5834\u6240\u67E5\u8A62\uFF0C\u8ACB\u5148\u958B\u5553",
  129095: "\u672A\u914D\u7F6E\u6D3B\u52D5\u88DD\u4FEE\uFF0C\u8ACB\u5148\u914D\u7F6E",
  129096: "\u63A8\u5EE3\u6E20\u9053\u7DE8\u8F2F\u5931\u6557",
  129097: "\u672A\u958B\u5553\u65E5\u671F\u67E5\u8A62\uFF0C\u8ACB\u5148\u958B\u5553",
  129100: "\u5275\u5EFA\u6D3B\u52D5\u51C6\u5165\u5931\u6557",
  129101: "\u4FEE\u6539\u6D3B\u52D5\u51C6\u5165\u5931\u6557",
  129102: "\u7121\u6548\u7684\u6D3B\u52D5\u51C6\u5165",
  129103: "\u8ACB\u5148\u914D\u7F6E\u5831\u540D\u8868\u55AE",
  129104: "\u672A\u5553\u7528\u958B\u653E\u5E73\u81FA",
  129105: "\u5275\u5EFA\u5609\u8CD3\u7570\u5E38",
  129106: "\u4FEE\u6539\u5609\u8CD3\u7570\u5E38",
  129107: "\u7121\u6548\u7684\u5609\u8CD3",
  129108: "\u7121\u6548\u7684\u5609\u8CD3",
  129109: "\u4E0D\u5141\u8A31\u4FEE\u6539\u66B1\u7A31",
  129110: "\u66F4\u65B0\u63A8\u5EE3\u6E20\u9053\u7D71\u8A08\u6578\u64DA\u5931\u6557",
  129120: "\u7121\u6548\u7684\u901A\u77E5\u985E\u578B",
  129121: "\u672A\u914D\u7F6E\u5FAE\u4FE1\u901A\u77E5\u6A21\u677F",
  129122: "\u76F4\u64AD\u65E5\u7A0B\u6700\u591A%s\u4F4D\u5609\u8CD3",
  129123: "\u624B\u6A5F\u865F\u6216\u90F5\u7BB1\u5FC5\u586B\u4E00\u9805",
  129124: "\u8A72\u63A5\u53E3\u66AB\u4E0D\u652F\u6301\u5831\u540D\u6216\u767D\u540D\u55AE\u51C6\u5165\u914D\u7F6E",
  129125: "\u5275\u5EFA\u7528\u6236\u9580\u7968\u8A02\u55AE\u5931\u6557",
  129126: "\u66F4\u65B0\u8A02\u55AE\u72C0\u614B\u5931\u6557",
  129127: "\u79FB\u9664\u72C0\u614B\u4E0D\u80FD\u7232\u7A7A",
  129128: "\u624B\u6A5F\u865F\u683C\u5F0F\u4E0D\u6B63\u78BA:%s",
  129129: "\u958B\u59CB\u6642\u9593\u61C9\u5728\u7D50\u675F\u6642\u9593\u4E4B\u524D",
  129130: "\u6D3B\u52D5\u6642\u9593\u6700\u77ED\u7232%s\u5C0F\u6642",
  129131: "\u6D3B\u52D5\u6642\u9593\u6700\u9577\u7232%s\u5929",
  129132: "\u5C0E\u5165\u6578\u64DA\u4E0D\u80FD\u7232\u7A7A",
  129133: "\u5609\u8CD3\u4E0D\u5141\u8A31\u91CD\u8907\u6DFB\u52A0",
  129134: "\u901A\u77E5\u6642\u9593\u4E0D\u80FD\u7232\u6B77\u53F2\u6642\u9593",
  129135: "\u5C1A\u672A\u914D\u7F6E\u5FAE\u4FE1\u516C\u8846\u865F\uFF0C\u7121\u6CD5\u958B\u5553\u5FAE\u4FE1\u8A02\u95B1\u901A\u77E5",
  129136: "\u7814\u8A0E\u6703\u53EF\u5275\u5EFA\u6578\u91CF\u8CC7\u6E90\u4E0D\u8DB3\uFF0C\u7121\u6CD5\u6062\u5FA9\u8A72\u6D3B\u52D5",
  129137: "\u6D3B\u52D5\u901A\u77E5\u914D\u7F6E\u5DF2\u5B58\u5728",
  129138: "\u8ACB\u81F3\u5C11\u9078\u64C7\u4E00\u7A2E\u901A\u77E5\u65B9\u5F0F",
  129139: "\u60A8\u5DF2\u8A02\u95B1\uFF0C\u7121\u9700\u91CD\u8907\u63D0\u4EA4",
  129140: "\u6D3B\u52D5\u8A02\u95B1\u6642\u9593\u5DF2\u7D50\u675F",
  129141: "\u90F5\u4EF6\u5167\u5BB9\u8D85\u904E\u9650\u5236\u9577\u5EA6",
  129142: "\u90F5\u4EF6\u5167\u5BB9\u4E0D\u80FD\u70BA\u7A7A",
  129143: "\u8A02\u95B1\u6210\u529F\u901A\u77E5\u5167\u5BB9\u4E0D\u80FD\u70BA\u7A7A",
  129144: "\u6D3B\u52D5\u8A02\u95B1\u529F\u80FD\u5DF2\u95DC\u9589",
  129145: "\u81F3\u5C11\u958B\u555F\u4E00\u500B\u6D3B\u52D5\u8A9E\u8A00",
  129151: "\u81F3\u5C11\u958B\u555F\u4E00\u500B\u6D3B\u52D5\u8A9E\u8A00",
  130001: "\u5BA2\u6236\u7981\u7528\u72C0\u614B\u4E0D\u5141\u8A31\u8CFC\u8CB7",
  130002: "\u7522\u54C1\u672A\u8655\u65BC\u4E0A\u67B6\u72C0\u614B",
  130003: "\u5275\u5EFA\u8A02\u55AE\u5931\u6557",
  130004: "\u5275\u5EFA\u8A02\u55AE\u5BE9\u6279\u6D41\u7A0B\u5931\u6557",
  130005: "\u5275\u5EFA\u8A02\u55AE\u652F\u4ED8\u6D41\u7A0B\u5931\u6557",
  130006: "\u4FEE\u6539\u8A02\u55AE\u5931\u6557",
  130007: "\u7121\u6548\u7684\u8A02\u55AE",
  130008: "\u8A02\u55AE\u7576\u524D\u5BE9\u6279\u72C0\u614B\u4E0D\u6B63\u78BA\uFF0C\u7121\u6CD5\u4FEE\u6539\u72C0\u614B",
  130009: "\u62D2\u7D55\u6642\u9700\u8981\u7406\u7531",
  130010: "\u5B9A\u6642\u751F\u6548\u6642\u9700\u8981\u751F\u6548\u6642\u9593",
  130011: "\u5275\u5EFA\u6C96\u92B7\u8A02\u55AE\u5931\u6557",
  130012: "\u4FEE\u6539\u6C96\u92B7\u8A02\u55AE\u72C0\u614B\u5931\u6557",
  130013: "\u7121\u6548\u7684\u6C96\u92B7\u8A02\u55AE",
  130014: "\u53EF\u6C96\u92B7\u6578\u91CF\u932F\u8AA4",
  130015: "\u7522\u54C1\u5DF2\u904E\u671F\uFF0C\u7121\u6CD5\u6C96\u92B7",
  130016: "\u8A02\u55AE\u672A\u652F\u4ED8\uFF0C\u4E0D\u5141\u8A31\u6C96\u92B7",
  130017: "\u5275\u5EFA\u5BA2\u6236\u4FE1\u606F\u5931\u6557",
  130018: "\u8A02\u55AE\u751F\u6548\u6642\u9593\u66F4\u65B0\u5931\u6557",
  130019: "\u7522\u54C1\u5957\u9910\u53CA\u7248\u672C\u50C5\u80FD\u8CFC\u8CB71\u4EF6",
  130020: "\u6C96\u92B7\u91D1\u984D\u4E0D\u80FD\u5927\u65BC\u5BE6\u4ED8\u91D1\u984D",
  130021: "\u6C96\u92B7\u6578\u91CF\u4E0D\u80FD\u5927\u65BC\u53EF\u6C96\u92B7\u6578\u91CF",
  130022: "\u8A72\u8A02\u55AE\u5DF2\u88AB\u6C96\u92B7\uFF0C\u7121\u6CD5\u518D\u6B21\u6C96\u92B7",
  130023: "\u540C\u4E00\u500B\u8A02\u55AE\u4E2D\u53EA\u80FD\u8CFC\u8CB7\u4E00\u500B\u7248\u672C",
  130024: "\u6C96\u92B7\u91D1\u984D\u61C9\u5C0F\u65BC\u5BE6\u4ED8\u91D1\u984D",
  131001: '\u60A8\u767C\u9001\u7684\u7D05\u5305\u53E3\u4EE4\u5305\u542B\u654F\u611F\u8A5E"%s"',
  131002: "\u50C5\u5141\u8A31\u5177\u540D\u7528\u6236\u6436\u7D05\u5305",
  131003: "\u6436\u7D05\u5305\u4EBA\u6578\u8F03\u591A\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  131004: "\u975E\u6CD5\u8ACB\u6C42",
  131005: "\u7121\u6548\u7684\u7D05\u5305",
  131006: "\u9810\u767C\u7D05\u5305\u932F\u8AA4",
  131007: "\u53E3\u4EE4\u932F\u8AA4",
  131008: "\u7D05\u5305\u5DF2\u904E\u671F",
  131009: "\u7D05\u5305\u5DF2\u88AB\u7981\u7528",
  131010: "\u60A8\u5DF2\u9818\u53D6\u904E\u8A72\u7D05\u5305\uFF0C\u8ACB\u52FF\u91CD\u8907\u9818\u53D6\u3002",
  131011: "\u975E\u6CD5\u7684\u7D05\u5305\u53C3\u6578",
  131012: "\u767C\u7D05\u5305\u9593\u9694\u4E0D\u5F97\u5C0F\u65BC1\u5206\u9418\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66",
  131013: "\u8ACB\u5148\u914D\u7F6E\u5FAE\u4FE1\u516C\u8846\u865F\u548C\u5546\u6236\u4FE1\u606F",
  131014: "\u7121\u6B0A\u9650\u64CD\u4F5C\u8A72\u7D05\u5305\u8A18\u9304",
  131015: "\u89C0\u8846\u672A\u9032\u884C\u5FAE\u4FE1\u6388\u6B0A",
  131016: "\u4E0D\u5B58\u5728\u7684\u7D05\u5305",
  131017: "\u6B64\u72C0\u614B\u7D05\u5305\u4E0D\u652F\u6301\u4FEE\u6539",
  131018: "\u55AE\u500B\u7D05\u5305\u91D1\u984D\u9700\u57280.3\u81F3200\u5143\u4E4B\u9593",
  131019: "\u6B64\u72C0\u614B\u7D05\u5305\u4E0D\u652F\u6301\u767C\u4F48",
  131020: "\u4E0D\u5B58\u5728\u7684\u7D05\u5305\u9818\u53D6\u8A18\u9304",
  131021: "\u7CFB\u7D71\u7570\u5E38",
  131022: "\u7D05\u5305\u5DF2\u6436\u5B8C",
  131023: "\u9810\u767C\u7D05\u5305\u585E\u56DE\u5831\u932F",
  131024: "\u8655\u7406\u7528\u6236\u9818\u53D6\u8A18\u9304\u51FA\u932F",
  131025: "\u6D88\u606F\u767C\u9001\u7570\u5E38",
  131026: "\u8ACB\u5728\u5FAE\u4FE1\u74B0\u5883\u5167\u53C3\u8207\u9818\u7D05\u5305",
  132001: "\u7121\u6548\u7684\u6703\u8B70\u5BA4",
  132002: "\u7121\u6548\u7684\u6703\u8B70",
  132003: "\u7121\u6548\u7684\u4E3B\u6301\u4EBA\u8A8D\u8B49\u53E3\u4EE4",
  132004: "\u932F\u8AA4\u7684\u4E3B\u6301\u4EBA\u8A8D\u8B49\u53E3\u4EE4",
  132005: "\u7121\u6548\u7684\u6703\u8B70\u90E8\u5206ID",
  132006: "\u9810\u5B9A\u5931\u6557\u8ACB\u91CD\u8A66",
  132007: "\u9A30\u8A0A\u6703\u8B70\u5275\u5EFA\u5931\u6557",
  132008: "\u9A30\u8A0A\u6703\u8B70\u4FEE\u6539\u5931\u6557",
  132009: "\u9A30\u8A0A\u6703\u8B70\u53D6\u6D88\u5931\u6557",
  132010: "\u6703\u8B70\u5BA4\u53C3\u6578\u7570\u5E38",
  132011: "\u6703\u8B70\u5BA4\u53D6\u6D88\u5931\u6557",
  132012: "\u6703\u8B70\u5BA4\u521D\u59CB\u5316\u5931\u6557",
  132013: "\u7528\u6236\u6D41\u6C34\u7372\u53D6\u7570\u5E38",
  132014: "\u6703\u8B70\u5BA4\u9810\u5B9A\u65E5\u671F\u8207\u6703\u8B70\u65E5\u671F\u4E0D\u5339\u914D",
  132015: "\u7121\u6548\u7684\u6703\u8B70\u6642\u9593",
  132016: "\u5609\u8CD3\u624B\u6A5F\u865F\u7232\u7A7A\u6216\u8005\u683C\u5F0F\u932F\u8AA4",
  132017: "\u8ACB\u5728\u6703\u8B70\u5BA4\u751F\u6548\u6642\u959324\u5C0F\u6642\u4E4B\u524D\u53D6\u6D88",
  132018: "\u5728\u9A30\u8A0A\u6703\u8B70SSO\u5E73\u81FA\u522A\u9664\u7528\u6236\u5931\u6557",
  132019: "\u5728\u9A30\u8A0A\u6703\u8B70\u5E73\u81FA\u522A\u9664\u7528\u6236\u5931\u6557",
  132020: "\u6703\u8B70\u5BA4\u5C0D\u61C9\u7684\u8CC7\u6E90\u5305\u904E\u671F\uFF0C\u7121\u6CD5\u522A\u9664",
  132021: "\u6703\u8B70\u5BA4\u5728\u8A72\u6642\u9593\u6BB5\u5DF2\u6709\u5176\u4ED6\u6703\u8B70",
  132022: "\u8A72\u6642\u6BB5\u53EF\u9810\u5B9A\u6703\u8B70\u5BA4\u6578\u91CF\u72320\uFF0C\u8ACB\u806F\u7E6B\u5BA2\u670D\u8655\u7406",
  132023: "\u6703\u8B70\u5BA4\u7684\u5275\u5EFA\u7BC4\u570D\u572830\u5929\u4EE5\u5167",
  132024: "\u6703\u8B70\u5DF2\u958B\u59CB\uFF0C\u4E0D\u5141\u8A31\u4FEE\u6539",
  132025: "\u6703\u8B70\u5DF2\u958B\u59CB\uFF0C\u4E0D\u5141\u8A31\u522A\u9664",
  132026: "\u50C5\u652F\u6301\u7D04\u5B9A30\u5929\u5167\u7684\u6703\u8B70\u5BA4",
  132027: "\u7121\u6548\u7684\u6703\u8B70\u53C3\u8207\u8005\u6D41\u6C34",
  133001: "\u5275\u5EFA\u4E3B\u64AD\u6B0A\u9650\u95DC\u806F\u4FE1\u606F\u5931\u6557",
  133002: "\u522A\u9664\u4E3B\u64AD\u6B0A\u9650\u95DC\u806F\u4FE1\u606F\u5931\u6557",
  133003: "\u7121\u6548\u7684\u4E3B\u64AD\u67E5\u8A62",
  133004: "\u5275\u5EFA\u6578\u91CF\u8D85\u904E\u4E0A\u9650",
  133005: "\u4E3B\u6301\u4EBA\u5DF2\u767B\u9304",
  133006: "\u66B1\u7A31\u4E0D\u80FD\u7232\u7A7A",
  133007: "\u53E3\u4EE4\u932F\u8AA4",
  133008: "\u7121\u6548\u7684appId",
  133009: "\u7121\u6548\u7684\u623F\u9593\u4FE1\u606F",
  133010: "\u7121\u6548\u7684\u4E3B\u64AD",
  133011: "\u8A72\u540D\u7A31\u5DF2\u5B58\u5728\uFF0C\u8ACB\u91CD\u65B0\u8A2D\u7F6E",
  133012: "\u7576\u524D\u6B63\u5728\u76F4\u64AD\u4E2D\uFF0C\u4E0D\u652F\u6301\u66F4\u65B0\u4E3B\u6301\u4EBA\u53E3\u4EE4",
  133113: "\u53C3\u6578\u4FE1\u606F\u5B58\u5728\u7F3A\u5931",
  133114: "\u4FEE\u6539\u4E3B\u64AD\u4FE1\u606F\u5931\u6557",
  133115: "\u4E3B\u6301\u4EBA\u5DF2\u767B\u9304",
  133116: "\u4E3B\u6301\u4EBA\u7121\u6CD5\u624B\u52D5\u5275\u5EFA",
  133117: "\u975E\u9023\u9EA5\u76F4\u64AD\u7121\u5609\u8CD3",
  133118: "\u5609\u8CD3\u5DF2\u767B\u9304",
  133119: "\u8A72\u623F\u9593\u985E\u578B\u7684\u52A9\u7406\u6C92\u6709\u8A72\u6B0A\u9650\uFF0C\u8ACB\u91CD\u65B0\u9078\u64C7",
  133120: "\u52A9\u7406\u6B0A\u9650\u4E0D\u80FD\u7232\u7A7A",
  133121: "\u52A9\u7406\u76E3\u63A7\u6B0A\u9650\u7232\u5FC5\u586B\u9805",
  133122: "\u8ACB\u4F7F\u7528\u7DB2\u9801\u7AEF\u9032\u5165",
  133994: "\u7121\u6548\u7684\u767B\u9304\u7528\u6236",
  133995: "\u5BC6\u78BC\u932F\u8AA4\u8D85\u904E10\u6B21\uFF0C\u8ACB\u572830\u5206\u9418\u5F8C\u91CD\u8A66\uFF01",
  133996: "\u975E\u6CD5\u7684\u623F\u9593\u6B0A\u9650",
  133997: "\u8CEC\u865F\u4E0D\u5B58\u5728\uFF0C\u8ACB\u806F\u7E6B\u4E3B\u8FA6\u65B9",
  133998: "\u4E3B\u6301\u4EBA\u4E0D\u80FD\u522A\u9664",
  134001: "\u5275\u5EFA\u79DF\u6236\u5546\u54C1\u7570\u5E38",
  134002: "\u4FEE\u6539\u79DF\u6236\u5546\u54C1\u7570\u5E38",
  134003: "\u522A\u9664\u79DF\u6236\u5546\u54C1\u7570\u5E38",
  134004: "\u7121\u6548\u79DF\u6236\u5546\u54C1",
  134011: "\u5275\u5EFA\u623F\u9593\u5546\u54C1\u7570\u5E38",
  134012: "\u4FEE\u6539\u623F\u9593\u5546\u54C1\u7570\u5E38",
  134013: "\u522A\u9664\u623F\u9593\u5546\u54C1\u7570\u5E38",
  134014: "\u7121\u6548\u623F\u9593\u5546\u54C1",
  134015: "\u5275\u5EFA\u623F\u9593\u5546\u54C1\u53C3\u6578\u7121\u6548",
  134016: "\u623F\u9593\u6392\u5E8F\u5B57\u6BB5\u7570\u5E38",
  134017: "\u623F\u9593\u6392\u5E8F\u53C3\u6578\u7570\u5E38",
  134018: "\u7B2C\u4E00\u500B\u6216\u8005\u6700\u5F8C\u4E00\u500B\u4E0D\u652F\u6301\u4E0A\u79FB\u4E0B\u79FB",
  134019: "\u7121\u6548\u7684\u5A92\u9AD4\u5EAB\u8CC7\u6E90",
  134020: "\u4E0A\u50B3\u5716\u7247\u5931\u6557",
  134021: "\u5546\u54C1\u540D\u4E0D\u80FD\u91CD\u8907",
  134022: "\u5546\u54C1\u50F9\u683C\u9700\u5C0F\u65BC\u5283\u7DDA\u50F9\u683C",
  134024: "\u623F\u9593\u5167\u6700\u5927\u6DFB\u52A050\u500B\u5546\u54C1",
  134995: "\u7121\u6548\u7684\u767B\u9304\u7528\u6236",
  135001: "\u522A\u9664\u5A92\u9AD4\u5EAB\u8CC7\u6E90\u5931\u6557",
  135002: "\u79FB\u81F3\u5A92\u9AD4\u5EAB\u5931\u6557",
  135003: "\u66AB\u5B58\u5A92\u8CC7\u4E0D\u5B58\u5728",
  135004: "\u7269\u7406\u522A\u9664\u66AB\u5B58\u5EAB\u8CC7\u6E90\u5931\u6557",
  135005: "\u4FDD\u5B58\u522A\u9664\u8A18\u9304\u5931\u6557",
  135006: "\u57F7\u884C\u7269\u7406\u522A\u9664\u5A92\u9AD4\u5EAB\u5A92\u8CC7\u5931\u6557",
  135007: "\u57F7\u884C\u7269\u7406\u522A\u9664\u66AB\u5B58\u5EAB\u5A92\u8CC7\u5931\u6557",
  135011: "\u522A\u9664\u5931\u6557\uFF0C\u8ABF\u7528\u9A30\u8A0A\u96F2\u522A\u9664\u5A92\u8CC7\u63A5\u53E3\u5931\u6557",
  135012: "\u5275\u5EFA\u5A92\u9AD4\u5EAB\u4E0A\u50B3\u6587\u4EF6\u8A18\u9304\u5931\u6557",
  135013: "\u5275\u5EFA\u5A92\u9AD4\u5EAB\u6587\u4EF6\u5931\u6557",
  135014: "\u7121\u6548\u7684\u5A92\u8CC7\u4FE1\u606F",
  135015: "\u66F4\u65B0\u5A92\u9AD4\u5EAB\u4E0A\u50B3\u6587\u4EF6\u8A18\u9304\u5931\u6557",
  135016: "\u66F4\u65B0\u5A92\u9AD4\u5EAB\u6587\u4EF6\u5931\u6557",
  135017: "\u8ACB\u6C42\u6B21\u6578\u9054\u5230\u6700\u5927\u503C",
  135018: "\u7121\u6548\u7684\u5A92\u9AD4\u5EAB\u6587\u4EF6",
  135019: "\u7121\u6548\u7684\u5A92\u9AD4\u5EAB\u6587\u4EF6\u4E0A\u50B3\u8A18\u9304",
  135020: "\u7269\u7406\u522A\u9664\u5A92\u9AD4\u5EAB\u8CC7\u6E90\u5931\u6557",
  135021: "\u5A92\u9AD4\u5EAB\u6587\u4EF6\u540D\u7A31\u4E0D\u80FD\u7232\u7A7A",
  135022: "\u5275\u5EFA\u5A92\u9AD4\u5EAB\u8F49\u78BC\u8A18\u9304\u5931\u6557",
  135023: "\u66F4\u65B0\u5A92\u9AD4\u5EAB\u8F49\u78BC\u8A18\u9304\u5931\u6557",
  135024: "\u6587\u4EF6\u8F49\u78BC\u4E2D\u6216\u8F49\u78BC\u6210\u529F\uFF0C\u7121\u6CD5\u8F49\u78BC",
  135025: "\u7121\u6548\u7684\u8F49\u78BC\u4EFB\u52D9",
  135026: "\u7121\u6548\u7684\u8996\u983B\u4F86\u6E90",
  135027: "\u4E0A\u50B3\u968A\u5217\u6700\u591A\u652F\u630120\u689D",
  135028: "\u522A\u9664\u7DB2\u7D61\u4E0A\u50B3\u8A18\u9304\u5931\u6557",
  135029: "\u91CD\u50B3\u7DB2\u7D61\u4E0A\u50B3\u6587\u4EF6\u5931\u6557",
  135030: "\u5275\u5EFA\u5A92\u9AD4\u5EAB\u8F49\u78BC\u6587\u4EF6\u5931\u6557",
  135031: "\u66F4\u65B0\u5A92\u9AD4\u5EAB\u8F49\u78BC\u6587\u4EF6\u5931\u6557",
  135032: "\u7B49\u5F85\u4E0A\u50B3\u53CA\u4E0A\u50B3\u5931\u6557\u624D\u80FD\u522A\u9664",
  135033: "\u4E0A\u50B3\u5931\u6557\u624D\u80FD\u91CD\u50B3",
  135034: "\u6587\u4EF6\u672A\u8F49\u78BC\u6216\u8F49\u78BC\u4E2D\uFF0C\u7121\u6CD5\u522A\u9664",
  135035: "\u4FEE\u6539\u8996\u983B\u6587\u4EF6\u904E\u671F\u6642\u9593\u5931\u6557",
  135036: "\u8996\u983B\u5DF2\u88AB\u522A\u9664\uFF0C\u7121\u6CD5\u64AD\u653E",
  135037: "\u4FEE\u6539\u5A92\u9AD4\u5EAB\u4E0A\u50B3\u8A18\u9304\u5931\u6557",
  135038: "\u5275\u5EFA\u5A92\u9AD4\u5EAB\u4E0A\u50B3\u8A18\u9304\u5931\u6557",
  135039: "\u7121\u6548\u7684\u5A92\u9AD4\u5EAB\u4E0A\u50B3\u8A18\u9304",
  135040: "\u6700\u591A\u9078\u64C720\u500B\u5A92\u9AD4\u6587\u4EF6",
  135041: "\u7121\u6548\u7684\u5A92\u9AD4\u5EAB\u5B58\u5132\u8CC7\u6E90\u4FE1\u606F",
  135042: "\u5275\u5EFA\u5A92\u9AD4\u6AA2\u6E2C\u4EFB\u52D9\u5931\u6557",
  135043: "\u4FEE\u6539\u5A92\u9AD4\u6AA2\u6E2C\u4EFB\u52D9\u5931\u6557",
  135044: "\u4FEE\u6539\u5A92\u9AD4\u8868\u6AA2\u6E2C\u72C0\u614B\u5931\u6557",
  135045: "\u76EE\u7779\u96F2\u6AA2\u6E2C\u7D50\u679C\u56DE\u8ABF\u7D50\u679C\u7232\u7A7A",
  135046: "mdf\u540C\u6B65\u6AA2\u6E2C\u72C0\u614B\u5931\u6557",
  135047: "\u5275\u5EFAmdf\u6AA2\u6E2C\u4EFB\u52D9\u5931\u6557",
  135048: "\u7B49\u5F85\u8F49\u78BC\u3001\u8F49\u78BC\u4E2D\u3001\u8F49\u78BC\u5931\u6557\u7684\u5A92\u8CC7\u4E0D\u80FD\u8F49\u78BC",
  135049: "\u7121\u6548\u7684\u8F49\u78BC\u5206\u8FA8\u7387",
  135050: "\u8A72\u8996\u983B\u5DF2\u6709%s\u7684\u8F49\u78BC\u8996\u983B\uFF0C\u8ACB\u52FF\u91CD\u8907\u8F49\u78BC",
  135051: "\u8A72\u8996\u983B\u7684%s\u6B63\u5728\u8F49\u78BC\u4E2D\uFF0C\u8ACB\u7A0D\u5F8C\u67E5\u8A62\u7D50\u679C",
  135052: "\u78BC\u7387\u672A\u8D85\u904E5Mbps",
  135053: "\u8A72\u8996\u983B\u6B63\u5728\u8F49\u78BC\u4E2D\uFF0C\u7121\u6CD5\u522A\u9664",
  135054: "\u50C5\u8996\u983B\u6587\u4EF6\u53EF\u4EE5\u8F49\u78BC",
  135055: "\u6AA2\u6E2C\u6210\u529F\u7684\u5A92\u8CC7\u624D\u80FD\u8F49\u78BC",
  135056: "\u6587\u4EF6\u5B58\u5728\u5F15\u7528\uFF0C\u7121\u6CD5\u522A\u9664",
  135057: "\u8996\u983B\u7570\u5E38\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  136001: "\u91CD\u8907\u7684\u5546\u6236\u652F\u4ED8\u8A02\u55AE\u865F",
  136002: "\u5546\u6236\u4ED8\u6B3E\u5FAE\u4FE1\u914D\u7F6E\u4E0D\u5B58\u5728",
  136003: "\u5546\u6236\u4ED8\u6B3E\u8A02\u55AE\u4E0D\u5B58\u5728",
  137001: "\u4E0D\u5B58\u5728\u7684\u76F4\u64AD\u9593",
  137002: "\u7D50\u675F\u865F\u53EC\u5931\u6557",
  137003: "\u865F\u53EC\u5DF2\u7D93\u7D50\u675F",
  137004: "\u865F\u53EC\u5DF2\u7D93\u7D50\u675F",
  137005: "\u80FD\u529B\u4E0D\u5B58\u5728",
  137006: "\u623F\u9593\u5B58\u5728\u6B63\u5728\u9032\u884C\u7684\u865F\u53EC",
  137007: "\u6D3B\u52D5\u5DF2\u7D50\u675F\uFF0C\u7121\u6CD5\u767C\u8D77\u865F\u53EC",
  137008: "\u7372\u53D6\u5177\u9AD4\u865F\u53EC\u80FD\u529B\u4FE1\u606F\u932F\u8AA4",
  137009: "\u5275\u5EFA\u865F\u53EC\u5931\u6557",
  137010: "\u5275\u5EFA\u865F\u53EC\u5931\u6557",
  137011: "\u522A\u9664\u865F\u53EC\u5931\u6557",
  137012: "\u8ACB\u9078\u64C7\u672A\u958B\u5553\u7684\u7C3D\u5230",
  137013: "\u884C\u52D5\u865F\u53EC\u7684\u6301\u7E8C\u6642\u9593\u5927\u65BC\u7C3D\u5230\u6642\u9577,\u8ACB\u91CD\u65B0\u9078\u64C7\u6301\u7E8C\u6642\u9593",
  137014: "\u8ACB\u5148\u958B\u5553\u7C3D\u5230\u529F\u80FD",
  137015: "\u6709\u7C3D\u5230\u6B63\u5728\u9032\u884C\u4E2D\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  137016: "\u884C\u52D5\u865F\u53EC\u7684\u7C3D\u5230\u958B\u5553\u5931\u6557",
  138001: "\u63A8\u5EE3\u6E20\u9053\u4E0D\u5B58\u5728",
  138002: "\u8A72\u6E20\u9053\u5DF2\u4E0B\u67B6",
  138003: "\u8A72\u6E20\u9053\u5DF2\u5931\u6548",
  139001: "\u7121\u6548\u7684\u901A\u77E5",
  139002: "\u5275\u5EFA\u901A\u77E5\u5931\u6557",
  139003: "\u4FEE\u6539\u901A\u77E5\u5931\u6557",
  139004: "\u50C5\u5F85\u767C\u9001\u53D6\u6D88\u53EF\u4EE5\u7DE8\u8F2F",
  139005: "\u5275\u5EFA\u901A\u77E5\u5C0D\u8C61\u5931\u6557",
  139006: "\u4FEE\u6539\u901A\u77E5\u5C0D\u8C61\u5931\u6557",
  139007: "\u53D6\u6D88\u5931\u6557\uFF0C\u6539\u901A\u77E5\u5DF2\u767C\u9001\u6210\u529F",
  14e4: "\u5275\u5EFA\u8A02\u55AE\u5831\u8868\u5931\u6557",
  140001: "\u4FEE\u6539\u8A02\u55AE\u5831\u8868\u72C0\u614B\u5931\u6557",
  140002: "\u72C0\u614B\u53D6\u503C\u7BC4\u570D\u72321-2",
  140003: "\u7121\u6548\u7684\u8A02\u55AE\u5831\u8868",
  140004: "\u522A\u9664\u6587\u4EF6\u5931\u6557",
  140005: "\u7121\u6548\u7684\u5831\u8868\u4E0B\u8F09\u5730\u5740",
  140006: "\u7814\u8A0E\u6703\u89C0\u770B\u81E8\u6642\u4F75\u767C \u61C9\u9078\u64C7 \u7814\u8A0E\u6703\u623F\u9593",
  141e3: "\u5275\u5EFA\u6578\u64DA\u5C0E\u51FA\u4EFB\u52D9\u5931\u6557",
  141001: "\u7576\u524D\u5DF2\u6709\u5C0E\u51FA\u4EFB\u52D9\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  141002: "\u4FEE\u6539\u6578\u64DA\u5C0E\u51FA\u72C0\u614B\u5931\u6557",
  141003: "\u5C0E\u51FA\u72C0\u614B\u53D6\u503C\u7BC4\u570D\u72320-2",
  141004: "\u7121\u6548\u7684\u6578\u64DA\u5C0E\u51FA\u4EFB\u52D9",
  141005: "\u522A\u9664\u6578\u64DA\u5C0E\u51FA\u4EFB\u52D9\u5931\u6557",
  141006: "\u7121\u6548\u7684\u5C0E\u51FA\u4EF6\u4E0B\u8F09\u5730\u5740",
  142001: "\u7121\u6548\u7684\u958B\u767C\u8005\u61C9\u7528",
  142002: "\u7121\u6548\u7684appSecret",
  142003: "\u5275\u5EFA\u5BA2\u6236\u7570\u5E38",
  142004: "\u4FEE\u6539\u61C9\u7528",
  142005: "\u61C9\u7528\u7955\u9470\u53EA\u80FD\u4E0B\u8F09\u4E00\u6B21",
  142006: "\u5275\u5EFA\u80FD\u529B\u7570\u5E38",
  142007: "\u7DE8\u8F2F\u80FD\u529B\u7570\u5E38",
  142008: "\u67E5\u8A62\u80FD\u529B\u8A73\u60C5\u7570\u5E38",
  142009: "\u522A\u9664\u80FD\u529B\u8A73\u60C5\u7570\u5E38",
  142010: "\u522A\u9664\u80FD\u529B-\u6B0A\u9650\u95DC\u806F\u7570\u5E38",
  142011: "\u5275\u5EFA\u80FD\u529B-\u6B0A\u9650\u95DC\u806F\u7570\u5E38",
  142012: "IP \u4E0D\u5408\u6CD5",
  142013: "\u8ACB\u5148\u958B\u5553\u958B\u653E\u5E73\u81FA\u529F\u80FD",
  143001: "\u4E0D\u5B58\u5728\u7684\u7522\u54C1",
  144001: "\u5BA2\u6236\u4E0D\u5B58\u5728",
  145001: "\u80FD\u529B\u4E0D\u5B58\u5728",
  145002: "\u91CD\u8907\u95DC\u806F\u6B0A\u9650\u7570\u5E38",
  146001: "\u6B78\u5C6C\u7D44\u7E54\u5275\u5EFA\u7684\u61C9\u7528\u6578\u91CF\u9054\u5230\u4E0A\u9650",
  146002: "\u7CFB\u7D71\u7E41\u5FD9\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  146003: "\u61C9\u7528\u4E0D\u5B58\u5728",
  146004: "\u975E\u6CD5\u8A2A\u554F\u61C9\u7528\u6578\u64DA",
  146005: "\u61C9\u7528\u4E0D\u5B58\u5728\u6216\u8005\u5BE9\u8988\u521D\u59CB\u72C0\u614B\u7570\u5E38",
  146006: "\u4FEE\u6539\u61C9\u7528\u5931\u6557",
  146007: "\u61C9\u7528key\u6216\u61C9\u7528\u6191\u8B49\u4E0D\u6B63\u78BA",
  146008: "\u61C9\u7528\u672A\u5553\u7528",
  146009: "\u61C9\u7528\u5DF2\u88AB\u7981\u7528",
  146010: "\u5BA2\u6236\u4E0D\u5B58\u5728",
  146011: "\u5BA2\u6236\u5DF2\u88AB\u7981\u7528",
  146012: "\u61C9\u7528key\u5275\u5EFA\u7570\u5E38\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  146013: "\u6388\u6B0A\u5BA2\u6236\u5DF2\u88AB\u7981\u7528",
  146014: "\u61C9\u7528\u4E0A\u9650\u6578\u91CF\u9700\u5927\u65BC\u5DF2\u4F7F\u7528\u6578\u91CF",
  146015: "grantType \u53C3\u6578\u4E0D\u6B63\u78BA",
  146016: "scope \u53C3\u6578\u4E0D\u6B63\u78BA",
  146017: "\u5916\u90E8\u7528\u6236\u552F\u4E00\u6A19\u8B58\u4E0D\u80FD\u7232\u7A7A",
  146018: "\u6D3B\u52D5\u865F\u548C\u6D3B\u52D5id\u4E0D\u80FD\u90FD\u7232\u7A7A",
  146019: "\u8A72\u61C9\u7528\u4E0D\u5B58\u5728\u6216\u672A\u5553\u7528",
  146020: "\u958B\u555F\u7BA1\u7406\u54E1\u767B\u9678URL\u9700\u914D\u7F6E\u5730\u5740",
  147001: "\u984F\u8272\u7DE8\u865F\u932F\u8AA4",
  147002: "\u4E3B\u984C\u4FEE\u6539\u5931\u6557",
  147003: "\u4E3B\u984C\u521D\u59CB\u5316\u5931\u6557",
  148e3: "\u5275\u5EFA\u6578\u64DA\u5C0E\u51FA\u4EFB\u52D9\u5931\u6557",
  148001: "\u7576\u524D\u5DF2\u6709\u5C0E\u51FA\u4EFB\u52D9\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  148002: "\u4FEE\u6539\u6578\u64DA\u5C0E\u51FA\u72C0\u614B\u5931\u6557",
  148003: "\u5C0E\u51FA\u72C0\u614B\u53D6\u503C\u7BC4\u570D\u72320-2",
  148004: "\u7121\u6548\u7684\u6578\u64DA\u5C0E\u51FA\u4EFB\u52D9",
  148005: "\u522A\u9664\u6578\u64DA\u5C0E\u51FA\u4EFB\u52D9\u5931\u6557",
  148006: "\u7121\u6548\u7684\u5C0E\u51FA\u4EF6\u4E0B\u8F09\u5730\u5740",
  149001: "\u4FEE\u6539\u5716\u7247\u5EE3\u544A\u5931\u6557",
  149002: "\u4E0D\u5B58\u5728\u7684\u5EE3\u544A\u9805id",
  149003: "\u4FEE\u6539\u5716\u7247\u5EE3\u544A\u9805\u5931\u6557",
  149004: "\u5141\u8A31\u95DC\u9589\u958B\u95DC\u72C0\u614B\u4E0D\u80FD\u7232\u7A7A",
  149005: "\u5EE3\u544A\u5716\u7247\u5217\u8868\u4E0D\u80FD\u7232\u7A7A",
  149006: "\u5EE3\u544A\u5716\u7247\u9805\u8DF3\u8F49\u5730\u5740\u683C\u5F0F\u4E0D\u6B63\u78BA",
  149007: "\u5C55\u793A\u4F4D\u7F6E\u4E0D\u80FD\u7232\u7A7A",
  15e4: "\u7121\u6548\u7684\u4F01\u696D\u8CC7\u6E90\u5305",
  150001: "\u4FEE\u6539\u4F01\u696D\u8CC7\u6E90\u5305\u5931\u6557",
  150002: "\u4F01\u696D\u5EAB\u5B58\u4E0D\u8DB3",
  150003: "\u4FEE\u6539\u4F01\u696D\u5EAB\u5B58\u5931\u6557",
  150004: "\u5275\u5EFA\u4F01\u696D\u8CC7\u6E90\u6D88\u8017\u6D41\u6C34\u5931\u6557",
  150005: "\u5A92\u9AD4\u5EAB\u5BB9\u91CF\u4E0D\u8DB3",
  150006: "\u5BA2\u6236\u6578\u91CF\u4E0D\u8DB3",
  150007: "\u77ED\u4FE1\u8CC7\u6E90\u4E0D\u8DB3\uFF0C\u8ACB\u806F\u7E6B\u7BA1\u7406\u54E1",
  150008: "\u5217\u8868\u76F4\u64AD\u6642\u9577\u8CC7\u6E90\u4E0D\u8DB3\uFF0C\u7121\u6CD5\u958B\u5553",
  150009: "\u5A92\u9AD4\u670D\u52D9\u6642\u9577\u8CC7\u6E90\u4E0D\u8DB3\uFF0C\u7121\u6CD5\u9032\u884C\u76F4\u64AD",
  150010: "\u7B2C\u4E09\u65B9\u8F49\u63A8\u6642\u9577\u4E0D\u8DB3",
  150011: "\u865B\u64EC\u6703\u8B70\u5BA4\u5EAB\u5B58\u4E0D\u8DB3",
  150012: "\u7B2C\u4E09\u65B9\u8F49\u63A8\u6642\u9577\u4E0D\u8DB3",
  150013: "\u9A57\u8B49\u78BC\u7372\u53D6\u5931\u6557\uFF0C\u8ACB\u806F\u7E6B\u4E3B\u8FA6\u65B9",
  150014: "\u7121\u6CD5\u64AD\u653E\uFF0C\u8ACB\u806F\u7E6B\u4E3B\u8FA6\u65B9",
  150015: "\u8CC7\u6E90\u5EAB\u5B58\u91CF\u4E0D\u8DB3",
  150016: "\u4F75\u767C\u8CC7\u6E90\u4E0D\u8DB3\uFF0C\u7121\u6CD5\u64AD\u653E",
  150017: "\u9023\u9EA5\u6642\u9577\u8CC7\u6E90\u4E0D\u8DB3",
  150018: "\u8D85\u6E05\u97F3\u8996\u983B\u9023\u9EA5\u6642\u9577\u5EAB\u5B58\u4E0D\u8DB3",
  150020: "\u672A\u77E5\u7684\u7BA1\u63A7\u5206\u7D44",
  150021: "\u901A\u7528\u8CC7\u6E90\u7BA1\u63A7\u7570\u5E38",
  150022: "\u7814\u8A0E\u6703\u8CC7\u6E90\u4E0D\u8DB3",
  150023: "\u64AD\u653E\u932F\u8AA4\uFF0C\u8CC7\u6E90\u4E0D\u8DB3",
  150024: "\u7814\u8A0E\u6703\u53EF\u5275\u5EFA\u6578\u91CF\u4E0D\u8DB3",
  150025: "\u7121\u6548\u7684\u7248\u672C",
  150026: "\u7576\u524D\u7248\u672C\u6700\u591A\u5275\u5EFA1\u500B\u76F4\u64AD\u9593\uFF0C\u8ACB\u5148\u5347\u7D1A\u7248\u672C",
  150027: "\u7576\u524D\u7248\u672C\u7121\u6CD5\u5275\u5EFA\u4E0D\u540C\u985E\u578B\u7A7A\u9593\uFF0C\u8ACB\u5148\u5347\u7D1A\u7248\u672C",
  150028: "\u8ACB\u5148\u8CFC\u8CB7\u7814\u8A0E\u6703\u6703\u8B70\u5BA4\u8CC7\u6E90",
  150029: "\u9A57\u8B49\u78BC\u77ED\u4FE1\u5C1A\u672A\u914D\u7F6E\uFF0C\u8ACB\u806F\u7E6B\u4E3B\u8FA6\u65B9",
  150030: "\u8D85\u6E05\u7814\u8A0E\u6703\u8CC7\u6E90\u4E0D\u8DB3",
  150031: "\u8ACB\u5148\u8CFC\u8CB7\u8D85\u6E05\u7814\u8A0E\u6703\u6703\u8B70\u5BA4\u8CC7\u6E90",
  151001: "\u7121\u6548\u7684\u7DDA\u4E0A\u89C0\u8846",
  151002: "\u7121\u6548\u7684\u5728\u7DDA\u804A\u5929",
  151003: "\u7121\u6548\u7684\u5728\u7DDA\u79C1\u4FE1",
  151004: "\u7121\u6548\u7684\u5728\u7DDA\u7528\u6236\u985E\u578B",
  151005: "\u7121\u6548\u7684\u8ACB\u6C42\u53C3\u6578",
  151006: "\u60A8\u7121\u6B0A\u9650\u9032\u5165\u8A72\u6703\u5834",
  151007: "\u8D85\u904E\u623F\u9593\u7F6E\u9802\u9650\u5236",
  151008: "\u7BA1\u7406\u54E1\u5DF2\u95DC\u9589\u804A\u5929\u529F\u80FD",
  151009: "\u533F\u540D\u7528\u6236\u4E0D\u5141\u8A31\u804A\u5929",
  151010: "\u958B\u59CB\u7C3D\u5230\u7570\u5E38",
  151011: "\u95DC\u9589\u7C3D\u5230\u7570\u5E38",
  151012: "\u7372\u53D6\u7C3D\u5230\u6578\u64DA\u7570\u5E38",
  151013: "\u5C0E\u51FA\u7C3D\u5230\u6578\u64DA\u5931\u6557\u7C3D\u5230\u5C1A\u672A\u7D50\u675F",
  151014: "\u7576\u524D\u7C3D\u5230\u5834\u6B21\u672A\u7D50\u675F",
  151015: "\u65B0\u589E\u7C3D\u5230\u7528\u6236\u7570\u5E38",
  151016: "\u4F60\u5728\u7981\u8A00\u5217\u8868\u4E2D",
  151017: '\u60A8\u767C\u9001\u7684\u5167\u5BB9\u5305\u542B\u654F\u611F\u8A5E"%s"',
  151018: "\u4FEE\u6539\u5728\u7DDA\u7528\u6236\u9023\u9EA5\u72C0\u614B\u7570\u5E38",
  151019: "\u8A72\u6D88\u606F\u672A\u5BE9\u8988,\u7981\u6B62\u64CD\u4F5C",
  151020: "\u804A\u5929\u5217\u8868\u67E5\u8A62\u8D85\u51FA\u4E86800\u689D\u9650\u5236",
  151021: "\u6C92\u6709\u6B0A\u9650\u4F86\u5275\u5EFA\u7D05\u5305",
  151022: "\u60A8\u8AAA\u7684\u592A\u5FEB\u4E86,\u4F11\u606F%s\u79D2\u5427",
  151023: "\u8ACB\u52FF\u983B\u7E41\u64CD\u4F5C",
  151024: "\u6D88\u606F\u670D\u52D9\u7570\u5E38\uFF0C\u8ACB\u5237\u65B0\u9801\u9762",
  151025: "\u5177\u540D\u7528\u6236\u533F\u540D\u804A\u5929\u95DC\u9589",
  151026: "\u7981\u8A00\u7528\u6236\u5DF2\u9054\u4E0A\u9650",
  151027: "\u8E22\u51FA\u7528\u6236\u5DF2\u9054\u4E0A\u9650",
  151028: "\u56DE\u8986\u5931\u6557,\u6D88\u606F\u5DF2\u88AB\u522A\u9664",
  151029: "\u804A\u5929\u5167\u5BB9\u4E0D\u5408\u898F",
  152001: "\u5275\u5EFA\u7DDA\u8DEF\u914D\u7F6E\u7570\u5E38",
  152002: "\u4FEE\u6539\u5168\u7403\u7DDA\u8DEF\u914D\u7F6E\u7570\u5E38",
  152003: "\u4FEE\u6539\u591A\u5206\u8FA8\u7387\u914D\u7F6E\u7570\u5E38",
  152004: "\u623F\u9593\u4E0D\u5B58\u5728",
  152005: "\u6B63\u5728\u63A8\u6D41\u4E2D",
  152006: "\u672A\u958B\u59CB\u76F4\u64AD",
  152007: "\u914D\u7F6E\u4E0D\u5B58\u5728\u6216\u8005\u672A\u958B\u5553\u591A\u5206\u8FA8\u7387\u914D\u7F6E",
  152008: "\u4FEE\u6539\u9ED8\u8A8D\u7DDA\u8DEF\u7570\u5E38",
  152009: "\u4FEE\u6539\u7DDA\u8DEF\u72C0\u614B\u7570\u5E38",
  152010: "\u4FEE\u6539\u7DDA\u8DEF\u540D\u7A31\u7570\u5E38",
  152011: "\u7121\u6548\u7684\u7B2C\u4E09\u65B9\u63A8\u6D41",
  152012: "\u4FEE\u6539\u7B2C\u4E09\u65B9\u63A8\u6D41\u7570\u5E38",
  152013: "\u5275\u5EFA\u7B2C\u4E09\u65B9\u63A8\u6D41\u7570\u5E38",
  152014: "\u522A\u9664\u7B2C\u4E09\u65B9\u63A8\u6D41\u7570\u5E38",
  152015: "\u5275\u5EFA\u76EE\u7779\u96F2\u63A8\u6D41\u7570\u5E38",
  152016: "\u7372\u53D6\u5206\u4F48\u5F0F\u9396\u7570\u5E38",
  152017: "\u7372\u53D6\u5716\u6587\u6578\u64DA\u7570\u5E38",
  152018: "\u91CB\u653E\u5206\u4F48\u5F0F\u9396\u7570\u5E38",
  152019: "\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  153001: '\u60A8\u767C\u9001\u7684\u516C\u544A\u5167\u5BB9\u5305\u542B\u654F\u611F\u8A5E"%s"',
  153002: "\u516C\u544A\u767C\u9001\u904E\u65BC\u983B\u7E41,\u8ACB5\u79D2\u5F8C\u91CD\u8A66",
  153003: "\u516C\u544A\u5167\u5BB9\u4E0D\u5408\u898F",
  154001: "\u7121\u6548\u7684\u71DF\u92B7\u5DE5\u5177",
  154002: "\u71DF\u92B7\u5DE5\u5177\u5553\u7528\u4E2D",
  154003: "\u5275\u5EFA\u71DF\u92B7\u5DE5\u5177\u7570\u5E38",
  154004: "\u4FEE\u6539\u71DF\u92B7\u5DE5\u5177\u7570\u5E38",
  154005: "\u522A\u9664\u71DF\u92B7\u5DE5\u5177\u7570\u5E38",
  154006: "\u76F8\u540C\u985E\u578B\u7684\u4E92\u52D5\u540C\u6642\u53EA\u80FD\u5553\u7528\u4E00\u500B,\u7576\u524D\u5553\u7528\u6578\u91CF\u7232%s",
  154007: "\u8868\u55AEID\u4E0D\u53EF\u4FEE\u6539",
  154008: "\u8868\u55AE\u554F\u984C\u4E0D\u53EF\u522A\u9664",
  154009: "\u554F\u984C\u4E0D\u53EF\u66F4\u63DB",
  154010: "\u554F\u984C\u985E\u578B\u4E0D\u53EF\u4FEE\u6539",
  154011: "\u9078\u9805\u4E0D\u53EF\u66F4\u63DB",
  154012: "\u9078\u9805\u4E0D\u53EF\u522A\u9664",
  154013: "\u984C\u76EE\u8D85\u51FA\u6700\u5927\u9650\u5236",
  154014: "\u63D0\u4EA4\u554F\u5377\u7232\u7A7A",
  154015: "\u5275\u5EFA\u71DF\u92B7\u5DE5\u5177\u95DC\u9375\u89C0\u8846\u7570\u5E38",
  154016: "\u8ACB\u52FF\u91CD\u8907\u586B\u5BEB",
  154017: "\u71DF\u92B7\u5DE5\u5177\u540D\u7A31\u4E0D\u652F\u6301\u91CD\u8907",
  154018: "\u63D0\u4EA4\u5BA2\u670D\u80FD\u529B\u7232\u7A7A",
  154019: "\u7121\u6548\u7684\u71DF\u92B7\u5DE5\u5177\u7D71\u8A08",
  154020: "\u71DF\u92B7\u5DE5\u5177\u672A\u5553\u7528",
  154021: "\u71DF\u92B7\u5DE5\u5177\u672A\u95DC\u806F\u80FD\u529B",
  154022: "\u6D3B\u52D5\u5DF2\u904E\u7D50\u675F\u6642\u9593\u4E0D\u53EF\u63D0\u4EA4\u554F\u5377",
  154023: "\u71DF\u92B7\u5DE5\u5177\u985E\u578B\u4E0D\u5B58\u5728\u554F\u5377",
  154024: "\u5275\u5EFA\u6587\u4EF6\u4E0B\u8F09\u7570\u5E38",
  154025: "\u7DE8\u8F2F\u6587\u4EF6\u4E0B\u8F09\u7570\u5E38",
  154026: "\u5275\u5EFA\u6587\u4EF6\u4E0B\u8F09\u53C3\u6578\u7570\u5E38",
  154027: "\u7121\u6548\u7684\u6587\u4EF6\u4E0B\u8F09",
  154028: "\u5275\u5EFA\u6587\u4EF6\u8A73\u60C5\u7570\u5E38",
  154029: "\u7DE8\u8F2F\u6587\u4EF6\u8A73\u60C5\u7570\u5E38",
  154030: "\u522A\u9664\u6587\u4EF6\u8A73\u60C5\u7570\u5E38",
  154031: "\u6587\u4EF6\u4E0A\u50B3\u5931\u6557",
  154032: "\u5275\u5EFA\u6587\u4EF6\u8A73\u60C5\u53C3\u6578\u7570\u5E38",
  154033: "\u71DF\u92B7\u5DE5\u5177\u985E\u578B\u7121\u6548",
  154034: "\u6587\u4EF6\u540D\u91CD\u8907",
  154035: "\u6587\u4EF6\u6578\u91CF\u9A57\u8B49\u5931\u6557 \u7576\u524D\u6578\u91CF%s",
  154036: "\u522A\u9664\u6587\u4EF6\u8A73\u60C5\u7570\u5E38",
  154037: "\u5275\u5EFA\u6587\u4EF6\u8A73\u60C5\u53C3\u6578\u7570\u5E38",
  155e3: "\u66F4\u65B0\u81EA\u5B9A\u7FA9\u83DC\u55AE\u6B04\u5931\u6557",
  155001: "\u6DFB\u52A0\u83DC\u55AE\u6B04\u8996\u983B\u5931\u6557",
  155002: "\u7121\u6548\u7684id",
  155003: "\u7121\u6548\u7684\u8996\u983B\u9805\u76EE",
  155004: "\u522A\u9664\u83DC\u55AE\u6B04\u8996\u983B\u5931\u6557",
  155005: "\u66F4\u65B0\u8996\u983B\u9806\u5E8F\u5931\u6557",
  155006: "\u7372\u53D6\u5A92\u9AD4\u5EAB\u8996\u983B\u4FE1\u606F\u5931\u6557",
  155007: "\u53C3\u6578\u932F\u8AA4",
  155008: "\u5275\u5EFA\u88DD\u4FEE\u4FE1\u606F\u5931\u6557",
  155009: "\u4FEE\u6539\u88DD\u4FEE\u4FE1\u606F\u5931\u6557",
  155010: "\u8ACB\u5148\u5275\u5EFA\u983B\u9053",
  155011: "\u7121\u6548\u7684\u81EA\u5B9A\u7FA9\u83DC\u55AE",
  155012: "\u79FB\u52D5ID\u7232\u7A7A",
  155013: "front ID\u7232\u7A7A",
  155014: "\u81EA\u5B9A\u7FA9\u83DC\u55AE\u6392\u5E8F\u7570\u5E38",
  155015: "URL\u7232\u7A7A",
  155016: "\u8907\u88FD\u88DD\u4FEE\u9801\u9078\u9805\u7232\u7A7A",
  155017: "\u5206\u7D44\u7232\u7A7A",
  155018: "\u4FEE\u6539\u88DD\u4FEE\u4FE1\u606F\u5931\u6557",
  155019: "\u522A\u9664\u5206\u7D44\u5167\u623F\u9593\u5931\u6557",
  155020: "\u5275\u5EFA\u5206\u7D44\u5167\u623F\u9593\u5931\u6557",
  155021: "\u5275\u5EFA\u5206\u7D44\u5931\u6557",
  155022: "\u5206\u7D44\u5167\u6C92\u6709\u5C0D\u65BC\u7684\u623F\u9593",
  155023: "\u8907\u88FD\u88DD\u4FEE\u65B9\u6848\u9078\u64C7\u7684\u623F\u9593\u6D3B\u52D5\u4E0D\u4E00\u81F4",
  155024: "\u8907\u88FD\u88DD\u4FEE\u65B9\u6848\u9078\u64C7\u7684\u623F\u9593\u4E00\u81F4",
  155025: "LOGO\u4E0D\u80FD\u62D6\u52D5",
  155026: "\u522A\u9664\u83DC\u55AE\u6B04\u5931\u6557",
  155027: "\u81EA\u5B9A\u7FA9\u83DC\u55AE\u6B04\u8996\u983B\u914D\u7F6E\u7570\u5E38",
  155028: "\u76F4\u64AD\u7C21\u4ECB\u4E3B\u6A19\u984C\u7232\u7A7A",
  155029: "\u958B\u59CB\u6642\u9593\u6216\u8005\u7D50\u675F\u6642\u9593\u70BA\u7A7A",
  155030: "\u5DF2\u6709\u76F4\u64AD\u7C21\u4ECB\u985E\u578B\u83DC\u55AE",
  155031: "\u6700\u591A\u53EF\u9078\u64C73\u7A2E\u9810\u8A2D\u6587\u6848",
  155032: "watermarkWordType \u53D6\u503C\u7BC4\u570D\u72320-1",
  155033: "\u6700\u5C11\u9078\u64C71\u7A2E\u9810\u8A2D\u6587\u6848",
  155034: "\u8ACB\u8F38\u5165\u5728\u7DDA\u7528\u6236\u958B\u95DC\u6A19\u8B58",
  155035: "\u5728\u7DDA\u7528\u6236\u958B\u95DC\u6A19\u8B58\u7684\u53D6\u503C\u7BC4\u570D\u72320~1",
  155036: "\u8ACB\u8F38\u5165\u5728\u7DDA\u7528\u6236\u982D\u50CF\u958B\u95DC\u6A19\u8B58",
  155037: "\u5728\u7DDA\u7528\u6236\u982D\u50CF\u958B\u95DC\u6A19\u8B58\u7684\u53D6\u503C\u7BC4\u570D\u72320~1",
  155038: "\u8ACB\u8F38\u5165\u5728\u7DDA\u7528\u6236\u7BC4\u570D",
  155039: "\u5728\u7DDA\u7528\u6236\u7BC4\u570D\u5FC5\u9808\u5305\u542B\u89C0\u8846",
  155040: "\u5728\u7DDA\u7528\u6236\u7BC4\u570D\u7684\u53D6\u503C\u7BC4\u570D\u7232%s~%s",
  155041: "\u7DE8\u8F2F\u5728\u7DDA\u7528\u6236\u914D\u7F6E\u5931\u6557",
  155042: "\u81F3\u5C11\u958B\u5553\u4E00\u500B\u8A9E\u8A00",
  156001: "\u6587\u4EF6\u5927\u5C0F\u6700\u59275M",
  156002: "\u7576\u524D\u5DF2\u6709\u5C0E\u5165\u4EFB\u52D9\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66",
  156003: "\u6587\u4EF6\u50C5\u652F\u6301xls,xlsx\u683C\u5F0F",
  156004: "\u55AE\u6B21\u6700\u591A\u5C0E\u51655w\uFF0C\u6700\u5C11\u5C0E\u51651\u689D",
  156005: "\u4E0A\u50B3\u6587\u4EF6\u5931\u6557",
  156007: "\u5275\u5EFA\u6578\u64DA\u4EFB\u52D9\u5C0E\u5165\u5931\u6557",
  156008: "\u4FEE\u6539\u6578\u64DA\u4EFB\u52D9\u5C0E\u5165\u5931\u6557",
  156009: "\u932F\u8AA4\u8A18\u9304\u8D85\u9650",
  156010: "\u8B80\u53D6\u6587\u4EF6\u5931\u6557",
  157001: "\u7121\u6548\u7684\u5C4F\u5E55\u63A7\u5236",
  157002: "\u5275\u5EFA\u5C4F\u5E55\u63A7\u5236\u5931\u6557",
  157003: "\u4FEE\u6539\u5C4F\u5E55\u63A7\u5236\u5931\u6557",
  157004: "\u4FEE\u6539\u5C4F\u5E55\u63A7\u5236\u4F48\u5C40\u5931\u6557",
  157005: "\u4FEE\u6539\u5C4F\u5E55\u63A7\u5236\u64AD\u55AEID\u5931\u6557",
  160001: "\u7576\u524D\u529F\u80FD\u672A\u958B\u5553\uFF0C\u8ACB\u806F\u7E6B\u7BA1\u7406\u54E1",
  160002: "\u57DF\u540D\u683C\u5F0F\u932F\u8AA4\uFF0C\u8ACB\u91CD\u65B0\u586B\u5BEB",
  160003: "\u7576\u524D\u57DF\u540D\u91CD\u8907\uFF0C\u8ACB\u91CD\u65B0\u586B\u5BEB",
  160004: "\u8B49\u66F8\u683C\u5F0F\u4E0D\u6B63\u78BA\uFF0C\u8ACB\u78BA\u8A8D\u5F8C\u91CD\u65B0\u63D0\u4EA4",
  160005: "\u8B49\u66F8\u548C\u57DF\u540D\u4E0D\u5339\u914D",
  160006: "\u8B49\u66F8\u6709\u6548\u6642\u9593\u4E0D\u8DB3\u4E00\u500B\u6708\uFF0C\u8ACB\u4F7F\u7528\u65B0\u7684\u8B49\u66F8",
  160007: "\u5BC6\u9470\u683C\u5F0F\u4E0D\u6B63\u78BA\uFF0C\u8ACB\u78BA\u8A8D\u5F8C\u91CD\u65B0\u63D0\u4EA4",
  160008: "\u8B49\u66F8\u548C\u5BC6\u9470\u89E3\u6790\u5931\u6557\uFF0C\u8ACB\u78BA\u8A8D\u5F8C\u91CD\u65B0\u63D0\u4EA4",
  160009: "\u8B49\u66F8\u8207\u5BC6\u9470\u4E0D\u5339\u914D\uFF0C\u8ACB\u78BA\u8A8D\u5F8C\u91CD\u65B0\u63D0\u4EA4",
  160010: "\u7576\u524D\u9801\u9762\u5DF2\u914D\u7F6E\uFF0C\u8ACB\u4FEE\u6539\u6216\u505C\u7528\u5F8C\u91CD\u65B0\u914D\u7F6E",
  160011: "\u7576\u524D\u9801\u9762\u672A\u914D\u7F6E\uFF0C\u8ACB\u5148\u914D\u7F6E\u57DF\u540D",
  160012: "\u96F2\u5EE0\u5546\u932F\u8AA4",
  160013: "\u8B49\u66F8\u90E8\u7F72\u5931\u6557",
  160014: "\u8B49\u66F8\u4FEE\u6539\u5931\u6557",
  160015: "\u7121\u6548\u9801\u9762id",
  160016: "\u6062\u5FA9\u9ED8\u8A8D\u5931\u6557",
  160017: "\u7528\u6236\u540D\u932F\u8AA4",
  160018: "\u57DF\u540D\u8207\u6D3B\u52D5\u4FE1\u606F\u4E0D\u5339\u914D",
  161001: "\u65B0\u589E\u6703\u87F2\u7528\u6236\u5931\u6557",
  161002: "\u65B0\u589E\u6703\u87F2IP\u5931\u6557",
  161003: "\u7121\u6548\u7684\u6703\u87F2\u7528\u6236",
  161004: "\u7121\u6548\u7684\u6703\u87F2IP",
  161005: "\u522A\u9664\u6703\u87F2\u7528\u6236\u5931\u6557",
  161006: "\u522A\u9664\u6703\u87F2IP\u5931\u6557",
  161007: "IP\u5DF2\u5B58\u5728",
  161008: "\u624B\u6A5F\u6216\u90F5\u7BB1\u5DF2\u5B58\u5728",
  162001: "\u65B0\u589E\u9ED1\u540D\u55AE\u7528\u6236\u5931\u6557",
  162002: "\u65B0\u589E\u9ED1\u540D\u55AEIP\u5931\u6557",
  162003: "\u7121\u6548\u7684\u9ED1\u540D\u55AE\u7528\u6236",
  162004: "\u7121\u6548\u7684\u9ED1\u540D\u55AEIP",
  162005: "\u522A\u9664\u9ED1\u540D\u55AE\u7528\u6236\u5931\u6557",
  162006: "\u522A\u9664\u9ED1\u540D\u55AEIP\u5931\u6557",
  162007: "IP\u5DF2\u5B58\u5728",
  162008: "\u624B\u6A5F\u6216\u90F5\u7BB1\u5DF2\u5B58\u5728",
  170001: "\u5831\u540D\u53C3\u8207\u5931\u6557\uFF0C\u8ACB\u806F\u7E6B\u7BA1\u7406\u54E1",
  170002: "\u7121\u6548\u623F\u9593",
  170003: "\u79FB\u9664\u53C3\u8207\u4EBA\u54E1\u5931\u6557\uFF0C\u8ACB\u806F\u7E6B\u7BA1\u7406\u54E1",
  170004: "\u62BD\u734E\u5DF2\u7D50\u675F",
  170005: "\u7121\u6548\u62BD\u734E",
  170006: "\u540C\u4E00\u76F4\u64AD\u9593\u62BD\u734E\u540D\u7A31\u4E0D\u652F\u6301\u91CD\u8907",
  170007: "\u62BD\u734E\u7684\u734E\u9805\u6578\u91CF\u6700\u591A\u723220\u500B",
  170008: "\u7121\u6548\u7684\u734E\u9805",
  170009: "\u6C92\u6709\u6B63\u5728\u9032\u884C\u4E2D\u7684\u62BD\u734E\u6D3B\u52D5",
  170010: "\u734E\u9805\u5DF2\u958B\u734E\uFF0C\u7121\u6CD5\u7DE8\u8F2F",
  170011: "\u734E\u9805\u5DF2\u958B\u734E\uFF0C\u7121\u6CD5\u522A\u9664",
  170012: "\u734E\u9805\u958B\u734E\u4E2D\uFF0C\u66AB\u6642\u7121\u6CD5\u95DC\u9589",
  170013: "\u7121\u6548\u7684\u734E\u54C1",
  170014: "\u8ACB\u52FF\u91CD\u8907\u958B\u734E",
  170015: "\u4FEE\u6539\u958B\u734E\u72C0\u614B\u7232\u958B\u734E\u4E2D\u5931\u6557",
  170016: "\u4FEE\u6539\u958B\u734E\u72C0\u614B\u5931\u6557",
  170017: "\u6709\u734E\u9805\u5728\u64CD\u4F5C\uFF0C\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  170018: "\u5275\u5EFA\u958B\u734E\u8A18\u9304\u5931\u6557",
  170019: "\u5275\u5EFA\u4E2D\u734E\u8A18\u9304\u5931\u6557",
  170020: "\u4FEE\u6539\u62BD\u734E\u7684\u4E2D\u734E\u4EBA\u6578\u5931\u6557",
  170021: "\u8ACB\u5148\u958B\u5553\u62BD\u734E\u6D3B\u52D5",
  170022: "\u62BD\u734E\u6D3B\u52D5\u5DF2\u7D50\u675F\uFF0C\u7121\u6CD5\u958B\u734E",
  170023: "\u7576\u524D\u62BD\u734E\u6D3B\u52D5\u5DF2\u7D93\u53C3\u8207\uFF0C\u8ACB\u52FF\u91CD\u8907\u5831\u540D\u53C3\u8207",
  170024: "\u53EA\u80FD\u6709\u4E00\u500B\u9032\u884C\u4E2D\u7684\u62BD\u734E\u6D3B\u52D5",
  170025: "\u4FEE\u6539\u53C3\u8207\u8005\u4E2D\u734E\u6B21\u6578\u5931\u6557",
  170026: "\u62BD\u734E\u72C0\u614B\u5DF2\u8B8A\u66F4\uFF0C\u8ACB\u5237\u65B0\u9801\u9762\u67E5\u770B",
  170027: "\u8ACB\u81F3\u5C11\u8A2D\u7F6E\u4E00\u500B\u734E\u9805",
  170028: "\u62BD\u734E\u6D3B\u52D5\u5DF2\u7D50\u675F",
  170029: "\u62BD\u734E\u6D3B\u52D5\u5DF2\u7D50\u675F\uFF0C\u7121\u6CD5\u522A\u9664\u53C3\u8207\u8005",
  170030: "\u62BD\u734E\u623F\u9593\u72C0\u614B\u7570\u5E38\uFF0C\u8ACB\u7A0D\u7B49",
  170031: "\u7121\u6548\u4EBA\u54E1\u4FE1\u606F",
  170032: "\u5275\u5EFA\u734E\u9805\u512A\u5148\u4E2D\u734E\u8005\u5931\u6557",
  170033: "\u522A\u9664\u734E\u9805\u512A\u5148\u4E2D\u734E\u8005\u5931\u6557",
  170034: "\u8A72\u62BD\u734E\u4E0D\u5141\u8A31\u5831\u540D\u53C3\u8207",
  170035: "\u7576\u524D\u62BD\u734E\u4E0D\u5141\u8A31\u89C0\u8846\u5831\u540D\uFF0C\u8ACB\u91CD\u65B0\u9078\u64C7\u62BD\u734E\u7BC4\u570D",
  170036: "\u7121\u6548\u7684\u62BD\u734E\u53C3\u8207\u8005",
  170037: "\u4E2D\u734E\u4EBA\u6578\u4E0D\u5F97\u5927\u65BC\u734E\u54C1\u6578\u91CF",
  170038: "\u7576\u524D\u734E\u54C1\u6578\u91CF\u5C0F\u65BC\u9810\u8A2D\u4E2D\u734E\u89C0\u8846\u6578\u91CF\uFF0C\u8ACB\u4FEE\u6539\u5F8C\u91CD\u8A66",
  170039: "\u7121\u6548\u7684\u62BD\u734E\u7BC4\u570D",
  170040: "\u672A\u652F\u6301\u6279\u91CF\u958B\u734E",
  170041: "\u53E3\u4EE4\u932F\u8AA4",
  170042: "\u8ACB\u5148\u586B\u5BEB\u53E3\u4EE4",
  170043: "\u62BD\u734E\u6D3B\u52D5\u958B\u555330\u5929\u5167\u672A\u64CD\u4F5C\u958B\u734E\uFF0C\u7121\u6CD5\u958B\u734E",
  171001: "\u5275\u5EFA\u6253\u8CDE\u6A21\u7248\u7570\u5E38",
  171002: "\u4FEE\u6539\u6253\u8CDE\u6A21\u7248\u7570\u5E38",
  171003: "\u522A\u9664\u6253\u8CDE\u6A21\u7248\u7570\u5E38",
  171004: "\u7121\u6548\u6253\u8CDE\u6A21\u7248",
  171010: "\u6A21\u7248\u540D\u7A31\u4E0D\u80FD\u91CD\u8907",
  171101: "\u5275\u5EFA\u6253\u8CDE\u6A21\u7248\u7570\u5E38",
  171102: "\u4FEE\u6539\u6253\u8CDE\u6A21\u7248\u7570\u5E38",
  171103: "\u522A\u9664\u6253\u8CDE\u6A21\u7248\u7570\u5E38",
  171104: "\u4FEE\u6539\u6253\u8CDE\u9053\u5177\u6392\u5E8F\u7570\u5E38",
  171105: "\u6700\u591A\u6DFB\u52A020\u500B\u6253\u8CDE\u9053\u5177",
  171106: "\u66F4\u65B0\u6253\u8CDE\u6A21\u677F\u958B\u5553\u6A19\u8A18\u5931\u6557",
  171110: "\u6253\u8CDE\u9053\u5177\u540D\u7A31\u4E0D\u5141\u8A31\u91CD\u8907",
  171111: "\u7121\u6548\u7684\u5546\u54C1\u9053\u5177",
  171112: "\u5546\u54C1\u9053\u5177\u5DF2\u7981\u7528",
  171113: "\u9053\u5177\u4ED8\u8CBB\u72C0\u614B\u932F\u8AA4",
  171114: "\u623F\u9593\u7981\u6B62\u6253\u8CDE",
  171115: "\u9053\u5177\u5553\u7528\u4E2D\uFF0C\u672A\u907F\u514D\u4F7F\u7528\u7570\u5E38\uFF0C\u8ACB\u95DC\u9589\u5F8C\u518D\u7DE8\u8F2F",
  171116: "\u8ACB\u52FF\u983B\u7E41\u64CD\u4F5C",
  183001: "\u7121\u6548\u7684\u76F4\u64AD\u89C0\u8846",
  183002: "\u8CEC\u865F\u4E0D\u80FD\u7232\u7A7A",
  183003: "\u624B\u6A5F\u865F\u78BC\u683C\u5F0F\u4E0D\u6B63\u78BA",
  183004: "\u6388\u6B0A\u6A21\u5F0F\u4E0D\u6B63\u78BA",
  183005: "\u9A57\u8B49\u78BC\u932F\u8AA4",
  183006: "\u4E0D\u5B58\u5728\u8A72\u7528\u6236",
  183007: "\u5BC6\u78BC\u932F\u8AA4",
  183008: "\u5275\u5EFA\u89C0\u8846\u5931\u6557",
  183009: "\u624B\u6A5F\u865F\u5DF2\u5B58\u5728\uFF0C\u4E0D\u5141\u8A31\u91CD\u8907",
  183010: "\u7372\u53D6\u5FAE\u4FE1\u6388\u6B0A\u93C8\u63A5\u7570\u5E38\uFF0Cscope\u7232\u7A7A",
  183011: "\u7372\u53D6\u5FAE\u4FE1\u6388\u6B0A\u93C8\u63A5\u7570\u5E38\uFF0Cscope\u7121\u6548",
  183012: "\u8ABF\u7528\u5FAE\u4FE1\u7DB2\u7D61\u8ACB\u6C42\u7570\u5E38",
  183013: "\u7121\u6548\u7684\u6388\u6B0A\u89C0\u8846",
  183014: "\u7372\u53D6\u5FAE\u4FE1\u7528\u6236\u6578\u64DA\u7570\u5E38",
  183015: "\u5275\u5EFA\u5FAE\u4FE1\u7528\u6236\u7570\u5E38",
  183016: "\u7D81\u5B9A\u7528\u6236\u7570\u5E38",
  183017: "\u67E5\u8A62\u7528\u6236token\u7570\u5E38",
  183018: "\u5FAE\u4FE1\u7528\u6236\u8207\u7576\u524D\u767B\u9304\u7528\u6236\u4E0D\u5339\u914D",
  183019: "\u5FAE\u4FE1\u6388\u6B0A\u8D85\u6642",
  183020: "\u7576\u524D\u767B\u9304\u7528\u6236\u5DF2\u7D93\u7D81\u5B9A\u5FAE\u4FE1",
  183021: "\u7372\u53D6\u5FAE\u4FE1\u6388\u6B0A\u93C8\u63A5\u623F\u9593\u865F\u7232\u7A7A",
  183022: "\u79DF\u6236\u672A\u914D\u7F6E\u5FAE\u4FE1\u6388\u6B0A\u4FE1\u606F",
  183023: "\u5FAE\u4FE1\u56DE\u8ABFcode\u7121\u6548",
  183024: "\u5FAE\u4FE1\u56DE\u8ABFstate\u7121\u6548",
  183025: "\u7528\u6236id\u7232\u7A7A",
  183026: "\u5FAE\u4FE1\u7372\u53D6accessToken\u7570\u5E38",
  183027: "\u5FAE\u4FE1\u7372\u53D6jsApiTicket\u7570\u5E38",
  183028: "\u623F\u9593\u865F\u4E0D\u80FD\u7232\u7A7A",
  183029: "\u6388\u6B0A\u8D85\u6642",
  183030: "\u516C\u8846\u865F\u6C92\u6709\u7D81\u5B9A\u958B\u653E\u5E73\u81FA",
  183031: "\u66AB\u4E0D\u652F\u6301\u958B\u653E\u5E73\u81FA\u7684\u6388\u6B0A\u65B9\u5F0F",
  183032: '\u60A8\u8F38\u5165\u7684\u5167\u5BB9\u5305\u542B\u654F\u611F\u8A5E"%s"\uFF0C\u8ACB\u4FEE\u6539\u5F8C\u91CD\u8A66\u3002',
  183033: `\u4E0D\u652F\u6301 ' " \\ / & > < \u7B49\u7279\u6B8A\u5B57\u7B26\u3002`,
  183034: "\u4FEE\u6539\u89C0\u8846\u5931\u6557",
  183035: "\u7121\u6548\u7684\u623F\u9593\u865F",
  183036: "\u5FAE\u4FE1\u56DE\u8ABF\u7570\u5E38",
  183037: "\u51C6\u5165\u65B9\u5F0F\u4E0D\u6B63\u78BA",
  183038: "\u624B\u6A5F\u865F/\u90F5\u7BB1\u4E0D\u80FD\u7232\u7A7A",
  183039: "\u9A57\u8B49\u78BC\u4E0D\u80FD\u7232\u7A7A",
  183040: "\u53E3\u4EE4\u4E0D\u80FD\u7232\u7A7A",
  183041: "\u53E3\u4EE4\u932F\u8AA4",
  183042: "\u90F5\u7BB1\u6216\u7B2C\u4E09\u65B9\u7DE8\u865F\u81F3\u5C11\u586B\u4E00\u500B",
  183043: "\u7528\u6236\u72C0\u614B\u4E0D\u80FD\u72321",
  183044: "\u89C0\u8846\u8D85\u904E1\u500B",
  183045: "\u4FEE\u6539\u79FB\u9664\u72C0\u614B\u5931\u6557",
  183046: "\u522A\u9664\u7528\u6236\u5931\u6557",
  183047: "\u5275\u5EFA\u7B2C\u4E09\u65B9\u8CEC\u865F\u5931\u6557",
  183048: "\u7372\u53D6\u7B2C\u4E09\u65B9\u8CEC\u865F\u5931\u6557",
  183050: "\u5FAE\u4FE1 appsecret \u914D\u7F6E\u4E0D\u6B63\u78BA",
  183051: "\u5FAE\u4FE1 appid \u914D\u7F6E\u4E0D\u6B63\u78BA",
  183052: "\u5FAE\u4FE1\u516C\u8846\u865F\u672A\u914D\u7F6EIP\u767D\u540D\u55AE",
  183053: "\u5FAE\u4FE1\u516C\u8846\u865F\u7570\u5E38\uFF0CIP\u9700\u7BA1\u7406\u54E1\u78BA\u8A8D",
  183054: "\u5FAE\u4FE1\u516C\u8846\u865F\u7570\u5E38\uFF0CIP\u7B49\u5F85\u7BA1\u7406\u54E1\u78BA\u8A8D\u4E2D",
  183055: "\u5FAE\u4FE1\u516C\u8846\u865F\u8ABF\u7528\u7570\u5E38\uFF0CIP\u88AB\u7BA1\u7406\u54E1\u62D2\u7D55",
  183056: "\u5FAE\u4FE1\u516C\u8846\u865F\u8ABF\u7528\u7570\u5E38\uFF0CIP\u88AB\u7BA1\u7406\u54E1\u62D2\u7D55",
  183057: "\u5FAE\u4FE1\u516C\u8846\u865FAppSecret\u914D\u7F6E\u932F\u8AA4",
  183058: "\u5FAE\u4FE1\u6388\u6B0Agrant_type\u50B3\u53C3\u7232\u975Eclient_credential",
  183059: "\u89C0\u8846\u5BE9\u8988\u5931\u6557",
  183060: "\u7576\u524D\u8CEC\u865F\u7232\u865B\u64EC\u8CEC\u865F",
  200001: "\u6578\u64DA\u7F3A\u5931",
  200002: "\u975E\u6CD5\u53C3\u6578",
  200003: "\u5C0E\u64AD\u81FA\u540D\u7A31\u6700\u9577255\u5B57\u7B26",
  200004: "\u96F2\u5C0E\u64AD\u81FA\u5C1A\u672A\u958B\u5553",
  200005: "\u96F2\u5C0E\u64AD\u81FA\u5DF2\u522A\u9664",
  200006: "\u96F2\u5C0E\u64AD\u81FA\u5DF2\u95DC\u9589",
  200007: "\u96F2\u5C0E\u64AD\u81FA\u5DF2\u958B\u5553",
  200008: "\u96F2\u5C0E\u64AD\u81FA\u5C1A\u672A\u95DC\u9589",
  200009: "\u5EF6\u6642\u64AD\u5DF2\u958B\u5553",
  200010: "\u5EF6\u6642\u64AD\u5DF2\u95DC\u9589",
  200011: "\u96F2\u5C0E\u64AD\u81FA\u4F7F\u7528\u6642\u9577\u8CC7\u6E90\u4E0D\u8DB3\uFF0C\u958B\u5553\u5931\u6557",
  200012: "\u5EF6\u6642\u64AD\u5C1A\u672A\u958B\u5553",
  200013: "\u5C0E\u64AD\u81FA\u958B\u5553\u4E2D",
  200014: "\u975E\u6CD5IP\u8ACB\u6C42",
  200015: "\u5C0E\u64AD\u81FA\u540D\u7A31\u50C5\u652F\u6301\u4E2D\u82F1\u6587\u548C\u6578\u5B57",
  200016: "\u64CD\u4F5C\u983B\u7E41",
  200017: "\u8CC7\u6E90\u6B63\u5728\u91CB\u653E\u4E2D\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66",
  200018: "\u8ACB\u5148\u95DC\u9589\u5EF6\u6642\u64AD",
  208e3: "\u7121\u6548\u7684\u6B0A\u9650",
  209e3: "\u7121\u6548\u7684\u89D2\u8272",
  209001: "\u5275\u5EFA\u89D2\u8272\u5931\u6557",
  209002: "\u4FEE\u6539\u89D2\u8272\u5931\u6557",
  209003: "\u522A\u9664\u89D2\u8272\u5931\u6557",
  209004: "\u8A72\u89D2\u8272\u5B58\u5728\u95DC\u806F\u7528\u6236",
  209005: "\u5275\u5EFA\u89D2\u8272\u6B0A\u9650\u95DC\u806F\u4FE1\u606F\u5931\u6557",
  209006: "\u522A\u9664\u89D2\u8272\u6B0A\u9650\u95DC\u806F\u4FE1\u606F\u5931\u6557",
  209007: "\u6DFB\u52A0\u6210\u54E1\u53C3\u6578\u932F\u8AA4",
  209008: "\u522A\u9664\u6210\u54E1\u53C3\u6578\u932F\u8AA4",
  209009: "\u89D2\u8272\u540D\u7A31\u4E0D\u53EF\u91CD\u8907",
  209010: "\u89D2\u8272\u4E0D\u53EF\u7DE8\u8F2F",
  21e4: "\u90F5\u7BB1\u548C\u624B\u6A5F\u4E0D\u80FD\u90FD\u7232\u7A7A",
  210001: "\u65B0\u589E\u4EBA\u54E1\u5931\u6557",
  210002: "\u4FEE\u6539\u4EBA\u54E1\u5931\u6557",
  210003: "\u7121\u6548\u7684\u4EBA\u54E1\u4FE1\u606F",
  210004: "\u624B\u6A5F\u865F\u78BC\u5DF2\u5B58\u5728",
  210005: "\u90F5\u7BB1\u5DF2\u5B58\u5728",
  210006: "\u624B\u6A5F\u865F/\u90F5\u7BB1\u4E0D\u5B58\u5728",
  210007: "\u624B\u6A5F\u865F/\u90F5\u7BB1\u5DF2\u5B58\u5728",
  210008: "\u5BC6\u78BC\u932F\u8AA4",
  210009: "\u820A\u5BC6\u78BC\u4E0D\u80FD\u7232\u7A7A",
  210010: "\u5FAE\u4FE1openId\u5DF2\u5B58\u5728",
  210011: "\u7B2C\u4E09\u65B9\u7528\u6236id\u5DF2\u5B58\u5728",
  210012: "\u7576\u524D\u7248\u672C\u4E0D\u652F\u6301\u5206\u7D44\u7BA1\u7406\uFF0C\u8ACB\u5148\u5347\u7D1A\u7248\u672C",
  22e4: "\u5206\u7D44\u6578\u91CF\u8D85\u904E\u79DF\u6236\u6700\u5927\u9650\u5236-",
  220001: "\u65B0\u589E\u4EBA\u54E1\u5206\u7D44\u5931\u6557",
  220002: "\u4FEE\u6539\u4EBA\u54E1\u5206\u7D44\u5931\u6557",
  220003: "\u7121\u6548\u7684\u4EBA\u54E1\u5206\u7D44",
  220004: "\u522A\u9664\u4EBA\u54E1\u5206\u7D44\u5931\u6557",
  220005: "\u5206\u7D44\u540D\u7A31\u5DF2\u5B58\u5728\uFF0C\u8ACB\u52FF\u91CD\u8907\u8F38\u5165",
  221001: "\u4E0D\u5B58\u5728\u7684\u7D05\u5305\u660E\u7D30",
  221002: "\u6301\u4E45\u5316\u7D05\u5305\u6578\u64DA\u660E\u7D30\u5931\u6557",
  221003: "\u6301\u4E45\u5316\u7D05\u5305\u6E20\u9053\u5F59\u7E3D\u6578\u64DA\u5931\u6557",
  221004: "\u4E0D\u5B58\u5728\u7684\u7D05\u5305\u5F59\u7E3D\u6578\u64DA",
  221005: "\u7121\u7AF6\u7B54\u4FE1\u606F",
  221006: "\u59D3\u540D\u4E0D\u80FD\u7232\u7A7A",
  221007: "\u624B\u6A5F\u4E0D\u80FD\u7232\u7A7A",
  221008: "\u90F5\u7BB1\u4E0D\u80FD\u7232\u7A7A",
  221009: "\u5730\u5740\u4E0D\u80FD\u7232\u7A7A",
  221010: "\u8868\u60C5\u5716\u7247\u5927\u5C0F\u8D85\u904E\u6700\u5927\u9650\u5236",
  221011: "\u8868\u60C5\u5716\u7247\u683C\u5F0F\u932F\u8AA4",
  221012: "\u8868\u60C5\u5716\u7247\u4E0A\u50B3\u6642\u9593\u8D85\u904E1\u5929",
  221013: "\u7576\u524D\u7248\u672C\u6700\u591A\u5275\u5EFA1\u5957\u8868\u60C5\u5305\uFF0C\u8ACB\u5148\u5347\u7D1A\u7248\u672C",
  221014: "\u6700\u591A\u5275\u5EFA5\u5957\u8868\u60C5\u5305",
  221015: "\u8868\u60C5\u5305\u540D\u7A31\u4E0D\u652F\u6301\u91CD\u8907",
  221016: "\u8868\u60C5\u4E0A\u50B3\u4E2D\uFF0C\u8ACB\u52FF\u64CD\u4F5C",
  221017: "\u4E0D\u5B58\u5728\u7684\u8868\u60C5\u5EAB",
  222001: "\u7814\u8A0E\u6703\u76F4\u64AD\u5834\u666F\u5FC5\u9808\u7232\u9023\u9EA5\u76F4\u64AD",
  222002: "\u7121\u6548\u7684\u64AD\u55AE",
  222003: "\u5275\u5EFA\u64AD\u55AE\u5931\u6557",
  222004: "\u4FEE\u6539\u64AD\u55AE\u5931\u6557",
  222005: "\u522A\u9664\u64AD\u55AE\u5931\u6557",
  222006: "\u64AD\u55AE\u6B63\u5728\u4F7F\u7528\u4E2D",
  222007: "\u64AD\u55AE\u672A\u914D\u7F6E\u8F38\u5165\u6E90",
  222008: "\u4FEE\u6539\u64AD\u55AE\u4F7F\u7528\u72C0\u614B\u5931\u6557",
  222009: "\u8ACB\u5148\u914D\u7F6E\u64AD\u55AE\u518D\u958B\u59CB\u76F4\u64AD",
  222010: "\u64AD\u55AE\u5B58\u5728\u76F8\u540C\u756B\u9762\uFF0C\u8ACB\u5148\u4FEE\u6539\u518D\u4FDD\u5B58",
  222011: "\u6B64\u914D\u7F6E\u4E0D\u80FD\u9078\u64C7\u5168\u5C4F",
  222012: "\u540C\u4E00\u6703\u8B70\u5167\u540D\u7A31\u4E0D\u652F\u6301\u91CD\u8907",
  222013: "\u50C5\u7814\u8A0E\u6703\u53EF\u4F7F\u7528\u64AD\u55AE",
  222014: "\u7B2C\u4E00\u500B\u6216\u8005\u6700\u5F8C\u4E00\u500B\u4E0D\u652F\u6301\u4E0A\u79FB\u4E0B\u79FB",
  222015: "\u64AD\u55AE\u6392\u5E8F\u5B57\u6BB5\u7570\u5E38",
  222016: "\u6700\u591A\u5275\u5EFA50\u500B\u64AD\u55AE",
  222017: "\u8ACB\u52FF\u983B\u7E41\u64CD\u4F5C",
  222018: "\u9810\u8A2D\u64AD\u55AE\u7121\u6CD5\u4FEE\u6539",
  222019: "\u9810\u8A2D\u64AD\u55AE\u7121\u6CD5\u522A\u9664",
  223001: "\u7121\u6548\u7684\u7AF6\u7B54",
  223002: "\u5275\u5EFA\u7AF6\u7B54\u5931\u6557",
  223003: "\u4FEE\u6539\u7AF6\u7B54\u5931\u6557",
  223004: "\u522A\u9664\u7AF6\u7B54\u5931\u6557",
  223005: "\u5275\u5EFA\u7AF6\u7B54\u734E\u54C1\u5931\u6557",
  223006: "\u4FEE\u6539\u7AF6\u7B54\u734E\u54C1\u5931\u6557",
  223007: "\u7AF6\u7B54\u540D\u7A31\u4E0D\u80FD\u91CD\u8907",
  223008: "\u50C5\u672A\u958B\u5553\u7684\u7AF6\u7B54\u53EF\u4EE5\u7DE8\u8F2F",
  223009: "\u50C5\u672A\u958B\u5553\u7684\u7AF6\u7B54\u53EF\u4EE5\u522A\u9664",
  223010: "\u7576\u524D\u6709\u9032\u884C\u4E2D\u7AF6\u7B54\uFF0C\u4E0D\u652F\u6301\u95DC\u9589",
  223011: "\u7AF6\u7B54\u72C0\u614B\u932F\u8AA4",
  223012: "\u8ACB\u5148\u958B\u5553\u7AF6\u7B54\u529F\u80FD",
  223013: "\u7576\u524D\u6709\u6B63\u5728\u9032\u884C\u4E2D\u7684\u7AF6\u7B54\uFF0C\u8ACB\u5148\u7D50\u675F",
  223014: "\u7121\u6548\u7684\u7AF6\u7B54\u734E\u54C1",
  223015: "\u5275\u5EFA\u7AF6\u7B54\u8A18\u9304\u5931\u6557",
  223016: "\u4FEE\u6539\u7AF6\u7B54\u8A18\u9304\u5931\u6557",
  223017: "\u6B63\u5728\u9032\u884C\u4E2D\u7684\u7AF6\u7B54\u5927\u65BC1\u500B",
  223018: "\u66AB\u7121\u7AF6\u7B54\u6D3B\u52D5",
  223019: "\u91CD\u8907\u7684\u7528\u6236\u7AF6\u7B54\u8A18\u9304",
  223020: "\u554F\u5377\u672A\u8A2D\u7F6E\u7B54\u6848",
  225001: "\u7121\u6548\u7684\u8003\u8A66",
  225002: "\u5275\u5EFA\u8003\u8A66\u5931\u6557",
  225003: "\u4FEE\u6539\u8003\u8A66\u5931\u6557",
  225004: "\u522A\u9664\u8003\u8A66\u5931\u6557",
  225005: "\u4E0D\u5B58\u5728\u9032\u884C\u4E2D\u7684\u8003\u8A66",
  225006: "\u9032\u884C\u4E2D\u7684\u8003\u8A66\u6578\u91CF\u7570\u5E38",
  225007: "\u8003\u8A66\u540D\u7A31\u4E0D\u80FD\u91CD\u8907",
  225008: "\u50C5\u672A\u958B\u5553\u7684\u8003\u8A66\u53EF\u4EE5\u7DE8\u8F2F",
  225009: "\u50C5\u672A\u958B\u5553\u7684\u8003\u8A66\u53EF\u4EE5\u522A\u9664",
  225010: "\u6B63\u5728\u9032\u884C\u4E2D\u7684\u8003\u8A66\u5927\u65BC1\u500B",
  225011: "\u50C5\u672A\u958B\u5553\u7684\u8003\u8A66\u53EF\u4EE5\u958B\u5553",
  225012: "\u4E0D\u5B58\u5728\u7684\u8003\u8A66\u4FE1\u606F",
  225013: "\u60A8\u4F86\u665A\u4E86\uFF0C\u7576\u524D\u8003\u8A66\u5DF2\u4E0D\u5141\u8A31\u9032\u5165",
  225014: "\u8003\u8A66\u5DF2\u7D50\u675F",
  225015: "\u5275\u5EFA\u8003\u8A66\u8A18\u9304\u5931\u6557",
  225016: "\u63D0\u554F\u672A\u7D50\u675F",
  225017: "\u8003\u8A66\u672A\u958B\u59CB",
  225018: "\u8003\u8A66\u5DF2\u958B\u5553\uFF0C\u7121\u9700\u91CD\u8907\u958B\u5553",
  225019: "\u8003\u8A66\u5DF2\u95DC\u9589\uFF0C\u7121\u9700\u91CD\u8907\u95DC\u9589",
  225020: "\u4E0D\u5B58\u5728\u7684\u8003\u8A66\u8A18\u9304",
  225021: "\u5DF2\u904E\u7B54\u984C\u6642\u9593",
  225022: "\u6587\u6A94\u4E0D\u7B26\u5408\u5C0E\u5165\u898F\u7BC4,\u8ACB\u6309\u7167EXCEL\u6587\u6A94\u6A21\u677F\u898F\u7BC4\u64CD\u4F5C",
  225023: "\u8ACB\u4E0A\u50B3.xls\u6216.xlsx\u683C\u5F0F\u6587\u4EF6",
  226001: "\u7121\u6548\u7684\u63D0\u554F",
  226002: "\u5275\u5EFA\u63D0\u554F\u5931\u6557",
  226003: "\u4FEE\u6539\u63D0\u554F\u5931\u6557",
  226004: "\u522A\u9664\u63D0\u554F\u5931\u6557",
  226005: "\u4E0D\u5B58\u5728\u9032\u884C\u4E2D\u7684\u63D0\u554F",
  226006: "\u9032\u884C\u4E2D\u7684\u63D0\u554F\u6578\u91CF\u7570\u5E38",
  226008: "\u50C5\u672A\u958B\u5553\u7684\u63D0\u554F\u53EF\u4EE5\u7DE8\u8F2F",
  226009: "\u50C5\u672A\u958B\u5553\u7684\u63D0\u554F\u53EF\u4EE5\u522A\u9664",
  226010: "\u6B63\u5728\u9032\u884C\u4E2D\u7684\u63D0\u554F\u5927\u65BC1\u500B",
  226011: "\u50C5\u672A\u958B\u5553\u7684\u63D0\u554F\u53EF\u4EE5\u958B\u5553",
  226012: "\u50C5\u9032\u884C\u4E2D\u7684\u63D0\u554F\u53EF\u4EE5\u7D50\u675F",
  226013: "\u4E0D\u5B58\u5728\u7684\u63D0\u554F\u4FE1\u606F",
  226014: "\u63D0\u554F\u5DF2\u516C\u4F48",
  226015: "\u63D0\u554F\u5DF2\u7D50\u675F",
  226016: "\u63D0\u554F\u672A\u7D50\u675F",
  226017: "\u91CD\u8907\u63D0\u4EA4",
  226018: "\u932F\u8AA4\u63D0\u4EA4\u9078\u9805",
  226019: "\u975E\u9032\u884C\u4E2D\u7684\u63D0\u554F\u4E0D\u53EF\u63D0\u4EA4\u7B54\u6848",
  226020: "\u6700\u591A\u9078\u64C7\u4E00\u500B\u7B54\u6848",
  226021: "\u8ACB\u81F3\u5C11\u9078\u64C7\u5169\u500B\u7B54\u6848",
  226022: "\u9078\u9805\u6578\u91CF\u6700\u591A50\u500B",
  226023: "\u9078\u9805\u672A\u63D0\u4EA4",
  226024: "\u8ACB\u52FF\u91CD\u8907\u4FEE\u6539",
  227001: "\u4E0D\u5B58\u5728\u7684\u5206\u767C\u4EFB\u52D9",
  227002: "\u5275\u5EFA\u5206\u767C\u4EFB\u52D9\u5931\u6557",
  227003: "\u6279\u91CF\u5275\u5EFA\u5206\u767C\u4EFB\u52D9\u5931\u6557",
  227004: "\u4FEE\u6539\u5206\u767C\u4EFB\u52D9\u5931\u6557",
  227005: "\u76EE\u6A19\u63A8\u6D41\u5730\u5740\u91CD\u8907",
  227006: "\u4E00\u6B21\u6700\u591A\u5275\u5EFA20\u500B\u76F4\u64AD\u5206\u767C\u4EFB\u52D9",
  227007: "\u76EE\u6A19\u63A8\u6D41\u5730\u5740\u91CD\u8907",
  227008: "\u6279\u91CF\u64CD\u4F5C\u53C3\u6578\u4E0D\u5C0D",
  227009: "\u522A\u9664\u5931\u6557",
  227010: "\u6279\u91CF\u522A\u9664\u5931\u6557",
  227011: "\u6279\u91CF\u64CD\u4F5C\u5931\u6557",
  227012: "\u591A\u96F2\u878D\u5408\u56DE\u8ABF\u53C3\u6578\u932F\u8AA4",
  227013: "\u7576\u524D\u76F4\u64AD\u5C1A\u672A\u958B\u59CB\uFF0C\u7121\u6CD5\u5553\u52D5\u76F4\u64AD\u5206\u767C\u4EFB\u52D9",
  227014: "\u8A72\u76F4\u64AD\u985E\u578B\u7981\u6B62\u6B64\u64CD\u4F5C",
  227015: "\u64CD\u4F5C\u983B\u7E41,\u8ACB\u7A0D\u5F8C\u91CD\u8A66",
  227016: "\u5206\u767C\u4EFB\u52D9\u9032\u884C\u4E2D\uFF0C\u7121\u6CD5\u522A\u9664",
  227017: "\u8A72\u4EFB\u52D9\u7981\u6B62\u6B64\u64CD\u4F5C",
  227018: "\u4E0D\u5B58\u5728\u7684\u5206\u767C\u5E73\u81FA",
  227019: "\u7576\u524D\u5217\u8868\u76F4\u64AD\u8996\u983B\u5927\u65BC1\u500B\uFF0C\u7121\u6CD5\u4F7F\u7528\u76F4\u64AD\u5206\u767C\u529F\u80FD",
  227020: "\u570B\u5167\u5E73\u81FA\u4E0D\u652F\u6301rtmps\u5354\u8B70",
  227021: "\u5206\u767C\u5E73\u81FA\u985E\u578B\u4E0D\u5339\u914D",
  228001: "\u6295\u7968\u540D\u7A31\u4E0D\u80FD\u91CD\u8907",
  228002: "\u5275\u5EFA\u6295\u7968\u5931\u6557",
  228003: "\u50C5\u672A\u958B\u5553\u7684\u6295\u7968\u53EF\u4EE5\u7DE8\u8F2F",
  228004: "\u7121\u6548\u7684\u6295\u7968",
  228005: "\u5DF2\u7D93\u6709\u4EBA\u6295\u7968",
  228006: "\u7DE8\u8F2F\u6295\u7968\u5931\u6557",
  228007: "\u50C5\u672A\u958B\u5553\u7684\u6295\u7968\u53EF\u4EE5\u522A\u9664",
  228008: "\u522A\u9664\u6295\u7968\u5931\u6557",
  228009: "\u6B63\u5728\u9032\u884C\u4E2D\u7684\u6295\u7968\u5927\u65BC1\u500B",
  228010: "\u7DE8\u8F2F\u6295\u7968\u72C0\u614B\u5931\u6557",
  228011: "\u91CD\u8907\u63D0\u4EA4",
  228012: "\u975E\u9032\u884C\u4E2D\u7684\u6295\u7968\u4E0D\u53EF\u63D0\u4EA4",
  228013: "\u5275\u5EFA\u6295\u7968\u8A18\u9304\u5931\u6557",
  228014: "\u8D85\u904E\u9078\u9805\u6578\u91CF",
  228015: "\u622A\u6B62\u6642\u9593\u81F3\u5C11\u665A\u65BC\u7576\u524D\u6642\u95931\u5206\u9418",
  229001: "\u5275\u5EFA\u64CD\u4F5C\u8A18\u9304\u5931\u6557",
  230001: "\u5EE0\u5546\u985E\u578B:%s\u4E0B\u66AB\u627E\u4E0D\u5230\u8A72\u63A5\u53E3: %s,\u8ACB\u4ED4\u7D30\u8988\u5C0D",
  230002: "\u5EE0\u5546\u985E\u578B:%s, \u66AB\u4E0D\u652F\u6301\u8A72\u63A5\u53E3: %s",
  230003: "\u8ABF\u7528\u96F2%s\u7684%s\u63A5\u53E3\u7570\u5E38: %s",
  230004: "\u96F2\u5EE0\u5546\u8ACB\u6C42\u56DE\u5305\u7232NULL",
  231001: "\u5275\u5EFA\u8CEC\u55AE\u5931\u6557",
  231002: "\u4FEE\u6539\u8CEC\u55AE\u5931\u6557",
  231003: "\u5275\u5EFA\u8CEC\u55AE\u4EFB\u52D9\u5931\u6557",
  231004: "\u5834\u6B21\u4E0D\u5B58\u5728",
  231005: "\u8CEC\u55AE\u751F\u6210\u5B8C\u7562\u66F4\u65B0\u4EFB\u52D9\u72C0\u614B\u5931\u6557",
  231006: "\u8CEC\u55AE\u7232\u7A7A",
  240001: "\u7C3D\u540D\u72C0\u614B\u4E0D\u6B63\u78BA\uFF0C\u8ACB\u6AA2\u67E5\u5F8C\u91CD\u8A66",
  240002: "AccessKey\u914D\u7F6E\u4E0D\u6B63\u78BA",
  240003: "\u7C3D\u540D\u4E0D\u5B58\u5728\uFF0C\u8ACB\u6AA2\u67E5\u5F8C\u91CD\u8A66",
  240004: "\u901A\u4FE1\u5931\u6557\uFF0C\u8ACB\u6AA2\u67E5\u914D\u7F6E\u9805",
  240005: "%s \u5FC5\u9808\u662F\u5927\u5C0F\u5BEB\u5B57\u6BCD\u3001\u6578\u5B57",
  240006: "\u5FC5\u586B\u9805\u672A\u914D\u7F6E",
  240007: "\u8ACB\u5148\u914D\u7F6E\u81EA\u6709\u77ED\u4FE1\u670D\u52D9",
  250001: "\u7DE8\u8F2F\u6A21\u677F\u5931\u6557\uFF0C\u8ACB\u6AA2\u67E5\u914D\u7F6E\u9805",
  250002: "%s \u5FC5\u9808\u662F\u5927\u5C0F\u5BEB\u5B57\u6BCD+\u6578\u5B57+_",
  250003: "\u5FC5\u586B\u9805\u672A\u914D\u7F6E",
  250004: "\u8ACB\u4F7F\u7528\u9A57\u8B49\u78BC\u985E\u578B\u7684\u77ED\u4FE1\u6A21\u677F",
  250005: "\u77ED\u4FE1\u6A21\u677F\u985E\u578B\u4E0D\u6B63\u78BA",
  250006: "\u77ED\u4FE1\u6A21\u677Fcode\u4E0D\u5B58\u5728\uFF0C\u8ACB\u6AA2\u67E5\u5F8C\u91CD\u8A66",
  250007: "\u77ED\u4FE1\u6A21\u677F\u4E2D\u5FC5\u9808\u6709{code}\u8B8A\u91CF",
  250008: "\u77ED\u4FE1\u6A21\u677F\u4E2D\u5B58\u5728\u4E0D\u652F\u6301\u7684\u8B8A\u91CF",
  250009: "\u77ED\u4FE1\u6A21\u677F\u5C1A\u672A\u901A\u904E\u5BE9\u8988\uFF0C\u8ACB\u78BA\u8A8D\u5F8C\u91CD\u8A66",
  250010: "\u77ED\u4FE1\u6A21\u677F\u4F7F\u7528\u5834\u666F\u91CD\u8907\uFF0C\u8ACB\u78BA\u8A8D\u5F8C\u91CD\u8A66",
  250011: "\u672A\u914D\u7F6E\u81EA\u6709\u77ED\u4FE1\u670D\u52D9",
  250012: "\u7372\u53D6\u77ED\u93C8\u7570\u5E38",
  250013: "\u77ED\u4FE1\u6A21\u677F\u4E2D\u5FC5\u9808\u6709{expireDate}\u8B8A\u91CF",
  250014: "\u77ED\u4FE1\u6A21\u677F\u4E0D\u5B58\u5728",
  260001: "\u8ACB\u52FF\u6DFB\u52A0\u91CD\u8907\u90F5\u7BB1",
  260002: "\u8ACB\u52FF\u6DFB\u52A0\u91CD\u8907\u624B\u6A5F\u865F",
  260003: "\u6DFB\u52A0\u806F\u7E6B\u4EBA\u5931\u6557",
  260004: "\u806F\u7E6B\u4EBA\u4E0D\u5B58\u5728",
  260005: "\u4FEE\u6539\u806F\u7E6B\u4EBA\u5931\u6557",
  260006: "\u8ACB\u5C07\u59D3\u540D\u548C\u90F5\u7BB1\u586B\u5BEB\u5B8C\u6574",
  260007: "\u90F5\u7BB1\u683C\u5F0F\u932F\u8AA4\uFF01",
  260008: "\u8ACB\u8F38\u5165\u59D3\u540D\uFF01",
  260009: "\u8ACB\u8F38\u5165\u90F5\u7BB1\u6216\u624B\u6A5F\u865F\uFF01",
  260010: "\u90F5\u7BB1/\u624B\u6A5F\u865F\u683C\u5F0F\u932F\u8AA4\uFF01",
  260011: "\u6DFB\u52A0\u81F3\u591A5\u500B\u806F\u7E6B\u4EBA",
  260012: "\u4E0D\u53EF\u522A\u9664",
  260013: "\u64CD\u4F5C\u5931\u6557\uFF0C\u8ACB\u91CD\u8A66",
  270001: "\u4FEE\u6539\u8CC7\u6E90\u9810\u8B66\u914D\u7F6E\u5931\u6557",
  280001: "\u5275\u5EFA\u7D50\u7B97\u55AE\u5931\u6557",
  280002: "\u7121\u6548\u7D50\u7B97\u55AE",
  290001: "\u5275\u5EFA\u623F\u9593\u6642\u521D\u59CB\u5316\u9810\u8A2D\u83DC\u55AE\u5931\u6557",
  290002: "\u7576\u524D\u623F\u9593\u6B63\u5728\u9810\u8A2D\u83DC\u55AE\u4E2D",
  290003: "\u65B0\u589E\u81EA\u5B9A\u7FA9\u83DC\u55AE\u5165\u5EAB\u5931\u6557",
  290004: "\u65B0\u589E\u81EA\u5B9A\u7FA9\u83DC\u55AE\u5931\u6557",
  290005: "\u7121\u6548\u83DC\u55AE",
  290006: "\u8ACB\u52FF\u8DE8\u623F\u9593\u64CD\u4F5C",
  290007: "\u7576\u524D\u83DC\u55AE\u6B63\u5728\u7DE8\u8F2F\u4E2D",
  290008: "\u4FEE\u6539\u83DC\u55AE\u4FE1\u606F\u5165\u5EAB\u5931\u6557",
  290009: "\u4FEE\u6539\u83DC\u55AE\u4FE1\u606F\u5931\u6557",
  290010: "\u7576\u524D\u83DC\u55AE\u6B63\u88AB\u522A\u9664\u4E2D",
  290011: "\u9810\u8A2D\u83DC\u55AE\u4E0D\u53EF\u522A\u9664",
  290012: "\u522A\u9664\u83DC\u55AE\u5165\u5EAB\u5931\u6557",
  290013: "\u522A\u9664\u83DC\u55AE\u5931\u6557",
  290014: "\u7576\u524D\u623F\u9593\u6B63\u5728\u57F7\u884C\u83DC\u55AE\u6392\u5E8F\u4E2D",
  290015: "\u79FB\u52D5\u7684\u83DC\u55AE\u7232\u7121\u6548\u83DC\u55AE",
  290016: "\u88AB\u79FB\u52D5\u7684\u83DC\u55AE\u7232\u7121\u6548\u83DC\u55AE",
  290017: "\u83DC\u55AE\u6392\u5E8F\u8ACB\u52FF\u8DE8\u623F\u9593\u64CD\u4F5C,\u79FB\u52D5\u7684\u83DC\u55AE\u4E0D\u5C6C\u65BC\u8A72\u623F\u9593\u4E0B",
  290018: "\u83DC\u55AE\u6392\u5E8F\u8ACB\u52FF\u8DE8\u623F\u9593\u64CD\u4F5C,\u88AB\u79FB\u52D5\u7684\u83DC\u55AE\u4E0D\u5C6C\u65BC\u8A72\u623F\u9593\u4E0B",
  290019: "\u83DC\u55AE\u6392\u5E8F\u8ACB\u52FF\u8DE8\u8A9E\u8A00\u64CD\u4F5C",
  290020: "\u83DC\u55AE\u6392\u5E8F\u5165\u5EAB\u5931\u6557",
  290021: "\u83DC\u55AE\u6392\u5E8F\u5931\u6557",
  290022: "\u4E0D\u652F\u6301\u7684\u83DC\u55AE\u7D44\u4EF6",
  290023: "\u9810\u8A2D\u83DC\u55AE\u7121\u6CD5\u6DFB\u52A0\u7D44\u4EF6",
  290024: "\u65B0\u589E\u9ED8\u8A8D\u503C\u7684%s\u7D44\u4EF6\u4FE1\u606F\u5165\u5EAB\u5931\u6557",
  290025: "\u65B0\u589E\u9ED8\u8A8D\u503C\u7684%s\u7D44\u4EF6\u4FE1\u606F\u5931\u6557",
  290026: "\u65B0\u589E\u9ED8\u8A8D\u503C\u7684\u7D44\u4EF6\u4FE1\u606F\u5931\u6557",
  290027: "\u55AE\u500B\u81EA\u5B9A\u7FA9\u83DC\u55AE\u4E0B\u6700\u591A\u6DFB\u52A0%s\u500B\u7D44\u4EF6",
  290028: "\u9810\u8A2D\u83DC\u55AE\u7121\u6CD5\u7DE8\u8F2F\u7D44\u4EF6",
  290029: "\u7981\u6B62\u8DE8\u83DC\u55AE\u7DE8\u8F2F\u7D44\u4EF6",
  290030: "\u7DE8\u8F2F\u7D44\u4EF6\u6642\u7684\u5165\u53C3[requestData]\u5C0D\u8C61\u8F49\u63DB\u5F8C\u5FC5\u9808\u662FJson\u5B57\u7B26\u4E32",
  290031: "\u7121\u6548\u7684%s\u7D44\u4EF6",
  290032: "\u7DE8\u8F2F%s\u7D44\u4EF6\u4FE1\u606F\u5931\u6557",
  290033: "\u9810\u8A2D\u83DC\u55AE\u7121\u6CD5\u522A\u9664\u7D44\u4EF6",
  290034: "\u7981\u6B62\u8DE8\u83DC\u55AE\u522A\u9664\u7D44\u4EF6",
  290035: "\u522A\u9664%s\u7D44\u4EF6\u4FE1\u606F\u5165\u5EAB\u5931\u6557",
  290036: "\u522A\u9664%s\u7D44\u4EF6\u4FE1\u606F\u5931\u6557",
  290037: "\u7DE8\u8F2F\u5BCC\u6587\u672C\u6846\u7D44\u4EF6\u6642\u6587\u672C\u5167\u5BB9\u5B57\u6578\u4E0D\u80FD\u8D85\u51FA%s\u5B57",
  290038: "\u9810\u8A2D\u83DC\u55AE\u7121\u6CD5\u67E5\u8A62\u7D44\u4EF6",
  290039: "\u7981\u6B62\u8DE8\u83DC\u55AE\u67E5\u8A62\u7D44\u4EF6",
  290040: "\u8ACB\u8F38\u5165\u958B\u59CB\u6642\u9593",
  290041: "\u8ACB\u8F38\u5165\u7D50\u675F\u6642\u9593",
  290042: "\u6700\u591A\u53EF\u914D\u7F6E%s\u5F35\u5716\u7247",
  290043: "\u7DE8\u8F2F%s\u7D44\u4EF6\u4FE1\u606F\u5165\u5EAB\u5931\u6557",
  290044: "%s\u6392\u5E8F\u4E0D\u5141\u8A31\u91CD\u8907",
  290045: "%s\u6392\u5E8F\u5FC5\u9808\u9023\u7E8C",
  290046: "\u6700\u591A\u53EF\u914D\u7F6E%s\u500B\u5408\u4F5C\u4F19\u4F34\u7FA3\u7D44",
  290047: "\u6700\u591A\u53EF\u914D\u7F6E%s\u500B\u5408\u4F5C\u4F19\u4F34",
  290048: "\u6700\u591A\u53EF\u914D\u7F6E%s\u500B\u6D3B\u52D5",
  290049: "\u6700\u591A\u53EF\u914D\u7F6E%s\u500B\u5834\u6240",
  290050: "\u5C0D\u83DC\u55AE\u4E0B\u7684\u7D44\u4EF6\u6392\u5E8F\u5165\u5EAB\u5931\u6557",
  290051: "\u5C0D\u83DC\u55AE\u4E0B\u7684\u7D44\u4EF6\u6392\u5E8F\u5931\u6557",
  290052: "\u7576\u524D\u83DC\u55AE\u4E0B\u7684\u7D44\u4EF6\u6B63\u5728\u6392\u5E8F\u4E2D",
  290053: "\u9810\u8A2D\u83DC\u55AE\u7121\u6CD5\u7D44\u4EF6\u6392\u5E8F",
  290054: "\u79FB\u52D5\u7684\u7D44\u4EF6\u7232\u7121\u6548\u7D44\u4EF6",
  290055: "\u88AB\u79FB\u52D5\u7684\u7D44\u4EF6\u7232\u7121\u6548\u7D44\u4EF6",
  290056: "\u7576\u524D\u623F\u9593\u6B63\u5728\u8907\u88FD\u88DD\u4FEE\u4E2D",
  290057: "\u8907\u88FD\u83DC\u55AE\u6216\u8005\u64AD\u653E\u5340\u7CBE\u5F69\u8996\u983B\u5931\u6557",
  290058: "\u8907\u88FD\u83DC\u55AE\u6216\u8005\u64AD\u653E\u5340\u7CBE\u5F69\u8996\u983B\u5165\u5EAB\u5931\u6557",
  290059: "\u6700\u591A\u53EF\u914D\u7F6E%s\u500B\u8996\u983B",
  290060: "\u6DFB\u52A0\u7CBE\u5F69\u8996\u983B\u5165\u5EAB\u5931\u6557",
  290061: "\u6DFB\u52A0\u7CBE\u5F69\u8996\u983B\u5931\u6557",
  290062: "\u8996\u983B\u985E\u578B\u7684\u83DC\u55AE\u4E0D\u5B58\u5728",
  290063: "\u4E0D\u5B58\u5728\u7684\u7CBE\u5F69\u8996\u983B",
  290064: "\u4FEE\u6539\u7CBE\u5F69\u8996\u983B\u5165\u5EAB\u5931\u6557",
  290065: "\u4FEE\u6539\u7CBE\u5F69\u8996\u983B\u5931\u6557",
  290066: "\u522A\u9664\u7CBE\u5F69\u8996\u983B\u5165\u5EAB\u5931\u6557",
  290067: "\u522A\u9664\u7CBE\u5F69\u8996\u983B\u5931\u6557",
  290068: "\u7576\u524D\u623F\u9593\u6B63\u5728\u57F7\u884C\u7CBE\u5F69\u8996\u983B\u6392\u5E8F\u4E2D",
  290069: "\u79FB\u52D5\u7684\u7CBE\u5F69\u8996\u983B\u7232\u7121\u6548\u8996\u983B",
  290070: "\u88AB\u79FB\u52D5\u7684\u7CBE\u5F69\u8996\u983B\u7232\u7121\u6548\u8996\u983B",
  290071: "\u7CBE\u5F69\u8996\u983B\u6392\u5E8F\u8ACB\u52FF\u8DE8\u623F\u9593\u64CD\u4F5C,\u79FB\u52D5\u7684\u7CBE\u5F69\u8996\u983B\u4E0D\u5C6C\u65BC\u8A72\u623F\u9593\u4E0B",
  290072: "\u7CBE\u5F69\u8996\u983B\u6392\u5E8F\u8ACB\u52FF\u8DE8\u623F\u9593\u64CD\u4F5C,\u88AB\u79FB\u52D5\u7684\u7CBE\u5F69\u8996\u983B\u4E0D\u5C6C\u65BC\u8A72\u623F\u9593\u4E0B",
  290073: "\u7CBE\u5F69\u8996\u983B\u6392\u5E8F\u8ACB\u52FF\u8DE8\u83DC\u55AE\u64CD\u4F5C,\u88AB\u79FB\u52D5\u7684\u7CBE\u5F69\u8996\u983B\u548C\u79FB\u52D5\u7684\u7CBE\u5F69\u8996\u983B\u7684\u6240\u5C6C\u83DC\u55AE\u4E0D\u5339\u914D",
  290074: "\u83DC\u55AE\u6578\u64DA\u9077\u79FB\u5165\u5EAB\u5931\u6557",
  290075: "\u7D44\u4EF6\u522A\u9664\u5F15\u8D77\u7684\u83DC\u55AE\u4E0B\u7684\u7D44\u4EF6\u5217\u8868\u91CD\u6392\u5E8F\u5165\u5EAB\u5931\u6557",
  290076: "\u65B0\u589E\u81EA\u5B9A\u7FA9\u83DC\u55AE\u8D85\u51FA\u9650\u5236,\u6700\u591A\u53EF\u65B0\u589E%s\u500B\u81EA\u5B9A\u7FA9\u83DC\u55AE",
  290077: "\u8ACB\u8F38\u5165\u5FAE\u4FE1\u4E8C\u7DAD\u78BC\u5716\u7247",
  290078: "\u8ACB\u8F38\u5165\u806F\u7E6B\u96FB\u8A71",
  290079: "\u8ACB\u8F38\u5165\u806F\u7E6B\u90F5\u7BB1",
  290080: "\u8ACB\u8F38\u5165\u806F\u7E6B\u5FAE\u535A\u5730\u5740",
  290081: "\u8ACB\u8F38\u5165\u806F\u7E6BFaceBook\u5730\u5740",
  290082: "\u6240\u9078\u8996\u983B\u5B58\u5728\u7121\u6548\u7684\u5A92\u9AD4\u5EAB\u8996\u983B",
  290083: "\u6240\u9078\u8996\u983B\u88AB\u522A\u9664,\u8ACB\u91CD\u65B0\u9078\u64C7",
  290084: "\u7576\u524D\u623F\u9593\u6B63\u5728\u83DC\u55AE\u6578\u64DA\u88DC\u511F\u4E2D",
  290085: "\u83DC\u55AE\u6578\u64DA\u88DC\u511F\u5931\u6557",
  290086: "\u7576\u524D\u623F\u9593\u6B63\u5728\u57F7\u884C\u963F\u62C9\u4F2F\u8A9E\u83DC\u55AE\u6578\u64DA\u88DC\u511F\u64CD\u4F5C",
  290998: "\u7981\u6B62\u8DE8\u79DF\u6236\u64CD\u4F5C",
  291001: "\u5275\u5EFA\u5206\u7D44\u9593\u914D\u7F6E\u932F\u8AA4",
  291002: "\u66F4\u65B0\u5206\u7D44\u9593\u914D\u7F6E\u932F\u8AA4",
  291003: "\u522A\u9664\u5206\u7D44\u9593\u914D\u7F6E\u932F\u8AA4",
  291004: "\u66F4\u65B0\u5206\u7D44\u9593\u914D\u7F6E\u932F\u8AA4",
  291005: "\u4E0D\u5B58\u5728\u7684\u5206\u7D44\u9593\u914D\u7F6E",
  291006: "\u9700\u8981\u5206\u7D44\u6578\u91CF\u53C3\u6578",
  291007: "\u5DF2\u5B58\u5728\u5206\u7D44\u9593\u914D\u7F6E,\u8ACB\u52FF\u91CD\u65B0\u5275\u5EFA",
  291008: "\u6700\u591A\u5141\u8A31\u6DFB\u52A050\u500B\u5206\u7D44",
  291101: "\u4E0D\u5B58\u5728\u7684\u5206\u7D44\u9593",
  291102: "\u5275\u5EFA\u5206\u7D44\u9593\u932F\u8AA4",
  291103: "\u522A\u9664\u5206\u7D44\u9593\u932F\u8AA4",
  291104: "\u66F4\u65B0\u5206\u7D44\u9593\u932F\u8AA4",
  291105: "\u66F4\u65B0\u5206\u7D44\u9593\u7D44\u9577\u4FE1\u606F\u932F\u8AA4",
  291106: "\u6279\u91CF\u522A\u9664\u5206\u7D44\u9593\u932F\u8AA4",
  291107: "\u6279\u91CF\u66F4\u65B0\u5206\u7D44\u9593\u7D44\u9577\u4FE1\u606F\u932F\u8AA4",
  291108: "\u5206\u7D44\u9593\u7533\u8ACB\u5354\u52A9\u72C0\u614B\u7232\u7A7A",
  291109: "\u7533\u8ACB\u5DF2\u5728\u8A72\u72C0\u614B\u4E2D",
  291110: "\u4E3B\u6301\u4EBA\u6B63\u5728\u5206\u7D44\u623F\u9593\u4E2D",
  291111: "\u5206\u7D44\u8A0E\u8AD6\u672A\u958B\u59CB",
  291112: "\u672A\u8A2D\u7F6E\u5206\u7D44\u9593",
  291113: "\u5206\u7D44\u9593\u8ACB\u6C42\u72C0\u614B\u4E0D\u6B63\u78BA",
  291301: "\u6210\u54E1\u5DF2\u6EFF,\u8ACB\u91CD\u65B0\u9078\u64C7\u5206\u7D44",
  291302: "\u6279\u91CF\u5275\u5EFA\u6210\u54E1\u5931\u6557",
  291303: "\u8ACB\u9EDE\u64CA\u5237\u65B0\u7372\u53D6\u6700\u65B0\u5217\u8868",
  291304: "\u6279\u91CF\u521D\u59CB\u5316\u6210\u54E1\u5931\u6557",
  291305: "\u6279\u91CF\u522A\u9664\u5206\u7D44\u9593\u6210\u54E1\u932F\u8AA4",
  291306: "\u5206\u914D\u6210\u54E1\u5931\u6557,\u8ACB\u5237\u65B0\u9801\u9762\u91CD\u8A66",
  291307: "\u6210\u54E1\u5DF2\u6EFF\uFF0C\u8ACB\u91CD\u65B0\u9078\u64C7\u5206\u7D44",
  291997: "\u8A0E\u8AD6\u9032\u884C\u4E2D,\u7981\u6B62\u6B64\u64CD\u4F5C",
  291998: "\u64CD\u4F5C\u983B\u7387\u904E\u5FEB\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66",
  292001: "\u7121\u6548\u7684\u5206\u7D44\u9593\u4EBA\u54E1",
  292002: "\u65B0\u589E\u5206\u7D44\u9593\u4EBA\u54E1\u5931\u6557",
  292003: "\u4FEE\u6539\u5206\u7D44\u9593\u4EBA\u54E1\u5931\u6557",
  292004: "\u522A\u9664\u5206\u7D44\u9593\u4EBA\u54E1\u5931\u6557",
  292005: "\u7576\u524D\u4EBA\u54E1\u5DF2\u7D93\u662F\u7D44\u9577",
  292006: "\u5206\u7D44\u6210\u54E1\u89D2\u8272id\u7372\u53D6\u5931\u6557",
  292007: "\u7576\u524D\u4EBA\u54E1\u5DF2\u7D93\u662F\u4E3B\u8B1B",
  292008: "\u539F\u4EBA\u54E1\u4E0D\u662F\u4E3B\u8B1B",
  292009: "\u8A72\u5206\u7D44\u4EBA\u54E1\u5DF2\u6EFF\uFF0C\u7121\u6CD5\u52A0\u5165!",
  292010: "\u60A8\u672A\u5728\u5206\u7D44\u8A0E\u8AD6\u4E2D",
  292011: "\u60A8\u5DF2\u5728\u5176\u4ED6\u5206\u7D44\u4E2D",
  292012: "\u6279\u91CF\u522A\u9664\u5206\u7D44\u9593\u4EBA\u54E1\u5931\u6557",
  292013: "\u4E3B\u6301\u4EBA\u4ECD\u5728\u5206\u7D44\u9593\uFF0C\u7121\u6CD5\u522A\u9664",
  292014: "\u4E3B\u6301\u4EBA\u7121\u6CD5\u6210\u7232\u7D44\u9577",
  292015: "\u60A8\u5DF2\u7D93\u5728\u5206\u7D44\u8A0E\u8AD6\u4E2D\uFF0C\u7121\u6CD5\u518D\u6B21\u9032\u5165",
  293001: "\u623F\u9593\u4E0D\u5728\u8A0E\u8AD6\u4E2D",
  293002: "\u623F\u9593\u6B63\u5728\u8A0E\u8AD6\u4E2D",
  293003: "\u958B\u5553\u5931\u6557\uFF0C\u7576\u524D\u66AB\u7121\u5206\u7D44",
  293004: "\u958B\u5553\u5931\u6557\uFF0C\u8ACB\u5148\u958B\u5553\u76F4\u64AD",
  294001: "\u5275\u5EFA\u79DF\u6236\u56DE\u8ABF\u914D\u7F6E\u7570\u5E38",
  294002: "\u91CD\u7F6E\u79DF\u6236\u56DE\u8ABF\u914D\u7F6E\u7570\u5E38",
  294003: "\u79DF\u6236\u56DE\u8ABF\u914D\u7F6E\u4E0D\u5B58\u5728",
  294004: "\u522A\u9664\u79DF\u6236\u56DE\u8ABF\u914D\u7F6E\u7570\u5E38",
  294005: "\u79DF\u6236\u56DE\u8ABF\u914D\u7F6E\u5DF2\u5B58\u5728",
  294006: "\u79DF\u6236\u56DE\u8ABF\u914D\u7F6E\u5DF2\u5B58\u5728",
  294100: "\u79DF\u6236\u56DE\u8ABF\u5DF2\u9054\u5230\u6700\u5927\u503C",
  295001: "\u81F3\u5C11\u958B\u555F\u4E00\u7A2E\u767B\u9304\u65B9\u5F0F",
  300001: "\u81EA\u5B9A\u7FA9\u4E92\u52D5\u6578\u91CF\u4E0D\u80FD\u8D85\u904E100",
  300002: "\u4E92\u52D5\u7DE8\u865F\u5DF2\u5B58\u5728",
  300101: "\u66F4\u65B0iframe\u914D\u7F6E\u5931\u6557",
  501e3: "\u7121\u6548\u7684\u90E8\u9580",
  501001: "\u7121\u6548\u7684\u7236\u90E8\u9580",
  501002: "\u7121\u6CD5\u4FEE\u6539\u9ED8\u8A8D\u90E8\u9580",
  501010: "\u5275\u5EFA\u90E8\u9580\u5931\u6557",
  501011: "\u4FEE\u6539\u90E8\u9580\u5931\u6557",
  501012: "\u522A\u9664\u90E8\u9580\u5931\u6557",
  501013: "\u540C\u7D1A\u90E8\u9580\u7684\u90E8\u9580\u540D\u7A31\u4E0D\u80FD\u91CD\u8907",
  501014: "\u4FEE\u6539\u90E8\u9580\u7B49\u7D1A\u5931\u6557",
  501015: "\u4FEE\u6539\u90E8\u9580\u72C0\u614B\u5931\u6557",
  501016: "\u8A72\u90E8\u9580\u4E0B\u4ECD\u6709\u6210\u54E1\uFF0C\u4E0D\u5141\u8A31\u7981\u7528",
  501017: "\u8A72\u90E8\u9580\u4E0B\u4ECD\u6709\u5553\u7528\u7684\u5B50\u90E8\u9580\uFF0C\u4E0D\u5141\u8A31\u7981\u7528",
  501018: "\u8A72\u7BC0\u9EDE\u4E0B\u4ECD\u6709\u6210\u54E1\uFF0C\u4E0D\u652F\u6301\u522A\u9664",
  502001: "\u5275\u5EFA\u5168\u7403\u4F75\u767C\u670D\u52D9\u914D\u5BD8\u5931\u6557",
  502002: "\u66F4\u65B0\u5168\u7403\u4F75\u767C\u670D\u52D9\u914D\u5BD8\u72C0\u614B\u5931\u6557",
  502003: "\u5728\u8A72\u751F\u6548\u6642\u9593\u7BC4\u570D\u4E0B\u5DF2\u5B58\u5728\u3010\u751F\u6548\u4E2D\u3011\u6216\u3010\u5F85\u751F\u6548\u3011\u7684\u958B\u901A\u8A18\u9304\uFF0C\u8ACB\u4F5C\u5EE2\u3010\u5F85\u751F\u6548\u3011\u8A18\u9304\u6216\u66F4\u6539\u751F\u6548\u6642\u9593\u5F8C\u91CD\u8A66\u3002",
  601001: "\u8A72\u7C3D\u5230\u7576\u524D\u72C0\u614B\u4E0D\u5141\u8A31\u522A\u9664",
  601003: "\u6578\u64DA\u7570\u5E38",
  601004: "\u7C3D\u5230\u72C0\u614B\u6709\u8AA4\uFF0C\u7121\u6CD5\u64CD\u4F5C\u958B\u5553\u6216\u95DC\u9589",
  601005: "\u8A72\u7C3D\u5230\u5DF2\u7D93\u958B\u5553",
  601006: "\u8A72\u7C3D\u5230\u5DF2\u7D93\u95DC\u9589",
  601007: "\u672A\u958B\u5553\u7684\u7C3D\u5230\u624D\u80FD\u7DE8\u8F2F",
  601009: "\u8ACB\u52FF\u91CD\u8907\u7C3D\u5230",
  601011: "\u8ACB\u5148\u958B\u5553\u7C3D\u5230\u529F\u80FD",
  601012: "\u5DF2\u6709\u7C3D\u5230\u9032\u884C\u4E2D\uFF0C\u8ACB\u52FF\u91CD\u8907\u767C\u8D77",
  601013: "\u7576\u524D\u7C3D\u5230\u5DF2\u522A\u9664\uFF0C\u8ACB\u91CD\u65B0\u5237\u65B0\u5217\u8868",
  601201: "\u6578\u7F8E\u63A5\u53E3\u672A\u77E5\u932F\u8AA4",
  601202: "\u654F\u611F\u8A5E\u91CD\u8907",
  601203: "\u654F\u611F\u8A5E\u9577\u5EA6\u904E\u9577",
  601204: "\u4E00\u6B21\u6027\u5C0E\u5165\u6578\u64DA\u904E\u591A",
  601205: "\u6578\u64DA\u5C0E\u5165\u4E2D\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66",
  601206: "\u81EA\u5EFA\u654F\u611F\u8A5E\u4E0D\u5B58\u5728",
  601207: "\u7121\u6B0A\u9650\u5207\u63DB\u8A72ai\u65B9\u6848",
  601300: "\u8CC7\u6599\u4E0D\u5B58\u5728\u6216\u5DF2\u522A\u9664",
  601301: "\u5305\u542B\u654F\u611F\u8A5E",
  601302: "\u7CFB\u7D71\u9810\u8A2D\u6578\u64DA\uFF0C\u4E0D\u5141\u8A31\u64CD\u4F5C",
  601303: "\u6BCF\u6B21\u50C5\u80FD\u5C0E\u51651000\u689D\u6578\u64DA",
  601304: "\u9577\u5EA6\u8D85\u9577",
  601305: "\u8ACB\u8F38\u51651-10000\u7684\u6578\u5B57",
  601306: "\u8ACB\u8F38\u51651-300\u7684\u6578\u5B57",
  601307: "\u8ACB\u8F38\u51651-20\u7684\u6578\u5B57",
  601308: "\u914D\u5BD8\u5DF2\u5B58\u5728",
  601309: "AI\u6C1B\u570D\u8005\u5DF2\u958B\u555F\uFF0C\u8ACB\u5237\u65B0\u9801\u9762",
  601310: "AI\u6C1B\u570D\u5E2B\u5DF2\u95DC\u9589\uFF0C\u8ACB\u5237\u65B0\u9801\u9762",
  601311: "AI\u6C1B\u570D\u5E2B\u5DF2\u66AB\u505C\uFF0C\u8ACB\u5237\u65B0\u9801\u9762",
  601312: "AI\u6C1B\u570D\u5E2B\u72C0\u614B\u975E\u6CD5\uFF0C\u8ACB\u5237\u65B0\u9801\u9762",
  601313: "\u672A\u76F4\u64AD\u6642\u7121\u6CD5\u958B\u555FAI\u6C1B\u570D\u5E2B",
  601314: "\u6635\u7A31\u5EAB\u6B63\u5728\u4F7F\u7528\u4E2D\uFF0C\u8ACB\u8ABF\u6574AI\u6C1B\u570D\u5E2B\u914D\u5BD8\u6216\u7D50\u675FAI\u6C1B\u570D\u5E2B\u5F8C\u91CD\u8A66",
  601315: "\u8A71\u8853\u5EAB\u6B63\u5728\u4F7F\u7528\u4E2D\uFF0C\u8ACB\u8ABF\u6574AI\u6C1B\u570D\u5E2B\u914D\u5BD8\u6216\u7D50\u675FAI\u6C1B\u570D\u5E2B\u5F8C\u91CD\u8A66",
  601316: "\u8ACB\u5148\u66AB\u505CAI\u6C1B\u570D\u5E2B",
  601317: "\u4F01\u696D\u6700\u591A\u53EF\u5275\u5EFA10\u500B\u6635\u7A31\u5EAB",
  601318: "\u5275\u5EFA\u5931\u6557\uFF0C\u5EAB\u5BB9\u91CF\u5DF2\u9054\u4E0A\u9650",
  601319: "\u6700\u591A\u53EF\u5275\u5EFA20\u500B\u8A71\u8853\u5EAB",
  601320: "\u6635\u7A31\u5EAB\u81F3\u5C11\u9700\u8981\u4FDD\u7559\u4E00\u689D\u8A18\u9304\uFF0C\u5982\u9700\u8981\u5220\u9664\u6240\u6709\u8A18\u9304\uFF0C\u5EFA\u8B70\u4F7F\u7528\u6635\u7A31\u5EAB\u5220\u9664\u529F\u80FD",
  601321: "\u8A71\u8853\u5EAB\u81F3\u5C11\u9700\u8981\u4FDD\u7559\u4E00\u689D\u8A18\u9304\uFF0C\u5982\u9700\u8981\u5220\u9664\u6240\u6709\u8A18\u9304\uFF0C\u5EFA\u8B70\u4F7F\u7528\u8A71\u8853\u5EAB\u5220\u9664\u529F\u80FD",
  601322: "\u64CD\u4F5C\u983B\u7E41",
  601323: "AI\u6C1B\u570D\u5E2B\u7684\u9078\u64C7\u6578\u91CF\u4E0D\u53EF\u5927\u65BC\u6635\u7A31\u5EAB\u4E2D\u6635\u7A31\u7684\u7E3D\u6578",
  602001: "\u8A71\u984C\u4E92\u52D5\u6578\u91CF\u8D85\u9650",
  602002: "\u8A71\u984C\u56DE\u8986\u5DF2\u95DC\u9589\uFF0C\u7121\u6CD5\u56DE\u8986",
  602003: "\u672A\u958B\u5553\u8A71\u984C\u9EDE\u8D0A",
  602004: "\u672A\u958B\u5553\u56DE\u8986\u9EDE\u8D0A",
  602005: "\u4E0D\u9700\u8981\u5BE9\u8988",
  602006: "\u8A71\u984C\u4E0D\u5B58\u5728",
  602007: "\u56DE\u8986\u5167\u5BB9\u4E2D\u6709\u654F\u611F\u8A5E\uFF0C\u8ACB\u91CD\u65B0\u7DE8\u8F2F",
  602008: "\u8A71\u984C\u958B\u95DC\u672A\u958B\u5553",
  602009: "\u7981\u8A00\u4E2D\uFF0C\u60A8\u7121\u6CD5\u53C3\u8207\u8A71\u984C\u4E92\u52D5",
  602010: "\u60A8\u5DF2\u9EDE\u8D0A",
  602011: "\u56DE\u8986\u5C1A\u7232\u901A\u904E\u5BE9\u8988",
  602012: "\u8A71\u984C\u5DF2\u7F6E\u9802",
  602013: "\u8A71\u984C\u5DF2\u53D6\u6D88\u7F6E\u9802",
  602014: "\u8A72\u56DE\u5FA9\u5DF2\u5BE9\u8988\u901A\u904E\uFF0C\u8ACB\u5237\u65B0\u5217\u8868",
  602015: "\u8A72\u56DE\u5FA9\u5DF2\u88AB\u522A\u9664\uFF0C\u8ACB\u5237\u65B0\u5217\u8868",
  603001: "\u6700\u591A\u6DFB\u52A010\u5F35\u6D77\u5831",
  603002: "\u6578\u64DA\u7372\u53D6\u5931\u6557",
  603003: "\u6D77\u5831\u6578\u64DA\u6DFB\u52A0\u5931\u6557",
  603004: "room\u5339\u914D\u932F\u8AA4",
  603005: "\u6D3B\u52D5\u5339\u914D\u932F\u8AA4",
  603006: "\u6D77\u5831\u4FEE\u6539\u5931\u6557",
  603007: "\u6D77\u5831\u522A\u9664\u5931\u6557",
  603008: "\u8ACB\u5148\u958B\u5553\u6D77\u5831\u5206\u4EAB\u958B\u95DC",
  603009: "\u5206\u4EAB\u914D\u7F6E\u91CD\u8907\u5275\u5EFA",
  604001: "\u7BA1\u7406\u54E1\u5DF2\u95DC\u9589\u804A\u5929\u529F\u80FD",
  604002: "\u804A\u5929\u5DF2\u7F6E\u9802",
  604003: "\u804A\u5929\u5C1A\u672A\u7F6E\u9802",
  604004: "\u804A\u5929\u5DF2\u5BE9\u8988",
  604005: "\u804A\u5929\u4E0D\u9700\u8981\u5BE9\u8988",
  604006: "\u804A\u5929\u5DF2\u88AB\u62D2\u7D55",
  604007: "\u7121\u6548\u7684\u5728\u7DDA\u804A\u5929",
  604008: "\u767C\u9001\u804A\u5929\u932F\u8AA4",
  604009: "\u6700\u591A\u7F6E\u980210\u5247\u8A0A\u606F",
  604010: "\u804A\u5929\u5167\u5BB9\u4E0D\u5408\u898F",
  604011: "\u804A\u5929\u6D88\u606F\u5C1A\u672A\u7A3D\u6838",
  605e3: "\u975E\u6CD5\u53C3\u6578",
  605001: "\u67E5\u8A62\u7528\u6236\u5931\u6557",
  605002: "\u7528\u6236\u5DF2\u5B58\u5728",
  605003: "\u6DFB\u52A0\u7528\u6236\u5931\u6557",
  605004: "\u7DE9\u5B58\u52A0\u7528\u6236\u5931\u6557",
  605005: "\u522A\u9664\u7528\u6236\u5931\u6557",
  605006: "\u7528\u6236\u4E0A\u7DDA\u8655\u7406\u5931\u6557",
  605007: "\u7528\u6236\u4E0B\u7DDA\u8655\u7406\u5931\u6557",
  605008: "\u7372\u53D6\u734E\u6C60\u6578\u64DA\u5931\u6557",
  605101: "\u8A02\u55AE\u7372\u53D6\u5931\u6557",
  605102: "\u8A02\u55AE\u5275\u5EFA\u5931\u6557",
  606e3: "\u62BD\u734E\u4E0D\u5B58\u5728",
  606001: "\u62BD\u734E\u540D\u7A31\u5DF2\u5B58\u5728",
  606002: "\u62BD\u734E\u7684\u734E\u9805\u6578\u91CF\u6700\u591A\u723220\u500B",
  606003: "\u734E\u9805\u4E0D\u5B58\u5728",
  606004: "\u6C92\u6709\u6B63\u5728\u9032\u884C\u4E2D\u7684\u62BD\u734E\u6D3B\u52D5",
  606005: "\u734E\u9805\u5DF2\u958B\u734E\uFF0C\u7121\u6CD5\u7DE8\u8F2F",
  606006: "\u734E\u9805\u5DF2\u958B\u734E\uFF0C\u7121\u6CD5\u522A\u9664",
  606007: "\u734E\u9805\u958B\u734E\u4E2D\uFF0C\u66AB\u6642\u7121\u6CD5\u95DC\u9589",
  606008: "\u734E\u54C1\u4E0D\u5B58\u5728",
  606009: "\u734E\u9805\u958B\u734E\u4E2D\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66",
  606010: "\u734E\u9805\u5DF2\u958B\u734E",
  606011: "\u7576\u524D\u62BD\u734E\u6D3B\u52D5\u5DF2\u7D93\u53C3\u8207\uFF0C\u8ACB\u52FF\u91CD\u8907\u5831\u540D\u53C3\u8207",
  606013: "\u512A\u5148\u4E2D\u734E\u914D\u7F6E\u672A\u958B\u5553",
  606014: "\u8A72\u62BD\u734E\u4E0D\u5141\u8A31\u5831\u540D\u53C3\u8207",
  606015: "\u7121\u6548\u7684\u62BD\u734E\u53C3\u8207\u8005",
  606016: "\u4E2D\u734E\u4EBA\u6578\u4E0D\u5F97\u5927\u65BC\u734E\u54C1\u6578\u91CF",
  606017: "\u53E3\u4EE4\u932F\u8AA4",
  606018: "\u62BD\u734E\u6D3B\u52D5\u958B\u555330\u5929\u5167\u672A\u64CD\u4F5C\u958B\u734E\uFF0C\u7121\u6CD5\u958B\u734E",
  606019: "\u5B58\u5728\u654F\u611F\u8A5E",
  606020: "\u5B57\u7B26\u8D85\u9577",
  606021: "\u53EA\u6709\u672A\u958B\u5553\u7684\u62BD\u734E\u5141\u8A31\u522A\u9664",
  606022: "\u62BD\u734E\u72C0\u614B\u6D41\u8F49\u7570\u5E38",
  606023: "\u62BD\u734E\u5DF2\u958B\u5553",
  606024: "\u62BD\u734E\u5DF2\u95DC\u9589",
  606025: "\u81F3\u5C11\u67091\u500B\u734E\u9805\u624D\u80FD\u958B\u5553\u62BD\u734E",
  606026: "\u89C0\u8846\u4E0D\u5B58\u5728",
  606027: "\u8868\u55AE\u4E0D\u5B58\u5728",
  606028: "\u89C0\u8846\u5DF2\u522A\u9664",
  606030: "\u62BD\u734E\u672A\u958B\u5553",
  606031: "\u4E0B\u8F09\u8868\u55AE\u672A\u958B\u5553",
  607001: "\u975E\u6CD5\u53C3\u6578",
  607002: "\u7D05\u5305\u53E3\u4EE4\u5305\u542B\u654F\u611F\u8A5E",
  607003: "\u7D05\u5305\u53E3\u4EE4\u932F\u8AA4",
  607004: "\u7D05\u5305\u5DF2\u904E\u671F",
  607005: "\u8ACB\u5148\u914D\u7F6E\u5FAE\u4FE1\u516C\u8846\u865F\u548C\u5546\u6236\u4FE1\u606F",
  607006: "\u7D05\u5305\u4E0D\u5B58\u5728",
  607007: "\u7D05\u5305\u4E0D\u652F\u6301\u4FEE\u6539",
  607008: "\u7D05\u5305\u5DF2\u6436\u5B8C",
  607010: "\u7D05\u5305\u7E3D\u91D1\u984D\u4E0D\u5F97\u5C11\u65BC0.3\u5143*\u7D05\u5305\u500B\u6578\uFF0C\u4E0D\u5F97\u8D85\u904E20W\u5143",
  607013: "\u7D05\u5305\u767C\u653E\u4E2D",
  607014: "\u7D05\u5305\u8A18\u9304\u4E0D\u5B58\u5728",
  607015: "\u89C0\u884624\u5C0F\u6642\u5167\u672A\u9818\u53D6\u7D05\u5305",
  608001: "\u5DF2\u6709\u8A08\u6642\u5668\u5728\u904B\u884C\u4E2D\uFF0C\u8ACB\u52FF\u91CD\u5FA9\u767C\u8D77",
  608002: "\u5DF2\u7D50\u675F",
  608003: "\u6C92\u6709\u9032\u884C\u4E2D\u7684\u8A08\u6642\u5668",
  2800003: "\u66F4\u65B0\u7D50\u7B97\u55AE\u5931\u6557",
  2800004: "\u522A\u9664\u7D50\u7B97\u55AE\u5931\u6557",
  2800005: "\u7121\u6548\u5FC3\u8DF3",
  2800006: "\u66F4\u65B0\u7D50\u7B97\u72C0\u614B\u5931\u6557"
}, zh_Hant = {
  httpErrorCode: httpErrorCode$1
}, httpErrorCode = {
  200: "\u0646\u062C\u0627\u062D",
  201: "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0648\u0631\u062F",
  202: "\u062A\u0645 \u0627\u0633\u062A\u0644\u0627\u0645 \u0627\u0644\u0637\u0644\u0628",
  300: "\u064A\u0641\u0634\u0644",
  401: "\u062D\u0627\u0644\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  403: "\u063A\u064A\u0631 \u0645\u0635\u0631\u062D",
  500: "\u0627\u0644\u0646\u0638\u0627\u0645\u064A\u0629",
  5002: "\u062E\u0637\u0623 \u0627\u0644\u0645\u0639\u0644\u0645\u0629",
  5003: "\u0641\u0634\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u062F\u0627\u062E\u0644\u064A",
  5004: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0644\u0641",
  5005: "\u0641\u0634\u0644 \u062D\u0641\u0638 \u0627\u0644\u0645\u0644\u0641",
  5006: "\u0637\u0644\u0628 \u0645\u062A\u0643\u0631\u0631",
  5008: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  5009: "\u0641\u0634\u0644 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u060C \u0646\u0648\u0639 \u0645\u0633\u062A\u062E\u062F\u0645 \u062E\u0627\u0637\u0626",
  5010: "\u0643\u0631\u0631 \u0627\u0644\u0637\u0644\u0628",
  5011: "\u0641\u0634\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u062F\u0627\u062E\u0644\u064A",
  5012: "\u0627\u0644\u0637\u0644\u0628 \u0645\u062A\u0643\u0631\u0631 \u0644\u0644\u063A\u0627\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  5013: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0641\u0634\u0644 \u0627\u0644\u0642\u0641\u0644",
  1e5: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0642\u0627\u0639\u062F\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  100001: "\u0645\u0648\u062C\u0648\u062F",
  100005: "\u0644\u0627\u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A",
  100006: "\u062A\u0647\u064A\u0626\u0629 \u0627\u0644\u062E\u062F\u0645\u0629",
  100007: "\u0627\u0644\u062E\u062F\u0645\u0629 \u0645\u062D\u0638\u0648\u0631\u0629",
  100008: "\u062D\u0638\u0631 \u0627\u0633\u062A\u062B\u0646\u0627\u0621",
  100009: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u0627\u062A Dubbo",
  100010: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0639\u0644\u0645\u0629 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A\u0629",
  100011: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u062F\u0648\u0644\u0629 \u063A\u064A\u0631 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
  100012: "\u0645\u0639\u0644\u0645\u0627\u062A \u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0648\u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  100013: "\u0645\u0639\u0644\u0645\u0627\u062A \u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0648\u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  100014: "\u0645\u0639\u0644\u0645\u0627\u062A \u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0648\u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  100015: "\u062A\u0639\u0630\u0631 \u0625\u0646\u0634\u0627\u0621 \u0645\u0639\u0631\u0641 \u0645\u0648\u0632\u0639 \u0628\u0645\u0639\u0631\u0641 \u0639\u0627\u0645\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  100016: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0634\u0628\u0643\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642",
  100017: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0634\u0628\u0643\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642",
  100018: "\u062C\u0627\u0631\u064A \u062A\u0647\u064A\u0626\u0629 \u062E\u0627\u062F\u0645 \u0648\u0627\u062D\u062F \u0645\u0646%s",
  100019: "\u0637\u0644\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  100020: "\u0627\u0644\u062E\u0627\u062F\u0645 \u0645\u0634\u063A\u0648\u0644 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  100021: "\u0645\u0647\u0644\u0629 \u0627\u0644\u0648\u0635\u0648\u0644",
  100022: "\u062A\u0639\u0627\u0631\u0636 \u0641\u0647\u0631\u0633 \u0642\u0627\u0639\u062F\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A:%s",
  100023: "\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0645\u0639\u0644\u0645\u0629 \u0644\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  100024: "\u062A\u0645 \u0637\u0644\u0628 \u062E\u0637\u0623 \u062A\u062D\u0648\u064A\u0644 \u0645\u0639\u0644\u0645\u0629 JSON",
  100025: "\u0645\u0639\u0627\u0645\u0650\u0644 \u0627\u0644\u0637\u0644\u0628:%s \u060C \u0627\u0644\u0642\u064A\u0645\u0629:%s \u060C \u0646\u0648\u0639 \u0627\u0644\u0645\u0639\u0644\u0645\u0629:%s \u060C \u0646\u0648\u0639 \u0627\u0644\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0645\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u0646\u0648\u0639 \u0627\u0644\u0645\u0639\u0644\u0645\u0629",
  100026: "\u0646\u0648\u0639 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0641\u064A \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645. \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0642\u064A\u0645\u0629 \u0646\u0648\u0639 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0641\u064A \u0627\u0644\u0631\u0623\u0633 \u0628\u0639\u0646\u0627\u064A\u0629",
  100027: "\u0639\u0648\u062F\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0633\u0644\u0633\u0644 \u0627\u0644\u0645\u0639\u0644\u0645\u0629",
  100028: "\u0627\u0644\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645\u0629",
  100029: "\u0637\u0644\u0628 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0645\u0639\u0644\u0645\u0629",
  100030: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u0644\u063A\u0627\u0621 \u062A\u0633\u0644\u0633\u0644 JSON \u0644\u0646\u0635 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628",
  100031: "\u062E\u0637\u0623 \u0641\u064A \u0625\u062F\u062E\u0627\u0644 [%s] \u0641\u064A \u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0637\u0644\u0628",
  100040: "AccessToken \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  100041: "\u062D\u0627\u0644\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  100042: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  100043: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u062C\u0644\u0633\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  100044: "\u0631\u0645\u0632 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A \u060C \u064A\u0631\u062C\u0649 \u0645\u0642\u0627\u0631\u0646\u0629 \u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0631\u0645\u0632 \u0628\u0639\u0646\u0627\u064A\u0629",
  100045: "\u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u0641\u0642\u0648\u062F\u0629",
  100046: "\u062E\u0637\u0623 \u0641\u064A \u062A\u062D\u0644\u064A\u0644 \u0647\u0648\u064A\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u060C \u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649!",
  100047: "\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u0641\u0627\u0631\u063A!",
  100048: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0625\u0630\u0646 \u0644\u0644\u062F\u062E\u0648\u0644",
  100049: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  100050: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628\u0643 \u0628\u0627\u0644\u0641\u0639\u0644 \u0639\u0644\u0649 \u062C\u0647\u0627\u0632 \u0622\u062E\u0631",
  100051: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0647 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0641\u064A \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u060C \u064A\u0631\u062C\u0649 \u062A\u0631\u0642\u064A\u0629 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u0646\u062A\u062C \u0623\u0648\u0644\u0627\u064B",
  100052: "\u0641\u0634\u0644 MQ \u0641\u064A \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
  100053: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  100054: "\u0646\u0635 \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0637\u0644\u0628 \u0644\u0627 \u064A\u0644\u0628\u064A \u0645\u062A\u0637\u0644\u0628\u0627\u062A \u0648\u0627\u062C\u0647\u0629 \u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A",
  100055: "\u0646\u0635 \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0637\u0644\u0628 BODY \u0641\u0627\u0631\u063A",
  100056: "[%s] \u062E\u0637\u0623 \u0625\u062F\u062E\u0627\u0644 \u0641\u064A \u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0637\u0644\u0628",
  100057: "\u062D\u0638 \u0633\u064A\u0621",
  100058: "\u062A\u0646\u062A\u0647\u064A \u0635\u0644\u0627\u062D\u064A\u0629 \u0631\u0645\u0632 MDF",
  100059: "\u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062A\u0634\u0641\u064A\u0631 \u0627\u0644\u062F\u0627\u062E\u0644\u064A \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  100060: "\u0639\u0645\u0644\u064A\u0629 \u0641\u0643 \u0627\u0644\u062A\u0634\u0641\u064A\u0631 \u0627\u0644\u062F\u0627\u062E\u0644\u064A\u0629 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  100061: "\u062D\u0633\u0627\u0628 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u062F\u0627\u062E\u0644\u064A\u0629 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  100062: "%s \u0645\u0637\u0644\u0648\u0628",
  100063: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u0647\u0630\u0647 \u0627\u0644\u0644\u063A\u0629 \u060C \u064A\u0631\u062C\u0649 \u0641\u062A\u062D\u0647\u0627 \u0628\u0639\u062F \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u0646 \u0627\u0644\u062A\u0643\u0648\u064A\u0646",
  100064: "\u0646\u0648\u0639 \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646\u0647 \u0628\u0639\u062F!",
  100065: "\u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0641\u0642\u0637 \u064A\u0645\u0643\u0646\u0647 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0647 \u0627\u0644\u0642\u062F\u0631\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629!",
  100066: "\u0641\u0634\u0644 \u0641\u064A \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  100067: "\u0641\u0634\u0644 \u0641\u064A \u062D\u0630\u0641 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  100068: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0642\u062F \u0627\u0646\u062A\u0647\u062A \u060C \u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0648\u0636\u0639",
  100069: "\u0644\u0627 \u062A\u0639\u0645\u0644 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  100070: "\u064A\u0631\u062C\u0649 \u062A\u0643\u0648\u064A\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0639\u0627\u0645 \u0641\u064A WeChat \u0623\u0648\u0644\u0627\u064B",
  100071: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u060C \u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0623\u0648\u0644\u0627",
  100072: "\u0641\u0634\u0644\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  100073: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062A\u062C\u0627\u0648\u0632 \u0641\u062A\u0631\u0629 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 %s \u064A\u0648\u0645\u064B\u0627",
  100074: "\u0644\u0627 \u062A\u0643\u0631\u0631 \u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A",
  100076: "\u0641\u0634\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u060C \u0627\u0644\u0645\u0624\u0633 WeCom  \u0625\u0630\u0646 \u063A\u064A\u0631 \u0645\u0643\u062A\u0645\u0644\u0629",
  100077: "\u0648\u0627\u062C\u0647\u0629 \u0637\u0644\u0628 \u0641\u0634\u0644",
  100078: "WeCom \u062E\u0637\u0623",
  100100: "\u062A\u0646\u0633\u064A\u0642 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  100700: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0647\u064A\u0626\u0629 \u0627\u0644\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0648\u0632\u0639",
  100701: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0648\u0632\u0639",
  100702: "\u0645\u0641\u062A\u0627\u062D \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u060C \u062A\u0633\u0628\u0628 \u0641\u064A \u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0648\u0632\u0639",
  100703: "\u062A\u0631\u0627\u062C\u0639 \u0627\u0644\u0648\u0642\u062A \u060C \u0645\u0645\u0627 \u062A\u0633\u0628\u0628 \u0641\u064A \u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0648\u0632\u0639",
  100704: "\u062E\u0637\u0623 \u0641\u064A \u062A\u0647\u064A\u0626\u0629 \u0627\u0644\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0648\u0632\u0639",
  100800: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
  100900: "\u0645\u0639\u0644\u0645\u0629 \u0631\u0642\u0645 \u0647\u0627\u062A\u0641 SMS \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  100901: "\u0645\u0639\u0644\u0645\u0627\u062A \u0642\u0627\u0644\u0628 SMS \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  100902: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0631\u0645\u0632 \u0642\u0627\u0644\u0628 SMS \u062D\u0633\u0628 \u0627\u0633\u0645 \u0627\u0644\u0641\u0626\u0629",
  100903: "\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u062E\u062F\u0645\u0629 Aliyun SMS \u0647\u064A \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0644\u0627\u063A\u064D",
  100904: "\u062E\u0637\u0623 \u0628\u0627\u0644\u0646\u0638\u0627\u0645. \u0627\u0644\u0631\u062C\u0627\u0621 \u0645\u0639\u0627\u0648\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642.",
  100905: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0645\u0639\u0627\u0648\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642",
  100906: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0647\u0645\u0629 \u062A\u0646\u0641\u064A\u0630 \u062A\u062C\u0645\u0639 \u0645\u0624\u0634\u0631 \u0627\u0644\u062A\u0631\u0627\u0628\u0637",
  100907: "\u0627\u0644\u062E\u062F\u0645\u0629 \u0645\u0634\u063A\u0648\u0644\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  100908: "\u064A\u062A\u062C\u0627\u0648\u0632 \u0639\u062F\u062F \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0635\u064A\u0629 \u0627\u0644\u0645\u0631\u0633\u0644\u0629 \u0627\u0644\u062D\u062F \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642.",
  100909: "\u0623\u0646\u062A \u0644\u0645 \u062A\u0633\u062C\u0644 \u0628\u0639\u062F \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0623\u0648\u0644\u0627\u064B",
  100910: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062D\u062F\u062B \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u0638\u0645",
  100911: "\u064A\u0631\u062C\u0649 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u0625\u0630\u0646 \u0623\u0648\u0644\u0627",
  100912: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062D\u062F\u062B \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u0638\u0645",
  100913: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0645\u0639\u0644\u0645\u0629 \u0641\u0627\u0631\u063A\u0629",
  100914: "\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062D\u062F\u062B. \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u062F\u064A\u0643 \u0623\u064A \u0623\u0633\u0626\u0644\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u0638\u0645",
  100971: "\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0623\u062D\u0631\u0641 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A\u0629 . \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0630\u0644\u0643 \u0648\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  100972: "\u0645\u0642\u0627\u0639\u062F \u0645\u0648\u062C\u0648\u062F\u0629 \u0628\u0627\u0644\u0641\u0639\u0644",
  100973: "\u0627\u0644\u0641\u0634\u0644 \u0641\u064A \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0642\u0627\u0639\u062F \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  100974: "\u0639\u062F\u0645 \u0625\u0636\u0627\u0641\u0629 \u0645\u0642\u0627\u0639\u062F \u060C \u064A\u0631\u062C\u0649 \u062A\u062C\u0631\u0628\u062A\u0647\u0627 \u0644\u0627\u062D\u0642\u064B\u0627",
  100975: "\u0641\u0634\u0644 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
  100976: "\u0641\u0634\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  100977: "\u0627\u0633\u062A\u062F\u0639\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0627\u0646\u0635\u0647\u0627\u0631 \u0645\u062A\u0639\u062F\u062F \u0627\u0644\u0633\u062D\u0627\u0628\u0629",
  100978: "\u0641\u0634\u0644 \u0627\u0644\u0627\u0646\u0633\u062D\u0627\u0628 \u0645\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  100979: "\u0643\u0627\u0646\u062A \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u0645\u062D\u062F\u0648\u062F\u0629",
  100980: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0645\u0639\u0631\u0641 \u0627\u0644\u0637\u0644\u0628",
  100981: "\u0637\u0644\u0628 \u062A\u0634\u0641\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  100982: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635",
  100983: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0628\u0637\u0648\u0644%s ~%s \u0628\u062A",
  100984: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0635\u062D\u064A\u062D",
  100985: "\u0623\u0642\u0635\u0649 \u0637\u0648\u0644 \u0644\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0647\u0648%s",
  100986: "\u0641\u0634\u0644 \u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 RSA",
  100987: "\u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0639\u0627\u0645 RSA",
  100988: "\u0641\u0634\u0644 \u062A\u0634\u0641\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0639\u0627\u0645 RSA",
  100989: "\u0641\u0634\u0644 \u0641\u0643 \u062A\u0634\u0641\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635 RSA",
  100990: "\u0645\u0641\u062A\u0627\u062D \u062A\u0647\u064A\u0626\u0629 RSA \u0628\u0647 \u062E\u0637\u0623 \u0648\u062E\u0648\u0627\u0631\u0632\u0645\u064A\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621",
  100991: "\u062A\u0634\u0641\u064A\u0631 RSA \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  100992: "\u0627\u0644\u0627\u062D\u062A\u062C\u0627\u062C \u063A\u064A\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
  100993: "\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0630\u064A \u062A\u0645 \u062A\u062D\u0645\u064A\u0644\u0647 \u064A\u062F\u0639\u0645%s \u0641\u0642\u0637. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0627\u062E\u0631\u0649",
  100994: "\u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0645\u064A\u0644 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  100995: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u062A\u064A \u062A\u0645 \u062A\u062D\u0645\u064A\u0644\u0647\u0627 \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u060C \u0648\u0647\u0648%s \u0645\u064A\u063A\u0627 \u0628\u0627\u064A\u062A",
  100996: "\u0637\u0644\u0628 \u0627\u0644\u0645\u0639\u0644\u0645\u0629 \u0641\u0627\u0631\u063A",
  100997: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  100998: "\u0646\u0648\u0639 \u0627\u0644\u0633\u0644\u0648\u0643 \u0627\u0644\u0630\u064A \u062A\u0645 \u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646\u0647 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645",
  100999: "\u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
  101001: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0623\u0648 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
  101002: "\u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  101003: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062E\u0627\u0637\u0626\u0629",
  101004: "refreshToken \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u060C \u063A\u064A\u0631 \u0642\u0627\u062F\u0631 \u0639\u0644\u0649 \u062A\u062D\u0645\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  101005: "refreshToken \u0641\u0627\u0631\u063A",
  101006: "grantType \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645 \u060C \u064A\u0631\u062C\u0649 \u062A\u0645\u0631\u064A\u0631 \u0627\u0644\u0645\u0639\u0644\u0645\u0629 grantType \u0627\u0644\u0635\u062D\u064A\u062D\u0629",
  101007: "\u062E\u0637\u0623 \u0641\u064A \u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u062D\u0633\u0627\u0628",
  101008: "\u062A\u0645 \u062A\u0646\u0634\u064A\u0637 \u0627\u0644\u062D\u0633\u0627\u0628 \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0639\u0645\u0644\u064A\u0629.",
  101009: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0631\u0627\u0628\u0637 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0631\u0627\u0628\u0637 \u062F\u0639\u0648\u0629 \u062C\u062F\u064A\u062F.",
  101010: "\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  101011: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  101012: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  101013: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  101014: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0645\u0639\u0644\u0645\u0629 \u060C \u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  101015: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u062C\u0631\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u0639\u0644\u0649 \u0646\u0641\u0633\u064A",
  101020: "\u0641\u0634\u0644 \u0631\u0628\u0637 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
  101021: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u0642\u062F\u064A\u0645\u0629 \u0648\u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0645\u062A\u0637\u0627\u0628\u0642\u0629",
  101022: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u0643\u0645\u0627\u0644 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0625\u0646\u0633\u0627\u0646 \u0648\u0627\u0644\u0622\u0644\u0629 \u0623\u0648\u0644\u0627\u064B",
  101023: "\u0641\u0634\u0644 CAPTCHA",
  101024: "\u062E\u0637\u0623 \u0641\u064A \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
  101025: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644",
  101026: "\u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u060C \u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644",
  101027: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  101028: "\u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u060C \u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  101029: "\u062A\u0646\u0633\u064A\u0642 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  101030: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  101031: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u064A\u0633 \u0644\u062F\u064A\u0647 \u0625\u0630\u0646 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  101032: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0645\u0642\u0641\u0644\u0629 \u060C \u0644\u0627 \u064A\u0648\u062C\u062F \u0625\u0630\u0646 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  101033: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  101034: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0627\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  101035: "\u0627\u0644\u062D\u0633\u0627\u0628 / \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629 \u060C \u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u062F\u062E\u0627\u0644",
  101036: "\u062A\u0645 \u0642\u0641\u0644 \u0627\u0644\u062D\u0633\u0627\u0628 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u062E\u0644\u0627\u0644%s \u062F\u0642\u064A\u0642\u0629",
  101037: "\u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u063A\u0644\u0642 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0644\u0641\u062A\u062D\u0647",
  101038: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  101039: "\u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0645\u0646\u062E\u0641\u0636 \u062C\u062F\u064B\u0627 \u060C \u064A\u0631\u062C\u0649 \u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
  101050: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0639\u0644\u0645\u0629 \u0625\u0630\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  101051: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0631\u0645\u0632 6 \u0645\u0631\u0627\u062A \u0641\u064A \u0627\u0644\u0633\u0627\u0639\u0629",
  101052: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0631\u0645\u0632 20 \u0645\u0631\u0629 \u0641\u064A 24 \u0633\u0627\u0639\u0629",
  101053: "\u0641\u0634\u0644 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0634\u062C\u0631\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0623\u0643\u064A\u062F \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0627\u0644\u0645\u0639\u0644\u0645\u0627\u062A \u0635\u062D\u064A\u062D\u0629",
  101054: "\u0641\u0634\u0644 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
  101055: "\u0641\u0634\u0644 \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
  101056: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062F\u0648\u0631 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
  101057: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0645\u0631\u0627\u062F \u0625\u0636\u0627\u0641\u062A\u0647 \u0645\u0633\u0624\u0648\u0644\u0627\u064B \u0641\u0627\u0631\u063A\u064B\u0627",
  101058: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u062D\u0633\u0627\u0628 \u0627\u0644\u062A\u0639\u0627\u0648\u0646",
  101059: "\u0641\u0634\u0644\u062A \u0625\u0632\u0627\u0644\u0629 \u062D\u0633\u0627\u0628 \u0627\u0644\u062A\u0639\u0627\u0648\u0646",
  101060: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062F\u0648\u0631 \u062D\u0633\u0627\u0628 \u0627\u0644\u062A\u0639\u0627\u0648\u0646",
  101061: "\u062D\u0633\u0627\u0628 \u0627\u0644\u062A\u0639\u0627\u0648\u0646 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u062A\u0623\u0643\u064A\u062F \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0645\u0643\u0631\u0631\u064B\u0627",
  101062: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0639\u062F\u062F \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0625\u062F\u0627\u0631\u064A\u064A\u0646",
  101063: "\u0641\u0634\u0644 \u0627\u0633\u062A\u0628\u062F\u0627\u0644 \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
  101064: "\u0644\u0627 \u062A\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631 \u062E\u0644\u0627\u0644 \u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629!",
  101065: "\u0641\u0634\u0644 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
  101066: "\u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0631\u0645\u0632 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  101067: "\u0635\u064A\u063A\u0629 \u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  101068: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 / \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  101069: "\u064A\u062A\u0645 \u062F\u0639\u0645 \u0639\u0645\u0644\u064A\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637 \u0641\u064A \u063A\u0636\u0648\u0646 5 \u062F\u0642\u0627\u0626\u0642 \u060C \u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0639\u0645\u0644 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  101070: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u062A\u0643\u0631\u0627\u0631\u0627\u062A",
  101071: "\u0645\u0639\u0631\u0641\u0627\u062A \u0627\u0644\u062C\u0647\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629 \u0644\u0627 \u062A\u062F\u0639\u0645 \u0627\u0644\u062A\u0643\u0631\u0627\u0631\u0627\u062A",
  101072: "\u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0628\u0639\u062F \u0627\u0644\u062A\u0641\u0639\u064A\u0644",
  101073: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  101074: "\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0628\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0645\u0646\u0635\u0629 \u0627\u0644\u0625\u062F\u0627\u0631\u0629",
  101075: "\u0639\u0646\u062F\u0645\u0627 \u064A\u062A\u0645 \u062A\u0646\u0634\u064A\u0637\u0643 \u0628\u0634\u0643\u0644 \u0645\u0633\u062A\u0642\u0644 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u060C \u0641\u0623\u0646\u062A \u0628\u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u062A\u0639\u064A\u064A\u0646 \u0635\u0646\u062F\u0648\u0642 \u0627\u0644\u0628\u0631\u064A\u062F",
  101076: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0639\u0644\u064A",
  101077: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
  101078: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u062A\u0646\u0633\u064A\u0642 \u0635\u062D\u064A\u062D \u0644\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0639\u0644\u064A",
  101079: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u062A\u0646\u0633\u064A\u0642 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D",
  101080: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u0639\u0644\u064A \u0642\u0628\u0644 \u0627\u0644\u064A\u0648\u0645",
  101081: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0642\u0628\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0633\u0631\u064A\u0627\u0646",
  101082: "\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u0646\u0648\u0639 \u0627\u0644\u062D\u0633\u0627\u0628",
  101083: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0625\u0630\u0646 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  101084: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0625\u0630\u0646 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  101085: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
  101086: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0633\u0631\u064A\u0627\u0646",
  101087: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0642\u0628\u0644 \u0627\u0644\u064A\u0648\u0645",
  101088: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0645\u064A\u064A\u0632 \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u062D\u062F\u0648\u062F \u0627\u0644\u0648\u0642\u062A",
  101089: "\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0644\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u062D\u062F\u0648\u062F \u0628\u0648\u0642\u062A \u0628\u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0633\u0627\u0628",
  101090: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0625\u0630\u0646 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  101091: "\u0641\u0634\u0644 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0642\u0627\u0639\u062F",
  101092: "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0633\u0631\u064A\u0627\u0646 \u0645\u062A\u0623\u062E\u0631\u064B\u0627 \u0639\u0646 \u0627\u0644\u064A\u0648\u0645",
  101094: `\u0644\u0627 \u062A\u062F\u0639\u0645 \u0623\u0633\u0645\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u062E\u0627\u0635\u0629 \u0645\u062B\u0644 ' " \\ / & > <`,
  103e3: "\u0645\u0646\u0638\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  103001: "\u0645\u0646\u0638\u0645\u0629 \u0631\u0626\u064A\u0633\u064A\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  103002: "\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062C\u0630\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0628\u0627\u0644\u0641\u0639\u0644",
  103003: "\u062A\u0639\u0630\u0631 \u062D\u0630\u0641 \u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062C\u0630\u0631",
  103004: "\u062A\u0639\u0630\u0631 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062C\u0630\u0631\u064A\u0629",
  103005: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0642\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u0648\u0649 \u0646\u0641\u0633\u0647",
  103006: "\u0627\u0644\u0645\u0646\u0638\u0645\u0629 \u0627\u0644\u0623\u0645 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0644\u0647\u0627 \u0628\u0627\u0644\u062A\u0639\u062F\u064A\u0644",
  103007: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0645\u0639\u0637\u0644\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0623\u0648\u0644\u0627\u064B",
  103010: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
  103011: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
  103012: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
  103013: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0639\u062F\u062F \u0637\u0628\u0642\u0627\u062A \u0627\u0644\u0645\u0624\u0633\u0633\u0629 7 \u0637\u0628\u0642\u0627\u062A",
  103014: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062A\u062C\u0627\u0648\u0632 \u0639\u0642\u062F \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0641\u0631\u0639\u064A\u0629 100",
  103015: "\u0647\u0646\u0627\u0643 \u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0648\u0638\u0641\u064A\u0646 \u0623\u0648 \u0623\u0639\u0645\u0627\u0644 \u062A\u062D\u062A \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647\u0627",
  108e3: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  108001: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638",
  108002: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u062A\u0627\u0628\u0639\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  108003: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638",
  108004: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
  108005: "\u0641\u0634\u0644 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  108006: "\u0627\u0644\u062E\u0627\u062F\u0645 \u0645\u0634\u063A\u0648\u0644",
  108007: "\u062A\u0643\u0631\u0627\u0631 \u0625\u0631\u0633\u0627\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
  108008: "\u062E\u0637\u0623 \u0641\u064A \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
  108009: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
  109e3: "\u062F\u0648\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  109001: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062F\u0648\u0631",
  109002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062F\u0648\u0631",
  109003: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u062F\u0648\u0631",
  109004: "\u0647\u0646\u0627\u0643 \u0645\u0648\u0638\u0641\u064A\u0646 \u0645\u0631\u062A\u0628\u0637\u064A\u0646 \u0628\u0647\u0630\u0627 \u0627\u0644\u062F\u0648\u0631",
  109005: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0631\u062A\u0628\u0627\u0637 \u0623\u0630\u0648\u0646\u0627\u062A \u0627\u0644\u062F\u0648\u0631",
  109006: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0631\u062A\u0628\u0627\u0637 \u0625\u0630\u0646 \u0627\u0644\u062F\u0648\u0631",
  109007: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0623\u0630\u0648\u0646\u0627\u062A \u0627\u0644\u062F\u0648\u0631 \u0641\u0627\u0631\u063A\u0629",
  109008: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0627\u0644\u062F\u0648\u0631",
  110001: "\u0625\u0630\u0646 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  111e3: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0623\u0648 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
  111001: "\u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  111002: "\u062A\u0645 \u062A\u0639\u0637\u064A\u0644 \u0627\u0644\u062D\u0633\u0627\u0628",
  111003: "refreshToken \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u060C \u063A\u064A\u0631 \u0642\u0627\u062F\u0631 \u0639\u0644\u0649 \u062A\u062D\u0645\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  111004: "refreshToken \u0641\u0627\u0631\u063A",
  111005: "grantType \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645 \u060C \u064A\u0631\u062C\u0649 \u062A\u0645\u0631\u064A\u0631 \u0627\u0644\u0645\u0639\u0644\u0645\u0629 grantType \u0627\u0644\u0635\u062D\u064A\u062D\u0629",
  111006: "\u0645\u0648\u0638\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  111007: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0648\u0638\u0641",
  111008: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0648\u0638\u0641",
  111009: "\u0641\u0634\u0644 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0645\u0648\u0638\u0641",
  111010: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u062F\u0648\u0631 \u0627\u0644\u0645\u0648\u0638\u0641",
  111011: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 / \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A / \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0627\u0644\u0646\u0633\u062E",
  111012: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u062F\u0648\u0631 \u0627\u0644\u0645\u0648\u0638\u0641",
  111013: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062D\u0633\u0627\u0628 / \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
  111014: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0639\u0646\u0648\u0627\u0646 IP \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0648\u0627\u0644\u0648\u0642\u062A",
  111015: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  111016: "\u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u062E\u0627\u0637\u0626\u0629 \u0623\u0643\u062B\u0631 \u0645\u0646 3 \u0645\u0631\u0627\u062A \u060C \u0641\u064A\u062C\u0628 \u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0644\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629 \u0627\u0644\u0625\u0646\u0633\u0627\u0646 \u0648\u0627\u0644\u0622\u0644\u0629",
  111017: "\u0645\u0639\u0644\u0645\u0629 CAB \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  111018: "\u0641\u0634\u0644 CAPTCHA",
  111019: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u0642\u062F\u064A\u0645\u0629 \u0648\u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0645\u062A\u0637\u0627\u0628\u0642\u0629",
  111020: "\u0631\u0645\u0632 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  111021: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0642\u062F\u064A\u0645\u0629 \u062E\u0627\u0637\u0626\u0629",
  111022: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0628\u0639\u062F \u062F\u0642\u064A\u0642\u0629",
  112e3: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631",
  112001: "\u0645\u0633\u062A\u0623\u062C\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112002: "\u062A\u0645 \u062A\u0645\u0631\u064A\u0631 \u0645\u0639\u0644\u0645\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  112003: "\u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112004: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  112005: "\u0645\u0648\u0631\u062F \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112006: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0627\u0644\u0645\u0648\u0627\u0631\u062F",
  112007: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0648\u0631\u062F \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112008: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0633\u0628\u0628 \u0627\u0644\u062A\u0639\u0637\u064A\u0644 \u0641\u0627\u0631\u063A\u064B\u0627",
  112009: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0633\u0645 \u0627\u0644\u0639\u0645\u064A\u0644 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u0641\u0627\u0631\u063A\u064B\u0627",
  112010: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062A\u0635\u0646\u064A\u0641 \u0627\u0644\u0646\u062C\u0648\u0645 \u0644\u0644\u0639\u0645\u064A\u0644 \u0641\u064A 1-5",
  112011: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u0644\u0644\u0639\u0645\u064A\u0644 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  112012: "\u0648\u0635\u0644 \u0639\u062F\u062F \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631\u064A\u0646 \u0627\u0644\u0641\u0631\u0639\u064A\u064A\u0646 \u0625\u0644\u0649 \u0633\u0639\u0629 \u062D\u0632\u0645\u0629 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0646\u0634\u0627\u0624\u0647\u0627",
  112013: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631",
  112014: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u0627\u0631\u063A\u0629",
  112015: "\u0644\u0627 \u062A\u0643\u0631\u0631 \u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0641\u064A \u063A\u0636\u0648\u0646 \u062F\u0642\u064A\u0642\u0629",
  112016: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0628\u0648\u0627\u0628\u0629",
  112017: "\u0628\u0648\u0627\u0628\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  112018: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0628\u0648\u0627\u0628\u0629",
  112019: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0628\u0648\u0627\u0628\u0629",
  112020: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0642\u0633\u0645",
  112021: "\u0641\u0634\u0644 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0642\u0633\u0645",
  112022: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0642\u0633\u0645",
  112023: "\u0642\u0633\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112024: "\u0644\u0627 \u064A\u0633\u0645\u062D \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u0639\u0644\u0648\u064A \u0623\u0648 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u0633\u0641\u0644\u064A \u0628\u0627\u0644\u0641\u0631\u0632",
  112025: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u0639\u0644\u0648\u064A",
  112026: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u0633\u0641\u0644\u064A",
  112027: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0628\u064A\u0627\u0646\u0627\u062A \u0646\u0648\u0639 \u0627\u0644\u0635\u0648\u0631\u0629",
  112028: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0631\u0641 \u0627\u0644\u062F\u0627\u0626\u0631\u064A",
  112029: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0643\u062A\u0628\u0629",
  112030: "\u0631\u0641 \u062F\u0627\u0626\u0631\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112031: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  112032: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  112033: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  112034: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  112035: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  112036: "\u0641\u0634\u0644 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  112037: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  112038: "\u0641\u064A\u062F\u064A\u0648 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112039: "\u062A\u063A\u064A\u064A\u0631 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A \u0644\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629",
  112040: "\u062A\u0639\u062F\u064A\u0644 \u0634\u0630\u0648\u0630 \u0641\u064A \u0631\u0645\u0632 \u0627\u0644\u0634\u0639\u0627\u0631",
  112041: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0631\u0645\u0632 \u0645\u0648\u0642\u0639 \u0627\u0644\u0648\u064A\u0628",
  112042: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0634\u0639\u0627\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  112043: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  112044: "\u0642\u0645 \u0628\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0637\u0628\u064A\u0639\u064A\u0629 \u0644\u0645\u0646\u0635\u0629 WeChat \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629",
  112045: "\u0642\u0645 \u0628\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0637\u0628\u064A\u0639\u064A\u0629 \u0644\u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0639\u0627\u0645",
  112046: "\u0642\u0645 \u0628\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0637\u0628\u064A\u0639\u064A\u0629 \u0644\u062F\u0641\u0639 WeChat",
  112047: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u062E\u0648\u064A\u0644 \u0627\u0644\u062C\u0647\u0629 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
  112048: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  112049: "\u0645\u0634\u0647\u062F \u062D\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112050: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062F\u0641\u0639 WeChat",
  112051: "\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112052: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  112053: "\u0627\u0632\u062F\u0648\u0627\u062C\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  112054: "\u0645\u0639\u0644\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  112055: "\u0645\u0639\u0631\u0641 \u0627\u0644\u0639\u0645\u064A\u0644 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  112056: "\u0645\u0639\u0644\u0645\u0629 \u0646\u0648\u0639 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0648\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u0648\u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A\u0647\u0627 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  112057: "\u0646\u0648\u0639 \u0627\u0644\u0642\u0633\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112058: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0631\u0642\u0645 \u0623\u0642\u0644 \u0645\u0646 0 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0640%s",
  112059: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
  112060: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0646\u0634\u0627\u0637",
  112061: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0646\u0634\u0637\u0629",
  112062: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0646\u0634\u0637\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  112063: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u062C\u0645\u0648\u0639\u0629 \u0634\u0631\u0643\u0627\u0621",
  112064: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u062C\u0645\u064A\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u0621",
  112065: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0634\u0631\u064A\u0643",
  112066: "\u062A\u062C\u0645\u0639 \u0627\u0644\u0634\u0631\u0643\u0627\u0621 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112067: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0634\u0631\u064A\u0643",
  112068: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0634\u0631\u064A\u0643",
  112069: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0634\u0631\u064A\u0643",
  112070: "\u0634\u0631\u064A\u0643 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  112071: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062D\u0642\u0644 \u0641\u0631\u0632 \u0627\u0644\u0642\u0633\u0645",
  112072: "\u0627\u0633\u0645 \u0627\u0644\u0628\u0648\u0627\u0628\u0629 \u0645\u0643\u0631\u0631 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  112073: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0628\u0648\u0627\u0628\u0629",
  112074: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0634\u0631\u064A\u0643",
  112075: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0628\u0648\u0627\u0628\u0629",
  112076: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u062D\u0642 \u0627\u0644\u0628\u0648\u0627\u0628\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
  112077: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u062D\u0642 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0627\u0644\u0628\u0648\u0627\u0628\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
  112078: "\u064A\u062C\u0628 \u0623\u0646 \u062A\u062D\u062A\u0648\u064A \u0643\u0644 \u0628\u0648\u0627\u0628\u0629 \u0639\u0644\u0649 \u0642\u0633\u0645 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  112079: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0642\u0633\u0645 \u0634\u0631\u064A\u0637 \u0639\u0644\u0648\u064A \u0648\u0627\u062D\u062F \u0641\u0642\u0637",
  112080: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u062E\u0645\u0633\u0629 \u0623\u0642\u0633\u0627\u0645 \u0641\u0642\u0637 \u0644\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0635\u0648\u0631\u0629",
  112081: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u062E\u0645\u0633 \u0644\u0648\u062D\u0627\u062A \u062A\u0646\u0642\u0644 \u0641\u064A \u0627\u0644\u0641\u0626\u0627\u062A \u0641\u0642\u0637",
  112082: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0641\u0642\u0637 \u062E\u0645\u0633\u0629 \u0623\u0642\u0633\u0627\u0645 \u0645\u0642\u062F\u0645\u0629 \u0628\u064A\u0627\u0646\u064A\u0629",
  112083: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u062B\u0644\u0627\u062B\u0629 \u0623\u0642\u0633\u0627\u0645 \u0641\u0642\u0637 \u0644\u062C\u0645\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  112084: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u062B\u0644\u0627\u062B\u0629 \u0623\u0642\u0633\u0627\u0645 \u0641\u0642\u0637 \u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0646\u0634\u0637\u0629",
  112085: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0642\u0633\u0645 \u0634\u0631\u064A\u0643 \u0648\u0627\u062D\u062F \u0641\u0642\u0637",
  112086: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0642\u0633\u0645 \u0648\u0627\u062D\u062F \u0641\u0642\u0637 \u0644\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0646\u0627",
  112087: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0642\u0633\u0645 \u0634\u0631\u064A\u0637 \u0633\u0641\u0644\u064A \u0648\u0627\u062D\u062F \u0641\u0642\u0637",
  112088: "\u0627\u0644\u0628\u0648\u0627\u0628\u0629 \u0645\u0648\u062C\u0648\u062F\u0629 \u0628\u0627\u0644\u0641\u0639\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0641 \u060C \u064A\u0631\u062C\u0649 \u0625\u0632\u0627\u0644\u062A\u0647\u0627 \u0645\u0646 \u0627\u0644\u0631\u0641 \u0642\u0628\u0644 \u062D\u0630\u0641\u0647\u0627",
  112090: "\u0641\u0634\u0644 \u0641\u064A \u0625\u062F\u0631\u0627\u062C \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631",
  112091: "\u0623\u0646\u0634\u0626 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 5 \u0628\u0648\u0627\u0628\u0627\u062A \u060C \u064A\u0631\u062C\u0649 \u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0623\u0648\u0644\u0627\u064B",
  112092: "\u0623\u0646\u0634\u0626 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 20 \u0628\u0648\u0627\u0628\u0629",
  112093: "\u064A\u062A\u062C\u0627\u0648\u0632 \u062F\u0642\u0629 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  112094: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0631\u0642\u0645 \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0639\u0645\u064A\u0644 \u0641\u0627\u0631\u063A\u064B\u0627",
  112095: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u0639\u062F\u0627\u062F \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u0644\u0627\u062D\u064A\u0629 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
  112096: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631",
  112097: "\u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u0644\u062F\u064A\u0647 \u0623\u0630\u0648\u0646\u0627\u062A \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629",
  112098: "\u0641\u0634\u0644\u062A \u062A\u0647\u064A\u0626\u0629 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  112201: "\u0641\u0634\u0644 \u062A\u0647\u064A\u0626\u0629 \u062A\u0643\u0648\u064A\u0646 \u0635\u0641\u062D\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  112202: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u062A\u0643\u0648\u064A\u0646 \u0635\u0641\u062D\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  112203: "\u062A\u0643\u0648\u064A\u0646 \u0635\u0641\u062D\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u062E\u0635\u0635\u0629 \u0644\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  112204: "\u0645\u0639 \u062E\u062F\u0645\u0629 \u0627\u0644\u0641\u0636\u0627\u0621 \u0627\u0644\u0648\u0647\u0645\u064A\u0629 \u0644\u0645 \u062A\u0641\u062A\u062D \u0628\u0639\u062F \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u062E\u062F\u0645\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
  112205: "\u0631\u0645\u0632 \u0627\u0644\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0634\u0648\u0627\u0626\u064A\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  112206: "\u064A\u0631\u062C\u0649 \u062A\u0634\u063A\u064A\u0644/\u0625\u064A\u0642\u0627\u0641 \u062A\u0634\u063A\u064A\u0644 \u0645\u0641\u062A\u0627\u062D \u0645\u0635\u0627\u062F\u0642\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u062A\u0639\u062F\u062F",
  112207: "\u0642\u0645 \u0628\u062A\u0645\u0643\u064A\u0646 \u0637\u0631\u064A\u0642\u0629 \u0645\u0635\u0627\u062F\u0642\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  112208: "\u0646\u0637\u0627\u0642 \u0627\u0644\u0642\u064A\u0645\u0629 \u0644\u0645\u0641\u062A\u0627\u062D \u0645\u0635\u0627\u062F\u0642\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u062A\u0639\u062F\u062F \u0647\u0648 0~1",
  112209: "\u0646\u0637\u0627\u0642 \u0627\u0644\u0642\u064A\u0645\u0629 \u0644\u0637\u0631\u064A\u0642\u0629 \u0645\u0635\u0627\u062F\u0642\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u062A\u0639\u062F\u062F \u0647\u0648 0~1",
  112210: "\u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  113e3: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u062A\u0639\u0627\u0648\u0646",
  113001: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u062A\u0639\u0627\u0648\u0646",
  113002: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u062A\u0639\u0627\u0648\u0646",
  113003: "\u0645\u062A\u0639\u0627\u0648\u0646 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  113004: "\u0639\u062F\u062F \u0627\u0644\u0625\u0628\u062F\u0627\u0639\u0627\u062A \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  113005: "\u0627\u0633\u0645 \u0627\u0644\u0645\u062A\u0639\u0627\u0648\u0646 \u0641\u064A \u0627\u0644\u062D\u062F\u062B \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  114e3: "\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  114001: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0625\u0639\u0644\u0627\u0645",
  114002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0633\u062C\u0644 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0625\u0639\u0644\u0627\u0645",
  114003: "\u0646\u0645\u0648\u0630\u062C SMS \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  115e3: "\u0625\u0635\u062F\u0627\u0631 \u0645\u0646\u062A\u062C \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  115001: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u0646\u062A\u062C",
  115002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u0646\u062A\u062C",
  115003: "\u0645\u064A\u0632\u0629 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u0646\u062A\u062C \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  115004: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0644\u0627 \u062A\u0633\u0645\u062D \u0628\u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
  115005: "\u062D\u0632\u0645\u0629 \u0645\u0648\u0627\u0631\u062F \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  115006: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062E\u0637\u0629",
  115007: "\u062D\u0632\u0645\u0629 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u0648\u0646\u0648\u0639 \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A \u0641\u064A \u062D\u0632\u0645\u0629 \u0627\u0644\u062D\u0632\u0645\u0629 \u063A\u064A\u0631 \u0645\u062A\u0648\u0627\u0641\u0642\u064A\u0646 \u0645\u0639 \u062D\u0632\u0645\u0629 \u0627\u0644\u062D\u0632\u0645\u0629!",
  115008: "\u0641\u062A\u0631\u0629 \u0635\u0644\u0627\u062D\u064A\u0629 \u062D\u0632\u0645\u0629 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u0648\u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0641\u064A \u062D\u0632\u0645\u0629 \u0627\u0644\u062D\u0632\u0645\u0629 \u063A\u064A\u0631 \u0645\u062A\u0648\u0627\u0641\u0642\u0629 \u0645\u0639 \u062D\u0632\u0645\u0629 \u0627\u0644\u062D\u0632\u0645\u0629!",
  115009: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062E\u0637\u0629",
  115010: "\u062E\u0637\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  115011: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0632\u0645\u0629",
  115012: "\u0633\u062C\u0644 \u0625\u062C\u0631\u0627\u0621 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u0646\u062A\u062C \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  115013: "\u062A\u0639\u062F\u064A\u0644 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u0646\u062A\u062C \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647",
  115014: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0633\u0639\u0631 \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A 0",
  115015: "\u0645\u0639\u0631\u0641 \u062D\u0632\u0645\u0629 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  115016: "\u0645\u0648\u0631\u062F \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  116001: "\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0639\u0645\u064A\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  116002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0639\u0645\u064A\u0644",
  116003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0639\u0645\u064A\u0644",
  116004: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0639\u0645\u064A\u0644",
  116005: "\u0631\u0642\u0645 \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0644\u0627 \u064A\u0633\u0645\u062D \u0628\u0627\u0644\u062A\u0643\u0631\u0627\u0631\u0627\u062A",
  117050: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0644\u0644\u063A\u0631\u0641\u0629",
  117051: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u063A\u0631\u0641\u0629",
  117052: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u063A\u0631\u0641\u0629",
  117053: "\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  117054: "\u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0645\u0628\u0627\u0634\u0631 \u0648\u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u062A\u0628\u062F\u064A\u0644",
  117055: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0644\u064A\u0633\u062A \u062D\u064A\u0629",
  117056: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u064A\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0646\u0634\u0637\u0629 \u060C \u0648\u0627\u0644\u062D\u0630\u0641 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
  117057: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117058: "\u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  117059: "\u064A\u0639\u062F \u0627\u0633\u062A\u062F\u0639\u0627\u0621 Tencent Cloud \u0644\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0623\u0645\u0631\u064B\u0627 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  117060: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u062A\u062F\u0641\u0642 \u0627\u0644\u0645\u062E\u062A\u0644\u0637",
  117061: "\u062A\u062E\u0637\u064A\u0637 \u0645\u0632\u064A\u062C \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u0633\u062D\u0627\u0628\u064A \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  117062: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0645\u0647\u064A\u0623\u0629 \u0644\u0639\u062F\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
  117063: "\u064A\u062A\u0645 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0641\u064A \u0622\u062E\u0631 \u0628\u062B \u0645\u0628\u0627\u0634\u0631 \u060C \u064A\u0631\u062C\u0649 \u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0644\u0627\u062D\u0642\u064B\u0627",
  117064: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117065: "\u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  117066: "\u0627\u0633\u062A\u062F\u0639\u0627\u0621 Tencent Cloud \u0644\u0625\u0646\u0647\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
  117067: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u062A\u062F\u0641\u0642 \u0627\u0644\u0645\u062E\u062A\u0644\u0637",
  117068: "\u062A\u062E\u0637\u064A\u0637 \u0645\u0632\u064A\u062C \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u0633\u062D\u0627\u0628\u064A \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  117069: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0645\u0647\u064A\u0623\u0629 \u0644\u0639\u062F\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
  117070: "\u064A\u062A\u0645 \u0627\u062D\u062A\u0633\u0627\u0628 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0641\u064A \u0622\u062E\u0631 \u0628\u062B \u0645\u0628\u0627\u0634\u0631 \u060C \u064A\u0631\u062C\u0649 \u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0644\u0627\u062D\u0642\u064B\u0627",
  117080: "\u062A\u064A\u0627\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  117081: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0628\u062B \u0645\u0628\u0627\u0634\u0631 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A \u060C \u064A\u0631\u062C\u0649 \u062F\u0641\u0639 \u0627\u0644\u0628\u062B \u062B\u0645 \u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117120: "\u062A\u0643\u0648\u064A\u0646 \u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  117121: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u063A\u0631\u0641\u0629",
  117122: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u063A\u0631\u0641\u0629",
  117160: "\u062A\u0635\u0646\u064A\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  117161: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0627\u0644\u0641\u0626\u0629",
  117162: "\u064A\u062A\u062C\u0627\u0648\u0632 \u0639\u062F\u062F \u0637\u0628\u0642\u0627\u062A \u0627\u0644\u062A\u0635\u0646\u064A\u0641 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  117163: "\u0639\u062F\u062F \u0627\u0644\u0641\u0626\u0627\u062A \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  117164: "\u062A\u062C\u0627\u0648\u0632 \u0639\u062F\u062F \u0627\u0644\u0641\u0626\u0627\u062A \u0627\u0644\u0641\u0631\u0639\u064A\u0629 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  117165: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0627\u0644\u0641\u0626\u0629 \u062A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0639\u064F\u0642\u062F \u0641\u0631\u0639\u064A\u0629",
  117166: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0635\u0646\u064A\u0641",
  117167: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0641\u0626\u0629",
  117168: "\u0628\u0627\u0644\u0641\u0639\u0644 \u0627\u0644\u0623\u0648\u0644 \u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062A\u062D\u0631\u0643 \u0644\u0623\u0639\u0644\u0649 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0630\u0644\u0643",
  117169: "\u0625\u0646\u0647 \u0627\u0644\u0623\u062E\u064A\u0631 \u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u062D\u0631\u0643 \u0644\u0623\u0633\u0641\u0644 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0630\u0644\u0643",
  117170: "\u0641\u0634\u0644 \u0641\u064A \u0631\u0641\u0639 \u0627\u0644\u0641\u0626\u0629",
  117171: "\u0641\u0634\u0644 \u0646\u0642\u0644 \u0627\u0644\u0641\u0626\u0629 \u0644\u0623\u0633\u0641\u0644",
  117172: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u063A\u0631\u0641\u0629",
  117200: "\u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0645\u0628\u0627\u0634\u0631",
  117201: "\u0633\u062D\u0628 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u064A\u0633 \u0645\u0628\u0627\u0634\u0631\u064B\u0627",
  117202: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117203: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117210: "\u0642\u0627\u0626\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  117211: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  117212: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  117213: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  117214: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0645\u0628\u0627\u0634\u0631\u0629",
  117215: "\u0642\u0627\u0626\u0645\u0629 \u0644\u0627 \u062A\u0639\u064A\u0634",
  117216: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0641\u064A\u062F\u064A\u0648 \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  117217: "\u062A\u0648\u062C\u062F \u0642\u0627\u0626\u0645\u0629 \u0644\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u0645\u062C\u062F\u0648\u0644 \u060C \u064A\u0631\u062C\u0649 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u0645\u062C\u062F\u0648\u0644 \u0623\u0648\u0644\u0627\u064B",
  117218: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0639\u064A\u064A\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0644\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0628\u0627\u0646\u062A\u0638\u0627\u0645",
  117219: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062D\u0644\u0642\u0629",
  117220: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0648\u0642\u062A \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u0645\u062C\u062F\u0648\u0644 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A",
  117221: "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0648\u0642\u062A \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u0645\u062C\u062F\u0648\u0644",
  117222: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0648\u0642\u062A \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u0645\u062C\u062F\u0648\u0644",
  117230: "\u0628\u0631\u0646\u0627\u0645\u062C \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  117231: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0631\u0636",
  117232: "\u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0645\u0628\u0627\u0634\u0631",
  117233: "\u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0644\u064A\u0633 \u0645\u0628\u0627\u0634\u0631\u064B\u0627",
  117240: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0647\u0645\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117241: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0647\u064A\u0626\u0629 \u0627\u0644\u0635\u0641\u062D\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642",
  117242: "\u0641\u0634\u0644 \u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117243: "\u0644\u0627 \u062A\u062D\u062A\u0648\u064A \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0639\u0644\u0649 \u062F\u0641\u0642 \u0641\u064A\u062F\u064A\u0648 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647 \u0642\u0628\u0644 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647",
  117272: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  117273: "\u062C\u0644\u0633\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  117274: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629",
  117275: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062C\u0644\u0633\u0629",
  117300: "\u062C\u0644\u0633\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  117301: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629",
  117302: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062C\u0644\u0633\u0629",
  117303: "\u064A\u0639\u062F \u0627\u0633\u062A\u062F\u0639\u0627\u0621 Tencent Cloud \u0644\u0625\u063A\u0644\u0627\u0642 \u0648\u0627\u062C\u0647\u0629 \u062A\u062F\u0641\u0642 \u062F\u0641\u0639 \u0627\u0644\u0633\u0628\u0648\u0631\u0629 \u0623\u0645\u0631\u064B\u0627 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  117304: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0647\u0645\u0629 \u0627\u0644\u0633\u0628\u0648\u0631\u0629",
  117305: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u063A\u0631\u0641\u0629",
  117306: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0645\u0643\u064A\u0646 \u062F\u0641\u0642 \u0627\u0644\u0633\u0628\u0648\u0631\u0629 \u0641\u064A \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  117307: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0623\u062A\u0627\u062D\u062A \u062A\u062F\u0641\u0642 \u0627\u0644\u0633\u0628\u0648\u0631\u0629 \u0627\u0644\u0628\u064A\u0636\u0627\u0621",
  117308: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  117309: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062A\u064A\u0627\u0631 \u0644\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  117310: "\u0645\u0633\u062A\u0646\u062F \u0623\u0648 \u0645\u0633\u0627\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  117311: "\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
  117312: "\u0637\u0648\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0627\u0644\u0630\u064A \u062A\u0645 \u062A\u062D\u0645\u064A\u0644\u0647 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F",
  117313: "\u062A\u0646\u0633\u064A\u0642 \u062A\u062D\u0645\u064A\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  117314: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0633\u062C\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
  117315: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
  117316: "\u0648\u062B\u0627\u0626\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  117317: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  117318: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
  117319: "\u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0633\u062A\u0646\u062F \u0648\u0627\u062D\u062F \u0641\u0642\u0637 \u0641\u064A \u0643\u0644 \u0645\u0631\u0629",
  117320: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0634\u0641\u0631\u0629",
  117321: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u062D\u0648\u064A\u0644 \u062A\u0631\u0645\u064A\u0632 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0627\u0644\u062D\u0627\u0644\u064A \u0628\u0646\u062C\u0627\u062D",
  117322: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0648\u0627\u0631\u062F \u0627\u0644\u0634\u0628\u0643\u0629",
  117323: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0647\u0645\u0629 \u0627\u0644\u062A\u0631\u0645\u064A\u0632",
  117324: "\u062A\u0639\u062A\u0645\u062F \u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0639\u0644\u0649 \u062A\u0645\u0643\u064A\u0646 \u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  117325: "\u064A\u0639\u062A\u0645\u062F \u0641\u062A\u062D \u0648\u0638\u064A\u0641\u0629 \u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0646\u0642\u0637\u064A\u0629 \u0639\u0644\u0649 \u0641\u062A\u062D \u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0646\u0642\u0637\u064A\u0629",
  117326: "\u0644\u0627 \u064A\u0633\u0645\u062D \u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u0634\u0627\u0647\u062F\u0629 \u0628\u0639\u0631\u0636 \u0644\u0642\u0637\u0627\u062A \u062D\u064A\u0629",
  117327: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0647\u064A \u0628\u0627\u0644\u0641\u0639\u0644 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
  117328: "\u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u062D\u0630\u0641",
  117329: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0645\u062B\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  117330: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0643\u0627\u0646 \u0631\u0626\u064A\u0633\u064A \u060C \u064A\u0631\u062C\u0649 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0631\u0626\u064A\u0633\u064A \u0623\u0648\u0644\u0627\u064B",
  117331: "\u0627\u0644\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u0638\u0645",
  117332: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0634\u0627\u0647\u062F \u0627\u0644\u062D\u064A\u0629",
  117333: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062A\u0623\u062E\u064A\u0631 \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117334: "\u062E\u0637\u0623 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u063A\u0631\u0641\u0629",
  117335: "\u062E\u0637\u0623 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0646\u0645\u0648\u0630\u062C \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  117336: "\u062A\u0639\u062F\u064A\u0644 \u062E\u0637\u0623 \u0646\u0645\u0648\u0630\u062C \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  117340: "Live Text \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  117341: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0641\u064A\u062F\u064A\u0648 \u0645\u0628\u0627\u0634\u0631",
  117342: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A \u0641\u064A \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117343: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0641\u064A \u062D\u0630\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  117344: "\u062A\u0645 \u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0644\u0635\u0648\u0631 \u0648\u0627\u0644\u0646\u0635\u0648\u0635 \u060C \u0644\u0630\u0627 \u0644\u0627 \u062F\u0627\u0639\u064A \u0644\u0625\u0639\u0627\u062F\u0629 \u062A\u0634\u063A\u064A\u0644\u0647 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  117345: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u060C \u0644\u0630\u0627 \u0644\u0627 \u062F\u0627\u0639\u064A \u0644\u0625\u063A\u0644\u0627\u0642\u0647 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  117346: "\u0646\u0637\u0627\u0642 \u0642\u064A\u0645\u0629 liveDelay \u0647\u0648 1-2",
  117347: "\u0648\u0642\u062A \u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0623\u0642\u062F\u0645 \u0645\u0646 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A",
  117348: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0648\u0642\u062A \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0623\u0642\u062F\u0645 \u0645\u0646 \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621",
  117349: "\u062A\u0646\u0633\u064A\u0642 \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621 \u0623\u0648 \u0648\u0642\u062A \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  117350: "\u062A\u0645 \u062A\u0645\u0643\u064A\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0648\u0635\u0648\u0644",
  117351: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0648\u0635\u0648\u0644",
  117352: "\u0641\u0634\u0644 \u0641\u064A \u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u0625\u064A\u062F\u0627\u0639.",
  117353: "\u0641\u0634\u0644 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062A\u0633\u062C\u064A\u0644.",
  117354: "\u062A\u0645 \u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u0645\u0648\u0636\u0648\u0639.",
  117355: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0648\u0636\u0648\u0639.",
  117356: "\u0641\u0634\u0644 \u0641\u064A \u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u0645\u0648\u0636\u0648\u0639.",
  117357: "\u0641\u0634\u0644 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0645\u0648\u0636\u0648\u0639.",
  117358: "\u0641\u0634\u0644 \u062A\u0645\u0643\u064A\u0646 Tencent Cloud Bypass push-stream",
  117359: "\u0641\u0634\u0644 \u0625\u063A\u0644\u0627\u0642 Tencent Cloud Bypass push-stream",
  117360: "\u0645\u0647\u0645\u0629 \u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  117361: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B Tencent Cloud bypass Push-Stream",
  117362: "\u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0645\u0633\u062A\u0645\u0631. \u0627\u0644\u0631\u062C\u0627\u0621 \u0645\u0639\u0627\u0648\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642",
  117363: "\u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0642\u064A\u062F \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u060C \u0648\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645",
  117364: "\u062A\u0639\u0630\u0631 \u0625\u0646\u0634\u0627\u0621 0 \u063A\u0631\u0641\u0629 \u062D\u064A\u0629 \u0645\u0624\u062C\u0644\u0629",
  117996: "\u062A\u062D\u0645\u064A\u0644 \u0645\u0633\u062A\u0646\u062F Alibaba Cloud: \u062D\u062C\u0645 \u0645\u0644\u0641 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  117997: "\u062A\u0648\u0644\u064A\u062F \u0645\u0639\u0631\u0641 \u0623\u0642\u0644 \u0645\u0646 0",
  117998: "\u0644\u0627",
  118001: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u062A\u062F\u0641\u0642",
  118002: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u063A\u0631\u0641\u0629",
  118003: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u063A\u0631\u0641\u0629",
  120001: "\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  120002: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A \u0642\u0627\u0626\u0645\u0629 \u0645\u062A\u0639\u062F\u062F\u0629",
  120003: "\u0642\u0627\u0626\u0645\u0629 \u062F\u0641\u0642 \u0627\u0644\u0633\u062D\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  120004: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0633\u062D\u0628",
  120005: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  120006: "\u062D\u0627\u0644\u0629 \u0627\u0644\u063A\u0631\u0641\u0629 \u060C \u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0645\u0634\u0647\u062F",
  120007: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0624\u0642\u062A",
  120008: "\u0647\u0646\u0627\u0643 \u0642\u0627\u0626\u0645\u0629 \u0645\u0648\u0642\u0648\u062A\u0629 \u0641\u064A \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  120009: "\u0643\u0631\u0631 \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0645\u0648\u0642\u062A",
  120010: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0647\u0645\u0629 \u0627\u0644\u0633\u062D\u0628",
  120011: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0647\u0645\u0629 \u062F\u0641\u0642 \u0627\u0644\u0633\u062D\u0628",
  120012: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0647\u0645\u0629 \u0627\u0644\u0633\u062D\u0628",
  120013: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0641\u0627\u0631\u063A",
  120014: "\u0627\u0644\u0645\u0639\u0631\u0641 \u0627\u0644\u0623\u0645\u0627\u0645\u064A \u0641\u0627\u0631\u063A",
  120015: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A \u0641\u0631\u0632 \u0627\u0644\u0645\u0647\u0627\u0645",
  120016: "\u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u062F\u064F\u0641\u0639\u0627\u062A",
  120017: "\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u062C\u0645\u0639\u0629 \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  120018: "\u0644\u0627 \u062A\u062A\u062F\u0641\u0642 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u062A\u0627\u062D\u0629",
  120019: "\u062D\u0627\u0644\u0629 \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0644\u0627 \u064A\u0645\u0643\u0646 \u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  120020: "\u0645\u0634\u0647\u062F \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  120021: "\u0628\u062F\u0627\u064A\u0629 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629 \u0644\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  120022: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0645\u0647\u0627\u0645 \u062A\u062F\u0641\u0642 \u0633\u062D\u0628 Tencent Cloud \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  120023: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  120024: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0628\u0627\u0633\u062A\u062B\u0646\u0627\u0621",
  120025: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0643\u062A\u0628\u0629 \u0648\u0633\u0627\u0626\u0637 \u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645",
  120026: "\u064A\u062A\u062C\u0627\u0648\u0632 \u062F\u0642\u0629 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  120027: "\u0645\u0635\u062F\u0631 \u0627\u0644\u0633\u062D\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  120028: "\u0645\u0635\u062F\u0631 \u0627\u0644\u0633\u062D\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  120029: "\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0645\u062A\u0645\u062B\u0644 \u0641\u064A \u0639\u062F\u0645 \u062A\u0644\u0642\u064A \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0641\u0635\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  120030: "\u0639\u0646\u0648\u0627\u0646 \u062F\u0641\u0642 \u0627\u0644\u0633\u062D\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  120031: "\u062A\u0648\u0642\u064A\u062A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  120032: "\u064A\u0642\u062A\u0635\u0631 \u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0648\u0642\u062A \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0639\u0644\u0649 7 \u0623\u064A\u0627\u0645",
  120033: "\u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621/\u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u063A\u064A\u0631 \u0645\u062A\u0648\u0642\u0639",
  120034: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621 \u0623\u0642\u062F\u0645 \u0645\u0646 \u0648\u0642\u062A \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
  120035: "\u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639\u0631\u0641 \u0645\u0647\u0645\u0629 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 Tencent Cloud \u0645\u0639 \u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0647\u0645\u0629 \u0627\u0644\u062D\u0627\u0644\u064A",
  120036: "\u0646\u0648\u0639 \u0627\u0644\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  120037: "\u0648\u0642\u062A \u062A\u0634\u063A\u064A\u0644 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  120038: "\u0625\u0631\u0633\u0627\u0644 \u0645\u0644\u0641 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0645\u0643\u0631\u0631",
  120039: "\u0647\u0646\u0627\u0643 \u0645\u0642\u0627\u0637\u0639 \u0641\u064A\u062F\u064A\u0648 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u064A\u062A\u0645 \u0641\u062D\u0635\u0647\u0627 \u062D\u0627\u0644\u064A\u064B\u0627.",
  120040: "\u0647\u0646\u0627\u0643 \u0645\u0642\u0627\u0637\u0639 \u0641\u064A\u062F\u064A\u0648 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0641\u0634\u0644\u062A \u0641\u064A \u0627\u0644\u0641\u062D\u0635.",
  120041: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0648\u0642\u062A \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u062A\u0623\u062E\u0631\u064B\u0627 \u0628\u0623\u0643\u062B\u0631 \u0645\u0646 10 \u062F\u0642\u0627\u0626\u0642 \u0639\u0646 \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621",
  120042: "\u0645\u0647\u0645\u0629 \u062A\u062F\u0641\u0642 \u0627\u0644\u0633\u062D\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  120043: "\u0645\u0639\u0627\u0644\u062C\u0629 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0628\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u060C \u0641\u0634\u0644\u062A \u0641\u064A \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  120044: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u060C \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u062F\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  120045: "\u0648\u0636\u0639 \u0627\u0644\u0628\u062B \u0627\u0644\u062D\u0627\u0644\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  121e3: "\u0646\u0648\u0639 \u0627\u0644\u0645\u0644\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  121001: "\u0628\u064A\u0627\u0646\u0627\u062A \u0642\u0627\u0645\u0648\u0633 \u0627\u0644\u0645\u0631\u0627\u062F\u0641\u0627\u062A \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0641\u0627\u0631\u063A\u0629",
  121002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0642\u0627\u0645\u0648\u0633 \u0627\u0644\u0645\u0631\u0627\u062F\u0641\u0627\u062A \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
  121003: "\u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629 \u0630\u0627\u062A\u064A\u0629 \u0627\u0644\u0628\u0646\u0627\u0621",
  121004: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0627\u062A \u062D\u0633\u0627\u0633\u0629",
  121005: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629",
  121006: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629",
  121007: "\u0643\u0644\u0645\u0629 \u062D\u0633\u0627\u0633\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  121008: "\u062A\u0639\u0630\u0631 \u062D\u0630\u0641 \u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629 \u0627\u0644\u062A\u064A \u0644\u0645 \u064A\u062A\u0645 \u0625\u0646\u0634\u0627\u0624\u0647\u0627 \u0630\u0627\u062A\u064A\u064B\u0627",
  121009: "\u062D\u062C\u0645 \u0627\u0644\u0645\u0644\u0641 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F",
  121010: "\u062A\u062A\u062C\u0627\u0648\u0632 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0644\u0641 5000",
  121011: "\u0641\u0634\u0644 \u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  121012: "\u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0639\u062F\u062F \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u0644\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0645 \u0625\u0646\u0634\u0627\u0624\u0647\u0627 \u0630\u0627\u062A\u064A\u064B\u0627 \u0627\u0644\u062D\u062F",
  121013: "\u0645\u0633\u062A\u0623\u062C\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  121014: "\u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u0645\u0641\u0642\u0648\u062F\u0629",
  121015: "\u0641\u0634\u0644 \u0645\u0624\u0634\u0631 \u0627\u0644\u062A\u0631\u0627\u0628\u0637 \u0627\u0644\u0641\u0631\u0639\u064A \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0629 \u062D\u0633\u0627\u0633\u0629 \u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631",
  121016: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0629 \u062D\u0633\u0627\u0633\u0629 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0641\u064A \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0641\u0631\u0639\u064A\u0629",
  121017: "\u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u063A\u064A\u0631 \u0644\u0627\u0626\u0642. \u064A\u0631\u062C\u0649 \u062A\u0639\u062F\u064A\u0644\u0647 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  121018: "\u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u063A\u064A\u0631 \u0644\u0627\u0626\u0642. \u064A\u0631\u062C\u0649 \u062A\u0639\u062F\u064A\u0644\u0647 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  121019: "\u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u063A\u064A\u0631 \u0644\u0627\u0626\u0642. \u064A\u0631\u062C\u0649 \u062A\u0639\u062F\u064A\u0644\u0647 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  122001: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0634\u062E\u0635 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  122002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0634\u0627\u0631\u0643",
  122003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u0643",
  122004: "\u0641\u0634\u0644\u062A \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u0643",
  122005: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062F\u062E\u0648\u0644 \u0644\u0644\u062A\u0633\u062C\u064A\u0644",
  122006: "\u0644\u0642\u062F \u062A\u0645 \u0645\u0646\u0639\u0643 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u062D\u0645\u0644\u0629",
  122007: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0647\u0630\u0627 \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  122008: "\u0623\u062F\u062E\u0644 \u0648\u0627\u062D\u062F\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0645\u0646 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0648\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  122009: "\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u062A\u0630\u0643\u0631\u0629",
  122010: "\u0627\u0644\u0634\u062E\u0635 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  122011: "\u063A\u064A\u0631 \u0645\u0633\u062C\u0644 \u0644\u0647\u0630\u0627 \u0627\u0644\u062D\u062F\u062B",
  122012: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0636\u064A\u0641",
  122013: "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0633\u062C\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  122014: "\u0625\u0630\u0627 \u062A\u062C\u0627\u0648\u0632\u062A \u0627\u0644\u0643\u0645\u064A\u0629 500 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u0645\u064A\u0644\u0647\u0627 \u0639\u0644\u0649 \u062F\u0641\u0639\u0627\u062A",
  122015: "\u0644\u0627 \u064A\u062A\u0648\u0627\u0641\u0642 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0645\u0639 \u0645\u0648\u0627\u0635\u0641\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u064A\u0631\u0627\u062F \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0639\u0645\u0644 \u0648\u0641\u0642\u064B\u0627 \u0644\u0645\u0648\u0627\u0635\u0641\u0627\u062A \u0642\u0627\u0644\u0628 \u0645\u0633\u062A\u0646\u062F EXCEL",
  122016: "\u062D\u0627\u0644\u0629 \u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u062C\u0645\u0647\u0648\u0631 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  122017: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0648\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0648\u0627\u0644\u0645\u0634\u0627\u0647\u062F\u0648\u0646 \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0648\u0646 \u0627\u0644\u0645\u0631\u062E\u0635\u0648\u0646 \u0644\u0627 \u064A\u062F\u0639\u0645\u0648\u0646 \u0627\u0644\u062D\u0630\u0641",
  123001: "\u062A\u0643\u0648\u064A\u0646 \u062A\u062E\u0648\u064A\u0644 \u0627\u0644\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  123002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u0643\u0648\u064A\u0646 \u062A\u0631\u062E\u064A\u0635 \u0627\u0644\u063A\u0631\u0641\u0629",
  123003: "\u0641\u0634\u0644 \u0625\u0641\u0631\u0627\u063A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0628\u064A\u0636\u0627\u0621 \u0644\u0644\u0647\u0627\u062A\u0641",
  123004: "\u0623\u0633\u0645\u0627\u0621 \u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0645\u0643\u0631\u0631\u0629 \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629.",
  123005: "\u0633\u062D\u0628 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0628\u064A\u0636\u0627\u0621 \u0641\u0634\u0644 \u0627\u0644\u062A\u0641\u0648\u0642",
  123006: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0641\u0627\u0631\u063A\u064B\u0627",
  123007: "\u0645\u0639\u0644\u0645\u0629 tenantId \u0645\u0641\u0642\u0648\u062F\u0629",
  123008: "roomId \u0645\u0639\u0644\u0645\u0629 \u0645\u0641\u0642\u0648\u062F\u0629",
  123009: "0 \u062A\u0623\u062E\u064A\u0631 \u0623\u0648 \u063A\u0631\u0641\u0629 \u0627\u0644\u062A\u0633\u0631\u064A\u0639 \u0627\u0644\u0639\u0627\u0644\u0645\u064A\u0629 \u0644\u0627 \u064A\u0645\u0643\u0646 \u0641\u062A\u062D \u062E\u0637\u0648\u0637 \u0645\u062A\u0639\u062F\u062F\u0629",
  124001: "\u062A\u0643\u0648\u064A\u0646 \u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  124002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u062A\u0643\u0648\u064A\u0646 \u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0645\u062A\u0635\u0644",
  124003: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0639\u0631\u0641 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124004: "\u062A\u0645 \u0625\u064A\u0642\u0627\u0641 \u062A\u0634\u063A\u064A\u0644 \u0645\u0643\u0627\u0644\u0645\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0648\u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627",
  124005: "\u062A\u0645 \u0625\u064A\u0642\u0627\u0641 \u062A\u0634\u063A\u064A\u0644 \u0645\u0641\u062A\u0627\u062D \u0627\u062A\u0635\u0627\u0644 \u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0627\u0644\u0636\u064A\u0641 \u060C \u0648\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0628\u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  124006: "\u062A\u0645 \u0636\u0628\u0637 \u0648\u0636\u0639 \u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0636\u064A\u0641 \u0639\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
  124007: "\u062A\u0645 \u0625\u064A\u0642\u0627\u0641 \u062A\u0634\u063A\u064A\u0644 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u062C\u0645\u0647\u0648\u0631 \u0644\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u060C \u0648\u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627",
  124008: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0648\u0635\u064A\u0644 \u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0628\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
  124009: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0645\u0639\u0644\u0645\u0629",
  124010: "\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0636\u064A\u0641 \u0623\u0648 \u0627\u0644\u0645\u0642\u062F\u0645 \u0641\u0642\u0637 \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
  124011: "\u0644\u0627 \u062A\u0643\u0631\u0631 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0634\u0627\u0634\u0629",
  124012: "\u062D\u0627\u0644\u0629 \u0625\u062E\u0631\u0627\u062C \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0647\u064A \u0628\u0627\u0644\u0641\u0639\u0644 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0625\u062E\u0631\u0627\u062C \u0623\u0648 \u0627\u0644\u0625\u062E\u0631\u0627\u062C",
  124013: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u062A\u062E\u062F\u0645 \u062F\u0631\u062F\u0634\u0629 \u0645\u0628\u0627\u0634\u0631\u0629",
  124014: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  124015: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0647\u0648 \u0645\u0642\u062F\u0645 \u0627\u0644\u0639\u0631\u0636 \u0628\u0627\u0644\u0641\u0639\u0644",
  124016: "\u0627\u0644\u0645\u0634\u063A\u0644 \u0644\u064A\u0633 \u0627\u0644\u0648\u0633\u064A\u0637",
  124017: "\u0627\u0644\u0645\u062A\u062D\u062F\u062B \u0627\u0644\u0623\u0635\u0644\u064A \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  124018: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u062A\u0635\u0644 \u0628\u0627\u0644\u0641\u0639\u0644 \u0628\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
  124019: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u064A\u064A\u0646 \u0627\u0644\u062C\u0645\u0647\u0648\u0631 \u0643\u0645\u0642\u062F\u0645",
  124020: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u062A\u0635\u0644 \u0628\u0627\u0644\u0641\u0639\u0644 \u0628\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
  124021: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0639\u0631\u0651\u0641 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  124022: "\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0636\u064A\u0641 \u0623\u0648 \u0627\u0644\u0645\u0642\u062F\u0645 \u0641\u0642\u0637 \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629",
  124023: "\u0644\u0627 \u062A\u0643\u0631\u0631 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0634\u0627\u0634\u0629",
  124030: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124031: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0645\u0643\u0633\u0648",
  124032: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u062F\u062B \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  124033: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u062F\u062B",
  124034: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u062F\u062B",
  124035: "\u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u0639\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u064A\u0648\u0645 \u0645\u0639\u064A\u0646 \u0641\u0627\u0631\u063A\u0629",
  124040: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  124041: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A",
  124050: "\u0633\u062C\u0644 \u0637\u0644\u0628 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  124051: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0637\u0644\u0628 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124052: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0633\u062C\u0644 \u0637\u0644\u0628 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  124053: "\u0627\u0644\u0645\u0636\u064A\u0641 \u063A\u064A\u0631 \u0645\u062A\u0635\u0644 \u0628\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
  124054: "\u062A\u0645\u062A \u0645\u0639\u0627\u0644\u062C\u0629 \u0637\u0644\u0628 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124055: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0645\u062A\u0648\u0627\u0641\u0642 \u0645\u0639 \u0645\u0633\u062A\u062E\u062F\u0645 \u0637\u0644\u0628 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  124056: "\u063A\u0631\u0641\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629 \u0645\u0645\u062A\u0644\u0626\u0629",
  124057: "\u062A\u0645 \u0636\u0628\u0637 \u0648\u0636\u0639 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0627\u0644\u0645\u0633\u062A\u0645\u0631 \u0639\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
  124058: "linkRequestId \u0645\u0637\u0644\u0648\u0628",
  124059: "\u062A\u0645 \u0631\u0641\u0636 \u0637\u0644\u0628 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  124060: "\u064A\u0648\u062C\u062F \u062D\u0627\u0644\u064A\u064B\u0627 \u0645\u0633\u062A\u062E\u062F\u0645 \u062F\u0631\u062F\u0634\u0629 \u0645\u0628\u0627\u0634\u0631\u0629 \u060C \u0641\u0634\u0644 \u0641\u064A \u062A\u0639\u0637\u064A\u0644\u0647",
  124061: "\u064A\u0648\u062C\u062F \u062D\u0627\u0644\u064A\u064B\u0627 \u062A\u0637\u0628\u064A\u0642 \u062F\u0631\u062F\u0634\u0629 \u0645\u0628\u0627\u0634\u0631 \u0623\u0648 \u062F\u0639\u0648\u0629 \u060C \u0641\u0634\u0644 \u062A\u0639\u0637\u064A\u0644\u0647\u0627",
  124062: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  124065: "\u0627\u0644\u0646\u0648\u0639 \u063A\u064A\u0631 \u0645\u062A\u0648\u0627\u0641\u0642 \u0645\u0639 \u0646\u0648\u0639 \u0637\u0644\u0628 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  124067: "\u064A\u0645\u0643\u0646 \u0641\u0642\u0637 \u0644\u0644\u0636\u064A\u0648\u0641 \u0648\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u062C\u0645\u0647\u0648\u0631 \u0627\u0644\u0645\u062D\u062F\u062F\u064A\u0646 \u0627\u0644\u062A\u0642\u062F\u0645 \u0639\u0628\u0631 \u0647\u064A\u0626\u0629 \u0627\u0644\u062A\u0635\u0646\u064A\u0639 \u0627\u0644\u0639\u0633\u0643\u0631\u064A",
  124068: "\u062A\u0645 \u0628\u062F\u0621 \u062A\u0637\u0628\u064A\u0642 \u062A\u0648\u0635\u064A\u0644 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0623\u0648 \u062A\u0645 \u062A\u0648\u0635\u064A\u0644 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
  124069: "\u0647\u0646\u0627\u0643 \u0637\u0644\u0628 \u0644\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0623\u0648 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0642\u062F \u062A\u0645 \u062A\u0648\u0635\u064A\u0644\u0647",
  124070: "\u0627\u0644\u0636\u064A\u0641 \u0644\u064A\u0633 \u0645\u062A\u0635\u0644\u0627\u064B \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
  124071: "\u064A\u0645\u0643\u0646 \u062F\u0639\u0648\u0629 \u0627\u0644\u0636\u064A\u0648\u0641 \u0641\u0642\u0637 \u0644\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124072: "\u0627\u0644\u0639\u062F\u062F \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0644\u0623\u0634\u062E\u0627\u0635 \u0645\u0645\u062A\u0644\u0626 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  124073: "\u0627\u0646\u062A\u0647\u062A \u0645\u0647\u0644\u0629 \u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0637\u0644\u0628 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  124074: "\u0641\u0634\u0644 \u0637\u0644\u0628 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124075: "\u0644\u0627 \u062A\u062A\u0642\u062F\u0645 \u0628\u0637\u0644\u0628 \u0644\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  124076: "\u0641\u0634\u0644 \u0627\u0644\u0628\u062B \u060C \u063A\u0631\u0641\u0629 \u0633\u062D\u0627\u0628\u0629 Tencent \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  124077: "\u0641\u0634\u0644 \u0645\u0633\u0643",
  124078: "\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0636\u064A\u0641 \u0641\u0642\u0637 \u0643\u062A\u0645 \u0635\u0648\u062A \u0627\u0644\u0643\u0644",
  124079: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0639\u064A\u064A\u0646 \u0646\u0648\u0639 \u0631\u0633\u0627\u0644\u0629 \u0637\u0644\u0628 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  124080: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0639\u064A\u064A\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646",
  124081: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0625\u062E\u0631\u0627\u062C \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124082: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0633\u062C\u0644 \u0625\u062E\u0631\u0627\u062C \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124083: "\u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u062A\u062D\u062F\u062B \u0641\u0642\u0637 \u0636\u0628\u0637 \u0627\u0644\u062A\u062E\u0637\u064A\u0637",
  124084: "\u0633\u062C\u0644 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  124085: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124086: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0633\u062C\u0644 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124087: "\u0644\u0627 \u062A\u0642\u0645 \u0628\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  124088: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0647\u0630\u0647 \u0627\u0644\u0639\u0645\u0644\u064A\u0629",
  124089: "\u0644\u0627 \u064A\u062A\u0641\u0642 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646 \u0645\u0639 \u0645\u0633\u062A\u062E\u062F\u0645\u064A \u0637\u0644\u0628 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  124090: "\u0641\u0634\u0644 \u0634\u0627\u0634\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
  124091: "\u062A\u0645 \u0642\u0637\u0639 \u0645\u0627\u064A \u0627\u0644\u062D\u0627\u0644\u064A",
  124092: "\u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629 \u0642\u064A\u062F \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u060C \u0641\u0634\u0644\u062A \u0641\u064A \u062A\u0628\u062F\u064A\u0644 \u0648\u0636\u0639 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629 \u0639\u0627\u0644\u064A\u0629 \u0627\u0644\u062F\u0642\u0629",
  124093: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0644\u064A\u0627\u0646 \u0645\u0627\u064A \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  124094: "\u0641\u0634\u0644\u062A \u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u0623\u0648\u0644\u0627\u064B \u0627\u062A\u0628\u0627\u0639 \u0627\u0644\u0642\u0645\u062D \u062B\u0645 \u0627\u0644\u0639\u0645\u0644",
  124095: "\u0641\u064A \u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0623\u062E\u064A\u0631\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  124096: "\u0644\u0627 \u062A\u0643\u0631\u0631 \u0627\u0644\u0639\u0645\u0644\u064A\u0629",
  124097: "\u0641\u0642\u0637 \u0627\u0644\u0646\u0627\u0633 \u064A\u0645\u0643\u0646\u0647\u0645 \u0627\u0644\u0639\u0645\u0644",
  124098: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0648\u0627\u0644\u0644\u0648\u062D\u0627\u062A \u0627\u0644\u0628\u064A\u0636\u0627\u0621 \u0648\u0627\u0644\u0634\u0627\u0634\u0627\u062A \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629 \u063A\u064A\u0631 \u0645\u0641\u062A\u0648\u062D\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0628\u062F\u064A\u0644\u0647\u0627 \u0628\u0627\u0644\u0634\u0627\u0634\u0629",
  124099: "\u0639\u0627\u0645\u0644 \u063A\u064A\u0631 \u0642\u0627\u0626\u062F \u0641\u0631\u064A\u0642",
  124100: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0642\u0627\u0626\u062F \u0627\u0644\u0641\u0631\u064A\u0642 \u0641\u0642\u0637 \u0643\u062A\u0645 \u0627\u0644\u0635\u0648\u062A",
  124101: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u062D\u064A\u0629",
  125001: "\u0645\u0639\u0644\u0645\u0629 \u0628\u064A\u0627\u0646\u0627\u062A \u0637\u0644\u0628 \u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u0641\u0627\u0631\u063A\u0629",
  125002: "\u0646\u0648\u0639 \u062F\u0641\u0639 \u062E\u0627\u0637\u0626",
  125003: "\u0645\u0639\u0644\u0645\u0627\u062A \u0627\u0644\u062F\u0641\u0639 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  125004: "\u0627\u0644\u062A\u0646\u0641\u064A\u0630 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062F\u0641\u0639",
  125005: "\u0645\u0639\u0644\u0645\u0629 \u0627\u0633\u062A\u0631\u062F\u0627\u062F \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  125006: "\u0633\u062C\u0644 \u0627\u0644\u062F\u0641\u0639 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  125007: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  125008: "\u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0648\u0627\u062C\u0647\u0629 \u0637\u0644\u0628 WeChat \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  125009: "\u064A\u0639\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0648\u0627\u062C\u0647\u0629 \u0627\u0633\u062A\u0631\u062F\u0627\u062F WeChat \u0623\u0645\u0631\u064B\u0627 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  125010: "\u0633\u062C\u0644 \u0627\u0644\u062F\u0641\u0639 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  125011: "\u062F\u0641\u0639 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  125012: "\u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 \u062E\u0627\u0637\u0626\u0629",
  125013: "\u0646\u0648\u0639 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 WeChat \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
  125014: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0641\u0643 \u062A\u0634\u0641\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 WeChat",
  125015: "\u0643\u0631\u0631 \u0627\u0644\u062F\u0641\u0639 \u0644\u0623\u0645\u0631",
  125016: "\u0623\u063A\u0644\u0642 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0637\u0644\u0628 WeChat",
  125017: "\u062D\u0627\u0644\u0629 \u0637\u0644\u0628 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  125018: "\u062D\u0627\u0644\u0629 \u0633\u062C\u0644 \u062F\u0641\u0639 WeChat \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  125019: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u062F\u0641\u0639",
  125020: "\u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u062D\u0627\u0644\u064A \u0641\u064A \u0639\u0645\u0644\u064A\u0629 \u0627\u0633\u062A\u0631\u062F\u0627\u062F \u0627\u0644\u0623\u0645\u0648\u0627\u0644",
  125021: "\u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639",
  125022: "\u0645\u0628\u0644\u063A \u0627\u0644\u0627\u0633\u062A\u0631\u062F\u0627\u062F \u064A\u062A\u062C\u0627\u0648\u0632 \u0645\u0628\u0644\u063A \u0627\u0644\u062F\u0641\u0639",
  125023: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0648\u0642\u062A \u0627\u0644\u0627\u0633\u062A\u0631\u062F\u0627\u062F \u0627\u0644\u0645\u062D\u062F\u062F",
  125024: "\u0641\u0634\u0644 \u0637\u0644\u0628 \u0627\u0633\u062A\u0631\u062F\u0627\u062F WeChat",
  125025: "\u0646\u0648\u0639 \u0627\u0644\u0639\u0645\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  125100: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u0637\u0644\u0628",
  125101: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u0637\u0644\u0628",
  125102: "\u0633\u062C\u0644 \u0637\u0644\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  125110: "\u0623\u0636\u0641 \u0633\u062C\u0644 \u062F\u0641\u0639 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  125111: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u062F\u0641\u0639",
  125112: "\u0633\u062C\u0644 \u0627\u0644\u062F\u0641\u0639 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  125120: "\u0623\u0636\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u0644\u0649 \u0633\u062C\u0644 \u0627\u0644\u0627\u0633\u062A\u0631\u062F\u0627\u062F",
  125121: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u0627\u0633\u062A\u0631\u062F\u0627\u062F",
  125122: "\u0633\u062C\u0644 \u0627\u0633\u062A\u0631\u062F\u0627\u062F \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  125130: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u062C\u0644 \u062A\u0633\u0648\u064A\u0629 \u062D\u0633\u0627\u0628 WeChat",
  125131: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u062C\u0644 \u062A\u0633\u0648\u064A\u0629 \u062D\u0633\u0627\u0628 WeChat",
  125132: "\u0633\u062C\u0644 \u062A\u0633\u0648\u064A\u0629 WeChat \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  125133: "\u0633\u062C\u0644 \u0627\u0633\u062A\u0631\u062F\u0627\u062F \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  125134: "\u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0648\u0627\u062C\u0647\u0629 WeChat \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  125135: "JsApi \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
  125136: "\u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u0645\u062F\u0641\u0648\u0639",
  126001: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0645\u0629 \u0645\u0641\u0642\u0648\u062F\u0629",
  126002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0627\u0644\u062C\u0644\u0633\u0629",
  126003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0633\u0645 \u0627\u0644\u062C\u0644\u0633\u0629",
  126004: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062C\u0644\u0633\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  126005: "\u0645\u0639\u0644\u0645\u0629 \u0637\u0644\u0628 \u0627\u0644\u0628\u062D\u062B \u0645\u0641\u0642\u0648\u062F\u0629",
  126006: "\u0641\u0634\u0644 \u062D\u0633\u0627\u0628 \u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0642\u062A \u0627\u0644\u0645\u0634\u0627\u0647\u062F\u0629",
  126007: "\u0641\u0634\u0644 \u0639\u062F \u0627\u0644\u0645\u0634\u0627\u0647\u062F\u064A\u0646",
  126008: "\u0641\u0634\u0644 \u062D\u0633\u0627\u0628 \u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0639\u0631\u0636",
  126020: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  126021: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0628\u062B \u0639\u0646\u062F \u0627\u0644\u0637\u0644\u0628",
  126022: "\u0623\u0636\u0641 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0627\u0644\u063A\u0631\u0641\u0629",
  126023: "\u0623\u0636\u0641 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u063A\u0631\u0641\u0629",
  126024: "\u064A\u0633\u062A\u063A\u0631\u0642 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0625\u062D\u0635\u0627\u0621\u0627\u062A \u0627\u0644\u063A\u0631\u0641\u0629 \u0648\u0642\u062A\u064B\u0627 \u0637\u0648\u064A\u0644\u0627\u064B",
  126025: "\u0627\u0646\u062A\u0647\u062A \u0645\u0647\u0644\u0629 \u0645\u0647\u0645\u0629 \u062A\u0646\u0641\u064A\u0630 \u0645\u0624\u0634\u0631 \u0627\u0644\u062A\u0631\u0627\u0628\u0637 \u0627\u0644\u0641\u0631\u0639\u064A",
  126026: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0646\u0641\u064A\u0630 \u0645\u0624\u0634\u0631 \u062A\u0631\u0627\u0628\u0637 \u062A\u0627\u0628\u0639",
  126027: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0633\u062C\u0644 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0627\u0644\u0646\u0634\u0627\u0637",
  126028: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0633\u062C\u0644 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0627\u0644\u0646\u0634\u0627\u0637",
  126029: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0633\u062C\u0644 \u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0646\u0634\u0637\u0629",
  126030: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0633\u062C\u0644 \u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0646\u0634\u0637\u0629",
  126031: "\u0644\u0627 \u062A\u0633\u062A\u062E\u062F\u0645 \u0627\u0633\u062A\u0639\u0644\u0627\u0645\u0627\u062A \u0630\u0627\u062A \u0628\u064F\u0639\u062F\u064A\u0646 \u0641\u064A \u0646\u0641\u0633 \u0627\u0644\u0648\u0642\u062A",
  126032: "\u0633\u062C\u0644 \u0627\u0644\u0625\u0639\u062C\u0627\u0628\u0627\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  126033: "\u062D\u0641\u0638 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u063A\u0631\u0641\u0629",
  126034: "\u062D\u0641\u0638 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0642\u0646\u0627\u0629",
  126035: "\u0645\u0639\u0644\u0645\u0627\u062A \u0642\u0627\u0626\u0645\u0629 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  126036: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  126037: "\u0646\u0648\u0639 \u0631\u062A\u0628\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  126038: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u062A\u062D\u062F\u064A\u062F \u0644\u0639\u0631\u0636 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0642\u0646\u0627\u0629 \u0623\u0648 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0643\u0627\u0646",
  126039: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629",
  126040: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0627\u0644\u0625\u0643\u0631\u0627\u0645\u064A\u0629",
  126041: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
  126042: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
  126043: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0639\u062F\u062F \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0628\u0627\u0644\u064A\u0648\u0645",
  126044: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0639\u062F\u062F \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u064A\u0648\u0645",
  127001: "\u0627\u0633\u0645 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u062A\u0643\u0631\u0627\u0631",
  127002: "\u064A\u062A\u0631\u0627\u0648\u062D \u0639\u062F\u062F \u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0645\u0646 2 \u0625\u0644\u0649 50",
  127003: "\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0645\u0646 \u0646\u0641\u0633 \u0627\u0644\u0646\u0648\u0639",
  127004: "\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  127005: "\u0641\u0634\u0644 \u0641\u064A \u062D\u0630\u0641 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646",
  127006: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u062D\u0627\u0644\u0629 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646",
  127007: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0646\u0634\u0637 \u0641\u064A \u063A\u0631\u0641\u0629 \u0627\u0644\u0645\u0639\u064A\u0634\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  127008: "\u0627\u0644\u0633\u0624\u0627\u0644 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0644\u0645 \u062A\u062A\u0645 \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \u0639\u0644\u064A\u0647",
  127009: "\u0642\u0627\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0628\u0645\u0644\u0621 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646",
  127010: "\u0644\u0642\u062F \u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0627\u0644\u062D\u0627\u0644\u064A \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0642\u062F\u064A\u0645\u0647",
  127011: "\u064A\u0648\u062C\u062F \u062D\u0627\u0644\u064A\u064B\u0627 \u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0642\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0623\u0648\u0644\u0627\u064B",
  127012: "\u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0627\u0644\u062D\u0627\u0644\u064A \u0642\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0623\u0648\u0644\u0627\u064B",
  127013: "\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0645\u062A\u0639\u062F\u062F\u0629 \u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627 \u0641\u064A \u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0646 \u0645\u062A\u0639\u062F\u062F",
  127014: "\u0644\u0627 \u062A\u0642\u0645 \u0628\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u0628\u064A\u0627\u0646\u0627\u062A \u0641\u0627\u0631\u063A\u0629",
  127015: "\u064A\u062D\u062A\u0627\u062C \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0625\u0644\u0649 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u062A\u0641\u0627\u0642\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0642\u0628\u0644 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0625\u062C\u0627\u0628\u0629",
  127016: "\u0639\u0646\u0648\u0627\u0646 \u0633\u0624\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0623\u062D\u0631\u0641",
  127017: "\u064A\u062A\u062C\u0627\u0648\u0632 \u0645\u062D\u062A\u0648\u0649 \u062E\u064A\u0627\u0631 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0643\u0644\u0645\u0627\u062A",
  127018: "\u0645\u062D\u062A\u0648\u0649 \u0625\u062C\u0627\u0628\u0629 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u0643\u0644\u0645\u0627\u062A",
  127019: "\u064A\u064F\u0633\u0645\u062D \u0641\u0642\u0637 \u0628\u0640 11 \u0631\u0642\u0645\u064B\u0627 \u0644\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0641\u064A \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646",
  127020: "\u062A\u0646\u0633\u064A\u0642 \u0631\u0642\u0645 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u0631\u062F \u0639\u0644\u0649 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  127021: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0647\u0630\u0627 \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  127022: "\u064A\u0631\u062C\u0649 \u062A\u0643\u0648\u064A\u0646 \u062A\u062C\u0627\u0631 WeChat \u0644\u0644\u062F\u0641\u0639 \u0623\u0648\u0644\u0627\u064B \u060C \u0648\u0625\u0644\u0627 \u0641\u0644\u0646 \u064A\u062A\u0645 \u062A\u0645\u0643\u064A\u0646 \u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u0634\u062D\u0646",
  127023: "\u0646\u0637\u0627\u0642 \u0633\u0639\u0631 \u0627\u0644\u0634\u062D\u0646 \u0647\u0648 0.01 ~ 999999.99",
  127024: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0631\u0643 \u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0641\u0627\u0631\u063A\u0629",
  127025: "\u062F\u0639\u0645 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 50 \u0633\u0624\u0627\u0644\u0627",
  127026: "\u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629 \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0639\u0645\u0644\u064A\u0629",
  127027: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0631\u0643 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0641\u0627\u0631\u063A\u064B\u0627",
  127028: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u062E\u064A\u0627\u0631 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0646 \u0645\u062A\u0639\u062F\u062F \u0641\u0627\u0631\u063A\u064B\u0627",
  127029: "\u0641\u0634\u0644 \u0641\u064A \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646",
  127030: "\u0641\u0634\u0644 \u0641\u064A \u062D\u0630\u0641 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646",
  127031: "\u064A\u062C\u0628 \u0645\u0644\u0621 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
  127032: "\u062E\u0637\u0623 \u0641\u064A \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
  127033: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u0641\u0627\u0631\u063A\u064B\u0627",
  127034: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0631\u0643 \u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u0646\u0634\u0627\u0637 \u0641\u0627\u0631\u063A\u064B\u0627",
  127035: "\u0627\u0644\u0633\u0624\u0627\u0644 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0644\u0645 \u064A\u062A\u0645 \u0645\u0644\u0624\u0647",
  127036: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0645\u0634\u062A\u0631\u0643 \u0627\u0644\u062D\u0627\u0644\u064A \u060C \u0644\u0645 \u064A\u0639\u062F \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u064A\u062F\u0639\u0645 \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
  127037: "\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0634\u0631\u0639\u064A\u0629 \u0644\u0646\u0648\u0639 \u0627\u0644\u0633\u0624\u0627\u0644",
  127038: "\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u062A\u0630\u0643\u0631\u0629",
  127039: "\u0644\u0642\u062F \u0634\u0627\u0631\u0643\u062A \u0628\u0627\u0644\u0641\u0639\u0644 \u0641\u064A \u0627\u0644\u0646\u0634\u0627\u0637 \u060C \u0648\u0644\u0627 \u062F\u0627\u0639\u064A \u0644\u0644\u062A\u0633\u062C\u064A\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  127040: "\u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0637\u0631\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0644\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0623\u0648 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  127041: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0645\u0639\u0631\u0641 \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0641\u0627\u0631\u063A\u064B\u0627",
  127042: "\u0633\u0624\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  127043: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0645\u062D\u062A\u0648\u0649 \u062E\u064A\u0627\u0631 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0646 \u0645\u062A\u0639\u062F\u062F \u0641\u0627\u0631\u063A\u064B\u0627",
  127044: "\u0627\u0633\u0645 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0645\u0637\u0644\u0648\u0628",
  127045: "\u0646\u0637\u0627\u0642 \u0642\u064A\u0645\u0629 questionScore \u0647\u0648 1-100",
  127046: "\u0645\u0646\u0638\u0645 \u062D\u0627\u0644\u064A\u0627 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 . \u0627\u0644\u0631\u062C\u0627\u0621 \u0639\u062F\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  127047: "\u0627\u0644\u0645\u0646\u0638\u0645 \u064A\u0624\u0643\u062F \u062A\u0633\u062C\u064A\u0644\u0643 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 \u0628\u0635\u0628\u0631",
  127048: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u062A\u0633\u062C\u064A\u0644\u0643 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 \u0628\u0635\u0628\u0631",
  127049: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u062A\u0633\u062C\u064A\u0644\u0643 \u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  127050: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0639\u062F\u062F \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0623\u0648 \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A \u0647\u0648 \u0646\u0641\u0633\u0647 \u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0635\u064A\u0646\u064A",
  128001: "\u062A\u062D\u0638\u0631 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u062A\u0628\u062F\u064A\u0644 \u0648\u0636\u0639 \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u064A\u0629",
  128002: "\u064A\u062D\u0638\u0631 \u062A\u0628\u062F\u064A\u0644 \u0648\u0636\u0639 \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u064A\u0629 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  128003: "\u0634\u0627\u0634\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  128004: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
  128005: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
  128006: "\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  128007: "\u0645\u0639\u0644\u0645\u0629 \u0645\u0639\u0631\u0641 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629 \u0645\u0641\u0642\u0648\u062F\u0629",
  128008: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u062D\u062F\u064A\u062F \u0635\u0648\u0631\u0629 \u0643\u0635\u0648\u0631\u0629 \u0631\u0626\u064A\u0633\u064A\u0629",
  128009: "\u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0647\u064A \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0628\u0627\u0644\u0641\u0639\u0644",
  128010: "\u0641\u0634\u0644 \u0627\u0633\u062A\u062F\u0639\u0627\u0621 \u062D\u0638\u0631 \u0627\u0644\u062F\u0641\u0639",
  128011: "\u0641\u0634\u0644 \u0627\u0633\u062A\u062F\u0639\u0627\u0621 \u062F\u0641\u0642 \u062F\u0641\u0639 \u0627\u0633\u062A\u0626\u0646\u0627\u0641",
  128012: "\u0641\u0634\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0628\u062B",
  128013: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u064A\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0642\u064A\u062F \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0648\u0644\u0627 \u062A\u062F\u0639\u0645 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0635\u0648\u0631",
  128014: "\u0645\u0648\u0627\u0631\u062F \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629 \u0644\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  128015: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0627 \u064A\u062F\u0639\u0645 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0635\u0648\u0631",
  128016: "\u0627\u0633\u0645 \u0627\u0644\u0634\u0627\u0634\u0629 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u0627\u0632\u062F\u0648\u0627\u062C\u064A\u0629",
  128017: "\u063A\u0631\u0641\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u062D\u064A\u0629 \u0648\u0644\u0627 \u062A\u062F\u0639\u0645 \u062D\u0630\u0641 \u0627\u0644\u0634\u0627\u0634\u0629",
  128018: "\u064A\u062D\u0638\u0631 \u062D\u0630\u0641 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
  128019: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u0633\u0648\u0649 8 \u0634\u0627\u0634\u0627\u062A \u0643\u062D\u062F \u0623\u0642\u0635\u0649",
  128020: "\u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631\u064A\u0646 \u064A\u0641\u062A\u0642\u0631\u0648\u0646 \u0625\u0644\u0649 \u0645\u0648\u0627\u0631\u062F \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  128021: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0634\u0627\u0634\u0629",
  128022: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062E\u0637\u0623 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062F\u0641\u0642 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
  128023: "\u0641\u0634\u0644 \u062A\u0639\u0648\u064A\u0636 \u062A\u0648\u0642\u064A\u062A \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0641\u064A \u062A\u0645\u0643\u064A\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  128024: "\u062A\u0648\u0642\u0641 \u062A\u0639\u0648\u064A\u0636 \u062F\u0641\u0639 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0639\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0641\u0634\u0644\u062A",
  128025: "\u0641\u0634\u0644 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0634\u0627\u0634\u0629",
  128026: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0634\u0627\u0634\u0629",
  128027: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0627\u0644\u0627\u062A \u062F\u0641\u0639 \u0645\u062A\u0627\u062D\u0629 \u0641\u064A \u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0645\u062C\u0627\u0644.",
  128028: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0627\u0644\u0627\u062A \u0633\u062D\u0628 \u0645\u062A\u0648\u0641\u0631\u0629 \u0641\u064A \u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0645\u062C\u0627\u0644.",
  128029: "\u0647\u0646\u0627\u0643 \u062A\u064A\u0627\u0631 \u0641\u064A \u062F\u0641\u0639 \u062A\u064A\u0627\u0631 \u060C \u0644\u0627 \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0628\u062B",
  129001: "\u062D\u062F\u062B \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  129002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u062F\u062B \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642.",
  129003: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u062F\u062B",
  129004: "\u0641\u0634\u0644 \u062D\u062F\u062B \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
  129005: "\u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u062D\u062F\u062B",
  129006: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0646\u0634\u0631 \u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0639\u0645\u0644\u064A\u0629.",
  129007: "\u062A\u0645 \u0627\u0644\u0646\u0634\u0631 \u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0639\u0645\u0644\u064A\u0629.",
  129008: "\u0644\u0642\u062F \u0645\u0631 \u0648\u0642\u062A \u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u062D\u062F\u062B \u0627\u0644\u062D\u0627\u0644\u064A\u060C \u064A\u0631\u062C\u0649 \u062A\u0639\u062F\u064A\u0644 \u0648\u0642\u062A \u0627\u0644\u062D\u062F\u062B \u0642\u0628\u0644 \u0627\u0644\u0646\u0634\u0631",
  129009: "\u0641\u0634\u0644 \u0641\u064A \u062A\u0639\u064A\u064A\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0646\u0634\u0631",
  129010: "\u0644\u0645 \u064A\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u063A\u0631\u0641\u0629 \u0628\u0648\u0627\u0633\u0637\u0629 \u0627\u0644\u062D\u062F\u062B.",
  129011: "\u062C\u062F\u0648\u0644 \u0627\u0644\u062D\u062F\u062B \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  129012: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u062C\u062F\u0648\u0644 \u0627\u0644\u062D\u062F\u062B",
  129013: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062C\u062F\u0648\u0644 \u0627\u0644\u062D\u062F\u062B",
  129014: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u062C\u062F\u0648\u0644 \u0627\u0644\u062D\u062F\u062B",
  129015: "\u062A\u0645 \u0628\u0627\u0644\u0641\u0639\u0644 \u0625\u0642\u0631\u0627\u0646 \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0628\u0648\u0642\u062A \u062D\u062F\u062B \u0645\u062C\u062F\u0648\u0644 \u0622\u062E\u0631. \u064A\u0631\u062C\u0649 \u0627\u0644\u0636\u0628\u0637 \u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u0631.",
  129016: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u062D\u062F\u062B.",
  129017: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u062D\u062F\u062B.",
  129018: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0633\u0645 \u0627\u0644\u0636\u064A\u0641 \u0641\u0627\u0631\u063A\u064B\u0627",
  129019: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0646\u0634\u0631 \u0627\u0644\u062D\u062F\u062B \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A. \u064A\u0631\u062C\u0649 \u0625\u0646\u0634\u0627\u0621 \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0623\u0648\u0644\u0627\u064B \u0648\u0646\u0634\u0631\u0647 \u0644\u0627\u062D\u0642\u064B\u0627.",
  129020: "\u0644\u0627 \u062A\u0633\u062C\u064A\u0644 \u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u0646\u0634\u0631 \u0627\u0644\u062D\u062F\u062B",
  129021: "\u062A\u0645 \u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
  129022: "\u062A\u0646\u0633\u064A\u0642 \u0648\u0642\u062A \u0628\u062F\u0621 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  129023: "\u062A\u0646\u0633\u064A\u0642 \u0648\u0642\u062A \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  129024: "\u0648\u0642\u062A \u0628\u062F\u0621 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0623\u0648 \u0646\u0647\u0627\u064A\u062A\u0647 \u0641\u0627\u0631\u063A",
  129025: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u062D\u062F\u062B.",
  129026: "\u0627\u0644\u062D\u062F\u062B \u062A\u0645 \u0627\u0644\u063A\u0627\u0626\u0647.",
  129027: "\u0648\u0636\u0639 \u0627\u0644\u062D\u062F\u062B \u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u0648\u0636\u0639 \u0627\u0644\u063A\u0631\u0641\u0629.",
  129028: "\u062D\u062F\u062B \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F.",
  129031: "\u062A\u0630\u0627\u0643\u0631 \u0627\u0644\u062D\u062F\u062B \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629.",
  129032: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u062D\u062F\u062B",
  129033: "\u0631\u0642\u0645 \u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647",
  129034: "\u064A\u0645\u0643\u0646 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u063A\u064A\u0631 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0629 \u0641\u0642\u0637.",
  129035: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u063A\u064A\u0631 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0629 \u0625\u0644\u0627 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0629.",
  129036: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0629 \u0625\u0644\u0627 \u0625\u0644\u0649 \u062D\u0627\u0644\u0629 \u0639\u062F\u0645 \u0627\u0644\u0646\u0634\u0631.",
  129037: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u063A\u064A\u0631 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0629 \u0625\u0644\u0627 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0629.",
  129038: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0631\u0641 \u062A\u0630\u0627\u0643\u0631 \u0627\u0644\u062D\u062F\u062B",
  129039: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0643\u0645\u064A\u0629 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u0623\u0642\u0644 \u0645\u0646 \u0639\u062F\u062F \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u0627\u0644\u0645\u0628\u0627\u0639\u0629 \u0628\u0627\u0644\u0641\u0639\u0644.",
  129040: "\u062A\u0648\u062C\u062F \u062A\u0630\u0627\u0643\u0631 \u063A\u064A\u0631 \u0645\u0646\u0634\u0648\u0631\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0648\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
  129041: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0643\u0645\u064A\u0629 \u0627\u0644\u0627\u0633\u062A\u064A\u0631\u0627\u062F",
  129042: "\u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0644\u0623\u0646 \u0627\u0644\u062D\u062F\u062B \u0644\u0645 \u064A\u0645\u0643\u0651\u0646\u0647\u0627 \u0628\u0639\u062F.",
  129043: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u062D\u062F\u062B",
  129050: "\u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u0645\u062A\u0627\u062D\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u062D\u062F\u062B \u060C \u064A\u0631\u062C\u0649 \u0627\u062E\u062A\u064A\u0627\u0631 \u062A\u0630\u0643\u0631\u0629.",
  129051: "\u064A\u0645\u0643\u0646\u0643 \u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 10 \u062A\u0630\u0627\u0643\u0631 \u0641\u0642\u0637.",
  129052: "\u0641\u0634\u0644 \u0627\u0642\u062A\u0631\u0627\u0646 \u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u0644\u0627\u0633\u062A\u0645\u0627\u0631\u0629 \u0627\u0644\u062A\u0633\u062C\u064A\u0644.",
  129053: "\u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u0628\u0627\u0644\u0641\u0639\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0641\u0648\u0641",
  129054: "\u062A\u0645 \u0628\u064A\u0639 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u060C \u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u062A\u0630\u0627\u0643\u0631",
  129055: "\u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u0644\u064A\u0633\u062A \u0641\u064A \u062D\u0627\u0644\u0629 \u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  129056: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0642\u062A\u0631\u0627\u0646 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  129057: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0642\u062A\u0631\u0627\u0646 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u062D\u0630\u0641 \u0627\u0644\u0639\u0644\u0627\u0645\u0629",
  129058: "\u0627\u0642\u062A\u0631\u0627\u0646 \u062A\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  129059: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u062F\u0641\u0639 WeChat \u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0648\u0638\u064A\u0641\u0629 \u0634\u062D\u0646 \u0627\u0644\u062A\u0630\u0627\u0643\u0631",
  129060: "\u0627\u0644\u0645\u062F\u0639\u0648\u064A\u0646 \u0627\u0644\u0645\u062C\u062F\u0648\u0644\u064A\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u064A\u0646",
  129061: "\u062D\u0627\u0644\u0629 \u062F\u0641\u0639 \u062A\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  129062: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u062F\u0641\u0639 \u062A\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  129063: "\u0627\u0633\u0645 \u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u064A\u062F",
  129064: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0630\u0627\u0643\u0631 \u0627\u0644\u062A\u064A \u0643\u0627\u0646\u062A \u0639\u0644\u0649 \u0627\u0644\u0631\u0641\u0648\u0641 \u0648\u062E\u0627\u0631\u062C \u0627\u0644\u0623\u0631\u0641\u0641 \u0625\u0644\u0627: \u0627\u0633\u0645 \u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u060C \u0648\u0635\u0641 \u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u060C \u0648\u0643\u0645\u064A\u0629 \u0627\u0644\u062A\u0630\u0643\u0631\u0629 \u060C \u0648\u0648\u0642\u062A \u0627\u0644\u062A\u0630\u0643\u0631\u0629",
  129065: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0630\u0627\u0643\u0631 \u0639\u0644\u0649 \u0627\u0644\u0631\u0641\u0648\u0641 \u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0637\u0644\u0627\u0642 \u0623\u064A \u062D\u062F\u062B",
  129070: "\u0641\u0634\u0644 \u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A",
  129071: "\u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062A\u0642\u064A\u064A\u0645 \u0644\u064A\u0633\u062A \u0642\u064A\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  129072: "\u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u062C\u0639\u062A\u0647\u0627 \u0628\u0639\u062F \u0628\u062F\u0621 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A",
  129073: "\u062F\u0639\u0645 \u0627\u0644\u062A\u0642\u064A\u064A\u0645 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637",
  129080: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
  129081: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u0644\u0633\u0644\u064A \u0644\u062A\u0632\u064A\u064A\u0646 \u0627\u0644\u0646\u0634\u0627\u0637",
  129082: "\u064A\u062A\u0645 \u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u0644\u0633\u0644\u064A \u0644\u062A\u0632\u064A\u064A\u0646 \u0627\u0644\u0646\u0634\u0627\u0637",
  129083: "\u064A\u064F\u0646\u0634\u0626 \u062D\u062F \u0627\u0644\u0646\u0634\u0627\u0637 \u0627\u0644\u0641\u0631\u062F\u064A \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 20 \u0646\u0645\u0648\u0630\u062C \u0625\u062F\u062E\u0627\u0644",
  129084: "\u062A\u0645 \u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0646\u0634\u0627\u0637 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0646\u0634\u0627\u0621 \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
  129085: "\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0642\u0646\u0648\u0627\u062A \u0627\u0644\u062A\u0631\u0648\u064A\u062C \u0641\u0627\u0631\u063A",
  129086: "\u0644\u0642\u062F \u0641\u0634\u0644\u062A \u0642\u0646\u0648\u0627\u062A \u0627\u0644\u062A\u0631\u0648\u064A\u062C \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
  129087: "\u0623\u0636\u0641 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 20 \u0642\u0646\u0627\u0629",
  129088: "\u0646\u0641\u0633 \u0627\u0644\u0627\u0633\u0645 \u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u062A\u0631\u0648\u064A\u062C",
  129089: "\u0631\u0642\u0645 \u0642\u0646\u0627\u0629 \u0627\u0644\u062A\u0631\u0648\u064A\u062C \u0647\u0648 \u0646\u0641\u0633\u0647",
  129090: "\u0627\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0642\u0646\u0627\u0629 \u0627\u0644\u062A\u0631\u0648\u064A\u062C \u0627\u0644\u0648\u0635\u0648\u0644 \u0641\u0627\u0631\u063A\u0629",
  129091: "\u0641\u0634\u0644\u062A \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0642\u0646\u0627\u0629 \u0627\u0644\u062A\u0631\u0648\u064A\u062C \u0627\u0644\u062C\u062F\u064A\u062F\u0629",
  129092: "\u0642\u0627\u0645 \u0634\u062E\u0635 \u0645\u0627 \u0628\u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0628\u0627\u0644\u0641\u0639\u0644 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u062D\u0631\u064A\u0631\u0647",
  129093: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u0642\u0646\u0627\u0629",
  129094: "\u0644\u0645 \u064A\u062A\u0645 \u0641\u062A\u062D \u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u0639\u0646 \u0627\u0644\u0645\u0643\u0627\u0646 \u060C \u064A\u0631\u062C\u0649 \u0641\u062A\u062D\u0647 \u0623\u0648\u0644\u0627\u064B",
  129095: "\u0628\u062F\u0648\u0646 \u0632\u062E\u0631\u0641\u0629 \u0627\u0644\u0646\u0634\u0627\u0637 \u0627\u0644\u0645\u0647\u064A\u0623\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0647\u064A\u0626\u0629 \u0623\u0648\u0644\u0627\u064B",
  129096: "\u0641\u0634\u0644 \u062A\u062D\u0631\u064A\u0631 \u0642\u0646\u0627\u0629 \u0627\u0644\u062A\u0631\u0648\u064A\u062C",
  129097: "\u0644\u0645 \u064A\u062A\u0645 \u0641\u062A\u062D \u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u0639\u0646 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u060C \u064A\u0631\u062C\u0649 \u0641\u062A\u062D\u0647 \u0623\u0648\u0644\u0627\u064B",
  129100: "Faof \u062E\u0644\u0642 \u0644\u0644\u0641\u0634\u0644",
  129101: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0646\u0634\u0627\u0637",
  129102: "\u0648\u0635\u0648\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0644\u0644\u0623\u0646\u0634\u0637\u0629",
  129103: "\u064A\u0631\u062C\u0649 \u062A\u0643\u0648\u064A\u0646 \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0623\u0648\u0644\u0627",
  129104: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u0627\u0644\u0645\u0641\u062A\u0648\u062D",
  129105: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0636\u064A\u0641",
  129106: "\u062A\u0639\u062F\u064A\u0644 \u062A\u0634\u0648\u0647\u0627\u062A \u0627\u0644\u0636\u064A\u0641",
  129107: "\u0636\u064A\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  129108: "\u0636\u064A\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  129109: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0623\u0633\u0645\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u0639\u0627\u0631\u0629 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647",
  129110: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0642\u0646\u0627\u0629 \u0627\u0644\u062A\u0631\u0648\u064A\u062C",
  129120: "\u0646\u0648\u0639 \u0627\u0644\u0625\u062E\u0637\u0627\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  129121: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u0642\u0627\u0644\u0628 \u0625\u0639\u0644\u0627\u0645 WeChat",
  129122: "\u064A\u062D\u062A\u0648\u064A \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0639\u0644\u0649%s \u0636\u064A\u0648\u0641 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631",
  129123: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0623\u0648 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0637\u0644\u0648\u0628",
  129124: "\u0644\u0627 \u062A\u062F\u0639\u0645 \u0647\u0630\u0647 \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u062D\u0627\u0644\u064A\u064B\u0627 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0623\u0648 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0628\u064A\u0636\u0627\u0621",
  129125: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0637\u0644\u0628 \u062A\u0630\u0643\u0631\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  129126: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u062D\u0627\u0644\u0629 \u0627\u0644\u0637\u0644\u0628",
  129127: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0625\u0632\u0627\u0644\u0629 \u0641\u0627\u0631\u063A\u0629",
  129128: "\u062A\u0646\u0633\u064A\u0642 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D:%s",
  129129: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621 \u0642\u0628\u0644 \u0648\u0642\u062A \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
  129130: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u062F\u0646\u0649 \u0644\u0648\u0642\u062A \u0627\u0644\u0646\u0634\u0627\u0637 \u0647\u0648%s \u0633\u0627\u0639\u0629",
  129131: "\u0623\u0642\u0635\u0649 \u0648\u0642\u062A \u0644\u0644\u0646\u0634\u0627\u0637 \u0647\u0648%s \u064A\u0648\u0645",
  129132: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0641\u0627\u0631\u063A\u0629",
  129133: "\u0644\u0627 \u064A\u0633\u0645\u062D \u0644\u0644\u0636\u064A\u0648\u0641 \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  129134: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0648\u0642\u062A \u0627\u0644\u0625\u062E\u0637\u0627\u0631 \u0647\u0648 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u064A",
  129135: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0631\u0633\u0645\u064A \u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0641\u062A\u062D \u0625\u0634\u0639\u0627\u0631 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u064A WeChat",
  129136: "\u0627\u0644\u0645\u0648\u0627\u0631\u062F \u0627\u0644\u0644\u0627\u0632\u0645\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0646\u062F\u0648\u0627\u062A \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u062D\u062F\u062B.",
  129137: "\u062A\u0643\u0648\u064A\u0646 \u0625\u0639\u0644\u0627\u0645 \u0627\u0644\u062D\u062F\u062B \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  129138: "\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u0637\u0631\u064A\u0642\u0629 \u0625\u0639\u0644\u0627\u0645 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  129139: "\u0644\u0642\u062F \u0642\u0645\u062A \u0628\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643",
  129140: "\u0648\u0642\u062A \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u0646\u0634\u0637 \u0647\u0648 \u0623\u0643\u062B\u0631",
  129141: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u0637\u0648\u0644",
  129142: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0641\u0627\u0631\u063A\u0629",
  129143: "\u0646\u062C\u0627\u062D \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u0625\u062E\u0637\u0627\u0631 \u0644\u0627 \u064A\u0645\u0643\u0646 \u0641\u0627\u0631\u063A\u0629",
  129144: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u0646\u0634\u0637 \u0648\u0638\u064A\u0641\u0629 \u0645\u063A\u0644\u0642\u0629",
  129145: "\u062A\u0645\u0643\u064A\u0646 \u0644\u063A\u0629 \u0646\u0634\u0637\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  129151: "\u062A\u0645\u0643\u064A\u0646 \u0644\u063A\u0629 \u0646\u0634\u0637\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  130001: "\u062D\u0627\u0644\u0629 \u062A\u0639\u0637\u064A\u0644 \u0627\u0644\u0639\u0645\u064A\u0644 \u0644\u0627 \u062A\u0633\u0645\u062D \u0628\u0627\u0644\u0645\u0634\u062A\u0631\u064A\u0627\u062A",
  130002: "\u0627\u0644\u0645\u0646\u062A\u062C \u063A\u064A\u0631 \u0645\u062A\u0648\u0641\u0631",
  130003: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0637\u0644\u0628",
  130004: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0645\u0631",
  130005: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u062F\u0641\u0639 \u0627\u0644\u0637\u0644\u0628",
  130006: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0637\u0644\u0628",
  130007: "\u0637\u0644\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  130008: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062D\u0627\u0644\u0629",
  130009: "\u0623\u0633\u0628\u0627\u0628 \u0627\u0644\u0631\u0641\u0636 \u0645\u0637\u0644\u0648\u0628\u0629",
  130010: "\u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0641\u0639\u0627\u0644 \u0645\u0637\u0644\u0648\u0628 \u0644\u0644\u062A\u0648\u0642\u064A\u062A \u062D\u062A\u0649 \u064A\u0635\u0628\u062D \u0633\u0627\u0631\u064A \u0627\u0644\u0645\u0641\u0639\u0648\u0644",
  130011: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0623\u0645\u0631 \u0639\u0643\u0633\u064A",
  130012: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0637\u0644\u0628 \u0627\u0644\u062A\u0631\u0627\u062C\u0639",
  130013: "\u062A\u0631\u062A\u064A\u0628 \u0639\u0643\u0633\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  130014: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0643\u0645\u064A\u0629 \u0639\u0643\u0633\u064A",
  130015: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0645\u0646\u062A\u062C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646\u0647",
  130016: "\u0627\u0644\u0637\u0644\u0628 \u0644\u0645 \u064A\u062A\u0645 \u062F\u0641\u0639\u0647 \u060C \u0644\u0627 \u064A\u0633\u0645\u062D \u0628\u0627\u0644\u0639\u0643\u0633",
  130017: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0639\u0645\u064A\u0644",
  130018: "\u0637\u0644\u0628 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0641\u0639\u0627\u0644 \u0641\u0634\u0644",
  130019: "\u064A\u0645\u0643\u0646 \u0634\u0631\u0627\u0621 \u062D\u0632\u0645 \u0627\u0644\u0645\u0646\u062A\u062C \u0648\u0627\u0644\u0625\u0635\u062F\u0627\u0631\u0627\u062A 1 \u0642\u0637\u0639\u0629 \u0641\u0642\u0637",
  130020: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0645\u0628\u0644\u063A \u0627\u0644\u0625\u0632\u0627\u062D\u0629 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0645\u0628\u0644\u063A \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0641\u0639\u0644\u064A",
  130021: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0643\u0645\u064A\u0629 \u0627\u0644\u0627\u0646\u0639\u0643\u0627\u0633 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0643\u0645\u064A\u0629 \u0627\u0644\u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0639\u0643\u0633",
  130022: "\u062A\u0645 \u0639\u0643\u0633 \u0627\u0644\u0637\u0644\u0628 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646\u0647 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  130023: "\u064A\u0645\u0643\u0646 \u0634\u0631\u0627\u0621 \u0646\u0633\u062E\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637 \u0628\u0646\u0641\u0633 \u0627\u0644\u062A\u0631\u062A\u064A\u0628",
  130024: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0645\u0628\u0644\u063A \u0627\u0644\u0634\u0637\u0628 \u0623\u0642\u0644 \u0645\u0646 \u0645\u0628\u0644\u063A \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0641\u0639\u0644\u064A",
  131001: '\u062A\u062D\u062A\u0648\u064A \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u062D\u0632\u0645\u0629 \u0627\u0644\u062D\u0645\u0631\u0627\u0621 \u0627\u0644\u062A\u064A \u0623\u0631\u0633\u0644\u062A\u0647\u0627 \u0639\u0644\u0649 \u0643\u0644\u0645\u0627\u062A \u062D\u0633\u0627\u0633\u0629 "%s"',
  131002: "\u064A\u064F\u0633\u0645\u062D \u0641\u0642\u0637 \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0645\u062D\u062F\u062F\u064A\u0646 \u0628\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062D\u0632\u0645 \u062D\u0645\u0631\u0627\u0621",
  131003: "\u0647\u0646\u0627\u0643 \u0627\u0644\u0643\u062B\u064A\u0631 \u0645\u0646 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u064A\u0645\u0633\u0643\u0648\u0646 \u0628\u0627\u0644\u0645\u063A\u0644\u0641\u0627\u062A \u0627\u0644\u062D\u0645\u0631\u0627\u0621 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  131004: "\u0637\u0644\u0628 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A",
  131005: "\u0645\u063A\u0644\u0641 \u0623\u062D\u0645\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  131006: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u0627\u0644\u0635\u0627\u062F\u0631 \u0645\u0633\u0628\u0642\u064B\u0627",
  131007: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062E\u0627\u0637\u0626\u0629",
  131008: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0638\u0631\u0641 \u0627\u0644\u0623\u062D\u0645\u0631",
  131009: "\u062A\u0645 \u062A\u0639\u0637\u064A\u0644 \u0627\u0644\u062D\u0632\u0645 \u0627\u0644\u062D\u0645\u0631\u0627\u0621",
  131010: "\u0644\u0642\u062F \u0633\u0628\u0642 \u0644\u0643 \u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0629 \u0628\u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u060C \u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0637\u0627\u0644\u0628 \u0628\u0647 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
  131011: "\u0645\u0639\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A\u0629",
  131012: "\u064A\u062C\u0628 \u0623\u0644\u0627 \u062A\u0642\u0644 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0641\u0627\u0635\u0644\u0629 \u0628\u064A\u0646 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062D\u0632\u0645 \u0627\u0644\u062D\u0645\u0631\u0627\u0621 \u0639\u0646 \u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  131013: "\u064A\u0631\u062C\u0649 \u062A\u0643\u0648\u064A\u0646 \u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0631\u0633\u0645\u064A \u0648\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0627\u062C\u0631 \u0623\u0648\u0644\u0627\u064B",
  131014: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0625\u0630\u0646 \u0644\u062A\u0634\u063A\u064A\u0644 \u0633\u062C\u0644 \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631",
  131015: "\u0644\u0645 \u064A\u0635\u0631\u062D \u0627\u0644\u062C\u0645\u0647\u0648\u0631 \u0628\u0640 WeChat",
  131016: "\u0645\u063A\u0644\u0641\u0627\u062A \u062D\u0645\u0631\u0627\u0621 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  131017: "\u0647\u0630\u0627 \u0627\u0644\u0638\u0631\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u0644\u0644\u062D\u0627\u0644\u0629 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
  131018: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0645\u0628\u0644\u063A \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u0628\u064A\u0646 0.3 \u0648 200 \u064A\u0648\u0627\u0646",
  131019: "\u0647\u0630\u0627 \u0627\u0644\u0638\u0631\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u0644\u0644\u062D\u0627\u0644\u0629 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u0646\u0634\u0631",
  131020: "\u0633\u062C\u0644 \u0645\u0637\u0627\u0644\u0628\u0629 \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  131021: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0641\u064A \u0627\u0644\u0646\u0638\u0627\u0645",
  131022: "\u062A\u0645 \u0628\u064A\u0639 \u0627\u0644\u0645\u0638\u0627\u0631\u064A\u0641 \u0627\u0644\u062D\u0645\u0631\u0627\u0621",
  131023: "\u0645\u063A\u0644\u0641 \u0623\u062D\u0645\u0631 \u0635\u0627\u062F\u0631 \u0645\u0633\u0628\u0642\u064B\u0627 \u0645\u062D\u0634\u0648 \u0628\u0625\u0631\u062C\u0627\u0639 \u062E\u0627\u0637\u0626",
  131024: "\u062E\u0637\u0623 \u0641\u064A \u0645\u0639\u0627\u0644\u062C\u0629 \u0633\u062C\u0644 \u0645\u0637\u0627\u0644\u0628\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  131025: "\u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621",
  131026: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0641\u062A\u062D\u0647 \u0641\u064A Wechat",
  132001: "\u063A\u0631\u0641\u0629 \u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  132002: "\u0627\u062C\u062A\u0645\u0627\u0639 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  132003: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u0645\u0636\u064A\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  132004: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0645\u0635\u0627\u062F\u0642\u0629 \u0627\u0644\u0645\u0636\u064A\u0641 \u0627\u0644\u0635\u062D\u064A\u062D\u0629",
  132005: "\u0645\u0639\u0631\u0641 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  132006: "\u0641\u0634\u0644 \u0627\u0644\u062D\u062C\u0632",
  132007: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0624\u062A\u0645\u0631 Tencent",
  132008: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u062C\u062A\u0645\u0627\u0639 Tencent",
  132009: "\u0641\u0634\u0644 \u0625\u0644\u063A\u0627\u0621 \u0627\u062C\u062A\u0645\u0627\u0639 Tencent",
  132010: "\u0645\u0639\u0644\u0645\u0627\u062A \u063A\u0631\u0641\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  132011: "\u0641\u0634\u0644 \u0625\u0644\u063A\u0627\u0621 \u063A\u0631\u0641\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A",
  132012: "\u0641\u0634\u0644\u062A \u062A\u0647\u064A\u0626\u0629 \u063A\u0631\u0641\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A",
  132013: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u064A\u0627\u0647 \u062A\u062F\u0641\u0642 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  132014: "\u062A\u0627\u0631\u064A\u062E \u062D\u062C\u0632 \u063A\u0631\u0641\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
  132015: "\u0648\u0642\u062A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  132016: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0627\u0644\u062E\u0627\u0635 \u0628\u0627\u0644\u0636\u064A\u0641 \u0641\u0627\u0631\u063A \u0623\u0648 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  132017: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u0625\u0644\u063A\u0627\u0621 \u0642\u0628\u0644 24 \u0633\u0627\u0639\u0629 \u0645\u0646 \u0628\u062F\u0621 \u0642\u0627\u0639\u0629 \u0627\u0644\u0645\u0624\u062A\u0645\u0631\u0627\u062A",
  132018: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0645\u0646 \u0645\u0646\u0635\u0629 Tencent Conference SSO",
  132019: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0639\u0644\u0649 \u0645\u0646\u0635\u0629 \u0645\u0624\u062A\u0645\u0631\u0627\u062A Tencent",
  132020: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u062D\u0632\u0645\u0629 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u0627\u0644\u0645\u0637\u0627\u0628\u0642\u0629 \u0644\u0642\u0627\u0639\u0629 \u0627\u0644\u0645\u0624\u062A\u0645\u0631\u0627\u062A \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647\u0627",
  132021: "\u063A\u0631\u0641\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0644\u062F\u064A\u0647\u0627 \u0628\u0627\u0644\u0641\u0639\u0644 \u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0623\u062E\u0631\u0649 \u062E\u0644\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
  132022: "\u0639\u062F\u062F \u063A\u0631\u0641 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646 \u062D\u062C\u0632\u0647\u0627 \u062E\u0644\u0627\u0644 \u0647\u0630\u0647 \u0627\u0644\u0641\u062A\u0631\u0629 \u0647\u0648 0 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u062E\u062F\u0645\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0644\u0644\u0645\u0639\u0627\u0644\u062C\u0629",
  132023: "\u0633\u064A\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u063A\u0631\u0641\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0641\u064A \u063A\u0636\u0648\u0646 30 \u064A\u0648\u0645\u064B\u0627",
  132024: "\u062A\u0645 \u0628\u062F\u0621 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0648\u0644\u0627 \u064A\u0633\u0645\u062D \u0628\u0623\u064A \u062A\u0639\u062F\u064A\u0644",
  132025: "\u0628\u062F\u0623 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639 \u0648\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0628\u0627\u0644\u062D\u0630\u0641",
  132026: "\u062F\u0639\u0645 \u0641\u0642\u0637 \u0642\u0627\u0639\u0627\u062A \u0627\u0644\u0645\u0624\u062A\u0645\u0631\u0627\u062A \u0627\u0644\u0645\u062A\u0641\u0642 \u0639\u0644\u064A\u0647\u0627 \u0641\u064A \u063A\u0636\u0648\u0646 30 \u064A\u0648\u0645\u064B\u0627",
  132027: "\u062A\u062F\u0641\u0642 \u0645\u064A\u0627\u0647 \u0645\u0634\u0627\u0631\u0643 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0641\u064A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
  133001: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0642\u062A\u0631\u0627\u0646 \u0625\u0630\u0646 \u0627\u0644\u0627\u0631\u062A\u0633\u0627\u0621",
  133002: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0625\u0630\u0646 \u0627\u0644\u0627\u0631\u062A\u0633\u0627\u0621",
  133003: "\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u063A\u0627\u0633\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  133004: "\u0639\u062F\u062F \u0627\u0644\u0625\u0628\u062F\u0627\u0639\u0627\u062A \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  133005: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u0634\u0631\u0641",
  133006: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0641\u0627\u0631\u063A\u0627",
  133007: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062E\u0627\u0637\u0626\u0629",
  133008: "\u0645\u0639\u0631\u0641 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  133009: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  133010: "\u0645\u0636\u064A\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  133011: "\u0627\u0644\u0627\u0633\u0645 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0639\u064A\u064A\u0646",
  133012: "\u062D\u0627\u0644\u064A\u064B\u0627 \u0641\u064A \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u060C \u062A\u062D\u062F\u064A\u062B \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0645\u0636\u064A\u0641 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645",
  133113: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0645\u0629 \u0645\u0641\u0642\u0648\u062F\u0629",
  133114: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0636\u064A\u0641",
  133115: "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u0634\u0631\u0641",
  133116: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0634\u0631\u0641\u064A\u0646 \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u064A\u062F\u0648\u064A\u064B\u0627",
  133117: "\u0641\u0642\u0637 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0644\u062F\u0631\u062F\u0634\u0629 \u0644\u0647 \u062F\u0648\u0631 \u0627\u0644\u0636\u064A\u0641",
  133118: "\u0642\u0627\u0645 \u0627\u0644\u0636\u064A\u0641 \u0628\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  133119: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u063A\u0631\u0641 \u0644\u064A\u0633 \u0644\u062F\u064A\u0647 \u0647\u0630\u0627 \u0627\u0644\u0625\u0630\u0646 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u062F\u064A\u062F \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  133120: "\u0645\u0637\u0644\u0648\u0628 \u0633\u0644\u0637\u0629 \u0645\u0631\u0627\u0642\u0628\u0629 \u0645\u0633\u0627\u0639\u062F\u0629",
  133121: "\u0645\u0637\u0644\u0648\u0628 \u0633\u0644\u0637\u0629 \u0645\u0631\u0627\u0642\u0628\u0629 \u0645\u0633\u0627\u0639\u062F\u0629",
  133122: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0635\u0641\u062D\u0629 \u0627\u0644\u0648\u064A\u0628 \u0644\u0644\u062F\u062E\u0648\u0644",
  133994: "\u0645\u0633\u062A\u062E\u062F\u0645 \u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644\u0647 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  133995: "\u062E\u0637\u0623 \u0641\u064A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0623\u0643\u062B\u0631 \u0645\u0646 10 \u0645\u0631\u0627\u062A \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0628\u0639\u062F 30 \u062F\u0642\u064A\u0642\u0629!",
  133996: "\u0625\u0630\u0646 \u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A",
  133997: "\u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u0638\u0645",
  133998: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u0645\u0636\u064A\u0641",
  134001: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u0644\u0639\u0629 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631",
  134002: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u0644\u0639\u0629 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631",
  134003: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u0644\u0639\u0629 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631",
  134004: "\u0639\u0646\u0635\u0631 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  134011: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0644\u0645\u0646\u062A\u062C \u0627\u0644\u063A\u0631\u0641\u0629",
  134012: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0646\u062A\u062C \u0627\u0644\u063A\u0631\u0641\u0629",
  134013: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0646\u062A\u062C \u0627\u0644\u063A\u0631\u0641\u0629",
  134014: "\u0639\u0646\u0635\u0631 \u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  134015: "\u0645\u0639\u0644\u0645\u0627\u062A \u0645\u0646\u062A\u062C \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  134016: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062D\u0642\u0644 \u0641\u0631\u0632 \u0627\u0644\u063A\u0631\u0641\u0629",
  134017: "\u0645\u0639\u0644\u0645\u0629 \u0641\u0631\u0632 \u0627\u0644\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  134018: "\u0627\u0644\u0623\u0648\u0644 \u0623\u0648 \u0627\u0644\u0623\u062E\u064A\u0631 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u062A\u062D\u0631\u0643 \u0644\u0623\u0639\u0644\u0649 \u0648\u0644\u0623\u0633\u0641\u0644",
  134019: "\u0645\u0648\u0631\u062F \u0645\u0643\u062A\u0628\u0629 \u0648\u0633\u0627\u0626\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  134020: "\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
  134021: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0627\u0644\u0645\u0646\u062A\u062C",
  134022: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0633\u0639\u0631 \u0627\u0644\u0645\u0646\u062A\u062C \u0623\u0642\u0644 \u0645\u0646 \u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0645\u0633\u0637\u0631",
  134024: "\u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 50 \u0639\u0646\u0635\u0631\u064B\u0627 \u0643\u062D\u062F \u0623\u0642\u0635\u0649 \u0625\u0644\u0649 \u0627\u0644\u063A\u0631\u0641\u0629",
  134995: "\u0645\u0633\u062A\u062E\u062F\u0645 \u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644\u0647 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  135001: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0623\u0635\u0648\u0644 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135002: "\u0641\u0634\u0644 \u0627\u0644\u0646\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0643\u062A\u0628\u0629",
  135003: "\u0623\u0635\u0648\u0644 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0627\u0644\u0645\u0624\u0642\u062A\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  135004: "\u0641\u0634\u0644 \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0645\u0627\u062F\u064A \u0644\u0645\u0648\u0631\u062F \u0645\u0633\u062A\u0648\u062F\u0639 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0631\u062D\u0644\u064A",
  135005: "\u0641\u0634\u0644 \u0641\u064A \u062D\u0641\u0638 \u0648\u062D\u0630\u0641 \u0627\u0644\u0633\u062C\u0644\u0627\u062A",
  135006: "\u0641\u0634\u0644 \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0645\u0627\u062F\u064A \u0644\u0623\u0635\u0648\u0644 \u0648\u0633\u0627\u0626\u0637 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135007: "\u0641\u0634\u0644 \u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0645\u0627\u062F\u064A \u0644\u0623\u0635\u0648\u0644 \u0648\u0633\u0627\u0626\u0637 \u0627\u0644\u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0645\u0631\u062D\u0644\u064A\u0629",
  135011: "\u0641\u0634\u0644 \u0627\u0644\u062D\u0630\u0641 \u060C \u0648\u0641\u0634\u0644\u062A \u0627\u0633\u062A\u062F\u0639\u0627\u0621 Tencent Cloud \u0644\u062D\u0630\u0641 \u0648\u0627\u062C\u0647\u0629 \u0623\u0635\u0648\u0644 \u0627\u0644\u0648\u0633\u0627\u0626\u0637.",
  135012: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0645\u0644\u0641 \u062A\u062D\u0645\u064A\u0644 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135013: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0641 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135014: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0623\u0635\u0648\u0644 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  135015: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0633\u062C\u0644 \u0645\u0644\u0641 \u062A\u062D\u0645\u064A\u0644 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135016: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0645\u0644\u0641 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135017: "\u0623\u0642\u0635\u0649 \u0639\u062F\u062F \u0645\u0646 \u0627\u0644\u0637\u0644\u0628\u0627\u062A",
  135018: "\u0645\u0644\u0641 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  135019: "\u0633\u062C\u0644 \u062A\u062D\u0645\u064A\u0644 \u0645\u0644\u0641 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  135020: "\u0641\u0634\u0644 \u0627\u0644\u062D\u0630\u0641 \u0627\u0644\u0645\u0627\u062F\u064A \u0644\u0645\u0648\u0631\u062F \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135021: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0633\u0645 \u0645\u0644\u0641 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0641\u0627\u0631\u063A\u064B\u0627",
  135022: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u062A\u062D\u0648\u064A\u0644 \u062A\u0631\u0645\u064A\u0632 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135023: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0633\u062C\u0644 \u062A\u062D\u0648\u064A\u0644 \u062A\u0631\u0645\u064A\u0632 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135024: "\u064A\u062A\u0645 \u0627\u0644\u0622\u0646 \u062A\u062D\u0648\u064A\u0644 \u062A\u0631\u0645\u064A\u0632 \u0627\u0644\u0645\u0644\u0641 \u0623\u0648 \u062A\u0631\u0645\u064A\u0632\u0647 \u0628\u0646\u062C\u0627\u062D \u060C \u0648\u0644\u0643\u0646 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u062D\u0648\u064A\u0644 \u062A\u0631\u0645\u064A\u0632\u0647",
  135025: "\u0645\u0647\u0645\u0629 \u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u062A\u0631\u0645\u064A\u0632 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  135026: "\u0645\u0635\u062F\u0631 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  135027: "\u062A\u062F\u0639\u0645 \u0642\u0627\u0626\u0645\u0629 \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062A\u062D\u0645\u064A\u0644 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 20 \u0639\u0646\u0635\u0631\u064B\u0627",
  135028: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0633\u062C\u0644 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0634\u0628\u0643\u0629",
  135029: "\u0641\u0634\u0644 \u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0645\u0644\u0641 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0634\u0628\u0643\u0629",
  135030: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0641 \u062A\u0645 \u062A\u062D\u0648\u064A\u0644 \u062A\u0631\u0645\u064A\u0632\u0647 \u0644\u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135031: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0645\u0644\u0641 \u062A\u062D\u0648\u064A\u0644 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135032: "\u0627\u0646\u062A\u0638\u0631 \u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0645\u064A\u0644 \u0648\u0627\u0644\u062A\u062D\u0645\u064A\u0644 \u0644\u0644\u062D\u0630\u0641",
  135033: "\u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0645\u064A\u0644 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
  135034: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u062D\u0648\u064A\u0644 \u062A\u0631\u0645\u064A\u0632 \u0627\u0644\u0645\u0644\u0641 \u0623\u0648 \u062C\u0627\u0631\u064A \u062A\u062D\u0648\u064A\u0644\u0647 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647",
  135035: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0648\u0642\u062A \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u0644\u0627\u062D\u064A\u0629 \u0645\u0644\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  135036: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0634\u063A\u064A\u0644\u0647",
  135037: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0633\u062C\u0644 \u062A\u062D\u0645\u064A\u0644 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135038: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u062A\u062D\u0645\u064A\u0644 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135039: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0634\u063A\u064A\u0644\u0647",
  135040: "\u062D\u062F\u062F \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 20 \u0645\u0644\u0641 \u0648\u0633\u0627\u0626\u0637",
  135041: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u0648\u0627\u0631\u062F \u062A\u062E\u0632\u064A\u0646 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  135042: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0647\u0645\u0629 \u0627\u0644\u0643\u0634\u0641 \u0639\u0646 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  135043: "\u0641\u0634\u0644\u062A \u0645\u0647\u0645\u0629 \u0627\u0644\u0643\u0634\u0641 \u0639\u0646 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0627\u0644\u0645\u0639\u062F\u0644\u0629",
  135044: "\u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u0643\u0634\u0641 \u0639\u0646 \u062C\u062F\u0648\u0644 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0641\u0634\u0644",
  135045: "\u0646\u062A\u064A\u062C\u0629 \u0631\u062F \u0646\u062A\u064A\u062C\u0629 \u0627\u0643\u062A\u0634\u0627\u0641 MDC \u0641\u0627\u0631\u063A\u0629",
  135046: "\u0641\u0634\u0644\u062A \u062D\u0627\u0644\u0629 \u0627\u0643\u062A\u0634\u0627\u0641 \u0645\u0632\u0627\u0645\u0646\u0629 MDF",
  135047: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0647\u0645\u0629 \u0627\u0644\u0643\u0634\u0641 \u0639\u0646 MDF",
  135048: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0646\u0642\u0644 \u062C\u0648\u0627\u0646\u0628 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0641\u0634\u0644 \u0627\u0644\u062A\u0631\u0645\u064A\u0632 \u0648\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0634\u0641\u0631\u0629 \u0648\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u062A\u0631\u0645\u064A\u0632",
  135049: "\u062F\u0642\u0629 \u062A\u062D\u0648\u064A\u0644 \u0623\u0642\u0644 \u0634\u0623\u0646\u0627",
  135050: "\u064A\u062D\u062A\u0648\u064A \u0647\u0630\u0627 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0628\u0627\u0644\u0641\u0639\u0644 \u0639\u0644\u0649 \u0641\u064A\u062F\u064A\u0648 \u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0634\u0641\u0631\u0629 \u0644\u0640%s \u060C \u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0643\u0631\u0631 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062A\u062D\u0648\u064A\u0644",
  135051: "\u064A\u062A\u0645 \u0627\u0644\u0622\u0646 \u0646\u0642\u0644%s \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u060C \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0644\u0627\u062D\u0642\u064B\u0627",
  135052: "\u0645\u0639\u062F\u0644 \u0627\u0644\u0634\u0641\u0631\u0629 \u0644\u0627 \u064A\u062A\u062C\u0627\u0648\u0632 5 \u0645\u064A\u062C\u0627\u0628\u062A \u0641\u064A \u0627\u0644\u062B\u0627\u0646\u064A\u0629",
  135053: "\u064A\u062A\u0645 \u062A\u062D\u0648\u064A\u0644 \u062A\u0631\u0645\u064A\u0632 \u0647\u0630\u0627 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647",
  135054: "\u064A\u0645\u0643\u0646 \u0646\u0642\u0644 \u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  135055: "\u064A\u0645\u0643\u0646 \u0646\u0642\u0644 \u0627\u0644\u0627\u0643\u062A\u0634\u0627\u0641 \u0627\u0644\u0646\u0627\u062C\u062D \u0644\u0631\u0623\u0633 \u0627\u0644\u0645\u0627\u0644 \u0627\u0644\u0625\u0639\u0644\u0627\u0645\u064A",
  135056: "\u062A\u0645\u062A \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0644\u0641 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647",
  135057: "\u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  136001: "\u0631\u0642\u0645 \u0637\u0644\u0628 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u062A\u0627\u062C\u0631 \u0645\u0643\u0631\u0631",
  136002: "\u062A\u0643\u0648\u064A\u0646 WeChat \u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0627\u0644\u062A\u0627\u062C\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  136003: "\u0623\u0645\u0631 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u062A\u0627\u062C\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  137001: "\u064A\u0639\u064A\u0634 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  137002: "\u0641\u0634\u0644 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
  137003: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
  137004: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
  137005: "\u0627\u0644\u0642\u062F\u0631\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  137006: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0645\u0648\u062C\u0648\u062F\u0629 \u0628\u0645\u0643\u0627\u0644\u0645\u0629 \u062C\u0627\u0631\u064A\u0629",
  137007: "\u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u062D\u062F\u062B \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0628\u062F\u0621 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
  137008: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0642\u062F\u0631\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u062D\u062F\u062F\u0629",
  137009: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
  137010: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
  137011: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
  137012: "\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u062A\u0633\u062C\u064A\u0644 \u0648\u0635\u0648\u0644 \u063A\u064A\u0631 \u0645\u0641\u062A\u0648\u062D",
  137013: "\u0645\u062F\u0629 \u0627\u0644\u062F\u0639\u0648\u0629 \u0625\u0644\u0649 \u0627\u062A\u062E\u0627\u0630 \u0625\u062C\u0631\u0627\u0621 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0648\u0642\u062A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u060C \u064A\u0631\u062C\u0649 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u062F\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  137014: "\u064A\u0631\u062C\u0649 \u0628\u062F\u0621 \u0648\u0638\u064A\u0641\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0648\u0635\u0648\u0644 \u0623\u0648\u0644\u0627\u064B",
  137015: "\u0647\u0646\u0627\u0643 \u0639\u0645\u0644\u064A\u0629 \u062A\u0633\u062C\u064A\u0644 \u0648\u0635\u0648\u0644 \u062C\u0627\u0631\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642",
  137016: "\u0641\u0634\u0644 \u0628\u062F\u0621 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0648\u0635\u0648\u0644 \u0644\u0644\u062D\u062B \u0639\u0644\u0649 \u0627\u062A\u062E\u0627\u0630 \u0625\u062C\u0631\u0627\u0621",
  138001: "\u0642\u0646\u0627\u0629 \u0627\u0644\u062A\u0631\u0648\u064A\u062C \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  138002: "\u062A\u0645 \u0625\u064A\u0642\u0627\u0641 \u0647\u0630\u0647 \u0627\u0644\u0642\u0646\u0627\u0629",
  138003: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0642\u0646\u0627\u0629",
  139001: "\u0625\u0639\u0644\u0627\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  139002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0625\u062E\u0637\u0627\u0631",
  139003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0625\u0634\u0639\u0627\u0631",
  139004: "\u0623\u0631\u0633\u0644 \u0625\u0644\u063A\u0627\u0621 \u0644\u0644\u062A\u062D\u0631\u064A\u0631 \u0641\u0642\u0637",
  139005: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0643\u0627\u0626\u0646 \u0627\u0644\u0625\u0639\u0644\u0627\u0645",
  139006: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0643\u0627\u0626\u0646 \u0627\u0644\u0625\u0639\u0644\u0627\u0645",
  139007: "\u0641\u0634\u0644 \u0627\u0644\u0625\u0644\u063A\u0627\u0621 \u060C \u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0625\u0639\u0644\u0627\u0645 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0628\u0646\u062C\u0627\u062D",
  14e4: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u062A\u0642\u0631\u064A\u0631 \u0627\u0644\u0637\u0644\u0628",
  140001: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u062A\u0642\u0631\u064A\u0631 \u0627\u0644\u0637\u0644\u0628",
  140002: "\u0646\u0637\u0627\u0642 \u0642\u064A\u0645\u0629 \u0627\u0644\u062D\u0627\u0644\u0629 \u0647\u0648 1-2",
  140003: "\u062A\u0642\u0631\u064A\u0631 \u0637\u0644\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  140004: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0644\u0641",
  140005: "\u0639\u0646\u0648\u0627\u0646 URL \u0644\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u062A\u0642\u0631\u064A\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  140006: "\u064A\u062C\u0628 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u062A\u0632\u0627\u0645\u0646 \u0627\u0644\u0645\u062E\u0635\u0635 \u0644\u0639\u0631\u0636 \u0627\u0644\u0646\u062F\u0648\u0629 \u063A\u0631\u0641\u0629 \u0627\u0644\u0646\u062F\u0648\u0629",
  141e3: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0647\u0645\u0629 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  141001: "\u062A\u0648\u062C\u062F \u062D\u0627\u0644\u064A\u064B\u0627 \u0645\u0647\u0645\u0629 \u062A\u0635\u062F\u064A\u0631 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  141002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  141003: "\u0646\u0637\u0627\u0642 \u0642\u064A\u0645\u0629 \u062D\u0627\u0644\u0629 \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0647\u0648 0-2",
  141004: "\u0645\u0647\u0645\u0629 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  141005: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u0647\u0645\u0629 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  141006: "\u0639\u0646\u0648\u0627\u0646 URL \u0644\u0644\u062A\u0646\u0632\u064A\u0644 \u0644\u0644\u062A\u0635\u062F\u064A\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  142001: "\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0645\u0637\u0648\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  142002: "appSecret \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  142003: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0639\u0645\u064A\u0644",
  142004: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
  142005: "\u064A\u0645\u0643\u0646 \u062A\u0646\u0632\u064A\u0644 \u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637",
  142006: "\u0627\u0644\u0642\u062F\u0631\u0629 \u0639\u0644\u0649 \u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A",
  142007: "\u0642\u062F\u0631\u0629 \u062A\u062D\u0631\u064A\u0631 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  142008: "\u062A\u0641\u0627\u0635\u064A\u0644 \u0642\u062F\u0631\u0629 \u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  142009: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0642\u062F\u0631\u0629",
  142010: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0642\u062A\u0631\u0627\u0646 \u0627\u0644\u0642\u062F\u0631\u0629 \u0648\u0627\u0644\u0625\u0630\u0646",
  142011: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0642\u062A\u0631\u0627\u0646 \u0627\u0644\u0642\u062F\u0631\u0629 - \u0625\u0630\u0646",
  142012: "IP \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  142013: "\u064A\u0631\u062C\u0649 \u062A\u0645\u0643\u064A\u0646 \u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u0627\u0644\u0645\u0641\u062A\u0648\u062D \u0623\u0648\u0644\u0627\u064B",
  143001: "\u0645\u0646\u062A\u062C \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  144001: "\u0627\u0644\u0632\u0628\u0648\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  145001: "\u0627\u0644\u0642\u062F\u0631\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  145002: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u0630\u0646 \u0627\u0644\u0627\u0642\u062A\u0631\u0627\u0646 \u0627\u0644\u0645\u0643\u0631\u0631",
  146001: "\u0648\u0635\u0644 \u0639\u062F\u062F \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u0627\u0644\u062A\u064A \u0623\u0646\u0634\u0623\u062A\u0647\u0627 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  146002: "\u0627\u0644\u0646\u0638\u0627\u0645 \u0645\u0634\u063A\u0648\u0644 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  146003: "\u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  146004: "\u0627\u0644\u0648\u0635\u0648\u0644 \u063A\u064A\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0625\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
  146005: "\u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0623\u0646 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0623\u0648\u0644\u064A\u0629 \u0644\u0644\u062A\u062F\u0642\u064A\u0642 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  146006: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
  146007: "\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0623\u0648 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0639\u062A\u0645\u0627\u062F \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  146008: "\u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u063A\u064A\u0631 \u0645\u0645\u0643\u0651\u0646",
  146009: "\u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0645\u0639\u0637\u0644",
  146010: "\u0627\u0644\u0632\u0628\u0648\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  146011: "\u0627\u0644\u0639\u0645\u064A\u0644 \u0645\u0639\u0637\u0644",
  146012: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0625\u0646\u0634\u0627\u0621 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  146013: "\u062A\u0645 \u062A\u0639\u0637\u064A\u0644 \u0627\u0644\u0639\u0645\u064A\u0644 \u0627\u0644\u0645\u0639\u062A\u0645\u062F",
  146014: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0639\u062F\u062F \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  146015: "\u0645\u0639\u0644\u0645\u0629 GrantType \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  146016: "\u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0646\u0637\u0627\u0642 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  146017: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u0639\u0631\u0641 \u0627\u0644\u0641\u0631\u064A\u062F \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u062E\u0627\u0631\u062C\u064A \u0641\u0627\u0631\u063A\u064B\u0627",
  146018: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u0646\u0634\u0627\u0637 \u0648\u0645\u0639\u0631\u0641 \u0627\u0644\u0646\u0634\u0627\u0637 \u0641\u0627\u0631\u063A\u064A\u0646",
  146019: "\u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u0645 \u064A\u062A\u0645 \u062A\u0645\u0643\u064A\u0646\u0647",
  146020: "\u0644\u062A\u0645\u0643\u064A\u0646 \u0639\u0646\u0648\u0627\u0646 URL \u0644\u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u060C \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0639\u0646\u0648\u0627\u0646.",
  147001: "\u0631\u0642\u0645 \u0644\u0648\u0646 \u062E\u0627\u0637\u0626",
  147002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0648\u0636\u0648\u0639",
  147003: "\u0641\u0634\u0644\u062A \u062A\u0647\u064A\u0626\u0629 \u0627\u0644\u0645\u0648\u0636\u0648\u0639",
  148e3: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0647\u0645\u0629 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  148001: "\u062A\u0648\u062C\u062F \u0645\u0647\u0645\u0629 \u062A\u0635\u062F\u064A\u0631 \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u0644\u0630\u0627 \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  148002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  148003: "\u062A\u062A\u0631\u0627\u0648\u062D \u0642\u064A\u0645 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0635\u062F\u0631\u0629 \u0645\u0646 0-2",
  148004: "\u0645\u0647\u0645\u0629 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  148005: "\u0641\u0634\u0644\u062A \u0645\u0647\u0645\u0629 \u062D\u0630\u0641 \u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  148006: "\u0639\u0646\u0648\u0627\u0646 \u062A\u0646\u0632\u064A\u0644 \u0642\u0637\u0639\u0629 \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  149001: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0635\u0648\u0631\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646",
  149002: "\u0645\u0639\u0631\u0651\u0641 \u0639\u0646\u0635\u0631 \u0625\u0639\u0644\u0627\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  149003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
  149004: "\u064A\u0631\u062C\u0649 \u062A\u0623\u0643\u064A\u062F \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u064A\u0633\u0645\u062D \u0628\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A",
  149005: "\u0644\u0627 \u064A\u062C\u0648\u0632 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u064A\u0629 \u0641\u0627\u0631\u063A\u0629",
  149006: "\u062A\u0646\u0633\u064A\u0642 \u0639\u0646\u0648\u0627\u0646 \u0627\u0646\u062A\u0642\u0627\u0644 \u0639\u0646\u0635\u0631 \u0635\u0648\u0631\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  149007: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0645\u0648\u0636\u0639 \u0627\u0644\u0639\u0631\u0636 \u0641\u0627\u0631\u063A\u064B\u0627",
  15e4: "\u062D\u0632\u0645\u0629 \u0645\u0648\u0627\u0631\u062F \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  150001: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0632\u0645\u0629 \u0645\u0648\u0627\u0631\u062F \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
  150002: "\u0645\u062E\u0632\u0648\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u063A\u064A\u0631 \u0643\u0627\u0641",
  150003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u062E\u0632\u0648\u0646 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
  150004: "\u0641\u0634\u0644 \u0641\u064A \u062A\u0643\u0648\u064A\u0646 \u062E\u0637 \u0623\u0646\u0627\u0628\u064A\u0628 \u0627\u0633\u062A\u0647\u0644\u0627\u0643 \u0645\u0648\u0627\u0631\u062F \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
  150005: "\u0633\u0639\u0629 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629",
  150006: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u062F\u062F \u0643\u0627\u0641\u064D \u0645\u0646 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
  150007: "\u0645\u0648\u0627\u0631\u062F SMS \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
  150008: "\u0648\u0642\u062A \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0644\u0642\u0627\u0626\u0645\u0629 \u063A\u064A\u0631 \u0643\u0627\u0641\u064D \u0644\u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0644\u0642\u0627\u0626\u0645\u0629",
  150009: "\u062A\u062F\u0641\u0642 \u0648\u0633\u0627\u0626\u0644 \u0627\u0644\u0627\u0639\u0644\u0627\u0645 \u062E\u062F\u0645\u0629 \u0637\u0648\u064A\u0644\u0629 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629 \u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0639\u064A\u0634",
  150010: "\u0648\u0642\u062A \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u063A\u0631\u064A\u062F \u063A\u064A\u0631 \u0627\u0644\u0643\u0627\u0641\u064A \u0644\u0644\u062C\u0647\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
  150011: "\u062C\u0631\u062F \u063A\u064A\u0631 \u0643\u0627\u0641 \u0644\u0642\u0627\u0639\u0627\u062A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
  150012: "\u0648\u0642\u062A \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u063A\u0631\u064A\u062F \u063A\u064A\u0631 \u0627\u0644\u0643\u0627\u0641\u064A \u0644\u0644\u062C\u0647\u0627\u062A \u0627\u0644\u062E\u0627\u0631\u062C\u064A\u0629",
  150013: "\u0641\u0634\u0644 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u0638\u0645",
  150014: "\u063A\u064A\u0631 \u0642\u0627\u062F\u0631 \u0639\u0644\u0649 \u0627\u0644\u0644\u0639\u0628 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u0638\u0645",
  150015: "\u062C\u0631\u062F \u063A\u064A\u0631 \u0643\u0627\u0641 \u0644\u0644\u0645\u0648\u0627\u0631\u062F",
  150016: "\u0645\u0648\u0627\u0631\u062F \u0645\u062A\u0632\u0627\u0645\u0646\u0629 \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629 \u0644\u0644\u0639\u0628",
  150017: "\u0627\u0644\u0645\u0648\u0627\u0631\u062F \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629 \u0644\u0645\u062F\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  150018: "\u0645\u062E\u0632\u0648\u0646 \u063A\u064A\u0631 \u0643\u0627\u0641\u064D \u0644\u0648\u0642\u062A \u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0635\u0648\u062A \u0648\u0627\u0644\u0641\u064A\u062F\u064A\u0648 UHD",
  150020: "\u0645\u062C\u0645\u0648\u0639\u0629 \u062A\u062D\u0643\u0645 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641\u0629",
  150021: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u0627\u0644\u0639\u0627\u0645\u0629 \u0648\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u062A\u062D\u0643\u0645",
  150022: "\u0645\u0648\u0627\u0631\u062F \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629 \u0644\u0644\u0646\u062F\u0648\u0627\u062A",
  150023: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u060C \u0645\u0648\u0627\u0631\u062F \u063A\u064A\u0631 \u0643\u0627\u0641\u064A\u0629",
  150024: "\u064A\u0645\u0643\u0646 \u0625\u0646\u0634\u0627\u0621 \u0639\u062F\u062F \u063A\u064A\u0631 \u0643\u0627\u0641\u064D \u0645\u0646 \u0648\u0631\u0634 \u0627\u0644\u0639\u0645\u0644",
  150025: "\u0646\u0633\u062E\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  150026: "\u064A\u0645\u0643\u0646 \u0644\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0625\u0646\u0634\u0627\u0621 \u063A\u0631\u0641\u0629 \u0628\u062B \u0645\u0628\u0627\u0634\u0631 \u0648\u0627\u062D\u062F\u0629 \u0643\u062D\u062F \u0623\u0642\u0635\u0649 \u060C \u064A\u0631\u062C\u0649 \u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0623\u0648\u0644\u0627\u064B",
  150027: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0625\u0646\u0634\u0627\u0621 \u0623\u0646\u0648\u0627\u0639 \u0645\u062E\u062A\u0644\u0641\u0629 \u0645\u0646 \u0627\u0644\u0645\u0633\u0627\u0641\u0627\u062A \u060C \u064A\u0631\u062C\u0649 \u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0623\u0648\u0644\u0627\u064B",
  150028: "\u064A\u0631\u062C\u0649 \u0634\u0631\u0627\u0621 \u0645\u0648\u0627\u0631\u062F \u063A\u0631\u0641\u0629 \u0627\u062C\u062A\u0645\u0627\u0639\u0627\u062A \u0627\u0644\u0646\u062F\u0648\u0629 \u0623\u0648\u0644\u0627\u064B",
  150029: "\u062E\u0637\u0623 \u0641\u064A \u0642\u0627\u0644\u0628 SMS",
  150030: "\u0645\u062E\u0632\u0648\u0646 \u063A\u064A\u0631 \u0643\u0627\u0641\u064D \u0644\u0645\u0648\u0627\u0631\u062F \u0646\u062F\u0648\u0629 \u0627\u0644\u0648\u064A\u0628 UHD",
  150031: "\u064A\u0631\u062C\u0649 \u0634\u0631\u0627\u0621 \u0645\u0648\u0627\u0631\u062F \u063A\u0631\u0641\u0629 UHD \u0644\u0644\u0646\u062F\u0648\u0629 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0623\u0648\u0644\u0627\u064B",
  151001: "\u062C\u0645\u0647\u0648\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  151002: "\u062F\u0631\u062F\u0634\u0629 \u062D\u064A\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  151003: "\u0631\u0633\u0627\u0644\u0629 \u062E\u0627\u0635\u0629 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  151004: "\u0646\u0648\u0639 \u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u062A\u0635\u0644 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  151005: "\u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  151006: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0625\u0630\u0646 \u0644\u062F\u062E\u0648\u0644 \u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u0627\u0646",
  151007: "\u064A\u062A\u062C\u0627\u0648\u0632 \u0633\u0642\u0641 \u0627\u0644\u063A\u0631\u0641\u0629",
  151008: "\u0642\u0627\u0645 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0628\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  151009: "\u0644\u0627 \u064A\u0633\u0645\u062D \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0645\u062C\u0647\u0648\u0644\u064A\u0646 \u0628\u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  151010: "\u0628\u062F\u0621 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621",
  151011: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0625\u064A\u062F\u0627\u0639",
  151012: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0628\u064A\u0627\u0646\u0627\u062A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0648\u0635\u0648\u0644",
  151013: "\u0641\u0634\u0644 \u062A\u0635\u062F\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0648\u0644\u0645 \u064A\u0646\u062A\u0647 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0639\u062F",
  151014: "\u062C\u0644\u0633\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0644\u0645 \u062A\u0646\u062A\u0647 \u0628\u0639\u062F",
  151015: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0633\u062A\u062E\u062F\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0648\u0635\u0648\u0644",
  151016: "\u0623\u0646\u062A \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0645\u0646\u0648\u0639\u064A\u0646",
  151017: '\u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644\u062A\u0647 \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0643\u0644\u0645\u0627\u062A \u062D\u0633\u0627\u0633\u0629 "%s"',
  151018: "\u0642\u0645 \u0628\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062D\u0627\u0644\u0629 \u063A\u064A\u0631 \u0627\u0644\u0637\u0628\u064A\u0639\u064A\u0629 \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0645\u062A\u0635\u0644\u064A\u0646 \u0628\u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
  151019: "\u0644\u0645 \u062A\u062A\u0645 \u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u060C \u0648\u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u0645\u062D\u0638\u0648\u0631\u0629",
  151020: "\u064A\u062A\u062C\u0627\u0648\u0632 \u0637\u0644\u0628 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 800 \u062D\u062F",
  151021: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0625\u0630\u0646 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u063A\u0644\u0641\u0627\u062A \u062D\u0645\u0631\u0627\u0621",
  151022: "\u0623\u0646\u062A \u062A\u062A\u062D\u062F\u062B \u0628\u0633\u0631\u0639\u0629 \u0643\u0628\u064A\u0631\u0629 \u060C \u0627\u0633\u062A\u0631\u062D \u0644\u0645\u062F\u0629%s \u062B\u0627\u0646\u064A\u0629",
  151023: "\u0644\u0627 \u062A\u0639\u0645\u0644 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  151024: "\u062E\u062F\u0645\u0629 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629",
  151025: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0645\u062C\u0647\u0648\u0644\u0629 \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0645\u062D\u062F\u062F\u064A\u0646",
  151026: "\u0648\u0635\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646 \u0627\u0644\u0645\u062D\u0638\u0648\u0631\u0648\u0646 \u0625\u0644\u0649 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  151027: "\u0648\u0635\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646 \u0627\u0644\u0630\u064A\u0646 \u062A\u0645 \u0637\u0631\u062F\u0647\u0645 \u0625\u0644\u0649 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  151028: "\u0641\u0634\u0644 \u0627\u0644\u0631\u062F \u060C \u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
  151029: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A",
  152001: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u062E\u0637",
  152002: "\u0642\u0645 \u0628\u062A\u0639\u062F\u064A\u0644 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u062E\u0637 \u0627\u0644\u0639\u0627\u0645 \u063A\u064A\u0631 \u0627\u0644\u0637\u0628\u064A\u0639\u064A",
  152003: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0643\u0648\u064A\u0646 \u062F\u0642\u0629 \u0645\u062A\u0639\u062F\u062F\u0629",
  152004: "\u0627\u0644\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  152005: "\u062A\u062F\u0641\u0642",
  152006: "\u0627\u0644\u062C\u0631\u064A \u0644\u0645 \u064A\u0628\u062F\u0623",
  152007: "\u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0623\u0648 \u0644\u0645 \u064A\u062A\u0645 \u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0645\u062A\u0639\u062F\u062F \u0627\u0644\u062F\u0642\u0629",
  152008: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u062E\u0637 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
  152009: "\u0642\u0645 \u0628\u062A\u0635\u062D\u064A\u062D \u062D\u0627\u0644\u0629 \u0627\u0644\u062E\u0637 \u063A\u064A\u0631 \u0627\u0644\u0637\u0628\u064A\u0639\u064A\u0629",
  152010: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u0645 \u0627\u0644\u062E\u0637 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  152011: "\u0645\u0648\u062C\u0632 \u062C\u0647\u0629 \u062E\u0627\u0631\u062C\u064A\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  152012: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062F\u0641\u0642 \u0627\u0644\u062F\u0641\u0639 \u0644\u062C\u0647\u0629 \u062E\u0627\u0631\u062C\u064A\u0629",
  152013: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062F\u0641\u0639 \u0644\u062C\u0647\u0629 \u062E\u0627\u0631\u062C\u064A\u0629",
  152014: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A \u062F\u0641\u0639 \u0627\u0644\u0637\u0631\u0641 \u0627\u0644\u062B\u0627\u0644\u062B",
  152015: "\u0625\u0646\u0634\u0627\u0621 \u0648\u0627\u0644\u0634\u0627\u0647\u062F \u0633\u062D\u0627\u0628\u0629 \u062F\u0641\u0639 \u0627\u0644\u0634\u0630\u0648\u0630",
  152016: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0642\u0641\u0644 \u0627\u0644\u0645\u0648\u0632\u0639",
  152017: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0631\u0633\u0648\u0645\u064A\u0629",
  152018: "\u062D\u0631\u0631 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0642\u0641\u0644 \u0627\u0644\u0645\u0648\u0632\u0639",
  152019: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0645\u0639\u0627\u0648\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642",
  153001: '\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0625\u0639\u0644\u0627\u0646 \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644\u062A\u0647 \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0643\u0644\u0645\u0627\u062A \u062D\u0633\u0627\u0633\u0629 "%s"',
  153002: "\u064A\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0628\u0639\u062F 5 \u062B\u0648\u0627\u0646\u064D",
  153003: "\u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0625\u0639\u0644\u0627\u0646 \u063A\u064A\u0631 \u0645\u062A\u0648\u0627\u0641\u0642",
  154001: "\u0623\u062F\u0648\u0627\u062A \u062A\u0633\u0648\u064A\u0642 \u063A\u064A\u0631 \u0641\u0639\u0627\u0644\u0629",
  154002: "\u0623\u062F\u0627\u0629 \u0627\u0644\u062A\u0633\u0648\u064A\u0642 \u0646\u0634\u0637\u0629",
  154003: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A \u0623\u062F\u0627\u0629 \u0627\u0644\u062A\u0633\u0648\u064A\u0642",
  154004: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0623\u062F\u0627\u0629 \u0627\u0644\u062A\u0633\u0648\u064A\u0642",
  154005: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0623\u062F\u0627\u0629 \u0627\u0644\u062A\u0633\u0648\u064A\u0642",
  154006: "\u064A\u0645\u0643\u0646 \u062A\u0645\u0643\u064A\u0646 \u062A\u0641\u0627\u0639\u0644 \u0648\u0627\u062D\u062F \u0641\u0642\u0637 \u0645\u0646 \u0646\u0641\u0633 \u0627\u0644\u0646\u0648\u0639 \u0641\u064A \u0643\u0644 \u0645\u0631\u0629 \u060C \u0648\u0627\u0644\u0639\u062F\u062F \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0644\u062A\u0641\u0627\u0639\u0644\u0627\u062A \u0627\u0644\u0645\u0645\u0643\u0646\u0629 \u0647\u0648 %s",
  154007: "\u0645\u0639\u0631\u0641 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u063A\u064A\u0631 \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0639\u062F\u064A\u0644",
  154008: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
  154009: "\u0627\u0644\u0645\u0634\u0643\u0644\u0629 \u0644\u064A\u0633\u062A \u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0627\u0633\u062A\u0628\u062F\u0627\u0644",
  154010: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0646\u0648\u0639 \u0627\u0644\u0633\u0624\u0627\u0644",
  154011: "\u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A \u063A\u064A\u0631 \u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u062A\u0628\u062F\u064A\u0644",
  154012: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A",
  154013: "\u0627\u0644\u0633\u0624\u0627\u0644 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  154014: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0641\u0627\u0631\u063A",
  154015: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A \u0627\u0644\u062C\u0645\u0647\u0648\u0631 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u062A\u0633\u0648\u064A\u0642",
  154016: "\u0639\u062F\u0645 \u062A\u0643\u0631\u0627\u0631",
  154017: "\u0627\u0633\u0645 \u0623\u062F\u0627\u0629 \u0627\u0644\u062A\u0633\u0648\u064A\u0642 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u062A\u0643\u0631\u0627\u0631\u0627\u062A",
  154018: "\u0625\u0631\u0633\u0627\u0644 \u0642\u062F\u0631\u0629 \u062E\u062F\u0645\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0641\u0627\u0631\u063A\u0629",
  154019: "\u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0623\u062F\u0627\u0629 \u0627\u0644\u062A\u0633\u0648\u064A\u0642 \u063A\u064A\u0631 \u0627\u0644\u0641\u0639\u0627\u0644\u0629",
  154020: "\u0623\u062F\u0627\u0629 \u0627\u0644\u062A\u0633\u0648\u064A\u0642 \u063A\u064A\u0631 \u0645\u0645\u0643\u0651\u0646\u0629",
  154021: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u062A\u0633\u0648\u064A\u0642 \u0627\u0644\u0642\u062F\u0631\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629",
  154022: "\u0644\u0642\u062F \u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F\u062B \u0648\u0642\u062A \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646",
  154023: "\u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F \u0644\u0646\u0648\u0639 \u0623\u062F\u0627\u0629 \u0627\u0644\u062A\u0633\u0648\u064A\u0642",
  154024: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0644\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  154025: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  154026: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0639\u0644\u0645\u0629 \u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  154027: "\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  154028: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  154029: "\u062A\u0639\u062F\u064A\u0644 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621",
  154030: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  154031: "\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  154032: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0639\u0644\u0645\u0629 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  154033: "\u0646\u0648\u0639 \u0623\u062F\u0627\u0629 \u062A\u0633\u0648\u064A\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  154034: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0644\u0641 \u0645\u0643\u0631\u0631",
  154035: "\u0641\u0634\u0644 \u0639\u062F\u062F \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0641\u064A \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062D\u0627\u0644\u064A%s",
  154036: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  154037: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0639\u0644\u0645\u0629 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  155e3: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0634\u0631\u064A\u0637 \u0627\u0644\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u0645\u062E\u0635\u0635",
  155001: "\u0641\u0634\u0644 \u0625\u0636\u0627\u0641\u0629 \u0641\u064A\u062F\u064A\u0648 \u0634\u0631\u064A\u0637 \u0627\u0644\u0642\u0648\u0627\u0626\u0645",
  155002: "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  155003: "\u0639\u0646\u0635\u0631 \u0641\u064A\u062F\u064A\u0648 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  155004: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0641\u064A\u062F\u064A\u0648 \u0634\u0631\u064A\u0637 \u0627\u0644\u0642\u0648\u0627\u0626\u0645",
  155005: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0637\u0644\u0628 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  155006: "\u0641\u0634\u0644 \u0641\u064A \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0648\u0633\u0627\u0626\u0637",
  155007: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0645\u0639\u0644\u0645\u0629",
  155008: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0632\u062E\u0631\u0641\u0629",
  155009: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0632\u062E\u0631\u0641\u0629",
  155010: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u0646\u0634\u0627\u0621 \u0642\u0646\u0627\u0629 \u0623\u0648\u0644\u0627",
  155011: "\u0642\u0627\u0626\u0645\u0629 \u0645\u062E\u0635\u0635\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  155012: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0641\u0627\u0631\u063A",
  155013: "\u0627\u0644\u0645\u0639\u0631\u0641 \u0627\u0644\u0623\u0645\u0627\u0645\u064A \u0641\u0627\u0631\u063A",
  155014: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0641\u0631\u0632 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u062E\u0635\u0635\u0629",
  155015: "\u0639\u0646\u0648\u0627\u0646 URL \u0641\u0627\u0631\u063A",
  155016: "\u062E\u064A\u0627\u0631 \u0646\u0633\u062E \u0635\u0641\u062D\u0629 \u0627\u0644\u0632\u062E\u0631\u0641\u0629 \u0641\u0627\u0631\u063A",
  155017: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0641\u0627\u0631\u063A\u0629",
  155018: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0632\u062E\u0631\u0641\u0629",
  155019: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u063A\u0631\u0641\u0629 \u0641\u064A \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  155020: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u063A\u0631\u0641\u0629 \u0641\u064A \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  155021: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  155022: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0643\u0627\u0646 \u0644\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  155023: "\u0623\u0646\u0634\u0637\u0629 \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0628\u0648\u0627\u0633\u0637\u0629 \u062E\u0637\u0629 \u0632\u062E\u0631\u0641\u0629 \u0627\u0644\u0646\u0633\u062E \u063A\u064A\u0631 \u0645\u062A\u0633\u0642\u0629",
  155024: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0628\u0648\u0627\u0633\u0637\u0629 \u062E\u0637\u0629 \u0632\u062E\u0631\u0641\u0629 \u0627\u0644\u0646\u0633\u062E \u0645\u062A\u0633\u0642\u0629",
  155025: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0633\u062D\u0628 \u0627\u0644\u0634\u0639\u0627\u0631",
  155026: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0634\u0631\u064A\u0637 \u0627\u0644\u0642\u0648\u0627\u0626\u0645",
  155027: "\u062A\u0643\u0648\u064A\u0646 \u0641\u064A\u062F\u064A\u0648 \u0634\u0631\u064A\u0637 \u0627\u0644\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u0645\u062E\u0635\u0635 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  155028: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0627\u063A",
  155029: "\u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621 \u0623\u0648 \u0648\u0642\u062A \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0641\u0627\u0631\u063A",
  155030: "\u0627\u0644\u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u064A\u0633 \u0641\u0627\u0631\u063A\u064B\u0627",
  155031: "\u064A\u0645\u0643\u0646 \u062A\u062D\u062F\u064A\u062F \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 3 \u0646\u0635\u0648\u0635 \u0645\u062D\u062F\u062F\u0629 \u0645\u0633\u0628\u0642\u064B\u0627",
  155032: "watermarkWordType \u0627\u0644\u0642\u064A\u0645 \u062A\u062A\u0631\u0627\u0648\u062D \u0628\u064A\u0646 0-1",
  155033: "\u0627\u062E\u062A\u0631 \u0646\u0635\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0645\u064F\u0639\u062F\u064B\u0627 \u0645\u0633\u0628\u0642\u064B\u0627 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  155034: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0634\u0639\u0627\u0631 \u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
  155035: "\u0646\u0637\u0627\u0642 \u0627\u0644\u0642\u064A\u0645\u0629 \u0644\u062A\u062D\u062F\u064A\u062F \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0647\u0648 0 ~ 1",
  155036: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0634\u0639\u0627\u0631 \u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0644\u0649 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
  155037: "\u0646\u0637\u0627\u0642 \u0642\u064A\u0645\u0629 \u0634\u0639\u0627\u0631 \u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0631\u0645\u0632\u064A \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0647\u0648 0 ~ 1",
  155038: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0646\u0637\u0627\u0642 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
  155039: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0636\u0645\u0646 \u0646\u0637\u0627\u0642 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0627\u0644\u062C\u0645\u0627\u0647\u064A\u0631",
  155040: "\u0646\u0637\u0627\u0642 \u0646\u0637\u0627\u0642 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0647\u0648 \u066A s ~ \u066A s",
  155041: "\u0641\u0634\u0644 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
  155042: "\u064A\u062A\u0645 \u062A\u0634\u063A\u064A\u0644 \u0644\u063A\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  156001: "\u062D\u062C\u0645 \u0627\u0644\u0645\u0644\u0641 \u0628\u062D\u062F \u0623\u0642\u0635\u0649 5 \u0645\u064A\u062C\u0627",
  156002: "\u0644\u062F\u064A\u0643 \u062D\u0627\u0644\u064A\u064B\u0627 \u0645\u0647\u0645\u0629 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  156003: "\u0627\u0644\u0645\u0644\u0641 \u064A\u062F\u0639\u0645 \u0641\u0642\u0637 \u062A\u0646\u0633\u064A\u0642 xls \u0648 xlsx",
  156004: "\u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631 5 \u0648\u0627\u0637 \u0648 1 \u0628\u0627\u0631",
  156005: "\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u0641",
  156007: "\u0641\u0634\u0644 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u0647\u0645\u0629 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  156008: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u0647\u0645\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0641\u0634\u0644",
  156009: "\u0633\u062C\u0644 \u062E\u0637\u0623 \u0641\u0648\u0642 \u0627\u0644\u062D\u062F",
  156010: "\u0641\u0634\u0644\u062A \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0645\u0644\u0641",
  157001: "\u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0627\u0644\u0634\u0627\u0634\u0629 \u063A\u064A\u0631 \u0642\u0627\u0628\u0644 \u0644\u0644\u0625\u0635\u0644\u0627\u062D",
  157002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0627\u0644\u0634\u0627\u0634\u0629",
  157003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0627\u0644\u0634\u0627\u0634\u0629",
  157004: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0627\u0644\u0634\u0627\u0634\u0629",
  157005: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0639\u0631\u0641 \u0628\u062B \u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0627\u0644\u0634\u0627\u0634\u0629",
  160001: "\u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u063A\u064A\u0631 \u0645\u0645\u0643\u0651\u0646\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
  160002: "\u0634\u0643\u0644 \u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0627\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D \u060C \u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u0628\u0626\u062A\u0647",
  160003: "\u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0627\u0644 \u0627\u0644\u062D\u0627\u0644\u064A \u0645\u0643\u0631\u0631 \u060C \u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u0628\u0626\u062A\u0647",
  160004: "\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0648\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0645",
  160005: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0648\u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0627\u0644 \u063A\u064A\u0631 \u0645\u062A\u0637\u0627\u0628\u0642\u064A\u0646",
  160006: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0635\u0627\u0644\u062D\u0629 \u0644\u0645\u062F\u0629 \u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631 \u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0634\u0647\u0627\u062F\u0629 \u062C\u062F\u064A\u062F\u0629",
  160007: "\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u063A\u064A\u0631 \u0635\u062D\u064A\u062D \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0648\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0645",
  160008: "\u0641\u0634\u0644 \u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0648\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0648\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0645",
  160009: "\u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0644\u0627 \u062A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0648\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0642\u062F\u064A\u0645",
  160010: "\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0623\u0648 \u062A\u0639\u0637\u064A\u0644\u0647\u0627 \u062B\u0645 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0643\u0648\u064A\u0646",
  160011: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646\u0647\u0627 \u060C \u064A\u0631\u062C\u0649 \u062A\u0643\u0648\u064A\u0646 \u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0627\u0644 \u0623\u0648\u0644\u0627\u064B",
  160012: "\u062E\u0637\u0623 \u0628\u0627\u0626\u0639 \u0627\u0644\u0633\u062D\u0627\u0628\u0629",
  160013: "\u0641\u0634\u0644 \u0646\u0634\u0631 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
  160014: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0634\u0647\u0627\u062F\u0629",
  160015: "\u0645\u0639\u0631\u0641 \u0627\u0644\u0635\u0641\u062D\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  160016: "\u0641\u0634\u0644 \u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
  160017: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  160018: "\u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0627\u0644 \u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0646\u0634\u0627\u0637",
  161001: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u062E\u0637\u0623",
  161002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u062E\u0637\u0623 IP",
  161003: "\u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u062E\u0637\u0623 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  161004: "\u062E\u0637\u0623 IP \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  161005: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u062E\u0637\u0623",
  161006: "\u0641\u0634\u0644 \u062D\u0630\u0641 bug-IP",
  161007: "IP \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  161008: "\u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u062E\u0644\u0648\u064A \u0623\u0648 \u0635\u0646\u062F\u0648\u0642 \u0627\u0644\u0628\u0631\u064A\u062F \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  162001: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0642\u0627\u0626\u0645\u0629 \u0633\u0648\u062F\u0627\u0621 \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646",
  162002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 IP \u0644\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0633\u0648\u062F\u0627\u0621",
  162003: "\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0633\u0648\u062F\u0627\u0621",
  162004: "IP \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0633\u0648\u062F\u0627\u0621 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  162005: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0633\u0648\u062F\u0627\u0621",
  162006: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0639\u0646\u0648\u0627\u0646 IP \u0627\u0644\u062E\u0627\u0635 \u0628\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0633\u0648\u062F\u0627\u0621",
  162007: "IP \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  162008: "\u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u062E\u0644\u0648\u064A \u0623\u0648 \u0635\u0646\u062F\u0648\u0642 \u0627\u0644\u0628\u0631\u064A\u062F \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  170001: "\u0641\u0634\u0644 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
  170002: "\u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  170003: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0634\u0627\u0631\u0643 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0633\u0624\u0648\u0644",
  170004: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0642\u0631\u0639\u0629",
  170005: "\u064A\u0627\u0646\u0635\u064A\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  170006: "\u0627\u0633\u0645 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u0641\u064A \u0646\u0641\u0633 \u063A\u0631\u0641\u0629 \u0627\u0644\u0645\u0639\u064A\u0634\u0629 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u0627\u0632\u062F\u0648\u0627\u062C\u064A\u0629",
  170007: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0627\u0644\u062C\u0648\u0627\u0626\u0632 \u0641\u064A \u0627\u0644\u0633\u062D\u0628 \u0647\u0648 20",
  170008: "\u062C\u0627\u0626\u0632\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  170009: "\u0644\u0627 \u064A\u0627\u0646\u0635\u064A\u0628 \u062C\u0627\u0631\u064A\u0629",
  170010: "\u062A\u0645 \u0633\u062D\u0628 \u0627\u0644\u062C\u0627\u0626\u0632\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u062D\u0631\u064A\u0631\u0647\u0627",
  170011: "\u062A\u0645 \u0633\u062D\u0628 \u0627\u0644\u062C\u0627\u0626\u0632\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647\u0627",
  170012: "\u0627\u0644\u0633\u062D\u0628 \u0639\u0644\u0649 \u0627\u0644\u062C\u0648\u0627\u0626\u0632 \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645 \u062D\u0627\u0644\u064A\u064B\u0627 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u063A\u0644\u0627\u0642\u0647 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A",
  170013: "\u062C\u0627\u0626\u0632\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  170014: "\u0644\u0627 \u062A\u0643\u0631\u0631 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  170015: "\u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u0644\u0644\u0641\u0634\u0644 \u0641\u064A \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  170016: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  170017: "\u0647\u0646\u0627\u0643 \u062C\u0648\u0627\u0626\u0632 \u0642\u064A\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  170018: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  170019: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0642\u064A\u0627\u0633\u064A \u0627\u0644\u0641\u0627\u0626\u0632",
  170020: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0639\u062F\u062F \u0627\u0644\u0641\u0627\u0626\u0632\u064A\u0646 \u0641\u064A \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  170021: "\u064A\u0631\u062C\u0649 \u0628\u062F\u0621 \u0627\u0644\u0633\u062D\u0628 \u0623\u0648\u0644\u0627\u064B",
  170022: "\u0644\u0642\u062F \u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0633\u062D\u0628 \u0627\u0644\u062C\u0627\u0626\u0632\u0629",
  170023: "\u0644\u0642\u062F \u0627\u0646\u0636\u0645\u0645\u062A \u0625\u0644\u0649 \u0627\u0644\u0633\u062D\u0628 \u060C \u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0643\u0631\u0631 \u0627\u0644\u0639\u0645\u0644\u064A\u0629",
  170024: "\u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0647\u0646\u0627\u0643 \u064A\u0627\u0646\u0635\u064A\u0628 \u0648\u0627\u062D\u062F \u0641\u0642\u0637 \u0646\u0634\u0637",
  170025: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0639\u062F\u062F \u0627\u0644\u0641\u0627\u0626\u0632\u064A\u0646 \u0644\u0623\u062D\u062F \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646",
  170026: "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u062D\u0627\u0644\u0629 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0639\u0631\u0636\u0647\u0627",
  170027: "\u064A\u0631\u062C\u0649 \u062A\u0639\u064A\u064A\u0646 \u062C\u0627\u0626\u0632\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  170028: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  170029: "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646",
  170030: "\u062D\u0627\u0644\u0629 \u063A\u0631\u0641\u0629 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629 \u060C \u0628\u0631\u062C\u0627\u0621 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
  170031: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  170032: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0641\u0627\u0626\u0632 \u0623\u0648\u0644\u0648\u064A\u0629 \u0627\u0644\u062C\u0627\u0626\u0632\u0629",
  170033: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0641\u0627\u0626\u0632 \u0628\u0627\u0644\u062C\u0627\u0626\u0632\u0629 \u0627\u0644\u0623\u0648\u0644\u0649",
  170034: "\u0627\u0644\u062F\u062E\u0648\u0644 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647 \u0644\u0647\u0630\u0647 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  170035: "\u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0627 \u064A\u0633\u0645\u062D \u0644\u0644\u0645\u0634\u0627\u0647\u062F\u064A\u0646 \u0628\u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u060C \u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u062F\u064A\u062F \u0646\u0637\u0627\u0642 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  170036: "\u0645\u0634\u0627\u0631\u0643 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D \u0641\u064A \u0645\u0633\u0627\u0628\u0642\u0629 \u064A\u0627\u0646\u0635\u064A\u0628",
  170037: "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0632\u064A\u062F \u0639\u062F\u062F \u0627\u0644\u0641\u0627\u0626\u0632\u064A\u0646 \u0639\u0646 \u0639\u062F\u062F \u0627\u0644\u062C\u0648\u0627\u0626\u0632",
  170038: "\u0639\u062F\u062F \u0627\u0644\u062C\u0648\u0627\u0626\u0632 \u0627\u0644\u062D\u0627\u0644\u064A \u0623\u0642\u0644 \u0645\u0646 \u0627\u0644\u0639\u062F\u062F \u0627\u0644\u0645\u062D\u062F\u062F \u0645\u0633\u0628\u0642\u064B\u0627 \u0644\u0644\u0641\u0627\u0626\u0632\u064A\u0646 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  170039: "\u0646\u0637\u0627\u0642 \u064A\u0627\u0646\u0635\u064A\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  170040: "\u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u0627\u0644\u062F\u0641\u0639\u064A \u063A\u064A\u0631 \u0645\u0639\u062A\u0645\u062F",
  170041: "\u0631\u0645\u0632 \u0627\u0644\u062E\u0637\u0623",
  170042: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0643\u0648\u062F",
  170043: "\u0625\u0630\u0627 \u0644\u0645 \u064A\u062A\u0645 \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u0641\u064A \u063A\u0636\u0648\u0646 30 \u064A\u0648\u0645\u064B\u0627 \u0628\u0639\u062F \u0628\u062F\u0621 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u060C \u0641\u0644\u0627 \u064A\u0645\u0643\u0646 \u0633\u062D\u0628 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  171001: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0642\u0627\u0644\u0628 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629",
  171002: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0642\u0627\u0644\u0628 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629",
  171003: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0642\u0627\u0644\u0628 \u062A\u0644\u0645\u064A\u062D",
  171004: "\u0646\u0645\u0648\u0630\u062C \u0646\u0635\u064A\u062D\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  171010: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0627\u0644\u0642\u0627\u0644\u0628",
  171101: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0642\u0627\u0644\u0628 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629",
  171102: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0642\u0627\u0644\u0628 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629",
  171103: "\u062D\u0630\u0641 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0642\u0627\u0644\u0628 \u062A\u0644\u0645\u064A\u062D",
  171104: "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062A\u0631\u062A\u064A\u0628 \u063A\u064A\u0631 \u0627\u0644\u0637\u0628\u064A\u0639\u064A \u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629",
  171105: "\u0623\u0636\u0641 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 20 \u062F\u0639\u0627\u0645\u0629",
  171106: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u0641\u062A\u062D \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0642\u0627\u0644\u0628 \u0627\u0644\u0646\u0635\u064A\u062D\u0629",
  171110: "\u0644\u0627 \u064A\u0633\u0645\u062D \u0628\u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0639\u0646\u0635\u0631 \u0627\u0644\u0628\u0642\u0634\u064A\u0634",
  171111: "\u0639\u0646\u0635\u0631 \u0627\u0644\u0645\u0646\u062A\u062C \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  171112: "\u062F\u0639\u0627\u0626\u0645 \u0627\u0644\u0628\u0636\u0627\u0626\u0639 \u0645\u0639\u0637\u0644\u0629",
  171113: "\u062E\u0637\u0623 \u0641\u064A \u062D\u0627\u0644\u0629 \u062F\u0641\u0639 \u0627\u0644\u0639\u0646\u0635\u0631",
  171114: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0643\u0627\u0641\u0623\u0629 \u0641\u064A \u0627\u0644\u063A\u0631\u0641\u0629",
  171115: "\u0627\u0644\u062F\u0639\u0627\u0626\u0645 \u0642\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u060C \u0648\u0644\u0627 \u064A\u062A\u0645 \u062A\u062C\u0646\u0628 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A. \u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u063A\u0644\u0627\u0642\u0647\u0627 \u0642\u0628\u0644 \u0627\u0644\u062A\u062D\u0631\u064A\u0631.",
  171116: "\u0644\u0627 \u062A\u0639\u0645\u0644 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  183001: "\u0639\u0627\u0631\u0636 \u0645\u0628\u0627\u0634\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  183002: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u062D\u0633\u0627\u0628 \u0641\u0627\u0631\u063A\u064B\u0627",
  183003: "\u062A\u0646\u0633\u064A\u0642 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  183004: "\u0648\u0636\u0639 \u0627\u0644\u062A\u0641\u0648\u064A\u0636 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  183005: "\u062E\u0637\u0623 \u0641\u064A \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
  183006: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  183007: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062E\u0627\u0637\u0626\u0629",
  183008: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062C\u0645\u0647\u0648\u0631",
  183009: " \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u0644\u0627 \u064A\u0633\u0645\u062D \u0628\u0627\u0644\u062A\u0643\u0631\u0627\u0631",
  183010: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0631\u0627\u0628\u0637 \u062A\u0631\u062E\u064A\u0635 WeChat \u060C \u0627\u0644\u0646\u0637\u0627\u0642 \u0641\u0627\u0631\u063A",
  183011: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0631\u0627\u0628\u0637 \u062A\u0641\u0648\u064A\u0636 WeChat \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A \u060C \u0648\u0627\u0644\u0646\u0637\u0627\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  183012: "\u0627\u0633\u062A\u062F\u0639\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0637\u0644\u0628 \u0634\u0628\u0643\u0629 WeChat",
  183013: "\u0639\u0627\u0631\u0636 \u0645\u0639\u062A\u0645\u062F \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  183014: "\u0627\u0643\u062A\u0633\u0627\u0628 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A \u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0633\u062A\u062E\u062F\u0645 WeChat",
  183015: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0633\u062A\u062E\u062F\u0645 WeChat",
  183016: "\u0631\u0628\u0637 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  183017: "\u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u0639\u0646 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0631\u0645\u0632 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  183018: "\u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0633\u062A\u062E\u062F\u0645 WeChat \u0645\u0639 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0630\u064A \u0642\u0627\u0645 \u0628\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u062D\u0627\u0644\u064A\u064B\u0627",
  183019: "\u0627\u0646\u062A\u0647\u062A \u0645\u0647\u0644\u0629 \u062A\u0641\u0648\u064A\u0636 WeChat",
  183020: "\u062A\u0645 \u0631\u0628\u0637 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u062D\u0627\u0644\u064A \u0627\u0644\u0630\u064A \u0642\u0627\u0645 \u0628\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0640 WeChat",
  183021: "\u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0631\u0642\u0645 \u063A\u0631\u0641\u0629 \u0627\u0631\u062A\u0628\u0627\u0637 WeChat \u0627\u0644\u0645\u0635\u0631\u062D \u0628\u0647 \u0641\u0627\u0631\u063A",
  183022: "\u0644\u0627 \u064A\u0642\u0648\u0645 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u0628\u062A\u0643\u0648\u064A\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062A\u0641\u0648\u064A\u0636 WeChat",
  183023: "\u0631\u0645\u0632 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 WeChat \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  183024: "\u062D\u0627\u0644\u0629 \u0631\u062F \u0627\u062A\u0635\u0627\u0644 WeChat \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  183025: "\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0641\u0627\u0631\u063A",
  183026: "Wechat \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0627\u0644\u0648\u0635\u0648\u0644",
  183027: "Wechat \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 jsApiTicket",
  183028: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u063A\u0631\u0641\u0629 \u0641\u0627\u0631\u063A\u064B\u0627",
  183029: "\u0627\u0646\u062A\u0647\u062A \u0645\u0647\u0644\u0629 \u0627\u0644\u062A\u0641\u0648\u064A\u0636",
  183030: "\u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0631\u0633\u0645\u064A \u063A\u064A\u0631 \u0645\u0631\u062A\u0628\u0637 \u0628\u0627\u0644\u0645\u0646\u0635\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629",
  183031: "\u0637\u0631\u064A\u0642\u0629 \u062A\u0631\u062E\u064A\u0635 \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u0633\u0627\u0633\u064A \u0627\u0644\u0645\u0641\u062A\u0648\u062D \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645\u0629 \u062D\u0627\u0644\u064A\u064B\u0627",
  183032: '\u062A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0627\u0644\u0643\u0644\u0645\u0629 \u0627\u0644\u062D\u0633\u0627\u0633\u0629 "%s" \u060C \u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0623\u0648\u0644\u0627\u064B',
  183033: `\u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u062E\u0627\u0635\u0629 \u060C \u0645\u062B\u0644 ' " \\ / & > <`,
  183034: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062C\u0645\u0647\u0648\u0631",
  183035: "\u0631\u0642\u0645 \u063A\u0631\u0641\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  183036: "\u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0633\u062A\u062E\u062F\u0645 WeChat \u0645\u0639 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0630\u064A \u0642\u0627\u0645 \u0628\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u062D\u0627\u0644\u064A\u064B\u0627",
  183037: "\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  183038: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 / \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0641\u0627\u0631\u063A\u064A\u0646",
  183039: "\u064A\u062C\u0628 \u0645\u0644\u0621 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
  183040: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0641\u0627\u0631\u063A\u0629",
  183041: "\u0631\u0645\u0632 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  183042: "\u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0623\u0648 \u0631\u0642\u0645 \u062C\u0647\u0629 \u062E\u0627\u0631\u062C\u064A\u0629",
  183043: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 1",
  183044: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u062C\u0645\u0647\u0648\u0631",
  183045: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u0625\u0632\u0627\u0644\u0629",
  183046: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  183047: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u062C\u0647\u0629 \u062E\u0627\u0631\u062C\u064A\u0629",
  183048: "\u0641\u0634\u0644 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062D\u0633\u0627\u0628 \u062C\u0647\u0629 \u062E\u0627\u0631\u062C\u064A\u0629",
  183050: "\u062A\u0643\u0648\u064A\u0646 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D \u0644\u0640 WeChat appsecret",
  183051: "\u062A\u0643\u0648\u064A\u0646 \u0645\u0639\u0631\u0641 \u062A\u0637\u0628\u064A\u0642 WeChat \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  183052: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0631\u0633\u0645\u064A \u0645\u0639 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0628\u064A\u0636\u0627\u0621 IP",
  183053: "\u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0631\u0633\u0645\u064A \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A \u060C \u0648\u064A\u062C\u0628 \u062A\u0623\u0643\u064A\u062F \u0639\u0646\u0648\u0627\u0646 IP \u0645\u0646 \u0642\u0628\u0644 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
  183054: "\u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0631\u0633\u0645\u064A \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A \u060C \u0648\u0639\u0646\u0648\u0627\u0646 IP \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0644\u0644\u062A\u0623\u0643\u064A\u062F",
  183055: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0643\u0627\u0644\u0645\u0629 \u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0631\u0633\u0645\u064A \u060C \u0631\u0641\u0636 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 IP",
  183056: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0645\u0643\u0627\u0644\u0645\u0629 \u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0631\u0633\u0645\u064A \u060C \u0631\u0641\u0636 \u0627\u0644\u0645\u0633\u0624\u0648\u0644 IP",
  183057: "\u062E\u0637\u0623 \u062A\u0643\u0648\u064A\u0646 \u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0631\u0633\u0645\u064A AppSecret",
  183058: "\u0645\u0639\u0644\u0645\u0629 \u0646\u0648\u0639 \u0645\u0646\u062D\u0629 WeChat \u0644\u064A\u0633\u062A \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0639\u062A\u0645\u0627\u062F client_",
  183059: "\u0641\u0634\u0644 \u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u062C\u0645\u0647\u0648\u0631",
  183060: "\u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u062C\u0627\u0631\u064A \u062D\u0633\u0627\u0628 \u0627\u0641\u062A\u0631\u0627\u0636\u064A.",
  200001: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0641\u0642\u0648\u062F\u0629",
  200002: "\u0627\u0644\u0645\u0639\u0644\u0645\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629",
  200003: "\u0645\u062F\u064A\u0631 \u0627\u0644\u0645\u062E\u0631\u062C \u0644\u0623\u0643\u062B\u0631 255 \u062D\u0631\u0641\u064B\u0627",
  200004: "\u0644\u0645 \u064A\u062A\u0645 \u0641\u062A\u062D \u0645\u0643\u062A\u0628 \u0628\u062B \u0627\u0644\u062F\u0644\u064A\u0644 \u0627\u0644\u0633\u062D\u0627\u0628\u064A \u0628\u0639\u062F",
  200005: "\u062A\u0645 \u062D\u0630\u0641 \u0642\u0646\u0627\u0629 \u0628\u062B \u0627\u0644\u062F\u0644\u064A\u0644 \u0627\u0644\u0633\u062D\u0627\u0628\u064A",
  200006: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0642\u0646\u0627\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u062F\u0644\u064A\u0644 \u0627\u0644\u0633\u062D\u0627\u0628\u064A",
  200007: "\u062A\u0645 \u0641\u062A\u062D \u0642\u0646\u0627\u0629 \u0627\u0644\u0628\u062B \u0627\u0644\u062F\u0644\u064A\u0644 \u0627\u0644\u0633\u062D\u0627\u0628\u064A",
  200008: "\u0644\u0645 \u064A\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0642\u0646\u0627\u0629 \u0628\u062B \u0627\u0644\u062F\u0644\u064A\u0644 \u0627\u0644\u0633\u062D\u0627\u0628\u064A \u0628\u0639\u062F",
  200009: "\u062A\u0645 \u0641\u062A\u062D \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u062A\u0623\u062E\u0631",
  200010: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u062A\u0623\u062E\u0631",
  200011: "\u0645\u0648\u0631\u062F \u063A\u064A\u0631 \u0643\u0627\u0641 \u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0643\u062A\u0628 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0633\u062D\u0627\u0628\u064A \u060C \u0641\u0634\u0644 \u0627\u0644\u0641\u062A\u062D",
  200012: "\u0644\u0645 \u064A\u062A\u0645 \u0641\u062A\u062D \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u062A\u0623\u062E\u0631 \u0628\u0639\u062F",
  200013: "\u0645\u062F\u064A\u0631 \u062C\u062F\u0648\u0644 \u0627\u0644\u062F\u0644\u064A\u0644",
  200014: "\u0637\u0644\u0628 IP \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A",
  200015: "\u0645\u062F\u064A\u0631 \u0645\u0643\u062A\u0628 \u0627\u0644\u062F\u0644\u064A\u0644 \u064A\u062F\u0639\u0645 \u0641\u0642\u0637 \u0627\u0644\u0635\u064A\u0646\u064A\u0629 \u0648\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629 \u0648\u0627\u0644\u0623\u0631\u0642\u0627\u0645",
  200016: "\u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0645\u062A\u0643\u0631\u0631",
  200017: "\u064A\u062A\u0645 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  200018: "\u064A\u0631\u062C\u0649 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0628\u062B \u0627\u0644\u062A\u0623\u062E\u064A\u0631 \u0623\u0648\u0644\u0627\u064B",
  208e3: "\u0625\u0630\u0646 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  209e3: "\u062F\u0648\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  209001: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062F\u0648\u0631",
  209002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u062F\u0648\u0631",
  209003: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u062F\u0648\u0631",
  209004: "\u0647\u0646\u0627\u0643 \u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u0631\u062A\u0628\u0637 \u0644\u0647\u0630\u0627 \u0627\u0644\u062F\u0648\u0631",
  209005: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0631\u062A\u0628\u0627\u0637 \u0623\u0630\u0648\u0646\u0627\u062A \u0627\u0644\u062F\u0648\u0631",
  209006: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0631\u062A\u0628\u0627\u0637 \u0625\u0630\u0646 \u0627\u0644\u062F\u0648\u0631",
  209007: "\u062E\u0637\u0623 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0639\u0636\u0648",
  209008: "\u062D\u0630\u0641 \u0645\u0639\u0644\u0645\u0629 \u062E\u0637\u0623",
  209009: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0627\u0644\u062F\u0648\u0631",
  209010: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0634\u062E\u0635\u064A\u0629",
  21e4: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0643\u0644 \u0645\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u0647\u0627\u062A\u0641 \u0641\u0627\u0631\u063A\u064A\u0646",
  210001: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646",
  210002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0623\u0634\u062E\u0627\u0635",
  210003: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0634\u062E\u0635 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  210004: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  210005: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0627\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  210006: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 / \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  210007: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 / \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  210008: "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062E\u0627\u0637\u0626\u0629",
  210009: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u0642\u062F\u064A\u0645\u0629 \u0641\u0627\u0631\u063A\u0629",
  210010: "WeChat openId \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  210011: "\u0645\u0639\u0631\u0641 \u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0637\u0631\u0641 \u0627\u0644\u062B\u0627\u0644\u062B \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  210012: "\u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0644\u0627 \u064A\u062F\u0639\u0645 \u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0623\u0648\u0644\u0627\u064B",
  22e4: "\u0639\u062F\u062F \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u0645\u0633\u062A\u0623\u062C\u0631 -",
  220001: "\u0641\u0634\u0644 \u0625\u0636\u0627\u0641\u0629 \u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0623\u0641\u0631\u0627\u062F",
  220002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0623\u0641\u0631\u0627\u062F",
  220003: "\u062A\u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  220004: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0623\u0634\u062E\u0627\u0635",
  220005: "\u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0625\u062F\u062E\u0627\u0644\u0647 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  221001: "\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062D\u0632\u0645 \u0627\u0644\u062D\u0645\u0631\u0627\u0621 \u063A\u064A\u0631 \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629",
  221002: "\u0641\u0634\u0644 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u062A\u0641\u0627\u0635\u064A\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062D\u0632\u0645\u0629 \u0627\u0644\u062D\u0645\u0631\u0627\u0621",
  221003: "\u0641\u0634\u0644\u062A \u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0644\u062E\u0635 \u0642\u0646\u0627\u0629 \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u0627\u0644\u0645\u0633\u062A\u0645\u0631\u0629",
  221004: "\u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  221005: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0646 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  221006: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0627\u0633\u0645 \u0641\u0627\u0631\u063A\u064B\u0627",
  221007: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0647\u0627\u062A\u0641 \u0641\u0627\u0631\u063A\u064B\u0627",
  221008: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0641\u0627\u0631\u063A\u064B\u0627",
  221009: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0641\u0627\u0631\u063A\u064B\u0627",
  221010: "\u062D\u062C\u0645 \u0635\u0648\u0631\u0629 \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u062A\u0639\u0628\u064A\u0631\u064A\u0629 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  221011: "\u062E\u0637\u0623 \u0641\u064A \u062A\u0646\u0633\u064A\u0642 \u0635\u0648\u0631\u0629 \u0627\u0644\u0631\u0645\u0648\u0632",
  221012: "\u062A\u0645 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u062A\u0639\u0628\u064A\u0631\u064A\u0629 \u0644\u0623\u0643\u062B\u0631 \u0645\u0646 \u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
  221013: "\u064A\u0645\u0643\u0646 \u0644\u0644\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0625\u0646\u0634\u0627\u0621 \u0645\u062C\u0645\u0648\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631 \u0645\u0646 \u0627\u0644\u0631\u0645\u0648\u0632 \u060C \u064A\u0631\u062C\u0649 \u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u0625\u0635\u062F\u0627\u0631 \u0623\u0648\u0644\u0627\u064B",
  221014: "\u0623\u0646\u0634\u0626 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 5 \u0631\u0645\u0648\u0632 \u062A\u0639\u0628\u064A\u0631\u064A\u0629",
  221015: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0631\u0645\u0648\u0632",
  221016: "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0639\u0645\u0644 \u0623\u062B\u0646\u0627\u0621 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0631\u0645\u0632",
  221017: "\u0627\u0644\u0645\u0634\u0627\u0639\u0631 \u063A\u064A\u0631 \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629",
  222001: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A \u0639\u0644\u0649 \u0627\u0644\u0648\u064A\u0628 \u0645\u0646 \u0646\u0648\u0639 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0644\u062F\u0631\u062F\u0634\u0629",
  222002: "\u0642\u0627\u0626\u0645\u0629 \u062A\u0634\u063A\u064A\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  222003: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  222004: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  222005: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  222006: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0642\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
  222007: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u0645\u0635\u062F\u0631 \u0625\u062F\u062E\u0627\u0644 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  222008: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  222009: "\u064A\u0631\u062C\u0649 \u062A\u0643\u0648\u064A\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0642\u0628\u0644 \u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  222010: "\u0646\u0641\u0633 \u0627\u0644\u0634\u0627\u0634\u0629 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u060C \u064A\u0631\u062C\u0649 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0623\u0648\u0644\u0627\u064B \u062B\u0645 \u062D\u0641\u0638\u0647\u0627",
  222011: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u062D\u062F\u064A\u062F \u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u062A\u0643\u0648\u064A\u0646",
  222012: "\u0627\u0644\u0623\u0633\u0645\u0627\u0621 \u0627\u0644\u0645\u0643\u0631\u0631\u0629 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645\u0629 \u0641\u064A \u0646\u0641\u0633 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639",
  222013: "\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0645\u062A\u0627\u062D\u0629 \u0641\u0642\u0637 \u0644\u0644\u0646\u062F\u0648\u0627\u062A",
  222014: "\u0627\u0644\u0623\u0648\u0644 \u0623\u0648 \u0627\u0644\u0623\u062E\u064A\u0631 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u062A\u062D\u0631\u0643 \u0644\u0623\u0639\u0644\u0649 \u0648\u0644\u0623\u0633\u0641\u0644",
  222015: "\u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062D\u0642\u0644 \u0641\u0631\u0632 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  222016: "\u0623\u0646\u0634\u0626 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 50 \u0642\u0627\u0626\u0645\u0629 \u062A\u0634\u063A\u064A\u0644",
  222017: "\u0644\u0627 \u062A\u0639\u0645\u0644 \u0628\u0634\u0643\u0644 \u0645\u062A\u0643\u0631\u0631",
  222018: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u062D\u062F\u062F \u0645\u0633\u0628\u0642\u064B\u0627",
  222019: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u062D\u062F\u062F \u0645\u0633\u0628\u0642\u064B\u0627",
  223001: "\u0645\u0633\u0627\u0628\u0642\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  223002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  223003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  223004: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  223005: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u062C\u0627\u0626\u0632\u0629 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  223006: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062C\u0627\u0626\u0632\u0629 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  223007: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  223008: "\u064A\u0645\u0643\u0646 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u0642\u0637",
  223009: "\u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u0642\u0637",
  223010: "\u064A\u0648\u062C\u062F \u062D\u0627\u0644\u064A\u064B\u0627 \u0645\u0633\u0627\u0628\u0642\u0629 \u062C\u0627\u0631\u064A\u0629 \u0644\u0627 \u062A\u062F\u0639\u0645 \u0627\u0644\u0625\u063A\u0644\u0627\u0642",
  223011: "\u062E\u0637\u0623 \u0641\u064A \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  223012: "\u064A\u0631\u062C\u0649 \u062A\u0645\u0643\u064A\u0646 \u0645\u064A\u0632\u0629 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631 \u0623\u0648\u0644\u0627\u064B",
  223013: "\u0647\u0646\u0627\u0643 \u062D\u0627\u0644\u064A\u064B\u0627 \u0645\u0633\u0627\u0628\u0642\u0629 \u0645\u0633\u062A\u0645\u0631\u0629\u060C \u064A\u0631\u062C\u0649 \u0625\u0646\u0647\u0627\u0626\u0647\u0627 \u0623\u0648\u0644\u0627\u064B",
  223014: "\u062C\u0627\u0626\u0632\u0629 \u0645\u0633\u0627\u0628\u0642\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  223015: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  223016: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0633\u062C\u0644 \u0627\u0644\u0645\u0633\u0627\u0628\u0642\u0629",
  223017: "\u0647\u0646\u0627\u0643 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0645\u0633\u0627\u0628\u0642\u0629 \u0648\u0627\u062D\u062F\u0629 \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645",
  223018: "\u0644\u0627\u064A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A",
  223019: "\u0633\u062C\u0644 \u0645\u0633\u0627\u0628\u0642\u0629 \u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u0643\u0631\u0631",
  223020: "\u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646 \u0644\u064A\u0633 \u0644\u0647 \u0625\u062C\u0627\u0628\u0627\u062A",
  225001: "\u0627\u0645\u062A\u062D\u0627\u0646 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  225002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631",
  225003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631",
  225004: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646",
  225005: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0627\u0645\u062A\u062D\u0627\u0646\u0627\u062A \u062C\u0627\u0631\u064A\u0629",
  225006: "\u0639\u062F\u062F \u063A\u064A\u0631 \u0639\u0627\u062F\u064A \u0645\u0646 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645",
  225007: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0639\u0627\u062F\u0629 \u0627\u0633\u0645 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631",
  225008: "\u064A\u0645\u0643\u0646 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u0642\u0637",
  225009: "\u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u0642\u0637",
  225010: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0627\u062E\u062A\u0628\u0627\u0631 \u0648\u0627\u062D\u062F \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645",
  225011: "\u064A\u0645\u0643\u0646 \u0641\u062A\u062D \u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u0642\u0637",
  225012: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  225013: "\u0644\u0642\u062F \u0641\u0627\u062A \u0627\u0644\u0623\u0648\u0627\u0646 \u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646.",
  225014: "\u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646",
  225015: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646",
  225016: "\u064A\u0645\u0643\u0646 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646\u0627\u062A \u0627\u0644\u062C\u0627\u0631\u064A\u0629 \u0641\u0642\u0637",
  225017: "\u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646 \u0644\u0645 \u064A\u0628\u062F\u0623",
  225018: "\u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646 \u0645\u0641\u062A\u0648\u062D \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u0648\u0644\u0627 \u062F\u0627\u0639\u064A \u0644\u0641\u062A\u062D\u0647 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  225019: "\u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646 \u0645\u063A\u0644\u0642 \u060C \u0644\u0627 \u062F\u0627\u0639\u064A \u0644\u0625\u063A\u0644\u0627\u0642\u0647 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  225020: "\u0633\u062C\u0644\u0627\u062A \u0627\u0644\u0627\u0645\u062A\u062D\u0627\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  225021: "\u0627\u0646\u0642\u0636\u0649 \u0648\u0642\u062A \u0627\u0644\u0633\u0624\u0627\u0644",
  225022: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0644\u0627 \u064A\u0641\u064A \u0628\u0645\u0648\u0627\u0635\u0641\u0627\u062A \u0627\u0644\u0627\u0633\u062A\u064A\u0631\u0627\u062F \u060C \u064A\u0631\u062C\u0649 \u0627\u062A\u0628\u0627\u0639 \u0645\u0648\u0627\u0635\u0641\u0627\u062A \u0642\u0627\u0644\u0628 \u0645\u0633\u062A\u0646\u062F EXCEL",
  225023: "\u064A\u0631\u062C\u0649 \u062A\u062D\u0645\u064A\u0644 \u0645\u0644\u0641 \u0628\u062A\u0646\u0633\u064A\u0642 xls. \u0631\u0628\u0645\u0627 .xlsx",
  226001: "\u0633\u0624\u0627\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  226002: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0633\u0624\u0627\u0644",
  226003: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0633\u0624\u0627\u0644",
  226004: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0633\u0624\u0627\u0644",
  226005: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u0633\u0626\u0644\u0629 \u062C\u0627\u0631\u064A\u0629",
  226006: "\u0639\u062F\u062F \u063A\u064A\u0631 \u0639\u0627\u062F\u064A \u0645\u0646 \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645",
  226008: "\u064A\u0645\u0643\u0646 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u0642\u0637",
  226009: "\u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u063A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u0642\u0637",
  226010: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0624\u0627\u0644 \u0648\u0627\u062D\u062F \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645",
  226011: "\u064A\u0645\u0643\u0646 \u0641\u062A\u062D \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u063A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u0642\u0637",
  226012: "\u064A\u0645\u0643\u0646 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645 \u0641\u0642\u0637",
  226013: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0633\u0624\u0627\u0644 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  226014: "\u062A\u0645 \u0646\u0634\u0631 \u0627\u0644\u0633\u0624\u0627\u0644",
  226015: "\u0627\u0646\u062A\u0647\u0649 \u0627\u0644\u0633\u0624\u0627\u0644",
  226016: "\u0627\u0644\u0633\u0624\u0627\u0644 \u0644\u0645 \u064A\u0646\u062A\u0647 \u0628\u0639\u062F",
  226017: "\u062A\u0642\u062F\u064A\u0645 \u0645\u062A\u0643\u0631\u0631",
  226018: "\u062E\u064A\u0627\u0631\u0627\u062A \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062E\u0637\u0623",
  226019: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A \u0644\u0644\u0623\u0633\u0626\u0644\u0629 \u063A\u064A\u0631 \u0627\u0644\u062C\u0627\u0631\u064A\u0629",
  226020: "\u0627\u062E\u062A\u0631 \u0625\u062C\u0627\u0628\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0643\u062B\u0631",
  226021: "\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u0625\u062C\u0627\u0628\u062A\u064A\u0646 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  226022: "\u0639\u062F\u062F \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A \u064A\u0635\u0644 \u0625\u0644\u0649 50",
  226023: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u062E\u064A\u0627\u0631",
  226024: "\u0644\u0627 \u062A\u0643\u0631\u0631 \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
  227001: "\u0645\u0647\u0645\u0629 \u062A\u0648\u0632\u064A\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  227002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0647\u0645\u0629 \u0627\u0644\u062A\u0648\u0632\u064A\u0639",
  227003: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0645\u0647\u0627\u0645 \u0627\u0644\u062A\u0648\u0632\u064A\u0639 \u0639\u0644\u0649 \u062F\u0641\u0639\u0627\u062A",
  227004: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0647\u0645\u0629 \u0627\u0644\u062A\u0648\u0632\u064A\u0639",
  227005: "\u0639\u0646\u0648\u0627\u0646 \u062F\u0641\u0642 \u062F\u0641\u0639 \u0627\u0644\u0647\u062F\u0641 \u0645\u0643\u0631\u0631",
  227006: "\u0623\u0646\u0634\u0626 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 20 \u0645\u0647\u0645\u0629 \u062A\u0648\u0632\u064A\u0639 \u0645\u0628\u0627\u0634\u0631\u0629 \u0641\u064A \u0648\u0642\u062A \u0648\u0627\u062D\u062F",
  227007: "\u062A\u0645 \u062A\u0643\u0631\u0627\u0631 \u0639\u0646\u0648\u0627\u0646 \u062F\u0641\u0642 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0648\u062C\u0647\u0629",
  227008: "\u0645\u0639\u0644\u0645\u0627\u062A \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u064F\u0641\u0639\u0627\u062A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  227009: "\u0641\u0634\u0644 \u0641\u064A \u0627\u0644\u062D\u0630\u0641",
  227010: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u062F\u0641\u0639\u0629",
  227011: "\u0641\u0634\u0644\u062A \u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0645\u062C\u0645\u0639\u0629",
  227012: "\u062E\u0637\u0623 \u0641\u064A \u0645\u0639\u0627\u0645\u0644 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0645\u062A\u0639\u062F\u062F \u0627\u0644\u0633\u062D\u0627\u0628\u0629",
  227013: "\u0644\u0645 \u064A\u0628\u062F\u0623 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u062D\u0627\u0644\u064A \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0628\u062F\u0621 \u0645\u0647\u0645\u0629 \u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  227014: "\u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0645\u0645\u0646\u0648\u0639 \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  227015: "\u0639\u0645\u0644\u064A\u0627\u062A \u0645\u062A\u0643\u0631\u0631\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0641\u064A \u0648\u0642\u062A \u0644\u0627\u062D\u0642",
  227016: "\u0645\u0647\u0645\u0629 \u0627\u0644\u062A\u0648\u0632\u064A\u0639 \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647\u0627",
  227017: "\u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629 \u062A\u062D\u0638\u0631 \u0647\u0630\u0647 \u0627\u0644\u0639\u0645\u0644\u064A\u0629",
  227018: "\u0645\u0646\u0635\u0629 \u062A\u0648\u0632\u064A\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  227019: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0644\u0623\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u062A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0623\u0643\u062B\u0631 \u0645\u0646 \u0641\u064A\u062F\u064A\u0648 \u0648\u0627\u062D\u062F.",
  227020: "\u0644\u0627 \u062A\u062F\u0639\u0645 \u0645\u0646\u0635\u0629 \u0627\u0644\u0635\u064A\u0646 \u0627\u0644\u062D\u064A\u0629 \u0628\u0631\u0648\u062A\u0648\u0643\u0648\u0644 rtmps",
  227021: "\u0646\u0648\u0639 \u0645\u0646\u0635\u0629 \u0627\u0644\u062A\u0648\u0632\u064A\u0639 \u063A\u064A\u0631 \u0645\u062A\u0637\u0627\u0628\u0642",
  228001: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0623\u0633\u0645\u0627\u0621 \u0627\u0644\u062A\u0635\u0648\u064A\u062A",
  228002: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062A\u0635\u0648\u064A\u062A",
  228003: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0633\u0648\u0649 \u0627\u0644\u0623\u0635\u0648\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629",
  228004: "\u062A\u0635\u0648\u064A\u062A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  228005: "\u0643\u0627\u0646\u062A \u0647\u0646\u0627\u0643 \u0628\u0627\u0644\u0641\u0639\u0644 \u062A\u0635\u0648\u064A\u062A\u0627\u062A",
  228006: "\u0641\u0634\u0644 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u062A\u0635\u0648\u064A\u062A",
  228007: "\u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u0623\u0635\u0648\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629 \u0641\u0642\u0637",
  228008: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u062A\u0635\u0648\u064A\u062A",
  228009: "\u0639\u062F\u062F \u0627\u0644\u0623\u0635\u0648\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645 \u0623\u0643\u0628\u0631 \u0645\u0646 1",
  228010: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u062A\u0635\u0648\u064A\u062A",
  228011: "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0645\u0643\u0631\u0631\u0629",
  228012: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0623\u0635\u0648\u0627\u062A \u0627\u0644\u062A\u064A \u0644\u064A\u0633\u062A \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645",
  228013: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644 \u0627\u0644\u062A\u0635\u0648\u064A\u062A",
  228014: "\u062A\u0645 \u062A\u062C\u0627\u0648\u0632 \u0639\u062F\u062F \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A",
  228015: "\u0627\u0644\u0645\u0648\u0639\u062F \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0645\u062A\u0623\u062E\u0631 \u0628\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0639\u0646 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A",
  229001: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0633\u062C\u0644",
  230001: "\u0646\u0648\u0639 \u0627\u0644\u0634\u0631\u0643\u0629 \u0627\u0644\u0645\u0635\u0646\u0639\u0629:%s \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u0645\u0624\u0642\u062A\u064B\u0627:%s \u060C \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u062A\u062D\u0642\u0642 \u0628\u0639\u0646\u0627\u064A\u0629",
  230002: "\u0646\u0648\u0639 \u0627\u0644\u0628\u0627\u0626\u0639:%s \u060C \u0647\u0630\u0647 \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u063A\u064A\u0631 \u0645\u0639\u062A\u0645\u062F\u0629:%s",
  230003: "\u062A\u0633\u062A\u062F\u0639\u064A \u0627\u0644\u0648\u0627\u062C\u0647\u0629%s \u0627\u0633\u062A\u062B\u0646\u0627\u0621%s \u0627\u0644\u0633\u062D\u0627\u0628\u064A:%s",
  230004: "\u064A\u0637\u0644\u0628 \u0628\u0627\u0626\u0639 \u0627\u0644\u0633\u062D\u0627\u0628\u0629 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062D\u0632\u0645\u0629 \u0643\u0640 NULL",
  231001: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
  231002: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
  231003: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u0647\u0645\u0629",
  231004: "\u0627\u0644\u0646\u0634\u0627\u0637 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  231005: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0647\u0645\u0629 \u0628\u0639\u062F \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
  231006: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u0627\u0631\u063A\u0629",
  240001: "\u062D\u0627\u0644\u0629 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629. \u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u062C\u0639\u0629 \u0648\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  240002: "\u062A\u0643\u0648\u064A\u0646 AccessKey \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  240003: "\u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F. \u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u062C\u0639\u0629 \u0648\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  240004: "\u0641\u0634\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644. \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0639\u0646\u0635\u0631 \u0627\u0644\u062A\u0643\u0648\u064A\u0646",
  240005: "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0643\u0648\u0646%s \u0625\u0645\u0627 \u0623\u062D\u0631\u0641\u064B\u0627 \u0643\u0628\u064A\u0631\u0629 \u0623\u0648 \u0635\u063A\u064A\u0631\u0629 \u0623\u0648 \u0623\u0631\u0642\u0627\u0645\u064B\u0627",
  240006: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0625\u0644\u0632\u0627\u0645\u064A\u0629",
  240007: "\u0642\u0645 \u0628\u062A\u0643\u0648\u064A\u0646 \u062E\u062F\u0645\u0629 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0642\u0635\u064A\u0631\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u0623\u0648\u0644\u0627\u064B",
  250001: "\u0641\u0634\u0644 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0642\u0627\u0644\u0628. \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u062A\u0643\u0648\u064A\u0646",
  250002: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646%s \u0623\u062D\u0631\u0641\u064B\u0627 / \u0623\u0631\u0642\u0627\u0645\u064B\u0627 \u0643\u0628\u064A\u0631\u0629 / _",
  250003: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0625\u0644\u0632\u0627\u0645\u064A\u0629",
  250004: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0642\u0627\u0644\u0628 SMS \u0645\u0646 \u0646\u0648\u0639 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642",
  250005: "\u0646\u0648\u0639 \u0642\u0627\u0644\u0628 SMS \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  250006: "\u0631\u0645\u0632 \u0642\u0627\u0644\u0628 SMS \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F. \u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u062C\u0639\u0629 \u0648\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  250007: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062D\u062A\u0648\u064A \u0642\u0627\u0644\u0628 SMS \u0639\u0644\u0649 \u0645\u062A\u063A\u064A\u0631 {code}",
  250008: "\u062A\u0648\u062C\u062F \u0645\u062A\u063A\u064A\u0631\u0627\u062A \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645\u0629 \u0641\u064A \u0642\u0627\u0644\u0628 SMS. \u0625\u062C\u0631\u0627\u0621",
  250009: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0639\u062A\u0645\u0627\u062F \u0642\u0627\u0644\u0628 SMS. \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  250010: "\u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0642\u0627\u0644\u0628 SMS \u0641\u064A \u0646\u0641\u0633 \u0627\u0644\u0633\u064A\u0646\u0627\u0631\u064A\u0648. \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  250011: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0643\u0648\u064A\u0646 \u062E\u062F\u0645\u0629 SMS",
  250012: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u0633\u0644\u0633\u0644\u0629 \u0642\u0635\u064A\u0631\u0629",
  250013: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0627\u0644\u0645\u062A\u063A\u064A\u0631 {expireDate} \u0645\u0648\u062C\u0648\u062F\u064B\u0627 \u0641\u064A \u0642\u0627\u0644\u0628 SMS",
  250014: "\u0642\u0627\u0644\u0628 SMS \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  260001: "\u0644\u0627 \u062A\u0642\u0645 \u0628\u0625\u0636\u0627\u0641\u0629 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0643\u0631\u0631\u0629",
  260002: "\u0644\u0627 \u062A\u0642\u0645 \u0628\u0625\u0636\u0627\u0641\u0629 \u0623\u0631\u0642\u0627\u0645 \u0647\u0648\u0627\u062A\u0641 \u0645\u0643\u0631\u0631\u0629",
  260003: "\u0641\u0634\u0644 \u0625\u0636\u0627\u0641\u0629 \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644",
  260004: "\u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  260005: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  260006: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u0643\u0645\u0627\u0644 \u0627\u0644\u0627\u0633\u0645 \u0648\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  260007: "\u062E\u0637\u0623 \u0641\u064A \u062A\u0646\u0633\u064A\u0642 \u0635\u0646\u062F\u0648\u0642 \u0627\u0644\u0628\u0631\u064A\u062F!",
  260008: "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0623\u062F\u062E\u0644 \u0625\u0633\u0645\u0643!",
  260009: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0623\u0648 \u0631\u0642\u0645 \u0647\u0627\u062A\u0641\u0643 \u0627\u0644\u0645\u062D\u0645\u0648\u0644!",
  260010: "\u062E\u0637\u0623 \u0641\u064A \u062A\u0646\u0633\u064A\u0642 \u0631\u0642\u0645 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A / \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644!",
  260011: "\u0623\u0636\u0641 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 5 \u062C\u0647\u0627\u062A \u0627\u062A\u0635\u0627\u0644",
  260012: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0645\u0633\u062D\u0647",
  260013: "\u0641\u0634\u0644\u062A \u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  270001: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u0643\u0648\u064A\u0646 \u062A\u0646\u0628\u064A\u0647 \u0627\u0644\u0645\u0648\u0631\u062F",
  280001: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u0633\u0648\u064A\u0629",
  280002: "\u0648\u0631\u0642\u0629 \u062A\u0633\u0648\u064A\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  290001: "\u0641\u0634\u0644 \u0641\u064A \u062A\u0647\u064A\u0626\u0629 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0636\u0628\u0637 \u0627\u0644\u0645\u0633\u0628\u0642 \u0623\u062B\u0646\u0627\u0621 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u063A\u0631\u0641\u0629",
  290002: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0636\u0628\u0637 \u0627\u0644\u0645\u0633\u0628\u0642",
  290003: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0642\u0627\u0626\u0645\u0629 \u0645\u0639\u0631\u0651\u0641\u0629 \u0645\u0646 \u0642\u0628\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u0644\u062A\u062E\u0632\u064A\u0646",
  290004: "\u0641\u0634\u0644 \u0625\u0636\u0627\u0641\u0629 \u0642\u0627\u0626\u0645\u0629 \u0645\u062E\u0635\u0635\u0629",
  290005: "\u0642\u0627\u0626\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  290006: "\u0644\u0627 \u062A\u0639\u0645\u0644 \u0639\u0628\u0631 \u0627\u0644\u063A\u0631\u0641",
  290007: "\u064A\u062A\u0645 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  290008: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0648\u0648\u0636\u0639\u0647\u0627 \u0641\u064A \u0627\u0644\u062A\u062E\u0632\u064A\u0646",
  290009: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290010: "\u064A\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  290011: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0636\u0628\u0637 \u0627\u0644\u0645\u0633\u0628\u0642",
  290012: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u062E\u0632\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290013: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290014: "\u062A\u0642\u0648\u0645 \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0628\u0641\u0631\u0632 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290015: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0646\u0642\u0648\u0644\u0629 \u0644\u064A\u0633\u062A \u0642\u0627\u0626\u0645\u0629 \u0635\u0627\u0644\u062D\u0629",
  290016: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u0646\u0642\u0644\u0647\u0627 \u0644\u064A\u0633\u062A \u0642\u0627\u0626\u0645\u0629 \u0635\u0627\u0644\u062D\u0629",
  290017: "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0639\u0645\u0644 \u0639\u0628\u0631 \u0627\u0644\u063A\u0631\u0641 \u0644\u0641\u0631\u0632 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0646\u0642\u0648\u0644\u0629 \u0644\u0627 \u062A\u0646\u062A\u0645\u064A \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u063A\u0631\u0641\u0629",
  290018: "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0639\u0645\u0644 \u0639\u0628\u0631 \u0627\u0644\u063A\u0631\u0641 \u0644\u0641\u0631\u0632 \u0627\u0644\u0642\u0627\u0626\u0645\u0629. \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0646\u0642\u0648\u0644\u0629 \u0644\u0627 \u062A\u0646\u062A\u0645\u064A \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u063A\u0631\u0641\u0629",
  290019: "\u0644\u0627 \u062A\u0639\u0645\u0644 \u0639\u0628\u0631 \u0627\u0644\u0644\u063A\u0627\u062A \u0644\u0641\u0631\u0632 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290020: "\u0641\u0634\u0644 \u0641\u0631\u0632 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0648\u0627\u0644\u062A\u062E\u0632\u064A\u0646",
  290021: "\u0641\u0634\u0644 \u0641\u0631\u0632 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290022: "\u0645\u0643\u0648\u0646 \u0642\u0627\u0626\u0645\u0629 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645",
  290023: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0636\u0628\u0637 \u0627\u0644\u0645\u0633\u0628\u0642 \u0625\u0636\u0627\u0641\u0629 \u0645\u0643\u0648\u0646\u0627\u062A",
  290024: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u0643\u0648\u0646%s \u0628\u0642\u064A\u0645\u0629 \u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629 \u0625\u0644\u0649 \u0642\u0627\u0639\u062F\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  290025: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u0643\u0648\u0646%s \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
  290026: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0643\u0648\u0646 \u0644\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629",
  290027: "\u0623\u0636\u0641 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649%s \u0645\u0646 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A \u0636\u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0645\u062E\u0635\u0635\u0629 \u0648\u0627\u062D\u062F\u0629",
  290028: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0645\u0633\u0628\u0642 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A",
  290029: "\u062A\u0639\u0637\u064A\u0644 \u0627\u0644\u062A\u062D\u0631\u064A\u0631 \u0639\u0628\u0631 \u0627\u0644\u0642\u0648\u0627\u0626\u0645 \u0645\u0646 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A",
  290030: "\u0639\u0646\u062F \u062A\u062D\u0631\u064A\u0631 \u0645\u0643\u0648\u0646 \u060C \u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0643\u0627\u0626\u0646 \u0645\u0639\u0644\u0645\u0629 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 [requestData] \u0633\u0644\u0633\u0644\u0629 Json \u0628\u0639\u062F \u0627\u0644\u062A\u062D\u0648\u064A\u0644. \u064A\u062D\u0638\u0631 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A \u0639\u0628\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290031: "\u0645\u0643\u0648\u0646%s \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  290032: "\u0641\u0634\u0644 \u062A\u062D\u0631\u064A\u0631 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u0643\u0648\u0646%s",
  290033: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0636\u0628\u0637 \u0627\u0644\u0645\u0633\u0628\u0642 \u062D\u0630\u0641 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A",
  290034: "\u062A\u0639\u0637\u064A\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A \u0639\u0628\u0631 \u0627\u0644\u0642\u0648\u0627\u0626\u0645",
  290035: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u0643\u0648\u0646%s \u0644\u0644\u062A\u062E\u0632\u064A\u0646",
  290036: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u0643\u0648\u0646%s",
  290037: "\u0639\u0646\u062F \u062A\u062D\u0631\u064A\u0631 \u0645\u0643\u0648\u0646 \u0645\u0631\u0628\u0639 \u0646\u0635 \u0645\u0646\u0633\u0642 \u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0646\u0635%s \u0643\u0644\u0645\u0629",
  290038: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0645\u0633\u0628\u0642 \u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u0639\u0646 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A",
  290039: "\u0645\u0646\u0639 \u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u0639\u0646 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A \u0639\u0628\u0631 \u0627\u0644\u0642\u0648\u0627\u0626\u0645",
  290040: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621",
  290041: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0648\u0642\u062A \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
  290042: "\u064A\u0645\u0643\u0646 \u062A\u0643\u0648\u064A\u0646 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649%s \u0635\u0648\u0631",
  290043: "\u0641\u0634\u0644 \u062A\u062D\u0631\u064A\u0631 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u0643\u0648\u0646%s \u0644\u0644\u062A\u062E\u0632\u064A\u0646",
  290044: "%s \u0627\u0644\u0641\u0631\u0632 \u0627\u0644\u0645\u0643\u0631\u0631 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0647",
  290045: "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0641\u0631\u0632%s \u0645\u0633\u062A\u0645\u0631\u0627\u064B",
  290046: "\u064A\u0645\u0643\u0646\u0643 \u062A\u0643\u0648\u064A\u0646 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649%s \u0645\u0646 \u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u0634\u0631\u0643\u0627\u0621",
  290047: "\u064A\u0645\u0643\u0646 \u062A\u0643\u0648\u064A\u0646 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649%s \u0645\u0646 \u0627\u0644\u0634\u0631\u0643\u0627\u0621",
  290048: "\u064A\u0645\u0643\u0646 \u062A\u0643\u0648\u064A\u0646 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649%s \u0645\u0646 \u0627\u0644\u0623\u0646\u0634\u0637\u0629",
  290049: "\u064A\u0645\u0643\u0646 \u062A\u0643\u0648\u064A\u0646 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649%s \u0645\u0646 \u0627\u0644\u0645\u0648\u0627\u0642\u0639",
  290050: "\u0641\u0634\u0644 \u0641\u0631\u0632 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A \u0648\u062A\u062E\u0632\u064A\u0646\u0647\u0627 \u0636\u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290051: "\u0641\u0634\u0644 \u0641\u064A \u0641\u0631\u0632 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A \u0636\u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290052: "\u064A\u062A\u0645 \u0641\u0631\u0632 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629 \u0636\u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  290053: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0641\u0631\u0632 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0636\u0628\u0637 \u0627\u0644\u0645\u0633\u0628\u0642 \u062D\u0633\u0628 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A",
  290054: "\u0627\u0644\u0645\u0643\u0648\u0646 \u0627\u0644\u0630\u064A \u062A\u0645 \u0646\u0642\u0644\u0647 \u0644\u064A\u0633 \u0645\u0643\u0648\u0646\u064B\u0627 \u0635\u0627\u0644\u062D\u064B\u0627",
  290055: "\u0627\u0644\u0645\u0643\u0648\u0646 \u0627\u0644\u0630\u064A \u064A\u062A\u0645 \u0646\u0642\u0644\u0647 \u0644\u064A\u0633 \u0645\u0643\u0648\u0646\u064B\u0627 \u0635\u0627\u0644\u062D\u064B\u0627",
  290056: "\u064A\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0648\u062A\u0632\u064A\u064A\u0646\u0647\u0627",
  290057: "\u0641\u0634\u0644 \u0646\u0633\u062E \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0623\u0648 \u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  290058: "\u0641\u0634\u0644 \u0641\u064A \u0646\u0633\u062E \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0623\u0648 \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0631\u0627\u0626\u0639 \u0644\u0644\u0645\u0646\u0637\u0642\u0629 \u0641\u064A \u0627\u0644\u0645\u0643\u062A\u0628\u0629",
  290059: "\u064A\u0645\u0643\u0646 \u062A\u0643\u0648\u064A\u0646 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649%s \u0645\u0646 \u0645\u0642\u0627\u0637\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
  290060: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0641\u064A\u062F\u064A\u0648 \u0645\u062B\u064A\u0631 \u0625\u0644\u0649 mysql",
  290061: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0641\u064A\u062F\u064A\u0648 \u0645\u062B\u064A\u0631",
  290062: "\u0642\u0627\u0626\u0645\u0629 \u0646\u0648\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  290063: "\u0641\u064A\u062F\u064A\u0648\u0647\u0627\u062A \u0631\u0627\u0626\u0639\u0629 \u0644\u0627 \u0648\u062C\u0648\u062F \u0644\u0647\u0627",
  290064: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631",
  290065: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631",
  290066: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631 \u0641\u064A mysql",
  290067: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631",
  290068: "\u062A\u0642\u0648\u0645 \u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0628\u0641\u0631\u0632 \u0641\u064A\u062F\u064A\u0648 \u0645\u062B\u064A\u0631",
  290069: "\u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631 \u0644\u0644\u062C\u0648\u0627\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  290070: "\u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631 \u0627\u0644\u0630\u064A \u062A\u0645 \u0646\u0642\u0644\u0647 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  290071: "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0639\u0645\u0644 \u0639\u0628\u0631 \u0627\u0644\u063A\u0631\u0641 \u0644\u0641\u0631\u0632 \u0645\u0642\u0627\u0637\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631\u0629. \u0645\u0642\u0627\u0637\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631\u0629 \u0627\u0644\u0645\u0646\u0642\u0648\u0644\u0629 \u0644\u0627 \u062A\u0646\u062A\u0645\u064A \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u063A\u0631\u0641\u0629",
  290072: "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0639\u0645\u0644 \u0639\u0628\u0631 \u0627\u0644\u063A\u0631\u0641 \u0644\u0641\u0631\u0632 \u0645\u0642\u0627\u0637\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631\u0629. \u0644\u0627 \u062A\u0646\u062A\u0645\u064A \u0645\u0642\u0627\u0637\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631\u0629 \u0627\u0644\u062A\u064A \u064A\u062A\u0645 \u0646\u0642\u0644\u0647\u0627 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u063A\u0631\u0641\u0629",
  290073: "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0639\u0645\u0644 \u0639\u0628\u0631 \u0627\u0644\u0642\u0648\u0627\u0626\u0645 \u0644\u0641\u0631\u0632 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631. \u0644\u0627 \u062A\u062A\u0637\u0627\u0628\u0642 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631 \u0627\u0644\u0645\u062A\u062D\u0631\u0643 \u0645\u0639 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062B\u064A\u0631 \u0627\u0644\u0645\u062A\u062D\u0631\u0643",
  290074: "\u0641\u0634\u0644 \u062A\u0631\u062D\u064A\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0648\u062A\u062E\u0632\u064A\u0646\u0647\u0627",
  290075: "\u0641\u0634\u0644 \u0625\u0639\u0627\u062F\u0629 \u062A\u0631\u062A\u064A\u0628 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062A \u0636\u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0628\u0633\u0628\u0628 \u062D\u0630\u0641 \u0627\u0644\u0645\u0643\u0648\u0646",
  290076: "\u0625\u0636\u0627\u0641\u0629 \u0642\u0648\u0627\u0626\u0645 \u0645\u062E\u0635\u0635\u0629 \u064A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F. \u064A\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0642\u0648\u0627\u0626\u0645 \u0645\u062E\u0635\u0635\u0629 \u062A\u0635\u0644 \u0625\u0644\u0649%s",
  290077: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0635\u0648\u0631\u0629 \u0631\u0645\u0632 WeChat QR",
  290078: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0647\u0627\u062A\u0641 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  290079: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u0627\u062A\u0635\u0627\u0644",
  290080: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 Weibo",
  290081: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0639\u0646\u0648\u0627\u0646 FaceBook \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  290082: "\u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062D\u062F\u062F \u0628\u0647 \u0645\u0643\u062A\u0628\u0629 \u0648\u0633\u0627\u0626\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  290083: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u0645\u062D\u062F\u062F \u060C \u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u062F\u064A\u062F",
  290084: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0641\u064A \u0639\u0645\u0644\u064A\u0629 \u062A\u0639\u0648\u064A\u0636 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290085: "\u0641\u0634\u0644 \u062A\u0639\u0648\u064A\u0636 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  290086: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u062A\u0642\u0648\u0645 \u0628\u0639\u0645\u0644\u064A\u0629 \u062A\u0639\u0648\u064A\u0636 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629",
  290998: "\u0645\u0646\u0639 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u0639\u0628\u0631",
  291001: "\u0625\u0646\u0634\u0627\u0621 \u062E\u0637\u0623 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  291002: "\u062A\u062D\u062F\u064A\u062B \u062E\u0637\u0623 \u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0628\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  291003: "\u0627\u062D\u0630\u0641 \u062E\u0637\u0623 \u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0628\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  291004: "\u062A\u062D\u062F\u064A\u062B \u062E\u0637\u0623 \u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0628\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  291005: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0643\u0648\u064A\u0646 \u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u0646\u0641\u0635\u0644",
  291006: "\u0628\u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u0645\u0639\u0644\u0645\u0629 \u0643\u0645\u064A\u0629 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  291007: "\u064A\u0648\u062C\u062F \u062A\u0643\u0648\u064A\u0646 \u0628\u0627\u0644\u0641\u0639\u0644 \u0628\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u060C \u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0639\u064A\u062F \u0627\u0644\u0625\u0646\u0634\u0627\u0621",
  291008: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647 \u0644\u0625\u0636\u0627\u0641\u0629 50 \u0645\u062C\u0645\u0648\u0639\u0629",
  291101: "\u0644\u0627 \u062A\u0648\u062C\u062F \u063A\u0631\u0641\u0629 \u062C\u0645\u0627\u0639\u064A\u0629",
  291102: "\u0625\u0646\u0634\u0627\u0621 \u0645\u062C\u0645\u0648\u0639\u0629 \u062E\u0637\u0623",
  291103: "\u0627\u062D\u0630\u0641 \u0627\u0644\u062E\u0637\u0623 \u0628\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0627\u062A",
  291104: "\u062A\u062D\u062F\u064A\u062B \u062E\u0637\u0623 \u0627\u0644\u062A\u0642\u0633\u064A\u0645",
  291105: "\u062A\u062D\u062F\u064A\u062B \u062E\u0637\u0623 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u0642\u0627\u0626\u062F \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  291106: "\u062D\u0630\u0641 \u062F\u0641\u0639\u0629 \u062E\u0637\u0623 \u0628\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0627\u062A",
  291107: "\u062F\u0641\u0639\u0629 \u062A\u062D\u062F\u064A\u062B \u062E\u0637\u0623 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0642\u0627\u0626\u062F \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  291108: "\u0637\u0644\u0628 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0628\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0641\u0627\u0631\u063A",
  291109: "\u0643\u0627\u0646 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062D\u0627\u0644\u0629",
  291110: "\u0627\u0644\u0645\u0636\u064A\u0641 \u0641\u064A \u063A\u0631\u0641\u0629 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  291111: "\u0645\u0646\u0627\u0642\u0634\u0629 \u0645\u0646\u0627\u0642\u0634\u0627\u062A \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  291112: "\u063A\u064A\u0631 \u0627\u0644\u0645\u062C\u0647\u0632\u0629 \u0628\u064A\u0646 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0627\u062A",
  291113: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0637\u0644\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629 \u0641\u064A \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0627\u062A",
  291301: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0645\u0645\u062A\u0644\u0626\u0648\u0646 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  291302: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0623\u0639\u0636\u0627\u0621 \u0639\u0644\u0649 \u062F\u0641\u0639\u0627\u062A",
  291303: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u0646\u0642\u0631 \u0644\u0644\u062A\u062D\u062F\u064A\u062B \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0623\u062D\u062F\u062B \u0642\u0627\u0626\u0645\u0629",
  291304: "\u0641\u0634\u0644 \u0623\u0639\u0636\u0627\u0621 \u062A\u0647\u064A\u0626\u0629 \u0627\u0644\u062F\u0641\u0639\u0629",
  291305: "\u062D\u0630\u0641 \u062F\u0641\u0639\u0629 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u062E\u0637\u0623",
  291306: "\u0641\u0634\u0644 \u062A\u062E\u0635\u064A\u0635 \u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
  291307: "\u0627\u0644\u0623\u0639\u0636\u0627\u0621 \u0645\u0645\u062A\u0644\u0626\u0648\u0646 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  291997: "\u0627\u0644\u0645\u0646\u0627\u0642\u0634\u0629 \u0645\u062D\u0638\u0648\u0631 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0639\u0645\u0644\u064A\u0629",
  291998: "\u062A\u0631\u062F\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0633\u0631\u064A\u0639 \u062C\u062F\u064B\u0627 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  292001: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631\u064A\u0646",
  292002: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  292003: "\u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0645\u0627\u0631\u0633\u064A\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  292004: "\u062D\u0630\u0641 \u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  292005: "\u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0645\u0645\u0627\u0631\u0633 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  292006: "\u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0645\u0645\u0627\u0631\u0633 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  292007: "\u0627\u0644\u0637\u0627\u0642\u0645 \u0627\u0644\u062D\u0627\u0644\u064A \u0647\u0648 \u0628\u0627\u0644\u0641\u0639\u0644 \u0627\u0644\u0645\u062A\u062D\u062F\u062B \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
  292008: "\u0644\u0645 \u064A\u0643\u0646 \u0627\u0644\u0645\u0648\u0638\u0641\u0648\u0646 \u0627\u0644\u0623\u0635\u0644\u064A\u0648\u0646 \u0627\u0644\u0645\u062A\u062D\u062F\u062B \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
  292009: "\u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0645\u0645\u062A\u0644\u0626\u0629 \u062C\u062F\u064B\u0627 \u0628\u062D\u064A\u062B \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u064A\u0647\u0627!",
  292010: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0636\u0645\u064A\u0646\u0643 \u0641\u064A \u0645\u0646\u0627\u0642\u0634\u0629 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  292011: "\u0623\u0646\u062A \u0628\u0627\u0644\u0641\u0639\u0644 \u0641\u064A \u0645\u062C\u0645\u0648\u0639\u0629 \u0623\u062E\u0631\u0649",
  292012: "\u0641\u0634\u0644 \u0641\u064A \u062D\u0630\u0641 \u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u062F\u0641\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
  292013: "\u0644\u0627 \u064A\u0632\u0627\u0644 \u0627\u0644\u0645\u0636\u064A\u0641 \u0641\u064A \u063A\u0631\u0641\u0629 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647",
  292014: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0644\u0645\u0636\u064A\u0641 \u0623\u0646 \u064A\u0635\u0628\u062D \u0642\u0627\u0626\u062F \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
  292015: "\u0623\u0646\u062A \u0628\u0627\u0644\u0641\u0639\u0644 \u0641\u064A \u0645\u0646\u0627\u0642\u0634\u0629 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062F\u062E\u0648\u0644",
  293001: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0644\u064A\u0633\u062A \u0641\u064A \u0627\u0644\u0645\u0646\u0627\u0642\u0634\u0629",
  293002: "\u0627\u0644\u063A\u0631\u0641\u0629 \u0642\u064A\u062F \u0627\u0644\u0645\u0646\u0627\u0642\u0634\u0629",
  293003: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0645\u0648\u0639\u0629 \u0641\u064A \u0627\u0644\u0641\u0634\u0644 \u0627\u0644\u062D\u0627\u0644\u064A \u060C \u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062C\u0645\u0648\u0639\u0629 \u062D\u0627\u0644\u064A\u0627",
  293004: "\u0641\u0634\u0644 \u0627\u0644\u0628\u062F\u0621 \u060C \u064A\u0631\u062C\u0649 \u0628\u062F\u0621 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0623\u0648\u0644\u0627\u064B",
  294001: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0633\u062A\u062B\u0646\u0627\u0621 \u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631\u064A\u0646",
  294002: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  294003: "\u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0645\u0627\u0631\u0633\u064A\u0646 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  294004: "\u062D\u0630\u0641 \u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A",
  294005: "\u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0645\u0645\u0627\u0631\u0633 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  294006: "\u062A\u0643\u0648\u064A\u0646 \u0631\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0645\u0645\u0627\u0631\u0633 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  294100: "\u0644\u0642\u062F \u0648\u0635\u0644 \u0627\u0644\u0645\u0645\u0627\u0631\u0633\u0648\u0646 \u0625\u0644\u0649 \u0623\u0642\u0635\u0649 \u0642\u064A\u0645\u0629",
  295001: "\u062A\u0645\u0643\u064A\u0646 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0637\u0631\u064A\u0642\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  300001: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u062A\u062C\u0627\u0648\u0632 \u0639\u062F\u062F \u0627\u0644\u062A\u0641\u0627\u0639\u0644\u0627\u062A \u0627\u0644\u0645\u062E\u0635\u0635\u0629 100",
  300002: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0641\u0627\u0639\u0644\u064A \u0645\u0648\u062C\u0648\u062F",
  300101: "\u0641\u0634\u0644 \u062A\u0643\u0648\u064A\u0646 iFrame",
  501e3: "\u0642\u0633\u0645 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  501001: "\u0642\u0633\u0645 \u0627\u0644\u0648\u0627\u0644\u062F\u064A\u0646 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  501002: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0642\u0633\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
  501010: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0642\u0633\u0645",
  501011: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0642\u0633\u0645",
  501012: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0642\u0633\u0645",
  501013: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0643\u0631\u0627\u0631 \u0627\u0633\u0645 \u0627\u0644\u0642\u0633\u0645 \u0641\u064A \u0646\u0641\u0633 \u0627\u0644\u0645\u0633\u062A\u0648\u0649",
  501014: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u0642\u0633\u0645",
  501015: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u062D\u0627\u0644\u0629 \u0627\u0644\u0642\u0633\u0645",
  501016: "\u0644\u0627 \u064A\u0632\u0627\u0644 \u0647\u0646\u0627\u0643 \u0623\u0639\u0636\u0627\u0621 \u062A\u062D\u062A \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u060C \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0627\u0644\u0639\u0637\u0644",
  501017: "\u0644\u0627 \u062A\u0632\u0627\u0644 \u0647\u0646\u0627\u0643 \u0623\u0642\u0633\u0627\u0645 \u0641\u0631\u0639\u064A\u0629 \u0645\u0645\u0643\u0651\u0646\u0629 \u0636\u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0642\u0633\u0645 \u060C \u0648\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0628\u062A\u0639\u0637\u064A\u0644\u0647\u0627",
  501018: "\u0644\u0627 \u064A\u0632\u0627\u0644 \u0647\u0646\u0627\u0643 \u0623\u0639\u0636\u0627\u0621 \u0636\u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0639\u0642\u062F\u0629 \u060C \u0648\u0627\u0644\u062D\u0630\u0641 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645",
  502001: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0646\u0634\u0627\u0621 \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u062E\u062F\u0645\u0629 \u0627\u0644\u0645\u062A\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u0639\u0627\u0645\u0629",
  502002: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u062D\u0627\u0644\u0629 \u062A\u0643\u0648\u064A\u0646 \u062E\u062F\u0645\u0629 \u0627\u0644\u062A\u0632\u0627\u0645\u0646 \u0627\u0644\u0639\u0627\u0644\u0645\u064A\u0629",
  502003: "\u064A\u0648\u062C\u062F \u0628\u0627\u0644\u0641\u0639\u0644 \u0633\u062C\u0644 \u062A\u0641\u0639\u064A\u0644 \u0644\u0640 [\u0633\u0627\u0631\u064A \u0627\u0644\u0645\u0641\u0639\u0648\u0644] \u0623\u0648 [\u0644\u064A\u0643\u0648\u0646 \u0641\u0639\u0627\u0644\u0627\u064B] \u0636\u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0646\u0637\u0627\u0642 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0641\u0639\u0627\u0644. \u064A\u0631\u062C\u0649 \u0625\u0644\u063A\u0627\u0621 \u0633\u062C\u0644 [\u0644\u064A\u0643\u0648\u0646 \u0641\u0639\u0627\u0644\u0627\u064B] \u0623\u0648 \u062A\u063A\u064A\u064A\u0631 \u0648\u0642\u062A \u0627\u0644\u0633\u0631\u064A\u0627\u0646 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
  601001: "\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0628\u062D\u0630\u0641 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0644\u0644\u0639\u0644\u0627\u0645\u0629 -",
  601003: "\u0628\u064A\u0627\u0646\u0627\u062A \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  601004: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0639\u0644\u0627\u0645\u0629 -\u0641\u064A \u062E\u0637\u0623 \u060C \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0634\u063A\u064A\u0644\u0647\u0627 \u0623\u0648 \u0625\u063A\u0644\u0627\u0642\u0647\u0627",
  601005: "\u062A\u0645 \u0641\u062A\u062D \u0647\u0630\u0647 \u0627\u0644\u0639\u0644\u0627\u0645\u0629 -in",
  601006: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0647\u0630\u0647 \u0627\u0644\u0639\u0644\u0627\u0645\u0629 -in",
  601007: "\u064A\u0645\u0643\u0646\u0643 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u063A\u064A\u0631 \u0627\u0644\u0645\u0631\u063A\u0648\u0628 \u0641\u064A\u0647\u0627 -",
  601009: "\u0644\u0627 \u062A\u0633\u062C\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0631\u0627\u0631\u064B\u0627 \u0648\u062A\u0643\u0631\u0627\u0631\u064B\u0627",
  601011: "\u064A\u0631\u062C\u0649 \u0628\u062F\u0621 \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0623\u0648\u0644\u0627\u064B",
  601012: "\u0647\u0646\u0627\u0643 \u0639\u0644\u0627\u0645\u0629 -\u0641\u064A \u0627\u0644\u062A\u0642\u062F\u0645 \u060C \u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0637\u0644\u0642 \u0645\u0631\u0627\u0631\u064B\u0627 \u0648\u062A\u0643\u0631\u0627\u0631\u064B\u0627",
  601013: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 -in \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  601201: "\u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641 \u0641\u064A \u0648\u0627\u062C\u0647\u0629 Shumei",
  601202: "\u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629",
  601203: "\u0637\u0648\u0644 \u0627\u0644\u0643\u0644\u0645\u0629 \u0627\u0644\u062D\u0633\u0627\u0633\u0629 \u0637\u0648\u064A\u0644 \u062C\u062F\u064B\u0627",
  601204: "\u064A\u062A\u0645 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0627\u0644\u0643\u062B\u064A\u0631 \u0645\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0641\u064A \u0627\u0644\u0645\u0631\u0629 \u0627\u0644\u0648\u0627\u062D\u062F\u0629",
  601205: "\u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  601206: "\u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629 \u0627\u0644\u062A\u064A \u062A\u0645 \u0625\u0646\u0634\u0627\u0624\u0647\u0627 \u0630\u0627\u062A\u064A\u064B\u0627 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  601207: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0625\u0630\u0646 \u0644\u062A\u0628\u062F\u064A\u0644 \u0645\u062E\u0637\u0637 ai",
  601300: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0623\u0648 \u062A\u0645 \u062D\u0630\u0641\u0647\u0627",
  601301: "\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0643\u0644\u0645\u0627\u062A \u062D\u0633\u0627\u0633\u0629\u0627",
  601302: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A\u0629\u060C \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D \u0628\u0623\u064A \u0639\u0645\u0644\u064A\u0629",
  601303: "\u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u064A\u0631\u0627\u062F 1000 \u0642\u0637\u0639\u0629 \u0641\u0642\u0637 \u0645\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0641\u064A \u0627\u0644\u0645\u0631\u0629 \u0627\u0644\u0648\u0627\u062D\u062F\u0629",
  601304: "\u0637\u0648\u0644 \u0625\u0636\u0627\u0641\u064A \u0637\u0648\u064A\u0644",
  601305: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0645\u0646 1-10000",
  601306: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0645\u0646 1-300",
  601307: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0645\u0646 1 \u0625\u0644\u0649 20",
  601308: "\u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629",
  601309: "\u0645\u0646\u0638\u0645\u0629 \u0627\u0644\u0639\u0641\u0648 \u0627\u0644\u062F\u0648\u0644\u064A\u0629 \u0627\u0644\u0631\u0648\u0628\u0648\u062A \u0647\u0648 \u062A\u0641\u0639\u064A\u0644\u0647\u0627 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629",
  601310: "\u0645\u0646\u0638\u0645\u0629 \u0627\u0644\u0639\u0641\u0648 \u0627\u0644\u062F\u0648\u0644\u064A\u0629 \u0627\u0644\u0631\u0648\u0628\u0648\u062A \u0645\u063A\u0644\u0642\u0629 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629",
  601311: "\u0645\u0646\u0638\u0645\u0629 \u0627\u0644\u0639\u0641\u0648 \u0627\u0644\u062F\u0648\u0644\u064A\u0629 \u0627\u0644\u0631\u0648\u0628\u0648\u062A \u0642\u062F \u062A\u0648\u0642\u0641 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629",
  601312: "\u0645\u0646\u0638\u0645\u0629 \u0627\u0644\u0639\u0641\u0648 \u0627\u0644\u062F\u0648\u0644\u064A\u0629 \u0627\u0644\u0631\u0648\u0628\u0648\u062A \u0627\u0644\u062F\u0648\u0644\u0629 \u062E\u0637\u0623 \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629",
  601313: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0634\u063A\u064A\u0644 \u0645\u062F\u064A\u0631 \u0627\u0644\u062C\u0648 \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A \u0641\u064A \u062D\u0627\u0644\u0629 \u0639\u062F\u0645 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  601314: "\u0643\u0646\u064A\u0629 \u0627\u0644\u0645\u0643\u062A\u0628\u0629 \u062D\u0627\u0644\u064A\u0627 \u0641\u064A \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 . \u0636\u0628\u0637 \u0627\u064A \u0627\u062A\u064A\u0646\u062F\u064A\u0631 \u0631\u0648\u0628\u0648\u062A \u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0623\u0648 \u0625\u0646\u0647\u0627\u0621 \u0627\u064A \u0627\u062A\u064A\u0646\u062F\u064A\u0631 \u0631\u0648\u0628\u0648\u062A \u060C \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  601315: "\u063A\u0631\u0641\u0629 \u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0645\u0643\u062A\u0628\u0629 \u062D\u0627\u0644\u064A\u0627 \u0641\u064A \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 . \u0636\u0628\u0637 \u0627\u064A \u0627\u062A\u064A\u0646\u062F\u064A\u0631 \u0631\u0648\u0628\u0648\u062A \u0627\u0644\u062A\u0643\u0648\u064A\u0646 \u0623\u0648 \u0625\u0646\u0647\u0627\u0621 \u0627\u064A \u0627\u062A\u064A\u0646\u062F\u064A\u0631 \u0631\u0648\u0628\u0648\u062A \u060C \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  601316: "\u0645\u0646 \u0641\u0636\u0644\u0643 \u062A\u0648\u0642\u0641 \u0627\u064A \u0631\u0648\u0628\u0648\u062A",
  601317: "\u064A\u0645\u0643\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 10 \u0645\u0643\u062A\u0628\u0627\u062A \u0627\u0644\u0623\u0633\u0645\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u0639\u0627\u0631\u0629",
  601318: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u062D\u062C\u0645 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0642\u062F \u062A\u0645 \u0627\u0644\u062A\u0648\u0635\u0644 \u0625\u0644\u064A\u0647",
  601319: "\u064A\u0645\u0643\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 20 \u0645\u0643\u062A\u0628\u0627\u062A \u0627\u0644\u0646\u0635\u064A",
  601320: "\u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0633\u062C\u0644 \u0648\u0627\u062D\u062F \u064A\u062C\u0628 \u0623\u0646 \u062A\u0628\u0642\u0649 \u0641\u064A \u0643\u0646\u064A\u0629 \u0627\u0644\u0645\u0643\u062A\u0628\u0629 . \u0625\u0630\u0627 \u0643\u0646\u062A \u0628\u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u062D\u0630\u0641 \u062C\u0645\u064A\u0639 \u0627\u0644\u0633\u062C\u0644\u0627\u062A \u060C \u0641\u0645\u0646 \u0627\u0644\u0645\u0633\u062A\u062D\u0633\u0646 \u0623\u0646 \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0643\u062A\u0628\u0629 \u0627\u0644\u0623\u0633\u0645\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u0639\u0627\u0631\u0629 \u062D\u0630\u0641",
  601321: "\u0633\u062C\u0644 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u064A\u062C\u0628 \u0623\u0646 \u062A\u0628\u0642\u0649 \u0641\u064A \u063A\u0631\u0641\u0629 \u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0645\u0643\u062A\u0628\u0629 . \u0625\u0630\u0627 \u0643\u0646\u062A \u0641\u064A \u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u062D\u0630\u0641 \u062C\u0645\u064A\u0639 \u0627\u0644\u0633\u062C\u0644\u0627\u062A \u060C \u0641\u0645\u0646 \u0627\u0644\u0645\u0633\u062A\u062D\u0633\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0643\u062A\u0628\u0629 \u0646\u0635\u064A\u0629 \u062D\u0630\u0641 \u0648\u0638\u064A\u0641\u0629",
  601322: "\u0639\u0645\u0644\u064A\u0627\u062A \u0645\u062A\u0643\u0631\u0631\u0629",
  601323: "\u0639\u062F\u062F \u0645\u0646 \u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0646\u0638\u0645\u0629 \u0627\u0644\u0639\u0641\u0648 \u0627\u0644\u062F\u0648\u0644\u064A\u0629 \u0627\u0644\u0631\u0648\u0628\u0648\u062A\u0627\u062A \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0623\u0633\u0645\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u0639\u0627\u0631\u0629 \u0641\u064A \u0643\u0646\u064A\u0629 \u0627\u0644\u0645\u0643\u062A\u0628\u0629 .",
  602001: "\u062A\u0645\u064A\u0632 \u0627\u0644\u0643\u0645\u064A\u0629 \u0627\u0644\u062A\u0641\u0627\u0639\u0644\u064A\u0629",
  602002: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0631\u062F \u0627\u0644\u0645\u0648\u0636\u0648\u0639 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u0631\u062F \u0639\u0644\u064A\u0647",
  602003: "\u0639\u062F\u0645 \u0641\u062A\u062D \u0627\u0644\u0645\u0648\u0636\u0648\u0639 \u0645\u062B\u0644",
  602004: "\u0644\u0627 \u0631\u062F \u0639\u0644\u0649 \u0627\u0644\u0631\u062F \u0639\u0644\u0649 \u0645\u062B\u0644",
  602005: "\u0644\u0627 \u062D\u0627\u062C\u0629 \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
  602006: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  602007: "\u0647\u0646\u0627\u0643 \u0643\u0644\u0645\u0627\u062A \u062D\u0633\u0627\u0633\u0629 \u0641\u064A \u0627\u0644\u062F\u0631\u062F\u0634\u0629\u060C\u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  602008: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0634\u063A\u064A\u0644 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0645\u0648\u0636\u0648\u0639",
  602009: "\u0628\u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u062D\u0631\u0645\u0629 \u060C \u0644\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0641\u064A \u062A\u0641\u0627\u0639\u0644 \u0627\u0644\u0645\u0648\u0636\u0648\u0639",
  602010: "\u0623\u0646\u062A \u062A\u0639\u062C\u0628\u0643 \u0628\u0627\u0644\u0641\u0639\u0644",
  602011: "\u0644\u0627 \u064A\u0632\u0627\u0644 \u064A\u062A\u0645 \u062A\u0645\u0631\u064A\u0631 \u0627\u0644\u0631\u062F \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
  602012: "\u062A\u0645 \u062A\u0635\u062F\u0631 \u0627\u0644\u0645\u0648\u0636\u0648\u0639",
  602013: "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0648\u0636\u0648\u0639",
  602014: "\u062A\u0645\u062A \u0645\u0631\u0627\u062C\u0639\u0629 \u0647\u0630\u0627 \u0627\u0644\u0631\u062F \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  602015: "\u062A\u0645 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0631\u062F \u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  603001: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0627 \u064A\u0635\u0644 \u0625\u0644\u0649 10 \u0645\u0644\u0635\u0642\u0627\u062A",
  603002: "\u0641\u0634\u0644 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  603003: "\u0641\u0634\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0644\u0635\u0642\u0627\u062A",
  603004: "\u062E\u0637\u0623 \u0645\u0637\u0627\u0628\u0642\u0629 \u0627\u0644\u063A\u0631\u0641\u0629",
  603005: "\u062E\u0637\u0623 \u0645\u0637\u0627\u0628\u0642\u0629 \u0627\u0644\u062D\u062F\u062B",
  603006: "\u0641\u0634\u0644 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0635\u0642\u0627\u062A",
  603007: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0644\u0635\u0642\u0627\u062A",
  603008: "\u064A\u0631\u062C\u0649 \u062A\u0634\u063A\u064A\u0644 \u0645\u0641\u062A\u0627\u062D \u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0645\u0644\u0635\u0642\u0627\u062A \u0623\u0648\u0644\u0627\u064B",
  603009: "\u062A\u0643\u0648\u064A\u0646 \u0645\u0634\u0627\u0631\u0643\u0629 \u0644\u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0625\u0646\u0634\u0627\u0621",
  604001: "\u0623\u063A\u0644\u0642\u062A \u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  604002: "\u062A\u0645 \u062A\u0635\u062F\u0631 \u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  604003: "\u0644\u0645 \u064A\u062A\u0645 \u0628\u0639\u062F \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0628\u0639\u062F",
  604004: "\u062A\u0645\u062A \u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  604005: "\u0644\u0627 \u062D\u0627\u062C\u0629 \u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  604006: "\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  604007: "\u062F\u0631\u062F\u0634\u0629 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646",
  604008: "\u062E\u0637\u0623 \u0641\u064A \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  604009: "\u062A\u0635\u0644\u064A\u0642 \u062D\u062A\u0649 10 \u0631\u0633\u0627\u0626\u0644",
  604010: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0643\u0648\u0646 \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0641\u0627\u0631\u063A\u0629",
  604011: "\u0644\u0645 \u062A\u062A\u0645 \u0645\u0631\u0627\u062C\u0639\u0629 \u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0628\u0639\u062F",
  605e3: "\u0645\u0639\u0627\u0645\u0644 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A",
  605001: "\u0641\u0634\u0644 \u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u0639\u0646 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  605002: "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  605003: "\u0641\u0634\u0644 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  605004: "\u0641\u0634\u0644 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0625\u0644\u0649 \u0630\u0627\u0643\u0631\u0629 \u0627\u0644\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0624\u0642\u062A",
  605005: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  605006: "\u0641\u0634\u0644\u062A \u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
  605007: "\u0641\u0634\u0644\u062A \u0645\u0639\u0627\u0644\u062C\u0629 \u062A\u0633\u062C\u064A\u0644 \u062E\u0631\u0648\u062C \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  605008: "\u0641\u0634\u0644 \u0641\u064A \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A \u062A\u062C\u0645\u0639 \u0627\u0644\u062C\u0648\u0627\u0626\u0632",
  605101: "\u0641\u0634\u0644 \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u0623\u0645\u0631",
  605102: "\u0641\u0634\u0644 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0623\u0645\u0631",
  606e3: "\u0627\u0644\u0633\u062D\u0628 \u0627\u0644\u0645\u062D\u0638\u0648\u0638 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  606001: "\u0627\u0633\u0645 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644",
  606002: "\u0639\u062F\u062F \u062C\u0648\u0627\u0626\u0632 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u064A\u0635\u0644 \u0625\u0644\u0649 20",
  606003: "\u0627\u0644\u062C\u0627\u0626\u0632\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  606004: "\u0644\u0627 \u064A\u0648\u062C\u062F \u064A\u0627\u0646\u0635\u064A\u0628 \u0645\u0633\u062A\u0645\u0631",
  606005: "\u062A\u0645 \u0645\u0646\u062D \u0627\u0644\u062C\u0627\u0626\u0632\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u062D\u0631\u064A\u0631\u0647\u0627",
  606006: "\u062A\u0645 \u0645\u0646\u062D \u0627\u0644\u062C\u0627\u0626\u0632\u0629 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641\u0647\u0627",
  606007: "\u0641\u064A \u064A\u0627\u0646\u0635\u064A\u0628 \u0627\u0644\u062C\u0627\u0626\u0632\u0629 \u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u063A\u0644\u0627\u0642\u0647 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u062D\u0627\u0644\u064A",
  606008: "\u0627\u0644\u062C\u0648\u0627\u0626\u0632 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629",
  606009: "\u062C\u0648\u0627\u0626\u0632 \u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627",
  606010: "\u0627\u0644\u062C\u0627\u0626\u0632\u0629 \u0644\u062F\u064A\u0647\u0627 \u064A\u0627\u0646\u0635\u064A\u0628",
  606011: "\u0634\u0627\u0631\u0643 \u0627\u0644\u0633\u062D\u0628 \u0627\u0644\u062D\u0627\u0644\u064A \u060C \u0645\u0646 \u0641\u0636\u0644\u0643 \u0644\u0627 \u062A\u0633\u062C\u0644 \u0645\u0631\u0627\u0631\u064B\u0627 \u0648\u062A\u0643\u0631\u0627\u0631\u064B\u0627",
  606013: "\u0644\u0627 \u064A\u062A\u0645 \u0641\u062A\u062D \u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0641\u0648\u0632 \u0627\u0644\u0623\u0648\u0644\u0648\u064A\u0629",
  606014: "\u0647\u0630\u0627 \u0627\u0644\u0633\u062D\u0628 \u0644\u0627 \u064A\u0633\u0645\u062D \u0628\u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0628\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629",
  606015: "\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u064A\u0646 \u0641\u064A \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u064A\u0646",
  606016: "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0643\u0648\u0646 \u0639\u062F\u062F \u0627\u0644\u0641\u0627\u0626\u0632\u064A\u0646 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0639\u062F\u062F \u0627\u0644\u062C\u0648\u0627\u0626\u0632",
  606017: "\u062E\u0637\u0623 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
  606018: "\u0627\u0644\u0633\u062D\u0628 \u063A\u064A\u0631 \u0645\u0639\u0627\u0644\u062C \u0641\u064A \u063A\u0636\u0648\u0646 30 \u064A\u0648\u0645\u064B\u0627 \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0645\u0646\u062D\u0647.",
  606019: "\u0643\u0644\u0645\u0627\u062A \u062D\u0633\u0627\u0633\u0629",
  606020: "\u0627\u0644\u062D\u0631\u0641 \u0637\u0648\u064A\u0644 \u0644\u0644\u063A\u0627\u064A\u0629",
  606021: "\u064A\u062A\u064A\u062D \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628 \u063A\u064A\u0631 \u0627\u0644\u0645\u0631\u063A\u0648\u0628 \u0641\u064A\u0647 \u0641\u0642\u0637 \u0627\u0644\u062D\u0630\u0641",
  606022: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0631\u0633\u0645 \u063A\u064A\u0631 \u0637\u0628\u064A\u0639\u064A\u0629",
  606023: "\u062A\u0645 \u0641\u062A\u062D \u0627\u0644\u0633\u062D\u0628",
  606024: "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  606025: "\u064A\u0645\u0643\u0646 \u0641\u062A\u062D \u062C\u0627\u0626\u0632\u0629 \u0648\u0627\u062D\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0644\u0628\u062F\u0621 \u064A\u0627\u0646\u0635\u064A\u0628",
  606026: "\u0627\u0644\u062C\u0645\u0647\u0648\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  606027: "\u0627\u0644\u0646\u0645\u0648\u0630\u062C \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  606028: "\u062A\u0645 \u062D\u0630\u0641 \u0627\u0644\u062C\u0645\u0647\u0648\u0631",
  606030: "\u0644\u0645 \u064A\u062A\u0645 \u0641\u062A\u062D \u0627\u0644\u064A\u0627\u0646\u0635\u064A\u0628",
  606031: "\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u063A\u064A\u0631 \u0645\u0641\u062A\u0648\u062D",
  607001: "\u0627\u0644\u0645\u0639\u0644\u0645\u0627\u062A \u063A\u064A\u0631 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629",
  607002: "\u062A\u0631\u062A\u064A\u0628 \u0645\u0646\u0641\u0630 \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0643\u0644\u0645\u0627\u062A \u062D\u0633\u0627\u0633\u0629",
  607003: "\u062E\u0637\u0623 \u0641\u064A \u062A\u0631\u062A\u064A\u0628 \u0645\u0646\u0641\u0630 \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631",
  607004: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0638\u0631\u0641 \u0627\u0644\u0623\u062D\u0645\u0631",
  607005: "\u064A\u0631\u062C\u0649 \u062A\u0643\u0648\u064A\u0646 \u062D\u0633\u0627\u0628 WeChat \u0627\u0644\u0639\u0627\u0645 \u0648\u0627\u0644\u0645\u0648\u0627\u0642\u0639 \u0623\u0648\u0644\u0627\u064B",
  607006: "\u0627\u0644\u0638\u0631\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  607007: "\u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
  607008: "\u062A\u0645 \u0627\u0644\u0627\u0633\u062A\u064A\u0644\u0627\u0621 \u0639\u0644\u0649 \u0627\u0644\u0638\u0631\u0641 \u0627\u0644\u0623\u062D\u0645\u0631",
  607010: "\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0642\u0644 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u0644\u0644\u0623\u0638\u0631\u0641 \u0627\u0644\u062D\u0645\u0631",
  607013: "\u062A\u0645 \u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0638\u0631\u0641 \u0627\u0644\u0623\u062D\u0645\u0631",
  607014: "\u0633\u062C\u0644 \u0627\u0644\u0645\u063A\u0644\u0641 \u0627\u0644\u0623\u062D\u0645\u0631 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  607015: "\u0644\u0645 \u064A\u062A\u0644\u0642 \u0627\u0644\u062C\u0645\u0647\u0648\u0631 \u0645\u0638\u0627\u0631\u064A\u0641 \u062D\u0645\u0631\u0627\u0621 \u0641\u064A \u063A\u0636\u0648\u0646 24 \u0633\u0627\u0639\u0629",
  608001: "\u0647\u0646\u0627\u0643 \u0645\u0624\u0642\u062A \u0642\u064A\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0628\u0627\u0644\u0641\u0639\u0644\u060C \u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0628\u062F\u0621 \u0645\u0624\u0642\u062A \u0622\u062E\u0631.",
  608002: "\u0645\u0643\u062A\u0645\u0644",
  608003: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0624\u0642\u062A \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645",
  2800003: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0645\u0642\u0627\u0635\u0629",
  2800004: "\u0641\u0634\u0644 \u062D\u0630\u0641 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
  2800005: "\u0646\u0628\u0636\u0627\u062A \u0642\u0644\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  2800006: "\u0641\u0634\u0644 \u062A\u062D\u062F\u064A\u062B \u062D\u0627\u0644\u0629 \u0627\u0644\u062A\u0633\u0648\u064A\u0629"
}, ar = {
  httpErrorCode
};
let mounted = !1;
function i18nInit() {
  return Me(this, null, function* () {
    if (mounted)
      return;
    const e = {
      en,
      ["zh-Hans"]: zh_Hans,
      ["zh-Hant"]: zh_Hant,
      ar
    };
    instance.init({
      fallbackLng: "zh-Hans",
      resources: e,
      interpolation: {
        escapeValue: !1
      }
    }), mounted = !0;
  });
}
function statusClass(e) {
  return e >= 500 ? "5xx" : String(e);
}
const ERROR_CODE_NAMESPACE = "httpErrorCode";
function getI18nHttpErrorMessageByErrorCode(e, T) {
  const F = instance.t(`${ERROR_CODE_NAMESPACE}:${e != null ? e : 100016}`);
  return printf(F, T != null ? T : []);
}
function printf(e, T) {
  let F = 0;
  return e.replace(/%[s]/g, function() {
    const $ = T[F++];
    return String($ != null ? $ : "");
  });
}
function setEncodeAndDecode() {
  if (window.TextEncoder !== void 0)
    return;
  function e() {
  }
  e.prototype.encode = function(F) {
    var $ = unescape(encodeURIComponent(F)).split("").map(function(J) {
      return J.charCodeAt(0);
    });
    return $.byteLength = $.length, $;
  };
  function T() {
  }
  T.prototype.decode = function(F) {
    return decodeURIComponent(escape(String.fromCharCode.apply(null, F)));
  }, window.TextEncoder = e, window.TextDecoder = T;
}
var events = { exports: {} }, R = typeof Reflect == "object" ? Reflect : null, ReflectApply = R && typeof R.apply == "function" ? R.apply : function e(T, F, $) {
  return Function.prototype.apply.call(T, F, $);
}, ReflectOwnKeys;
R && typeof R.ownKeys == "function" ? ReflectOwnKeys = R.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(T) {
  return Object.getOwnPropertyNames(T).concat(Object.getOwnPropertySymbols(T));
} : ReflectOwnKeys = function(T) {
  return Object.getOwnPropertyNames(T);
};
function ProcessEmitWarning(e) {
  console && console.warn && console.warn(e);
}
var NumberIsNaN = Number.isNaN || function e(T) {
  return T !== T;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once;
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = void 0;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || NumberIsNaN(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    defaultMaxListeners = e;
  }
});
EventEmitter.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter.prototype.setMaxListeners = function e(T) {
  if (typeof T != "number" || T < 0 || NumberIsNaN(T))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + T + ".");
  return this._maxListeners = T, this;
};
function _getMaxListeners(e) {
  return e._maxListeners === void 0 ? EventEmitter.defaultMaxListeners : e._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function e() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function e(T) {
  for (var F = [], $ = 1; $ < arguments.length; $++)
    F.push(arguments[$]);
  var J = T === "error", ee = this._events;
  if (ee !== void 0)
    J = J && ee.error === void 0;
  else if (!J)
    return !1;
  if (J) {
    var ne;
    if (F.length > 0 && (ne = F[0]), ne instanceof Error)
      throw ne;
    var oe = new Error("Unhandled error." + (ne ? " (" + ne.message + ")" : ""));
    throw oe.context = ne, oe;
  }
  var se = ee[T];
  if (se === void 0)
    return !1;
  if (typeof se == "function")
    ReflectApply(se, this, F);
  else
    for (var le = se.length, de = arrayClone(se, le), $ = 0; $ < le; ++$)
      ReflectApply(de[$], this, F);
  return !0;
};
function _addListener(e, T, F, $) {
  var J, ee, ne;
  if (checkListener(F), ee = e._events, ee === void 0 ? (ee = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (ee.newListener !== void 0 && (e.emit(
    "newListener",
    T,
    F.listener ? F.listener : F
  ), ee = e._events), ne = ee[T]), ne === void 0)
    ne = ee[T] = F, ++e._eventsCount;
  else if (typeof ne == "function" ? ne = ee[T] = $ ? [F, ne] : [ne, F] : $ ? ne.unshift(F) : ne.push(F), J = _getMaxListeners(e), J > 0 && ne.length > J && !ne.warned) {
    ne.warned = !0;
    var oe = new Error("Possible EventEmitter memory leak detected. " + ne.length + " " + String(T) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    oe.name = "MaxListenersExceededWarning", oe.emitter = e, oe.type = T, oe.count = ne.length, ProcessEmitWarning(oe);
  }
  return e;
}
EventEmitter.prototype.addListener = function e(T, F) {
  return _addListener(this, T, F, !1);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function e(T, F) {
  return _addListener(this, T, F, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(e, T, F) {
  var $ = { fired: !1, wrapFn: void 0, target: e, type: T, listener: F }, J = onceWrapper.bind($);
  return J.listener = F, $.wrapFn = J, J;
}
EventEmitter.prototype.once = function e(T, F) {
  return checkListener(F), this.on(T, _onceWrap(this, T, F)), this;
};
EventEmitter.prototype.prependOnceListener = function e(T, F) {
  return checkListener(F), this.prependListener(T, _onceWrap(this, T, F)), this;
};
EventEmitter.prototype.removeListener = function e(T, F) {
  var $, J, ee, ne, oe;
  if (checkListener(F), J = this._events, J === void 0)
    return this;
  if ($ = J[T], $ === void 0)
    return this;
  if ($ === F || $.listener === F)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete J[T], J.removeListener && this.emit("removeListener", T, $.listener || F));
  else if (typeof $ != "function") {
    for (ee = -1, ne = $.length - 1; ne >= 0; ne--)
      if ($[ne] === F || $[ne].listener === F) {
        oe = $[ne].listener, ee = ne;
        break;
      }
    if (ee < 0)
      return this;
    ee === 0 ? $.shift() : spliceOne($, ee), $.length === 1 && (J[T] = $[0]), J.removeListener !== void 0 && this.emit("removeListener", T, oe || F);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function e(T) {
  var F, $, J;
  if ($ = this._events, $ === void 0)
    return this;
  if ($.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : $[T] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete $[T]), this;
  if (arguments.length === 0) {
    var ee = Object.keys($), ne;
    for (J = 0; J < ee.length; ++J)
      ne = ee[J], ne !== "removeListener" && this.removeAllListeners(ne);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (F = $[T], typeof F == "function")
    this.removeListener(T, F);
  else if (F !== void 0)
    for (J = F.length - 1; J >= 0; J--)
      this.removeListener(T, F[J]);
  return this;
};
function _listeners(e, T, F) {
  var $ = e._events;
  if ($ === void 0)
    return [];
  var J = $[T];
  return J === void 0 ? [] : typeof J == "function" ? F ? [J.listener || J] : [J] : F ? unwrapListeners(J) : arrayClone(J, J.length);
}
EventEmitter.prototype.listeners = function e(T) {
  return _listeners(this, T, !0);
};
EventEmitter.prototype.rawListeners = function e(T) {
  return _listeners(this, T, !1);
};
EventEmitter.listenerCount = function(e, T) {
  return typeof e.listenerCount == "function" ? e.listenerCount(T) : listenerCount.call(e, T);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(e) {
  var T = this._events;
  if (T !== void 0) {
    var F = T[e];
    if (typeof F == "function")
      return 1;
    if (F !== void 0)
      return F.length;
  }
  return 0;
}
EventEmitter.prototype.eventNames = function e() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(e, T) {
  for (var F = new Array(T), $ = 0; $ < T; ++$)
    F[$] = e[$];
  return F;
}
function spliceOne(e, T) {
  for (; T + 1 < e.length; T++)
    e[T] = e[T + 1];
  e.pop();
}
function unwrapListeners(e) {
  for (var T = new Array(e.length), F = 0; F < T.length; ++F)
    T[F] = e[F].listener || e[F];
  return T;
}
function once(e, T) {
  return new Promise(function(F, $) {
    function J(ne) {
      e.removeListener(T, ee), $(ne);
    }
    function ee() {
      typeof e.removeListener == "function" && e.removeListener("error", J), F([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(e, T, ee, { once: !0 }), T !== "error" && addErrorHandlerIfEventEmitter(e, J, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(e, T, F) {
  typeof e.on == "function" && eventTargetAgnosticAddListener(e, "error", T, F);
}
function eventTargetAgnosticAddListener(e, T, F, $) {
  if (typeof e.on == "function")
    $.once ? e.once(T, F) : e.on(T, F);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(T, function J(ee) {
      $.once && e.removeEventListener(T, J), F(ee);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
let enable = !1;
function disableLog() {
  enable = !1;
}
function log(...e) {
  enable && console.log(e);
}
var __defProp$H = Object.defineProperty, __defNormalProp$H = (e, T, F) => T in e ? __defProp$H(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$H = (e, T, F) => (__defNormalProp$H(e, typeof T != "symbol" ? T + "" : T, F), F);
const rawHeaderLen = 16, packetOffset = 0, headerOffset = 4, verOffset = 6, opOffset = 8, seqOffset = 12;
let heartbeatInterval = 0;
setEncodeAndDecode();
const textDecoder = new window.TextDecoder(), textEncoder = new window.TextEncoder();
class WebsocketNets extends events.exports.EventEmitter {
  constructor(T) {
    super(), __publicField$H(this, "ws"), __publicField$H(this, "MAX_CONNECT_TIMES", 10), __publicField$H(this, "DELAY", 15e3), __publicField$H(this, "options"), this.options = T, T.max_connect_times && (this.MAX_CONNECT_TIMES = T.max_connect_times), T.delay && (this.DELAY = T.delay), this.createConnect(this.MAX_CONNECT_TIMES, this.DELAY);
  }
  createConnect(T, F) {
    if (T <= 0) {
      this.destroy();
      return;
    }
    this.connect();
  }
  connect() {
    const T = this, F = new WebSocket(this.options.servers);
    this.ws = F, F.binaryType = "arraybuffer", F.onopen = function() {
      T.auth({
        access_token: T.options.access_token,
        room_id: T.options.room_id,
        events: T.options.events,
        extra: T.options.extra,
        platform: T.options.platform || "uni",
        name: T.options.name || "",
        avatar: T.options.avatar || ""
      });
    }, F.onmessage = function($) {
      const J = $.data, ee = new DataView(J, 0), ne = ee.getInt32(packetOffset), oe = ee.getInt16(headerOffset), se = ee.getInt16(verOffset), le = ee.getInt32(opOffset), de = ee.getInt32(seqOffset);
      switch (log("receiveMsgHeader: packetLen=" + ne, "headerLen=" + oe, "ver=" + se, "op=" + le, "seq=" + de), le) {
        case 8:
          log("add room success"), T.heartbeat(), heartbeatInterval = window.setInterval(() => {
            T.heartbeat();
          }, 30 * 1e3), T.setListener(), T.emit("connect");
          break;
        case 3:
          log("receive: heartbeat");
          break;
        case 13:
          log("change room success");
          break;
        case 9:
          let ce;
          for (let ve = rawHeaderLen; ve < J.byteLength; ve += ce) {
            ce = ee.getInt32(ve);
            const ge = ee.getInt16(ve + headerOffset), be = ee.getInt16(ve + verOffset), Te = ee.getInt32(ve + seqOffset), Se = textDecoder.decode(J.slice(ve + ge, ve + ce));
            log("receive message", "msg_ver=" + be, "msg_seq=" + Te), log("message=" + Se), T.messageReceived(Se);
          }
          break;
        default:
          const he = textDecoder.decode(J.slice(oe, ne));
          log(he);
          break;
      }
    }, F.onclose = function() {
      log("close"), T.clearHeartbeatInterval(), setTimeout(() => {
        T.reConnect();
      }, 0);
    }, F.onerror = function() {
      log("error");
      try {
        T.reConnect();
      } catch ($) {
        log($);
      }
    };
  }
  clearHeartbeatInterval() {
    heartbeatInterval && (clearInterval(heartbeatInterval), heartbeatInterval = 0);
  }
  sendMessage(T) {
    try {
      const F = this.setArrayBuffer(T);
      this.ws.send(F);
    } catch (F) {
      log(F), this.reConnect();
    }
  }
  auth(T) {
    const $ = {
      ver: 1,
      op: 7,
      seq: 3,
      msg: JSON.stringify({
        access_token: T.access_token,
        room_id: T.room_id,
        events: T.events,
        extra: JSON.stringify(T.extra),
        platform: T.platform,
        name: T.name,
        avatar: T.avatar
      })
    };
    this.sendMessage($);
  }
  heartbeat() {
    const T = {
      ver: 1,
      op: 2,
      seq: 1
    };
    this.sendMessage(T), log("send: heartbeat");
  }
  reConnect() {
    log("reconnect"), this.createConnect(--this.MAX_CONNECT_TIMES, this.DELAY);
  }
  changeRoom(T) {
    log("change room");
    const F = {
      ver: 1,
      op: 12,
      seq: 4,
      msg: T
    };
    this.sendMessage(F);
  }
  destroy() {
    this.clearHeartbeatInterval(), this.ws && (this.ws.close(), this.ws.onmessage = null, this.ws.onopen = null, this.ws.onclose = null), delete this.ws;
  }
  messageReceived(T) {
    this.emit("receiveMsg", T);
  }
  setArrayBuffer(T) {
    const { ver: F, op: $, seq: J, msg: ee } = T, ne = new ArrayBuffer(rawHeaderLen), oe = new DataView(ne, 0);
    log("headerBuf", ne);
    let se = 0, le = null;
    return ee && (le = textEncoder.encode(ee), se = le.byteLength), oe.setInt32(packetOffset, rawHeaderLen + se), oe.setInt16(headerOffset, rawHeaderLen), oe.setInt16(verOffset, F), oe.setInt32(opOffset, $), oe.setInt32(seqOffset, J), ee ? this.mergeArrayBuffer(ne, le) : ne;
  }
  mergeArrayBuffer(T, F) {
    const $ = new Uint8Array(T), J = new Uint8Array(F);
    let ee = new Uint8Array(T.byteLength + F.byteLength);
    return ee.set($, 0), ee.set(J, T.byteLength), ee.buffer;
  }
  char2ab(T) {
    let F = new ArrayBuffer(T.length), $ = new Uint8Array(F);
    for (let J = 0; J < T.length; J++)
      $[J] = T[J];
    return F;
  }
  setListener() {
    this.on("publish", (T) => {
      this.sendMessage(T);
    }), this.on("subscribe", (T) => {
      this.sendMessage({ ver: 1, op: 14, seq: 5, msg: T });
    }), this.on("unsubscribe", (T) => {
      this.sendMessage({ ver: 1, op: 16, seq: 6, msg: T });
    }), this.on("destroy", () => {
      this.destroy();
    });
  }
}
var __defProp$G = Object.defineProperty, __defNormalProp$G = (e, T, F) => T in e ? __defProp$G(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$G = (e, T, F) => (__defNormalProp$G(e, typeof T != "symbol" ? T + "" : T, F), F);
class Client {
  constructor(T, F) {
    __publicField$G(this, "options"), __publicField$G(this, "subEvents"), __publicField$G(this, "websocketNets"), this.options = T, this.subEvents = /* @__PURE__ */ new Map(), this.subEvents.clear(), this.websocketNets = new WebsocketNets(T), this.listen(F);
  }
  subscribeNotify(T, F) {
    this.subEvents.get(T) ? this.subEvents.get(T).push(F) : (this.subEvents.set(T, [F]), this.websocketNets.emit("subscribe", T));
  }
  unSubscribeNotify(T) {
    this.subEvents.delete(T), this.websocketNets.emit("unsubscribe", T);
  }
  destroy() {
    this.websocketNets.emit("destroy"), this.subEvents.clear(), this.websocketNets = null;
  }
  publish(T) {
    this.websocketNets.emit("publish", T);
  }
  listen(T) {
    this.websocketNets.on("receiveMsg", (F) => {
      const $ = JSON.parse(F), { event: J } = $;
      this.subEvents.forEach((ee, ne) => {
        if (J === ne)
          for (let oe = 0; oe < ee.length; oe++)
            ee[oe](F);
      });
    }), this.websocketNets.on("connect", () => {
      T && T();
    });
  }
}
const connectWs = function(e) {
  return new Client(e);
};
var __defProp$F = Object.defineProperty, __defNormalProp$F = (e, T, F) => T in e ? __defProp$F(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$F = (e, T, F) => (__defNormalProp$F(e, typeof T != "symbol" ? T + "" : T, F), F);
disableLog();
class GoimNats {
  constructor() {
    __publicField$F(this, "opts", {
      accessToken: "",
      roomId: "",
      events: [],
      pageSession: "",
      pageType: "",
      platform: "",
      promotionChannelId: ""
    }), __publicField$F(this, "nc", null);
  }
  connectWebsocket(T) {
    this.nc = connectWs({
      servers: T,
      access_token: this.opts.accessToken,
      room_id: this.opts.roomId,
      events: this.opts.events,
      extra: {
        pageSession: this.opts.pageSession,
        pageType: this.opts.pageType,
        promotionChannelId: this.opts.promotionChannelId
      },
      platform: this.opts.platform
    });
  }
  subscribe(T, F) {
    return this.nc.subscribeNotify(String(T), ($) => {
      const { content: J } = JSON.parse($);
      F(J);
    });
  }
  close() {
    this.nc.destroy();
  }
  listen(T) {
    T();
  }
  unsubscribe(T) {
    this.nc.unsubscribe(T);
  }
  getTopic(T) {
    return T;
  }
  connect(T, F) {
    return this.opts = F, new Observable(($) => {
      this.connectWebsocket(T), this.listen(() => {
        const J = {}, ee = {
          from: (ne) => {
            if (J[ne])
              return J[ne];
            const oe = new Subject();
            this.subscribe(this.getTopic(ne), (le) => oe.next(le));
            const se = oe.pipe(
              finalize(() => {
                this.unsubscribe(this.getTopic(ne)), J[ne] = null;
              }),
              share()
            );
            return J[ne] = se, se;
          },
          close: () => {
            this.close();
          }
        };
        $.next(ee), $.complete();
      });
    });
  }
}
var Topics = /* @__PURE__ */ ((e) => (e[e.BOARD_STREAMSTATUS = 20201] = "BOARD_STREAMSTATUS", e[e.WATCH_LIVESTATUS = 20005] = "WATCH_LIVESTATUS", e[e.WATCH_PUSHLIVESTATUS = 20015] = "WATCH_PUSHLIVESTATUS", e[e.ROOM_LAYOUT = 20205] = "ROOM_LAYOUT", e[e.ROOM_CONFIG = 20107] = "ROOM_CONFIG", e[e.MESSAGE_UPDATE = 20105] = "MESSAGE_UPDATE", e[e.MESSAGE_USER_CONFIG = 20106] = "MESSAGE_USER_CONFIG", e[e.WATCH_DOCUMENTSTATUS = 20202] = "WATCH_DOCUMENTSTATUS", e[e.WATCH_DOWNLOADFLAG = 20203] = "WATCH_DOWNLOADFLAG", e[e.CONNECTION_STATUS_CHANGE = 20100] = "CONNECTION_STATUS_CHANGE", e[e.LINK_SETTINGS_CHANGE = 20012] = "LINK_SETTINGS_CHANGE", e[e.WATCH_SCHEDULESTART = 20016] = "WATCH_SCHEDULESTART", e[e.WATCH_EVALUATIONFLAG = 20017] = "WATCH_EVALUATIONFLAG", e[e.ANNOUNCEMENT = 20108] = "ANNOUNCEMENT", e[e.REDPACKET_ARRIVAL_STATUS = 20114] = "REDPACKET_ARRIVAL_STATUS", e[e.WATCH_BAN_STATUS = 20104] = "WATCH_BAN_STATUS", e[e.WATCH_CALL_STATUS = 20206] = "WATCH_CALL_STATUS", e[e.LUCKY_DRAW_STATUS = 20021] = "LUCKY_DRAW_STATUS", e[e.LUCKY_DRAW_WIN = 20020] = "LUCKY_DRAW_WIN", e[e.GOODS_FLAG = 20207] = "GOODS_FLAG", e[e.QUI_FLAG = 20210] = "QUI_FLAG", e[e.QUI_STATUS = 20211] = "QUI_STATUS", e[e.REWARD_WIN = 20209] = "REWARD_WIN", e[e.REWARD_FLAG = 20208] = "REWARD_FLAG", e[e.REWARD_CHANGE = 20212] = "REWARD_CHANGE", e[e.TOP_MESSAGE_UPDATE = 20115] = "TOP_MESSAGE_UPDATE", e[e.QUESTIONING_FLAG = 20215] = "QUESTIONING_FLAG", e[e.QUESTIONING_STATUS = 20216] = "QUESTIONING_STATUS", e[e.QUESTIONING_PUBLISH = 20217] = "QUESTIONING_PUBLISH", e[e.EXAM_MAIN_SWITCH = 20213] = "EXAM_MAIN_SWITCH", e[e.EXAM_SWITCH = 20214] = "EXAM_SWITCH", e[e.VOTING_FLAG = 20221] = "VOTING_FLAG", e[e.VOTING_STATUS = 20220] = "VOTING_STATUS", e[e.SIGN_IN_FLAG = 20222] = "SIGN_IN_FLAG", e[e.SIGN_IN_STATUS = 20227] = "SIGN_IN_STATUS", e[e.FABULOUS_NUMBER = 20233] = "FABULOUS_NUMBER", e[e.WATCH_NUMBER = 20232] = "WATCH_NUMBER", e[e.WATCH_NUMBER_FLAG = 20235] = "WATCH_NUMBER_FLAG", e[e.USER_ONLINE = 20101] = "USER_ONLINE", e[e.USER_ONLINE_AUDIENCE = 20103] = "USER_ONLINE_AUDIENCE", e[e.INTERACTIVE_ACCESS_FLAG = 20241] = "INTERACTIVE_ACCESS_FLAG", e[e.LOOP_PLAYBACK = 20246] = "LOOP_PLAYBACK", e[e.TOPIC_FLAG = 20223] = "TOPIC_FLAG", e[e.TOPIC_CONFIG = 20228] = "TOPIC_CONFIG", e[e.TOPIC_ADD = 20229] = "TOPIC_ADD", e[e.TOPIC_EDIT = 20224] = "TOPIC_EDIT", e[e.TOPIC_DELETE = 20225] = "TOPIC_DELETE", e[e.TOPIC_REPLY_DELETE = 20226] = "TOPIC_REPLY_DELETE", e[e.TOPIC_TOP = 20230] = "TOPIC_TOP", e[e.TOPIC_CANCEL_TOP = 20231] = "TOPIC_CANCEL_TOP", e))(Topics || {}), WatchTopicTypeEnum = /* @__PURE__ */ ((e) => (e[e.DEEP = 0] = "DEEP", e[e.LIGHT = 1] = "LIGHT", e))(WatchTopicTypeEnum || {}), WatchBackgroundTypeEnum = /* @__PURE__ */ ((e) => (e[e.IMAGE = 0] = "IMAGE", e[e.COLOR = 1] = "COLOR", e))(WatchBackgroundTypeEnum || {}), WatchBackgroundColorTransitionEnum = /* @__PURE__ */ ((e) => (e[e.NO_TRANSITION = 0] = "NO_TRANSITION", e[e.TRANSITION = 1] = "TRANSITION", e))(WatchBackgroundColorTransitionEnum || {}), WatchBackgroundUrlDisplayEnum = /* @__PURE__ */ ((e) => (e[e.FIXED = 0] = "FIXED", e[e.SCROLL = 1] = "SCROLL", e))(WatchBackgroundUrlDisplayEnum || {}), RoomLayout = /* @__PURE__ */ ((e) => (e[e.VIDEO_BOARD = 1] = "VIDEO_BOARD", e[e.BOARD_VIDEO = 2] = "BOARD_VIDEO", e[e.VIDEO = 3] = "VIDEO", e[e.BOARD = 4] = "BOARD", e))(RoomLayout || {}), BanType = /* @__PURE__ */ ((e) => (e[e.BAN_CHAT = 1] = "BAN_CHAT", e[e.BAN_ONLINE = 2] = "BAN_ONLINE", e))(BanType || {});
function httpGetPageInfo(e) {
  return request$1.get("/page-info", {
    params: { roomNumber: e }
  });
}
var LiveCountDownLocation = /* @__PURE__ */ ((e) => (e[e.TOP = 1] = "TOP", e[e.CENTER = 2] = "CENTER", e[e.BOTTOM = 3] = "BOTTOM", e))(LiveCountDownLocation || {}), FullScreenType = /* @__PURE__ */ ((e) => (e[e.DEFAULT = 1] = "DEFAULT", e[e.FAKE = 2] = "FAKE", e))(FullScreenType || {}), MenuEnum = /* @__PURE__ */ ((e) => (e[e.CHAT = 1] = "CHAT", e[e.DOC = 2] = "DOC", e[e.GRAPHIC = 3] = "GRAPHIC", e[e.TRAILER = 4] = "TRAILER", e[e.TElETEXT = 5] = "TElETEXT", e[e.LIVE_INTRO = 6] = "LIVE_INTRO", e[e.TOPIC = 7] = "TOPIC", e[e.SESSION = 8] = "SESSION", e[e.VENUE = 9] = "VENUE", e[e.CUSTOM_MENU = 10] = "CUSTOM_MENU", e[e.ONLINE_USER = 11] = "ONLINE_USER", e))(MenuEnum || {});
function httpGetWatchInit(e, T) {
  return Me(this, null, function* () {
    return request$1.get(`/events/${e}/rooms/${T}/watch-init-new`);
  });
}
var WsUserConfigsResType = /* @__PURE__ */ ((e) => (e[e.SILENCE = 1] = "SILENCE", e[e.BAN = 2] = "BAN", e))(WsUserConfigsResType || {});
function httpPostHeartbeat(e, T, F) {
  return request$1.post(`/events/${e}/rooms/${T}/audiences/mine-online`, { pageSession: F });
}
var DotType = /* @__PURE__ */ ((e) => (e[e.INIT = 1] = "INIT", e[e.AD = 2] = "AD", e[e.TRAILER = 2] = "TRAILER", e[e.MENU_VIDEO = 2] = "MENU_VIDEO", e[e.LIVE = 3] = "LIVE", e))(DotType || {}), AdMediaType = /* @__PURE__ */ ((e) => (e[e.VIDEO = 1] = "VIDEO", e[e.AUDIO = 2] = "AUDIO", e))(AdMediaType || {}), RoomMediaSourceType = /* @__PURE__ */ ((e) => (e[e.AD = 1] = "AD", e[e.TRAILER = 2] = "TRAILER", e[e.MENU_VIDEO = 3] = "MENU_VIDEO", e))(RoomMediaSourceType || {}), VideoPlayType = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.AD = "AD", e.TRAILER = "TRAILER", e.LIVE = "LIVE", e.MENU_VIDEO = "MENU_VIDEO", e))(VideoPlayType || {}), LiveMode = /* @__PURE__ */ ((e) => (e[e.STREAM_PUSH_SINGLE = 6] = "STREAM_PUSH_SINGLE", e[e.STREAM_PUSH_MULTI = 7] = "STREAM_PUSH_MULTI", e))(LiveMode || {}), WatermarkType = /* @__PURE__ */ ((e) => (e[e.TEXT = 0] = "TEXT", e[e.IMAGE = 1] = "IMAGE", e))(WatermarkType || {}), WatermarkPosition = /* @__PURE__ */ ((e) => (e[e.TOP_LEFT = 0] = "TOP_LEFT", e[e.TOP_RIGHT = 1] = "TOP_RIGHT", e[e.BOTTOM_LEFT = 2] = "BOTTOM_LEFT", e[e.BOTTOM_RIGHT = 3] = "BOTTOM_RIGHT", e))(WatermarkPosition || {}), WatchPageSourceType = /* @__PURE__ */ ((e) => (e[e.AD = 1] = "AD", e[e.LIVE = 7] = "LIVE", e[e.TRAILER = 9] = "TRAILER", e[e.MENU_VIDEO = 14] = "MENU_VIDEO", e))(WatchPageSourceType || {}), MediaType = /* @__PURE__ */ ((e) => (e[e.VOD = 1] = "VOD", e[e.LIVE = 2] = "LIVE", e))(MediaType || {}), BarrageRange = /* @__PURE__ */ ((e) => (e.FULL = "full", e.HALF = "half", e.ONE_THIRD = "oneThird", e))(BarrageRange || {}), PlayerErrorType = /* @__PURE__ */ ((e) => (e.INVALID_SCREEN_ID = "INVALID_SCREEN_ID", e.NO_LIVE = "NO_LIVE", e.LIVING = "LIVING", e.NO_AD_PLAY = "NO_AD_PLAY", e.INVALID_MEDIA_ID = "INVALID_MEDIA_ID", e))(PlayerErrorType || {}), PortraitAdapterModeEnum = /* @__PURE__ */ ((e) => (e[e.TILE = 0] = "TILE", e[e.STRETCH = 1] = "STRETCH", e[e.TAILOR = 2] = "TAILOR", e))(PortraitAdapterModeEnum || {}), ButtonStyleEnum$1 = /* @__PURE__ */ ((e) => (e[e.FACE = 1] = "FACE", e[e.LINE = 2] = "LINE", e))(ButtonStyleEnum$1 || {}), ButtonPositionEnum$1 = /* @__PURE__ */ ((e) => (e[e.LEFT = 1] = "LEFT", e[e.CENTER = 2] = "CENTER", e[e.RIGHT = 3] = "RIGHT", e))(ButtonPositionEnum$1 || {}), lineStyleEnum$1 = /* @__PURE__ */ ((e) => (e[e.UNKNOW = 0] = "UNKNOW", e[e.PADDIN_LINE = 1] = "PADDIN_LINE", e[e.THROUGH_LINE = 2] = "THROUGH_LINE", e))(lineStyleEnum$1 || {}), GroupTitlePositionEnum$1 = /* @__PURE__ */ ((e) => (e[e.LEFT = 1] = "LEFT", e[e.CENTER = 2] = "CENTER", e[e.RIGHT = 3] = "RIGHT", e))(GroupTitlePositionEnum$1 || {}), TitlePositionEnum$1 = /* @__PURE__ */ ((e) => (e[e.LEFT = 1] = "LEFT", e[e.CENTER = 2] = "CENTER", e[e.RIGHT = 3] = "RIGHT", e))(TitlePositionEnum$1 || {}), CustomComponentType$1 = /* @__PURE__ */ ((e) => (e[e.TEXT = 1] = "TEXT", e[e.LIVE_INTRO = 2] = "LIVE_INTRO", e[e.TITLE = 3] = "TITLE", e[e.IMAGE = 4] = "IMAGE", e[e.IMAGE_SWIPER = 5] = "IMAGE_SWIPER", e[e.VIDEO = 6] = "VIDEO", e[e.ACTIVE_LIST = 7] = "ACTIVE_LIST", e[e.VENUE = 8] = "VENUE", e[e.IFRAME = 9] = "IFRAME", e[e.LINE = 10] = "LINE", e[e.PARTNER = 11] = "PARTNER", e[e.CONTACT_US = 12] = "CONTACT_US", e[e.BUTTON = 13] = "BUTTON", e))(CustomComponentType$1 || {});
function httpGetMenuDetail(e, T, F) {
  return Me(this, null, function* () {
    return request$1.get(`/events/${e}/rooms/${T}/menus/${F}`);
  });
}
var ApiHostEnum = /* @__PURE__ */ ((e) => (e.UAT = "UAT", e.SG = "SG", e))(ApiHostEnum || {});
const OriginEnum = {
  CN: "https://prod-tx-mdn-1305533294.file.myqcloud.com/sdk/img/",
  [ApiHostEnum.SG]: "https://prod-tx-sg-mdn-1305533294.cos.accelerate.myqcloud.com/sdk/img/"
}, DefaultBgEnum = {
  playerBgUrl: "player-bg.png",
  portraitPlayerBgUrl: "portrait-player-bg.png",
  boardBgUrl: "board-bg.png",
  eventBgUrl: "event-bg.png",
  roomBgUrl: "room-bg.png",
  meetBgUrl: "meet-bg.png"
};
function getDefaultCdnBgUrl(e) {
  return `${OriginEnum[_apiHost] || OriginEnum.CN}${e}`;
}
var __defProp$E = Object.defineProperty, __defNormalProp$E = (e, T, F) => T in e ? __defProp$E(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$E = (e, T, F) => (__defNormalProp$E(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$H = {
  menuList: [],
  allMenuList: [],
  onlineUSerMenuName: "\u5728\u7EBF\u5217\u8868"
};
class MenuModel extends Model {
  constructor() {
    super(INITIAL_STATE$H), __publicField$E(this, "queryCustomMenuDetail", (T) => Me(this, null, function* () {
      const { eventId: F } = eventModel.state, { roomId: $ } = roomModel.state;
      return httpGetMenuDetail(F, $, T).then((J) => {
        const { data: ee } = J.data || {};
        return this._dealDetailData(ee) || [];
      }).catch(() => Promise.reject({}));
    }));
  }
  init(T) {
    Array.isArray(T) && (this.setState({ allMenuList: T }), this._updateMenuList());
  }
  _updateMenuList() {
    const { watchLanguage: T } = roomModel.state, { allMenuList: F } = this.state;
    F.map((ee) => {
      ee.menuType === MenuEnum.ONLINE_USER && ee.languageType === T && this.setState({
        onlineUSerMenuName: ee.menuName
      });
    });
    const J = F.filter((ee) => ee.menuType === MenuEnum.CUSTOM_MENU && ee.languageType === T).map((ee) => {
      var ne, oe;
      return {
        menuName: (ne = ee == null ? void 0 : ee.menuName) != null ? ne : "",
        menuId: (oe = ee == null ? void 0 : ee.watchMenuConfigId) != null ? oe : 0
      };
    });
    this.setState({
      menuList: J || []
    });
  }
  _dealDetailData(T) {
    const { components: F } = T;
    return F.map((J) => {
      var ee;
      const { componentId: ne, componentType: oe } = J;
      if (oe === CustomComponentType$1.TEXT)
        return {
          componentId: ne,
          componentType: oe,
          textInfo: (ee = J.textInfo) != null ? ee : ""
        };
      if (oe === CustomComponentType$1.LIVE_INTRO) {
        const { icon: se = "", title: le = "", subtitle: de = "", startTime: ce = "", endTime: he = "", content: ve = "" } = J;
        return {
          componentId: ne,
          componentType: oe,
          icon: se,
          title: le,
          subtitle: de,
          startTime: ce,
          endTime: he,
          content: ve
        };
      }
      if (oe === CustomComponentType$1.TITLE) {
        const { title: se = "", titlePosition: le = TitlePositionEnum$1.CENTER, subtitle: de = "", subtitlePosition: ce = TitlePositionEnum$1.CENTER } = J;
        return {
          componentId: ne,
          componentType: oe,
          title: se,
          titlePosition: le,
          subtitle: de,
          subtitlePosition: ce
        };
      }
      if (oe === CustomComponentType$1.IMAGE) {
        const { items: se = [] } = J, le = se.map((de) => {
          var ce, he;
          return {
            subcomponentId: (ce = de.subcomponentId) != null ? ce : 0,
            pictureUrl: (he = de.pictureUrl) != null ? he : ""
          };
        });
        return {
          componentId: ne,
          componentType: oe,
          items: le
        };
      }
      if (oe === CustomComponentType$1.IMAGE_SWIPER) {
        const { items: se = [] } = J, le = se.map((de) => {
          var ce, he, ve;
          return {
            subcomponentId: (ce = de.subcomponentId) != null ? ce : 0,
            pictureUrl: (he = de.pictureUrl) != null ? he : "",
            pictureClickUrl: (ve = de.pictureClickUrl) != null ? ve : ""
          };
        });
        return {
          componentId: ne,
          componentType: oe,
          items: le
        };
      }
      if (oe === CustomComponentType$1.VIDEO) {
        const { items: se = [] } = J, le = se.map((de) => {
          var ce, he, ve, ge, be;
          return {
            mediaId: (ce = de.mediaId) != null ? ce : 0,
            mediaName: (he = de.mediaName) != null ? he : "",
            mediaCoverUrl: (ve = de.mediaCoverUrl) != null ? ve : "",
            mediaDuration: (ge = de.mediaDuration) != null ? ge : "",
            mediaType: (be = de.mediaType) != null ? be : AdMediaType.VIDEO
          };
        });
        return {
          componentId: ne,
          componentType: oe,
          items: le
        };
      }
      if (oe === CustomComponentType$1.ACTIVE_LIST) {
        const { eventUrl: se } = eventModel.state, { items: le = [] } = J, de = le.map((ce) => {
          var he, ve, ge, be, Te;
          return {
            virtualEventId: (he = ce.virtualEventId) != null ? he : 0,
            virtualEventName: (ve = ce.virtualEventName) != null ? ve : "",
            startTime: (ge = ce.startTime) != null ? ge : "",
            endTime: (be = ce.endTime) != null ? be : "",
            coverUrl: ce.coverUrl || getDefaultCdnBgUrl(DefaultBgEnum.eventBgUrl),
            virtualEventStatus: (Te = ce.virtualEventStatus) != null ? Te : VirtualEventStatusEnum.EVENTPRE,
            virtualEventUrl: `${se}/event/${ce.virtualEventNumber}/landing`
          };
        });
        return {
          componentId: ne,
          componentType: oe,
          items: de
        };
      }
      if (oe === CustomComponentType$1.VENUE) {
        const { eventUrl: se } = eventModel.state, { items: le = [] } = J, de = le.map((ce) => {
          var he, ve, ge;
          const { roomMode: be, virtualEventNumber: Te = "", roomNumber: Se = "" } = ce, Ie = be === RoomMode.LIVE ? "watch" : "meeting", Oe = `${se}/event/${Te}/${Ie}/${Se}`, Le = be === RoomMode.LIVE ? getDefaultCdnBgUrl(DefaultBgEnum.roomBgUrl) : getDefaultCdnBgUrl(DefaultBgEnum.meetBgUrl);
          return {
            roomId: (he = ce.roomId) != null ? he : 0,
            roomName: (ve = ce.roomName) != null ? ve : "",
            coverUrl: ce.coverUrl || Le,
            liveStatus: (ge = ce.liveStatus) != null ? ge : LiveStatus.NOBEGIN,
            roomUrl: Oe
          };
        });
        return {
          componentId: ne,
          componentType: oe,
          items: de
        };
      }
      if (oe === CustomComponentType$1.IFRAME) {
        const { pcOuterChain: se = "", pcOuterChainHeight: le = "", mobileOuterChain: de = "", mobileOuterChainHeight: ce = "" } = J;
        return {
          componentId: ne,
          componentType: oe,
          pcOuterChain: se,
          pcOuterChainHeight: le,
          mobileOuterChain: de,
          mobileOuterChainHeight: ce
        };
      }
      if (oe === CustomComponentType$1.LINE) {
        const {
          lineStyle: se = lineStyleEnum$1.UNKNOW,
          lineHeight: le = 1,
          lineOpacity: de = 10
        } = J;
        return {
          componentId: ne,
          componentType: oe,
          lineStyle: se,
          lineHeight: le,
          lineOpacity: de
        };
      }
      if (oe === CustomComponentType$1.PARTNER) {
        const { items: se = [] } = J, le = se.map((de) => {
          var ce, he, ve, ge;
          return {
            subcomponentId: (ce = de.subcomponentId) != null ? ce : 0,
            groupTitle: (he = de.groupTitle) != null ? he : "",
            groupTitlePosition: (ve = de.groupTitlePosition) != null ? ve : GroupTitlePositionEnum$1.CENTER,
            items: (ge = de.items) != null ? ge : []
          };
        });
        return {
          componentId: ne,
          componentType: oe,
          items: le
        };
      }
      if (oe === CustomComponentType$1.CONTACT_US) {
        const {
          title: se = "",
          wechatFlag: le = 0,
          wechatQrcodeUrl: de = "",
          contactPhoneFlag: ce = 0,
          contactPhone: he = "",
          contactEmailFlag: ve = 0,
          contactEmail: ge = "",
          contactMicroBlogFlag: be = 0,
          contactMicroBlogUrl: Te = "",
          contactFaceBookFlag: Se = 0,
          contactFaceBookUrl: Ie = ""
        } = J;
        return {
          title: se,
          componentId: ne,
          componentType: oe,
          wechatFlag: le,
          wechatQrcodeUrl: de,
          contactPhoneFlag: ce,
          contactPhone: he,
          contactEmailFlag: ve,
          contactEmail: ge,
          contactMicroBlogFlag: be,
          contactMicroBlogUrl: Te,
          contactFaceBookFlag: Se,
          contactFaceBookUrl: Ie
        };
      }
      if (oe === CustomComponentType$1.BUTTON) {
        const {
          buttonCopywriting: se = "",
          buttonStyle: le = ButtonStyleEnum$1.FACE,
          buttonFillet: de = 0,
          buttonSize: ce = 0,
          buttonPosition: he = ButtonPositionEnum$1.CENTER,
          buttonColor: ve = "",
          copywritingColor: ge = "",
          clickUrl: be = ""
        } = J;
        return {
          componentId: ne,
          componentType: oe,
          buttonCopywriting: se,
          buttonStyle: le,
          buttonFillet: de,
          buttonSize: ce,
          buttonPosition: he,
          buttonColor: ve,
          copywritingColor: ge,
          clickUrl: be
        };
      }
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$H);
  }
}
const menuModel = new MenuModel();
function inLanguageEnum(e) {
  return Object.values(LanguageEnum).includes(e);
}
function findFinalLangFun(e, T) {
  return T(e) ? e : LanguageTypeEnum.DEFAULT;
}
function getI18nRemark(e, T) {
  var F;
  const $ = findFinalLangFun(e, (J) => T == null ? void 0 : T.some((ee) => ee.languageType === J));
  return (F = T == null ? void 0 : T.find((J) => J.languageType === $)) == null ? void 0 : F.remark;
}
function getI18nRoomName(e, T) {
  var F;
  const $ = findFinalLangFun(e, (J) => T == null ? void 0 : T.some((ee) => ee.languageType === J));
  return (F = T == null ? void 0 : T.find((J) => J.languageType === $)) == null ? void 0 : F.roomName;
}
var muduPlayer$1 = { exports: {} };
/*!
* mudu-player.js v0.40.3
* commit: 04ece761
* Copyright Â© ç›®ç¹ http://mudu.tv
*/
(function(e, T) {
  (function(F, $) {
    e.exports = $();
  })(commonjsGlobal, function() {
    function F(ae) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? F = function(ie) {
        return typeof ie;
      } : F = function(ie) {
        return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
      }, F(ae);
    }
    function $(ae, ie) {
      if (!(ae instanceof ie))
        throw new TypeError("Cannot call a class as a function");
    }
    function J(ae, ie) {
      for (var re = 0; re < ie.length; re++) {
        var K = ie[re];
        K.enumerable = K.enumerable || !1, K.configurable = !0, "value" in K && (K.writable = !0), Object.defineProperty(ae, K.key, K);
      }
    }
    function ee(ae, ie, re) {
      return ie && J(ae.prototype, ie), re && J(ae, re), ae;
    }
    function ne(ae, ie, re) {
      return ie in ae ? Object.defineProperty(ae, ie, {
        value: re,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : ae[ie] = re, ae;
    }
    function oe(ae) {
      for (var ie = 1; ie < arguments.length; ie++) {
        var re = arguments[ie] != null ? arguments[ie] : {}, K = Object.keys(re);
        typeof Object.getOwnPropertySymbols == "function" && (K = K.concat(Object.getOwnPropertySymbols(re).filter(function(te) {
          return Object.getOwnPropertyDescriptor(re, te).enumerable;
        }))), K.forEach(function(te) {
          ne(ae, te, re[te]);
        });
      }
      return ae;
    }
    function se(ae, ie) {
      if (typeof ie != "function" && ie !== null)
        throw new TypeError("Super expression must either be null or a function");
      ae.prototype = Object.create(ie && ie.prototype, {
        constructor: {
          value: ae,
          writable: !0,
          configurable: !0
        }
      }), ie && de(ae, ie);
    }
    function le(ae) {
      return le = Object.setPrototypeOf ? Object.getPrototypeOf : function(re) {
        return re.__proto__ || Object.getPrototypeOf(re);
      }, le(ae);
    }
    function de(ae, ie) {
      return de = Object.setPrototypeOf || function(K, te) {
        return K.__proto__ = te, K;
      }, de(ae, ie);
    }
    function ce(ae) {
      if (ae === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return ae;
    }
    function he(ae, ie) {
      return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce(ae);
    }
    function ve(ae, ie) {
      for (; !Object.prototype.hasOwnProperty.call(ae, ie) && (ae = le(ae), ae !== null); )
        ;
      return ae;
    }
    function ge(ae, ie, re) {
      return typeof Reflect != "undefined" && Reflect.get ? ge = Reflect.get : ge = function(te, ue, fe) {
        var pe = ve(te, ue);
        if (!!pe) {
          var me = Object.getOwnPropertyDescriptor(pe, ue);
          return me.get ? me.get.call(fe) : me.value;
        }
      }, ge(ae, ie, re || ae);
    }
    function be(ae) {
      return Te(ae) || Se(ae) || Ie();
    }
    function Te(ae) {
      if (Array.isArray(ae)) {
        for (var ie = 0, re = new Array(ae.length); ie < ae.length; ie++)
          re[ie] = ae[ie];
        return re;
      }
    }
    function Se(ae) {
      if (Symbol.iterator in Object(ae) || Object.prototype.toString.call(ae) === "[object Arguments]")
        return Array.from(ae);
    }
    function Ie() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    var Oe = navigator.userAgent, Le = function(ie) {
      return Oe.match(ie) !== null;
    };
    function Ne(ae) {
      return function() {
        return Le(ae);
      };
    }
    function Ue() {
      var ae = cr();
      return !!ae;
    }
    function je() {
      var ae = cr();
      return !!(ae && ae >= "5.0.2-15");
    }
    var we = Ne(/gecko\//i), He = Ne(/trident\/.+rv:\s*11/i), De = Ne(/iP(hone|od)/i), $e = Ne(/iPad/i), Be = Ne(/Macintosh/i), lt = Ne(/FBAV/i), tt = function() {
      return Le(/\sEdge\/\d+/i);
    }, nt = function() {
      return Le(/msie/i);
    }, Et = function() {
      return Le(/\s(?:(?:Headless)?Chrome|CriOS)\//i) && !tt() && !Le(/UCBrowser/i);
    }, It = function() {
      return tt() || He() || nt();
    }, it = function() {
      return Le(/safari/i) && !Le(/(?:Chrome|CriOS|chromium|android|phantom)/i);
    }, ft = function() {
      return Le(/iP(hone|ad|od)/i);
    }, At = function() {
      return window.location.href.indexOf("playerdebug") >= 0;
    }, ur = function() {
      return navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
    }, Ho = function() {
      return Le(/chrome\/[123456789]/i) && !Le(/chrome\/18/i) && !we() ? !1 : Mt();
    }, Qi = function() {
      var ie = Oe.toLowerCase();
      return /webkit/.test(ie) ? parseFloat(ie.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) : !1;
    }, ni = function() {
      return Le(/UCBrowser/i);
    }, ai = function() {
      return Le(/MQQBrowser/i);
    }, Mt = function() {
      return Le(/Android/i) && !Le(/Windows Phone/i);
    }, rt = function() {
      return ft() || Mt() || Le(/Windows Phone/i);
    }, Ji = function() {
      return Le("Windows") > -1;
    }, Zi = function() {
      try {
        return window.self !== window.top;
      } catch (ie) {
        return !0;
      }
    }, $t = function() {
      return sn() || ln();
    }, sn = function() {
      var ie = Oe, re = /tbs\/(\d+) /gi.exec(ie), K = /wechat|micromessenger/gi.test(ie);
      return Mt() && (re || K) ? K || (re[1] || "") > "036849" : !1;
    }, ln = function() {
      var ie = Oe, re = /MQQBrowser\/([\d+.]+) /gi.exec(ie);
      return Mt() && re ? +(re[1] || "") >= 7.1 : !1;
    }, cr = function() {
      if (Mt())
        return 0;
      var ie = navigator.plugins, re;
      if (ie && (re = ie["Shockwave Flash"], re && re.description))
        return parseFloat(re.description.replace(/\D+(\d+\.?\d*).*/, "$1"));
      if (typeof window.ActiveXObject != "undefined") {
        try {
          if (re = new window.ActiveXObject("ShockwaveFlash.ShockwaveFlash"), re)
            return parseFloat(re.GetVariable("$version").split(" ")[1].replace(/\s*,\s*/, "."));
        } catch (K) {
          return 0;
        }
        return re;
      }
      return 0;
    };
    function Vo(ae, ie) {
      var re, K, te, ue;
      return ae.chrome ? ie.indexOf("Chrome") !== -1 ? re = ie.substring(ie.indexOf("Chrome") + 7) : re = ie.substring(ie.indexOf("CriOS") + 6) : ae.safari ? re = ie.substring(ie.indexOf("Version") + 8) : ae.firefox ? re = ie.substring(ie.indexOf("Firefox") + 8) : ae.edge ? re = ie.substring(ie.indexOf("Edge") + 5) : ae.ie && (ie.indexOf("rv:") !== -1 ? re = ie.substring(ie.indexOf("rv:") + 3) : ie.indexOf("MSIE") !== -1 && (re = ie.substring(ie.indexOf("MSIE") + 5))), re && ((ue = re.indexOf(";")) !== -1 && (re = re.substring(0, ue)), (ue = re.indexOf(" ")) !== -1 && (re = re.substring(0, ue)), (ue = re.indexOf(")")) !== -1 && (re = re.substring(0, ue)), K = parseInt(re, 10), te = parseInt(re.split(".")[1], 10)), {
        version: re,
        major: K,
        minor: te
      };
    }
    function wr(ae, ie) {
      if (ae && ae.length > ie)
        return ae[ie];
    }
    function Bo(ae, ie) {
      var re, K, te;
      if (ae.windows)
        switch (re = wr(/Windows(?: NT|)? ([._\d]+)/.exec(ie), 1), re) {
          case "6.1":
            re = "7.0";
            break;
          case "6.2":
            re = "8.0";
            break;
          case "6.3":
            re = "8.1";
            break;
        }
      else
        ae.android ? re = wr(/Android ([._\d]+)/.exec(ie), 1) : ae.iOS ? re = wr(/OS ([._\d]+)/.exec(ie), 1) : ae.mac && (re = wr(/Mac OS X (10[._\d]+)/.exec(ie), 1));
      if (re) {
        K = parseInt(re, 10);
        var ue = re.split(/[._]/);
        ue && (te = parseInt(ue[1], 10));
      }
      return {
        version: re,
        major: K,
        minor: te
      };
    }
    var cn = navigator.userAgent, Pr = {
      chrome: Et(),
      edge: tt(),
      firefox: we(),
      ie: It(),
      msie: nt(),
      safari: it()
    };
    Pr.version = Vo(Pr, cn);
    var Lr = {
      android: Mt(),
      iOS: ft(),
      mobile: rt(),
      mac: Be(),
      iPad: $e(),
      iPhone: De(),
      windows: Ji()
    };
    Lr.version = Bo(Lr, cn);
    var Go = {
      flashInstalled: Ue(),
      flashSupported: je(),
      flashVersion: cr(),
      iframe: Zi()
    }, Wo = {
      browser: Pr,
      os: Lr,
      others: Go
    }, dn = Pr.version, jo = Lr.version, dr = function() {
      return JSON.parse(JSON.stringify(Wo));
    }, zo = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      browserVersion: dn,
      osVersion: jo,
      getEnvor: dr,
      isFlashInstalled: Ue,
      isFlashSupported: je,
      isFF: we,
      isIETrident: He,
      isIPod: De,
      isIPad: $e,
      isOSX: Be,
      isFacebook: lt,
      isEdge: tt,
      isMSIE: nt,
      isChrome: Et,
      isIE: It,
      isSafari: it,
      isIOS: ft,
      isDebugMode: At,
      getLanguage: ur,
      isAndroidNative: Ho,
      getWebkitVersion: Qi,
      isUC: ni,
      isMQQBrowser: ai,
      isAndroid: Mt,
      isMobile: rt,
      isWindows: Ji,
      isIframe: Zi,
      isX5Layer: $t,
      isWxLayer: sn,
      isQQLayer: ln,
      flashVersion: cr
    }), vt = Ko, qo = [
      "",
      " ",
      "  ",
      "   ",
      "    ",
      "     ",
      "      ",
      "       ",
      "        ",
      "         "
    ];
    function Ko(ae, ie, re) {
      if (ae = ae + "", ie = ie - ae.length, ie <= 0)
        return ae;
      if (!re && re !== 0 && (re = " "), re = re + "", re === " " && ie < 10)
        return qo[ie] + ae;
      for (var K = ""; ie & 1 && (K += re), ie >>= 1, ie; )
        re += re;
      return K + ae;
    }
    var hn = function() {
      if (typeof Map != "undefined")
        return Map;
      function ae(ie, re) {
        var K = -1;
        return ie.some(function(te, ue) {
          return te[0] === re ? (K = ue, !0) : !1;
        }), K;
      }
      return function() {
        function ie() {
          this.__entries__ = [];
        }
        return Object.defineProperty(ie.prototype, "size", {
          get: function() {
            return this.__entries__.length;
          },
          enumerable: !0,
          configurable: !0
        }), ie.prototype.get = function(re) {
          var K = ae(this.__entries__, re), te = this.__entries__[K];
          return te && te[1];
        }, ie.prototype.set = function(re, K) {
          var te = ae(this.__entries__, re);
          ~te ? this.__entries__[te][1] = K : this.__entries__.push([re, K]);
        }, ie.prototype.delete = function(re) {
          var K = this.__entries__, te = ae(K, re);
          ~te && K.splice(te, 1);
        }, ie.prototype.has = function(re) {
          return !!~ae(this.__entries__, re);
        }, ie.prototype.clear = function() {
          this.__entries__.splice(0);
        }, ie.prototype.forEach = function(re, K) {
          K === void 0 && (K = null);
          for (var te = 0, ue = this.__entries__; te < ue.length; te++) {
            var fe = ue[te];
            re.call(K, fe[1], fe[0]);
          }
        }, ie;
      }();
    }(), oi = typeof window != "undefined" && typeof document != "undefined" && window.document === document, Cr = function() {
      return typeof commonjsGlobal != "undefined" && commonjsGlobal.Math === Math ? commonjsGlobal : typeof self != "undefined" && self.Math === Math ? self : typeof window != "undefined" && window.Math === Math ? window : Function("return this")();
    }(), Yo = function() {
      return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Cr) : function(ae) {
        return setTimeout(function() {
          return ae(Date.now());
        }, 1e3 / 60);
      };
    }(), Xo = 2;
    function Qo(ae, ie) {
      var re = !1, K = !1, te = 0;
      function ue() {
        re && (re = !1, ae()), K && pe();
      }
      function fe() {
        Yo(ue);
      }
      function pe() {
        var me = Date.now();
        if (re) {
          if (me - te < Xo)
            return;
          K = !0;
        } else
          re = !0, K = !1, setTimeout(fe, ie);
        te = me;
      }
      return pe;
    }
    var Jo = 20, Zo = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], es = typeof MutationObserver != "undefined", ts = function() {
      function ae() {
        this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Qo(this.refresh.bind(this), Jo);
      }
      return ae.prototype.addObserver = function(ie) {
        ~this.observers_.indexOf(ie) || this.observers_.push(ie), this.connected_ || this.connect_();
      }, ae.prototype.removeObserver = function(ie) {
        var re = this.observers_, K = re.indexOf(ie);
        ~K && re.splice(K, 1), !re.length && this.connected_ && this.disconnect_();
      }, ae.prototype.refresh = function() {
        var ie = this.updateObservers_();
        ie && this.refresh();
      }, ae.prototype.updateObservers_ = function() {
        var ie = this.observers_.filter(function(re) {
          return re.gatherActive(), re.hasActive();
        });
        return ie.forEach(function(re) {
          return re.broadcastActive();
        }), ie.length > 0;
      }, ae.prototype.connect_ = function() {
        !oi || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), es ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
          attributes: !0,
          childList: !0,
          characterData: !0,
          subtree: !0
        })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
      }, ae.prototype.disconnect_ = function() {
        !oi || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
      }, ae.prototype.onTransitionEnd_ = function(ie) {
        var re = ie.propertyName, K = re === void 0 ? "" : re, te = Zo.some(function(ue) {
          return !!~K.indexOf(ue);
        });
        te && this.refresh();
      }, ae.getInstance = function() {
        return this.instance_ || (this.instance_ = new ae()), this.instance_;
      }, ae.instance_ = null, ae;
    }(), pn = function(ae, ie) {
      for (var re = 0, K = Object.keys(ie); re < K.length; re++) {
        var te = K[re];
        Object.defineProperty(ae, te, {
          value: ie[te],
          enumerable: !1,
          writable: !1,
          configurable: !0
        });
      }
      return ae;
    }, Qt = function(ae) {
      var ie = ae && ae.ownerDocument && ae.ownerDocument.defaultView;
      return ie || Cr;
    }, mn = Fr(0, 0, 0, 0);
    function Mr(ae) {
      return parseFloat(ae) || 0;
    }
    function gn(ae) {
      for (var ie = [], re = 1; re < arguments.length; re++)
        ie[re - 1] = arguments[re];
      return ie.reduce(function(K, te) {
        var ue = ae["border-" + te + "-width"];
        return K + Mr(ue);
      }, 0);
    }
    function rs(ae) {
      for (var ie = ["top", "right", "bottom", "left"], re = {}, K = 0, te = ie; K < te.length; K++) {
        var ue = te[K], fe = ae["padding-" + ue];
        re[ue] = Mr(fe);
      }
      return re;
    }
    function is(ae) {
      var ie = ae.getBBox();
      return Fr(0, 0, ie.width, ie.height);
    }
    function ns(ae) {
      var ie = ae.clientWidth, re = ae.clientHeight;
      if (!ie && !re)
        return mn;
      var K = Qt(ae).getComputedStyle(ae), te = rs(K), ue = te.left + te.right, fe = te.top + te.bottom, pe = Mr(K.width), me = Mr(K.height);
      if (K.boxSizing === "border-box" && (Math.round(pe + ue) !== ie && (pe -= gn(K, "left", "right") + ue), Math.round(me + fe) !== re && (me -= gn(K, "top", "bottom") + fe)), !os(ae)) {
        var ye = Math.round(pe + ue) - ie, _e = Math.round(me + fe) - re;
        Math.abs(ye) !== 1 && (pe -= ye), Math.abs(_e) !== 1 && (me -= _e);
      }
      return Fr(te.left, te.top, pe, me);
    }
    var as = function() {
      return typeof SVGGraphicsElement != "undefined" ? function(ae) {
        return ae instanceof Qt(ae).SVGGraphicsElement;
      } : function(ae) {
        return ae instanceof Qt(ae).SVGElement && typeof ae.getBBox == "function";
      };
    }();
    function os(ae) {
      return ae === Qt(ae).document.documentElement;
    }
    function ss(ae) {
      return oi ? as(ae) ? is(ae) : ns(ae) : mn;
    }
    function ls(ae) {
      var ie = ae.x, re = ae.y, K = ae.width, te = ae.height, ue = typeof DOMRectReadOnly != "undefined" ? DOMRectReadOnly : Object, fe = Object.create(ue.prototype);
      return pn(fe, {
        x: ie,
        y: re,
        width: K,
        height: te,
        top: re,
        right: ie + K,
        bottom: te + re,
        left: ie
      }), fe;
    }
    function Fr(ae, ie, re, K) {
      return { x: ae, y: ie, width: re, height: K };
    }
    var us = function() {
      function ae(ie) {
        this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Fr(0, 0, 0, 0), this.target = ie;
      }
      return ae.prototype.isActive = function() {
        var ie = ss(this.target);
        return this.contentRect_ = ie, ie.width !== this.broadcastWidth || ie.height !== this.broadcastHeight;
      }, ae.prototype.broadcastRect = function() {
        var ie = this.contentRect_;
        return this.broadcastWidth = ie.width, this.broadcastHeight = ie.height, ie;
      }, ae;
    }(), cs = function() {
      function ae(ie, re) {
        var K = ls(re);
        pn(this, { target: ie, contentRect: K });
      }
      return ae;
    }(), ds = function() {
      function ae(ie, re, K) {
        if (this.activeObservations_ = [], this.observations_ = new hn(), typeof ie != "function")
          throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = ie, this.controller_ = re, this.callbackCtx_ = K;
      }
      return ae.prototype.observe = function(ie) {
        if (!arguments.length)
          throw new TypeError("1 argument required, but only 0 present.");
        if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
          if (!(ie instanceof Qt(ie).Element))
            throw new TypeError('parameter 1 is not of type "Element".');
          var re = this.observations_;
          re.has(ie) || (re.set(ie, new us(ie)), this.controller_.addObserver(this), this.controller_.refresh());
        }
      }, ae.prototype.unobserve = function(ie) {
        if (!arguments.length)
          throw new TypeError("1 argument required, but only 0 present.");
        if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
          if (!(ie instanceof Qt(ie).Element))
            throw new TypeError('parameter 1 is not of type "Element".');
          var re = this.observations_;
          !re.has(ie) || (re.delete(ie), re.size || this.controller_.removeObserver(this));
        }
      }, ae.prototype.disconnect = function() {
        this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
      }, ae.prototype.gatherActive = function() {
        var ie = this;
        this.clearActive(), this.observations_.forEach(function(re) {
          re.isActive() && ie.activeObservations_.push(re);
        });
      }, ae.prototype.broadcastActive = function() {
        if (!!this.hasActive()) {
          var ie = this.callbackCtx_, re = this.activeObservations_.map(function(K) {
            return new cs(K.target, K.broadcastRect());
          });
          this.callback_.call(ie, re, ie), this.clearActive();
        }
      }, ae.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
      }, ae.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
      }, ae;
    }(), vn = typeof WeakMap != "undefined" ? /* @__PURE__ */ new WeakMap() : new hn(), yn = function() {
      function ae(ie) {
        if (!(this instanceof ae))
          throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length)
          throw new TypeError("1 argument required, but only 0 present.");
        var re = ts.getInstance(), K = new ds(ie, re, this);
        vn.set(this, K);
      }
      return ae;
    }();
    [
      "observe",
      "unobserve",
      "disconnect"
    ].forEach(function(ae) {
      yn.prototype[ae] = function() {
        var ie;
        return (ie = vn.get(this))[ae].apply(ie, arguments);
      };
    });
    var hs = function() {
      return typeof Cr.ResizeObserver != "undefined" ? Cr.ResizeObserver : yn;
    }(), _n = /* @__PURE__ */ function() {
      function ae(ie) {
        $(this, ae), this.matrix = ie || [[1, 0, 0], [0, 1, 0], [0, 0, 1]];
      }
      return ee(ae, [{
        key: "multiply",
        value: function(re) {
          for (var K = [[0, 0, 0], [0, 0, 0], [0, 0, 0]], te = 0; te < 3; te++)
            for (var ue = 0; ue < 3; ue++)
              for (var fe = 0; fe < 3; fe++)
                K[te][ue] += this.matrix[te][fe] * re[fe][ue];
          this.matrix = K;
        }
      }, {
        key: "translate",
        value: function(re, K) {
          var te = [[1, 0, re], [0, 1, K], [0, 0, 1]];
          this.multiply(te);
        }
      }, {
        key: "scale",
        value: function(re, K) {
          var te = [[re, 0, 0], [0, K, 0], [0, 0, 1]];
          this.multiply(te);
        }
      }, {
        key: "rotate",
        value: function(re) {
          var K = re * (Math.PI / 180), te = Math.cos(K), ue = Math.sin(K), fe = [[te, -ue, 0], [ue, te, 0], [0, 0, 1]];
          this.multiply(fe);
        }
      }, {
        key: "applyToPoint",
        value: function(re, K) {
          for (var te = [re, K, 1], ue = [0, 0, 0], fe = 0; fe < 3; fe++)
            for (var pe = 0; pe < 3; pe++)
              ue[fe] += this.matrix[fe][pe] * te[pe];
          return {
            x: ue[0],
            y: ue[1]
          };
        }
      }, {
        key: "getMatrix",
        value: function() {
          return this.matrix;
        }
      }]), ae;
    }();
    function fs(ae, ie) {
      if (ie = hi(ie) ? ie : document.querySelector(".mudu-fullscreen-landscape-right") ? -90 : 0, !ie)
        return ae;
      var re = new _n(), K = innerWidth / 2, te = innerHeight / 2;
      re.translate(K, te), re.rotate(ie), re.translate(-K, -te);
      var ue = re.applyToPoint(ae.left, ae.top), fe = re.applyToPoint(ae.right, ae.top), pe = re.applyToPoint(ae.left, ae.bottom), me = re.applyToPoint(ae.right, ae.bottom), ye = Math.min(ue.x, fe.x, pe.x, me.x), _e = Math.max(ue.x, fe.x, pe.x, me.x), Ee = Math.min(ue.y, fe.y, pe.y, me.y), ke = Math.max(ue.y, fe.y, pe.y, me.y);
      return {
        x: ye,
        y: Ee,
        left: ye,
        top: Ee,
        right: _e,
        bottom: ke,
        width: _e - ye,
        height: ke - Ee
      };
    }
    function Jt(ae, ie) {
      if (ie = hi(ie) ? ie : document.querySelector(".mudu-fullscreen-landscape-right") ? -90 : 0, !ie)
        return ae;
      var re = new _n(), K = innerWidth / 2, te = innerHeight / 2;
      re.translate(K, te), re.rotate(ie), re.translate(-K, -te);
      var ue = re.applyToPoint(ae.x, ae.y), fe = ue.x, pe = ue.y;
      return {
        x: fe,
        y: pe
      };
    }
    function ps(ae, ie) {
      for (var re = [], K = [], te = 0; te < ae.length; te++) {
        var ue = ie(ae[te], te, ae);
        re.indexOf(ue) >= 0 || (K.push(ae[te]), re.push(ue));
      }
      return K;
    }
    function ms(ae) {
      return Object.prototype.toString.call(ae).slice(8, -1).toLowerCase();
    }
    function Ce(ae, ie) {
      return ms(ie) === ae.toLowerCase();
    }
    function yt(ae) {
      return Ce("number", ae) ? ae <= 0 ? 0 : ae <= 1 ? ae * 100 + "%" : ae + "px" : ae;
    }
    function Nt() {
    }
    var si = function() {
      return !0;
    }, gs = function() {
      return !1;
    };
    function Zt(ae) {
      var ie = [];
      for (var re in ae)
        ie.push(re);
      return ie;
    }
    function vs(ae) {
      var ie = {
        connection: "",
        stream: ""
      };
      if (!ae)
        return ie;
      var re = ae.search(/&(?!\w+=)/), K;
      return re !== -1 ? K = re : (re = K = ae.lastIndexOf("/"), re === 0 && (re = K = ae.length)), ie.connection = ae.substring(0, re), ie.stream = ae.substring(K + 1, ae.length), ie;
    }
    function hr(ae) {
      var ie = ae < 0;
      ie && (ae = -ae);
      var re = function(me) {
        return me < 10 ? "0" + me : "" + me;
      }, K = Math.floor(ae / 3600), te = Math.floor((ae - K * 3600) / 60), ue = Math.floor(ae - K * 3600 - te * 60), fe = (K > 0 ? [K, te, ue] : [te, ue]).map(re).join(":");
      return ie ? "-" + fe : fe;
    }
    function ys(ae) {
      return window.getComputedStyle ? window.getComputedStyle(ae) : ae.currentStyle ? ae.currentStyle : {};
    }
    var bn = function() {
      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(ae) {
        return window.setTimeout(ae, 1e3 / 60);
      };
    }(), _s = function() {
      return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCanelAnimationFrame || window.oCancelAnimationFrame || window.msCancelAnimationFrame || function(ae) {
        window.clearTimeout(ae);
      };
    }();
    function Qe(ae) {
      for (var ie = arguments.length, re = new Array(ie > 1 ? ie - 1 : 0), K = 1; K < ie; K++)
        re[K - 1] = arguments[K];
      return document.addEventListener ? ae.addEventListener.apply(ae, re) : ae.attachEvent("on" + re[0], re[1]);
    }
    function at(ae) {
      for (var ie = arguments.length, re = new Array(ie > 1 ? ie - 1 : 0), K = 1; K < ie; K++)
        re[K - 1] = arguments[K];
      return document.removeEventListener ? ae.removeEventListener.apply(ae, re) : ae.detachEvent("on" + re[0], re[1]);
    }
    function Ae(ae) {
      var ie = ae.className.split(" ").filter(function(pe) {
        return pe.replace(" ", "") !== "";
      });
      function re(pe) {
        ie.push(pe), fe();
      }
      function K(pe) {
        var me;
        Ce("RegExp", pe) ? me = function(_e) {
          return !_e.match(pe);
        } : me = function(_e) {
          return _e !== pe;
        }, ie = ie.filter(me), fe();
      }
      function te(pe) {
        var me = ue(pe);
        me ? K(pe) : re(pe);
      }
      function ue(pe) {
        return ie.indexOf(pe) >= 0;
      }
      function fe() {
        ie = ps(ie, function(pe) {
          return pe;
        }), ae.className = ie.join(" ");
      }
      return {
        add: re,
        remove: K,
        toggle: te,
        contains: ue
      };
    }
    function xt(ae) {
      var ie = document.createElement("div");
      return ie.innerHTML = ae, ie.firstChild;
    }
    function Tn(ae) {
      ae = ae || new Date();
      function ie(re) {
        re = re || "YYYY-MM-DD HH:mm:ss.SSS";
        var K = ae.getFullYear(), te = vt(ae.getMonth() + 1, 2, "0"), ue = vt(ae.getDate(), 2, 0), fe = vt(ae.getHours(), 2, 0), pe = vt(ae.getMinutes(), 2, 0), me = vt(ae.getSeconds(), 2, 0), ye = vt(ae.getMilliseconds(), 3, 0), _e = re.replace("YYYY", K).replace("MM", te).replace("DD", ue).replace("HH", fe).replace("mm", pe).replace("ss", me).replace("SSS", ye);
        return _e;
      }
      return {
        format: ie
      };
    }
    function li(ae) {
      ae = ae || new Date();
      var ie = ae.getFullYear(), re = vt(ae.getMonth() + 1, 2, "0"), K = vt(ae.getDate(), 2, 0), te = vt(ae.getHours(), 2, 0), ue = vt(ae.getMinutes(), 2, 0), fe = vt(ae.getSeconds(), 2, 0), pe = ae.getMilliseconds() * 1e6, me = -ae.getTimezoneOffset(), ye = Math.abs(ae.getTimezoneOffset()), _e = vt(Math.floor(ye / 60), 2, 0), Ee = vt(Math.floor(ye % 60), 2, 0), ke = me < 0 ? "-" : "+", Re = "".concat(ie, "-").concat(re, "-").concat(K), xe = pe === 0 ? "" : ".".concat(pe), Ge = "".concat(te, ":").concat(ue, ":").concat(fe).concat(xe), qe = me === 0 ? "" : "".concat(ke).concat(_e, ":").concat(Ee), Ze = "".concat(Ge).concat(qe), We = "".concat(Re, "T").concat(Ze);
      return We;
    }
    function er() {
      var ae = Tn().format("HHmmss"), ie = ui(3);
      return ae + ie;
    }
    function bs() {
      var ae = Tn().format("MMDDHHmmss"), ie = ui(5);
      return ae + ie;
    }
    function Ts(ae) {
      var ie = Zt(ae), re = ie.map(function(K) {
        var te = typeof ae[K] != "string" ? tr(ae[K]) : ae[K];
        return "".concat(K, "=").concat(encodeURIComponent(te));
      });
      return re.join("&");
    }
    function ut(ae) {
      var ie = {
        width: ae.offsetWidth,
        height: ae.offsetHeight
      }, re = ae.getBoundingClientRect(), K = {};
      return Zt(re).forEach(function(te) {
        K[te] = re[te];
      }), re = oe({}, ie, K), fs(re);
    }
    function kr(ae) {
      var ie = '<div class="mudu-reset mudu-tooltip-text-wrap">' + '<span class="mudu-reset mudu-tooltip-text">'.concat(ae, "</span>") + "</div>";
      return ie;
    }
    function tr(ae) {
      var ie = [];
      return JSON.stringify(ae, function(re, K) {
        if (F(K) === "object" && K !== null) {
          if (ie.indexOf(K) !== -1)
            return;
          ie.push(K);
        }
        return K;
      });
    }
    function ui() {
      for (var ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3, ie = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", re = ie.toLowerCase(), K = "0123456789", te = ie + re + K, ue = "", fe = 0; fe < ae; fe++)
        ue += te[ci(0, 62)];
      return ue;
    }
    function ci(ae, ie) {
      if (ae = +ae || 0, ie = typeof +ie == "number" && +ie ? +ie : 100, ae = Math.floor(ae), ie = Math.floor(ie), ae === ie)
        return ae;
      var re = Math.abs(ae - ie);
      return ae > ie && (ae = ie), ae + Math.floor(Math.random() * re);
    }
    function di(ae) {
      return !(!Ce("number", ae) || isNaN(ae) || ae === 1 / 0 || ae === -1 / 0);
    }
    function hi(ae) {
      return !(!Ce("number", ae) || isNaN(ae));
    }
    function wt(ae, ie) {
      if (ae instanceof HTMLElement && Ce("object", ie))
        for (var re in ie)
          ie.hasOwnProperty(re) && (ae.style[re] = ie[re]);
    }
    function Or(ae, ie) {
      var re = new hs(function(K) {
        ie(K);
      });
      return re.observe(ae), function() {
        re.disconnect();
      };
    }
    function Sn(ae, ie, re) {
      return Math.min(Math.max(ae, ie), re);
    }
    function En(ae) {
      var ie = ae.split(/\/?\?/);
      return "//".concat(ie[0].split("//")[1], ".m3u8?").concat(ie[1]);
    }
    function In(ae) {
      var ie = {}, re = new Promise(function(K, te) {
        ie.abort = te;
      });
      return ie.promise = Promise.race([ae, re]), ie;
    }
    var An = 0, Kt = /* @__PURE__ */ function() {
      function ae() {
        $(this, ae), this._listeners = {};
      }
      return ee(ae, [{
        key: "on",
        value: function(re, K) {
          var te = ++An;
          return this._listeners[re] = this._listeners[re] || [], this._listeners[re].push({
            id: te,
            listener: K,
            once: !1
          }), te;
        }
      }, {
        key: "once",
        value: function(re, K) {
          var te = ++An;
          return this._listeners[re] = this._listeners[re] || [], this._listeners[re].push({
            id: te,
            listener: K,
            once: !0
          }), te;
        }
      }, {
        key: "off",
        value: function(re, K) {
          this._listeners[re] = this._listeners[re] || [];
          for (var te = 0; te < this._listeners[re].length; te++) {
            var ue = this._listeners[re][te];
            if (ue.id === K || ue.listener === K) {
              this._listeners[re].splice(te, 1);
              break;
            }
          }
        }
      }, {
        key: "trigger",
        value: function(re) {
          for (var K = arguments.length, te = new Array(K > 1 ? K - 1 : 0), ue = 1; ue < K; ue++)
            te[ue - 1] = arguments[ue];
          this._listeners[re] = this._listeners[re] || [];
          var fe = be(this._listeners[re]);
          At() && console.log("[event] ".concat(this.constructor.name, " ").concat(re, " "), tr([].slice.call(arguments)));
          for (var pe = this._listeners[re].length - 1; pe >= 0; pe--) {
            var me = this._listeners[re][pe];
            try {
              me.listener.apply(me, te);
            } catch (ye) {
              throw console.error(ye), ye;
            }
            me.once && fe.splice(pe, 1);
          }
          this._listeners[re] = fe, re !== "all" && this.trigger.apply(this, ["all", re].concat(te));
        }
      }, {
        key: "clear",
        value: function() {
          this._listeners = {};
        }
      }]), ae;
    }(), wn = {
      Pause: "\u6682\u505C",
      Normal: "\u6B63\u5E38",
      Settings: "\u8BBE\u7F6E",
      "Full screen": "\u5168\u5C4F",
      "Exit full screen": "\u9000\u51FA\u5168\u5C4F",
      "You can try": "\u4F60\u53EF\u4EE5\u5C1D\u8BD5",
      "Switch to Flash": "\u5207\u6362\u5230Flash",
      "Switch to HTML5": "\u5207\u6362\u5230HTML5",
      Reload: "\u91CD\u65B0\u52A0\u8F7D",
      "Unknown Error": "\u672A\u77E5\u9519\u8BEF",
      "Network Error": "\u7F51\u7EDC\u9519\u8BEF",
      "Media Error": "\u7F16\u89E3\u7801\u9519\u8BEF",
      Mute: "\u9759\u97F3",
      Unmute: "\u53D6\u6D88\u9759\u97F3",
      Quality: "\u753B\u8D28",
      Live: "\u76F4\u64AD",
      Autoplay: "\u81EA\u52A8\u64AD\u653E",
      Captions: "\u5B57\u5E55",
      "Copy debug info": "\u590D\u5236\u6392\u9519\u65E5\u5FD7",
      "Upload debug info": "\u4E0A\u4F20\u6392\u9519\u65E5\u5FD7",
      "Skip ahead to live broadcast": "\u76F4\u63A5\u8DF3\u5230\u73B0\u573A\u76F4\u64AD",
      Line: "\u7EBF\u8DEF",
      Speed: "\u500D\u901F"
    }, Ss = {
      Pause: "\u66AB\u505C",
      Normal: "\u6B63\u5E38",
      Settings: "\u8A2D\u7F6E",
      "Full screen": "\u5168\u87A2\u5E55",
      "Exit full screen": "\u7D50\u675F\u5168\u87A2\u5E55",
      "You can try": "\u59B3\u53EF\u4EE5\u5617\u8A66",
      "Switch to Flash": "\u5207\u63DB\u5230Flash",
      "Switch to HTML5": "\u5207\u63DB\u5230HTML5",
      Reload: "\u91CD\u65B0\u52A0\u8F09",
      "Unknown Error": "\u672A\u77E5\u932F\u8AA4",
      "Network Error": "\u7DB2\u8DEF\u932F\u8AA4",
      "Media Error": "\u7DE8\u89E3\u78BC\u932F\u8AA4",
      Mute: "\u975C\u97F3",
      Unmute: "\u89E3\u9664\u975C\u97F3",
      Quality: "\u756B\u8CEA",
      Live: "\u76F4\u64AD",
      Autoplay: "\u81EA\u52D5\u64AD\u653E",
      Captions: "\u5B57\u5E55",
      "Copy debug info": "\u8907\u88FD\u5075\u932F\u8CC7\u8A0A",
      "Upload debug info": "\u4E0A\u50B3\u5075\u932F\u8CC7\u8A0A",
      "Skip ahead to live broadcast": "\u76F4\u63A5\u8DF3\u5230\u73FE\u5834\u76F4\u64AD",
      Line: "\u7DDA\u8DEF",
      Speed: "\u500D\u901F"
    }, Pn = {};
    for (var Ln in wn)
      Pn[Ln] = Ln;
    var Es = {
      "zh-CN": wn,
      "zh-TW": Ss,
      en: Pn
    };
    function fi(ae, ie) {
      ae === "auto" && (ae = ur()), ae = ae.toLowerCase();
      var re = ae.split("-")[0], K = Zt(ie), te = K.filter(function(ue) {
        return ue.toLowerCase() === ae;
      })[0];
      return te || (te = K.filter(function(ue) {
        return ue.toLowerCase().indexOf(re) === 0;
      })[0]), te || "en";
    }
    function Ft(ae, ie) {
      var re = ae;
      if (Ce("undefined", ae))
        for (var K = 0; K < this._config.playlist.length; K++) {
          var te = this._config.playlist[K];
          if (te.active) {
            re = te;
            break;
          }
        }
      var ue = ie;
      if (Ce("undefined", ie))
        for (var fe = 0; fe < re.sources.length; fe++) {
          var pe = re.sources[fe];
          if (pe.active) {
            ue = pe;
            break;
          }
        }
      var me = ue.file, ye = Cn(me), _e = Mn(ye), Ee = ue.type || _e, ke = ue.mineType || fr(Ee), Re = re.isLive, xe = re.image, Ge = re.alwaysDisplayImage, qe = re.title, Ze = re.highlights, We = re.playbackMessages, ze = ue.isTimeShift, Ve = typeof re.reloadAfterPausing == "undefined" ? !!ue.reloadAfterPausing : re.reloadAfterPausing, st = typeof re.reloadAfterPausingTime == "undefined" ? ue.reloadAfterPausingTime : re.reloadAfterPausingTime, gt = re.isHideProgress;
      return {
        file: me,
        absoluteFile: ye,
        mineType: ke,
        type: Ee,
        isLive: Re,
        image: xe,
        alwaysDisplayImage: Ge,
        title: qe,
        highlights: Ze,
        playbackMessages: We,
        item: re,
        source: ue,
        isTimeShift: ze,
        reloadAfterPausing: Ve,
        reloadAfterPausingTime: st,
        isHideProgress: gt
      };
    }
    function Rr(ae) {
      var ie = this._config.playlist, re = ie.length, K = 0, te;
      return Ce("number", ae) && ae < re ? te = ie[ae] : (ie.forEach(function(ue, fe) {
        ue.defaultPlay && (te = ue, ae = fe);
      }), te || (te = ie[0], ae = 0)), te.sources.forEach(function(ue, fe) {
        ue.defaultPlay && (K = fe);
      }), $r.call(this, ae, K);
    }
    function $r(ae) {
      var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, re = this._config.playlist, K = !!re[ae];
      if (!K)
        return K;
      for (var te = 0; te < re.length; te++) {
        re[te].active = te === ae;
        for (var ue = 0; ue < re[te].sources.length; ue++)
          re[te].sources[ue] = oe({}, re[te].sources[ue], {
            active: ue === ie
          });
      }
      return K;
    }
    function pi() {
      for (var ae, ie = 0; ie < this._config.playlist.length; ie++) {
        var re = this._config.playlist[ie];
        if (re.active) {
          ae = re;
          break;
        }
      }
      return ae.sources;
    }
    function mi() {
      var ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, ie = this._config.playbackRates, re = !!ie[ae];
      if (!re && ae !== "null")
        return re;
      for (var K = 0; K < ie.length; K++)
        ie[K].active = !1, ie[K].active = K === ae;
      return re;
    }
    var Cn = function(ie) {
      var re = document.createElement("a");
      return re.setAttribute("href", ie), re.href;
    }, Mn = function(ie) {
      var re = ie.match(/^https?:[^?]+(\.(\w+))\??(?![.\w/])/), K = ie.match(/^([a-zA-Z]+):.*/), te = ie.match(/^webrtc:[^?]+(\.(\w+))\??(?![.\w/])/);
      return re ? re[2] : K ? K[1] : te ? "webrtc" : "";
    }, fr = function(ie) {
      var re = {
        aac: "audio/mp4",
        mp4: "video/mp4",
        f4v: "video/mp4",
        m4v: "video/mp4",
        mov: "video/mp4",
        mp3: "audio/mpeg",
        mpeg: "audio/mpeg",
        ogv: "video/ogg",
        ogg: "video/ogg",
        oga: "video/ogg",
        vorbis: "video/ogg",
        webm: "video/webm",
        f4a: "video/aac",
        m3u8: "application/vnd.apple.mpegurl",
        m3u: "application/vnd.apple.mpegurl",
        hls: "application/vnd.apple.mpegurl",
        flv: "video/x-flv",
        rtmp: "rtmp/flv",
        dash: "application/dash+xml",
        mpd: "application/dash+xml"
      };
      return re[ie] || "";
    }, pr = [], Nr = [];
    function Fn(ae, ie) {
      var re = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, K = be(re ? Nr : pr);
      if (K.filter(function(pe) {
        return ae === pe.name;
      }).length > 0) {
        console.warn("provider [".concat(ae, "] is existed, so it will not be register twice, you can change a name and retry"));
        return;
      }
      var te = ie.isHTML5(), ue = ie.isFlash(), fe = ie.isPlaybackRateSupported();
      if (te || ue)
        K.push({
          name: ae,
          html5: te,
          flash: ue,
          isPlaybackRateSupported: fe,
          Provider: ie
        }), re ? (Ur({
          extraProvider: ne({}, ae, ie.defaultOptions)
        }), Nr = K) : (Ur({
          provider: ne({}, ae, ie.defaultOptions)
        }), pr = K);
      else
        throw new TypeError("registerProvider(name, Provider): Provider should extends HTML5Provider or FlashProvider");
    }
    function Is(ae, ie) {
      Fn(ae, ie, !0);
    }
    function kn() {
      return pr;
    }
    function On() {
      return Nr;
    }
    function As(ae) {
      for (var ie = 0; ie < pr.length; ie++) {
        var re = pr[ie];
        if (re.name === ae)
          return re;
      }
    }
    function ws(ae) {
      var ie = Nr.filter(function(re) {
        return re.name === ae;
      });
      if (ie.length === 1)
        return ie[0];
    }
    function Ps() {
      return kn().filter(function(ae) {
        return ae.Provider.isSupported();
      });
    }
    function Ls() {
      return On().filter(function(ae) {
        return ae.Provider.isSupported();
      });
    }
    function Cs(ae, ie) {
      var re = ie.length, K = ie.indexOf("html5"), te = ie.indexOf("flash"), ue = ae.map(function(fe) {
        var pe = ie.indexOf(fe.name), me = 0, ye = 0;
        pe >= 0 && (me += re - pe), K >= 0 && fe.html5 && (ye += re - K), te >= 0 && fe.flash && (ye += re - te);
        var _e = Math.max(me, ye);
        return me > 0 && ye > 0 && (_e += 0.5), {
          p: fe,
          name: fe.name,
          w: _e
        };
      });
      return ue.sort(function(fe, pe) {
        return pe.w - fe.w;
      }), ue.map(function(fe) {
        return fe.p;
      });
    }
    function xr(ae) {
      var ie = ae.type, re = ae.mineType, K = ae.url, te = ae.isLive, ue = ae.isTimeShift, fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], pe = fe.filter(function(Ee) {
        return Ee !== "vr";
      }), me = Ps(), ye = me.filter(function(Ee) {
        var ke = Ee.Provider, Re = ke.canPlay({
          file: K,
          type: ie,
          mimeType: re,
          isLive: te,
          isTimeShift: ue
        });
        return !!Re;
      }), _e = Cs(ye, pe);
      return _e[0];
    }
    function Ms(ae, ie) {
      var re = ae.type, K = ae.mineType, te = ae.url, ue = ae.isLive, fe = ae.isTimeShift, pe = Ls(), me = pe.filter(function(ye) {
        var _e = ye.Provider, Ee = _e.canPlay({
          file: te,
          type: re,
          mimeType: K,
          isLive: ue,
          isTimeShift: fe
        });
        return !!Ee;
      });
      return me;
    }
    var gi = {
      mute: !1,
      autoplay: !1,
      repeat: !1,
      playbackRatesLabel: "",
      playbackRates: [],
      trtcFallback: !0,
      controls: !0,
      videoLayerControl: !0,
      aspectratio: "",
      height: 270,
      width: 480,
      displaytitle: !0,
      displaydescription: !0,
      stretching: "contain",
      qualityLabels: "",
      renderLoading: "",
      fullscreenEmulation: !1,
      preload: "none",
      playlist: [],
      skin: {
        name: "default",
        url: "https://static.mudu.tv/mudu-player/0.40.3/mudu-player.css"
      },
      logo: {
        file: "",
        hide: !1,
        link: "",
        marginw: "3%",
        marginh: "6%",
        width: "15%",
        height: "10%",
        opacity: 1,
        position: "top-right"
      },
      providerOrder: ["hlsjs", "html5"],
      plugin: {},
      provider: {
        flvjs: {
          "flv.js": {
            fixAudioTimestampGap: !0
          }
        }
      },
      extraProvider: {
        vr: {
          use: !1
        }
      },
      fileCdnPath: "https://static.mudu.tv/mudu-player/0.40.3/assets",
      videoAttributes: oe({
        "x5-video-player-type": "h5-page",
        "webkit-playsinline": "true",
        playsinline: "",
        "x-webkit-airplay": "allow",
        "mtt-playsinline": !0
      }, $t() ? {
        loop: !0
      } : {}),
      contextMenus: [{
        key: "version",
        text: "v0.40.3"
      }],
      errorLogUrl: "",
      perfLogUrl: "",
      renderError: null,
      language: "auto",
      localization: Es,
      showSubtitle: !1,
      myunSyncTextTrackLabel: "ppt_sync",
      uniqId: "",
      enableErrorRetry: !1,
      errorMaxRetry: 10,
      errorMaxRetryTimeout: 15e3,
      errorRetryDelay: 3e3,
      recordRestrict: {
        enable360LoneWindowCloseStream: !1
      },
      bufferDetectGap: 200,
      textTrackDisable: !1
    };
    function Rn(ae, ie) {
      var re = oe({}, ae, ie);
      Ce("array", ie.playbackRates) && (re.playbackRates = ie.playbackRates, re.playbackRatesLabel = ie.playbackRatesLabel || re.playbackRatesLabel), re.playlist = ie.playlist, re.providerOrder = (Ce("array", ie.providerOrder) ? ie.providerOrder : ae.providerOrder).slice();
      var K = Ce("object", ie.skin) ? ie.skin : {};
      re.skin = oe({}, ae.skin, K);
      var te = Ce("object", ie.logo) ? ie.logo : {};
      re.logo = oe({}, ae.logo, te);
      var ue = Ce("object", ie.recordRestrict) ? ie.recordRestrict : {};
      re.recordRestrict = oe({}, ae.recordRestrict, ue), re.localization = oe({}, ae.localization), Zt(ie.localization || {}).forEach(function(Ze) {
        Ce("object", ie.localization[Ze]) && (re.localization[Ze] = oe({}, re.localization.en, ae.localization[Ze] || {}, ie.localization[Ze]));
      });
      var fe = Ce("object", ie.videoAttributes) ? ie.videoAttributes : {};
      re.videoAttributes = oe({}, ae.videoAttributes, fe);
      var pe = ae.contextMenus, me = ie.contextMenus;
      if (Ce("function", me) ? re.contextMenus = me(pe) : Ce("array", ie.contextMenus) ? re.contextMenus = me : re.contextMenus = pe, Ce("object", ie.plugin)) {
        var ye = ae.plugin || {};
        for (var _e in ie.plugin) {
          var Ee = ye[_e] || {}, ke = ie.plugin[_e] || {};
          ye[_e] = oe({}, Ee, ke);
        }
        re.plugin = ye;
      }
      if (Ce("object", ie.provider)) {
        var Re = ae.provider || {};
        for (var xe in ie.provider) {
          var Ge = Re[xe] || {}, qe = ie.provider[xe] || {};
          Re[xe] = oe({}, Ge, qe);
        }
        re.provider = Re;
      }
      return re;
    }
    function vi(ae) {
      if (Ce("array", ae)) {
        var ie = [];
        if (ae.forEach(function(re) {
          var K = {};
          Dr(K, re, [
            "isLive",
            "image",
            "alwaysDisplayImage",
            "isHideProgress",
            "description",
            "title",
            "mediaid",
            "defaultPlay",
            "reloadAfterPausing",
            "reloadAfterPausingTime",
            "highlights",
            "playbackMessages"
          ]), Ce("string", re.file) && re.file !== "" ? (K.sources = [{
            file: re.file,
            type: re.type,
            mineType: re.mineType
          }], Dr(K.sources[0], re, ["type"]), ie.push(K)) : Ce("array", re.sources) && Ce("object", re.sources[0]) && Ce("string", re.sources[0].file) && re.sources[0].file !== "" && (K.sources = [], re.sources.forEach(function(te, ue) {
            if (Ce("string", te.file) && te.file !== "") {
              var fe = {
                file: te.file,
                index: ue
              };
              Dr(fe, te, ["type", "mineType", "label", "isTimeShift", "defaultPlay", "reloadAfterPausing", "reloadAfterPausingTime", "path", "path_name"]), K.sources.push(fe);
            }
          }), ie.push(K));
        }), Ce("array", ie) && Ce("object", ie[0]) && Ce("array", ie[0].sources) && Ce("object", ie[0].sources[0]) && Ce("string", ie[0].sources[0].file) && ie[0].sources[0].file !== "")
          return ie = ie.map(function(re) {
            re.allSources = re.sources.map(function(te) {
              return oe({}, te);
            });
            var K = re.sources.filter(function(te) {
              var ue = te.file, fe = Cn(ue), pe = Mn(fe), me = te.type || pe, ye = te.mineType || fr(me), _e = re.isLive, Ee = re.isTimeShift, ke = xr({
                type: me,
                mineType: ye,
                url: ue,
                isLive: _e,
                isTimeShift: Ee
              }, []);
              return !!ke;
            });
            return K.length !== 0 && (re.sources = K), re;
          }), ie;
      }
    }
    function $n(ae) {
      var ie = ["type", "mineType", "isLive", "file", "image", "description", "title", "playlist", "highlights"], re = {};
      for (var K in ae)
        ie.indexOf(K) < 0 && ae !== void 0 && (re[K] = ae[K]);
      if (Ce("array", ae.playlist))
        re.playlist = vi(ae.playlist);
      else if (Ce("string", ae.file) && ae.file) {
        var te = {};
        Dr(te, ae, ["isLive", "image", "alwaysDisplayImage", "description", "isHideProgress", "highlights"]);
        var ue = {
          file: ae.file,
          type: ae.type,
          mineType: ae.mineType,
          label: "default",
          isTimeShift: !!ae.isTimeShift || !1,
          reloadAfterPausing: !!ae.reloadAfterPausing,
          reloadAfterPausingTime: ae.reloadAfterPausingTime
        };
        te.sources = [ue], re.playlist = [te];
      }
      return re;
    }
    function Dr(ae, ie, re) {
      re.forEach(function(K) {
        Ce("undefined", ie[K]) || (ae[K] = ie[K]);
      });
    }
    function Nn() {
      return gi;
    }
    function Ur(ae) {
      gi = Rn(gi, $n(ae));
    }
    var mr = "mudu-icon-play", xn = "mudu-icon-pause", Fs = "mudu-icon-volume-up", ks = "mudu-icon-volume-down", Os = "mudu-icon-volume-off", Dn = "mudu-icon-fullscreen", Rs = "mudu-icon-fullscreen-off", $s = "mudu-icon-setting", Ns = "mudu-icon-load", Un = "mudu-icon-check", Hn = "mudu-icon-error", Hr = /mudu-icon-[\w-]+/, Vn = "mudu-aspect", xs = "mudu-mask", yi = "mudu-video-wrap", _i = "mudu-video", Ds = "mudu-hide-video", Bn = "mudu-logo-link", bi = "mudu-logo", Gn = "mudu-video-title", Ti = "mudu-video-danmaku", Si = "mudu-subtitle", Wn = "mudu-subtitle-item", jn = "mudu-bezel", zn = "mudu-base-layer", qn = "mudu-controller-wrap", Kn = "mudu-controller-mask", Yn = "mudu-controller-blank", Xn = "mudu-big-play-btn", Qn = "mudu-controller", Jn = "mudu-icons", Us = "mudu-icons-left", Yt = "mudu-icon", Ei = "mudu-switch-text", Hs = "mudu-switch-speed", Zn = "mudu-switch-quality", ea = "mudu-switch-path", ta = "mudu-volume", ra = "mudu-volume-bar-wrap", ia = "mudu-volume-bar", na = "mudu-volume-bar-inner", aa = "mudu-thumb", Vs = "mudu-time", oa = "mudu-ptime", sa = "mudu-dtime", la = "mudu-bar-wrap", Bs = "mudu-bar-preview", ua = "mudu-bar-popup", Ii = "mudu-bar-popup-text", ca = "mudu-bar-img", Gs = "mudu-bar-text-wrap", da = "mudu-bar-text", ha = "mudu-bar-text-time", fa = "mudu-bar-text-text", pa = "mudu-bar-time", Ws = "mudu-bar-time-wrap", js = "mudu-bar", ma = "mudu-loaded", ga = "mudu-played", va = "mudu-highlight", gr = "mudu-dot", Ai = "mudu-panel", ya = "mudu-live-badge", zs = "mudu-live-dot", _a = "mudu-icons-right", ba = "mudu-bezel-transition", qs = "hidden", Ta = "mudu-flash", Sa = "mudu-flash-tip", Ks = "mudu-flash-tip-inner", Ea = "mudu-error-icon", Vr = "mudu-error-text", Ia = "mudu-error-wrap", Aa = "mudu-error-inner", wa = "mudu-restrict-360", Pa = "mudu-background", La = "mudu-always-display-bg", Ca = "mudu-watermark", wi = "mudu-menuitem", Ys = "mudu-menuitem-label", Xs = "mudu-contextmenu-panel", Ma = "mudu-panel-menu", Qs = "mudu-menuitem-label", Fa = "mudu-play-back-rate-panel", Js = "mudu-play-back-rate-panel-mobile", ka = "mudu-quality-wrap", Zs = "mudu-path-wrap", Pi = "mudu-quality-menu", rr = "mudu-quality-menu-item", Oa = "mudu-quality-menu-item-tip", ir = "mudu-quality-item-name", el = "mudu-path-multi", Ra = "mudu-quality-menu-item-wrap", Li = "mudu-path-select-wrap", $a = "mudu-path-select-menu", tl = "mudu-path-select-menu-item", Na = "mudu-notice", Br = "mudu-live", xa = "mudu-playback", rl = "mudu", il = "mudu-fullscreen", Ci = "mudu-fullscreen-landscape-right", Da = "mudu-aspect-mode", nl = "mudu-normal-mode", Mi = "mudu-hide-controller", Fi = "mudu-hide-time", al = "mudu-state-idle", ki = "mudu-state-error", ol = "mudu-stretch", sl = "mudu-provider-flash", ll = "mudu-provider-html5", ul = "mudu-provider-ready", cl = "mudu-skin", Gr = "mudu-mobile", Ua = "mudu-flash-disabled", nr = "mudu-hide-everything", dl = "mudu-hide-setting", hl = "mudu-flag-dragging", Oi = "mudu-flag-small-player", fl = "mudu-duration-valid", Ri = "mudu-time-shift", Ha = "mudu-play-back-rate", pl = "mudu-play-back-rate-hide", ml = "mudu-play-back-rate-show", gl = "mudu-player-vr-mode", Wr = "mudu-hide-progress", Va = "mudu-hide-custom-control", $i = "mudu-time-shift-live", Ni = /mudu-state-\w+/, vl = /mudu-stretch-\w+/, Ba = /mudu-provider-\w+/, yl = /mudu-play-back-rate-\w+/, Ga = "mudu-bezel-icon", _l = "mudu-loading-icon", bl = "mudu-extra-loading-icon", Wa = "mudu-caption-icon", ja = "mudu-setting-icon", za = "mudu-fullscreen-icon", qa = "mudu-play-icon", Ka = "mudu-volume-icon", Ya = "mudu-icon-custom-control", jr = "mudu-hide", pt = "mudu-active", Pe = "mudu-reset", Tl = "mudu-non-scrollable", Xa = {}, vr = {
      NEW: 0,
      LOADING: 1,
      ERROR: 2,
      COMPLETE: 3
    }, mt = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K, te = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        return $(this, ie), K = he(this, le(ie).call(this)), K.url = re, K.isStyle = te, K.status = vr.NEW, K;
      }
      return ee(ie, [{
        key: "getElement",
        value: function() {
          if (this.isStyle) {
            var K = document.createElement("link");
            return K.type = "text/css", K.rel = "stylesheet", K.href = this.url, K;
          } else {
            var te = document.createElement("script");
            return te.src = this.url, te;
          }
        }
      }, {
        key: "getStatus",
        value: function() {
          return this.status;
        }
      }, {
        key: "load",
        value: function() {
          var K = this;
          this.status !== vr.NEW && Promise.reject(new Error("loader.load can only call once"));
          var te = Xa[this.url];
          if (te && te.isStyle === this.isStyle) {
            var ue = te.loader.getStatus();
            if (ue === vr.COMPLETE)
              return setTimeout(function() {
                K.trigger("done");
              }, 0), Promise.resolve();
          }
          var fe = document.getElementsByTagName("head")[0] || document.documentElement, pe = this.getElement(), me = this;
          return new Promise(function(ye, _e) {
            var Ee = !1;
            pe.onload = pe.onreadystatechange = function(ke) {
              !Ee && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") && (pe.onload = pe.onreadystatechange = null), Ee = !0, setTimeout(function() {
                me.trigger("done"), me.status = vr.COMPLETE, ye();
              }, 0);
            }, pe.onerror = function(ke) {
              me.trigger("error"), _e(ke);
            }, fe.insertBefore(pe, fe.firstChild), me.status = vr.LOADING, Xa[me.url] = {
              isStyle: me.isStyle,
              loader: me
            };
          });
        }
      }]), ie;
    }(Kt), Sl = "internal_option_merged", El = "internal_dom_inited", Il = "internal_model_inited", Al = "internal_plugin_inited", et = "internal_provider_inited", Pt = "internal_provider_removed", wl = "internal_plugin_init", Pl = "internal_status_formated", yr = "internal_key_down", Qa = "internal_style_loaded", zr = "internal_language_change", xi = "internal_playlist_loaded", Di = "contextMenuClick", _r = "play", Ll = "pause", Ja = "videoLayerControl", Za = "controls", eo = "controlsVisible", Ui = "fullscreen", Cl = "complete", Ml = "playlistComplete", to = "playlist", qr = "playlistItem", ro = "switchQuality", Hi = "time", Vi = "duration", io = "resize", Fl = "buffer", Bi = "idle", Bt = "beforePlay", kl = "mute", Ol = "volume", no = "canSeek", Rl = "seek", $l = "seeked", Dt = "error", ao = "textTrackChange", Kr = "textTrackAdd", Yr = "textTrackCueChange", oo = "liveEndDetect", Nl = "trtc:fallback", xl = "trtc:autoplayFail", Dl = "xp2p:rollback", Ul = "beforeSmoothSwitching", Hl = "afterSmoothSwitching", so = "all", lo = "ended", Vl = "bufferchange", uo = "timeupdate", co = "duration", Bl = "stageclick", Gl = "stagedoubleclick", ho = "play", Xr = "pause", Wl = "mute", jl = "volume", zl = "seeked", ql = "seek", Ot = "error", Kl = "loadeddata", Yl = "waiting", fo = "texttrackadd", po = "texttrackchange", mo = "cuechange", Xl = "canplay";
    function Ql() {
      var ae = this, ie = this._container, re = this.dom;
      Ae(ie).add(nr);
      var K = this._config.skin, te = new mt(K.url, !0);
      te.load().then(function() {
        Ae(ie).remove(nr), ae.trigger(Qa);
      });
      var ue = Zl(this._status.localization, this._config.fileCdnPath);
      ie.innerHTML = ue, Ae(ie).add(Pe), Ae(ie).add(rl), Ae(ie).add(dl), Ae(ie).add("".concat(cl, "-").concat(K.name)), rt() && Ae(ie).add(Gr), re.container = ie, re.baseLayer = ie.querySelector(".".concat(zn)), re.aspect = ie.querySelector(".".concat(Vn)), re.fullscreen = ie.querySelector(".".concat(za)), re.caption = ie.querySelector(".".concat(Wa)), re.video = ie.querySelector("video"), re.videoWrap = ie.querySelector(".".concat(yi)), re.controllerWrap = ie.querySelector(".".concat(qn)), re.controller = ie.querySelector(".".concat(Qn)), re.controllerMask = ie.querySelector(".".concat(Kn)), re.controllerBlank = ie.querySelector(".".concat(Yn)), re.controllerRightIcons = ie.querySelector(".".concat(_a)), re.leftPlayBtn = ie.querySelector(".".concat(qa)), re.volumeWrap = ie.querySelector(".".concat(ta)), re.volumeButton = ie.querySelector(".".concat(Ka)), re.volumeBar = ie.querySelector(".".concat(na)), re.volumeBarWrap = ie.querySelector(".".concat(ia)), re.volumeBarWrapWrap = ie.querySelector(".".concat(ra)), re.playedBar = ie.querySelector(".".concat(ga)), re.loadedBar = ie.querySelector(".".concat(ma)), re.playedBarWrap = ie.querySelector(".".concat(la)), re.barPopup = ie.querySelector(".".concat(ua)), re.barImg = ie.querySelector(".".concat(ca)), re.barTime = re.playedBarTime = ie.querySelector(".".concat(pa)), re.barText = ie.querySelector(".".concat(da)), re.barTextTime = ie.querySelector(".".concat(ha)), re.barTextText = ie.querySelector(".".concat(fa)), re.ptime = ie.querySelector(".".concat(oa)), re.dtime = ie.querySelector(".".concat(sa)), re.logoWrap = ie.querySelector(".".concat(bi)), re.logoImg = ie.querySelector(".".concat(bi, " img")), re.logoLink = ie.querySelector(".".concat(Bn)), re.bezelWrap = ie.querySelector(".".concat(jn)), re.bezel = ie.querySelector(".".concat(Ga)), re.background = ie.querySelector(".".concat(Pa)), re.watermark = ie.querySelector(".".concat(Ca)), re.title = ie.querySelector(".".concat(Gn)), re.settingBtn = ie.querySelector(".".concat(ja)), re.errorWrap = ie.querySelector(".".concat(Ia)), re.errorText = ie.querySelector(".".concat(Vr)), re.highlight = ie.querySelector(".".concat(va)), re.flashTip = ie.querySelector(".".concat(Sa)), re.flash = ie.querySelector(".".concat(Ta)), re.notice = ie.querySelector(".".concat(Na)), re.switchQuality = ie.querySelector(".".concat(Zn)), re.switchPath = ie.querySelector(".".concat(ea)), re.bigPlayBtn = ie.querySelector(".".concat(Xn)), re.recordRestrict360 = ie.querySelector(".".concat(wa)), re.liveBadge = ie.querySelector(".".concat(ya)), re.playbackRate = ie.querySelector(".".concat(Ha)), re.pathSelectWrap = ie.querySelector(".".concat(Li)), this.trigger(El);
    }
    function Jl() {
      this._container.innerHTML = "", Ae(this._container).remove(/mudu-.*/), Ae(this._container).remove("mudu");
    }
    function Zl(ae, ie, re) {
      var K = "<style>" + ".mudu.".concat(nr, " {background: #000;}") + ".mudu.".concat(nr, " div {display: none !important;}") + ".mudu.".concat(nr, " span {display: none !important;}") + ".mudu.".concat(nr, " button {display: none !important;}") + `@font-face{font-family:'mudu-icons';src:url("`.concat(ie, '/fonts/mudu-icons.eot?yyls80");src:url("').concat(ie, '/fonts/mudu-icons.eot?yyls80#iefix") format("embedded-opentype"),url("').concat(ie, '/fonts/mudu-icons.ttf?yyls80") format("truetype"),url("').concat(ie, '/fonts/mudu-icons.woff?yyls80") format("woff"),url("').concat(ie, '/fonts/mudu-icons.svg?yyls80#mudu-icons") format("svg");font-weight:normal;font-style:normal}') + "</style>" + '<div class="'.concat(Pe, " ").concat(Vn, '"></div>') + '<div class="'.concat(Pe, " ").concat(xs, '"></div>') + '<div class="'.concat(Pe, " ").concat(yi, '">') + '<div class="'.concat(Pe, " ").concat(Ta, '"></div>') + '<div class="'.concat(Pe, " ").concat(Pa, '"></div>') + '<div class="'.concat(Pe, " ").concat(Ca, '"></div>') + '<div class="'.concat(Pe, " ").concat(jn, '">') + '<span class="'.concat(Pe, " ").concat(Ga, '"></span>') + "</div></div>" + '<div class="'.concat(Pe, " ").concat(zn, '"></div>') + '<div class="'.concat(Pe, " ").concat(bi, '">') + '<a class="'.concat(Pe, " ").concat(Bn, '" target="_blank"><img style="display: none;" /></a>') + "</div>" + '<div class="'.concat(Pe, " ").concat(Ti, '"></div>') + '<div class="'.concat(Pe, " ").concat(Ia, '">') + '<div class="'.concat(Pe, " ").concat(Aa, '">') + '<div class="'.concat(Pe, " ").concat(Ea, '"><span class="').concat(Pe, " ").concat(Hn, '"></span></div>') + '<div class="'.concat(Pe, " ").concat(Vr, '">There is some error: </div>') + "</div></div>" + '<div class="'.concat(Pe, " ").concat(qn, '">') + '<div class="'.concat(Pe, " ").concat(Yn, '"></div>') + '<div class="'.concat(Pe, " ").concat(Gn, '"></div>') + '<div class="'.concat(Pe, " ").concat(Xn, '">') + '<button type="button" class="'.concat(Pe, " ").concat(Yt, " ").concat(mr, '"></button>') + "</div>" + '<div class="'.concat(Si, '">') + "</div>" + '<div class="'.concat(Pe, " ").concat(Kn, '"></div>') + '<div class="'.concat(Pe, " ").concat(Qn, '">') + '<div class="'.concat(Pe, " ").concat(Jn, " ").concat(Us, '">') + '<button type="button" class="'.concat(Pe, " ").concat(Yt, " ").concat(qa, '">') + "</button>" + '<div class="'.concat(Pe, " ").concat(ta, '">') + '<button type="button" class="'.concat(Pe, " ").concat(Yt, " ").concat(Ka, '" mudu-tooltip placement="top" tooltip-title="').concat(ae.Mute, '">') + "</button>" + '<div class="'.concat(Pe, " ").concat(ra, '">') + '<div class="'.concat(Pe, " ").concat(ia, '">') + '<div class="'.concat(Pe, " ").concat(na, '">') + '<span class="'.concat(Pe, " ").concat(aa, '" style="background: #b7daff;">') + "</span></div></div></div></div>" + '<span class="'.concat(Pe, " ").concat(ya, '" mudu-tooltip placement="top" tooltip-title="').concat(ae["Skip ahead to live broadcast"], '">') + '<span class="'.concat(Pe, " ").concat(zs, '"></span>') + "Live</span>" + '<span class="'.concat(Pe, " ").concat(Vs, '">') + '<span class="'.concat(Pe, " ").concat(oa, '"></span>') + " / " + '<span class="'.concat(Pe, " ").concat(sa, '"></span>') + "</span></div>" + '<div class="'.concat(Pe, " ").concat(Jn, " ").concat(_a, '">') + '<span role="button" class="'.concat(Pe, " ").concat(Ei, " ").concat(ea, '"></span>') + '<span role="button" class="'.concat(Pe, " ").concat(Ei, " ").concat(Zn, '"></span>') + '<span role="button" class="'.concat(Pe, " ").concat(Ei, " ").concat(Ha, " ").concat(Hs, '"></span>') + '<button type="button" class="'.concat(Pe, " ").concat(Yt, " ").concat(Wa, '"></button>') + '<button type="button" class="'.concat(Pe, " ").concat(Yt, " ").concat(ja, " ").concat($s, '"></button>') + '<button type="button" class="'.concat(Pe, " ").concat(Yt, " ").concat(za, '" mudu-tooltip placement="top" tooltip-title="').concat(ae["Full screen"], '"></button>') + '<span type="button" class="'.concat(Pe, " ").concat(Yt, " ").concat(Ya, '"></span>') + "</div>" + '<div class="'.concat(Pe, " ").concat(la, '">') + '<div class="'.concat(Pe, " ").concat(ua, " ").concat(qs, '">') + '<div class="'.concat(Pe, " ").concat(Bs, '">') + '<div class="'.concat(Pe, " ").concat(ca, '"></div>') + '<div class="'.concat(Pe, " ").concat(Ws, '">') + '<div class="'.concat(Pe, " ").concat(pa, '"></div>') + "</div></div>" + '<div class="'.concat(Pe, " ").concat(Gs, '">') + '<div class="'.concat(Pe, " ").concat(da, '">') + '<span class="'.concat(Pe, " ").concat(ha, '"></span>') + '<span class="'.concat(Pe, " ").concat(fa, '"></span>') + "</div></div></div>" + '<div class="'.concat(Pe, " ").concat(js, '">') + '<div class="'.concat(Pe, " ").concat(ma, '"></div>') + '<div class="'.concat(Pe, " ").concat(ga, '" style="background: #f00;">') + '<span class="'.concat(Pe, " ").concat(aa, '" style="background: #f00;"></span>') + "</div>" + '<div class="'.concat(Pe, " ").concat(va, '"></div>') + "</div></div></div></div>" + '<div class="'.concat(Pe, " ").concat(Sa, '">') + '<div class="'.concat(Pe, " ").concat(Ks, '"><a href="http://www.adobe.com/go/getflash" target="_blank">\u68C0\u6D4B\u5230\u60A8\u8FD8\u672A\u5B89\u88C5flash, \u8BF7\u70B9\u51FB\u8FD9\u91CC\u5B89\u88C5</a></div>') + "</div>" + '<div class="'.concat(Pe, " ").concat(Na, " ").concat(jr, '"></div>') + '<div class="'.concat(Pe, " ").concat(wa, " ").concat(jr, '"></div>');
      return K;
    }
    function Je(ae, ie) {
      if (!(this instanceof Je))
        return new Je(ae, ie);
      this.proto = ae, this.target = ie;
    }
    Je.prototype.method = function(ae) {
      var ie = this.proto, re = this.target;
      return ie[ae] = function() {
        return At() && console.log("[delegates]: (".concat(ie.constructor.name, " | ").concat(re.constructor.name, ").").concat(ae, " --"), tr([].slice.call(arguments))), re.TAG === "model" && this.trigger("delegate-model", {
          fn: ae,
          args: [].slice.call(arguments)
        }), re[ae].apply(re, arguments);
      }, this;
    };
    var Ye = /* @__PURE__ */ function() {
      function ae(ie) {
        $(this, ae), this.player = ie, this.m_player_events = [], this.m_dom_events = [], this.m_provider_events = [], this.m_removed = !1, this.TAG = "model";
      }
      return ee(ae, [{
        key: "provider",
        value: function() {
          return this.player._provider && this.player._provider.instance;
        }
      }, {
        key: "remove",
        value: function() {
          var re = this;
          this.m_removed = !0, this.m_player_events.forEach(function(K) {
            return re.player.off(K.evt, K.fn);
          }), this.m_dom_events.forEach(function(K) {
            return at(K.ele, K.evt, K.fn);
          }), this.m_provider_events.forEach(function(K) {
            re.provider() && re.provider().off(K.evt, K.fn);
          });
        }
      }, {
        key: "onPlayer",
        value: function(re, K) {
          this.player.on(re, K), this.m_player_events.push({
            evt: re,
            fn: K
          });
        }
      }, {
        key: "oncePlayer",
        value: function(re, K) {
          this.player.once(re, K), this.m_player_events.push({
            evt: re,
            fn: K
          });
        }
      }, {
        key: "onDom",
        value: function(re, K, te) {
          Qe(re, K, te), re === this.player.dom.container && this.m_dom_events.push({
            ele: re,
            evt: K,
            fn: te
          });
        }
      }, {
        key: "onProvider",
        value: function(re, K) {
          this.provider() && (this.provider().on(re, K), this.m_provider_events.push({
            evt: re,
            fn: K
          }));
        }
      }, {
        key: "onceProvider",
        value: function(re, K) {
          this.provider() && (this.provider().once(re, K), this.m_provider_events.push({
            evt: re,
            fn: K
          }));
        }
      }, {
        key: "lang",
        get: function() {
          return this.player._status.localization;
        }
      }]), ae;
    }(), or = function() {
      for (var ae, ie = [
        ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
        ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
        ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
        ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
        ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
      ], re = 0, K = ie.length, te = {}; re < K; re++)
        if (ae = ie[re], ae && ae[1] in document) {
          for (re = 0; re < ae.length; re++)
            te[ie[0][re]] = ae[re];
          return te;
        }
      return !1;
    }();
    function eu(ae) {
      ae[or.requestFullscreen]();
    }
    function tu() {
      document[or.exitFullscreen]();
    }
    function Gi() {
      return Boolean(document[or.fullscreenEnabled]);
    }
    function ru(ae) {
      Qe(document, or.fullscreenchange, ae);
    }
    function iu(ae) {
      at(document, or.fullscreenchange, ae);
    }
    function nu() {
      return document[or.fullscreenElement];
    }
    var au = {
      trigger: "hover",
      placement: "top",
      container: document.body,
      distance: 10,
      content: "",
      getMaxHeight: function() {
        return "none";
      },
      class: "mudu-tooltip"
    }, Wi = "-20000px", Ut = new Kt(), sr = [];
    function ou() {
      Qe(document, "mouseover", function(ae) {
        var ie = ae.target || ae.srcElement;
        ji(ie) && Ut.trigger("mouseover", ae, ie);
      }), Qe(document, "mouseout", function(ae) {
        var ie = ae.target || ae.srcElement;
        ji(ie) && Ut.trigger("mouseout", ae, ie);
      }), Qe(document, "click", function(ae) {
        var ie = ae.target || ae.srcElement;
        if (go()) {
          vo();
          return;
        }
        ji(ie) && Ut.trigger("click", ae, ie);
      });
    }
    function go() {
      return sr.filter(function(ae) {
        return ae.isShow();
      }).length > 0;
    }
    function su(ae) {
      return sr.filter(function(ie) {
        return ie.isShow() && ie.getConfig().class === ae;
      }).length > 0;
    }
    function vo() {
      sr.forEach(function(ae) {
        return ae.hide();
      });
    }
    function ji(ae) {
      return ae && ae.getAttribute("mudu-tooltip") === "";
    }
    function _t(ae) {
      var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      ae = typeof ae == "string" && ae ? document.querySelector(ae) : ae, ie = oe({}, au, ie), ae && ae.setAttribute("mudu-tooltip", "");
      var re = !0, K = Ee();
      xe(ie.content);
      var te = Ut.on("mouseover", function(ze, Ve) {
        Ve === ae && ie.trigger === "hover" && re && Ge();
      }), ue = Ut.on("mouseout", function(ze, Ve) {
        Ve === ae && ie.trigger === "hover" && We();
      }), fe = Ut.on("click", function(ze, Ve) {
        Ve === ae && ie.trigger === "click" && re && Ge();
      }), pe = function() {
        return oe({}, ie);
      }, me = {
        hide: We,
        isShow: ke,
        destroy: Re,
        getTooltipContainer: Ze,
        updateContent: xe,
        show: Ge,
        getConfig: pe,
        disable: ye,
        enable: _e
      };
      return sr.push(me), me;
      function ye() {
        re = !1, We();
      }
      function _e() {
        re = !0;
      }
      function Ee() {
        var ze = document.createElement("div");
        return ie.container.appendChild(ze), ze.setAttribute("class", "mudu-reset " + ie.class), Qe(ze, "click", function(Ve) {
          ie.wrapClick && ie.wrapClick(Ve), Ve.stopPropagation && Ve.stopPropagation(), Ve.cancelBubble = !0;
        }), ze.style.cssText = "position: absolute; top: 0; left: ".concat(Wi, "; opacity: 0; visibility: hidden;"), ze;
      }
      function ke() {
        return K && K.style.left !== Wi;
      }
      function Re() {
        var ze = sr.indexOf(me);
        ze < 0 || (Ut.off("mouseover", te), Ut.off("mouseout", ue), Ut.off("click", fe), K.parentElement.removeChild(K), ae && ae.removeAttribute("mudu-tooltip"), sr.splice(ze, 1));
      }
      function xe(ze) {
        typeof ze == "string" && (K.innerHTML = ze), F(ze) === "object" && (K.innerHTML = "", K.appendChild(ze));
      }
      function Ge() {
        var ze = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ve = ze.left, st = ze.top;
        if (qe(), Ve === void 0 && st === void 0 && ie.placement === "top") {
          var gt = ut(ie.container), Xt = ut(K), qt = ut(ae), G0 = ie.distance;
          Ve = qt.left + qt.width / 2 - Xt.width / 2 - gt.left, st = qt.top - Xt.height - G0 - gt.top, Ve + Xt.width > gt.right && (Ve = gt.right - Xt.width), Ve < 0 && (Ve = gt.left);
        }
        K.style.left = Ve + "px", K.style.top = st + "px", K.style.visibility = "visible", K.style.opacity = 1;
      }
      function qe() {
        var ze = ut(ie.container), Ve = ie.getMaxHeight(ze);
        K.style.maxHeight = yt(Ve);
      }
      function Ze() {
        return K;
      }
      function We() {
        K && (K.style.left = Wi, K.style.opacity = 0, K.style.visibility = "hidden");
      }
    }
    _t.isAnyShow = go, _t.hideAll = vo, _t.isAnyClassShow = su, ou();
    var Qr = {
      isAvailable: function() {
        return !!(window.screen && window.screen.orientation);
      },
      lock: function(ie) {
        var re = window.screen.orientation.lock(ie);
        return re;
      },
      unlock: function() {
        window.screen.orientation.unlock();
      },
      getType: function() {
        return window.screen.orientation.type;
      },
      getAngle: function() {
        return window.screen.orientation.angle;
      },
      getOrientationObj: function() {
        return window.screen.orientation;
      },
      isLandscape: function() {
        return window.screen.orientation.type.includes("landscape");
      },
      isPortrait: function() {
        return window.screen.orientation.type.includes("portrait");
      },
      isEstimatedPortrait: function() {
        return innerWidth / innerHeight < 1;
      }
    }, lu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.isFullscreen = !1, K.fullscreenEmulation = K.player._config.fullscreenEmulation, K.subEvents(), Je(K.player, ce(ce(K))).method("getFullscreen").method("setFullscreen"), Ae(K.player.dom.fullscreen).add(Dn), K.fullTip = _t(K.player.dom.fullscreen, {
          content: kr(K.lang["Full screen"]),
          container: K.player.dom.container
        }), K;
      }
      return ee(ie, [{
        key: "subEvents",
        value: function() {
          var K = this;
          this.onDom(this.player.dom.fullscreen, "click", function() {
            K.setFullscreen(!K.isFullscreen);
          }), this.onPlayer(et, function() {
            K.onProvider(Gl, function() {
              K.setFullscreen(!K.isFullscreen);
            });
          }), this.onPlayer(zr, function(te) {
            K.fullTip.updateContent(kr(K.isFullscreen ? K.lang["Exit full screen"] : K.lang["Full screen"]));
          }), this.fullscreenEmulation && (this.onDom(window, "orientationchange", function() {
            Ae(K.player.dom.container)[Qr.isLandscape() ? "remove" : "add"](Ci);
          }), this.onPlayer(yr, function(te) {
            te === 27 && K.isFullscreen && K.setFullscreen(!1);
          })), this.handleFullscreenChange = function(te) {
            var ue = nu();
            rt() && (!ue && !K.isFullscreen || ue && ue.nodeName === "VIDEO") || (ue && ue === K.player.dom.container && !K.isFullscreen || !ue && K.isFullscreen) && (K.isFullscreen = ue === K.player.dom.container, K.onAfterFullScreen());
          }, Gi() && ru(this.handleFullscreenChange), rt() || this.onDom(this.player.dom.videoWrap, "dblclick", function() {
            K.player._provider && K.player._provider.flash || K.player.getControls() && K.toggle();
          });
        }
      }, {
        key: "onAfterFullScreen",
        value: function() {
          var K = this.player.dom;
          this.player.trigger(Ui, {
            type: Ui,
            fullscreen: this.isFullscreen
          }), Ae(K.container).toggle(il), this.fullscreenEmulation && (this.isFullscreen && (Qr.isAvailable() ? Qr.isPortrait() : Qr.isEstimatedPortrait()) ? Ae(K.container).add(Ci) : Ae(K.container).remove(Ci)), Ae(K.fullscreen).remove(Hr), Ae(K.fullscreen).add(this.isFullscreen ? Rs : Dn), Ae(document.body).toggle(Tl), this.fullTip.updateContent(kr(this.isFullscreen ? this.lang["Exit full screen"] : this.lang["Full screen"]));
        }
      }, {
        key: "toggle",
        value: function() {
          this.setFullscreen(!this.getFullscreen());
        }
      }, {
        key: "getFullscreen",
        value: function() {
          return this.isFullscreen;
        }
      }, {
        key: "remove",
        value: function() {
          Gi() && iu(this.handleFullscreenChange), ge(le(ie.prototype), "remove", this).call(this);
        }
      }, {
        key: "setFullscreen",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, te = this.player.dom.container, ue = this.isFullscreen;
          if (this.fullscreenEmulation) {
            this.isFullscreen = K, this.onAfterFullScreen();
            return;
          }
          var fe = this.player.dom.container.querySelector(".".concat(_i)), pe = this.player._config.extraProvider.vr.use && this.player.dom.videoWrap.querySelector("canvas"), me = this.player._extraProviders.vr, ye = me && pe;
          ye || Gi() ? K ? !ue && eu(te) : ue && tu() : rt() && fe.webkitSupportsFullscreen ? K ? fe.webkitEnterFullScreen() : fe.webkitExitFullScreen() : (this.isFullscreen = K, this.onAfterFullScreen());
        }
      }]), ie;
    }(Ye), uu = function() {
      return new Error("method should be override");
    }, Gt = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this)), te.player = re, te.option = K, te.p_player_events = [], te.p_dom_events = [], te.p_self_events = [], te.removed = !1, te.TAG = "Provider", te;
      }
      return ee(ie, [{
        key: "loadFiles",
        value: function() {
          return Promise.resolve();
        }
      }, {
        key: "getMediaElement",
        value: function() {
        }
      }, {
        key: "createMediaElement",
        value: function() {
        }
      }, {
        key: "setup",
        value: function() {
          return Promise.reject(uu());
        }
      }, {
        key: "remove",
        value: function() {
          var K = this;
          this.p_player_events.forEach(function(te) {
            return K.player.off(te.evt, te.fn);
          }), this.p_dom_events.forEach(function(te) {
            return at(te.ele, te.evt, te.fn);
          }), this.p_self_events.forEach(function(te) {
            return K.off(te.evt, te.fn);
          }), this.removed = !0;
        }
      }, {
        key: "getVolume",
        value: function() {
        }
      }, {
        key: "setVolume",
        value: function() {
        }
      }, {
        key: "getMute",
        value: function() {
        }
      }, {
        key: "setMute",
        value: function() {
        }
      }, {
        key: "getWidth",
        value: function() {
          return -1;
        }
      }, {
        key: "getHeight",
        value: function() {
          return -1;
        }
      }, {
        key: "getMetrics",
        value: function() {
          return {};
        }
      }, {
        key: "getBuffer",
        value: function() {
          return [];
        }
      }, {
        key: "getCurrentTime",
        value: function() {
        }
      }, {
        key: "getDuration",
        value: function() {
        }
      }, {
        key: "setStretching",
        value: function() {
        }
      }, {
        key: "getStretching",
        value: function() {
        }
      }, {
        key: "getMetadata",
        value: function() {
        }
      }, {
        key: "play",
        value: function() {
        }
      }, {
        key: "pause",
        value: function() {
        }
      }, {
        key: "seek",
        value: function() {
        }
      }, {
        key: "getPlaybackRate",
        value: function() {
        }
      }, {
        key: "setPlaybackRate",
        value: function() {
        }
      }, {
        key: "getTextTracks",
        value: function() {
          return [];
        }
      }, {
        key: "setTextTrackActive",
        value: function(K) {
        }
      }, {
        key: "onPlayer",
        value: function(K, te) {
          this.player.on(K, te), this.p_player_events.push({
            evt: K,
            fn: te
          });
        }
      }, {
        key: "oncePlayer",
        value: function(K, te) {
          this.player.once(K, te), this.p_player_events.push({
            evt: K,
            fn: te
          });
        }
      }, {
        key: "onDom",
        value: function(K, te, ue) {
          var fe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
          Qe(K, te, ue), fe && this.p_dom_events.push({
            ele: K,
            evt: te,
            fn: ue
          });
        }
      }, {
        key: "onSelf",
        value: function(K, te) {
          this.on(K, te), this.p_self_events.push({
            evt: K,
            fn: te
          });
        }
      }, {
        key: "onceSelf",
        value: function(K, te) {
          this.once(K, te), this.p_self_events.push({
            evt: K,
            fn: te
          });
        }
      }]), ie;
    }(Kt);
    Gt.defaultOptions = {}, Gt.canPlay = Nt, Gt.isSupported = Nt, Gt.isPlaybackRateSupported = Nt, Gt.isFlash = Nt, Gt.isHTML5 = Nt;
    var cu = "application/x-shockwave-flash", yo = [], du = cr(), zi = nt(), Jr = Qi();
    function hu(ae, ie, re, K, te, ue, fe, pe, me, ye) {
      var _e = ie, Ee = {
        success: !1,
        id: _e
      };
      if (!(Jr && Jr < 312) && ae && ie && re && K && te) {
        qi(_e, !1);
        var ke = function() {
          re += "", K += "";
          var xe = {};
          if (me && F(me) === "object")
            for (var Ge in me)
              xe[Ge] = me[Ge];
          xe.data = ae, xe.width = re, xe.height = K;
          var qe = {};
          if (pe && F(pe) === "object")
            for (var Ze in pe)
              qe[Ze] = pe[Ze];
          if (fe && F(fe) === "object") {
            for (var We in fe)
              if (fe.hasOwnProperty(We)) {
                var ze = We, Ve = fe[We];
                typeof qe.flashvars != "undefined" ? qe.flashvars += "&" + ze + "=" + Ve : qe.flashvars = ze + "=" + Ve;
              }
          }
          if (fu(te)) {
            var st = pu(xe, qe, ie);
            xe.id === _e && qi(_e, !0), Ee.success = !0, Ee.ref = st, Ee.id = st.id;
          } else
            qi(_e, !0);
          ye && ye(Ee);
        };
        ke();
      } else
        ye && ye(Ee);
    }
    function qi(ae, ie) {
      var re = ie ? "visible" : "hidden", K = document.getElementById(ae);
      K.style.visibility = re;
    }
    function fu(ae) {
      return ae = parseFloat(ae), du >= ae;
    }
    function pu(ae, ie, re) {
      var K, te = document.getElementById(re);
      if (Jr && Jr < 312)
        return K;
      if (te) {
        var ue = zi ? document.createElement("div") : document.createElement("object"), fe, pe, me;
        typeof ae.id == "undefined" && (ae.id = re);
        for (me in ie)
          ie.hasOwnProperty(me) && me.toLowerCase() !== "movie" && gu(ue, me, ie[me]);
        zi && (ue = mu(ae.data, ue.innerHTML));
        for (fe in ae)
          ae.hasOwnProperty(fe) && (pe = fe.toLowerCase(), pe === "styleclass" ? ue.setAttribute("class", ae[fe]) : pe !== "classid" && pe !== "data" && ue.setAttribute(fe, ae[fe]));
        zi ? yo[yo.length] = ae.id : (ue.setAttribute("type", cu), ue.setAttribute("data", ae.data)), te.parentNode.replaceChild(ue, te), K = ue;
      }
      return K;
    }
    function mu(ae, ie) {
      var re = document.createElement("div");
      return re.innerHTML = "<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000'><param name='movie' value='" + ae + "'>" + ie + "</object>", re.firstChild;
    }
    function gu(ae, ie, re) {
      var K = document.createElement("param");
      K.setAttribute("name", ie), K.setAttribute("value", re), ae.appendChild(K);
    }
    var Wt = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this)), K.options = re || {}, K.gap = +K.options.gap || 1e3, K.isRaf = !!K.options.isRaf, K.task = null, K.dotTime = new Date().getTime(), K;
      }
      return ee(ie, [{
        key: "start",
        value: function() {
          this.trigger("start", {
            options: this.options
          }), this.stop(), this._startTimer();
        }
      }, {
        key: "tick",
        value: function() {
          var K = this._passedTime();
          !this.task || (this._clearTimer(), K > 0 && this.trigger("tick", {
            options: this.options,
            duration: K,
            isStop: !1
          }), this._startTimer());
        }
      }, {
        key: "stop",
        value: function() {
          var K = this._passedTime();
          !this.task || (this._clearTimer(), K > 0 && this.trigger("tick", {
            options: this.options,
            duration: K,
            isStop: !0
          }), this.trigger("stop", {
            options: this.options
          }));
        }
      }, {
        key: "_internalF",
        value: function() {
          var K = this._passedTime();
          K > 0 && this.trigger("tick", {
            options: this.options,
            duration: K,
            isStop: !1
          }), this._startTimer();
        }
      }, {
        key: "_clearTimer",
        value: function() {
          this.isRaf ? _s(this.task) : clearTimeout(this.task), this.task = null;
        }
      }, {
        key: "_startTimer",
        value: function() {
          var K = this;
          this.isRaf ? this.task = bn(function() {
            return K._internalF();
          }) : this.task = setTimeout(function() {
            return K._internalF();
          }, this.gap);
        }
      }, {
        key: "_passedTime",
        value: function() {
          var K = new Date().getTime(), te = K - this.dotTime;
          return this.dotTime = K, te;
        }
      }]), ie;
    }(Kt);
    function Lt() {
      var ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "muduPlayer";
      if (!(this instanceof Lt))
        return new Lt(ae);
      this.storeKey = ae;
    }
    Lt.prototype.get = function(ae) {
      var ie = this._getData();
      return ie[ae];
    }, Lt.prototype.set = function(ae, ie) {
      var re = this._getData();
      re[ae] = ie, this._setData(re);
    }, Lt.prototype._getData = function() {
      var ae = {};
      try {
        ae = localStorage.getItem(this.storeKey), ae = JSON.parse(ae);
      } catch (ie) {
        ae = {}, console.error("muduplayer: cannot read localstorage");
      }
      return ae || {};
    }, Lt.prototype._setData = function(ae) {
      try {
        localStorage.setItem(this.storeKey, tr(ae));
      } catch (ie) {
        console.error("muduplayer: cannot set localstorage");
      }
    };
    var vu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie() {
        return $(this, ie), he(this, le(ie).apply(this, arguments));
      }
      return ee(ie, [{
        key: "onError",
        value: function() {
          this.trigger.apply(this, ["onError"].concat(Array.prototype.slice.call(arguments)));
        }
      }, {
        key: "onEvent",
        value: function() {
          this.trigger.apply(this, ["onEvent"].concat(Array.prototype.slice.call(arguments)));
        }
      }, {
        key: "onReady",
        value: function() {
          this.trigger.apply(this, ["onReady"].concat(Array.prototype.slice.call(arguments)));
        }
      }]), ie;
    }(Kt), br = new vu(), ct = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, oe({}, ie.defaultOptions, K))), te.object = null, te._prevPos = null, te.flashUtilListener = [], te._commandQueue = [], te.currentTimer = null, te.commandQueueTimer = null, te.lastVolume = Lt().get("volume"), window.muduPlayer = window.muduPlayer || {}, window.muduPlayer.flashUtil = window.muduPlayer.flashUtil || br, te.renderCustomTip(), te.initCommandQueueTimer(), te.removed = !1, te;
      }
      return ee(ie, [{
        key: "loadFiles",
        value: function() {
          return this.removed ? Promise.reject(new TypeError("flash provider removed")) : ge(le(ie.prototype), "loadFiles", this).call(this);
        }
      }, {
        key: "getMediaElement",
        value: function() {
          return this.player.dom.videoWrap.querySelector("object");
        }
      }, {
        key: "createMediaElement",
        value: function() {
          var K = this;
          this.id = this.player._config.containerId + "-flash", this.player.dom.flash.id = this.id;
          var te = {
            autoplay: !1,
            preload: this.player._config.preload,
            hls_seekmode: "ACCURATE",
            debug: !1,
            connectTimeout: this.option.connectTimeout || 3
          }, ue = {
            id: this.id,
            name: this.id,
            class: _i,
            style: "position: absolute; display: block; left: 0; right: 0; top: 0; bottom: 0; pointer-events:auto;"
          }, fe = {
            wmode: "opaque",
            allowScriptAccess: "always",
            bgcolor: "#000000"
          };
          return hu(this.player._config.fileCdnPath + "/mudu-player.swf", this.id, "100%", "100%", "10.3", "", te, fe, ue, function(pe) {
            pe.success === !1 && Ae(K.player.dom.container).add(Ua);
          }), this.getMediaElement();
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.removed = !0, this.currentTimer && this.currentTimer.stop(), this.commandQueueTimer && this.commandQueueTimer.stop(), this.flashUtilListener.forEach(function(K) {
            return br.off(K.event, K.id);
          }), this.triggerFlash("mudu_stop"), this.object = null;
        }
      }, {
        key: "setup",
        value: function(K) {
          var te = this, ue = K.type, fe = K.absoluteFile, pe = K.isLive;
          if (this.removed) {
            console.log("setup: plash provider removed");
            return;
          }
          var me = function() {
            te.player._status.flashReady = !0, te.object = te.getMediaElement(), te.id = te.player._config.containerId + "-flash";
            var Ee = "", ke = new Date().getTime();
            if (fe.indexOf("?") >= 0 ? Ee = "&safari".concat(ke, "=").concat(ke) : Ee = "?safari".concat(ke, "=").concat(ke), ue === "rtmp") {
              var Re = vs(fe);
              te.triggerFlash("mudu_setProperty", "rtmpConnection", Re.connection), te.triggerFlash("mudu_setProperty", "rtmpStream", Re.stream);
            } else
              te.player._config.preload === "auto" ? it() && pe ? te.triggerFlash("mudu_src", fe + Ee) : te.triggerFlash("mudu_src", fe) : te.oncePlayer("beforePlay", function() {
                it() && pe ? te.triggerFlash("mudu_src", fe + Ee) : te.triggerFlash("mudu_src", fe);
              });
            te._subEvents(), te._updateCurrentTime();
          };
          if (this.player._status.flashReady)
            return me(), Promise.resolve();
          var ye = new Promise(function(_e, Ee) {
            var ke = !1, Re = br.on("onReady", function(xe) {
              xe === te.id && te.object === null && (ke = !0, me(), _e());
            });
            te.flashUtilListener.push({
              event: "onReady",
              id: Re
            }), we() && setTimeout(function() {
              ke || (Ae(te.player.dom.container).add(Ua), Ee(new Error(ie.Error.NotAllowedError)));
            }, 5e3);
          });
          return ye;
        }
      }, {
        key: "initCommandQueueTimer",
        value: function() {
          var K = this;
          this.commandQueueTimer = new Wt({
            gap: 200
          }), this.commandQueueTimer.on("tick", function(te) {
            var ue = te.isStop;
            ue || (K._commandQueue.length === 0 ? K.commandQueueTimer.stop() : K._apiAvailable() && (K._commandQueue.forEach(function(fe) {
              if (K.object[fe.fn]) {
                var pe;
                (pe = K.object)[fe.fn].apply(pe, be(fe.args));
              }
            }), K._commandQueue = []));
          });
        }
      }, {
        key: "renderCustomTip",
        value: function() {
          var K = this.option.renderTip(), te = this.player.dom.flashTip, ue = function() {
            te.innerHTML = "";
          };
          typeof K == "string" && (ue(), te.innerHTML = K), F(K) === "object" && (ue(), te.appendChild(K));
        }
      }, {
        key: "triggerFlash",
        value: function(K) {
          for (var te = arguments.length, ue = new Array(te > 1 ? te - 1 : 0), fe = 1; fe < te; fe++)
            ue[fe - 1] = arguments[fe];
          if (this.object && this.object[K]) {
            var pe;
            return (pe = this.object)[K].apply(pe, ue);
          } else
            this._commandQueue.push({
              fn: K,
              args: ue
            }), this.commandQueueTimer.start();
        }
      }, {
        key: "_subEvents",
        value: function() {
          var K = this, te = br.on("onEvent", function(fe, pe) {
            if (!(fe !== K.id || K.object === null))
              switch (K.trigger(pe), pe) {
                case "playing":
                  K.trigger("play");
                  break;
                case "durationchange":
                  K.trigger("duration");
                  break;
                case "volumechange":
                  var me = K.getVolume();
                  K.trigger("volume", {
                    type: "volume",
                    volume: me
                  });
                  break;
              }
          }), ue = br.on("onError", function(fe) {
            for (var pe = arguments.length, me = new Array(pe > 1 ? pe - 1 : 0), ye = 1; ye < pe; ye++)
              me[ye - 1] = arguments[ye];
            fe !== K.id || K.object === null || K.trigger(Ot, {
              message: me.join(),
              data: me,
              fatal: !0
            });
          });
          this.flashUtilListener.push({
            event: "onEvent",
            id: te
          }), this.flashUtilListener.push({
            event: "onError",
            id2: ue
          });
        }
      }, {
        key: "_updateCurrentTime",
        value: function() {
          var K = this;
          this.currentTimer = new Wt({
            gap: 500,
            name: "flash update time"
          }), this.currentTimer.on("tick", function() {
            if (K.object) {
              var te = K.getPosition();
              te !== K._prevPos && K.trigger("timeupdate"), K._prevPos = te;
            }
          }), this.currentTimer.start();
        }
      }, {
        key: "getWidth",
        value: function() {
          return this._get("videoWidth", -1);
        }
      }, {
        key: "getHeight",
        value: function() {
          return this._get("videoHeight", -1);
        }
      }, {
        key: "getMetrics",
        value: function() {
          return this._apiAvailable() ? {
            videoHeight: this.getHeight(),
            videoWidth: this.getWidth(),
            fps: this.getFPS(),
            bps: this.getBPS()
          } : {};
        }
      }, {
        key: "getFPS",
        value: function() {
          return this._get("currentFPS", -1);
        }
      }, {
        key: "getBPS",
        value: function() {
          return this._get("currentBPS", -1);
        }
      }, {
        key: "getBuffer",
        value: function() {
          if (this._apiAvailable()) {
            var K = this._get("buffered", []);
            if (K.length >= 1) {
              var te = K.map(function(ue) {
                return {
                  start: ue[0],
                  end: ue[1]
                };
              });
              return te;
            }
          }
          return [];
        }
      }, {
        key: "getVolume",
        value: function() {
          return this._apiAvailable() ? this._get("volume") : 1;
        }
      }, {
        key: "setVolume",
        value: function(K) {
          if (!!this.object) {
            var te = this.getMute();
            Ce("number", K) && (K < 0 && (K = 0), K > 1 && (K = 1), this.triggerFlash("mudu_setProperty", "volume", K), te && K > 0 && this.setMute(!1), !te && K === 0 && this.setMute(!0));
          }
        }
      }, {
        key: "setMute",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
          this._apiAvailable() && (!K && this.getVolume() === 0 && this.setVolume(0.5), this.object.mudu_setProperty("muted", !!K), this.trigger("mute", {
            type: "mute",
            mute: !!K
          }));
        }
      }, {
        key: "getMute",
        value: function() {
          return this._apiAvailable() ? this._get("muted") : !1;
        }
      }, {
        key: "setStretching",
        value: function(K) {
          if (!!this._apiAvailable())
            switch (K) {
              case "none":
              case "contain":
              case "fill":
              case "cover":
              case "scale-down":
                this.object.mudu_setProperty("stretching", K);
                break;
              default:
                this.object.mudu_setProperty("stretching", "contain");
            }
        }
      }, {
        key: "getStretching",
        value: function() {
          return this._apiAvailable() ? this._get("stretching") : "contain";
        }
      }, {
        key: "getPosition",
        value: function() {
          if (this._apiAvailable())
            return this._get("currentTime") || 0;
        }
      }, {
        key: "getDuration",
        value: function() {
          if (this._apiAvailable())
            return this._get("duration");
        }
      }, {
        key: "setStretch",
        value: function() {
        }
      }, {
        key: "getMetadata",
        value: function() {
        }
      }, {
        key: "play",
        value: function() {
          if (this.object)
            if (this._get) {
              var K = this._get("ended");
              K ? (this.object.mudu_play(), this.seek(0)) : this.object.mudu_play();
            } else
              this.triggerFlash("mudu_play");
          return Promise.resolve();
        }
      }, {
        key: "pause",
        value: function() {
          return this.object && this.triggerFlash("mudu_pause"), Promise.resolve();
        }
      }, {
        key: "seek",
        value: function(K) {
          if (this._apiAvailable()) {
            var te = this._get("currentTime");
            this.object.mudu_setProperty("currentTime", K), this.trigger("seek", {
              type: "seek",
              position: te,
              offset: K
            });
          }
        }
      }, {
        key: "getPlaybackRate",
        value: function() {
          return 1;
        }
      }, {
        key: "setPlaybackRate",
        value: function() {
        }
      }, {
        key: "_apiAvailable",
        value: function() {
          return this.object && this.object.mudu_getProperty;
        }
      }, {
        key: "_get",
        value: function(K, te) {
          try {
            return this.object.mudu_getProperty(K);
          } catch (ue) {
            if (Ce("undefined", te))
              throw ue;
            return te;
          }
        }
      }]), ie;
    }(Gt);
    ct.types = ["flv", "rtmp", "hls", "m3u8", "mp4"], ct.canPlay = function(ae) {
      var ie = ae.type;
      return ct.types.indexOf(ie) >= 0;
    }, ct.canPlayMineType = Nt, ct.isSupported = function() {
      return !rt();
    }, ct.isPlaybackRateSupported = function() {
      return !1;
    }, ct.isFlash = function(ae) {
      return !0;
    }, ct.isHTML5 = function(ae) {
      return !1;
    }, ct.version = "5.0.2-15", ct.defaultOptions = {
      renderTip: Nt
    }, ct.Error = {
      NotAllowedError: "Media element cannot be created, probably flash is not allowed"
    };
    var ot = {
      NETWORK_ERROR: 1,
      MEDIA_ERROR: 2,
      FILE_NOT_SUPPORTED: 3,
      AUTO_PLAY_FAILED: 1001,
      OTHER_ERROR: 2e3
    }, dt = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, K)), te._onVideoEvents = te._onVideoEvents.bind(ce(ce(te))), te._onTextTracksAdd = te._onTextTracksAdd.bind(ce(ce(te))), te._onTextTracksChange = te._onTextTracksChange.bind(ce(ce(te))), te._onTextTracksRemove = te._onTextTracksRemove.bind(ce(ce(te))), te._onTextTrackCueChange = te._onTextTrackCueChange.bind(ce(ce(te))), te.TAG = "HTML5Provider", te.video_error_report = !0, te;
      }
      return ee(ie, [{
        key: "setup",
        value: function(K) {
          var te = this, ue = K.file;
          K.image, this._setupEvents(), this._duration = 0, this.video.src = ue;
          var fe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
          this.video.setAttribute("poster", fe), this.oncePlayer("play", function() {
            te.oncePlayer("canSeek", function() {
              var pe = !0;
              te.oncePlayer("seek", function() {
                pe = !1;
              }), te.oncePlayer("time", function(me) {
                var ye = me.position;
                ye !== 0 && (pe = !1);
              }), setTimeout(function() {
                var me = te.getPosition();
                te.TAG === "HTML5Provider" && pe && me === 0 && te.seek(0.01);
              }, 50);
            });
          });
        }
      }, {
        key: "getMediaElement",
        value: function() {
          var K = this.player.dom.videoWrap.querySelector("video");
          if (K) {
            var te = K.textTracks;
            if (te && te.length) {
              try {
                K.parentNode.removeChild(K);
              } catch (ue) {
                console.error("remove video element error");
              }
              return null;
            }
          }
          return this.video = K, K;
        }
      }, {
        key: "createMediaElement",
        value: function() {
          var K = document.createElement("video"), te = this.player._config.preload;
          K.setAttribute("class", _i), K.setAttribute("preload", te), ft() && delete this.player._config.videoAttributes.loop, this.player._config.videoAttributes.loop || delete this.player._config.videoAttributes.loop;
          for (var ue in this.player._config.videoAttributes) {
            var fe = this.player._config.videoAttributes[ue];
            K.setAttribute(ue, fe);
          }
          return this.video = K, K;
        }
      }, {
        key: "play",
        value: function() {
          var K = this;
          if (this.video) {
            this.video.setAttribute("preload", "auto");
            try {
              var te = this.video.play();
              if (te)
                return te.catch(function(ue) {
                  console.warn(ue), K.trigger(Ot, {
                    code: ot.AUTO_PLAY_FAILED,
                    message: ue.message,
                    fatal: !1,
                    data: ue
                  });
                });
            } catch (ue) {
              throw new Error("player cannot play");
            }
          }
          return Promise.resolve();
        }
      }, {
        key: "pause",
        value: function() {
          return this.video && this.video.pause(), Promise.resolve();
        }
      }, {
        key: "remove",
        value: function() {
          if (this._removeEvents(), this.video) {
            try {
              this.video.parentNode.removeChild(this.video);
            } catch (K) {
            }
            this.video = null;
          }
          ge(le(ie.prototype), "remove", this).call(this);
        }
      }, {
        key: "seek",
        value: function(K) {
          if (!!this.video) {
            var te = this.getPosition();
            this.video.currentTime = K, this.trigger("seek", {
              type: "seek",
              position: te,
              offset: K
            });
          }
        }
      }, {
        key: "getPlaybackRate",
        value: function() {
          return this.video ? this.video.playbackRate : 1;
        }
      }, {
        key: "setPlaybackRate",
        value: function(K) {
          this.video && (this.video.playbackRate = K, this.trigger("playbackrate", {
            type: "playbackrate",
            playbackRate: K
          }));
        }
      }, {
        key: "getDuration",
        value: function() {
          return this._duration;
        }
      }, {
        key: "getPosition",
        value: function() {
          return this.video ? this.video.currentTime : 0;
        }
      }, {
        key: "getVolume",
        value: function() {
          return this.video ? this.getMute() ? 0 : this.video.volume : 1;
        }
      }, {
        key: "getWidth",
        value: function() {
          return this.video ? this.video.videoWidth : -1;
        }
      }, {
        key: "getHeight",
        value: function() {
          return this.video ? this.video.videoHeight : -1;
        }
      }, {
        key: "setVolume",
        value: function(K) {
          if (!!this.video) {
            var te = this.video.muted;
            Ce("number", K) && (K < 0 && (K = 0), K > 1 && (K = 1), this.video.volume = K, this.trigger("volume", {
              type: "volume",
              volume: K
            }), te && K > 0 && this.setMute(!1), !te && K === 0 && this.setMute(!0));
          }
        }
      }, {
        key: "setMute",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
          !this.video || (this.video.muted = !!K, this.trigger("mute", {
            type: "mute",
            mute: !!K
          }));
        }
      }, {
        key: "getMute",
        value: function() {
          return this.video ? this.video.muted : !1;
        }
      }, {
        key: "setStretching",
        value: function(K) {
          if (!!this.video)
            switch (K) {
              case "none":
              case "contain":
              case "fill":
              case "cover":
              case "scale-down":
                this.video.style.objectFit = K;
                break;
              default:
                this.video.style.objectFit = "contain";
            }
        }
      }, {
        key: "getStretching",
        value: function() {
          return this.video.style.objectFit;
        }
      }, {
        key: "getBuffer",
        value: function() {
          if (!this.video)
            return [];
          for (var K = this.video, te = K.buffered, ue = [], fe = 0; fe < te.length; fe++)
            ue.push({
              start: te.start(fe),
              end: te.end(fe)
            });
          return ue.sort(function(pe, me) {
            var ye = pe.start - me.start;
            return ye || me.end - pe.end;
          });
        }
      }, {
        key: "getMetrics",
        value: function() {
          var K = this.video;
          return K ? {
            videoHeight: K.videoHeight,
            videoWidth: K.videoWidth,
            mozParsedFrames: K.mozParsedFrames,
            mozDecodedFrames: K.mozDecodedFrames,
            mozPresentedFrames: K.mozPresentedFrames,
            mozPaintedFrames: K.mozPaintedFrames,
            mozFrameDelay: K.mozFrameDelay,
            mozHasAudio: K.mozHasAudio,
            networkState: K.networkState,
            msHorizontalMirror: K.msHorizontalMirror,
            msInsertVideoEffect: K.msInsertVideoEffect,
            msIsStereo3D: K.msIsStereo3D,
            webkitAudioDecodedByteCount: K.webkitAudioDecodedByteCount,
            webkitVideoDecodedByteCount: K.webkitVideoDecodedByteCount,
            webkitDecodedFrameCount: K.webkitDecodedFrameCount,
            webkitDroppedFrameCount: K.webkitDroppedFrameCount
          } : ge(le(ie.prototype), "getMetrics", this).call(this);
        }
      }, {
        key: "getTextTracks",
        value: function() {
          var K = this;
          if (!this.video)
            return [];
          var te = [].slice.call(this.video.textTracks).map(function(ue) {
            K._addCustomTrack(ue);
            var fe = ue.customTrack;
            return fe;
          });
          return te;
        }
      }, {
        key: "setTextTrackEnable",
        value: function(K) {
          var te = this.video && this.video.textTracks, ue = te && te[K];
          !ue || (ue.customTrack || this._addCustomTrack(ue), ue.customTrack.mode = "hidden", ue.mode = "hidden");
        }
      }, {
        key: "setTextTrackDisable",
        value: function(K) {
          var te = this.video && this.video.textTracks, ue = te && te[K];
          !ue || (ue.customTrack || this._addCustomTrack(ue), ue.customTrack.mode = "disabled", ue.mode = "disabled");
        }
      }, {
        key: "getTextTrackCues",
        value: function(K) {
          var te = this, ue = this.video && this.video.textTracks, fe = ue && ue[K];
          if (!!fe) {
            var pe = [].slice.call(fe.cues || []).map(function(me) {
              return te._addCustomCue(me), me.customCue;
            });
            return pe;
          }
        }
      }, {
        key: "getTextTrackActiveCues",
        value: function(K) {
          var te = this, ue = this.video && this.video.textTracks, fe = ue && ue[K];
          if (!!fe) {
            var pe = [].slice.call(fe.activeCues || []).map(function(me) {
              return te._addCustomCue(me), me.customCue;
            });
            return pe;
          }
        }
      }, {
        key: "_setupEvents",
        value: function() {
          var K = this;
          ie.mediaEvents.forEach(function(te) {
            Qe(K.video, te, K._onVideoEvents);
          }), this.video.textTracks && (Qe(this.video.textTracks, "change", this._onTextTracksChange), Qe(this.video.textTracks, "addtrack", this._onTextTracksAdd), Qe(this.video.textTracks, "removetrack", this._onTextTracksRemove));
        }
      }, {
        key: "_removeEvents",
        value: function() {
          var K = this;
          if (this.video) {
            ie.mediaEvents.forEach(function(ue) {
              at(K.video, ue, K._onVideoEvents);
            });
            for (var te = 0; te < this.video.textTracks.length; te++)
              at(this.video.textTracks[te], "cuechange", this._onTextTrackCueChange);
            at(this.video.textTracks, "change", this._onTextTracksChange), at(this.video.textTracks, "addtrack", this._onTextTracksAdd), at(this.video.textTracks, "removetrack", this._onTextTracksRemove);
          }
        }
      }, {
        key: "_onTextTracksChange",
        value: function() {
          !this.video || this.trigger(po, this.getTextTracks());
        }
      }, {
        key: "_onTextTracksAdd",
        value: function(K) {
          if (!!this.video) {
            var te = K.track;
            this._addCustomTrack(te), this.trigger(fo, te.customTrack), Qe(te, "cuechange", this._onTextTrackCueChange);
          }
        }
      }, {
        key: "_onTextTracksRemove",
        value: function(K) {
        }
      }, {
        key: "_onTextTrackCueChange",
        value: function(K) {
          if (!!this.video) {
            var te = K.target, ue = this._getIndexByTrack(te);
            this.trigger(mo, {
              cues: this.getTextTrackCues(ue),
              activeCues: this.getTextTrackActiveCues(ue),
              track: te.customTrack
            });
          }
        }
      }, {
        key: "_getIndexByTrack",
        value: function(K) {
          for (var te = this.video.textTracks, ue = te.length, fe = 0; fe < ue; fe++)
            if (te[fe] === K)
              return fe;
          return -1;
        }
      }, {
        key: "_addCustomTrack",
        value: function(K) {
          K.customTrack = K.customTrack || {};
          var te = K.customTrack;
          te.id = K.id, te.kind = K.kind, te.label = K.label, te.language = K.language, te.mode = K.mode;
        }
      }, {
        key: "_addCustomCue",
        value: function(K) {
          K.customCue = K.customCue || {};
          var te = K.customCue;
          te.startTime = K.startTime, te.endTime = K.endTime, te.text = K.text;
        }
      }, {
        key: "_onVideoEvents",
        value: function(K) {
          var te = K.type;
          switch (te) {
            case "error":
              var ue = this.video.error || {}, fe = ue.message, pe = ue.code, me = this.video.networkState;
              if (pe === 3 && this.TAG === "HTML5Provider" && $t()) {
                console.log("x5 layer error"), this.play();
                return;
              }
              !fe && me === 3 && (fe = "networkError"), this.video_error_report && this.trigger(Ot, {
                code: {
                  1: ot.OTHER_ERROR,
                  2: ot.NETWORK_ERROR,
                  3: ot.MEDIA_ERROR,
                  4: ot.FILE_NOT_SUPPORTED
                }[pe],
                message: fe || {
                  1: "Aborted Error",
                  2: "Network Error",
                  3: "Decode Error",
                  4: "File type not supported"
                }[pe],
                fatal: pe > 1,
                data: K
              });
              break;
            case "playing":
              this.trigger("play", K), this.trigger(te, K);
              break;
            case "durationchange":
              this.video.duration !== 1 && (this._duration = this.video.duration, this.trigger("duration")), this.trigger(te, K);
              break;
            default:
              this.trigger(te, K);
          }
        }
      }]), ie;
    }(Gt);
    dt.mediaEvents = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "mozaudioavailable", "pause", "play", "playing", "progress", "ratechange", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], dt.canPlay = function(ae) {
      var ie = ae.mimeType, re = document.createElement("video");
      return re.canPlayType(ie);
    }, dt.isSupported = function() {
      return !It() || It() && dn.major > 8;
    }, dt.isPlaybackRateSupported = function() {
      return !0;
    }, dt.isHTML5 = function(ae) {
      return !0;
    }, dt.isFlash = function(ae) {
      return !1;
    }, dt.version = "0.40.3";
    var Ht = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, K)), te.player = re, te._onVideoEvents = te._onVideoEvents.bind(ce(ce(te))), te.TAG = "TcPlayerLiteProvider", te.video_error_report = !0, te;
      }
      return ee(ie, [{
        key: "loadFiles",
        value: function() {
          var K = new mt(this.player._config.fileCdnPath + "/tc-player-lite.js");
          return K.load();
        }
      }, {
        key: "setup",
        value: function(K) {
          var te = this;
          this._setupEvents(), this.onPlayer(et, function() {
            !te.video || (rt() && ft() && te.onDom(te.video, "webkitendfullscreen", function() {
              te.tcPlayer && te.tcPlayer.pause();
            }), te.onDom(te.video, "pause", function() {
              te.tcPlayer && te.tcPlayer.pause();
            }));
          });
          var ue = this.player._config;
          this.tcPlayer = new window.TcPlayer(this.player._container.id, {
            webrtc: K.file,
            autoplay: ue.autoplay,
            listener: function(pe) {
              !te.video.srcObject && (pe.type === "loadedmetadata" || pe.type === "webrtcstatupdate") && (te.video.srcObject = pe.src.el.srcObject, pe.src.owner.style.display = "none", te.play()), pe.type === "error" && (pe.detail.code === 2005 ? te.player.trigger(xl, {
                message: pe.detail.reason
              }) : te.trigger(Ot, {
                code: {
                  1: ot.OTHER_ERROR,
                  2: ot.NETWORK_ERROR,
                  3: ot.MEDIA_ERROR,
                  4: ot.FILE_NOT_SUPPORTED
                }[pe.detail.code] || ot.OTHER_ERROR,
                message: pe.detail.reason,
                fatal: !0,
                data: pe
              }));
            }
          });
        }
      }, {
        key: "getMediaElement",
        value: function() {
          return !1;
        }
      }, {
        key: "play",
        value: function() {
          if (this.tcPlayer) {
            this.video.setAttribute("preload", "auto");
            try {
              this.tcPlayer.play();
              var K = this.video.play();
              if (K)
                return K.catch(function(te) {
                  return console.warn(te);
                });
            } catch (te) {
              throw new Error("player cannot play");
            }
          }
          return Promise.resolve();
        }
      }, {
        key: "pause",
        value: function() {
          return this.tcPlayer && (this.tcPlayer.pause(), this.video.pause()), Promise.resolve();
        }
      }, {
        key: "setVolume",
        value: function(K) {
          if (!!this.video) {
            var te = this.video.muted;
            Ce("number", K) && (K < 0 && (K = 0), K > 1 && (K = 1), this.video.volume = K, this.tcPlayer.volume(K), this.trigger("volume", {
              type: "volume",
              volume: K
            }), te && K > 0 && this.setMute(!1), !te && K === 0 && this.setMute(!0));
          }
        }
      }, {
        key: "setMute",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
          !this.video || (this.video.muted = !!K, this.tcPlayer.mute(!!K), this.trigger("mute", {
            type: "mute",
            mute: !!K
          }));
        }
      }, {
        key: "getMute",
        value: function() {
          return this.video ? this.video.muted : !1;
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.tcPlayer && this.tcPlayer.destroy();
        }
      }]), ie;
    }(dt);
    Ht.type = ["webrtc"], Ht.canPlay = function(ae) {
      var ie = ae.type;
      return Ht.type.indexOf(ie) > -1;
    }, Ht.isSupported = function() {
      return window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
    }, Ht.isFlash = function(ae) {
      return !1;
    }, Ht.isHTML5 = function(ae) {
      return !0;
    };
    function lr() {
      var ae = this;
      try {
        Tr.call(this);
      } catch (Ve) {
        console.error("destroy provider", Ve);
      }
      console.log("initProvider");
      var ie = Ft.call(this), re = ie.file, K = ie.type, te = ie.mineType, ue = ie.isLive, fe = ie.absoluteFile, pe = ie.image, me = ie.alwaysDisplayImage, ye = ie.isTimeShift, _e = ie.reloadAfterPausing, Ee = ie.reloadAfterPausingTime, ke = ie.isHideProgress, Re = K, xe = re, Ge = te;
      K === "webrtc" && this._config.trtcFallback && (!Ht.isSupported() || ni() && Mt() || ai() && Mt()) && (Re = "m3u8", xe = En(re), Ge = fr("m3u8"), this.trigger(Nl, {
        from: {
          type: "webrtc",
          url: re
        },
        to: {
          type: "m3u8",
          url: xe
        },
        mineType: fr("m3u8")
      }));
      var qe = xr({
        type: Re,
        mineType: Ge,
        url: xe,
        isLive: ue,
        isTimeShift: ye
      }, this._config.providerOrder);
      if (console.log(Re), console.log(xe), console.log(Ge), !qe) {
        var Ze = "File type not supported";
        return this.trigger(Dt, {
          code: ot.FILE_NOT_SUPPORTED,
          message: Ze,
          fatal: !0,
          errorId: er()
        }), Promise.reject(new TypeError(Ze));
      }
      var We = new qe.Provider(this, this._config.provider[qe.name]);
      this._provider = oe({}, qe, {
        instance: We
      });
      var ze = this;
      return We.loadFiles().then(function() {
        if (!We.removed) {
          var st = We.getMediaElement();
          if (!st) {
            var gt = We.createMediaElement();
            if (!gt)
              throw new Error(ct.Error.NotAllowedError);
            ze.dom.videoWrap.insertBefore(gt, ze.dom.background);
          }
        }
      }).then(function() {
        if (!We.removed)
          return console.log("instance setup"), We.setup({
            isLive: ue,
            file: xe,
            image: pe,
            absoluteFile: fe,
            type: Re,
            mineType: te
          });
      }).then(function() {
        console.log("provider setup \u6210\u529F"), ae.trigger(et, {
          isLive: ue,
          file: re,
          absoluteFile: fe,
          type: K,
          mineType: te,
          image: pe,
          alwaysDisplayImage: me,
          isTimeShift: ye,
          reloadAfterPausing: _e,
          reloadAfterPausingTime: Ee,
          isHideProgress: ke,
          providerType: qe.name
        });
      }).catch(function(Ve) {
        throw console.error("provider setup \u9519\u8BEF", Ve), ae.trigger(Dt, {
          error: Ve,
          message: Ve.message,
          column: Ve.columnNumber,
          fileName: Ve.fileName,
          lineNumber: Ve.lineNumber,
          name: Ve.name,
          stack: Ve.stack,
          errorId: er()
        }), Ve;
      });
    }
    function yu(ae, ie) {
      var re = Ft.call(this, ae, ie), K = re.file, te = re.type, ue = re.mineType, fe = re.isLive, pe = re.absoluteFile, me = re.image, ye = re.isTimeShift, _e = te, Ee = K, ke = ue;
      te === "webrtc" && this._config.trtcFallback && (!Ht.isSupported() || ni() && Mt() || ai() && Mt()) && (_e = "m3u8", Ee = En(K), ke = fr("m3u8"));
      var Re = xr({
        type: _e,
        mineType: ke,
        url: Ee,
        isLive: fe,
        isTimeShift: ye
      }, this._config.providerOrder);
      if (!Re) {
        var xe = "File type not supported";
        return Promise.reject(new TypeError(xe));
      }
      var Ge = new Re.Provider(this, this._config.provider[Re.name]), qe = In(new Promise(function(Ze) {
        Ge.loadFiles().then(function() {
          Ge.removed || Ge.createMediaElement();
        }).then(function() {
          if (!Ge.removed) {
            Ge.setup({
              isLive: fe,
              file: Ee,
              image: me,
              absoluteFile: pe,
              type: _e,
              mineType: ue
            }), Ge.setVolume(0), Ge.play();
            var ze = [], Ve = Ge.on(so, function(st) {
              for (var gt = arguments.length, Xt = new Array(gt > 1 ? gt - 1 : 0), qt = 1; qt < gt; qt++)
                Xt[qt - 1] = arguments[qt];
              ze.push({
                event: st,
                args: Xt
              });
            });
            [Xl, Ot].forEach(function(st) {
              Ge.once(st, function() {
                setTimeout(function() {
                  Ge.off(so, Ve), Ze({
                    provider: Re,
                    instance: Ge,
                    details: re,
                    outdatedEvents: ze
                  });
                }, 0);
              });
            });
          }
        }).catch(function(We) {
          throw Ge.remove(), We;
        });
      }));
      return oe({}, qe, {
        promise: qe.promise.catch(function(Ze) {
          throw Ge.remove(), Ze;
        })
      });
    }
    function Tr() {
      console.log("destroyProvider");
      var ae = this._provider && this._provider.instance;
      ae && (this._provider = null, ae.remove(), this.trigger(Pt));
    }
    function Sr() {
      var ae = this;
      try {
        _u.call(this);
      } catch (_e) {
        console.error("destroy extra provider", _e);
      }
      console.log("add extra provider");
      var ie = Ft.call(this), re = ie.file, K = ie.type, te = ie.mineType, ue = ie.isLive, fe = ie.absoluteFile, pe = ie.image, me = ie.isTimeShift, ye = Ms({
        type: K,
        mineType: te,
        url: re,
        isLive: ue,
        isTimeShift: me
      }, this._config);
      Promise.all(ye.map(function(_e) {
        if (!_e) {
          var Ee = "".concat(_e.name, " cannot support file type");
          ae.trigger(Dt, {
            message: Ee,
            fatal: !0,
            errorId: er()
          }), Promise.reject(new TypeError(Ee));
        }
        if (!!ae._config.extraProvider[_e.name].use) {
          var ke = new _e.Provider(ae, ae._config.extraProvider[_e.name]);
          ae._extraProviders[_e.name] = oe({}, _e, {
            instance: ke
          });
          var Re = ae;
          return ke.loadFiles().then(function() {
            var Ge = ke.getMediaElement();
            if (!Ge) {
              var qe = ke.createMediaElement();
              if (!qe)
                throw new Error(ct.Error.NotAllowedError);
              Re.dom.videoWrap.insertBefore(qe, Re.dom.background);
            }
          }).then(function() {
            return console.log("instance setup"), ke.setup({
              isLive: ue,
              file: re,
              image: pe,
              absoluteFile: fe,
              type: K,
              mineType: te
            });
          }).then(function() {
            console.log("extra provider setup \u6210\u529F  ");
          }).catch(function(xe) {
            throw console.error("extra provider setup \u9519\u8BEF", xe), ae.trigger(Dt, {
              error: xe,
              message: xe.message,
              column: xe.columnNumber,
              fileName: xe.fileName,
              lineNumber: xe.lineNumber,
              name: xe.name,
              stack: xe.stack,
              errorId: er()
            }), xe;
          });
        }
      }));
    }
    function _u() {
      var ae = this;
      console.log("destroyExtraProvider");
      var ie = [];
      for (var re in this._extraProviders)
        Object.prototype.hasOwnProperty.call(this._extraProviders, re) && ie.push(this._extraProviders[re]);
      ie.length > 0 && ie.forEach(function(K, te) {
        K.instance && (K.instance.remove(), K.removed = !0, delete ae._extraProviders[K.name]);
      });
    }
    var bu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), Je(K.player, ce(ce(K))).method("play").method("pause").method("toggle").method("getState").method("getPlaybackRate").method("setPlaybackRate"), K.subEvents(), K.setPlayBtnIcon(mr), K.initPlayButton(), K._lastPausedTimeStamp = 0, K;
      }
      return ee(ie, [{
        key: "changeStateClass",
        value: function() {
          var K = this.getState();
          Ae(this.player.dom.container).remove(Ni), Ae(this.player.dom.container).add("mudu-state-".concat(K));
        }
      }, {
        key: "subEvents",
        value: function() {
          var K = this;
          this.onPlayer(et, function() {
            K.subProvider(), Ae(K.player.dom.container).add(al);
          }), this.onPlayer(wl, function() {
            Ae(K.player.dom.container).remove(Ni);
          }), this.onPlayer(Pt, function() {
            K.player.timer.loading.stop(), Ae(K.player.dom.container).remove(Ni), Ae(K.player.dom.container).remove(Ba), K._triggerStateEvt(Bi, "idle"), K.setPlayBtnIcon(mr), K.changeStateClass();
          }), this.onPlayer("internal_buffer", function(te) {
            if (te) {
              if (K._isErrorState())
                return;
              K._triggerStateEvt("buffer", "buffering"), K.changeStateClass();
            } else
              K._triggerStateEvt("play", "playing"), K.changeStateClass();
          }), this.onPlayer(yr, this._onInternalKeyDown.bind(this));
        }
      }, {
        key: "subProvider",
        value: function() {
          var K = this;
          this.onProvider(ho, function() {
            K.player.timer.loading.start();
            var te = K.getState();
            K.getState() !== "playing" && (K._triggerStateEvt(_r, "playing"), K.setPlayBtnIcon(xn), te !== "buffering" && te !== "playing" && K.player.model.bezel.switch(mr), K.changeStateClass());
          }), this.onProvider(Xr, function() {
            K._lastPausedTimeStamp = Date.now(), K.player.timer.loading.stop(), K._triggerStateEvt(Xr, "paused"), K.setPlayBtnIcon(mr), K.player.model.bezel.switch(xn), !K._isErrorState() && K.changeStateClass();
          }), this.onProvider(lo, function() {
            K.player.timer.loading.stop(), K._triggerStateEvt(Bi), K.changeStateClass();
          }), this.onProvider(zl, function() {
            K.player.trigger($l);
          }), this.onProvider(ql, function(te) {
            K.player.trigger(Rl, te);
          }), this.onProvider(Bl, function() {
            var te = _t.isAnyClassShow("mudu-popup");
            te ? _t.hideAll() : K.player.getControls() && K.player.toggle();
          });
        }
      }, {
        key: "_triggerStateEvt",
        value: function(K, te) {
          te = te || K;
          var ue = this.player._status.state;
          this.player._status.state = te, this.player.trigger(K, {
            type: K,
            oldState: ue,
            newState: te
          });
        }
      }, {
        key: "_isErrorState",
        value: function() {
          return Ae(this.player.dom.container).contains(ki);
        }
      }, {
        key: "initPlayButton",
        value: function() {
          var K = this;
          this.onDom(this.player.dom.leftPlayBtn, "click", function() {
            K.player.toggle();
          }), this.onDom(this.player.dom.bigPlayBtn, "click", function() {
            K.player.toggle();
          }), rt() || this.onDom(this.player.dom.videoWrap, "click", function(te) {
            if (!(K.player._provider && K.player._provider.flash)) {
              var ue = _t.isAnyClassShow("mudu-popup");
              !ue && K.player.getControls() && K.player.toggle();
            }
          });
        }
      }, {
        key: "setPlayBtnIcon",
        value: function(K) {
          var te = this.player.dom.leftPlayBtn;
          Ae(te).remove(Hr), Ae(te).add(K);
        }
      }, {
        key: "toggle",
        value: function() {
          console.log(Ft.call(this.player));
          var K = this.player._status.state;
          return K === "paused" || K === "idle" || K === "error" ? this.play() : this.pause();
        }
      }, {
        key: "play",
        value: function() {
          var K = this, te = this.player._status.state, ue = Ft.call(this.player), fe = ue.reloadAfterPausing, pe = ue.reloadAfterPausingTime;
          if (fe && this._lastPausedTimeStamp && te === "paused") {
            var me = Date.now();
            pe = Ce("undefined", pe) ? 3e3 : pe;
            var ye = me - this._lastPausedTimeStamp > pe;
            if (ye) {
              this.player.replay();
              return;
            }
          }
          return this.provider() ? (this.player.trigger(Bt, {
            type: Bt
          }), this.provider().play()) : lr.call(this.player).then(function() {
            Sr.call(K.player);
            try {
              K.play();
            } catch (_e) {
              console.warn(_e);
            }
          });
        }
      }, {
        key: "pause",
        value: function() {
          return this.provider() ? this.provider().pause() : Promise.resolve();
        }
      }, {
        key: "getPlaybackRate",
        value: function() {
          return this.provider() ? this.provider().getPlaybackRate() : 1;
        }
      }, {
        key: "setPlaybackRate",
        value: function(K) {
          if (this.provider())
            return this.provider().setPlaybackRate(K);
        }
      }, {
        key: "getState",
        value: function() {
          return this.player._status.state;
        }
      }, {
        key: "_onInternalKeyDown",
        value: function(K) {
          var te = Ae(this.player.dom.container).contains(Br), ue = Ae(this.player.dom.container).contains(Wr);
          te || ue || K === 32 && this.toggle();
        }
      }]), ie;
    }(Ye), Rt = {
      nameMap: {
        dragStart: rt() ? "touchstart" : "mousedown",
        dragMove: rt() ? "touchmove" : "mousemove",
        dragEnd: rt() ? "touchend" : "mouseup"
      }
    }, Tu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.player.dom.ptime.innerHTML = "00:00", K.prevDragX = null, K._latest10tsLength = [], K._lastDuration = 0, K.onPlayer(et, K._onProviderInited.bind(ce(ce(K)))), K.onPlayer(Pt, K._onProviderRemoved.bind(ce(ce(K)))), K.onPlayer(yr, K._onInternalKeyDown.bind(ce(ce(K)))), K.initPlayedBar(), K.initTimeShiftSeek(), Je(K.player, ce(ce(K))).method("seek").method("getPosition").method("getDuration").method("getBuffer").method("setProgressVisible").method("getProgressVisible"), K;
      }
      return ee(ie, [{
        key: "setBarWidth",
        value: function(K) {
          this.player.dom.playedBar.style.width = yt(K);
        }
      }, {
        key: "getBarWidth",
        value: function() {
          return parseFloat(this.player.dom.playedBar.style.width) / 100;
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.provider() ? this.provider().getDuration() : 1;
        }
      }, {
        key: "getPosition",
        value: function() {
          return this.provider() ? this.provider().getPosition() : 0;
        }
      }, {
        key: "getBufferPercentage",
        value: function() {
          if (!this.provider())
            return 0;
          var K = this.getBuffer(), te = K.pop(), ue = te && te.end || 0, fe = this.getDuration(), pe = ue / fe || 0;
          return pe;
        }
      }, {
        key: "getBuffer",
        value: function() {
          return this.provider() ? this.provider().getBuffer() : [];
        }
      }, {
        key: "seek",
        value: function(K) {
          if (!!this.provider()) {
            this.provider().seek(K);
            var te = this.getDuration();
            K = Math.max(K, 0), te && (K = Math.min(K, te)), this.setBarWidth(this.getPlayedBarPercentage(K)), this.player.dom.ptime.innerHTML = hr(K);
          }
        }
      }, {
        key: "computeDragDirec",
        value: function(K) {
          if (this.prevDragX === null)
            return this.prevDragX = K, "";
          var te = K > this.prevDragX ? "right" : "left";
          return this.prevDragX = K, te;
        }
      }, {
        key: "initPlayedBar",
        value: function() {
          var K = this, te = function(pe) {
            if (!!K.getProgressVisible()) {
              Ae(K.player.dom.container).add(hl);
              var me = Jt({
                x: pe.clientX || pe.changedTouches[0].clientX,
                y: pe.clientY || pe.changedTouches[0].clientY
              }), ye = me.x, _e = ye - ut(K.player.dom.playedBarWrap).left;
              K.player.model.progressPopup.dragMove(_e, K.computeDragDirec(_e)), K.player.model.progressPopup.show();
              var Ee = _e / K.player.dom.playedBarWrap.clientWidth;
              Ee = Math.max(Ee, 0), Ee = Math.min(Ee, 1), K.setBarWidth(Ee), K.player.dom.ptime.innerHTML = hr(Ee * K.getDuration());
            }
          }, ue = function fe(pe) {
            if (K.prevDragX = null, K.player.model.progressPopup.hide(), K.player.model.progressPopup.dragEnd(), K.player._status.dragging = !1, K.player.model.controls.setAutoHide(), at(document, Rt.nameMap.dragEnd, fe), at(document, Rt.nameMap.dragMove, te), K.getProgressVisible()) {
              var me = Jt({
                x: pe.clientX || pe.changedTouches[0].clientX,
                y: pe.clientY || pe.changedTouches[0].clientY
              }), ye = me.x, _e = (ye - ut(K.player.dom.playedBarWrap).left) / K.player.dom.playedBarWrap.clientWidth;
              _e = Math.max(_e, 0), _e = Math.min(_e, 1), K.setBarWidth(_e), K.seekByPercentage(_e);
            }
          };
          Qe(this.player.dom.playedBarWrap, Rt.nameMap.dragStart, function() {
            K.player._status.dragging = !0, Qe(document, Rt.nameMap.dragMove, te), Qe(document, Rt.nameMap.dragEnd, ue);
          });
        }
      }, {
        key: "initTimeShiftSeek",
        value: function() {
          var K = this, te = this.player.dom.liveBadge;
          te.addEventListener("click", function() {
            K.seekTimeShiftLive();
          });
        }
      }, {
        key: "_onProviderInited",
        value: function(K) {
          var te = K.isLive, ue = K.isTimeShift, fe = K.isHideProgress;
          this.onProvider(Vl, this._onBufferChange.bind(this)), this.onProvider(co, this._onDuration.bind(this)), this.onProvider(uo, this._onTimeUpdate.bind(this)), this.onProvider(uo, this._onBufferChange.bind(this)), this.onceProvider(Kl, this._onLoadedData.bind(this)), Ae(this.player.dom.container).add(Fi), te ? (Ae(this.player.dom.container).add(Br), Ae(this.player.dom.container).remove(xa)) : (Ae(this.player.dom.container).remove(Br), Ae(this.player.dom.container).add(xa)), ue ? Ae(this.player.dom.container).add(Ri) : (Ae(this.player.dom.container).remove(Ri), Ae(this.player.dom.container).remove($i)), this.setProgressVisible(!fe), this._latest10tsLength = [];
        }
      }, {
        key: "_onProviderRemoved",
        value: function() {
          Ae(this.player.dom.container).add(Fi);
        }
      }, {
        key: "_onBufferChange",
        value: function() {
          var K = this.player.dom.loadedBar, te = this.getBufferPercentage() * this.getDuration(), ue = this.getPlayedBarPercentage(te);
          K.style.width = yt(ue);
        }
      }, {
        key: "_onDuration",
        value: function() {
          var K = this.player.dom.dtime, te = this.getDuration() || 0;
          di(te) && te > 0 && (K.innerHTML = hr(te), this.player.trigger(Vi, {
            type: Vi,
            duration: te
          }), Ae(this.player.dom.container).remove(Fi), Ae(this.player.dom.container).add(fl));
          var ue = 1, fe = te - this._lastDuration;
          if (this._lastDuration !== 0 && fe >= ue) {
            var pe = this._latest10tsLength;
            pe.unshift(fe), pe.length > 10 && pe.pop();
          }
          this._lastDuration = te, this._updateTimeShiftLiveBadge();
        }
      }, {
        key: "_onTimeUpdate",
        value: function() {
          var K = this.player.dom.ptime, te = this.getPosition();
          this.player._status.dragging || (this.setBarWidth(this.getPlayedBarPercentage(te)), K.innerHTML = hr(this.getPosition())), this.player.trigger(Hi, {
            type: Hi,
            position: te
          }), this._updateTimeShiftLiveBadge();
        }
      }, {
        key: "_onLoadedData",
        value: function() {
          var K = this, te = this.getDuration();
          di(te) && te > 0 ? this.player.trigger(no) : this.onceProvider(co, function() {
            K.player.trigger(no);
          });
        }
      }, {
        key: "_onInternalKeyDown",
        value: function(K) {
          var te = this._isLive(), ue = !this.getProgressVisible();
          if (!(te || ue))
            switch (K) {
              case 37:
                this.seek(this.getPosition() - 5);
                break;
              case 39:
                this.seek(this.getPosition() + 5);
                break;
            }
        }
      }, {
        key: "_isLive",
        value: function() {
          return Ae(this.player.dom.container).contains(Br);
        }
      }, {
        key: "_updateTimeShiftLiveBadge",
        value: function() {
          var K = this.isTimeShiftLive(), te = this.player.dom.container;
          K ? Ae(te).add($i) : Ae(te).remove($i);
        }
      }, {
        key: "seekTimeShiftLive",
        value: function() {
          if (!!this.isTimeShift()) {
            var K = this.getDuration(), te = this._latest10tsLength;
            if (te.length < 3) {
              var ue = K - 20;
              ue > 0 && this.seek(ue);
            } else {
              var fe = K - te[0] - te[1];
              this.seek(fe);
            }
          }
        }
      }, {
        key: "getPositionByPercentage",
        value: function(K) {
          var te = this.getDuration();
          if (this.isTimeShift()) {
            var ue = this.getTimeShiftGap();
            return (ue - te) * (1 - K);
          } else
            return te ? K * te : 0;
        }
      }, {
        key: "seekByPercentage",
        value: function(K) {
          var te, ue = this.getDuration();
          if (this.isTimeShift()) {
            var fe = this.getTimeShiftGap();
            te = (ue - fe) * K;
          } else
            te = K * ue;
          this.seek(te);
        }
      }, {
        key: "isTimeShiftLive",
        value: function() {
          var K = this.getDuration(), te = this.getPosition(), ue = this._latest10tsLength;
          if (ue.length < 3)
            return K - te < 30;
          var fe = ue[0] + ue[1] + ue[2];
          return K - te < fe;
        }
      }, {
        key: "isTimeShift",
        value: function() {
          var K = this.getDuration(), te = di(K) && K > 0, ue = Ae(this.player.dom.container).contains(Ri);
          return te && ue;
        }
      }, {
        key: "getTimeShiftGap",
        value: function() {
          var K = this._latest10tsLength, te = this.getDuration(), ue = this.getPosition();
          if (K.length < 3) {
            var fe = te - ue;
            return fe < 30 ? 30 - fe : 30;
          } else {
            var pe = K[0] + K[1] + K[2];
            return pe;
          }
        }
      }, {
        key: "getPlayedBarPercentage",
        value: function(K) {
          var te = this.getDuration();
          if (this.isTimeShift()) {
            var ue = this.getTimeShiftGap(), fe = K / (te - ue);
            return fe > 1 ? 1 : fe;
          } else
            return K / te;
        }
      }, {
        key: "setProgressVisible",
        value: function(K) {
          K ? Ae(this.player.dom.container).remove(Wr) : (Ae(this.player.dom.container).add(Wr), this.player._status.dragging = !1);
          var te = this.player._config.playlist;
          if (te && te.length > 0)
            for (var ue = 0; ue < te.length; ue++)
              te[ue].isHideProgress = !K;
        }
      }, {
        key: "getProgressVisible",
        value: function() {
          return !this._isLive() && !Ae(this.player.dom.container).contains(Wr);
        }
      }]), ie;
    }(Ye), Su = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.isMobile = rt(), K.autoHideTimer = null, K._controlsVisible = !!re._config.controls, K._videoLayerControl = !!re._config.videoLayerControl, Je(K.player, ce(ce(K))).method("setControls").method("getControls").method("setVideoLayerControl").method("getVideoLayerControl").method("setCustomControl"), K.setControls(!!re._config.controls), K.setVideoLayerControl(!!re._config.videoLayerControl), K.setMobileToggle(), K.setPcToggle(), K.setCustomControl(re._config.customControl), K;
      }
      return ee(ie, [{
        key: "setPcToggle",
        value: function() {
          var K = this;
          if (!this.isMobile) {
            var te = function() {
              K.show(), K.setAutoHide();
            }, ue = function(pe) {
              var me = pe.oldState;
              me !== "buffering" && me !== "playing" && te();
            };
            this.onDom(this.player.dom.container, "mousemove", te), this.onDom(this.player.dom.container, "click", te), this.onPlayer(_r, ue), this.onPlayer(Ll, te);
          }
        }
      }, {
        key: "setMobileToggle",
        value: function() {
          var K = this;
          if (!!this.isMobile) {
            var te = function(fe) {
              fe.stopPropagation(), K.toggle();
            };
            this.onDom(this.player.dom.videoWrap, "click", te), this.onPlayer(_r, function() {
              K.setAutoHide();
            });
          }
        }
      }, {
        key: "setAutoHide",
        value: function() {
          var K = this;
          clearTimeout(this.autoHideTimer), this.autoHideTimer = setTimeout(function() {
            var te = K.isMobile ? "mudu-popup ".concat(Gr) : "mudu-popup";
            !_t.isAnyClassShow(te) && !K.player._status.dragging && K.hide();
          }, 3e3);
        }
      }, {
        key: "show",
        value: function() {
          Ae(this.player.dom.container).remove(Mi), this._triggerControlsVisible(this.getControls());
        }
      }, {
        key: "hide",
        value: function() {
          var K = this.player.model.video.getState();
          K === "paused" || K === "idle" || (Ae(this.player.dom.container).add(Mi), this._triggerControlsVisible(!1));
        }
      }, {
        key: "isShow",
        value: function() {
          return !Ae(this.player.dom.container).contains(Mi);
        }
      }, {
        key: "_triggerControlsVisible",
        value: function(K) {
          K !== this._controlsVisible && (this._controlsVisible = K, this.player.trigger(eo, {
            type: eo,
            visible: this._controlsVisible
          }));
        }
      }, {
        key: "toggle",
        value: function() {
          var K = this.isShow();
          K ? this.hide() : this.show(), this.setAutoHide();
        }
      }, {
        key: "setVideoLayerControl",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
          if (!rt()) {
            this._videoLayerControl = !!K;
            var te = this._videoLayerControl ? "none" : "block";
            this.player.dom.baseLayer.style.display = te, this.player.trigger(Ja, {
              type: Ja,
              videoLayerControl: this._videoLayerControl
            });
          }
        }
      }, {
        key: "setControls",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
          this._showControls = !!K;
          var te = this._showControls ? "block" : "none";
          this.player.dom.controllerWrap.style.display = te, this.player.trigger(Za, {
            type: Za,
            controls: this._showControls
          }), this._triggerControlsVisible(this._showControls && this.isShow());
        }
      }, {
        key: "setCustomControl",
        value: function(K) {
          this.customControl = K;
          var te = this.player.dom.controllerWrap.querySelector(".".concat(Ya));
          te.innerHTML = null, typeof this.customControl == "string" ? te.innerText = this.customControl : F(this.customControl) === "object" ? te.appendChild(this.customControl) : te.innerText = this.customControl || "", this.customControl ? Ae(te).remove(Va) : Ae(te).add(Va);
        }
      }, {
        key: "getControls",
        value: function() {
          return this._showControls;
        }
      }, {
        key: "getVideoLayerControl",
        value: function() {
          return this._videoLayerControl;
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), clearTimeout(this.autoHideTimer);
        }
      }]), ie;
    }(Ye), Eu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), Je(K.player, ce(ce(K))).method("getMute").method("setMute").method("getVolume").method("setVolume"), K.initVolumeButton(), K.subEvents(), K.volumeTip = _t(K.player.dom.volumeButton, {
          content: "",
          container: K.player.dom.container
        }), rt() && (K.player.dom.volumeWrap.style.display = "none"), K;
      }
      return ee(ie, [{
        key: "subEvents",
        value: function() {
          var K = this;
          this.onPlayer(et, function() {
            K.subProviderEvents();
            var te = Lt().get("volume") || 1, ue = Lt().get("mute") || !1;
            rt() ? K.setVolume(1) : (K.setVolume(te), K.setMute(ue));
          }), this.onPlayer(yr, this._onInternalKeyDown.bind(this)), this.onPlayer(zr, this.updateTipText.bind(this));
        }
      }, {
        key: "updateTipText",
        value: function() {
          var K = this.getMute() ? this.lang.Unmute : this.lang.Mute, te = kr(K);
          this.volumeTip.updateContent(te);
        }
      }, {
        key: "subProviderEvents",
        value: function() {
          var K = this;
          this.onProvider(Wl, function(te) {
            K.player.trigger(kl, te), K.switchVolumeIcon(), K.setBarWidth(yt(K.getVolume())), K.cacheVolume(), K.updateTipText();
          }), this.onProvider(jl, function(te) {
            K.player.trigger(Ol, te), K.switchVolumeIcon(), K.setBarWidth(yt(K.getVolume())), K.cacheVolume();
          });
        }
      }, {
        key: "cacheVolume",
        value: function() {
          Lt().set("volume", this.getVolume()), Lt().set("mute", this.getMute());
        }
      }, {
        key: "initVolumeButton",
        value: function() {
          var K = this;
          this.setBarWidth("100%"), this.switchVolumeIcon();
          var te = function(pe) {
            var me = pe || window.event, ye = K.player._status.containerFontSize / 16, _e = 45 * ye, Ee = Jt({
              x: me.clientX || me.changedTouches[0].clientX,
              y: me.clientY || me.changedTouches[0].clientY
            }), ke = Ee.x, Re = (ke - ut(K.player.dom.volumeBarWrap).left) / _e;
            K.setVolume(Re);
          }, ue = function fe() {
            at(document, Rt.nameMap.dragEnd, fe), at(document, Rt.nameMap.dragMove, te);
          };
          Qe(this.player.dom.volumeBarWrapWrap, "click", function(fe) {
            var pe = K.player._status.containerFontSize / 16, me = 45 * pe, ye = fe || window.event, _e = Jt({
              x: ye.clientX || ye.changedTouches[0].clientX,
              y: ye.clientY || ye.changedTouches[0].clientY
            }), Ee = _e.x, ke = (Ee - ut(K.player.dom.volumeBarWrap).left) / me;
            K.player.setVolume(ke);
          }), Qe(this.player.dom.volumeBarWrapWrap, Rt.nameMap.dragStart, function() {
            Qe(document, Rt.nameMap.dragMove, te), Qe(document, Rt.nameMap.dragEnd, ue);
          }), Qe(this.player.dom.volumeButton, "click", function() {
            K.setMute(!K.getMute()), bn(function() {
              K.updateTipText(), K.volumeTip.show();
            });
          });
        }
      }, {
        key: "getMute",
        value: function() {
          return this.provider() ? this.provider().getMute() : !1;
        }
      }, {
        key: "setMute",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
          if (!!this.provider())
            return !K && this.getVolume() === 0 && this.setVolume(0.5), this.provider().setMute(K);
        }
      }, {
        key: "getVolume",
        value: function() {
          return this.provider() ? this.provider().getVolume() : 1;
        }
      }, {
        key: "setVolume",
        value: function(K) {
          !this.provider() || this.provider().setVolume(K);
        }
      }, {
        key: "setBarWidth",
        value: function(K) {
          this.player.dom.volumeBar.style.width = K;
        }
      }, {
        key: "switchVolumeIcon",
        value: function(K) {
          var te = this.player.dom.volumeButton;
          if (Ae(te).remove(Hr), K) {
            Ae(te).add(K);
            return;
          }
          this.getVolume() >= 0.95 ? Ae(te).add(Fs) : this.getVolume() > 0 ? Ae(te).add(ks) : Ae(te).add(Os);
        }
      }, {
        key: "_onInternalKeyDown",
        value: function(K) {
          switch (K) {
            case 38:
              this.setVolume(this.getVolume() + 0.1);
              break;
            case 40:
              this.setVolume(this.getVolume() - 0.1);
              break;
          }
        }
      }]), ie;
    }(Ye), Iu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), Je(K.player, ce(ce(K))).method("getPlaylist").method("getPlaylistItem").method("getPlaylistIndex").method("load").method("reload").method("next").method("prev").method("replay").method("setQuality").method("setQualityActive").method("getQuality").method("switchQuality").method("switchListItem").method("setRepeat").method("getRepeat"), K._subEvent(), K._retryStartTime = new Date(), K._retryTimes = 0, K._retryTimer = null, re._config.enableErrorRetry && (K.onPlayer("delegate-model", K._onDelegateModel.bind(ce(ce(K)))), K.onPlayer(Dt, K._onOuterError.bind(ce(ce(K))))), K;
      }
      return ee(ie, [{
        key: "_onDelegateModel",
        value: function(K) {
          var te = K.fn;
          switch (te) {
            case "load":
            case "reload":
            case "next":
            case "prev":
            case "replay":
            case "setQuality":
            case "switchQuality":
            case "switchListItem":
              this._retryStartTime = new Date(), this._retryTimes = 0, clearTimeout(this._retryTimer);
          }
        }
      }, {
        key: "_onOuterError",
        value: function(K) {
          var te = this, ue = K.fatal, fe = this.player._config, pe = fe.errorMaxRetry, me = fe.errorMaxRetryTimeout, ye = fe.errorRetryDelay, _e = new Date();
          ue && (pe > this._retryTimes || _e.getTime() < this._retryStartTime.getTime() + me) && (clearTimeout(this._retryTimer), this._retryTimer = setTimeout(function() {
            te.m_removed || (te._retryTimes++, te.replay());
          }, ye));
        }
      }, {
        key: "_subEvent",
        value: function() {
          var K = this, te = this.player;
          this.onPlayer(et, function() {
            if (!!te._provider) {
              var ue = te._provider.html5, fe = te.dom.container;
              Ae(fe).remove(Ba), Ae(fe).add(ul), ue ? Ae(fe).add(ll) : Ae(fe).add(sl), K.onProvider(lo, function() {
                te.trigger(Cl);
                var pe = K.getPlaylistIndex() === K.getPlaylist().length - 1;
                pe ? te._config.repeat ? K.reload() : te.trigger(Ml) : K.next();
              });
            }
          });
        }
      }, {
        key: "load",
        value: function(K) {
          var te = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, ue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          delete ue.playlist, this.player._config = oe({}, this.player._config, ue);
          var fe = vi(K);
          return fe ? (this.player._config.playlist = fe, this.player.trigger(to, {
            type: to,
            playlist: fe
          }), this.reload(te)) : Promise.reject(new Error("muduPlayer().load(`playlist`): the format of `playlist` is illegel"));
        }
      }, {
        key: "reload",
        value: function() {
          var K = this, te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
          return Rr.call(this.player), lr.call(this.player).then(function() {
            Sr.call(K.player), K.player.trigger(xi, {
              type: xi
            });
            try {
              if (te)
                return K.player.play();
            } catch (ue) {
              console.warn(ue);
            }
          });
        }
      }, {
        key: "replay",
        value: function() {
          var K = this;
          return lr.call(this.player).then(function() {
            Sr.call(K.player);
            try {
              return K.player.play();
            } catch (te) {
              console.warn(te);
            }
          });
        }
      }, {
        key: "switchListItem",
        value: function(K, te) {
          var ue = this;
          if (!Ce("number", K))
            return Promise.resolve(!1);
          var fe = this.player._config.playlist[K];
          return !fe || Ce("number", te) & !fe.sources[te] ? Promise.resolve(!1) : (Ce("number", te) ? $r.call(this.player, K, te) : Rr.call(this.player, K), this.player.trigger(qr, {
            type: qr,
            index: K,
            item: this.getPlaylistItem(K)
          }), lr.call(this.player).then(function() {
            return ue.player.play();
          }).then(function() {
            return !0;
          }));
        }
      }, {
        key: "next",
        value: function() {
          var K = this.getPlaylistIndex() + 1;
          return this.switchListItem(K);
        }
      }, {
        key: "prev",
        value: function() {
          var K = this.getPlaylistIndex() - 1;
          return this.switchListItem(K);
        }
      }, {
        key: "getPlaylist",
        value: function() {
          return this.player._config.playlist;
        }
      }, {
        key: "getPlaylistItem",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          return this.player._config.playlist[K];
        }
      }, {
        key: "getPlaylistIndex",
        value: function() {
          for (var K = 0; K < this.player._config.playlist.length; K++) {
            var te = this.player._config.playlist[K];
            if (te.active)
              return K;
          }
          return -1;
        }
      }, {
        key: "setQualityActive",
        value: function(K) {
          var te = this.getPlaylistIndex();
          return $r.call(this.player, te, K);
        }
      }, {
        key: "getQuality",
        value: function(K) {
          for (var te = this.getPlaylistIndex(), ue = this.player._config.playlist, fe = 0; fe < ue[te].sources.length; fe++)
            if (K === fe)
              return ue[te].sources[fe];
        }
      }, {
        key: "setQuality",
        value: function(K) {
          return console.warn("player.setQuality will be removed after v1.0.0, please use player.switchQuality instead"), this.switchQuality(K);
        }
      }, {
        key: "switchQuality",
        value: function(K) {
          var te = this.getQuality(K);
          return te ? (this.setQualityActive(K), this.player.trigger(ro, {
            index: K,
            item: te
          }), this.replay()) : Promise.resolve();
        }
      }, {
        key: "setRepeat",
        value: function(K) {
          this.player._config.repeat = !!K;
        }
      }, {
        key: "getRepeat",
        value: function() {
          return this.player._config.repeat;
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), clearTimeout(this._retryTimer);
        }
      }]), ie;
    }(Ye), _o = we() ? "keyup" : "keydown", Au = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.subEvent(), K;
      }
      return ee(ie, [{
        key: "subEvent",
        value: function() {
          var K = this.player;
          this.onKeyUp = function(te) {
            if (K._status.focus) {
              var ue = document.activeElement, fe = ue.tagName.toUpperCase(), pe = ue.getAttribute("contenteditable");
              if (fe !== "INPUT" && fe !== "TEXTAREA" && pe !== "" && pe !== "true") {
                var me = te || window.event;
                switch (me.keyCode) {
                  case 27:
                  case 32:
                  case 37:
                  case 39:
                  case 38:
                  case 40:
                    me.keyCode !== 27 && me.preventDefault(), K.trigger(yr, me.keyCode, me);
                }
              }
            }
          }, Qe(document, _o, this.onKeyUp);
        }
      }, {
        key: "remove",
        value: function() {
          at(document, _o, this.onKeyUp);
        }
      }]), ie;
    }(Ye), wu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), (!CSS.supports || CSS.supports && !CSS.supports("(width: 100dvw) and (height: 100dvh)")) && (K.removeResizeEventListener = Or(K.player.dom.container, function() {
          K.player.dom.container.style.setProperty("--fulldvw", innerWidth + "px"), K.player.dom.container.style.setProperty("--fulldvh", innerHeight + "px");
        })), Je(K.player, ce(ce(K))).method("getWidth").method("getHeight").method("resize").method("getRect"), K.setWidth(), K.setHeight(), K.setAspect() || K.setHeight(), K;
      }
      return ee(ie, [{
        key: "getWidth",
        value: function() {
          return this.getRect().width;
        }
      }, {
        key: "getHeight",
        value: function() {
          return this.getRect().height;
        }
      }, {
        key: "getRect",
        value: function() {
          return ut(this.player.dom.container);
        }
      }, {
        key: "resize",
        value: function(K, te) {
          K = this.setWidth(K), te = this.setHeight(te), this.removeAspect(), this.player.trigger(io, {
            type: io,
            width: K,
            height: te
          });
        }
      }, {
        key: "setWidth",
        value: function(K) {
          var te = K = K || this.player._config.width;
          return this.player.dom.container.style.width = yt(te), K;
        }
      }, {
        key: "setHeight",
        value: function(K) {
          var te = K = K || this.player._config.height;
          return this.player.dom.container.style.height = yt(te), K;
        }
      }, {
        key: "setAspect",
        value: function() {
          var K = this.player._config.aspectratio, te = (K + "").split(":").map(function(fe) {
            return +fe;
          }).filter(function(fe) {
            return !!fe && fe > 0;
          });
          if (te.length === 2) {
            var ue = te[1] / te[0] * 100 + "%";
            return this.player.dom.aspect.style.paddingTop = ue, Ae(this.player.dom.container).add(Da), this.setHeight("auto"), !0;
          } else
            Ae(this.player.dom.container).add(nl);
          return !1;
        }
      }, {
        key: "removeAspect",
        value: function() {
          this.player.dom.aspect.style.paddingTop = 0, Ae(this.player.dom.container).remove(Da);
        }
      }, {
        key: "remove",
        value: function() {
          this.removeResizeEventListener && this.removeResizeEventListener();
        }
      }]), ie;
    }(Ye), Pu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.onPlayer(et, K._onProviderInited.bind(ce(ce(K)))), K;
      }
      return ee(ie, [{
        key: "_onProviderInited",
        value: function() {
          var K = this.player._config.stretching;
          this.provider() && this.provider().setStretching(K);
        }
      }]), ie;
    }(Ye), Lu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K._onImgLoad = K._onImgLoad.bind(ce(ce(K))), K._onStyleLoaded = K._onStyleLoaded.bind(ce(ce(K))), K.setLogoStyle(), K.oncePlayer(Qa, K._onStyleLoaded), K;
      }
      return ee(ie, [{
        key: "_onStyleLoaded",
        value: function() {
          this.setLogoVisible();
        }
      }, {
        key: "_onImgLoad",
        value: function() {
          var K = this.player.dom, te = K.logoWrap, ue = K.logoImg, fe = ut(ue), pe = ut(te), me = pe.width / pe.height, ye = fe.width / fe.height;
          me > ye ? ue.style.height = "100%" : ue.style.width = "100%", ue.style.opacity = this.player._config.logo.opacity + "";
        }
      }, {
        key: "setLogoVisible",
        value: function() {
          var K = this.player._config.logo, te = this.player.dom.logoImg;
          Qe(te, "load", this._onImgLoad), te.style.display = "inline-block", te.src = K.file;
        }
      }, {
        key: "setLogoStyle",
        value: function() {
          var K = this.player._config.logo, te = this.player.dom, ue = te.logoWrap, fe = te.logoImg, pe = te.logoLink;
          if (!!K.file) {
            if (this.resetPosition(), ue.style.width = yt(K.width), ue.style.height = yt(K.height), K.position !== "control-bar") {
              var me = K.position.split("-");
              me.forEach(function(ye) {
                (ye === "top" || ye === "bottom") && (ue.style[ye] = yt(K.marginh)), (ye === "left" || ye === "right") && (ue.style[ye] = yt(K.marginw));
              }), me.forEach(function(ye) {
                fe.style[ye] = "0";
              });
            }
            pe.href = K.link ? K.link : "javascript:void(0);", pe.target = K.link ? "_blank" : "_self", pe.style.cursor = K.link ? "pointer" : "default";
          }
        }
      }, {
        key: "resetPosition",
        value: function() {
          var K = this.player.dom.logoWrap;
          K.style.cssText = "position: absolute;";
        }
      }, {
        key: "remove",
        value: function() {
          at(this.player.dom.logoImg, "load", this._onImgLoad), ge(le(ie.prototype), "remove", this).call(this);
        }
      }]), ie;
    }(Ye), Cu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.init(), K;
      }
      return ee(ie, [{
        key: "init",
        value: function() {
          var K = this.player;
          this.setTrue = function() {
            K._status.focus = !0;
          }, this.setFalse = function() {
            K._status.focus = !1;
          }, Qe(document, "click", this.setFalse, !0), Qe(K.dom.container, "click", this.setTrue, !0);
        }
      }, {
        key: "remove",
        value: function() {
          at(document, "click", this.setFalse, !0), at(this.player.dom.container, "click", this.setTrue, !0);
        }
      }]), ie;
    }(Ye), Mu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        $(this, ie), K = he(this, le(ie).call(this, re)), Je(K.player, ce(ce(K))).method("setLoadingForced");
        var te = K.player.dom.bezel, ue = K.player.dom.bezelWrap, fe = K.player._config.renderLoading;
        return fe ? (K.renderLoadingString = typeof fe == "string" ? xt(fe) : fe, K.renderLoadingString.className += "".concat(Pe, " ").concat(bl), ue.appendChild(K.renderLoadingString)) : (K.renderLoadingString = xt('<span class="'.concat(Pe, " ").concat(_l, " ").concat(Ns, '"></span>')), ue.appendChild(K.renderLoadingString)), K.onDom(te, "animationend", function() {
          Ae(te).remove(ba);
        }), K;
      }
      return ee(ie, [{
        key: "setLoadingForced",
        value: function(K) {
          this.renderLoadingString.style.display = K ? "block" : "";
        }
      }, {
        key: "switch",
        value: function(K) {
          var te = this.player.dom.bezel;
          Ae(te).remove(Hr), Ae(te).add(K), Ae(te).add(ba);
        }
      }]), ie;
    }(Ye), Fu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), Je(K.player, ce(ce(K))).method("setImage").method("setImageDisplay"), K.subEvents(), K;
      }
      return ee(ie, [{
        key: "setImage",
        value: function(K) {
          var te = this.player.dom.background, ue = Ft.call(this.player), fe = ue.alwaysDisplayImage, pe = this.player.getPlaylistIndex(), me = this.player.getPlaylistItem(pe);
          me.image = K, K ? te.style.backgroundImage = "url(".concat(K, ")") : te.style.backgroundImage = "none", fe ? Ae(te).add(La) : Ae(te).remove(La);
        }
      }, {
        key: "setImageDisplay",
        value: function(K) {
          var te = this.player.dom.background;
          switch (K) {
            case "show":
              te.style.display = "block";
              break;
            case "hidden":
              te.style.display = "none";
              break;
            case "auto":
              te.style.display = "";
          }
        }
      }, {
        key: "subEvents",
        value: function() {
          var K = this;
          this.onPlayer(et, function(te) {
            var ue = te.image, fe = K.player.dom.container;
            Ae(fe).remove(vl), Ae(fe).add(ol + "-" + K.player._config.stretching), K.setImage(ue);
          });
        }
      }]), ie;
    }(Ye), ku = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), Je(K.player, ce(ce(K))).method("appendRightControllerButton"), K;
      }
      return ee(ie, [{
        key: "appendRightControllerButton",
        value: function(K) {
          K instanceof window.HTMLElement && this.player.dom.controllerRightIcons.appendChild(K);
        }
      }]), ie;
    }(Ye);
    function bt(ae) {
      if (Ce("string", ae))
        return ae;
      if (Ce("object", ae)) {
        var ie = fi(this._status.lang, ae);
        return ae[ie];
      }
    }
    function Ki(ae, ie) {
      var re = {};
      Ce("object", ae) && (re = ae), ie.setAttribute("data-locale", "");
      for (var K in re)
        Object.hasOwnProperty.call(re, K) && ie.setAttribute("data-locale-".concat(K), re[K]);
    }
    function jt(ae) {
      if (Ce("string", ae))
        return "";
      if (Ce("object", ae)) {
        var ie = Object.keys(ae).map(function(re) {
          return "data-locale-".concat(re, '="').concat(ae[re], '"');
        });
        return ie.unshift("data-locale"), ie.join(" ");
      }
      return "";
    }
    function Ou(ae) {
      for (var ie = {}, re = 0; re < ae.length; re++) {
        var K = ae[re], te = K.name, ue = K.value;
        te.startsWith("data-locale-") && (ie[te.slice(12)] = ue);
      }
      return ie;
    }
    var Ru = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.onPlayer(et, function() {
          var te = Ft.call(re), ue = te.title;
          ue ? (re.dom.title.innerText = bt.call(K.player, ue), Ki(ue, K.player.dom.title)) : re.dom.title.style.display = "none";
        }), K;
      }
      return ie;
    }(Ye), $u = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.player._config.contextMenus.length > 0 && (K.dom = null, K.createDom(), K.tip = _t("", {
          container: re.dom.container,
          content: K.dom,
          class: "mudu-popup",
          getMaxHeight: function(ue) {
            var fe = ue.height;
            return fe;
          }
        }), K._subEvents()), K;
      }
      return ee(ie, [{
        key: "generateDom",
        value: function() {
          this.createDom();
        }
      }, {
        key: "_subEvents",
        value: function() {
          var K = this;
          this.handleContextMenu = function(te) {
            if (K.tip.isShow()) {
              K.tip.hide();
              return;
            }
            var ue = K.getStyle(te);
            ue && (_t.hideAll(), K.tip.show(ue), te.preventDefault && te.preventDefault());
          }, this.onDom(this.player.dom.container, "contextmenu", this.handleContextMenu);
        }
      }, {
        key: "getStyle",
        value: function(K) {
          var te = ut(this.player.dom.container), ue = ut(this.player.dom.container.querySelector(".".concat(Ai)));
          if (!(te.width < ue.width || te.height < ue.height)) {
            var fe = Jt({
              x: K.clientX,
              y: K.clientY
            }), pe = fe.x, me = fe.y, ye = pe, _e = me, Ee = te.height - ue.height, ke = te.width - ue.width, Re = ye - te.left, xe = _e - te.top;
            return xe = xe > Ee ? Ee : xe, Re = Re > ke ? ke : Re, {
              left: Re,
              top: xe
            };
          }
        }
      }, {
        key: "createDom",
        value: function() {
          for (var K = this.player._config.contextMenus, te = K.map(function(_e) {
            var Ee = '<a class="'.concat(Pe, " ").concat(wi, '" target="_blank" menuKey="').concat(_e.key, '" menuText="').concat(_e.text, '">') + '<div class="'.concat(Pe, " ").concat(Ys, '">').concat(_e.text, "</div>") + "</a>";
            return Ee;
          }), ue = '<div class="'.concat(Pe, " ").concat(Ai, " ").concat(Xs, '">') + '<div class="'.concat(Pe, " ").concat(Ma, '">').concat(te.join(""), "</div>") + "</div>", fe = xt(ue), pe = fe.querySelectorAll(".".concat(wi)), me = this, ye = 0; ye < pe.length; ye++)
            pe[ye].onclick = function() {
              var _e = this.getAttribute("menuKey"), Ee = this.getAttribute("menuText");
              me.tip.hide(), me.player.trigger(Di, {
                key: _e,
                text: Ee,
                type: Di
              });
            };
          this.dom = fe;
        }
      }]), ie;
    }(Ye), Nu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.highlights = [], K.autoHideTimer = null, K.subEvents(), K;
      }
      return ee(ie, [{
        key: "subEvents",
        value: function() {
          var K = this;
          this.onPlayer(Vi, function() {
            K.setHightLights();
          }), this.onPlayer(Pt, function() {
            K.clearHightLights();
          }), this.onDom(this.player.dom.playedBarWrap, "mousemove", function(te) {
            K.show(), K.handleMouseMove(te), rt() && K.setAutohide();
          }), rt() || (this.onDom(this.player.dom.playedBarWrap, "mouseenter", function(te) {
            K.show();
          }), this.onDom(this.player.dom.playedBarWrap, "mouseleave", function(te) {
            K.hide();
          }), this.onDom(this.player.dom.playedBarWrap, "mouseover", function(te) {
            K.handleDotEnter(te);
          }), this.onDom(this.player.dom.playedBarWrap, "mouseout", function(te) {
            K.handleDotLeave(te);
          }));
        }
      }, {
        key: "setAutohide",
        value: function() {
          var K = this;
          clearTimeout(this.autoHideTimer), this.autoHideTimer = setTimeout(function() {
            K.hide();
          }, 300);
        }
      }, {
        key: "handleMouseMove",
        value: function(K) {
          var te = ut(this.player.dom.playedBarWrap).left, ue = Jt({
            x: K.clientX || K.chhegdTouches[0].clientX,
            y: K.clientY || K.chhegdTouches[0].clientY
          }), fe = ue.x, pe = fe - te;
          pe < 0 || pe > this.player.dom.playedBarWrap.offsetWidth || this.move(pe);
        }
      }, {
        key: "handleDotEnter",
        value: function(K) {
          var te = K.target || K.srcElement;
          if (te && Ae(te).contains(gr)) {
            var ue = te.getAttribute("text");
            this.setDotActive(te, !0), this.setPopText(ue), this.setPopTextVisible(!0), this.handleMouseMove(K);
          }
        }
      }, {
        key: "handleDotLeave",
        value: function(K) {
          var te = K.target || K.srcElement;
          te && Ae(te).contains(gr) && (this.setDotActive(te, !1), this.setPopText(""), this.setPopTextVisible(!1), this.handleMouseMove(K));
        }
      }, {
        key: "setPopText",
        value: function(K) {
          this.player.dom.barTextText.innerHTML = K;
        }
      }, {
        key: "setPopTextVisible",
        value: function(K) {
          var te = Ae(this.player.dom.barPopup);
          K ? te.add(Ii) : te.remove(Ii);
        }
      }, {
        key: "isPopTextVisible",
        value: function() {
          return Ae(this.player.dom.barPopup).contains(Ii);
        }
      }, {
        key: "setDotActive",
        value: function(K, te) {
          var ue = Ae(K);
          te ? ue.add(pt) : ue.remove(pt);
        }
      }, {
        key: "show",
        value: function() {
          Ae(this.player.dom.barPopup).remove("hidden");
        }
      }, {
        key: "hide",
        value: function() {
          Ae(this.player.dom.barPopup).add("hidden");
        }
      }, {
        key: "move",
        value: function(K) {
          this.player.model.progress.getDuration();
          var te = this.player.dom.playedBarWrap.offsetWidth;
          K < 0 && (K = 0), K > te && (K = te);
          var ue = K / te, fe = this.player.model.progress.getPositionByPercentage(ue), pe = hr(fe);
          this.player.dom.barTime.innerHTML = pe, this.player.dom.barTextTime.innerHTML = pe, this.setPosition(!1, this.isPopTextVisible(), K, te);
        }
      }, {
        key: "dragMove",
        value: function(K, te) {
          var ue = this, fe = this.getDotFromDrag(K, te), pe = this.highlights.indexOf(fe), me = this.player.dom.highlight.querySelectorAll(".".concat(gr)), ye = me[pe];
          [].slice.call(me).forEach(function(_e) {
            return ue.setDotActive(_e, _e === ye);
          }), ye ? (this.setPopText(fe.text), this.setPopTextVisible(!0)) : (this.setPopText(""), this.setPopTextVisible(!1)), this.move(K);
        }
      }, {
        key: "dragEnd",
        value: function() {
          var K = this, te = this.player.dom.highlight.querySelectorAll(".".concat(gr));
          [].slice.call(te).forEach(function(ue) {
            return K.setDotActive(ue, !1);
          });
        }
      }, {
        key: "getDotFromDrag",
        value: function(K, te) {
          var ue = this.player.dom.playedBarWrap.offsetWidth, fe = 6, pe = this.player.model.progress.getDuration(), me = K / ue * pe, ye = fe / 2 / ue * pe, _e = this.highlights.filter(function(Ee) {
            return Ee.time > me - ye && Ee.time < me + ye;
          });
          return _e.length <= 1 || te === "left" ? _e[0] : te === "right" ? _e.pop() : _e[0];
        }
      }, {
        key: "setPosition",
        value: function(K, te, ue, fe) {
          var pe, me = 168 * this.player._status.containerFontSize / 16;
          !K && !te ? pe = this.player.dom.barTime.offsetWidth : !K && te ? pe = this.player.dom.barText.offsetWidth : pe = me;
          var ye = -(me - pe) / 2, _e = fe - (me / 2 + pe / 2), Ee = ue - me / 2;
          Ee < ye && (Ee = ye), Ee > _e && (Ee = _e), this.player.dom.barPopup.style.left = "".concat(Ee, "px");
        }
      }, {
        key: "setHightLights",
        value: function() {
          var K = Ft.call(this.player), te = K.highlights, ue = this.player.dom.highlight, fe = this.player.model.progress.getDuration();
          this.highlights = Ce("array", te) ? te : [], this.highlights = this.highlights.slice().sort(function(me, ye) {
            return me.time >= ye.time;
          });
          var pe = this.highlights.map(function(me) {
            var ye = me.time / fe;
            return '<div class="'.concat(Pe, " ").concat(gr, '" text="').concat(me.text, '" style="left: ').concat(yt(ye), '"></div>');
          });
          ue.innerHTML = pe.join("");
        }
      }, {
        key: "clearHightLights",
        value: function() {
          this.player.dom.highlight.innerHTML = "", this.highlights = [];
        }
      }]), ie;
    }(Ye), xu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K._tryDom = K.geneTryDom(), K.renderError = Ce("function", K.player._config.renderError) ? K.player._config.renderError : K.defaultRenderError.bind(ce(ce(K))), K.onPlayer(et, function() {
          K.onProvider(Ot, function(te) {
            te.message = "provider_".concat(K.player._provider.name, "_").concat(te.message), te.errorId = er(), K.player._status.state = "error", K.player.trigger(Dt, te);
          });
        }), K.onPlayer(Dt, function(te) {
          var ue = {
            errorId: te.errorId,
            message: K.filterErrorMsg(te.message),
            detail: te.message
          };
          if (te.fatal) {
            var fe = K.renderError(ue);
            (!fe || !Ce("string", fe) && !(fe instanceof HTMLElement)) && (fe = K.defaultRenderError(ue)), Ce("string", fe) ? K.player.dom.errorWrap.innerHTML = fe : (K.player.dom.errorWrap.innerHTML = "", K.player.dom.errorWrap.appendChild(fe)), Ae(K.player.dom.container).add(ki);
          }
        }), K;
      }
      return ee(ie, [{
        key: "geneTryDom",
        value: function() {
          var K = this, te = '<a href="javascript:void(0)" action="reload" style="color: blue;">'.concat(this.lang.Reload, "</a>"), ue = "<div>".concat(this.lang["You can try"], " ").concat(te, "</div>"), fe = xt(ue);
          return fe.onclick = function(pe) {
            pe = pe || window.event;
            var me = pe.target || pe.srcElement;
            me.getAttribute("action") === "reload" && K.player.replay();
          }, fe;
        }
      }, {
        key: "defaultRenderError",
        value: function(K) {
          var te = K.message;
          K.detail;
          var ue = K.errorId, fe = '<div class="'.concat(Pe, " ").concat(Aa, '">') + '<div class="'.concat(Pe, " ").concat(Ea, '"><span class="').concat(Pe, " ").concat(Hn, '"></span></div>') + '<div class="'.concat(Pe, " ").concat(Vr, '">') + "<div>".concat(te, "(").concat(ue, ")</div>") + "</div></div>", pe = xt(fe);
          return pe.querySelector(".".concat(Vr)).appendChild(this._tryDom), pe;
        }
      }, {
        key: "filterErrorMsg",
        value: function(K) {
          if (!K)
            return this.lang["Unknown Error"];
          var te = K.toLowerCase(), ue = function(pe) {
            return te.indexOf(pe) >= 0;
          };
          return ue("network") ? this.lang["Network Error"] : ue("media") || ue("parse") || ue("demux") || ue("remux") || ue("decode") ? this.lang["Media Error"] : K;
        }
      }, {
        key: "hideError",
        value: function() {
          Ae(this.player.dom.container).remove(ki);
        }
      }]), ie;
    }(Ye), Du = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.nt = K.player.dom.notice, K._t = null, Je(K.player, ce(ce(K))).method("notice"), K;
      }
      return ee(ie, [{
        key: "notice",
        value: function(K) {
          var te = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3e3;
          this.setContent(K), te > 0 && this.autoHide(te);
        }
      }, {
        key: "hide",
        value: function() {
          this.setVisible(!1);
        }
      }, {
        key: "show",
        value: function() {
          this.setVisible(!0);
        }
      }, {
        key: "autoHide",
        value: function(K) {
          var te = this;
          this.show(), this._t && (clearTimeout(this._t), this._t = null), setTimeout(function() {
            return te.hide();
          }, K);
        }
      }, {
        key: "setContent",
        value: function(K) {
          this.nt.innerHTML = K;
        }
      }, {
        key: "setVisible",
        value: function(K) {
          K ? Ae(this.nt).remove(jr) : Ae(this.nt).add(jr);
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this._t && clearTimeout(this._t);
        }
      }]), ie;
    }(Ye), Uu = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.isMobile = rt(), K.onPlayer(et, function() {
          K.onProviderInited(re);
        }), K;
      }
      return ee(ie, [{
        key: "onProviderInited",
        value: function() {
          var K = pi.call(this.player), te = this.getActiveSource(K), ue = this.getPathListBySources(K);
          this.init(), K.length > 1 && (this.isMobile ? this.initMobile(ue, K, te) : this.initQuality(ue, K, te));
        }
      }, {
        key: "init",
        value: function() {
          this.mobilePopup && this.mobilePopup.destroy(), this.qsPopup && this.qsPopup.destroy(), this.psPopup && this.psPopup.destroy(), this.player.dom.switchPath.style.display = "none", this.player.dom.switchQuality.innerHTML = "";
        }
      }, {
        key: "initMobile",
        value: function(K, te, ue) {
          var fe = this.player.dom, pe = fe.container, me = fe.switchQuality, ye = this.getSourcesByPath(ue.path, te), _e = this.createMobileMenuitem(ye, K, ue.path);
          this.mobilePopup = this.createTooltip(pe, me, _e), _e.addEventListener("click", this.mobilePopup.hide), this.addEventClick(_e.querySelectorAll('[type="path"]'), this.switchPath), this.addEventClick(_e.querySelectorAll('[type="quality"]'), this.switchQuality), ue && (this.player.dom.switchQuality.innerHTML = bt.call(this.player, ye.length > 1 ? ue.label : ue.path_name), Ki(ye.length > 1 ? ue.label : ue.path_name, this.player.dom.switchQuality));
        }
      }, {
        key: "initQuality",
        value: function(K, te, ue) {
          var fe = this.player.dom, pe = fe.container, me = fe.switchQuality, ye = this.getSourcesByPath(ue.path, te), _e = this.createQualityMenuitem(ye, K, ue);
          this.addEventClick(_e.querySelectorAll('[type="quality"]'), this.switchQuality), this.addEventClick(_e.querySelectorAll('[type="path"]'), this.switchPath);
          var Ee = _e.querySelector(".".concat(Li)), ke = _e.querySelector(".".concat($a));
          this.qsPopup = this.createTooltip(pe, me, _e, function() {
            ke && (ke.style.visibility = "hidden");
          }), Qe(Ee, "click", function(Re) {
            var xe = "hidden";
            if (ke.style.visibility !== "visible") {
              var Ge = ut(_e).height - 48;
              ke.style.maxHeight = yt(Ge), xe = "visible";
            }
            ke.style.visibility = xe, Re.stopPropagation && Re.stopPropagation(), Re.cancelBubble = !0;
          }), Qe(document, "click", function(Re) {
            ke.style.visibility = "hidden";
          }), ue && (this.player.dom.switchQuality.innerHTML = bt.call(this.player, ye.length > 1 ? ue.label : ue.path_name), Ki(ye.length > 1 ? ue.label : ue.path_name, this.player.dom.switchQuality));
        }
      }, {
        key: "initPath",
        value: function(K, te) {
          var ue = this.player.dom, fe = ue.container, pe = ue.switchPath, me = this.getPathListBySources(K), ye = this.createPathMenuitem(te.path, me);
          this.addEventClick(ye.querySelectorAll('[type="path"]'), this.switchPath), this.psPopup = this.createTooltip(fe, pe, ye), te && (this.player.dom.switchPath.innerHTML = bt.call(this.player, te.path_name));
        }
      }, {
        key: "addEventClick",
        value: function(K, te) {
          var ue = this;
          K.forEach(function(fe) {
            fe.onclick = function() {
              return te.call(ue, fe);
            };
          });
        }
      }, {
        key: "getActiveSource",
        value: function(K) {
          return K.filter(function(te) {
            return te.active;
          })[0];
        }
      }, {
        key: "switchQuality",
        value: function(K) {
          if (this.isMobile ? this.mobilePopup.hide() : this.qsPopup.hide(), !Ae(K).contains(pt)) {
            var te = Number(K.getAttribute("value"));
            this.player.switchQuality(te);
          }
        }
      }, {
        key: "switchPath",
        value: function(K) {
          if (!Ae(K).contains(pt)) {
            var te = pi.call(this.player), ue = K.getAttribute("value"), fe = this.getActiveSource(te), pe = te.filter(function(ye) {
              return ye.path === ue;
            }), me = pe.find(function(ye) {
              return ye.label === fe.label;
            });
            me || (me = pe[0]), this.player.switchQuality(Number(me.index)), this.isMobile ? this.mobilePopup.hide() : this.qsPopup.hide();
          }
        }
      }, {
        key: "getSourcesByPath",
        value: function(K, te) {
          return te.filter(function(ue) {
            return ue.path === K;
          });
        }
      }, {
        key: "getPathListBySources",
        value: function(K) {
          var te = K.filter(function(fe) {
            return fe.path && fe.path_name;
          }), ue = [];
          return te.forEach(function(fe) {
            var pe = ue.findIndex(function(me) {
              return me.path === fe.path;
            }) > -1;
            pe || ue.push({
              path: fe.path,
              path_name: fe.path_name
            });
          }), ue;
        }
      }, {
        key: "createMobileMenuitem",
        value: function(K, te, ue) {
          var fe = this, pe = te.map(function(_e, Ee) {
            return '<div class="'.concat(rr, " ").concat(ue === _e.path ? pt : "", '" type="path" value="').concat(_e.path, `">
         `).concat(Ee === 0 ? '<div class="'.concat(Pe, " ").concat(Oa, '" data-lang-key="Line">').concat(fe.lang.Line, "</div>") : "", `
         <span class="`).concat(ir, '" ').concat(jt(_e.path_name), ">").concat(bt.call(fe.player, _e.path_name), `</span>
       </div>`);
          }).join(""), me = K.map(function(_e, Ee) {
            return '<div class="'.concat(rr, " ").concat(_e.active ? pt : "", '" type="quality" value="').concat(_e.index, `">
        `).concat(Ee === 0 ? '<div class="'.concat(Pe, " ").concat(Oa, '" data-lang-key="Quality">').concat(fe.lang.Quality, "</div>") : "", `
         <span class="`).concat(ir, '" ').concat(jt(_e.label), ">").concat(bt.call(fe.player, _e.label), `</span>
       </div>`);
          }).join(""), ye = '<div class="'.concat(ka, `">
                   <div class="`).concat(Pi, `">
                    <div style="display: `).concat(te.length > 1 ? "flex" : "none", `">
                       <div class="`).concat(Ra, '">').concat(pe, `</div>
                     </div>
                     <div style="display: `).concat(K.length > 1 ? "flex" : "none", `">
                       <div class="`).concat(Ra, '">').concat(me, `</div>
                     </div>
                   </div>
                 </div>`);
          return xt(ye);
        }
      }, {
        key: "createQualityMenuitem",
        value: function(K, te, ue) {
          var fe = this, pe = "", me = "";
          K.length > 1 && te.length > 1 ? (pe = K.map(function(_e) {
            return '<div class="'.concat(rr, " ").concat(_e.active ? pt : "", '" type="quality" value="').concat(_e.index, `">
           <span class="`).concat(ir, '" ').concat(jt(_e.label), ">").concat(bt.call(fe.player, _e.label), `</span>
         </div>`);
          }).join(""), me = te.map(function(_e) {
            return '<div class="'.concat(tl, " ").concat(ue.path === _e.path ? pt : "", '" type="path" value="').concat(_e.path, '" ').concat(jt(_e.path_name), ">").concat(bt.call(fe.player, _e.path_name), "</div>");
          }).join("")) : te.length > 1 && K.length <= 1 ? pe = te.map(function(_e) {
            return '<div class="'.concat(rr, " ").concat(ue.path === _e.path ? pt : "", '" type="path" value="').concat(_e.path, `">
           <span class="`).concat(ir, '" ').concat(jt(_e.path_name), ">").concat(bt.call(fe.player, _e.path_name), `</span>
         </div>`);
          }).join("") : pe = K.map(function(_e) {
            return '<div class="'.concat(rr, " ").concat(_e.active ? pt : "", '" type="quality" value="').concat(_e.index, `">
           <span class="`).concat(ir, '" ').concat(jt(_e.label), ">").concat(bt.call(fe.player, _e.label), `</span>
         </div>`);
          }).join("");
          var ye = '<div class="'.concat(ka, `">
      <div class="`).concat(Li, '" style="display: ').concat(te.length > 1 && K.length > 1 ? "block" : "none", `">
        <div `).concat(jt(ue.path_name), `>
          `).concat(bt.call(this.player, ue.path_name), `
        </div>
        <div class="`).concat(Pe, " ").concat($a, `">
          `).concat(me, `
        </div>
      </div>
      <div class="`).concat(Pi, '">').concat(pe, `</div>
    </div>`);
          return xt(ye);
        }
      }, {
        key: "createPathMenuitem",
        value: function(K, te) {
          var ue = this, fe = te.length > 4 && !this.mobile, pe = te.map(function(me) {
            return '<div class="'.concat(rr, " ").concat(K === me.path ? pt : "", '" type="path" value="').concat(me.path, `">
         <span class="`).concat(ir, '" ').concat(jt(me.path_name), ">").concat(bt.call(ue.player, me.path_name), `</span>
       </div>`);
          }).join("");
          return xt('<div class="'.concat(Zs, " ").concat(fe ? el : "", `">
                                <div class="`).concat(Pi, '">').concat(pe, `</div>
                              </div>`));
        }
      }, {
        key: "createTooltip",
        value: function(K, te, ue, fe) {
          var pe = this, me = _t(te, {
            trigger: "click",
            content: ue,
            container: K,
            distance: 0,
            class: this.isMobile ? "mudu-popup ".concat(Gr) : "mudu-popup",
            getMaxHeight: function(_e) {
              var Ee = _e.height;
              return pe.isMobile ? Ee : Ee - 70;
            },
            wrapClick: fe
          });
          return this.onPlayer(Pt, me.destroy), me;
        }
      }]), ie;
    }(Ye), bo = typeof window != "undefined" ? window : typeof commonjsGlobal != "undefined" ? commonjsGlobal : typeof self != "undefined" ? self : {};
    function Hu(ae, ie) {
      return ie = { exports: {} }, ae(ie, ie.exports), ie.exports;
    }
    var Er;
    typeof window != "undefined" ? Er = window : typeof bo != "undefined" ? Er = bo : typeof self != "undefined" ? Er = self : Er = {};
    var To = Er, Vu = Gu, Bu = Object.prototype.toString;
    function Gu(ae) {
      var ie = Bu.call(ae);
      return ie === "[object Function]" || typeof ae == "function" && ie !== "[object RegExp]" || typeof window != "undefined" && (ae === window.setTimeout || ae === window.alert || ae === window.confirm || ae === window.prompt);
    }
    var Ir = Hu(function(ae, ie) {
      ie = ae.exports = re;
      function re(K) {
        return K.replace(/^\s*|\s*$/g, "");
      }
      ie.left = function(K) {
        return K.replace(/^\s*/, "");
      }, ie.right = function(K) {
        return K.replace(/\s*$/, "");
      };
    });
    Ir.left, Ir.right;
    var So = Function.prototype.toString, Wu = /^\s*class\b/, Eo = function(ie) {
      try {
        var re = So.call(ie);
        return Wu.test(re);
      } catch (K) {
        return !1;
      }
    }, ju = function(ie) {
      try {
        return Eo(ie) ? !1 : (So.call(ie), !0);
      } catch (re) {
        return !1;
      }
    }, zu = Object.prototype.toString, qu = "[object Function]", Ku = "[object GeneratorFunction]", Yu = typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol", Xu = function(ie) {
      if (!ie || typeof ie != "function" && typeof ie != "object")
        return !1;
      if (typeof ie == "function" && !ie.prototype)
        return !0;
      if (Yu)
        return ju(ie);
      if (Eo(ie))
        return !1;
      var re = zu.call(ie);
      return re === qu || re === Ku;
    }, Qu = Object.prototype.toString, Io = Object.prototype.hasOwnProperty, Ju = function(ie, re, K) {
      for (var te = 0, ue = ie.length; te < ue; te++)
        Io.call(ie, te) && (K == null ? re(ie[te], te, ie) : re.call(K, ie[te], te, ie));
    }, Zu = function(ie, re, K) {
      for (var te = 0, ue = ie.length; te < ue; te++)
        K == null ? re(ie.charAt(te), te, ie) : re.call(K, ie.charAt(te), te, ie);
    }, e0 = function(ie, re, K) {
      for (var te in ie)
        Io.call(ie, te) && (K == null ? re(ie[te], te, ie) : re.call(K, ie[te], te, ie));
    }, t0 = function(ie, re, K) {
      if (!Xu(re))
        throw new TypeError("iterator must be a function");
      var te;
      arguments.length >= 3 && (te = K), Qu.call(ie) === "[object Array]" ? Ju(ie, re, te) : typeof ie == "string" ? Zu(ie, re, te) : e0(ie, re, te);
    }, r0 = t0, i0 = function(ae) {
      return Object.prototype.toString.call(ae) === "[object Array]";
    }, n0 = function(ae) {
      if (!ae)
        return {};
      var ie = {};
      return r0(
        Ir(ae).split(`
`),
        function(re) {
          var K = re.indexOf(":"), te = Ir(re.slice(0, K)).toLowerCase(), ue = Ir(re.slice(K + 1));
          typeof ie[te] == "undefined" ? ie[te] = ue : i0(ie[te]) ? ie[te].push(ue) : ie[te] = [ie[te], ue];
        }
      ), ie;
    }, a0 = s0, o0 = Object.prototype.hasOwnProperty;
    function s0() {
      for (var ae = {}, ie = 0; ie < arguments.length; ie++) {
        var re = arguments[ie];
        for (var K in re)
          o0.call(re, K) && (ae[K] = re[K]);
      }
      return ae;
    }
    var Yi = Vt, l0 = Vt;
    Vt.XMLHttpRequest = To.XMLHttpRequest || h0, Vt.XDomainRequest = "withCredentials" in new Vt.XMLHttpRequest() ? Vt.XMLHttpRequest : To.XDomainRequest, u0(["get", "put", "post", "patch", "head", "delete"], function(ae) {
      Vt[ae === "delete" ? "del" : ae] = function(ie, re, K) {
        return re = Ao(ie, re, K), re.method = ae.toUpperCase(), wo(re);
      };
    });
    function u0(ae, ie) {
      for (var re = 0; re < ae.length; re++)
        ie(ae[re]);
    }
    function c0(ae) {
      for (var ie in ae)
        if (ae.hasOwnProperty(ie))
          return !1;
      return !0;
    }
    function Ao(ae, ie, re) {
      var K = ae;
      return Vu(ie) ? (re = ie, typeof ae == "string" && (K = { uri: ae })) : K = a0(ie, { uri: ae }), K.callback = re, K;
    }
    function Vt(ae, ie, re) {
      return ie = Ao(ae, ie, re), wo(ie);
    }
    function wo(ae) {
      if (typeof ae.callback == "undefined")
        throw new Error("callback argument missing");
      var ie = !1, re = function(ze, Ve, st) {
        ie || (ie = !0, ae.callback(ze, Ve, st));
      };
      function K() {
        pe.readyState === 4 && setTimeout(fe, 0);
      }
      function te() {
        var We = void 0;
        if (pe.response ? We = pe.response : We = pe.responseText || d0(pe), Ge)
          try {
            We = JSON.parse(We);
          } catch (ze) {
          }
        return We;
      }
      function ue(We) {
        return clearTimeout(qe), We instanceof Error || (We = new Error("" + (We || "Unknown XMLHttpRequest Error"))), We.statusCode = 0, re(We, Ze);
      }
      function fe() {
        if (!ye) {
          var We;
          clearTimeout(qe), ae.useXDR && pe.status === void 0 ? We = 200 : We = pe.status === 1223 ? 204 : pe.status;
          var ze = Ze, Ve = null;
          return We !== 0 ? (ze = {
            body: te(),
            statusCode: We,
            method: Ee,
            headers: {},
            url: _e,
            rawRequest: pe
          }, pe.getAllResponseHeaders && (ze.headers = n0(pe.getAllResponseHeaders()))) : Ve = new Error("Internal XMLHttpRequest Error"), re(Ve, ze, ze.body);
        }
      }
      var pe = ae.xhr || null;
      pe || (ae.cors || ae.useXDR ? pe = new Vt.XDomainRequest() : pe = new Vt.XMLHttpRequest());
      var me, ye, _e = pe.url = ae.uri || ae.url, Ee = pe.method = ae.method || "GET", ke = ae.body || ae.data, Re = pe.headers = ae.headers || {}, xe = !!ae.sync, Ge = !1, qe, Ze = {
        body: void 0,
        headers: {},
        statusCode: 0,
        method: Ee,
        url: _e,
        rawRequest: pe
      };
      if ("json" in ae && ae.json !== !1 && (Ge = !0, Re.accept || Re.Accept || (Re.Accept = "application/json"), Ee !== "GET" && Ee !== "HEAD" && (Re["content-type"] || Re["Content-Type"] || (Re["Content-Type"] = "application/json"), ke = JSON.stringify(ae.json === !0 ? ke : ae.json))), pe.onreadystatechange = K, pe.onload = fe, pe.onerror = ue, pe.onprogress = function() {
      }, pe.onabort = function() {
        ye = !0;
      }, pe.ontimeout = ue, pe.open(Ee, _e, !xe, ae.username, ae.password), xe || (pe.withCredentials = !!ae.withCredentials), !xe && ae.timeout > 0 && (qe = setTimeout(function() {
        if (!ye) {
          ye = !0, pe.abort("timeout");
          var We = new Error("XMLHttpRequest timeout");
          We.code = "ETIMEDOUT", ue(We);
        }
      }, ae.timeout)), pe.setRequestHeader)
        for (me in Re)
          Re.hasOwnProperty(me) && pe.setRequestHeader(me, Re[me]);
      else if (ae.headers && !c0(ae.headers))
        throw new Error("Headers cannot be set on an XDomainRequest object");
      return "responseType" in ae && (pe.responseType = ae.responseType), "beforeSend" in ae && typeof ae.beforeSend == "function" && ae.beforeSend(pe), pe.send(ke || null), pe;
    }
    function d0(ae) {
      try {
        if (ae.responseType === "document")
          return ae.responseXML;
        var ie = ae.responseXML && ae.responseXML.documentElement.nodeName === "parsererror";
        if (ae.responseType === "" && !ie)
          return ae.responseXML;
      } catch (re) {
      }
      return null;
    }
    function h0() {
    }
    Yi.default = l0;
    function Po(ae, ie) {
      var re = li(), K = Zt(ie), te = {
        time: re
      };
      K.forEach(function(ue) {
        te[ue] = tr(ie[ue]);
      });
      try {
        Yi({
          url: ae + "?time=" + decodeURIComponent(re),
          method: "POST",
          body: tr(te),
          headers: {
            "Content-Type": "application/json"
          }
        }, Nt);
      } catch (ue) {
      }
    }
    function f0(ae, ie) {
      var re = Ts(oe({}, ie, {
        time: li()
      }));
      Yi("".concat(ae, "?").concat(re), Nt);
    }
    var p0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.perfLogUrl = re._config.perfLogUrl, K.buffer_records = [], K.metric_records = [], K.provider_is_html5 = !1, K.provider_name = "", K.stream_url = "", K.perf_id = "", K.perf_paused = !0, Je(K.player, ce(ce(K))).method("getMediaHeight").method("getMediaWidth").method("getMetrics"), !K.perfLogUrl || $t() ? he(K, ce(ce(K))) : (K.calcTimer = new Wt({
          gap: 3e3
        }), K.recordTimer = new Wt({
          gap: 800
        }), K.onPlayer(et, K._onProviderInited.bind(ce(ce(K)))), K.onPlayer(Pt, K._onProviderRemoved.bind(ce(ce(K)))), K.recordTimer.on("tick", K._onRecordTimerTick.bind(ce(ce(K)))), K.recordTimer.on("start", K._onRecordTimerTick.bind(ce(ce(K)))), K.calcTimer.on("tick", K._onCalcTimerTick.bind(ce(ce(K)))), K);
      }
      return ee(ie, [{
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.recordTimer && this.recordTimer.stop(), this.calcTimer && this.calcTimer.stop();
        }
      }, {
        key: "getMediaHeight",
        value: function() {
          return this.provider() ? this.provider().getHeight() : -1;
        }
      }, {
        key: "getMeidaWidth",
        value: function() {
          return this.provider() ? this.provider().getWidth() : -1;
        }
      }, {
        key: "getMetrics",
        value: function() {
          return this.provider() ? this.provider().getMetrics() : null;
        }
      }, {
        key: "recordMetrics",
        value: function() {
          this.metric_records.push(oe({
            time: this._getTs(),
            pos: this.player.model.progress.getPosition()
          }, this.getMetrics()));
        }
      }, {
        key: "calcBufferTimes",
        value: function() {
          var K = this._getTs(), te = this.buffer_records.filter(function(ue) {
            return ue.time >= K - 3e3 && ue.time < K;
          });
          return this.buffer_records = this.buffer_records.filter(function(ue) {
            return ue.time < K - 3e4;
          }), {
            times: te.filter(function(ue) {
              return ue.type === "waiting";
            }).length,
            records: te
          };
        }
      }, {
        key: "calcBuffer",
        value: function() {
          var K = this.player.model.progress.getBuffer(), te = K.reduce(function(ue, fe) {
            return ue + (fe.end - fe.start);
          }, 0);
          return {
            buffer: K,
            length: te
          };
        }
      }, {
        key: "calcMetrics",
        value: function() {
          var K = this._getTs(), te = this.metric_records.filter(function(me) {
            return me.time >= K - 3e3 && me.time <= K;
          });
          if (this.metric_records = this.metric_records.filter(function(me) {
            return me.time < K - 3e3;
          }), te.length !== 0) {
            var ue, fe = {}, pe = te[0];
            return Ce("undefined", pe.fps) ? Ce("undefined", pe.mozParsedFrames) ? Ce("undefined", pe.webkitAudioDecodedByteCount) ? ue = "other" : (ue = "webkit", fe = this._calcWebkitMetrics(te)) : (ue = "moz", fe = this._calcMozMetrics(te)) : (ue = "flash", fe = this._calcFlashMetrics(te)), oe({}, fe, {
              type: ue,
              records: te
            });
          }
        }
      }, {
        key: "_calcFlashMetrics",
        value: function(K) {
          var te = {
            fps: 0,
            bps: 0
          }, ue = K.map(function(ye) {
            return ye.fps;
          }).filter(function(ye) {
            return ye > 0;
          }), fe = K.map(function(ye) {
            return ye.bps;
          }).filter(function(ye) {
            return ye > 0;
          }), pe = ue.length, me = fe.length;
          return ue.forEach(function(ye) {
            te.fps += ye / pe;
          }), fe.forEach(function(ye) {
            te.bps += ye / me;
          }), te;
        }
      }, {
        key: "_calcWebkitMetrics",
        value: function(K) {
          var te = {
            fps: 0,
            bps: 0,
            decodedFps: 0,
            droppedFps: 0,
            audioBps: 0,
            videoBps: 0,
            recordsLength: K.length
          };
          if (K.length === 1)
            return te;
          var ue = K.map(function(me, ye, _e) {
            return ye === 0 ? {
              time: 0
            } : {
              time: _e[ye].time - _e[ye - 1].time,
              audioDecodedBytes: _e[ye].webkitAudioDecodedByteCount - _e[ye - 1].webkitAudioDecodedByteCount,
              videoDecodedBytes: _e[ye].webkitVideoDecodedByteCount - _e[ye - 1].webkitVideoDecodedByteCount,
              decodedFrames: _e[ye].webkitDecodedFrameCount - _e[ye - 1].webkitDecodedFrameCount,
              droppedFrames: _e[ye].webkitDroppedFrameCount - _e[ye - 1].webkitDroppedFrameCount
            };
          }).filter(function(me) {
            return me.time !== 0;
          }), fe = ue.map(function(me) {
            var ye = me.time / 1e3, _e = {
              decodedFps: me.decodedFrames / ye,
              droppedFps: me.droppedFrames / ye,
              audioBps: me.audioDecodedBytes / ye,
              videoBps: me.videoDecodedBytes / ye,
              time: ye
            };
            return _e.fps = _e.decodedFps + _e.droppedFps, _e.bps = _e.audioBps + _e.videoBps, _e;
          }), pe = fe.reduce(function(me, ye) {
            return me + ye.time;
          }, 0);
          return fe.forEach(function(me) {
            te.decodedFps = me.decodedFps * me.time / pe + te.decodedFps, te.droppedFps = me.droppedFps * me.time / pe + te.droppedFps, te.audioBps = me.audioBps * me.time / pe + te.audioBps, te.videoBps = me.videoBps * me.time / pe + te.videoBps;
          }), te.fps = te.decodedFps + te.droppedFps, te.bps = te.audioBps + te.videoBps, te;
        }
      }, {
        key: "_calcMozMetrics",
        value: function(K) {
          var te = {
            fps: 0,
            parsedFps: 0,
            decodedFps: 0,
            presentedFps: 0,
            paintedFps: 0,
            recordsLength: K.length
          };
          if (K.length === 1)
            return te;
          var ue = K.map(function(me, ye, _e) {
            return ye === 0 ? {
              time: 0
            } : {
              time: _e[ye].time - _e[ye - 1].time,
              parsedFrames: _e[ye].mozParsedFrames - _e[ye - 1].mozParsedFrames,
              decodedFrames: _e[ye].mozDecodedFrames - _e[ye - 1].mozDecodedFrames,
              presentedFrames: _e[ye].mozPresentedFrames - _e[ye - 1].mozPresentedFrames,
              paintedFrames: _e[ye].mozPaintedFrames - _e[ye - 1].mozPaintedFrames
            };
          }).filter(function(me) {
            return me.time !== 0;
          }), fe = ue.map(function(me) {
            var ye = me.time / 1e3, _e = {
              parsedFps: me.parsedFrames / ye,
              decodedFps: me.decodedFrames / ye,
              presentedFps: me.presentedFrames / ye,
              paintedFps: me.paintedFrames / ye,
              time: ye
            };
            return _e.fps = _e.parsedFps, _e;
          }), pe = fe.reduce(function(me, ye) {
            return me + ye.time;
          }, 0);
          return fe.forEach(function(me) {
            te.parsedFps = me.parsedFps * me.time / pe + te.parsedFps, te.decodedFps = me.decodedFps * me.time / pe + te.decodedFps, te.presentedFps = me.presentedFps * me.time / pe + te.presentedFps, te.paintedFps = me.paintedFps * me.time / pe + te.paintedFps;
          }), te.fps = te.parsedFps, te;
        }
      }, {
        key: "_onProviderInited",
        value: function(K) {
          var te = K.file;
          this.stream_url = te, this.provider_is_html5 = this.player._provider.html5, this.provider_name = this.player._provider.name, this.perf_id = this.player._status.uniqId + "_" + ui(2), this.buffer_records = [], this.metric_records = [], this.onProvider(Yl, this._onWaiting.bind(this)), this.onProvider(ho, this._onPlay.bind(this)), this.onProvider(Xr, this._onPause.bind(this));
        }
      }, {
        key: "_onProviderRemoved",
        value: function() {
          this.stream_url = "", this.provider_name = "", this.buffer_records = [], this.metric_records = [], this.calcTimer && this.calcTimer.stop(), this.recordTimer && this.recordTimer.stop();
        }
      }, {
        key: "_onCalcTimerTick",
        value: function(K) {
          var te = K.isStop;
          if (K.duration, !te) {
            var ue = this.calcMetrics();
            if (!!ue) {
              var fe = this.calcBufferTimes(), pe = this.calcBuffer(), me = ue.records[0], ye = ue.records[ue.records.length - 1], _e = me && me.pos, Ee = ye && ye.pos - me.pos, ke = {
                fps: ue.fps,
                bps: ue.bps,
                waiting_times: fe.times,
                buffer_length: pe.length,
                decoded_fps: Ce("number", ue.decodedFps) ? ue.decodedFps : -1,
                dropped_fps: Ce("number", ue.droppedFps) ? ue.droppedFps : -1,
                audio_bps: Ce("number", ue.audioBps) ? ue.audioBps : -1,
                video_bps: Ce("number", ue.videoBps) ? ue.videoBps : -1,
                records_count: ue.records.length,
                record_pos: _e,
                record_time: Ee,
                metric_type: ue.type,
                buffer_detail: JSON.stringify(pe.buffer),
                metrics_detail: JSON.stringify(ue),
                stream_url: this.stream_url,
                metric_id: this.perf_id,
                user_agent: navigator.userAgent,
                refer: window.location.href
              };
              f0(this.perfLogUrl, ke);
            }
          }
        }
      }, {
        key: "_onRecordTimerTick",
        value: function(K) {
          var te = K.isStop;
          !te && this.recordMetrics();
        }
      }, {
        key: "_onWaiting",
        value: function() {
          this.buffer_records.push({
            type: "waiting",
            pos: this.player.model.progress.getPosition(),
            time: this._getTs()
          });
        }
      }, {
        key: "_onPlay",
        value: function() {
          this.buffer_records.push({
            type: "play",
            pos: this.player.model.progress.getPosition(),
            time: this._getTs()
          }), this.recordTimer.start(), this.calcTimer.start();
        }
      }, {
        key: "_onPause",
        value: function() {
          this.recordTimer.tick(), this.recordTimer.stop(), this.calcTimer.tick(), this.calcTimer.stop();
        }
      }, {
        key: "_getTs",
        value: function() {
          return new Date().getTime();
        }
      }]), ie;
    }(Ye), m0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.onPlayer(et, K._onProviderInited.bind(ce(ce(K)))), Je(K.player, ce(ce(K))).method("getTextTracks").method("setTextTrackEnable").method("setTextTrackDisable").method("getTextTrackCues").method("getTextTrackActiveCues"), K;
      }
      return ee(ie, [{
        key: "getTextTracks",
        value: function() {
          return this.provider() ? this.provider().getTextTracks() : [];
        }
      }, {
        key: "getTextTrackCues",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          return this.provider() ? this.provider().getTextTrackCues(K) : [];
        }
      }, {
        key: "getTextTrackActiveCues",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          return this.provider() ? this.provider().getTextTrackActiveCues(K) : [];
        }
      }, {
        key: "setTextTrackEnable",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          if (this.provider())
            return this.provider().setTextTrackEnable(K);
        }
      }, {
        key: "setTextTrackDisable",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          if (this.provider())
            return this.provider().setTextTrackDisable(K);
        }
      }, {
        key: "_onProviderInited",
        value: function() {
          this.player._config.textTrackDisable || (this.onProvider(fo, this._onTexttrackAdd.bind(this)), this.onProvider(po, this._onTexttrackChange.bind(this)), this.onProvider(mo, this._onCueChange.bind(this)));
        }
      }, {
        key: "_onCueChange",
        value: function(K) {
          var te = K.track, ue = K.cues, fe = K.activeCues;
          this.player.trigger(Yr, {
            track: te,
            cues: ue,
            activeCues: fe,
            type: Yr
          });
        }
      }, {
        key: "_onTexttrackAdd",
        value: function(K) {
          this.player.trigger(Kr, {
            track: K,
            type: Kr
          });
        }
      }, {
        key: "_onTexttrackChange",
        value: function(K) {
          this.player.trigger(ao, {
            tracks: K,
            type: ao
          });
        }
      }]), ie;
    }(Ye), g0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K._fontSize = 0, K._borderRadius = 0, K._subtitleTrackIdx = -1, K._showSubtitles = re._config.showSubtitle, Je(K.player, ce(ce(K))).method("getShowSubtitle").method("setShowSubtitle").method("setShowingTextTrackIndex").method("getShowingTextTrackIndex"), K.onPlayer(Pt, K._onProviderRemoved.bind(ce(ce(K)))), K.onPlayer(Kr, K._onTextTrackAdd.bind(ce(ce(K)))), K.onPlayer(Yr, K._onCueChange.bind(ce(ce(K)))), K;
      }
      return ee(ie, [{
        key: "setShowSubtitle",
        value: function(K) {
          K = !!K, K && !this._isShowingSubtitles() && this._showRandomSubtitle(), !K && this._isShowingSubtitles() && (this._clearShowingCues(), this._subtitleTrackIdx = -1), this._showSubtitles = K;
        }
      }, {
        key: "getShowSubtitle",
        value: function() {
          return this._showSubtitles;
        }
      }, {
        key: "setShowingTextTrackIndex",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, te = this.player.model.textTrack.getTextTracks(), ue = te[K];
          K !== this._subtitleTrackIdx && ue && (this._subtitleTrackIdx >= 0 && this.player.model.textTrack.setTextTrackDisable(this._subtitleTrackIdx), this._subtitleTrackIdx = K, this.player.model.textTrack.setTextTrackEnable(K));
        }
      }, {
        key: "getShowingTextTrackIndex",
        value: function() {
          return this._subtitleTrackIdx;
        }
      }, {
        key: "_onCueChange",
        value: function(K) {
          var te = K.track, ue = K.activeCues, fe = this.player.model.textTrack.getTextTracks(), pe = fe.indexOf(te);
          pe === this._subtitleTrackIdx && this._showActiveCues(ue);
        }
      }, {
        key: "_onTextTrackAdd",
        value: function(K) {
          K.track, this._showSubtitles && this._subtitleTrackIdx === -1 && this._showRandomSubtitle();
        }
      }, {
        key: "_updateSubtitleStyle",
        value: function() {
          var K = this, te = [].slice.call(document.querySelectorAll(".".concat(Wn)));
          te.forEach(function(ue) {
            ue.style.fontSize = K._fontSize + "px", ue.style.borderRadius = K._borderRadius + "px";
          });
        }
      }, {
        key: "_onProviderRemoved",
        value: function() {
          this._clearShowingCues(), this._subtitleTrackIdx = -1;
        }
      }, {
        key: "_isShowingSubtitles",
        value: function() {
          return this._showSubtitles && this._subtitleTrackIdx !== -1;
        }
      }, {
        key: "_selectSubtitleTrack",
        value: function() {
          for (var K = this.player.model.textTrack.getTextTracks(), te, ue, fe = 0; fe < K.length; fe++)
            (K[fe].kind === "subtitles" || K[fe].kind === "captions") && (te || (te = {
              index: fe,
              track: K[fe]
            }), K[fe].mode === "hidden" && !ue && (ue = {
              index: fe,
              track: K[fe]
            }));
          return ue || te || {
            index: -1,
            track: null
          };
        }
      }, {
        key: "_clearShowingCues",
        value: function() {
          var K = document.querySelector(".".concat(Si));
          K.innerHTML = "";
        }
      }, {
        key: "_showActiveCues",
        value: function(K) {
          if (!K.length)
            return this._clearShowingCues();
          K.sort(function(pe, me) {
            var ye = pe.startTime - me.startTime;
            return ye || me.endTime - pe.endTime;
          });
          var te = "font-size: ".concat(this._fontSize, "px; border-radius: ").concat(this._borderRadius, "px"), ue = K.map(function(pe) {
            var me = '<span class="'.concat(Wn, '" style="').concat(te, '">&nbsp;').concat(pe.text, "&nbsp;</span>");
            return me;
          }), fe = document.querySelector(".".concat(Si));
          fe.innerHTML = ue.join("<br>");
        }
      }, {
        key: "_setSubtitleSize",
        value: function(K) {
          var te = 3125e-6, ue = 0.025, fe = 14, pe = 40, me = 1.5;
          this._fontSize = Math.max(K * ue, fe), this._fontSize = Math.min(this._fontSize, pe), this._borderRadius = Math.max(K * te, me);
        }
      }, {
        key: "_showRandomSubtitle",
        value: function() {
          var K = this._selectSubtitleTrack(), te = K.index;
          return te === -1 ? !1 : (this.setShowingTextTrackIndex(te, !0), !0);
        }
      }]), ie;
    }(Ye), Zr = "myunSyncAvailable", ei = "myunSyncMessage", v0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K._available = !1, K._textTrackLabel = re._config.myunSyncTextTrackLabel, K._myunSyncTrack = null, K._myunMsgCue = null, K.onPlayer(Pt, K._onProviderRemoved.bind(ce(ce(K)))), K.onPlayer(Kr, K._onTextTrackAdd.bind(ce(ce(K)))), K.onPlayer(Yr, K._onCueChange.bind(ce(ce(K)))), Je(K.player, ce(ce(K))).method("getMyunSyncAvailable"), K;
      }
      return ee(ie, [{
        key: "getMyunSyncAvailable",
        value: function() {
          return this._available;
        }
      }, {
        key: "_onProviderRemoved",
        value: function() {
          this._myunSyncTrack = null, this._available = !1, this._myunMsgCue = null, this.player.trigger(Zr, {
            type: Zr,
            available: !1
          });
        }
      }, {
        key: "_onTextTrackAdd",
        value: function(K) {
          var te = K.track;
          if (te.label === this._textTrackLabel && te.kind === "subtitles") {
            var ue = this.player.model.textTrack.getTextTracks(), fe = ue.indexOf(te);
            this.player.model.textTrack.setTextTrackEnable(fe), this._myunSyncTrack = te, this._available = !0, this.player.trigger(Zr, {
              type: Zr,
              available: !0
            });
          }
        }
      }, {
        key: "_onCueChange",
        value: function(K) {
          var te = this, ue = K.activeCues, fe = K.cues, pe = K.track, me = {};
          if (pe === this._myunSyncTrack) {
            if (ue.length !== 0)
              me = ue.pop();
            else if (ft()) {
              var ye = Math.floor(this.player._container.querySelector("video").currentTime);
              if (me = fe.find(function(Ee) {
                return ye === Math.floor(Ee.startTime);
              }), !me || me.startTime !== me.endTime)
                return;
            } else
              return;
            if (me !== this._myunMsgCue) {
              this._myunMsgCue = me;
              var _e = JSON.parse(me.text);
              Array.isArray(_e) && _e[0].ts_ms && _e[0].content ? _e.forEach(function(Ee) {
                setTimeout(function() {
                  return te.player.trigger(ei, {
                    type: ei,
                    message: Ee.content || ""
                  });
                }, Ee.ts_ms);
              }) : this.player.trigger(ei, {
                type: ei,
                message: me.text,
                cue: me,
                cues: fe
              });
            }
          }
        }
      }]), ie;
    }(Ye), y0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        $(this, ie), K = he(this, le(ie).call(this, re)), K._is360loneWindow = !1, K._timer = 0;
        var te = re._config.recordRestrict.enable360LoneWindowCloseStream, ue = te && (Et() || It());
        return ue && K.oncePlayer(et, function() {
          re.timer.raf.on("tick", function(fe) {
            var pe = fe.isStop;
            pe || K._onTimerTick();
          });
        }), K;
      }
      return ee(ie, [{
        key: "_onTimerTick",
        value: function() {
          var K = this, te = this._detect360loneWindow(), ue = this.player;
          this._is360loneWindow !== te && (this._is360loneWindow = te, this._is360loneWindow ? (clearTimeout(this._timer), this._timer = setTimeout(function() {
            K._showRecordRestrict360(), ue.stop(), K._removeProviderElement();
          }, 20)) : this._hideRecordREstrict360()), this._is360loneWindow && (ue.dom.controllerWrap.style.display = "none");
        }
      }, {
        key: "_showRecordRestrict360",
        value: function() {
          var K = this.player.dom.recordRestrict360, te = "position:absolute;top:0;left:0;right:0;bottom:0;background-color:#000;z-index:9999;", ue = It() ? "" : "top:50%;margin-top:-0.75em;";
          K.setAttribute("style", te), K.innerHTML = '<div class="'.concat(Pe, '" style="position:absolute;').concat(ue, 'width:100%;text-align:center;color:#fff;font-size:1.25em;line-height:1.5em;">\u89C6\u9891\u7981\u6B62\u5728\u5C0F\u7A97\u53E3\u64AD\u653E\uFF0C\u8BF7\u9000\u51FA\u5C0F\u7A97\u540E\u5237\u65B0\u9875\u9762\u7EE7\u7EED\u89C2\u770B</div>');
        }
      }, {
        key: "_hideRecordREstrict360",
        value: function() {
          var K = this.player.dom.recordRestrict360;
          K.setAttribute("style", "");
        }
      }, {
        key: "_detect360loneWindow",
        value: function() {
          var K = this.player._provider, te = this.player.dom, ue = te.container;
          if (K) {
            if (K.html5) {
              var fe = ue.querySelector("div"), pe = fe.getAttribute("style") || "", me = pe.indexOf("visibility:hidden") >= 0 && pe.indexOf("opacity:0") >= 0;
              return me;
            } else if (K.flash) {
              var ye = document.querySelector("object"), _e = ye.style.width;
              return !!_e;
            }
          }
          return this._is360loneWindow;
        }
      }, {
        key: "_removeProviderElement",
        value: function() {
          var K = this.player.dom.videoWrap, te = K.querySelector("video"), ue = K.querySelector("object");
          te && K.removeChild(te), ue && K.removeChild(ue);
        }
      }, {
        key: "remove",
        value: function() {
          clearTimeout(this._timer), ge(le(ie.prototype), "remove", this).call(this);
        }
      }]), ie;
    }(Ye), _0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K._enableDetect = !1, K._isLive = !1, K._streamType = "", Je(K.player, ce(ce(K))).method("setLiveEndDetect").method("getLiveEndDetect"), K.onPlayer(et, K._onProviderInit.bind(ce(ce(K)))), K.onPlayer(Bi, K._onIdle.bind(ce(ce(K)))), K.onPlayer(Dt, K._onError.bind(ce(ce(K)))), K.onPlayer(Fl, K._onBuffer.bind(ce(ce(K)))), $t() && K.onPlayer(Hi, K._onTime.bind(ce(ce(K)))), K;
      }
      return ee(ie, [{
        key: "setLiveEndDetect",
        value: function(K) {
          this._enableDetect = !!K;
        }
      }, {
        key: "getLiveEndDetect",
        value: function() {
          return this._enableDetect;
        }
      }, {
        key: "_onProviderInit",
        value: function(K) {
          var te = K.isLive, ue = K.type;
          this._isLive = te, this._streamType = ue;
        }
      }, {
        key: "_shouldDetect",
        value: function(K) {
          return K ? this._enableDetect && this._isLive && this._streamType === K : this._enableDetect && this._isLive;
        }
      }, {
        key: "_triggerEvt",
        value: function() {
          this.player.trigger(oo, {
            type: oo,
            liveEnd: !0
          });
        }
      }, {
        key: "_onIdle",
        value: function() {
          (this._shouldDetect("flv") || this._shouldDetect("hls") || this._shouldDetect("m3u8")) && this._triggerEvt();
        }
      }, {
        key: "_onError",
        value: function(K) {
          var te = K.fatal;
          (this._shouldDetect("m3u8") || this._shouldDetect("hls")) && te && this._triggerEvt();
        }
      }, {
        key: "_onBuffer",
        value: function() {
          (this._shouldDetect("rtmp") || this._shouldDetect("hls") || this._shouldDetect("m3u8")) && this._triggerEvt();
        }
      }, {
        key: "_onTime",
        value: function(K) {
          K.position, this._shouldDetect("") && this._triggerEvt();
        }
      }]), ie;
    }(Ye), b0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.onPlayer(et, K._onProviderInited.bind(ce(ce(K)))), K.onPlayer(Pt, K._onProviderRemoved.bind(ce(ce(K)))), K.msgList = null, K.lastMsgIdx = -2, K;
      }
      return ee(ie, [{
        key: "_onTick",
        value: function() {
          if (!!this.msgList) {
            for (var K = this.player.model.progress.getPosition(), te, ue = 0; ue < this.msgList.length; ue++) {
              var fe = this.msgList[ue];
              if (K < fe.time) {
                te = ue - 1;
                break;
              }
            }
            te === void 0 && (te = this.msgList.length - 1), te !== this.lastMsgIdx && (this.lastMsgIdx = te, this.player.trigger("playbackMessage", {
              type: "playbackMessage",
              prev: this.msgList[te] || null,
              next: this.msgList[te + 1] || null
            }));
          }
        }
      }, {
        key: "_onProviderInited",
        value: function() {
          var K = Ft.call(this.player);
          this.msgList = Ce("array", K.playbackMessages) ? K.playbackMessages : null, this.msgList && this.msgList.sort(function(te, ue) {
            return te.time - ue.time;
          });
        }
      }, {
        key: "_onProviderRemoved",
        value: function() {
          this.msgList = null, this.lastMsgIdx = -2;
        }
      }]), ie;
    }(Ye), T0 = /* @__PURE__ */ function(ae) {
      se(ie, ae), ee(ie, [{
        key: "playbackRatesLabel",
        get: function() {
          return this.player._config.playbackRatesLabel || this.lang.Speed;
        }
      }]);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.isMobile = rt(), K.tempRateList = [], K.dom = null, K.createDom(), K._playbackRate = 1, K._init = null, K.setPlaybackRates(re._config.playbackRates), K.onPlayer(et, function() {
          K._init !== null && (K._init = !0), K.initPlaybackRates();
        }), K.onPlayer(Pt, function() {
          K.resetState();
        }), K.onPlayer(zr, function(te) {
          K.updateSwitchText();
        }), K.onPlayer(Bt, function() {
          K._init && K.player.setPlaybackRate(K._playbackRate), K._init = !1;
        }), K.onPlayer(xi, function() {
          K.tempRateList.length && (K.setPlaybackRates(K.tempRateList), K.tempRateList = []);
        }), K.qsPopup = _t(re.dom.playbackRate, {
          trigger: "click",
          content: K.dom,
          container: re.dom.container,
          class: K.isMobile ? "mudu-popup ".concat(Gr) : "mudu-popup",
          getMaxHeight: function(ue) {
            var fe = ue.height;
            return K.isMobile ? fe : fe - 70;
          }
        }), K.qsPopup.show(), K.dom.addEventListener("click", K.qsPopup.hide), Je(K.player, ce(ce(K))).method("setPlaybackRates").method("switchPlaybackRate"), K;
      }
      return ee(ie, [{
        key: "clearPlaybackRates",
        value: function() {
          this.rateList = [], this._playbackRate = 1, mi.call(this.player, "null"), this.player.setPlaybackRate(this._playbackRate), this.resetState(), this.updateRateItem(), this.updateControlRate(), this.updateSwitchText();
        }
      }, {
        key: "setPlaybackRates",
        value: function(K) {
          var te = Ce("array", K);
          if (!K) {
            this.clearPlaybackRates();
            return;
          }
          te || (K = []), this.rateList = K;
          var ue = this.player.getState() === "idle";
          ue ? this.tempRateList = K : (this._init || (this._playbackRate = 1, mi.call(this.player, "null"), this.player.setPlaybackRate(this._playbackRate)), this.initPlaybackRates());
        }
      }, {
        key: "switchPlaybackRate",
        value: function(K) {
          var te = this.player.getState();
          if (!(te === "idle" || te === "error" || this.rateList.length <= 0)) {
            var ue = this.rateList.findIndex(function(pe) {
              return K === pe.playbackRate;
            });
            if (ue !== -1) {
              var fe = this.dom.querySelectorAll('[type="value"]');
              this.handlePlaybackRate(ue, fe);
            }
          }
        }
      }, {
        key: "handlePlaybackRate",
        value: function(K, te) {
          this._playbackRate = this.rateList[K].playbackRate * 1, this.player.setPlaybackRate(this._playbackRate), mi.call(this.player, K), this.player.dom.playbackRate.innerHTML = this.rateList[K].label, this.rateList.map(function(ue, fe) {
            Ae(te[fe]).remove(pt), Ae(te[fe]).add(fe === K ? pt : "");
          }), this.qsPopup.hide();
        }
      }, {
        key: "createDom",
        value: function() {
          var K = '<div class="'.concat(this.isMobile ? Js : "", `">
      <div class="`).concat(Pe, " ").concat(Ai, " ").concat(Fa, `">
        <div class="`).concat(Pe, " ").concat(Ma, `"></div>
      </div>
    </div>`);
          this.dom = xt(K);
        }
      }, {
        key: "initPlaybackRates",
        value: function() {
          this.resetState(), this.updateRateItem(), this.updateControlRate(), this.updateSwitchText();
        }
      }, {
        key: "resetState",
        value: function() {
          this.qsPopup.hide();
        }
      }, {
        key: "updateControlRate",
        value: function() {
          var K = this.rateList.length, te = Ft.call(this.player).isLive, ue = this.player.dom.container, fe = te || K < 1 || !this.player._provider || !this.player._provider.isPlaybackRateSupported;
          Ae(ue).remove(yl), Ae(ue).add(fe ? pl : ml);
        }
      }, {
        key: "updateSwitchText",
        value: function() {
          var K = this.rateList.filter(function(te) {
            return te.active;
          })[0];
          K ? this.player.dom.playbackRate.innerHTML = K.label : this.player.dom.playbackRate.innerHTML = this.playbackRatesLabel;
        }
      }, {
        key: "updateRateItem",
        value: function() {
          var K = this, te = this.rateList.map(function(ye, _e) {
            return '<div class="'.concat(Pe, " ").concat(wi, '" type="value" value="').concat(_e, '" data-content-before=').concat(K.playbackRatesLabel, `>
          <div class="`).concat(Pe, " ").concat(Qs, '">').concat(ye.label, `</div>
          </div>`);
          }).join("");
          this.dom.querySelector(".".concat(Fa)).innerHTML = te;
          for (var ue = this.dom.querySelectorAll('[type="value"]'), fe = this, pe = function(_e) {
            var Ee = ue[_e], ke = fe.rateList[_e].playbackRate;
            Ee.onclick = function() {
              fe.handlePlaybackRate(_e, ue);
            }, Ae(Ee).add(ke === fe._playbackRate ? pt : "");
          }, me = 0; me < ue.length; me++)
            pe(me);
        }
      }]), ie;
    }(Ye);
    function S0(ae, ie) {
      var re = ae.width / ae.height, K = ie.width / ie.height, te, ue;
      return re > K ? (te = ae.width, ue = ae.width / K) : (te = ae.height * K, ue = ae.height), {
        width: te,
        height: ue
      };
    }
    function Lo(ae, ie) {
      var re = ae.width / ae.height, K = ie.width / ie.height, te, ue;
      return re < K ? (te = ae.width, ue = ae.width / K) : (te = ae.height * K, ue = ae.height), {
        width: te,
        height: ue
      };
    }
    function q0(ae) {
      return ae;
    }
    function K0(ae) {
      return ae;
    }
    function E0(ae, ie) {
      return ie.width > ae.width || ie.height > ae.height ? Lo(ae, ie) : ae;
    }
    function I0() {
      return {
        designWidth: 750,
        type: "text",
        data: "",
        placement: "repeat",
        opacity: 0.5,
        fontSize: 16,
        fontFamily: "PingFang SC",
        color: "#FFFFFF",
        rotate: -25,
        marginTop: 8,
        marginRight: 8,
        marginBottom: 8,
        marginLeft: 8,
        cellSize: {
          width: 250,
          height: 140.625
        },
        imageSize: null,
        autoRandom: 5 * 1e3
      };
    }
    function A0(ae, ie) {
      var re = null, K = function te() {
        var ue = ae.getMetrics() || {};
        ue.videoWidth > 1 && ue.videoWidth > 1 ? ie(ue) : re = setTimeout(te, 100);
      };
      return K(), function() {
        return re && clearTimeout(re);
      };
    }
    var w0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), K.config = K.player._config, K.watermarkContainer = K.player.dom.watermark, K.watermarkTimers = [], K.videoWidth = 0, K.videoHeight = 0, K.watermarkContainerW = 0, K.watermarkContainerH = 0, Je(K.player, ce(ce(K))).method("setWatermark").method("clearWatermark").method("setWatermarkRenderingMode"), K._subEvents(), K;
      }
      return ee(ie, [{
        key: "setWatermark",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.config.watermark;
          if (this.config.watermark = K, this.videoWidth > 1 && this.videoHeight > 1) {
            if (Ce("function", K))
              return this._customRender(K);
            Ce("object", K) && (K = [K]), Ce("array", K) && (this.clearWatermark(), this._render(K));
          }
        }
      }, {
        key: "setWatermarkRenderingMode",
        value: function(K) {
          if (K !== "container" && K !== "content")
            throw new Error("Invalid watermark rendering mode: " + K);
          this.config.watermarkRenderingMode = K, this.videoWidth > 1 && this.videoHeight > 1 && (K === "content" ? (this.watermarkContainerW = this.videoWidth, this.watermarkContainerH = this.videoHeight) : (this.watermarkContainerW = this.videoWidth, this.watermarkContainerH = this.videoWidth / this._getPlayerAspectRatio()), wt(this.watermarkContainer, {
            width: this.watermarkContainerW + "px",
            height: this.watermarkContainerH + "px"
          }), this._handleResize());
        }
      }, {
        key: "clearWatermark",
        value: function() {
          for (this.watermarkContainer.innerHTML = ""; this.watermarkTimers.length; )
            clearInterval(this.watermarkTimers.pop());
        }
      }, {
        key: "remove",
        value: function() {
          this.clearWatermark(), this.removeResizeEventListener && this.removeResizeEventListener();
        }
      }, {
        key: "_subEvents",
        value: function() {
          var K = this;
          this.removeResizeEventListener = Or(this.player.dom.container, function() {
            K._handleResize();
          }), this.onPlayer(Pt, function() {
            K.clearWatermark(), K.videoWidth = K.videoWidth = K.watermarkContainerW = K.watermarkContainerH = 0;
          }), this.onPlayer(et, function() {
            K.player.off(_r, K.outerPlayEventListener), K.outerPlayEventListener = K.player.once(_r, function() {
              K.cancelEnsureMetrics && K.cancelEnsureMetrics(), K.cancelEnsureMetrics = A0(K.player, function(te) {
                var ue = te.videoWidth, fe = te.videoHeight;
                K.videoWidth = ue, K.videoHeight = fe;
                var pe = K._isRendingModeContent();
                pe ? (K.watermarkContainerW = ue, K.watermarkContainerH = fe) : (K.watermarkContainerW = ue, K.watermarkContainerH = ue / K._getPlayerAspectRatio()), wt(K.watermarkContainer, {
                  width: K.watermarkContainerW + "px",
                  height: K.watermarkContainerH + "px"
                }), K._handleResize(), K.setWatermark();
              });
            });
          });
        }
      }, {
        key: "_handleResize",
        value: function() {
          if (!!this.player.dom) {
            var K = this.player.dom.container, te = this.watermarkContainer, ue = this._isRendingModeContent();
            ue || (this.watermarkContainerH = this.videoWidth / this._getPlayerAspectRatio(), wt(te, {
              height: this.watermarkContainerH + "px"
            }));
            var fe = {
              width: K.offsetWidth,
              height: K.offsetHeight
            }, pe = {
              width: te.offsetWidth,
              height: te.offsetHeight
            }, me;
            switch (this.config.stretching) {
              case "contain":
                me = Lo(fe, pe);
                break;
              case "cover":
                me = S0(fe, pe);
                break;
              case "fill":
                me = fe;
                break;
              case "none":
                me = pe;
                break;
              case "scale-down":
                me = E0(fe, pe);
                break;
            }
            var ye = me.width / pe.width, _e = me.height / pe.height;
            wt(te, {
              transform: "scale(".concat(ye, ", ").concat(_e === ye ? ye : _e, ") translate(-50%, -50%)")
            }), ue || this.setWatermark();
          }
        }
      }, {
        key: "_render",
        value: function(K) {
          for (var te = 0; te < K.length; te++) {
            var ue = this._resolveOptions(K[te]);
            switch (ue.placement) {
              case "top-left":
                this._genTopLeft(ue);
                break;
              case "top-right":
                this._genTopRight(ue);
                break;
              case "bottom-left":
                this._genBottomLeft(ue);
                break;
              case "bottom-right":
                this._genBottomRight(ue);
                break;
              case "repeat":
                this._genRepeat(ue);
                break;
              case "random":
                this._genRandom(ue);
                break;
            }
          }
        }
      }, {
        key: "_customRender",
        value: function(K) {
          var te = this, ue = K();
          ue && ue.then && ue.then(function(fe) {
            fe && fe instanceof HTMLElement && (te.clearWatermark(), te.watermarkContainer.appendChild(fe));
          });
        }
      }, {
        key: "_resolveOptions",
        value: function(K) {
          K = JSON.parse(JSON.stringify(K));
          var te = oe({}, I0(), K), ue = this.watermarkContainerW / te.designWidth;
          return te.fontSize *= ue, te.marginTop *= ue, te.marginRight *= ue, te.marginBottom *= ue, te.marginLeft *= ue, te.cellSize.width *= ue, te.cellSize.height *= ue, te.imageSize ? (Ce("number", te.imageSize.width) && (te.imageSize.width *= ue), Ce("number", te.imageSize.height) && (te.imageSize.height *= ue)) : te.imageSize = {
            width: "auto",
            height: "auto"
          }, te;
        }
      }, {
        key: "_genRandom",
        value: function(K) {
          var te = this, ue = this._resolveElement(K);
          this.watermarkContainer.appendChild(ue);
          var fe = function() {
            wt(ue, {
              top: Sn(ci(0, te.watermarkContainerH), 0, te.watermarkContainerH - ue.offsetHeight) + "px",
              left: Sn(ci(0, te.watermarkContainerW), 0, te.watermarkContainerW - ue.offsetWidth) + "px"
            });
          }, pe = function() {
            if (K.autoRandom > 0) {
              var ye = setInterval(function() {
                fe();
              }, K.autoRandom);
              te.watermarkTimers.push(ye);
            }
            fe();
          };
          K.type === "image" ? ue.onload = function() {
            pe();
          } : pe();
        }
      }, {
        key: "_genTopLeft",
        value: function(K) {
          var te = this._resolveElement(K);
          wt(te, {
            top: K.marginTop + "px",
            left: K.marginLeft + "px"
          }), this.watermarkContainer.appendChild(te);
        }
      }, {
        key: "_genTopRight",
        value: function(K) {
          var te = this._resolveElement(K);
          wt(te, {
            top: K.marginTop + "px",
            right: K.marginRight + "px"
          }), this.watermarkContainer.appendChild(te);
        }
      }, {
        key: "_genBottomLeft",
        value: function(K) {
          var te = this._resolveElement(K);
          wt(te, {
            bottom: K.marginBottom + "px",
            left: K.marginLeft + "px"
          }), this.watermarkContainer.appendChild(te);
        }
      }, {
        key: "_genBottomRight",
        value: function(K) {
          var te = this._resolveElement(K);
          wt(te, {
            bottom: K.marginBottom + "px",
            right: K.marginRight + "px"
          }), this.watermarkContainer.appendChild(te);
        }
      }, {
        key: "_genRepeat",
        value: function(K) {
          for (var te = K.cellSize.width, ue = K.cellSize.height, fe = 0; fe < this.watermarkContainerW / te; fe++)
            for (var pe = 0; pe < this.watermarkContainerH / ue; pe++) {
              var me = document.createElement("div");
              Ae(me).add("mudu-watermark-cell-wrap");
              var ye = this._resolveElement(K);
              wt(me, {
                top: pe * ue + "px",
                left: fe * te + "px",
                width: te + "px",
                height: ue + "px",
                transform: "rotate(".concat(K.rotate, "deg)")
              }), me.appendChild(ye), this.watermarkContainer.appendChild(me);
            }
        }
      }, {
        key: "_resolveElement",
        value: function(K) {
          if (K.type === "text")
            return this._resolveTextElement(K);
          if (K.type === "image")
            return this._resolveImageElement(K);
        }
      }, {
        key: "_resolveTextElement",
        value: function(K) {
          var te = document.createElement("span");
          return te.innerHTML = K.data, wt(te, {
            fontFamily: K.fontFamily,
            fontSize: K.fontSize + "px",
            color: K.color,
            opacity: K.opacity
          }), Ae(te).add("mudu-watermark-text"), te;
        }
      }, {
        key: "_resolveImageElement",
        value: function(K) {
          var te = document.createElement("img");
          return te.src = K.data, wt(te, {
            opacity: K.opacity,
            width: K.imageSize.width + "px",
            height: K.imageSize.height + "px"
          }), Ae(te).add("mudu-watermark-image"), te;
        }
      }, {
        key: "_isRendingModeContent",
        value: function() {
          var K = this.config.watermarkRenderingMode || "content";
          return K === "content";
        }
      }, {
        key: "_getPlayerAspectRatio",
        value: function() {
          var K = this.player.dom.container;
          return K.offsetWidth / K.offsetHeight;
        }
      }]), ie;
    }(Ye), P0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this, re)), Je(K.player, ce(ce(K))).method("changeLanguage"), K;
      }
      return ee(ie, [{
        key: "changeLanguage",
        value: function(K) {
          var te = this.player, ue = te._config.localization, fe = fi(K, ue);
          te._status.lang = fe, te._status.localization = ue[fe];
          for (var pe = document.querySelectorAll("[data-lang-key]"), me = 0; me < pe.length; me++) {
            var ye = pe[me], _e = ye.getAttribute("data-lang-key");
            ye.innerText = this.lang[_e];
          }
          for (var Ee = document.querySelectorAll("[data-locale]"), ke = 0; ke < Ee.length; ke++) {
            var Re = Ee[ke], xe = Ou(Re.attributes), Ge = bt.call(this.player, xe);
            Ge && (Re.innerText = Ge);
          }
          te.trigger(zr, fe);
        }
      }]), ie;
    }(Ye);
    function L0() {
      this.model.fullscreen = new lu(this), this.model.video = new bu(this), this.model.progress = new Tu(this), this.model.controls = new Su(this), this.model.volume = new Eu(this), this.model.playlist = new Iu(this), this.model.hotkeys = new Au(this), this.model.resize = new wu(this), this.model.stretch = new Pu(this), this.model.logo = new Lu(this), this.model.focus = new Cu(this), this.model.bezel = new Mu(this), this.model.background = new Fu(this), this.model.dom = new ku(this), this.model.title = new Ru(this), this.model.contextMenu = new $u(this), this.model.error = new xu(this), this.model.progressPopup = new Nu(this), this.model.notice = new Du(this), this.model.qualitySwitch = new Uu(this), this.model.perf = new p0(this), this.model.textTrack = new m0(this), this.model.subtitle = new g0(this), this.model.myunSync = new v0(this), this.model.recordRestrict = new y0(this), this.model.liveEndDetect = new _0(this), this.model.playbackMessage = new b0(this), this.model.playbackRate = new T0(this), this.model.watermark = new w0(this), this.model.language = new P0(this), this.trigger(Il);
    }
    function C0() {
      for (var ae in this.model)
        this.model[ae].remove();
    }
    function M0() {
      var ae = this;
      this.timer = {};
      var ie = this._config.bufferDetectGap;
      (!Ce("number", ie) || isNaN(ie) || ie <= 0) && (ie = 200), this.timer.loading = new Wt({
        type: "loading",
        gap: ie
      }), this.timer.raf = new Wt({
        type: "raf",
        isRaf: !0
      });
      var re = 0, K = 0, te = !1;
      this.timer.loading.on("tick", function(fe) {
        var pe = fe.isStop;
        if (!pe) {
          K = ae.model.progress.getPosition();
          var me = ae.model.video.getState(), ye = me === "playing" || me === "buffering";
          if (!te && K === re && ye) {
            var _e = ae.getDuration();
            !$t() && hi(_e) && _e > 0 && (te = !0, ae.trigger("internal_buffer", !0));
          }
          te && K > re && ye && (te = !1, ae.trigger("internal_buffer", !1)), re = K;
        }
      });
      var ue = -1;
      this.timer.raf.on("tick", function(fe) {
        var pe = fe.isStop;
        if (!pe) {
          var me = ae.model.resize.getWidth(), ye = Ae(ae.dom.container).contains(Oi);
          me < 350 ? !ye && Ae(ae.dom.container).add(Oi) : ye && Ae(ae.dom.container).remove(Oi), ue !== me && (ae.model.subtitle._setSubtitleSize(me), ae.model.subtitle._updateSubtitleStyle()), ue = me;
          var _e = +ys(ae.dom.container).fontSize.replace(/[^\d]+/, "");
          ae._status.containerFontSize = _e < 16 ? 16 : _e, ae.model.playbackMessage._onTick();
        }
      }), this.timer.raf.start();
    }
    function F0() {
      this.timer.loading.stop(), this.timer.raf.stop();
    }
    var ti = {};
    function k0(ae, ie) {
      if (ti[ae]) {
        console.warn("provider [".concat(ae, "] is existed, so it will not be register twice, you can change a name and retry"));
        return;
      }
      ti[ae] = {
        name: ae,
        Plugin: ie
      }, Ur({
        plugin: ne({}, ae, ie.defaultOptions)
      });
    }
    function Co() {
      return ti;
    }
    function O0(ae) {
      return ti[ae] || null;
    }
    function R0() {
      var ae = Co();
      for (var ie in ae) {
        var re = ae[ie];
        re.Plugin.isSupported() && (this.plugin[ie] = new re.Plugin(this, this._config.plugin[ie]));
      }
      this.trigger(Al);
    }
    function $0() {
      if (this.plugin)
        for (var ae in this.plugin)
          this.plugin[ae] && this.plugin[ae].remove();
    }
    var N0 = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re) {
        var K;
        return $(this, ie), K = he(this, le(ie).call(this)), K._container = document.getElementById(re), K.formatState(), K;
      }
      return ee(ie, [{
        key: "formatState",
        value: function() {
          this._config = {}, this._config.containerId = this._container.id, this._status = {
            uniqId: bs(),
            state: "idle",
            focus: !1,
            isSetuped: !1,
            flashReady: !1,
            dragging: !1,
            index: "",
            containerFontSize: 16
          }, this._provider = null, this._extraProviders = {}, this.plugin = {}, this.dom = {}, this.timer = {}, this.model = {};
        }
      }, {
        key: "getUniqId",
        value: function() {
          return this._status.uniqId;
        }
      }, {
        key: "setup",
        value: function(K) {
          var te = this, ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
          At() && console.log("[setup]", K), this._status && this._status.isSetuped && !this._container.querySelector(yi) && (this.remove(), !ue && console.warn("muduPlayer().setup(): please don`t setup twice")), this.formatState();
          var fe = $n(K), pe = Rn(Nn(), fe);
          if (this._config = oe({}, this._config, pe), this._config.uniqId && (this._status.uniqId = this._config.uniqId), R0.call(this), !ue && this.trigger(Sl), !Ce("array", this._config.playlist) && !ue)
            throw new Error("setup(options): you should give me a video url to play, through `options.file` or `options.playlist` array");
          this._status.lang = fi(this._config.language, this._config.localization), this._status.localization = this._config.localization[this._status.lang], this._status.isSetuped = !0, !ue && this.trigger(Pl), !ue && this.trigger("setup"), Ql.call(this), L0.call(this), M0.call(this), Rr.call(this);
          var me = this._config.autoplay;
          return lr.call(this).then(function() {
            if (Sr.call(te), me)
              try {
                te.play();
              } catch (ye) {
                console.warn(ye);
              }
            return Promise.resolve();
          });
        }
      }, {
        key: "remove",
        value: function() {
          At() && console.log("[remove]"), !(!this._status || !this._status.isSetuped) && (F0.call(this), C0.call(this), $0.call(this), Tr.call(this), Jl.call(this), this._config = null, this._status = null, this._provider = null, this.dom = null, this.timer = null, this.model = null, this.trigger("remove"));
        }
      }, {
        key: "stop",
        value: function() {
          At() && console.log("[stop]"), Tr.call(this);
        }
      }]), ie;
    }(Kt), kt = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, K)), te.video_error_report = !1, te.TAG = "DashjsProvider", te;
      }
      return ee(ie, [{
        key: "loadFiles",
        value: function() {
          var K = new mt(this.player._config.fileCdnPath + "/dash.js");
          return K.load();
        }
      }, {
        key: "setup",
        value: function(K) {
          var te = this, ue = K.file;
          ge(le(ie.prototype), "setup", this).call(this, {
            file: ue
          }), this.file = ue, this.player._config.preload === "auto" ? this.loadDash() : this.oncePlayer("beforePlay", function() {
            return te.loadDash();
          });
        }
      }, {
        key: "loadDash",
        value: function() {
          this.dashPlayer = window.dashjs.MediaPlayer().create(), this.dashPlayer.initialize(this.video, this.file, !1);
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.dashPlayer && this.dashPlayer.reset();
        }
      }]), ie;
    }(dt);
    kt.formats = {
      "application/dash+xml": "dash"
    }, kt.types = ["mpd", "dash"], kt.canPlay = function(ae) {
      var ie = ae.type;
      return kt.types.indexOf(ie) >= 0 ? "maybe" : "";
    }, kt.isSupported = function() {
      var ae = window.MediaSource || window.WebKitMediaSource, ie = window.SourceBuffer || window.WebKitSourceBuffer, re = ae && typeof ae.isTypeSupported == "function" && ae.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), K = !ie || ie.prototype && typeof ie.prototype.appendBuffer == "function" && typeof ie.prototype.remove == "function";
      return !!re && !!K;
    }, kt.isFlash = function(ae) {
      return !1;
    }, kt.isHTML5 = function(ae) {
      return !0;
    }, kt.HlsP2pisPlaybackRateSupported = function() {
      return !0;
    }, kt.isPlaybackRateSupported = function() {
      return !0;
    }, kt.version = "2.9.0";
    var Ct = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), K = K || {}, te = he(this, le(ie).call(this, re, K)), te.video_error_report = !1, te.TAG = "FlvjsProvider", te;
      }
      return ee(ie, [{
        key: "loadFiles",
        value: function() {
          var K = new mt(this.player._config.fileCdnPath + "/flv.js");
          return K.load();
        }
      }, {
        key: "setup",
        value: function(K) {
          var te = this, ue = K.file, fe = K.isLive;
          ge(le(ie.prototype), "setup", this).call(this, {
            file: ue
          }), this.onFlvError = function(me, ye, _e) {
            var Ee = "".concat(me, "_").concat(ye);
            me === window.flvjs.ErrorTypes.NETWORK_ERROR && (_e.code && (Ee += "_".concat(_e.code)), _e.msg && (Ee += "_".concat(_e.msg))), te.trigger(Ot, {
              message: Ee,
              details: ye,
              fatal: !0,
              data: {
                type: me,
                details: ye,
                other: _e
              }
            });
          };
          var pe = this.option["flv.js"] || {};
          this.flvPlayer = window.flvjs.createPlayer({
            type: "flv",
            url: ue,
            isLive: !!fe
          }, pe), this.flvPlayer.attachMediaElement(this.video), this.flvPlayer.on(window.flvjs.Events.ERROR, this.onFlvError), this.player._config.preload === "auto" ? this.flvPlayer.load() : this.oncePlayer("beforePlay", function() {
            return te.flvPlayer.load();
          });
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.flvPlayer && (this.flvPlayer.off(window.flvjs.Events.ERROR, this.onFlvError), this.flvPlayer.detachMediaElement(), this.flvPlayer.destroy());
        }
      }]), ie;
    }(dt);
    Ct.formats = {
      "video/flv": "FLV",
      "video/x-flv": "FLV"
    }, Ct.canPlay = function(ae) {
      var ie = ae.type, re = ae.isLive;
      return ie === "flv" && (!re || re && Ct.isLiveSupported()) ? "maybe" : "";
    }, Ct.canPlaySource = function() {
    }, Ct.isSupported = function() {
      return window.MediaSource && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
    }, Ct.isLiveSupported = function() {
      var ae = dr(), ie = ae.browser;
      try {
        var re = ie.msedge && (ie.version.major > 15 || ie.version.major === 15 && ie.version.minor >= 15048), K = ie.msedge ? re : !0;
        return window.fetch && window.ReadableStream && K;
      } catch (te) {
        return !1;
      }
    }, Ct.isFlash = function(ae) {
      return !1;
    }, Ct.isHTML5 = function(ae) {
      return !0;
    }, Ct.HlsP2pisPlaybackRateSupported = function() {
      return !0;
    }, Ct.isPlaybackRateSupported = function() {
      return !0;
    }, Ct.version = "1.4.2";
    function x0() {
      var ae = /* @__PURE__ */ function(ie) {
        se(re, ie);
        function re() {
          return $(this, re), he(this, le(re).apply(this, arguments));
        }
        return ee(re, [{
          key: "loadInternal",
          value: function() {
            var te, ue = this.context;
            te = this.loader = new window.XMLHttpRequest();
            var fe = this.stats;
            fe.tfirst = 0, fe.loaded = 0;
            var pe = this.xhrSetup, me = window.location.protocol === "https:" ? ue.url.replace(/^http:/, "https:") : ue.url;
            try {
              if (pe)
                try {
                  pe(te, me);
                } catch (ye) {
                  te.open("GET", me, !0), pe(te, me);
                }
              te.readyState || te.open("GET", me, !0);
            } catch (ye) {
              this.callbacks.onError({
                code: te.status,
                text: ye.message
              }, ue, te);
              return;
            }
            ue.rangeEnd && te.setRequestHeader("Range", "bytes=" + ue.rangeStart + "-" + (ue.rangeEnd - 1)), te.onreadystatechange = this.readystatechange.bind(this), te.onprogress = this.loadprogress.bind(this), te.responseType = ue.responseType, this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout), te.send();
          }
        }]), re;
      }(window.Hls.DefaultConfig.loader);
      return {
        XHRLoader: ae
      };
    }
    var Tt = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), K = K || {}, te = he(this, le(ie).call(this, re, K)), te.onHlsError = te.onHlsError.bind(ce(ce(te))), te.option = K, te.video_error_report = !1, te.onPlayer("buffer", te._onPlayerBuffer.bind(ce(ce(te)))), te.TAG = "HlsjsProvider", te;
      }
      return ee(ie, [{
        key: "loadFiles",
        value: function() {
          var K = new mt(this.player._config.fileCdnPath + "/hls.js");
          return K.load();
        }
      }, {
        key: "setup",
        value: function(K) {
          var te = this, ue = K.file;
          ge(le(ie.prototype), "setup", this).call(this, K), this.file = ue, this.player._config.preload === "auto" ? this.loadHls() : this.oncePlayer(Bt, function() {
            return te.loadHls();
          });
        }
      }, {
        key: "play",
        value: function() {
          var K = this.player.getState(), te = this.getPosition();
          return K === "idle" && te > 0 && this.seek(0), ge(le(ie.prototype), "play", this).call(this);
        }
      }, {
        key: "loadHls",
        value: function() {
          var K = x0(), te = K.XHRLoader, ue = {
            fLoader: te
          }, fe = oe({}, this.option["hls.js"] || {}, ue), pe = this.hlsPlayer = new window.Hls(fe);
          pe.subtitleDisplay = !1, pe.loadSource(this.file), pe.attachMedia(this.video), pe.on(window.Hls.Events.ERROR, this.onHlsError);
        }
      }, {
        key: "onHlsError",
        value: function(K, te) {
          var ue, fe = te.type, pe = te.details, me = te.fatal, ye = "".concat(fe, "_").concat(pe), _e = [window.Hls.ErrorDetails.BUFFER_STALLED_ERROR, window.Hls.ErrorDetails.BUFFER_NUDGE_ON_STALL];
          if (_e.indexOf(pe) === -1) {
            if (fe === window.Hls.ErrorTypes.NETWORK_ERROR) {
              var Ee = te.networkDetails;
              Ee && (Ee.status && (ye += "_".concat(Ee.status)), Ee.statusText && (ye += "_".concat(Ee.statusText)));
            }
            this.trigger(Ot, {
              code: (ue = {}, ne(ue, window.Hls.ErrorTypes.NETWORK_ERROR, ot.NETWORK_ERROR), ne(ue, window.Hls.ErrorTypes.MEDIA_ERROR, ot.MEDIA_ERROR), ne(ue, window.Hls.ErrorTypes.MUX_ERROR, ot.MEDIA_ERROR), ne(ue, window.Hls.ErrorTypes.KEY_SYSTEM_ERROR, ot.MEDIA_ERROR), ne(ue, window.Hls.ErrorTypes.OTHER_ERROR, ot.OTHER_ERROR), ue)[fe],
              message: ye,
              fatal: me,
              data: te
            });
          }
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.hlsPlayer && (this.hlsPlayer.off(window.Hls.Events.ERROR, this.onHlsError), this.hlsPlayer.detachMedia(), this.hlsPlayer.destroy());
        }
      }, {
        key: "_onPlayerBuffer",
        value: function(K) {
          var te = K.oldState;
          if (te === "playing") {
            var ue = this.getPosition(), fe = this.getDuration();
            fe - ue < 1 && ue > 0 && fe > 2 && (this.pause(), this.trigger("ended"));
          }
        }
      }]), ie;
    }(dt);
    Tt.formats = {
      "application/vnd.apple.mpegurl": "hls"
    }, Tt.type = ["m3u8", "hls"], Tt.canPlay = function(ae) {
      var ie = ae.type, re = ae.isTimeShift;
      return re && $t() ? !1 : Tt.type.indexOf(ie) >= 0;
    }, Tt.isHlsSupported = function() {
      var ae = window.MediaSource || window.WebKitMediaSource, ie = window.SourceBuffer || window.WebKitSourceBuffer, re = ae && typeof ae.isTypeSupported == "function" && ae.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), K = !ie || ie.prototype && typeof ie.prototype.appendBuffer == "function" && typeof ie.prototype.remove == "function";
      return !!re && !!K;
    }, Tt.isSupported = function() {
      return Tt.isHlsSupported();
    }, Tt.isFlash = function(ae) {
      return !1;
    }, Tt.isHTML5 = function(ae) {
      return !0;
    }, Tt.HlsP2pisPlaybackRateSupported = function() {
      return !0;
    }, Tt.isPlaybackRateSupported = function() {
      return !0;
    }, Tt.version = "1.4.12";
    var St = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), K = K || {}, te = he(this, le(ie).call(this, re, K)), te.onHlsError = te.onHlsError.bind(ce(ce(te))), te.option = K, te.video_error_report = !1, te.onPlayer("buffer", te._onPlayerBuffer.bind(ce(ce(te)))), te.TAG = "HlsPeer5Provider", te;
      }
      return ee(ie, [{
        key: "loadFiles",
        value: function() {
          var K = this.option.customID, te = new mt("https://static.mudu.tv/peer5/peer5.js?id=".concat(K)).load(), ue = new mt("https://static.mudu.tv/peer5/peer5.hlsjs.loader.js").load(), fe = new mt(this.player._config.fileCdnPath + "/hls.js").load();
          return Promise.all([te, ue, fe]);
        }
      }, {
        key: "setup",
        value: function(K) {
          var te = this, ue = K.file;
          ge(le(ie.prototype), "setup", this).call(this, K), this.file = ue, this.player._config.preload === "auto" ? this.loadHls() : this.oncePlayer(Bt, function() {
            return te.loadHls();
          });
        }
      }, {
        key: "play",
        value: function() {
          var K = this.player.getState(), te = this.getPosition();
          return K === "idle" && te > 0 && this.seek(0), ge(le(ie.prototype), "play", this).call(this);
        }
      }, {
        key: "loadHls",
        value: function() {
          var K = {
            fLoader: window.peer5 && window.peer5.HlsJsFragmentLoader,
            pLoader: window.peer5 && window.peer5.HlsJsPlaylistLoader
          }, te = oe({}, this.option["hls.js"] || {}, K), ue = this.hlsPlayer = new window.Hls(te);
          ue.subtitleDisplay = !1, ue.loadSource(this.file), ue.attachMedia(this.video), ue.on(window.Hls.Events.ERROR, this.onHlsError);
        }
      }, {
        key: "onHlsError",
        value: function(K, te) {
          var ue = te.type, fe = te.details, pe = te.fatal, me = "".concat(ue, "_").concat(fe), ye = [window.Hls.ErrorDetails.BUFFER_STALLED_ERROR, window.Hls.ErrorDetails.BUFFER_NUDGE_ON_STALL];
          if (ye.indexOf(fe) === -1) {
            if (ue === window.Hls.ErrorTypes.NETWORK_ERROR) {
              var _e = te.networkDetails;
              _e && (_e.status && (me += "_".concat(_e.status)), _e.statusText && (me += "_".concat(_e.statusText)));
            }
            this.trigger(Ot, {
              message: me,
              fatal: pe,
              details: fe,
              data: te
            });
          }
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.hlsPlayer && (this.hlsPlayer.off(window.Hls.Events.ERROR, this.onHlsError), this.hlsPlayer.detachMedia(), this.hlsPlayer.destroy());
        }
      }, {
        key: "_onPlayerBuffer",
        value: function(K) {
          var te = K.oldState;
          if (te === "playing") {
            var ue = this.getPosition(), fe = this.getDuration();
            fe - ue < 1 && ue > 0 && fe > 2 && (this.pause(), this.trigger("ended"));
          }
        }
      }]), ie;
    }(dt);
    St.formats = {
      "application/vnd.apple.mpegurl": "hls"
    }, St.type = ["m3u8", "hls"], St.canPlay = function(ae) {
      var ie = ae.type, re = ae.isTimeShift;
      return re && $t() ? !1 : St.type.indexOf(ie) >= 0;
    }, St.isHlsPeer5Supported = function() {
      var ae = window.MediaSource || window.WebKitMediaSource, ie = window.SourceBuffer || window.WebKitSourceBuffer, re = ae && typeof ae.isTypeSupported == "function" && ae.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), K = !ie || ie.prototype && typeof ie.prototype.appendBuffer == "function" && typeof ie.prototype.remove == "function";
      return !!re && !!K;
    }, St.isSupported = function() {
      return St.isHlsPeer5Supported();
    }, St.isFlash = function(ae) {
      return !1;
    }, St.isHTML5 = function(ae) {
      return !0;
    }, St.HlsP2pisPlaybackRateSupported = function() {
      return !0;
    }, St.isPlaybackRateSupported = function() {
      return !0;
    }, St.version = "1.4.12";
    var Mo = "mudu-player-video-hls-p2p", ht = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), K = K || {}, te = he(this, le(ie).call(this, re, K)), te.onHlsError = te.onHlsError.bind(ce(ce(te))), te.video_error_report = !1, te.onPlayer("buffer", te._onPlayerBuffer.bind(ce(ce(te)))), te.TAG = "HlsXP2PProvider", te;
      }
      return ee(ie, [{
        key: "loadFiles",
        value: function() {
          var K = new mt(this.player._config.fileCdnPath + "/hlsp2p.min.js").load(), te = new mt(this.player._config.fileCdnPath + "/hls.js").load();
          return Promise.all([K, te]);
        }
      }, {
        key: "setup",
        value: function(K) {
          var te = this;
          this.destroyHlsp2p();
          var ue = K.file, fe = K.isLive;
          ge(le(ie.prototype), "setup", this).call(this, K), this.file = ue, this._videoType = fe ? "LIVE" : "VOD", this.player._config.preload === "auto" ? this.loadHls() : this.oncePlayer(Bt, function() {
            return te.loadHls();
          });
        }
      }, {
        key: "play",
        value: function() {
          var K = this.player.getState(), te = this.getPosition();
          return K === "idle" && te > 0 && this.seek(0), ge(le(ie.prototype), "play", this).call(this);
        }
      }, {
        key: "loadHls",
        value: function() {
          var K = oe({}, this.option["hls.js"] || {}), te = this.hlsPlayer = new window.Hls({
            config: K
          });
          te.subtitleDisplay = !1, te.loadSource(this.file), te.attachMedia(this.video), this.video.id = Mo, te.on(window.Hls.Events.ERROR, this.onHlsError), this.initHLSP2P();
        }
      }, {
        key: "initHLSP2P",
        value: function() {
          var K = this;
          if (!!window.HLSP2P.isSupported()) {
            var te = this.option, ue = te.xp2pAppId, fe = te.cloudAppId, pe = te.channelId, me = te.enableMultiArea, ye = me === void 0 ? !0 : me, _e = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/.exec(this.file)[0], Ee = {
              videoId: Mo,
              videoType: this._videoType,
              url: this.file,
              channelId: pe,
              domain: _e,
              xp2pAppId: ue,
              cloudAppId: fe,
              enableLocalNetworkShare: !0,
              enableMultiArea: ye,
              p2pStartDelay: 1e3
            };
            this.hlsp2p = window.HLSP2P.create(this.hlsPlayer, Ee), this.hlsp2p.on(window.HLSP2P.Events.Rollback, function(ke) {
              var Re = ke.reason;
              console.warn("p2p \u56DE\u9000 destroy, reason: ".concat(Re)), K.hlsp2p.destroy(), K.player.trigger(Dl, Re);
            }), this.hlsp2p.on("log", function(ke) {
              K.player.trigger("hlsp2pMsg", ke);
            });
          }
        }
      }, {
        key: "onHlsError",
        value: function(K, te) {
          var ue = te.type, fe = te.details, pe = te.fatal, me = "".concat(ue, "_").concat(fe), ye = [window.Hls.ErrorDetails.BUFFER_STALLED_ERROR, window.Hls.ErrorDetails.BUFFER_NUDGE_ON_STALL];
          if (ye.indexOf(fe) === -1) {
            if (ue === window.Hls.ErrorTypes.NETWORK_ERROR) {
              var _e = te.networkDetails;
              _e && (_e.status && (me += "_".concat(_e.status)), _e.statusText && (me += "_".concat(_e.statusText)));
            }
            this.trigger(Ot, {
              message: me,
              fatal: pe,
              details: fe,
              data: te
            });
          }
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.hlsPlayer && (this.hlsPlayer.off(window.Hls.Events.ERROR, this.onHlsError), this.hlsPlayer.detachMedia(), this.hlsPlayer.destroy(), this.hlsPlayer = null), this.destroyHlsp2p();
        }
      }, {
        key: "destroyHlsp2p",
        value: function() {
          this.hlsp2p && (this.hlsp2p.destroy(), this.hlsp2p = null);
        }
      }, {
        key: "_onPlayerBuffer",
        value: function(K) {
          var te = K.oldState;
          if (te === "playing") {
            var ue = this.getPosition(), fe = this.getDuration();
            fe - ue < 1 && ue > 0 && fe > 2 && (this.pause(), this.trigger("ended"));
          }
        }
      }]), ie;
    }(dt);
    ht.formats = {
      "application/vnd.apple.mpegurl": "hls"
    }, ht.type = ["m3u8", "hls"], ht.canPlay = function(ae) {
      var ie = ae.type, re = ae.isTimeShift;
      return re && $t() ? !1 : ht.type.indexOf(ie) >= 0;
    }, ht.isHlsSupported = function() {
      var ae = window.MediaSource || window.WebKitMediaSource, ie = window.SourceBuffer || window.WebKitSourceBuffer, re = ae && typeof ae.isTypeSupported == "function" && ae.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), K = !ie || ie.prototype && typeof ie.prototype.appendBuffer == "function" && typeof ie.prototype.remove == "function";
      return !!re && !!K;
    }, ht.isXP2pSupported = function() {
      return re() && K() && ae() && ie();
      function ae() {
        return !(!window.Array.from || !window.Array.prototype.find);
      }
      function ie() {
        return !!window.crypto;
      }
      function re() {
        return !(!window.MediaSource || !window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'));
      }
      function K() {
        return te() && ue() && fe() && pe() && me();
      }
      function te() {
        return "WebSocket" in window || "MozWebSocket" in window;
      }
      function ue() {
        return !(typeof ArrayBuffer == "undefined" || typeof Uint8Array == "undefined" || typeof Uint16Array == "undefined" || typeof Uint32Array == "undefined" || typeof DataView == "undefined");
      }
      function fe() {
        return "URL" in window && "createObjectURL" in URL;
      }
      function pe() {
        return !!window.RTCPeerConnection || !!(window.webkitRTCPeerConnection || window.mozRTCPeerConnection || window.msRTCPeerConnection || window.oRTCPeerConnection);
      }
      function me() {
        var ye = window.RTCPeerConnection || window.msRTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
        return function() {
          var _e = !1;
          try {
            var Ee = new ye(null);
            _e = "createDataChannel" in Ee, Ee.close(), Ee = null;
          } catch (ke) {
          }
          return _e;
        }();
      }
    }, ht.isSupported = function() {
      return ht.isHlsSupported() && ht.isXP2pSupported;
    }, ht.isFlash = function(ae) {
      return !1;
    }, ht.isHTML5 = function(ae) {
      return !0;
    }, ht.HlsP2pisPlaybackRateSupported = function() {
      return !0;
    }, ht.isPlaybackRateSupported = function() {
      return !0;
    }, ht.version = "1.4.12";
    var zt = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this)), te.player = re, te.p_player_events = [], te.m_provider_events = [], te.p_dom_events = [], te.option = K, te;
      }
      return ee(ie, [{
        key: "provider",
        value: function() {
          return this.player._provider && this.player._provider.instance;
        }
      }, {
        key: "onPlayer",
        value: function(K, te) {
          this.player.on(K, te), this.p_player_events.push({
            evt: K,
            fn: te
          });
        }
      }, {
        key: "oncePlayer",
        value: function(K, te) {
          this.player.once(K, te), this.p_player_events.push({
            evt: K,
            fn: te
          });
        }
      }, {
        key: "onProvider",
        value: function(K, te) {
          this.provider() && (this.provider().on(K, te), this.m_provider_events.push({
            evt: K,
            fn: te
          }));
        }
      }, {
        key: "onceProvider",
        value: function(K, te) {
          this.provider() && (this.provider().once(K, te), this.m_provider_events.push({
            evt: K,
            fn: te
          }));
        }
      }, {
        key: "onDom",
        value: function(K, te, ue) {
          var fe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
          Qe(K, te, ue), fe && this.p_dom_events.push({
            ele: K,
            evt: te,
            fn: ue
          });
        }
      }, {
        key: "remove",
        value: function() {
          var K = this;
          this.p_player_events.forEach(function(te) {
            return K.player.off(te.evt, te.fn);
          }), this.m_provider_events.forEach(function(te) {
            K.provider() && K.provider().off(te.evt, te.fn);
          }), this.p_dom_events.forEach(function(te) {
            return at(te.ele, te.evt, te.fn);
          });
        }
      }]), ie;
    }(Kt);
    zt.isSupported = gs, zt.defaultOptions = {};
    var Fo = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, K)), te.removeResizeListener = null, te;
      }
      return ee(ie, [{
        key: "init",
        value: function() {
          var K = this, te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ue = new mt(this.player._config.fileCdnPath + "/danmaku.js");
          return ue.load().then(function() {
            var fe = K.player.dom.container.querySelector(".".concat(Ti)), pe = new window.Danmaku(oe({
              container: fe
            }, te));
            Je(K, pe).method("resize").method("show").method("hide").method("destroy").method("clear"), K.danmaku = pe;
            var me = K.getCompaVisibility(), ye = function() {
              Ce("function", K.resize) && K.resize();
            }, _e = function() {
              K.danmaku.clear(), K.disableSend = document[me.hidden];
            };
            return K.onPlayer("play", function() {
              pe.paused = !1;
            }), K.onPlayer("pause", function() {
              pe.paused = !0;
            }), K.onPlayer("resize", ye), K.onDom(window, "resize", ye), K.removeResizeListener = Or(fe, ye), me && K.onDom(document, me.visibilitychange, _e), pe;
          });
        }
      }, {
        key: "emit",
        value: function(K) {
          this.disableSend || this.danmaku.emit(K);
        }
      }, {
        key: "getCompaVisibility",
        value: function() {
          if (!Ce("undefined", document.hidden))
            return {
              hidden: "hidden",
              visibilitychange: "visibilitychange"
            };
          if (!Ce("undefined", document.msHidden))
            return {
              hidden: "msHidden",
              visibilitychange: "msvisibilitychange"
            };
          if (!Ce("undefined", document.webkitHidden))
            return {
              hidden: "webkitHidden",
              visibilitychange: "webkitvisibilitychange"
            };
        }
      }, {
        key: "setSpeed",
        value: function(K) {
          this.danmaku && (this.danmaku.speed = K);
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.removeResizeListener && this.removeResizeListener(), Ce("function", this.destroy) && this.destroy();
        }
      }]), ie;
    }(zt);
    Fo.isSupported = function() {
      var ae = dr(), ie = ae.browser.msie && ae.browser.version.major === 8;
      return !ie;
    };
    var ko = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, K)), te.timer = new Wt(oe({}, K, {
          gap: te.option.gap || 60 * 1e3
        })), te.timer.on("tick", function(ue) {
          te.trigger("tick", ue);
        }), te.onPlayer("play", function() {
          te.timer.start();
        }), te.onPlayer("pause", function() {
          te.timer.stop();
        }), te.onPlayer("idle", function() {
          te.timer.stop();
        }), te.onPlayer("complete", function() {
          te.timer.stop();
        }), te.onDom(document, "visibilitychange", function() {
          te.timer.tick();
        }), te.onDom(window, "pagehide", function() {
          te.timer.tick();
        }), te.onDom(window, "unload", function() {
          te.timer.tick();
        }), te.onDom(window, "beforeunload", function() {
          te.timer.tick();
        }), Ce("function", te.option.onTick) && te.on("tick", te.option.onTick), te;
      }
      return ee(ie, [{
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.timer.stop();
        }
      }]), ie;
    }(zt);
    ko.isSupported = si;
    var Oo = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, K)), te.removeResizeListener = null, te;
      }
      return ee(ie, [{
        key: "init",
        value: function() {
          var K = this, te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          console.log("init");
          var ue = new mt(this.player._config.fileCdnPath + "/danmaku-plugin.min.js");
          return ue.load().then(function() {
            var fe = K.player.dom.container.querySelector(".".concat(Ti)), pe = new window.MuduDanmaku(fe, te);
            Je(K, pe).method("resize").method("emit").method("destroy").method("clear").method("setSpeed").method("setRange"), K.danmaku = pe;
            var me = function() {
              Ce("function", K.resize) && K.resize();
            };
            return K.onPlayer("resize", me), K.onDom(window, "resize", me), K.removeResizeListener = Or(fe, me), pe;
          });
        }
      }, {
        key: "emit",
        value: function(K) {
          console.log("emit"), this.danmaku.emit(K);
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this.removeResizeListener && this.removeResizeListener(), Ce("function", this.destroy) && this.destroy();
        }
      }]), ie;
    }(zt);
    Oo.isSupported = function() {
      var ae = dr(), ie = ae.browser.msie && ae.browser.version.major === 10;
      return !ie;
    };
    var D0 = function() {
      var ae = document.getSelection();
      if (!ae.rangeCount)
        return function() {
        };
      for (var ie = document.activeElement, re = [], K = 0; K < ae.rangeCount; K++)
        re.push(ae.getRangeAt(K));
      switch (ie.tagName.toUpperCase()) {
        case "INPUT":
        case "TEXTAREA":
          ie.blur();
          break;
        default:
          ie = null;
          break;
      }
      return ae.removeAllRanges(), function() {
        ae.type === "Caret" && ae.removeAllRanges(), ae.rangeCount || re.forEach(function(te) {
          ae.addRange(te);
        }), ie && ie.focus();
      };
    }, U0 = "Copy to clipboard: #{key}, Enter";
    function H0(ae) {
      var ie = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
      return ae.replace(/#{\s*key\s*}/g, ie);
    }
    function V0(ae, ie) {
      var re, K, te, ue, fe, pe, me = !1;
      ie || (ie = {}), re = ie.debug || !1;
      try {
        te = D0(), ue = document.createRange(), fe = document.getSelection(), pe = document.createElement("span"), pe.textContent = ae, pe.style.all = "unset", pe.style.position = "fixed", pe.style.top = 0, pe.style.clip = "rect(0, 0, 0, 0)", pe.style.whiteSpace = "pre", pe.style.webkitUserSelect = "text", pe.style.MozUserSelect = "text", pe.style.msUserSelect = "text", pe.style.userSelect = "text", document.body.appendChild(pe), ue.selectNode(pe), fe.addRange(ue);
        var ye = document.execCommand("copy");
        if (!ye)
          throw new Error("copy command was unsuccessful");
        me = !0;
      } catch (_e) {
        re && console.error("unable to copy using execCommand: ", _e), re && console.warn("trying IE specific stuff");
        try {
          window.clipboardData.setData("text", ae), me = !0;
        } catch (Ee) {
          re && console.error("unable to copy using clipboardData: ", Ee), re && console.error("falling back to prompt"), K = H0("message" in ie ? ie.message : U0), window.prompt(K, ae);
        }
      } finally {
        fe && (typeof fe.removeRange == "function" ? fe.removeRange(ue) : fe.removeAllRanges()), pe && document.body.removeChild(pe), te();
      }
      return me;
    }
    var B0 = V0, Xi = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, K)), te.logs = [], te.errorLogUrl = re._config.errorLogUrl, te.onPlayer(Di, function(ue) {
          var fe = ue.key;
          fe === "copy-log" && te.copyLog(), fe === "upload-log" && te.uploadLog();
        }), te.onPlayer("all", function(ue) {
          for (var fe = arguments.length, pe = new Array(fe > 1 ? fe - 1 : 0), me = 1; me < fe; me++)
            pe[me - 1] = arguments[me];
          var ye = li();
          te.logs.push({
            type: ue,
            time: ye,
            args: pe
          });
        }), te.onPlayer("error", function(ue) {
          var fe = te.getOtherInfo();
          fe.errorId = ue.errorId, fe.error = ue, !(ue.message === ct.Error.NotAllowedError && te.player._provider && te.player._provider.flash) && te.uploadError(fe);
        }), te;
      }
      return ee(ie, [{
        key: "copyLog",
        value: function() {
          var K = this.getDebugInfo();
          B0(JSON.stringify(K)), this.player.model.bezel.switch(Un);
        }
      }, {
        key: "uploadLog",
        value: function() {
          var K = this.errorLogUrl, te = this.getDebugInfo();
          K && Po(K, te), this.player.model.bezel.switch(Un);
        }
      }, {
        key: "uploadError",
        value: function(K) {
          var te = this.errorLogUrl;
          te && Po(te, K);
        }
      }, {
        key: "filterLog",
        value: function() {
          var K = [];
          return this.logs.forEach(function(te, ue, fe) {
            var pe = fe[ue - 1], me = fe[ue + 1];
            te.type === "time" && pe && pe.type === "time" && me && me.type === "time" || K.push(te);
          }), this.logs = K, K;
        }
      }, {
        key: "getDebugInfo",
        value: function() {
          var K = this.filterLog(), te = this.getOtherInfo();
          return te.log = K, te;
        }
      }, {
        key: "getOtherInfo",
        value: function() {
          var K = oe({}, this.player._status, {
            localization: ""
          }), te = this.player._config, ue = dr(), fe = {};
          this.player._provider && (fe.name = this.player._provider.name);
          var pe = Zt(this.player.plugin), me = document.getElementById(this.player._config.containerId), ye = me && me.outerHTML, _e = {
            uniqId: K.uniqId,
            status: K,
            config: te,
            env: ue,
            provider: fe,
            plugins: pe,
            ua: navigator.userAgent,
            version: "0.40.3",
            url: window.location.href,
            documentTitle: document.title,
            html: ye,
            cookie: document.cookie
          };
          return _e;
        }
      }]), ie;
    }(zt);
    Xi.isSupported = si, Xi.defaultOptions = {};
    var Ro = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, K)), te.backgroundProvider = null, te.abortablePromiseOfProviderInit = null, te.abortablePromiseOfSourceUpdate = null, te._lastPausedTimeStamp = 0, K.enabled && (re._config.preload !== "auto" && (console.warn("SmoothSwitching plugin has been enabled, config.preload will be replace to 'auto'"), re._config.preload = "auto"), setTimeout(function() {
          Je(te.player, ce(ce(te))).method("play").method("toggle").method("next").method("prev").method("switchQuality").method("switchListItem").method("updateCurrentSourceFile");
        }, 0)), te.onPlayer(et, function() {
          te.onProvider(Xr, function() {
            te._lastPausedTimeStamp = Date.now();
          });
        }), te;
      }
      return ee(ie, [{
        key: "play",
        value: function() {
          var K = this, te = this.player._status.state, ue = Ft.call(this.player), fe = ue.reloadAfterPausing, pe = ue.reloadAfterPausingTime;
          if (fe && this._lastPausedTimeStamp && te === "paused") {
            var me = Date.now();
            pe = Ce("undefined", pe) ? 3e3 : pe;
            var ye = me - this._lastPausedTimeStamp > pe;
            if (ye) {
              this._updateSourceFile(ue).then(function(_e) {
                K.updateCurrentSourceFile({
                  file: _e,
                  type: "play"
                }).then(function() {
                  K.provider().play();
                });
              });
              return;
            }
          }
          return this.provider() ? (this.player.trigger(Bt, {
            type: Bt
          }), this.provider().play()) : lr.call(this.player).then(function() {
            Sr.call(K.player);
            try {
              K.player.play();
            } catch (_e) {
              console.error(_e);
            }
          });
        }
      }, {
        key: "toggle",
        value: function() {
          var K = this.player._status.state;
          return K === "paused" || K === "idle" || K === "error" ? this.play() : this.player.pause();
        }
      }, {
        key: "next",
        value: function() {
          var K = this.player.getPlaylistIndex() + 1;
          return this.switchListItem(K);
        }
      }, {
        key: "prev",
        value: function() {
          var K = this.player.getPlaylistIndex() - 1;
          return this.switchListItem(K);
        }
      }, {
        key: "switchQuality",
        value: function(K) {
          var te = this, ue = this.player.getQuality(K);
          return ue ? (this._cleanup(), this._updateSourceFile(ue).then(function() {
            return new Promise(function(fe) {
              var pe = te.player.getPlaylistItem(te.player.getPlaylistIndex()), me = ue;
              te._initBackgroundProvider({
                item: pe,
                source: me,
                type: "switch-quality"
              }).then(function() {
                te._switchToBackgroundProvider({
                  beforeEmitProviderInited: function() {
                    te.player.setQualityActive(K);
                  }
                }), te.player.trigger(ro, {
                  index: K,
                  item: ue
                });
              }), fe();
            });
          })) : Promise.resolve();
        }
      }, {
        key: "switchListItem",
        value: function(K, te) {
          var ue = this;
          if (!Ce("number", K))
            return Promise.resolve(!1);
          var fe = this.player._config.playlist[K];
          if (!fe || Ce("number", te) & !fe.sources[te])
            return Promise.resolve(!1);
          Ce("number", te) ? $r.call(this.player, K, te) : Rr.call(this.player, K), this._cleanup();
          var pe = fe.sources.filter(function(me) {
            return me.active;
          })[0];
          return this._updateSourceFile(pe).then(function() {
            return ue.player.trigger(qr, {
              type: qr,
              index: K,
              item: ue.player.getPlaylistItem(K)
            }), ue._initBackgroundProvider({
              item: fe,
              source: Ce("undefined", te) ? fe.sources[0] : fe.sources[te],
              type: "switch-list-item"
            }).then(function() {
              ue._switchToBackgroundProvider();
            }).then(function() {
              return !0;
            });
          });
        }
      }, {
        key: "updateCurrentSourceFile",
        value: function() {
          var K = this, te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ue = te.file, fe = te.preservePlaybackPosition, pe = fe === void 0 ? !0 : fe, me = te.type, ye = me === void 0 ? "update-current-source-file" : me, _e = this.player.getPlaylistItem(this.player.getPlaylistIndex()), Ee = pi.call(this.player).filter(function(ke) {
            return ke.active;
          })[0];
          return Ee.file = ue, this._cleanup(), this._initBackgroundProvider({
            item: _e,
            source: Ee,
            type: ye
          }).then(function(ke) {
            var Re = ke.instance, xe = ke.details;
            if (!xe.isLive && pe) {
              var Ge = K.player.getPosition();
              Re.seek(Ge), Re.once("seeked", function() {
                setTimeout(function() {
                  if (!Re.removed) {
                    var qe = K.player.getPosition();
                    Re.seek(qe), Re.once("seeked", function() {
                      setTimeout(function() {
                        Re.removed || K._switchToBackgroundProvider();
                      }, 0);
                    });
                  }
                }, 0);
              });
            } else
              K._switchToBackgroundProvider();
          }).then(function() {
            return !0;
          });
        }
      }, {
        key: "remove",
        value: function() {
          ge(le(ie.prototype), "remove", this).call(this), this._cleanup();
        }
      }, {
        key: "_initBackgroundProvider",
        value: function(K) {
          var te = this, ue = K.item, fe = K.source, pe = K.type;
          return this.player.trigger(Ul, {
            item: ue,
            source: fe,
            type: pe
          }), this.abortablePromiseOfProviderInit = yu.call(this.player, ue, fe), this.abortablePromiseOfProviderInit.promise.then(function(me) {
            return te.backgroundProvider && te.backgroundProvider.instance.remove(), te.backgroundProvider = me, me;
          }).catch(function(me) {
            throw me !== "abort" && (Tr.call(te.player), te.player.trigger(Dt, {
              message: me.message,
              fatal: !0,
              errorId: er()
            })), me;
          });
        }
      }, {
        key: "_switchToBackgroundProvider",
        value: function() {
          var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          if (!!this.backgroundProvider) {
            var te = K.beforeEmitProviderInited, ue = this.backgroundProvider, fe = ue.provider, pe = ue.instance, me = ue.details, ye = ue.outdatedEvents, _e = this.player.dom.videoWrap, Ee = this.player.getState(), ke = _e.querySelector("video");
            _e.insertBefore(pe.video, ke), Ee === "idle" || Ee === "paused" ? pe.pause() : pe.play(), Tr.call(this.player), this.player._provider = oe({}, fe, {
              instance: pe
            }), Ce("function", te) && te();
            var Re = this.player.dom.bezel;
            Re.style["z-index"] = -1, setTimeout(function() {
              Re.style["z-index"] = null;
            }, 500), this.player.trigger(et, me), ye.forEach(function(xe) {
              var Ge = xe.event, qe = xe.args;
              pe.trigger.apply(pe, [Ge].concat(be(qe)));
            }), this.backgroundProvider = null, this.player.trigger(Hl);
          }
        }
      }, {
        key: "_updateSourceFile",
        value: function(K) {
          var te = this.option.getSourceFile;
          return this.abortablePromiseOfSourceUpdate = In(Promise.resolve(Ce("function", te) ? te(K) : K.file).then(function(ue) {
            if (!!Ce("string", ue))
              return K.file = ue, ue;
          })), this.abortablePromiseOfSourceUpdate.promise;
        }
      }, {
        key: "_cleanup",
        value: function() {
          this.abortablePromiseOfProviderInit && (this.abortablePromiseOfProviderInit.abort("abort"), this.abortablePromiseOfProviderInit = null), this.abortablePromiseOfSourceUpdate && (this.abortablePromiseOfSourceUpdate.abort("abort"), this.abortablePromiseOfSourceUpdate = null), this.backgroundProvider && (this.backgroundProvider.instance.remove(), this.backgroundProvider = null);
        }
      }]), ie;
    }(zt);
    Ro.isSupported = si;
    var Ar = /* @__PURE__ */ function(ae) {
      se(ie, ae);
      function ie(re, K) {
        var te;
        return $(this, ie), te = he(this, le(ie).call(this, re, K)), te.player = re, te.option = K, te.TAG = "vrProvider", te.inited = !1, te.isFullscreen = !1, te;
      }
      return ee(ie, [{
        key: "loadFiles",
        value: function() {
          var K = new mt("https://static.mudu.tv/mudu-vr-player/v0.1.0/mudu-vr-player.umd.js");
          return K.load();
        }
      }, {
        key: "setup",
        value: function() {
          this.inited && this.destroy(), this.initVRPlayer();
        }
      }, {
        key: "initVRPlayer",
        value: function() {
          var K = this;
          this.inited = !0, this.containerElem = this.player.dom.videoWrap, this.videoElem = this.player.dom.videoWrap.querySelector("video"), this.containerElem.classList.add(gl), this.vrPlayer = new window.muduVRPlayer.VRPlayer(this.containerElem, this.videoElem, oe({}, this.option, {
            onSuccess: function() {
              return K._onVRInitSuccess();
            }
          })), this.subEvents();
        }
      }, {
        key: "destroy",
        value: function() {
          this.vrPlayer.destroy(), this.inited = !1;
        }
      }, {
        key: "subEvents",
        value: function() {
          var K = this;
          this.onDom(this.containerElem, "click", function(te) {
            te.stopPropagation();
          }), this.onDom(window, "resize", function() {
            K.vrPlayer.resize();
          }), this.onPlayer(Ui, function(te) {
            setTimeout(function() {
              K.vrPlayer.resize(K.containerElem.clientWidth, K.containerElem.clientHeight);
            }, 0);
          }), this.oncePlayer(Pt, function(te) {
            K.destroy();
          });
        }
      }, {
        key: "_onVRInitSuccess",
        value: function() {
          this.videoElem.classList.add(Ds), document.body.appendChild(this.videoElem), typeof this.option.onSuccess == "function" && this.option.onSuccess();
        }
      }]), ie;
    }(dt);
    Ar.isSupported = function() {
      return !0;
    }, Ar.defaultOptions = {
      projection: "sphere"
    }, Ar.canPlay = function(ae) {
      return ae !== "flash";
    }, Ar.isLiveSupported = function() {
      return !0;
    };
    var $o = 0, ri = {};
    function Xe(ae) {
      var ie = document.getElementById(ae);
      if (!ie)
        throw new Error("muduPlayer(container): container should be an id of a div in the body, but not found");
      if (ri[ae] && ri[ae]._status)
        return ri[ae];
      $o++;
      var re = new N0(ae);
      return ri[ae] = re, re._status.index = $o, re;
    }
    return Xe.VERSION = "0.40.3", Xe.setDefaultOptions = Ur, Xe.getDefaultOptions = Nn, Xe.registerProvider = Fn, Xe.registerExtraProvider = Is, Xe.getProvider = As, Xe.getExtraProvider = ws, Xe.getProviders = kn, Xe.getExtraProviders = On, Xe.chooseProvider = xr, Xe.registerPlugin = k0, Xe.getPlugin = O0, Xe.getPlugins = Co, Xe.utils = {
      formatPlaylist: vi,
      Timer: Wt,
      ScriptLoader: mt,
      browser: zo,
      Cache: Lt,
      delegates: Je
    }, Xe.registerExtraProvider("vr", Ar), Xe.registerProvider("html5", dt), Xe.registerProvider("dash", kt), Xe.registerProvider("flvjs", Ct), Xe.registerProvider("hlsjs", Tt), Xe.registerProvider("hlsPeer5", St), Xe.registerProvider("tcPlayerLite", Ht), Xe.registerProvider("flash", ct), Xe.registerProvider("hlsXp2p", ht), Xe.registerPlugin("plugin", zt), Xe.registerPlugin("tick", ko), Xe.registerPlugin("danmaku", Fo), Xe.registerPlugin("muduDanmaku", Oo), Xe.registerPlugin("log", Xi), Xe.registerPlugin("smoothSwitching", Ro), Xe;
  });
})(muduPlayer$1);
const muduPlayer = muduPlayer$1.exports;
function isObject$6(e) {
  var T = typeof e;
  return e != null && (T == "object" || T == "function");
}
var isObject_1 = isObject$6, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$9 = freeGlobal || freeSelf || Function("return this")(), _root = root$9, root$8 = _root, now$1 = function() {
  return root$8.Date.now();
}, now_1 = now$1, reWhitespace = /\s/;
function trimmedEndIndex$1(e) {
  for (var T = e.length; T-- && reWhitespace.test(e.charAt(T)); )
    ;
  return T;
}
var _trimmedEndIndex = trimmedEndIndex$1, trimmedEndIndex = _trimmedEndIndex, reTrimStart = /^\s+/;
function baseTrim$1(e) {
  return e && e.slice(0, trimmedEndIndex(e) + 1).replace(reTrimStart, "");
}
var _baseTrim = baseTrim$1, root$7 = _root, Symbol$5 = root$7.Symbol, _Symbol = Symbol$5, Symbol$4 = _Symbol, objectProto$b = Object.prototype, hasOwnProperty$8 = objectProto$b.hasOwnProperty, nativeObjectToString$1 = objectProto$b.toString, symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$1(e) {
  var T = hasOwnProperty$8.call(e, symToStringTag$1), F = e[symToStringTag$1];
  try {
    e[symToStringTag$1] = void 0;
    var $ = !0;
  } catch (ee) {
  }
  var J = nativeObjectToString$1.call(e);
  return $ && (T ? e[symToStringTag$1] = F : delete e[symToStringTag$1]), J;
}
var _getRawTag = getRawTag$1, objectProto$a = Object.prototype, nativeObjectToString = objectProto$a.toString;
function objectToString$1(e) {
  return nativeObjectToString.call(e);
}
var _objectToString = objectToString$1, Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$5(e) {
  return e == null ? e === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(e) ? getRawTag(e) : objectToString(e);
}
var _baseGetTag = baseGetTag$5;
function isObjectLike$5(e) {
  return e != null && typeof e == "object";
}
var isObjectLike_1 = isObjectLike$5, baseGetTag$4 = _baseGetTag, isObjectLike$4 = isObjectLike_1, symbolTag$1 = "[object Symbol]";
function isSymbol$4(e) {
  return typeof e == "symbol" || isObjectLike$4(e) && baseGetTag$4(e) == symbolTag$1;
}
var isSymbol_1 = isSymbol$4, baseTrim = _baseTrim, isObject$5 = isObject_1, isSymbol$3 = isSymbol_1, NAN = 0 / 0, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber$2(e) {
  if (typeof e == "number")
    return e;
  if (isSymbol$3(e))
    return NAN;
  if (isObject$5(e)) {
    var T = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = isObject$5(T) ? T + "" : T;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = baseTrim(e);
  var F = reIsBinary.test(e);
  return F || reIsOctal.test(e) ? freeParseInt(e.slice(2), F ? 2 : 8) : reIsBadHex.test(e) ? NAN : +e;
}
var toNumber_1 = toNumber$2, isObject$4 = isObject_1, now = now_1, toNumber$1 = toNumber_1, FUNC_ERROR_TEXT$2 = "Expected a function", nativeMax$1 = Math.max, nativeMin$1 = Math.min;
function debounce$1(e, T, F) {
  var $, J, ee, ne, oe, se, le = 0, de = !1, ce = !1, he = !0;
  if (typeof e != "function")
    throw new TypeError(FUNC_ERROR_TEXT$2);
  T = toNumber$1(T) || 0, isObject$4(F) && (de = !!F.leading, ce = "maxWait" in F, ee = ce ? nativeMax$1(toNumber$1(F.maxWait) || 0, T) : ee, he = "trailing" in F ? !!F.trailing : he);
  function ve(Ue) {
    var je = $, we = J;
    return $ = J = void 0, le = Ue, ne = e.apply(we, je), ne;
  }
  function ge(Ue) {
    return le = Ue, oe = setTimeout(Se, T), de ? ve(Ue) : ne;
  }
  function be(Ue) {
    var je = Ue - se, we = Ue - le, He = T - je;
    return ce ? nativeMin$1(He, ee - we) : He;
  }
  function Te(Ue) {
    var je = Ue - se, we = Ue - le;
    return se === void 0 || je >= T || je < 0 || ce && we >= ee;
  }
  function Se() {
    var Ue = now();
    if (Te(Ue))
      return Ie(Ue);
    oe = setTimeout(Se, be(Ue));
  }
  function Ie(Ue) {
    return oe = void 0, he && $ ? ve(Ue) : ($ = J = void 0, ne);
  }
  function Oe() {
    oe !== void 0 && clearTimeout(oe), le = 0, $ = se = J = oe = void 0;
  }
  function Le() {
    return oe === void 0 ? ne : Ie(now());
  }
  function Ne() {
    var Ue = now(), je = Te(Ue);
    if ($ = arguments, J = this, se = Ue, je) {
      if (oe === void 0)
        return ge(se);
      if (ce)
        return clearTimeout(oe), oe = setTimeout(Se, T), ve(se);
    }
    return oe === void 0 && (oe = setTimeout(Se, T)), ne;
  }
  return Ne.cancel = Oe, Ne.flush = Le, Ne;
}
var debounce_1 = debounce$1, isArray$8 = Array.isArray, isArray_1 = isArray$8, isArray$7 = isArray_1, isSymbol$2 = isSymbol_1, reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(e, T) {
  if (isArray$7(e))
    return !1;
  var F = typeof e;
  return F == "number" || F == "symbol" || F == "boolean" || e == null || isSymbol$2(e) ? !0 : reIsPlainProp.test(e) || !reIsDeepProp.test(e) || T != null && e in Object(T);
}
var _isKey = isKey$3, baseGetTag$3 = _baseGetTag, isObject$3 = isObject_1, asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(e) {
  if (!isObject$3(e))
    return !1;
  var T = baseGetTag$3(e);
  return T == funcTag$1 || T == genTag || T == asyncTag || T == proxyTag;
}
var isFunction_1 = isFunction$2, root$6 = _root, coreJsData$1 = root$6["__core-js_shared__"], _coreJsData = coreJsData$1, coreJsData = _coreJsData, maskSrcKey = function() {
  var e = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function isMasked$1(e) {
  return !!maskSrcKey && maskSrcKey in e;
}
var _isMasked = isMasked$1, funcProto$1 = Function.prototype, funcToString$1 = funcProto$1.toString;
function toSource$2(e) {
  if (e != null) {
    try {
      return funcToString$1.call(e);
    } catch (T) {
    }
    try {
      return e + "";
    } catch (T) {
    }
  }
  return "";
}
var _toSource = toSource$2, isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$2 = isObject_1, toSource$1 = _toSource, reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto = Function.prototype, objectProto$9 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$7 = objectProto$9.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(e) {
  if (!isObject$2(e) || isMasked(e))
    return !1;
  var T = isFunction$1(e) ? reIsNative : reIsHostCtor;
  return T.test(toSource$1(e));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(e, T) {
  return e == null ? void 0 : e[T];
}
var _getValue = getValue$1, baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$6(e, T) {
  var F = getValue(e, T);
  return baseIsNative(F) ? F : void 0;
}
var _getNative = getNative$6, getNative$5 = _getNative, nativeCreate$4 = getNative$5(Object, "create"), _nativeCreate = nativeCreate$4, nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(e) {
  var T = this.has(e) && delete this.__data__[e];
  return this.size -= T ? 1 : 0, T;
}
var _hashDelete = hashDelete$1, nativeCreate$2 = _nativeCreate, HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$8 = Object.prototype, hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet$1(e) {
  var T = this.__data__;
  if (nativeCreate$2) {
    var F = T[e];
    return F === HASH_UNDEFINED$2 ? void 0 : F;
  }
  return hasOwnProperty$6.call(T, e) ? T[e] : void 0;
}
var _hashGet = hashGet$1, nativeCreate$1 = _nativeCreate, objectProto$7 = Object.prototype, hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas$1(e) {
  var T = this.__data__;
  return nativeCreate$1 ? T[e] !== void 0 : hasOwnProperty$5.call(T, e);
}
var _hashHas = hashHas$1, nativeCreate = _nativeCreate, HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(e, T) {
  var F = this.__data__;
  return this.size += this.has(e) ? 0 : 1, F[e] = nativeCreate && T === void 0 ? HASH_UNDEFINED$1 : T, this;
}
var _hashSet = hashSet$1, hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(e) {
  var T = -1, F = e == null ? 0 : e.length;
  for (this.clear(); ++T < F; ) {
    var $ = e[T];
    this.set($[0], $[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype.delete = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$2(e, T) {
  return e === T || e !== e && T !== T;
}
var eq_1 = eq$2, eq$1 = eq_1;
function assocIndexOf$4(e, T) {
  for (var F = e.length; F--; )
    if (eq$1(e[F][0], T))
      return F;
  return -1;
}
var _assocIndexOf = assocIndexOf$4, assocIndexOf$3 = _assocIndexOf, arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete$1(e) {
  var T = this.__data__, F = assocIndexOf$3(T, e);
  if (F < 0)
    return !1;
  var $ = T.length - 1;
  return F == $ ? T.pop() : splice.call(T, F, 1), --this.size, !0;
}
var _listCacheDelete = listCacheDelete$1, assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(e) {
  var T = this.__data__, F = assocIndexOf$2(T, e);
  return F < 0 ? void 0 : T[F][1];
}
var _listCacheGet = listCacheGet$1, assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(e) {
  return assocIndexOf$1(this.__data__, e) > -1;
}
var _listCacheHas = listCacheHas$1, assocIndexOf = _assocIndexOf;
function listCacheSet$1(e, T) {
  var F = this.__data__, $ = assocIndexOf(F, e);
  return $ < 0 ? (++this.size, F.push([e, T])) : F[$][1] = T, this;
}
var _listCacheSet = listCacheSet$1, listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(e) {
  var T = -1, F = e == null ? 0 : e.length;
  for (this.clear(); ++T < F; ) {
    var $ = e[T];
    this.set($[0], $[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype.delete = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4, getNative$4 = _getNative, root$5 = _root, Map$4 = getNative$4(root$5, "Map"), _Map = Map$4, Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$3 || ListCache$3)(),
    string: new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(e) {
  var T = typeof e;
  return T == "string" || T == "number" || T == "symbol" || T == "boolean" ? e !== "__proto__" : e === null;
}
var _isKeyable = isKeyable$1, isKeyable = _isKeyable;
function getMapData$4(e, T) {
  var F = e.__data__;
  return isKeyable(T) ? F[typeof T == "string" ? "string" : "hash"] : F.map;
}
var _getMapData = getMapData$4, getMapData$3 = _getMapData;
function mapCacheDelete$1(e) {
  var T = getMapData$3(this, e).delete(e);
  return this.size -= T ? 1 : 0, T;
}
var _mapCacheDelete = mapCacheDelete$1, getMapData$2 = _getMapData;
function mapCacheGet$1(e) {
  return getMapData$2(this, e).get(e);
}
var _mapCacheGet = mapCacheGet$1, getMapData$1 = _getMapData;
function mapCacheHas$1(e) {
  return getMapData$1(this, e).has(e);
}
var _mapCacheHas = mapCacheHas$1, getMapData = _getMapData;
function mapCacheSet$1(e, T) {
  var F = getMapData(this, e), $ = F.size;
  return F.set(e, T), this.size += F.size == $ ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet$1, mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(e) {
  var T = -1, F = e == null ? 0 : e.length;
  for (this.clear(); ++T < F; ) {
    var $ = e[T];
    this.set($[0], $[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype.delete = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3, MapCache$2 = _MapCache, FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize$1(e, T) {
  if (typeof e != "function" || T != null && typeof T != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  var F = function() {
    var $ = arguments, J = T ? T.apply(this, $) : $[0], ee = F.cache;
    if (ee.has(J))
      return ee.get(J);
    var ne = e.apply(this, $);
    return F.cache = ee.set(J, ne) || ee, ne;
  };
  return F.cache = new (memoize$1.Cache || MapCache$2)(), F;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1, memoize = memoize_1, MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(e) {
  var T = memoize(e, function($) {
    return F.size === MAX_MEMOIZE_SIZE && F.clear(), $;
  }), F = T.cache;
  return T;
}
var _memoizeCapped = memoizeCapped$1, memoizeCapped = _memoizeCapped, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath$1 = memoizeCapped(function(e) {
  var T = [];
  return e.charCodeAt(0) === 46 && T.push(""), e.replace(rePropName, function(F, $, J, ee) {
    T.push(J ? ee.replace(reEscapeChar, "$1") : $ || F);
  }), T;
}), _stringToPath = stringToPath$1;
function arrayMap$1(e, T) {
  for (var F = -1, $ = e == null ? 0 : e.length, J = Array($); ++F < $; )
    J[F] = T(e[F], F, e);
  return J;
}
var _arrayMap = arrayMap$1, Symbol$2 = _Symbol, arrayMap = _arrayMap, isArray$6 = isArray_1, isSymbol$1 = isSymbol_1, INFINITY$2 = 1 / 0, symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(e) {
  if (typeof e == "string")
    return e;
  if (isArray$6(e))
    return arrayMap(e, baseToString$1) + "";
  if (isSymbol$1(e))
    return symbolToString ? symbolToString.call(e) : "";
  var T = e + "";
  return T == "0" && 1 / e == -INFINITY$2 ? "-0" : T;
}
var _baseToString = baseToString$1, baseToString = _baseToString;
function toString$1(e) {
  return e == null ? "" : baseToString(e);
}
var toString_1 = toString$1, isArray$5 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString = toString_1;
function castPath$2(e, T) {
  return isArray$5(e) ? e : isKey$2(e, T) ? [e] : stringToPath(toString(e));
}
var _castPath = castPath$2, isSymbol = isSymbol_1, INFINITY$1 = 1 / 0;
function toKey$4(e) {
  if (typeof e == "string" || isSymbol(e))
    return e;
  var T = e + "";
  return T == "0" && 1 / e == -INFINITY$1 ? "-0" : T;
}
var _toKey = toKey$4, castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$2(e, T) {
  T = castPath$1(T, e);
  for (var F = 0, $ = T.length; e != null && F < $; )
    e = e[toKey$3(T[F++])];
  return F && F == $ ? e : void 0;
}
var _baseGet = baseGet$2, baseGet$1 = _baseGet;
function get$1(e, T, F) {
  var $ = e == null ? void 0 : baseGet$1(e, T);
  return $ === void 0 ? F : $;
}
var get_1 = get$1, httpStreamDetect = { exports: {} };
/*!
* repo: https://git.mudu.tv/front-end/http-stream-detect
* HttpStreamDetect v1.0.0
* hash: 477c015b
*/
(function(e, T) {
  (function(F, $) {
    e.exports = $();
  })(commonjsGlobal, function() {
    function F(we, He) {
      if (!(we instanceof He))
        throw new TypeError("Cannot call a class as a function");
    }
    function $(we, He) {
      for (var De = 0; De < He.length; De++) {
        var $e = He[De];
        $e.enumerable = $e.enumerable || !1, $e.configurable = !0, "value" in $e && ($e.writable = !0), Object.defineProperty(we, $e.key, $e);
      }
    }
    function J(we, He, De) {
      return He && $(we.prototype, He), De && $(we, De), we;
    }
    function ee(we, He) {
      if (typeof He != "function" && He !== null)
        throw new TypeError("Super expression must either be null or a function");
      we.prototype = Object.create(He && He.prototype, {
        constructor: {
          value: we,
          writable: !0,
          configurable: !0
        }
      }), He && oe(we, He);
    }
    function ne(we) {
      return ne = Object.setPrototypeOf ? Object.getPrototypeOf : function(De) {
        return De.__proto__ || Object.getPrototypeOf(De);
      }, ne(we);
    }
    function oe(we, He) {
      return oe = Object.setPrototypeOf || function($e, Be) {
        return $e.__proto__ = Be, $e;
      }, oe(we, He);
    }
    function se(we) {
      if (we === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return we;
    }
    function le(we, He) {
      return He && (typeof He == "object" || typeof He == "function") ? He : se(we);
    }
    function de(we) {
      return ce(we) || he(we) || ve();
    }
    function ce(we) {
      if (Array.isArray(we)) {
        for (var He = 0, De = new Array(we.length); He < we.length; He++)
          De[He] = we[He];
        return De;
      }
    }
    function he(we) {
      if (Symbol.iterator in Object(we) || Object.prototype.toString.call(we) === "[object Arguments]")
        return Array.from(we);
    }
    function ve() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    var ge = 0, be = /* @__PURE__ */ function() {
      function we() {
        F(this, we), this._listeners = {};
      }
      return J(we, [{
        key: "on",
        value: function(De, $e) {
          var Be = ++ge;
          return this._listeners[De] = this._listeners[De] || [], this._listeners[De].push({
            id: Be,
            listener: $e,
            once: !1
          }), Be;
        }
      }, {
        key: "once",
        value: function(De, $e) {
          var Be = ++ge;
          return this._listeners[De] = this._listeners[De] || [], this._listeners[De].push({
            id: Be,
            listener: $e,
            once: !0
          }), Be;
        }
      }, {
        key: "off",
        value: function(De, $e) {
          this._listeners[De] = this._listeners[De] || [];
          for (var Be = 0; Be < this._listeners[De].length; Be++) {
            var lt = this._listeners[De][Be];
            if (lt.id === $e || lt.listener === $e) {
              this._listeners[De].splice(Be, 1);
              break;
            }
          }
        }
      }, {
        key: "trigger",
        value: function(De) {
          this._listeners[De] = this._listeners[De] || [];
          for (var $e = de(this._listeners[De]), Be = arguments.length, lt = new Array(Be > 1 ? Be - 1 : 0), tt = 1; tt < Be; tt++)
            lt[tt - 1] = arguments[tt];
          for (var nt = this._listeners[De].length - 1; nt >= 0; nt--) {
            var Et = this._listeners[De][nt];
            try {
              Et.listener.apply(Et, lt);
            } catch (It) {
              throw console.error(It), It;
            }
            Et.once && $e.splice(nt, 1);
          }
          this._listeners[De] = $e, De !== "all" && this.trigger.apply(this, ["all", De].concat(lt));
        }
      }, {
        key: "clear",
        value: function() {
          this._listeners = {};
        }
      }]), we;
    }(), Te = "detect_result_event", Se = "detect_change_event", Ie = "fail_reason_timeout", Oe = "fail_reason_statuscode", Le = "fail_reason_data_length", Ne = "fail_reason_success";
    function Ue(we, He) {
      return new Promise(function(De) {
        var $e = new XMLHttpRequest(), Be = !1, lt = 0;
        He > 0 && (lt = setTimeout(function() {
          Be || (Be = !0, De({
            success: !1,
            reason: Ie
          }), $e.abort());
        }, He)), $e.onreadystatechange = function() {
          if ($e.readyState > 2) {
            var tt = $e.status, nt = $e.responseText.length;
            if (Be)
              return;
            Be = !0, clearTimeout(lt), tt >= 200 && tt < 300 ? De(nt ? {
              success: !0,
              reason: Ne
            } : {
              success: !1,
              reason: Le
            }) : De({
              success: !1,
              reason: Oe
            }), $e.abort();
          }
        }, $e.open("GET", we), $e.send();
      });
    }
    var je = /* @__PURE__ */ function(we) {
      ee(He, we);
      function He(De, $e) {
        var Be;
        return F(this, He), Be = le(this, ne(He).call(this)), Be._file = De, Be._gap = +$e || 3e3, Be._timer = null, Be._isChecking = !1, Be._timeOut = 3e3, Be._preventResult = !1, Be._lastConnected = null, Be;
      }
      return J(He, [{
        key: "setPrev",
        value: function($e) {
          this._lastConnected = !!$e;
        }
      }, {
        key: "_tick",
        value: function() {
          var $e = this;
          this._isChecking || (this._preventResult = !1, this._isChecking = !0, Ue(this._file, this._timeOut).then(function(Be) {
            $e._isChecking = !1, $e._preventResult || ($e.trigger(He.DETECT_RESULT_EVENT, {
              file: $e._file,
              prev: $e._lastConnected,
              current: Be.success,
              reason: Be.reason
            }), $e._lastConnected !== Be.success && $e.trigger(He.DETECT_CHANGE_EVENT, {
              file: $e._file,
              prev: $e._lastConnected,
              current: Be.success,
              reason: Be.reason
            }), $e._lastConnected = Be.success);
          }));
        }
      }, {
        key: "start",
        value: function() {
          this._timer && (clearInterval(this._timer), this._timer = null), this._timer = setInterval(this._tick.bind(this), this._gap);
        }
      }, {
        key: "stop",
        value: function() {
          this._timer && (this._preventResult = !0, clearInterval(this._timer), this._timer = null);
        }
      }, {
        key: "setGap",
        value: function($e) {
          $e = +$e, isFinite($e) && $e && (this._gap = $e, this.start());
        }
      }, {
        key: "setTimeout",
        value: function($e) {
          $e = +$e, isFinite($e) && $e && (this._timeOut = $e);
        }
      }]), He;
    }(be);
    return je.DETECT_RESULT_EVENT = Te, je.DETECT_CHANGE_EVENT = Se, je.FAIL_REASON_TIMEOUT = Ie, je.FAIL_REASON_STATUSCODE = Oe, je.FAIL_REASON_DATA_LENGTH = Le, je.FAIL_REASON_SUCCESS = Ne, je.testHttp = Ue, je;
  });
})(httpStreamDetect);
const HttpStreamDetect = httpStreamDetect.exports, ajax = (e, T) => {
  const F = T || {}, $ = (F.method || "GET").toUpperCase(), J = F.async === void 0 ? !0 : F.async, ee = new XMLHttpRequest(), ne = F.data || {};
  if (J && (ee.onreadystatechange = () => {
    ee.readyState === 4 && oe(F, ee);
  }), $ === "GET") {
    let le = e;
    const de = se(ne);
    de && (le = `${e}?${de}`), ee.open("GET", le, J), ee.send(null);
  } else if ($ === "POST") {
    let le = !1;
    if (J || dealWithSendSyncError(e, ne) && (le = !0), !le) {
      ee.open("POST", e, J), ee.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
      const de = JSON.stringify(ne);
      try {
        ee.send(de);
      } catch (ce) {
      }
    }
  } else if ($ === "PUT") {
    let le = !1;
    if (J || dealWithSendSyncError(e, ne) && (le = !0), !le) {
      ee.open("PUT", e, J), ee.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
      const de = JSON.stringify(ne);
      try {
        ee.send(de);
      } catch (ce) {
      }
    }
  }
  J || oe(F, ee);
  function oe(le, de) {
    const { status: ce } = de;
    ce >= 200 && ce < 300 ? typeof le.success == "function" && le.success(de.responseText, de.responseXML) : typeof le.fail == "function" && le.fail(de), typeof le.complete == "function" && le.complete(de);
  }
  function se(le) {
    const de = [];
    for (const ce in le)
      Object.prototype.hasOwnProperty.call(le, ce) && de.push(`${encodeURIComponent(ce)}=${encodeURIComponent(le[ce])}`);
    return de.join("&");
  }
};
function dealWithSendSyncError(e, T) {
  if (navigator.sendBeacon) {
    const F = new FormData();
    for (const $ in T)
      if (Object.prototype.hasOwnProperty.call(T, $)) {
        let J = T[$];
        typeof J != "string" && (J = JSON.stringify(J)), F.append($, J);
      }
    return navigator.sendBeacon(e, F);
  }
  return !1;
}
const unescape$1 = (e) => e ? e.replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&#34;/g, '"').replace(/&amp;/g, "&") : "", DETECT_RESULT_EVENT = "detect_result_event";
var version = "3.4.2";
function wait(e, T) {
  return new Promise(function(F) {
    return setTimeout(F, e, T);
  });
}
function requestIdleCallbackIfAvailable(e, T) {
  T === void 0 && (T = 1 / 0);
  var F = window.requestIdleCallback;
  return F ? new Promise(function($) {
    return F.call(window, function() {
      return $();
    }, { timeout: T });
  }) : wait(Math.min(e, T));
}
function isPromise(e) {
  return !!e && typeof e.then == "function";
}
function awaitIfAsync(e, T) {
  try {
    var F = e();
    isPromise(F) ? F.then(function($) {
      return T(!0, $);
    }, function($) {
      return T(!1, $);
    }) : T(!0, F);
  } catch ($) {
    T(!1, $);
  }
}
function mapWithBreaks(e, T, F) {
  return F === void 0 && (F = 16), __awaiter(this, void 0, void 0, function() {
    var $, J, ee, ne;
    return __generator(this, function(oe) {
      switch (oe.label) {
        case 0:
          $ = Array(e.length), J = Date.now(), ee = 0, oe.label = 1;
        case 1:
          return ee < e.length ? ($[ee] = T(e[ee], ee), ne = Date.now(), ne >= J + F ? (J = ne, [4, wait(0)]) : [3, 3]) : [3, 4];
        case 2:
          oe.sent(), oe.label = 3;
        case 3:
          return ++ee, [3, 1];
        case 4:
          return [2, $];
      }
    });
  });
}
function suppressUnhandledRejectionWarning(e) {
  e.then(void 0, function() {
  });
}
function x64Add(e, T) {
  e = [e[0] >>> 16, e[0] & 65535, e[1] >>> 16, e[1] & 65535], T = [T[0] >>> 16, T[0] & 65535, T[1] >>> 16, T[1] & 65535];
  var F = [0, 0, 0, 0];
  return F[3] += e[3] + T[3], F[2] += F[3] >>> 16, F[3] &= 65535, F[2] += e[2] + T[2], F[1] += F[2] >>> 16, F[2] &= 65535, F[1] += e[1] + T[1], F[0] += F[1] >>> 16, F[1] &= 65535, F[0] += e[0] + T[0], F[0] &= 65535, [F[0] << 16 | F[1], F[2] << 16 | F[3]];
}
function x64Multiply(e, T) {
  e = [e[0] >>> 16, e[0] & 65535, e[1] >>> 16, e[1] & 65535], T = [T[0] >>> 16, T[0] & 65535, T[1] >>> 16, T[1] & 65535];
  var F = [0, 0, 0, 0];
  return F[3] += e[3] * T[3], F[2] += F[3] >>> 16, F[3] &= 65535, F[2] += e[2] * T[3], F[1] += F[2] >>> 16, F[2] &= 65535, F[2] += e[3] * T[2], F[1] += F[2] >>> 16, F[2] &= 65535, F[1] += e[1] * T[3], F[0] += F[1] >>> 16, F[1] &= 65535, F[1] += e[2] * T[2], F[0] += F[1] >>> 16, F[1] &= 65535, F[1] += e[3] * T[1], F[0] += F[1] >>> 16, F[1] &= 65535, F[0] += e[0] * T[3] + e[1] * T[2] + e[2] * T[1] + e[3] * T[0], F[0] &= 65535, [F[0] << 16 | F[1], F[2] << 16 | F[3]];
}
function x64Rotl(e, T) {
  return T %= 64, T === 32 ? [e[1], e[0]] : T < 32 ? [e[0] << T | e[1] >>> 32 - T, e[1] << T | e[0] >>> 32 - T] : (T -= 32, [e[1] << T | e[0] >>> 32 - T, e[0] << T | e[1] >>> 32 - T]);
}
function x64LeftShift(e, T) {
  return T %= 64, T === 0 ? e : T < 32 ? [e[0] << T | e[1] >>> 32 - T, e[1] << T] : [e[1] << T - 32, 0];
}
function x64Xor(e, T) {
  return [e[0] ^ T[0], e[1] ^ T[1]];
}
function x64Fmix(e) {
  return e = x64Xor(e, [0, e[0] >>> 1]), e = x64Multiply(e, [4283543511, 3981806797]), e = x64Xor(e, [0, e[0] >>> 1]), e = x64Multiply(e, [3301882366, 444984403]), e = x64Xor(e, [0, e[0] >>> 1]), e;
}
function x64hash128(e, T) {
  e = e || "", T = T || 0;
  var F = e.length % 16, $ = e.length - F, J = [0, T], ee = [0, T], ne = [0, 0], oe = [0, 0], se = [2277735313, 289559509], le = [1291169091, 658871167], de;
  for (de = 0; de < $; de = de + 16)
    ne = [
      e.charCodeAt(de + 4) & 255 | (e.charCodeAt(de + 5) & 255) << 8 | (e.charCodeAt(de + 6) & 255) << 16 | (e.charCodeAt(de + 7) & 255) << 24,
      e.charCodeAt(de) & 255 | (e.charCodeAt(de + 1) & 255) << 8 | (e.charCodeAt(de + 2) & 255) << 16 | (e.charCodeAt(de + 3) & 255) << 24
    ], oe = [
      e.charCodeAt(de + 12) & 255 | (e.charCodeAt(de + 13) & 255) << 8 | (e.charCodeAt(de + 14) & 255) << 16 | (e.charCodeAt(de + 15) & 255) << 24,
      e.charCodeAt(de + 8) & 255 | (e.charCodeAt(de + 9) & 255) << 8 | (e.charCodeAt(de + 10) & 255) << 16 | (e.charCodeAt(de + 11) & 255) << 24
    ], ne = x64Multiply(ne, se), ne = x64Rotl(ne, 31), ne = x64Multiply(ne, le), J = x64Xor(J, ne), J = x64Rotl(J, 27), J = x64Add(J, ee), J = x64Add(x64Multiply(J, [0, 5]), [0, 1390208809]), oe = x64Multiply(oe, le), oe = x64Rotl(oe, 33), oe = x64Multiply(oe, se), ee = x64Xor(ee, oe), ee = x64Rotl(ee, 31), ee = x64Add(ee, J), ee = x64Add(x64Multiply(ee, [0, 5]), [0, 944331445]);
  switch (ne = [0, 0], oe = [0, 0], F) {
    case 15:
      oe = x64Xor(oe, x64LeftShift([0, e.charCodeAt(de + 14)], 48));
    case 14:
      oe = x64Xor(oe, x64LeftShift([0, e.charCodeAt(de + 13)], 40));
    case 13:
      oe = x64Xor(oe, x64LeftShift([0, e.charCodeAt(de + 12)], 32));
    case 12:
      oe = x64Xor(oe, x64LeftShift([0, e.charCodeAt(de + 11)], 24));
    case 11:
      oe = x64Xor(oe, x64LeftShift([0, e.charCodeAt(de + 10)], 16));
    case 10:
      oe = x64Xor(oe, x64LeftShift([0, e.charCodeAt(de + 9)], 8));
    case 9:
      oe = x64Xor(oe, [0, e.charCodeAt(de + 8)]), oe = x64Multiply(oe, le), oe = x64Rotl(oe, 33), oe = x64Multiply(oe, se), ee = x64Xor(ee, oe);
    case 8:
      ne = x64Xor(ne, x64LeftShift([0, e.charCodeAt(de + 7)], 56));
    case 7:
      ne = x64Xor(ne, x64LeftShift([0, e.charCodeAt(de + 6)], 48));
    case 6:
      ne = x64Xor(ne, x64LeftShift([0, e.charCodeAt(de + 5)], 40));
    case 5:
      ne = x64Xor(ne, x64LeftShift([0, e.charCodeAt(de + 4)], 32));
    case 4:
      ne = x64Xor(ne, x64LeftShift([0, e.charCodeAt(de + 3)], 24));
    case 3:
      ne = x64Xor(ne, x64LeftShift([0, e.charCodeAt(de + 2)], 16));
    case 2:
      ne = x64Xor(ne, x64LeftShift([0, e.charCodeAt(de + 1)], 8));
    case 1:
      ne = x64Xor(ne, [0, e.charCodeAt(de)]), ne = x64Multiply(ne, se), ne = x64Rotl(ne, 31), ne = x64Multiply(ne, le), J = x64Xor(J, ne);
  }
  return J = x64Xor(J, [0, e.length]), ee = x64Xor(ee, [0, e.length]), J = x64Add(J, ee), ee = x64Add(ee, J), J = x64Fmix(J), ee = x64Fmix(ee), J = x64Add(J, ee), ee = x64Add(ee, J), ("00000000" + (J[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (J[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (ee[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (ee[1] >>> 0).toString(16)).slice(-8);
}
function errorToObject(e) {
  var T;
  return __assign({ name: e.name, message: e.message, stack: (T = e.stack) === null || T === void 0 ? void 0 : T.split(`
`) }, e);
}
function includes(e, T) {
  for (var F = 0, $ = e.length; F < $; ++F)
    if (e[F] === T)
      return !0;
  return !1;
}
function excludes(e, T) {
  return !includes(e, T);
}
function toInt(e) {
  return parseInt(e);
}
function toFloat(e) {
  return parseFloat(e);
}
function replaceNaN(e, T) {
  return typeof e == "number" && isNaN(e) ? T : e;
}
function countTruthy(e) {
  return e.reduce(function(T, F) {
    return T + (F ? 1 : 0);
  }, 0);
}
function round(e, T) {
  if (T === void 0 && (T = 1), Math.abs(T) >= 1)
    return Math.round(e / T) * T;
  var F = 1 / T;
  return Math.round(e * F) / F;
}
function parseSimpleCssSelector(e) {
  for (var T, F, $ = "Unexpected syntax '".concat(e, "'"), J = /^\s*([a-z-]*)(.*)$/i.exec(e), ee = J[1] || void 0, ne = {}, oe = /([.:#][\w-]+|\[.+?\])/gi, se = function(he, ve) {
    ne[he] = ne[he] || [], ne[he].push(ve);
  }; ; ) {
    var le = oe.exec(J[2]);
    if (!le)
      break;
    var de = le[0];
    switch (de[0]) {
      case ".":
        se("class", de.slice(1));
        break;
      case "#":
        se("id", de.slice(1));
        break;
      case "[": {
        var ce = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(de);
        if (ce)
          se(ce[1], (F = (T = ce[4]) !== null && T !== void 0 ? T : ce[5]) !== null && F !== void 0 ? F : "");
        else
          throw new Error($);
        break;
      }
      default:
        throw new Error($);
    }
  }
  return [ee, ne];
}
function ensureErrorWithMessage(e) {
  return e && typeof e == "object" && "message" in e ? e : { message: e };
}
function isFinalResultLoaded(e) {
  return typeof e != "function";
}
function loadSource(e, T) {
  var F = new Promise(function($) {
    var J = Date.now();
    awaitIfAsync(e.bind(null, T), function() {
      for (var ee = [], ne = 0; ne < arguments.length; ne++)
        ee[ne] = arguments[ne];
      var oe = Date.now() - J;
      if (!ee[0])
        return $(function() {
          return { error: ensureErrorWithMessage(ee[1]), duration: oe };
        });
      var se = ee[1];
      if (isFinalResultLoaded(se))
        return $(function() {
          return { value: se, duration: oe };
        });
      $(function() {
        return new Promise(function(le) {
          var de = Date.now();
          awaitIfAsync(se, function() {
            for (var ce = [], he = 0; he < arguments.length; he++)
              ce[he] = arguments[he];
            var ve = oe + Date.now() - de;
            if (!ce[0])
              return le({ error: ensureErrorWithMessage(ce[1]), duration: ve });
            le({ value: ce[1], duration: ve });
          });
        });
      });
    });
  });
  return suppressUnhandledRejectionWarning(F), function() {
    return F.then(function(J) {
      return J();
    });
  };
}
function loadSources(e, T, F) {
  var $ = Object.keys(e).filter(function(ee) {
    return excludes(F, ee);
  }), J = mapWithBreaks($, function(ee) {
    return loadSource(e[ee], T);
  });
  return suppressUnhandledRejectionWarning(J), function() {
    return __awaiter(this, void 0, void 0, function() {
      var ne, oe, se, le, de;
      return __generator(this, function(ce) {
        switch (ce.label) {
          case 0:
            return [4, J];
          case 1:
            return ne = ce.sent(), [4, mapWithBreaks(ne, function(he) {
              var ve = he();
              return suppressUnhandledRejectionWarning(ve), ve;
            })];
          case 2:
            return oe = ce.sent(), [
              4,
              Promise.all(oe)
            ];
          case 3:
            for (se = ce.sent(), le = {}, de = 0; de < $.length; ++de)
              le[$[de]] = se[de];
            return [2, le];
        }
      });
    });
  };
}
function isTrident() {
  var e = window, T = navigator;
  return countTruthy([
    "MSCSSMatrix" in e,
    "msSetImmediate" in e,
    "msIndexedDB" in e,
    "msMaxTouchPoints" in T,
    "msPointerEnabled" in T
  ]) >= 4;
}
function isEdgeHTML() {
  var e = window, T = navigator;
  return countTruthy(["msWriteProfilerMark" in e, "MSStream" in e, "msLaunchUri" in T, "msSaveBlob" in T]) >= 3 && !isTrident();
}
function isChromium() {
  var e = window, T = navigator;
  return countTruthy([
    "webkitPersistentStorage" in T,
    "webkitTemporaryStorage" in T,
    T.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in e,
    "BatteryManager" in e,
    "webkitMediaStream" in e,
    "webkitSpeechGrammar" in e
  ]) >= 5;
}
function isWebKit() {
  var e = window, T = navigator;
  return countTruthy([
    "ApplePayError" in e,
    "CSSPrimitiveValue" in e,
    "Counter" in e,
    T.vendor.indexOf("Apple") === 0,
    "getStorageUpdates" in T,
    "WebKitMediaKeys" in e
  ]) >= 4;
}
function isDesktopSafari() {
  var e = window;
  return countTruthy([
    "safari" in e,
    !("DeviceMotionEvent" in e),
    !("ongestureend" in e),
    !("standalone" in navigator)
  ]) >= 3;
}
function isGecko() {
  var e, T, F = window;
  return countTruthy([
    "buildID" in navigator,
    "MozAppearance" in ((T = (e = document.documentElement) === null || e === void 0 ? void 0 : e.style) !== null && T !== void 0 ? T : {}),
    "onmozfullscreenchange" in F,
    "mozInnerScreenX" in F,
    "CSSMozDocumentRule" in F,
    "CanvasCaptureMediaStream" in F
  ]) >= 4;
}
function isChromium86OrNewer() {
  var e = window;
  return countTruthy([
    !("MediaSettingsRange" in e),
    "RTCEncodedAudioFrame" in e,
    "" + e.Intl == "[object Intl]",
    "" + e.Reflect == "[object Reflect]"
  ]) >= 3;
}
function isWebKit606OrNewer() {
  var e = window;
  return countTruthy([
    "DOMRectList" in e,
    "RTCPeerConnectionIceEvent" in e,
    "SVGGeometryElement" in e,
    "ontransitioncancel" in e
  ]) >= 3;
}
function isIPad() {
  if (navigator.platform === "iPad")
    return !0;
  var e = screen, T = e.width / e.height;
  return countTruthy([
    "MediaSource" in window,
    !!Element.prototype.webkitRequestFullscreen,
    T > 0.65 && T < 1.53
  ]) >= 2;
}
function getFullscreenElement() {
  var e = document;
  return e.fullscreenElement || e.msFullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement || null;
}
function exitFullscreen() {
  var e = document;
  return (e.exitFullscreen || e.msExitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen).call(e);
}
function isAndroid() {
  var e = isChromium(), T = isGecko();
  if (!e && !T)
    return !1;
  var F = window;
  return countTruthy([
    "onorientationchange" in F,
    "orientation" in F,
    e && !("SharedWorker" in F),
    T && /android/i.test(navigator.appVersion)
  ]) >= 2;
}
function getAudioFingerprint() {
  var e = window, T = e.OfflineAudioContext || e.webkitOfflineAudioContext;
  if (!T)
    return -2;
  if (doesCurrentBrowserSuspendAudioContext())
    return -1;
  var F = 4500, $ = 5e3, J = new T(1, $, 44100), ee = J.createOscillator();
  ee.type = "triangle", ee.frequency.value = 1e4;
  var ne = J.createDynamicsCompressor();
  ne.threshold.value = -50, ne.knee.value = 40, ne.ratio.value = 12, ne.attack.value = 0, ne.release.value = 0.25, ee.connect(ne), ne.connect(J.destination), ee.start(0);
  var oe = startRenderingAudio(J), se = oe[0], le = oe[1], de = se.then(function(ce) {
    return getHash(ce.getChannelData(0).subarray(F));
  }, function(ce) {
    if (ce.name === "timeout" || ce.name === "suspended")
      return -3;
    throw ce;
  });
  return suppressUnhandledRejectionWarning(de), function() {
    return le(), de;
  };
}
function doesCurrentBrowserSuspendAudioContext() {
  return isWebKit() && !isDesktopSafari() && !isWebKit606OrNewer();
}
function startRenderingAudio(e) {
  var T = 3, F = 500, $ = 500, J = 5e3, ee = function() {
  }, ne = new Promise(function(oe, se) {
    var le = !1, de = 0, ce = 0;
    e.oncomplete = function(ge) {
      return oe(ge.renderedBuffer);
    };
    var he = function() {
      setTimeout(function() {
        return se(makeInnerError("timeout"));
      }, Math.min($, ce + J - Date.now()));
    }, ve = function() {
      try {
        var ge = e.startRendering();
        switch (isPromise(ge) && suppressUnhandledRejectionWarning(ge), e.state) {
          case "running":
            ce = Date.now(), le && he();
            break;
          case "suspended":
            document.hidden || de++, le && de >= T ? se(makeInnerError("suspended")) : setTimeout(ve, F);
            break;
        }
      } catch (be) {
        se(be);
      }
    };
    ve(), ee = function() {
      le || (le = !0, ce > 0 && he());
    };
  });
  return [ne, ee];
}
function getHash(e) {
  for (var T = 0, F = 0; F < e.length; ++F)
    T += Math.abs(e[F]);
  return T;
}
function makeInnerError(e) {
  var T = new Error(e);
  return T.name = e, T;
}
function withIframe(e, T, F) {
  var $, J, ee;
  return F === void 0 && (F = 50), __awaiter(this, void 0, void 0, function() {
    var ne, oe;
    return __generator(this, function(se) {
      switch (se.label) {
        case 0:
          ne = document, se.label = 1;
        case 1:
          return ne.body ? [3, 3] : [4, wait(F)];
        case 2:
          return se.sent(), [3, 1];
        case 3:
          oe = ne.createElement("iframe"), se.label = 4;
        case 4:
          return se.trys.push([4, , 10, 11]), [4, new Promise(function(le, de) {
            var ce = !1, he = function() {
              ce = !0, le();
            }, ve = function(Te) {
              ce = !0, de(Te);
            };
            oe.onload = he, oe.onerror = ve;
            var ge = oe.style;
            ge.setProperty("display", "block", "important"), ge.position = "absolute", ge.top = "0", ge.left = "0", ge.visibility = "hidden", T && "srcdoc" in oe ? oe.srcdoc = T : oe.src = "about:blank", ne.body.appendChild(oe);
            var be = function() {
              var Te, Se;
              ce || (((Se = (Te = oe.contentWindow) === null || Te === void 0 ? void 0 : Te.document) === null || Se === void 0 ? void 0 : Se.readyState) === "complete" ? he() : setTimeout(be, 10));
            };
            be();
          })];
        case 5:
          se.sent(), se.label = 6;
        case 6:
          return !((J = ($ = oe.contentWindow) === null || $ === void 0 ? void 0 : $.document) === null || J === void 0) && J.body ? [3, 8] : [4, wait(F)];
        case 7:
          return se.sent(), [3, 6];
        case 8:
          return [4, e(oe, oe.contentWindow)];
        case 9:
          return [2, se.sent()];
        case 10:
          return (ee = oe.parentNode) === null || ee === void 0 || ee.removeChild(oe), [7];
        case 11:
          return [2];
      }
    });
  });
}
function selectorToElement(e) {
  for (var T = parseSimpleCssSelector(e), F = T[0], $ = T[1], J = document.createElement(F != null ? F : "div"), ee = 0, ne = Object.keys($); ee < ne.length; ee++) {
    var oe = ne[ee], se = $[oe].join(" ");
    oe === "style" ? addStyleString(J.style, se) : J.setAttribute(oe, se);
  }
  return J;
}
function addStyleString(e, T) {
  for (var F = 0, $ = T.split(";"); F < $.length; F++) {
    var J = $[F], ee = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(J);
    if (ee) {
      var ne = ee[1], oe = ee[2], se = ee[4];
      e.setProperty(ne, oe, se || "");
    }
  }
}
var testString = "mmMwWLliI0O&1", textSize = "48px", baseFonts = ["monospace", "sans-serif", "serif"], fontList = [
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function getFonts() {
  return withIframe(function(e, T) {
    var F = T.document, $ = F.body;
    $.style.fontSize = textSize;
    var J = F.createElement("div"), ee = {}, ne = {}, oe = function(be) {
      var Te = F.createElement("span"), Se = Te.style;
      return Se.position = "absolute", Se.top = "0", Se.left = "0", Se.fontFamily = be, Te.textContent = testString, J.appendChild(Te), Te;
    }, se = function(be, Te) {
      return oe("'".concat(be, "',").concat(Te));
    }, le = function() {
      return baseFonts.map(oe);
    }, de = function() {
      for (var be = {}, Te = function(Le) {
        be[Le] = baseFonts.map(function(Ne) {
          return se(Le, Ne);
        });
      }, Se = 0, Ie = fontList; Se < Ie.length; Se++) {
        var Oe = Ie[Se];
        Te(Oe);
      }
      return be;
    }, ce = function(be) {
      return baseFonts.some(function(Te, Se) {
        return be[Se].offsetWidth !== ee[Te] || be[Se].offsetHeight !== ne[Te];
      });
    }, he = le(), ve = de();
    $.appendChild(J);
    for (var ge = 0; ge < baseFonts.length; ge++)
      ee[baseFonts[ge]] = he[ge].offsetWidth, ne[baseFonts[ge]] = he[ge].offsetHeight;
    return fontList.filter(function(be) {
      return ce(ve[be]);
    });
  });
}
function getPlugins() {
  var e = navigator.plugins;
  if (!!e) {
    for (var T = [], F = 0; F < e.length; ++F) {
      var $ = e[F];
      if (!!$) {
        for (var J = [], ee = 0; ee < $.length; ++ee) {
          var ne = $[ee];
          J.push({
            type: ne.type,
            suffixes: ne.suffixes
          });
        }
        T.push({
          name: $.name,
          description: $.description,
          mimeTypes: J
        });
      }
    }
    return T;
  }
}
function getCanvasFingerprint() {
  var e = !1, T, F, $ = makeCanvasContext(), J = $[0], ee = $[1];
  if (!isSupported(J, ee))
    T = F = "";
  else {
    e = doesSupportWinding(ee), renderTextImage(J, ee);
    var ne = canvasToString(J), oe = canvasToString(J);
    ne !== oe ? T = F = "unstable" : (F = ne, renderGeometryImage(J, ee), T = canvasToString(J));
  }
  return { winding: e, geometry: T, text: F };
}
function makeCanvasContext() {
  var e = document.createElement("canvas");
  return e.width = 1, e.height = 1, [e, e.getContext("2d")];
}
function isSupported(e, T) {
  return !!(T && e.toDataURL);
}
function doesSupportWinding(e) {
  return e.rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), !e.isPointInPath(5, 5, "evenodd");
}
function renderTextImage(e, T) {
  e.width = 240, e.height = 60, T.textBaseline = "alphabetic", T.fillStyle = "#f60", T.fillRect(100, 1, 62, 20), T.fillStyle = "#069", T.font = '11pt "Times New Roman"';
  var F = "Cwm fjordbank gly ".concat(String.fromCharCode(55357, 56835));
  T.fillText(F, 2, 15), T.fillStyle = "rgba(102, 204, 0, 0.2)", T.font = "18pt Arial", T.fillText(F, 4, 45);
}
function renderGeometryImage(e, T) {
  e.width = 122, e.height = 110, T.globalCompositeOperation = "multiply";
  for (var F = 0, $ = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; F < $.length; F++) {
    var J = $[F], ee = J[0], ne = J[1], oe = J[2];
    T.fillStyle = ee, T.beginPath(), T.arc(ne, oe, 40, 0, Math.PI * 2, !0), T.closePath(), T.fill();
  }
  T.fillStyle = "#f9c", T.arc(60, 60, 60, 0, Math.PI * 2, !0), T.arc(60, 60, 20, 0, Math.PI * 2, !0), T.fill("evenodd");
}
function canvasToString(e) {
  return e.toDataURL();
}
function getTouchSupport() {
  var e = navigator, T = 0, F;
  e.maxTouchPoints !== void 0 ? T = toInt(e.maxTouchPoints) : e.msMaxTouchPoints !== void 0 && (T = e.msMaxTouchPoints);
  try {
    document.createEvent("TouchEvent"), F = !0;
  } catch (J) {
    F = !1;
  }
  var $ = "ontouchstart" in window;
  return {
    maxTouchPoints: T,
    touchEvent: F,
    touchStart: $
  };
}
function getOsCpu() {
  return navigator.oscpu;
}
function getLanguages() {
  var e = navigator, T = [], F = e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
  if (F !== void 0 && T.push([F]), Array.isArray(e.languages))
    isChromium() && isChromium86OrNewer() || T.push(e.languages);
  else if (typeof e.languages == "string") {
    var $ = e.languages;
    $ && T.push($.split(","));
  }
  return T;
}
function getColorDepth() {
  return window.screen.colorDepth;
}
function getDeviceMemory() {
  return replaceNaN(toFloat(navigator.deviceMemory), void 0);
}
function getScreenResolution() {
  var e = screen, T = function($) {
    return replaceNaN(toInt($), null);
  }, F = [T(e.width), T(e.height)];
  return F.sort().reverse(), F;
}
var screenFrameCheckInterval = 2500, roundingPrecision = 10, screenFrameBackup, screenFrameSizeTimeoutId;
function watchScreenFrame() {
  if (screenFrameSizeTimeoutId === void 0) {
    var e = function() {
      var T = getCurrentScreenFrame();
      isFrameSizeNull(T) ? screenFrameSizeTimeoutId = setTimeout(e, screenFrameCheckInterval) : (screenFrameBackup = T, screenFrameSizeTimeoutId = void 0);
    };
    e();
  }
}
function getScreenFrame() {
  var e = this;
  return watchScreenFrame(), function() {
    return __awaiter(e, void 0, void 0, function() {
      var T;
      return __generator(this, function(F) {
        switch (F.label) {
          case 0:
            return T = getCurrentScreenFrame(), isFrameSizeNull(T) ? screenFrameBackup ? [2, __spreadArray([], screenFrameBackup, !0)] : getFullscreenElement() ? [4, exitFullscreen()] : [3, 2] : [3, 2];
          case 1:
            F.sent(), T = getCurrentScreenFrame(), F.label = 2;
          case 2:
            return isFrameSizeNull(T) || (screenFrameBackup = T), [2, T];
        }
      });
    });
  };
}
function getRoundedScreenFrame() {
  var e = this, T = getScreenFrame();
  return function() {
    return __awaiter(e, void 0, void 0, function() {
      var F, $;
      return __generator(this, function(J) {
        switch (J.label) {
          case 0:
            return [4, T()];
          case 1:
            return F = J.sent(), $ = function(ee) {
              return ee === null ? null : round(ee, roundingPrecision);
            }, [2, [$(F[0]), $(F[1]), $(F[2]), $(F[3])]];
        }
      });
    });
  };
}
function getCurrentScreenFrame() {
  var e = screen;
  return [
    replaceNaN(toFloat(e.availTop), null),
    replaceNaN(toFloat(e.width) - toFloat(e.availWidth) - replaceNaN(toFloat(e.availLeft), 0), null),
    replaceNaN(toFloat(e.height) - toFloat(e.availHeight) - replaceNaN(toFloat(e.availTop), 0), null),
    replaceNaN(toFloat(e.availLeft), null)
  ];
}
function isFrameSizeNull(e) {
  for (var T = 0; T < 4; ++T)
    if (e[T])
      return !1;
  return !0;
}
function getHardwareConcurrency() {
  return replaceNaN(toInt(navigator.hardwareConcurrency), void 0);
}
function getTimezone() {
  var e, T = (e = window.Intl) === null || e === void 0 ? void 0 : e.DateTimeFormat;
  if (T) {
    var F = new T().resolvedOptions().timeZone;
    if (F)
      return F;
  }
  var $ = -getTimezoneOffset();
  return "UTC".concat($ >= 0 ? "+" : "").concat(Math.abs($));
}
function getTimezoneOffset() {
  var e = new Date().getFullYear();
  return Math.max(
    toFloat(new Date(e, 0, 1).getTimezoneOffset()),
    toFloat(new Date(e, 6, 1).getTimezoneOffset())
  );
}
function getSessionStorage() {
  try {
    return !!window.sessionStorage;
  } catch (e) {
    return !0;
  }
}
function getLocalStorage() {
  try {
    return !!window.localStorage;
  } catch (e) {
    return !0;
  }
}
function getIndexedDB() {
  if (!(isTrident() || isEdgeHTML()))
    try {
      return !!window.indexedDB;
    } catch (e) {
      return !0;
    }
}
function getOpenDatabase() {
  return !!window.openDatabase;
}
function getCpuClass() {
  return navigator.cpuClass;
}
function getPlatform() {
  var e = navigator.platform;
  return e === "MacIntel" && isWebKit() && !isDesktopSafari() ? isIPad() ? "iPad" : "iPhone" : e;
}
function getVendor() {
  return navigator.vendor || "";
}
function getVendorFlavors() {
  for (var e = [], T = 0, F = [
    "chrome",
    "safari",
    "__crWeb",
    "__gCrWeb",
    "yandex",
    "__yb",
    "__ybro",
    "__firefox__",
    "__edgeTrackingPreventionStatistics",
    "webkit",
    "oprt",
    "samsungAr",
    "ucweb",
    "UCShellJava",
    "puffinDevice"
  ]; T < F.length; T++) {
    var $ = F[T], J = window[$];
    J && typeof J == "object" && e.push($);
  }
  return e.sort();
}
function areCookiesEnabled() {
  var e = document;
  try {
    e.cookie = "cookietest=1; SameSite=Strict;";
    var T = e.cookie.indexOf("cookietest=") !== -1;
    return e.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", T;
  } catch (F) {
    return !1;
  }
}
function getFilters() {
  var e = atob;
  return {
    abpIndo: [
      "#Iklan-Melayang",
      "#Kolom-Iklan-728",
      "#SidebarIklan-wrapper",
      '[title="ALIENBOLA" i]',
      e("I0JveC1CYW5uZXItYWRz")
    ],
    abpvn: [".quangcao", "#mobileCatfish", e("LmNsb3NlLWFkcw=="), '[id^="bn_bottom_fixed_"]', "#pmadv"],
    adBlockFinland: [
      ".mainostila",
      e("LnNwb25zb3JpdA=="),
      ".ylamainos",
      e("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
    ],
    adBlockPersian: [
      "#navbar_notice_50",
      ".kadr",
      'TABLE[width="140px"]',
      "#divAgahi",
      e("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
    ],
    adBlockWarningRemoval: [
      "#adblock-honeypot",
      ".adblocker-root",
      ".wp_adblock_detect",
      e("LmhlYWRlci1ibG9ja2VkLWFk"),
      e("I2FkX2Jsb2NrZXI=")
    ],
    adGuardAnnoyances: [
      ".hs-sosyal",
      "#cookieconsentdiv",
      'div[class^="app_gdpr"]',
      ".as-oil",
      '[data-cypress="soft-push-notification-modal"]'
    ],
    adGuardBase: [
      ".BetterJsPopOverlay",
      e("I2FkXzMwMFgyNTA="),
      e("I2Jhbm5lcmZsb2F0MjI="),
      e("I2NhbXBhaWduLWJhbm5lcg=="),
      e("I0FkLUNvbnRlbnQ=")
    ],
    adGuardChinese: [
      e("LlppX2FkX2FfSA=="),
      e("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
      "#widget-quan",
      e("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
      e("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
    ],
    adGuardFrench: [
      "#pavePub",
      e("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
      ".mobile_adhesion",
      ".widgetadv",
      e("LmFkc19iYW4=")
    ],
    adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
    adGuardJapanese: [
      "#kauli_yad_1",
      e("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
      e("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
      e("LmFkZ29vZ2xl"),
      e("Ll9faXNib29zdFJldHVybkFk")
    ],
    adGuardMobile: [
      e("YW1wLWF1dG8tYWRz"),
      e("LmFtcF9hZA=="),
      'amp-embed[type="24smi"]',
      "#mgid_iframe1",
      e("I2FkX2ludmlld19hcmVh")
    ],
    adGuardRussian: [
      e("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
      e("LnJlY2xhbWE="),
      'div[id^="smi2adblock"]',
      e("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
      "#psyduckpockeball"
    ],
    adGuardSocial: [
      e("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
      e("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
      ".etsy-tweet",
      "#inlineShare",
      ".popup-social"
    ],
    adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", ".cnt-publi"],
    adGuardTrackingProtection: [
      "#qoo-counter",
      e("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
      e("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
      "#top100counter"
    ],
    adGuardTurkish: [
      "#backkapat",
      e("I3Jla2xhbWk="),
      e("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
      e("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
      e("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
    ],
    bulgarian: [e("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
    easyList: [
      ".yb-floorad",
      e("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
      e("LnRyYWZmaWNqdW5reS1hZA=="),
      ".textad_headline",
      e("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
    ],
    easyListChina: [
      e("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
      e("LmZyb250cGFnZUFkdk0="),
      "#taotaole",
      "#aafoot.top_box",
      ".cfa_popup"
    ],
    easyListCookie: [
      ".ezmob-footer",
      ".cc-CookieWarning",
      "[data-cookie-number]",
      e("LmF3LWNvb2tpZS1iYW5uZXI="),
      ".sygnal24-gdpr-modal-wrap"
    ],
    easyListCzechSlovak: [
      "#onlajny-stickers",
      e("I3Jla2xhbW5pLWJveA=="),
      e("LnJla2xhbWEtbWVnYWJvYXJk"),
      ".sklik",
      e("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
    ],
    easyListDutch: [
      e("I2FkdmVydGVudGll"),
      e("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
      ".adstekst",
      e("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
      "#semilo-lrectangle"
    ],
    easyListGermany: [
      "#SSpotIMPopSlider",
      e("LnNwb25zb3JsaW5rZ3J1ZW4="),
      e("I3dlcmJ1bmdza3k="),
      e("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
      e("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
    ],
    easyListItaly: [
      e("LmJveF9hZHZfYW5udW5jaQ=="),
      ".sb-box-pubbliredazionale",
      e("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
    ],
    easyListLithuania: [
      e("LnJla2xhbW9zX3RhcnBhcw=="),
      e("LnJla2xhbW9zX251b3JvZG9z"),
      e("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
      e("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
      e("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
    ],
    estonian: [e("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
    fanboyAnnoyances: ["#ac-lre-player", ".navigate-to-top", "#subscribe_popup", ".newsletter_holder", "#back-top"],
    fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
    fanboyEnhancedTrackers: [
      ".open.pushModal",
      "#issuem-leaky-paywall-articles-zero-remaining-nag",
      "#sovrn_container",
      'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
      ".BlockNag__Card"
    ],
    fanboySocial: ["#FollowUs", "#meteored_share", "#social_follow", ".article-sharer", ".community__social-desc"],
    frellwitSwedish: [
      e("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
      e("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
      "article.category-samarbete",
      e("ZGl2LmhvbGlkQWRz"),
      "ul.adsmodern"
    ],
    greekAdBlock: [
      e("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
      e("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
      e("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
      "DIV.agores300",
      "TABLE.advright"
    ],
    hungarian: [
      "#cemp_doboz",
      ".optimonk-iframe-container",
      e("LmFkX19tYWlu"),
      e("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
      "#hirdetesek_box"
    ],
    iDontCareAboutCookies: [
      '.alert-info[data-block-track*="CookieNotice"]',
      ".ModuleTemplateCookieIndicator",
      ".o--cookies--container",
      "#cookies-policy-sticky",
      "#stickyCookieBar"
    ],
    icelandicAbp: [e("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
    latvian: [
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
    ],
    listKr: [
      e("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
      e("I2xpdmVyZUFkV3JhcHBlcg=="),
      e("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
      e("aW5zLmZhc3R2aWV3LWFk"),
      ".revenue_unit_item.dable"
    ],
    listeAr: [
      e("LmdlbWluaUxCMUFk"),
      ".right-and-left-sponsers",
      e("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
      e("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
      e("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
    ],
    listeFr: [
      e("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
      e("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
      e("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
      ".site-pub-interstitiel",
      'div[id^="crt-"][data-criteo-id]'
    ],
    officialPolish: [
      "#ceneo-placeholder-ceneo-12",
      e("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
      e("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
      e("ZGl2I3NrYXBpZWNfYWQ=")
    ],
    ro: [
      e("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
      e("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
      'a[href^="/url/"]'
    ],
    ruAd: [
      e("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
      e("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
      e("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
      "#pgeldiz",
      ".yandex-rtb-block"
    ],
    thaiAds: [
      "a[href*=macau-uta-popup]",
      e("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
      e("LmFkczMwMHM="),
      ".bumq",
      ".img-kosana"
    ],
    webAnnoyancesUltralist: [
      "#mod-social-share-2",
      "#social-tools",
      e("LmN0cGwtZnVsbGJhbm5lcg=="),
      ".zergnet-recommend",
      ".yt.btn-link.btn-md.btn"
    ]
  };
}
function getDomBlockers(e) {
  var T = e === void 0 ? {} : e, F = T.debug;
  return __awaiter(this, void 0, void 0, function() {
    var $, J, ee, ne, oe, se;
    return __generator(this, function(le) {
      switch (le.label) {
        case 0:
          return isApplicable() ? ($ = getFilters(), J = Object.keys($), ee = (se = []).concat.apply(se, J.map(function(de) {
            return $[de];
          })), [4, getBlockedSelectors(ee)]) : [2, void 0];
        case 1:
          return ne = le.sent(), F && printDebug($, ne), oe = J.filter(function(de) {
            var ce = $[de], he = countTruthy(ce.map(function(ve) {
              return ne[ve];
            }));
            return he > ce.length * 0.6;
          }), oe.sort(), [2, oe];
      }
    });
  });
}
function isApplicable() {
  return isWebKit() || isAndroid();
}
function getBlockedSelectors(e) {
  var T;
  return __awaiter(this, void 0, void 0, function() {
    var F, $, J, ee, se, ne, oe, se;
    return __generator(this, function(le) {
      switch (le.label) {
        case 0:
          for (F = document, $ = F.createElement("div"), J = new Array(e.length), ee = {}, forceShow($), se = 0; se < e.length; ++se)
            ne = selectorToElement(e[se]), ne.tagName === "DIALOG" && ne.show(), oe = F.createElement("div"), forceShow(oe), oe.appendChild(ne), $.appendChild(oe), J[se] = ne;
          le.label = 1;
        case 1:
          return F.body ? [3, 3] : [4, wait(50)];
        case 2:
          return le.sent(), [3, 1];
        case 3:
          F.body.appendChild($);
          try {
            for (se = 0; se < e.length; ++se)
              J[se].offsetParent || (ee[e[se]] = !0);
          } finally {
            (T = $.parentNode) === null || T === void 0 || T.removeChild($);
          }
          return [2, ee];
      }
    });
  });
}
function forceShow(e) {
  e.style.setProperty("display", "block", "important");
}
function printDebug(e, T) {
  for (var F = "DOM blockers debug:\n```", $ = 0, J = Object.keys(e); $ < J.length; $++) {
    var ee = J[$];
    F += `
`.concat(ee, ":");
    for (var ne = 0, oe = e[ee]; ne < oe.length; ne++) {
      var se = oe[ne];
      F += `
  `.concat(T[se] ? "\u{1F6AB}" : "\u27A1\uFE0F", " ").concat(se);
    }
  }
  console.log("".concat(F, "\n```"));
}
function getColorGamut() {
  for (var e = 0, T = ["rec2020", "p3", "srgb"]; e < T.length; e++) {
    var F = T[e];
    if (matchMedia("(color-gamut: ".concat(F, ")")).matches)
      return F;
  }
}
function areColorsInverted() {
  if (doesMatch$4("inverted"))
    return !0;
  if (doesMatch$4("none"))
    return !1;
}
function doesMatch$4(e) {
  return matchMedia("(inverted-colors: ".concat(e, ")")).matches;
}
function areColorsForced() {
  if (doesMatch$3("active"))
    return !0;
  if (doesMatch$3("none"))
    return !1;
}
function doesMatch$3(e) {
  return matchMedia("(forced-colors: ".concat(e, ")")).matches;
}
var maxValueToCheck = 100;
function getMonochromeDepth() {
  if (!!matchMedia("(min-monochrome: 0)").matches) {
    for (var e = 0; e <= maxValueToCheck; ++e)
      if (matchMedia("(max-monochrome: ".concat(e, ")")).matches)
        return e;
    throw new Error("Too high value");
  }
}
function getContrastPreference() {
  if (doesMatch$2("no-preference"))
    return 0;
  if (doesMatch$2("high") || doesMatch$2("more"))
    return 1;
  if (doesMatch$2("low") || doesMatch$2("less"))
    return -1;
  if (doesMatch$2("forced"))
    return 10;
}
function doesMatch$2(e) {
  return matchMedia("(prefers-contrast: ".concat(e, ")")).matches;
}
function isMotionReduced() {
  if (doesMatch$1("reduce"))
    return !0;
  if (doesMatch$1("no-preference"))
    return !1;
}
function doesMatch$1(e) {
  return matchMedia("(prefers-reduced-motion: ".concat(e, ")")).matches;
}
function isHDR() {
  if (doesMatch("high"))
    return !0;
  if (doesMatch("standard"))
    return !1;
}
function doesMatch(e) {
  return matchMedia("(dynamic-range: ".concat(e, ")")).matches;
}
var M = Math, fallbackFn = function() {
  return 0;
};
function getMathFingerprint() {
  var e = M.acos || fallbackFn, T = M.acosh || fallbackFn, F = M.asin || fallbackFn, $ = M.asinh || fallbackFn, J = M.atanh || fallbackFn, ee = M.atan || fallbackFn, ne = M.sin || fallbackFn, oe = M.sinh || fallbackFn, se = M.cos || fallbackFn, le = M.cosh || fallbackFn, de = M.tan || fallbackFn, ce = M.tanh || fallbackFn, he = M.exp || fallbackFn, ve = M.expm1 || fallbackFn, ge = M.log1p || fallbackFn, be = function(we) {
    return M.pow(M.PI, we);
  }, Te = function(we) {
    return M.log(we + M.sqrt(we * we - 1));
  }, Se = function(we) {
    return M.log(we + M.sqrt(we * we + 1));
  }, Ie = function(we) {
    return M.log((1 + we) / (1 - we)) / 2;
  }, Oe = function(we) {
    return M.exp(we) - 1 / M.exp(we) / 2;
  }, Le = function(we) {
    return (M.exp(we) + 1 / M.exp(we)) / 2;
  }, Ne = function(we) {
    return M.exp(we) - 1;
  }, Ue = function(we) {
    return (M.exp(2 * we) - 1) / (M.exp(2 * we) + 1);
  }, je = function(we) {
    return M.log(1 + we);
  };
  return {
    acos: e(0.12312423423423424),
    acosh: T(1e308),
    acoshPf: Te(1e154),
    asin: F(0.12312423423423424),
    asinh: $(1),
    asinhPf: Se(1),
    atanh: J(0.5),
    atanhPf: Ie(0.5),
    atan: ee(0.5),
    sin: ne(-1e300),
    sinh: oe(1),
    sinhPf: Oe(1),
    cos: se(10.000000000123),
    cosh: le(1),
    coshPf: Le(1),
    tan: de(-1e300),
    tanh: ce(1),
    tanhPf: Ue(1),
    exp: he(1),
    expm1: ve(1),
    expm1Pf: Ne(1),
    log1p: ge(10),
    log1pPf: je(10),
    powPI: be(-100)
  };
}
var defaultText = "mmMwWLliI0fiflO&1", presets = {
  default: [],
  apple: [{ font: "-apple-system-body" }],
  serif: [{ fontFamily: "serif" }],
  sans: [{ fontFamily: "sans-serif" }],
  mono: [{ fontFamily: "monospace" }],
  min: [{ fontSize: "1px" }],
  system: [{ fontFamily: "system-ui" }]
};
function getFontPreferences() {
  return withNaturalFonts(function(e, T) {
    for (var F = {}, $ = {}, J = 0, ee = Object.keys(presets); J < ee.length; J++) {
      var ne = ee[J], oe = presets[ne], se = oe[0], le = se === void 0 ? {} : se, de = oe[1], ce = de === void 0 ? defaultText : de, he = e.createElement("span");
      he.textContent = ce, he.style.whiteSpace = "nowrap";
      for (var ve = 0, ge = Object.keys(le); ve < ge.length; ve++) {
        var be = ge[ve], Te = le[be];
        Te !== void 0 && (he.style[be] = Te);
      }
      F[ne] = he, T.appendChild(e.createElement("br")), T.appendChild(he);
    }
    for (var Se = 0, Ie = Object.keys(presets); Se < Ie.length; Se++) {
      var ne = Ie[Se];
      $[ne] = F[ne].getBoundingClientRect().width;
    }
    return $;
  });
}
function withNaturalFonts(e, T) {
  return T === void 0 && (T = 4e3), withIframe(function(F, $) {
    var J = $.document, ee = J.body, ne = ee.style;
    ne.width = "".concat(T, "px"), ne.webkitTextSizeAdjust = ne.textSizeAdjust = "none", isChromium() ? ee.style.zoom = "".concat(1 / $.devicePixelRatio) : isWebKit() && (ee.style.zoom = "reset");
    var oe = J.createElement("div");
    return oe.textContent = __spreadArray([], Array(T / 20 << 0), !0).map(function() {
      return "word";
    }).join(" "), ee.appendChild(oe), e(J, ee);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function getVideoCard() {
  var e, T = document.createElement("canvas"), F = (e = T.getContext("webgl")) !== null && e !== void 0 ? e : T.getContext("experimental-webgl");
  if (F && "getExtension" in F) {
    var $ = F.getExtension("WEBGL_debug_renderer_info");
    if ($)
      return {
        vendor: (F.getParameter($.UNMASKED_VENDOR_WEBGL) || "").toString(),
        renderer: (F.getParameter($.UNMASKED_RENDERER_WEBGL) || "").toString()
      };
  }
}
function isPdfViewerEnabled() {
  return navigator.pdfViewerEnabled;
}
function getArchitecture() {
  var e = new Float32Array(1), T = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], T[3];
}
var sources = {
  fonts: getFonts,
  domBlockers: getDomBlockers,
  fontPreferences: getFontPreferences,
  audio: getAudioFingerprint,
  screenFrame: getRoundedScreenFrame,
  osCpu: getOsCpu,
  languages: getLanguages,
  colorDepth: getColorDepth,
  deviceMemory: getDeviceMemory,
  screenResolution: getScreenResolution,
  hardwareConcurrency: getHardwareConcurrency,
  timezone: getTimezone,
  sessionStorage: getSessionStorage,
  localStorage: getLocalStorage,
  indexedDB: getIndexedDB,
  openDatabase: getOpenDatabase,
  cpuClass: getCpuClass,
  platform: getPlatform,
  plugins: getPlugins,
  canvas: getCanvasFingerprint,
  touchSupport: getTouchSupport,
  vendor: getVendor,
  vendorFlavors: getVendorFlavors,
  cookiesEnabled: areCookiesEnabled,
  colorGamut: getColorGamut,
  invertedColors: areColorsInverted,
  forcedColors: areColorsForced,
  monochrome: getMonochromeDepth,
  contrast: getContrastPreference,
  reducedMotion: isMotionReduced,
  hdr: isHDR,
  math: getMathFingerprint,
  videoCard: getVideoCard,
  pdfViewerEnabled: isPdfViewerEnabled,
  architecture: getArchitecture
};
function loadBuiltinSources(e) {
  return loadSources(sources, e, []);
}
var commentTemplate = "$ if upgrade to Pro: https://fpjs.dev/pro";
function getConfidence(e) {
  var T = getOpenConfidenceScore(e), F = deriveProConfidenceScore(T);
  return { score: T, comment: commentTemplate.replace(/\$/g, "".concat(F)) };
}
function getOpenConfidenceScore(e) {
  if (isAndroid())
    return 0.4;
  if (isWebKit())
    return isDesktopSafari() ? 0.5 : 0.3;
  var T = e.platform.value || "";
  return /^Win/.test(T) ? 0.6 : /^Mac/.test(T) ? 0.5 : 0.7;
}
function deriveProConfidenceScore(e) {
  return round(0.99 + 0.01 * e, 1e-4);
}
function componentsToCanonicalString(e) {
  for (var T = "", F = 0, $ = Object.keys(e).sort(); F < $.length; F++) {
    var J = $[F], ee = e[J], ne = ee.error ? "error" : JSON.stringify(ee.value);
    T += "".concat(T ? "|" : "").concat(J.replace(/([:|\\])/g, "\\$1"), ":").concat(ne);
  }
  return T;
}
function componentsToDebugString(e) {
  return JSON.stringify(e, function(T, F) {
    return F instanceof Error ? errorToObject(F) : F;
  }, 2);
}
function hashComponents(e) {
  return x64hash128(componentsToCanonicalString(e));
}
function makeLazyGetResult(e) {
  var T, F = getConfidence(e);
  return {
    get visitorId() {
      return T === void 0 && (T = hashComponents(this.components)), T;
    },
    set visitorId($) {
      T = $;
    },
    confidence: F,
    components: e,
    version
  };
}
function prepareForSources(e) {
  return e === void 0 && (e = 50), requestIdleCallbackIfAvailable(e, e * 2);
}
function makeAgent(e, T) {
  var F = Date.now();
  return {
    get: function($) {
      return __awaiter(this, void 0, void 0, function() {
        var J, ee, ne;
        return __generator(this, function(oe) {
          switch (oe.label) {
            case 0:
              return J = Date.now(), [4, e()];
            case 1:
              return ee = oe.sent(), ne = makeLazyGetResult(ee), (T || ($ == null ? void 0 : $.debug)) && console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(ne.version, `
userAgent: `).concat(navigator.userAgent, `
timeBetweenLoadAndGet: `).concat(J - F, `
visitorId: `).concat(ne.visitorId, `
components: `).concat(componentsToDebugString(ee), "\n```")), [2, ne];
          }
        });
      });
    }
  };
}
function monitor() {
  if (!(window.__fpjs_d_m || Math.random() >= 1e-3))
    try {
      var e = new XMLHttpRequest();
      e.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat(version, "/npm-monitoring"), !0), e.send();
    } catch (T) {
      console.error(T);
    }
}
function load(e) {
  var T = e === void 0 ? {} : e, F = T.delayFallback, $ = T.debug, J = T.monitoring, ee = J === void 0 ? !0 : J;
  return __awaiter(this, void 0, void 0, function() {
    var ne;
    return __generator(this, function(oe) {
      switch (oe.label) {
        case 0:
          return ee && monitor(), [4, prepareForSources(F)];
        case 1:
          return oe.sent(), ne = loadBuiltinSources({ debug: $ }), [2, makeAgent(ne, $)];
      }
    });
  });
}
var index = { load, hashComponents, componentsToDebugString };
function getFingerPrint() {
  return Me(this, null, function* () {
    var e;
    try {
      return (e = (yield (yield index.load()).get()).visitorId) != null ? e : "";
    } catch (T) {
      return "";
    }
  });
}
const isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|miniProgram)/i.test(window.navigator.userAgent);
var BoardStatus = /* @__PURE__ */ ((e) => (e[e.NO_START = 0] = "NO_START", e[e.PENDING = 1] = "PENDING", e[e.PUSH_START = 2] = "PUSH_START", e))(BoardStatus || {});
function httpGetBoardUrl(e, T) {
  return Me(this, null, function* () {
    return request$1.get(`/events/${e}/boards/board-play-addr`, {
      params: T
    });
  });
}
WatermarkType.TEXT + "", WatermarkType.IMAGE + "";
WatermarkPosition.TOP_LEFT + "", WatermarkPosition.TOP_RIGHT + "", WatermarkPosition.BOTTOM_LEFT + "", WatermarkPosition.BOTTOM_RIGHT + "";
const playbackRatesList = [{
  label: "0.5x",
  playbackRate: 0.5
}, {
  label: "0.75x",
  playbackRate: 0.75
}, {
  label: "1.0x",
  playbackRate: 1
}, {
  label: "1.25x",
  playbackRate: 1.25
}, {
  label: "1.5x",
  playbackRate: 1.5
}, {
  label: "2.0x",
  playbackRate: 2
}], PlayerLanguageTypeMap = {
  [LanguageTypeEnum.DEFAULT]: "en",
  [LanguageTypeEnum["zh-Hans"]]: "zh-CN",
  [LanguageTypeEnum["zh-Hant"]]: "zh-TW",
  [LanguageTypeEnum.en]: "en-US",
  [LanguageTypeEnum.ar]: "ar"
}, PlayerLocalizationMap = {
  [PlayerLanguageTypeMap[LanguageTypeEnum.ar]]: {
    Pause: "\u0648\u0642\u0641\u0629",
    Normal: "\u0627\u0644\u0639\u0627\u062F\u064A\u0629",
    Settings: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
    "Full screen": "\u0634\u0627\u0634\u0629 \u0643\u0627\u0645\u0644\u0629",
    "Exit full screen": "\u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u0648\u0636\u0639 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0643\u0627\u0645\u0644\u0629",
    "You can try": "\u064A\u0645\u0643\u0646\u0643 \u0623\u0646 \u062A\u062D\u0627\u0648\u0644",
    "Switch to Flash": "\u0642\u0645 \u0628\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 Flash Player",
    "Switch to HTML5": "\u0642\u0645 \u0628\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 HTML5 Player",
    Reload: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
    "Unknown Error": "\u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641 \u062E\u0637\u0623",
    "Network Error": "\u062E\u0637\u0623 \u0628\u0627\u0644\u0634\u0628\u0643\u0629",
    "Media Error": "\u062E\u0637\u0623 \u0641\u064A \u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0631\u0645\u064A\u0632",
    Mute: "\u0643\u062A\u0645 \u0627\u0644\u0635\u0648\u062A",
    Unmute: "\u0625\u0644\u063A\u0627\u0621 \u0643\u062A\u0645 \u0627\u0644\u0635\u0648\u062A",
    Quality: "\u062C\u0648\u062F\u0629 \u0627\u0644\u0641\u064A\u062F\u064A\u0648",
    Live: "\u0628\u062B \u0645\u0628\u0627\u0634\u0631",
    Autoplay: "\u062A\u0634\u063A\u064A\u0644 \u0622\u0644\u064A",
    Captions: "\u062A\u0633\u0645\u064A\u0627\u062A \u062A\u0648\u0636\u064A\u062D\u064A\u0629",
    "Copy debug info": "\u0627\u0646\u0633\u062E \u0633\u062C\u0644\u0627\u062A \u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0623\u062E\u0637\u0627\u0621",
    "Upload debug info": "\u062A\u0642\u062F\u064A\u0645 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0635\u062D\u064A\u062D",
    "Skip ahead to live broadcast": "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0628\u062B \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
    Line: "\u0627\u0644\u062E\u0627\u062F\u0645",
    Speed: "\u0627\u0644\u0633\u0631\u0639\u0629"
  }
};
function getLangRoomNameConfig() {
  const { watchLanguage: e, languages: T, watchOptionalLanguage: F } = roomModel.state, $ = [...F || []];
  $.includes(e) || $.push(e);
  const J = {};
  return $.forEach((ee) => {
    var ne;
    const oe = findFinalLangFun(ee, (le) => T == null ? void 0 : T.some((de) => de.languageType === le)), se = (ne = T == null ? void 0 : T.find((le) => le.languageType === oe)) == null ? void 0 : ne.roomName;
    J[PlayerLanguageTypeMap[ee]] = se != null ? se : "";
  }), J;
}
function setCurLangPlayerBg(e) {
  var T, F;
  const { watchLanguage: $ } = roomModel.state, J = e != null ? e : $, { detailData: ee } = playerModel.state, { playerBackgroundUrlLanguages: ne, screenOrientation: oe } = ee || {}, se = oe === ScreenOrientationEnum.PORTRAIT;
  let le = getDefaultCdnBgUrl(se ? DefaultBgEnum.portraitPlayerBgUrl : DefaultBgEnum.playerBgUrl);
  if (Array.isArray(ne) && ne.length) {
    const de = findFinalLangFun(J, (ce) => ne == null ? void 0 : ne.some((he) => he.languageType === ce));
    se ? le = ((T = ne == null ? void 0 : ne.find((ce) => ce.languageType === de)) == null ? void 0 : T.playerBackgroundPortraitUrl) || le : le = ((F = ne == null ? void 0 : ne.find((ce) => ce.languageType === de)) == null ? void 0 : F.playerBackgroundUrl) || le;
  }
  playerModel.setCurLangPlayerBgUrlState(le);
}
const PortraitAdapterModeMap = {
  [PortraitAdapterModeEnum.TILE]: "contain",
  [PortraitAdapterModeEnum.STRETCH]: "fill",
  [PortraitAdapterModeEnum.TAILOR]: "cover"
};
function streamStretchingMode() {
  const { detailData: e } = playerModel.state, { screenOrientation: T, portraitAdaptStyle: F } = e || {};
  return T === ScreenOrientationEnum.PORTRAIT ? PortraitAdapterModeMap[F != null ? F : PortraitAdapterModeEnum.TILE] : PortraitAdapterModeMap[PortraitAdapterModeEnum.TILE];
}
var __defProp$D = Object.defineProperty, __defNormalProp$D = (e, T, F) => T in e ? __defProp$D(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$D = (e, T, F) => (__defNormalProp$D(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$G = {};
class BoardSdkModel extends Model {
  constructor() {
    super(INITIAL_STATE$G), __publicField$D(this, "BOARD_STREAM_STATUS_CHANGED", "BOARD_STREAM_STATUS_CHANGED"), __publicField$D(this, "boardStreamStatus", () => this._getModelState(boardModel, "boardStreamStatus"));
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$G);
  }
  setFullscreen(T) {
    var F, $;
    ($ = (F = boardModel.state.initBoardPlayer) == null ? void 0 : F.setFullscreen) == null || $.call(F, T);
  }
}
const boardSdkModel = new BoardSdkModel();
var __defProp$C = Object.defineProperty, __defNormalProp$C = (e, T, F) => T in e ? __defProp$C(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$C = (e, T, F) => (__defNormalProp$C(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$F = {
  roomLayout: RoomLayout.VIDEO,
  boardUrl: "",
  errorBoardLock: !1,
  initBoardPlayer: "",
  boardStreamDetect: "",
  boardDomId: "",
  boardStreamStatus: !1
};
class BoardModel extends Model {
  constructor() {
    super(INITIAL_STATE$F), __publicField$C(this, "BOARD_STREAM_STATUS_CHANGED", "BOARD_STREAM_STATUS_CHANGED"), __publicField$C(this, "_queryBoardUrl", () => {
      const { roomId: T } = roomModel.state, { eventId: F } = eventModel.state, $ = roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY ? "udp" : "hls";
      httpGetBoardUrl(F, { roomId: T, protocol: $ }).then((J) => {
        var ee;
        const { boardsPlayUrl: ne } = ((ee = J == null ? void 0 : J.data) == null ? void 0 : ee.data) || {};
        this.setState({ boardUrl: ne }), ne ? this._restartDetect() : this._removePlayer();
      }).catch(() => {
      });
    }), __publicField$C(this, "_monitorBoardError", debounce_1(() => {
      const { initBoardPlayer: T } = this.state;
      T && T.getState && this._verifyStreamStatus("monitorBoardError");
    }, 2e3)), __publicField$C(this, "_updateBoardUrl", () => {
      const { roomId: T } = roomModel.state, { eventId: F } = eventModel.state, $ = roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY ? "udp" : "hls";
      httpGetBoardUrl(F, { roomId: T, protocol: $ }).then((J) => {
        var ee;
        const { initBoardPlayer: ne } = this.state, { boardsPlayUrl: oe } = ((ee = J == null ? void 0 : J.data) == null ? void 0 : ee.data) || {};
        if (this.setState({ boardUrl: oe }), oe)
          if (ne && ne.load) {
            const se = this._getBoardPlayList();
            ne.load([se]).then(() => {
              var le;
              (le = ne == null ? void 0 : ne.play) == null || le.call(ne);
            });
          } else
            this._createPlayer();
        else
          this._removePlayer();
      }).catch(() => {
        this._removePlayer();
      });
    }), __publicField$C(this, "_exitFullScreen", (T) => {
      const { initBoardPlayer: F } = this.state;
      F && F.getFullscreen && F.getFullscreen() && F.setFullscreen(!1), T && T();
    }), __publicField$C(this, "_verifyStreamStatus", (T) => {
      const { boardUrl: F } = this.state;
      if (F && roomModel.state.liveStatus === LiveStatus.LIVING) {
        if (roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY)
          return;
        ajax(F, {
          success: () => {
          },
          fail: ($) => {
            if (get_1($, "status") === 403) {
              this._updateBoardUrl();
              return;
            }
            this._removePlayer(T, !0);
          }
        });
      } else
        this._removePlayer(T);
    }), __publicField$C(this, "_removePlayer", (T = "", F = !1) => {
      const { initBoardPlayer: $ } = this.state;
      this._exitFullScreen(() => {
        $ && (console.log(`${T}---remove`), this.setState({
          errorBoardLock: F
        }), $.remove());
      });
    }), __publicField$C(this, "_getBoardPlayList", () => {
      const { boardUrl: T } = this.state, F = getDefaultCdnBgUrl(DefaultBgEnum.boardBgUrl), $ = {
        file: T,
        image: F,
        isLive: !0
      };
      return roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY ? $ : Ke(Fe({}, $), {
        reloadAfterPausing: !0,
        reloadAfterPausingTime: 50
      });
    }), __publicField$C(this, "_changeLanguage", (T) => {
      var F;
      try {
        (F = this.state.initBoardPlayer) == null || F.changeLanguage(PlayerLanguageTypeMap[T]);
      } catch ($) {
      }
    }), __publicField$C(this, "_displayVideoControls", () => {
      const { boardDomId: T } = this.state;
      try {
        if (!T)
          return;
        const F = document.querySelector(`#${T} .mudu-controller-wrap .mudu-controller .mudu-icons-left`), $ = document.querySelector(`#${T} .mudu-controller-wrap .mudu-controller .mudu-icons-right .mudu-switch-path`), J = document.querySelector(`#${T} .mudu-controller-wrap .mudu-controller .mudu-icons-right .mudu-switch-quality`);
        F && (F.style.display = "none"), $ && ($.style.display = "none"), J && (F.style.display = "none");
        const ee = document.querySelector(`#${T}.mudu .mudu-video-wrap .mudu-background`);
        ee && (ee.style.backgroundSize = "100% 100%");
      } catch (F) {
      }
    });
  }
  init(T, F) {
    const { liveScene: $, roomMode: J } = roomModel.state;
    F && J === RoomMode.LIVE && $ === LiveScene.LINK && (this.setState({
      roomLayout: T != null ? T : RoomLayout.VIDEO,
      boardDomId: F
    }), roomModel.state.liveStatus === LiveStatus.LIVING && [RoomLayout.VIDEO_BOARD, RoomLayout.BOARD_VIDEO].includes(T) && this._queryBoardUrl(), this._onWsBoardStreamStatus(), this._onWsRoomLayout());
  }
  _restartDetect() {
    const { boardStreamDetect: T, boardUrl: F } = this.state;
    if (T && T.stop && T.stop(), !F) {
      console.warn("empty live stream file");
      return;
    }
    if (roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY) {
      this._exitFullScreen(() => {
        this.state.initBoardPlayer && this.state.initBoardPlayer.remove(), this._createPlayer();
      });
      return;
    }
    let $ = 0;
    const J = 2e3, ee = 1e4, ne = new HttpStreamDetect(F, 10);
    this.setState({ boardStreamDetect: ne }), ne.on(DETECT_RESULT_EVENT, (oe) => {
      const { initBoardPlayer: se } = this.state;
      $ += 1;
      const { current: le } = oe;
      if (le) {
        ne.stop(), this._exitFullScreen(() => {
          se && se.remove(), this._createPlayer();
        });
        return;
      }
      $ > 18 ? ne.stop() : $ > 15 ? ne.setGap(ee) : $ > 1 && ne.setGap(J);
    }), ne.start();
  }
  _createPlayer() {
    try {
      if (!document.querySelector(`#${this.state.boardDomId}`) || !this.state.boardUrl)
        return;
      const F = muduPlayer(this.state.boardDomId);
      this.setState({ initBoardPlayer: F });
      const $ = this._getBoardPlayList();
      F.setup({
        playlist: [$],
        height: "100%",
        width: "100%",
        videoAttributes: { "raw-controls": !1, muted: !0 },
        language: PlayerLanguageTypeMap[roomModel.state.watchLanguage],
        localization: PlayerLocalizationMap,
        fullscreenEmulation: isMobile,
        autoplay: !0,
        plugin: {
          x5: {
            inline: !0,
            layer: !1
          }
        },
        renderError: () => {
          const J = document.createElement("div");
          return J.className = "mudu-bezel", J.innerHTML = '<span class="mudu-reset mudu-loading-icon mudu-icon-load" style="display: block"></span>', J;
        }
      }).then(() => {
        this._displayVideoControls(), F.setVideoLayerControl(!1), F.setMute(!0), F.play().then(() => {
          this.setState({
            boardStreamStatus: !0
          }), boardSdkModel.emit(this.BOARD_STREAM_STATUS_CHANGED, !0);
        });
      }).catch(() => {
      }), F.on("complete", () => {
        this._verifyStreamStatus("complete");
      }), F.on("error", (J) => {
        var ee, ne, oe;
        if (roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY) {
          ((ee = J == null ? void 0 : J.data) == null ? void 0 : ee.code) === 2002 ? this._updateBoardUrl() : (ne = J == null ? void 0 : J.data) != null && ne.fatal && this._removePlayer();
          return;
        }
        const se = F == null ? void 0 : F.getState();
        ((F == null ? void 0 : F.getPosition()) === 0 || se === "idle" || ((oe = J == null ? void 0 : J.data) == null ? void 0 : oe.fatal)) && this._verifyStreamStatus("error");
      }), F.on("time", (J) => {
        J.position && roomModel.state.liveDelay !== LiveDelayEnum.NO_DELAY && this._monitorBoardError();
      }), F.on("remove", () => {
        this.setState({
          initBoardPlayer: "",
          boardStreamStatus: !1
        }), boardSdkModel.emit(this.BOARD_STREAM_STATUS_CHANGED, !1), roomModel.state.liveStatus === LiveStatus.LIVING && this.state.errorBoardLock && (this.setState({ errorBoardLock: !1 }), this._queryBoardUrl());
      });
    } catch (T) {
    }
  }
  destroy() {
    this._removePlayer();
    const { boardStreamDetect: T } = this.state;
    T && T.stop && T.stop(), this.setState({
      roomLayout: RoomLayout.VIDEO,
      boardUrl: "",
      errorBoardLock: !1,
      initBoardPlayer: "",
      boardStreamDetect: ""
    });
  }
  _onWsBoardStreamStatus() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.BOARD_STREAMSTATUS).subscribe((F) => {
      const { roomLayout: $ } = this.state, { pushStatus: J, boardsPlayUrl: ee } = F;
      J === BoardStatus.PUSH_START && [RoomLayout.VIDEO_BOARD, RoomLayout.BOARD_VIDEO].includes($) && (this.setState({ boardUrl: ee }), this._restartDetect());
    });
  }
  _onWsRoomLayout() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.ROOM_LAYOUT).subscribe((F) => {
      (![RoomLayout.VIDEO_BOARD, RoomLayout.BOARD_VIDEO].includes(this.state.roomLayout) || ![RoomLayout.VIDEO_BOARD, RoomLayout.BOARD_VIDEO].includes(F.layoutFlag)) && ([RoomLayout.VIDEO_BOARD, RoomLayout.BOARD_VIDEO].includes(F.layoutFlag) ? this._queryBoardUrl() : this.destroy()), this.setState({ roomLayout: F.layoutFlag });
    });
  }
}
const boardModel = new BoardModel(), emojiReg = /\[em_(\d{1,2})\]/g, MIN_COUNT$1 = 1, MAX_COUNT$1 = 75, STATIC_PREFIX$1 = "https://static.mudu.tv/assets/face/", EXTENSION$1 = ".png", getEmojiList = () => {
  const e = [];
  for (let T = MIN_COUNT$1; T <= MAX_COUNT$1; T++)
    e.push({
      src: STATIC_PREFIX$1 + T + EXTENSION$1,
      label: `[em_${T}]`
    });
  return e;
}, findEmojiSrcByCharacter = (e) => {
  let T;
  const F = getEmojiList();
  return F.find(($) => $.label === e) && (T = F.filter(($) => $.label === e)[0].src), T;
};
var __defProp$B = Object.defineProperty, __defNormalProp$B = (e, T, F) => T in e ? __defProp$B(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$B = (e, T, F) => (__defNormalProp$B(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$E = {
  barrageConfigFlag: !1,
  barrageFlag: !1,
  barrageSpeed: 144,
  barrageTransparent: 80,
  barrageSize: 14,
  barrageColor: "#fff",
  barrageShowRegion: BarrageRange.FULL,
  barrageNicknameShowFlag: !1
};
class BarrageModel extends Model {
  constructor() {
    super(INITIAL_STATE$E), __publicField$B(this, "setBarrageSpeed", (T) => {
      this.setState({ barrageSpeed: Number(T) || 144 });
    }), __publicField$B(this, "setBarrageTransparent", (T) => {
      this.setState({ barrageTransparent: T || 80 });
    }), __publicField$B(this, "setBarrageSize", (T) => {
      this.setState({ barrageSize: T || 14 });
    }), __publicField$B(this, "setBarrageColor", (T) => {
      this.setState({ barrageColor: T || "#fff" });
    }), __publicField$B(this, "setBarrageFlag", (T) => {
      T || this._clearBarrage(), this.setState({ barrageFlag: !!T });
    }), __publicField$B(this, "emitBarrage", (T, F) => {
      const { initVideoPlayer: $ } = playerModel.state, { barrageConfigFlag: J, barrageFlag: ee, barrageColor: ne } = this.state;
      try {
        if (J && ee && $) {
          const { danmaku: oe } = $.plugin, { barrageSpeed: se, barrageTransparent: le, barrageSize: de, barrageNicknameShowFlag: ce } = this.state;
          oe && oe.emit && (oe.setSpeed(se), oe.emit({
            render: () => {
              const he = document.createElement("div");
              he.style.color = `${ne || "#fff"}`, he.style.padding = "8px", he.style.opacity = `${le}%`, he.style.fontSize = `${de}px`, he.innerHTML = `${ce ? `<span>${F}\uFF1A</span>` : ""}${this._filterDanmakuContent(T, de)}`;
              const ve = he.querySelector("span");
              return ve != null && ve.style && (ve.style.opacity = "0.65"), he;
            }
          }));
        }
      } catch (oe) {
      }
    });
  }
  init(T, F) {
    this.setState({
      barrageConfigFlag: isTrue(T == null ? void 0 : T.barrageFlag),
      barrageFlag: isTrue(T == null ? void 0 : T.barrageFlag),
      barrageTransparent: (T == null ? void 0 : T.barrageOpacity) || 80,
      barrageColor: (T == null ? void 0 : T.barrageColor) || "#fff",
      barrageShowRegion: (T == null ? void 0 : T.barrageShowRegion) || BarrageRange.FULL,
      barrageNicknameShowFlag: isTrue(F)
    }), this._onWsRoomDanmaku();
  }
  _filterDanmakuContent(T, F) {
    return emojiReg.test(T) ? T.replace(emojiReg, (J) => {
      const ee = findEmojiSrcByCharacter(J);
      return ee ? `<img width=${F} height=${F} src=${ee} />` : J;
    }) : T;
  }
  _clearBarrage() {
    const { initVideoPlayer: T } = playerModel.state;
    if (T) {
      const { danmaku: F } = T.plugin;
      F && F.clear && F.clear();
    }
  }
  destroy() {
    this._clearBarrage(), this.setState(INITIAL_STATE$E);
  }
  _onWsRoomDanmaku() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.ROOM_CONFIG).subscribe((F) => {
      if (F != null && F.hasOwnProperty("autoBulletCommentFlag")) {
        const $ = isTrue(F.autoBulletCommentFlag);
        this.setState({
          barrageConfigFlag: $,
          barrageFlag: $
        }), $ || this._clearBarrage();
      }
    });
  }
}
const barrageModel = new BarrageModel();
var __defProp$A = Object.defineProperty, __defNormalProp$A = (e, T, F) => T in e ? __defProp$A(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$A = (e, T, F) => (__defNormalProp$A(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$D = {};
class PlayerSdkModel extends Model {
  constructor() {
    super(INITIAL_STATE$D), __publicField$A(this, "VOD_RESOURCE_STOCK_EMPTY", "VOD_RESOURCE_STOCK_EMPTY"), __publicField$A(this, "LIVE_RESOURCE_STOCK_EMPTY", "LIVE_RESOURCE_STOCK_EMPTY"), __publicField$A(this, "barrageConfigFlag", () => this._getModelState(barrageModel, "barrageConfigFlag")), __publicField$A(this, "barrageFlag", () => this._getModelState(barrageModel, "barrageFlag")), __publicField$A(this, "setBarrageSpeed", barrageModel.setBarrageSpeed), __publicField$A(this, "setBarrageTransparent", barrageModel.setBarrageTransparent), __publicField$A(this, "setBarrageSize", barrageModel.setBarrageSize), __publicField$A(this, "setBarrageColor", barrageModel.setBarrageColor), __publicField$A(this, "setBarrageFlag", barrageModel.setBarrageFlag), __publicField$A(this, "emitBarrage", barrageModel.emitBarrage), __publicField$A(this, "currentPlaybackMediaId", () => this._getModelState(playerModel, "currentTrailerAddr", (T) => {
      var F;
      const { currentPlayType: $, initVideoPlayer: J } = playerModel.state;
      return J && $ === VideoPlayType.TRAILER && (F = T == null ? void 0 : T.mediaId) != null ? F : 0;
    })), __publicField$A(this, "playbackList", () => this._getModelState(playerModel, "trailerVideoList", (T) => Array.isArray(T) && T.length ? T.map((F) => ({
      mediaName: F == null ? void 0 : F.mediaName,
      mediaCover: F == null ? void 0 : F.mediaCoverUrl,
      mediaId: F == null ? void 0 : F.mediaId,
      mediaDuration: F == null ? void 0 : F.mediaDuration
    })) : [])), __publicField$A(this, "currentPushLiveMultiScreenId", () => this._getModelState(playerModel, "currentLiveAddr", (T) => {
      var F;
      const { currentPlayType: $, initVideoPlayer: J } = playerModel.state, { liveScene: ee, liveMode: ne } = roomModel.state;
      return J && $ === VideoPlayType.LIVE && ee === LiveScene.STREAM_PUSH && ne === LiveMode.STREAM_PUSH_MULTI && (F = T == null ? void 0 : T.screenId) != null ? F : 0;
    })), __publicField$A(this, "pushLiveMultiScreenList", () => this._getModelState(playerModel, "pushStreamLiveAddr", (T) => {
      const { watchLanguage: F } = roomModel.state;
      return Array.isArray(T) && T.length ? T.map(($) => {
        var J;
        const ee = findFinalLangFun(F, (se) => {
          var le;
          return (le = $ == null ? void 0 : $.languages) == null ? void 0 : le.some((de) => de.languageType === se);
        }), { screenName: ne, screenCover: oe } = ((J = $ == null ? void 0 : $.languages) == null ? void 0 : J.find(({ languageType: se }) => se === ee)) || {};
        return {
          screenName: ne,
          screenCover: oe,
          screenId: $ == null ? void 0 : $.screenId,
          mainScreenFlag: isTrue($ == null ? void 0 : $.mainScreenFlag),
          pushStatus: isTrue($ == null ? void 0 : $.pushStatus),
          languages: $ == null ? void 0 : $.languages
        };
      }) : [];
    })), __publicField$A(this, "currentPlayType", () => this._getModelState(playerModel, "currentPlayType")), __publicField$A(this, "enableVideo", () => this._getModelState(playerModel, "showMaskPlayer")), __publicField$A(this, "getPlayerBgUrl", () => this._getModelState(playerModel, "curLangPlayerBgUrl"));
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$D);
  }
  playMultiScreen(T) {
    return Me(this, null, function* () {
      const { videoStreamDetect: F, pushStreamLiveAddr: $ } = playerModel.state, J = $.find((ee) => ee.screenId === T);
      if (!J)
        return Promise.reject({
          code: PlayerErrorType.INVALID_SCREEN_ID,
          msg: "\u65E0\u6548\u7684\u63A8\u6D41\u753B\u9762id"
        });
      playerModel._setCurrentLiveAddr(J), F && F.stop && F.stop(), playerModel._updateVideoUrl();
    });
  }
  backLive() {
    return Me(this, null, function* () {
      const { currentPlayType: T } = playerModel.state, { liveStatus: F } = roomModel.state;
      if (F !== LiveStatus.LIVING)
        return Promise.reject({
          code: PlayerErrorType.NO_LIVE,
          msg: "\u5F53\u524D\u672A\u76F4\u64AD"
        });
      if (T === VideoPlayType.LIVE)
        return Promise.reject({
          code: PlayerErrorType.LIVING,
          msg: "\u5DF2\u5728\u76F4\u64AD\u4E2D"
        });
      playerModel._updateVideoUrl();
    });
  }
  skipAd() {
    return Me(this, null, function* () {
      const { currentPlayType: T } = playerModel.state;
      if (T === VideoPlayType.AD)
        playerModel._setCurrentPlayFile();
      else
        return Promise.reject({
          code: PlayerErrorType.NO_AD_PLAY,
          msg: "\u65E0\u6CD5\u8DF3\u8FC7\uFF0C\u5F53\u524D\u672A\u64AD\u653E\u5E7F\u544A"
        });
    });
  }
  playPlayback(T) {
    return Me(this, null, function* () {
      const { videoStreamDetect: F, trailerVideoList: $ } = playerModel.state, J = $.find((ee) => ee.mediaId === T);
      if (!J)
        return Promise.reject({
          code: PlayerErrorType.INVALID_MEDIA_ID,
          msg: "\u65E0\u6548\u7684\u56DE\u653E\u89C6\u9891id"
        });
      F && F.stop && F.stop(), playerModel._updateTrailerUrl(J);
    });
  }
  setFullscreen(T) {
    var F, $;
    ($ = (F = playerModel.state.initVideoPlayer) == null ? void 0 : F.setFullscreen) == null || $.call(F, T);
  }
}
const playerSdkModel = new PlayerSdkModel();
var MediaResourceCode = /* @__PURE__ */ ((e) => (e.RESOURCE_STOCK_IS_EMPTY = "150023", e))(MediaResourceCode || {});
function httpGetVideoUrl(e, T) {
  return Me(this, null, function* () {
    return request$1.get(`/events/${e}/rooms/${T}/live-play-addr`);
  });
}
function httpPostDurationDots(e) {
  return request$1.post(`/events/${e.virtualEventId}/rooms/duration-dots`, e, {
    silence: !0
  });
}
function httpGetTrailerVideo(e, T) {
  return request$1.get(
    `/events/${e}/rooms/${T}/watch-medias`
  );
}
function httpGetRoomMediaUrl(e, T, F, $) {
  return Me(this, null, function* () {
    return request$1.get(`/events/${e}/rooms/${T}/medias/${F}/watch-preview`, {
      params: {
        sourceType: $
      }
    });
  });
}
var __defProp$z = Object.defineProperty, __defNormalProp$z = (e, T, F) => T in e ? __defProp$z(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$z = (e, T, F) => (__defNormalProp$z(e, typeof T != "symbol" ? T + "" : T, F), F), __accessCheck = (e, T, F) => {
  if (!T.has(e))
    throw TypeError("Cannot " + F);
}, __privateGet = (e, T, F) => (__accessCheck(e, T, "read from private field"), F ? F.call(e) : T.get(e)), __privateAdd = (e, T, F) => {
  if (T.has(e))
    throw TypeError("Cannot add the same private member more than once");
  T instanceof WeakSet ? T.add(e) : T.set(e, F);
}, __privateSet = (e, T, F, $) => (__accessCheck(e, T, "write to private field"), $ ? $.call(e, F) : T.set(e, F), F), _durationTimer, _durationCount;
const DEFAULT_PROVIDER = ["hlsjs", "html5"], INITIAL_STATE$C = {
  playerDomId: "",
  barrageShowRegion: BarrageRange.FULL,
  errorWatchLock: !1,
  liveUrl: "",
  currentPlayType: VideoPlayType.INIT,
  detailData: {},
  videoStreamDetect: "",
  currentLiveAddr: {},
  pushStreamLiveAddr: [],
  streamId: 0,
  initVideoPlayer: "",
  showMaskPlayer: !0,
  trailerVideoShowFlag: !1,
  currentTrailerAddr: {},
  trailerVideoList: [],
  durationValueFlag: !0,
  doubleSpeedFlag: !1,
  progressBarFlag: !1,
  menuVideoInfo: {},
  curLangPlayerBgUrl: "",
  loopPlaybackFlag: !1,
  xp2pAppId: "",
  cloudAppId: "",
  autoplay: !0,
  mute: !1
};
class PlayerModel extends Model {
  constructor() {
    super(INITIAL_STATE$C), __privateAdd(this, _durationTimer, null), __privateAdd(this, _durationCount, 0), __publicField$z(this, "VOD_RESOURCE_STOCK_EMPTY", "VOD_RESOURCE_STOCK_EMPTY"), __publicField$z(this, "LIVE_RESOURCE_STOCK_EMPTY", "LIVE_RESOURCE_STOCK_EMPTY"), __publicField$z(this, "_getAdPlayList", () => {
      const { detailData: T, curLangPlayerBgUrl: F } = this.state, { adShowFlag: $, adMediaId: J, adMediaCoverUrl: ee, adMediaUrl: ne, adMediaName: oe, adMediaType: se } = T || {};
      return isTrue($) && ne ? {
        file: ne,
        image: ee || F,
        alwaysDisplayImage: se === AdMediaType.AUDIO,
        isLive: !1,
        title: unescape$1(oe),
        mediaid: J,
        defaultPlay: !0
      } : null;
    }), __publicField$z(this, "_getLivePlayList", () => {
      const T = this._getCurrentLiveUrl();
      if (!T)
        return null;
      const { curLangPlayerBgUrl: F } = this.state, $ = {
        file: T,
        image: F,
        title: getLangRoomNameConfig(),
        isLive: !0
      };
      return roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY ? $ : Ke(Fe({}, $), {
        reloadAfterPausing: !0,
        reloadAfterPausingTime: 50
      });
    }), __publicField$z(this, "_getTrailerPlayList", () => {
      const { currentTrailerAddr: T, progressBarFlag: F, curLangPlayerBgUrl: $ } = this.state, { mediaId: J, mediaType: ee, mediaName: ne, mediaCoverUrl: oe, mediaUrl: se } = T || {};
      return se ? {
        file: se,
        image: oe || $,
        alwaysDisplayImage: ee === AdMediaType.AUDIO,
        isLive: !1,
        title: unescape$1(ne),
        mediaid: J,
        defaultPlay: !0,
        isHideProgress: !F
      } : null;
    }), __publicField$z(this, "_getMenuVideoPlayList", () => {
      const { menuVideoInfo: T, curLangPlayerBgUrl: F } = this.state, { mediaId: $, mediaType: J, mediaName: ee, coverUrl: ne, mediaUrl: oe } = T || {};
      return oe ? {
        file: oe,
        image: ne || F,
        alwaysDisplayImage: J === AdMediaType.AUDIO,
        isLive: !1,
        title: unescape$1(ee),
        mediaid: $,
        defaultPlay: !0
      } : null;
    }), __publicField$z(this, "_playMenuVideo", (T) => Me(this, null, function* () {
      var F, $, J;
      if (!!T) {
        ($ = (F = this.state.videoStreamDetect) == null ? void 0 : F.stop) == null || $.call(F);
        try {
          const { roomId: ee } = roomModel.state, { eventId: ne } = eventModel.state, oe = yield httpGetRoomMediaUrl(ne, ee, T, RoomMediaSourceType.MENU_VIDEO), se = ((J = oe == null ? void 0 : oe.data) == null ? void 0 : J.data) || {};
          if ((se == null ? void 0 : se.responseCode) === MediaResourceCode.RESOURCE_STOCK_IS_EMPTY) {
            this._emitMediaResourceIsEmpty(MediaType.VOD);
            return;
          }
          if (se != null && se.mediaUrl) {
            this._clearDurationInterval(), this.setState((de) => {
              de.menuVideoInfo = se, de.currentPlayType = VideoPlayType.MENU_VIDEO;
            });
            const { initVideoPlayer: le } = this.state;
            if (le && le.load) {
              const de = this._getMenuVideoPlayList();
              le.load([de], !0, {
                providerOrder: DEFAULT_PROVIDER
              }).then(() => {
                this._durationInterval();
              });
            } else
              this._createPlayer(VideoPlayType.MENU_VIDEO);
          }
        } catch (ee) {
        }
      }
    })), __publicField$z(this, "_updateTrailerUrl", (T) => Me(this, null, function* () {
      var F;
      try {
        const { roomId: $ } = roomModel.state, { eventId: J } = eventModel.state, ee = yield httpGetRoomMediaUrl(J, $, T.mediaId, RoomMediaSourceType.TRAILER), ne = ((F = ee == null ? void 0 : ee.data) == null ? void 0 : F.data) || {};
        if (ne != null && ne.mediaUrl) {
          this._clearDurationInterval(), this.setState((se) => {
            se.currentTrailerAddr = Ke(Fe({}, T), { mediaUrl: ne.mediaUrl }), se.currentPlayType = VideoPlayType.TRAILER;
          });
          const { initVideoPlayer: oe } = this.state;
          if (oe && oe.load) {
            const se = this._getTrailerPlayList();
            oe.load([se], !0, {
              providerOrder: DEFAULT_PROVIDER
            }).then(() => {
              var le;
              this.state.doubleSpeedFlag && ((le = oe.setPlaybackRates) == null || le.call(oe, playbackRatesList)), this._durationInterval();
            });
          } else
            this._createPlayer(VideoPlayType.TRAILER);
        } else
          (ne == null ? void 0 : ne.responseCode) === MediaResourceCode.RESOURCE_STOCK_IS_EMPTY ? this._emitMediaResourceIsEmpty(MediaType.VOD) : this._loadNextTrailerFile(T);
      } catch ($) {
        this._loadNextTrailerFile(T);
      }
    })), __publicField$z(this, "_loadNextTrailerFile", (T) => {
      const { trailerVideoList: F, initVideoPlayer: $, loopPlaybackFlag: J } = this.state, ee = F.findIndex((ne) => ne.mediaId === T.mediaId);
      ee + 1 < F.length ? this._updateTrailerUrl(F[ee + 1]) : J && ee + 1 === F.length ? this._updateTrailerUrl(F[0]) : $ && $.getState && $.getState() === "error" && this._removePlayer();
    }), __publicField$z(this, "_getCurrentLiveUrl", () => {
      const { liveScene: T } = roomModel.state, { liveUrl: F, currentLiveAddr: $ } = this.state;
      let J = F;
      return T === LiveScene.STREAM_PUSH && (J = $.liveUrl), J;
    }), __publicField$z(this, "_verifyStreamStatus", (T) => {
      const { currentLiveAddr: F, currentPlayType: $ } = this.state, { liveScene: J, liveStatus: ee } = roomModel.state, ne = this._getCurrentLiveUrl();
      if ($ === VideoPlayType.LIVE && ne && ee === LiveStatus.LIVING && (J === LiveScene.STREAM_PULL || J === LiveScene.LINK || J === LiveScene.STREAM_PUSH && isTrue(F.pushStatus))) {
        if (roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY)
          return;
        ajax(ne, {
          success: () => {
          },
          fail: (oe) => {
            if (get_1(oe, "status") === 403) {
              this._updateVideoUrl();
              return;
            }
            this._removePlayer(T, !0);
          }
        });
      } else
        this._removePlayer(T);
    }), __publicField$z(this, "_removePlayer", (T = "", F = !1) => {
      const { initVideoPlayer: $ } = this.state;
      this._exitFullScreen(() => {
        $ && (console.log(`${T}---remove`), this.setState({
          errorWatchLock: F
        }), $.remove());
      });
    }), __publicField$z(this, "_exitFullScreen", (T) => {
      const { initVideoPlayer: F } = this.state;
      F && F.getFullscreen && F.getFullscreen() && F.setFullscreen(!1), T && setTimeout(() => {
        T();
      });
    }), __publicField$z(this, "_updateVideoUrl", () => {
      const { roomId: T } = roomModel.state, { eventId: F } = eventModel.state;
      this._clearDurationInterval(), httpGetVideoUrl(F, T).then(($) => {
        var J;
        const ee = ((J = $ == null ? void 0 : $.data) == null ? void 0 : J.data) || {};
        if (this._handleStreamAddr(ee), (ee == null ? void 0 : ee.responseCode) === MediaResourceCode.RESOURCE_STOCK_IS_EMPTY) {
          this._emitMediaResourceIsEmpty(MediaType.LIVE);
          return;
        }
        const ne = this._getCurrentLiveUrl(), { initVideoPlayer: oe, currentLiveAddr: se, xp2pAppId: le, cloudAppId: de } = this.state;
        if (ne) {
          if (roomModel.state.liveScene === LiveScene.STREAM_PUSH && !isTrue(se.pushStatus)) {
            this._removePlayer();
            return;
          }
          if (oe && oe.load) {
            const ce = this._getLivePlayList();
            oe.load([ce], !0, {
              providerOrder: le && de ? ["hlsXp2p"] : DEFAULT_PROVIDER
            }).then(() => {
              this._durationInterval();
            });
          } else
            this._createPlayer();
          this.setState({ currentPlayType: VideoPlayType.LIVE });
        } else
          this._removePlayer();
      }).catch(() => {
        this._removePlayer();
      });
    }), __publicField$z(this, "_emitMediaResourceIsEmpty", (T) => {
      var F;
      T === MediaType.LIVE ? (playerSdkModel.emit(this.LIVE_RESOURCE_STOCK_EMPTY), (F = boardModel) == null || F._removePlayer()) : playerSdkModel.emit(this.VOD_RESOURCE_STOCK_EMPTY), this._removePlayer();
    }), __publicField$z(this, "_detectLiveStream", () => {
      const { liveScene: T, liveStatus: F } = roomModel.state, { currentLiveAddr: $ } = this.state, J = this._getCurrentLiveUrl();
      F === LiveStatus.LIVING && J && (T === LiveScene.STREAM_PUSH && isTrue($.pushStatus) || T === LiveScene.STREAM_PULL || T === LiveScene.LINK) && this._restartDetect();
    }), __publicField$z(this, "_monitorStreamStatus", debounce_1(() => {
      this.state.currentPlayType === VideoPlayType.LIVE && this._verifyStreamStatus("monitorVideoError");
    }, 2e3)), __publicField$z(this, "_setCurrentPlayFile", () => {
      var T;
      const { initVideoPlayer: F, currentPlayType: $, currentTrailerAddr: J, trailerVideoShowFlag: ee, trailerVideoList: ne } = this.state;
      if ($ === VideoPlayType.AD) {
        roomModel.state.liveStatus === LiveStatus.LIVING ? this._updateVideoUrl() : ee && ne.length ? this._updateTrailerUrl(J) : this._verifyStreamStatus("completeWatchError");
        return;
      }
      if ($ === VideoPlayType.TRAILER) {
        this._loadNextTrailerFile(J);
        return;
      }
      if ($ === VideoPlayType.MENU_VIDEO) {
        ((T = F == null ? void 0 : F.getState) == null ? void 0 : T.call(F)) === "error" && this._removePlayer();
        return;
      }
      this._verifyStreamStatus("completeWatchError");
    }), __publicField$z(this, "_handleStreamAddr", (T) => {
      const { liveStatus: F } = T || {}, { liveScene: $, liveMode: J } = roomModel.state, { currentLiveAddr: ee } = this.state;
      if (roomModel._setLiveStatusState(F), $ === LiveScene.STREAM_PUSH) {
        const ne = get_1(T, "pushStreamLiveAddr", []) || [];
        J === LiveMode.STREAM_PUSH_SINGLE && (ne[0].liveUrl = get_1(T, "pushStreamLiveAddr[0].playAddrs[0].resolutions[0].url", "") || "", this.setState({
          currentLiveAddr: get_1(T, "pushStreamLiveAddr[0]", {}) || {}
        })), J === LiveMode.STREAM_PUSH_MULTI && (Array.isArray(ne) && ne.forEach((oe) => {
          oe.liveUrl = get_1(oe, "playAddrs[0].resolutions[0].url", "") || "";
        }), this.setState({
          pushStreamLiveAddr: ne
        }), ee.liveUrl ? ne.forEach((oe) => {
          oe.screenId === ee.screenId && this.setState({
            currentLiveAddr: oe
          });
        }) : this.setState({
          currentLiveAddr: get_1(ne.filter((oe) => isTrue(oe.mainScreenFlag)), "[0]", {}) || {}
        }));
      } else {
        let ne = {};
        $ === LiveScene.LINK && (ne = get_1(T, "linkMikeLiveAddr[0]", {}) || {}), $ === LiveScene.STREAM_PULL && (ne = get_1(T, "pullStreamLiveAddr[0]", {}) || {}), ne.liveUrl = get_1(ne, "playAddrs[0].resolutions[0].url", "") || "";
        const { liveUrl: oe, streamId: se } = ne;
        this.setState({ liveUrl: oe, streamId: se });
      }
    }), __publicField$z(this, "_queryVideoUrl", () => {
      const { roomId: T } = roomModel.state, { eventId: F } = eventModel.state;
      httpGetVideoUrl(F, T).then(($) => {
        var J;
        const ee = ((J = $ == null ? void 0 : $.data) == null ? void 0 : J.data) || {};
        this._handleStreamAddr(ee), roomModel.state.liveStatus === LiveStatus.LIVING && [VideoPlayType.INIT, VideoPlayType.LIVE].includes(this.state.currentPlayType) && ((ee == null ? void 0 : ee.responseCode) === MediaResourceCode.RESOURCE_STOCK_IS_EMPTY ? this._emitMediaResourceIsEmpty(MediaType.LIVE) : this._detectLiveStream());
      }).catch(() => {
      });
    }), __publicField$z(this, "_displayPlayerByDomId", () => {
      const { playerDomId: T, showMaskPlayer: F, detailData: $ } = this.state, { screenOrientation: J } = $ || {}, ee = document.querySelector(`#${T}`), ne = document.querySelector(`#${T}.mudu .mudu-video-wrap .mudu-background`), oe = document.querySelector(`#${T}.mudu .mudu-fullscreen-icon`);
      ee && (F ? ee.style.display = "block" : ee.style.display = "none"), ne && (ne.style.backgroundSize = "100% 100%"), oe && J === ScreenOrientationEnum.PORTRAIT && (oe.style.display = "none");
    }), __publicField$z(this, "_changeLanguage", (T) => {
      var F, $;
      try {
        setCurLangPlayerBg(T), ($ = (F = this.state.initVideoPlayer) == null ? void 0 : F.changeLanguage) == null || $.call(F, PlayerLanguageTypeMap[T]);
      } catch (J) {
      }
    }), __publicField$z(this, "_createPlayer", (T = VideoPlayType.LIVE) => {
      if (!document.querySelector(`#${this.state.playerDomId}`)) {
        this.setState({ currentPlayType: VideoPlayType.INIT });
        return;
      }
      const $ = [];
      let J = [];
      if (T === VideoPlayType.AD) {
        const ce = this._getAdPlayList();
        if (!ce) {
          this.setState({ currentPlayType: VideoPlayType.INIT });
          return;
        }
        $.push(ce);
      }
      if (T === VideoPlayType.LIVE) {
        const ce = this._getLivePlayList();
        if (!ce) {
          this.setState({ currentPlayType: VideoPlayType.INIT });
          return;
        }
        $.push(ce);
      }
      if (T === VideoPlayType.TRAILER) {
        const ce = this._getTrailerPlayList();
        if (!ce) {
          this.setState({ currentPlayType: VideoPlayType.INIT });
          return;
        }
        $.push(ce), this.state.doubleSpeedFlag && (J = playbackRatesList);
      }
      if (T === VideoPlayType.MENU_VIDEO) {
        const ce = this._getMenuVideoPlayList();
        if (!ce) {
          this.setState({ currentPlayType: VideoPlayType.INIT });
          return;
        }
        $.push(ce);
      }
      const ee = muduPlayer(this.state.playerDomId);
      this.setState({ initVideoPlayer: ee });
      const { xp2pAppId: ne, cloudAppId: oe, autoplay: se, mute: le } = this.state || {}, de = T === VideoPlayType.LIVE && ne && oe ? ["hlsXp2p"] : DEFAULT_PROVIDER;
      try {
        ee.setup({
          height: "100%",
          width: "100%",
          language: PlayerLanguageTypeMap[roomModel.state.watchLanguage],
          localization: PlayerLocalizationMap,
          fullscreenEmulation: this._getFullscreenEmulation(),
          stretching: streamStretchingMode(),
          videoAttributes: {
            "raw-controls": !1,
            loop: !1
          },
          repeat: !1,
          playlist: $,
          playbackRates: J,
          providerOrder: de,
          provider: {
            hlsjs: {
              "hls.js": { manifestLoadingTimeOut: 2e4 }
            },
            hlsXp2p: {
              xp2pAppId: ne,
              cloudAppId: oe,
              "hls.js": { manifestLoadingTimeOut: 2e4 }
            }
          },
          plugin: {
            x5: {
              inline: !0,
              layer: !1
            }
          },
          renderError: () => {
            const ce = document.createElement("div");
            return ce.className = "mudu-bezel", ce.innerHTML = '<span class="mudu-reset mudu-loading-icon mudu-icon-load" style="display: block"></span>', ce;
          }
        }).then(() => {
          this.state.showMaskPlayer ? ee.setMute(le) : ee.setMute(!0), se && ee.play(), this._displayPlayerByDomId(), this.setState({ currentPlayType: T }), this._durationInterval();
          const { danmaku: ce } = ee.plugin;
          return ce.init();
        }).then(() => {
          var ce, he;
          const ve = (ce = ee == null ? void 0 : ee.plugin) == null ? void 0 : ce.danmaku;
          (he = ve == null ? void 0 : ve.setRange) == null || he.call(ve, this.state.barrageShowRegion);
        }).catch(() => {
          this.setState({ currentPlayType: T }), this._detectLiveStream();
        }), ee.on("pause", () => {
          const { currentPlayType: ce } = this.state;
          ([VideoPlayType.AD, VideoPlayType.TRAILER, VideoPlayType.MENU_VIDEO].includes(ce) || ce === VideoPlayType.LIVE && roomModel.state.liveStatus !== LiveStatus.LIVING) && this._durationInterval();
        }), ee.on("play", () => {
          this._durationInterval();
        }), ee.on("complete", () => {
          this._setCurrentPlayFile();
        }), ee.on("error", (ce) => {
          var he, ve, ge, be;
          const { currentPlayType: Te } = this.state;
          if ([VideoPlayType.AD, VideoPlayType.TRAILER, VideoPlayType.MENU_VIDEO].includes(Te)) {
            (he = ce == null ? void 0 : ce.data) != null && he.fatal && this._setCurrentPlayFile();
            return;
          }
          if (Te === VideoPlayType.LIVE) {
            if (roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY) {
              ((ve = ce == null ? void 0 : ce.data) == null ? void 0 : ve.code) === 2002 ? this._updateVideoUrl() : (ge = ce == null ? void 0 : ce.data) != null && ge.fatal && this._removePlayer();
              return;
            }
            const Se = ee == null ? void 0 : ee.getState();
            ((ee == null ? void 0 : ee.getPosition()) === 0 || Se === "idle" || ((be = ce == null ? void 0 : ce.data) == null ? void 0 : be.fatal)) && this._verifyStreamStatus("error");
          }
        }), ee.on("time", (ce) => {
          ce.position && this.state.currentPlayType === VideoPlayType.LIVE && roomModel.state.liveDelay !== LiveDelayEnum.NO_DELAY && this._monitorStreamStatus();
        }), ee.on("remove", () => {
          const { currentLiveAddr: ce } = this.state, { liveScene: he } = roomModel.state;
          roomModel.state.liveStatus === LiveStatus.LIVING && this.state.errorWatchLock && (he === LiveScene.STREAM_PULL || he === LiveScene.LINK || he === LiveScene.STREAM_PUSH && isTrue(ce.pushStatus)) && this._queryVideoUrl(), this._clearDurationInterval(), this.setState({
            initVideoPlayer: "",
            streamId: 0,
            errorWatchLock: !1,
            currentTrailerAddr: {},
            currentPlayType: VideoPlayType.INIT
          });
        });
      } catch (ce) {
      }
    });
  }
  init(T, F, $, J, ee) {
    return Me(this, null, function* () {
      var ne, oe, se, le;
      const { playerDomId: de, autoplay: ce, mute: he } = ee || {};
      if (this.setState({
        detailData: T || {},
        showMaskPlayer: isTrue(F),
        trailerVideoShowFlag: isTrue(T == null ? void 0 : T.videoShowFlag),
        doubleSpeedFlag: isTrue(T == null ? void 0 : T.doublePlaybackFlag),
        progressBarFlag: isTrue(T == null ? void 0 : T.dragPlaybackFlag),
        loopPlaybackFlag: isTrue(T == null ? void 0 : T.videoLoopPlaybackFlag),
        barrageShowRegion: (T == null ? void 0 : T.barrageShowRegion) || BarrageRange.FULL,
        playerDomId: de,
        xp2pAppId: (ne = $ == null ? void 0 : $.xp2pAppId) != null ? ne : "",
        cloudAppId: (oe = $ == null ? void 0 : $.cloudAppId) != null ? oe : "",
        autoplay: ce != null ? ce : !0,
        mute: he != null ? he : !1
      }), setCurLangPlayerBg(), !!de) {
        barrageModel.init(T, J), this._onWsLiveStatus(), this._onWsPushLiveStatus(), this._onWsRoomConfigs(), this._onWsLoopPlaybackFlag(), this._dispatchDurationDots(0, "INIT");
        try {
          const { roomId: ve } = roomModel.state, { eventId: ge } = eventModel.state, { adShowFlag: be, adMediaId: Te } = T || {};
          if (isTrue(be) && Te)
            try {
              const Se = yield httpGetRoomMediaUrl(ge, ve, Te, RoomMediaSourceType.AD), Ie = ((se = Se == null ? void 0 : Se.data) == null ? void 0 : se.data) || {};
              Ie != null && Ie.mediaUrl ? (this.setState((Oe) => {
                Oe.detailData.adMediaUrl = Ie.mediaUrl;
              }), this._createPlayer(VideoPlayType.AD), this.setState({ currentPlayType: VideoPlayType.AD })) : roomModel.state.liveStatus !== LiveStatus.LIVING && (Ie == null ? void 0 : Ie.responseCode) === MediaResourceCode.RESOURCE_STOCK_IS_EMPTY && this._emitMediaResourceIsEmpty(MediaType.VOD);
            } catch (Se) {
            }
          if ((roomModel.state.liveScene === LiveScene.STREAM_PUSH || roomModel.state.liveStatus === LiveStatus.LIVING && this.state.currentPlayType === VideoPlayType.INIT) && this._queryVideoUrl(), isTrue(T == null ? void 0 : T.videoShowFlag)) {
            const Se = yield httpGetTrailerVideo(ge, ve), Ie = ((le = Se == null ? void 0 : Se.data) == null ? void 0 : le.data) || [];
            this.setState({
              trailerVideoList: Ie,
              currentTrailerAddr: Ie[0] || {}
            }), this.state.currentPlayType === VideoPlayType.INIT && roomModel.state.liveStatus !== LiveStatus.LIVING && this.state.trailerVideoList.length && this._updateTrailerUrl(Ie[0]);
          }
        } catch (ve) {
        }
      }
    });
  }
  setCurLangPlayerBgUrlState(T) {
    var F, $;
    this.setState({
      curLangPlayerBgUrl: T
    }), this.state.currentPlayType === VideoPlayType.LIVE && (($ = (F = this.state.initVideoPlayer) == null ? void 0 : F.setImage) == null || $.call(F, T));
  }
  _restartDetect() {
    if ([VideoPlayType.AD, VideoPlayType.TRAILER, VideoPlayType.MENU_VIDEO].includes(this.state.currentPlayType))
      return;
    const { videoStreamDetect: T } = this.state, F = this._getCurrentLiveUrl();
    if (T && T.stop && T.stop(), !F) {
      console.warn("empty live stream file");
      return;
    }
    if (roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY) {
      this._exitFullScreen(() => {
        this.state.initVideoPlayer && this.state.initVideoPlayer.remove(), this._createPlayer();
      });
      return;
    }
    let $ = 0;
    const J = 2e3, ee = 1e4, ne = new HttpStreamDetect(F, 10);
    this.setState({ videoStreamDetect: ne }), ne.on(DETECT_RESULT_EVENT, (oe) => {
      const { initVideoPlayer: se } = this.state;
      $ += 1;
      const { current: le } = oe;
      if (le) {
        ne.stop(), this._exitFullScreen(() => {
          se && se.remove(), this._createPlayer();
        });
        return;
      }
      $ > 18 ? ne.stop() : $ > 15 ? ne.setGap(ee) : $ > 1 && ne.setGap(J);
    }), ne.start();
  }
  _setCurrentLiveAddr(T) {
    this.setState({ currentLiveAddr: T });
  }
  _getFullscreenEmulation() {
    return isMobile ? this.state.detailData.fullScreenType === FullScreenType.FAKE : !1;
  }
  _dispatchDurationDots(T, F) {
    const { streamId: $, currentPlayType: J, currentLiveAddr: ee, detailData: ne, durationValueFlag: oe } = this.state, { roomId: se, pageSession: le, roomMode: de } = roomModel.state, { liveScene: ce, liveDelay: he } = roomModel.state, { eventId: ve, eventName: ge } = eventModel.state, { userId: be, tenantId: Te, nickName: Se } = userModel.state;
    let Ie = $;
    ce === LiveScene.STREAM_PUSH && (Ie = ee.streamId), httpPostDurationDots({
      roomId: se,
      virtualEventId: ve,
      virtualEventName: ge || "",
      pageSession: le,
      streamId: Ie,
      userId: be,
      tenantId: Te,
      liveScene: ce,
      nickName: Se,
      duration: oe ? T : 0,
      actionType: DotType[F || J],
      pageSourceType: WatchPageSourceType[J],
      mediaId: ne == null ? void 0 : ne.adMediaId,
      liveDelay: he,
      roomMode: de
    }).catch(() => {
    });
  }
  _setDurationValueFlag() {
    var T, F;
    const { currentPlayType: $, initVideoPlayer: J } = this.state;
    ["paused", "idle"].includes((T = J == null ? void 0 : J.getState) == null ? void 0 : T.call(J)) ? [VideoPlayType.AD, VideoPlayType.TRAILER, VideoPlayType.MENU_VIDEO].includes($) || $ === VideoPlayType.LIVE && roomModel.state.liveStatus !== LiveStatus.LIVING ? this.setState({ durationValueFlag: !1 }) : ((F = J == null ? void 0 : J.getState) == null ? void 0 : F.call(J)) === "idle" ? this.setState({ durationValueFlag: !1 }) : this.setState({ durationValueFlag: !0 }) : this.setState({ durationValueFlag: !0 });
  }
  _durationInterval() {
    this._clearDurationInterval(), this._setDurationValueFlag(), __privateSet(this, _durationTimer, setInterval(() => {
      __privateSet(this, _durationCount, __privateGet(this, _durationCount) + 1), __privateGet(this, _durationCount) === 10 && (this._dispatchDurationDots(10), __privateSet(this, _durationCount, 0));
    }, 1e3));
  }
  _clearDurationInterval() {
    var T;
    __privateGet(this, _durationCount) > 0 && ((T = lsGetEventToken()) == null ? void 0 : T.accessToken) && this._dispatchDurationDots(__privateGet(this, _durationCount)), __privateSet(this, _durationCount, 0), clearInterval(__privateGet(this, _durationTimer));
  }
  destroy() {
    barrageModel.destroy(), this._clearDurationInterval();
    const { videoStreamDetect: T } = this.state;
    T && T.stop && T.stop(), this._removePlayer(), this.setState(INITIAL_STATE$C);
  }
  _onWsLiveStatus() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.WATCH_LIVESTATUS).subscribe((F) => {
      var $;
      const { liveStatus: J } = F;
      if (roomModel._setLiveStatusState(J), J === LiveStatus.LIVING)
        [VideoPlayType.INIT, VideoPlayType.LIVE].includes(this.state.currentPlayType) && this._queryVideoUrl();
      else {
        const { initVideoPlayer: ee, currentPlayType: ne } = this.state;
        if (ne === VideoPlayType.LIVE && ee && ee.getState) {
          const oe = ee.getState();
          oe && oe === "paused" && this._durationInterval();
        }
        roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY && (ne === VideoPlayType.LIVE && this._removePlayer(), ($ = boardModel) == null || $._removePlayer());
      }
    });
  }
  _onWsPushLiveStatus() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.WATCH_PUSHLIVESTATUS).subscribe((F) => {
      const { pushStatus: $, screenId: J, streamId: ee, eventTime: ne } = F, { liveScene: oe, liveMode: se } = roomModel.state, { currentLiveAddr: le, pushStreamLiveAddr: de, currentPlayType: ce } = this.state;
      if (oe === LiveScene.STREAM_PUSH) {
        if (le.screenId === J && (!le.eventTime || Number(ne) > Number(le.eventTime))) {
          const he = Ke(Fe({}, le), {
            pushStatus: $,
            streamId: ee,
            eventTime: ne
          });
          this.setState({ currentLiveAddr: he }), isTrue($) ? (roomModel._setLiveStatusState(LiveStatus.LIVING), [VideoPlayType.INIT, VideoPlayType.LIVE].includes(this.state.currentPlayType) && this._queryVideoUrl()) : roomModel.state.liveDelay === LiveDelayEnum.NO_DELAY && ce === VideoPlayType.LIVE && this._removePlayer();
        }
        if (se === LiveMode.STREAM_PUSH_MULTI) {
          let he = !1;
          const ve = de.map((ge) => {
            const be = Fe({}, ge);
            return ge.screenId === J && (!ge.eventTime || ne > ge.eventTime) && (he = !0, be.pushStatus = $, be.streamId = ee, be.eventTime = ne), be;
          });
          if (!he)
            return;
          isTrue($) && roomModel._setLiveStatusState(LiveStatus.LIVING), this.setState({ pushStreamLiveAddr: ve });
        }
      }
    });
  }
  _onWsRoomConfigs() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.ROOM_CONFIG).subscribe((F) => {
      if (F != null && F.hasOwnProperty("liveViewPageShowFlag")) {
        const $ = isTrue(F.liveViewPageShowFlag);
        this.setState({ showMaskPlayer: $ });
        const { initVideoPlayer: J, mute: ee } = this.state;
        J && J.setMute && ($ ? J.setMute(ee) : J.setMute(!0), this._displayPlayerByDomId());
      }
    });
  }
  _onWsLoopPlaybackFlag() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.LOOP_PLAYBACK).subscribe((F) => {
      this.setState({
        loopPlaybackFlag: isTrue(F == null ? void 0 : F.videoLoopPlaybackFlag)
      });
    });
  }
}
_durationTimer = /* @__PURE__ */ new WeakMap();
_durationCount = /* @__PURE__ */ new WeakMap();
const playerModel = new PlayerModel();
var __defProp$y = Object.defineProperty, __defNormalProp$y = (e, T, F) => T in e ? __defProp$y(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$y = (e, T, F) => (__defNormalProp$y(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$B = {
  roomNumber: "",
  pageSession: "",
  roomId: 0,
  roomMode: RoomMode.LIVE,
  ws: null,
  loading: !0,
  watchBg: "",
  watchBgPc: "",
  liveStatus: LiveStatus.NOBEGIN,
  liveScene: LiveScene.LINK,
  liveMode: LiveMode.STREAM_PUSH_SINGLE,
  liveDelay: LiveDelayEnum.COMMON,
  heartbeatInter: 0,
  watchTopicType: WatchTopicTypeEnum.DEEP,
  watchBgUrlDisplay: WatchBackgroundUrlDisplayEnum.FIXED,
  watchBgColorTransitionFlag: WatchBackgroundColorTransitionEnum.NO_TRANSITION,
  moduleMoveRange: 0,
  topbarFlag: 0,
  topbarLogo: "",
  watchBgType: WatchBackgroundTypeEnum.IMAGE,
  iphoneIconFlag: !0,
  backTopFlag: !0,
  showBackTop: !1,
  userIconFlag: !0,
  watchLanguage: LanguageTypeEnum["zh-Hans"],
  watchOptionalLanguage: [],
  followSystemLanguageFlag: !0,
  remark: "",
  roomName: "",
  interacts: [],
  languages: [],
  screenOrientation: ScreenOrientationEnum.LANDSCAPE
};
class RoomModel extends Model {
  constructor() {
    super(INITIAL_STATE$B), __publicField$y(this, "KICKED_OUT", "KICKED_OUT"), __publicField$y(this, "_initLanguage", (T) => {
      const { watchOptionalLanguage: F = [], followSystemLanguageFlag: $ } = this.state;
      if (T && F.includes(LanguageTypeEnum[T])) {
        this._applyLanguage(T);
        return;
      }
      if ($) {
        const J = navigator.language.toLocaleLowerCase(), ee = Object.values(LanguageConfig).find((ne) => {
          const { language: oe, systemLangs: se } = ne, le = se.some((ce) => ce === J || J.includes(ce)), de = F.includes(LanguageTypeEnum[oe]);
          return !!(le && de);
        });
        if (ee != null && ee.language) {
          this._applyLanguage(ee.language);
          return;
        }
      }
      if (F.length > 0) {
        const J = F[0], ee = LanguageEnum[LanguageTypeEnum[J]];
        this._applyLanguage(ee);
      }
    }), __publicField$y(this, "setLanguage", (T) => {
      const { watchOptionalLanguage: F = [] } = this.state;
      let $ = LanguageEnum[LanguageTypeEnum[this.state.watchLanguage]];
      return T && F.includes(LanguageTypeEnum[T]) && (this._applyLanguage(T), $ = T), playerModel._changeLanguage(LanguageTypeEnum[$]), boardModel._changeLanguage(LanguageTypeEnum[$]), $;
    });
  }
  get ws() {
    return this.state.ws;
  }
  init(T, F) {
    return Me(this, null, function* () {
      var $;
      yield this._initBase(T);
      const { accessToken: J = "" } = lsGetEventToken() || {}, ee = [
        httpGetWatchInit(eventModel.state.eventId, T),
        this._connectWs(J).toPromise()
      ];
      try {
        const [ne] = yield Promise.all(ee);
        return this._reportHeartbeat(), this._resolveInitData(ne.data.data), this._initLanguage(F), this._onWsBanOnline(), this._onWsInteractiveAccessStatus(), this.setState({ loading: !1 }), (($ = ne == null ? void 0 : ne.data) == null ? void 0 : $.data) || {};
      } catch (ne) {
        return this.setState({ loading: !1 }), Promise.reject();
      }
    });
  }
  destroy() {
    var T;
    (T = this.ws) == null || T.close(), clearInterval(this.state.heartbeatInter), this.setState(INITIAL_STATE$B);
  }
  _initBase(T) {
    return Me(this, null, function* () {
      this.setState({ roomNumber: T });
      try {
        const $ = (yield httpGetPageInfo(T)).data.data || {}, {
          pageSession: J,
          roomId: ee
        } = $;
        this.setState({ pageSession: J, roomId: ee });
      } catch (F) {
        return console.log(F), Promise.reject(F);
      }
    });
  }
  _connectWs(T) {
    const { roomId: F, pageSession: $ } = this.state, { goImUrl: J } = eventModel.state, { promotionChannelId: ee } = userModel.state, ne = new GoimNats(), oe = Object.values(Topics).filter((se) => typeof se != "string").map((se) => `${se}`);
    return ne.connect(J, {
      accessToken: T,
      roomId: String(F),
      events: oe,
      pageSession: $,
      promotionChannelId: ee,
      pageType: "live",
      platform: "pc"
    }).pipe(
      tap((se) => {
        this.setState({
          ws: se
        });
      })
    );
  }
  _reportHeartbeat() {
    const { roomId: T, pageSession: F } = this.state, { eventId: $ } = eventModel.state;
    httpPostHeartbeat($, T, F);
    const J = window.setInterval(() => {
      httpPostHeartbeat($, T, F);
    }, 3e4);
    this.setState({ heartbeatInter: J });
  }
  _resolveInitData(T) {
    var F, $, J, ee, ne, oe, se, le, de, ce;
    const {
      watchDecorate: he,
      roomInfo: ve
    } = T, ge = he != null && he.languageSort ? he == null ? void 0 : he.languageSort.split(",") : [], be = he != null && he.watchOptionalLanguage ? ge.filter((Se) => he == null ? void 0 : he.watchOptionalLanguage.includes(Se)).map((Se) => Number(Se)) : [], Te = isTrue((F = he == null ? void 0 : he.followSystemLanguageFlag) != null ? F : 1);
    this.setState({
      loading: !1,
      watchBg: (he == null ? void 0 : he.watchBackgroundGaussianUrl) || "",
      watchBgPc: (he == null ? void 0 : he.watchBackgroundUrl) || "",
      watchTopicType: (he == null ? void 0 : he.watchBackgroundTopicType) || WatchTopicTypeEnum.DEEP,
      watchBgColor: (he == null ? void 0 : he.watchBackgroundColor) || "#dbe7f9",
      watchBgType: (he == null ? void 0 : he.watchBackgroundType) || WatchBackgroundTypeEnum.IMAGE,
      watchBgUrlDisplay: (he == null ? void 0 : he.watchBackgroundUrlDisplay) || WatchBackgroundUrlDisplayEnum.FIXED,
      watchBgColorTransitionFlag: ($ = he == null ? void 0 : he.watchBackgroundColorTransitionFlag) != null ? $ : WatchBackgroundColorTransitionEnum.TRANSITION,
      moduleMoveRange: he == null ? void 0 : he.moduleMoveRange,
      topbarFlag: he == null ? void 0 : he.topbarFlag,
      topbarLogo: he == null ? void 0 : he.topbarLogo,
      liveScene: ve == null ? void 0 : ve.liveScene,
      liveMode: ve == null ? void 0 : ve.liveMode,
      liveDelay: ve == null ? void 0 : ve.liveDelay,
      liveStatus: ve == null ? void 0 : ve.liveStatus,
      roomMode: (J = ve == null ? void 0 : ve.roomMode) != null ? J : RoomMode.LIVE,
      remark: (ee = ve == null ? void 0 : ve.remark) != null ? ee : "",
      roomName: (ne = ve == null ? void 0 : ve.roomName) != null ? ne : "",
      iphoneIconFlag: isTrue((oe = he == null ? void 0 : he.iphoneIconFlag) != null ? oe : 1),
      backTopFlag: isTrue((se = he == null ? void 0 : he.backTopFlag) != null ? se : 1),
      userIconFlag: isTrue((le = he == null ? void 0 : he.userIconFlag) != null ? le : 1),
      watchOptionalLanguage: be,
      followSystemLanguageFlag: Te,
      languages: (de = ve == null ? void 0 : ve.languages) != null ? de : [],
      screenOrientation: (ce = he == null ? void 0 : he.screenOrientation) != null ? ce : ScreenOrientationEnum.LANDSCAPE
    });
  }
  _applyLanguage(T) {
    instance.changeLanguage(T), this.setState({ watchLanguage: LanguageTypeEnum[T] });
    const { languages: F } = this.state;
    this.setState({
      remark: getI18nRemark(LanguageTypeEnum[T], F),
      roomName: getI18nRoomName(LanguageTypeEnum[T], F)
    }), menuModel._updateMenuList();
  }
  _onWsBanOnline() {
    var T;
    (T = this.state.ws) == null || T.from(Topics.WATCH_BAN_STATUS).subscribe((F) => {
      (F == null ? void 0 : F.type) === BanType.BAN_ONLINE && (console.log("[ws]WATCH_BAN_STATUS:", F), watchModel.destroy(), this.emit(this.KICKED_OUT));
    });
  }
  _onWsInteractiveAccessStatus() {
    var T;
    (T = this.state.ws) == null || T.from(Topics.INTERACTIVE_ACCESS_FLAG).subscribe((F) => {
      eventModel._setInteractAccessFlagState(isTrue(F == null ? void 0 : F.interactAccessFlag));
    });
  }
  _setRoomNumberState(T) {
    this.setState({ roomNumber: T });
  }
  _setLiveStatusState(T) {
    this.setState({ liveStatus: T });
  }
}
const roomModel = new RoomModel();
class WatchPageSessionStorage extends LRULocalStorage {
  getDataKey() {
    const { eventNumber: T } = eventModel.state, { roomNumber: F } = roomModel.state;
    return T && F ? `${T}-${F}` : "";
  }
}
const STORE_KEY = "landing:pageSession", watchPageSessionStorage = new WatchPageSessionStorage(STORE_KEY);
var __defProp$x = Object.defineProperty, __defNormalProp$x = (e, T, F) => T in e ? __defProp$x(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$x = (e, T, F) => (__defNormalProp$x(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$A = {
  _ramWatchPageSession: "",
  _timer: void 0
};
class PageSessionModel extends Model {
  constructor() {
    super(INITIAL_STATE$A), __publicField$x(this, "_VALIDATE_SESSTION_DURATION", 5 * 1e3);
  }
  init() {
    this._setWatchPageSession(), this._startValidateTimer();
  }
  destroy() {
    this.setState({ _ramWatchPageSession: "" }), this._stopValidateTimer();
  }
  _setWatchPageSession() {
    const T = getRandomString();
    watchPageSessionStorage.set(T), this.setState({ _ramWatchPageSession: T });
  }
  _startValidateTimer() {
    const T = window.setInterval(() => {
      const { _ramWatchPageSession: F } = this.state, $ = watchPageSessionStorage.get();
      F && F !== $ && (this._stopValidateTimer(), console.error("pageSession MULTI_TABS"), accessModel.destroy(), watchModel.destroy(), messageModel.emit(messageModel.MULTI_TABS));
    }, this._VALIDATE_SESSTION_DURATION);
    this.setState({ _timer: T });
  }
  _stopValidateTimer() {
    window.clearInterval(this.state._timer), this.setState({ _timer: void 0 });
  }
}
const pageSessionModel = new PageSessionModel();
var debounce = debounce_1, isObject$1 = isObject_1, FUNC_ERROR_TEXT = "Expected a function";
function throttle(e, T, F) {
  var $ = !0, J = !0;
  if (typeof e != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return isObject$1(F) && ($ = "leading" in F ? !!F.leading : $, J = "trailing" in F ? !!F.trailing : J), debounce(e, T, {
    leading: $,
    maxWait: T,
    trailing: J
  });
}
var throttle_1 = throttle;
const { VITE_API_HOST: VITE_API_HOST$1 } = { VITE_APP_ENV: "prod", VITE_API_HOST: "https://api.event.mudu.com", VITE_APPKEY: "MDNPvWWWJfj42zAiEr1", VITE_SECRET_KEY: "oF8qiy35irUxRSWLu2dasW8P9nMYrwmCo3RcOp2QQzoNdyTCHU4EDBQGhONsFGci", VITE_USER_NODE_ENV: "production", BASE_URL: "/", MODE: "lib", DEV: !1, PROD: !0 }, apiHostMap = {
  [ApiHostEnum.UAT]: "https://mdn-api.uat.mudu.tv",
  [ApiHostEnum.SG]: "https://api-sg.event.mudu.com"
};
function getApiHost(e) {
  var T;
  return (T = apiHostMap[e]) != null ? T : VITE_API_HOST$1;
}
var HttpGetOnlineChatsQueryFlag = /* @__PURE__ */ ((e) => (e[e.CHAT = 0] = "CHAT", e[e.TOP = 1] = "TOP", e))(HttpGetOnlineChatsQueryFlag || {}), BulletCheckStatus = /* @__PURE__ */ ((e) => (e[e.NO_BULLET = 0] = "NO_BULLET", e[e.NO_REQUIRED = 1] = "NO_REQUIRED", e[e.UNCHECKED = 2] = "UNCHECKED", e[e.APPROVED = 3] = "APPROVED", e[e.NOT_APPROVED = 4] = "NOT_APPROVED", e))(BulletCheckStatus || {}), ChatCheckStatus = /* @__PURE__ */ ((e) => (e[e.UNCHECKED = 0] = "UNCHECKED", e[e.APPROVED = 1] = "APPROVED", e[e.NOT_APPROVED = 2] = "NOT_APPROVED", e[e.NO_REQUIRED = 3] = "NO_REQUIRED", e))(ChatCheckStatus || {}), ChatType = /* @__PURE__ */ ((e) => (e[e.COMMON = 1] = "COMMON", e[e.REPLY_PUBLIC = 2] = "REPLY_PUBLIC", e[e.ANONYMOUS = 3] = "ANONYMOUS", e))(ChatType || {}), ChatContentType = /* @__PURE__ */ ((e) => (e[e.TEXT = 1] = "TEXT", e[e.IMAGE = 2] = "IMAGE", e[e.RED_PACKET = 3] = "RED_PACKET", e[e.EMOTICON_IMAGE = 4] = "EMOTICON_IMAGE", e))(ChatContentType || {});
function httpGetOnlineChats(e, T, F) {
  return request$1.get(
    `/interact/sdk/events/${e}/rooms/${T}/chats`,
    {
      params: F,
      baseURL: getApiHost(_apiHost)
    }
  );
}
var WsChatListUpdateTypes = /* @__PURE__ */ ((e) => (e[e.ADD = 1] = "ADD", e[e.TOP = 2] = "TOP", e[e.DELETE = 3] = "DELETE", e[e.CHAT_APPROVED = 4] = "CHAT_APPROVED", e[e.BULLET_APPROVED = 5] = "BULLET_APPROVED", e[e.CHAT_BULLET_APPROVED = 6] = "CHAT_BULLET_APPROVED", e))(WsChatListUpdateTypes || {});
function httpPostOnlineChat(e, T, F, $) {
  return request$1.post(
    `/interact/sdk/events/${e}/rooms/${T}/chats`,
    Ke(Fe({}, $), {
      pageSession: F
    }),
    {
      baseURL: getApiHost(_apiHost)
    }
  );
}
const INITIAL_STATE$z = {
  chatWindowShowFlag: !0,
  chatFlag: !0,
  chatHistoryClearFlag: !1,
  chatCheckFlag: !1,
  audienceShowUncheckChatFlag: !1,
  anonymousChatFlag: !1,
  banChatFlag: !1,
  avatar: "",
  title: ""
};
class ChatRoomModel extends Model {
  constructor() {
    super(INITIAL_STATE$z);
  }
  init(T) {
    return Me(this, null, function* () {
      var F, $, J, ee, ne, oe, se, le, de;
      const { watchDecorate: ce, roomConfig: he, onlineUserBO: ve } = T || {};
      this.setState({
        chatWindowShowFlag: isTrue((F = ce == null ? void 0 : ce.chatWindowShowFlag) != null ? F : 0),
        chatFlag: isTrue(($ = he == null ? void 0 : he.chatFlag) != null ? $ : 0),
        chatHistoryClearFlag: isTrue((J = he == null ? void 0 : he.chatHistoryClearFlag) != null ? J : 0),
        chatCheckFlag: isTrue((ee = he == null ? void 0 : he.chatCheckFlag) != null ? ee : 0),
        audienceShowUncheckChatFlag: isTrue((ne = he == null ? void 0 : he.audienceShowUncheckChatFlag) != null ? ne : 0),
        anonymousChatFlag: isTrue((oe = he == null ? void 0 : he.anonymousChatFlag) != null ? oe : 0),
        banChatFlag: isTrue((se = ve == null ? void 0 : ve.banChatFlag) != null ? se : 0),
        avatar: (le = ve == null ? void 0 : ve.avatar) != null ? le : "",
        title: (de = ve == null ? void 0 : ve.title) != null ? de : ""
      }), this._onWsRoomConfigs(), this._onWsUserConfig();
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$z);
  }
  _onWsRoomConfigs() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.ROOM_CONFIG).subscribe((F) => {
      this.setState(($) => {
        F.hasOwnProperty("chatWindowShowFlag") && ($.chatWindowShowFlag = isTrue(F.chatWindowShowFlag)), F.hasOwnProperty("chatFlag") && ($.chatFlag = isTrue(F.chatFlag)), F.hasOwnProperty("anonymousChatFlag") && ($.anonymousChatFlag = isTrue(F.anonymousChatFlag), isTrue(F.anonymousChatFlag) || listModel$1.setAnonymousFlag(!1)), F.hasOwnProperty("chatHistoryClearFlag") && ($.chatHistoryClearFlag = isTrue(F.chatHistoryClearFlag)), F.hasOwnProperty("chatCheckFlag") && ($.chatCheckFlag = isTrue(F.chatCheckFlag)), F.hasOwnProperty("audienceShowUncheckChatFlag") && ($.audienceShowUncheckChatFlag = isTrue(F.audienceShowUncheckChatFlag));
      });
    });
  }
  _onWsUserConfig() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.MESSAGE_USER_CONFIG).subscribe((F) => {
      const { userId: $ } = userModel.state;
      if (F.type === WsUserConfigsResType.SILENCE) {
        const {
          onlineUserId: J,
          banChatFlag: ee = 0
        } = F.data;
        J === $ && this.setState({
          banChatFlag: isTrue(ee)
        });
      }
    });
  }
}
const chatRoomModel = new ChatRoomModel(), MAXMESSAGENUM = 850;
function unique(e, T) {
  const F = /* @__PURE__ */ new Map();
  return e.filter(($) => {
    if (T && !$[T])
      return !0;
    const J = T ? $[T] : $;
    return J && !F.has(J) && F.set(J, 1);
  });
}
function findIndeies(e, T, F) {
  const $ = [], J = Array.isArray(F) ? F : [F];
  return e.forEach((ee, ne) => {
    J.includes(ee[T]) && $.push(ne);
  }), $;
}
function adaptChatList(e) {
  return e.map((T) => {
    var F, $, J, ee, ne, oe, se, le, de, ce, he, ve, ge, be, Te, Se, Ie, Oe, Le;
    return {
      onlineChatId: (F = T.onlineChatId) != null ? F : 0,
      onlineUserId: ($ = T.onlineUserId) != null ? $ : 0,
      liveUserId: (J = T.liveUserId) != null ? J : 0,
      userType: (ee = T.userType) != null ? ee : OnlineUserType.ANONYMOUS_AUDIENCE,
      nickname: (ne = T.nickname) != null ? ne : "",
      title: (oe = T.title) != null ? oe : "",
      avatar: (se = T.avatar) != null ? se : "",
      topFlag: isTrue((le = T.topFlag) != null ? le : 0),
      checkFlag: (de = T.checkFlag) != null ? de : ChatCheckStatus.NO_REQUIRED,
      bulletCommentFlag: (ce = T.bulletCommentFlag) != null ? ce : BulletCheckStatus.NO_REQUIRED,
      chatContent: (he = T.chatContent) != null ? he : "",
      contentType: (ve = T.contentType) != null ? ve : ChatContentType.TEXT,
      chatTime: (ge = T.chatTime) != null ? ge : 0,
      chatType: (be = T.chatType) != null ? be : ChatType.COMMON,
      replyChatId: (Te = T.replyChatId) != null ? Te : 0,
      replyNickname: (Se = T.replyNickname) != null ? Se : "",
      replyChatContent: (Ie = T.replyChatContent) != null ? Ie : "",
      replyContentType: (Oe = T.replyContentType) != null ? Oe : ChatContentType.TEXT,
      pageSession: (Le = T.pageSession) != null ? Le : "",
      languages: T.languages || []
    };
  });
}
function polishChatList(e) {
  let T = unique(e, "onlineChatId").sort((F, $) => {
    var J, ee;
    return ((J = F.chatTime) != null ? J : 0) - ((ee = $.chatTime) != null ? ee : 0);
  });
  return T.length > MAXMESSAGENUM && (T = T.slice(T.length - MAXMESSAGENUM)), T;
}
function isSameOne(e) {
  const {
    otherPageSession: T,
    otherUserId: F,
    userId: $,
    pageSession: J
  } = e;
  return !!(T && T === J || !T && $ === F);
}
var __defProp$w = Object.defineProperty, __defNormalProp$w = (e, T, F) => T in e ? __defProp$w(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$w = (e, T, F) => (__defNormalProp$w(e, typeof T != "symbol" ? T + "" : T, F), F);
const PERPAGE = 30;
var CHAT_LIST_UPDATE_DIRECTION = /* @__PURE__ */ ((e) => (e[e.HEAD = 0] = "HEAD", e[e.TAIL = 1] = "TAIL", e))(CHAT_LIST_UPDATE_DIRECTION || {});
const INITIAL_STATE$y = {
  loading: !1,
  chatList: [],
  chatListLength: 0,
  total: 0,
  page: 1,
  perPage: PERPAGE,
  sending: !1,
  sendChatType: ChatType.COMMON,
  hasClearedAllChats: !1
};
class ListModel$1 extends Model {
  constructor() {
    super(INITIAL_STATE$y), __publicField$w(this, "CHAT_LIST_UPDATED", "CHAT_LIST_UPDATED"), __publicField$w(this, "CHAT_SEND_CHECKING", "CHAT_SEND_CHECKING"), __publicField$w(this, "fetchHistory", throttle_1(() => Me(this, null, function* () {
      return this.state.hasClearedAllChats ? Promise.reject() : this._fetchChats().then((T) => (chatModel.emit(this.CHAT_LIST_UPDATED, {
        isFirst: !1,
        direction: 0,
        chatList: this.state.chatList
      }), T));
    }), 1e3, { trailing: !1 })), __publicField$w(this, "setAnonymousFlag", (T) => {
      this.setState({
        sendChatType: T ? ChatType.ANONYMOUS : ChatType.COMMON
      });
    }), __publicField$w(this, "sendChat", (T) => Me(this, null, function* () {
      const { userId: F } = userModel.state;
      yield userModel._interceptAnonymous(InteractionType.CHAT);
      const { sending: $, sendChatType: J } = this.state;
      if (!T || !J)
        return Promise.reject("Need chat content");
      if ($)
        return Promise.reject("Sending chat");
      const { eventId: ee } = eventModel.state, { roomId: ne, pageSession: oe } = roomModel.state;
      return this.setState({ sending: !0 }), httpPostOnlineChat(ee, ne, oe, {
        chatType: J,
        contentType: ChatContentType.TEXT,
        chatContent: T
      }).then(({ data: se }) => {
        var le;
        const { avatar: de, title: ce, chatCheckFlag: he, audienceShowUncheckChatFlag: ve } = chatRoomModel.state, { nickName: ge, anonymousNickname: be } = userModel.state;
        if (this.setState({ sending: !1 }), he && !ve) {
          chatModel.emit(this.CHAT_SEND_CHECKING);
          return;
        }
        const Te = (le = adaptChatList([se == null ? void 0 : se.data])[0]) != null ? le : {}, {
          chatType: Se,
          bulletCommentFlag: Ie,
          chatContent: Oe,
          contentType: Le,
          nickname: Ne
        } = Te;
        this._pushList([Ke(Fe({}, Te), {
          avatar: de,
          title: ce,
          nickname: Se === ChatType.ANONYMOUS ? be : ge
        })]);
        const Ue = ve && Te.onlineUserId === F;
        Oe && Le === ChatContentType.TEXT && Ie === BulletCheckStatus.NO_REQUIRED && (Te.checkFlag === ChatCheckStatus.APPROVED || Te.checkFlag === ChatCheckStatus.NO_REQUIRED || Ue) && playerSdkModel.emitBarrage(T, Ne);
      }).catch((se) => (this.setState({ sending: !1 }), Promise.reject(se)));
    })), __publicField$w(this, "clearAllChats", () => {
      this.setState({
        chatList: [],
        hasClearedAllChats: !0
      });
    });
  }
  init() {
    return Me(this, null, function* () {
      this._onWsChatListUpdate(), this._onWsChatOperation(), this._onWsTopListUpdate(), yield this._fetchChats(), chatModel.emit(this.CHAT_LIST_UPDATED, {
        isFirst: !0,
        direction: 0,
        chatList: this.state.chatList
      });
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$y);
  }
  _fetchChats() {
    return Me(this, null, function* () {
      var T, F;
      const { roomId: $ } = roomModel.state, { eventId: J } = eventModel.state, { page: ee, perPage: ne, chatList: oe, loading: se, total: le } = this.state, de = ee === 1;
      if (se)
        return Promise.reject("Duplicate fetching chat list");
      if (!de && (oe.length >= le || oe.length >= MAXMESSAGENUM))
        return Promise.reject("No more chat");
      this.setState({ loading: !0 });
      const ce = (F = (T = oe.find((he) => he == null ? void 0 : he.onlineChatId)) == null ? void 0 : T.onlineChatId) != null ? F : 0;
      return httpGetOnlineChats(J, $, {
        sinceId: ce,
        limit: ne,
        topFlag: HttpGetOnlineChatsQueryFlag.CHAT
      }).then(({ data: he }) => {
        var ve;
        const ge = ((ve = he == null ? void 0 : he.data) == null ? void 0 : ve.items) || [], { total: be } = he.data, Te = adaptChatList(ge);
        return this.setState({
          page: ee + 1,
          total: be,
          loading: !1
        }), this._unshiftList(Te), Te;
      }).catch((he) => (this.setState({ loading: !1 }), Promise.reject(he)));
    });
  }
  _onWsChatListUpdate() {
    const { ws: T, pageSession: F } = roomModel.state, { userId: $ } = userModel.state;
    T == null || T.from(Topics.MESSAGE_UPDATE).pipe(
      filter(({ type: J }) => J === WsChatListUpdateTypes.ADD || J === WsChatListUpdateTypes.CHAT_APPROVED || J === WsChatListUpdateTypes.CHAT_BULLET_APPROVED),
      filter((J) => {
        var ee;
        const { operatorUserId: ne, pageSession: oe } = J, { displayFlag: se = 0 } = (ee = J.data) != null ? ee : {};
        return !isSameOne({ otherPageSession: oe, otherUserId: ne, pageSession: F, userId: $ }) || isTrue(se);
      }),
      map$1(({ data: J }) => J),
      bufferTime(500),
      map$1((J) => adaptChatList(J)),
      filter((J) => J.length > 0)
    ).subscribe((J) => {
      J.forEach((ee) => {
        this.state.chatList.find((ne) => ne.onlineChatId === ee.onlineChatId) ? ee.checkFlag === ChatCheckStatus.NOT_APPROVED ? this._deleteChat(ee.onlineChatId) : this._setChat(ee.onlineChatId, { checkFlag: ee.checkFlag }) : (ee.checkFlag === ChatCheckStatus.APPROVED || ee.checkFlag === ChatCheckStatus.NO_REQUIRED) && this._pushList([ee]);
      });
    });
  }
  _onWsChatOperation() {
    const { ws: T, pageSession: F } = roomModel.state, { userId: $ } = userModel.state;
    T == null || T.from(Topics.MESSAGE_UPDATE).pipe(
      filter(({ operatorUserId: J, pageSession: ee }) => !isSameOne({ otherPageSession: ee, otherUserId: J, pageSession: F, userId: $ }))
    ).subscribe((J) => {
      const { type: ee, data: ne } = J, { bulletCommentFlag: oe, chatContent: se, contentType: le, nickname: de } = ne != null ? ne : {};
      ((ee === WsChatListUpdateTypes.ADD || ee === WsChatListUpdateTypes.CHAT_APPROVED) && oe === BulletCheckStatus.NO_REQUIRED || ee === WsChatListUpdateTypes.BULLET_APPROVED || ee === WsChatListUpdateTypes.CHAT_BULLET_APPROVED) && se && le === ChatContentType.TEXT && (ne.checkFlag === ChatCheckStatus.APPROVED || ne.checkFlag === ChatCheckStatus.NO_REQUIRED) && playerSdkModel.emitBarrage(se, de), ee === WsChatListUpdateTypes.DELETE && this._deleteChat(ne.onlineChatId);
    });
  }
  _onWsTopListUpdate() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.TOP_MESSAGE_UPDATE).pipe().subscribe((F) => {
      const { updateDataDTO: $ } = F, { removeTopChatIds: J = [], topChatIds: ee = [] } = $, ne = J.map((se) => se.onlineChatId), oe = ee.map((se) => se.onlineChatId);
      this._setChat(ne, { topFlag: !1 }), this._setChat(oe, { topFlag: !0 });
    });
  }
  _pushList(T) {
    const { chatList: F } = this.state, $ = polishChatList([...F, ...T]);
    this.setState({
      chatList: $,
      chatListLength: $.length
    }), chatModel.emit(this.CHAT_LIST_UPDATED, {
      isFirst: !1,
      direction: 1,
      chatList: this.state.chatList
    });
  }
  _unshiftList(T) {
    const { chatList: F } = this.state, $ = polishChatList([...T, ...F]);
    this.setState({
      chatList: $,
      chatListLength: $.length
    });
  }
  _deleteChat(T) {
    this.setState((F) => {
      F.chatList = F.chatList.filter(({ onlineChatId: $ }) => T !== $), F.chatListLength = F.chatList.length;
    });
  }
  _setChat(T, F) {
    const $ = findIndeies(this.state.chatList, "onlineChatId", T);
    $.length <= 0 || this.setState((J) => {
      $.forEach((ee) => {
        J.chatList[ee] = Fe(Fe({}, J.chatList[ee]), F);
      });
    });
  }
  getI18nTitle(T, F) {
    var $, J;
    const ee = findFinalLangFun(T, (ne) => F.some((oe) => oe.languageType === ne));
    return (J = ($ = F.find((ne) => ne.languageType === ee)) == null ? void 0 : $.title) != null ? J : "";
  }
}
const listModel$1 = new ListModel$1();
var __defProp$v = Object.defineProperty, __defNormalProp$v = (e, T, F) => T in e ? __defProp$v(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$v = (e, T, F) => (__defNormalProp$v(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$x = {
  loading: !1,
  topList: []
};
class TopModel extends Model {
  constructor() {
    super(INITIAL_STATE$x), __publicField$v(this, "TOP_LIST_UPDATED", "TOP_LIST_UPDATED");
  }
  init() {
    return Me(this, null, function* () {
      this._fetchTops(), this._onWsTopListUpdate();
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$x);
  }
  _fetchTops() {
    return Me(this, null, function* () {
      const { roomId: T } = roomModel.state, { eventId: F } = eventModel.state;
      return this.setState({ loading: !0 }), httpGetOnlineChats(F, T, {
        sinceId: 0,
        limit: 10,
        topFlag: HttpGetOnlineChatsQueryFlag.TOP
      }).then(({ data: $ }) => {
        var J;
        const ee = ((J = $ == null ? void 0 : $.data) == null ? void 0 : J.items) || [], ne = adaptChatList(ee);
        this.setState({
          loading: !1,
          topList: ne
        });
      }).catch(($) => (this.setState({ loading: !1 }), Promise.reject($)));
    });
  }
  _onWsTopListUpdate() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.TOP_MESSAGE_UPDATE).subscribe(() => {
      this._fetchTops(), this.emit(this.TOP_LIST_UPDATED);
    });
  }
}
const topModel = new TopModel();
var EmoticonType = /* @__PURE__ */ ((e) => (e[e.EMOJI = 1] = "EMOJI", e[e.IMAGE = 2] = "IMAGE", e))(EmoticonType || {});
const MIN_COUNT = 1, MAX_COUNT = 75, STATIC_PREFIX = "https://static.mudu.tv/assets/face/", EXTENSION = ".png", getDefaultEmoticons = () => {
  const e = [];
  for (let T = MIN_COUNT; T <= MAX_COUNT; T++)
    e.push({
      emoticonId: T,
      visitUrl: STATIC_PREFIX + T + EXTENSION,
      sequence: T + 1,
      label: `[em_${T != null ? T : 0}]`
    });
  return e;
}, DEFAULT_EMOTICON_LIBRARY = {
  emoticonLibraryId: 1e3,
  emoticonLibraryName: "\u7CFB\u7EDF\u8868\u60C5\u5305",
  currentEmoticonType: EmoticonType.EMOJI,
  emoticons: getDefaultEmoticons()
}, INITIAL_STATE$w = {
  loading: !1,
  emoticonLibraryId: DEFAULT_EMOTICON_LIBRARY.emoticonLibraryId,
  emoticonLibraryName: DEFAULT_EMOTICON_LIBRARY.emoticonLibraryName,
  currentEmoticonType: DEFAULT_EMOTICON_LIBRARY.currentEmoticonType,
  emoticons: DEFAULT_EMOTICON_LIBRARY.emoticons
};
class EmoticonModel extends Model {
  constructor() {
    super(INITIAL_STATE$w);
  }
  init(T) {
    return Me(this, null, function* () {
      this._resolveEmoticonData(T);
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$w);
  }
  _resolveEmoticonData(T) {
    var F;
    if (T === null)
      return;
    const {
      emoticonLibraryId: $ = -1,
      emoticonLibraryName: J = "",
      currentEmoticonType: ee = EmoticonType.EMOJI
    } = T != null ? T : {}, ne = ((F = T == null ? void 0 : T.emoticons) != null ? F : []).map((oe) => {
      var se, le, de, ce;
      return {
        emoticonId: (se = oe.emoticonId) != null ? se : -1,
        visitUrl: (le = oe.visitUrl) != null ? le : "",
        sequence: (de = oe.sequence) != null ? de : 0,
        label: `[em_${(ce = oe.emoticonId) != null ? ce : 0}]`
      };
    });
    this.setState({
      emoticonLibraryId: $,
      emoticonLibraryName: J,
      currentEmoticonType: ee,
      emoticons: ne
    });
  }
}
const emoticonModel = new EmoticonModel();
var __defProp$u = Object.defineProperty, __defNormalProp$u = (e, T, F) => T in e ? __defProp$u(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$u = (e, T, F) => (__defNormalProp$u(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$v = {};
class ChatModel extends Model {
  constructor() {
    super(INITIAL_STATE$v), __publicField$u(this, "CHAT_LIST_UPDATE_DIRECTION", CHAT_LIST_UPDATE_DIRECTION), __publicField$u(this, "CHAT_LIST_UPDATED", listModel$1.CHAT_LIST_UPDATED), __publicField$u(this, "CHAT_SEND_CHECKING", listModel$1.CHAT_SEND_CHECKING), __publicField$u(this, "chatWindowShowFlag", modelStateGetter(chatRoomModel, "chatWindowShowFlag")), __publicField$u(this, "chatFlag", modelStateGetter(chatRoomModel, "chatFlag")), __publicField$u(this, "chatHistoryClearFlag", modelStateGetter(chatRoomModel, "chatHistoryClearFlag")), __publicField$u(this, "chatCheckFlag", modelStateGetter(chatRoomModel, "chatCheckFlag")), __publicField$u(this, "audienceShowUncheckChatFlag", modelStateGetter(chatRoomModel, "audienceShowUncheckChatFlag")), __publicField$u(this, "anonymousChatFlag", modelStateGetter(chatRoomModel, "anonymousChatFlag")), __publicField$u(this, "banChatFlag", modelStateGetter(chatRoomModel, "banChatFlag")), __publicField$u(this, "avatar", modelStateGetter(chatRoomModel, "avatar")), __publicField$u(this, "title", modelStateGetter(chatRoomModel, "title")), __publicField$u(this, "listLoading", modelStateGetter(listModel$1, "loading")), __publicField$u(this, "chatList", modelStateGetter(listModel$1, "chatList")), __publicField$u(this, "chatListLength", modelStateGetter(listModel$1, "chatListLength")), __publicField$u(this, "sending", modelStateGetter(listModel$1, "sending")), __publicField$u(this, "anonymousFlag", modelStateGetter(listModel$1, "sendChatType", (T) => T === ChatType.ANONYMOUS)), __publicField$u(this, "emoticonLibraryId", modelStateGetter(emoticonModel, "emoticonLibraryId")), __publicField$u(this, "emoticonLibraryName", modelStateGetter(emoticonModel, "emoticonLibraryName")), __publicField$u(this, "currentEmoticonType", modelStateGetter(emoticonModel, "currentEmoticonType")), __publicField$u(this, "emoticons", modelStateGetter(emoticonModel, "emoticons")), __publicField$u(this, "topLoading", modelStateGetter(topModel, "loading")), __publicField$u(this, "topList", modelStateGetter(topModel, "topList")), __publicField$u(this, "fetchHistory", listModel$1.fetchHistory), __publicField$u(this, "sendChat", listModel$1.sendChat), __publicField$u(this, "setAnonymousFlag", listModel$1.setAnonymousFlag), __publicField$u(this, "getI18nTitle", listModel$1.getI18nTitle), __publicField$u(this, "clearAllChats", listModel$1.clearAllChats);
  }
  init(T) {
    chatRoomModel.init(T), topModel.init(), listModel$1.init(), emoticonModel.init(T.emoticonLibrary);
  }
  destroy() {
    listModel$1.destroy(), topModel.destroy(), chatRoomModel.destroy();
  }
}
const chatModel = new ChatModel();
var VoteQuestionTypesEnum = /* @__PURE__ */ ((e) => (e[e.RADIO = 4] = "RADIO", e[e.CHECKBOX = 5] = "CHECKBOX", e))(VoteQuestionTypesEnum || {}), OptionStyle = /* @__PURE__ */ ((e) => (e[e.TILE = 1] = "TILE", e[e.SELECT = 2] = "SELECT", e))(OptionStyle || {});
function httpGetVoteInfo(e, T) {
  return Me(this, null, function* () {
    return request$1.get(`/events/${e}/rooms/${T}/audience-votings-info`);
  });
}
function httpPostVoteAnswer(e, T, F, $) {
  return request$1.post(`/events/${e}/rooms/${T}/votings/${F}`, $);
}
var __defProp$t = Object.defineProperty, __defNormalProp$t = (e, T, F) => T in e ? __defProp$t(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$t = (e, T, F) => (__defNormalProp$t(e, typeof T != "symbol" ? T + "" : T, F), F);
const defaultTime = "1900-01-01 00:00:00", INITIAL_STATE$u = {
  voteFlag: !1,
  voteInfoLoading: !1,
  isVoting: !1,
  questionnaireId: 0,
  votingName: "",
  votingId: 0,
  showOrderFlag: !1,
  votingSubmitFlag: !1,
  votingResultsFlag: !1,
  votingEndTime: "",
  votingNoticeFlag: !1,
  votingNotice: "",
  voteQuestionList: [],
  submitLoading: !1
};
class VoteInfoModel extends Model {
  constructor() {
    super(INITIAL_STATE$u), __publicField$t(this, "VOTE_STATUS_CHANGED", "VOTE_STATUS_CHANGED"), __publicField$t(this, "getVoteInfo", () => Me(this, null, function* () {
      try {
        return yield userModel._interceptAnonymous(InteractionType.VOTE), new Promise((T, F) => {
          const { voteInfoLoading: $ } = this.state;
          if ($)
            return F("Loading");
          const { eventId: J } = eventModel.state, { roomId: ee } = roomModel.state;
          this.setState({ voteInfoLoading: !0 }), httpGetVoteInfo(J, ee).then((ne) => {
            var oe, se;
            if (this.setState({ voteInfoLoading: !1 }), (oe = ne == null ? void 0 : ne.data) != null && oe.data) {
              const {
                questionnaireId: le = 0,
                votingName: de = "",
                votingId: ce = 0,
                showOrderFlag: he = 0,
                votingSubmitFlag: ve = 0,
                votingResultsFlag: ge = 0,
                votingEndTime: be = "",
                votingNoticeFlag: Te = 0,
                votingNotice: Se = "",
                questions: Ie = []
              } = ((se = ne == null ? void 0 : ne.data) == null ? void 0 : se.data) || {};
              this.setState({
                questionnaireId: le,
                isVoting: !0,
                votingName: de,
                votingId: ce,
                showOrderFlag: isTrue(he),
                votingSubmitFlag: isTrue(ve),
                votingResultsFlag: isTrue(ge),
                votingEndTime: be === defaultTime ? "" : be,
                votingNoticeFlag: isTrue(Te),
                votingNotice: Se,
                voteQuestionList: this._dealQuestionList(Ie)
              }), T({
                votingName: de,
                votingId: ce,
                showOrderFlag: isTrue(he),
                votingSubmitFlag: isTrue(ve),
                votingResultsFlag: isTrue(ge),
                votingEndTime: be,
                votingNoticeFlag: isTrue(Te),
                votingNotice: Se,
                voteQuestionList: this._dealQuestionList(Ie)
              });
            } else
              this.setState({
                isVoting: !1,
                questionnaireId: 0,
                votingName: "",
                votingId: 0,
                showOrderFlag: !1,
                votingSubmitFlag: !1,
                votingResultsFlag: !1,
                votingEndTime: "",
                votingNoticeFlag: !1,
                votingNotice: "",
                voteQuestionList: []
              }), T(null);
          }).catch((ne) => {
            this.setState({ voteInfoLoading: !1 }), F(ne);
          });
        });
      } catch (T) {
      }
    })), __publicField$t(this, "actionSubmitVote", (T, F) => {
      const { submitLoading: $, votingId: J, questionnaireId: ee, voteQuestionList: ne } = this.state;
      if ($)
        return Promise.reject("Submiting vote");
      if ((T.filter((ce) => ce.options && ce.options.length !== 0) || []).length < ne.length)
        return Promise.reject("Please Checked All");
      const se = {
        questionnaireId: ee,
        questions: T.map((ce, he) => {
          var ve, ge;
          const be = ne[he];
          return Fe({
            questionId: be.questionId,
            questionType: be.questionType,
            optionSelectMin: (ve = be.optionSelectMin) != null ? ve : null,
            questionOptionRestricted: (ge = be.questionOptionRestricted) != null ? ge : null
          }, ce);
        }),
        callToActionId: F
      }, { eventId: le } = eventModel.state, { roomId: de } = roomModel.state;
      return httpPostVoteAnswer(le, de, J, se).then((ce) => {
        var he, ve;
        if ((he = ce == null ? void 0 : ce.data) != null && he.data) {
          const {
            votingResultsFlag: ge = 0,
            questions: be = []
          } = ((ve = ce == null ? void 0 : ce.data) == null ? void 0 : ve.data) || {};
          this.setState((Te) => {
            const Se = Te.voteQuestionList.map((Ie) => {
              const Oe = be.find((Le) => Le.questionId === Ie.questionId);
              return Ke(Fe({}, Ie), {
                answerNum: (Oe == null ? void 0 : Oe.answerNum) || 0,
                options: (Ie.options || []).map((Le) => {
                  const Ne = ((Oe == null ? void 0 : Oe.options) || []).find((Ue) => Ue.optionId === Le.optionId);
                  return Ke(Fe({}, Le), {
                    answerNum: (Ne == null ? void 0 : Ne.answerNum) || 0,
                    commitFlag: Ne == null ? void 0 : Ne.commitFlag,
                    customAnswerContent: (Ne == null ? void 0 : Ne.customAnswerContent) || ""
                  });
                })
              });
            });
            Te.submitLoading = !1, Te.votingResultsFlag = isTrue(ge), Te.votingSubmitFlag = !0, Te.voteQuestionList = Se;
          });
        }
      }).catch((ce) => (this.setState({ submitLoading: !1 }), Promise.reject(ce)));
    });
  }
  init(T) {
    return Me(this, null, function* () {
      this.setState({
        voteFlag: isTrue(T)
      }), this._onWsVoteFlagChange(), this._onWsVoteStatusChange();
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$u);
  }
  _dealQuestionList(T) {
    return T && T.length ? T.map(($) => {
      var J, ee;
      return {
        questionId: $.questionId || 0,
        questionHeading: $.questionHeading || "",
        questionType: $.questionType || VoteQuestionTypesEnum.RADIO,
        questionOrder: $.questionOrder || 0,
        optionSelectMin: (J = $.optionSelectMin) != null ? J : null,
        questionOptionRestricted: (ee = $.questionOptionRestricted) != null ? ee : null,
        options: $.options || [],
        answerNum: $.answerNum,
        optionStyle: $.optionStyle
      };
    }) : [];
  }
  _onWsVoteStatusChange() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.VOTING_STATUS).subscribe((F) => {
      const { watchLanguage: $ } = roomModel.state, {
        votingId: J = 0,
        votingEndTime: ee = "",
        votingStatus: ne = 0,
        votingNoticeFlag: oe = 0,
        i18ns: se = []
      } = F || {}, le = findFinalLangFun($, (he) => se == null ? void 0 : se.some((ve) => ve.languageType === he)), { votingName: de, votingNotice: ce } = (se == null ? void 0 : se.find(({ languageType: he }) => he === le)) || {};
      isTrue(ne) ? this.setState((he) => {
        he.isVoting = !0, he.votingId = J, he.votingName = de, he.votingEndTime = ee === defaultTime ? "" : ee, he.votingNoticeFlag = isTrue(oe), he.votingNotice = ce, he.voteQuestionList = [];
      }) : this.setState((he) => {
        he.isVoting = !1;
      }), voteModel.emit(this.VOTE_STATUS_CHANGED, {
        votingId: J,
        votingName: de,
        votingEndTime: ee === defaultTime ? "" : ee,
        votingStatus: isTrue(ne),
        votingNoticeFlag: isTrue(oe),
        votingNotice: ce
      });
    });
  }
  _onWsVoteFlagChange() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.VOTING_FLAG).subscribe((F) => {
      const { voteFlag: $ = 0 } = F || {};
      this.setState({
        voteFlag: isTrue($)
      });
    });
  }
}
const voteInfoModel = new VoteInfoModel();
var __defProp$s = Object.defineProperty, __defNormalProp$s = (e, T, F) => T in e ? __defProp$s(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$s = (e, T, F) => (__defNormalProp$s(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$t = {};
class VoteModel extends Model {
  constructor() {
    super(INITIAL_STATE$t), __publicField$s(this, "VOTE_STATUS_CHANGED", voteInfoModel.VOTE_STATUS_CHANGED), __publicField$s(this, "voteFlag", modelStateGetter(voteInfoModel, "voteFlag")), __publicField$s(this, "voteInfoLoading", modelStateGetter(voteInfoModel, "voteInfoLoading")), __publicField$s(this, "isVoting", modelStateGetter(voteInfoModel, "isVoting")), __publicField$s(this, "votingName", modelStateGetter(voteInfoModel, "votingName")), __publicField$s(this, "votingId", modelStateGetter(voteInfoModel, "votingId")), __publicField$s(this, "showOrderFlag", modelStateGetter(voteInfoModel, "showOrderFlag")), __publicField$s(this, "votingSubmitFlag", modelStateGetter(voteInfoModel, "votingSubmitFlag")), __publicField$s(this, "votingResultsFlag", modelStateGetter(voteInfoModel, "votingResultsFlag")), __publicField$s(this, "votingEndTime", modelStateGetter(voteInfoModel, "votingEndTime")), __publicField$s(this, "votingNoticeFlag", modelStateGetter(voteInfoModel, "votingNoticeFlag")), __publicField$s(this, "votingNotice", modelStateGetter(voteInfoModel, "votingNotice")), __publicField$s(this, "voteQuestionList", modelStateGetter(voteInfoModel, "voteQuestionList")), __publicField$s(this, "submitLoading", modelStateGetter(voteInfoModel, "submitLoading")), __publicField$s(this, "getVoteInfo", voteInfoModel.getVoteInfo), __publicField$s(this, "actionSubmitVote", voteInfoModel.actionSubmitVote);
  }
  init(T) {
    voteInfoModel.init(T);
  }
  destroy() {
    voteInfoModel.destroy();
  }
}
const voteModel = new VoteModel();
var millisecondsInMinute = 6e4, millisecondsInHour = 36e5;
function requiredArgs(e, T) {
  if (T.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + T.length + " present");
}
function toInteger$2(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var T = Number(e);
  return isNaN(T) ? T : T < 0 ? Math.ceil(T) : Math.floor(T);
}
function parseISO(e, T) {
  var F;
  requiredArgs(1, arguments);
  var $ = toInteger$2((F = T == null ? void 0 : T.additionalDigits) !== null && F !== void 0 ? F : 2);
  if ($ !== 2 && $ !== 1 && $ !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return new Date(NaN);
  var J = splitDateString(e), ee;
  if (J.date) {
    var ne = parseYear(J.date, $);
    ee = parseDate(ne.restDateString, ne.year);
  }
  if (!ee || isNaN(ee.getTime()))
    return new Date(NaN);
  var oe = ee.getTime(), se = 0, le;
  if (J.time && (se = parseTime(J.time), isNaN(se)))
    return new Date(NaN);
  if (J.timezone) {
    if (le = parseTimezone(J.timezone), isNaN(le))
      return new Date(NaN);
  } else {
    var de = new Date(oe + se), ce = new Date(0);
    return ce.setFullYear(de.getUTCFullYear(), de.getUTCMonth(), de.getUTCDate()), ce.setHours(de.getUTCHours(), de.getUTCMinutes(), de.getUTCSeconds(), de.getUTCMilliseconds()), ce;
  }
  return new Date(oe + se + le);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(e) {
  var T = {}, F = e.split(patterns.dateTimeDelimiter), $;
  if (F.length > 2)
    return T;
  if (/:/.test(F[0]) ? $ = F[0] : (T.date = F[0], $ = F[1], patterns.timeZoneDelimiter.test(T.date) && (T.date = e.split(patterns.timeZoneDelimiter)[0], $ = e.substr(T.date.length, e.length))), $) {
    var J = patterns.timezone.exec($);
    J ? (T.time = $.replace(J[1], ""), T.timezone = J[1]) : T.time = $;
  }
  return T;
}
function parseYear(e, T) {
  var F = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + T) + "})|(\\d{2}|[+-]\\d{" + (2 + T) + "})$)"), $ = e.match(F);
  if (!$)
    return {
      year: NaN,
      restDateString: ""
    };
  var J = $[1] ? parseInt($[1]) : null, ee = $[2] ? parseInt($[2]) : null;
  return {
    year: ee === null ? J : ee * 100,
    restDateString: e.slice(($[1] || $[2]).length)
  };
}
function parseDate(e, T) {
  if (T === null)
    return new Date(NaN);
  var F = e.match(dateRegex);
  if (!F)
    return new Date(NaN);
  var $ = !!F[4], J = parseDateUnit(F[1]), ee = parseDateUnit(F[2]) - 1, ne = parseDateUnit(F[3]), oe = parseDateUnit(F[4]), se = parseDateUnit(F[5]) - 1;
  if ($)
    return validateWeekDate(T, oe, se) ? dayOfISOWeekYear(T, oe, se) : new Date(NaN);
  var le = new Date(0);
  return !validateDate(T, ee, ne) || !validateDayOfYearDate(T, J) ? new Date(NaN) : (le.setUTCFullYear(T, ee, Math.max(J, ne)), le);
}
function parseDateUnit(e) {
  return e ? parseInt(e) : 1;
}
function parseTime(e) {
  var T = e.match(timeRegex);
  if (!T)
    return NaN;
  var F = parseTimeUnit(T[1]), $ = parseTimeUnit(T[2]), J = parseTimeUnit(T[3]);
  return validateTime(F, $, J) ? F * millisecondsInHour + $ * millisecondsInMinute + J * 1e3 : NaN;
}
function parseTimeUnit(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function parseTimezone(e) {
  if (e === "Z")
    return 0;
  var T = e.match(timezoneRegex);
  if (!T)
    return 0;
  var F = T[1] === "+" ? -1 : 1, $ = parseInt(T[2]), J = T[3] && parseInt(T[3]) || 0;
  return validateTimezone($, J) ? F * ($ * millisecondsInHour + J * millisecondsInMinute) : NaN;
}
function dayOfISOWeekYear(e, T, F) {
  var $ = new Date(0);
  $.setUTCFullYear(e, 0, 4);
  var J = $.getUTCDay() || 7, ee = (T - 1) * 7 + F + 1 - J;
  return $.setUTCDate($.getUTCDate() + ee), $;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function validateDate(e, T, F) {
  return T >= 0 && T <= 11 && F >= 1 && F <= (daysInMonths[T] || (isLeapYearIndex(e) ? 29 : 28));
}
function validateDayOfYearDate(e, T) {
  return T >= 1 && T <= (isLeapYearIndex(e) ? 366 : 365);
}
function validateWeekDate(e, T, F) {
  return T >= 1 && T <= 53 && F >= 0 && F <= 6;
}
function validateTime(e, T, F) {
  return e === 24 ? T === 0 && F === 0 : F >= 0 && F < 60 && T >= 0 && T < 60 && e >= 0 && e < 25;
}
function validateTimezone(e, T) {
  return T >= 0 && T <= 59;
}
function _typeof(e) {
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(T) {
    return typeof T;
  } : function(T) {
    return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
  }, _typeof(e);
}
function toDate(e) {
  requiredArgs(1, arguments);
  var T = Object.prototype.toString.call(e);
  return e instanceof Date || _typeof(e) === "object" && T === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || T === "[object Number]" ? new Date(e) : ((typeof e == "string" || T === "[object String]") && typeof console != "undefined" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
}
function differenceInMilliseconds(e, T) {
  return requiredArgs(2, arguments), toDate(e).getTime() - toDate(T).getTime();
}
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function e(T) {
    return T < 0 ? Math.ceil(T) : Math.floor(T);
  }
}, defaultRoundingMethod = "trunc";
function getRoundingMethod(e) {
  return e ? roundingMap[e] : roundingMap[defaultRoundingMethod];
}
function differenceInSeconds(e, T, F) {
  requiredArgs(2, arguments);
  var $ = differenceInMilliseconds(e, T) / 1e3;
  return getRoundingMethod(F == null ? void 0 : F.roundingMethod)($);
}
var TriggerMode = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.ACTIVE = 1] = "ACTIVE", e[e.PASSIVE = 2] = "PASSIVE", e))(TriggerMode || {}), AbilityType = /* @__PURE__ */ ((e) => (e[e.COLLECT_FORM = 1] = "COLLECT_FORM", e[e.DOWNLOAD_FILE = 2] = "DOWNLOAD_FILE", e[e.CODE_ATTENTION = 3] = "CODE_ATTENTION", e[e.CONTACT_SERVICE = 4] = "CONTACT_SERVICE", e[e.DRAW = 5] = "DRAW", e[e.GOODS = 6] = "GOODS", e[e.VOTE = 7] = "VOTE", e[e.SIGN_IN = 8] = "SIGN_IN", e))(AbilityType || {});
function httpPostToolBuriedDots(e, T, F) {
  return request$1.post(`/events/${e}/rooms/${T}/marketing-apps/bury`, F);
}
var MarketingAppType = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.APPOINTMENT_DEMO = 1] = "APPOINTMENT_DEMO", e[e.INTEND_RETENTION = 2] = "INTEND_RETENTION", e[e.ASK_PRICE = 3] = "ASK_PRICE", e[e.APPLY_TRIAL = 4] = "APPLY_TRIAL", e[e.CUSTOMIZE_MENU = 5] = "CUSTOMIZE_MENU", e[e.DOWNLOAD_MATERIALS = 6] = "DOWNLOAD_MATERIALS", e[e.CODE_ATTENTION = 7] = "CODE_ATTENTION", e[e.CUSTOMER_SERVICE = 8] = "CUSTOMER_SERVICE", e))(MarketingAppType || {}), ActionType$1 = /* @__PURE__ */ ((e) => (e[e.END = 0] = "END", e[e.START = 1] = "START", e))(ActionType$1 || {});
function httpGetCallTool(e, T) {
  return request$1.get(`/events/${e}/rooms/${T}/call-to-actions`, {
    method: "GET"
  });
}
function httpGetToolList(e, T) {
  return request$1.get(`/events/${e}/rooms/${T}/watch-marketing-app`, {
    method: "GET",
    params: {
      page: 1,
      perPage: 20
    }
  });
}
var JumpUrlType = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.QRCODE = 1] = "QRCODE", e[e.URL = 2] = "URL", e))(JumpUrlType || {}), MarketingAppBaseType = /* @__PURE__ */ ((e) => (e[e.COLLECT_FORM = 1] = "COLLECT_FORM", e[e.DOWNLOAD_FILE = 2] = "DOWNLOAD_FILE", e[e.CODE_ATTENTION = 3] = "CODE_ATTENTION", e[e.CONTACT_SERVICE = 4] = "CONTACT_SERVICE", e))(MarketingAppBaseType || {});
function httpGetToolDetail(e, T, F) {
  return request$1.get(`/events/${e}/rooms/${T}/watch-marketing-app/${F}`, {
    method: "GET"
  });
}
var __defProp$r = Object.defineProperty, __defNormalProp$r = (e, T, F) => T in e ? __defProp$r(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$r = (e, T, F) => (__defNormalProp$r(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$s = {
  marketToolList: [],
  marketToolDetail: {},
  marketToolDetaiLoading: !1
};
class MarketToolInfoModel extends Model {
  constructor() {
    super(INITIAL_STATE$s), __publicField$r(this, "_getMarketToolList", () => Me(this, null, function* () {
      const { eventId: T } = eventModel.state, { roomId: F } = roomModel.state;
      httpGetToolList(T, F).then(($) => {
        var J, ee;
        const { items: ne = [] } = (ee = (J = $ == null ? void 0 : $.data) == null ? void 0 : J.data) != null ? ee : {}, oe = ne.map((se) => ({
          marketingAppId: se.marketingAppId || 0,
          marketingAppName: se.marketingAppName || "",
          marketingAppType: se.marketingAppType
        }));
        this.setState({
          marketToolList: oe
        });
      }).catch(() => {
      });
    })), __publicField$r(this, "_dealMarketToolDetail", (T) => {
      var F, $;
      const {
        marketingAppId: J = 0,
        marketingAppName: ee = "",
        marketingAppBaseType: ne = MarketingAppBaseType.COLLECT_FORM,
        liveShowFlag: oe = 0,
        marketingAppType: se = MarketingAppType.UNKNOWN,
        subjectIndexFlag: le = 0,
        statusFlag: de = 0
      } = T != null ? T : {}, {
        jumpUrlId: ce = 0,
        jumpUrlDetailId: he = 0,
        jumpUrlType: ve = JumpUrlType.QRCODE,
        jumpUrlDetail: ge = "",
        remark: be = ""
      } = ($ = (F = T == null ? void 0 : T.jumpUrl) == null ? void 0 : F.jumpUrlDetail[0]) != null ? $ : {};
      this.setState({
        marketToolDetail: {
          marketingAppId: J,
          marketingAppName: ee,
          marketingAppBaseType: ne,
          liveShowFlag: isTrue(oe),
          marketingAppType: se,
          subjectIndexFlag: isTrue(le),
          statusFlag: isTrue(de),
          jumpUrlId: ce,
          jumpUrlDetailId: he,
          jumpUrlType: ve,
          jumpUrlDetail: ge,
          remark: be
        }
      });
    }), __publicField$r(this, "getMarketToolDetail", (T, F) => Me(this, null, function* () {
      try {
        return yield userModel._interceptAnonymous(), new Promise(($, J) => {
          const { marketToolDetaiLoading: ee } = this.state;
          if (ee)
            return J("Loading");
          const { eventId: ne } = eventModel.state, { roomId: oe } = roomModel.state;
          this.setState({ marketToolDetaiLoading: !0 }), httpGetToolDetail(ne, oe, T).then((se) => {
            var le;
            this.setState({ marketToolDetaiLoading: !1 });
            const { data: de } = (le = se == null ? void 0 : se.data) != null ? le : {}, ce = de.marketingAppBaseType;
            callModel._reportCallBury(F || TriggerMode.ACTIVE, T, ce), this._dealMarketToolDetail(de), $();
          }).catch((se) => {
            this.setState({ marketToolDetaiLoading: !1 }), J(se);
          });
        });
      } catch ($) {
      }
    }));
  }
  init() {
    return Me(this, null, function* () {
      try {
        this._getMarketToolList();
      } catch (T) {
      }
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$s);
  }
}
const marketToolInfoModel = new MarketToolInfoModel();
var __defProp$q = Object.defineProperty, __defNormalProp$q = (e, T, F) => T in e ? __defProp$q(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$q = (e, T, F) => (__defNormalProp$q(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$r = {};
class MarketToolModel extends Model {
  constructor() {
    super(INITIAL_STATE$r), __publicField$q(this, "marketToolList", modelStateGetter(marketToolInfoModel, "marketToolList")), __publicField$q(this, "marketToolDetaiLoading", modelStateGetter(marketToolInfoModel, "marketToolDetaiLoading")), __publicField$q(this, "marketToolDetail", modelStateGetter(marketToolInfoModel, "marketToolDetail")), __publicField$q(this, "getMarketToolDetail", marketToolInfoModel.getMarketToolDetail);
  }
  init() {
    marketToolInfoModel.init();
  }
  destroy() {
    marketToolInfoModel.destroy();
  }
}
const marketToolModel = new MarketToolModel();
var __defProp$p = Object.defineProperty, __defNormalProp$p = (e, T, F) => T in e ? __defProp$p(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$p = (e, T, F) => (__defNormalProp$p(e, typeof T != "symbol" ? T + "" : T, F), F);
const defaultCallInfoData = {
  callToActionId: null,
  callToActionSn: 0,
  abilityType: AbilityType.COLLECT_FORM,
  serverCurrentTimestamp: 0,
  endTime: "",
  abilityId: 0,
  extraContent: "",
  actionType: ActionType$1.END,
  marketingAppName: "",
  marketingAppType: MarketingAppType.UNKNOWN,
  jumpUrl: "",
  picUrl: "",
  goodsName: "",
  price: 0
}, abilityTypeTool = [AbilityType.COLLECT_FORM, AbilityType.DOWNLOAD_FILE, AbilityType.CODE_ATTENTION, AbilityType.CONTACT_SERVICE], INITIAL_STATE$q = {
  callInfoData: defaultCallInfoData,
  callToActionId: null,
  callToActionSn: 0,
  callInter: 0
};
class CallInfoModel extends Model {
  constructor() {
    super(INITIAL_STATE$q), __publicField$p(this, "CALL_DATA_CHANGED", "CALL_DATA_CHANGED"), __publicField$p(this, "_reportCallBury", (T, F, $) => {
      const { eventId: J } = eventModel.state, { roomId: ee } = roomModel.state;
      let ne = {
        marketingAppId: F,
        triggerMode: T,
        marketingAppPrimaryType: $
      };
      if (T === TriggerMode.PASSIVE) {
        const { callToActionId: oe } = this.state;
        ne = Ke(Fe({}, ne), { callToActionId: oe });
      }
      httpPostToolBuriedDots(J, ee, ne).catch(() => {
      });
    }), __publicField$p(this, "_setCallToActionIdState", (T) => {
      this.setState({ callToActionId: T });
    }), __publicField$p(this, "_setCallToActionSnState", (T) => {
      this.setState({ callToActionSn: T });
    }), __publicField$p(this, "_callInterval", () => {
      const { callInfoData: T } = this.state;
      let F = (T == null ? void 0 : T.endTime) && differenceInSeconds(parseISO(T == null ? void 0 : T.endTime), T == null ? void 0 : T.serverCurrentTimestamp) || 0;
      const $ = window.setInterval(() => {
        if (F === 0) {
          this.clearCallInterval(), callModel.emit(this.CALL_DATA_CHANGED, {
            actionType: ActionType$1.END,
            abilityType: T == null ? void 0 : T.abilityType,
            serverCurrentTimestamp: T == null ? void 0 : T.serverCurrentTimestamp,
            endTime: T == null ? void 0 : T.endTime
          });
          return;
        }
        F -= 1;
      }, 1e3);
      this.setState({ callInter: $ });
    }), __publicField$p(this, "actionCallCard", () => Me(this, null, function* () {
      try {
        return yield userModel._interceptAnonymous(), new Promise((T) => Me(this, null, function* () {
          const { callInfoData: F } = this.state;
          this.clearCallInterval(), this._setCallToActionIdState((F == null ? void 0 : F.callToActionId) || 0), this._setCallToActionSnState((F == null ? void 0 : F.callToActionSn) || 0), (F == null ? void 0 : F.abilityType) === AbilityType.GOODS ? this._reportCallBury(TriggerMode.PASSIVE, F.abilityId, AbilityType.GOODS) : F && abilityTypeTool.includes(F == null ? void 0 : F.abilityType) ? yield marketToolModel.getMarketToolDetail(F.abilityId, TriggerMode.PASSIVE) : F.abilityType === AbilityType.DRAW ? this._reportCallBury(TriggerMode.PASSIVE, F.abilityId, AbilityType.DRAW) : F.abilityType === AbilityType.VOTE ? this._reportCallBury(TriggerMode.PASSIVE, F.abilityId, AbilityType.VOTE) : F.abilityType === AbilityType.SIGN_IN && this._reportCallBury(TriggerMode.PASSIVE, F.abilityId, AbilityType.SIGN_IN), T();
        }));
      } catch (T) {
      }
    }));
  }
  init() {
    return Me(this, null, function* () {
      this._queryCallTool(), this._onWsCallToolStatus();
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$q);
  }
  _dealCallData(T) {
    const {
      callToActionId: F = null,
      callToActionSn: $ = 0,
      abilityType: J = AbilityType.COLLECT_FORM,
      serverCurrentTimestamp: ee = 0,
      endTime: ne = "",
      abilityId: oe = 0,
      extraContent: se,
      actionType: le
    } = T != null ? T : {}, {
      marketingAppName: de = "",
      marketingAppType: ce = MarketingAppType.UNKNOWN,
      jumpUrl: he = "",
      picUrl: ve = "",
      goodsName: ge = "",
      price: be = 0
    } = se != null ? se : {};
    this.setState({
      callInfoData: {
        callToActionId: F,
        callToActionSn: $,
        abilityType: J,
        serverCurrentTimestamp: ee,
        endTime: ne,
        abilityId: oe,
        marketingAppName: de,
        marketingAppType: ce,
        jumpUrl: he,
        picUrl: ve,
        goodsName: ge,
        price: be,
        actionType: le
      }
    });
  }
  _queryCallTool() {
    const { eventId: T } = eventModel.state, { roomId: F } = roomModel.state;
    httpGetCallTool(T, F).then(($) => {
      var J, ee, ne, oe;
      const {
        actionType: se = ActionType$1.END,
        abilityType: le = AbilityType.COLLECT_FORM,
        serverCurrentTimestamp: de = 0,
        endTime: ce = ""
      } = (ee = (J = $ == null ? void 0 : $.data) == null ? void 0 : J.data) != null ? ee : {};
      this._dealCallData((oe = (ne = $ == null ? void 0 : $.data) == null ? void 0 : ne.data) != null ? oe : {}), setTimeout(() => {
        se === ActionType$1.START && this._callInterval(), callModel.emit(this.CALL_DATA_CHANGED, {
          actionType: se,
          abilityType: le,
          serverCurrentTimestamp: de,
          endTime: ce
        });
      });
    }).catch(() => {
    });
  }
  _onWsCallToolStatus() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.WATCH_CALL_STATUS).subscribe((F) => {
      const {
        actionType: $ = ActionType$1.END,
        abilityType: J = AbilityType.COLLECT_FORM,
        serverCurrentTimestamp: ee = 0,
        endTime: ne = ""
      } = F != null ? F : {};
      $ === ActionType$1.START ? (this._dealCallData(F != null ? F : {}), this._callInterval()) : (this.setState({
        callInfoData: defaultCallInfoData
      }), this.clearCallInterval()), setTimeout(() => {
        J === AbilityType.VOTE && userModel.state.userType === OnlineUserType.ANONYMOUS_AUDIENCE || callModel.emit(this.CALL_DATA_CHANGED, {
          actionType: $,
          abilityType: J,
          serverCurrentTimestamp: ee,
          endTime: ne
        });
      });
    });
  }
  clearCallInterval() {
    window.clearInterval(this.state.callInter);
  }
}
const callInfoModel = new CallInfoModel();
var __defProp$o = Object.defineProperty, __defNormalProp$o = (e, T, F) => T in e ? __defProp$o(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$o = (e, T, F) => (__defNormalProp$o(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$p = {};
class CallModel extends Model {
  constructor() {
    super(INITIAL_STATE$p), __publicField$o(this, "CALL_DATA_CHANGED", callInfoModel.CALL_DATA_CHANGED), __publicField$o(this, "callInfoData", modelStateGetter(callInfoModel, "callInfoData")), __publicField$o(this, "clearCallInterval", callInfoModel.clearCallInterval), __publicField$o(this, "actionCallCard", callInfoModel.actionCallCard), __publicField$o(this, "_reportCallBury", callInfoModel._reportCallBury), __publicField$o(this, "_setCallToActionIdState", callInfoModel._setCallToActionIdState), __publicField$o(this, "_setCallToActionSnState", callInfoModel._setCallToActionSnState);
  }
  init() {
    callInfoModel.init();
  }
  destroy() {
    callInfoModel.destroy();
  }
}
const callModel = new CallModel();
function httpGetGoodsList(e, T) {
  return request$1.get(`/events/${T}/rooms/${e}/goods`);
}
var __defProp$n = Object.defineProperty, __defNormalProp$n = (e, T, F) => T in e ? __defProp$n(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$n = (e, T, F) => (__defNormalProp$n(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$o = {
  goodsFlag: !1,
  goodsListLoading: !1,
  goodsList: []
};
class GoodsInfoModel extends Model {
  constructor() {
    super(INITIAL_STATE$o), __publicField$n(this, "getGoodsList", () => Me(this, null, function* () {
      try {
        return yield userModel._interceptAnonymous(), new Promise((T, F) => {
          const { goodsListLoading: $ } = this.state;
          if ($)
            return F("Loading");
          const { eventId: J } = eventModel.state, { roomId: ee } = roomModel.state;
          this.setState({ goodsListLoading: !0 }), httpGetGoodsList(ee, J).then((ne) => {
            var oe, se;
            this.setState({ goodsListLoading: !1 });
            const { items: le = [] } = (se = (oe = ne == null ? void 0 : ne.data) == null ? void 0 : oe.data) != null ? se : {}, de = le.map((ce) => ({
              goodsId: ce.goodsId || 0,
              goodsName: ce.goodsName || "",
              introduce: ce.introduce || "",
              price: ce.price || 0,
              creatorName: ce.creatorName || "",
              createTime: ce.createTime || "",
              picUrl: ce.picUrl || "",
              jumpUrl: ce.webUrlFlag && ce.jumpUrl ? ce.jumpUrl : "",
              h5JumpUrl: ce.webUrlFlag && ce.h5JumpUrl ? ce.h5JumpUrl : "",
              miniProgramAppId: ce.miniProgramFlag && ce.miniProgramAppId ? ce.miniProgramAppId : "",
              miniProgramUrl: ce.miniProgramFlag && ce.miniProgramUrl ? ce.miniProgramUrl : "",
              scribingPrice: ce.scribingPrice || 0
            }));
            this.setState({
              goodsList: de
            }), T();
          }).catch((ne) => {
            this.setState({ goodsListLoading: !1 }), F(ne);
          });
        });
      } catch (T) {
      }
    }));
  }
  init(T) {
    return Me(this, null, function* () {
      try {
        this.setState({
          goodsFlag: isTrue(T)
        }), this._onWsGoodsFlag();
      } catch (F) {
      }
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$o);
  }
  _onWsGoodsFlag() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.GOODS_FLAG).subscribe((F) => {
      const { goodsFlag: $ = 0 } = F || {};
      this.setState({
        goodsFlag: isTrue($)
      });
    });
  }
  goodsListReportCallBury(T) {
    return Me(this, null, function* () {
      try {
        return yield userModel._interceptAnonymous(), new Promise((F) => {
          callModel._reportCallBury(TriggerMode.ACTIVE, T, AbilityType.GOODS), F();
        });
      } catch (F) {
      }
    });
  }
}
const goodsInfoModel = new GoodsInfoModel();
var __defProp$m = Object.defineProperty, __defNormalProp$m = (e, T, F) => T in e ? __defProp$m(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$m = (e, T, F) => (__defNormalProp$m(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$n = {};
class GoodsModel extends Model {
  constructor() {
    super(INITIAL_STATE$n), __publicField$m(this, "goodsFlag", modelStateGetter(goodsInfoModel, "goodsFlag")), __publicField$m(this, "goodsListLoading", modelStateGetter(goodsInfoModel, "goodsListLoading")), __publicField$m(this, "goodsList", modelStateGetter(goodsInfoModel, "goodsList")), __publicField$m(this, "getGoodsList", goodsInfoModel.getGoodsList), __publicField$m(this, "goodsListReportCallBury", goodsInfoModel.goodsListReportCallBury);
  }
  init(T) {
    goodsInfoModel.init(T);
  }
  destroy() {
    goodsInfoModel.destroy();
  }
}
const goodsModel = new GoodsModel();
function httpGetReportLikeCount(e, T, F) {
  return request$1.get(`/events/${e}/rooms/${T}/fabulous`, {
    method: "GET",
    params: { number: F }
  });
}
var __defProp$l = Object.defineProperty, __defNormalProp$l = (e, T, F) => T in e ? __defProp$l(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$l = (e, T, F) => (__defNormalProp$l(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$m = {
  likeFlag: !1,
  likeNumberFlag: !1,
  likeNumber: 0,
  reportLikeCount: 0
};
class LikeModel extends Model {
  constructor() {
    super(INITIAL_STATE$m), __publicField$l(this, "dispatchLikeBar", () => Me(this, null, function* () {
      try {
        yield userModel._interceptAnonymous(InteractionType.LIKE);
        const { reportLikeCount: T, likeNumber: F } = this.state;
        this.setState({
          likeNumber: F + 1,
          reportLikeCount: T + 1
        }), this._throttleDispatchReportLikeCount();
      } catch (T) {
      }
    })), __publicField$l(this, "_throttleDispatchReportLikeCount", throttle_1(() => {
      this._dispatchReportLikeCount();
    }, 5e3, {
      leading: !1
    }));
  }
  init(T, F, $) {
    this.setState({
      likeFlag: isTrue(T),
      likeNumberFlag: isTrue(F),
      likeNumber: $ != null ? $ : 0
    }), this._onWsFabulousNumber();
  }
  _dispatchReportLikeCount() {
    const { reportLikeCount: T } = this.state, { eventId: F } = eventModel.state, { roomId: $ } = roomModel.state;
    T && httpGetReportLikeCount(F, $, T).then(() => {
      this.setState({ reportLikeCount: 0 });
    }).catch(() => {
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$m);
  }
  _onWsFabulousNumber() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.FABULOUS_NUMBER).subscribe((F) => {
      var $;
      const { likeNumber: J } = this.state, ee = Number(($ = F == null ? void 0 : F.fabulousNumber) != null ? $ : 0) || 0;
      ee > J && this.setState({ likeNumber: ee });
    });
  }
}
const likeModel = new LikeModel(), INITIAL_STATE$l = {
  liveCountDownFlag: !1,
  liveCountDownRemain: 0,
  liveCountDownLocation: LiveCountDownLocation.CENTER,
  liveCountDownAutoZoomFlag: !0
};
class LiveCountdownModel extends Model {
  constructor() {
    super(INITIAL_STATE$l);
  }
  init(T, F, $, J) {
    this.setState({
      liveCountDownFlag: isTrue(T),
      liveCountDownRemain: F != null ? F : 0,
      liveCountDownLocation: $ != null ? $ : LiveCountDownLocation.CENTER,
      liveCountDownAutoZoomFlag: isTrue(J)
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$l);
  }
}
const liveCountdownModel = new LiveCountdownModel();
var WsAnnouncementEnum = /* @__PURE__ */ ((e) => (e[e.ADD = 1] = "ADD", e[e.UPDATE = 2] = "UPDATE", e[e.CLEAR = 3] = "CLEAR", e[e.ROLLING_Flag = 4] = "ROLLING_Flag", e))(WsAnnouncementEnum || {}), DeployStatus = /* @__PURE__ */ ((e) => (e[e.CLOSE = 0] = "CLOSE", e[e.OPEN = 1] = "OPEN", e))(DeployStatus || {}), __defProp$k = Object.defineProperty, __defNormalProp$k = (e, T, F) => T in e ? __defProp$k(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$k = (e, T, F) => (__defNormalProp$k(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$k = {
  announcements: {
    announcementContent: "",
    color: "",
    deployStatus: !1,
    rollingAnnouncementFlag: !1
  },
  announcementId: 0,
  sendTime: ""
};
class AnnounceModel extends Model {
  constructor() {
    super(INITIAL_STATE$k), __publicField$k(this, "_resolveAnnouceData", (T) => ({
      announcementContent: T.announcementContent,
      color: T.color,
      deployStatus: isTrue(T.deployStatus),
      rollingAnnouncementFlag: isTrue(T.rollingAnnouncementFlag)
    }));
  }
  init(T) {
    this.setState({
      announcements: this._resolveAnnouceData(T || INITIAL_STATE$k)
    }), this._onWsAnnouncementsPush();
  }
  destroy() {
    this.setState(INITIAL_STATE$k);
  }
  _onWsAnnouncementsPush() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.ANNOUNCEMENT).subscribe((F) => {
      var $;
      const { announcements: J, announcementId: ee, sendTime: ne } = this.state, { announcementContent: oe } = J;
      if (F.type === WsAnnouncementEnum.UPDATE) {
        this.setState({
          announcements: this._resolveAnnouceData(Ke(Fe({}, F.data || J), {
            announcementContent: oe,
            deployStatus: DeployStatus.OPEN
          }))
        });
        return;
      } else if (F.type === WsAnnouncementEnum.CLEAR) {
        this.setState({
          announcements: this._resolveAnnouceData(Ke(Fe({}, F.data || J), {
            announcementId: 0
          }))
        });
        return;
      } else if (F.type === WsAnnouncementEnum.ROLLING_Flag) {
        this.setState({
          announcements: this._resolveAnnouceData(Ke(Fe({}, J), {
            rollingAnnouncementFlag: ($ = F == null ? void 0 : F.data) == null ? void 0 : $.rollingAnnouncementFlag,
            deployStatus: DeployStatus.OPEN,
            announcementId: ee,
            sendTime: ne
          }))
        });
        return;
      }
      this.setState({
        announcements: this._resolveAnnouceData(F.data || J)
      });
    });
  }
}
const announceModel = new AnnounceModel();
var ViewerEnum = /* @__PURE__ */ ((e) => (e[e.NO = 0] = "NO", e[e.PV = 1] = "PV", e[e.UV = 2] = "UV", e))(ViewerEnum || {});
const INITIAL_STATE$j = {
  watchNumber: 0,
  viewerNumberType: 0
};
class WatchNumberModel extends Model {
  constructor() {
    super(INITIAL_STATE$j);
  }
  init(T, F) {
    this.setState({
      watchNumber: T && T > 0 ? T : 0,
      viewerNumberType: F != null ? F : 0
    }), this._onWsWatchNumber(), this._onWsWatchNumberFlag();
  }
  destroy() {
    this.setState(INITIAL_STATE$j);
  }
  _onWsWatchNumber() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.WATCH_NUMBER).subscribe((F) => {
      const { watchNumber: $ = 0 } = F || {};
      this.setState({
        watchNumber: $ && $ > 0 ? $ : 0
      });
    });
  }
  _onWsWatchNumberFlag() {
    var T;
    (T = roomModel.state.ws) == null || T.from(Topics.WATCH_NUMBER_FLAG).subscribe((F) => {
      var $;
      this.setState({
        viewerNumberType: ($ = F == null ? void 0 : F.viewerNumberType) != null ? $ : 0
      });
    });
  }
}
const watchNumberModel = new WatchNumberModel();
function httpPostInitVerify(e) {
  return request$1.post(
    "/init-verify",
    e
  );
}
function httpGetOnLineUsers(e) {
  return request$1.get(
    `/rooms/${e}/online-users`
  );
}
var OnlineUserRangeEnum = /* @__PURE__ */ ((e) => (e[e.HOST = 0] = "HOST", e[e.GUEST = 1] = "GUEST", e[e.ASSISTANT = 2] = "ASSISTANT", e[e.AUDIENCE = 3] = "AUDIENCE", e[e.ATMOSPHERE_MASTER = 7] = "ATMOSPHERE_MASTER", e))(OnlineUserRangeEnum || {}), OnlineUserTypeEnum = /* @__PURE__ */ ((e) => (e[e.HOST = 0] = "HOST", e[e.GUEST = 1] = "GUEST", e[e.ASSISTANT = 2] = "ASSISTANT", e[e.AUDIENCE = 3] = "AUDIENCE", e[e.ANONYMOUS_AUDIENCE = 4] = "ANONYMOUS_AUDIENCE", e[e.AUDIENCE_TO_GUEST = 5] = "AUDIENCE_TO_GUEST", e[e.ATMOSPHERE_MASTER = 7] = "ATMOSPHERE_MASTER", e))(OnlineUserTypeEnum || {}), OnlineTypeEnum = /* @__PURE__ */ ((e) => (e[e.OFFLINE = 1] = "OFFLINE", e[e.ONLINE = 2] = "ONLINE", e[e.USER_INFO_CHANGE = 3] = "USER_INFO_CHANGE", e))(OnlineTypeEnum || {}), __defProp$j = Object.defineProperty, __defNormalProp$j = (e, T, F) => T in e ? __defProp$j(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$j = (e, T, F) => (__defNormalProp$j(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$i = {
  onlineUserFlag: !1,
  onlineUserList: [],
  onlineUserAvatarFlag: !1,
  onlineUserRange: []
};
class ListModel extends Model {
  constructor() {
    super(INITIAL_STATE$i), __publicField$j(this, "ONLINE_USER_SATUS_UPDATE", "ONLINE_USER_SATUS_UPDATE");
  }
  init(T, F, $) {
    return Me(this, null, function* () {
      this.setState({
        onlineUserFlag: isTrue(T),
        onlineUserAvatarFlag: isTrue(F),
        onlineUserRange: $
      }), T && (yield this._initOnlineUserList(), this._onWsUserList(), this._onWsUserAudienceList());
    });
  }
  _onWsUserList() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.USER_ONLINE).pipe(
      bufferTime(1e3),
      filter((F) => F.length > 0)
    ).subscribe((F) => {
      const J = F.filter((ee) => {
        const { data: ne } = ee || {}, { onlineUserRange: oe } = this.state;
        ne.userType && ne.userType === OnlineUserTypeEnum.AUDIENCE_TO_GUEST && (ne.userType = OnlineUserTypeEnum.GUEST);
        const { userType: se } = ne || {};
        return se === OnlineUserTypeEnum.HOST ? oe.includes(OnlineUserRangeEnum.HOST) : se === OnlineUserTypeEnum.ASSISTANT ? oe.includes(OnlineUserRangeEnum.ASSISTANT) : se === OnlineUserTypeEnum.GUEST ? oe.includes(OnlineUserRangeEnum.GUEST) : !0;
      }).map((ee) => {
        const { data: ne } = ee || {};
        return ne.userType && ne.userType === OnlineUserTypeEnum.AUDIENCE_TO_GUEST && (ee.data.userType = OnlineUserTypeEnum.GUEST), ee;
      });
      onlineUserModel.emit(this.ONLINE_USER_SATUS_UPDATE, this._dealWsEmitMessageListData(J)), this._dealWsMessageListData(J);
    });
  }
  _onWsUserAudienceList() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.USER_ONLINE_AUDIENCE).pipe(
      bufferTime(1e3),
      filter((F) => F.length > 0)
    ).subscribe((F) => {
      const $ = F.filter((J) => {
        const { data: ee } = J || {}, { onlineUserRange: ne } = this.state, { userType: oe } = ee || {};
        return oe === OnlineUserTypeEnum.ATMOSPHERE_MASTER ? ne.includes(OnlineUserRangeEnum.ATMOSPHERE_MASTER) : oe === OnlineUserTypeEnum.AUDIENCE ? ne.includes(OnlineUserRangeEnum.AUDIENCE) : !0;
      });
      onlineUserModel.emit(this.ONLINE_USER_SATUS_UPDATE, this._dealWsEmitMessageListData($)), this._dealWsMessageListData($);
    });
  }
  _dealWsEmitMessageListData(T) {
    return T.map(($) => ({
      type: $.type,
      data: this._dealOnlineData($.data)
    }));
  }
  _dealWsMessageListData(T) {
    const { onlineUserList: F } = this.state;
    this.setState({ onlineUserList: this.updateUserList(T, [...F]) });
  }
  updateUserList(T, F) {
    const $ = {}, J = this._addOnlineUserData(T, F);
    T.map((se) => {
      const { data: le } = se, { onlineUserId: de } = le;
      $[de] = se;
    });
    const ee = [], ne = produce(J, (se) => {
      se.forEach((le, de) => {
        if ($[le.onlineUserId]) {
          const { type: ce, data: he } = $[le.onlineUserId];
          ce === OnlineTypeEnum.OFFLINE && ee.push(le.onlineUserId), ce === OnlineTypeEnum.USER_INFO_CHANGE && (se[de] = this._dealOnlineData(he));
        }
      });
    });
    return produce(ne, (se) => se.filter((le) => !ee.includes(le.onlineUserId)));
  }
  _addOnlineUserData(T, F) {
    return produce(F, ($) => {
      T.map((J) => {
        const { type: ee, data: ne } = J, oe = this._dealOnlineData(ne);
        if (ee === OnlineTypeEnum.ONLINE) {
          if (ne.userType === OnlineUserTypeEnum.HOST || ne.userType === OnlineUserTypeEnum.GUEST || ne.userType === OnlineUserTypeEnum.ASSISTANT) {
            const se = $.map((ce) => ce.userType).lastIndexOf(OnlineUserTypeEnum.HOST), le = $.map((ce) => ce.userType).lastIndexOf(OnlineUserTypeEnum.GUEST), de = $.map((ce) => ce.userType).lastIndexOf(OnlineUserTypeEnum.ASSISTANT);
            ne.userType === OnlineUserTypeEnum.HOST && $.splice(se + 1, 0, oe), ne.userType === OnlineUserTypeEnum.GUEST && (le === -1 ? $.splice(se + 1, 0, oe) : $.splice(le + 1, 0, oe)), ne.userType === OnlineUserTypeEnum.ASSISTANT && (de === -1 ? le !== -1 ? $.splice(le + 1, 0, oe) : $.splice(se + 1, 0, oe) : $.splice(de + 1, 0, oe));
          }
          if (ne.userType === OnlineUserTypeEnum.AUDIENCE && !F.some((se) => se.onlineUserId === ne.onlineUserId)) {
            const se = $.findIndex((le) => le.userType === OnlineUserTypeEnum.ATMOSPHERE_MASTER);
            se !== -1 ? $.splice(se, 0, oe) : $.push(oe);
          }
          ne.userType === OnlineUserTypeEnum.ATMOSPHERE_MASTER && !F.some((se) => se.onlineUserId === ne.onlineUserId) && $.push(oe);
        }
      });
    });
  }
  _initOnlineUserList() {
    const { roomNumber: T } = roomModel.state;
    return httpGetOnLineUsers(T).then(({ data: F }) => {
      const { items: $ = [] } = (F == null ? void 0 : F.data) || [], J = $.map((ee) => this._dealOnlineData(ee));
      this.setState({ onlineUserList: J });
    });
  }
  _dealOnlineData(T) {
    var F, $, J, ee, ne;
    const { onlineUserAvatarFlag: oe } = this.state, { userId: se } = userModel.state, le = {
      onlineUserId: (F = T.onlineUserId) != null ? F : 0,
      userType: ($ = T.userType) != null ? $ : OnlineUserTypeEnum.AUDIENCE,
      nickname: (J = T.nickname) != null ? J : "",
      title: (ee = T.title) != null ? ee : "",
      isMeFlag: T.onlineUserId === se,
      languages: T.languages || []
    };
    return oe ? Ke(Fe({}, le), {
      avatar: (ne = T.avatar) != null ? ne : ""
    }) : le;
  }
  destroy() {
    this.setState(INITIAL_STATE$i);
  }
  getI18nTitle(T, F) {
    var $, J;
    const ee = findFinalLangFun(T, (ne) => F.some((oe) => oe.languageType === ne));
    return (J = ($ = F.find((ne) => ne.languageType === ee)) == null ? void 0 : $.title) != null ? J : "";
  }
}
const listModel = new ListModel();
var __defProp$i = Object.defineProperty, __defNormalProp$i = (e, T, F) => T in e ? __defProp$i(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$i = (e, T, F) => (__defNormalProp$i(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$h = {};
class OnlineUserModel extends Model {
  constructor() {
    super(INITIAL_STATE$h), __publicField$i(this, "ONLINE_USER_SATUS_UPDATE", listModel.ONLINE_USER_SATUS_UPDATE), __publicField$i(this, "onlineUserFlag", modelStateGetter(listModel, "onlineUserFlag")), __publicField$i(this, "onlineUserAvatarFlag", modelStateGetter(listModel, "onlineUserAvatarFlag")), __publicField$i(this, "onlineUserList", modelStateGetter(listModel, "onlineUserList")), __publicField$i(this, "onlineUSerMenuName", modelStateGetter(menuModel, "onlineUSerMenuName")), __publicField$i(this, "getI18nTitle", listModel.getI18nTitle);
  }
  init(T, F, $) {
    listModel.init(T, F, $);
  }
  destroy() {
    this.setState(INITIAL_STATE$h);
  }
}
const onlineUserModel = new OnlineUserModel();
var __defProp$h = Object.defineProperty, __defNormalProp$h = (e, T, F) => T in e ? __defProp$h(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$h = (e, T, F) => (__defNormalProp$h(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$g = {};
class InteractAppSdkModel extends Model {
  constructor() {
    super(INITIAL_STATE$g), __publicField$h(this, "INTERACT_CUSTOM", "INTERACT_CUSTOM");
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$g);
  }
}
const interactAppSdkModel = new InteractAppSdkModel();
var CustomTopics = /* @__PURE__ */ ((e) => (e.INTERACT_CUSTOM = "CX-interact", e))(CustomTopics || {}), __defProp$g = Object.defineProperty, __defNormalProp$g = (e, T, F) => T in e ? __defProp$g(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$g = (e, T, F) => (__defNormalProp$g(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$f = {
  wsInteract: null
};
class InteractAppModel extends Model {
  constructor() {
    super(INITIAL_STATE$f), __publicField$g(this, "INTERACT_CUSTOM", "INTERACT_CUSTOM");
  }
  init(T) {
    return Me(this, null, function* () {
      yield this._onCustomInteractWsConnent(T), this._onWsInteractAppListen();
    });
  }
  destroy() {
  }
  _onCustomInteractWsConnent(T) {
    return Me(this, null, function* () {
      if (!(T.filter(($) => $.interactType === InteractionTypeEnum.CUSTOM).length <= 0))
        return this._connectWs().toPromise();
    });
  }
  _connectWs() {
    const { accessToken: T = "" } = lsGetEventToken() || {}, { roomId: F, pageSession: $ } = roomModel.state, { goImUrl: J } = eventModel.state, { promotionChannelId: ee } = userModel.state, ne = new GoimNats(), oe = Object.values(CustomTopics).filter((se) => typeof se == "string").map((se) => `${se}`);
    return ne.connect(J, {
      accessToken: T,
      roomId: `CI-${F}`,
      events: oe,
      pageSession: $,
      promotionChannelId: ee,
      pageType: "live",
      platform: "pc"
    }).pipe(
      tap((se) => {
        this.setState({
          wsInteract: se
        });
      })
    );
  }
  _onWsInteractAppListen() {
    var T;
    (T = this.state.wsInteract) == null || T.from(`${CustomTopics.INTERACT_CUSTOM}`).subscribe((F) => {
      interactAppSdkModel.emit(this.INTERACT_CUSTOM, F);
    });
  }
}
const interactAppModel = new InteractAppModel();
var __defProp$f = Object.defineProperty, __defNormalProp$f = (e, T, F) => T in e ? __defProp$f(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$f = (e, T, F) => (__defNormalProp$f(e, typeof T != "symbol" ? T + "" : T, F), F);
const _ErrorEnum = class {
  constructor(e, T) {
    __publicField$f(this, "_code"), __publicField$f(this, "_message"), this._code = e, this._message = T;
  }
  get code() {
    return this._code;
  }
  get message() {
    return this._message;
  }
};
let ErrorEnum = _ErrorEnum;
__publicField$f(ErrorEnum, "SDK_INIT_FAILED", new _ErrorEnum("SDK_INIT_FAILED", "SDK init verify failed"));
__publicField$f(ErrorEnum, "TOKEN_NOT_FOUND", new _ErrorEnum("TOKEN_NOT_FOUND", "Local token not found"));
__publicField$f(ErrorEnum, "ANONYMOUS_FORBIDDEN", new _ErrorEnum("ANONYMOUS_FORBIDDEN", "anonymous entry forbidden"));
function httpGetSubscribeState(e, T) {
  return Me(this, null, function* () {
    return request$1.get("/events/subscribe-state", {
      params: {
        virtualEventId: e,
        noticeIndex: T
      }
    });
  });
}
var __defProp$e = Object.defineProperty, __defNormalProp$e = (e, T, F) => T in e ? __defProp$e(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$e = (e, T, F) => (__defNormalProp$e(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$e = {
  eventStartTime: "",
  subscribeId: 0,
  smsNoticeFlag: !1,
  smsCheckFlag: !1,
  emailNoticeFlag: !1,
  emailCheckFlag: !1,
  automaticPopupFlag: !1,
  subscribeState: !1
};
class SubscribeModel extends Model {
  constructor() {
    super(INITIAL_STATE$e), __publicField$e(this, "_resolveInitData", (T, F) => {
      const { activityNoticeConfigId: $, smsNoticeFlag: J, smsCheckFlag: ee, emailNoticeFlag: ne, emailCheckFlag: oe, automaticPopup: se } = F || {}, le = isTrue(F == null ? void 0 : F.displaySubscribe);
      this.setState({
        eventStartTime: T != null ? T : "",
        subscribeId: $ != null ? $ : 0,
        smsNoticeFlag: le ? isTrue(J) : !1,
        smsCheckFlag: le ? isTrue(ee) : !1,
        emailNoticeFlag: le ? isTrue(ne) : !1,
        emailCheckFlag: le ? isTrue(oe) : !1,
        automaticPopupFlag: le ? isTrue(se) : !1
      });
    }), __publicField$e(this, "_dispatchSubscribeState", (T, F) => Me(this, null, function* () {
      return httpGetSubscribeState(T, F).then(({ data: $ }) => {
        var J;
        this.setState({
          subscribeState: isTrue((J = $ == null ? void 0 : $.data) == null ? void 0 : J.subscribeState)
        });
      });
    }));
  }
  init(T, F) {
    return Me(this, null, function* () {
      var $;
      const { eventId: J } = eventModel.state;
      try {
        isTrue(F == null ? void 0 : F.displaySubscribe) && (yield this._dispatchSubscribeState(J, ($ = F == null ? void 0 : F.noticeIndex) != null ? $ : 0));
      } catch (ee) {
      }
      this._resolveInitData(T, F);
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$e);
  }
}
const subscribeModel = new SubscribeModel();
var LuckyDrawStatus = /* @__PURE__ */ ((e) => (e[e.NOTOPEN = 0] = "NOTOPEN", e[e.INTHELOTTERY = 1] = "INTHELOTTERY", e[e.END = 2] = "END", e))(LuckyDrawStatus || {});
function httpGetLuckyDrawsInfo(e, T) {
  return request$1.get(`/events/${T}/rooms/${e}/lucky-draws/info`);
}
function httpPostLuckyDrawsJoin(e, T, F, $) {
  return request$1.post(`/events/${T}/rooms/${e}/lucky-draws/${F}`, {
    drawToken: $
  });
}
function httpGetLuckyDrawsAwardRecord(e, T, F) {
  return request$1.get(`/events/${T}/rooms/${e}/lucky-draws/${F}/winners`);
}
function httpPutDrawWinnerInfo(ee) {
  var ne = ee, {
    eventId: e,
    roomId: T,
    luckyDrawId: F,
    winnerId: $
  } = ne, J = Uo(ne, [
    "eventId",
    "roomId",
    "luckyDrawId",
    "winnerId"
  ]);
  return request$1.put(`/events/${e}/rooms/${T}/lucky-draws/${F}/winners/${$}`, J);
}
function httpGetAwardWinners(e) {
  return request$1.get(`/events/${e.virtualEventId}/rooms/${e.roomId}/lucky-draws/${e.luckyDrawId}/awards/${e.awardId}/winners`);
}
function formatLuckyDrawsInfo(e) {
  var T, F, $, J, ee, ne;
  return {
    drawName: (T = e.drawName) != null ? T : "",
    participantFlag: isTrue(e.participantFlag),
    acquisition: (F = e.acquisition) != null ? F : [1, 2, 4],
    luckyDrawId: ($ = e.luckyDrawId) != null ? $ : 0,
    awardList: formatAwardList(e.awardList),
    allowEnrollDrawFlag: isTrue(e.allowEnrollDrawFlag),
    description: (J = e.description) != null ? J : "",
    winnerShowFlag: isTrue(e.winnerShowFlag),
    prizeNumShowFlag: isTrue(e.prizeNumShowFlag),
    missPrompt: (ee = e.missPrompt) != null ? ee : "",
    winPrompt: (ne = e.winPrompt) != null ? ne : "",
    tokenFlag: isTrue(e.tokenFlag)
  };
}
function formatAwardList(e) {
  return (e != null ? e : []).map((T) => {
    var F, $, J, ee, ne, oe;
    return {
      awardId: (F = T.awardId) != null ? F : 0,
      awardName: ($ = T.awardName) != null ? $ : "",
      prizeName: (J = T.prizeName) != null ? J : "",
      prizePicUrl: (ee = T.prizePicUrl) != null ? ee : "",
      prizeNum: (ne = T.prizeNum) != null ? ne : 0,
      prizeStatus: isTrue(T.prizeStatus),
      prizeSequence: (oe = T.prizeSequence) != null ? oe : 0
    };
  });
}
function formatWinnerList(e) {
  return (e != null ? e : []).map((T) => {
    var F, $, J, ee, ne, oe, se, le, de, ce;
    return {
      luckyDrawId: (F = T.luckyDrawId) != null ? F : 0,
      winnerId: ($ = T.winnerId) != null ? $ : 0,
      prizeId: (J = T.prizeId) != null ? J : 0,
      awardName: (ee = T.awardName) != null ? ee : "",
      prizeName: (ne = T.prizeName) != null ? ne : "",
      prizePicUrl: (oe = T.prizePicUrl) != null ? oe : "",
      acquisitionName: (se = T.acquisitionName) != null ? se : "",
      acquisitionMobile: (le = T.acquisitionMobile) != null ? le : "",
      acquisitionEmail: (de = T.acquisitionEmail) != null ? de : "",
      acquisitionAddress: (ce = T.acquisitionAddress) != null ? ce : ""
    };
  });
}
function formatWsDrawData(e) {
  var T, F, $, J, ee, ne, oe, se, le, de, ce, he;
  return {
    luckyDrawId: (T = e.luckyDrawId) != null ? T : 0,
    prizePicUrl: (F = e.prizePicUrl) != null ? F : "",
    awardName: ($ = e.awardName) != null ? $ : "",
    prizeId: (J = e.prizeId) != null ? J : 0,
    prizeName: (ee = e.prizeName) != null ? ee : "",
    prizeNum: (ne = e.prizeNum) != null ? ne : 0,
    allWinners: ((oe = e.allWinners) != null ? oe : []).map((ve) => {
      var ge, be, Te, Se, Ie, Oe;
      return {
        userId: (ge = ve.userId) != null ? ge : 0,
        winnerId: (be = ve.winnerId) != null ? be : 0,
        participantName: (Te = ve.participantName) != null ? Te : "",
        participantMobile: (Se = ve.participantMobile) != null ? Se : "",
        participantEmail: (Ie = ve.participantEmail) != null ? Ie : "",
        thirdOpenId: (Oe = ve.thirdOpenId) != null ? Oe : ""
      };
    }),
    acquisition: (se = e.acquisition) != null ? se : "",
    winnerShowFlag: (le = isTrue(e.winnerShowFlag)) != null ? le : !0,
    prizeNumShowFlag: (de = isTrue(e.prizeNumShowFlag)) != null ? de : !0,
    missPrompt: (ce = e.missPrompt) != null ? ce : "",
    winPrompt: (he = e.winPrompt) != null ? he : ""
  };
}
function formatAwardWinners(e) {
  return (e != null ? e : []).map((T) => {
    var F, $, J, ee, ne, oe;
    return {
      winnerId: (F = T.winnerId) != null ? F : 0,
      liveUserId: ($ = T.liveUserId) != null ? $ : 0,
      participantName: (J = T.participantName) != null ? J : "",
      participantMobile: (ee = T.participantMobile) != null ? ee : "",
      participantEmail: (ne = T.participantEmail) != null ? ne : "",
      thirdOpenId: (oe = T.thirdOpenId) != null ? oe : 0
    };
  });
}
var __defProp$d = Object.defineProperty, __defNormalProp$d = (e, T, F) => T in e ? __defProp$d(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$d = (e, T, F) => (__defNormalProp$d(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$d = {
  luckyDrawFlag: !1,
  joining: !1,
  drawName: "",
  participantFlag: !1,
  acquisition: "",
  luckyDrawId: 0,
  allowEnrollDrawFlag: !0,
  description: "",
  winnerShowFlag: !0,
  prizeNumShowFlag: !0,
  missPrompt: "",
  winPrompt: "",
  tokenFlag: !1,
  awardList: [],
  winnerList: [],
  awardName: "",
  prizeName: "",
  prizePicUrl: "",
  allWinners: [],
  isWin: !1
};
class LuckyDrawModel extends Model {
  constructor() {
    super(INITIAL_STATE$d), __publicField$d(this, "STATUS_CHANGE", "STATUS_CHANGE"), __publicField$d(this, "OPEN", "OPEN"), __publicField$d(this, "fetchLuckyDrawsInfo", () => Me(this, null, function* () {
      const { roomId: T } = roomModel.state, { eventId: F } = eventModel.state;
      return httpGetLuckyDrawsInfo(T, F).then(($) => {
        var J;
        const ee = formatLuckyDrawsInfo((J = $.data.data) != null ? J : {});
        return this.setState(Fe({}, ee)), ee;
      });
    })), __publicField$d(this, "join", (T) => Me(this, null, function* () {
      const { roomId: F } = roomModel.state, { eventId: $ } = eventModel.state;
      return yield userModel._interceptAnonymous(), this.setState({ joining: !0 }), httpPostLuckyDrawsJoin(F, $, this.state.luckyDrawId, T).then(() => {
        this.setState({
          joining: !1
        });
      }).catch(() => (this.setState({ joining: !1 }), Promise.reject()));
    })), __publicField$d(this, "fetchAwardRecord", () => Me(this, null, function* () {
      const { roomId: T } = roomModel.state, { eventId: F } = eventModel.state;
      return httpGetLuckyDrawsAwardRecord(T, F, this.state.luckyDrawId).then(($) => {
        const J = formatWinnerList($.data.data.winnerList);
        return this.setState({
          winnerList: J
        }), J;
      });
    })), __publicField$d(this, "submitLuckyDrawContactInfo", (T) => Me(this, null, function* () {
      const { roomId: F } = roomModel.state, { eventId: $ } = eventModel.state;
      return httpPutDrawWinnerInfo(Ke(Fe({}, T), {
        roomId: F,
        eventId: $
      })).then(() => {
        this.fetchAwardRecord();
      }).catch((J) => Promise.reject(J));
    })), __publicField$d(this, "fetchAwardWinners", (T) => Me(this, null, function* () {
      const { roomId: F } = roomModel.state, { eventId: $ } = eventModel.state, { luckyDrawId: J } = this.state;
      return httpGetAwardWinners({
        virtualEventId: $,
        roomId: F,
        luckyDrawId: J,
        awardId: T
      }).then((ee) => formatAwardWinners(ee.data.data.items)).catch((ee) => Promise.reject(ee));
    }));
  }
  init(T) {
    this.setState({
      luckyDrawFlag: isTrue(T)
    }), this._onWsLuckyDrawStatus(), this._onWsDraw();
  }
  _onWsLuckyDrawStatus() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.LUCKY_DRAW_STATUS).subscribe((F) => {
      var $;
      const J = Ke(Fe({}, formatLuckyDrawsInfo(F != null ? F : {})), {
        drawStatus: ($ = F.drawStatus) != null ? $ : LuckyDrawStatus.NOTOPEN
      });
      this.setState(Fe({
        luckyDrawFlag: F.drawStatus === LuckyDrawStatus.INTHELOTTERY
      }, J)), this.emit(this.STATUS_CHANGE, {
        drawStatus: J.drawStatus
      });
    });
  }
  _onWsDraw() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.LUCKY_DRAW_WIN).subscribe((F) => {
      var $, J, ee;
      const { userId: ne } = userModel.state, oe = formatWsDrawData(F), se = (ee = (J = (($ = oe.allWinners) != null ? $ : []).find((de) => de.userId === ne)) == null ? void 0 : J.winnerId) != null ? ee : 0, le = !!se;
      this.setState({
        luckyDrawId: oe.luckyDrawId,
        acquisition: oe.acquisition,
        prizeNumShowFlag: oe.prizeNumShowFlag,
        winnerShowFlag: oe.winnerShowFlag,
        missPrompt: oe.missPrompt,
        winPrompt: oe.winPrompt,
        awardName: oe.awardName,
        prizeName: oe.prizeName,
        prizePicUrl: oe.prizePicUrl,
        allWinners: oe.allWinners,
        isWin: le
      }), this.emit(this.OPEN, {
        luckyDrawId: oe.luckyDrawId,
        winnerId: se,
        isWin: le,
        allWinners: oe.allWinners
      });
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$d);
  }
}
const luckyDrawModel = new LuckyDrawModel();
function httpGetSignInConfigData(e, T) {
  return request$1.get(`/interact/sdk/events/${e}/rooms/${T}/signs`, {
    baseURL: getApiHost(_apiHost)
  });
}
function httpPostSignIndData(e, T, F) {
  return request$1.post(
    `/interact/sdk/events/${e}/rooms/${T}/sign/${F}/journals`,
    {
      method: "POST"
    },
    {
      baseURL: getApiHost(_apiHost)
    }
  );
}
var SignInStatus = /* @__PURE__ */ ((e) => (e[e.EMPTY = -1] = "EMPTY", e[e.UNSIGNED = 0] = "UNSIGNED", e[e.SIGNED = 1] = "SIGNED", e))(SignInStatus || {}), SignInAction = /* @__PURE__ */ ((e) => (e[e.START = 1] = "START", e[e.END = 2] = "END", e))(SignInAction || {});
function formatSignInConfig(e) {
  var T, F, $;
  const { duration: J = 60 } = e, ee = Date.now() + J * 1e3;
  return {
    id: (T = e.id) != null ? T : 0,
    must: isTrue(e.must),
    title: (F = e.title) != null ? F : "",
    btnContent: ($ = e.btnContent) != null ? $ : "\u7ACB\u5373\u7B7E\u5230",
    duration: J,
    endTime: ee
  };
}
var __defProp$c = Object.defineProperty, __defNormalProp$c = (e, T, F) => T in e ? __defProp$c(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$c = (e, T, F) => (__defNormalProp$c(e, typeof T != "symbol" ? T + "" : T, F), F);
const initialSignInConfig = {
  id: 0,
  title: "",
  must: !0,
  duration: 60,
  endTime: Date.now() + 60 * 1e3,
  btnContent: "\u7ACB\u5373\u7B7E\u5230"
}, INITIAL_STATE$c = {
  signInFlag: !1,
  signInStatus: SignInStatus.EMPTY,
  signInConfig: initialSignInConfig
};
class SignInModel extends Model {
  constructor() {
    super(INITIAL_STATE$c), __publicField$c(this, "SIGN_IN_ACTION", "SIGN_IN_ACTION"), __publicField$c(this, "actionSubmitSignIn", () => Me(this, null, function* () {
      const { roomId: T } = roomModel.state, { eventId: F } = eventModel.state, { signInConfig: $ } = this.state;
      return yield userModel._interceptAnonymous(), httpPostSignIndData(F, T, $.id).then(() => {
        this.setState({
          signInStatus: SignInStatus.SIGNED
        });
      });
    }));
  }
  init(T) {
    return Me(this, null, function* () {
      this.setState({
        signInFlag: isTrue(T)
      }), yield this._getSignInConfig(), this._onWsSignInFlag(), this._onWsSignInStatus(), this.state.signInStatus === SignInStatus.UNSIGNED && this.emit(this.SIGN_IN_ACTION, !0);
    });
  }
  _getSignInConfig() {
    return Me(this, null, function* () {
      const { roomId: T } = roomModel.state, { eventId: F } = eventModel.state;
      return httpGetSignInConfigData(F, T).then(($) => {
        var J, ee;
        let ne = Ke(Fe({}, initialSignInConfig), {
          must: !1
        }), oe = SignInStatus.EMPTY;
        if ((J = $ == null ? void 0 : $.data) != null && J.data) {
          const { isSign: se, config: le } = ((ee = $ == null ? void 0 : $.data) == null ? void 0 : ee.data) || {};
          ne = formatSignInConfig(le), oe = se ? SignInStatus.SIGNED : SignInStatus.UNSIGNED;
        }
        this.setState((se) => {
          se.signInConfig = ne, se.signInStatus = oe;
        });
      }).catch(() => {
      });
    });
  }
  _onWsSignInFlag() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.SIGN_IN_FLAG).subscribe((F) => {
      const { roomId: $ } = roomModel.state, { roomId: J, registrationFlag: ee } = F || {};
      J === $ && this.setState({
        signInFlag: isTrue(ee)
      });
    });
  }
  _onWsSignInStatus() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.SIGN_IN_STATUS).subscribe((F) => {
      const { signState: $, signId: J = 0, must: ee = 1, title: ne = "", btnContent: oe = "\u7ACB\u5373\u7B7E\u5230", duration: se = 60 } = F || {};
      $ === SignInAction.START ? (this.setState((le) => {
        le.signInConfig = formatSignInConfig({
          id: J,
          title: ne,
          must: ee,
          btnContent: oe,
          duration: se
        }), le.signInStatus = SignInStatus.UNSIGNED;
      }), this.emit(this.SIGN_IN_ACTION, !0)) : (this.setState((le) => {
        le.signInConfig = Ke(Fe({}, initialSignInConfig), {
          must: !1
        }), le.signInStatus = SignInStatus.EMPTY;
      }), this.emit(this.SIGN_IN_ACTION, !1));
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$c);
  }
}
const signInModel = new SignInModel();
function httpGetTopicsList(e, T, F) {
  return request$1.get(
    `/interact/sdk/events/${e}/rooms/${T}/topics`,
    {
      params: F,
      baseURL: getApiHost(_apiHost)
    }
  );
}
function httpPostTopicsReply(e, T, F, $) {
  return request$1.post(
    `/interact/sdk/events/${e}/rooms/${T}/topics/${F}/reply`,
    $,
    {
      baseURL: getApiHost(_apiHost)
    }
  );
}
function httpGetRepliesList(e, T, F, $) {
  return request$1.get(
    `/interact/sdk/events/${e}/rooms/${T}/topics/${F}/replies`,
    {
      params: $,
      baseURL: getApiHost(_apiHost)
    }
  );
}
function httpPostTopicsLike(e, T, F) {
  return request$1.post(
    `/interact/sdk/events/${e}/rooms/${T}/topics/${F}/like`,
    null,
    {
      baseURL: getApiHost(_apiHost)
    }
  );
}
function httpPostTopicsRepliesLike(e, T, F, $) {
  return request$1.post(
    `/interact/sdk/events/${e}/rooms/${T}/topics/${F}/replies/${$}/like`,
    null,
    {
      baseURL: getApiHost(_apiHost)
    }
  );
}
function httpPostNewTopic(e, T, F) {
  return request$1.post(
    `/interact/sdk/events/${e}/rooms/${T}/topic`,
    F,
    {
      baseURL: getApiHost(_apiHost)
    }
  );
}
function httpGetTopicConfig(e, T) {
  return request$1.get(
    `/interact/sdk/events/${e}/rooms/${T}/topic-config`,
    {
      method: "GET",
      baseURL: getApiHost(_apiHost)
    }
  );
}
function httpGetTopicDetail(e, T, F, $ = 10) {
  return request$1.get(
    `/interact/sdk/events/${e}/rooms/${T}/topics/${F}`,
    {
      method: "GET",
      params: {
        replySize: $
      },
      baseURL: getApiHost(_apiHost)
    }
  );
}
function httpGetTopicsTiming(e, T, F) {
  return request$1.get(
    `/interact/sdk/events/${e}/rooms/${T}/topics-timing`,
    {
      method: "GET",
      params: {
        topicId: F
      },
      baseURL: getApiHost(_apiHost)
    }
  );
}
var TopicFlagType = /* @__PURE__ */ ((e) => (e[e.ALLOW_REPLY_FLAG = 1] = "ALLOW_REPLY_FLAG", e[e.REPLY_NEED_REVIEWFLAG = 2] = "REPLY_NEED_REVIEWFLAG", e[e.ALLOW_LIKE_TOPIC_FLAG = 3] = "ALLOW_LIKE_TOPIC_FLAG", e[e.ALLOW_LIKE_REPLY_FLAG = 4] = "ALLOW_LIKE_REPLY_FLAG", e[e.ALLOW_AUDIENCE_FLAG = 5] = "ALLOW_AUDIENCE_FLAG", e))(TopicFlagType || {});
function baseFindIndex$1(e, T, F, $) {
  for (var J = e.length, ee = F + ($ ? 1 : -1); $ ? ee-- : ++ee < J; )
    if (T(e[ee], ee, e))
      return ee;
  return -1;
}
var _baseFindIndex = baseFindIndex$1, ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2(), this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(e) {
  var T = this.__data__, F = T.delete(e);
  return this.size = T.size, F;
}
var _stackDelete = stackDelete$1;
function stackGet$1(e) {
  return this.__data__.get(e);
}
var _stackGet = stackGet$1;
function stackHas$1(e) {
  return this.__data__.has(e);
}
var _stackHas = stackHas$1, ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache, LARGE_ARRAY_SIZE = 200;
function stackSet$1(e, T) {
  var F = this.__data__;
  if (F instanceof ListCache$1) {
    var $ = F.__data__;
    if (!Map$2 || $.length < LARGE_ARRAY_SIZE - 1)
      return $.push([e, T]), this.size = ++F.size, this;
    F = this.__data__ = new MapCache$1($);
  }
  return F.set(e, T), this.size = F.size, this;
}
var _stackSet = stackSet$1, ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(e) {
  var T = this.__data__ = new ListCache(e);
  this.size = T.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype.delete = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2, HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(e) {
  return this.__data__.set(e, HASH_UNDEFINED), this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(e) {
  return this.__data__.has(e);
}
var _setCacheHas = setCacheHas$1, MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(e) {
  var T = -1, F = e == null ? 0 : e.length;
  for (this.__data__ = new MapCache(); ++T < F; )
    this.add(e[T]);
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(e, T) {
  for (var F = -1, $ = e == null ? 0 : e.length; ++F < $; )
    if (T(e[F], F, e))
      return !0;
  return !1;
}
var _arraySome = arraySome$1;
function cacheHas$1(e, T) {
  return e.has(T);
}
var _cacheHas = cacheHas$1, SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas, COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(e, T, F, $, J, ee) {
  var ne = F & COMPARE_PARTIAL_FLAG$5, oe = e.length, se = T.length;
  if (oe != se && !(ne && se > oe))
    return !1;
  var le = ee.get(e), de = ee.get(T);
  if (le && de)
    return le == T && de == e;
  var ce = -1, he = !0, ve = F & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (ee.set(e, T), ee.set(T, e); ++ce < oe; ) {
    var ge = e[ce], be = T[ce];
    if ($)
      var Te = ne ? $(be, ge, ce, T, e, ee) : $(ge, be, ce, e, T, ee);
    if (Te !== void 0) {
      if (Te)
        continue;
      he = !1;
      break;
    }
    if (ve) {
      if (!arraySome(T, function(Se, Ie) {
        if (!cacheHas(ve, Ie) && (ge === Se || J(ge, Se, F, $, ee)))
          return ve.push(Ie);
      })) {
        he = !1;
        break;
      }
    } else if (!(ge === be || J(ge, be, F, $, ee))) {
      he = !1;
      break;
    }
  }
  return ee.delete(e), ee.delete(T), he;
}
var _equalArrays = equalArrays$2, root$4 = _root, Uint8Array$2 = root$4.Uint8Array, _Uint8Array = Uint8Array$2;
function mapToArray$1(e) {
  var T = -1, F = Array(e.size);
  return e.forEach(function($, J) {
    F[++T] = [J, $];
  }), F;
}
var _mapToArray = mapToArray$1;
function setToArray$1(e) {
  var T = -1, F = Array(e.size);
  return e.forEach(function($) {
    F[++T] = $;
  }), F;
}
var _setToArray = setToArray$1, Symbol$1 = _Symbol, Uint8Array$1 = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray, COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(e, T, F, $, J, ee, ne) {
  switch (F) {
    case dataViewTag$2:
      if (e.byteLength != T.byteLength || e.byteOffset != T.byteOffset)
        return !1;
      e = e.buffer, T = T.buffer;
    case arrayBufferTag$1:
      return !(e.byteLength != T.byteLength || !ee(new Uint8Array$1(e), new Uint8Array$1(T)));
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+e, +T);
    case errorTag$1:
      return e.name == T.name && e.message == T.message;
    case regexpTag$1:
    case stringTag$1:
      return e == T + "";
    case mapTag$2:
      var oe = mapToArray;
    case setTag$2:
      var se = $ & COMPARE_PARTIAL_FLAG$4;
      if (oe || (oe = setToArray), e.size != T.size && !se)
        return !1;
      var le = ne.get(e);
      if (le)
        return le == T;
      $ |= COMPARE_UNORDERED_FLAG$2, ne.set(e, T);
      var de = equalArrays$1(oe(e), oe(T), $, J, ee, ne);
      return ne.delete(e), de;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(e) == symbolValueOf.call(T);
  }
  return !1;
}
var _equalByTag = equalByTag$1;
function arrayPush$1(e, T) {
  for (var F = -1, $ = T.length, J = e.length; ++F < $; )
    e[J + F] = T[F];
  return e;
}
var _arrayPush = arrayPush$1, arrayPush = _arrayPush, isArray$4 = isArray_1;
function baseGetAllKeys$1(e, T, F) {
  var $ = T(e);
  return isArray$4(e) ? $ : arrayPush($, F(e));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(e, T) {
  for (var F = -1, $ = e == null ? 0 : e.length, J = 0, ee = []; ++F < $; ) {
    var ne = e[F];
    T(ne, F, e) && (ee[J++] = ne);
  }
  return ee;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1, arrayFilter = _arrayFilter, stubArray = stubArray_1, objectProto$6 = Object.prototype, propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols$1 = nativeGetSymbols ? function(e) {
  return e == null ? [] : (e = Object(e), arrayFilter(nativeGetSymbols(e), function(T) {
    return propertyIsEnumerable$1.call(e, T);
  }));
} : stubArray, _getSymbols = getSymbols$1;
function baseTimes$1(e, T) {
  for (var F = -1, $ = Array(e); ++F < e; )
    $[F] = T(F);
  return $;
}
var _baseTimes = baseTimes$1, baseGetTag$2 = _baseGetTag, isObjectLike$3 = isObjectLike_1, argsTag$2 = "[object Arguments]";
function baseIsArguments$1(e) {
  return isObjectLike$3(e) && baseGetTag$2(e) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1, baseIsArguments = _baseIsArguments, isObjectLike$2 = isObjectLike_1, objectProto$5 = Object.prototype, hasOwnProperty$4 = objectProto$5.hasOwnProperty, propertyIsEnumerable = objectProto$5.propertyIsEnumerable, isArguments$2 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(e) {
  return isObjectLike$2(e) && hasOwnProperty$4.call(e, "callee") && !propertyIsEnumerable.call(e, "callee");
}, isArguments_1 = isArguments$2, isBuffer$2 = { exports: {} };
function stubFalse() {
  return !1;
}
var stubFalse_1 = stubFalse;
(function(e, T) {
  var F = _root, $ = stubFalse_1, J = T && !T.nodeType && T, ee = J && !0 && e && !e.nodeType && e, ne = ee && ee.exports === J, oe = ne ? F.Buffer : void 0, se = oe ? oe.isBuffer : void 0, le = se || $;
  e.exports = le;
})(isBuffer$2, isBuffer$2.exports);
var MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$2(e, T) {
  var F = typeof e;
  return T = T == null ? MAX_SAFE_INTEGER$1 : T, !!T && (F == "number" || F != "symbol" && reIsUint.test(e)) && e > -1 && e % 1 == 0 && e < T;
}
var _isIndex = isIndex$2, MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3, baseGetTag$1 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$1 = isObjectLike_1, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$2 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray$1(e) {
  return isObjectLike$1(e) && isLength$2(e.length) && !!typedArrayTags[baseGetTag$1(e)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$1(e) {
  return function(T) {
    return e(T);
  };
}
var _baseUnary = baseUnary$1, _nodeUtil = { exports: {} };
(function(e, T) {
  var F = _freeGlobal, $ = T && !T.nodeType && T, J = $ && !0 && e && !e.nodeType && e, ee = J && J.exports === $, ne = ee && F.process, oe = function() {
    try {
      var se = J && J.require && J.require("util").types;
      return se || ne && ne.binding && ne.binding("util");
    } catch (le) {
    }
  }();
  e.exports = oe;
})(_nodeUtil, _nodeUtil.exports);
var baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtil.exports, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, isTypedArray_1 = isTypedArray$2, baseTimes = _baseTimes, isArguments$1 = isArguments_1, isArray$3 = isArray_1, isBuffer$1 = isBuffer$2.exports, isIndex$1 = _isIndex, isTypedArray$1 = isTypedArray_1, objectProto$4 = Object.prototype, hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function arrayLikeKeys$1(e, T) {
  var F = isArray$3(e), $ = !F && isArguments$1(e), J = !F && !$ && isBuffer$1(e), ee = !F && !$ && !J && isTypedArray$1(e), ne = F || $ || J || ee, oe = ne ? baseTimes(e.length, String) : [], se = oe.length;
  for (var le in e)
    (T || hasOwnProperty$3.call(e, le)) && !(ne && (le == "length" || J && (le == "offset" || le == "parent") || ee && (le == "buffer" || le == "byteLength" || le == "byteOffset") || isIndex$1(le, se))) && oe.push(le);
  return oe;
}
var _arrayLikeKeys = arrayLikeKeys$1, objectProto$3 = Object.prototype;
function isPrototype$1(e) {
  var T = e && e.constructor, F = typeof T == "function" && T.prototype || objectProto$3;
  return e === F;
}
var _isPrototype = isPrototype$1;
function overArg$1(e, T) {
  return function(F) {
    return e(T(F));
  };
}
var _overArg = overArg$1, overArg = _overArg, nativeKeys$1 = overArg(Object.keys, Object), _nativeKeys = nativeKeys$1, isPrototype = _isPrototype, nativeKeys = _nativeKeys, objectProto$2 = Object.prototype, hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseKeys$1(e) {
  if (!isPrototype(e))
    return nativeKeys(e);
  var T = [];
  for (var F in Object(e))
    hasOwnProperty$2.call(e, F) && F != "constructor" && T.push(F);
  return T;
}
var _baseKeys = baseKeys$1, isFunction = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$1(e) {
  return e != null && isLength$1(e.length) && !isFunction(e);
}
var isArrayLike_1 = isArrayLike$1, arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike = isArrayLike_1;
function keys$2(e) {
  return isArrayLike(e) ? arrayLikeKeys(e) : baseKeys(e);
}
var keys_1 = keys$2, baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$1 = keys_1;
function getAllKeys$1(e) {
  return baseGetAllKeys(e, keys$1, getSymbols);
}
var _getAllKeys = getAllKeys$1, getAllKeys = _getAllKeys, COMPARE_PARTIAL_FLAG$3 = 1, objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(e, T, F, $, J, ee) {
  var ne = F & COMPARE_PARTIAL_FLAG$3, oe = getAllKeys(e), se = oe.length, le = getAllKeys(T), de = le.length;
  if (se != de && !ne)
    return !1;
  for (var ce = se; ce--; ) {
    var he = oe[ce];
    if (!(ne ? he in T : hasOwnProperty$1.call(T, he)))
      return !1;
  }
  var ve = ee.get(e), ge = ee.get(T);
  if (ve && ge)
    return ve == T && ge == e;
  var be = !0;
  ee.set(e, T), ee.set(T, e);
  for (var Te = ne; ++ce < se; ) {
    he = oe[ce];
    var Se = e[he], Ie = T[he];
    if ($)
      var Oe = ne ? $(Ie, Se, he, T, e, ee) : $(Se, Ie, he, e, T, ee);
    if (!(Oe === void 0 ? Se === Ie || J(Se, Ie, F, $, ee) : Oe)) {
      be = !1;
      break;
    }
    Te || (Te = he == "constructor");
  }
  if (be && !Te) {
    var Le = e.constructor, Ne = T.constructor;
    Le != Ne && "constructor" in e && "constructor" in T && !(typeof Le == "function" && Le instanceof Le && typeof Ne == "function" && Ne instanceof Ne) && (be = !1);
  }
  return ee.delete(e), ee.delete(T), be;
}
var _equalObjects = equalObjects$1, getNative$3 = _getNative, root$3 = _root, DataView$2 = getNative$3(root$3, "DataView"), _DataView = DataView$2, getNative$2 = _getNative, root$2 = _root, Promise$2 = getNative$2(root$2, "Promise"), _Promise = Promise$2, getNative$1 = _getNative, root$1 = _root, Set$2 = getNative$1(root$1, "Set"), _Set = Set$2, getNative = _getNative, root = _root, WeakMap$2 = getNative(root, "WeakMap"), _WeakMap = WeakMap$2, DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap$1 = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource, mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag$1 = baseGetTag;
(DataView$1 && getTag$1(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) && (getTag$1 = function(e) {
  var T = baseGetTag(e), F = T == objectTag$1 ? e.constructor : void 0, $ = F ? toSource(F) : "";
  if ($)
    switch ($) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return T;
});
var _getTag = getTag$1, Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$2 = isArray_1, isBuffer = isBuffer$2.exports, isTypedArray = isTypedArray_1, COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(e, T, F, $, J, ee) {
  var ne = isArray$2(e), oe = isArray$2(T), se = ne ? arrayTag : getTag(e), le = oe ? arrayTag : getTag(T);
  se = se == argsTag ? objectTag : se, le = le == argsTag ? objectTag : le;
  var de = se == objectTag, ce = le == objectTag, he = se == le;
  if (he && isBuffer(e)) {
    if (!isBuffer(T))
      return !1;
    ne = !0, de = !1;
  }
  if (he && !de)
    return ee || (ee = new Stack$1()), ne || isTypedArray(e) ? equalArrays(e, T, F, $, J, ee) : equalByTag(e, T, se, F, $, J, ee);
  if (!(F & COMPARE_PARTIAL_FLAG$2)) {
    var ve = de && hasOwnProperty.call(e, "__wrapped__"), ge = ce && hasOwnProperty.call(T, "__wrapped__");
    if (ve || ge) {
      var be = ve ? e.value() : e, Te = ge ? T.value() : T;
      return ee || (ee = new Stack$1()), J(be, Te, F, $, ee);
    }
  }
  return he ? (ee || (ee = new Stack$1()), equalObjects(e, T, F, $, J, ee)) : !1;
}
var _baseIsEqualDeep = baseIsEqualDeep$1, baseIsEqualDeep = _baseIsEqualDeep, isObjectLike = isObjectLike_1;
function baseIsEqual$2(e, T, F, $, J) {
  return e === T ? !0 : e == null || T == null || !isObjectLike(e) && !isObjectLike(T) ? e !== e && T !== T : baseIsEqualDeep(e, T, F, $, baseIsEqual$2, J);
}
var _baseIsEqual = baseIsEqual$2, Stack = _Stack, baseIsEqual$1 = _baseIsEqual, COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(e, T, F, $) {
  var J = F.length, ee = J, ne = !$;
  if (e == null)
    return !ee;
  for (e = Object(e); J--; ) {
    var oe = F[J];
    if (ne && oe[2] ? oe[1] !== e[oe[0]] : !(oe[0] in e))
      return !1;
  }
  for (; ++J < ee; ) {
    oe = F[J];
    var se = oe[0], le = e[se], de = oe[1];
    if (ne && oe[2]) {
      if (le === void 0 && !(se in e))
        return !1;
    } else {
      var ce = new Stack();
      if ($)
        var he = $(le, de, se, e, T, ce);
      if (!(he === void 0 ? baseIsEqual$1(de, le, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, $, ce) : he))
        return !1;
    }
  }
  return !0;
}
var _baseIsMatch = baseIsMatch$1, isObject = isObject_1;
function isStrictComparable$2(e) {
  return e === e && !isObject(e);
}
var _isStrictComparable = isStrictComparable$2, isStrictComparable$1 = _isStrictComparable, keys = keys_1;
function getMatchData$1(e) {
  for (var T = keys(e), F = T.length; F--; ) {
    var $ = T[F], J = e[$];
    T[F] = [$, J, isStrictComparable$1(J)];
  }
  return T;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(e, T) {
  return function(F) {
    return F == null ? !1 : F[e] === T && (T !== void 0 || e in Object(F));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2, baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(e) {
  var T = getMatchData(e);
  return T.length == 1 && T[0][2] ? matchesStrictComparable$1(T[0][0], T[0][1]) : function(F) {
    return F === e || baseIsMatch(F, e, T);
  };
}
var _baseMatches = baseMatches$1;
function baseHasIn$1(e, T) {
  return e != null && T in Object(e);
}
var _baseHasIn = baseHasIn$1, castPath = _castPath, isArguments = isArguments_1, isArray$1 = isArray_1, isIndex = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$1(e, T, F) {
  T = castPath(T, e);
  for (var $ = -1, J = T.length, ee = !1; ++$ < J; ) {
    var ne = toKey$2(T[$]);
    if (!(ee = e != null && F(e, ne)))
      break;
    e = e[ne];
  }
  return ee || ++$ != J ? ee : (J = e == null ? 0 : e.length, !!J && isLength(J) && isIndex(ne, J) && (isArray$1(e) || isArguments(e)));
}
var _hasPath = hasPath$1, baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(e, T) {
  return e != null && hasPath(e, T, baseHasIn);
}
var hasIn_1 = hasIn$1, baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey, COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(e, T) {
  return isKey$1(e) && isStrictComparable(T) ? matchesStrictComparable(toKey$1(e), T) : function(F) {
    var $ = get(F, e);
    return $ === void 0 && $ === T ? hasIn(F, e) : baseIsEqual(T, $, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$1(e) {
  return e;
}
var identity_1 = identity$1;
function baseProperty$1(e) {
  return function(T) {
    return T == null ? void 0 : T[e];
  };
}
var _baseProperty = baseProperty$1, baseGet = _baseGet;
function basePropertyDeep$1(e) {
  return function(T) {
    return baseGet(T, e);
  };
}
var _basePropertyDeep = basePropertyDeep$1, baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(e) {
  return isKey(e) ? baseProperty(toKey(e)) : basePropertyDeep(e);
}
var property_1 = property$1, baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity = identity_1, isArray = isArray_1, property = property_1;
function baseIteratee$1(e) {
  return typeof e == "function" ? e : e == null ? identity : typeof e == "object" ? isArray(e) ? baseMatchesProperty(e[0], e[1]) : baseMatches(e) : property(e);
}
var _baseIteratee = baseIteratee$1, toNumber = toNumber_1, INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$1(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = toNumber(e), e === INFINITY || e === -INFINITY) {
    var T = e < 0 ? -1 : 1;
    return T * MAX_INTEGER;
  }
  return e === e ? e : 0;
}
var toFinite_1 = toFinite$1, toFinite = toFinite_1;
function toInteger$1(e) {
  var T = toFinite(e), F = T % 1;
  return T === T ? F ? T - F : T : 0;
}
var toInteger_1 = toInteger$1, baseFindIndex = _baseFindIndex, baseIteratee = _baseIteratee, toInteger = toInteger_1, nativeMax = Math.max, nativeMin = Math.min;
function findLastIndex(e, T, F) {
  var $ = e == null ? 0 : e.length;
  if (!$)
    return -1;
  var J = $ - 1;
  return F !== void 0 && (J = toInteger(F), J = F < 0 ? nativeMax($ + J, 0) : nativeMin(J, $ - 1)), baseFindIndex(e, baseIteratee(T), J, !0);
}
var findLastIndex_1 = findLastIndex, ActionType = /* @__PURE__ */ ((e) => (e[e.ADD = 1] = "ADD", e[e.DELETE = 2] = "DELETE", e[e.EDIT = 3] = "EDIT", e))(ActionType || {}), __defProp$b = Object.defineProperty, __defNormalProp$b = (e, T, F) => T in e ? __defProp$b(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$b = (e, T, F) => (__defNormalProp$b(e, typeof T != "symbol" ? T + "" : T, F), F);
const SendGapTimeMin = 3e3, SendTopicGapTimeMin = 10 * 1e3, RefreshTopicGapTimeMin = 5 * 1e3, DEFAULT_PAGE_SIZE = 15, INITIAL_STATE$b = {
  topicFlag: !1,
  topicList: [],
  replyLoading: !1,
  replySuccessTime: 0,
  topicNumsDatarTimer: null,
  allowLikeTopicFlag: !1,
  replyNeedReviewFlag: !1,
  allowLikeReplyFlag: !1,
  allowReplyFlag: !1,
  allowAudienceFlag: !1,
  sendTopicSuccessTime: 0,
  refreshTopicSuccessTimeList: [],
  isNoMore: !1
};
class TopicModel extends Model {
  constructor() {
    super(INITIAL_STATE$b), __publicField$b(this, "fetchTopicList", (T) => Me(this, null, function* () {
      if (this.state.isNoMore)
        return Promise.reject("No more");
      const F = {
        offSet: this.offSet,
        pageSize: T != null ? T : DEFAULT_PAGE_SIZE
      }, { eventId: $ } = eventModel.state, { roomId: J } = roomModel.state, { topicList: ee } = this.state;
      return httpGetTopicsList($, J, F).then((ne) => {
        var oe;
        const { items: se = [], total: le = 0 } = ((oe = ne == null ? void 0 : ne.data) == null ? void 0 : oe.data) || {}, de = se.map((he) => this._dealTopicsData(he)), ce = ee.length > 0 ? [...ee, ...de] : de;
        return this.setState((he) => {
          he.topicList = ce, he.isNoMore = de.length < (T != null ? T : DEFAULT_PAGE_SIZE);
        }), {
          list: de || [],
          offSet: this.offSet,
          total: le
        };
      }).catch(() => ({
        list: [],
        total: 0,
        offSet: 0
      }));
    })), __publicField$b(this, "fetchMoreReplies", (T) => {
      const F = this.state.topicList.find((ee) => ee.id === T);
      if (!F)
        return Promise.reject();
      const { id: $, replies: J } = F;
      return this._fetchReplyList($, J.length);
    }), __publicField$b(this, "_fetchReplyList", (T, F, $) => {
      const J = {
        offSet: F || 0,
        pageSize: $ != null && $.pageSize ? $ == null ? void 0 : $.pageSize : 10
      }, { roomId: ee } = roomModel.state, { eventId: ne } = eventModel.state;
      return httpGetRepliesList(ne, ee, T, J).then((oe) => {
        const { data: se } = oe.data || {}, { items: le = [], total: de = 0 } = se || {}, { topicList: ce } = this.state, he = ce.findIndex((ge) => ge.id === T), ve = (le || []).map((ge) => this._dealRepliesData(ge));
        this.setState((ge) => {
          if ($ != null && $.isCover)
            if (ge.topicList[he].replies = [...ve], ($ == null ? void 0 : $.type) === ActionType.DELETE) {
              const be = ge.topicList[he].repliesTotal, Te = be > 0 ? be - 1 : 0;
              ge.topicList[he].repliesTotal = de || Te;
            } else
              ($ == null ? void 0 : $.type) === ActionType.ADD && (ge.topicList[he].repliesTotal = de || ge.topicList[he].repliesTotal + 1);
          else
            ge.topicList[he].replies = [...ge.topicList[he].replies, ...ve], ge.topicList[he].repliesTotal = de || ge.topicList[he].repliesTotal;
        });
      }).catch(() => {
      });
    }), __publicField$b(this, "submitReply", (T, F) => Me(this, null, function* () {
      try {
        yield userModel._interceptAnonymous();
        const { roomId: $ } = roomModel.state, { eventId: J } = eventModel.state, { nickName: ee } = userModel.state, { replyLoading: ne, replySuccessTime: oe } = this.state, { banChatFlag: se } = chatRoomModel.state;
        return se ? Promise.reject({
          code: 420001,
          message: "\u7981\u8A00\u4E2D\uFF0C\u60A8\u65E0\u6CD5\u53C2\u4E0E\u8BDD\u9898\u4E92\u52A8"
        }) : ne ? Promise.reject() : oe && new Date().getTime() - oe <= SendGapTimeMin ? Promise.reject({
          code: 420002,
          message: "\u56DE\u590D\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5"
        }) : F ? F.length > 500 ? Promise.reject({
          code: 420006,
          message: "\u56DE\u590D\u5185\u5BB9\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC7500\u4E2A\u5B57"
        }) : (this.setState({ replyLoading: !0 }), httpPostTopicsReply(J, $, T, {
          content: F,
          signature: ee
        }).then(() => {
          this.setState({
            replyLoading: !1,
            replySuccessTime: new Date().getTime()
          });
          const { topicList: de, replyNeedReviewFlag: ce } = this.state;
          if (ce)
            return Promise.reject({
              code: 420004,
              message: "\u60A8\u7684\u56DE\u590D\u88AB\u9009\u4E3A\u7CBE\u5F69\u8BC4\u8BBA\u540E\u5C06\u516C\u5F00\u5C55\u793A"
            });
          const he = de.findIndex((ge) => ge.id === T);
          return de[he].replies.length < 10 ? this._fetchReplyList(
            de[he].id,
            0,
            { pageSize: 10, isCover: !0, type: ActionType.ADD }
          ) : this.setState((ge) => {
            ge.topicList[he].repliesTotal += 1;
          }), Promise.resolve();
        }).catch((de) => (this.setState({ replyLoading: !1 }), Promise.reject(de)))) : Promise.reject({
          code: 420003,
          message: "\u8BF7\u5148\u8F93\u5165\u56DE\u590D\u5185\u5BB9"
        });
      } catch ($) {
        return Promise.reject($);
      }
    })), __publicField$b(this, "likeTopic", (T) => Me(this, null, function* () {
      const { roomId: F } = roomModel.state, { eventId: $ } = eventModel.state, J = this.state.topicList.find((ee) => ee.id === T);
      if (!J)
        return Promise.reject();
      try {
        return yield userModel._interceptAnonymous(), J.isLiked ? Promise.reject({
          code: 420005,
          message: "\u5DF2\u70B9\u8D5E"
        }) : httpPostTopicsLike($, F, T).then(() => {
          this.setState((ee) => {
            const ne = ee.topicList.findIndex((oe) => oe.id === T);
            ee.topicList[ne].likeCount += 1, ee.topicList[ne].isLiked = !0;
          });
        });
      } catch (ee) {
        return Promise.reject(ee);
      }
    })), __publicField$b(this, "likeReply", (T, F) => Me(this, null, function* () {
      try {
        yield userModel._interceptAnonymous();
        const { roomId: $ } = roomModel.state, { eventId: J } = eventModel.state;
        httpPostTopicsRepliesLike(J, $, T, F).then(() => {
          this.setState((ee) => {
            const ne = ee.topicList.findIndex((oe) => oe.id === T);
            if (ne > -1) {
              const oe = ee.topicList[ne].replies.findIndex((se) => se.id === F);
              ee.topicList[ne].replies[oe].likeCount += 1, ee.topicList[ne].replies[oe].isLiked = !0;
            }
          });
        }).catch(() => {
        });
      } catch ($) {
      }
    })), __publicField$b(this, "packupReplies", (T) => {
      this.setState((F) => {
        const $ = F.topicList.findIndex((J) => J.id === T);
        $ > -1 && (F.topicList[$].replies = F.topicList[$].replies.slice(0, 10));
      });
    }), __publicField$b(this, "submitTopic", (T, F) => Me(this, null, function* () {
      try {
        yield userModel._interceptAnonymous();
        const { roomId: $ } = roomModel.state, { eventId: J } = eventModel.state, { nickName: ee } = userModel.state, { sendTopicSuccessTime: ne } = this.state;
        return !F && T.length === 0 ? Promise.reject({
          code: 420007,
          message: "\u8BDD\u9898\u6587\u6848\u548C\u56FE\u7247\u81F3\u5C11\u9700\u586B\u5199\u4E00\u9879"
        }) : F && F.length > 500 ? Promise.reject({
          code: 420008,
          message: "\u8BDD\u9898\u5185\u5BB9\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC7500\u4E2A\u5B57"
        }) : T.length > 9 ? Promise.reject({
          code: 420009,
          message: "\u6700\u591A\u4E0A\u4F209\u5F20\u56FE\u7247"
        }) : ne && new Date().getTime() - ne <= SendTopicGapTimeMin ? Promise.reject({
          code: 420011,
          message: "\u64CD\u4F5C\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5"
        }) : httpPostNewTopic(J, $, {
          content: F,
          images: T,
          signature: ee
        }).then(() => (this.setState({
          sendTopicSuccessTime: new Date().getTime()
        }), this.state.replyNeedReviewFlag ? Promise.reject({
          code: 420010,
          message: "\u5BA1\u6838\u4E2D"
        }) : Promise.resolve())).catch((se) => Promise.reject(se));
      } catch ($) {
        return Promise.reject($);
      }
    })), __publicField$b(this, "refreshTopic", (T) => Me(this, null, function* () {
      var F, $, J, ee;
      try {
        yield userModel._interceptAnonymous();
        const { refreshTopicSuccessTimeList: ne } = this.state, oe = ($ = (F = ne == null ? void 0 : ne.find((ve) => ve.topicId === T)) == null ? void 0 : F.refreshTime) != null ? $ : 0, { roomId: se } = roomModel.state, { eventId: le } = eventModel.state, de = this.state.topicList.find((ve) => ve.id === T), ce = (ee = (J = de == null ? void 0 : de.replies) == null ? void 0 : J.length) != null ? ee : 10, he = ce < 10 ? 10 : ce;
        return oe && new Date().getTime() - oe <= RefreshTopicGapTimeMin ? Promise.reject({
          code: 420012,
          message: "\u64CD\u4F5C\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5"
        }) : httpGetTopicDetail(le, se, T, he).then((ve) => {
          const ge = ne.findIndex((Te) => Te.topicId === T);
          ge > -1 ? this.setState((Te) => {
            Te.refreshTopicSuccessTimeList[ge].refreshTime = new Date().getTime();
          }) : this.setState((Te) => {
            Te.refreshTopicSuccessTimeList = [...ne, {
              topicId: T,
              refreshTime: new Date().getTime()
            }];
          });
          const { data: be } = (ve == null ? void 0 : ve.data) || {};
          return this.setState((Te) => {
            const Se = Te.topicList.findIndex((Ie) => Ie.id === T);
            if (Se > -1) {
              const Ie = (be.replies || []).map((Oe) => this._dealRepliesData(Oe));
              Te.topicList[Se] = Ke(Fe(Fe({}, Te.topicList[Se]), be), {
                isTop: isTrue(be.isTop),
                isLiked: isTrue(be.isLiked),
                replies: Ie
              });
            }
          }), Promise.resolve();
        }).catch((ve) => Promise.reject(ve));
      } catch (ne) {
        return Promise.reject(ne);
      }
    }));
  }
  get offSet() {
    const { topicList: T } = this.state;
    return T.length > 0 ? T[T.length - 1].id : 0;
  }
  init(T) {
    return Me(this, null, function* () {
      this.setState({
        topicFlag: isTrue(T)
      }), this._getTopicConfig(), this._onWsTopicFlag(), this._onWsTopicConfig(), this._onWsTopicAdd(), this._onWsTopicDelete(), this._onWsTopicEdit(), this._onWsTopicTop(), this._onWsTopicCancelTop(), this._onWsTopicReplyDelete();
      try {
        yield this.fetchTopicList();
      } catch (F) {
      }
      this._checkInterval();
    });
  }
  _getTopicConfig() {
    const { eventId: T } = eventModel.state, { roomId: F } = roomModel.state;
    httpGetTopicConfig(T, F).then(($) => {
      var J, ee;
      const {
        allowLikeTopicFlag: ne = 0,
        replyNeedReviewFlag: oe = 0,
        allowLikeReplyFlag: se = 0,
        allowReplyFlag: le = 0,
        allowAudienceFlag: de = 0
      } = (ee = (J = $ == null ? void 0 : $.data) == null ? void 0 : J.data) != null ? ee : {};
      this.setState({
        allowLikeTopicFlag: isTrue(ne),
        replyNeedReviewFlag: isTrue(oe),
        allowLikeReplyFlag: isTrue(se),
        allowReplyFlag: isTrue(le),
        allowAudienceFlag: isTrue(de)
      });
    }).catch(() => {
    });
  }
  _dealTopicsData(T) {
    var F, $, J, ee, ne, oe, se, le, de, ce;
    return {
      id: (F = T.id) != null ? F : 0,
      createdAt: ($ = T.createdAt) != null ? $ : "",
      creatorName: (J = T.creatorName) != null ? J : "",
      isTop: isTrue((ee = T.isTop) != null ? ee : 0),
      likeCount: (ne = T.likeCount) != null ? ne : 0,
      images: (oe = T.images) != null ? oe : [],
      content: (se = T.content) != null ? se : "",
      replies: ((le = T.replies) != null ? le : []).map((he) => this._dealRepliesData(he)),
      repliesTotal: (de = T.repliesTotal) != null ? de : 0,
      isLiked: isTrue((ce = T.isLiked) != null ? ce : 0)
    };
  }
  _dealRepliesData(T) {
    var F, $, J, ee, ne, oe;
    return {
      id: (F = T.id) != null ? F : 0,
      replyAt: ($ = T.replyAt) != null ? $ : "",
      content: (J = T.content) != null ? J : "",
      likeCount: (ee = T.likeCount) != null ? ee : 0,
      replierName: (ne = T.replierName) != null ? ne : "",
      isLiked: isTrue((oe = T.isLiked) != null ? oe : 0)
    };
  }
  _onWsTopicFlag() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.TOPIC_FLAG).subscribe((F) => {
      console.log("\u8BDD\u9898\u603B\u5F00\u5173\u6D88\u606F\u63A8\u9001", F);
      const { roomId: $ } = roomModel.state, { roomId: J, topicFlag: ee } = F || {};
      J === $ && this.setState({
        topicFlag: isTrue(ee)
      });
    });
  }
  _onWsTopicConfig() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.TOPIC_CONFIG).subscribe((F) => {
      console.log("\u5F00\u542F/\u5173\u95ED\u8BDD\u9898\u7684\u76F8\u5173\u914D\u7F6E\u6D88\u606F\u63A8\u9001", F);
      const { flagType: $ = TopicFlagType.ALLOW_REPLY_FLAG, isOpen: J = 0 } = F || {};
      let ee = "allowReplyFlag";
      $ === TopicFlagType.REPLY_NEED_REVIEWFLAG ? ee = "replyNeedReviewFlag" : $ === TopicFlagType.ALLOW_LIKE_TOPIC_FLAG ? ee = "allowLikeTopicFlag" : $ === TopicFlagType.ALLOW_LIKE_REPLY_FLAG ? ee = "allowLikeReplyFlag" : $ === TopicFlagType.ALLOW_AUDIENCE_FLAG && (ee = "allowAudienceFlag"), this.setState((ne) => {
        ne[ee] = isTrue(J);
      });
    });
  }
  _onWsTopicAdd() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.TOPIC_ADD).subscribe((F) => {
      console.log("\u76D1\u542Cgoim\u6D88\u606F\uFF1A\u65B0\u589E\u8BDD\u9898\u6D88\u606F\u63A8\u9001", F);
      const { id: $ = 0, createdAt: J = 0, creatorName: ee = "", images: ne = [], content: oe = "" } = F || {}, se = {
        id: $,
        createdAt: J,
        creatorName: ee,
        isTop: !1,
        likeCount: 0,
        images: ne,
        content: oe,
        replies: [],
        repliesTotal: 0,
        isLiked: !1
      };
      this.setState((le) => {
        const de = findLastIndex_1(le.topicList, (ce) => ce.isTop);
        le.topicList.splice(de + 1, 0, se);
      });
    });
  }
  _onWsTopicDelete() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.TOPIC_DELETE).subscribe((F) => {
      console.log("\u76D1\u542Cgoim\u6D88\u606F\uFF1A\u5220\u9664\u8BDD\u9898\u6D88\u606F\u63A8\u9001", F);
      const { id: $ = "" } = F || {}, { topicList: J } = this.state;
      J.length <= 0 || this.setState((ee) => {
        ee.topicList = ee.topicList.filter((ne) => ne.id !== $);
      });
    });
  }
  _onWsTopicEdit() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.TOPIC_EDIT).subscribe((F) => {
      console.log("\u76D1\u542Cgoim\u6D88\u606F\uFF1A\u7F16\u8F91\u8BDD\u9898\u6D88\u606F\u63A8\u9001", F);
      const { id: $ = "", creatorName: J = "", images: ee = [], content: ne = "" } = F || {};
      this.setState((oe) => {
        const se = oe.topicList.findIndex((le) => le.id === $);
        se > -1 && (oe.topicList[se] = Ke(Fe({}, oe.topicList[se]), {
          creatorName: J,
          images: ee,
          content: ne
        }));
      });
    });
  }
  _getTopicDetail(T) {
    const { roomId: F } = roomModel.state, { eventId: $ } = eventModel.state;
    httpGetTopicDetail($, F, T).then((J) => {
      this.setState((ee) => {
        ee.topicList.unshift(this._dealTopicsData((J == null ? void 0 : J.data.data) || {}));
      });
    }).catch(() => {
    });
  }
  _onWsTopicTop() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.TOPIC_TOP).subscribe((F) => {
      console.log("\u76D1\u542Cgoim\u6D88\u606F\uFF1A\u7F6E\u9876\u8BDD\u9898\u6D88\u606F\u63A8\u9001", F);
      const { id: $ = 0 } = F || {}, { topicList: J } = this.state;
      if (J.length <= 0)
        return;
      const ee = J.findIndex((ne) => ne.id === $);
      ee > -1 ? this.setState((ne) => {
        ne.topicList.unshift(ne.topicList.splice(ee, 1)[0]), ne.topicList[0].isTop = !0;
      }) : this._getTopicDetail($);
    });
  }
  _onWsTopicCancelTop() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.TOPIC_CANCEL_TOP).subscribe((F) => {
      console.log("\u76D1\u542Cgoim\u6D88\u606F\uFF1A\u53D6\u6D88\u7F6E\u9876\u8BDD\u9898\u6D88\u606F\u63A8\u9001", F);
      const { id: $ = "", previousTopicId: J } = F || {}, { topicList: ee } = this.state, ne = ee.findIndex((se) => se.id === $), oe = ee.findIndex((se) => se.id === J);
      ne > -1 && (Number(J) === 0 ? this.setState((se) => {
        const le = findLastIndex_1(se.topicList, (de) => de.isTop);
        se.topicList[ne].isTop = !1, le > -1 ? se.topicList.splice(le, 0, se.topicList.splice(ne, 1)[0]) : se.topicList.unshift(se.topicList.splice(ne, 1)[0]);
      }) : oe > -1 ? this.setState((se) => {
        se.topicList[ne].isTop = !1, se.topicList.splice(oe, 0, se.topicList.splice(ne, 1)[0]);
      }) : this.setState((se) => {
        se.topicList.splice(ne, 1);
      }));
    });
  }
  _onWsTopicReplyDelete() {
    const { ws: T } = roomModel.state;
    T == null || T.from(Topics.TOPIC_REPLY_DELETE).subscribe((F) => {
      const { id: $ = 0, replyId: J = 0 } = F || {}, { topicList: ee } = this.state, ne = ee.findIndex((oe) => oe.id === $);
      ne !== -1 && (ee[ne].replies.length <= 10 ? this._fetchReplyList(
        ee[ne].id,
        0,
        { pageSize: 10, isCover: !0, type: ActionType.DELETE }
      ) : this.setState((oe) => {
        oe.topicList[ne].replies = oe.topicList[ne].replies.filter((se) => se.id !== J), oe.topicList[ne].repliesTotal -= 1;
      }));
    });
  }
  _updateTopicListNumData() {
    const { topicList: T } = this.state, { roomId: F } = roomModel.state, { eventId: $ } = eventModel.state;
    if (T && T.length <= 0)
      return;
    const J = T.map((ee) => ee.id);
    httpGetTopicsTiming($, F, J.toString()).then((ee) => {
      const { data: ne } = ee.data || [], oe = T.map((se) => {
        var le, de;
        const ce = ne.filter((he) => se.id === he.id);
        return Ke(Fe({}, se), {
          likeCount: ((le = ce[0]) == null ? void 0 : le.likeCount) || 0,
          repliesTotal: ((de = ce[0]) == null ? void 0 : de.replyCount) || 0,
          replies: se.replies.length <= 10 ? (ce[0].replies || []).map((he) => this._dealRepliesData(he)) : se.replies
        });
      });
      this.setState((se) => {
        se.topicList = oe;
      });
    }).catch(() => {
    });
  }
  _topicNumsDataInterval() {
    this._clearTopicNumsDataInterval();
    const T = setInterval(() => {
      this._updateTopicListNumData();
    }, 6e4);
    this.setState({ topicNumsDatarTimer: T });
  }
  _clearTopicNumsDataInterval() {
    const { topicNumsDatarTimer: T } = this.state;
    clearInterval(T), this.setState({ topicNumsDatarTimer: null });
  }
  _checkInterval() {
    merge$1(
      this._selectState((T) => T.allowReplyFlag),
      this._selectState((T) => T.allowLikeTopicFlag),
      this._selectState((T) => T.allowLikeReplyFlag),
      this._selectState((T) => T.topicList)
    ).subscribe(() => {
      const { allowReplyFlag: T, allowLikeTopicFlag: F, allowLikeReplyFlag: $, topicList: J } = this.state;
      T || F || $ || J.length ? this._topicNumsDataInterval() : this._clearTopicNumsDataInterval();
    });
  }
  destroy() {
    this.setState(INITIAL_STATE$b);
  }
}
const topicModel = new TopicModel();
var __defProp$a = Object.defineProperty, __defNormalProp$a = (e, T, F) => T in e ? __defProp$a(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$a = (e, T, F) => (__defNormalProp$a(e, typeof T != "symbol" ? T + "" : T, F), F);
let _apiHost;
const INITIAL_STATE$a = {
  loading: !0
};
class WatchModel extends Model {
  constructor() {
    super(INITIAL_STATE$a), __publicField$a(this, "ANONYMOUS_FORBIDDEN", userModel.ANONYMOUS_FORBIDDEN), __publicField$a(this, "KICKED_OUT", roomModel.KICKED_OUT), __publicField$a(this, "eventNumber", modelStateGetter(eventModel, "eventNumber")), __publicField$a(this, "eventId", modelStateGetter(eventModel, "eventId")), __publicField$a(this, "eventName", modelStateGetter(eventModel, "eventName")), __publicField$a(this, "eventStatus", modelStateGetter(eventModel, "eventStatus")), __publicField$a(this, "eventInvalid", modelStateGetter(eventModel, "eventInvalid")), __publicField$a(this, "mainRoomNumber", modelStateGetter(eventModel, "mainRoomNumber")), __publicField$a(this, "mainSeminarNumber", modelStateGetter(eventModel, "mainSeminarNumber")), __publicField$a(this, "systemTime", modelStateGetter(eventModel, "systemTime")), __publicField$a(this, "systemTimeGap", modelStateGetter(eventModel, "systemTimeGap")), __publicField$a(this, "audienceNicknameChangeFlag", modelStateGetter(eventModel, "audienceNicknameChangeFlag")), __publicField$a(this, "interactAccessFlag", modelStateGetter(eventModel, "interactAccessFlag")), __publicField$a(this, "tenantId", modelStateGetter(userModel, "tenantId")), __publicField$a(this, "userType", modelStateGetter(userModel, "userType")), __publicField$a(this, "userId", modelStateGetter(userModel, "userId")), __publicField$a(this, "thirdOpenId", modelStateGetter(userModel, "thirdOpenId")), __publicField$a(this, "nickName", modelStateGetter(userModel, "nickName")), __publicField$a(this, "avatar", modelStateGetter(userModel, "avatar")), __publicField$a(this, "anonymousNickname", modelStateGetter(userModel, "anonymousNickname")), __publicField$a(this, "email", modelStateGetter(userModel, "email")), __publicField$a(this, "mobile", modelStateGetter(userModel, "mobile")), __publicField$a(this, "roomNumber", modelStateGetter(roomModel, "roomNumber")), __publicField$a(this, "roomId", modelStateGetter(roomModel, "roomId")), __publicField$a(this, "roomMode", modelStateGetter(roomModel, "roomMode")), __publicField$a(this, "liveStatus", modelStateGetter(roomModel, "liveStatus")), __publicField$a(this, "liveScene", modelStateGetter(roomModel, "liveScene")), __publicField$a(this, "liveMode", modelStateGetter(roomModel, "liveMode")), __publicField$a(this, "liveDelay", modelStateGetter(roomModel, "liveDelay")), __publicField$a(this, "watchNumber", modelStateGetter(watchNumberModel, "watchNumber")), __publicField$a(this, "viewerNumberType", modelStateGetter(watchNumberModel, "viewerNumberType")), __publicField$a(this, "remark", modelStateGetter(roomModel, "remark")), __publicField$a(this, "roomName", modelStateGetter(roomModel, "roomName")), __publicField$a(this, "watchLanguageEnum", modelStateGetter(roomModel, "watchLanguage")), __publicField$a(this, "watchLanguage", modelStateGetter(roomModel, "watchLanguage", (T) => LanguageTypeEnum[T])), __publicField$a(this, "watchOptionalLanguage", modelStateGetter(roomModel, "watchOptionalLanguage", (T) => T.map((F) => LanguageEnum[LanguageTypeEnum[F]]))), __publicField$a(this, "watchScreenOrientation", modelStateGetter(roomModel, "screenOrientation")), __publicField$a(this, "setLanguage", roomModel.setLanguage), this._initEvents();
  }
  _initEvents() {
    userModel.on(userModel.ANONYMOUS_FORBIDDEN, (T) => this.emit(this.ANONYMOUS_FORBIDDEN, T)), roomModel.on(roomModel.KICKED_OUT, () => this.emit(this.KICKED_OUT));
  }
  init(T) {
    return Me(this, null, function* () {
      var F;
      const { accessKeyId: $ = "", secretAccessKey: J = "", eventNumber: ee, roomNumber: ne, accessToken: oe, refreshToken: se, expiration: le, lang: de, apiHost: ce } = T;
      ce && (_apiHost = ce, request$1.defaults.baseURL = getApiHost(ce) + "/sdk"), yield i18nInit(), de && inLanguageEnum(de) && roomModel._applyLanguage(de);
      try {
        yield httpPostInitVerify({
          eventNumber: ee,
          accessKeyId: $,
          secretAccessKey: J
        });
      } catch (he) {
        return Promise.reject(ErrorEnum.SDK_INIT_FAILED);
      }
      try {
        eventModel._setEventNumberState(ee), roomModel._setRoomNumberState(ne), oe && se && le && lsSetEventToken(oe, se, le), pageSessionModel.init();
        const { accessToken: he } = lsGetEventToken({ bellwether: !0 }) || {};
        if (!he)
          return messageModel.emit(messageModel.UI_TOAST_ERROR, {
            errorMessage: getI18nHttpErrorMessageByErrorCode("401")
          }), messageModel.emit(messageModel.UNAUTHORIZED, ErrorEnum.TOKEN_NOT_FOUND), this.setState({ loading: !1 }), Promise.reject(ErrorEnum.TOKEN_NOT_FOUND);
        userModel._setRamTokenState(he);
        try {
          yield refreshTokenModel.init();
        } catch (Ie) {
          return;
        }
        yield eventModel._requestConfigUrlLazily();
        const { data: ve } = yield httpGetMine({ virtualEventNumber: ee }), {
          eventInfoBO: ge,
          liveUserBO: be,
          systemTime: Te
        } = ve.data || {};
        if ((be == null ? void 0 : be.userType) === OnlineUserType.ANONYMOUS_AUDIENCE)
          try {
            const Ie = yield httpGetAccessConfig({ virtualEventNumber: ee }), { forceAuth: Oe, accessType: Le } = ((F = Ie == null ? void 0 : Ie.data) == null ? void 0 : F.data) || {};
            if (Le === AccessType.UNLIMITED && isTrue(Oe))
              return userModel.emit(this.ANONYMOUS_FORBIDDEN, { type: AnonymousForbiddenType.LOGIN }), this.setState({ loading: !1 }), Promise.reject(ErrorEnum.ANONYMOUS_FORBIDDEN);
          } catch (Ie) {
          }
        eventModel.init(ge, Te), userModel.init(be), this.setState({ loading: !1 });
        const Se = yield roomModel.init(ne, de);
        this._initModels(Se, T);
      } catch (he) {
        this.setState({ loading: !1 }), console.log(he);
      }
    });
  }
  destroy() {
    interactAppModel.destroy(), watchNumberModel.destroy(), marketToolModel.destroy(), liveCountdownModel.destroy(), likeModel.destroy(), menuModel.destroy(), goodsModel.destroy(), voteModel.destroy(), callModel.destroy(), chatModel.destroy(), boardModel.destroy(), playerModel.destroy(), roomModel.destroy(), userModel.destroy(), eventModel.destroy(), refreshTokenModel.destroy(), pageSessionModel.destroy(), subscribeModel.destroy(), this.setState(INITIAL_STATE$a);
  }
  _initModels(T, F) {
    const { virtualEventStartTime: $, noticeConfig: J, watchDecorate: ee, roomConfig: ne, watchMenu: oe, fabulousNumber: se = 0, announcement: le, watchNumber: de, interacts: ce, xp2pInfo: he } = T || {}, { liveViewPageShowFlag: ve, layoutFlag: ge, voteFlag: be, goodsFlag: Te = 0, barrageNicknameShowFlag: Se, signUpLuckyDrawFlag: Ie, registrationFlag: Oe, topicFlag: Le = 0 } = ne || {}, { likeFlag: Ne, likeNumberFlag: Ue, liveCountDownFlag: je, liveCountDownRemain: we, liveCountDownLocation: He, liveCountDownAutoZoomFlag: De, viewerNumberType: $e, onlineUserFlag: Be, onlineUserAvatarFlag: lt, onlineUserRange: tt } = ee || {};
    chatModel.init(T), onlineUserModel.init(Be, lt, tt), boardModel.init(ge, F == null ? void 0 : F.boardDomId), playerModel.init(ee, ve, he, Se, F), callModel.init(), voteModel.init(be), goodsModel.init(Te), marketToolModel.init(), menuModel.init(oe), likeModel.init(Ne, Ue, se), liveCountdownModel.init(je, we, He, De), announceModel.init(le), watchNumberModel.init(de, $e), interactAppModel.init(ce), subscribeModel.init($, J), luckyDrawModel.init(Ie), signInModel.init(Oe), topicModel.init(Le);
  }
  setUserName(T) {
    return userModel.setUserName(T);
  }
  setUserAvatar(T) {
    return userModel.setUserAvatar(T);
  }
}
const watchModel = new WatchModel(), { VITE_APP_NEPXION_DISCOVERY_VERSION, VITE_API_HOST } = { VITE_APP_ENV: "prod", VITE_API_HOST: "https://api.event.mudu.com", VITE_APPKEY: "MDNPvWWWJfj42zAiEr1", VITE_SECRET_KEY: "oF8qiy35irUxRSWLu2dasW8P9nMYrwmCo3RcOp2QQzoNdyTCHU4EDBQGhONsFGci", VITE_USER_NODE_ENV: "production", BASE_URL: "/", MODE: "lib", DEV: !1, PROD: !0 };
function handle401(e) {
  const { code: T, message: F } = e;
  watchModel.destroy(), lsRemoveEventToken(), messageModel.emit(messageModel.UNAUTHORIZED, {
    code: T,
    message: F
  });
}
const statusMap = {
  401: handle401,
  403: () => {
  },
  404: () => {
  },
  409: () => {
  },
  "5xx": () => {
  }
}, codeMap = {
  151006: () => {
    watchModel.destroy(), watchModel.emit(watchModel.KICKED_OUT);
  },
  403: () => {
    watchModel.destroy(), watchModel.emit(messageModel.NO_ACCESS);
  },
  404: () => {
    watchModel.destroy(), watchModel.emit(messageModel.NOT_FOUND);
  },
  100041: handle401,
  100046: handle401,
  100048: handle401,
  100910: handle401,
  100911: handle401,
  100912: handle401,
  138002: () => {
  },
  100050: () => {
    watchModel.destroy(), watchModel.emit(messageModel.MULTI_DEVICES);
  }
}, request = axios$1.create({
  baseURL: VITE_API_HOST + "/sdk",
  withCredentials: !0,
  timeout: 15e3
});
request.interceptors.request.use(
  (e) => {
    e.headers && (e.headers["Accept-language"] = instance.language);
    const { accessToken: T = "" } = lsGetEventToken() || {};
    if (e.headers && !e.headers.Authorization) {
      e.headers.Authorization = `Bearer ${T}`;
      const { ramToken: F } = userModel.state;
      F && F !== T && (accessModel.destroy(), watchModel.destroy(), messageModel.emit(messageModel.MULTI_ACCOUNT_LOGINED));
    }
    return e.headers && VITE_APP_NEPXION_DISCOVERY_VERSION && (e.headers["n-d-version"] = VITE_APP_NEPXION_DISCOVERY_VERSION), e;
  },
  (e) => (console.log(e), Promise.reject(e))
);
request.interceptors.response.use(
  (e) => {
    const { code: T, message: F, args: $ = [] } = e.data, { silence: J = !1, ignoreResponseIC: ee = !1 } = e.config;
    if (ee)
      return e;
    if (T !== "200") {
      if (!J && typeof F == "string") {
        const ne = getI18nHttpErrorMessageByErrorCode(T, $);
        messageModel.emit(messageModel.UI_TOAST_ERROR, {
          errorMessage: ne
        });
      }
      return Promise.reject(new Error(F || `Http error, code is ${T}`));
    }
    return e;
  },
  (e) => {
    const { response: T } = e, { status: F, data: $ } = T, { silence: J = !1, ignoreResponseIC: ee = !1 } = e.config || {};
    if (ee)
      return Promise.reject(e);
    if (F !== 200) {
      if (!J && typeof $.message == "string" && $.message) {
        const oe = getI18nHttpErrorMessageByErrorCode($.code, $.args);
        messageModel.emit(messageModel.UI_TOAST_ERROR, {
          errorMessage: oe
        });
      }
      const ne = statusMap[statusClass(F)];
      if (typeof ne == "function" && ne($), $.code && $.code !== "200") {
        const oe = codeMap[$.code];
        typeof oe == "function" && oe($);
      }
    }
    return Promise.reject(e);
  }
);
const request$1 = request;
var AccessType = /* @__PURE__ */ ((e) => (e[e.UNLIMITED = 0] = "UNLIMITED", e[e.SIGNUP = 1] = "SIGNUP", e[e.PASSWORD = 2] = "PASSWORD", e[e.WHITE_LIST = 3] = "WHITE_LIST", e[e.EXTERNAL_AUTH = 4] = "EXTERNAL_AUTH", e))(AccessType || {});
function httpGetAccessConfig(e) {
  return Me(this, null, function* () {
    const { virtualEventNumber: T, mainVenueNumber: F } = e;
    return request$1.get("/events/enable-access-config", {
      params: {
        virtualEventNumber: T,
        mainVenueNumber: F
      }
    });
  });
}
function httpPostAccessAuth(e, T) {
  return Me(this, null, function* () {
    const { ignoreResponseIC: F = !1 } = T || {};
    return request$1.post("/sso/events/access/auth", e, {
      ignoreResponseIC: F
    });
  });
}
var __defProp$9 = Object.defineProperty, __defNormalProp$9 = (e, T, F) => T in e ? __defProp$9(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$9 = (e, T, F) => (__defNormalProp$9(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$9 = {
  pageloading: !0,
  eventNumber: "",
  channelNumber: "",
  removeFlag: !1,
  submitLoading: !1,
  accessType: AccessType.WHITE_LIST,
  prompt: "",
  customAddress: "",
  defaultQuestionnaireId: 0,
  pcWatchBackgroundUrl: "",
  mobileWatchBackgroundUrl: "",
  virtualEventId: 0,
  virtualEventName: "",
  tenantId: 0,
  mainRoomNumber: "",
  mainSeminarNumber: ""
};
class AccessModel extends Model {
  constructor() {
    super(INITIAL_STATE$9), __publicField$9(this, "EXTERNAL_AUTH", "EXTERNAL_AUTH"), __publicField$9(this, "AUTH_SUCCESS", "AUTH_SUCCESS"), __publicField$9(this, "AUTH_FAILED", "AUTH_FAILED"), __publicField$9(this, "init", (T) => Me(this, null, function* () {
      const { eventNumber: F, channelNumber: $ = "", lang: J, apiHost: ee } = T;
      ee && (request$1.defaults.baseURL = getApiHost(ee) + "/sdk"), yield i18nInit(), J && inLanguageEnum(J) && instance.changeLanguage(J), this.setState({ eventNumber: F, channelNumber: $ });
      try {
        const ne = yield this._requestAccessConfig();
        ne === AccessType.UNLIMITED ? yield this._unlimitedAuth() : ne === AccessType.EXTERNAL_AUTH ? yield this._externalAuth() : this.setState({ pageloading: !1 });
      } catch (ne) {
        console.log(ne), this.setState({ pageloading: !1 });
      }
    })), __publicField$9(this, "destroy", () => {
      this.setState(INITIAL_STATE$9);
    });
  }
  _requestAccessConfig() {
    return Me(this, null, function* () {
      const { eventNumber: T } = this.state;
      return httpGetAccessConfig({
        virtualEventNumber: T
      }).then((F) => {
        var $;
        const {
          accessType: J,
          prompt: ee,
          customAddress: ne,
          defaultQuestionnaireId: oe,
          pcWatchBackgroundUrl: se,
          mobileWatchBackgroundUrl: le,
          virtualEventId: de,
          virtualEventName: ce,
          tenantId: he,
          mainVenueNumber: ve,
          mainSeminarNumber: ge,
          removeFlag: be
        } = (($ = F == null ? void 0 : F.data) == null ? void 0 : $.data) || {};
        return this.setState({
          removeFlag: isTrue(be),
          accessType: J,
          prompt: ee,
          customAddress: ne,
          defaultQuestionnaireId: oe,
          pcWatchBackgroundUrl: se,
          mobileWatchBackgroundUrl: le,
          virtualEventId: de,
          virtualEventName: ce,
          tenantId: he,
          mainRoomNumber: ve,
          mainSeminarNumber: ge
        }), J;
      });
    });
  }
  _unlimitedAuth() {
    return Me(this, null, function* () {
      const { tenantId: T, virtualEventId: F, accessType: $, channelNumber: J } = this.state, ee = yield getFingerPrint();
      return httpPostAccessAuth({
        tenantId: T,
        virtualEventId: F,
        browserFingerprint: ee,
        accessType: $,
        channelNum: J
      }).then((oe) => {
        var se, le;
        const { accessToken: de = "", refreshToken: ce = "", expiration: he = 0 } = (le = (se = oe == null ? void 0 : oe.data) == null ? void 0 : se.data) != null ? le : {};
        this.emit(this.AUTH_SUCCESS, {
          accessToken: de,
          refreshToken: ce,
          expiration: he
        });
      }).catch((oe) => {
        var se;
        const le = ((se = oe == null ? void 0 : oe.response) == null ? void 0 : se.data) || {};
        this.emit(this.AUTH_FAILED, le);
      });
    });
  }
  _externalAuth() {
    if (this.state.customAddress)
      this.emit(this.EXTERNAL_AUTH);
    else
      return Promise.reject();
  }
  limitedAuth(T) {
    return Me(this, null, function* () {
      const F = yield getFingerPrint();
      this.setState({ submitLoading: !0 });
      const { accessType: $, virtualEventId: J, tenantId: ee, channelNumber: ne } = this.state, oe = Fe({
        tenantId: ee,
        virtualEventId: J,
        browserFingerprint: F,
        accessType: $,
        channelNum: ne
      }, T);
      httpPostAccessAuth(oe, { ignoreResponseIC: !0 }).then((se) => {
        var le, de;
        const { accessToken: ce = "", refreshToken: he = "", expiration: ve = 0 } = (de = (le = se == null ? void 0 : se.data) == null ? void 0 : le.data) != null ? de : {};
        this.emit(this.AUTH_SUCCESS, {
          accessToken: ce,
          refreshToken: he,
          expiration: ve
        });
      }).catch((se) => {
        var le;
        const de = ((le = se == null ? void 0 : se.response) == null ? void 0 : le.data) || {};
        this.emit(this.AUTH_FAILED, de.message);
      }).finally(() => {
        this.setState({ submitLoading: !1 });
      });
    });
  }
}
const accessModel = new AccessModel();
var __defProp$8 = Object.defineProperty, __defNormalProp$8 = (e, T, F) => T in e ? __defProp$8(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$8 = (e, T, F) => (__defNormalProp$8(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$8 = {};
class AccessIndexModel extends Model {
  constructor() {
    super(INITIAL_STATE$8), __publicField$8(this, "EXTERNAL_AUTH", accessModel.EXTERNAL_AUTH), __publicField$8(this, "AUTH_SUCCESS", accessModel.AUTH_SUCCESS), __publicField$8(this, "AUTH_FAILED", accessModel.AUTH_FAILED), __publicField$8(this, "pageloading", modelStateGetter(accessModel, "pageloading")), __publicField$8(this, "eventId", modelStateGetter(accessModel, "virtualEventId")), __publicField$8(this, "eventNumber", modelStateGetter(accessModel, "eventNumber")), __publicField$8(this, "channelNumber", modelStateGetter(accessModel, "channelNumber")), __publicField$8(this, "mainRoomNumber", modelStateGetter(accessModel, "mainRoomNumber")), __publicField$8(this, "mainSeminarNumber", modelStateGetter(accessModel, "mainSeminarNumber")), __publicField$8(this, "removeFlag", modelStateGetter(accessModel, "removeFlag")), __publicField$8(this, "eventName", modelStateGetter(accessModel, "virtualEventName")), __publicField$8(this, "accessType", modelStateGetter(accessModel, "accessType")), __publicField$8(this, "customAddress", modelStateGetter(accessModel, "customAddress")), __publicField$8(this, "init", accessModel.init), __publicField$8(this, "destroy", accessModel.destroy), __publicField$8(this, "accessAuth", accessModel.limitedAuth), this._initEvents();
  }
  _initEvents() {
    accessModel.on(accessModel.EXTERNAL_AUTH, () => this.emit(this.EXTERNAL_AUTH)), accessModel.on(accessModel.AUTH_SUCCESS, (T) => this.emit(this.AUTH_SUCCESS, T)), accessModel.on(accessModel.AUTH_FAILED, (T) => this.emit(this.AUTH_FAILED, T));
  }
}
const accessIndexModel = new AccessIndexModel();
var __defProp$7 = Object.defineProperty, __defNormalProp$7 = (e, T, F) => T in e ? __defProp$7(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$7 = (e, T, F) => (__defNormalProp$7(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$7 = {};
class MenuSdkModel extends Model {
  constructor() {
    super(INITIAL_STATE$7), __publicField$7(this, "menuList", modelStateGetter(menuModel, "menuList")), __publicField$7(this, "queryCustomMenuDetail", menuModel.queryCustomMenuDetail);
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$7);
  }
  playMenuVideo(T) {
    playerModel._playMenuVideo(T);
  }
}
const menuSdkModel = new MenuSdkModel();
var __defProp$6 = Object.defineProperty, __defNormalProp$6 = (e, T, F) => T in e ? __defProp$6(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$6 = (e, T, F) => (__defNormalProp$6(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$6 = {};
class LikeSdkModel extends Model {
  constructor() {
    super(INITIAL_STATE$6), __publicField$6(this, "likeFlag", modelStateGetter(likeModel, "likeFlag")), __publicField$6(this, "likeNumberFlag", modelStateGetter(likeModel, "likeNumberFlag")), __publicField$6(this, "likeNumber", modelStateGetter(likeModel, "likeNumber")), __publicField$6(this, "dispatchLikeBar", likeModel.dispatchLikeBar);
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$6);
  }
}
const likeSdkModel = new LikeSdkModel();
var __defProp$5 = Object.defineProperty, __defNormalProp$5 = (e, T, F) => T in e ? __defProp$5(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$5 = (e, T, F) => (__defNormalProp$5(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$5 = {};
class LiveCountdownSdkModel extends Model {
  constructor() {
    super(INITIAL_STATE$5), __publicField$5(this, "liveCountDownFlag", modelStateGetter(liveCountdownModel, "liveCountDownFlag")), __publicField$5(this, "liveCountDownRemain", modelStateGetter(liveCountdownModel, "liveCountDownRemain")), __publicField$5(this, "liveCountDownLocation", modelStateGetter(liveCountdownModel, "liveCountDownLocation")), __publicField$5(this, "liveCountDownAutoZoomFlag", modelStateGetter(liveCountdownModel, "liveCountDownAutoZoomFlag"));
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$5);
  }
}
const liveCountdownSdkModel = new LiveCountdownSdkModel();
var __defProp$4 = Object.defineProperty, __defNormalProp$4 = (e, T, F) => T in e ? __defProp$4(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$4 = (e, T, F) => (__defNormalProp$4(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$4 = {};
class AnnouncementSdkModel extends Model {
  constructor() {
    super(INITIAL_STATE$4), __publicField$4(this, "announcements", modelStateGetter(announceModel, "announcements"));
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$4);
  }
}
const announcementSdkModel = new AnnouncementSdkModel();
var __defProp$3 = Object.defineProperty, __defNormalProp$3 = (e, T, F) => T in e ? __defProp$3(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$3 = (e, T, F) => (__defNormalProp$3(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$3 = {};
class SubscribeSdkModel extends Model {
  constructor() {
    super(INITIAL_STATE$3), __publicField$3(this, "subscribeId", modelStateGetter(subscribeModel, "subscribeId")), __publicField$3(this, "eventStartTime", modelStateGetter(subscribeModel, "eventStartTime")), __publicField$3(this, "subscribeState", modelStateGetter(subscribeModel, "subscribeState")), __publicField$3(this, "automaticPopupFlag", modelStateGetter(subscribeModel, "automaticPopupFlag")), __publicField$3(this, "emailNoticeFlag", modelStateGetter(subscribeModel, "emailNoticeFlag")), __publicField$3(this, "emailCheckFlag", modelStateGetter(subscribeModel, "emailCheckFlag")), __publicField$3(this, "smsNoticeFlag", modelStateGetter(subscribeModel, "smsNoticeFlag")), __publicField$3(this, "smsCheckFlag", modelStateGetter(subscribeModel, "smsCheckFlag"));
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$3);
  }
}
const subscribeSdkModel = new SubscribeSdkModel();
var __defProp$2 = Object.defineProperty, __defNormalProp$2 = (e, T, F) => T in e ? __defProp$2(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$2 = (e, T, F) => (__defNormalProp$2(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$2 = {};
class LuckyDrawIndexModel extends Model {
  constructor() {
    super(INITIAL_STATE$2), __publicField$2(this, "STATUS_CHANGE", luckyDrawModel.STATUS_CHANGE), __publicField$2(this, "OPEN", luckyDrawModel.OPEN), __publicField$2(this, "winnerList", modelStateGetter(luckyDrawModel, "winnerList")), __publicField$2(this, "luckyDrawFlag", modelStateGetter(luckyDrawModel, "luckyDrawFlag")), __publicField$2(this, "joining", modelStateGetter(luckyDrawModel, "joining")), __publicField$2(this, "drawName", modelStateGetter(luckyDrawModel, "drawName")), __publicField$2(this, "acquisition", modelStateGetter(luckyDrawModel, "acquisition")), __publicField$2(this, "luckyDrawId", modelStateGetter(luckyDrawModel, "luckyDrawId")), __publicField$2(this, "allowEnrollDrawFlag", modelStateGetter(luckyDrawModel, "allowEnrollDrawFlag")), __publicField$2(this, "description", modelStateGetter(luckyDrawModel, "description")), __publicField$2(this, "winnerShowFlag", modelStateGetter(luckyDrawModel, "winnerShowFlag")), __publicField$2(this, "participantFlag", modelStateGetter(luckyDrawModel, "participantFlag")), __publicField$2(this, "prizeNumShowFlag", modelStateGetter(luckyDrawModel, "prizeNumShowFlag")), __publicField$2(this, "missPrompt", modelStateGetter(luckyDrawModel, "missPrompt")), __publicField$2(this, "winPrompt", modelStateGetter(luckyDrawModel, "winPrompt")), __publicField$2(this, "tokenFlag", modelStateGetter(luckyDrawModel, "tokenFlag")), __publicField$2(this, "awardList", modelStateGetter(luckyDrawModel, "awardList")), __publicField$2(this, "awardName", modelStateGetter(luckyDrawModel, "awardName")), __publicField$2(this, "prizeName", modelStateGetter(luckyDrawModel, "prizeName")), __publicField$2(this, "prizePicUrl", modelStateGetter(luckyDrawModel, "prizePicUrl")), __publicField$2(this, "allWinners", modelStateGetter(luckyDrawModel, "allWinners")), __publicField$2(this, "isWin", modelStateGetter(luckyDrawModel, "isWin")), __publicField$2(this, "fetchLuckyDrawsInfo", luckyDrawModel.fetchLuckyDrawsInfo), __publicField$2(this, "join", luckyDrawModel.join), __publicField$2(this, "fetchAwardRecord", luckyDrawModel.fetchAwardRecord), __publicField$2(this, "submitLuckyDrawContactInfo", luckyDrawModel.submitLuckyDrawContactInfo), __publicField$2(this, "fetchAwardWinners", luckyDrawModel.fetchAwardWinners), this._initEvents();
  }
  _initEvents() {
    luckyDrawModel.on(luckyDrawModel.STATUS_CHANGE, (T) => this.emit(this.STATUS_CHANGE, T)), luckyDrawModel.on(luckyDrawModel.OPEN, (T) => this.emit(this.OPEN, T));
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$2);
  }
}
const luckyDrawIndexModel = new LuckyDrawIndexModel();
var __defProp$1 = Object.defineProperty, __defNormalProp$1 = (e, T, F) => T in e ? __defProp$1(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField$1 = (e, T, F) => (__defNormalProp$1(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE$1 = {};
class SignInIndexModel extends Model {
  constructor() {
    super(INITIAL_STATE$1), __publicField$1(this, "SIGN_IN_ACTION", signInModel.SIGN_IN_ACTION), __publicField$1(this, "signInStatus", modelStateGetter(signInModel, "signInStatus")), __publicField$1(this, "signInFlag", modelStateGetter(signInModel, "signInFlag")), __publicField$1(this, "signInConfig", modelStateGetter(signInModel, "signInConfig")), __publicField$1(this, "actionSubmitSignIn", signInModel.actionSubmitSignIn), this._initEvents();
  }
  _initEvents() {
    signInModel.on(signInModel.SIGN_IN_ACTION, (T) => {
      this.emit(this.SIGN_IN_ACTION, T);
    });
  }
  init() {
  }
  destroy() {
    this.setState(INITIAL_STATE$1);
  }
}
const signInIndexModel = new SignInIndexModel();
var __defProp = Object.defineProperty, __defNormalProp = (e, T, F) => T in e ? __defProp(e, T, { enumerable: !0, configurable: !0, writable: !0, value: F }) : e[T] = F, __publicField = (e, T, F) => (__defNormalProp(e, typeof T != "symbol" ? T + "" : T, F), F);
const INITIAL_STATE = {};
class TopicIndexModel extends Model {
  constructor() {
    super(INITIAL_STATE), __publicField(this, "topicFlag", modelStateGetter(topicModel, "topicFlag")), __publicField(this, "topicList", modelStateGetter(topicModel, "topicList")), __publicField(this, "allowReplyFlag", modelStateGetter(topicModel, "allowReplyFlag")), __publicField(this, "replyNeedReviewFlag", modelStateGetter(topicModel, "replyNeedReviewFlag")), __publicField(this, "allowLikeTopicFlag", modelStateGetter(topicModel, "allowLikeTopicFlag")), __publicField(this, "allowLikeReplyFlag", modelStateGetter(topicModel, "allowLikeReplyFlag")), __publicField(this, "allowAudienceFlag", modelStateGetter(topicModel, "allowAudienceFlag")), __publicField(this, "replyLoading", modelStateGetter(topicModel, "replyLoading")), __publicField(this, "fetchTopicList", topicModel.fetchTopicList), __publicField(this, "fetchMoreReplies", topicModel.fetchMoreReplies), __publicField(this, "packupReplies", topicModel.packupReplies), __publicField(this, "likeTopic", topicModel.likeTopic), __publicField(this, "likeReply", topicModel.likeReply), __publicField(this, "submitReply", topicModel.submitReply), __publicField(this, "submitTopic", topicModel.submitTopic), __publicField(this, "refreshTopic", topicModel.refreshTopic);
  }
  init() {
  }
  destroy() {
    topicModel.destroy();
  }
}
const topicIndexModel = new TopicIndexModel();
var CustomComponentType = /* @__PURE__ */ ((e) => (e[e.TEXT = 1] = "TEXT", e[e.LIVE_INTRO = 2] = "LIVE_INTRO", e[e.TITLE = 3] = "TITLE", e[e.IMAGE = 4] = "IMAGE", e[e.IMAGE_SWIPER = 5] = "IMAGE_SWIPER", e[e.VIDEO = 6] = "VIDEO", e[e.ACTIVE_LIST = 7] = "ACTIVE_LIST", e[e.VENUE = 8] = "VENUE", e[e.IFRAME = 9] = "IFRAME", e[e.LINE = 10] = "LINE", e[e.PARTNER = 11] = "PARTNER", e[e.CONTACT_US = 12] = "CONTACT_US", e[e.BUTTON = 13] = "BUTTON", e))(CustomComponentType || {}), ButtonStyleEnum = /* @__PURE__ */ ((e) => (e[e.FACE = 1] = "FACE", e[e.LINE = 2] = "LINE", e))(ButtonStyleEnum || {}), ButtonSizeEnum = /* @__PURE__ */ ((e) => (e[e.SMALL = 1] = "SMALL", e[e.MIDDLE = 2] = "MIDDLE", e[e.BIG = 3] = "BIG", e))(ButtonSizeEnum || {}), ButtonPositionEnum = /* @__PURE__ */ ((e) => (e[e.LEFT = 1] = "LEFT", e[e.CENTER = 2] = "CENTER", e[e.RIGHT = 3] = "RIGHT", e))(ButtonPositionEnum || {}), lineStyleEnum = /* @__PURE__ */ ((e) => (e[e.UNKNOW = 0] = "UNKNOW", e[e.PADDIN_LINE = 1] = "PADDIN_LINE", e[e.THROUGH_LINE = 2] = "THROUGH_LINE", e))(lineStyleEnum || {}), GroupTitlePositionEnum = /* @__PURE__ */ ((e) => (e[e.LEFT = 1] = "LEFT", e[e.CENTER = 2] = "CENTER", e[e.RIGHT = 3] = "RIGHT", e))(GroupTitlePositionEnum || {}), TitlePositionEnum = /* @__PURE__ */ ((e) => (e[e.LEFT = 1] = "LEFT", e[e.CENTER = 2] = "CENTER", e[e.RIGHT = 3] = "RIGHT", e))(TitlePositionEnum || {});
C();
export {
  AbilityType,
  accessIndexModel as Access,
  ActionType$1 as ActionType,
  AdMediaType,
  announcementSdkModel as Announcement,
  AnonymousForbiddenType,
  ApiHostEnum,
  boardSdkModel as Board,
  BulletCheckStatus,
  ButtonPositionEnum,
  ButtonSizeEnum,
  ButtonStyleEnum,
  callModel as Call,
  chatModel as Chat,
  ChatCheckStatus,
  ChatContentType,
  ChatType,
  CustomComponentType,
  ErrorEnum,
  goodsModel as Goods,
  GroupTitlePositionEnum,
  interactAppSdkModel as InteractApp,
  LanguageEnum,
  LanguageTypeEnum,
  likeSdkModel as Like,
  liveCountdownSdkModel as LiveCountdown,
  LiveMode,
  LiveStatus,
  luckyDrawIndexModel as LuckyDraw,
  LuckyDrawStatus,
  marketToolModel as MarketTool,
  MarketingAppType,
  menuSdkModel as Menu,
  messageModel as Message,
  onlineUserModel as OnlineUser,
  OnlineUserTypeEnum,
  OptionStyle,
  playerSdkModel as Player,
  PlayerErrorType,
  ScreenOrientationEnum,
  signInIndexModel as SignIn,
  SignInStatus,
  subscribeSdkModel as Subscribe,
  TitlePositionEnum,
  topicIndexModel as Topic,
  VideoPlayType,
  ViewerEnum,
  voteModel as Vote,
  VoteQuestionTypesEnum,
  watchModel as Watch,
  barrageModel,
  lineStyleEnum
};